// THIS IS A GENERATED FILE - DO NOT EDIT.
// EDIT strings.js INSTEAD, THEN RUN "npm run localize" TO REGENERATE.

import { Locale } from './locale';

interface TemplateResult {
  readonly strings: TemplateStringsArray;
  readonly values: unknown[];
}

const TEMPLATE_RESULT = Symbol.for('cumulus.templates.result');

/*#__NO_SIDE_EFFECTS__*/ function html(
  strings: TemplateStringsArray,
  ...values: any[]
): TemplateResult {
  return {
    [TEMPLATE_RESULT]: true,
    strings,
    values
  } as TemplateResult;
}

export function cleanupTranslation(s: string) {
  return (
    s
      // Remove trailing underscores, including the whitespace preceding the trailing underscores
      .replace(/(?:\s+)?_+$/, '')
      // Replace "covid-19" with "COVID-19"
      .replace(/([^\s])?covid-19([\s$])?/g, '$1COVID-19$2')
  );
}

export function applyTranslationOverride(locale: Locale, s: string) {
  /**
   * @type {Record<string, Record<string, string>>}
   */
  const overrides: { [locale in Locale]?: Record<string, string> } = {
    es: {
      Hembra: 'Femenino'
    }
  };
  return overrides[locale]?.[s] ?? s;
}
export const loc_1month: Record<Locale, string> = {
	ar: `شهر واحد`,
	de: `1 Monat`,
	es: `1 mes`,
	fa: `۱ ماه`,
	fil: `1 buwan`,
	fr: `1 mois`,
	hi: `1 महिना`,
	ht: `1 mwa`,
	it: `1 mese`,
	ja: `1ヶ月`,
	ko: `1개월`,
	mww: `1 lub hlis`,
	ps: `۱ میاشت`,
	pt: `1 mês`,
	'pt-pt': `1 mês`,
	ru: `1 месяц`,
	sm: `1 masina`,
	so: `1 bil`,
	th: `1 เดือน`,
	ur: `1 مہینہ`,
	vi: `1 tháng`,
	'zh-hans': `1个月`,
	'zh-hant': `1個月`,
	en: `1 month`
};

export const loc_1week: Record<Locale, string> = {
	ar: `أسبوع واحد`,
	de: `1 Woche`,
	es: `1 semana`,
	fa: `یک هفته`,
	fil: `1 linggo`,
	fr: `1 semaine`,
	hi: `1 सप्ताह`,
	ht: `1 semèn`,
	it: `1 settimana`,
	ja: `1週間`,
	ko: `1주`,
	mww: `1 lub lim tiam`,
	ps: `۱ اونۍ`,
	pt: `1 semana`,
	'pt-pt': `1 semana`,
	ru: `1 неделя`,
	sm: `1 vaiaso`,
	so: `1 toddobaad`,
	th: `1 สัปดาห์`,
	ur: `1 ہفتہ`,
	vi: `1 tuần`,
	'zh-hans': `一周`,
	'zh-hant': `一週`,
	en: `1 week`
};

export const loc_2weeks: Record<Locale, string> = {
	ar: `أسبوعان`,
	de: `2 Wochen`,
	es: `2 semanas`,
	fa: `۲ هفته`,
	fil: `2 linggo`,
	fr: `2 semaines`,
	hi: `2 सप्ताह`,
	ht: `2 semèn`,
	it: `2 settimane`,
	ja: `2週間`,
	ko: `2주`,
	mww: `2 lub lis piam`,
	ps: `۲ اونۍ`,
	pt: `2 semanas`,
	'pt-pt': `2 semanas`,
	ru: `2 недели`,
	sm: `2 vaiaso`,
	so: `2 toddobaad`,
	th: `2 สัปดาห์`,
	ur: `2 ہفتے`,
	vi: `2 tuần`,
	'zh-hans': `两周`,
	'zh-hant': `兩週`,
	en: `2 weeks`
};

export const loc_3days: Record<Locale, string> = {
	ar: `3 أيام`,
	de: `3 Tage`,
	es: `3 días`,
	fa: `۳ روز`,
	fil: `3 araw`,
	fr: `3 jours`,
	hi: `3 दिन`,
	ht: `3 jou`,
	it: `3 giorni`,
	ja: `3日間`,
	ko: `3일`,
	mww: `3 hnub`,
	ps: `۳ ورځې`,
	pt: `3 dias`,
	'pt-pt': `3 dias`,
	ru: `3 дня`,
	sm: `3 aso`,
	so: `3 maalmood`,
	th: `3 วัน`,
	ur: `3 دن`,
	vi: `3 ngày`,
	'zh-hans': `3天`,
	'zh-hant': `三天`,
	en: `3 days`
};

export const loc_about: Record<Locale, string> = {
	ar: `حول`,
	de: `Über uns`,
	es: `Acerca de`,
	fa: `درباره`,
	fil: `Tungkol sa`,
	fr: `À propos`,
	hi: `के बारे में`,
	ht: `A pwopo`,
	it: `Informazioni`,
	ja: `概要`,
	ko: `소개`,
	mww: `Hais txog`,
	ps: `په اړه`,
	pt: `Sobre`,
	'pt-pt': `Sobre`,
	ru: `О компании`,
	sm: `E uiga i`,
	so: `Ku saabsan`,
	th: `เกี่ยวกับ`,
	ur: `بارے میں`,
	vi: `Giới thiệu`,
	'zh-hans': `关于`,
	'zh-hant': `關於`,
	en: `About`
};

export const loc_acceptSignature: Record<Locale, string> = {
	ar: `قبول التوقيع`,
	de: `Unterschrift akzeptieren`,
	es: `Aceptar firma`,
	fa: `امضا را بپذیرید`,
	fil: `Tanggapin ang lagda`,
	fr: `Accepter la signature`,
	hi: `हस्ताक्षर स्वीकार करें`,
	ht: `Aksepte siyati`,
	it: `Accetta firma`,
	ja: `署名を受け入れてください`,
	ko: `서명 수락`,
	mww: `Txais kos npe`,
	ps: `لاسلیک ومنئ`,
	pt: `Aceitar assinatura`,
	'pt-pt': `Aceitar assinatura`,
	ru: `Принять подпись`,
	sm: `Talia le saini`,
	so: `Aqbal saxiixa`,
	th: `ยอมรับลายเซ็น`,
	ur: `دستخط قبول کریں`,
	vi: `Chấp nhận chữ ký`,
	'zh-hans': `接受签名`,
	'zh-hant': `接受簽名`,
	en: `Accept signature`
};

export const loc_accountAlreadyRegisteredMessage: Record<Locale, string> = {
	ar: `الحساب مسجل بالفعل. سجل الدخول إلى حسابك.`,
	de: `Konto bereits registriert. Melden Sie sich in Ihrem Konto an.`,
	es: `Cuenta ya registrada. Inicia sesión en tu cuenta.`,
	fa: `حساب کاربری قبلا ثبت شده است. وارد حساب کاربری خود شوید.`,
	fil: `Nakarehistro na ang account. Mag-sign in sa iyong account.`,
	fr: `Compte déjà enregistré. Connectez-vous à votre compte.`,
	hi: `खाता पहले से ही पंजीकृत है। अपने खाते में साइन इन करें.`,
	ht: `Kont deja anrejistre Siyen nan kont ou.`,
	it: `Account già registrato. Accedi al tuo account.`,
	ja: `アカウントはすでに登録済みです。アカウントにサインインしてください。`,
	ko: `계정은 이미 등록되어 있습니다. 계정에 로그인하세요.`,
	mww: `Tus account twb sau npe lawm. Kos npe rau hauv koj tus account.`,
	ps: `حساب ثبت شوی دی. خپل حساب ته ننوتل.`,
	pt: `Conta já registrada. Faça login na sua conta.`,
	'pt-pt': `Conta já registada. Inicia sessão na tua conta.`,
	ru: `Аккаунт уже зарегистрирован. Войдите в свой аккаунт.`,
	sm: `Ua uma ona lesitala le teugatupe. Saini i totonu o lau teuga tupe.`,
	so: `Akoonka hore ayaa loo diiwaan geliyay. Gali akoonkaaga.`,
	th: `บัญชีที่ลงทะเบียนแล้ว ลงชื่อเข้าใช้บัญชีของคุณ`,
	ur: `اکاؤنٹ پہلے ہی رجسٹرڈ ہے۔ اپنے اکاؤنٹ میں سائن ان کریں۔`,
	vi: `Tài khoản đã được đăng ký. Đăng nhập vào tài khoản của bạn.`,
	'zh-hans': `账户已注册。登录您的账户。`,
	'zh-hant': `帳號已經註冊。登入你的帳號。`,
	en: `Account already registered. Sign in to your account.`
};

export const loc_accountCreated: Record<Locale, string> = {
	ar: `إنشاء حساب`,
	de: `Konto erstellt`,
	es: `Cuenta creada`,
	fa: `ایجاد حساب کاربری`,
	fil: `Email Address *`,
	fr: `Compte créé`,
	hi: `खाता बनाया गया`,
	ht: `Kont kreye`,
	it: `Account creato`,
	ja: `アカウント作成`,
	ko: `계정 생성`,
	mww: `Tus account tsim`,
	ps: `حساب جوړ شو`,
	pt: `Conta criada`,
	'pt-pt': `Conta criada`,
	ru: `Аккаунт создан`,
	sm: `Fausiaina o le teugatupe`,
	so: `Xisaab la sameeyay`,
	th: `สร้างบัญชี`,
	ur: `اکاؤنٹ بنایا گیا`,
	vi: `Đã tạo tài khoản`,
	'zh-hans': `创建账户`,
	'zh-hant': `帳號已建立`,
	en: `Account created`
};

export const loc_accountLinkedFormat: Record<Locale, (provider: unknown) => string> = {
	ar: (provider) => `تم ربط حسابك ${provider} بنجاح.`,
	de: (provider) => `Dein ${provider} wurde erfolgreich verknüpft.`,
	es: (provider) => `Tu cuenta ${provider} fue vinculada correctamente.`,
	fa: (provider) => `حساب ${provider} شما با موفقیت لینک شد.`,
	fil: (provider) => `Matagumpay na na-link ang iyong ${provider} account.`,
	fr: (provider) => `Votre compte ${provider} a été lié avec succès.`,
	hi: (provider) => `आपका ${provider} खाता सफलतापूर्वक लिंक हो गया था.`,
	ht: (provider) => `Kont ${provider} ou te lye avèk siksè.`,
	it: (provider) => `Il tuo account ${provider} è stato collegato con successo.`,
	ja: (provider) => `あなたの ${provider} アカウントは正常に連携されました。`,
	ko: (provider) => `${provider} 계정이 성공적으로 연결되었습니다.`,
	mww: (provider) => `Koj ${provider} tau ua tiav txuas.`,
	ps: (provider) => `ستا ${provider} حساب بریالی لینک شو.`,
	pt: (provider) => `Sua conta ${provider} foi vinculada com sucesso.`,
	'pt-pt': (provider) => `A sua conta ${provider} foi ligada com sucesso.`,
	ru: (provider) => `Ваш ${provider} был успешно связан.`,
	sm: (provider) => `O lau ${provider} account na fa'afeso'ota'i ma le manuia.`,
	so: (provider) => `Akoonkaaga ${provider} si guul leh ayaa loo xidhay.`,
	th: (provider) => `บัญชี ${provider} ของคุณเชื่อมโยงสําเร็จแล้ว`,
	ur: (provider) => `آپ ${provider} اکاؤنٹ کامیابی سے لنک ہو گیا ہے۔`,
	vi: (provider) => `Tài khoản ${provider} của bạn đã được liên kết thành công.`,
	'zh-hans': (provider) => `你的 ${provider} 账户已成功关联。`,
	'zh-hant': (provider) => `你的 ${provider} 帳號已經成功連結。`,
	en: (provider) => `Your ${provider} account was successfully linked.`
};

export const loc_accountWelcome: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `مرحبا بكم في ${cumulus}! سجل الدخول لبدء التعاون.`,
	de: (cumulus) => `Willkommen bei ${cumulus}! Melden Sie sich an, um mit der Zusammenarbeit zu beginnen.`,
	es: (cumulus) => `¡Bienvenido a ${cumulus}! Inicia sesión para empezar a colaborar.`,
	fa: (cumulus) => `به ${cumulus} خوش آمدید! برای شروع همکاری وارد شوید.`,
	fil: (cumulus) => `Maligayang pagdating sa ${cumulus}! Mag-sign in upang simulan ang pakikipagtulungan.`,
	fr: (cumulus) => `Bienvenue chez ${cumulus} ! Connectez-vous pour commencer à collaborer.`,
	hi: (cumulus) => `${cumulus} में आपका स्वागत है! सहयोग शुरू करने के लिए साइन इन करें।`,
	ht: (cumulus) => `Byenveni nan ${cumulus}! Siyen pou kòmanse kolabore.`,
	it: (cumulus) => `Benvenuto su ${cumulus}! Accedi per iniziare a collaborare.`,
	ja: (cumulus) => `${cumulus}へようこそ!コラボレーションを始めるにはサインインしてください。`,
	ko: (cumulus) => `${cumulus}에 오신 것을 환영합니다! 협업을 시작하려면 로그인하세요.`,
	mww: (cumulus) => `Zoo siab txais tos rau ${cumulus}! Kos npe rau hauv pib sib koom tes.`,
	ps: (cumulus) => `${cumulus} ته ښه راغلاست! د همکارۍ پیل لپاره ننوتل.`,
	pt: (cumulus) => `Bem-vindo à ${cumulus}! Faça login para começar a colaborar.`,
	'pt-pt': (cumulus) => `Bem-vindo à ${cumulus}! Inicia sessão para começares a colaborar.`,
	ru: (cumulus) => `Добро пожаловать в ${cumulus}! Войдите в систему, чтобы начать совместную работу.`,
	sm: (cumulus) => `Fa'afeiloa'i i ${cumulus}! Saini i totonu e amata galulue fa'atasi.`,
	so: (cumulus) => `Ku soo dhawoow ${cumulus}! Isdiiwaangeli si aad iskaashi u bilowdo.`,
	th: (cumulus) => `ยินดีต้อนรับสู่ ${cumulus}! ลงชื่อเข้าใช้เพื่อเริ่มทํางานร่วมกัน`,
	ur: (cumulus) => `${cumulus} میں خوش آمدید! تعاون شروع کرنے کے لیے سائن ان کریں۔`,
	vi: (cumulus) => `Chào mừng bạn đến với ${cumulus}! Đăng nhập để bắt đầu cộng tác.`,
	'zh-hans': (cumulus) => `欢迎来到 ${cumulus}！登录即可开始合作。`,
	'zh-hant': (cumulus) => `歡迎來到 ${cumulus}！登入以開始合作。`,
	en: (cumulus) => `Welcome to ${cumulus}! Sign in to start collaborating.`
};

export const loc_action: Record<Locale, string> = {
	ar: `الحدث`,
	de: `Aktion`,
	es: `Acción`,
	fa: `عملیات`,
	fil: `Aksyon`,
	fr: `Action`,
	hi: `मुक़दमा`,
	ht: `Aksyon`,
	it: `Azione`,
	ja: `戦闘`,
	ko: `작전`,
	mww: `Kev nqis tes ua`,
	ps: `عمل`,
	pt: `Ação`,
	'pt-pt': `Ação`,
	ru: `Бой`,
	sm: `Faatinoga`,
	so: `Ficil`,
	th: `การกระทํา`,
	ur: `کارروائی`,
	vi: `Hoạt động`,
	'zh-hans': `行动`,
	'zh-hant': `行動`,
	en: `Action`
};

export const loc_actionRequired: Record<Locale, string> = {
	ar: `الإجراء المطلوب`,
	de: `Handlungsbedarf`,
	es: `Se requiere acción`,
	fa: `اقدام لازم است`,
	fil: `Kinakailangan ang aksyon`,
	fr: `Action requise`,
	hi: `कार्रवाई की आवश्यकता है`,
	ht: `Aksyon obligatwa`,
	it: `Azione richiesta`,
	ja: `必要な行動`,
	ko: `조치 필요`,
	mww: `Yuav tsum tau nqis tes ua`,
	ps: `اقدام ته اړتیا ده`,
	pt: `Ação necessária`,
	'pt-pt': `Ação necessária`,
	ru: `Требуются действия`,
	sm: `Faatinoga e manaomia`,
	so: `Tallaabo loo baahan yahay`,
	th: `การดําเนินการที่จําเป็น`,
	ur: `کارروائی ضروری ہے`,
	vi: `Hành động bắt buộc`,
	'zh-hans': `需要采取行动`,
	'zh-hant': `需要採取行動`,
	en: `Action required`
};

export const loc_actions: Record<Locale, string> = {
	ar: `الإجراءات`,
	de: `Aktionen`,
	es: `Acciones`,
	fa: `اقدامات`,
	fil: `Mga Pagkilos`,
	fr: `Actions`,
	hi: `कार्रवाई`,
	ht: `Aksyon yo`,
	it: `Azioni`,
	ja: `行動`,
	ko: `작전`,
	mww: `Kev Ua`,
	ps: `کړنې`,
	pt: `Ações`,
	'pt-pt': `Ações`,
	ru: `Действия`,
	sm: `Faatinoga`,
	so: `Falalka`,
	th: `การดําเนินการ`,
	ur: `کارروائیاں`,
	vi: `Hành động`,
	'zh-hans': `行动`,
	'zh-hant': `行動`,
	en: `Actions`
};

export const loc_active: Record<Locale, string> = {
	ar: `نشط`,
	de: `Aktiv`,
	es: `Activo`,
	fa: `فعال`,
	fil: `Aktibo`,
	fr: `Actifs`,
	hi: `सक्रिय`,
	ht: `Aktif`,
	it: `Attivo`,
	ja: `現役`,
	ko: `활성`,
	mww: `nquag`,
	ps: `فعال`,
	pt: `Ativo`,
	'pt-pt': `Ativo`,
	ru: `Активные`,
	sm: `Toaga`,
	so: `Firfircoon`,
	th: `คล่องแคล่ว`,
	ur: `فعال`,
	vi: `Hoạt động`,
	'zh-hans': `活跃`,
	'zh-hant': `現役`,
	en: `Active`
};

export const loc_activities: Record<Locale, string> = {
	ar: `الأنشطة`,
	de: `Aktivitäten`,
	es: `Actividades`,
	fa: `فعالیت ها`,
	fil: `Mga Aktibidad`,
	fr: `Activités`,
	hi: `गतिविधियाँ`,
	ht: `Aktivite yo`,
	it: `Attività`,
	ja: `活動`,
	ko: `활동`,
	mww: `Kev Ua Si`,
	ps: `فعالیتونه`,
	pt: `Atividades`,
	'pt-pt': `Atividades`,
	ru: `Деятельность`,
	sm: `Gaoioiga`,
	so: `Hawlaha`,
	th: `กิจกรรม`,
	ur: `سرگرمیاں`,
	vi: `Hoạt động`,
	'zh-hans': `活动`,
	'zh-hant': `活動`,
	en: `Activities`
};

export const loc_activitiesFormat: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} أنشطة`,
	de: (count) => `${count} Aktivitäten`,
	es: (count) => `${count} actividades`,
	fa: (count) => `${count} فعالیت`,
	fil: (count) => `${count} Mga Aktibidad`,
	fr: (count) => `${count} activités`,
	hi: (count) => `${count} गतिविधियाँ`,
	ht: (count) => `${count} Aktivite`,
	it: (count) => `${count} attività`,
	ja: (count) => `${count} つの活動`,
	ko: (count) => `${count} 가지 활동`,
	mww: (count) => `${count} kev ua ub no`,
	ps: (count) => `${count} فعالیتونه`,
	pt: (count) => `${count} atividades`,
	'pt-pt': (count) => `${count} Atividades`,
	ru: (count) => `${count} видов деятельности`,
	sm: (count) => `${count} Gaoioiga`,
	so: (count) => `${count} Hawlo`,
	th: (count) => `${count} กิจกรรม`,
	ur: (count) => `${count} سرگرمیاں`,
	vi: (count) => `${count} hoạt động`,
	'zh-hans': (count) => `${count} 活动`,
	'zh-hant': (count) => `${count} 活動`,
	en: (count) => `${count} activities`
};

export const loc_activity: Record<Locale, string> = {
	ar: `النشاط`,
	de: `Tätigkeit`,
	es: `Actividad`,
	fa: `فعالیت ها`,
	fil: `Aktibidad`,
	fr: `Activité`,
	hi: `गतिविधि`,
	ht: `Aktivite`,
	it: `Attività`,
	ja: `活動`,
	ko: `활동`,
	mww: `Kev Ua Si`,
	ps: `فعالیت`,
	pt: `Atividade`,
	'pt-pt': `Atividade`,
	ru: `Деятельность`,
	sm: `Gaoioiga`,
	so: `Hawlaha`,
	th: `กิจกรรม`,
	ur: `سرگرمی`,
	vi: `Hoạt động`,
	'zh-hans': `活动`,
	'zh-hant': `活動`,
	en: `Activity`
};

export const loc_activityDefinition: Record<Locale, string> = {
	ar: `تعريف النشاط`,
	de: `Aktivitätsdefinition`,
	es: `Definición de actividad`,
	fa: `تعریف فعالیت`,
	fil: `Kahulugan ng aktibidad`,
	fr: `Définition de l’activité`,
	hi: `गतिविधि परिभाषा`,
	ht: `Definisyon aktivite`,
	it: `Definizione dell'attività`,
	ja: `活動の定義`,
	ko: `활동 정의`,
	mww: `Kev ua haujlwm txhais`,
	ps: `د فعالیت تعریف`,
	pt: `Definição de atividade`,
	'pt-pt': `Definição de atividade`,
	ru: `Определение деятельности`,
	sm: `Fa'amatalaga o le gaioiga`,
	so: `Qeexidda hawlaha`,
	th: `คําจํากัดความของกิจกรรม`,
	ur: `سرگرمی کی تعریف`,
	vi: `Định nghĩa hoạt động`,
	'zh-hans': `活动定义`,
	'zh-hant': `活動定義`,
	en: `Activity definition`
};

export const loc_activityDefinitionInstructionsDescription: Record<Locale, (entityType: unknown) => string> = {
	ar: (entityType) => `التعليمات اختيارية وستظهر في أعلى كل ${entityType}.`,
	de: (entityType) => `Anweisungen sind optional und erscheinen am Anfang jeder ${entityType}.`,
	es: (entityType) => `Las instrucciones son opcionales y aparecerán al principio de cada ${entityType}.`,
	fa: (entityType) => `دستورالعمل ها اختیاری هستند و در ابتدای هر ${entityType} ظاهر می شوند.`,
	fil: (entityType) => `Ang mga tagubilin ay opsyonal at lilitaw sa tuktok ng bawat ${entityType}.`,
	fr: (entityType) => `Les instructions sont optionnelles et apparaîtront en haut de chaque ${entityType}.`,
	hi: (entityType) => `निर्देश वैकल्पिक हैं और प्रत्येक ${entityType} के शीर्ष पर दिखाई देंगे।`,
	ht: (entityType) => `Enstriksyon yo si ou vle epi yo pral parèt nan tèt chak ${entityType}.`,
	it: (entityType) => `Le istruzioni sono opzionali e appariranno in cima a ogni ${entityType}.`,
	ja: (entityType) => `指示は任意で、各 ${entityType}の上部に表示されます。`,
	ko: (entityType) => `지침은 선택 사항이며 각 ${entityType} 상단에 나타납니다.`,
	mww: (entityType) => `Cov lus qhia yog yeem thiab yuav tshwm sim rau sab saum toj ntawm txhua ${entityType}.`,
	ps: (entityType) => `لارښوونې اختیاری دی او د هرې ${entityType} په سر کې څرګندیږی.`,
	pt: (entityType) => `As instruções são opcionais e aparecerão no topo de cada ${entityType}.`,
	'pt-pt': (entityType) => `As instruções são opcionais e aparecem no topo de cada ${entityType}.`,
	ru: (entityType) => `Инструкции необязательны и будут отображаться в начале ${entityType}.`,
	sm: (entityType) => `O faatonuga e faitaliatia ma o le a faaali mai i le pito i luga o ${entityType} taitasi.`,
	so: (entityType) => `Tilmaamuhu waa ikhtiyaari waxayna ka soo muuqan doonaan dusha sare ee ${entityType} kasta.`,
	th: (entityType) => `วิธีการเป็นทางเลือกและจะปรากฏที่ด้านบนของ${entityType}`,
	ur: (entityType) => `ہدایات اختیاری ہیں اور ہر ${entityType} کے اوپر ظاہر ہوں گی۔`,
	vi: (entityType) => `Hướng dẫn là tùy chọn và sẽ xuất hiện ở đầu mỗi ${entityType}.`,
	'zh-hans': (entityType) => `说明是可选的，会显示在每个 ${entityType}的顶部。`,
	'zh-hant': (entityType) => `說明書為可選，會顯示在每個 ${entityType}的頂端。`,
	en: (entityType) => `Instructions are optional and will appear at the top of each ${entityType}.`
};

export const loc_activityDefinitions: Record<Locale, string> = {
	ar: `تعريفات الأنشطة`,
	de: `Aktivitätsdefinitionen`,
	es: `Definiciones de actividades`,
	fa: `تعاریف فعالیت ها`,
	fil: `Mga kahulugan ng aktibidad`,
	fr: `Définitions d’activités`,
	hi: `गतिविधि परिभाषाएँ`,
	ht: `Definisyon aktivite`,
	it: `Definizioni di attività`,
	ja: `活動の定義`,
	ko: `활동 정의`,
	mww: `Cov lus txhais ntawm kev ua ub no`,
	ps: `د فعالیت تعریفونه`,
	pt: `Definições de atividades`,
	'pt-pt': `Definições de atividades`,
	ru: `Определения деятельности`,
	sm: `Faauigaga o gaoioiga`,
	so: `Qeexitaannada hawlaha`,
	th: `คําจํากัดความของกิจกรรม`,
	ur: `سرگرمیوں کی تعریفیں`,
	vi: `Định nghĩa hoạt động`,
	'zh-hans': `活动定义`,
	'zh-hant': `活動定義`,
	en: `Activity definitions`
};

export const loc_activityReportDescription: Record<Locale, string> = {
	ar: `سجلات النشاط، بالإضافة إلى التركيبة السكانية للشخص المعني ومعلومات الاتصال به.`,
	de: `Aktivitätsaufzeichnungen sowie die demografischen Angaben und Kontaktdaten der zugehörigen Person.`,
	es: `Registros de actividades, junto con la demografía y la información de contacto de la persona asociada.`,
	fa: `سوابق فعالیت ها، همراه با جمعیت شناسی و اطلاعات تماس فرد مرتبط.`,
	fil: `Mga talaan ng aktibidad, kasama ang demograpiko at impormasyon sa pakikipag-ugnay ng nauugnay na tao.`,
	fr: `Des dossiers d’activité, ainsi que la démographie et les coordonnées de la personne associée.`,
	hi: `गतिविधि रिकॉर्ड, संबद्ध व्यक्ति की जनसांख्यिकी और संपर्क जानकारी के साथ।`,
	ht: `Dosye aktivite, ansanm ak demografik moun ki asosye ak enfòmasyon kontak.`,
	it: `Registri delle attività, insieme alla demografia e alle informazioni di contatto della persona associata.`,
	ja: `活動記録、関連する人物の人口統計や連絡先情報も含めて。`,
	ko: `활동 기록과 관련된 사람의 인구통계 및 연락처 정보.`,
	mww: `Cov ntaub ntawv ua ub no, nrog rau tus neeg koom nrog cov pej xeem thiab cov ntaub ntawv tiv tauj.`,
	ps: `د فعالیت ریکارډونه، د اړوند کس نفوس او د تماس معلومات.`,
	pt: `Registros de atividades, junto com a demografia e informações de contato da pessoa associada.`,
	'pt-pt': `Registos de atividades, juntamente com a demografia e informações de contacto da pessoa associada.`,
	ru: `Записи о активности, а также демографические данные и контактные данные соответствующего лица.`,
	sm: `Faamaumauga o gaoioiga, faatasi ai ma le faitau aofai o tagata e fesootai ma faamatalaga e faafesootai ai.`,
	so: `Diiwaanka hawlaha, iyo sidoo kale tirakoobka dadka la xiriira iyo macluumaadka xiriirka.`,
	th: `บันทึกกิจกรรม พร้อมกับข้อมูลประชากรและข้อมูลติดต่อของบุคคลที่เกี่ยวข้อง`,
	ur: `سرگرمیوں کے ریکارڈز، متعلقہ شخص کی آبادیاتی معلومات اور رابطہ معلومات۔`,
	vi: `Hồ sơ hoạt động, cùng với thông tin nhân khẩu học và liên hệ của người được liên kết.`,
	'zh-hans': `活动记录，以及相关人员的人口统计和联系方式。`,
	'zh-hant': `活動紀錄，以及相關人員的人口統計資料和聯絡資訊。`,
	en: `Activity records, along with the associated person's demographics and contact information.`
};

export const loc_addAddress: Record<Locale, string> = {
	ar: `إضافة عنوان`,
	de: `Adresse hinzufügen`,
	es: `Añadir dirección`,
	fa: `افزودن آدرس`,
	fil: `Email Address`,
	fr: `Ajouter l’adresse`,
	hi: `पता जोड़ें`,
	ht: `Ajoute adrès`,
	it: `Aggiungi indirizzo`,
	ja: `アドレスを追加`,
	ko: `주소 추가`,
	mww: `Ntxiv chaw nyob`,
	ps: `د پته اضافه کول`,
	pt: `Adicionar endereço`,
	'pt-pt': `Adicionar morada`,
	ru: `Добавить адрес`,
	sm: `Fa'aopopo le tuatusi`,
	so: `Cinwaanka ku dar`,
	th: `เพิ่มที่อยู่`,
	ur: `ایڈریس شامل کریں`,
	vi: `Thêm địa chỉ`,
	'zh-hans': `添加地址`,
	'zh-hant': `新增地址`,
	en: `Add address`
};

export const loc_addAnotherActivityContent: Record<Locale, (addNextHref: unknown, activityTitle: unknown, parentHref: unknown, parentActivityTitle: unknown) => TemplateResult> = {
	ar: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">أضف ${activityTitle}</a> إلى <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	de: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Füge eine weitere ${activityTitle}</a> zur <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> hinzu.`,
	es: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Añade otra ${activityTitle}</a> al <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	fa: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">یک ${activityTitle} دیگر به</a> <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> اضافه کنید.`,
	fil: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Magdagdag ng isa pang ${activityTitle}</a> sa <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	fr: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Ajoutez une ${activityTitle}</a> à <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	hi: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> में <a class="text-bold" href="${addNextHref}">एक और ${activityTitle} जोड़ें</a>।`,
	ht: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Ajoute yon lòt ${activityTitle}</a> nan <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>`,
	it: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Aggiungi un ${activityTitle}</a> <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	ja: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`家庭<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>に<a class="text-bold" href="${addNextHref}">もう一${activityTitle}を追加</a>しましょう。`,
	ko: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>에 <a class="text-bold" href="${addNextHref}">또 다른 ${activityTitle}를 추가</a>하세요.`,
	mww: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Ntxiv lwm ${activityTitle}</a> rau <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	ps: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`د <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> <a class="text-bold" href="${addNextHref}">ته بله ${activityTitle} اضافه</a> کړه.`,
	pt: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Adicione mais uma ${activityTitle}</a> ao <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	'pt-pt': (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Adicione mais um ${activityTitle}</a> ao <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	ru: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Добавьте ещё один ${activityTitle}</a> в <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	sm: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Fa'aopopo se isi ${activityTitle}</a> i le <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	so: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Ku dar ${activityTitle}</a> dhacdada <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	th: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">เพิ่ม${activityTitle}อื่น</a>ใน<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>`,
	ur: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> میں <a class="text-bold" href="${addNextHref}">ایک اور ${activityTitle} شامل</a> کریں۔`,
	vi: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Thêm một ${activityTitle} khác</a> vào <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
	'zh-hans': (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`在<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a><a class="text-bold" href="${addNextHref}">中添加另一项${activityTitle}</a>。`,
	'zh-hant': (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`在<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a><a class="text-bold" href="${addNextHref}">中新增另一${activityTitle}</a>。`,
	en: (addNextHref, activityTitle, parentHref, parentActivityTitle) => html`<a class="text-bold" href="${addNextHref}">Add another ${activityTitle}</a> to <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`
};

export const loc_addCap: Record<Locale, string> = {
	ar: `إضافة غطاء`,
	de: `Kappe hinzufügen`,
	es: `Añadir la tapa`,
	fa: `افزودن کلاه`,
	fil: `Email Address *`,
	fr: `Ajouter un condensateur`,
	hi: `टोपी जोड़ें`,
	ht: `Ajoute bouchon`,
	it: `Aggiungi maiusculo`,
	ja: `キャップを付ける`,
	ko: `캡 추가하세요`,
	mww: `Ntxiv lub kaus mom`,
	ps: `د کپ اضافه کول`,
	pt: `Adicionar tampa`,
	'pt-pt': `Adicionar maiúscula`,
	ru: `Добавь крышку`,
	sm: `Fa'aopopo pulou`,
	so: `Ku dar koofiyadda`,
	th: `เพิ่มฝาปิด`,
	ur: `ٹوپی شامل کریں`,
	vi: `Thêm nắp`,
	'zh-hans': `加盖`,
	'zh-hant': `加蓋`,
	en: `Add cap`
};

export const loc_addContact: Record<Locale, string> = {
	ar: `أضف الاتصال`,
	de: `Kontakt hinzufügen`,
	es: `Añadir contacto`,
	fa: `تماس را اضافه کنید`,
	fil: `Email Address *`,
	fr: `Ajouter le contact`,
	hi: `संपर्क जोड़ें`,
	ht: `Ajoute kontak`,
	it: `Aggiungi contatto`,
	ja: `連絡先を追加`,
	ko: `연락처 추가`,
	mww: `Ntxiv kev sib cuag`,
	ps: `تماس اضافه کړئ`,
	pt: `Adicionar contato`,
	'pt-pt': `Adicionar contacto`,
	ru: `Добавить контакт`,
	sm: `Fa'aopopo le feso'ota'iga`,
	so: `Ku dar xiriirka`,
	th: `เพิ่มผู้ติดต่อ`,
	ur: `رابطہ شامل کریں`,
	vi: `Thêm liên hệ`,
	'zh-hans': `添加联系`,
	'zh-hant': `新增聯絡人`,
	en: `Add contact`
};

export const loc_addEmail: Record<Locale, string> = {
	ar: `إضافة البريد الإلكتروني`,
	de: `E-Mail hinzufügen`,
	es: `Añadir correo electrónico`,
	fa: `افزودن ایمیل`,
	fil: `Email Address`,
	fr: `Ajouter un email`,
	hi: `ईमेल जोड़ें`,
	ht: `Ajoute imèl`,
	it: `Aggiungi email`,
	ja: `メールを追加`,
	ko: `이메일 추가로`,
	mww: `Ntxiv email`,
	ps: `ایمیل اضافه کړئ`,
	pt: `Adicionar e-mail`,
	'pt-pt': `Adicionar email`,
	ru: `Добавить электронную почту`,
	sm: `Fa'aopopo imeli`,
	so: `Ku dar email`,
	th: `เพิ่มอีเมล`,
	ur: `ای میل شامل کریں`,
	vi: `Thêm email`,
	'zh-hans': `添加邮箱`,
	'zh-hant': `新增電子郵件`,
	en: `Add email`
};

export const loc_addEntryToFormat: Record<Locale, (date: unknown) => string> = {
	ar: (date) => `أضف المشاركة إلى ${date}`,
	de: (date) => `Eintritt hinzufügen am ${date}`,
	es: (date) => `Añadir entrada al ${date}`,
	fa: (date) => `اضافه کردن ورودی به ${date}`,
	fil: (date) => `Magdagdag ng entry sa ${date}`,
	fr: (date) => `Ajouter l’entrée au ${date}`,
	hi: (date) => `${date} में प्रविष्टि जोड़ें`,
	ht: (date) => `Add entry to ${date}`,
	it: (date) => `Aggiungi ${date}`,
	ja: (date) => `${date}への参加追加`,
	ko: (date) => `${date}에 참가를 추가하세요`,
	mww: (date) => `Ntxiv nkag rau ${date}`,
	ps: (date) => `ګډون ${date} ته اضافه کړئ`,
	pt: (date) => `Adicionar entrada para ${date}`,
	'pt-pt': (date) => `Adicionar entrada para ${date}`,
	ru: (date) => `Добавить запись в ${date} года`,
	sm: (date) => `Fa'aopopo le ulufale i le ${date}`,
	so: (date) => `Ku dar gelitaanka ${date}`,
	th: (date) => `เพิ่มสิทธิ์เข้า ${date}`,
	ur: (date) => `${date} کو اندراج شامل کریں`,
	vi: (date) => `Thêm vé vào Thứ ${date}`,
	'zh-hans': (date) => `新增报名日期： ${date}`,
	'zh-hant': (date) => `新增報名日期： ${date}`,
	en: (date) => `Add entry to ${date}`
};

export const loc_addMedication: Record<Locale, string> = {
	ar: `أضف الدواء`,
	de: `Medikamente hinzufügen`,
	es: `Añadir medicación`,
	fa: `دارو اضافه کنید`,
	fil: `Magdagdag ng gamot`,
	fr: `Ajouter un médicament`,
	hi: `दवा जोड़ें`,
	ht: `Ajoute medikaman`,
	it: `Aggiungi farmaci`,
	ja: `薬を追加してください`,
	ko: `약물 복용`,
	mww: `Ntxiv tshuaj`,
	ps: `درمل اضافه کړئ`,
	pt: `Adicionar medicação`,
	'pt-pt': `Adicionar medicação`,
	ru: `Добавьте лекарства`,
	sm: `Fa'aopopo vaila'au`,
	so: `Daawo ku dar`,
	th: `เพิ่มยา`,
	ur: `دوا شامل کریں`,
	vi: `Thêm thuốc`,
	'zh-hans': `加药`,
	'zh-hant': `加藥`,
	en: `Add medication`
};

export const loc_addNew: Record<Locale, string> = {
	ar: `إضافة جديد`,
	de: `Neue hinzufügen`,
	es: `Añadir nuevo`,
	fa: `افزودن جدید`,
	fil: `Email Address *`,
	fr: `Ajouter de nouvelles`,
	hi: `नया जोड़ें`,
	ht: `Ajoute nouvo`,
	it: `Aggiungi nuovo`,
	ja: `新たに追加`,
	ko: `새 새 항목 추가.`,
	mww: `Ntxiv tshiab`,
	ps: `نوی اضافه کړه`,
	pt: `Adicionar novo`,
	'pt-pt': `Adicionar novo`,
	ru: `Добавить новые`,
	sm: `Fa'aopopo fou`,
	so: `Ku dar cusub`,
	th: `เพิ่มใหม่`,
	ur: `نیا شامل کریں`,
	vi: `Thêm`,
	'zh-hans': `添加新内容`,
	'zh-hant': `新增`,
	en: `Add new`
};

export const loc_addPhone: Record<Locale, string> = {
	ar: `إضافة الهاتف`,
	de: `Handy hinzufügen`,
	es: `Añadir teléfono`,
	fa: `افزودن تلفن`,
	fil: `Email Address *`,
	fr: `Ajouter le téléphone`,
	hi: `फ़ोन जोड़ें`,
	ht: `Ajoute telefòn`,
	it: `Aggiungi telefono`,
	ja: `電話を追加`,
	ko: `전화 추가하세요`,
	mww: `Ntxiv xov tooj`,
	ps: `د ټیلیفون اضافه کول`,
	pt: `Adicionar telefone`,
	'pt-pt': `Adicionar telefone`,
	ru: `Добавить телефон`,
	sm: `Fa'aopopo le telefoni`,
	so: `Ku dar telefoonka`,
	th: `เพิ่มโทรศัพท์`,
	ur: `ایڈ فون`,
	vi: `Thêm điện thoại`,
	'zh-hans': `添加电话`,
	'zh-hant': `新增電話`,
	en: `Add phone`
};

export const loc_address: Record<Locale, string> = {
	ar: `العنوان`,
	de: `Adresse`,
	es: `Dirección`,
	fa: `آدرس`,
	fil: `Email Address`,
	fr: `Adresse`,
	hi: `पता`,
	ht: `Adrès`,
	it: `Indirizzo`,
	ja: `住所`,
	ko: `주소`,
	mww: `Chaw Nyob`,
	ps: `پته`,
	pt: `Endereço`,
	'pt-pt': `Endereço`,
	ru: `Адрес`,
	sm: `Tuatusi`,
	so: `Cinwaanka`,
	th: `ที่อยู่`,
	ur: `خطاب`,
	vi: `Địa chỉ`,
	'zh-hans': `地址`,
	'zh-hant': `地址`,
	en: `Address`
};

export const loc_addressCouldNotBeGeolocated: Record<Locale, string> = {
	ar: `لم يكن بالإمكان تحديد موقع العنوان`,
	de: `Adresse konnte nicht geolokalisiert werden`,
	es: `La dirección no pudo ser geolocalizada`,
	fa: `آدرس را نمی شد مکان یابی کرد`,
	fil: `Hindi ma-geolocate ang address`,
	fr: `L’adresse n’a pas pu être géolocalisée`,
	hi: `पता जियोलोकेट नहीं किया जा सका`,
	ht: `Adrès pa t 'kapab jeolokalize`,
	it: `L'indirizzo non poteva essere geolocalizzato`,
	ja: `住所はジオロケーションできませんでした`,
	ko: `주소는 위치 지정이 불가능했습니다`,
	mww: `Chaw nyob tsis tau nrhiav tau qhov chaw nyob`,
	ps: `پته نشوه کولای جغرافیایی موقعیت پیدا کړی`,
	pt: `O endereço não pôde ser geolocalizado`,
	'pt-pt': `O endereço não pôde ser geolocalizado`,
	ru: `Адрес не мог быть геолокационен`,
	sm: `E le mafai ona fa'apipi'i le tuatusi`,
	so: `Cinwaanka lama heli karin geolocation`,
	th: `ไม่สามารถระบุตําแหน่งที่อยู่ได้`,
	ur: `پتہ جیو لوکیشن نہیں کیا جا سکتا تھا`,
	vi: `Địa chỉ không thể định vị địa lý`,
	'zh-hans': `地址无法定位`,
	'zh-hant': `地址無法定位`,
	en: `Address could not be geolocated`
};

export const loc_addressDetails: Record<Locale, string> = {
	ar: `تفاصيل العنوان`,
	de: `Adressdetails`,
	es: `Detalles de la dirección`,
	fa: `جزئیات آدرس`,
	fil: `Mga detalye ng address`,
	fr: `Détails de l’adresse`,
	hi: `पते का विवरण`,
	ht: `Adrès detay`,
	it: `Dettagli dell'indirizzo`,
	ja: `住所の詳細`,
	ko: `주소 세부사항`,
	mww: `Chaw nyob cov ntsiab lus`,
	ps: `د پته تفصیلات`,
	pt: `Detalhes do endereço`,
	'pt-pt': `Detalhes do endereço`,
	ru: `Данные адреса`,
	sm: `Faamatalaga o le tuatusi`,
	so: `Faahfaahinta cinwaanka`,
	th: `รายละเอียดที่อยู่`,
	ur: `پتے کی تفصیلات`,
	vi: `Chi tiết địa chỉ`,
	'zh-hans': `地址详情`,
	'zh-hant': `地址詳情`,
	en: `Address details`
};

export const loc_addresses: Record<Locale, string> = {
	ar: `العناوين`,
	de: `Adressen`,
	es: `Direcciones`,
	fa: `آدرس ها`,
	fil: `Email Address`,
	fr: `Allocutions`,
	hi: `पते`,
	ht: `Adrès yo`,
	it: `Indirizzi`,
	ja: `住所`,
	ko: `주소`,
	mww: `Chaw Nyob`,
	ps: `پته ګانې`,
	pt: `Endereços`,
	'pt-pt': `Endereços`,
	ru: `Адреса`,
	sm: `Tuatusi`,
	so: `Cinwaanada`,
	th: `ที่อยู่`,
	ur: `خطابات`,
	vi: `Địa chỉ`,
	'zh-hans': `地址`,
	'zh-hant': `地址`,
	en: `Addresses`
};

export const loc_addSite: Record<Locale, string> = {
	ar: `إضافة الموقع`,
	de: `Webseite hinzufügen`,
	es: `Añadir sitio`,
	fa: `افزودن سایت`,
	fil: `Email Address *`,
	fr: `Ajouter le site`,
	hi: `साइट जोड़ें`,
	ht: `Ajoute sit`,
	it: `Aggiungi sito`,
	ja: `サイトを追加`,
	ko: `사이트 추가`,
	mww: `Ntxiv qhov chaw`,
	ps: `د ځای اضافه کول`,
	pt: `Adicionar site`,
	'pt-pt': `Adicionar site`,
	ru: `Добавить сайт`,
	sm: `Fa'aopopo le 'upega tafa'ilagi`,
	so: `Ku dar bogga`,
	th: `เพิ่มเว็บไซต์`,
	ur: `سائٹ شامل کریں`,
	vi: `Thêm trang web`,
	'zh-hans': `添加网站`,
	'zh-hant': `新增網站`,
	en: `Add site`
};

export const loc_adherence: Record<Locale, string> = {
	ar: `الالتزام`,
	de: `Treue`,
	es: `Cumplimiento`,
	fa: `پایبندی`,
	fil: `Pagsunod`,
	fr: `Adhésion`,
	hi: `पालन`,
	ht: `Adezyon`,
	it: `Adesione`,
	ja: `遵守`,
	ko: `준수`,
	mww: `Kev ua raws li`,
	ps: `تعقیب`,
	pt: `Adesão`,
	'pt-pt': `Adesão`,
	ru: `Приверженность`,
	sm: `Tausisia`,
	so: `Adherance`,
	th: `การยึดมั่น`,
	ur: `پابندی`,
	vi: `Tuân thủ`,
	'zh-hans': `遵循`,
	'zh-hant': `遵從`,
	en: `Adherance`
};

export const loc_administrative: Record<Locale, string> = {
	ar: `الإدارة`,
	de: `Verwaltung`,
	es: `Administrativa`,
	fa: `اداری`,
	fil: `Administratibo`,
	fr: `Administratif`,
	hi: `संचालन-संबंधी`,
	ht: `Administratif`,
	it: `Amministrativa`,
	ja: `行政`,
	ko: `행정`,
	mww: `Kev tswj hwm`,
	ps: `اداری`,
	pt: `Administrativo`,
	'pt-pt': `Administrativo`,
	ru: `Административные`,
	sm: `Pulega`,
	so: `Maamulka`,
	th: `ธุรการ`,
	ur: `انتظامی`,
	vi: `Hành chính`,
	'zh-hans': `行政`,
	'zh-hant': `行政`,
	en: `Administrative`
};

export const loc_advanced: Record<Locale, string> = {
	ar: `متقدمة`,
	de: `Fortgeschritten`,
	es: `Avanzado`,
	fa: `پیشرفته`,
	fil: `Advanced`,
	fr: `Avancé`,
	hi: `अग्रवर्ती`,
	ht: `Avanse`,
	it: `Avanzato`,
	ja: `上級`,
	ko: `고급`,
	mww: `siab heev`,
	ps: `پرمختللی`,
	pt: `Avançado`,
	'pt-pt': `Avançado`,
	ru: `Продвинутый`,
	sm: `Alualu i luma`,
	so: `Horumarsan`,
	th: `ขั้นสูง`,
	ur: `ایڈوانسڈ`,
	vi: `Nâng cao`,
	'zh-hans': `高级`,
	'zh-hant': `進階`,
	en: `Advanced`
};

export const loc_age: Record<Locale, string> = {
	ar: `العمر`,
	de: `Alter`,
	es: `Edad`,
	fa: `سن`,
	fil: `Edad`,
	fr: `Âge`,
	hi: `उम्र`,
	ht: `Laj`,
	it: `Età`,
	ja: `年代`,
	ko: `연식`,
	mww: `hnub nyoog`,
	ps: `عمر`,
	pt: `Idade`,
	'pt-pt': `Idade`,
	ru: `Возраст`,
	sm: `Tausaga`,
	so: `Da'da`,
	th: `อายุ`,
	ur: `عمر`,
	vi: `Tuổi tác`,
	'zh-hans': `年龄`,
	'zh-hant': `年代`,
	en: `Age`
};

export const loc_agency: Record<Locale, string> = {
	ar: `الوكالة`,
	de: `Agentur`,
	es: `Agencia`,
	fa: `نمایندگی`,
	fil: `Ahensya`,
	fr: `Agence`,
	hi: `सरकारी एजेंसी`,
	ht: `Ajans`,
	it: `Agenzia`,
	ja: `代理店`,
	ko: `기관`,
	mww: `Lub koom haum`,
	ps: `اداره`,
	pt: `Agência`,
	'pt-pt': `Agência`,
	ru: `Агентство`,
	sm: `Faitalia`,
	so: `Hay'adda`,
	th: `หน่วยงาน`,
	ur: `ایجنسی`,
	vi: `Cơ quan`,
	'zh-hans': `代理机构`,
	'zh-hant': `代理機構`,
	en: `Agency`
};

export const loc_agreeToTermsOfUse: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `أوافق على شروط استخدام ${cumulus}`,
	de: (cumulus) => `Ich stimme den ${cumulus} zu`,
	es: (cumulus) => `Acepto los Términos de Uso ${cumulus}`,
	fa: (cumulus) => `من با شرایط استفاده ${cumulus} موافقم`,
	fil: (cumulus) => `Sumasang-ayon ako sa Mga Tuntunin ng Paggamit ${cumulus}`,
	fr: (cumulus) => `J’accepte les Conditions d’utilisation ${cumulus}`,
	hi: (cumulus) => `मैं ${cumulus} उपयोग की शर्तों से सहमत हूं`,
	ht: (cumulus) => `Mwen dakò ak Regleman ${cumulus}`,
	it: (cumulus) => `Accetto i Termini di Utilizzo ${cumulus}`,
	ja: (cumulus) => `私は ${cumulus} 利用規約に同意します`,
	ko: (cumulus) => `저는 ${cumulus} 이용 약관에 동의합니다`,
	mww: (cumulus) => `Kuv pom zoo rau ${cumulus} Cov Lus Cog Tseg ntawm Kev Siv`,
	ps: (cumulus) => `زه د ${cumulus} د کارونې شرایطو سره موافق یم`,
	pt: (cumulus) => `Concordo com os Termos de Uso ${cumulus}`,
	'pt-pt': (cumulus) => `Concordo com os Termos de Utilização ${cumulus}`,
	ru: (cumulus) => `Я согласен с условиями использования ${cumulus}`,
	sm: (cumulus) => `Ou te ioe i tuutuuga o le fa'aaogaina o ${cumulus}`,
	so: (cumulus) => `Waxaan ku raacsanahay Shuruudaha ${cumulus}`,
	th: (cumulus) => `ฉันยอมรับข้อกําหนดการใช้งาน ${cumulus}`,
	ur: (cumulus) => `میں ${cumulus} کی شرائط استعمال سے اتفاق کرتا ہوں`,
	vi: (cumulus) => `Tôi đồng ý với Điều khoản sử dụng ${cumulus}`,
	'zh-hans': (cumulus) => `我同意 ${cumulus} 使用条款`,
	'zh-hant': (cumulus) => `我同意 ${cumulus} 使用條款`,
	en: (cumulus) => `I agree to the ${cumulus} Terms of Use`
};

export const loc_all: Record<Locale, string> = {
	ar: `الجميع`,
	de: `Alle`,
	es: `Todos`,
	fa: `همه`,
	fil: `Lahat`,
	fr: `Tous`,
	hi: `सभी`,
	ht: `Tout`,
	it: `Tutti`,
	ja: `全員`,
	ko: `모두`,
	mww: `tag nrho`,
	ps: `ټول`,
	pt: `Todos`,
	'pt-pt': `Todos`,
	ru: `Все`,
	sm: `Uma`,
	so: `Dhammaan`,
	th: `ทั้งหมด`,
	ur: `سب`,
	vi: `Tất cả`,
	'zh-hans': `全部`,
	'zh-hant': `全部`,
	en: `All`
};

export const loc_allActivities: Record<Locale, string> = {
	ar: `جميع الأنشطة`,
	de: `Alle Aktivitäten`,
	es: `Todas las actividades`,
	fa: `تمام فعالیت ها`,
	fil: `Lahat ng Aktibidad`,
	fr: `Toutes les activités`,
	hi: `सभी गतिविधियाँ`,
	ht: `Tout aktivite`,
	it: `Tutte le attività`,
	ja: `すべての活動`,
	ko: `모든 활동`,
	mww: `Txhua yam kev ua ub no`,
	ps: `ټولې فعالیتونه`,
	pt: `Todas as atividades`,
	'pt-pt': `Todas as atividades`,
	ru: `Все виды деятельности`,
	sm: `Gaoioiga uma`,
	so: `Dhammaan hawlaha`,
	th: `กิจกรรมทั้งหมด`,
	ur: `تمام سرگرمیاں`,
	vi: `Tất cả các hoạt động`,
	'zh-hans': `所有活动`,
	'zh-hant': `所有活動`,
	en: `All activities`
};

export const loc_allAgencies: Record<Locale, string> = {
	ar: `جميع الوكالات`,
	de: `Alle Behörden`,
	es: `Todas las agencias`,
	fa: `تمام آژانس ها`,
	fil: `Lahat ng mga ahensya`,
	fr: `Toutes les agences`,
	hi: `सभी एजेंसियां`,
	ht: `Tout ajans yo`,
	it: `Tutte le agenzie`,
	ja: `すべての機関`,
	ko: `모든 기관`,
	mww: `Tag nrho cov chaw ua hauj lwm`,
	ps: `ټولې ادارې`,
	pt: `Todas as agências`,
	'pt-pt': `Todas as agências`,
	ru: `Все агентства`,
	sm: `Ofisa uma`,
	so: `Dhammaan hay'adaha`,
	th: `หน่วยงานทั้งหมด`,
	ur: `تمام ایجنسیاں`,
	vi: `Tất cả các cơ quan`,
	'zh-hans': `所有机构`,
	'zh-hant': `所有機構`,
	en: `All agencies`
};

export const loc_allEpisodesCases: Record<Locale, string> = {
	ar: `جميع الحلقات / القضايا`,
	de: `Alle Episoden / Fälle`,
	es: `Todos los episodios / casos`,
	fa: `تمام قسمت ها / پرونده ها`,
	fil: `Lahat ng mga episode / kaso`,
	fr: `Tous les épisodes / cas`,
	hi: `सभी एपिसोड/मामले`,
	ht: `Tout epizòd / ka`,
	it: `Tutti gli episodi / casi`,
	ja: `全エピソード/事件`,
	ko: `모든 에피소드 / 사건`,
	mww: `Txhua ntu / rooj plaub`,
	ps: `ټولې برخې / قضیې`,
	pt: `Todos os episódios / casos`,
	'pt-pt': `Todos os episódios / casos`,
	ru: `Все эпизоды / дела`,
	sm: `Vaega uma / mataupu`,
	so: `Dhammaan qaybaha / kiisaska`,
	th: `ทุกตอน / กรณี`,
	ur: `تمام اقساط / کیسز`,
	vi: `Tất cả các tập / trường hợp`,
	'zh-hans': `所有剧集/案件`,
	'zh-hant': `所有集數/案件`,
	en: `All episodes / cases`
};

export const loc_allEvents: Record<Locale, string> = {
	ar: `جميع الفعاليات`,
	de: `Alle Veranstaltungen`,
	es: `Todos los eventos`,
	fa: `تمام رویدادها`,
	fil: `Lahat ng mga kaganapan`,
	fr: `Tous les événements`,
	hi: `सभी कार्यक्रम`,
	ht: `Tout evènman`,
	it: `Tutti gli eventi`,
	ja: `すべてのイベント`,
	ko: `모든 행사`,
	mww: `Tag nrho cov xwm txheej`,
	ps: `ټولې پیښې`,
	pt: `Todos os eventos`,
	'pt-pt': `Todos os eventos`,
	ru: `Все мероприятия`,
	sm: `Mea uma na tutupu`,
	so: `Dhammaan dhacdooyinka`,
	th: `กิจกรรมทั้งหมด`,
	ur: `تمام ایونٹس`,
	vi: `Tất cả các sự kiện`,
	'zh-hans': `所有赛事`,
	'zh-hant': `所有活動`,
	en: `All events`
};

export const loc_allowCopying: Record<Locale, string> = {
	ar: `السماح بالنسخ`,
	de: `Kopieren erlaubt`,
	es: `Permitir la copia`,
	fa: `اجازه کپی کردن را بدهید`,
	fil: `Payagan ang pagkopya`,
	fr: `Autoriser la copie`,
	hi: `कॉपी करने की अनुमति दें`,
	ht: `Pèmèt kopi`,
	it: `Consentire la copia`,
	ja: `コピーを許可する`,
	ko: `복사 허용`,
	mww: `Tso cai luam`,
	ps: `کاپی کول اجازه ورکړئ`,
	pt: `Permitir cópia`,
	'pt-pt': `Permitir cópia`,
	ru: `Разрешить копирование`,
	sm: `Faataga le kopiina`,
	so: `Oggolaanshaha nuqulka`,
	th: `อนุญาตให้คัดลอก`,
	ur: `نقل کی اجازت دیں`,
	vi: `Cho phép sao chép`,
	'zh-hans': `允许复制`,
	'zh-hant': `允許複製`,
	en: `Allow copying`
};

export const loc_allowCopyingDescription: Record<Locale, string> = {
	ar: `هل يمكن السماح للمستخدمين بعمل نسخة من هذا النشاط؟`,
	de: `Erlauben Sie Nutzern, eine Kopie dieser Aktivität zu erstellen?`,
	es: `¿Permitir que los usuarios hagan una copia de esta actividad?`,
	fa: `آیا به کاربران اجازه داده می شود که یک نسخه از این فعالیت تهیه کنند؟`,
	fil: `Papayagan ba ang mga gumagamit na gumawa ng kopya ng aktibidad na ito?`,
	fr: `Permettre aux utilisateurs de faire une copie de cette activité ?`,
	hi: `उपयोगकर्ताओं को इस गतिविधि की प्रतिलिपि बनाने की अनुमति दें?`,
	ht: `Pèmèt itilizatè yo fè yon kopi aktivite sa a?`,
	it: `Permettere agli utenti di fare una copia di questa attività?`,
	ja: `ユーザーがこの活動のコピーを作成できるようにできますか?`,
	ko: `사용자가 이 활동의 복사본을 만들 수 있게 하나요?`,
	mww: `Tso cai rau cov neeg siv los ua ib daim qauv ntawm qhov kev ua no?`,
	ps: `کاروونکو ته اجازه ورکول چې د دې فعالیت کاپی جوړ کړی؟`,
	pt: `Permitir que os usuários façam uma cópia dessa atividade?`,
	'pt-pt': `Permitir que os utilizadores façam uma cópia desta atividade?`,
	ru: `Разрешите пользователям сделать копию этой активности?`,
	sm: `E mafai e tagata fa'aaoga ona faia se kopi o lenei gaoioiga?`,
	so: `Isticmaaleyaasha ma u oggolaan kartaa inay nuqul ka sameeyaan hawshan?`,
	th: `อนุญาตให้ผู้ใช้ทําสําเนากิจกรรมนี้ได้ไหม`,
	ur: `کیا صارفین کو اس سرگرمی کی کاپی بنانے کی اجازت دی جا سکتی ہے؟`,
	vi: `Cho phép người dùng tạo bản sao của hoạt động này?`,
	'zh-hans': `允许用户复制这项活动吗？`,
	'zh-hant': `允許使用者複製這個活動？`,
	en: `Allow users to make a copy of this activity?`
};

export const loc_allowOverlaps: Record<Locale, string> = {
	ar: `السماح بالتداخلات`,
	de: `Überlappungen erlauben`,
	es: `Permitir solapamientos`,
	fa: `اجازه دادن به همپوشانی ها`,
	fil: `Payagan ang mga overlap`,
	fr: `Autoriser les chevauchements`,
	hi: `ओवरलैप की अनुमति दें`,
	ht: `Pèmèt sipèpoze`,
	it: `Consentire sovrapposizioni`,
	ja: `重複を認める`,
	ko: `중첩 허용`,
	mww: `Tso cai sib tshooj`,
	ps: `همغږی اجازه ورکړئ`,
	pt: `Permitir sobreposições`,
	'pt-pt': `Permitir sobreposições`,
	ru: `Разрешить перекрытия`,
	sm: `Faatagaina overlaps`,
	so: `U oggolaa is-dhexgalka`,
	th: `อนุญาตให้ทับซ้อนกัน`,
	ur: `اوورلیپس کی اجازت دیں`,
	vi: `Cho phép trùng lặp`,
	'zh-hans': `允许重叠`,
	'zh-hant': `允許重疊`,
	en: `Allow overlaps`
};

export const loc_allowOverlapsDesc: Record<Locale, string> = {
	ar: `اسمح لعدة أنشطة من هذا النوع بأن يكون لها تواريخ بداية ونهاية متداخلة. يتم التحقق من جميع حالات النشاط باستثناء الملغاة عند تحديد التداخل.`,
	de: `Erlauben Sie, dass mehrere Aktivitäten dieser Art überlappende Start- und Enddaten haben. Alle Aktivitätsstatusse außer "Abgesagt" werden bei der Bestimmung der Überlappung überprüft.`,
	es: `Permite que varias actividades de este tipo tengan fechas de inicio y fin que se solapan. Todos los estados de actividad excepto Cancelado se comprueban al determinar solapamientos.`,
	fa: `اجازه دهید چندین فعالیت از این نوع تاریخ های شروع و پایان همپوشانی داشته باشند. تمام وضعیت فعالیت ها به جز لغو شده هنگام تعیین همپوشانی بررسی می شوند.`,
	fil: `Pahintulutan ang maramihang mga aktibidad ng ganitong uri na magkaroon ng magkakapatong na petsa ng pagsisimula at pagtatapos. Lahat ng katayuan ng aktibidad maliban sa Kinansela ay naka-check kapag tinutukoy ang overlap.`,
	fr: `Permettre à plusieurs activités de ce type d’avoir des dates de début et de fin qui se chevauchent. Tous les statuts d’activité sauf Annulés sont vérifiés lors de la détermination du chevauchement.`,
	hi: `इस प्रकार की कई गतिविधियों को ओवरलैपिंग प्रारंभ और समाप्ति दिनांक रखने की अनुमति दें। ओवरलैप का निर्धारण करते समय रद्द किए गए को छोड़कर सभी गतिविधि स्थितियों की जाँच की जाती है.`,
	ht: `Pèmèt plizyè aktivite nan kalite sa a gen sipèpoze dat kòmanse ak fen. Tout estati aktivite eksepte anile yo tcheke lè detèmine sipèvizyon.`,
	it: `Consentire che più attività di questo tipo abbiano date di inizio e fine sovrapposte. Tutti gli stati delle attività tranne Cancellata vengono controllati quando si determina la sovrapposizione.`,
	ja: `この種の複数の活動が開始日と終了日が重なることを許可しましょう。キャンセルされた以外のすべてのアクティビティステータスは重複を判断する際にチェックされます。`,
	ko: `이러한 유형의 여러 활동이 시작과 종료일이 겹치도록 허용하세요. 취소된 모든 활동 상태는 중복 여부를 확인할 때 확인됩니다.`,
	mww: `Tso cai rau ntau yam kev ua ub no ntawm hom no kom muaj cov hnub pib thiab xaus sib tshooj. Tag nrho cov xwm txheej kev ua ub no tshwj tsis yog Cancelled raug kuaj xyuas thaum txiav txim siab sib tshooj.`,
	ps: `د دې ډول څو فعالیتونو ته اجازه ورکړئ چې د پیل او پای نیټې سره ګډ وی. ټول فعالیتونه پرته له لغوه شوی، د همغږی معلومولو پر مهال چک کېږی.`,
	pt: `Permitir que múltiplas atividades desse tipo tenham datas de início e término sobrepostas. Todos os status de atividade, exceto Cancelado, são verificados ao determinar sobreposição.`,
	'pt-pt': `Permitir que múltiplas atividades deste tipo tenham datas de início e fim sobrepostas. Todos os estados das atividades, exceto Cancelado, são verificados ao determinar sobreposição.`,
	ru: `Позволить нескольким видам деятельности такого рода иметь пересекающиеся даты начала и окончания. Все статусы активности, кроме Отмененных, проверяются при определении пересечения.`,
	sm: `Faataga le tele o gaoioiga o lenei ituaiga ina ia fesiligia aso amata ma aso faaiuga. O tulaga uma o gaoioiga sei vagana ai le Faaleaogaina e siakiina pe a fuafuaina le fesiligia.`,
	so: `U oggolaa hawlo badan oo noocan ah inay yeeshaan taariikho bilow iyo dhammaad isku dul saaran. Dhammaan xaaladaha hawlaha marka laga reebo Cancelled waa la hubiyaa marka la go'aamiyo isku-darka.`,
	th: `อนุญาตให้หลายกิจกรรมชนิดนี้มีวันที่เริ่มต้นและวันที่สิ้นสุดที่ทับซ้อนกัน สถานะกิจกรรมทั้งหมดยกเว้นยกเลิกจะถูกตรวจสอบเมื่อพิจารณาการทับซ้อนกัน`,
	ur: `اس قسم کی متعدد سرگرمیوں کی شروعات اور اختتام کی تاریخیں ایک جیسی ہونے کی اجازت دیں۔ تمام سرگرمیوں کی حالتیں سوائے 'منسوخ' کے، اوورلیپ کا تعین کرتے وقت چیک کی جاتی ہیں۔`,
	vi: `Cho phép nhiều hoạt động thuộc loại này có ngày bắt đầu và ngày kết thúc trùng lặp. Tất cả các trạng thái hoạt động ngoại trừ Đã hủy đều được kiểm tra khi xác định trùng lặp.`,
	'zh-hans': `允许此类多个活动的开始和结束日期重叠。在确定重叠时，除取消外的所有活动状态都会被检查。`,
	'zh-hant': `允許此類多項活動的開始與結束日期重疊。在判斷活動重疊時，除了取消外，所有活動狀態都會被檢查。`,
	en: `Permit multiple activities of this type to have overlapping start and end dates. All activity statuses except Cancelled are checked when determining overlap.`
};

export const loc_allPeriods: Record<Locale, string> = {
	ar: `جميع الفترات`,
	de: `Alle Perioden`,
	es: `Todos los periodos`,
	fa: `تمام دوره ها`,
	fil: `Lahat ng mga panahon`,
	fr: `Toutes les périodes`,
	hi: `सभी अवधि`,
	ht: `Tout peryòd`,
	it: `Tutti i periodi`,
	ja: `全期間`,
	ko: `모든 기간`,
	mww: `Txhua lub sij hawm`,
	ps: `ټولې دورې`,
	pt: `Todos os períodos`,
	'pt-pt': `Todos os períodos`,
	ru: `Все периоды`,
	sm: `Vaitaimi uma`,
	so: `Dhammaan xilliyada`,
	th: `ทุกช่วงเวลา`,
	ur: `تمام ادوار`,
	vi: `Tất cả các giai đoạn`,
	'zh-hans': `所有时期`,
	'zh-hant': `所有時期`,
	en: `All periods`
};

export const loc_allProjects: Record<Locale, string> = {
	ar: `جميع المشاريع`,
	de: `Alle Projekte`,
	es: `Todos los proyectos`,
	fa: `تمام پروژه ها`,
	fil: `Lahat ng proyekto`,
	fr: `Tous les projets`,
	hi: `सभी परियोजनाएं`,
	ht: `Tout pwojè yo`,
	it: `Tutti i progetti`,
	ja: `すべてのプロジェクト`,
	ko: `모든 프로젝트`,
	mww: `Tag nrho cov haujlwm`,
	ps: `ټولې پروژې`,
	pt: `Todos os projetos`,
	'pt-pt': `Todos os projetos`,
	ru: `Все проекты`,
	sm: `Galuega faatino uma`,
	so: `Dhammaan mashaariicda`,
	th: `โครงการทั้งหมด`,
	ur: `تمام منصوبے`,
	vi: `Tất cả các dự án`,
	'zh-hans': `所有项目`,
	'zh-hant': `所有專案`,
	en: `All projects`
};

export const loc_alreadyFilled: Record<Locale, string> = {
	ar: `تم تعبئة الوثيقة بالفعل.`,
	de: `Das Dokument wurde bereits ausgefüllt.`,
	es: `El documento ya ha sido rellenado.`,
	fa: `سند قبلا پر شده است.`,
	fil: `Nakumpleto na ang dokumento.`,
	fr: `Le document a déjà été rempli.`,
	hi: `दस्तावेज़ पहले ही भरा जा चुका है।`,
	ht: `Dokiman an deja ranpli`,
	it: `Il documento è già stato compilato.`,
	ja: `書類はすでに記入済みです。`,
	ko: `문서는 이미 작성되었습니다.`,
	mww: `Cov ntaub ntawv twb tau sau.`,
	ps: `سند لا دمخه ډک شوی دی.`,
	pt: `O documento já foi preenchido.`,
	'pt-pt': `O documento já foi preenchido.`,
	ru: `Документ уже заполнен.`,
	sm: `Ua uma ona fa'atumuina le pepa.`,
	so: `Dukumentigu hore ayaa loo buuxiyay.`,
	th: `กรอกเอกสารแล้ว`,
	ur: `دستاویز پہلے ہی بھر دی گئی ہے۔`,
	vi: `Tài liệu đã được điền vào.`,
	'zh-hans': `文件已经填写完毕。`,
	'zh-hant': `文件已經填寫完畢。`,
	en: `The document has already been filled.`
};

export const loc_alreadySigned: Record<Locale, string> = {
	ar: `الوثيقة قد تم توقيعها بالفعل.`,
	de: `Das Dokument wurde bereits unterschrieben.`,
	es: `El documento ya ha sido firmado.`,
	fa: `سند قبلا امضا شده است.`,
	fil: `Nilagdaan na ang dokumento.`,
	fr: `Le document a déjà été signé.`,
	hi: `दस्तावेज़ पर पहले ही हस्ताक्षर किए जा चुके हैं।`,
	ht: `Dokiman an te deja siyen`,
	it: `Il documento è già stato firmato.`,
	ja: `その文書はすでに署名されています。`,
	ko: `문서는 이미 서명되었습니다.`,
	mww: `Daim ntawv twb tau kos npe lawm.`,
	ps: `سند لا دمخه لاسلیک شوی دی.`,
	pt: `O documento já foi assinado.`,
	'pt-pt': `O documento já foi assinado.`,
	ru: `Документ уже подписан.`,
	sm: `Ua uma ona sainia le pepa.`,
	so: `Dukumentigu hore ayaa loo saxiixay.`,
	th: `เอกสารได้รับการลงนามแล้ว`,
	ur: `دستاویز پر پہلے ہی دستخط ہو چکے ہیں۔`,
	vi: `Tài liệu đã được ký.`,
	'zh-hans': `文件已经签署。`,
	'zh-hant': `文件已經簽署。`,
	en: `The document has already been signed.`
};

export const loc_alsoReachUsFormat: Record<Locale, (email: unknown, phone: unknown, address: unknown) => TemplateResult> = {
	ar: (email, phone, address) => html`<span>يمكنك أيضا التواصل معنا عبر البريد الإلكتروني ${email}، والهاتف ${phone}، وعبر البريد ${address}.</span>`,
	de: (email, phone, address) => html`<span>Sie können uns auch per E-Mail unter ${email}, telefonisch ${phone} und per Post unter ${address}, erreichen.</span>`,
	es: (email, phone, address) => html`<span>También puedes contactarnos por correo electrónico ${email}, por teléfono al ${phone} y por correo postal en ${address}.</span>`,
	fa: (email, phone, address) => html`<span>همچنین می توانید از طریق ایمیل ${email}، تلفن ${phone} و پست به ${address} با ما تماس بگیرید.</span>`,
	fil: (email, phone, address) => html`<span>Maaari mo ring maabot kami sa pamamagitan ng email sa ${email}, sa pamamagitan ng telepono sa ${phone}, at sa pamamagitan ng koreo sa ${address}.</span>`,
	fr: (email, phone, address) => html`<span>Vous pouvez également nous joindre par email ${email}, par téléphone au ${phone}, et par courrier à ${address}.</span>`,
	hi: (email, phone, address) => html`<span>आप हमें ${email} पर ईमेल के माध्यम से, ${phone} पर फोन द्वारा और ${address} पर मेल द्वारा भी संपर्क कर सकते हैं।</span>`,
	ht: (email, phone, address) => html`<span>Ou ka kontakte nou tou pa imèl ${email}, pa telefòn nan ${phone}, ak pa lapòs nan ${address}.</span>`,
	it: (email, phone, address) => html`<span>Potete anche contattarci via email ${email}, telefonicamente al ${phone} e per posta all'indirizzo ${address}.</span>`,
	ja: (email, phone, address) => html`<span>また、 ${email})、電話 ${phone}、郵便( ${address})でもご連絡いただけます。</span>`,
	ko: (email, phone, address) => html`<span>또한 ${email}, ${phone}, 우편 주소 ${address}로 연락하실 수 있습니다.</span>`,
	mww: (email, phone, address) => html`<span>Koj tseem tuaj yeem tiv tauj peb ntawm email ntawm ${email}, hauv xov tooj ntawm ${phone} thiab los ntawm kev xa ntawv ntawm ${address}.</span>`,
	ps: (email, phone, address) => html`<span>تاسو کولی شئ موږ ته د ایمیل له ${email}، د ${phone}، او د پوست له لارې په ${address} کې هم اړیکه ونیسئ.</span>`,
	pt: (email, phone, address) => html`<span>Você também pode nos contatar por e-mail ${email}, pelo ${phone} e pelo correio ${address}.</span>`,
	'pt-pt': (email, phone, address) => html`<span>Também pode contactar-nos por email ${email}, por telefone para ${phone} e por correio para ${address}.</span>`,
	ru: (email, phone, address) => html`<span>Вы также можете связаться с нами по электронной почте ${email}, по ${phone} и по почте по ${address}.</span>`,
	sm: (email, phone, address) => html`<span>E mafai foi ona e fa'afeso'ota'i mai matou e ala i le imeli i ${email}, i le telefoni i ${phone}, ma le meli i le ${address}.</span>`,
	so: (email, phone, address) => html`<span>Waxaad sidoo kale nala xiriiri kartaa email ${email}, telefoonka ${phone}, iyo boostada ${address}.</span>`,
	th: (email, phone, address) => html`<span>คุณสามารถติดต่อเราทางอีเมลได้ที่ ${email} ทางโทรศัพท์ที่ ${phone} และทางไปรษณีย์ที่ ${address}</span>`,
	ur: (email, phone, address) => html`<span>آپ ہمیں ${email}، ${phone}، اور ${address} پر بھی رابطہ کر سکتے ہیں۔</span>`,
	vi: (email, phone, address) => html`<span>Bạn cũng có thể liên hệ với chúng tôi qua email theo địa chỉ ${email}, qua điện thoại ${phone} và qua đường bưu điện tại ${address}.</span>`,
	'zh-hans': (email, phone, address) => html`<span>你也可以通过 ${email}、电话 ${phone}，以及邮寄至 ${address}号与我们联系。</span>`,
	'zh-hant': (email, phone, address) => html`<span>您也可以透過電子郵件 ${email}、電話 ${phone}，以及郵寄至 ${address} 與我們聯繫。</span>`,
	en: (email, phone, address) => html`<span>You can also reach us via email at ${email}, by phone at ${phone}, and by mail at ${address}.</span>`
};

export const loc_amount: Record<Locale, string> = {
	ar: `المبلغ`,
	de: `Betrag`,
	es: `Cantidad`,
	fa: `مقدار`,
	fil: `Halaga`,
	fr: `Montant`,
	hi: `कुल धनराशि`,
	ht: `Kantite lajan`,
	it: `Importo`,
	ja: `金額`,
	ko: `양`,
	mww: `nyiaj npaum li cas`,
	ps: `مقدار`,
	pt: `Valor`,
	'pt-pt': `Montante`,
	ru: `Сумма`,
	sm: `Aofaiga`,
	so: `Qadarka`,
	th: `จํานวนเงิน`,
	ur: `رقم`,
	vi: `Số tiền`,
	'zh-hans': `数量`,
	'zh-hant': `金額`,
	en: `Amount`
};

export const loc_any: Record<Locale, string> = {
	ar: `أي`,
	de: `Irgendeine`,
	es: `Cualquiera`,
	fa: `هیچ`,
	fil: `Anumang`,
	fr: `N’importe lequel`,
	hi: `कोई भी`,
	ht: `Nenpòt`,
	it: `Qualsiasi`,
	ja: `どんな人でも`,
	ko: `어떤 것이든`,
	mww: `Ib qho`,
	ps: `هر`,
	pt: `Qualquer`,
	'pt-pt': `Qualquer`,
	ru: `Любой`,
	sm: `So'o se`,
	so: `Mid kasta`,
	th: `ใด ๆ`,
	ur: `کوئی بھی`,
	vi: `Bất kỳ`,
	'zh-hans': `任何`,
	'zh-hant': `任何`,
	en: `Any`
};

export const loc_anyDistance: Record<Locale, string> = {
	ar: `أي مسافة`,
	de: `Jede Entfernung`,
	es: `Cualquier distancia`,
	fa: `هر فاصله ای`,
	fil: `Anumang distansya`,
	fr: `N’importe quelle distance`,
	hi: `कोई भी दूरी`,
	ht: `Nenpòt distans`,
	it: `Qualsiasi distanza`,
	ja: `どんな距離でも`,
	ko: `어떤 거리든`,
	mww: `kev ncua deb`,
	ps: `هر واټن`,
	pt: `Qualquer distância`,
	'pt-pt': `Qualquer distância`,
	ru: `Любое расстояние`,
	sm: `So'o se mamao`,
	so: `Masaafad kasta`,
	th: `ทุกระยะทาง`,
	ur: `کسی بھی فاصلے پر`,
	vi: `Bất kỳ khoảng cách nào`,
	'zh-hans': `任何距离`,
	'zh-hant': `任何距離`,
	en: `Any distance`
};

export const loc_anywhere: Record<Locale, string> = {
	ar: `في أي مكان`,
	de: `Irgendwo`,
	es: `En cualquier sitio`,
	fa: `هر جا`,
	fil: `Kahit saan`,
	fr: `N’importe où`,
	hi: `कहीं भी`,
	ht: `Nenpòt kote`,
	it: `Ovunque`,
	ja: `どこでも`,
	ko: `어디서든`,
	mww: `nyob qhov twg`,
	ps: `هر ځای`,
	pt: `Em qualquer lugar`,
	'pt-pt': `Em qualquer lugar`,
	ru: `Где угодно`,
	sm: `Soo se mea`,
	so: `Meel kasta`,
	th: `ทุกที่`,
	ur: `کہیں بھی`,
	vi: `Bất cứ nơi nào`,
	'zh-hans': `任何地方`,
	'zh-hant': `任何地方`,
	en: `Anywhere`
};

export const loc_apply: Record<Locale, string> = {
	ar: `قدم`,
	de: `Bewerben Sie sich`,
	es: `Solicita`,
	fa: `درخواست بده`,
	fil: `Mag-aplay`,
	fr: `Postulez`,
	hi: `लागू करें`,
	ht: `Aplike`,
	it: `Candidati`,
	ja: `応募してください`,
	ko: `지원`,
	mww: `thov`,
	ps: `درخواست ورکړه`,
	pt: `Candidate-se`,
	'pt-pt': `Candidata-te`,
	ru: `Подайте заявку`,
	sm: `Talosaga`,
	so: `Codso`,
	th: `สมัคร`,
	ur: `درخواست دیں`,
	vi: `Đăng ký`,
	'zh-hans': `申请`,
	'zh-hant': `申請`,
	en: `Apply`
};

export const loc_approved: Record<Locale, string> = {
	ar: `تمت الموافقة`,
	de: `Genehmigt`,
	es: `Aprobado`,
	fa: `تأیید شده`,
	fil: `Inaprubahan`,
	fr: `Approuvé`,
	hi: `स्वीकृत`,
	ht: `Apwouve`,
	it: `Approvato`,
	ja: `承認済み`,
	ko: `승인`,
	mww: `Pom Zoo`,
	ps: `تصویب شو`,
	pt: `Aprovado`,
	'pt-pt': `Aprovado`,
	ru: `Одобрено`,
	sm: `Faamaonia`,
	so: `La ansixiyay`,
	th: `อนุมัติ`,
	ur: `منظور شدہ`,
	vi: `Đã được phê duyệt`,
	'zh-hans': `批准了`,
	'zh-hant': `已批准`,
	en: `Approved`
};

export const loc_approveTimesheet: Record<Locale, string> = {
	ar: `الموافقة على جدول المواعيد`,
	de: `Stundenzettel genehmigen`,
	es: `Aprobar la hoja de horas`,
	fa: `تأیید برگه زمان`,
	fil: `Aprubahan ang timesheet`,
	fr: `Approuver la feuille de temps`,
	hi: `टाइमशीट स्वीकृत करें`,
	ht: `Apwouve Timesheet`,
	it: `Approva il foglio orario`,
	ja: `承認タイムシート`,
	ko: `승인 근무 시간표`,
	mww: `Pom zoo rau daim ntawv teev sijhawm`,
	ps: `د وخت پاڼه تایید کړئ`,
	pt: `Aprovar folha de ponto`,
	'pt-pt': `Aprovar folha de horas`,
	ru: `Утверждение табелья рабочего времени`,
	sm: `Faamaonia le pepa o taimi`,
	so: `Ansixi jadwalka waqtiga`,
	th: `อนุมัติไทม์ชีท`,
	ur: `ٹائم شیٹ کی منظوری دیں`,
	vi: `Phê duyệt bảng chấm công`,
	'zh-hans': `批准时间表`,
	'zh-hant': `批准工時表`,
	en: `Approve timesheet`
};

export const loc_approximateLocation: Record<Locale, string> = {
	ar: `الموقع التقريبي`,
	de: `Ungefährer Standort`,
	es: `Ubicación aproximada`,
	fa: `موقعیت تقریبی`,
	fil: `Tinatayang lokasyon`,
	fr: `Localisation approximative`,
	hi: `अनुमानित स्थान`,
	ht: `Kote apwoksimatif`,
	it: `Posizione approssimativa`,
	ja: `おおよその位置`,
	ko: `대략적인 위치`,
	mww: `Qhov chaw kwv yees`,
	ps: `تقریبی موقعیت`,
	pt: `Localização aproximada`,
	'pt-pt': `Localização aproximada`,
	ru: `Приблизительное расположение`,
	sm: `Nofoaga fa'atatau`,
	so: `Goobta qiyaasta ah`,
	th: `ตําแหน่งโดยประมาณ`,
	ur: `تقریبا مقام`,
	vi: `Vị trí gần đúng`,
	'zh-hans': `大致位置`,
	'zh-hant': `大致位置`,
	en: `Approximate location`
};

export const loc_askCumulusAssistant: Record<Locale, (cumulusAssistant: unknown) => string> = {
	ar: (cumulusAssistant) => `اسأل ${cumulusAssistant}`,
	de: (cumulusAssistant) => `Fragen ${cumulusAssistant}`,
	es: (cumulusAssistant) => `Pregunta ${cumulusAssistant}`,
	fa: (cumulusAssistant) => `از ${cumulusAssistant} بپرسید`,
	fil: (cumulusAssistant) => `Magtanong ${cumulusAssistant}`,
	fr: (cumulusAssistant) => `Demandez ${cumulusAssistant}`,
	hi: (cumulusAssistant) => `${cumulusAssistant} पूछें`,
	ht: (cumulusAssistant) => `Mande ${cumulusAssistant}`,
	it: (cumulusAssistant) => `Chiedi ${cumulusAssistant}`,
	ja: (cumulusAssistant) => `${cumulusAssistant}トに聞く`,
	ko: (cumulusAssistant) => `${cumulusAssistant}트에게 물어보세요`,
	mww: (cumulusAssistant) => `Nug ${cumulusAssistant}`,
	ps: (cumulusAssistant) => `${cumulusAssistant}`,
	pt: (cumulusAssistant) => `Pergunte ${cumulusAssistant}`,
	'pt-pt': (cumulusAssistant) => `Pergunte ${cumulusAssistant}`,
	ru: (cumulusAssistant) => `${cumulusAssistant}`,
	sm: (cumulusAssistant) => `Fesili ${cumulusAssistant}`,
	so: (cumulusAssistant) => `Weydii ${cumulusAssistant}`,
	th: (cumulusAssistant) => `ถาม ${cumulusAssistant}`,
	ur: (cumulusAssistant) => `${cumulusAssistant} سے پوچھیں`,
	vi: (cumulusAssistant) => `Hỏi ${cumulusAssistant}`,
	'zh-hans': (cumulusAssistant) => `问 ${cumulusAssistant}`,
	'zh-hant': (cumulusAssistant) => `問 ${cumulusAssistant}`,
	en: (cumulusAssistant) => `Ask ${cumulusAssistant}`
};

export const loc_assignedToLogin: Record<Locale, (login: unknown) => TemplateResult> = {
	ar: (login) => html`التعيين <span>${login}</span>`,
	de: (login) => html`Jane zugeteilt <span>${login}</span>`,
	es: (login) => html`asignado a <span>${login}</span>`,
	fa: (login) => html`اختصاص یافته به <span>${login}</span>`,
	fil: (login) => html`Inatasan si <span>${login}</span>`,
	fr: (login) => html`assigné à <span>${login}</span>`,
	hi: (login) => html`जेन को सौंपा गया <span>${login}</span>`,
	ht: (login) => html`asiyen nan <span>${login}</span>`,
	it: (login) => html`assegnato a <span>${login}</span>`,
	ja: (login) => html`<span>${login}に割り当てられた</span>`,
	ko: (login) => html`<span>${login}에게 배정되었다</span>`,
	mww: (login) => html`raug xa mus rau <span>${login}</span>`,
	ps: (login) => html`جین ته ټاکل <span>${login}</span>`,
	pt: (login) => html`Designado para <span>${login}</span>`,
	'pt-pt': (login) => html`atribuído a <span>${login}</span>`,
	ru: (login) => html`назначен на <span>${login}</span>`,
	sm: (login) => html`Tofia ia <span>${login}</span>`,
	so: (login) => html`<span>${login}</span>`,
	th: (login) => html`มอบหมายให้ <span>${login}</span>`,
	ur: (login) => html`جین کو تفویض <span>${login}</span>`,
	vi: (login) => html`được giao cho <span>${login}</span>`,
	'zh-hans': (login) => html`分配给 <span>${login}</span>`,
	'zh-hant': (login) => html`被分配給 <span>${login}</span>`,
	en: (login) => html`assigned to <span>${login}</span>`
};

export const loc_assignedToYou: Record<Locale, string> = {
	ar: `تم تعيينه لك`,
	de: `Ihnen zugeteilt`,
	es: `Asignado a ti`,
	fa: `به تو اختصاص داده شده`,
	fil: `Itinalaga sa iyo`,
	fr: `Assigné à toi`,
	hi: `आपको सौंपा गया`,
	ht: `Asiyen pou ou`,
	it: `Assegnato a te`,
	ja: `あなたに割り当てられた`,
	ko: `너에게 배정됐어`,
	mww: `Muab tso rau koj`,
	ps: `تا ته ټاکل شوی`,
	pt: `Designado para você`,
	'pt-pt': `Atribuído a ti`,
	ru: `Назначено тебе`,
	sm: `Tofia ia te oe`,
	so: `Adiga ayaa loo xilsaaray`,
	th: `มอบหมายให้คุณ`,
	ur: `آپ کو تفویض کیا گیا`,
	vi: `Được chỉ định cho bạn`,
	'zh-hans': `分配给你`,
	'zh-hant': `分配給你`,
	en: `Assigned to you`
};

export const loc_assignedToYourOrganization: Record<Locale, string> = {
	ar: `تم تعيينهم في منظمتك`,
	de: `Ihrer Organisation zugewiesen`,
	es: `Asignado a tu organización`,
	fa: `به سازمان شما اختصاص داده شده است`,
	fil: `Itinalaga sa Iyong Organisasyon`,
	fr: `Affecté à votre organisation`,
	hi: `आपके संगठन को असाइन किया गया`,
	ht: `Asiyen nan òganizasyon ou an`,
	it: `Assegnato alla tua organizzazione`,
	ja: `あなたの組織に配属されています`,
	ko: `귀하의 조직에 배정됨`,
	mww: `Raug xa mus rau koj lub koom haum`,
	ps: `ستاسو سازمان ته ټاکل شوی یم`,
	pt: `Designado para sua organização`,
	'pt-pt': `Atribuído à sua organização`,
	ru: `Назначен в вашу организацию`,
	sm: `Tofia i lau faalapotopotoga`,
	so: `Waxaa loo xilsaaray ururkaaga`,
	th: `มอบหมายให้กับองค์กรของคุณ`,
	ur: `آپ کی تنظیم میں تعینات`,
	vi: `Được chỉ định cho tổ chức của bạn`,
	'zh-hans': `分配到你的组织`,
	'zh-hant': `分配到你的組織`,
	en: `Assigned to your organization`
};

export const loc_assignee: Record<Locale, string> = {
	ar: `الموزع`,
	de: `Beauftragter`,
	es: `Asignado`,
	fa: `مأمور`,
	fil: `Tagapag-atas`,
	fr: `Assigné`,
	hi: `असाइनी`,
	ht: `Asiyen`,
	it: `Assegnato`,
	ja: `配属先`,
	ko: `파견자`,
	mww: `Tus neeg ua hauj lwm`,
	ps: `ټاکل شوی`,
	pt: `Cessionário`,
	'pt-pt': `Cedente`,
	ru: `Правообладатель`,
	sm: `Tofia`,
	so: `Qofka la siiyay`,
	th: `ผู้รับมอบหมาย`,
	ur: `تفویض شدہ`,
	vi: `Người được chuyển nhượng`,
	'zh-hans': `受派人`,
	'zh-hant': `受派人`,
	en: `Assignee`
};

export const loc_assignToMe: Record<Locale, string> = {
	ar: `التعيين لي`,
	de: `Geben Sie mir die Rechte zu.`,
	es: `Asigna a mí`,
	fa: `به من اختصاص بده`,
	fil: `Atasan mo ako`,
	fr: `Assigne-moi`,
	hi: `मुझे असाइन करें`,
	ht: `Asiyen m '`,
	it: `Assegnami`,
	ja: `私に割り当ててくれ`,
	ko: `나한테 맡겨`,
	mww: `muab rau kuv`,
	ps: `ما ته وټاکئ`,
	pt: `Me atribui`,
	'pt-pt': `Atribui-me`,
	ru: `Назначьте мне`,
	sm: `Tofi mai ia te a'u`,
	so: `I sii`,
	th: `มอบหมายให้ฉัน`,
	ur: `مجھے تفویض کریں`,
	vi: `Chỉ định cho tôi`,
	'zh-hans': `分配给我`,
	'zh-hant': `分配給我`,
	en: `Assign to me`
};

export const loc_associateActivityConfirmationMessageFormat: Record<Locale, (activityTitle: unknown, personName: unknown) => string> = {
	ar: (activityTitle, personName) => `قضية مرتبطة ${activityTitle} مع ${personName}؟`,
	de: (activityTitle, personName) => `${activityTitle} mit Smith assoziieren${personName}?`,
	es: (activityTitle, personName) => `¿ ${activityTitle} con ${personName}?`,
	fa: (activityTitle, personName) => `${activityTitle} با ${personName}؟`,
	fil: (activityTitle, personName) => `Iugnay ${activityTitle} kay ${personName}?`,
	fr: (activityTitle, personName) => `Associer ${activityTitle} à ${personName} ?`,
	hi: (activityTitle, personName) => `स्मिथ${personName} के साथ ${activityTitle} को एसोसिएट करें?`,
	ht: (activityTitle, personName) => `Asosye ${activityTitle} ak ${personName}?`,
	it: (activityTitle, personName) => `Associare ${activityTitle} a ${personName}?`,
	ja: (activityTitle, personName) => `${activityTitle}をスミスと関連付けるのか${personName}?`,
	ko: (activityTitle, personName) => `${activityTitle}을 스미스와 연관 짓는 거${personName}?`,
	mww: (activityTitle, personName) => `Associate ${activityTitle} nrog ${personName}?`,
	ps: (activityTitle, personName) => `د ${activityTitle} د سمیت سره تړاو لری ${personName}؟`,
	pt: (activityTitle, personName) => `${activityTitle} com ${personName}?`,
	'pt-pt': (activityTitle, personName) => `Associar ${activityTitle} ao ${personName}?`,
	ru: (activityTitle, personName) => `Ассоциированное ${activityTitle} со ${personName}?`,
	sm: (activityTitle, personName) => `Feso'ota'i ${activityTitle} ma ${personName}`,
	so: (activityTitle, personName) => `${activityTitle} ee la xiriira ${personName}?`,
	th: (activityTitle, personName) => `เชื่อมโยง ${activityTitle} กับ ${personName}?`,
	ur: (activityTitle, personName) => `اسمتھ کے ساتھ ${activityTitle}${personName}؟`,
	vi: (activityTitle, personName) => `Liên kết ${activityTitle} với ${personName}?`,
	'zh-hans': (activityTitle, personName) => `约翰，把 ${activityTitle} 子和 ${personName}联系起来？`,
	'zh-hant': (activityTitle, personName) => `把 ${activityTitle} 子和 ${personName}扯上關係，約翰？`,
	en: (activityTitle, personName) => `Associate ${activityTitle} with ${personName}?`
};

export const loc_associateActivityPersonCreateFormat: Record<Locale, (activityTitle: unknown) => TemplateResult> = {
	ar: (activityTitle) => html`<strong>ربط ${activityTitle} بالشخص</strong>: أنشئ شخصا جديدا`,
	de: (activityTitle) => html`<strong>Verknüpfe die ${activityTitle} mit der Person</strong>: Erstelle eine neue Person`,
	es: (activityTitle) => html`<strong>${activityTitle} con la persona</strong>: crear una nueva persona`,
	fa: (activityTitle) => html`<strong>${activityTitle} را با فرد مرتبط</strong> کنید: یک فرد جدید بسازید`,
	fil: (activityTitle) => html`<strong>Iugnay ang ${activityTitle} sa tao</strong>: lumikha ng bagong tao`,
	fr: (activityTitle) => html`<strong>${activityTitle} à la personne</strong> : créer une nouvelle personne`,
	hi: (activityTitle) => html`<strong>व्यक्ति के साथ ${activityTitle} को संबद्ध करें</strong>: एक नया व्यक्ति बनाएं`,
	ht: (activityTitle) => html`<strong>Asosye ${activityTitle} ak moun</strong>: kreye yon nouvo moun`,
	it: (activityTitle) => html`<strong>${activityTitle} con una persona</strong>: crea una nuova persona`,
	ja: (activityTitle) => html`<strong>${activityTitle}を人と結びつける</strong>:新しい人を作る`,
	ko: (activityTitle) => html`<strong>${activityTitle}을 사람과 연관 짓기</strong>: 새로운 사람을 만들기.`,
	mww: (activityTitle) => html`<strong>Associate ${activityTitle} nrog tus neeg</strong>: tsim ib tug neeg tshiab`,
	ps: (activityTitle) => html`<strong>${activityTitle}</strong> کول: یو نوی کس جوړول`,
	pt: (activityTitle) => html`<strong>${activityTitle} com pessoa</strong>: crie uma nova pessoa`,
	'pt-pt': (activityTitle) => html`<strong>${activityTitle} a pessoa</strong>: criar uma nova pessoa`,
	ru: (activityTitle) => html`<strong>Ассоциируйте ${activityTitle} с человеком</strong>: создайте нового человека`,
	sm: (activityTitle) => html`<strong>Fa'afeso'ota'i le ${activityTitle} ma le tagata</strong>: fatu se tagata fou`,
	so: (activityTitle) => html`<strong>La xiriir ${activityTitle} qof</strong>: abuur qof cusub`,
	th: (activityTitle) => html`<strong>เชื่อมโยง ${activityTitle} กับบุคคล</strong>: สร้างบุคคลใหม่`,
	ur: (activityTitle) => html`<strong>${activityTitle} کو شخص کے ساتھ جوڑیں</strong>: ایک نیا شخص بنائیں`,
	vi: (activityTitle) => html`<strong>Liên kết ${activityTitle} với người</strong>: tạo một người mới`,
	'zh-hans': (activityTitle) => html`将<strong>${activityTitle}与个人联系起来</strong>：创建一个新的人`,
	'zh-hant': (activityTitle) => html`將<strong>${activityTitle}與人連結</strong>：創造一個新的人`,
	en: (activityTitle) => html`<strong>Associate ${activityTitle} with person</strong>: create a new person`
};

export const loc_associateActivityPersonSearchFormat: Record<Locale, (activityTitle: unknown) => TemplateResult> = {
	ar: (activityTitle) => html`<strong>ربط ${activityTitle} مع الشخص</strong>: ابحث عن شخص`,
	de: (activityTitle) => html`<strong>${activityTitle} mit der Person</strong>: Suche nach einer Person`,
	es: (activityTitle) => html`<strong>${activityTitle} con la persona</strong>: buscar a una persona`,
	fa: (activityTitle) => html`<strong>${activityTitle} را با شخص مرتبط</strong> کنید: به دنبال فرد بگردید`,
	fil: (activityTitle) => html`<strong>Iugnay ang ${activityTitle} sa tao</strong>: maghanap ng isang tao`,
	fr: (activityTitle) => html`<strong>${activityTitle} associée avec personne</strong> : recherche une personne`,
	hi: (activityTitle) => html`<strong>व्यक्ति के साथ ${activityTitle} को संबद्ध करें</strong>: किसी व्यक्ति की खोज करें`,
	ht: (activityTitle) => html`<strong>Asosye ${activityTitle} ak moun</strong>: rechèch pou yon moun`,
	it: (activityTitle) => html`<strong>${activityTitle} associata con persona</strong>: cerca una persona`,
	ja: (activityTitle) => html`<strong>${activityTitle}を人と関連付け</strong>る:人を検索する`,
	ko: (activityTitle) => html`<strong>${activityTitle} 사람과 연관 짓</strong>기: 사람을 검색하세요`,
	mww: (activityTitle) => html`<strong>Associate ${activityTitle} with person</strong>: nrhiav ib tug neeg`,
	ps: (activityTitle) => html`<strong>${activityTitle}</strong> کول: د یو کس لټون`,
	pt: (activityTitle) => html`<strong>${activityTitle} associada com pessoa</strong>: procure por uma pessoa`,
	'pt-pt': (activityTitle) => html`<strong>${activityTitle} associada com pessoa</strong>: procure uma pessoa`,
	ru: (activityTitle) => html`<strong>Сотрудничество ${activityTitle} с человеком</strong>: поиск человека`,
	sm: (activityTitle) => html`<strong>Fa'afeso'ota'i le ${activityTitle} ma le tagata</strong>: saili se tagata`,
	so: (activityTitle) => html`<strong>Xiriir ${activityTitle} tixraac qof</strong>: raadi qof`,
	th: (activityTitle) => html`<strong>เชื่อมโยง ${activityTitle} กับบุคคล</strong>: ค้นหาบุคคล`,
	ur: (activityTitle) => html`<strong>${activityTitle} کو شخص کے ساتھ منسلک</strong> کریں: کسی شخص کی تلاش کریں`,
	vi: (activityTitle) => html`<strong>Liên kết ${activityTitle} với người</strong>: tìm kiếm một người`,
	'zh-hans': (activityTitle) => html`<strong>将 ${activityTitle} 与人联系起来</strong>：搜索一个人`,
	'zh-hant': (activityTitle) => html`<strong>將 ${activityTitle} 與人聯繫</strong>起來：搜尋一個人`,
	en: (activityTitle) => html`<strong>Associate ${activityTitle} with person</strong>: search for a person`
};

export const loc_associateActivitySelectParentActivityFormat: Record<Locale, (activityTitle: unknown) => TemplateResult> = {
	ar: (activityTitle) => html`<strong>ربط ${activityTitle} مع الشخص</strong>: اختر النشاط الذي سيرتبط به ${activityTitle} الجديدة`,
	de: (activityTitle) => html`<strong>Überweisung mit Person ${activityTitle} verknüpfen</strong>: Wähle die Aktivität aus, mit der die neue ${activityTitle} verknüpft werden soll`,
	es: (activityTitle) => html`<strong>${activityTitle} asociada con persona</strong>: selecciona la actividad con la que se asociará la nueva ${activityTitle}`,
	fa: (activityTitle) => html`<strong>${activityTitle} را با شخص مرتبط</strong> کنید: فعالیتی را که ${activityTitle} جدید با آن مرتبط خواهد بود انتخاب کنید`,
	fil: (activityTitle) => html`<strong>Iugnay ang ${activityTitle} sa tao</strong>: piliin ang aktibidad na maiuugnay sa bagong ${activityTitle}`,
	fr: (activityTitle) => html`<strong>${activityTitle} associée avec la personne</strong> : sélectionnez l’activité à laquelle la nouvelle ${activityTitle} sera associée`,
	hi: (activityTitle) => html`<strong>व्यक्ति के साथ ${activityTitle} को संबद्ध करें</strong>: उस गतिविधि का चयन करें जिसके साथ नया ${activityTitle} जुड़ा होगा`,
	ht: (activityTitle) => html`<strong>Asosye ${activityTitle} ak moun</strong>: chwazi aktivite nouvo ${activityTitle} lan pral asosye avèk`,
	it: (activityTitle) => html`<strong>${activityTitle} associata con persona</strong>: seleziona l'attività a cui sarà associata la nuova ${activityTitle}`,
	ja: (activityTitle) => html`<strong>紹介を対象者${activityTitle}と関連付け</strong>る:新しい${activityTitle}が関連付けられる活動を選択します`,
	ko: (activityTitle) => html`<strong>추천을 사람과 ${activityTitle} 연관</strong>시키기: 새 ${activityTitle}이 연관될 활동을 선택하세요`,
	mww: (activityTitle) => html`<strong>Koom nrog kev ${activityTitle} nrog tus neeg</strong>: xaiv qhov haujlwm uas kev ${activityTitle} tshiab yuav cuam tshuam nrog`,
	ps: (activityTitle) => html`<strong>د ${activityTitle}</strong> ورکول: هغه فعالیت وټاکئ چې نوی ${activityTitle} کول به ورسره تړاو ولری`,
	pt: (activityTitle) => html`<strong>${activityTitle} associada com pessoa</strong>: selecione a atividade à qual a nova ${activityTitle} será associada`,
	'pt-pt': (activityTitle) => html`<strong>${activityTitle} associada com pessoa</strong>: selecione a atividade à qual a nova ${activityTitle} estará associada`,
	ru: (activityTitle) => html`<strong>Сотрудничество ${activityTitle} направления с человеком</strong>: выберите деятельность, с которой будет связана новая ${activityTitle}`,
	sm: (activityTitle) => html`<strong>Fa'afeso'ota'i le ${activityTitle} ma le tagata</strong>: filifili le gaioiga o le a feso'ota'i ma le fa'asino fou ${activityTitle}`,
	so: (activityTitle) => html`<strong>Xiriir ${activityTitle} iyo qof</strong>: dooro hawsha uu ${activityTitle} cusub la xiriiri doono`,
	th: (activityTitle) => html`<strong>เชื่อมโยง ${activityTitle} กับบุคคล</strong>: เลือกกิจกรรมที่จะเชื่อมโยงกับ ${activityTitle} ใหม่`,
	ur: (activityTitle) => html`<strong>${activityTitle} کو شخص کے ساتھ منسلک</strong> کریں: وہ سرگرمی منتخب کریں جس سے نیا ${activityTitle} منسلک ہوگا`,
	vi: (activityTitle) => html`<strong>Liên kết ${activityTitle} với người</strong>: chọn hoạt động mà ${activityTitle} mới sẽ được liên kết`,
	'zh-hans': (activityTitle) => html`<strong>将 ${activityTitle} 与个人关联</strong>：选择新 ${activityTitle} 将关联的活动`,
	'zh-hant': (activityTitle) => html`<strong>將 ${activityTitle} 與個人關聯</strong>：選擇新 ${activityTitle} 將關聯的活動`,
	en: (activityTitle) => html`<strong>Associate ${activityTitle} with person</strong>: select the activity the new ${activityTitle} will be associated with`
};

export const loc_associated: Record<Locale, string> = {
	ar: `مرتبطون`,
	de: `Assoziierte`,
	es: `Asociados`,
	fa: `وابسته`,
	fil: `Nauugnay`,
	fr: `Associés`,
	hi: `संबद्ध`,
	ht: `Asosye`,
	it: `Associati`,
	ja: `関連`,
	ko: `관련`,
	mww: `Txuam`,
	ps: `اسوشیټډ`,
	pt: `Associados`,
	'pt-pt': `Associados`,
	ru: `Связанные`,
	sm: `Feso'ota'iga`,
	so: `La xiriira`,
	th: `ที่เกี่ยวข้อง`,
	ur: `وابستہ`,
	vi: `Liên kết`,
	'zh-hans': `相关`,
	'zh-hant': `相關`,
	en: `Associated`
};

export const loc_associatedActivities: Record<Locale, string> = {
	ar: `الأنشطة المرتبطة`,
	de: `Verwandte Aktivitäten`,
	es: `Actividades asociadas`,
	fa: `فعالیت های مرتبط`,
	fil: `Mga kaugnay na aktibidad`,
	fr: `Activités associées`,
	hi: `संबद्ध गतिविधियाँ`,
	ht: `Aktivite ki asosye yo`,
	it: `Attività associate`,
	ja: `関連活動`,
	ko: `관련 활동`,
	mww: `Cov kev ua ub no cuam tshuam`,
	ps: `اړوند فعالیتونه`,
	pt: `Atividades associadas`,
	'pt-pt': `Atividades associadas`,
	ru: `Связанные виды деятельности`,
	sm: `Gaoioiga fesootai`,
	so: `Hawlaha la xiriira`,
	th: `กิจกรรมที่เกี่ยวข้อง`,
	ur: `متعلقہ سرگرمیاں`,
	vi: `Các hoạt động liên quan`,
	'zh-hans': `相关活动`,
	'zh-hant': `相關活動`,
	en: `Associated activities`
};

export const loc_associateSMSInstruction: Record<Locale, string> = {
	ar: `أدخل رقم هاتفك أدناه. سيتم إرسال رسالة نصية إلى ذلك الرقم مع رمز لإدخاله في الشاشة التالية.`,
	de: `Geben Sie unten Ihre Telefonnummer ein. Eine SMS wird an diese Nummer gesendet, mit einem Code, den man auf dem nächsten Bildschirm eingeben kann.`,
	es: `Introduce tu número de teléfono a continuación. Se enviará un SMS a ese número con un código para introducir en la siguiente pantalla.`,
	fa: `شماره تلفن خود را در زیر وارد کنید. یک پیامک به آن شماره ارسال می شود که کدی برای وارد کردن در صفحه بعدی وجود دارد.`,
	fil: `Ipasok ang iyong numero ng telepono sa ibaba. Isang SMS ang ipapadala sa numerong iyon na may code na ipasok sa susunod na screen.`,
	fr: `Saisissez votre numéro de téléphone ci-dessous. Un SMS sera envoyé à ce numéro avec un code à saisir à l’écran suivant.`,
	hi: `नीचे अपना फ़ोन नंबर दर्ज करें। अगली स्क्रीन पर दर्ज करने के लिए एक कोड के साथ उस नंबर पर एक एसएमएस भेजा जाएगा।`,
	ht: `Antre nimewo telefòn ou anba a. Yon SMS yo pral voye nan nimewo sa a ak yon kòd antre nan ekran kap vini an.`,
	it: `Inserisci il tuo numero di telefono qui sotto. Un SMS verrà inviato a quel numero con un codice da inserire nella schermata successiva.`,
	ja: `以下に電話番号を入力してください。次の画面で入力するコード付きのSMSがその番号に送られます。`,
	ko: `아래에 전화번호를 입력하세요. 다음 화면에 입력할 코드가 포함된 SMS가 해당 번호로 전송됩니다.`,
	mww: `Sau koj tus xov tooj hauv qab no. Ib qho SMS yuav raug xa mus rau tus xov tooj ntawd nrog tus lej nkag mus rau ntawm lub vijtsam tom ntej.`,
	ps: `لاندې خپل د تلیفون شمېره داخل کړئ. یو SMS به هغه شمېره ته واستول شی چې په بل سکرین کې کوډ پکې شامل شی.`,
	pt: `Insira seu número de telefone abaixo. Um SMS será enviado para esse número com um código para inserir na próxima tela.`,
	'pt-pt': `Insira o seu número de telefone abaixo. Será enviado um SMS para esse número com um código para introduzir no ecrã seguinte.`,
	ru: `Введите свой номер телефона ниже. На этот номер будет отправлено SMS с кодом для ввода на следующем экране.`,
	sm: `Ulu atu i lau numera telefoni o loo i lalo. O le a lafoina se SMS i lena numera ma se code e ulufale ai i le isi lau.`,
	so: `Geli lambarkaaga telefoonka hoos. SMS ayaa loo diri doonaa lambarkaas iyadoo la heli karo koodh lagu galo shaashadda xigta.`,
	th: `ป้อนหมายเลขโทรศัพท์ของคุณด้านล่าง SMS จะถูกส่งไปยังหมายเลขนั้นพร้อมรหัสเพื่อป้อนในหน้าจอถัดไป`,
	ur: `نیچے اپنا فون نمبر درج کریں۔ اس نمبر پر ایک ایس ایم ایس بھیجا جائے گا جس میں اگلی اسکرین پر درج کرنے کے لیے کوڈ ہوگا۔`,
	vi: `Nhập số điện thoại của bạn bên dưới. Một tin nhắn SMS sẽ được gửi đến số đó với một mã để nhập vào màn hình tiếp theo.`,
	'zh-hans': `请在下方输入您的电话号码。会向该号码发送短信，并附有代码，需在下一页输入。`,
	'zh-hant': `請在下方輸入您的電話號碼。該號碼會發送簡訊，並附有代碼，需在下一個畫面輸入。`,
	en: `Enter your phone number below. An SMS will be sent to that number with a code to enter on the next screen.`
};

export const loc_associateTOTPInstruction: Record<Locale, string> = {
	ar: `قم بمسح رمز QR أعلاه باستخدام تطبيق المصادقة المفضل لديك ثم أدخل الرمز المخصص لمرة واحدة أدناه.`,
	de: `Scannen Sie den oben genannten QR-Code mit Ihrer bevorzugten Authenticator-App und geben Sie dann den unten angegebenen Einmalcode ein.`,
	es: `Escanea el código QR de arriba usando tu aplicación de autenticación favorita y luego introduce el código de un solo uso proporcionado a continuación.`,
	fa: `کد QR بالا را با اپلیکیشن احراز هویت مورد علاقه تان اسکن کنید و سپس کد یک بار مصرف ارائه شده را در زیر وارد کنید.`,
	fil: `I-scan ang QR Code sa itaas gamit ang iyong ginustong authenticator app at pagkatapos ay ipasok ang ibinigay na one-time code sa ibaba.`,
	fr: `Scannez le QR Code ci-dessus à l’aide de votre application d’authentification préférée, puis entrez le code à usage unique fourni ci-dessous.`,
	hi: `अपने पसंदीदा प्रमाणक ऐप का उपयोग करके ऊपर दिए गए क्यूआर कोड को स्कैन करें और फिर नीचे दिए गए वन-टाइम कोड को दर्ज करें।`,
	ht: `Eskane Kòd QR ki anwo a lè l sèvi avèk app otantifikatè ou pi pito ak Lè sa a, antre nan kòd la bay yon sèl-fwa anba a.`,
	it: `Scansiona il codice QR sopra usando la tua app di autenticazione preferita e poi inserisci il codice monouso fornito qui sotto.`,
	ja: `お好みの認証アプリで上記のQRコードをスキャンし、下記のワンタイムコードを入力してください。`,
	ko: `위의 QR 코드를 선호하는 인증 앱으로 스캔한 후, 아래에 제공된 일회용 코드를 입력하세요.`,
	mww: `Luam theej duab QR Code saum toj no siv koj nyiam authenticator app thiab tom qab ntawd nkag mus rau tus lej ib zaug hauv qab no.`,
	ps: `پورته QR کوډ د خپل خوښ شوی تصدیق کوونکی اپلیکیشن په کارولو سره سکین کړئ او بیا لاندې ورکړل شوی یو ځل کوډ داخل کړئ.`,
	pt: `Escaneie o QR Code acima usando seu aplicativo de autenticação preferido e então insira o código único fornecido abaixo.`,
	'pt-pt': `Digitalize o Código QR acima usando a sua aplicação de autenticação preferida e depois introduza o código único fornecido abaixo.`,
	ru: `Отсканируйте QR-код выше с помощью предпочитаемого приложения аутентификации, а затем введите предоставленный одноразовый код ниже.`,
	sm: `Fa'ata'ita'i le QR Code i luga e fa'aaoga ai lau authenticator app e te fiafia i ai ona ulufale lea i le code e tasi le taimi o lo'o i lalo.`,
	so: `Iska baar QR Code-ka kor ku xusan adigoo isticmaalaya app-ka authenticator-ka aad doorbideyso, kadibna geli koodhka hal mar ee la bixiyay hoos.`,
	th: `สแกน QR Code ด้านบนโดยใช้แอปยืนยันตัวตนที่คุณต้องการ จากนั้นป้อนรหัสแบบใช้ครั้งเดียวที่ให้ไว้ด้านล่าง`,
	ur: `اوپر دیے گئے QR کوڈ کو اپنی پسندیدہ آتھنٹی کیٹر ایپ سے اسکین کریں اور پھر نیچے دیا گیا ون ٹائم کوڈ درج کریں۔`,
	vi: `Quét Mã QR ở trên bằng ứng dụng xác thực ưa thích của bạn và sau đó nhập mã dùng một lần được cung cấp bên dưới.`,
	'zh-hans': `使用您偏好的身份验证应用扫描上方二维码，然后输入下方提供的一次性验证码。`,
	'zh-hant': `使用您偏好的驗證應用程式掃描上方的 QR 碼，然後輸入下方提供的一次性驗證碼。`,
	en: `Scan the QR Code above using your preferred authenticator app and then enter the provided one-time code below.`
};

export const loc_associateUser: Record<Locale, string> = {
	ar: `المستخدم المساعد`,
	de: `Assoziierter Nutzer`,
	es: `Usuario asociado`,
	fa: `کاربر همکار`,
	fil: `Email Address *`,
	fr: `Utilisateur associé`,
	hi: `सहयोगी उपयोगकर्ता`,
	ht: `Asosye itilizatè`,
	it: `Utente associato`,
	ja: `アソシエイトユーザー`,
	ko: `어소시에이트 사용자`,
	mww: `Associate neeg siv`,
	ps: `همکار کارونکی`,
	pt: `Usuário associado`,
	'pt-pt': `Utilizador associado`,
	ru: `Ассоциированный пользователь`,
	sm: `Tagata faaaoga lagolago`,
	so: `Isticmaale la shaqeeya`,
	th: `เชื่อมโยงผู้ใช้`,
	ur: `ایسوسی ایٹ یوزر`,
	vi: `Liên kết người dùng`,
	'zh-hans': `助理用户`,
	'zh-hant': `副用戶`,
	en: `Associate user`
};

export const loc_attachFilesBy: Record<Locale, string> = {
	ar: `أرفق الملفات عن طريق السحب والإفلات، الاختيار، أو لصقها.`,
	de: `Fügen Sie Dateien an, indem Sie sie ziehen und absetzen, auswählen oder einfügen.`,
	es: `Adjunta archivos arrastrándolos y soltándolos, seleccionándolos o pegándolos.`,
	fa: `فایل ها را با کشیدن و رها کردن، انتخاب یا پیست کردن ضمیمه کنید.`,
	fil: `Ilakip ang mga file sa pamamagitan ng pag-drag at pag-drop, pagpili, o pag-paste ng mga ito.`,
	fr: `Attachez les fichiers en les faisant glisser-déposer, sélectionner ou coller.`,
	hi: `फ़ाइलों को खींचकर और छोड़कर, चुनकर या चिपकाने के द्वारा अनुलग्न करें।`,
	ht: `Tache dosye pa trennen & jete, chwazi, oswa kole yo.`,
	it: `Allega i file trascinandoli e rilasciandoli, selezionandoli o incollandoli.`,
	ja: `ファイルをドラッグ&ドロップ、選択、または貼り付けで添付できます。`,
	ko: `파일을 드래그 앤 드롭, 선택 또는 붙여넣기로 첨부할 수 있습니다.`,
	mww: `Txuas cov ntaub ntawv los ntawm dragging & poob, xaiv los yog pasting lawv.`,
	ps: `فایلونه د راکش او غورځولو، انتخاب یا پیسټولو له لارې وصل کړئ.`,
	pt: `Anexe arquivos arrastando e soltando, selecionando ou colando.`,
	'pt-pt': `Anexe ficheiros arrastando-os e soltando-os, selecionando-os ou colando-os.`,
	ru: `Прикрепляйте файлы, перетаскивая, выбирая или вставляя их.`,
	sm: `Fa'apipi'i faila e ala i le tosoina ma pa'u, filifilia, pe fa'apipi'i i latou.`,
	so: `Faylasha ku xir adigoo jiidaya oo la daadinayaa, dooranaya, ama ku dhejiya.`,
	th: `แนบไฟล์โดยการลากและวาง เลือก หรือวางไฟล์`,
	ur: `فائلز کو ڈریگ اور ڈراپ، منتخب یا پیسٹ کر کے اٹیچ کریں۔`,
	vi: `Đính kèm tệp bằng cách kéo và thả, chọn hoặc dán chúng.`,
	'zh-hans': `通过拖拽、选择或粘贴文件来附加文件。`,
	'zh-hant': `透過拖放、選取或貼上檔案來附加檔案。`,
	en: `Attach files by dragging & dropping, selecting, or pasting them.`
};

export const loc_attachment: Record<Locale, string> = {
	ar: `الارتباط`,
	de: `Anhang`,
	es: `Anexo`,
	fa: `وابستگی`,
	fil: `Attachment`,
	fr: `Attachement`,
	hi: `अनुलग्नक`,
	ht: `Atachman`,
	it: `Allegamento`,
	ja: `愛着`,
	ko: `부착`,
	mww: `Txuas`,
	ps: `ضمیمه`,
	pt: `Anexo`,
	'pt-pt': `Anexo`,
	ru: `Прикрепление`,
	sm: `Fa'apipi'i`,
	so: `Ku xiran`,
	th: `เอกสารแนบ`,
	ur: `وابستگی`,
	vi: `Tệp đính kèm`,
	'zh-hans': `依附`,
	'zh-hant': `依附`,
	en: `Attachment`
};

export const loc_attachments: Record<Locale, string> = {
	ar: `الملحقات`,
	de: `Anhänge`,
	es: `Accesorios`,
	fa: `ضمیمه ها`,
	fil: `Mga Attachment`,
	fr: `Accessoires`,
	hi: `अनुरक्ति`,
	ht: `Atachman`,
	it: `Allegati`,
	ja: `付属施設`,
	ko: `부속 자료`,
	mww: `Cov ntawv txuas`,
	ps: `ضمیمې`,
	pt: `Anexos`,
	'pt-pt': `Anexos`,
	ru: `Вложения`,
	sm: `Fa'apipi'i`,
	so: `Lifaaqyo`,
	th: `เอกสารแนบ`,
	ur: `اٹیچمنٹس`,
	vi: `Tệp đính kèm`,
	'zh-hans': `附属品`,
	'zh-hant': `附屬設施`,
	en: `Attachments`
};

export const loc_authorizationInvalid: Record<Locale, string> = {
	ar: `التفويض غير صالح.`,
	de: `Autorisierung ungültig.`,
	es: `Autorización inválida.`,
	fa: `مجوز نامعتبر است.`,
	fil: `Hindi wasto ang awtorisasyon.`,
	fr: `Autorisation invalide.`,
	hi: `प्राधिकरण अमान्य।`,
	ht: `Otorizasyon envalid`,
	it: `Autorizzazione non valida.`,
	ja: `認証無効です。`,
	ko: `권한이 무효입니다.`,
	mww: `Kev tso cai tsis raug.`,
	ps: `اجازه ناقانونه ده.`,
	pt: `Autorização inválida.`,
	'pt-pt': `Autorização inválida.`,
	ru: `Авторизация недействительна.`,
	sm: `E le aoga le faatagaga.`,
	so: `Oggolaanshuhu waa mid aan sax ahayn.`,
	th: `การอนุญาตไม่ถูกต้อง`,
	ur: `اجازت نامہ غیر معتبر ہے۔`,
	vi: `Ủy quyền không hợp lệ.`,
	'zh-hans': `授权无效。`,
	'zh-hant': `授權無效。`,
	en: `Authorization invalid.`
};

export const loc_authorizationMissing: Record<Locale, string> = {
	ar: `التفويض مفقود.`,
	de: `Genehmigung fehlt.`,
	es: `Falta autorización.`,
	fa: `مجوز وجود ندارد.`,
	fil: `Nawawala ang awtorisasyon.`,
	fr: `Autorisation manquante.`,
	hi: `प्राधिकरण अनुपलब्ध।`,
	ht: `Otorizasyon ki manke.`,
	it: `Autorizzazione mancante.`,
	ja: `承認が抜けています。`,
	ko: `승인 부족.`,
	mww: `Kev tso cai ploj lawm.`,
	ps: `اجازه نشته.`,
	pt: `Autorização faltando.`,
	'pt-pt': `Autorização em falta.`,
	ru: `Разрешение отсутствует.`,
	sm: `Ua misi le faatagaga.`,
	so: `Oggolaansho ma jirto.`,
	th: `ขาดการอนุญาต`,
	ur: `اجازت نامہ غائب ہے۔`,
	vi: `Thiếu ủy quyền.`,
	'zh-hans': `缺少授权。`,
	'zh-hant': `缺少授權。`,
	en: `Authorization missing.`
};

export const loc_balance: Record<Locale, string> = {
	ar: `التوازن`,
	de: `Gleichgewicht`,
	es: `Equilibrio`,
	fa: `تعادل`,
	fil: `Balanse`,
	fr: `Équilibre`,
	hi: `संतुलन`,
	ht: `Balans`,
	it: `Bilanciamento`,
	ja: `バランス`,
	ko: `밸런스`,
	mww: `Sib npaug`,
	ps: `توازن`,
	pt: `Equilíbrio`,
	'pt-pt': `Equilíbrio`,
	ru: `Баланс`,
	sm: `Paleni`,
	so: `Dheelitirka`,
	th: `สมดุล`,
	ur: `توازن`,
	vi: `Cân bằng`,
	'zh-hans': `平衡`,
	'zh-hant': `平衡`,
	en: `Balance`
};

export const loc_billing: Record<Locale, string> = {
	ar: `التصنيف`,
	de: `Abrechnung`,
	es: `Facturación`,
	fa: `صورتحساب`,
	fil: `Email Address *`,
	fr: `Facturation`,
	hi: `बिलिंग`,
	ht: `Bòdwo`,
	it: `Pubblicazione`,
	ja: `請求`,
	ko: `청구`,
	mww: `Kev them nqi`,
	ps: `بیلینګ`,
	pt: `Faturamento`,
	'pt-pt': `Faturamento`,
	ru: `Биллинг`,
	sm: `Pili`,
	so: `Qiimeynta`,
	th: `การเรียกเก็บเงิน`,
	ur: `بلنگ`,
	vi: `Thanh toán`,
	'zh-hans': `账单`,
	'zh-hant': `計費`,
	en: `Billing`
};

export const loc_billingProfiles: Record<Locale, string> = {
	ar: `ملفات الفوترة`,
	de: `Abrechnungsprofile`,
	es: `Perfiles de facturación`,
	fa: `پروفایل های صورتحساب`,
	fil: `Mga Profile sa Pagsingil`,
	fr: `Profils de facturation`,
	hi: `बिलिंग प्रोफाइल`,
	ht: `Bòdwo Des`,
	it: `Profili di fatturazione`,
	ja: `請求プロファイル`,
	ko: `청구 프로필`,
	mww: `Them nqi profiles`,
	ps: `د بیلینګ پروفایلونه`,
	pt: `Perfis de faturamento`,
	'pt-pt': `Perfis de faturação`,
	ru: `Профили выставления счетов`,
	sm: `Talaaga otooto o pili`,
	so: `Astaamaha Billing-ka`,
	th: `โปรไฟล์การเรียกเก็บเงิน`,
	ur: `بلنگ پروفائلز`,
	vi: `Hồ sơ thanh toán`,
	'zh-hans': `计费配置文件`,
	'zh-hant': `計費設定檔`,
	en: `Billing profiles`
};

export const loc_bio: Record<Locale, string> = {
	ar: `السيرة الذاتية`,
	de: `Biografie`,
	es: `Biografía`,
	fa: `زندگی نامه`,
	fil: `Talambuhay`,
	fr: `Biographie`,
	hi: `जैव`,
	ht: `Biyo`,
	it: `Biografia`,
	ja: `経歴`,
	ko: `약력`,
	mww: `Bio`,
	ps: `ژوندلیک`,
	pt: `Biografia`,
	'pt-pt': `Biografia`,
	ru: `Биография`,
	sm: `Talaaga`,
	so: `Taariikh nololeed`,
	th: `ชีวประวัติ`,
	ur: `سوانح حیات`,
	vi: `Tiểu sử`,
	'zh-hans': `简介`,
	'zh-hant': `簡介`,
	en: `Bio`
};

export const loc_blankScsepTimesheet: Record<Locale, string> = {
	ar: `جدول زمني فارغ ل SCSEP`,
	de: `Leeres SCSEP-Stundenblatt`,
	es: `Hoja de horas SCSEP en blanco`,
	fa: `برگه زمانی خالی SCSEP`,
	fil: `Blangko SCSEP timesheet`,
	fr: `Feuille horaire SCSEP vierge`,
	hi: `रिक्त SCSEP समय पत्रक`,
	ht: `Blank SCSEP timesheet`,
	it: `Foglio orario SCSEP vuoto`,
	ja: `空白のSCSEPタイムシート`,
	ko: `빈 SCSEP 시간표`,
	mww: `Dawb paug SCSEP daim ntawv teev sij hawm`,
	ps: `د SCSEP خالی وخت پاڼه`,
	pt: `Folha de horas SCSEP em branco`,
	'pt-pt': `Folha de horas SCSEP em branco`,
	ru: `Пустой табель SCSEP`,
	sm: `Avanoa SCSEP timesheet`,
	so: `Jadwalka SCSEP ee madhan`,
	th: `แผ่นเวลา SCSEP เปล่า`,
	ur: `خالی SCSEP ٹائم شیٹ`,
	vi: `Bảng chấm công SCSEP trống`,
	'zh-hans': `空白SCSEP时间表`,
	'zh-hant': `空白SCSEP工時表`,
	en: `Blank SCSEP timesheet`
};

export const loc_breakFreeFromComplicatedIT: Record<Locale, TemplateResult> = {
	ar: html`<span class="text-gradient text-gradient--purple-pink">التحرر</span> من تكنولوجيا المعلومات المعقدة`,
	de: html`<span class="text-gradient text-gradient--purple-pink">Befreie dich</span> aus der komplizierten IT`,
	es: html`<span class="text-gradient text-gradient--purple-pink">Libérate</span> de la informática complicada`,
	fa: html`<span class="text-gradient text-gradient--purple-pink">رهایی</span> از فناوری اطلاعات پیچیده`,
	fil: html`<span class="text-gradient text-gradient--purple-pink">Alisin</span> ang tiyan mula sa kumplikadong pag-uugali`,
	fr: html`<span class="text-gradient text-gradient--purple-pink">Libérez-vous</span> de l’informatique compliquée`,
	hi: html`जटिल आईटी से <span class="text-gradient text-gradient--purple-pink">मुक्त हो जाओ</span>`,
	ht: html`<span class="text-gradient text-gradient--purple-pink">Kraze soti</span> nan IT konplike`,
	it: html`<span class="text-gradient text-gradient--purple-pink">Liberarsi</span> dall'IT complicato`,
	ja: html`複雑なITからの<span class="text-gradient text-gradient--purple-pink">脱</span>却`,
	ko: html`복잡한 IT에서 <span class="text-gradient text-gradient--purple-pink">벗어나</span>`,
	mww: html`<span class="text-gradient text-gradient--purple-pink">Tawg tawm</span> ntawm IT nyuaj`,
	ps: html`له پېچلو آی ټی څخه <span class="text-gradient text-gradient--purple-pink">ځان خلاص کړه</span>`,
	pt: html`<span class="text-gradient text-gradient--purple-pink">Liberte-se</span> de TI complicada`,
	'pt-pt': html`<span class="text-gradient text-gradient--purple-pink">Liberta-te</span> de TI complicada`,
	ru: html`<span class="text-gradient text-gradient--purple-pink">Освободиться</span> от сложной ИТ`,
	sm: html`<span class="text-gradient text-gradient--purple-pink">Fa'asa'oloto mai</span> le fa'alavelave fa'alavelave`,
	so: html`<span class="text-gradient text-gradient--purple-pink">Ka bax</span> IT-ga adag`,
	th: html`<span class="text-gradient text-gradient--purple-pink">หลุดพ้น</span> จากไอทีที่ซับซ้อน`,
	ur: html`پیچیدہ آئی ٹی سے <span class="text-gradient text-gradient--purple-pink">آزاد ہونا</span>`,
	vi: html`<span class="text-gradient text-gradient--purple-pink">Thoát khỏi</span> CNTT phức tạp`,
	'zh-hans': html`摆<span class="text-gradient text-gradient--purple-pink">脱</span>复杂的IT困境`,
	'zh-hant': html`擺脫<span class="text-gradient text-gradient--purple-pink"></span>複雜的 IT 困境`,
	en: html`<span class="text-gradient text-gradient--purple-pink">Break free</span> from complicated IT`
};

export const loc_budget: Record<Locale, string> = {
	ar: `الميزانية`,
	de: `Budget`,
	es: `Presupuesto`,
	fa: `بودجه`,
	fil: `Badyet`,
	fr: `Budget`,
	hi: `बहुत सस्‍ता`,
	ht: `Bidjè`,
	it: `Budget`,
	ja: `予算`,
	ko: `예산`,
	mww: `Nyiaj Txiag`,
	ps: `بودیجه`,
	pt: `Orçamento`,
	'pt-pt': `Orçamento`,
	ru: `Бюджет`,
	sm: `Paketi`,
	so: `Miisaaniyadda`,
	th: `งบประมาณ`,
	ur: `بجٹ`,
	vi: `Ngân sách`,
	'zh-hans': `预算`,
	'zh-hant': `預算`,
	en: `Budget`
};

export const loc_budgets: Record<Locale, string> = {
	ar: `الميزانيات`,
	de: `Budgets`,
	es: `Presupuestos`,
	fa: `بودجه ها`,
	fil: `Mga badyet`,
	fr: `Budgets`,
	hi: `बजट`,
	ht: `Bidjè yo`,
	it: `Bilanci`,
	ja: `予算`,
	ko: `예산`,
	mww: `Cov Nyiaj Txiag`,
	ps: `بودیجه`,
	pt: `Orçamentos`,
	'pt-pt': `Orçamentos`,
	ru: `Бюджеты`,
	sm: `Paketi`,
	so: `Miisaaniyadda`,
	th: `งบประมาณ`,
	ur: `بجٹ`,
	vi: `Ngân sách`,
	'zh-hans': `预算`,
	'zh-hant': `預算`,
	en: `Budgets`
};

export const loc_businessEmail: Record<Locale, string> = {
	ar: `البريد الإلكتروني التجاري`,
	de: `Geschäfts-E-Mail`,
	es: `Correo electrónico empresarial`,
	fa: `ایمیل تجاری`,
	fil: `Email Address *`,
	fr: `Email professionnel`,
	hi: `व्यापार ईमेल`,
	ht: `Imèl biznis`,
	it: `Email aziendale`,
	ja: `ビジネスメール`,
	ko: `비즈니스 이메일`,
	mww: `Kev lag luam email`,
	ps: `د سوداګرۍ برېښنالیک`,
	pt: `E-mail empresarial`,
	'pt-pt': `Email empresarial`,
	ru: `Деловая почта`,
	sm: `Pisinisi imeli`,
	so: `Email ganacsi`,
	th: `อีเมลธุรกิจ`,
	ur: `کاروباری ای میل`,
	vi: `Email doanh nghiệp`,
	'zh-hans': `商务邮箱`,
	'zh-hant': `商業電子郵件`,
	en: `Business email`
};

export const loc_cancel: Record<Locale, string> = {
	ar: `إلغاء`,
	de: `Stornieren`,
	es: `Cancelar`,
	fa: `لغو`,
	fil: `Kanselahin`,
	fr: `Annuler`,
	hi: `रद्द करना`,
	ht: `Anile`,
	it: `Cancella`,
	ja: `キャンセル`,
	ko: `취소`,
	mww: `rho tawm`,
	ps: `لغوه کول`,
	pt: `Cancelar`,
	'pt-pt': `Cancelar`,
	ru: `Отмена`,
	sm: `Fa'alēāogāina`,
	so: `Jooji`,
	th: `ยกเลิก`,
	ur: `منسوخ کریں`,
	vi: `Hủy bỏ`,
	'zh-hans': `取消`,
	'zh-hant': `取消`,
	en: `Cancel`
};

export const loc_cancelled: Record<Locale, string> = {
	ar: `تم الإلغاء`,
	de: `Eingestellt`,
	es: `Cancelado`,
	fa: `لغو شده`,
	fil: `Kinansela`,
	fr: `Annulé`,
	hi: `रद्द किया गया`,
	ht: `Anile`,
	it: `Cancellato`,
	ja: `中止`,
	ko: `취소됨`,
	mww: `muab tso tseg`,
	ps: `لغوه شو`,
	pt: `Cancelado`,
	'pt-pt': `Cancelado`,
	ru: `Отменён`,
	sm: `Fa'aleaogaina`,
	so: `La joojiyay`,
	th: `ยกเลิก`,
	ur: `منسوخ شدہ`,
	vi: `Đã hủy`,
	'zh-hans': `取消`,
	'zh-hant': `取消`,
	en: `Cancelled`
};

export const loc_cancelledStatusDesc: Record<Locale, string> = {
	ar: `لم تكتمل هذه النشاطات.`,
	de: `Die Aktivität wurde nicht abgeschlossen.`,
	es: `La actividad no se completó.`,
	fa: `این فعالیت به پایان نرسید.`,
	fil: `Hindi pa tapos ang aktibidad.`,
	fr: `L’activité n’a pas été achevée.`,
	hi: `गतिविधि पूरी नहीं हुई थी।`,
	ht: `Aktivite a pa t fini`,
	it: `L'attività non fu completata.`,
	ja: `しかし、その活動は完了しませんでした。`,
	ko: `그러나 이 활동은 완료되지 않았습니다.`,
	mww: `Qhov kev ua haujlwm tsis tiav.`,
	ps: `فعالیت بشپړ نه شو.`,
	pt: `A atividade não foi concluída.`,
	'pt-pt': `A atividade não foi concluída.`,
	ru: `Деятельность не была завершена.`,
	sm: `E le'i mae'a le gaoioiga.`,
	so: `Hawshaas lama dhammeystirin.`,
	th: `กิจกรรมยังไม่เสร็จสมบูรณ์`,
	ur: `یہ سرگرمی مکمل نہیں ہوئی۔`,
	vi: `Hoạt động chưa hoàn thành.`,
	'zh-hans': `该活动未完成。`,
	'zh-hant': `該活動尚未完成。`,
	en: `The activity was not completed.`
};

export const loc_cannotCreateChildActivities: Record<Locale, string> = {
	ar: `هذا النشاط لا يمكنه إنشاء سجلات جديدة.`,
	de: `Diese Aktivität kann keine neuen Datensätze erstellen.`,
	es: `Esta actividad no puede crear nuevos registros.`,
	fa: `این فعالیت نمی تواند رکوردهای جدیدی ایجاد کند.`,
	fil: `Ang aktibidad na ito ay hindi maaaring lumikha ng mga bagong talaan.`,
	fr: `Cette activité ne peut pas créer de nouveaux enregistrements.`,
	hi: `यह गतिविधि नए रिकॉर्ड नहीं बना सकती.`,
	ht: `Aktivite sa a pa ka kreye nouvo dosye.`,
	it: `Questa attività non può creare nuovi record.`,
	ja: `この活動は新しい記録を作成することはできません。`,
	ko: `이 활동은 새로운 기록을 생성할 수 없습니다.`,
	mww: `Qhov kev ua no tsis tuaj yeem tsim cov ntaub ntawv tshiab.`,
	ps: `دا فعالیت نشی کولای نوی ریکارډونه جوړ کړی.`,
	pt: `Essa atividade não pode criar novos registros.`,
	'pt-pt': `Esta atividade não pode criar novos registos.`,
	ru: `Эта деятельность не может создавать новые записи.`,
	sm: `E le mafai e lenei gaoioiga ona fatuina ni faamaumauga fou.`,
	so: `Hawlgalkan ma abuuri karo diiwaanno cusub.`,
	th: `กิจกรรมนี้ไม่สามารถสร้างเรกคอร์ดใหม่ได้`,
	ur: `یہ سرگرمی نئے ریکارڈز نہیں بنا سکتی۔`,
	vi: `Hoạt động này không thể tạo bản ghi mới.`,
	'zh-hans': `该活动无法创造新记录。`,
	'zh-hant': `此活動無法創造新紀錄。`,
	en: `This activity cannot create new records.`
};

export const loc_cannotSignUpAlreadyIn: Record<Locale, string> = {
	ar: `لا يمكنني التسجيل. أنت مسجلة الدخول بالفعل.`,
	de: `Kann mich nicht anmelden. Sie sind bereits angemeldet.`,
	es: `No puedo inscribirme. Ya has iniciado sesión.`,
	fa: `نمی توانم ثبت نام کنم. شما قبلا وارد شده اید.`,
	fil: `Hindi makapag-sign up. Naka-sign in ka na.`,
	fr: `Je ne peux pas m’inscrire. Vous êtes déjà connecté.`,
	hi: `साइन अप नहीं कर सकता. आप पहले से ही साइन इन हैं.`,
	ht: `Pa ka enskri. Ou deja siyen nan.`,
	it: `Non posso iscrivermi. Sei già registrato.`,
	ja: `登録できません。すでにサインインしています。`,
	ko: `가입할 수 없습니다. 이미 로그인되어 있습니다.`,
	mww: `Tsis tuaj yeem sau npe. Koj twb tau kos npe lawm.`,
	ps: `نشم کولای نوم لیکنه وکړم. ته لا دمخه ثبت شوی یې.`,
	pt: `Não posso me inscrever. Você já está logado.`,
	'pt-pt': `Não posso inscrever-me. Já está registado.`,
	ru: `Не могу зарегистрироваться. Вы уже вошли в систему.`,
	sm: `E le mafai ona saini. Ua uma ona e saini i totonu.`,
	so: `Ma isdiiwaangelin karo. Waxaad horey u diiwaangelisay.`,
	th: `ไม่สามารถลงทะเบียนได้ คุณลงชื่อเข้าใช้แล้ว`,
	ur: `سائن اپ نہیں کر سکتا۔ آپ پہلے ہی سائن ان کر چکے ہیں۔`,
	vi: `Không thể đăng ký. Bạn đã đăng nhập.`,
	'zh-hans': `无法注册。你已经登录了。`,
	'zh-hant': `無法註冊。你已經登入了。`,
	en: `Cannot sign up. You are already signed in.`
};

export const loc_cap: Record<Locale, string> = {
	ar: `قبعة`,
	de: `Cap`,
	es: `Cap`,
	fa: `کلاه`,
	fil: `Cap`,
	fr: `Cap`,
	hi: `टोपी`,
	ht: `Bouchon`,
	it: `Cap`,
	ja: `キャップ`,
	ko: `캡`,
	mww: `kaus mom`,
	ps: `کپ`,
	pt: `Cap`,
	'pt-pt': `Cap`,
	ru: `Кепка`,
	sm: `Pulou`,
	so: `Koofiyadda`,
	th: `หมวก`,
	ur: `کیپ`,
	vi: `Mũ lưỡi trai`,
	'zh-hans': `帽`,
	'zh-hant': `帽`,
	en: `Cap`
};

export const loc_caps: Record<Locale, string> = {
	ar: `الكابس`,
	de: `Caps`,
	es: `Internacionalidades`,
	fa: `کلاه ها`,
	fil: `Mga Takip`,
	fr: `Sélections`,
	hi: `कैप्स`,
	ht: `Bouchon`,
	it: `Presenze`,
	ja: `キャップ`,
	ko: `모자`,
	mww: `Kaus mom`,
	ps: `کپونه`,
	pt: `Partidas`,
	'pt-pt': `Internacionalizações`,
	ru: `Капы`,
	sm: `Pulou`,
	so: `Koobabka ciyaaraha`,
	th: `หมวก`,
	ur: `کیپس`,
	vi: `Mũ lưỡi trai`,
	'zh-hans': `帽`,
	'zh-hant': `帽`,
	en: `Caps`
};

export const loc_changePassword: Record<Locale, string> = {
	ar: `تغيير كلمة المرور`,
	de: `Passwort ändern`,
	es: `Cambiar la contraseña`,
	fa: `تغییر رمز عبور`,
	fil: `Password`,
	fr: `Changer le mot de passe`,
	hi: `पासवर्ड बदलें`,
	ht: `Chanje modpas`,
	it: `Cambia password`,
	ja: `パスワード変更`,
	ko: `비밀번호 변경`,
	mww: `Hloov lo lus zais`,
	ps: `رمز بدل کړه`,
	pt: `Alterar a senha`,
	'pt-pt': `Alterar palavra-passe`,
	ru: `Сменить пароль`,
	sm: `Sui le uputatala`,
	so: `Beddel erayga sirta ah`,
	th: `เปลี่ยนรหัสผ่าน`,
	ur: `پاس ورڈ تبدیل کریں`,
	vi: `Thay đổi mật khẩu`,
	'zh-hans': `更改密码`,
	'zh-hant': `更改密碼`,
	en: `Change password`
};

export const loc_changePasswordDescription: Record<Locale, string> = {
	ar: `أرسل رابطا عبر البريد الإلكتروني لتغيير كلمة المرور. تغيير كلمة المرور سيجعلك تخرج من Cumulus.`,
	de: `Senden Sie eine E-Mail mit einem Link, um Ihr Passwort zu ändern. Wenn du dein Passwort änderst, meldest du dich von Cumulus ab.`,
	es: `Envía un enlace por correo electrónico para cambiar tu contraseña. Cambiar tu contraseña te desconectará de Cumulus.`,
	fa: `لینکی ایمیل کنید تا رمز عبور خود را تغییر دهید. تغییر رمز عبور شما را از Cumulus خارج می کند.`,
	fil: `Mag-email ng link para baguhin ang iyong password. Ang pagbabago ng iyong password ay mag-sign out sa iyo mula sa Cumulus.`,
	fr: `Envoyez un lien par email pour changer votre mot de passe. Changer votre mot de passe vous déconnectera de Cumulus.`,
	hi: `अपना पासवर्ड बदलने के लिए एक लिंक ईमेल करें. अपना पासवर्ड बदलने से आप क्यूमुलस से बाहर हो जाएंगे।`,
	ht: `Imèl yon lyen pou chanje modpas ou. Chanje modpas ou pral siyen ou soti nan Cumulus.`,
	it: `Invia un link via email per cambiare la password. Cambiare la password ti farà uscire da Cumulus.`,
	ja: `パスワード変更のためのリンクをメールで送ってください。パスワードを変更するとCumulusからサインアウトされます。`,
	ko: `비밀번호를 변경하려면 링크를 이메일로 보내세요. 비밀번호를 변경하면 Cumulus에서 로그아웃됩니다.`,
	mww: `Email ib qhov txuas los hloov koj tus password. Hloov koj lo lus zais yuav kos npe rau koj tawm ntawm Cumulus.`,
	ps: `د پاسورډ بدلولو لپاره لینک ایمیل کړئ. پاسورډ بدلول به تا له کومیولس څخه وباسی.`,
	pt: `Envie um link para mudar sua senha. Mudar sua senha vai fazer você sair do Cumulus.`,
	'pt-pt': `Envie um link por email para alterar a sua palavra-passe. Mudar a sua palavra-passe vai desconectar-se da Cumulus.`,
	ru: `Отправьте ссылку по электронной почте для смены пароля. Смена пароля выйдет из Cumulus.`,
	sm: `Imeli mai se sootaga e sui ai lau uputatala. O le suia o lau uputatala o le a saini ai oe mai Cumulus.`,
	so: `U dir email link si aad u beddesho erayga sirta sirta ah. Beddelidda erayga sirta ah waxay kaa saari doontaa Cumulus.`,
	th: `ส่งลิงก์ทางอีเมลเพื่อเปลี่ยนรหัสผ่าน การเปลี่ยนรหัสผ่านของคุณจะเป็นการนําคุณออกจากระบบ Cumulus`,
	ur: `اپنا پاس ورڈ تبدیل کرنے کے لیے لنک ای میل کریں۔ اپنا پاس ورڈ تبدیل کرنے سے آپ Cumulus سے باہر ہو جائیں گے۔`,
	vi: `Gửi liên kết qua email để thay đổi mật khẩu của bạn. Thay đổi mật khẩu của bạn sẽ đăng xuất bạn khỏi Cumulus.`,
	'zh-hans': `通过电子邮件发送更改密码的链接。更改密码会让你登出Cumulus。`,
	'zh-hant': `透過電子郵件發送更改密碼的連結。更改密碼會讓你登出 Cumulus。`,
	en: `Email a link to change your password. Changing your password will sign you out of Cumulus.`
};

export const loc_changePWLinkSent: Record<Locale, string> = {
	ar: `تغيير رابط كلمة المرور أرسلت`,
	de: `Passwort ändern Link gesendet`,
	es: `Enlace de cambio de contraseña enviado`,
	fa: `تغییر رمز عبور لینک ارسال شد`,
	fil: `Baguhin ang link ng password na ipinadala`,
	fr: `Lien de changement de mot de passe envoyé`,
	hi: `पासवर्ड बदलें लिंक भेजा गया`,
	ht: `Chanje lyen modpas voye`,
	it: `Modifica password link inviato`,
	ja: `パスワード変更リンク送信済み`,
	ko: `비밀번호 변경 링크 전송`,
	mww: `Hloov lo lus zais txuas xa`,
	ps: `د پاسورډ بدلون لینک واستول شو`,
	pt: `Link de mudança de senha enviado`,
	'pt-pt': `Link de alteração de palavra-passe enviado`,
	ru: `Ссылка на смену пароля отправлена`,
	sm: `Suia le sootaga o le uputatala na auina atu`,
	so: `Beddel erayga sirta ah link la diray`,
	th: `เปลี่ยนลิงก์รหัสผ่านที่ส่ง`,
	ur: `پاس ورڈ لنک تبدیل کریں`,
	vi: `Thay đổi liên kết mật khẩu đã gửi`,
	'zh-hans': `更改密码链接已发送`,
	'zh-hant': `更改密碼連結已發送`,
	en: `Change password link sent`
};

export const loc_changePWLinkSentMessage: Record<Locale, string> = {
	ar: `تم إرسال رابط لتغيير كلمة المرور إلى بريدك الإلكتروني. واصل عملية تغيير كلمة المرور باستخدام الرابط الذي استلمته.`,
	de: `Ein Link zur Änderung Ihres Passworts wurde an Ihre E-Mail-Adresse gesendet. Setzen Sie den Passwortänderungsprozess über den erhaltenen Link fort.`,
	es: `Se ha enviado un enlace para cambiar tu contraseña a tu dirección de correo electrónico. Continúa el proceso de cambio de contraseña usando el enlace que has recibido.`,
	fa: `لینکی برای تغییر رمز عبور به آدرس ایمیل شما ارسال شده است. فرآیند تغییر رمز عبور را با استفاده از لینکی که دریافت کرده اید ادامه دهید.`,
	fil: `Isang link upang baguhin ang iyong password ay ipinadala sa iyong email address. Ipagpatuloy ang proseso ng pagbabago ng password gamit ang link na natanggap mo.`,
	fr: `Un lien pour changer votre mot de passe a été envoyé à votre adresse e-mail. Poursuivez le processus de changement de mot de passe en utilisant le lien que vous avez reçu.`,
	hi: `अपना पासवर्ड बदलने के लिए एक लिंक आपके ईमेल पते पर भेजा गया है। आपको प्राप्त लिंक का उपयोग करके पासवर्ड बदलें प्रक्रिया जारी रखें।`,
	ht: `Yon lyen pou chanje modpas ou te voye nan adrès imel ou. Kontinye pwosesis la chanje modpas lè l sèvi avèk lyen ou te resevwa a.`,
	it: `Un link per cambiare la password è stato inviato al tuo indirizzo email. Continua il processo di modifica password usando il link che hai ricevuto.`,
	ja: `パスワード変更のリンクがあなたのメールアドレスに送信されました。受け取ったリンクを使ってパスワード変更の手続きを続けてください。`,
	ko: `비밀번호 변경 링크가 이메일 주소로 전송되었습니다. 받은 링크를 사용해 비밀번호 변경 과정을 계속하세요.`,
	mww: `Ib qhov txuas los hloov koj lo lus zais tau xa mus rau koj tus email chaw nyob. Txuas ntxiv cov txheej txheem hloov lo lus zais siv qhov txuas uas koj tau txais.`,
	ps: `ستاسو د پاسورډ بدلولو لینک ستاسو ایمیل ته لیږل شوی دی. د پاسورډ بدلولو پروسه د هغه لینک په کارولو سره دوام ورکړئ چې ترلاسه مو کړی.`,
	pt: `Um link para alterar sua senha foi enviado para seu endereço de e-mail. Continue o processo de mudança de senha usando o link que você recebeu.`,
	'pt-pt': `Foi enviado um link para alterar a sua palavra-passe para o seu endereço de email. Continue o processo de alteração de palavra-passe usando o link que recebeu.`,
	ru: `Ссылка для смены пароля была отправлена на ваш адрес электронной почты. Продолжайте процесс смены пароля, используя полученную вами ссылку.`,
	sm: `Ua auina atu se sootaga e sui ai lau uputatala i lau tuatusi imeli. Faaauau pea le faagasologa o le suia o le uputatala e faaaoga ai le sootaga ua e mauaina.`,
	so: `Xiriir lagu beddelo erayga sirta ah ayaa loo diray cinwaankaaga email-ka. Sii wad habka beddelka erayga sirta ah adigoo adeegsanaya xiriirka aad heshay.`,
	th: `ลิงก์สําหรับเปลี่ยนรหัสผ่านของคุณถูกส่งไปยังที่อยู่อีเมลของคุณแล้ว ดําเนินการเปลี่ยนรหัสผ่านต่อไปโดยใช้ลิงก์ที่คุณได้รับ`,
	ur: `آپ کے پاس ورڈ تبدیل کرنے کا لنک آپ کے ای میل ایڈریس پر بھیج دیا گیا ہے۔ پاس ورڈ تبدیل کرنے کا عمل اس لنک کے ذریعے جاری رکھیں جو آپ کو موصول ہوا ہے۔`,
	vi: `Một liên kết để thay đổi mật khẩu của bạn đã được gửi đến địa chỉ email của bạn. Tiếp tục quá trình thay đổi mật khẩu bằng liên kết bạn đã nhận được.`,
	'zh-hans': `更改密码的链接已发送到您的邮箱地址。请继续使用您收到的链接更改密码。`,
	'zh-hant': `已發送到您的電子郵件地址，有更改密碼的連結。請繼續使用你收到的連結更改密碼。`,
	en: `A link to change your password has been sent to your email address. Continue the change password process using the link you've received.`
};

export const loc_chatPrompt1: Record<Locale, string> = {
	ar: `لخص هذا السجل`,
	de: `Fasse diesen Rekord zusammen`,
	es: `Resume este registro`,
	fa: `این رکورد را خلاصه کنید`,
	fil: `Ibuod ang talaang ito`,
	fr: `Résumez ce record`,
	hi: `इस रिकॉर्ड को संक्षेप में प्रस्तुत करें`,
	ht: `Rezime dosye sa a`,
	it: `Riassumi questo record`,
	ja: `この記録をまとめてみて`,
	ko: `이 기록을 요약해 주세요`,
	mww: `Sau cov ntaub ntawv no`,
	ps: `دا ریکارډ لنډیز کړئ`,
	pt: `Resuma este registro`,
	'pt-pt': `Resuma este registo`,
	ru: `Кратко изложите этот рекорд`,
	sm: `Otooto le faamaumauga lenei`,
	so: `Soo koob rikoodhkan`,
	th: `สรุประเบียนนี้`,
	ur: `اس ریکارڈ کا خلاصہ کریں`,
	vi: `Tóm tắt hồ sơ này`,
	'zh-hans': `总结一下这份记录`,
	'zh-hant': `總結這份紀錄`,
	en: `Summarize this record`
};

export const loc_chatPrompt2: Record<Locale, string> = {
	ar: `تحديد الخطوات التالية`,
	de: `Identifizieren Sie die nächsten Schritte`,
	es: `Identificar los siguientes pasos`,
	fa: `شناسایی گام های بعدی`,
	fil: `Tukuyin ang mga susunod na hakbang`,
	fr: `Identifier les prochaines étapes`,
	hi: `अगले चरणों की पहचान करें`,
	ht: `Idantifye pwochen etap yo`,
	it: `Individuare i prossimi passi`,
	ja: `次のステップを特定する`,
	ko: `다음 단계 파악`,
	mww: `Txheeb xyuas cov kauj ruam tom ntej`,
	ps: `راتلونکی ګامونه وپیژنئ`,
	pt: `Identifique os próximos passos`,
	'pt-pt': `Identificar os próximos passos`,
	ru: `Определите следующие шаги`,
	sm: `Faailoa laasaga e sosoo ai`,
	so: `Aqoonso tallaabooyinka xiga`,
	th: `ระบุขั้นตอนถัดไป`,
	ur: `اگلے اقدامات کی نشاندہی کریں`,
	vi: `Xác định các bước tiếp theo`,
	'zh-hans': `确定下一步行动`,
	'zh-hant': `找出下一步`,
	en: `Identify next steps`
};

export const loc_chatPrompt3: Record<Locale, string> = {
	ar: `ابحث عن علامات تحذير أو قضايا عاجلة`,
	de: `Finde Warnsignale oder dringende Probleme`,
	es: `Encuentra señales de alerta o problemas urgentes`,
	fa: `نشانه های هشداردهنده یا مسائل فوری را پیدا کنید`,
	fil: `Maghanap ng mga pulang bandila o mga kagyat na isyu`,
	fr: `Trouvez les signaux d’alerte ou les problèmes urgents`,
	hi: `लाल झंडे या अत्यावश्यक समस्याएं ढूंढें`,
	ht: `Jwenn drapo wouj oswa pwoblèm ijan`,
	it: `Individua segnali d'allarme o problemi urgenti`,
	ja: `赤信号や緊急の問題を見つけましょう`,
	ko: `경고 신호나 긴급한 문제를 찾아보세요`,
	mww: `Nrhiav chij liab lossis teeb meem ceev`,
	ps: `سور نښې یا عاجلې ستونزې پیدا کړئ`,
	pt: `Encontre sinais de alerta ou questões urgentes`,
	'pt-pt': `Encontre sinais de alerta ou problemas urgentes`,
	ru: `Найдите тревожные сигналы или срочные вопросы`,
	sm: `Saili fu'a mumu po'o fa'afitauli faanatinati`,
	so: `Hel calan cas ama arrimo degdeg ah`,
	th: `ค้นหาธงสีแดงหรือปัญหาเร่งด่วน`,
	ur: `خطرے کی جھنڈیاں یا فوری مسائل تلاش کریں`,
	vi: `Tìm cờ đỏ hoặc vấn đề khẩn cấp`,
	'zh-hans': `发现危险信号或紧急问题`,
	'zh-hant': `找出警訊或緊急問題`,
	en: `Find red flags or urgent issues`
};

export const loc_chatPrompt4: Record<Locale, string> = {
	ar: `قائمة بالتدخلات الرئيسية وتأثيراتها`,
	de: `Listen Sie wichtige Interventionen und deren Auswirkungen auf`,
	es: `Enumera las intervenciones clave y sus efectos`,
	fa: `فهرست مداخلات کلیدی و تأثیرات آن ها`,
	fil: `Ilista ang mga pangunahing interbensyon at ang kanilang mga epekto`,
	fr: `Énumérez les interventions clés et leurs effets`,
	hi: `प्रमुख हस्तक्षेपों और उनके प्रभावों की सूची बनाएं`,
	ht: `Lis entèvansyon kle yo ak efè yo`,
	it: `Elencare gli interventi chiave e i loro effetti`,
	ja: `主要な介入策とその効果をリスト`,
	ko: `주요 개입과 그 효과 목록`,
	mww: `Sau cov kev cuam tshuam tseem ceeb thiab lawv cov teebmeem`,
	ps: `مهمې مداخلې او د هغوی اغېزې لیست کړئ`,
	pt: `Liste as principais intervenções e seus efeitos`,
	'pt-pt': `Liste as principais intervenções e os seus efeitos`,
	ru: `Список ключевых вмешательств и их эффектов`,
	sm: `Lisi o fa'alavelave fa'afuase'i ma o latou a'afiaga`,
	so: `Liiska faragelinta muhiimka ah iyo saameyntooda`,
	th: `แสดงรายการการแทรกแซงที่สําคัญและผลกระทบ`,
	ur: `اہم مداخلتوں اور ان کے اثرات کی فہرست دیں`,
	vi: `Liệt kê các can thiệp chính và tác dụng của chúng`,
	'zh-hans': `列出关键干预措施及其效果`,
	'zh-hant': `列出主要介入措施及其影響`,
	en: `List key interventions and their effects`
};

export const loc_chatPrompt5: Record<Locale, string> = {
	ar: `تحليل استخدام الموارد`,
	de: `Analyse der Ressourcennutzung`,
	es: `Analizar la utilización de recursos`,
	fa: `تحلیل استفاده از منابع`,
	fil: `Suriin ang paggamit ng mapagkukunan`,
	fr: `Analyser l’utilisation des ressources`,
	hi: `संसाधन उपयोग का विश्लेषण करें`,
	ht: `Analize itilizasyon resous yo`,
	it: `Analizza l'utilizzo delle risorse`,
	ja: `資源利用の分析`,
	ko: `자원 활용 분석`,
	mww: `Txheeb xyuas kev siv cov peev txheej`,
	ps: `د سرچینو کارونه تحلیل کړئ`,
	pt: `Analisar a utilização de recursos`,
	'pt-pt': `Analisar a utilização de recursos`,
	ru: `Анализ использования ресурсов`,
	sm: `Iloilo le faaaogaina o punaoa`,
	so: `Falanqeeyo isticmaalka kheyraadka`,
	th: `วิเคราะห์การใช้ทรัพยากร`,
	ur: `وسائل کے استعمال کا تجزیہ کریں`,
	vi: `Phân tích việc sử dụng tài nguyên`,
	'zh-hans': `分析资源利用情况`,
	'zh-hant': `分析資源利用率`,
	en: `Analyze resource utilization`
};

export const loc_chatPrompt6: Record<Locale, string> = {
	ar: `ابحث عن ثغرات أو معلومات مفقودة`,
	de: `Finde Lücken oder fehlende Informationen`,
	es: `Encuentra lagunas o información que falta`,
	fa: `خلأها یا اطلاعات گمشده را پیدا کنید`,
	fil: `Maghanap ng mga puwang o nawawalang impormasyon`,
	fr: `Trouver des lacunes ou des informations manquantes`,
	hi: `अंतराल या अनुपलब्ध जानकारी ढूंढें`,
	ht: `Jwenn twou vid oswa enfòmasyon ki manke`,
	it: `Individua lacune o informazioni mancanti`,
	ja: `情報の抜けや欠落を見つけてください`,
	ko: `빈틈이나 누락된 정보를 찾아보세요`,
	mww: `Nrhiav qhov khoob lossis cov ntaub ntawv uas ploj lawm`,
	ps: `تشې یا ورک معلومات پیدا کړئ`,
	pt: `Encontre lacunas ou informações faltantes`,
	'pt-pt': `Encontre lacunas ou informações em falta`,
	ru: `Найдите пробелы или недостающую информацию`,
	sm: `Saili avanoa po o faamatalaga o loo misi`,
	so: `Hel meelaha bannaan ama macluumaad maqan`,
	th: `ค้นหาช่องว่างหรือข้อมูลที่ขาดหายไป`,
	ur: `خالی جگہیں یا معلومات تلاش کریں`,
	vi: `Tìm khoảng trống hoặc thông tin bị thiếu`,
	'zh-hans': `查找缺口或缺失信息`,
	'zh-hant': `尋找空白或缺失資訊`,
	en: `Find gaps or missing information`
};

export const loc_chatPrompt7: Record<Locale, string> = {
	ar: `تحقق من المشاعر/الرضا`,
	de: `Prüfen Sie Stimmung/Zufriedenheit`,
	es: `Comprueba el sentimiento/satisfacción`,
	fa: `احساسات و رضایت را بررسی کنید`,
	fil: `Suriin ang damdamin/kasiyahan`,
	fr: `Vérifiez le sentiment/la satisfaction`,
	hi: `भावना/संतुष्टि की जाँच करें`,
	ht: `Tcheke santiman / satisfaksyon`,
	it: `Controlla sentimento/soddisfazione`,
	ja: `感情や満足度を確認してください`,
	ko: `감정/만족도를 확인하세요`,
	mww: `Xyuas kev xav / kev txaus siab`,
	ps: `احساسات/رضایت وګوره`,
	pt: `Verifique sentimento/satisfação`,
	'pt-pt': `Verifica sentimento/satisfação`,
	ru: `Проверьте настроение/удовлетворенность`,
	sm: `Siaki lagona / faamalieina`,
	so: `Hubi dareenka/qanacsanaanta`,
	th: `ตรวจสอบความคิดเห็น/ความพึงพอใจ`,
	ur: `جذبات/اطمینان چیک کریں`,
	vi: `Kiểm tra cảm xúc/sự hài lòng`,
	'zh-hans': `检查情感/满意度`,
	'zh-hant': `檢查情緒/滿意度`,
	en: `Check sentiment/satisfaction`
};

export const loc_chatPrompt8: Record<Locale, string> = {
	ar: `قيم تقدم العميل`,
	de: `Bewerten Sie den Fortschritt des Kunden`,
	es: `Evalúa el progreso del cliente`,
	fa: `پیشرفت مشتری را ارزیابی کنید`,
	fil: `Suriin ang pag-unlad ng kliyente`,
	fr: `Évaluer les progrès du client`,
	hi: `ग्राहक की प्रगति का मूल्यांकन करें`,
	ht: `Evalye pwogrè kliyan an`,
	it: `Valuta i progressi del cliente`,
	ja: `クライアントの進捗を評価する`,
	ko: `내담자의 진행 상황을 평가하세요`,
	mww: `Txheeb xyuas tus neeg tau txais kev pab`,
	ps: `د مراجع پرمختګ ارزونه`,
	pt: `Avalie o progresso do cliente`,
	'pt-pt': `Avalie o progresso do cliente`,
	ru: `Оцените прогресс клиента`,
	sm: `Iloilo le alualu i luma o le tagata fa'atau`,
	so: `Qiimee horumarka macmiilka`,
	th: `ประเมินความคืบหน้าของลูกค้า`,
	ur: `کلائنٹ کی پیش رفت کا جائزہ لیں`,
	vi: `Đánh giá sự tiến bộ của khách hàng`,
	'zh-hans': `评估客户的进展情况`,
	'zh-hant': `評估客戶的進展`,
	en: `Evaluate the client's progress`
};

export const loc_chatPrompt9: Record<Locale, string> = {
	ar: `تسليط الضوء على قصص النجاح`,
	de: `Erfolgsgeschichten hervorheben`,
	es: `Destaca historias de éxito`,
	fa: `داستان های موفقیت را برجسته کنید`,
	fil: `I-highlight ang mga kwento ng tagumpay`,
	fr: `Mettez en avant les histoires de réussite`,
	hi: `सफलता की कहानियों को हाइलाइट करें`,
	ht: `Mete aksan sou istwa siksè`,
	it: `Metti in evidenza le storie di successo`,
	ja: `成功事例を紹介します`,
	ko: `성공 사례 하이라이트`,
	mww: `Qhia txog cov dab neeg ua tiav`,
	ps: `د بریا کیسې روښانه کړئ`,
	pt: `Destaque histórias de sucesso`,
	'pt-pt': `Destaque histórias de sucesso`,
	ru: `Выделяйте истории успеха`,
	sm: `Fa'ailoa tala manuia`,
	so: `Sheekooyinka guusha ee muhiimka ah`,
	th: `เน้นเรื่องราวความสําเร็จ`,
	ur: `کامیابی کی کہانیاں نمایاں کریں`,
	vi: `Làm nổi bật những câu chuyện thành công`,
	'zh-hans': `突出成功案例`,
	'zh-hant': `重點介紹成功案例`,
	en: `Highlight success stories`
};

export const loc_checkAllThatApply: Record<Locale, string> = {
	ar: `تحقق من كل ما ينطبق`,
	de: `Überprüfen Sie alles, was gelten`,
	es: `Comprueba todo lo que se aplica`,
	fa: `همه این موارد را بررسی کنید`,
	fil: `Suriin ang lahat ng naaangkop`,
	fr: `Vérifiez tout ce qui s’applique`,
	hi: `लागू होने वाले सभी की जाँच करें`,
	ht: `Tcheke tout sa ki aplike`,
	it: `Controlla tutto ciò che si applica`,
	ja: `すべての適用情報を確認してください`,
	ko: `모든 지원사항을 확인해 보세요`,
	mww: `Xyuas txhua yam uas siv tau`,
	ps: `ټول هغه څه وګوره چې تطبیق کیږی`,
	pt: `Verifique tudo que se aplica`,
	'pt-pt': `Verifique tudo o que se aplica`,
	ru: `Проверьте всё, что применимо`,
	sm: `Siaki mea uma e faatatau i ai`,
	so: `Hubi dhammaan kuwa khuseeya`,
	th: `ตรวจสอบทั้งหมดที่เกี่ยวข้อง`,
	ur: `ان سب چیزوں کو چیک کریں جو لاگو ہوتے ہیں`,
	vi: `Kiểm tra tất cả những gì áp dụng`,
	'zh-hans': `查看所有相关内容`,
	'zh-hant': `請檢查所有適用資訊`,
	en: `Check all that apply`
};

export const loc_checkEmailForNextSteps: Record<Locale, string> = {
	ar: `تحقق من بريدك الإلكتروني للخطوات التالية.`,
	de: `Überprüfen Sie Ihre E-Mail für die nächsten Schritte.`,
	es: `Consulta tu correo electrónico para ver los siguientes pasos.`,
	fa: `ایمیل خود را برای گام های بعدی بررسی کنید.`,
	fil: `Suriin ang iyong email para sa mga susunod na hakbang.`,
	fr: `Consultez vos e-mails pour connaître les prochaines étapes.`,
	hi: `अगले चरणों के लिए अपना ईमेल जांचें।`,
	ht: `Tcheke imèl ou pou pwochen etap yo.`,
	it: `Controlla la tua email per i prossimi passi.`,
	ja: `次のステップはメールで確認してください。`,
	ko: `다음 단계는 이메일을 확인하세요.`,
	mww: `Tshawb xyuas koj tus email rau cov kauj ruam tom ntej.`,
	ps: `د راتلونکی ګامونو لپاره خپل ایمیل وګوره.`,
	pt: `Confira seu e-mail para os próximos passos.`,
	'pt-pt': `Verifique o seu email para os próximos passos.`,
	ru: `Проверьте свою почту для дальнейших шагов.`,
	sm: `Siaki lau imeli mo laasaga e sosoo ai.`,
	so: `Hubi email-kaaga si aad u aragto tallaabooyinka xiga.`,
	th: `ตรวจสอบอีเมลของคุณสําหรับขั้นตอนต่อไป`,
	ur: `اگلے اقدامات کے لیے اپنا ای میل چیک کریں۔`,
	vi: `Kiểm tra email của bạn để biết các bước tiếp theo.`,
	'zh-hans': `请查看您的邮箱，了解下一步。`,
	'zh-hant': `請查看您的電子郵件以了解下一步。`,
	en: `Check your email for next steps.`
};

export const loc_checkSpamForAccountsEmail: Record<Locale, (email: unknown) => TemplateResult> = {
	ar: (email) => html`لم تستلم بريدا إلكترونيا؟ ابحث عن <strong>${email}</strong> في رسائل البريد المزعج.`,
	de: (email) => html`Keine E-Mail erhalten? Suche in deinem Spam nach <strong>${email}</strong> .`,
	es: (email) => html`¿No recibiste ningún correo? Busca <strong>${email}</strong> en tu spam.`,
	fa: (email) => html`ایمیلی دریافت نکردی؟ در اسپم خود <strong>${email}</strong> را جستجو کنید.`,
	fil: (email) => html`Hindi ka ba nakatanggap ng email? Hanapin ang <strong>${email}</strong> sa iyong spam.`,
	fr: (email) => html`Vous n’avez pas reçu d’e-mail ? Cherchez <strong>${email}</strong> dans votre spam.`,
	hi: (email) => html`कोई ईमेल प्राप्त नहीं हुआ? अपने स्पैम में <strong>${email}</strong> खोजें।`,
	ht: (email) => html`Pa t 'resevwa yon imèl? Rechèch <strong>${email}</strong> nan Spam ou`,
	it: (email) => html`Non hai ricevuto un'email? Cerca <strong>${email}</strong> nel tuo spam.`,
	ja: (email) => html`メールが届かなかったのですか?迷路メールで「 <strong>${email}</strong> 」を検索してください。`,
	ko: (email) => html`이메일을 못 받았나요? 스팸에서 <strong>${email}</strong> 를 검색해 보세요.`,
	mww: (email) => html`Tsis tau txais email? Tshawb rau <strong>${email}</strong> hauv koj spam.`,
	ps: (email) => html`ایمیل دې نه دی ترلاسه کړی؟ په خپل سپیم کې <strong>${email}</strong> لټون وکړئ.`,
	pt: (email) => html`Não recebeu nenhum e-mail? Procure <strong>${email}</strong> no seu spam.`,
	'pt-pt': (email) => html`Não recebeste email? Procure <strong>${email}</strong> no seu spam.`,
	ru: (email) => html`Не получили письмо? Ищите <strong>${email}</strong> в спам.`,
	sm: (email) => html`E te le'i mauaina se imeli? Saili mo <strong>${email}</strong> i lau spam.`,
	so: (email) => html`Ma helin email? Ka raadi <strong>${email}</strong> spam-kaaga.`,
	th: (email) => html`ไม่ได้รับอีเมลใช่ไหม ค้นหา <strong>${email}</strong> ในสแปมของคุณ`,
	ur: (email) => html`کیا آپ کو ای میل موصول نہیں ہوئی؟ اپنے اسپیم میں <strong>${email}</strong> تلاش کریں۔`,
	vi: (email) => html`Bạn không nhận được email? Tìm kiếm <strong>${email}</strong> trong thư rác của bạn.`,
	'zh-hans': (email) => html`没收到邮件？在垃圾邮件中搜索“ <strong>${email}</strong> ”。`,
	'zh-hant': (email) => html`沒收到電子郵件嗎？在垃圾郵件中搜尋 <strong>${email}</strong> 。`,
	en: (email) => html`Didn't receive an email? Search for <strong>${email}</strong> in your spam.`
};

export const loc_chooseActivity: Record<Locale, string> = {
	ar: `اختر النشاط`,
	de: `Wähle eine Aktivität`,
	es: `Elige la actividad`,
	fa: `فعالیت را انتخاب کنید`,
	fil: `Pumili ng aktibidad`,
	fr: `Choisir l’activité`,
	hi: `गतिविधि चुनें`,
	ht: `Chwazi aktivite`,
	it: `Scegli l'attività`,
	ja: `アクティビティを選びましょう`,
	ko: `활동을 선택하세요`,
	mww: `Xaiv kev ua si`,
	ps: `فعالیت انتخاب کړئ`,
	pt: `Escolha atividade`,
	'pt-pt': `Escolha atividade`,
	ru: `Выберите занятие`,
	sm: `Filifili gaoioiga`,
	so: `Dooro hawlaha`,
	th: `เลือกกิจกรรม`,
	ur: `سرگرمی منتخب کریں`,
	vi: `Chọn hoạt động`,
	'zh-hans': `选择活动`,
	'zh-hant': `選擇活動`,
	en: `Choose activity`
};

export const loc_chooseActivityType: Record<Locale, string> = {
	ar: `اختر نوع النشاط`,
	de: `Wählen Sie den Aktivitätstyp`,
	es: `Elige el tipo de actividad`,
	fa: `نوع فعالیت را انتخاب کنید`,
	fil: `Pumili ng uri ng aktibidad`,
	fr: `Choisir le type d’activité`,
	hi: `गतिविधि प्रकार चुनें`,
	ht: `Chwazi kalite aktivite`,
	it: `Scegli il tipo di attività`,
	ja: `アクティビティタイプを選ぶ`,
	ko: `활동 유형 선택`,
	mww: `Xaiv hom kev ua si`,
	ps: `د فعالیت ډول انتخاب کړئ`,
	pt: `Escolha o tipo de atividade`,
	'pt-pt': `Escolha o tipo de atividade`,
	ru: `Выберите тип деятельности`,
	sm: `Filifili le ituaiga o gaoioiga`,
	so: `Dooro nooca hawlgalka`,
	th: `เลือกประเภทกิจกรรม`,
	ur: `سرگرمی کی قسم منتخب کریں`,
	vi: `Chọn loại hoạt động`,
	'zh-hans': `选择活动类型`,
	'zh-hant': `選擇活動類型`,
	en: `Choose activity type`
};

export const loc_chooseAssignee: Record<Locale, string> = {
	ar: `اختر الموظف`,
	de: `Wähle den Zugewiesenen`,
	es: `Elegir asignado`,
	fa: `انتخاب مأمور`,
	fil: `Piliin ang tagapag-atas`,
	fr: `Choisir le destinataire`,
	hi: `असाइनी चुनें`,
	ht: `Chwazi asiyen`,
	it: `Scegli l'assegnato`,
	ja: `割り当て者を選ぶ`,
	ko: `할당자 선택`,
	mww: `Xaiv tus neeg ua hauj lwm`,
	ps: `ټاکل شوی انتخاب کړئ`,
	pt: `Escolha o designado`,
	'pt-pt': `Escolher o cedente`,
	ru: `Выберите правообладателя`,
	sm: `Filifili le tagata ua tofia`,
	so: `Dooro qofka la siiyay`,
	th: `เลือกผู้รับมอบหมาย`,
	ur: `assignee کا انتخاب کریں`,
	vi: `Chọn người được giao`,
	'zh-hans': `选择受让人`,
	'zh-hant': `選擇受讓人`,
	en: `Choose assignee`
};

export const loc_chooseAttachments: Record<Locale, string> = {
	ar: `اختر الملحقات`,
	de: `Wähle Anhänge`,
	es: `Elegir accesorios`,
	fa: `انتخاب ضمیمه ها`,
	fil: `Pumili ng mga attachment`,
	fr: `Choisir des pièces jointes`,
	hi: `अनुलग्नक चुनें`,
	ht: `Chwazi atachman`,
	it: `Scegli gli allegati`,
	ja: `添付ファイルを選ぶ`,
	ko: `첨부 자료 선택`,
	mww: `Xaiv cov ntawv txuas`,
	ps: `ضمیمې انتخاب کړئ`,
	pt: `Escolha anexos`,
	'pt-pt': `Escolha anexos`,
	ru: `Выбирайте прикрепления`,
	sm: `Filifili mea fa'apipi'i`,
	so: `Dooro lifaaqyo`,
	th: `เลือกไฟล์แนบ`,
	ur: `اٹیچمنٹس کا انتخاب کریں`,
	vi: `Chọn tệp đính kèm`,
	'zh-hans': `选择附件`,
	'zh-hant': `選擇附件`,
	en: `Choose attachments`
};

export const loc_chooseCreator: Record<Locale, string> = {
	ar: `اختر المبدع`,
	de: `Wähle den Ersteller`,
	es: `Elige creador`,
	fa: `خالق را انتخاب کنید`,
	fil: `Piliin ang tagalikha`,
	fr: `Choisir le créateur`,
	hi: `क्रिएटर चुनें`,
	ht: `Chwazi kreyatè`,
	it: `Scegli creatore`,
	ja: `クリエイターを選ぶ`,
	ko: `창작자를 선택하세요`,
	mww: `Xaiv tus tsim`,
	ps: `خالق انتخاب کړئ`,
	pt: `Escolha criador`,
	'pt-pt': `Escolher criador`,
	ru: `Выберите создателя`,
	sm: `Filifili le foafoa`,
	so: `Dooro abuuraha`,
	th: `เลือกครีเอเตอร์`,
	ur: `خالق منتخب کریں`,
	vi: `Chọn người sáng tạo`,
	'zh-hans': `选择创作者`,
	'zh-hant': `選擇創作者`,
	en: `Choose creator`
};

export const loc_chooseHowToSend: Record<Locale, string> = {
	ar: `اختر أين ترسل`,
	de: `Wähle, wohin du schicken möchtest`,
	es: `Elige dónde enviar`,
	fa: `محل ارسال را انتخاب کنید`,
	fil: `Piliin kung saan ipapadala`,
	fr: `Choisissez où envoyer`,
	hi: `चुनें कि कहां भेजना है`,
	ht: `Chwazi ki kote yo voye`,
	it: `Scegli dove inviare`,
	ja: `送る場所を選べます`,
	ko: `어디로 보내야 할지 선택하세요`,
	mww: `Xaiv qhov twg xa`,
	ps: `انتخاب کړئ چې چیرته واستول شئ`,
	pt: `Escolha para onde enviar`,
	'pt-pt': `Escolha para onde enviar`,
	ru: `Выбирайте, куда отправлять`,
	sm: `Filifili le mea e auina atu ai`,
	so: `Dooro meesha aad dirto`,
	th: `เลือกสถานที่ที่จะส่ง`,
	ur: `منتخب کریں کہ کہاں بھیجنا ہے`,
	vi: `Chọn nơi gửi`,
	'zh-hans': `选择发送地址`,
	'zh-hant': `選擇寄往哪裡`,
	en: `Choose where to send`
};

export const loc_chooseMentionedUser: Record<Locale, string> = {
	ar: `اختر المستخدم المذكور`,
	de: `Wählen Sie den genannten Nutzer aus`,
	es: `Elige el usuario mencionado`,
	fa: `کاربر مذکور را انتخاب کنید`,
	fil: `Piliin ang nabanggit na tagagamit`,
	fr: `Choisissez l’utilisateur mentionné`,
	hi: `उल्लिखित उपयोगकर्ता चुनें`,
	ht: `Chwazi mansyone itilizatè`,
	it: `Scegli l'utente menzionato`,
	ja: `言及されたユーザーを選択してください`,
	ko: `언급된 사용자를 선택하세요`,
	mww: `Xaiv hais tus neeg siv`,
	ps: `یاد شوی کاروونکی وټاکئ`,
	pt: `Escolha o usuário mencionado`,
	'pt-pt': `Escolha o utilizador mencionado`,
	ru: `Выберите упомянутого пользователя`,
	sm: `Filifili tagata faaaoga ua ta'ua`,
	so: `Dooro isticmaalaha la xusay`,
	th: `เลือกผู้ใช้ที่กล่าวถึง`,
	ur: `مذکورہ صارف منتخب کریں`,
	vi: `Chọn người dùng được đề cập`,
	'zh-hans': `选择被提及的用户`,
	'zh-hant': `選擇被提及的使用者`,
	en: `Choose mentioned user`
};

export const loc_chooseProject: Record<Locale, string> = {
	ar: `اختر المشروع`,
	de: `Projekt auswählen`,
	es: `Elige proyecto`,
	fa: `انتخاب پروژه`,
	fil: `Piliin ang proyekto`,
	fr: `Choisir le projet`,
	hi: `प्रोजेक्ट चुनें`,
	ht: `Chwazi pwojè`,
	it: `Scegli il progetto`,
	ja: `プロジェクトを選んでください`,
	ko: `프로젝트를 선택하세요`,
	mww: `Xaiv qhov project`,
	ps: `انتخاب پروژه`,
	pt: `Escolha projeto`,
	'pt-pt': `Escolher projeto`,
	ru: `Выберите проект`,
	sm: `Filifili le galuega faatino`,
	so: `Mashruuca Choose`,
	th: `เลือกโครงการ`,
	ur: `پروجیکٹ منتخب کریں`,
	vi: `Chọn dự án`,
	'zh-hans': `选择项目`,
	'zh-hant': `選擇專案`,
	en: `Choose project`
};

export const loc_chooseReportType: Record<Locale, string> = {
	ar: `اختر نوع التقرير`,
	de: `Wählen Sie Berichtstyp`,
	es: `Elegir tipo de informe`,
	fa: `نوع گزارش را انتخاب کنید`,
	fil: `Pumili ng uri ng ulat`,
	fr: `Choisir le type de rapport`,
	hi: `रिपोर्ट का प्रकार चुनें`,
	ht: `Chwazi kalite rapò`,
	it: `Scegli il tipo di rapporto`,
	ja: `レポートの種類を選択する`,
	ko: `보고서 유형 선택`,
	mww: `Xaiv hom ntawv ceeb toom`,
	ps: `د راپور ډول انتخاب کړئ`,
	pt: `Escolha o tipo de relatório`,
	'pt-pt': `Escolher o tipo de relatório`,
	ru: `Выберите тип отчета`,
	sm: `Filifili le ituaiga lipoti`,
	so: `Dooro nooca warbixinta`,
	th: `เลือกประเภทรายงาน`,
	ur: `رپورٹ کی قسم منتخب کریں`,
	vi: `Chọn loại báo cáo`,
	'zh-hans': `选择报告类型`,
	'zh-hant': `選擇報告類型`,
	en: `Choose report type`
};

export const loc_chooseSort: Record<Locale, string> = {
	ar: `اختر الفرز`,
	de: `Wählen Sie Sortierung`,
	es: `Elegir ordenar`,
	fa: `انتخاب مرتب سازی`,
	fil: `Piliin ang pag-uuri`,
	fr: `Choisir le tri`,
	hi: `सॉर्ट चुनें`,
	ht: `Chwazi sòt`,
	it: `Scegli l'ordinamento`,
	ja: `ソートを選択`,
	ko: `정렬 선택`,
	mww: `Xaiv hom`,
	ps: `انتخاب ترتیب`,
	pt: `Escolha ordenação`,
	'pt-pt': `Escolha ordenação`,
	ru: `Выберите сортировка`,
	sm: `Filifili le fa'avasegaina`,
	so: `Xulo kala soocidda`,
	th: `เลือกเรียงลําดับ`,
	ur: `ترتیب کا انتخاب کریں`,
	vi: `Chọn sắp xếp`,
	'zh-hans': `选择排序`,
	'zh-hant': `選擇排序`,
	en: `Choose sort`
};

export const loc_chooseStatus: Record<Locale, string> = {
	ar: `اختيار الحالة`,
	de: `Status wählen`,
	es: `Elegir estado`,
	fa: `وضعیت انتخاب`,
	fil: `Piliin ang katayuan`,
	fr: `Choisir le statut`,
	hi: `स्थिति चुनें`,
	ht: `Chwazi estati`,
	it: `Scegli lo stato`,
	ja: `ステータスを選ぶ`,
	ko: `신분 선택`,
	mww: `Xaiv cov xwm txheej`,
	ps: `انتخاب حالت`,
	pt: `Escolher status`,
	'pt-pt': `Escolher o estado`,
	ru: `Выберите статус`,
	sm: `Filifili le tulaga`,
	so: `Xulo xaaladda`,
	th: `เลือกสถานะ`,
	ur: `حیثیت منتخب کریں`,
	vi: `Chọn trạng thái`,
	'zh-hans': `选择地位`,
	'zh-hant': `選擇地位`,
	en: `Choose status`
};

export const loc_chooseTheme: Record<Locale, string> = {
	ar: `اختر موضوعا`,
	de: `Wähle ein Thema`,
	es: `Elige un tema`,
	fa: `یک تم انتخاب کنید`,
	fil: `Pumili ng Tema`,
	fr: `Choisissez un thème`,
	hi: `एक थीम चुनें`,
	ht: `Chwazi yon tèm`,
	it: `Scegli un tema`,
	ja: `テーマを選びましょう`,
	ko: `주제를 선택하세요`,
	mww: `Xaiv ib lub ntsiab lus`,
	ps: `یو موضوع انتخاب کړئ`,
	pt: `Escolha um tema`,
	'pt-pt': `Escolha um tema`,
	ru: `Выберите тему`,
	sm: `Filifili se autu`,
	so: `Dooro mowduuc`,
	th: `เลือกธีม`,
	ur: `تھیم منتخب کریں`,
	vi: `Chọn chủ đề`,
	'zh-hans': `选择一个主题`,
	'zh-hant': `選擇一個主題`,
	en: `Choose a theme`
};

export const loc_chooseTimesheetInstruction: Record<Locale, string> = {
	ar: `اختر جدول زمني لإنشائه أو فتحه. الجداول الزمنية التي سبقت فترة الدفع السابقة غير متاحة للإنشاء هنا.`,
	de: `Wähle einen Stundenzettel zum Erstellen oder Öffnen aus. Stundenzettel von vor dem vorherigen Abrechnungszeitraum können hier nicht erstellt werden.`,
	es: `Elige una hoja de horas para crear o abrir. No está disponible para crear hojas de horas anteriores al periodo de pago anterior.`,
	fa: `یک تایم شیت برای ایجاد یا باز کردن انتخاب کنید. برگه های زمانی قبل از دوره پرداخت قبلی در اینجا قابل تهیه نیستند.`,
	fil: `Pumili ng isang timesheet upang lumikha o buksan. Ang mga timesheet mula bago ang nakaraang panahon ng pagbabayad ay hindi magagamit upang lumikha dito.`,
	fr: `Choisissez une feuille de temps à créer ou à ouvrir. Les feuilles de temps d’avant la période de paie précédente ne sont pas disponibles à la création ici.`,
	hi: `बनाने या खोलने के लिए कोई टाइमशीट चुनें. पिछली वेतन अवधि से पहले की टाइमशीट यहां बनाने के लिए उपलब्ध नहीं हैं।`,
	ht: `Chwazi yon Timesheet yo kreye oswa louvri. Timesheets soti nan anvan peryòd peman anvan yo pa disponib pou kreye isit la.`,
	it: `Scegli un foglio orario da creare o da aprire. I fogli di pagamento precedenti al periodo di paga precedente non sono disponibili da creare qui.`,
	ja: `タイムシートを作成または開封するものを選びましょう。前回の給与期間以前のタイムシートはここで作成できません。`,
	ko: `타임시트를 선택해 만들거나 열어보세요. 이전 급여 기간 이전의 근무 시간표는 여기서 작성할 수 없습니다.`,
	mww: `Xaiv ib daim ntawv teev sij hawm los tsim los yog qhib. Cov ntawv teev sijhawm los ntawm ua ntej lub sijhawm them nyiaj yav dhau los tsis muaj los tsim ntawm no.`,
	ps: `د وخت پاڼه د جوړولو یا پرانستلو لپاره انتخاب کړئ. د تېرې معاش موده مخکې وختپاڼې دلته د جوړولو لپاره نشته.`,
	pt: `Escolha uma folha de ponto para criar ou abrir. Folhas de ponto anteriores ao período anterior não estão disponíveis para criação aqui.`,
	'pt-pt': `Escolha uma folha de horas para criar ou abrir. Folhas de ponto anteriores ao período de pagamento anterior não estão disponíveis para criar aqui.`,
	ru: `Выберите табель для создания или открытия. Табели времени работы до предыдущего платежного периода здесь недоступны для составления.`,
	sm: `Filifili se fa'ata'ita'iga e fa'apipi'i pe tatalaina. E le o maua iinei ia pepa o taimi a o lei oo i le vaitau o totogi ua mavae.`,
	so: `Dooro xaashiyaha waqtiga si aad u abuurto ama u furto. Waqtiyada ka hor muddadii mushaharka hore laguma heli karo halkan.`,
	th: `เลือกไทม์ชีทเพื่อสร้างหรือเปิด แผ่นเวลาก่อนรอบระยะเวลาการจ่ายเงินก่อนหน้านี้ไม่สามารถสร้างได้ที่นี่`,
	ur: `ایک ٹائم شیٹ منتخب کریں اور بنائیں یا کھولیں۔ پچھلی ادائیگی کی مدت سے پہلے کی ٹائم شیٹس یہاں تیار کرنے کے لیے دستیاب نہیں ہیں۔`,
	vi: `Chọn bảng chấm công để tạo hoặc mở. Bảng chấm công từ trước kỳ thanh toán trước đó không có sẵn để tạo tại đây.`,
	'zh-hans': `选择一份工时表来创建或打开。上一个工资期之前的工时表无法在此创建。`,
	'zh-hant': `選擇一份工時表來製作或打開。上一薪資期之前的工時表無法在此建立。`,
	en: `Choose a timesheet to create or open. Timesheets from before the previous pay period are not available to create here.`
};

export const loc_chooseType: Record<Locale, string> = {
	ar: `اختر النوع`,
	de: `Wählen Sie den Typ`,
	es: `Elegir tipo`,
	fa: `نوع را انتخاب کنید`,
	fil: `Piliin ang uri`,
	fr: `Choisir le type`,
	hi: `प्रकार चुनें`,
	ht: `Chwazi kalite`,
	it: `Scegli il tipo`,
	ja: `タイプを選択`,
	ko: `유형을 선택하세요`,
	mww: `Xaiv hom`,
	ps: `ډول انتخاب کړئ`,
	pt: `Escolha o tipo`,
	'pt-pt': `Escolha o tipo`,
	ru: `Выберите тип`,
	sm: `Filifili le ituaiga`,
	so: `Xulo nooca`,
	th: `เลือกประเภท`,
	ur: `قسم منتخب کریں`,
	vi: `Chọn loại`,
	'zh-hans': `选择类型`,
	'zh-hant': `選擇類型`,
	en: `Choose type`
};

export const loc_city: Record<Locale, string> = {
	ar: `المدينة`,
	de: `Stadt`,
	es: `Ciudad`,
	fa: `شهر`,
	fil: `Lungsod`,
	fr: `Ville`,
	hi: `शहर`,
	ht: `Vil la`,
	it: `Città`,
	ja: `都市`,
	ko: `도시`,
	mww: `Lub nroog`,
	ps: `ښار`,
	pt: `Cidade`,
	'pt-pt': `Cidade`,
	ru: `Город`,
	sm: `Aai`,
	so: `Magaalo`,
	th: `เมือง`,
	ur: `شہر`,
	vi: `Thành phố`,
	'zh-hans': `城市`,
	'zh-hant': `城市`,
	en: `City`
};

export const loc_claimBatches: Record<Locale, string> = {
	ar: `دفعات المطالبة`,
	de: `Claim-Chargen`,
	es: `Lotes de reclamaciones`,
	fa: `دسته های ادعایی`,
	fil: `Mga batch ng pag-angkin`,
	fr: `Groupes de revendications`,
	hi: `दावा बैच`,
	ht: `Reklamasyon pakèt`,
	it: `Lotti di richiesta`,
	ja: `クレームバッチ`,
	ko: `클레임 배치`,
	mww: `Thov pawg`,
	ps: `د ادعا ډلې`,
	pt: `Lotes de reivindicação`,
	'pt-pt': `Lotes de reivindicação`,
	ru: `Партии заявок`,
	sm: `Talosaga faaputuga`,
	so: `Qaybaha sheegashada`,
	th: `รับแบทช์`,
	ur: `کلیم بیچز`,
	vi: `Yêu cầu lô hàng`,
	'zh-hans': `索赔批次`,
	'zh-hant': `索賠批次`,
	en: `Claim batches`
};

export const loc_clear: Record<Locale, string> = {
	ar: `واضح`,
	de: `Frei`,
	es: `¡Libre`,
	fa: `پاک است`,
	fil: `I-clear`,
	fr: `Clair`,
	hi: `साफ़ करें`,
	ht: `Klè`,
	it: `Libero`,
	ja: `クリア`,
	ko: `비켜`,
	mww: `ntshiab`,
	ps: `پاکه`,
	pt: `Limpo`,
	'pt-pt': `Limpo`,
	ru: `Чисто`,
	sm: `Manino`,
	so: `Nadiif`,
	th: `ล้างค่าการค้นหา`,
	ur: `صاف`,
	vi: `Xóa`,
	'zh-hans': `清场`,
	'zh-hant': `清場`,
	en: `Clear`
};

export const loc_clearAll: Record<Locale, string> = {
	ar: `نظف كل شيء`,
	de: `Alles wegräumen`,
	es: `Limpiar todo`,
	fa: `همه رو پاک کن`,
	fil: `I-clear ang lahat`,
	fr: `Écartez tout`,
	hi: `सभी साफ़ करें`,
	ht: `Klè tout`,
	it: `Cancella tutto`,
	ja: `すべてクリア`,
	ko: `모두 정리`,
	mww: `Tshem tag nrho`,
	ps: `ټول پاک کړه`,
	pt: `Limpar tudo`,
	'pt-pt': `Limpar tudo`,
	ru: `Очистить всё`,
	sm: `Tāpē uma`,
	so: `Dhammaan tirtir`,
	th: `ล้างทั้งหมด`,
	ur: `سب صاف کریں`,
	vi: `Xóa tất cả`,
	'zh-hans': `全部清空`,
	'zh-hant': `全部清空`,
	en: `Clear all`
};

export const loc_clearLangPref: Record<Locale, TemplateResult> = {
	ar: html`<button class="btn-link" type="submit" name="locale" value="">امسح تفضيلي اللغوي</button> على هذا الموقع`,
	de: html`<button class="btn-link" type="submit" name="locale" value="">Meine Sprachpräferenz klar zu machen</button> auf dieser Seite`,
	es: html`<button class="btn-link" type="submit" name="locale" value="">Aclara mi preferencia lingüística</button> en este sitio`,
	fa: html`<button class="btn-link" type="submit" name="locale" value="">ترجیح زبانی ام را پاک کن</button> در این سایت`,
	fil: html`<button class="btn-link" type="submit" name="locale" value="">I-clear ang aking kagustuhan sa wika</button> Sa site na ito`,
	fr: html`<button class="btn-link" type="submit" name="locale" value="">Clarifiez ma préférence linguistique</button> sur ce site`,
	hi: html`<button class="btn-link" type="submit" name="locale" value="">मेरी भाषा वरीयता साफ़ करें</button> इस साइट पर`,
	ht: html`<button class="btn-link" type="submit" name="locale" value="">Klè preferans lang mwen</button> sou sit sa a`,
	it: html`<button class="btn-link" type="submit" name="locale" value="">Chiarisce la mia preferenza linguistica</button> su questo sito`,
	ja: html`<button class="btn-link" type="submit" name="locale" value="">言語の好みをクリアする</button> このサイトで`,
	ko: html`<button class="btn-link" type="submit" name="locale" value="">내 언어 선호를 지워</button> 이 사이트에서`,
	mww: html`<button class="btn-link" type="submit" name="locale" value="">Tshem kuv cov lus nyiam</button> ntawm qhov chaw no`,
	ps: html`<button class="btn-link" type="submit" name="locale" value="">زما د ژبې ترجیح پاکه کړه</button> په دې سایټ کې`,
	pt: html`<button class="btn-link" type="submit" name="locale" value="">Esclarecer minha preferência de idioma</button> neste site`,
	'pt-pt': html`<button class="btn-link" type="submit" name="locale" value="">Esclareça a minha preferência linguística</button> neste site`,
	ru: html`<button class="btn-link" type="submit" name="locale" value="">Прояснив свои языковые предпочтения</button> На этом сайте`,
	sm: html`<button class="btn-link" type="submit" name="locale" value="">Kilia la'u gagana e fiafia i ai</button> i luga o lenei 'upega tafa'ilagi`,
	so: html`<button class="btn-link" type="submit" name="locale" value="">Nadiifi doorashadayda luqadayda</button> boggan`,
	th: html`<button class="btn-link" type="submit" name="locale" value="">ล้างค่ากําหนดภาษาของฉัน</button> บนเว็บไซต์นี้`,
	ur: html`<button class="btn-link" type="submit" name="locale" value="">میری زبان کی ترجیح صاف کریں</button> اس سائٹ پر`,
	vi: html`<button class="btn-link" type="submit" name="locale" value="">Xóa tùy chọn ngôn ngữ của tôi</button> trên trang web này`,
	'zh-hans': html`<button class="btn-link" type="submit" name="locale" value="">清除我的语言偏好</button> 在本网站上`,
	'zh-hant': html`<button class="btn-link" type="submit" name="locale" value="">清除我的語言偏好</button> 在這個網站上`,
	en: html`<button class="btn-link" type="submit" name="locale" value="">Clear my language preference</button> on this site`
};

export const loc_clearSelection: Record<Locale, string> = {
	ar: `اختيار واضح`,
	de: `Klare Auswahl`,
	es: `Selección clara`,
	fa: `انتخاب شفاف`,
	fil: `I-clear ang pagpili`,
	fr: `Sélection claire`,
	hi: `चयन साफ़ करें`,
	ht: `Klè seleksyon`,
	it: `Selezione chiara`,
	ja: `クリアセレクション`,
	ko: `명확한 선발`,
	mww: `Kev xaiv kom meej`,
	ps: `پاک انتخاب`,
	pt: `Seleção clara`,
	'pt-pt': `Seleção clara`,
	ru: `Чистый выбор`,
	sm: `Filifiliga manino`,
	so: `Xulasho cad`,
	th: `ล้างการเลือก`,
	ur: `کلئیر سلیکشن`,
	vi: `Lựa chọn rõ ràng`,
	'zh-hans': `清晰选择`,
	'zh-hant': `明確選擇`,
	en: `Clear selection`
};

export const loc_clients: Record<Locale, string> = {
	ar: `العملاء`,
	de: `Kunden`,
	es: `Clientes`,
	fa: `مشتریان`,
	fil: `Mga kliyente`,
	fr: `Clients`,
	hi: `ग्राहकों`,
	ht: `Kliyan yo`,
	it: `Clienti`,
	ja: `クライアント`,
	ko: `고객`,
	mww: `Cov neeg siv khoom`,
	ps: `مراجعین`,
	pt: `Clientes`,
	'pt-pt': `Clientes`,
	ru: `Клиенты`,
	sm: `Tagata fa'atau`,
	so: `Macaamiisha`,
	th: `ลูกค้า`,
	ur: `کلائنٹس`,
	vi: `Khách hàng`,
	'zh-hans': `客户`,
	'zh-hant': `客戶`,
	en: `Clients`
};

export const loc_close: Record<Locale, string> = {
	ar: `إغلاق`,
	de: `Schließen`,
	es: `Cierre`,
	fa: `بسته شدن`,
	fil: `Isara`,
	fr: `Fermer`,
	hi: `घुटनभरा`,
	ht: `Fèmen`,
	it: `Chiudi`,
	ja: `閉じる`,
	ko: `닫습니다`,
	mww: `kaw`,
	ps: `نږدې`,
	pt: `Fechar`,
	'pt-pt': `Fechar`,
	ru: `Закрыть`,
	sm: `Tapuni`,
	so: `Xir`,
	th: `ปิด`,
	ur: `بند`,
	vi: `Đóng`,
	'zh-hans': `结束`,
	'zh-hant': `結束`,
	en: `Close`
};

export const loc_closedActivitiesDesc: Record<Locale, string> = {
	ar: `ستظهر الأنشطة المكتملة والملغاة هنا.`,
	de: `Abgeschlossene und abgesagte Aktivitäten erscheinen hier.`,
	es: `Las actividades completadas y canceladas aparecerán aquí.`,
	fa: `فعالیت های تکمیل شده و لغو شده در اینجا نمایش داده خواهند شد.`,
	fil: `Ang mga nakumpleto at kinansela na mga aktibidad ay lilitaw dito.`,
	fr: `Les activités terminées et annulées apparaîtront ici.`,
	hi: `पूर्ण और रद्द की गई गतिविधियाँ यहाँ दिखाई देंगी।`,
	ht: `Aktivite yo fini ak anile ap parèt isit la.`,
	it: `Le attività completate e cancellate appariranno qui.`,
	ja: `完了済みおよび中止されたアクティビティはここに掲載されます。`,
	ko: `완료 및 취소된 활동은 여기에 표시됩니다.`,
	mww: `Cov haujlwm ua tiav thiab tshem tawm yuav tshwm sim ntawm no.`,
	ps: `بشپړ شوی او لغوه شوی فعالیتونه به دلته ښکاره شی.`,
	pt: `Atividades concluídas e canceladas aparecerão aqui.`,
	'pt-pt': `Atividades concluídas e canceladas aparecerão aqui.`,
	ru: `Здесь будут отображаться завершённые и отменённые активности.`,
	sm: `O gaoioiga ua maea ma ua faaleaogaina o le a faaali mai iinei.`,
	so: `Hawlaha la dhammeystiray iyo kuwa la joojiyay ayaa halkan lagu soo bandhigi doonaa.`,
	th: `กิจกรรมที่เสร็จสมบูรณ์และถูกยกเลิกจะปรากฏที่นี่`,
	ur: `مکمل اور منسوخ شدہ سرگرمیاں یہاں ظاہر ہوں گی۔`,
	vi: `Các hoạt động đã hoàn thành và bị hủy sẽ xuất hiện tại đây.`,
	'zh-hans': `已完成和取消的活动将在此显示。`,
	'zh-hant': `已完成及取消的活動將顯示於此。`,
	en: `Completed and cancelled activities will appear here.`
};

export const loc_closedCount: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} مغلقين`,
	de: (count) => `${count} geschlossen`,
	es: (count) => `${count} cerrado`,
	fa: (count) => `${count} نفر بسته شدند`,
	fil: (count) => `${count} Sarado`,
	fr: (count) => `${count} fermé`,
	hi: (count) => `${count} बंद`,
	ht: (count) => `${count} fèmen`,
	it: (count) => `${count} chiuso`,
	ja: (count) => `${count} 閉鎖`,
	ko: (count) => `${count} 폐쇄`,
	mww: (count) => `${count} kaw`,
	ps: (count) => `${count} تړل شوی`,
	pt: (count) => `${count} fechados`,
	'pt-pt': (count) => `${count} fechados`,
	ru: (count) => `${count} закрыт`,
	sm: (count) => `${count} tapunia`,
	so: (count) => `${count} waa la xidhay`,
	th: (count) => `${count} ปิดทําการ`,
	ur: (count) => `${count} بند`,
	vi: (count) => `${count} đã đóng cửa`,
	'zh-hans': (count) => `${count} 号关闭`,
	'zh-hant': (count) => `${count} 號關閉`,
	en: (count) => `${count} closed`
};

export const loc_closedStatus: Record<Locale, string> = {
	ar: `الحالات المغلقة`,
	de: `Geschlossene Zustände`,
	es: `Fechas`,
	fa: `وضعیت های بسته شده`,
	fil: `Email Address *`,
	fr: `Statuts fermés`,
	hi: `बंद स्थितियाँ`,
	ht: `Estati fèmen`,
	it: `Status chiuso`,
	ja: `閉鎖状態`,
	ko: `폐쇄 상태`,
	mww: `Cov xwm txheej kaw`,
	ps: `تړل شوی حالتونه`,
	pt: `Status fechado`,
	'pt-pt': `Status de encerramento`,
	ru: `Закрытые статусы`,
	sm: `Tulaga tapunia`,
	so: `Xaaladaha xiran`,
	th: `สถานะปิด`,
	ur: `بند حالتیں`,
	vi: `Trạng thái đóng`,
	'zh-hans': `关闭状态`,
	'zh-hant': `關閉狀態`,
	en: `Closed statuses`
};

export const loc_closeEdit: Record<Locale, string> = {
	ar: `إغلاق التعديل`,
	de: `Schnitt geschlossen`,
	es: `Edición cerrada`,
	fa: `بستن ویرایش`,
	fil: `Isara ang pag-edit`,
	fr: `Édition finale`,
	hi: `संपादित करें बंद करें`,
	ht: `Fèmen modifikasyon`,
	it: `Modifica chiusa`,
	ja: `編集を閉じる`,
	ko: `마감 편집`,
	mww: `Kaw kho kom raug`,
	ps: `بند سمون`,
	pt: `Edição fechada`,
	'pt-pt': `Edição fechada`,
	ru: `Закрытое редактирование`,
	sm: `Tapunia faasa'oga`,
	so: `Tafatir xir`,
	th: `ปิดแก้ไข`,
	ur: `ترمیم بند کریں`,
	vi: `Đóng chỉnh sửa`,
	'zh-hans': `编辑`,
	'zh-hant': `編輯完畢`,
	en: `Close edit`
};

export const loc_closeMenu: Record<Locale, string> = {
	ar: `إغلاق القائمة`,
	de: `Menü schließen`,
	es: `Menú cerrado`,
	fa: `بستن منو`,
	fil: `Email Address *`,
	fr: `Fermer le menu`,
	hi: `मेनू बंद करें`,
	ht: `Fèmen meni`,
	it: `Chiudi menu`,
	ja: `メニューを閉じる`,
	ko: `메뉴 닫기`,
	mww: `Kaw cov ntawv qhia zaub mov`,
	ps: `مینو وتړئ`,
	pt: `Fechar cardápio`,
	'pt-pt': `Fechar menu`,
	ru: `Закрыть меню`,
	sm: `Tapuni le lisi autu`,
	so: `Liiska xir`,
	th: `ปิดเมนู`,
	ur: `مینو بند کریں`,
	vi: `Đóng menu`,
	'zh-hans': `关闭菜单`,
	'zh-hant': `關閉選單`,
	en: `Close menu`
};

export const loc_comment: Record<Locale, string> = {
	ar: `تعليق`,
	de: `Kommentar`,
	es: `Comentario`,
	fa: `نظر`,
	fil: `Komento`,
	fr: `Commentaire`,
	hi: `सम्‍मति देना`,
	ht: `Kòmantè`,
	it: `Commento`,
	ja: `コメント`,
	ko: `댓글`,
	mww: `Tawm tswv yim`,
	ps: `تبصره`,
	pt: `Comentário`,
	'pt-pt': `Comentário`,
	ru: `Комментарий`,
	sm: `Faamatalaga`,
	so: `Faallo`,
	th: `แสดงความคิดเห็น`,
	ur: `تبصرہ`,
	vi: `Bình luận`,
	'zh-hans': `评论`,
	'zh-hant': `留言`,
	en: `Comment`
};

export const loc_commentActions: Record<Locale, string> = {
	ar: `إجراءات التعليق`,
	de: `Kommentaraktionen`,
	es: `Acciones de comentario`,
	fa: `اقدامات نظر`,
	fil: `Mga aksyon ng komento`,
	fr: `Actions sur le commentaire`,
	hi: `टिप्पणी क्रियाएँ`,
	ht: `Aksyon kòmantè`,
	it: `Azioni commento`,
	ja: `コメントアクション`,
	ko: `댓글 행동`,
	mww: `Tawm tswv yim ua`,
	ps: `د نظرونو کړنې`,
	pt: `Ações do comentário`,
	'pt-pt': `Ações de comentário`,
	ru: `Действия с комментариями`,
	sm: `Faatinoga o faamatalaga`,
	so: `Falalka faallooyinka`,
	th: `การดําเนินการแสดงความคิดเห็น`,
	ur: `تبصرہ کے اقدامات`,
	vi: `Hành động nhận xét`,
	'zh-hans': `评论操作`,
	'zh-hant': `留言操作`,
	en: `Comment actions`
};

export const loc_commentCountPlural: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} تعليقات`,
	de: (count) => `${count} Kommentare`,
	es: (count) => `${count} comentarios`,
	fa: (count) => `${count} نظر`,
	fil: (count) => `${count} Mga Komento`,
	fr: (count) => `${count} commentaires`,
	hi: (count) => `${count} टिप्पणियाँ`,
	ht: (count) => `${count} kòmantè`,
	it: (count) => `${count} commenti`,
	ja: (count) => `${count} 件のコメント`,
	ko: (count) => `${count} 개의 댓글`,
	mww: (count) => `${count} comments`,
	ps: (count) => `${count} تبصرې`,
	pt: (count) => `${count} comentários`,
	'pt-pt': (count) => `${count} comentários`,
	ru: (count) => `${count} комментариев`,
	sm: (count) => `${count} fa'amatalaga`,
	so: (count) => `${count} faallooyin`,
	th: (count) => `${count} ความคิดเห็น`,
	ur: (count) => `${count} تبصرے`,
	vi: (count) => `${count} bình luận`,
	'zh-hans': (count) => `${count} 条评论`,
	'zh-hant': (count) => `${count} 則留言`,
	en: (count) => `${count} comments`
};

export const loc_commentCountSingular: Record<Locale, string> = {
	ar: `تعليق واحد`,
	de: `1 Kommentar`,
	es: `1 comentario`,
	fa: `۱ نظر`,
	fil: `1 komento`,
	fr: `1 commentaire`,
	hi: `1 टिप्पणी`,
	ht: `1 kòmantè`,
	it: `1 commento`,
	ja: `1件のコメント`,
	ko: `댓글 1개`,
	mww: `1 saib`,
	ps: `۱ تبصره`,
	pt: `1 comentário`,
	'pt-pt': `1 comentário`,
	ru: `1 комментарий`,
	sm: `1 faamatalaga`,
	so: `1 faallo`,
	th: `1 ความคิดเห็น`,
	ur: `1 تبصرہ`,
	vi: `1 bình luận`,
	'zh-hans': `1条评论`,
	'zh-hant': `1則留言`,
	en: `1 comment`
};

export const loc_commentedOnActivity: Record<Locale, string> = {
	ar: `علقت على هذا النشاط.`,
	de: `Zu dieser Aktivität kommentiert.`,
	es: `Comenté sobre esta actividad.`,
	fa: `در مورد این فعالیت نظر دادم.`,
	fil: `Nagkomento tungkol sa aktibidad na ito.`,
	fr: `Commenté cette activité.`,
	hi: `इस गतिविधि पर टिप्पणी की।`,
	ht: `Kòmantè sou aktivite sa a.`,
	it: `Ho commentato questa attività.`,
	ja: `この活動についてコメントしました。`,
	ko: `이 활동에 대해 댓글을 달았습니다.`,
	mww: `Tawm tswv yim txog qhov kev ua no.`,
	ps: `د دې فعالیت په اړه مې تبصره کړې وه.`,
	pt: `Comentei sobre essa atividade.`,
	'pt-pt': `Comentei sobre esta atividade.`,
	ru: `Прокомментировал эту активность.`,
	sm: `Na ia fa'amatalaina lenei gaoioiga.`,
	so: `Waxaan faallo ka bixiyay hawshan.`,
	th: `แสดงความคิดเห็นเกี่ยวกับกิจกรรมนี้`,
	ur: `اس سرگرمی پر تبصرہ کیا۔`,
	vi: `Nhận xét về hoạt động này.`,
	'zh-hans': `对此活动发表了评论。`,
	'zh-hant': `我對這個活動有留言。`,
	en: `Commented on this activity.`
};

export const loc_commentRequiredForDenialMessage: Record<Locale, string> = {
	ar: `التعليق مطلوب عند رفض جدول الزمن.`,
	de: `Ein Kommentar ist erforderlich, wenn man einen Stundenzettel ablehnt.`,
	es: `Es necesario comentar al negar una hoja de horas.`,
	fa: `هنگام رد برگه زمانی، نظر دادن لازم است.`,
	fil: `Kinakailangan ang komento kapag tinanggihan ang isang timesheet.`,
	fr: `Un commentaire est nécessaire lorsqu’on refuse une feuille de temps.`,
	hi: `टाइमशीट को अस्वीकार करते समय टिप्पणी की आवश्यकता होती है।`,
	ht: `Kòmantè obligatwa lè rejte yon Timesheet.`,
	it: `È necessario commentare quando si nega un foglio presenze.`,
	ja: `タイムシートを拒否する場合はコメントが必要です。`,
	ko: `근무 시간표를 거부할 때는 의견이 필요합니다.`,
	mww: `Yuav tsum tau tawm tswv yim thaum tsis kam lees ib daim ntawv teev sijhawm.`,
	ps: `د وخت پاڼې د ردولو پر مهال تبصره اړین ده.`,
	pt: `Comentário é necessário ao negar uma folha de ponto.`,
	'pt-pt': `É necessário comentar ao negar uma folha de pontos.`,
	ru: `При отказе в табеле работы требуется комментарий.`,
	sm: `E mana'omia se fa'amatalaga pe a teena se pepa o taimi.`,
	so: `Faallo ayaa loo baahan yahay marka la diidayo warqadda waqtiga.`,
	th: `จําเป็นต้องแสดงความคิดเห็นเมื่อปฏิเสธไทม์ชีท`,
	ur: `ٹائم شیٹ کو مسترد کرتے وقت تبصرہ ضروری ہے۔`,
	vi: `Nhận xét là bắt buộc khi từ chối bảng chấm công.`,
	'zh-hans': `拒绝工时表时必须发表评论。`,
	'zh-hant': `拒絕工時表時必須提出評論。`,
	en: `Comment is required when denying a timesheet.`
};

export const loc_comments: Record<Locale, string> = {
	ar: `تعليقات`,
	de: `Kommentare`,
	es: `Comentarios`,
	fa: `نظرات`,
	fil: `Mga Komento`,
	fr: `Commentaires`,
	hi: `टिप्पणियाँ`,
	ht: `Kòmantè`,
	it: `Commenti`,
	ja: `コメント`,
	ko: `댓글`,
	mww: `Cov lus`,
	ps: `تبصرې`,
	pt: `Comentários`,
	'pt-pt': `Comentários`,
	ru: `Комментарии`,
	sm: `Faamatalaga`,
	so: `Faallooyin`,
	th: `ความคิดเห็น`,
	ur: `تبصرے`,
	vi: `Bình luận`,
	'zh-hans': `评论`,
	'zh-hant': `留言`,
	en: `Comments`
};

export const loc_company: Record<Locale, string> = {
	ar: `الشركة`,
	de: `Gesellschaft`,
	es: `Compañía`,
	fa: `شرکت`,
	fil: `Kumpanya`,
	fr: `Entreprise`,
	hi: `अतिथि`,
	ht: `Konpayi an`,
	it: `Azienda`,
	ja: `会社`,
	ko: `회사`,
	mww: `Lub tuam txhab`,
	ps: `شرکت`,
	pt: `Empresa`,
	'pt-pt': `Empresa`,
	ru: `Компания`,
	sm: `Kamupani`,
	so: `Shirkad`,
	th: `บริษัท`,
	ur: `کمپنی`,
	vi: `Công ty`,
	'zh-hans': `公司`,
	'zh-hant': `公司`,
	en: `Company`
};

export const loc_complete: Record<Locale, string> = {
	ar: `اكتمل`,
	de: `Vollständig`,
	es: `Completo`,
	fa: `کامل`,
	fil: `Kumpleto`,
	fr: `Complet`,
	hi: `पूरा`,
	ht: `Konplete`,
	it: `Completa`,
	ja: `完了`,
	ko: `완전`,
	mww: `Ua tiav`,
	ps: `بشپړ`,
	pt: `Completo`,
	'pt-pt': `Completo`,
	ru: `Завершено`,
	sm: `Mae'a`,
	so: `Dhameystiran`,
	th: `สมบูรณ์`,
	ur: `مکمل`,
	vi: `Hoàn chỉnh`,
	'zh-hans': `完整`,
	'zh-hant': `完結`,
	en: `Complete`
};

export const loc_completed: Record<Locale, string> = {
	ar: `اكتمل`,
	de: `Abgeschlossen`,
	es: `Completado`,
	fa: `تکمیل شده`,
	fil: `Nakumpleto`,
	fr: `Achèvement`,
	hi: `पूरा`,
	ht: `Konplete`,
	it: `Completato`,
	ja: `完了`,
	ko: `완성됨`,
	mww: `ua tiav`,
	ps: `بشپړ شوی`,
	pt: `Concluído`,
	'pt-pt': `Concluído`,
	ru: `Завершено`,
	sm: `Faamaeaina`,
	so: `La dhammeystiray`,
	th: `เสร็จสมบูรณ์`,
	ur: `مکمل`,
	vi: `Đã hoàn thành`,
	'zh-hans': `完工`,
	'zh-hant': `完成`,
	en: `Completed`
};

export const loc_completedStatusDesc: Record<Locale, string> = {
	ar: `تم الانتهاء من النشاط.`,
	de: `Die Aktivität ist abgeschlossen.`,
	es: `La actividad ha finalizado.`,
	fa: `فعالیت به پایان رسیده است.`,
	fil: `Nakumpleto na ang aktibidad.`,
	fr: `L’activité est terminée.`,
	hi: `गतिविधि पूरी हो चुकी है।`,
	ht: `Aktivite a te konplete`,
	it: `L'attività è stata completata.`,
	ja: `活動は完了しました。`,
	ko: `활동은 완료되었습니다.`,
	mww: `Qhov kev ua haujlwm tau ua tiav.`,
	ps: `فعالیت بشپړ شوی دی.`,
	pt: `A atividade foi concluída.`,
	'pt-pt': `A atividade foi concluída.`,
	ru: `Деятельность завершена.`,
	sm: `Ua mae'a le gaoioiga.`,
	so: `Hawlgalka waa la dhammeeyay.`,
	th: `กิจกรรมเสร็จสมบูรณ์แล้ว`,
	ur: `یہ سرگرمی مکمل ہو چکی ہے۔`,
	vi: `Hoạt động đã hoàn tất.`,
	'zh-hans': `活动已完成。`,
	'zh-hant': `活動已完成。`,
	en: `The activity has been completed.`
};

export const loc_conditionallyReadOnly: Record<Locale, string> = {
	ar: `قراءة مشروطة فقط`,
	de: `Bedingt schreibgeschützt`,
	es: `Solo lectura condicional`,
	fa: `فقط خواندنی شرطی`,
	fil: `Kundisyonal na basahin lamang`,
	fr: `Lecture seule conditionnelle`,
	hi: `सशर्त रूप से केवल-पढ़ने के लिए`,
	ht: `Kondisyon li sèlman`,
	it: `Lettura di sola condizionata`,
	ja: `条件付き読み取り専用`,
	ko: `조건부 읽기 전용`,
	mww: `Conditionally nyeem nkaus xwb`,
	ps: `یوازې د مشروط لوستلو لپاره`,
	pt: `Somente leitura condicional`,
	'pt-pt': `Apenas leitura condicional`,
	ru: `Условно только для чтения`,
	sm: `Faitau na'o tuutuuga`,
	so: `Shuruud ahaan akhris kaliya`,
	th: `อ่านอย่างเดียวแบบมีเงื่อนไข`,
	ur: `مشروط طور پر صرف پڑھنے کے لیے`,
	vi: `Chỉ đọc có điều kiện`,
	'zh-hans': `条件只读`,
	'zh-hant': `條件唯讀`,
	en: `Conditionally read-only`
};

export const loc_conditionallyReadOnlyMessage: Record<Locale, string> = {
	ar: `هذا السجل للقراءة فقط بسبب شروط يحددها مسؤول المشروع.`,
	de: `Dieser Datensatz ist schreibgeschützt aufgrund der vom Projektadministrator gesetzten Bedingungen.`,
	es: `Este registro es de solo lectura debido a condiciones establecidas por el administrador del proyecto.`,
	fa: `این رکورد به دلیل شرایطی که توسط مدیر پروژه تعیین شده، فقط خواندنی است.`,
	fil: `Ang rekord na ito ay read-only dahil sa mga kondisyon na itinakda ng tagapangasiwa ng proyekto.`,
	fr: `Cet enregistrement est en lecture seule en raison des conditions imposées par l’administrateur du projet.`,
	hi: `यह रिकॉर्ड प्रोजेक्ट व्यवस्थापक द्वारा सेट की गई शर्तों के कारण केवल-पढ़ने के लिए है।`,
	ht: `Dosye sa a se li sèlman akòz kondisyon ki etabli pa administratè pwojè a.`,
	it: `Questo record è di sola lettura a causa delle condizioni imposte dall'amministratore del progetto.`,
	ja: `このレコードはプロジェクト管理者が設定した条件により読み取り専用です。`,
	ko: `이 레코드는 프로젝트 관리자가 설정한 조건 때문에 읽기 전용입니다.`,
	mww: `Cov ntaub ntawv no yog nyeem nkaus xwb vim yog cov xwm txheej uas tau teev tseg los ntawm tus thawj tswj hwm qhov project.`,
	ps: `دا ریکارډ یوازې د لوستلو وړ دی ځکه چې د پروژې مدیر لخوا ټاکل شوی شرایط ټاکل شوی دی.`,
	pt: `Este registro é somente leitura devido a condições estabelecidas pelo administrador do projeto.`,
	'pt-pt': `Este registo é apenas de leitura devido a condições definidas pelo administrador do projeto.`,
	ru: `Эта запись доступна только для чтения из-за условий, установленных администратором проекта.`,
	sm: `O lenei faamaumauga e na o le faitauina ona o tuutuuga ua setiina e le pule o le galuega faatino.`,
	so: `Diiwaankan waa akhris kaliya sababtoo ah shuruudaha uu dejiyay maamulaha mashruuca.`,
	th: `เรกคอร์ดนี้เป็นแบบอ่านอย่างเดียวเนื่องจากเงื่อนไขที่กําหนดโดยผู้ดูแลระบบโครงการ`,
	ur: `یہ ریکارڈ صرف پڑھنے کے لیے ہوتا ہے کیونکہ پروجیکٹ ایڈمنسٹریٹر نے شرائط مقرر کی ہیں۔`,
	vi: `Bản ghi này ở chế độ chỉ đọc do các điều kiện do quản trị viên dự án đặt ra.`,
	'zh-hans': `由于项目管理员设定的条件，该记录为只读。`,
	'zh-hant': `由於專案管理員設定的條件，此紀錄為唯讀。`,
	en: `This record is read-only due to conditions set by the project administrator.`
};

export const loc_confirm: Record<Locale, string> = {
	ar: `تأكيد`,
	de: `Bestätigen`,
	es: `Confirmar`,
	fa: `تأیید`,
	fil: `Kumpirmahin`,
	fr: `Confirmez`,
	hi: `सुदृढ़ करना`,
	ht: `Konfime`,
	it: `Conferma`,
	ja: `確認してください`,
	ko: `확인해`,
	mww: `Paub meej`,
	ps: `تایید کړه`,
	pt: `Confirme`,
	'pt-pt': `Confirmar`,
	ru: `Подтвердите`,
	sm: `Fa'amaonia`,
	so: `Xaqiiji`,
	th: `ยืนยัน`,
	ur: `تصدیق`,
	vi: `Xác nhận`,
	'zh-hans': `确认`,
	'zh-hant': `確認`,
	en: `Confirm`
};

export const loc_confirmDelete: Record<Locale, string> = {
	ar: `تأكيد حذف`,
	de: `Bestätigen, löschen`,
	es: `Confirmar eliminar`,
	fa: `تأیید حذف`,
	fil: `Kumpirmahin ang pagtanggal`,
	fr: `Confirmer supprimer`,
	hi: `हटाए जाने की पुष्टि करें`,
	ht: `Konfime efase`,
	it: `Conferma elimina`,
	ja: `確認 削除`,
	ko: `확인 삭제`,
	mww: `Paub meej tias rho tawm`,
	ps: `تایید، حذف`,
	pt: `Confirmar exclusão`,
	'pt-pt': `Confirmar eliminação`,
	ru: `Подтвердить, удалить`,
	sm: `Faamaonia le tapeina`,
	so: `Xaqiiji tirtirka`,
	th: `ยืนยันการลบ`,
	ur: `ڈیلیٹ کی تصدیق`,
	vi: `Xác nhận xóa`,
	'zh-hans': `确认删除`,
	'zh-hant': `確認刪除`,
	en: `Confirm delete`
};

export const loc_confirmDeleteSignature: Record<Locale, string> = {
	ar: `هل أنت متأكد أنك تريد حذف هذا التوقيع؟`,
	de: `Bist du sicher, dass du diese Signatur löschen willst?`,
	es: `¿Estás seguro de que quieres borrar esta firma?`,
	fa: `مطمئنی می خوای این امضا رو حذف کنی؟`,
	fil: `Sigurado ka bang nais mong tanggalin ang lagda na ito?`,
	fr: `Êtes-vous sûr de vouloir supprimer cette signature ?`,
	hi: `क्या आप वाकई इस हस्ताक्षर को हटाना चाहते हैं?`,
	ht: `Èske ou sèten ou vle efase siyati sa a?`,
	it: `Sei sicuro di voler cancellare questa firma?`,
	ja: `本当にこの署名を削除したいのですか?`,
	ko: `이 서명을 삭제할 거 확실해?`,
	mww: `Koj puas paub tseeb tias koj xav rho tawm qhov kos npe no?`,
	ps: `ته ډاډه یې چې دا لاسلیک حذف کول غواړې؟`,
	pt: `Tem certeza de que quer apagar essa assinatura?`,
	'pt-pt': `Tens a certeza de que queres apagar esta assinatura?`,
	ru: `Вы уверены, что хотите удалить эту подпись?`,
	sm: `E te mautinoa e te manao e tapeese lenei saini?`,
	so: `Ma hubtaa inaad rabto inaad tirtirto saxiixan?`,
	th: `คุณแน่ใจหรือไม่ว่าต้องการลบลายเซ็นนี้?`,
	ur: `کیا آپ واقعی اس دستخط کو حذف کرنا چاہتے ہیں؟`,
	vi: `Bạn có chắc chắn muốn xóa chữ ký này không?`,
	'zh-hans': `你确定要删除这个签名吗？`,
	'zh-hant': `你確定要刪除這個簽名嗎？`,
	en: `Are you sure you want to delete this signature?`
};

export const loc_confirmDuplicateFormat: Record<Locale, (person: unknown) => TemplateResult> = {
	ar: (person) => html`<span>أكد أن هذا العميل نسخة مكررة من ${person}</span>`,
	de: (person) => html`<span>Bestätigen Sie, dass dieser Kunde ein Duplikat von ${person} ist.</span>`,
	es: (person) => html`<span>Confirma que este cliente es un duplicado de ${person}</span>`,
	fa: (person) => html`<span>تأیید کنید این مشتری کپی ${person} است</span>`,
	fil: (person) => html`<span>Kumpirmahin na ang kliyente na ito ay isang duplicate ng ${person}</span>`,
	fr: (person) => html`<span>Confirmez que ce client est un double de ${person}</span>`,
	hi: (person) => html`<span>पुष्टि करें कि यह क्लाइंट ${person} का डुप्लिकेट है</span>`,
	ht: (person) => html`<span>Konfime kliyan sa a se yon kopi ${person}</span>`,
	it: (person) => html`<span>Conferma che questo cliente sia un duplicato di ${person}</span>`,
	ja: (person) => html`<span>このクライアントが${person}複製であることを確認してください</span>`,
	ko: (person) => html`<span>이 클라이언트가 ${person}의 중복인지 확인해 주세요</span>`,
	mww: (person) => html`<span>Paub tseeb tias tus neeg siv khoom no yog ib qho theej tawm ntawm ${person}</span>`,
	ps: (person) => html`<span>تایید کړه چې دا مشتری ${person} نقل دی</span>`,
	pt: (person) => html`<span>Confirme que este cliente é um duplicado de ${person}</span>`,
	'pt-pt': (person) => html`<span>Confirme que este cliente é um duplicado de ${person}</span>`,
	ru: (person) => html`<span>Подтвердите, что этот клиент — копия ${person}</span>`,
	sm: (person) => html`<span>Ia faamaonia o lenei tagata o se kopi o ${person}</span>`,
	so: (person) => html`<span>Xaqiiji in macmiilkan uu yahay nuqul ${person}</span>`,
	th: (person) => html`<span>ยืนยันว่าไคลเอ็นต์นี้เป็นสําเนาของ ${person}</span>`,
	ur: (person) => html`<span>تصدیق کریں کہ یہ کلائنٹ ${person} کا نقل ہے</span>`,
	vi: (person) => html`<span>Xác nhận ứng dụng này là bản sao của ${person}</span>`,
	'zh-hans': (person) => html`<span>确认这个客户是${person}的复制品</span>`,
	'zh-hant': (person) => html`<span>確認此客戶是否為${person}的複製品</span>`,
	en: (person) => html`<span>Confirm this client is a duplicate of ${person}</span>`
};

export const loc_confirmMerge: Record<Locale, string> = {
	ar: `تأكيد الدمج`,
	de: `Zusammenführung bestätigen`,
	es: `Confirmar fusión`,
	fa: `ادغام را تأیید کنید`,
	fil: `Kumpirmahin ang pagsasanib`,
	fr: `Confirmer la fusion`,
	hi: `मर्ज की पुष्टि करें`,
	ht: `Konfime rantre`,
	it: `Conferma la fusione`,
	ja: `統合を確認してください`,
	ko: `합병 확인`,
	mww: `Paub meej tias merge`,
	ps: `ادغام تایید کړه`,
	pt: `Confirmar fusão`,
	'pt-pt': `Confirmar fusão`,
	ru: `Подтвердить слияние`,
	sm: `Fa'amaonia le tu'ufa'atasia`,
	so: `Xaqiiji isku-darka`,
	th: `ยืนยันการผสาน`,
	ur: `مرج کی تصدیق کریں`,
	vi: `Xác nhận hợp nhất`,
	'zh-hans': `确认合并`,
	'zh-hant': `確認合併`,
	en: `Confirm merge`
};

export const loc_confirmSMSFormat: Record<Locale, (phone_number: unknown) => string> = {
	ar: (phone_number) => `أرسلنا رسالة نصية إلى +1 ${phone_number}. أدخل الرمز المكون من 6 أرقام من الرسالة النصية التي استلمتها.`,
	de: (phone_number) => `Wir haben eine SMS an +1 ${phone_number} gesendet. Gib den sechsstelligen Code aus der erhaltenen SMS ein.`,
	es: (phone_number) => `Hemos enviado un mensaje de texto al +1 ${phone_number}. Introduce el código de 6 dígitos del mensaje de texto que recibiste.`,
	fa: (phone_number) => `ما یک پیامک به +1 ${phone_number} ارسال کرده ایم. کد ۶ رقمی پیامی که دریافت کرده اید را وارد کنید.`,
	fil: (phone_number) => `Nagpadala kami ng text message sa +1 ${phone_number}. Ipasok ang 6-digit na code mula sa text message na natanggap mo.`,
	fr: (phone_number) => `Nous avons envoyé un message texte au +1 ${phone_number}. Saisissez le code à 6 chiffres du message texte que vous avez reçu.`,
	hi: (phone_number) => `हमने +1 ${phone_number} पर एक टेक्स्ट संदेश भेजा है। आपको प्राप्त पाठ संदेश से 6-अंकीय कोड दर्ज करें।`,
	ht: (phone_number) => `Nou voye yon mesaj tèks nan +1 ${phone_number} Antre kòd 6 chif nan tèks mesaj ou te resevwa a.`,
	it: (phone_number) => `Abbiamo inviato un messaggio di testo al numero +1 ${phone_number}. Inserisci il codice a 6 cifre dal messaggio di testo che hai ricevuto.`,
	ja: (phone_number) => `私たちは+1 ${phone_number}にテキストメッセージを送信しました。受け取ったテキストメッセージの6桁コードを入力してください。`,
	ko: (phone_number) => `문자 메시지를 +1 ${phone_number}로 보냈습니다. 받은 문자 메시지의 6자리 코드를 입력하세요.`,
	mww: (phone_number) => `Peb tau xa cov ntawv nyeem rau +1 ${phone_number}. Sau tus lej 6 tus lej los ntawm cov ntawv nyeem uas koj tau txais.`,
	ps: (phone_number) => `موږ یو پیغام +۱ ${phone_number} ته لیږلی دی. د هغه پیغام څخه ۶ عددی کوډ داخل کړئ چې ترلاسه مو کړی دی.`,
	pt: (phone_number) => `Enviamos uma mensagem de texto para o +1 ${phone_number}. Digite o código de 6 dígitos da mensagem de texto que você recebeu.`,
	'pt-pt': (phone_number) => `Enviámos uma mensagem de texto para o +1 ${phone_number}. Introduza o código de 6 dígitos da mensagem de texto que recebeu.`,
	ru: (phone_number) => `Мы отправили текстовое сообщение на +1 ${phone_number}. Введите шестизначный код из полученного текстового сообщения.`,
	sm: (phone_number) => `Na matou lafoina se feau tusitusia i le +1 ${phone_number}. Ulu atu i le numera numera 6-digit mai le feau tusitusia na e mauaina.`,
	so: (phone_number) => `Waxaan fariin qoraal ah u dirnay +1 ${phone_number}. Geli koodhka 6-lambar ee farriinta qoraalka ah ee aad heshay.`,
	th: (phone_number) => `เราได้ส่งข้อความไปที่ +1 ${phone_number} ป้อนรหัส 6 หลักจากข้อความที่คุณได้รับ`,
	ur: (phone_number) => `ہم نے +1 ${phone_number} پر ٹیکسٹ میسج بھیجا ہے۔ موصول ہونے والے ٹیکسٹ میسج سے 6 ہندسوں کا کوڈ درج کریں۔`,
	vi: (phone_number) => `Chúng tôi đã gửi tin nhắn văn bản đến +1 ${phone_number}. Nhập mã gồm 6 chữ số từ tin nhắn văn bản bạn nhận được.`,
	'zh-hans': (phone_number) => `我们已发送短信至+1 ${phone_number}。输入你收到短信中的6位数代码。`,
	'zh-hant': (phone_number) => `我們已發送簡訊至+1 ${phone_number}。輸入你收到的簡訊中的六位數代碼。`,
	en: (phone_number) => `We've sent a text message to +1 ${phone_number}. Enter the 6-digit code from the text message you received.`
};

export const loc_consent: Record<Locale, string> = {
	ar: `الموافقة`,
	de: `Zustimmung`,
	es: `Consentimiento`,
	fa: `رضایت`,
	fil: `Pahintulot`,
	fr: `Consentement`,
	hi: `अनुमति`,
	ht: `Konsantman`,
	it: `Consenso`,
	ja: `同意`,
	ko: `동의`,
	mww: `Kev tso cai`,
	ps: `رضا`,
	pt: `Consentimento`,
	'pt-pt': `Consentimento`,
	ru: `Согласие`,
	sm: `Maliega`,
	so: `Ogolaansho`,
	th: `ความยินยอม`,
	ur: `رضامندی`,
	vi: `Sự đồng ý`,
	'zh-hans': `同意`,
	'zh-hant': `同意`,
	en: `Consent`
};

export const loc_consentToDoBusinessElectronically: Record<Locale, string> = {
	ar: `بقبول هذا التوقيع، فإنك توافق على أن هذا النشاط يمكن أن يكون موقعا إلكترونيا، وأن التواقيع الإلكترونية التي تظهر على هذا النشاط هي نفسها التوقيعات المكتوبة بخط اليد لأغراض الصلاحية والقابلية للتنفيذ والقبول.`,
	de: `Mit der Annahme dieser Unterschrift stimmen Sie zu, dass diese Aktivität elektronisch unterzeichnet werden darf und dass die auf dieser Aktivität erscheinenden elektronischen Unterschriften handschriftlichen Unterschriften im Hinblick auf Gültigkeit, Durchsetzbarkeit und Zulässigkeit entsprechen.`,
	es: `Al aceptar esta firma, aceptas que esta actividad puede ser firmada electrónicamente y que las firmas electrónicas que aparecen en esta actividad son iguales a las firmas manuscritas para fines de validez, exigibilidad y admisibilidad.`,
	fa: `با پذیرش این امضا، شما موافقت می کنید که این فعالیت ممکن است به صورت الکترونیکی امضا شود و امضاهای الکترونیکی ظاهر شده در این فعالیت همان امضاهای دست نویس برای اهداف اعتبار، قابلیت اجرا و پذیرش هستند.`,
	fil: `Sa pamamagitan ng pagtanggap ng lagda na ito, sumasang-ayon ka na ang aktibidad na ito ay maaaring lagdaan nang elektroniko at ang mga elektronikong lagda na lumilitaw sa aktibidad na ito ay kapareho ng mga sulat-kamay na lagda para sa mga layunin ng bisa, pagpapatupad, at katanggap-tanggap.`,
	fr: `En acceptant cette signature, vous acceptez que cette activité puisse être signée électroniquement et que les signatures électroniques apparaissant sur cette activité soient identiques à celles manuscrites, en ce qui concerne la validité, l’exécutabilité et l’admissibilité.`,
	hi: `इस हस्ताक्षर को स्वीकार करके आप सहमत हैं कि इस गतिविधि को इलेक्ट्रॉनिक रूप से हस्ताक्षरित किया जा सकता है और इस गतिविधि पर दिखाई देने वाले इलेक्ट्रॉनिक हस्ताक्षर वैधता, प्रवर्तनीयता और स्वीकार्यता के प्रयोजनों के लिए हस्तलिखित हस्ताक्षर के समान हैं।`,
	ht: `Lè w aksepte siyati sa a, ou dakò ke aktivite sa a ka siyen elektwonikman e ke siyati elektwonik ki parèt sou aktivite sa a se menm bagay la kòm siyati ekri men pou rezon validite, aplikabilite, ak admisibilite.`,
	it: `Accettando questa firma, accetti che questa attività possa essere firmata elettronicamente e che le firme elettroniche presenti in questa attività siano le stesse delle firme manoscritte ai fini di validità, applicabilità e ammissibilità.`,
	ja: `この署名を受け入れることで、本活動が電子的に署名されること、そして有効性、執行可能性、証拠性の観点から手書き署名と同一であることに同意したことになります。`,
	ko: `이 서명을 수락함으로써 귀하는 이 활동이 전자적으로 서명될 수 있으며, 이 활동에 나타나는 전자 서명이 유효성, 집행 가능성 및 증거 채택 목적상 손글씨 서명과 동일하다는 데 동의하는 것입니다.`,
	mww: `Yog koj lees txais qhov kos npe no, koj pom zoo tias tej zaum yuav kos npe rau hauv tshuab hluav taws xob thiab cov kos npe hauv tshuab hluav taws xob uas tshwm rau ntawm qhov kev ua no yog tib yam li cov kos npe ntawm tes sau rau lub hom phiaj ntawm kev siv tau, siv tau, thiab kev lees paub.`,
	ps: `د دې لاسلیک منلو سره تاسو موافقه کوئ چې دا فعالیت الکترونیکی لاسلیک کېدای شی او په دې فعالیت کې ښکاره شوی الکترونیکی لاسلیکونه د لاسلیکنو سره برابر دی د اعتبار، پلی کیدو او منلو لپاره.`,
	pt: `Ao aceitar esta assinatura, você concorda que essa atividade pode ser assinada eletronicamente e que as assinaturas eletrônicas presentes nesta atividade são as mesmas das assinaturas manuscritas, para fins de validade, aplicabilidade e admissibilidade.`,
	'pt-pt': `Ao aceitar esta assinatura, concorda que esta atividade pode ser assinada eletronicamente e que as assinaturas eletrónicas presentes nesta atividade são iguais às assinaturas manuscritas, para efeitos de validade, execução e admissibilidade.`,
	ru: `Принимая эту подпись, вы соглашаетесь с тем, что эта деятельность может быть подписана электронно, и что электронные подписи, появляющиеся на ней, совпадают с рукописными подписями для целей достоверности, силы исполнения и допустимости.`,
	sm: `E ala i le taliaina o lenei saini ua e malilie ai o lenei gaioiga e mafai ona sainia faaeletonika ma o saini faaeletonika o lo'o aliali mai i luga o lenei gaioiga e tutusa ma saini tusilima mo le fa'amoemoe o le aoga, fa'amalosia, ma le taliaina.`,
	so: `Adigoo aqbalaya saxiixan waxaad ku raacsan tahay in hawlgalkan si elektaroonik ah loo saxiixi karo iyo in saxiixyada elektarooniga ah ee ka muuqda hawshan ay la mid yihiin saxiixyada gacanta lagu qoray ujeeddooyinka saxnaanta ah, dhaqan gelinta, iyo aqbalaadda.`,
	th: `การยอมรับลายเซ็นนี้แสดงว่าคุณยอมรับว่ากิจกรรมนี้อาจได้รับการลงนามทางอิเล็กทรอนิกส์ และลายเซ็นอิเล็กทรอนิกส์ที่ปรากฏในกิจกรรมนี้เหมือนกับลายเซ็นที่เขียนด้วยลายมือเพื่อวัตถุประสงค์ในความถูกต้อง`,
	ur: `اس دستخط کو قبول کر کے آپ اس بات سے اتفاق کرتے ہیں کہ یہ سرگرمی الیکٹرانک دستخط ہو سکتی ہے اور اس سرگرمی پر ظاہر ہونے والے الیکٹرانک دستخط ہاتھ سے لکھے ہوئے دستخطوں کے برابر ہیں، تاکہ درستگی، نفاذ اور قبولیت کے مقاصد حاصل کیے جا سکیں۔`,
	vi: `Bằng cách chấp nhận chữ ký này, bạn đồng ý rằng hoạt động này có thể được ký điện tử và chữ ký điện tử xuất hiện trên hoạt động này giống như chữ ký viết tay vì mục đích hợp lệ, thực thi và được chấp nhận.`,
	'zh-hans': `接受该签名即表示您同意该活动可进行电子签名，且该活动上的电子签名与手写签名相同，以确保其有效性、可执行性和可采性。`,
	'zh-hant': `接受此簽名即表示您同意本活動可電子簽署，且該活動上的電子簽名在有效性、可執行性及可採性上與手寫簽名相同。`,
	en: `By accepting this signature you agree that this activity may be electronically signed and that the electronic signatures appearing on this activity are the same as handwritten signatures for the purposes of validity, enforceability, and admissibility.`
};

export const loc_consumer: Record<Locale, string> = {
	ar: `المستهلك`,
	de: `Verbraucher`,
	es: `Consumidor`,
	fa: `مصرف کننده`,
	fil: `Mamimili`,
	fr: `Consommateur`,
	hi: `उपभोक्ता`,
	ht: `Konsomatè yo`,
	it: `Consumatore`,
	ja: `消費者向け`,
	ko: `소비자`,
	mww: `Tus neeg siv khoom`,
	ps: `مصرف کوونکی`,
	pt: `Consumidor`,
	'pt-pt': `Consumidor`,
	ru: `Потребитель`,
	sm: `Tagata fa'atau`,
	so: `Macaamiil`,
	th: `ผู้บริโภค`,
	ur: `صارف`,
	vi: `Người tiêu dùng`,
	'zh-hans': `消费者`,
	'zh-hant': `消費者`,
	en: `Consumer`
};

export const loc_consumerManagesTheirOwnCare: Record<Locale, string> = {
	ar: `المستهلك يدير رعايته بنفسه.`,
	de: `Der Verbraucher verwaltet seine Versorgung selbst.`,
	es: `El consumidor gestiona su propio cuidado.`,
	fa: `مصرف کننده مراقبت خود را خودش مدیریت می کند.`,
	fil: `Ang mamimili ang namamahala sa kanilang sariling pangangalaga.`,
	fr: `Le consommateur gère lui-même ses soins.`,
	hi: `उपभोक्ता अपनी देखभाल का प्रबंधन स्वयं करता है।`,
	ht: `Konsomatè a jere pwòp swen li.`,
	it: `Il consumatore gestisce la propria cura.`,
	ja: `消費者は自分自身のケアを管理します。`,
	ko: `소비자는 자신의 관리를 스스로 관리합니다.`,
	mww: `Tus neeg tau txais kev pab tswj hwm nws tus kheej.`,
	ps: `مصرف کوونکی خپله پاملرنه پخپله اداره کوی.`,
	pt: `O consumidor gerencia seu próprio cuidado.`,
	'pt-pt': `O consumidor gere os seus próprios cuidados.`,
	ru: `Потребитель сам заботится о своём уходе.`,
	sm: `O le tagata fa'atau e fa'atautaia a latou lava tausiga.`,
	so: `Macaamiisha ayaa isagu maamula daryeelkooda.`,
	th: `ผู้บริโภคจัดการการดูแลของตนเอง`,
	ur: `صارف اپنی دیکھ بھال خود سنبھالتا ہے۔`,
	vi: `Người tiêu dùng tự quản lý việc chăm sóc của họ.`,
	'zh-hans': `消费者自行管理自己的医疗服务。`,
	'zh-hant': `消費者自行管理自己的照護。`,
	en: `The consumer manages their own care.`
};

export const loc_consumers: Record<Locale, string> = {
	ar: `المستهلكون`,
	de: `Verbraucher`,
	es: `Consumidores`,
	fa: `مصرف کنندگان`,
	fil: `Mga mamimili`,
	fr: `Consommateurs`,
	hi: `उपभोक्ताओं`,
	ht: `Konsomatè yo`,
	it: `Consumatori`,
	ja: `消費者`,
	ko: `소비자`,
	mww: `Cov neeg siv khoom`,
	ps: `مصرف کوونکی`,
	pt: `Consumidores`,
	'pt-pt': `Consumidores`,
	ru: `Потребители`,
	sm: `Tagata fa'atau`,
	so: `Macaamiisha`,
	th: `ผู้บริโภค`,
	ur: `صارفین`,
	vi: `Người tiêu dùng`,
	'zh-hans': `消费者`,
	'zh-hant': `消費者`,
	en: `Consumers`
};

export const loc_contact: Record<Locale, string> = {
	ar: `الاتصال`,
	de: `Kontakt`,
	es: `Contacto`,
	fa: `تماس`,
	fil: `Makipag-ugnay`,
	fr: `Contact`,
	hi: `संपर्क करें`,
	ht: `Kontak`,
	it: `Contatto`,
	ja: `連絡先`,
	ko: `연락처`,
	mww: `Hu rau`,
	ps: `تماس`,
	pt: `Contato`,
	'pt-pt': `Contacto`,
	ru: `Контакт`,
	sm: `Fa'afeso'ota'i`,
	so: `Xiriir`,
	th: `ติดต่อ`,
	ur: `رابطہ`,
	vi: `Liên hệ`,
	'zh-hans': `联系方式`,
	'zh-hant': `聯絡人`,
	en: `Contact`
};

export const loc_contactEmail: Record<Locale, string> = {
	ar: `بريد التواصل`,
	de: `Kontakt-E-Mail`,
	es: `Correo electrónico de contacto`,
	fa: `ایمیل تماس`,
	fil: `Email ng kontak`,
	fr: `Email de contact`,
	hi: `संपर्क ईमेल`,
	ht: `Kontakte imèl`,
	it: `Email di contatto`,
	ja: `お問い合わせメール`,
	ko: `연락처 이메일`,
	mww: `Email tiv tauj`,
	ps: `د اړیکې برېښنالیک`,
	pt: `E-mail de contato`,
	'pt-pt': `Email de contacto`,
	ru: `Контактная электронная почта`,
	sm: `Fa'afeso'ota'i imeli`,
	so: `Email-ka xiriirka`,
	th: `อีเมลติดต่อ`,
	ur: `رابطہ ای میل`,
	vi: `Email liên hệ`,
	'zh-hans': `联系邮箱`,
	'zh-hant': `聯絡電子郵件`,
	en: `Contact email`
};

export const loc_contactOurTeam: Record<Locale, string> = {
	ar: `تواصل مع فريقنا`,
	de: `Kontaktieren Sie unser Team`,
	es: `Contacta con nuestro equipo`,
	fa: `با تیم ما تماس بگیرید`,
	fil: `Makipag-ugnay sa aming koponan`,
	fr: `Contactez notre équipe`,
	hi: `हमारी टीम से संपर्क करें`,
	ht: `Kontakte ekip nou an`,
	it: `Contatta il nostro team`,
	ja: `当チームにお問い合わせください`,
	ko: `저희 팀에 연락하세요`,
	mww: `Hu rau peb pab neeg`,
	ps: `زموږ ټیم سره اړیکه ونیسئ`,
	pt: `Entre em contato com nossa equipe`,
	'pt-pt': `Contacte a nossa equipa`,
	ru: `Свяжитесь с нашей командой`,
	sm: `Fa'afeso'ota'i la matou 'au`,
	so: `La xiriir kooxdeena`,
	th: `ติดต่อทีมงานของเรา`,
	ur: `ہماری ٹیم سے رابطہ کریں`,
	vi: `Liên hệ với nhóm của chúng tôi`,
	'zh-hans': `联系我们的团队`,
	'zh-hant': `聯絡我們的團隊`,
	en: `Contact our team`
};

export const loc_contactPhone: Record<Locale, string> = {
	ar: `هاتف الاتصال`,
	de: `Kontakttelefon`,
	es: `Teléfono de contacto`,
	fa: `تلفن تماس`,
	fil: `Telepono ng kontak`,
	fr: `Contact téléphonique`,
	hi: `संपर्क फोन`,
	ht: `Kontak telefòn`,
	it: `Telefono di contatto`,
	ja: `連絡先電話`,
	ko: `연락처 전화`,
	mww: `Xov tooj tiv tauj`,
	ps: `د تماس تلیفون`,
	pt: `Telefone de contato`,
	'pt-pt': `Telefone de contacto`,
	ru: `Контактный телефон`,
	sm: `Fa'afeso'ota'i telefoni`,
	so: `Xiriirka telefoonka`,
	th: `หมายเลขโทรศัพท์ติดต่อ`,
	ur: `رابطہ فون`,
	vi: `Số điện thoại liên hệ`,
	'zh-hans': `联系电话`,
	'zh-hant': `聯絡電話`,
	en: `Contact phone`
};

export const loc_contacts: Record<Locale, string> = {
	ar: `جهات الاتصال`,
	de: `Kontakte`,
	es: `Contactos`,
	fa: `ارتباطات`,
	fil: `Email Address *`,
	fr: `Contacts`,
	hi: `संपर्क`,
	ht: `Kontak`,
	it: `Contatti`,
	ja: `連絡先`,
	ko: `연락처`,
	mww: `Hu rau`,
	ps: `اړیکې`,
	pt: `Contatos`,
	'pt-pt': `Contactos`,
	ru: `Контакты`,
	sm: `Fa'afeso'ota'iga`,
	so: `Xiriirada`,
	th: `ติดต่อ`,
	ur: `رابطے`,
	vi: `Liên hệ`,
	'zh-hans': `联系人`,
	'zh-hant': `聯絡人`,
	en: `Contacts`
};

export const loc_contactSales: Record<Locale, string> = {
	ar: `مبيعات الاتصال`,
	de: `Kontakt zum Vertrieb`,
	es: `Ventas de contacto`,
	fa: `فروش تماس`,
	fil: `Makipag-ugnay sa mga benta`,
	fr: `Ventes de contact`,
	hi: `बिक्री से संपर्क करें`,
	ht: `Kontakte lavant`,
	it: `Contatta vendite`,
	ja: `営業に連絡`,
	ko: `영업 연락처`,
	mww: `Hu rau kev muag khoom`,
	ps: `د تماس پلور`,
	pt: `Vendas de contato`,
	'pt-pt': `Vendas de contacto`,
	ru: `Контактные продажи`,
	sm: `Fa'afeso'ota'i tagata fa'`,
	so: `Xiriirka iibka`,
	th: `ติดต่อฝ่ายขาย`,
	ur: `رابطہ سیلز`,
	vi: `Liên hệ với bộ phận bán hàng`,
	'zh-hans': `联系销售`,
	'zh-hant': `聯絡銷售`,
	en: `Contact sales`
};

export const loc_contactSupportForEmailOrUsername: Record<Locale, TemplateResult> = {
	ar: html`<a href="/support">تواصل مع الدعم</a> للحصول على المساعدة في تغيير بريدك الإلكتروني أو اسم المستخدم.`,
	de: html`<a href="/support">Kontaktieren Sie den Support</a> für Hilfe bei der Änderung Ihrer E-Mail-Adresse oder Ihres Benutzernamens.`,
	es: html`<a href="/support">Contacta con el soporte</a> para recibir ayuda para cambiar tu correo electrónico o nombre de usuario.`,
	fa: html`برای دریافت کمک در تغییر ایمیل یا نام کاربری <a href="/support">خود با پشتیبانی تماس بگیرید</a>.`,
	fil: html`<a href="/support">Makipag-ugnay sa suporta</a> para sa tulong sa pagbabago ng iyong email o username.`,
	fr: html`<a href="/support">Contactez le support</a> pour obtenir de l’aide afin de changer votre adresse e-mail ou votre nom d’utilisateur.`,
	hi: html`अपना ईमेल या उपयोगकर्ता नाम बदलने में सहायता के लिए <a href="/support">सहायता सहायता से संपर्क करें</a>.`,
	ht: html`<a href="/support">Kontakte sipò</a> pou asistans chanje imèl ou oswa non itilizatè ou.`,
	it: html`<a href="/support">Contatta l'assistenza</a> per assistenza nella modifica della tua email o del tuo username.`,
	ja: html`メールアドレスやユーザー名の変更についてサポート<a href="/support">までご連絡</a>ください。`,
	ko: html`이메일이나 사용자 이름 변경에 도움을 원하시면 <a href="/support">지원팀에 연락</a>하세요.`,
	mww: html`<a href="/support">Hu rau kev txhawb nqa</a> rau kev pab hloov koj tus email lossis username.`,
	ps: html`د ایمیل یا کارن نوم بدلولو کې <a href="/support">د مرستې لپاره له ملاتړ سره اړیکه ونیسئ</a>.`,
	pt: html`<a href="/support">Entre em contato com o suporte</a> para obter ajuda para alterar seu e-mail ou nome de usuário.`,
	'pt-pt': html`<a href="/support">Contacte o suporte</a> para obter ajuda para alterar o seu email ou nome de utilizador.`,
	ru: html`<a href="/support">Свяжитесь с поддержкой</a> для помощи в изменении электронной почты или имени пользователя.`,
	sm: html`<a href="/support">Faafesootai le lagolago</a> mo se fesoasoani e suia ai lau imeli po o le igoa faaaoga.`,
	so: html`<a href="/support">La xiriir taageerada</a> si aad u hesho caawimaad beddelidda email-kaaga ama username-kaaga.`,
	th: html`<a href="/support">ติดต่อฝ่ายสนับสนุน</a> เพื่อขอความช่วยเหลือในการเปลี่ยนอีเมลหรือชื่อผู้ใช้ของคุณ`,
	ur: html`اپنا ای میل یا یوزر نیم تبدیل کرنے میں مدد کے <a href="/support">لیے سپورٹ سے رابطہ کریں۔</a>`,
	vi: html`<a href="/support">Liên hệ với bộ phận hỗ trợ</a> để được hỗ trợ thay đổi email hoặc tên người dùng của bạn.`,
	'zh-hans': html`如需更改邮箱或用户名，<a href="/support">请联系客服</a>协助。`,
	'zh-hant': html`如需協助更改您的電子郵件或使用者名稱，<a href="/support">請聯絡客服</a>。`,
	en: html`<a href="/support">Contact support</a> for assistance changing your email or username.`
};

export const loc_contactUs: Record<Locale, string> = {
	ar: `تواصل معنا`,
	de: `Kontaktieren Sie uns`,
	es: `Contáctanos`,
	fa: `با ما تماس بگیرید`,
	fil: `Makipag-ugnayan sa amin`,
	fr: `Contactez-nous`,
	hi: `संपर्क करें`,
	ht: `Kontakte nou`,
	it: `Contattaci`,
	ja: `お問い合わせ`,
	ko: `문의해 주세요`,
	mww: `Tiv tauj peb`,
	ps: `له موږ سره اړیکه ونیسئ`,
	pt: `Entre em contato conosco`,
	'pt-pt': `Contacte-nos`,
	ru: `Свяжитесь с нами`,
	sm: `Fa'afeso'ota'i mai matou`,
	so: `Nala soo xiriir`,
	th: `ติดต่อเรา`,
	ur: `ہم سے رابطہ کریں`,
	vi: `Liên hệ với chúng tôi`,
	'zh-hans': `联系我们`,
	'zh-hant': `聯絡我們`,
	en: `Contact us`
};

export const loc_contactUsMarketingText: Record<Locale, string> = {
	ar: `تجعل Cumulus من السهل جمع الشركاء معا—حتى عبر أنظمة تكنولوجيا المعلومات المختلفة. من القبول والتقييم إلى تنسيق الرعاية وتتبع الإحالات، تساعد Cumulus الفرق على العمل كوحدة واحدة.`,
	de: `Cumulus macht es einfach, Partner zusammenzubringen – selbst über verschiedene IT-Systeme hinweg. Von der Aufnahme und Beurteilung über die Koordination der Versorgung bis hin zur Überweisungsverfolgung hilft Cumulus den Teams, als Einheit zusammenzuarbeiten.`,
	es: `Cumulus facilita la unión de socios, incluso a través de diferentes sistemas informáticos. Desde la admisión y evaluación hasta la coordinación de cuidados y el seguimiento de derivaciones, Cumulus ayuda a los equipos a trabajar como uno solo.`,
	fa: `Cumulus به راحتی می توان شرکا را گرد هم آورد—حتی در سیستم های مختلف فناوری اطلاعات. از پذیرش و ارزیابی گرفته تا هماهنگی مراقبت و پیگیری ارجاع، Cumulus به تیم ها کمک می کند تا به صورت یکپارچه کار کنند.`,
	fil: `Ginagawang madali ng Cumulus na pagsamahin ang mga kasosyo - kahit na sa iba't ibang mga sistema ng IT. Mula sa pagkuha at pagtatasa hanggang sa koordinasyon ng pangangalaga at pagsubaybay sa referral, tinutulungan ng Cumulus ang mga koponan na magtrabaho bilang isa.`,
	fr: `Cumulus facilite la réunification des partenaires — même à travers différents systèmes informatiques. De l’admission et l’évaluation à la coordination des soins et au suivi des orientations, Cumulus aide les équipes à fonctionner comme une seule personne.`,
	hi: `क्यूमुलस भागीदारों को एक साथ लाना आसान बनाता है - यहां तक कि विभिन्न आईटी प्रणालियों में भी। सेवन और मूल्यांकन से लेकर देखभाल समन्वय और रेफरल ट्रैकिंग तक, क्यूमुलस टीमों को एक के रूप में काम करने में मदद करता है।`,
	ht: `Cumulus fè li fasil yo pote patnè ansanm - menm atravè diferan sistèm IT. Soti nan konsomasyon ak evalyasyon nan kowòdinasyon swen ak swiv referans, Cumulus ede ekip travay kòm yon sèl.`,
	it: `Cumulus rende facile unire i partner—anche tra diversi sistemi IT. Dall'accoglienza e valutazione al coordinamento delle cure e al monitoraggio delle segnalazioni, Cumulus aiuta i team a lavorare come uno solo.`,
	ja: `Cumulusは、異なるITシステム間でもパートナーを簡単に結びつけることができます。受け入れや評価からケアの調整、紹介の追跡に至るまで、Cumulusはチームが一体となって働くのを支援します。`,
	ko: `Cumulus는 서로 다른 IT 시스템 간에 파트너를 쉽게 모을 수 있게 합니다. 접수 및 평가부터 케어 조정과 의뢰 추적에 이르기까지, Cumulus는 팀이 하나로 협력할 수 있도록 돕습니다.`,
	mww: `Cumulus ua rau nws yooj yim los coj cov neeg koom tes ua ke-txawm tias thoob plaws IT systems sib txawv. Los ntawm kev nkag thiab kev ntsuam xyuas mus rau kev saib xyuas kev saib xyuas thiab kev xa mus taug qab, Cumulus pab pab pawg ua haujlwm ua ib qho.`,
	ps: `Cumulus دا اسانه کوی چې شریکان سره راټول شی—حتی د مختلفو IT سیسټمونو په منځ کې. له داخلېدو او ارزونې څخه تر پاملرنې همغږۍ او راجع کولو تعقیب پورې، Cumulus ټیمونو سره مرسته کوی چې یو ځای کار وکړی.`,
	pt: `A Cumulus facilita a aproximação de parceiros — mesmo entre diferentes sistemas de TI. Desde a admissão e avaliação até a coordenação de cuidados e o acompanhamento de encaminhamentos, a Cumulus ajuda as equipes a funcionarem como uma só.`,
	'pt-pt': `A Cumulus facilita a aproximação de parceiros — mesmo em diferentes sistemas de TI. Desde a admissão e avaliação até à coordenação de cuidados e acompanhamento de encaminhamentos, a Cumulus ajuda as equipas a funcionar como uma só.`,
	ru: `Cumulus облегчает объединение партнеров — даже в разных ИТ-системах. От приёма и оценки до координации ухода и отслеживания направлений — Cumulus помогает командам работать как единое целое.`,
	sm: `Cumulus fa'afaigofie ona tu'ufa'atasia pa'aga-e o'o lava i faiga IT eseese. Mai le fa'aaogaina ma le iloiloga i le fa'amaopoopoina o le tausiga ma le siakiina o fa'asino atu, Cumulus fesoasoani i 'au e galulue o se tasi.`,
	so: `Cumulus waxay fududeysaa in la iskeeno la-hawlgalayaal—xitaa nidaamyada IT-ga ee kala duwan. Laga bilaabo qaadashada iyo qiimeynta ilaa isku-duwidda daryeelka iyo raadraaca tixraaca, Cumulus waxay ka caawisaa kooxaha inay si hal ah u shaqeeyaan.`,
	th: `Cumulus ทําให้การนําพาร์ทเนอร์มารวมกันเป็นเรื่องง่ายแม้ในระบบไอทีที่แตกต่างกัน ตั้งแต่การรับเข้าและการประเมินไปจนถึงการประสานงานการดูแลและการติดตามการส่งต่อ Cumulus ช่วยให้ทีมทํางานเป็นหนึ่งเดียว`,
	ur: `Cumulus شراکت داروں کو ایک ساتھ لانا آسان بناتا ہے—چاہے مختلف آئی ٹی سسٹمز میں ہی کیوں نہ ہوں۔ انٹیک اور تشخیص سے لے کر دیکھ بھال کی ہم آہنگی اور ریفرل ٹریکنگ تک، Cumulus ٹیموں کو ایک ساتھ کام کرنے میں مدد دیتا ہے۔`,
	vi: `Cumulus giúp bạn dễ dàng kết nối các đối tác lại với nhau—ngay cả trên các hệ thống CNTT khác nhau. Từ tiếp nhận và đánh giá đến điều phối chăm sóc và theo dõi giới thiệu, Cumulus giúp các nhóm làm việc như một.`,
	'zh-hans': `Cumulus使得跨不同IT系统的合作伙伴能够轻松聚集在一起。从接收和评估到护理协调和转诊跟踪，Cumulus帮助团队协作。`,
	'zh-hant': `Cumulus 讓跨 IT 系統的合作夥伴更容易聚集在一起。從接收與評估到照護協調與轉介追蹤，Cumulus 幫助團隊齊心協力。`,
	en: `Cumulus makes it easy to bring partners together—even across different IT systems. From intake and assessment to care coordination and referral tracking, Cumulus helps teams work as one.`
};

export const loc_contactUsToExplore: Record<Locale, string> = {
	ar: `تواصل معنا لاستكشاف كيف يمكنك الاستفادة القصوى من Cumulus!`,
	de: `Kontaktieren Sie uns, um herauszufinden, wie Sie das Beste aus Cumulus herausholen können!`,
	es: `¡Contáctanos para descubrir cómo puedes sacar el máximo partido a Cumulus!`,
	fa: `با ما تماس بگیرید تا ببینید چگونه می توانید بیشترین بهره را از Cumulus ببرید!`,
	fil: `Makipag-ugnay sa amin upang malaman kung paano mo makukuha ang pinaka-out ng Cumulus!`,
	fr: `Contactez-nous pour découvrir comment tirer le meilleur parti de Cumulus !`,
	hi: `यह जानने के लिए हमसे संपर्क करें कि आप क्यूम्यलस से अधिकतम लाभ कैसे प्राप्त कर सकते हैं!`,
	ht: `Kontakte nou yo eksplore ki jan ou ka jwenn pi plis soti nan Cumulus!`,
	it: `Contattaci per scoprire come ottenere il massimo da Cumulus!`,
	ja: `Cumulusを最大限に活用する方法をぜひご相談ください!`,
	ko: `Cumulus를 최대한 활용할 수 있는 방법을 알아보고 싶으시면 저희에게 연락해 주세요!`,
	mww: `Tiv tauj peb los tshawb nrhiav yuav ua li cas koj tuaj yeem tau txais txiaj ntsig zoo tshaj plaws ntawm Cumulus!`,
	ps: `موږ سره اړیکه ونیسئ ترڅو وګورئ څنګه کولی شئ له Cumulus څخه تر ټولو زیات ګټه واخلئ!`,
	pt: `Entre em contato conosco para descobrir como você pode aproveitar ao máximo a Cumulus!`,
	'pt-pt': `Contacte-nos para descobrir como pode tirar o máximo partido da Cumulus!`,
	ru: `Свяжитесь с нами, чтобы узнать, как вы можете получить максимум от Cumulus!`,
	sm: `Fa'afeso'ota'i mai matou e su'esu'e pe fa'afefea ona e maua le tele o mea mai Cumulus!`,
	so: `Nala soo xiriir si aad u ogaato sida aad uga faa'iideysan karto Cumulus!`,
	th: `ติดต่อเราเพื่อสํารวจว่าคุณจะได้รับประโยชน์สูงสุดจาก Cumulus ได้อย่างไร!`,
	ur: `ہم سے رابطہ کریں تاکہ آپ Cumulus سے زیادہ سے زیادہ فائدہ کیسے اٹھا سکتے ہیں!`,
	vi: `Liên hệ với chúng tôi để khám phá cách bạn có thể tận dụng tối đa Cumulus!`,
	'zh-hans': `联系我们，探索如何最大化利用Cumulus！`,
	'zh-hant': `歡迎聯絡我們，探索如何最大化 Cumulus 的效益！`,
	en: `Contact us to explore how you can get the most out of Cumulus!`
};

export const loc_contactUsTypePrompt: Record<Locale, string> = {
	ar: `بماذا يمكننا مساعدتك؟`,
	de: `Wobei können wir Ihnen helfen?`,
	es: `¿En qué podemos ayudarte?`,
	fa: `چه کمکی از دستمان برمی آید؟`,
	fil: `Ano ang matutulungan namin sa iyo?`,
	fr: `En quoi pouvons-nous vous aider ?`,
	hi: `हम आपकी क्या मदद कर सकते हैं?`,
	ht: `Kisa nou ka ede ou?`,
	it: `In cosa possiamo aiutarla?`,
	ja: `何のご用件でしょうか?`,
	ko: `무엇을 도와드릴까요?`,
	mww: `Peb tuaj yeem pab koj nrog dab tsi?`,
	ps: `موږ څنګه مرسته کولی شو؟`,
	pt: `Com o que podemos ajudar?`,
	'pt-pt': `Em que podemos ajudar?`,
	ru: `Чем мы можем вам помочь?`,
	sm: `O le a se mea e mafai ona matou fesoasoani ia te oe?`,
	so: `Maxaan ku caawin karnaa?`,
	th: `เราสามารถช่วยคุณอะไรได้บ้าง?`,
	ur: `ہم آپ کی کس طرح مدد کر سکتے ہیں؟`,
	vi: `Chúng tôi có thể giúp bạn điều gì?`,
	'zh-hans': `我们能帮您什么？`,
	'zh-hant': `我們能幫你什麼？`,
	en: `What can we help you with?`
};

export const loc_contactYourAdministrator: Record<Locale, string> = {
	ar: `تواصل مع المسؤول الخاص بك للحصول على المساعدة.`,
	de: `Kontaktieren Sie Ihren Administrator für Unterstützung.`,
	es: `Contacta con tu administrador para recibir ayuda.`,
	fa: `برای دریافت کمک با مدیر خود تماس بگیرید.`,
	fil: `Makipag-ugnay sa iyong administrator para sa tulong.`,
	fr: `Contactez votre administrateur pour obtenir de l’aide.`,
	hi: `सहायता के लिए अपने व्यवस्थापक से संपर्क करें.`,
	ht: `Kontakte administratè ou pou èd.`,
	it: `Contatta il tuo amministratore per assistenza.`,
	ja: `支援が必要な場合は管理者にお問い合わせください。`,
	ko: `도움이 필요하면 관리자에게 연락하세요.`,
	mww: `Hu rau koj tus thawj tswj hwm kom tau kev pab.`,
	ps: `د مرستې لپاره له خپل مدیر سره اړیکه ونیسئ.`,
	pt: `Entre em contato com seu administrador para obter assistência.`,
	'pt-pt': `Contacte o seu administrador para obter ajuda.`,
	ru: `Свяжитесь с администратором для получения помощи.`,
	sm: `Faafesootai lou pule mo se fesoasoani.`,
	so: `La xiriir maamulahaaga si aad u hesho caawimaad.`,
	th: `ติดต่อผู้ดูแลระบบของคุณเพื่อขอความช่วยเหลือ`,
	ur: `مدد کے لیے اپنے ایڈمنسٹریٹر سے رابطہ کریں۔`,
	vi: `Liên hệ với quản trị viên của bạn để được hỗ trợ.`,
	'zh-hans': `请联系您的管理员寻求帮助。`,
	'zh-hant': `請聯絡你的管理員尋求協助。`,
	en: `Contact your administrator for assistance.`
};

export const loc_continue: Record<Locale, string> = {
	ar: `تابع`,
	de: `Weitermachen`,
	es: `Continúa`,
	fa: `ادامه بده`,
	fil: `Magpatuloy`,
	fr: `Continuez`,
	hi: `आगे बढ़ना`,
	ht: `Kontinye`,
	it: `Continua`,
	ja: `続けてください`,
	ko: `계속`,
	mww: `txuas ntxiv`,
	ps: `دوام ورکړه`,
	pt: `Continue`,
	'pt-pt': `Continuar`,
	ru: `Продолжайте`,
	sm: `Fa'aauau`,
	so: `Sii wad`,
	th: `ดําเนินการต่อ`,
	ur: `جاری رکھیں`,
	vi: `Tiếp tục`,
	'zh-hans': `继续`,
	'zh-hant': `繼續`,
	en: `Continue`
};

export const loc_continueWithFormat: Record<Locale, (provider: unknown) => string> = {
	ar: (provider) => `تابع مع ${provider}`,
	de: (provider) => `Fahren Sie mit ${provider} fort`,
	es: (provider) => `Continúa con ${provider}`,
	fa: (provider) => `ادامه ${provider}`,
	fil: (provider) => `Magpatuloy sa ${provider}`,
	fr: (provider) => `Continuez avec ${provider}`,
	hi: (provider) => `${provider} के साथ जारी रखें`,
	ht: (provider) => `Kontinye ak ${provider}`,
	it: (provider) => `Continua con ${provider}`,
	ja: (provider) => `${provider}で続けてください`,
	ko: (provider) => `${provider}로 계속 이어가세요`,
	mww: (provider) => `Txuas ntxiv nrog ${provider}`,
	ps: (provider) => `له ${provider} سره دوام ورکړئ`,
	pt: (provider) => `Continue com ${provider}`,
	'pt-pt': (provider) => `Continue com ${provider}`,
	ru: (provider) => `Продолжайте с ${provider}`,
	sm: (provider) => `Fa'aauau pea ma ${provider}`,
	so: (provider) => `Sii wad ${provider}`,
	th: (provider) => `ดําเนินการต่อด้วย ${provider}`,
	ur: (provider) => `${provider} کے ساتھ جاری رکھیں`,
	vi: (provider) => `Tiếp tục với ${provider}`,
	'zh-hans': (provider) => `继续用 ${provider}`,
	'zh-hant': (provider) => `繼續用 ${provider}`,
	en: (provider) => `Continue with ${provider}`
};

export const loc_contract: Record<Locale, string> = {
	ar: `العقد`,
	de: `Vertrag`,
	es: `Contrato`,
	fa: `قرارداد`,
	fil: `Kontrata`,
	fr: `Contrat`,
	hi: `इक़रारनामा करना`,
	ht: `Kontra`,
	it: `Contratto`,
	ja: `契約`,
	ko: `계약`,
	mww: `Daim Ntawv Cog Lus`,
	ps: `قرارداد`,
	pt: `Contrato`,
	'pt-pt': `Contrato`,
	ru: `Контракт`,
	sm: `Konekarate`,
	so: `Qandaraaska`,
	th: `สัญญา`,
	ur: `معاہدہ`,
	vi: `Hợp đồng`,
	'zh-hans': `合同`,
	'zh-hant': `合約`,
	en: `Contract`
};

export const loc_contractedAnOrganization: Record<Locale, string> = {
	ar: `تعاقدت مع منظمة تشارك في هذا النشاط.`,
	de: `Beauftragte eine Organisation, die an dieser Aktivität beteiligt war.`,
	es: `Contratamos a una organización que participa en esta actividad.`,
	fa: `با سازمانی که در این فعالیت شرکت دارد قرارداد بست.`,
	fil: `Nakipag-ugnayan sa isang organisasyon na nakikilahok sa aktibidad na ito.`,
	fr: `A contracté une organisation participant à cette activité.`,
	hi: `इस गतिविधि में भाग लेने वाले एक संगठन को अनुबंधित किया।`,
	ht: `Kontrate yon òganizasyon k ap patisipe nan aktivite sa a.`,
	it: `Ha incaricato un'organizzazione che partecipa a questa attività.`,
	ja: `この活動に参加する組織と契約しました。`,
	ko: `이 활동에 참여하는 단체와 계약을 맺었습니다.`,
	mww: `Cog lus rau ib lub koom haum koom nrog txoj haujlwm no.`,
	ps: `ما د دې فعالیت په برخه کې د یوې ادارې قرارداد وکړ.`,
	pt: `Contratou uma organização que participe dessa atividade.`,
	'pt-pt': `Contratou uma organização que participe nesta atividade.`,
	ru: `Заключил контракт с организацией, участвующей в этой деятельности.`,
	sm: `Fa'afeso'ota'i se fa'alapotopotoga o lo'o auai i lenei gaoioiga.`,
	so: `Wuxuu qandaraas la galay urur ka qayb qaadanaya hawshan.`,
	th: `ทําสัญญากับองค์กรที่เข้าร่วมกิจกรรมนี้`,
	ur: `اس سرگرمی میں حصہ لینے والی ایک تنظیم سے معاہدہ کیا۔`,
	vi: `Đã ký hợp đồng với một tổ chức tham gia hoạt động này.`,
	'zh-hans': `签约了一个参与该活动的组织。`,
	'zh-hant': `與參與此活動的組織簽約。`,
	en: `Contracted an organization participating in this activity.`
};

export const loc_copy: Record<Locale, string> = {
	ar: `نسخة`,
	de: `Verstanden`,
	es: `Copiado`,
	fa: `کپی`,
	fil: `Kopyahin`,
	fr: `Bien reçu`,
	hi: `प्रतिलिपि`,
	ht: `Kopi`,
	it: `Ricevuto`,
	ja: `了解`,
	ko: `알겠습니다`,
	mww: `luam`,
	ps: `کاپی`,
	pt: `Cópia`,
	'pt-pt': `Cópia`,
	ru: `Принято`,
	sm: `Kopi`,
	so: `Fahmay`,
	th: `สําเนา`,
	ur: `نقل`,
	vi: `Sao chép`,
	'zh-hans': `收到`,
	'zh-hant': `收到`,
	en: `Copy`
};

export const loc_copyLink: Record<Locale, string> = {
	ar: `رابط النسخ`,
	de: `Link kopieren`,
	es: `Copiar enlace`,
	fa: `کپی لینک`,
	fil: `Email Address *`,
	fr: `Lien copié`,
	hi: `लिंक कॉपी करें`,
	ht: `Kopi lyen`,
	it: `Copia link`,
	ja: `リンクをコピーします`,
	ko: `링크 복사`,
	mww: `Luam qhov txuas`,
	ps: `کاپی لینک`,
	pt: `Copiar link`,
	'pt-pt': `Copiar link`,
	ru: `Скопировать ссылку`,
	sm: `Kopi sootaga`,
	so: `Nuqul link`,
	th: `คัดลอกลิงค์`,
	ur: `کاپی لنک`,
	vi: `Sao chép liên kết`,
	'zh-hans': `复制链接`,
	'zh-hant': `複製連結`,
	en: `Copy link`
};

export const loc_copyRecoveryCodeInstructions: Record<Locale, string> = {
	ar: `انسخ رمز الاستعادة هذا واحتفظ به في مكان آمن. ستحتاجه إذا احتجت يوما لتسجيل الدخول بدون جهازك.`,
	de: `Kopiere diesen Wiederherstellungscode und bewahre ihn an einem sicheren Ort auf. Du wirst es brauchen, falls du dich jemals ohne dein Gerät anmelden musst.`,
	es: `Copia este código de recuperación y guárdalo en un lugar seguro. La necesitarás si alguna vez necesitas iniciar sesión sin tu dispositivo.`,
	fa: `این کد بازیابی را کپی کنید و جایی امن نگه دارید. اگر روزی نیاز به ورود بدون دستگاه داشتید، به آن نیاز خواهید داشت.`,
	fil: `Kopyahin ang recovery code na ito at itago ito sa isang lugar na ligtas. Kakailanganin mo ito kung sakaling kailangan mong mag-log in nang wala ang iyong aparato.`,
	fr: `Copiez ce code de récupération et gardez-le en lieu sûr. Vous en aurez besoin si jamais vous devez vous connecter sans votre appareil.`,
	hi: `इस रिकवरी कोड को कॉपी करें और इसे कहीं सुरक्षित रखें। यदि आपको कभी भी अपने डिवाइस के बिना लॉग इन करने की आवश्यकता होती है तो आपको इसकी आवश्यकता होगी।`,
	ht: `Kopi kòd gerizon sa a epi kenbe li yon kote ki an sekirite. Ou pral bezwen li si ou janm bezwen ouvri sesyon an san yo pa aparèy ou an.`,
	it: `Copia questo codice di recupero e tienilo in un posto sicuro. Ti servirà se mai dovrai accedere senza il dispositivo.`,
	ja: `このリカバリーコードをコピーして安全な場所に保管しろ。もしデバイスなしでログインする必要がある場合、必ず必要になります。`,
	ko: `이 복구 코드를 복사해서 안전한 곳에 보관하세요. 기기 없이 로그인해야 할 때 필요할 때 꼭 필요합니다.`,
	mww: `Luam no rov qab code thiab cia nws nyob qhov chaw nyab xeeb. Koj yuav xav tau nws yog tias koj puas tau nkag mus yam tsis muaj koj lub cuab yeej.`,
	ps: `دا د بیا رغونې کوډ کاپی کړه او په خوندی ځای کې یې کېږده. که کله هم اړتیا وی چې بې له خپل آلې ننوتل وکړې، نو ته به ورته اړتیا ولرې.`,
	pt: `Copie esse código de recuperação e guarde em um lugar seguro. Você vai precisar dele se algum dia precisar fazer login sem seu dispositivo.`,
	'pt-pt': `Copie este código de recuperação e guarde-o num local seguro. Vais precisar dele se alguma vez precisares de iniciar sessão sem o teu dispositivo.`,
	ru: `Скопируйте этот код восстановления и храните его в безопасном месте. Он понадобится, если когда-нибудь нужно войти без устройства.`,
	sm: `Kopi lenei numera laiti toe faaleleia ma teu i se mea saogalemu. O le ae manaomia ai pe afai e te manaomia e alu i totonu e aunoa ma lau masini.`,
	so: `Nuqul ka qaad koodhkan soo kabashada oo meel ammaan ah ku hay. Waxaad u baahan doontaa haddii aad mar walba u baahato inaad gasho adigoon qalabkaaga wato.`,
	th: `คัดลอกรหัสกู้คืนนี้และเก็บไว้ในที่ปลอดภัย คุณจะต้องใช้มันหากคุณต้องการเข้าสู่ระบบโดยไม่ต้องใช้อุปกรณ์ของคุณ`,
	ur: `اس ریکوری کوڈ کو کاپی کریں اور اسے محفوظ جگہ پر رکھیں۔ اگر کبھی آپ کو اپنے ڈیوائس کے بغیر لاگ ان کرنا پڑے تو آپ کو اس کی ضرورت پڑے گی۔`,
	vi: `Sao chép mã khôi phục này và giữ nó ở nơi an toàn. Bạn sẽ cần nó nếu bạn cần đăng nhập mà không cần thiết bị của mình.`,
	'zh-hans': `复制这个恢复码，放在安全的地方。如果你需要在没有设备的情况下登录，你会需要它。`,
	'zh-hant': `複製這個復原碼，並妥善保管。如果你需要在沒有裝置的情況下登入，這功能會很重要。`,
	en: `Copy this recovery code and keep it somewhere safe. You’ll need it if you ever need to log in without your device.`
};

export const loc_copyShareableLink: Record<Locale, string> = {
	ar: `نسخ رابط قابل للمشاركة`,
	de: `Teilbarer Link kopieren`,
	es: `Copiar enlace compartible`,
	fa: `کپی لینک قابل اشتراک گذاری`,
	fil: `Kopyahin ang link na maaaring ibahagi`,
	fr: `Lien partageable à copier`,
	hi: `साझा करने योग्य लिंक की प्रतिलिपि बनाएँ`,
	ht: `Kopi lyen pataje`,
	it: `Copia link condividere`,
	ja: `共有可能なリンクをコピーします`,
	ko: `공유 가능한 링크 복사`,
	mww: `Luam qhov txuas sib koom`,
	ps: `شریکېدونکی لینک کاپی کړئ`,
	pt: `Copiar link compartilhável`,
	'pt-pt': `Copiar link partilhável`,
	ru: `Скопировать ссылку для обмена`,
	sm: `Kopi sootaga e mafai ona faasoa atu`,
	so: `Nuqul ka qaado xiriirka la wadaagi karo`,
	th: `คัดลอกลิงก์ที่แชร์ได้`,
	ur: `شیئر ایبل لنک کاپی کریں`,
	vi: `Sao chép liên kết có thể chia sẻ`,
	'zh-hans': `复制可分享链接`,
	'zh-hant': `複製可分享連結`,
	en: `Copy shareable link`
};

export const loc_country: Record<Locale, string> = {
	ar: `كانتري`,
	de: `Land`,
	es: `País`,
	fa: `کانتری`,
	fil: `Bansa`,
	fr: `Pays`,
	hi: `भूक्षेत्र`,
	ht: `Peyi a`,
	it: `Paese`,
	ja: `国`,
	ko: `국가`,
	mww: `Lub teb chaws`,
	ps: `کنټری`,
	pt: `País`,
	'pt-pt': `País`,
	ru: `Кантри`,
	sm: `Atunuu`,
	so: `Dalka`,
	th: `ประเทศ`,
	ur: `کنٹری`,
	vi: `Quốc gia`,
	'zh-hans': `乡村`,
	'zh-hant': `鄉村`,
	en: `Country`
};

export const loc_county: Record<Locale, string> = {
	ar: `المقاطعة`,
	de: `Bezirk`,
	es: `Condado`,
	fa: `شهرستان`,
	fil: `County`,
	fr: `Comté`,
	hi: `काउंटी`,
	ht: `Konte`,
	it: `Contea`,
	ja: `郡`,
	ko: `카운티`,
	mww: `Lub Nroog`,
	ps: `ولایت`,
	pt: `Condado`,
	'pt-pt': `Condado`,
	ru: `Графство`,
	sm: `Itumalo`,
	so: `Degmada`,
	th: `เคาน์ตี`,
	ur: `کاؤنٹی`,
	vi: `Quận`,
	'zh-hans': `县级`,
	'zh-hant': `縣`,
	en: `County`
};

export const loc_create: Record<Locale, string> = {
	ar: `اصنع`,
	de: `Erstellen Sie`,
	es: `Crear`,
	fa: `خلق کنید`,
	fil: `Lumikha`,
	fr: `Créer`,
	hi: `बनाएं`,
	ht: `Kreye`,
	it: `Crea`,
	ja: `作成`,
	ko: `창조`,
	mww: `tsim`,
	ps: `Create`,
	pt: `Criar`,
	'pt-pt': `Criar`,
	ru: `Создайте`,
	sm: `Fausia`,
	so: `Abuur`,
	th: `สร้าง`,
	ur: `تخلیق`,
	vi: `Tạo`,
	'zh-hans': `创作`,
	'zh-hant': `創作`,
	en: `Create`
};

export const loc_createADashboard: Record<Locale, string> = {
	ar: `إنشاء لوحة تحكم`,
	de: `Erstellen Sie ein Dashboard`,
	es: `Crea un panel de control`,
	fa: `ایجاد داشبورد`,
	fil: `Email Address *`,
	fr: `Créer un tableau de bord`,
	hi: `एक डैशबोर्ड बनाएं`,
	ht: `Kreye yon tablodbò`,
	it: `Crea una dashboard`,
	ja: `ダッシュボードを作成する`,
	ko: `대시보드 생성`,
	mww: `Tsim ib lub dashboard`,
	ps: `داشبورډ جوړ کړئ`,
	pt: `Crie um painel`,
	'pt-pt': `Crie um painel de controlo`,
	ru: `Создайте дашборд`,
	sm: `Fausia se dashboard`,
	so: `Samee dashboard`,
	th: `สร้างแดชบอร์ด`,
	ur: `ڈیش بورڈ بنائیں`,
	vi: `Tạo bảng thông tin`,
	'zh-hans': `创建一个仪表盘`,
	'zh-hant': `建立儀表板`,
	en: `Create a dashboard`
};

export const loc_createANewPerson: Record<Locale, string> = {
	ar: `أنشئ عميلا / مريضا / عضوا جديدا`,
	de: `Erstelle einen neuen Kunden / Patienten / Mitglied`,
	es: `Crea un nuevo cliente / paciente / miembro`,
	fa: `ایجاد یک مراجع / بیمار / عضو جدید`,
	fil: `Lumikha ng isang bagong kliyente / pasyente / miyembro`,
	fr: `Créer un nouveau client / patient / membre`,
	hi: `एक नया ग्राहक/रोगी/सदस्य बनाएं`,
	ht: `Kreye yon nouvo kliyan / pasyan / manm`,
	it: `Crea un nuovo cliente / paziente / membro`,
	ja: `新しいクライアント/患者/メンバーを作成する`,
	ko: `새로운 클라이언트 / 환자 / 회원 생성하기`,
	mww: `Tsim tus neeg siv khoom / tus neeg mob / tus tswv cuab tshiab`,
	ps: `یو نوی مراجع / ناروغ / غړی جوړ کړئ`,
	pt: `Crie um novo cliente / paciente / membro`,
	'pt-pt': `Crie um novo cliente / paciente / membro`,
	ru: `Создайте нового клиента / пациента / участника`,
	sm: `Fausia se tagata fou / tagata ma'i / tagata`,
	so: `Abuur macmiil cusub / bukaan / xubin`,
	th: `สร้างลูกค้า / ผู้ป่วย / สมาชิกใหม่`,
	ur: `نیا کلائنٹ / مریض / ممبر بنائیں`,
	vi: `Tạo khách hàng / bệnh nhân / thành viên mới`,
	'zh-hans': `创建一个新的客户/患者/会员`,
	'zh-hant': `建立新的客戶/病人/會員`,
	en: `Create a new client / patient / member`
};

export const loc_createANewReferral: Record<Locale, string> = {
	ar: `أنشئ توصية جديدة`,
	de: `Erstelle eine neue Empfehlung`,
	es: `Crea una nueva derivación`,
	fa: `یک معرفی نامه جدید ایجاد کنید`,
	fil: `Lumikha ng Bagong Referral`,
	fr: `Créez une nouvelle recommandation`,
	hi: `एक नया रेफ़रल बनाएं`,
	ht: `Kreye yon nouvo referans`,
	it: `Crea una nuova segnalazione`,
	ja: `新しい紹介を作成する`,
	ko: `새 의뢰 생성`,
	mww: `Tsim ib qho kev xa mus tshiab`,
	ps: `نوې معرفی نامه جوړه کړئ`,
	pt: `Crie uma nova indicação`,
	'pt-pt': `Crie uma nova referência`,
	ru: `Создайте новое направление`,
	sm: `Fausia se fa'asino fou`,
	so: `Samee tixraac cusub`,
	th: `สร้างการอ้างอิงใหม่`,
	ur: `نیا ریفرل بنائیں`,
	vi: `Tạo giới thiệu mới`,
	'zh-hans': `创建一个新的转诊`,
	'zh-hant': `建立新的轉介`,
	en: `Create a new referral`
};

export const loc_created: Record<Locale, string> = {
	ar: `تأسيس`,
	de: `Erstellt`,
	es: `Creación`,
	fa: `ایجاد شده`,
	fil: `Nilikha`,
	fr: `Création`,
	hi: `बनाया गया`,
	ht: `Te kreye`,
	it: `Creazione`,
	ja: `創設`,
	ko: `창조`,
	mww: `tsim`,
	ps: `جوړ شوی`,
	pt: `Criação`,
	'pt-pt': `Criação`,
	ru: `Создание`,
	sm: `Foafoaina`,
	so: `La abuuray`,
	th: `สร้าง`,
	ur: `تخلیق شدہ`,
	vi: `Đã tạo`,
	'zh-hans': `创作`,
	'zh-hant': `創作`,
	en: `Created`
};

export const loc_createDate: Record<Locale, string> = {
	ar: `تاريخ إنشاء`,
	de: `Erstellungsdatum`,
	es: `Fecha de creación`,
	fa: `تاریخ ایجاد`,
	fil: `Email Address *`,
	fr: `Date de création`,
	hi: `दिनांक बनाएँ`,
	ht: `Kreye dat`,
	it: `Data di creazione`,
	ja: `日付作成`,
	ko: `날짜 생성`,
	mww: `Tsim hnub`,
	ps: `د تاریخ جوړولو نېټه`,
	pt: `Data de criação`,
	'pt-pt': `Data de criação`,
	ru: `Дата создания`,
	sm: `Fatu aso`,
	so: `Taariikhda abuurista`,
	th: `วันที่สร้าง`,
	ur: `تاریخ بنائیں`,
	vi: `Ngày tạo`,
	'zh-hans': `创建日期`,
	'zh-hant': `建立日期`,
	en: `Create date`
};

export const loc_createdByLogin: Record<Locale, (login: unknown) => TemplateResult> = {
	ar: (login) => html`أنشأتها <span>${login}</span>`,
	de: (login) => html`Erstellt von <span>${login}</span>`,
	es: (login) => html`Creado por <span>${login}</span>`,
	fa: (login) => html`خلق شده <span>${login}</span>`,
	fil: (login) => html`Nilikha ni <span>${login}</span>`,
	fr: (login) => html`Créé par <span>${login}</span>`,
	hi: (login) => html`जेन द्वारा बनाया गया <span>${login}</span>`,
	ht: (login) => html`Te kreye pa <span>${login}</span>`,
	it: (login) => html`Creato da <span>${login}</span>`,
	ja: (login) => html`ジェ<span>${login}作成</span>`,
	ko: (login) => html`<span>${login}이 창작함</span>`,
	mww: (login) => html`Tsim los ntawm <span>${login}</span>`,
	ps: (login) => html`د جین لخوا جوړ شوی <span>${login}</span>`,
	pt: (login) => html`Criado por <span>${login}</span>`,
	'pt-pt': (login) => html`Criado por <span>${login}</span>`,
	ru: (login) => html`Создано <span>${login}</span>`,
	sm: (login) => html`Saunia e <span>${login}</span>`,
	so: (login) => html`Waxaa abuuray <span>${login}</span>`,
	th: (login) => html`สร้างโดย <span>${login}</span>`,
	ur: (login) => html`<span>${login}</span>`,
	vi: (login) => html`Tạo bởi <span>${login}</span>`,
	'zh-hans': (login) => html`由<span>${login}创作</span>`,
	'zh-hant': (login) => html`由<span>${login}創作</span>`,
	en: (login) => html`Created by <span>${login}</span>`
};

export const loc_createdByYou: Record<Locale, string> = {
	ar: `خلقت بواسطتك`,
	de: `Von dir erschaffen`,
	es: `Creado por ti`,
	fa: `خلق شده توسط تو`,
	fil: `Nilikha Mo`,
	fr: `Créé par toi`,
	hi: `आपके द्वारा बनाया गया`,
	ht: `Kreye pa ou`,
	it: `Creato da te`,
	ja: `あなたが作った`,
	ko: `네가 만든 거야`,
	mww: `Tsim los ntawm koj`,
	ps: `ستا لخوا جوړ شوی`,
	pt: `Criado por você`,
	'pt-pt': `Criado por ti`,
	ru: `Создано вами`,
	sm: `Faauta, sa ia lei faia ea mo oe se faataitaiga lelei?`,
	so: `Adiga ayaa abuuray`,
	th: `สร้างโดยคุณ`,
	ur: `تمہارے بنائے ہوئے`,
	vi: `Do bạn tạo ra`,
	'zh-hans': `由你创造`,
	'zh-hant': `由你創造`,
	en: `Created by you`
};

export const loc_createdByYourOrganization: Record<Locale, string> = {
	ar: `تم إنشاؤها من قبل منظمتك`,
	de: `Erstellt von Ihrer Organisation`,
	es: `Creado por tu organización`,
	fa: `ایجاد شده توسط سازمان شما`,
	fil: `Nilikha ng Iyong Organisasyon`,
	fr: `Créé par votre organisation`,
	hi: `आपके संगठन द्वारा बनाया गया`,
	ht: `Kreye pa òganizasyon ou an`,
	it: `Creato dalla tua organizzazione`,
	ja: `あなたの組織によって作成された`,
	ko: `귀하의 조직에서 제작했습니다`,
	mww: `Tsim los ntawm koj lub koom haum`,
	ps: `ستاسو د سازمان لخوا جوړ شوی`,
	pt: `Criado pela sua organização`,
	'pt-pt': `Criado pela sua organização`,
	ru: `Создано вашей организацией`,
	sm: `Fausiaina e lau fa'alapotopotoga`,
	so: `Waxaa abuuray ururkaaga`,
	th: `สร้างโดยองค์กรของคุณ`,
	ur: `آپ کی تنظیم نے تخلیق کیا`,
	vi: `Được tạo bởi tổ chức của bạn`,
	'zh-hans': `由贵组织创建`,
	'zh-hant': `由你們組織創建`,
	en: `Created by your organization`
};

export const loc_createdDateFormat: Record<Locale, (date: unknown) => TemplateResult> = {
	ar: (date) => html`تم إنشاؤه <span>${date}</span>`,
	de: (date) => html`Vor <span>${date} erstellt</span>`,
	es: (date) => html`Creado <span>${date}</span>`,
	fa: (date) => html`<span>${date}</span>`,
	fil: (date) => html`Nilikha <span>${date}</span>`,
	fr: (date) => html`Créé <span>${date}</span>`,
	hi: (date) => html`3 <span>${date} गया</span>`,
	ht: (date) => html`Created <span>${date}</span>`,
	it: (date) => html`Creato <span>${date}</span>`,
	ja: (date) => html`<span>${date}作成</span>`,
	ko: (date) => html`<span>${date} 작성됨</span>`,
	mww: (date) => html`Tsim <span>${date}</span>`,
	ps: (date) => html`<span>${date} جوړ شوی</span>`,
	pt: (date) => html`Criado <span>${date}</span>`,
	'pt-pt': (date) => html`Criado <span>${date}</span>`,
	ru: (date) => html`<span>${date}</span>`,
	sm: (date) => html`Foafoaina <span>${date}</span>`,
	so: (date) => html`Waxaa la abuuray <span>${date}</span>`,
	th: (date) => html`สร้างเมื่อ <span>${date}</span>`,
	ur: (date) => html`<span>${date} بنایا گیا</span>`,
	vi: (date) => html`Đã tạo <span>${date}</span>`,
	'zh-hans': (date) => html`创建 <span>${date}</span>`,
	'zh-hant': (date) => html`三<span>${date}建立</span>`,
	en: (date) => html`Created <span>${date}</span>`
};

export const loc_createdThisActivity: Record<Locale, string> = {
	ar: `أنشأت هذا النشاط.`,
	de: `Ich habe diese Aktivität erstellt.`,
	es: `Creé esta actividad.`,
	fa: `این فعالیت را ایجاد کردم.`,
	fil: `Nilikha ang aktibidad na ito.`,
	fr: `J’ai créé cette activité.`,
	hi: `इस गतिविधि को बनाया।`,
	ht: `Te kreye aktivite sa a.`,
	it: `Ho creato questa attività.`,
	ja: `このアクティビティを作りました。`,
	ko: `이 활동을 만들었어요.`,
	mww: `Tsim qhov kev ua no.`,
	ps: `دا فعالیت مې جوړ کړی.`,
	pt: `Criei essa atividade.`,
	'pt-pt': `Criei esta atividade.`,
	ru: `Создал это занятие.`,
	sm: `Fausiaina lenei gaoioiga.`,
	so: `Wuxuu abuuray hawshan.`,
	th: `สร้างกิจกรรมนี้`,
	ur: `میں نے یہ سرگرمی پیدا کی۔`,
	vi: `Đã tạo hoạt động này.`,
	'zh-hans': `创建了这个活动。`,
	'zh-hant': `我創建了這個活動。`,
	en: `Created this activity.`
};

export const loc_createTimesheet: Record<Locale, string> = {
	ar: `إنشاء جدول زمني`,
	de: `Stundenzettel erstellen`,
	es: `Crear hoja de horas`,
	fa: `ایجاد برگه زمان بندی`,
	fil: `Lumikha ng timesheet`,
	fr: `Créer une feuille de temps`,
	hi: `समय पत्रक बनाएँ`,
	ht: `Kreye Timesheet`,
	it: `Crea il foglio orario`,
	ja: `タイムシートの作成`,
	ko: `근무 시간표 작성`,
	mww: `Tsim daim ntawv teev sijhawm`,
	ps: `د وخت پاڼه جوړول`,
	pt: `Criar folha de ponto`,
	'pt-pt': `Criar folha de horas`,
	ru: `Создать табель рабочего времени`,
	sm: `Fatu le pepa o taimi`,
	so: `Abuur jadwalka waqtiga`,
	th: `สร้างไทม์ชีท`,
	ur: `ٹائم شیٹ بنائیں`,
	vi: `Tạo bảng chấm công`,
	'zh-hans': `制作工时表`,
	'zh-hant': `建立工時表`,
	en: `Create timesheet`
};

export const loc_createYourAccount: Record<Locale, string> = {
	ar: `أنشئ حسابك`,
	de: `Erstellen Sie Ihr Konto`,
	es: `Crea tu cuenta`,
	fa: `حساب کاربری خود را بسازید`,
	fil: `Email:`,
	fr: `Créez votre compte`,
	hi: `अपना खाता बनाएं`,
	ht: `Kreye kont ou`,
	it: `Crea il tuo account`,
	ja: `アカウント作成`,
	ko: `계정 생성`,
	mww: `Tsim koj tus account`,
	ps: `خپل حساب جوړ کړئ`,
	pt: `Crie sua conta`,
	'pt-pt': `Crie a sua conta`,
	ru: `Создайте свой аккаунт`,
	sm: `Fausia lau teuga tupe`,
	so: `Abuur akoonkaaga`,
	th: `สร้างบัญชีของคุณ`,
	ur: `اپنا اکاؤنٹ بنائیں`,
	vi: `Tạo tài khoản của bạn`,
	'zh-hans': `创建您的账户`,
	'zh-hant': `建立您的帳號`,
	en: `Create your account`
};

export const loc_creator: Record<Locale, string> = {
	ar: `المبدع`,
	de: `Schöpfer`,
	es: `Creador`,
	fa: `خالق`,
	fil: `Lumikha`,
	fr: `Créateur`,
	hi: `सृजनकर्ता`,
	ht: `kreyatè`,
	it: `Creatore`,
	ja: `クリエイター`,
	ko: `창조자`,
	mww: `Tus tsim`,
	ps: `خالق`,
	pt: `Criador`,
	'pt-pt': `Criador`,
	ru: `Создатель`,
	sm: `Foafoa`,
	so: `Abuuraha`,
	th: `ครีเอเตอร์`,
	ur: `تخلیق کار`,
	vi: `Người sáng tạo`,
	'zh-hans': `创作者`,
	'zh-hant': `創作者`,
	en: `Creator`
};

export const loc_cumulativeBalance: Record<Locale, string> = {
	ar: `الرصيد التراكمي`,
	de: `Kumulativer Saldo`,
	es: `Saldo acumulativo`,
	fa: `مانده تجمعی`,
	fil: `Pinagsama-samang balanse`,
	fr: `Solde cumulatif`,
	hi: `संचयी शेष`,
	ht: `Balans kimilatif`,
	it: `Saldo cumulativo`,
	ja: `累積残高`,
	ko: `누적 잔액`,
	mww: `Kev sib npaug sib npaug`,
	ps: `ټولیز توازن`,
	pt: `Saldo acumulado`,
	'pt-pt': `Saldo cumulativo`,
	ru: `Кумулятивный баланс`,
	sm: `Paleni faaputuputu`,
	so: `Isku-dheelitirka guud`,
	th: `ยอดคงเหลือสะสม`,
	ur: `مجموعی بیلنس`,
	vi: `Số dư tích lũy`,
	'zh-hans': `累积余额`,
	'zh-hant': `累積餘額`,
	en: `Cumulative balance`
};

export const loc_cumulusParticipantPortal: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `${cumulus} بوابة المشاركين`,
	de: (cumulus) => `${cumulus} Teilnehmerportal`,
	es: (cumulus) => `${cumulus} Portal de Participantes`,
	fa: (cumulus) => `${cumulus} پورتال شرکت کنندگان`,
	fil: (cumulus) => `${cumulus} Portal ng Kalahok`,
	fr: (cumulus) => `${cumulus} Portail des participants`,
	hi: (cumulus) => `${cumulus} प्रतिभागी पोर्टल`,
	ht: (cumulus) => `${cumulus} Patisipan Portal`,
	it: (cumulus) => `${cumulus} Portale Partecipanti`,
	ja: (cumulus) => `${cumulus} 参加者ポータル`,
	ko: (cumulus) => `${cumulus} 참여자 포털`,
	mww: (cumulus) => `${cumulus} Cov Neeg Koom Portal`,
	ps: (cumulus) => `${cumulus} د ګډونوال پورټل`,
	pt: (cumulus) => `${cumulus} Portal de Participantes`,
	'pt-pt': (cumulus) => `${cumulus} Portal de Participantes`,
	ru: (cumulus) => `${cumulus} Портал участников`,
	sm: (cumulus) => `${cumulus} Faitotoa a le Tagata Auai`,
	so: (cumulus) => `${cumulus} Albaabka Ka Qaybgalayaasha`,
	th: (cumulus) => `${cumulus} พอร์ทัลผู้เข้าร่วม`,
	ur: (cumulus) => `${cumulus} شرکاء کا پورٹل`,
	vi: (cumulus) => `${cumulus} Cổng thông tin người tham gia`,
	'zh-hans': (cumulus) => `${cumulus} 参与者门户`,
	'zh-hant': (cumulus) => `${cumulus} 參與者入口網站`,
	en: (cumulus) => `${cumulus} Participant Portal`
};

export const loc_currentAndUpcomingFormat: Record<Locale, (activityTitle: unknown, org: unknown) => string> = {
	ar: (activityTitle, org) => `أنشطة ${activityTitle} الحالية والقادمة من ${org}، مرتبة حسب المسافة من موقعك.`,
	de: (activityTitle, org) => `Aktuelle und kommende ${activityTitle} von ${org}, sortiert nach Entfernung zu Ihrem Standort.`,
	es: (activityTitle, org) => `Actividades actuales y próximas ${activityTitle} de ${org}, ordenadas por distancia desde tu ubicación.`,
	fa: (activityTitle, org) => `فعالیت ${activityTitle} توسط ${org}، مرتب شده بر اساس فاصله از محل سکونت.`,
	fil: (activityTitle, org) => `Kasalukuyan at paparating na mga aktibidad sa ${activityTitle} ng ${org}, na pinagsunod-sunod ayon sa distansya mula sa iyong lokasyon.`,
	fr: (activityTitle, org) => `Activités actuelles et à venir de ${activityTitle} de ${org}, classées par distance depuis votre localisation.`,
	hi: (activityTitle, org) => `${org} द्वारा वर्तमान और आगामी ${activityTitle} गतिविधियाँ, आपके स्थान से दूरी के आधार पर क्रमबद्ध की जाती हैं।`,
	ht: (activityTitle, org) => `Aktivite klinik ${activityTitle} aktyèl ak k ap vini yo pa ${org}, triye pa distans soti nan kote w ye a.`,
	it: (activityTitle, org) => `Attività attuali e future ${activityTitle} di ${org}, ordinate per distanza dalla tua sede.`,
	ja: (activityTitle, org) => `リ${org}による現在および今後の${activityTitle}の活動を、あなたの所在地からの距離順に整理しています。`,
	ko: (activityTitle, org) => `${org}의 현재 및 예정된 ${activityTitle}은 귀하의 위치와의 거리별로 정렬되어 있습니다.`,
	mww: (activityTitle, org) => `Cov kev ua ub no tam sim no thiab tom ntej no ${activityTitle} ${org}, txheeb raws qhov deb ntawm koj qhov chaw.`,
	ps: (activityTitle, org) => `د ${org} لخوا د ${activityTitle} اوسنی او راتلونکی فعالیتونه، چې ستاسو له ځایه د واټن له مخې ترتیب شوی.`,
	pt: (activityTitle, org) => `Atividades atuais e futuras ${activityTitle} da ${org}, organizadas por distância da sua localização.`,
	'pt-pt': (activityTitle, org) => `Atividades atuais e futuras ${activityTitle} da ${org}, ordenadas pela distância à sua localização.`,
	ru: (activityTitle, org) => `Текущие и предстоящие мероприятия ${activityTitle} от ${org}, отсортированные по расстоянию от вашего местоположения.`,
	sm: (activityTitle, org) => `O lo'o i ai nei ma le lumana'i o gaioiga a le ${activityTitle} e ${org}, fa'avasegaina i le mamao mai lou nofoaga.`,
	so: (activityTitle, org) => `Hawlaha hadda iyo kuwa soo socda ${activityTitle} ee ${org}, oo loo kala saaray masaafada ka fog goobtaada.`,
	th: (activityTitle, org) => `กิจกรรม ${activityTitle} ในปัจจุบันและที่กําลังจะเกิดขึ้นโดย ${org} เรียงตามระยะทางจากสถานที่ของคุณ`,
	ur: (activityTitle, org) => `${org} کی موجودہ اور آنے والی ${activityTitle} کی سرگرمیاں، جو آپ کے مقام سے فاصلے کے حساب سے ترتیب دی گئی ہیں۔`,
	vi: (activityTitle, org) => `Các hoạt động ${activityTitle} hiện tại và sắp tới theo ${org}, được sắp xếp theo khoảng cách từ vị trí của bạn.`,
	'zh-hans': (activityTitle, org) => `${org}提供的当前及即将开展${activityTitle}活动，按您所在地的距离排序。`,
	'zh-hant': (activityTitle, org) => `${org}目前及即將舉辦的${activityTitle}活動，依照您所在地區的距離排序。`,
	en: (activityTitle, org) => `Current and upcoming ${activityTitle} activities by ${org}, sorted by distance from your location.`
};

export const loc_currentLangSelection: Record<Locale, (name: unknown) => TemplateResult> = {
	ar: (name) => html`الاختيار الحالي: <strong>${name}</strong>`,
	de: (name) => html`Aktuelle Auswahl: <strong>${name}</strong>`,
	es: (name) => html`Selección actual: <strong>${name}</strong>`,
	fa: (name) => html`انتخاب فعلی: <strong>${name}</strong>`,
	fil: (name) => html`Kasalukuyang seleksyon: <strong>${name}</strong>`,
	fr: (name) => html`Sélection actuelle : <strong>${name}</strong>`,
	hi: (name) => html`वर्तमान चयन: <strong>${name}</strong>`,
	ht: (name) => html`Seleksyon aktyèl: <strong>${name}</strong>`,
	it: (name) => html`Selezione attuale: <strong>${name}</strong>`,
	ja: (name) => html`現在の選考: <strong>${name}</strong>`,
	ko: (name) => html`현재 선발: <strong>${name}</strong>`,
	mww: (name) => html`Kev xaiv tam sim no: <strong>${name}</strong>`,
	ps: (name) => html`اوسنی انتخاب: <strong>${name}</strong>`,
	pt: (name) => html`Seleção atual: <strong>${name}</strong>`,
	'pt-pt': (name) => html`Seleção atual: <strong>${name}</strong>`,
	ru: (name) => html`Текущий отбор: <strong>${name}</strong>`,
	sm: (name) => html`Filifiliga o lo'o i ai nei: <strong>${name}</strong>`,
	so: (name) => html`Xulashada hadda: <strong>${name}</strong>`,
	th: (name) => html`การเลือกปัจจุบัน: <strong>${name}</strong>`,
	ur: (name) => html`موجودہ انتخاب: <strong>${name}</strong>`,
	vi: (name) => html`Lựa chọn hiện tại: <strong>${name}</strong>`,
	'zh-hans': (name) => html`当前选择： <strong>${name}</strong>`,
	'zh-hant': (name) => html`目前選擇： <strong>${name}</strong>`,
	en: (name) => html`Current selection: <strong>${name}</strong>`
};

export const loc_currentPayPeriod: Record<Locale, string> = {
	ar: `فترة الدفع الحالية`,
	de: `Aktueller Abrechnungszeitraum`,
	es: `Periodo de pago actual`,
	fa: `دوره پرداخت فعلی`,
	fil: `Kasalukuyang panahon ng suweldo`,
	fr: `Période de paie actuelle`,
	hi: `वर्तमान वेतन अवधि`,
	ht: `Peryòd peman aktyèl la`,
	it: `Periodo di paga attuale`,
	ja: `現在の給与期間`,
	ko: `현재 급여 기간`,
	mww: `Lub sijhawm them nyiaj tam sim no`,
	ps: `اوسنی د معاش موده`,
	pt: `Período atual de pagamento`,
	'pt-pt': `Período de pagamento atual`,
	ru: `Текущий период оплаты`,
	sm: `Vaitau o totogi o loo i ai nei`,
	so: `Muddada mushaarka hadda`,
	th: `รอบระยะเวลาการจ่ายเงินปัจจุบัน`,
	ur: `موجودہ تنخواہ کی مدت`,
	vi: `Kỳ trả lương hiện tại`,
	'zh-hans': `当前薪酬周期`,
	'zh-hant': `目前薪資期間`,
	en: `Current pay period`
};

export const loc_customEmailAddress: Record<Locale, string> = {
	ar: `عنوان البريد الإلكتروني المخصص`,
	de: `Benutzerdefinierte E-Mail-Adresse`,
	es: `Dirección de correo electrónico personalizada`,
	fa: `آدرس ایمیل سفارشی`,
	fil: `Pasadyang email address`,
	fr: `Adresse e-mail personnalisée`,
	hi: `कस्टम ईमेल पता`,
	ht: `Adrès imel koutim`,
	it: `Indirizzo email personalizzato`,
	ja: `カスタムメールアドレス`,
	ko: `맞춤 이메일 주소`,
	mww: `Kev cai email chaw nyob`,
	ps: `دودیز برېښنالیک پته`,
	pt: `Endereço de e-mail personalizado`,
	'pt-pt': `Endereço de email personalizado`,
	ru: `Пользовательский адрес электронной почты`,
	sm: `Tuatusi imeli masani`,
	so: `Cinwaanka email-ka gaarka ah`,
	th: `ที่อยู่อีเมลที่กําหนดเอง`,
	ur: `کسٹم ای میل ایڈریس`,
	vi: `Địa chỉ email tùy chỉnh`,
	'zh-hans': `自定义电子邮件地址`,
	'zh-hant': `自訂電子郵件地址`,
	en: `Custom email address`
};

export const loc_customPhoneNumber: Record<Locale, string> = {
	ar: `رقم هاتف مخصص`,
	de: `Individuelle Telefonnummer`,
	es: `Número de teléfono personalizado`,
	fa: `شماره تلفن سفارشی`,
	fil: `Pasadyang numero ng telepono`,
	fr: `Numéro de téléphone personnalisé`,
	hi: `कस्टम फ़ोन नंबर`,
	ht: `Nimewo telefòn koutim`,
	it: `Numero di telefono personalizzato`,
	ja: `カスタム電話番号`,
	ko: `맞춤 전화번호`,
	mww: `Kev cai xov tooj`,
	ps: `دودیز تلیفون شمېره`,
	pt: `Número de telefone personalizado`,
	'pt-pt': `Número de telefone personalizado`,
	ru: `Индивидуальный номер телефона`,
	sm: `Numera telefoni masani`,
	so: `Lambarka telefoonka ee gaarka ah`,
	th: `หมายเลขโทรศัพท์ที่กําหนดเอง`,
	ur: `کسٹم فون نمبر`,
	vi: `Số điện thoại tùy chỉnh`,
	'zh-hans': `自定义电话号码`,
	'zh-hant': `自訂電話號碼`,
	en: `Custom phone number`
};

export const loc_darkColorblind: Record<Locale, string> = {
	ar: `بروتانوبيا المظلمة والديوتيرانوبيا`,
	de: `Dunkle Protanopie & Deuteranopie`,
	es: `Protanopía oscura y deuteranopía`,
	fa: `پروتانوپیا تاریک و دوترانوپیا`,
	fil: `Madilim na Protanopia at Deuteranopia`,
	fr: `Protanopie sombre et deutéranopie`,
	hi: `डार्क प्रोटानोपिया और ड्यूटेरानोपिया`,
	ht: `Nwa Protanopia & Deuteranopia`,
	it: `Protanopia Oscura e Deuteranopia`,
	ja: `ダークプロタノピアとデュウテラノピア`,
	ko: `다크 프로타노피아 및 도테라노피아`,
	mww: `Tsaus Protanopia & Deuteranopia`,
	ps: `توره پروتانوپیا او دیوترانوپیا`,
	pt: `Protanopia Escura e Deuteranopia`,
	'pt-pt': `Protanopia Escura e Deuteranopia`,
	ru: `Тёмная протанопия и дейтеранопия`,
	sm: `Pogisa Protanopia ma Deuteranopia`,
	so: `Dark Protanopia & Deuteranopia`,
	th: `โพรตาโนเปียมืด & ดิวเทราโนเปีย`,
	ur: `ڈارک پروٹانوپیا اور ڈیوٹیرانوپیا`,
	vi: `Protanopia đen & Deuteranopia`,
	'zh-hans': `暗色盲与杜特拉诺皮亚`,
	'zh-hant': `暗原生盲與杜特拉諾皮亞`,
	en: `Dark Protanopia & Deuteranopia`
};

export const loc_darkDefault: Record<Locale, string> = {
	ar: `الوضع المالي المظلم`,
	de: `Dark Default`,
	es: `Defecto Oscuro`,
	fa: `پیش فرض تاریک`,
	fil: `Madilim na Default`,
	fr: `Défaut Sombre`,
	hi: `डार्क डिफॉल्ट`,
	ht: `Nwa Default`,
	it: `Dark Default`,
	ja: `ダークデフォルト`,
	ko: `다크 디폴트`,
	mww: `Tsaus Ntuj Neej ntawd`,
	ps: `ډارک ډیفالټ`,
	pt: `Padrão Sombrio`,
	'pt-pt': `Padrão Sombrio`,
	ru: `Dark Default`,
	sm: `Pogisa Faaletonu`,
	so: `Dark Default`,
	th: `ค่าเริ่มต้นที่มืด`,
	ur: `ڈارک ڈیفالٹ`,
	vi: `Mặc định tối`,
	'zh-hans': `黑暗默认`,
	'zh-hant': `黑暗預設`,
	en: `Dark Default`
};

export const loc_darkDimmed: Record<Locale, string> = {
	ar: `الظلام الخافت`,
	de: `Dunkel gedimmt`,
	es: `Oscuridad Atenuada`,
	fa: `تاریک کم نور`,
	fil: `Madilim na Malabo`,
	fr: `Sombre Atténué`,
	hi: `डार्क डिम्ड`,
	ht: `Nwa Dimmed`,
	it: `Dark si affievoliva`,
	ja: `暗い`,
	ko: `어둠 어둠`,
	mww: `tsaus nti tsaus nti`,
	ps: `ډارک ډیمډ`,
	pt: `Escuridão Atenuada`,
	'pt-pt': `Escuridão Apagada`,
	ru: `Dark Dimmed`,
	sm: `Pogisa pogisa`,
	so: `Dark Dimmed`,
	th: `มืดสลัว`,
	ur: `ڈارک ڈمڈ`,
	vi: `Mờ tối`,
	'zh-hans': `黑暗暗淡`,
	'zh-hant': `黑暗暗淡`,
	en: `Dark Dimmed`
};

export const loc_darkHighContrast: Record<Locale, string> = {
	ar: `التباين العالي الداكن`,
	de: `Dunkel, hoher Kontrast`,
	es: `Alto contraste oscuro`,
	fa: `کنتراست تاریک بالا`,
	fil: `Madilim na Mataas na Pagkakaiba`,
	fr: `Contraste à fort contraste sombre`,
	hi: `डार्क हाई कंट्रास्ट`,
	ht: `Fè nwa kontras segondè`,
	it: `Scuro ad alto contrasto`,
	ja: `ダーク・ハイ・コントラスト`,
	ko: `다크 하이 콘트라스트`,
	mww: `Tsaus Siab Sib Piv`,
	ps: `تیاره لوړ کنټراست`,
	pt: `Alto Contraste Escuro`,
	'pt-pt': `Alto Contraste Escuro`,
	ru: `Тёмный высокий контраст`,
	sm: `Pogisa Maualuga Eseesega`,
	so: `Dark High Contrast`,
	th: `ความคมชัดสูงที่มืด`,
	ur: `ڈارک ہائی کنٹراسٹ`,
	vi: `Độ tương phản cao tối`,
	'zh-hans': `暗高对比`,
	'zh-hant': `暗高對比`,
	en: `Dark High Contrast`
};

export const loc_darkTritanopia: Record<Locale, string> = {
	ar: `تريتانوبيا المظلمة`,
	de: `Dunkle Tritanopie`,
	es: `Tritanopia Oscura`,
	fa: `تریتانوپیای تاریک`,
	fil: `Madilim na Tritanopia`,
	fr: `Tritanopie Sombre`,
	hi: `डार्क ट्रिटानोपिया`,
	ht: `Tritanopia fè nwa`,
	it: `Tritanopia Oscura`,
	ja: `ダーク・トリタノピア`,
	ko: `다크 트리타노피아`,
	mww: `Tsaus Tritanopia`,
	ps: `ډارک ټریټانوپیا`,
	pt: `Tritanopia Sombria`,
	'pt-pt': `Tritanopia Sombria`,
	ru: `Тёмная Тританопия`,
	sm: `Tritanopia pogisa`,
	so: `Tritanopia Madow`,
	th: `ทริทาโนเปียมืด`,
	ur: `ڈارک ٹرائیٹانوپیا`,
	vi: `Tritanopia đen tối`,
	'zh-hans': `暗三角洲`,
	'zh-hant': `黑暗三葉片`,
	en: `Dark Tritanopia`
};

export const loc_dashboard: Record<Locale, string> = {
	ar: `لوحة المعلومات`,
	de: `Armaturenbrett`,
	es: `Salpicadero`,
	fa: `داشبورد`,
	fil: `Dashboard`,
	fr: `Tableau de bord`,
	hi: `डैशबोर्ड`,
	ht: `Tablodbò`,
	it: `Cruscotto`,
	ja: `ダッシュボード`,
	ko: `대시보드`,
	mww: `Dashboard`,
	ps: `داشبورډ`,
	pt: `Painel`,
	'pt-pt': `Painel de instrumentos`,
	ru: `Панель управления`,
	sm: `Dashboard`,
	so: `Dashboard`,
	th: `แดชบอร์ด`,
	ur: `ڈیش بورڈ`,
	vi: `Bảng điều khiển`,
	'zh-hans': `仪表盘`,
	'zh-hant': `儀表板`,
	en: `Dashboard`
};

export const loc_dashboards: Record<Locale, string> = {
	ar: `لوحات المعلومات`,
	de: `Dashboards`,
	es: `Paneles`,
	fa: `داشبوردها`,
	fil: `Mga Dashboard`,
	fr: `Tableaux de bord`,
	hi: `डैशबोर्ड`,
	ht: `Tablodbò yo`,
	it: `Cruscotti`,
	ja: `ダッシュボード`,
	ko: `대시보드`,
	mww: `Dashboards`,
	ps: `ډشبورډ`,
	pt: `Painéis de controle`,
	'pt-pt': `Dashboards`,
	ru: `Дашборды`,
	sm: `Dashboard`,
	so: `Dashboards`,
	th: `แดชบอร์ด`,
	ur: `ڈیش بورڈز`,
	vi: `Bảng điều khiển`,
	'zh-hans': `仪表盘`,
	'zh-hant': `儀表板`,
	en: `Dashboards`
};

export const loc_date: Record<Locale, string> = {
	ar: `التاريخ`,
	de: `Datum`,
	es: `Fecha`,
	fa: `تاریخ`,
	fil: `Petsa`,
	fr: `Date`,
	hi: `तारीख`,
	ht: `Dat`,
	it: `Data`,
	ja: `日付`,
	ko: `날짜`,
	mww: `Hnub Tim`,
	ps: `نېټه`,
	pt: `Data`,
	'pt-pt': `Data`,
	ru: `Дата`,
	sm: `Aso`,
	so: `Taariikhda`,
	th: `วันที่`,
	ur: `تاریخ`,
	vi: `Ngày`,
	'zh-hans': `日期`,
	'zh-hant': `日期`,
	en: `Date`
};

export const loc_dateAtLocation: Record<Locale, (eventDate: unknown, location: unknown) => string> = {
	ar: (eventDate, location) => `${eventDate} في ${location}`,
	de: (eventDate, location) => `${eventDate} in ${location}`,
	es: (eventDate, location) => `5${eventDate} en ${location}`,
	fa: (eventDate, location) => `${eventDate} در ${location}`,
	fil: (eventDate, location) => `${eventDate} sa ${location}`,
	fr: (eventDate, location) => `${eventDate} au ${location}`,
	hi: (eventDate, location) => `${eventDate} ${location} पर`,
	ht: (eventDate, location) => `${eventDate} nan ${location}`,
	it: (eventDate, location) => `${eventDate} al ${location}`,
	ja: (eventDate, location) => `${eventDate}日、1メイン${location}にて`,
	ko: (eventDate, location) => `${eventDate} , 1 ${location}`,
	mww: (eventDate, location) => `${eventDate} ntawm ${location}`,
	ps: (eventDate, location) => `${eventDate} په ${location}`,
	pt: (eventDate, location) => `${eventDate} na ${location}`,
	'pt-pt': (eventDate, location) => `${eventDate} na ${location}`,
	ru: (eventDate, location) => `${eventDate} по адресу: ${location}`,
	sm: (eventDate, location) => `${eventDate} i ${location}`,
	so: (eventDate, location) => `${eventDate} 1 ${location}`,
	th: (eventDate, location) => `${eventDate} ที่ ${location}`,
	ur: (eventDate, location) => `${eventDate} ، ${location}`,
	vi: (eventDate, location) => `${eventDate} tại ${location}`,
	'zh-hans': (eventDate, location) => `${eventDate} 日，地点： ${location}`,
	'zh-hant': (eventDate, location) => `${eventDate} ，地點： ${location}`,
	en: (eventDate, location) => `${eventDate} at ${location}`
};

export const loc_dates: Record<Locale, string> = {
	ar: `التواريخ`,
	de: `Daten`,
	es: `Fechas`,
	fa: `تاریخ ها`,
	fil: `Mga Petsa`,
	fr: `Dates`,
	hi: `खजूर`,
	ht: `Dat yo`,
	it: `Date`,
	ja: `日付`,
	ko: `날짜`,
	mww: `Hnub tim`,
	ps: `نیټې`,
	pt: `Datas`,
	'pt-pt': `Datas`,
	ru: `Даты`,
	sm: `Aso`,
	so: `Taariikhaha`,
	th: `วันที่`,
	ur: `تاریخیں`,
	vi: `Ngày`,
	'zh-hans': `日期`,
	'zh-hant': `日期`,
	en: `Dates`
};

export const loc_daysWorked: Record<Locale, string> = {
	ar: `أيام العمل`,
	de: `Gearbeitete Tage`,
	es: `Días trabajados`,
	fa: `روزهای کار`,
	fil: `Mga araw na nagtrabaho`,
	fr: `Jours de travail`,
	hi: `काम किए गए दिन`,
	ht: `Jou travay`,
	it: `Giornate lavorate`,
	ja: `労働日数`,
	ko: `근무 시간`,
	mww: `Hnub ua haujlwm`,
	ps: `ورځې چې کار کوی`,
	pt: `Dias trabalhados`,
	'pt-pt': `Dias trabalhados`,
	ru: `Рабочие дни`,
	sm: `Aso faigaluega`,
	so: `Maalmo la shaqeeyay`,
	th: `วันทํางาน`,
	ur: `کام کے دن`,
	vi: `Số ngày làm việc`,
	'zh-hans': `工作日数`,
	'zh-hant': `工作日`,
	en: `Days worked`
};

export const loc_delete: Record<Locale, string> = {
	ar: `حذف`,
	de: `Löschen`,
	es: `Borrar`,
	fa: `حذف`,
	fil: `Tanggalin`,
	fr: `Supprimer`,
	hi: `मिटाना`,
	ht: `Efase`,
	it: `Elimina`,
	ja: `削除`,
	ko: `삭제`,
	mww: `Rho tawm`,
	ps: `حذف کړه`,
	pt: `Excluir`,
	'pt-pt': `Eliminar`,
	ru: `Удалить`,
	sm: `Aveese`,
	so: `Tirtir`,
	th: `ลบ`,
	ur: `حذف کریں`,
	vi: `Xóa`,
	'zh-hans': `删除`,
	'zh-hant': `刪除`,
	en: `Delete`
};

export const loc_deleteConfirmation: Record<Locale, (title: unknown) => string> = {
	ar: (title) => `هل أنت متأكد أنك تريد حذف "${title}"؟`,
	de: (title) => `Bist du sicher, dass du "${title}" löschen willst?`,
	es: (title) => `¿Estás seguro de que quieres borrar "${title}"?`,
	fa: (title) => `مطمئنی می خوای «${title}» رو حذف کنی؟`,
	fil: (title) => `Sigurado ka bang gusto mong tanggalin ang "${title}"?`,
	fr: (title) => `Êtes-vous sûr de vouloir supprimer « ${title} » ?`,
	hi: (title) => `क्या आप वाकई "${title} को हटाना चाहते हैं?`,
	ht: (title) => `Ou sèten ou vle efase "${title}"?`,
	it: (title) => `Sei sicuro di voler cancellare "${title}"?`,
	ja: (title) => `「${title}」を削除したいのですか?`,
	ko: (title) => `"${title}를 삭제할 거 확실해?`,
	mww: (title) => `Koj puas paub tseeb tias koj xav rho tawm "${title}"?`,
	ps: (title) => `ته ډاډه یې چې "${title}" حذف کول غواړې؟`,
	pt: (title) => `Você tem certeza de que quer deletar "${title}"?`,
	'pt-pt': (title) => `Tens a certeza que queres apagar "${title}"?`,
	ru: (title) => `Вы уверены, что хотите удалить «${title}»?`,
	sm: (title) => `E te mautinoa e te mana'o e aveese le "${title}"?`,
	so: (title) => `Ma hubtaa inaad rabto inaad tirtirto "${title}"?`,
	th: (title) => `คุณแน่ใจหรือไม่ว่าต้องการลบ "${title}"`,
	ur: (title) => `کیا آپ واقعی "${title}" کو حذف کرنا چاہتے ہیں؟`,
	vi: (title) => `Bạn có chắc chắn muốn xóa "${title}" không?`,
	'zh-hans': (title) => `你确定要删除“${title}氏”吗？`,
	'zh-hant': (title) => `你確定要刪除「${title}」嗎？`,
	en: (title) => `Are you sure you want to delete "${title}"?`
};

export const loc_deleteEntry: Record<Locale, string> = {
	ar: `حذف المدخل`,
	de: `Eintrag löschen`,
	es: `Eliminar entrada`,
	fa: `حذف ورودی`,
	fil: `Tanggalin ang entry`,
	fr: `Supprimer l’entrée`,
	hi: `प्रविष्टि हटाएं`,
	ht: `Efase antre`,
	it: `Elimina la voce`,
	ja: `エントリを削除`,
	ko: `항목 삭제`,
	mww: `Rho tawm nkag`,
	ps: `ننوت حذف کړئ`,
	pt: `Excluir entrada`,
	'pt-pt': `Eliminar entrada`,
	ru: `Удалить запись`,
	sm: `Aveese le tusiga`,
	so: `Tirtir qoraalka`,
	th: `ลบรายการ`,
	ur: `اندراج حذف کریں`,
	vi: `Xóa mục nhập`,
	'zh-hans': `删除条目`,
	'zh-hant': `刪除條目`,
	en: `Delete entry`
};

export const loc_deletePerson: Record<Locale, string> = {
	ar: `حذف الشخص`,
	de: `Person löschen`,
	es: `Eliminar persona`,
	fa: `حذف شخص`,
	fil: `Tanggalin ang tao`,
	fr: `Supprimer la personne`,
	hi: `व्यक्ति को मिटाना`,
	ht: `Efase moun`,
	it: `Elimina persona`,
	ja: `人を削除`,
	ko: `사람 삭제`,
	mww: `Rho tawm tus neeg`,
	ps: `شخص حذف کړئ`,
	pt: `Excluir pessoa`,
	'pt-pt': `Eliminar pessoa`,
	ru: `Удалить человека`,
	sm: `Aveese le tagata`,
	so: `Qof tirtir`,
	th: `ลบบุคคล`,
	ur: `شخص کو حذف کریں`,
	vi: `Xóa người`,
	'zh-hans': `删除人`,
	'zh-hant': `刪除人`,
	en: `Delete person`
};

export const loc_deleteSignature: Record<Locale, string> = {
	ar: `حذف التوقيع`,
	de: `Signatur löschen`,
	es: `Eliminar firma`,
	fa: `حذف امضا`,
	fil: `Tanggalin ang lagda`,
	fr: `Supprimer la signature`,
	hi: `हस्ताक्षर हटाना`,
	ht: `Efase siyati`,
	it: `Elimina firma`,
	ja: `署名を削除`,
	ko: `서명 삭제`,
	mww: `Rho tawm kos npe`,
	ps: `لاسلیک حذف کړئ`,
	pt: `Excluir assinatura`,
	'pt-pt': `Eliminar assinatura`,
	ru: `Удалить подпись`,
	sm: `Tape le saini`,
	so: `Tirtir saxiixa`,
	th: `ลบลายเซ็น`,
	ur: `دستخط حذف کریں`,
	vi: `Xóa chữ ký`,
	'zh-hans': `删除签名`,
	'zh-hant': `刪除簽章`,
	en: `Delete signature`
};

export const loc_deleteTitle: Record<Locale, (title: unknown) => string> = {
	ar: (title) => `حذف ${title}`,
	de: (title) => `${title} löschen`,
	es: (title) => `Eliminar ${title}`,
	fa: (title) => `${title} را حذف کنید`,
	fil: (title) => `Tanggalin ${title}`,
	fr: (title) => `Supprimer ${title}`,
	hi: (title) => `${title} हटाएं`,
	ht: (title) => `Efase ${title}`,
	it: (title) => `Elimina ${title}`,
	ja: (title) => `${title}を削除`,
	ko: (title) => `${title} 삭제`,
	mww: (title) => `Rho tawm ${title}`,
	ps: (title) => `${title} حذف کړه`,
	pt: (title) => `${title}`,
	'pt-pt': (title) => `Eliminar ${title}`,
	ru: (title) => `Удалить ${title}`,
	sm: (title) => `Aveese ${title}`,
	so: (title) => `${title}`,
	th: (title) => `ลบ ${title}`,
	ur: (title) => `${title} کو حذف کریں`,
	vi: (title) => `Xóa ${title}`,
	'zh-hans': (title) => `删除 ${title}`,
	'zh-hant': (title) => `刪除 ${title}`,
	en: (title) => `Delete ${title}`
};

export const loc_denyTimesheet: Record<Locale, string> = {
	ar: `رفض جدول التوقيت`,
	de: `Zeiterfassung abweisen`,
	es: `Rechazar hoja de horas`,
	fa: `رد برگه زمان`,
	fil: `Tanggihan ang timesheet`,
	fr: `Refuser la feuille de temps`,
	hi: `टाइमशीट को अस्वीकार करें`,
	ht: `Refize Timesheet`,
	it: `Nega il foglio orario`,
	ja: `タイムシート拒否`,
	ko: `근무 기록 거부`,
	mww: `Tsis kam lees daim ntawv teev sijhawm`,
	ps: `د وخت پاڼه رد کړه`,
	pt: `Negar folha de ponto`,
	'pt-pt': `Negar folha de horas`,
	ru: `Табель отклонения`,
	sm: `Teena le pepa o taimi`,
	so: `Diido jadwalka waqtiga`,
	th: `ปฏิเสธไทม์ชีท`,
	ur: `ٹائم شیٹ سے انکار کریں`,
	vi: `Từ chối bảng chấm công`,
	'zh-hans': `拒绝工时表`,
	'zh-hant': `拒絕工時表`,
	en: `Deny timesheet`
};

export const loc_description: Record<Locale, string> = {
	ar: `الوصف`,
	de: `Beschreibung`,
	es: `Descripción`,
	fa: `توضیحات`,
	fil: `Paglalarawan`,
	fr: `Description`,
	hi: `या क़िस्‍म`,
	ht: `Deskripsyon`,
	it: `Descrizione`,
	ja: `概要`,
	ko: `설명`,
	mww: `Kev piav qhia`,
	ps: `توضیحات`,
	pt: `Descrição`,
	'pt-pt': `Descrição`,
	ru: `Описание`,
	sm: `Faamatalaga`,
	so: `Sharaxaad`,
	th: `คําอธิบาย`,
	ur: `تفصیل`,
	vi: `Sự miêu tả`,
	'zh-hans': `描述`,
	'zh-hant': `描述`,
	en: `Description`
};

export const loc_descriptionRecord: Record<Locale, string> = {
	ar: `الوصف / السجل`,
	de: `Beschreibung / Aufzeichnung`,
	es: `Descripción / registro`,
	fa: `توضیحات / سوابق`,
	fil: `Paglalarawan / talaan`,
	fr: `Description / dossier`,
	hi: `विवरण/रिकॉर्ड`,
	ht: `Deskripsyon / dosye`,
	it: `Descrizione / record`,
	ja: `説明/記録`,
	ko: `설명 / 기록`,
	mww: `Cov lus piav qhia / cov ntaub ntawv`,
	ps: `تشریح / ریکارډ`,
	pt: `Descrição / registro`,
	'pt-pt': `Descrição / registo`,
	ru: `Описание / запись`,
	sm: `Fa'amatalaga / fa'amaumauga`,
	so: `Sharaxaad / rikoodh`,
	th: `คําอธิบาย / บันทึก`,
	ur: `تفصیل / ریکارڈ`,
	vi: `Mô tả / hồ sơ`,
	'zh-hans': `描述 / 记录`,
	'zh-hant': `描述 / 紀錄`,
	en: `Description / record`
};

export const loc_deselectWetInk: Record<Locale, string> = {
	ar: `إلغاء اختيار الحبر الرطب`,
	de: `Nass-Tinte deaktivieren`,
	es: `Desseleccionar tinta húmeda`,
	fa: `لغو انتخاب جوهر مرطوب`,
	fil: `I-deselect ang wet ink`,
	fr: `Désélectionner l’encre humide`,
	hi: `गीली स्याही का चयन रद्द करें`,
	ht: `Deselect lank mouye`,
	it: `Deseleziona l'inchiostro umido`,
	ja: `ウェットインクの選択解除`,
	ko: `젖은 잉크 선택 해제`,
	mww: `Deselect tus cwj mem ntub`,
	ps: `د لوند رنګ انتخاب لغوه کړئ`,
	pt: `Desselecionar tinta úmida`,
	'pt-pt': `Desselecionar tinta húmida`,
	ru: `Отменить выбор влажных чернил`,
	sm: `Aveese le filifilia o le vaitusi susu`,
	so: `Ka saar doorashada khad qoyan`,
	th: `ยกเลิกการเลือกหมึกเปียก`,
	ur: `گیلی سیاہی کو غیر منتخب کریں`,
	vi: `Bỏ chọn mực ướt`,
	'zh-hans': `取消选择湿墨水`,
	'zh-hant': `取消選擇濕墨水`,
	en: `Deselect wet ink`
};

export const loc_details: Record<Locale, string> = {
	ar: `تفاصيل`,
	de: `Details`,
	es: `Detalles`,
	fa: `جزئیات`,
	fil: `Mga Detalye`,
	fr: `Détails`,
	hi: `विवरण`,
	ht: `Detay`,
	it: `Dettagli`,
	ja: `詳細`,
	ko: `세부 사항`,
	mww: `Cov ntsiab lus`,
	ps: `تفصیلات`,
	pt: `Detalhes`,
	'pt-pt': `Detalhes`,
	ru: `Подробности`,
	sm: `Auiliiliga`,
	so: `Faahfaahin`,
	th: `รายละเอียด`,
	ur: `تفصیلات`,
	vi: `Thông tin chi tiết`,
	'zh-hans': `详情`,
	'zh-hant': `詳情`,
	en: `Details`
};

export const loc_didYouKnow: Record<Locale, string> = {
	ar: `هل كنت تعلم أنه يمكنك استخدام Cumulus لبرامج أخرى؟`,
	de: `Wusstest du, dass man Cumulus für andere Programme nutzen kann?`,
	es: `¿Sabías que puedes usar Cumulus para otros programas?`,
	fa: `آیا می دانستید که می توانید از Cumulus برای برنامه های دیگر هم استفاده کنید؟`,
	fil: `Alam mo ba na maaari mong gamitin ang Cumulus para sa iba pang mga programa?`,
	fr: `Saviez-vous que vous pouvez utiliser Cumulus pour d’autres programmes ?`,
	hi: `क्या आप जानते हैं कि आप अन्य कार्यक्रमों के लिए क्यूम्यलस का उपयोग कर सकते हैं?`,
	ht: `Èske w te konnen ou ka itilize Cumulus pou lòt pwogram?`,
	it: `Sapevi che puoi usare Cumulus per altri programmi?`,
	ja: `Cumulusは他のプログラムでも使えるって知ってた?`,
	ko: `Cumulus를 다른 프로그램에도 사용할 수 있다는 사실 알고 계셨나요?`,
	mww: `Koj puas paub tias koj tuaj yeem siv Cumulus rau lwm cov kev pab cuam?`,
	ps: `ته پوهېدې چې Cumulus ته د نورو پروګرامونو لپاره هم کارول کېدای شی؟`,
	pt: `Você sabia que pode usar o Cumulus para outros programas?`,
	'pt-pt': `Sabias que podes usar o Cumulus para outros programas?`,
	ru: `Знаете ли вы, что Cumulus можно использовать и для других программ?`,
	sm: `Na e iloa e mafai ona e fa'aaogaina le Cumulus mo isi polokalama?`,
	so: `Ma ogtahay inaad Cumulus u isticmaali karto barnaamijyo kale?`,
	th: `คุณรู้หรือไม่ว่าคุณสามารถใช้ Cumulus สําหรับโปรแกรมอื่นได้`,
	ur: `کیا آپ جانتے ہیں کہ آپ Cumulus کو دوسرے پروگرامز کے لیے بھی استعمال کر سکتے ہیں؟`,
	vi: `Bạn có biết bạn có thể sử dụng Cumulus cho các chương trình khác không?`,
	'zh-hans': `你知道Cumulus也可以用来做其他项目吗？`,
	'zh-hant': `你知道 Cumulus 也可以用來做其他程式嗎？`,
	en: `Did you know you can use Cumulus for other programs?`
};

export const loc_distance: Record<Locale, string> = {
	ar: `المسافة`,
	de: `Entfernung`,
	es: `Distancia`,
	fa: `فاصله`,
	fil: `Distansya`,
	fr: `Distance`,
	hi: `दूरी`,
	ht: `Distans`,
	it: `Distanza`,
	ja: `距離`,
	ko: `거리`,
	mww: `Kev ncua deb`,
	ps: `فاصله`,
	pt: `Distância`,
	'pt-pt': `Distância`,
	ru: `Расстояние`,
	sm: `Mamao`,
	so: `Masaafada`,
	th: `ระยะทาง`,
	ur: `فاصلہ`,
	vi: `Khoảng cách`,
	'zh-hans': `距离`,
	'zh-hant': `距離`,
	en: `Distance`
};

export const loc_distanceFormat: Record<Locale, (distance: unknown, location: unknown) => string> = {
	ar: (distance, location) => `${distance} من ${location}`,
	de: (distance, location) => `${distance} von ${location} entfernt`,
	es: (distance, location) => `${distance} desde ${location}`,
	fa: (distance, location) => `${distance} از ${location} فاصله دارد`,
	fil: (distance, location) => `${distance} mula sa ${location}`,
	fr: (distance, location) => `${distance} depuis ${location}`,
	hi: (distance, location) => `54 ${location} ${distance} पर`,
	ht: (distance, location) => `${distance} soti nan ${location}`,
	it: (distance, location) => `${distance} da ${location}`,
	ja: (distance, location) => `バー${location}番地から${distance}`,
	ko: (distance, location) => `12 다이아몬드 스트리트에서 ${distance} 떨어진 세${location}`,
	mww: (distance, location) => `${distance} ntawm ${location}`,
	ps: (distance, location) => `${distance} له ۱۲ ${location} څخه`,
	pt: (distance, location) => `${distance} a ${location}`,
	'pt-pt': (distance, location) => `${distance} a partir do ${location}`,
	ru: (distance, location) => `${distance} от ${location}`,
	sm: (distance, location) => `${distance} mai le ${location}`,
	so: (distance, location) => `${distance} laga bilaabo ${location}`,
	th: (distance, location) => `${distance} จาก ${location}`,
	ur: (distance, location) => `${location} سے ${distance} دور`,
	vi: (distance, location) => `Cách ${location} ${distance}`,
	'zh-hans': (distance, location) => `距离${location}号${distance}`,
	'zh-hant': (distance, location) => `距離${location}號${distance}`,
	en: (distance, location) => `${distance} from ${location}`
};

export const loc_distanceFromYourLocationFormat: Record<Locale, (distance: unknown) => string> = {
	ar: (distance) => `${distance} أميال من موقعك`,
	de: (distance) => `${distance} Meilen von Ihrem Standort entfernt`,
	es: (distance) => `${distance} millas de tu ubicación`,
	fa: (distance) => `${distance} مایل از محل شما فاصله دارد`,
	fil: (distance) => `${distance} km mula sa iyong lokasyon`,
	fr: (distance) => `${distance} miles de votre position`,
	hi: (distance) => `आपके स्थान से ${distance} मील की दूरी पर`,
	ht: (distance) => `${distance} mil soti nan kote ou ye`,
	it: (distance) => `${distance} miglia dalla tua posizione`,
	ja: (distance) => `あなたの場所から${distance}マイル`,
	ko: (distance) => `당신 위치에서 ${distance}마일 떨어져 있습니다`,
	mww: (distance) => `${distance} mais ntawm koj qhov chaw nyob`,
	ps: (distance) => `ستاسو له ځایه ${distance} میل لرې`,
	pt: (distance) => `${distance} milhas da sua localização`,
	'pt-pt': (distance) => `${distance} milhas da sua localização`,
	ru: (distance) => `${distance} миль от вашего места`,
	sm: (distance) => `${distance} maila mai lou nofoaga`,
	so: (distance) => `${distance} mayl ka fog meesha aad joogtay`,
	th: (distance) => `${distance} กม. จากตําแหน่งของคุณ`,
	ur: (distance) => `آپ کے مقام سے ${distance} میل دور`,
	vi: (distance) => `${distance} dặm từ vị trí của bạn`,
	'zh-hans': (distance) => `距离你所在地${distance}英里`,
	'zh-hant': (distance) => `距離你所在地${distance}英里`,
	en: (distance) => `${distance} miles from your location`
};

export const loc_district: Record<Locale, string> = {
	ar: `المنطقة`,
	de: `Bezirk`,
	es: `Distrito`,
	fa: `حوزه انتخابیه`,
	fil: `Distrito`,
	fr: `Circonscription`,
	hi: `जिला`,
	ht: `Distri a`,
	it: `Distretto`,
	ja: `地区`,
	ko: `지구`,
	mww: `Cheeb Tsam Tsev Kawm`,
	ps: `ولسوالۍ`,
	pt: `Distrito`,
	'pt-pt': `Distrito`,
	ru: `Округ`,
	sm: `Itumalo`,
	so: `Degmada`,
	th: `เขต`,
	ur: `ضلع`,
	vi: `Quận`,
	'zh-hans': `区`,
	'zh-hant': `選區`,
	en: `District`
};

export const loc_dob: Record<Locale, string> = {
	ar: `تاريخ الميلاد`,
	de: `Geburtstag`,
	es: `DATA de nacimiento`,
	fa: `تاریخ تولد`,
	fil: `Tangga ng Batas`,
	fr: `Date de naissance`,
	hi: `जन्म तिथि`,
	ht: `KOTE`,
	it: `Data di nascita`,
	ja: `生年月日`,
	ko: `생년월일`,
	mww: `hnub yug`,
	ps: `د زیږون وخت`,
	pt: `Data de nascimento`,
	'pt-pt': `Data de nascimento`,
	ru: `Дата рождения`,
	sm: `Aso o le Fanau`,
	so: `Dhalasho`,
	th: `วันเกิด`,
	ur: `تاریخ پیدائش:`,
	vi: `Ngày sinh`,
	'zh-hans': `出生日期`,
	'zh-hant': `出生日期`,
	en: `DOB`
};

export const loc_docs: Record<Locale, string> = {
	ar: `وثائق`,
	de: `Docs`,
	es: `Docs`,
	fa: `مستندات`,
	fil: `Mga Dokumento`,
	fr: `Docs`,
	hi: `डॉक्स`,
	ht: `Dokiman yo`,
	it: `Documentazione`,
	ja: `ドキュメンタリー`,
	ko: `문서`,
	mww: `Cov ntaub ntawv`,
	ps: `اسناد`,
	pt: `Docs`,
	'pt-pt': `Docs`,
	ru: `Документы`,
	sm: `Docs`,
	so: `Dukumentiyada`,
	th: `เอกสาร`,
	ur: `دستاویزات`,
	vi: `Tài liệu`,
	'zh-hans': `文档`,
	'zh-hant': `文件`,
	en: `Docs`
};

export const loc_documentation: Record<Locale, string> = {
	ar: `الوثائق`,
	de: `Dokumentation`,
	es: `Documentación`,
	fa: `مستندات`,
	fil: `Dokumentasyon`,
	fr: `Documentation`,
	hi: `प्रलेखन`,
	ht: `Dokimantasyon`,
	it: `Documentazione`,
	ja: `文書`,
	ko: `문서`,
	mww: `Cov ntaub ntawv`,
	ps: `اسناد`,
	pt: `Documentação`,
	'pt-pt': `Documentação`,
	ru: `Документация`,
	sm: `Fa'amaumauga`,
	so: `Dukumentiyada`,
	th: `เอกสารประกอบ`,
	ur: `دستاویزات`,
	vi: `Tài liệu`,
	'zh-hans': `文献资料`,
	'zh-hant': `文件`,
	en: `Documentation`
};

export const loc_documentNoLongerExists: Record<Locale, string> = {
	ar: `لم يعد هذا المستند موجودا.`,
	de: `Das Dokument existiert nicht mehr.`,
	es: `El documento ya no existe.`,
	fa: `این سند دیگر وجود ندارد.`,
	fil: `Hindi na umiiral ang dokumento.`,
	fr: `Le document n’existe plus.`,
	hi: `दस्तावेज़ अब मौजूद नहीं है.`,
	ht: `Dokiman an pa egziste ankò.`,
	it: `Il documento non esiste più.`,
	ja: `その文書はもはや存在しません。`,
	ko: `이 문서는 더 이상 존재하지 않습니다.`,
	mww: `Daim ntawv tsis muaj lawm.`,
	ps: `سند نور نشته.`,
	pt: `O documento não existe mais.`,
	'pt-pt': `O documento já não existe.`,
	ru: `Этот документ больше не существует.`,
	sm: `E le o toe i ai le pepa.`,
	so: `Dukumentigu hadda ma jiro.`,
	th: `เอกสารไม่มีอยู่อีกต่อไป`,
	ur: `یہ دستاویز اب موجود نہیں ہے۔`,
	vi: `Tài liệu không còn tồn tại.`,
	'zh-hans': `该文件现已不复存在。`,
	'zh-hant': `該文件已不復存在。`,
	en: `The document no longer exists.`
};

export const loc_documentNotFound: Record<Locale, string> = {
	ar: `غير قادر على العثور على وثيقة`,
	de: `Dokument nicht gefunden`,
	es: `No se puede encontrar el documento`,
	fa: `یافتن سند وجود ندارد`,
	fil: `Hindi mahanap ang dokumento`,
	fr: `Impossible de trouver le document`,
	hi: `दस्तावेज़ ढूँढने में असमर्थ`,
	ht: `Pa kapab jwenn dokiman`,
	it: `Impossibile trovare il documento`,
	ja: `文書が見つからない`,
	ko: `문서를 찾을 수 없습니다`,
	mww: `Tsis tuaj yeem nrhiav cov ntaub ntawv`,
	ps: `سند نه موندل کېږی`,
	pt: `Não consegui encontrar o documento`,
	'pt-pt': `Não consigo encontrar documento`,
	ru: `Не удаётся найти документ`,
	sm: `E le mafai ona maua se pepa o faamatalaga`,
	so: `Lama heli karo dukumenti`,
	th: `ไม่พบเอกสาร`,
	ur: `دستاویز تلاش کرنے سے قاصر`,
	vi: `Không thể tìm thấy tài liệu`,
	'zh-hans': `找不到文档`,
	'zh-hant': `找不到文件`,
	en: `Unable to find document`
};

export const loc_documentRequestExpired: Record<Locale, string> = {
	ar: `انتهت صلاحية طلب المستند`,
	de: `Dokumentenanfrage abgelaufen`,
	es: `Solicitud de documento expirada`,
	fa: `درخواست سند منقضی شده است`,
	fil: `Nag-expire na ang kahilingan sa dokumento`,
	fr: `Demande de document expirée`,
	hi: `दस्तावेज़ अनुरोध की समय सीमा समाप्त हो गई`,
	ht: `Demann dokiman ekspire`,
	it: `Richiesta di documento scaduta`,
	ja: `書類請求が期限切れとなりました`,
	ko: `문서 요청 만료`,
	mww: `Daim ntawv thov tas sij hawm`,
	ps: `د سند غوښتنه پای ته رسېدلې`,
	pt: `Solicitação de documento expirada`,
	'pt-pt': `Pedido de documento expirado`,
	ru: `Запрос документов истёк`,
	sm: `Ua uma le aoga o le talosaga mo pepa o faamatalaga`,
	so: `Codsiga dukumentiga wuu dhacay`,
	th: `คําขอเอกสารหมดอายุ`,
	ur: `دستاویز کی درخواست کی میعاد ختم ہو گئی`,
	vi: `Yêu cầu tài liệu đã hết hạn`,
	'zh-hans': `文件请求已过期`,
	'zh-hant': `文件申請已過期`,
	en: `Document request expired`
};

export const loc_documentRequestExpiredDescFormat: Record<Locale, (when: unknown) => TemplateResult> = {
	ar: (when) => html`<p>انتهى هذا الطلب لإكمال المستند ${when}.</p>`,
	de: (when) => html`<p>Diese Anfrage, das Dokument auszufüllen, ist ${when} abgelaufen.</p>`,
	es: (when) => html`<p>Esta solicitud para completar el documento ${when}.</p>`,
	fa: (when) => html`<p>این درخواست برای تکمیل سند ${when} منقضی شده است.</p>`,
	fil: (when) => html`<p>Ang kahilingan na ito na kumpletuhin ang dokumento ay nag-expire ${when}.</p>`,
	fr: (when) => html`<p>Cette demande de complétion du document a ${when}.</p>`,
	hi: (when) => html`<p>दस्तावेज़ को पूरा करने के लिए यह अनुरोध ${when} समाप्त हो गया था।</p>`,
	ht: (when) => html`<p>Demann sa a pou ranpli dokiman an ekspire ${when}</p>`,
	it: (when) => html`<p>Questa richiesta di completare il documento è ${when}.</p>`,
	ja: (when) => html`<p>この書類の完成要求は ${when}期限切れとなりました。</p>`,
	ko: (when) => html`<p>이 문서 작성 요청은 ${when} 만료되었습니다.</p>`,
	mww: (when) => html`<p>Qhov kev thov no kom ua tiav cov ntaub ntawv tas sij hawm ${when}.</p>`,
	ps: (when) => html`<p>دا غوښتنه د سند بشپړولو لپاره ۴ ${when} پای ته رسېدلې.</p>`,
	pt: (when) => html`<p>Esse pedido para completar o documento expirou ${when}.</p>`,
	'pt-pt': (when) => html`<p>Este pedido para completar o documento ${when}.</p>`,
	ru: (when) => html`<p>Этот запрос на заполнение документа истёк ${when}.</p>`,
	sm: (when) => html`<p>O lenei talosaga e fa'amae'a ai le pepa na mae'a i le ${when}.</p>`,
	so: (when) => html`<p>Codsigan dhameystirka dukumentiga wuxuu dhacay ${when}.</p>`,
	th: (when) => html`<p>คําขอให้กรอกเอกสารนี้หมดอายุเมื่อ ${when}</p>`,
	ur: (when) => html`<p>دستاویز مکمل کرنے کی یہ درخواست ${when} ختم ہو چکی ہے۔</p>`,
	vi: (when) => html`<p>Yêu cầu hoàn thành tài liệu này đã hết hạn ${when}.</p>`,
	'zh-hans': (when) => html`<p>填写文件的请求在 ${when}已过期。</p>`,
	'zh-hant': (when) => html`<p>這個填寫文件的請求在 ${when}就過期了。</p>`,
	en: (when) => html`<p>This request to complete the document expired ${when}.</p>`
};

export const loc_documents: Record<Locale, string> = {
	ar: `الوثائق`,
	de: `Dokumente`,
	es: `Documentos`,
	fa: `اسناد`,
	fil: `Mga Dokumento`,
	fr: `Documents`,
	hi: `दस्तावेज़`,
	ht: `Dokiman yo`,
	it: `Documenti`,
	ja: `文書`,
	ko: `문서`,
	mww: `Cov ntaub ntawv`,
	ps: `اسناد`,
	pt: `Documentos`,
	'pt-pt': `Documentos`,
	ru: `Документы`,
	sm: `Pepa aloaia`,
	so: `Dukumentiyada`,
	th: `เอกสาร`,
	ur: `دستاویزات`,
	vi: `Tài liệu`,
	'zh-hans': `文献`,
	'zh-hant': `文件`,
	en: `Documents`
};

export const loc_documentSubmitted: Record<Locale, string> = {
	ar: `المستند المقدم`,
	de: `Dokument eingereicht`,
	es: `Documento presentado`,
	fa: `سند ارسال شده`,
	fil: `Dokumento na isinumite`,
	fr: `Document soumis`,
	hi: `दस्तावेज़ प्रस्तुत किया गया`,
	ht: `Dokiman ki soumèt`,
	it: `Documento inviato`,
	ja: `提出された書類`,
	ko: `제출된 문서`,
	mww: `Cov ntaub ntawv xa tuaj`,
	ps: `سند سپارل شوی`,
	pt: `Documento submetido`,
	'pt-pt': `Documento submetido`,
	ru: `Документ представлен`,
	sm: `Pepa na tuuina atu`,
	so: `Dukumenti la gudbiyay`,
	th: `เอกสารที่ส่ง`,
	ur: `دستاویز جمع کرائی گئی`,
	vi: `Tài liệu đã nộp`,
	'zh-hans': `提交的文件`,
	'zh-hant': `提交文件`,
	en: `Document submitted`
};

export const loc_done: Record<Locale, string> = {
	ar: `تم`,
	de: `Fertig`,
	es: `Hecho`,
	fa: `انجام شد`,
	fil: `Tapos na`,
	fr: `Marché conclu`,
	hi: `हो गया`,
	ht: `Fè`,
	it: `Fatto`,
	ja: `終わった`,
	ko: `끝났어`,
	mww: `Ua tiav lawm`,
	ps: `خلاص شو`,
	pt: `Feito`,
	'pt-pt': `Feito`,
	ru: `Готово`,
	sm: `Ua mae'a`,
	so: `Waa la qabtay`,
	th: `เสร็จแล้ว`,
	ur: `ہو گیا`,
	vi: `Xong`,
	'zh-hans': `完成`,
	'zh-hant': `完成`,
	en: `Done`
};

export const loc_doseAndFrequency: Record<Locale, string> = {
	ar: `الجرعة والتكرار`,
	de: `Dosis und Häufigkeit`,
	es: `Dosis y frecuencia`,
	fa: `دوز و فراوانی`,
	fil: `Dosis at dalas`,
	fr: `Dose et fréquence`,
	hi: `खुराक और आवृत्ति`,
	ht: `Dòz & frekans`,
	it: `Dose e frequenza`,
	ja: `投与量と頻度`,
	ko: `용량 및 빈도`,
	mww: `Koob tshuaj & zaus`,
	ps: `دوز او فریکونسی`,
	pt: `Dose e frequência`,
	'pt-pt': `Dose e frequência`,
	ru: `Доза и частота`,
	sm: `Dose ma taimi`,
	so: `Qiyaasta iyo soo noqnoqoshada`,
	th: `ปริมาณและความถี่`,
	ur: `خوراک اور تعدد`,
	vi: `Liều lượng và tần suất`,
	'zh-hans': `剂量与频率`,
	'zh-hant': `劑量與頻率`,
	en: `Dose & frequency`
};

export const loc_download: Record<Locale, string> = {
	ar: `تحميل`,
	de: `Download`,
	es: `Descargar`,
	fa: `دانلود`,
	fil: `I-download`,
	fr: `Télécharger`,
	hi: `डाउनलोड`,
	ht: `Rale dosye`,
	it: `Scarica`,
	ja: `ダウンロード`,
	ko: `다운로드`,
	mww: `Download tau`,
	ps: `ډاونلوډ`,
	pt: `Baixar`,
	'pt-pt': `Descarregar`,
	ru: `Скачать`,
	sm: `Sii mai`,
	so: `Soo dejiso`,
	th: `ดาวน์โหลด`,
	ur: `ڈاؤن لوڈ کریں`,
	vi: `Tải về`,
	'zh-hans': `下载`,
	'zh-hant': `下載`,
	en: `Download`
};

export const loc_downloadPdf: Record<Locale, string> = {
	ar: `تحميل ملف PDF`,
	de: `PDF herunterladen`,
	es: `Descargar PDF`,
	fa: `دانلود PDF`,
	fil: `I-download ang PDF`,
	fr: `Télécharger PDF`,
	hi: `पीडीएफ डाउनलोड करें`,
	ht: `Download PDF`,
	it: `Scarica PDF`,
	ja: `PDFをダウンロード`,
	ko: `PDF 다운로드`,
	mww: `Rub tawm PDF`,
	ps: `PDF ډاونلوډ کړئ`,
	pt: `Baixar PDF`,
	'pt-pt': `Descarregar PDF`,
	ru: `Скачать PDF`,
	sm: `Sii mai PDF`,
	so: `Soo dejiso PDF`,
	th: `ดาวน์โหลดไฟล์ PDF`,
	ur: `پی ڈی ایف ڈاؤن لوڈ کریں`,
	vi: `Tải PDF`,
	'zh-hans': `下载PDF`,
	'zh-hant': `下載 PDF`,
	en: `Download PDF`
};

export const loc_downloadZip: Record<Locale, string> = {
	ar: `تحميل ملف ZIP`,
	de: `ZIP herunterladen`,
	es: `Descargar ZIP`,
	fa: `دانلود ZIP`,
	fil: `I-download ang ZIP`,
	fr: `Télécharger ZIP`,
	hi: `डाउनलोड ZIP`,
	ht: `Download ZIP`,
	it: `Scarica ZIP`,
	ja: `ZIPをダウンロード`,
	ko: `ZIP 다운로드`,
	mww: `Download ZIP`,
	ps: `ZIP ډاونلوډ کړئ`,
	pt: `Baixar ZIP`,
	'pt-pt': `Descarregar ZIP`,
	ru: `Скачать ZIP`,
	sm: `Sii mai le ZIP`,
	so: `Soo dejiso ZIP`,
	th: `ดาวน์โหลด ZIP`,
	ur: `ZIP ڈاؤن لوڈ کریں`,
	vi: `Tải xuống ZIP`,
	'zh-hans': `下载ZIP`,
	'zh-hant': `下載 ZIP`,
	en: `Download ZIP`
};

export const loc_draft: Record<Locale, string> = {
	ar: `المسودة`,
	de: `Entwurf`,
	es: `Draft`,
	fa: `درفت`,
	fil: `Draft`,
	fr: `Repêchage`,
	hi: `ड्राफ्ट`,
	ht: `Bouyon`,
	it: `Draft`,
	ja: `ドラフト`,
	ko: `드래프트`,
	mww: `Draft`,
	ps: `مسوده`,
	pt: `Draft`,
	'pt-pt': `Draft`,
	ru: `Драфт`,
	sm: `Fa'ata'ita'iga`,
	so: `Qabashada`,
	th: `แบบร่าง`,
	ur: `ڈرافٹ`,
	vi: `Bản nháp`,
	'zh-hans': `选秀`,
	'zh-hant': `選秀`,
	en: `Draft`
};

export const loc_draftStatusDesc: Record<Locale, string> = {
	ar: `النشاط ليس جاهزا بعد للتنفيذ.`,
	de: `Die Aktivität ist noch nicht bereit, umgesetzt zu werden.`,
	es: `La actividad aún no está lista para ser llevada a cabo.`,
	fa: `این فعالیت هنوز آماده اقدام نیست.`,
	fil: `Ang aktibidad ay hindi pa handa na kumilos.`,
	fr: `L’activité n’est pas encore prête à être mise en œuvre.`,
	hi: `गतिविधि अभी तक कार्रवाई करने के लिए तैयार नहीं है।`,
	ht: `Aktivite a poko pare pou yo aji.`,
	it: `L'attività non è ancora pronta per essere attuata.`,
	ja: `この活動はまだ行動に移す準備ができていません。`,
	ko: `이 활동은 아직 행동에 옮길 준비가 되어 있지 않습니다.`,
	mww: `Qhov kev ua haujlwm tseem tsis tau npaj txhij los ua haujlwm.`,
	ps: `دا فعالیت لا تر اوسه د عمل لپاره چمتو نه دی.`,
	pt: `A atividade ainda não está pronta para ser executada.`,
	'pt-pt': `A atividade ainda não está pronta para ser executada.`,
	ru: `Деятельность ещё не готова к реализации.`,
	sm: `E le'i sauni le gaioiga e faatinoina.`,
	so: `Hawlgu weli diyaar uma aha in la fuliyo.`,
	th: `กิจกรรมยังไม่พร้อมที่จะดําเนินการ`,
	ur: `یہ سرگرمی ابھی تک عملی جامہ پہنانے کے لیے تیار نہیں ہے۔`,
	vi: `Hoạt động này vẫn chưa sẵn sàng để thực hiện.`,
	'zh-hans': `该活动尚未准备好采取行动。`,
	'zh-hant': `這項活動尚未準備好付諸行動。`,
	en: `The activity is not yet ready to be acted upon.`
};

export const loc_draw: Record<Locale, string> = {
	ar: `السحب`,
	de: `Auslosung`,
	es: `Empate`,
	fa: `قرعه کشی`,
	fil: `Gumuhit`,
	fr: `Match nul`,
	hi: `आकर्षित`,
	ht: `Trase`,
	it: `Draw`,
	ja: `引き分け`,
	ko: `드로우`,
	mww: `kos duab`,
	ps: `رسم کړه`,
	pt: `Sorteio`,
	'pt-pt': `Sorteio`,
	ru: `Жеребьёвка`,
	sm: `Ata`,
	so: `Draw`,
	th: `วาด`,
	ur: `ڈرا`,
	vi: `Hòa`,
	'zh-hans': `抽签`,
	'zh-hant': `抽籤`,
	en: `Draw`
};

export const loc_due: Record<Locale, string> = {
	ar: `الموعد`,
	de: `Fällig`,
	es: `Debido`,
	fa: `موعد`,
	fil: `Dahil`,
	fr: `Due`,
	hi: `बिल्‍कुल`,
	ht: `Akòz`,
	it: `Due`,
	ja: `期限`,
	ko: `기분`,
	mww: `tsim nyog`,
	ps: `د وخت له امله`,
	pt: `Devido`,
	'pt-pt': `Devido`,
	ru: `Срок`,
	sm: `E tatau ona`,
	so: `Waqtiga`,
	th: `ครบกําหนด`,
	ur: `ڈیو`,
	vi: `Đến hạn`,
	'zh-hans': `该`,
	'zh-hant': `該`,
	en: `Due`
};

export const loc_dueDate: Record<Locale, string> = {
	ar: `تاريخ الولادة`,
	de: `Geburtstermin`,
	es: `Fecha prevista de parto`,
	fa: `تاریخ تولد`,
	fil: `Takdang petsa`,
	fr: `Date d’accouchement`,
	hi: `नियत तारीख`,
	ht: `Dat limit yo`,
	it: `Data prevista`,
	ja: `出産予定日`,
	ko: `출산 예정일`,
	mww: `Hnub kawg`,
	ps: `د زېږون نېټه`,
	pt: `Data prevista para o parto`,
	'pt-pt': `Data prevista para o parto`,
	ru: `Срок родов`,
	sm: `Aso e faagata ai`,
	so: `Taariikhda dhalashada`,
	th: `วันครบกําหนด`,
	ur: `ڈیلیوری ڈیٹ`,
	vi: `Ngày đến hạn`,
	'zh-hans': `预产期`,
	'zh-hant': `預產期`,
	en: `Due date`
};

export const loc_dueOnDate: Record<Locale, (dueDate: unknown) => string> = {
	ar: (dueDate) => `موعد صدور ${dueDate}`,
	de: (dueDate) => `fällig am ${dueDate}`,
	es: (dueDate) => `Fecha prevista para ${dueDate}`,
	fa: (dueDate) => `موعد تحویل در ${dueDate}`,
	fil: (dueDate) => `dahil sa ${dueDate}`,
	fr: (dueDate) => `Prévu pour le ${dueDate}`,
	hi: (dueDate) => `${dueDate} को देय`,
	ht: (dueDate) => `akòz sou ${dueDate}`,
	it: (dueDate) => `Previsto per il ${dueDate}`,
	ja: (dueDate) => `提出予定日は${dueDate}です`,
	ko: (dueDate) => `${dueDate}일 제출 예정일`,
	mww: (dueDate) => `Them rau ${dueDate}`,
	ps: (dueDate) => `د ${dueDate} نیټه`,
	pt: (dueDate) => `Previsto para ${dueDate}`,
	'pt-pt': (dueDate) => `Previsto para ${dueDate}`,
	ru: (dueDate) => `Срок на ${dueDate}`,
	sm: (dueDate) => `Fa'atatau i le ${dueDate}`,
	so: (dueDate) => `Waa la filayaa ${dueDate}`,
	th: (dueDate) => `ครบกําหนดไถ่ถอนวันที่ ${dueDate}`,
	ur: (dueDate) => `2${dueDate} کو متوقع`,
	vi: (dueDate) => `đến hạn ${dueDate}`,
	'zh-hans': (dueDate) => `截止日期为 ${dueDate}`,
	'zh-hant': (dueDate) => `截止日期為 ${dueDate}`,
	en: (dueDate) => `due on ${dueDate}`
};

export const loc_earlierTimesheets: Record<Locale, string> = {
	ar: `جداول زمنية سابقة`,
	de: `Frühere Stundenzettel`,
	es: `Hojas de horas anteriores`,
	fa: `جدول های زمانی قبلی`,
	fil: `Mga naunang timesheet`,
	fr: `Feuilles de temps antérieures`,
	hi: `पहले की टाइमशीट`,
	ht: `Fich tan pi bonè`,
	it: `Fogli orari precedenti`,
	ja: `初期のタイムシート`,
	ko: `이전 타임시트`,
	mww: `Cov ntawv teev sijhawm ua ntej`,
	ps: `پخوانی وخت پاڼې`,
	pt: `Folhas de ponto anteriores`,
	'pt-pt': `Folhas de horas anteriores`,
	ru: `Ранние табели работы`,
	sm: `Pepa o taimi muamua`,
	so: `Jadwalka hore`,
	th: `ไทม์ชีทก่อนหน้านี้`,
	ur: `ابتدائی ٹائم شیٹس`,
	vi: `Bảng chấm công trước đó`,
	'zh-hans': `早期计时表`,
	'zh-hant': `早期工時表`,
	en: `Earlier timesheets`
};

export const loc_earliestEndDate: Record<Locale, string> = {
	ar: `أقدم تاريخ نهاية`,
	de: `Frühestes Enddatum`,
	es: `Fecha de finalización más temprana`,
	fa: `زودترین تاریخ پایان`,
	fil: `Pinakamaagang petsa ng pagtatapos`,
	fr: `Date de fin la plus ancienne`,
	hi: `सबसे पहले समाप्ति तिथि`,
	ht: `Pi bonè dat fen`,
	it: `Data di fine più antica`,
	ja: `最も早い終了日`,
	ko: `가장 이른 종료일`,
	mww: `Hnub xaus ntxov tshaj plaws`,
	ps: `تر ټولو ژر پای نیټه`,
	pt: `Data de término mais antiga`,
	'pt-pt': `Data de fim mais antiga`,
	ru: `Самая ранняя дата окончания`,
	sm: `Aso fa'amutaina muamua`,
	so: `Taariikhda ugu horreysa ee dhammaadka`,
	th: `วันที่สิ้นสุดเร็วที่สุด`,
	ur: `سب سے ابتدائی اختتام کی تاریخ`,
	vi: `Ngày kết thúc sớm nhất`,
	'zh-hans': `最早的终止日期`,
	'zh-hant': `最早結束日期`,
	en: `Earliest end date`
};

export const loc_earliestStartDate: Record<Locale, string> = {
	ar: `أقدم تاريخ بدء`,
	de: `Frühester Starttermin`,
	es: `Fecha de inicio más temprana`,
	fa: `زودترین تاریخ شروع`,
	fil: `Pinakamaagang petsa ng pagsisimula`,
	fr: `Date de début la plus ancienne`,
	hi: `जल्द से जल्द शुरू होने की तारीख`,
	ht: `Premye dat kòmanse`,
	it: `Data di inizio più antica`,
	ja: `最も早い開始日`,
	ko: `가장 이른 시작일`,
	mww: `Hnub pib ntxov tshaj plaws`,
	ps: `تر ټولو ژر د پیل نېټه`,
	pt: `Data de início mais antiga`,
	'pt-pt': `Data de início mais antiga`,
	ru: `Самая ранняя дата начала`,
	sm: `Aso amata muamua`,
	so: `Taariikhda ugu horreysa ee bilowga`,
	th: `วันที่เริ่มต้นเร็วที่สุด`,
	ur: `سب سے جلد آغاز کی تاریخ`,
	vi: `Ngày bắt đầu sớm nhất`,
	'zh-hans': `最早的起始日期`,
	'zh-hant': `最早的開始日期`,
	en: `Earliest start date`
};

export const loc_edit: Record<Locale, string> = {
	ar: `تعديل`,
	de: `Bearbeitung`,
	es: `Edición`,
	fa: `ویرایش`,
	fil: `Baguhin`,
	fr: `Édit`,
	hi: `संपादित करें`,
	ht: `modifye`,
	it: `Modifica`,
	ja: `編集`,
	ko: `수정`,
	mww: `Kho kom raug`,
	ps: `سمون`,
	pt: `Edit`,
	'pt-pt': `Editar`,
	ru: `Редактирование`,
	sm: `Fa'asa'o`,
	so: `Tafatir`,
	th: `แก้ไข`,
	ur: `ترمیم`,
	vi: `Chỉnh sửa`,
	'zh-hans': `编辑`,
	'zh-hant': `編輯`,
	en: `Edit`
};

export const loc_editDemographics: Record<Locale, string> = {
	ar: `تعديل التركيبة السكانية`,
	de: `Demografie bearbeiten`,
	es: `Editar demografía`,
	fa: `ویرایش جمعیت شناسی`,
	fil: `I-edit ang demograpiko`,
	fr: `Modifier la démographie`,
	hi: `जनसांख्यिकी संपादित करें`,
	ht: `Edite demografik`,
	it: `Modifica demografia`,
	ja: `編集:人口統計`,
	ko: `편집 인구 통계`,
	mww: `Kho kom raug demographics`,
	ps: `سمون نفوس`,
	pt: `Editar demografia`,
	'pt-pt': `Editar demografia`,
	ru: `Редактировать демографию`,
	sm: `Fa'asa'o le faitau aofa'i o tagata`,
	so: `Wax ka beddel tirakoobka dadka`,
	th: `แก้ไขข้อมูลประชากร`,
	ur: `ترمیم آبادیاتی معلومات`,
	vi: `Chỉnh sửa nhân khẩu học`,
	'zh-hans': `编辑 人口统计`,
	'zh-hant': `編輯：人口統計`,
	en: `Edit demographics`
};

export const loc_editDetails: Record<Locale, string> = {
	ar: `تفاصيل تعديل`,
	de: `Bearbeitungsdetails`,
	es: `Detalles de edición`,
	fa: `جزئیات ویرایش`,
	fil: `I-edit ang mga detalye`,
	fr: `Détails de la modification`,
	hi: `विवरण संपादित करें`,
	ht: `Edit detay yo`,
	it: `Dettagli modifica`,
	ja: `編集詳細`,
	ko: `편집 세부사항`,
	mww: `Kho kom raug cov ntsiab lus`,
	ps: `د سمون جزئیات`,
	pt: `Detalhes da edição`,
	'pt-pt': `Detalhes de edição`,
	ru: `Детали правки`,
	sm: `Fa'asa'o auiliiliga`,
	so: `Faahfaahinta wax ka beddel`,
	th: `แก้ไขรายละเอียด`,
	ur: `ترمیمی تفصیلات`,
	vi: `Chỉnh sửa chi tiết`,
	'zh-hans': `编辑详情`,
	'zh-hant': `編輯細節`,
	en: `Edit details`
};

export const loc_editElement: Record<Locale, string> = {
	ar: `عنصر التعديل`,
	de: `Bearbeitungselement`,
	es: `Elemento de edición`,
	fa: `عنصر ویرایش`,
	fil: `I-edit ang elemento`,
	fr: `Élément d’édition`,
	hi: `तत्व संपादित करें`,
	ht: `Edit eleman`,
	it: `Modifica elemento`,
	ja: `編集要素`,
	ko: `편집 요소`,
	mww: `Kho kom raug`,
	ps: `ایډیټ عنصر`,
	pt: `Elemento de edição`,
	'pt-pt': `Elemento de edição`,
	ru: `Элемент редактирования`,
	sm: `Fa'asa'o elemene`,
	so: `Qaybta tafatirka`,
	th: `แก้ไของค์ประกอบ`,
	ur: `ایڈیٹ ایلیمنٹ`,
	vi: `Chỉnh sửa phần tử`,
	'zh-hans': `编辑元素`,
	'zh-hant': `編輯元素`,
	en: `Edit element`
};

export const loc_editingDisabled: Record<Locale, string> = {
	ar: `تم تعطيل التحرير`,
	de: `Bearbeitung deaktiviert`,
	es: `Edición deshabilitada`,
	fa: `ویرایش غیرفعال شد`,
	fil: `Hindi pinagana ang pag-edit`,
	fr: `Montage désactivé`,
	hi: `संपादन अक्षम`,
	ht: `Modification enfim`,
	it: `Editing disabilitato`,
	ja: `編集無効`,
	ko: `편집 비활성화`,
	mww: `Kho cov neeg xiam oob khab`,
	ps: `ایډیټنګ غیر فعال شو`,
	pt: `Edição desativada`,
	'pt-pt': `Edição desativada`,
	ru: `Редактирование отключено`,
	sm: `Fa'asa'oina le fa'aleagaina`,
	so: `Tafatirka waa la joojiyay`,
	th: `การแก้ไขถูกปิดใช้งาน`,
	ur: `ایڈیٹنگ غیر فعال`,
	vi: `Chỉnh sửa bị vô hiệu hóa`,
	'zh-hans': `禁用编辑`,
	'zh-hant': `編輯功能被停用`,
	en: `Editing disabled`
};

export const loc_editor: Record<Locale, string> = {
	ar: `محرر`,
	de: `Herausgeber`,
	es: `Editor`,
	fa: `ویراستار`,
	fil: `Editor`,
	fr: `Rédacteur en chef`,
	hi: `संपादक`,
	ht: `Editè`,
	it: `Direttore`,
	ja: `編集者`,
	ko: `편집자`,
	mww: `Editor`,
	ps: `ایډیټر`,
	pt: `Editor`,
	'pt-pt': `Editor`,
	ru: `Редактор`,
	sm: `Faatonu`,
	so: `Tifaftiraha`,
	th: `บรรณาธิการ`,
	ur: `ایڈیٹر`,
	vi: `Biên tập viên`,
	'zh-hans': `编辑`,
	'zh-hant': `主編`,
	en: `Editor`
};

export const loc_editProfileAndAccount: Record<Locale, string> = {
	ar: `تعديل الملف الشخصي والحساب`,
	de: `Profil bearbeiten & Konto`,
	es: `Editar perfil y cuenta`,
	fa: `ویرایش پروفایل و حساب کاربری`,
	fil: `I-edit ang profile at account`,
	fr: `Modifier le profil et le compte`,
	hi: `प्रोफ़ाइल और खाता संपादित करें`,
	ht: `Edit pwofil & kont`,
	it: `Modifica profilo e account`,
	ja: `プロフィールとアカウントを編集`,
	ko: `프로필 및 계정 편집`,
	mww: `Kho kom raug profile & account`,
	ps: `پروفایل او حساب سمون کړئ`,
	pt: `Editar perfil & conta`,
	'pt-pt': `Editar perfil & conta`,
	ru: `Редактировать профиль и аккаунт`,
	sm: `Fa'asa'o talaaga otooto ma teuga tupe`,
	so: `Wax ka beddel profile & account`,
	th: `แก้ไขโปรไฟล์และบัญชี`,
	ur: `پروفائل اور اکاؤنٹ میں ترمیم کریں`,
	vi: `Chỉnh sửa hồ sơ và tài khoản`,
	'zh-hans': `编辑个人资料和账户`,
	'zh-hant': `編輯個人檔案與帳號`,
	en: `Edit profile & account`
};

export const loc_editSelection: Record<Locale, string> = {
	ar: `اختيار التعديل`,
	de: `Bearbeitungsauswahl`,
	es: `Selección de edición`,
	fa: `انتخاب ویرایش`,
	fil: `I-edit ang pagpili`,
	fr: `Sélection de la modification`,
	hi: `चयन संपादित करें`,
	ht: `Edit seleksyon`,
	it: `Modifica selezione`,
	ja: `編集選択`,
	ko: `편집 선택`,
	mww: `Kho kom raug xaiv`,
	ps: `د سمون انتخاب`,
	pt: `Seleção de edição`,
	'pt-pt': `Seleção de edição`,
	ru: `Выбор правки`,
	sm: `Fa'asa'o filifiliga`,
	so: `Xulashada tafatirka`,
	th: `แก้ไขส่วนที่เลือก`,
	ur: `ترمیمی انتخاب`,
	vi: `Chỉnh sửa lựa chọn`,
	'zh-hans': `编辑选择`,
	'zh-hant': `編輯選擇`,
	en: `Edit selection`
};

export const loc_editThisDashboard: Record<Locale, string> = {
	ar: `عدل هذه لوحة المعلومات`,
	de: `Bearbeiten Sie dieses Dashboard`,
	es: `Editar este panel de control`,
	fa: `این داشبورد را ویرایش کنید`,
	fil: `I-edit ang dashboard na ito`,
	fr: `Modifier ce tableau de bord`,
	hi: `इस डैशबोर्ड को संपादित करें`,
	ht: `Edite tablodbò sa a`,
	it: `Modifica questa dashboard`,
	ja: `このダッシュボードを編集`,
	ko: `이 대시보드를 편집하세요`,
	mww: `Kho kom raug no dashboard`,
	ps: `دا داشبورډ ایډیټ کړئ`,
	pt: `Editar este painel`,
	'pt-pt': `Editar este painel`,
	ru: `Отредактировать эту панель управления`,
	sm: `Fa'asa'o lenei dashboard`,
	so: `Wax ka beddel dashboard-kan`,
	th: `แก้ไขแดชบอร์ดนี้`,
	ur: `اس ڈیش بورڈ میں ترمیم کریں`,
	vi: `Chỉnh sửa bảng điều khiển này`,
	'zh-hans': `编辑此仪表盘`,
	'zh-hant': `編輯此儀表板`,
	en: `Edit this dashboard`
};

export const loc_editTimesheet: Record<Locale, string> = {
	ar: `تعديل جدول المواعيد`,
	de: `Stundenzettel bearbeiten`,
	es: `Hoja de horas de edición`,
	fa: `ویرایش برگه زمان`,
	fil: `I-edit ang timesheet`,
	fr: `Feuille d’heure de modification`,
	hi: `टाइमशीट संपादित करें`,
	ht: `Edite Fèy tan`,
	it: `Modifica foglio orario`,
	ja: `タイムシートを編集`,
	ko: `타임시트 편집`,
	mww: `Kho kom raug daim ntawv teev sijhawm`,
	ps: `د وخت پاڼه سمون کړئ`,
	pt: `Editar folha de ponto`,
	'pt-pt': `Folha de horas de edição`,
	ru: `Редактирование табеля`,
	sm: `Fa'asa'o le pepa o taimi`,
	so: `Tafatir jadwalka waqtiga`,
	th: `แก้ไขไทม์ชีท`,
	ur: `ٹائم شیٹ میں ترمیم کریں`,
	vi: `Chỉnh sửa bảng chấm công`,
	'zh-hans': `编辑时间表`,
	'zh-hant': `編輯時間表`,
	en: `Edit timesheet`
};

export const loc_email: Record<Locale, string> = {
	ar: `البريد الإلكتروني`,
	de: `E-Mail`,
	es: `Correo electrónico`,
	fa: `ایمیل`,
	fil: `Email`,
	fr: `Email`,
	hi: `ईमेल`,
	ht: `Imel`,
	it: `E-mail`,
	ja: `メール`,
	ko: `이메일`,
	mww: `Tus email`,
	ps: `ایمیل`,
	pt: `E-mail`,
	'pt-pt': `Email`,
	ru: `Электронная почта`,
	sm: `Imeli`,
	so: `Email`,
	th: `อีเมล`,
	ur: `ای میل`,
	vi: `Thư điện tử`,
	'zh-hans': `电子邮件`,
	'zh-hant': `電子郵件`,
	en: `Email`
};

export const loc_emailAndUsername: Record<Locale, string> = {
	ar: `البريد الإلكتروني & اسم المستخدم`,
	de: `E-Mail & Benutzername`,
	es: `Correo electrónico y nombre de usuario`,
	fa: `ایمیل و نام کاربری`,
	fil: `Email at Username`,
	fr: `Email & Nom d’utilisateur`,
	hi: `ईमेल और उपयोगकर्ता नाम`,
	ht: `Imèl & Non itilizatè`,
	it: `Email e Nome utente`,
	ja: `メールアドレスとユーザー名`,
	ko: `이메일 및 사용자 이름`,
	mww: `Email & Username`,
	ps: `ایمیل او کارن نوم`,
	pt: `E-mail & Nome de Usuário`,
	'pt-pt': `Email & Nome de Utilizador`,
	ru: `Электронная почта и имя пользователя`,
	sm: `Imeli ma Username`,
	so: `Email & Username`,
	th: `อีเมลและชื่อผู้ใช้`,
	ur: `ای میل اور یوزر نیم`,
	vi: `Email & Tên đăng nhập`,
	'zh-hans': `电子邮件及用户名`,
	'zh-hant': `電子郵件與使用者名稱`,
	en: `Email & Username`
};

export const loc_emails: Record<Locale, string> = {
	ar: `رسائل البريد الإلكتروني`,
	de: `E-Mails`,
	es: `Correos electrónicos`,
	fa: `ایمیل ها`,
	fil: `Email Address *`,
	fr: `Emails`,
	hi: `ईमेल`,
	ht: `Imèl`,
	it: `Email`,
	ja: `メール`,
	ko: `이메일`,
	mww: `Emails`,
	ps: `ایمیلونه`,
	pt: `E-mails`,
	'pt-pt': `Emails`,
	ru: `Электронные письма`,
	sm: `Imeli`,
	so: `Emaillo`,
	th: `อีเมล`,
	ur: `ای میلز`,
	vi: `Thư điện tử`,
	'zh-hans': `电子邮件`,
	'zh-hant': `電子郵件`,
	en: `Emails`
};

export const loc_emailSent: Record<Locale, string> = {
	ar: `تم إرسال البريد الإلكتروني`,
	de: `E-Mail gesendet`,
	es: `Correo electrónico enviado`,
	fa: `ایمیل ارسال شد`,
	fil: `Email Address *`,
	fr: `Email envoyé`,
	hi: `ईमेल भेजा गया`,
	ht: `Imèl voye`,
	it: `Email inviata`,
	ja: `メール送信済み`,
	ko: `이메일 보낸`,
	mww: `Email xa`,
	ps: `ایمیل واستول شو`,
	pt: `E-mail enviado`,
	'pt-pt': `Email enviado`,
	ru: `Отправлено письмо`,
	sm: `Auina atu imeli`,
	so: `Email la diray`,
	th: `ส่งอีเมลแล้ว`,
	ur: `ای میل بھیجی گئی`,
	vi: `Email đã gửi`,
	'zh-hans': `已发送邮件`,
	'zh-hant': `已發送電子郵件`,
	en: `Email sent`
};

export const loc_emailUndeliverableMessage: Record<Locale, string> = {
	ar: `عنوان البريد الإلكتروني غير قابل للتسليم. تواصل مع الدعم للحصول على المساعدة إذا كنت تعتقد أن هذا خطأ.`,
	de: `Die E-Mail-Adresse ist nicht zustellbar. Kontaktieren Sie den Support für Unterstützung, wenn Sie glauben, dass dies ein Fehler ist.`,
	es: `La dirección de correo electrónico no se puede entregar. Contacta con el soporte si crees que esto es un error.`,
	fa: `آدرس ایمیل قابل تحویل نیست. اگر فکر می کنید این یک اشتباه است، با پشتیبانی تماس بگیرید.`,
	fil: `Ang email address ay hindi maihahatid. Makipag-ugnay sa suporta para sa tulong kung sa palagay mo ito ay isang pagkakamali.`,
	fr: `L’adresse e-mail n’est pas livrable. Contactez le support pour obtenir de l’aide si vous pensez qu’il s’agit d’une erreur.`,
	hi: `ईमेल पता डिलीवर नहीं किया जा सकता है। यदि आप इसे एक त्रुटि मानते हैं तो सहायता के लिए समर्थन से संपर्क करें।`,
	ht: `Adrès imel se undeliverable. Kontakte sipò pou asistans si ou kwè sa a se yon erè.`,
	it: `L'indirizzo email non è consegnabile. Contatta l'assistenza per assistenza se ritieni che si tratti di un errore.`,
	ja: `メールアドレスは配達不可です。もしこれが誤りだと思われる場合はサポートに連絡してください。`,
	ko: `이메일 주소가 배달 불가입니다. 이게 오류라고 생각되면 지원팀에 연락해 도움을 받으세요.`,
	mww: `Email chaw nyob yog unsupplyable. Hu rau kev pab txhawb nqa yog koj ntseeg tias qhov no yog ib qho yuam kev.`,
	ps: `د ایمیل پته نه سپارل کېږی. که تاسو فکر کوئ چې دا تېروتنه ده، له ملاتړ سره اړیکه ونیسئ.`,
	pt: `Endereço de e-mail não pode ser entregue. Entre em contato com o suporte para obter ajuda se você acreditar que isso foi um erro.`,
	'pt-pt': `O endereço de email não pode ser entregue. Contacte o apoio ao público para obter assistência se achar que isto é um erro.`,
	ru: `Адрес электронной почты не подлежит доставке. Обратитесь в поддержку за помощью, если считаете это ошибкой.`,
	sm: `O le tuatusi imeli e le mafai ona tu'uina atu. Fa'afeso'ota'i le lagolago mo se fesoasoani pe afai e te manatu o se mea sese.`,
	so: `Cinwaanka email-ka lama gaarsiin karo. La xiriir taageerada si aad u hesho caawimaad haddii aad u malaynayso in tani ay khalad tahay.`,
	th: `อีเมลไม่สามารถส่งได้ ติดต่อฝ่ายสนับสนุนเพื่อขอความช่วยเหลือหากคุณเชื่อว่าเป็นข้อผิดพลาด`,
	ur: `ای میل ایڈریس قابل ترسیل نہیں ہے۔ اگر آپ کو لگتا ہے کہ یہ غلطی ہے تو مدد کے لیے سپورٹ سے رابطہ کریں۔`,
	vi: `Địa chỉ email không thể gửi được. Liên hệ với bộ phận hỗ trợ để được hỗ trợ nếu bạn cho rằng đây là lỗi.`,
	'zh-hans': `电子邮件地址无法投递。如果你认为这是错误，请联系客服寻求帮助。`,
	'zh-hant': `電子郵件地址無法投遞。如果你認為這是錯誤，請聯絡客服尋求協助。`,
	en: `Email address is undeliverable. Contact support for assistance if you believe this to be an error.`
};

export const loc_emailVisibilityDescription: Record<Locale, string> = {
	ar: `البريد الإلكتروني مرئي لأعضاء Cumulus الذين تتعاون معهم.`,
	de: `Die E-Mail ist für Cumulus-Mitglieder, mit denen Sie zusammenarbeiten, sichtbar.`,
	es: `El correo electrónico es visible para los miembros de Cumulus con los que colaboras.`,
	fa: `ایمیل برای اعضای Cumulus که با آن ها همکاری می کنید قابل مشاهده است.`,
	fil: `Ang email ay nakikita ng mga miyembro ng Cumulus na nakikipagtulungan ka.`,
	fr: `L’email est visible pour les membres Cumulus avec lesquels vous collaborez.`,
	hi: `ईमेल क्यूम्यलस सदस्यों को दिखाई देता है जिनके साथ आप सहयोग कर रहे हैं।`,
	ht: `Imèl vizib pou Cumulus manm ou ap kolabore avèk yo.`,
	it: `L'email è visibile ai membri Cumulus con cui collabori.`,
	ja: `メールは、協力しているCumulusのメンバーにも閲覧可能です。`,
	ko: `이메일은 협업 중인 Cumulus 회원들에게 공개됩니다.`,
	mww: `Email yog pom rau Cumulus cov tswv cuab uas koj tab tom koom tes nrog.`,
	ps: `ایمیل د Cumulus هغو غړو ته ښکاره دی چې تاسو ورسره همکاری کوئ.`,
	pt: `O e-mail é visível para os membros da Cumulus com quem você está colaborando.`,
	'pt-pt': `O email é visível para os membros da Cumulus com quem colabora.`,
	ru: `Электронная почта доступна участникам Cumulus, с которыми вы сотрудничаете.`,
	sm: `O le imeli e mafai ona va'aia e tagata o le Cumulus o lo'o e galulue fa'atasi.`,
	so: `Email-ka waa la arki karaa xubnaha Cumulus ee aad la shaqaynayso.`,
	th: `สมาชิก Cumulus ที่คุณกําลังทํางานร่วมกันจะมองเห็นอีเมลได้`,
	ur: `ای میل ان کیومیولس ممبران کے لیے نظر آتی ہے جن کے ساتھ آپ تعاون کر رہے ہیں۔`,
	vi: `Email hiển thị cho các thành viên Cumulus mà bạn đang cộng tác.`,
	'zh-hans': `邮件对你合作的Cumulus成员可见。`,
	'zh-hant': `電子郵件對你合作的 Cumulus 會員可見。`,
	en: `Email is visible to Cumulus members you are collaborating with.`
};

export const loc_emergencyContact: Record<Locale, string> = {
	ar: `الاتصال الطارئ`,
	de: `Notfallkontakt`,
	es: `Contacto de emergencia`,
	fa: `تماس اضطراری`,
	fil: `Pakikipag-ugnay sa Emergency`,
	fr: `Contact d’urgence`,
	hi: `आपातकालीन संपर्क`,
	ht: `Kontak ijans`,
	it: `Contatto di emergenza`,
	ja: `緊急連絡先`,
	ko: `비상 연락처`,
	mww: `Kev Tiv Tauj Thaum Muaj Xwm Ceev`,
	ps: `بیړنی تماس`,
	pt: `Contato de Emergência`,
	'pt-pt': `Contacto de Emergência`,
	ru: `Экстренный контакт`,
	sm: `Fa'afeso'ota'iga mo Fa'alavelave`,
	so: `Xiriirka Degdegga ah`,
	th: `ติดต่อฉุกเฉิน`,
	ur: `ایمرجنسی رابطہ`,
	vi: `Liên hệ khẩn cấp`,
	'zh-hans': `紧急联系人`,
	'zh-hant': `緊急聯絡人`,
	en: `Emergency Contact`
};

export const loc_employee: Record<Locale, string> = {
	ar: `الموظف`,
	de: `Mitarbeiter`,
	es: `Empleado`,
	fa: `کارمند`,
	fil: `Empleyado`,
	fr: `Employé`,
	hi: `कर्मचारी`,
	ht: `Anplwaye`,
	it: `Dipendente`,
	ja: `従業員`,
	ko: `직원`,
	mww: `Tus neeg ua hauj lwm`,
	ps: `کارکوونکی`,
	pt: `Funcionário`,
	'pt-pt': `Funcionário`,
	ru: `Сотрудник`,
	sm: `Tagata faigaluega`,
	so: `Shaqaale`,
	th: `พนักงาน`,
	ur: `ملازم`,
	vi: `Nhân viên`,
	'zh-hans': `员工`,
	'zh-hant': `員工`,
	en: `Employee`
};

export const loc_employeeReview: Record<Locale, string> = {
	ar: `مراجعة الموظفين`,
	de: `Mitarbeiterbewertung`,
	es: `Evaluación del empleado`,
	fa: `بررسی کارکنان`,
	fil: `Pagsusuri ng empleyado`,
	fr: `Évaluation des employés`,
	hi: `कर्मचारी समीक्षा`,
	ht: `Revizyon anplwaye yo`,
	it: `Recensione del dipendente`,
	ja: `従業員レビュー`,
	ko: `직원 평가`,
	mww: `Kev tshuaj xyuas cov neeg ua haujlwm`,
	ps: `د کارکوونکو بیاکتنه`,
	pt: `Avaliação de funcionários`,
	'pt-pt': `Avaliação de colaboradores`,
	ru: `Отзыв сотрудников`,
	sm: `Iloiloga a tagata faigaluega`,
	so: `Dib u eegista shaqaalaha`,
	th: `การตรวจสอบพนักงาน`,
	ur: `ملازمین کا جائزہ`,
	vi: `Đánh giá của nhân viên`,
	'zh-hans': `员工评审`,
	'zh-hant': `員工評鑑`,
	en: `Employee review`
};

export const loc_employees: Record<Locale, string> = {
	ar: `الموظفون`,
	de: `Mitarbeiter`,
	es: `Empleados`,
	fa: `کارکنان`,
	fil: `Mga empleyado`,
	fr: `Employés`,
	hi: `कर्मचारी`,
	ht: `Anplwaye yo`,
	it: `Dipendenti`,
	ja: `従業員`,
	ko: `직원`,
	mww: `Cov neeg ua hauj lwm`,
	ps: `کارکوونکی`,
	pt: `Funcionários`,
	'pt-pt': `Funcionários`,
	ru: `Сотрудники`,
	sm: `Tagata faigaluega`,
	so: `Shaqaalaha`,
	th: `พนักงาน`,
	ur: `ملازمین`,
	vi: `Nhân viên`,
	'zh-hans': `员工`,
	'zh-hant': `員工`,
	en: `Employees`
};

export const loc_employer: Record<Locale, string> = {
	ar: `صاحب العمل`,
	de: `Arbeitgeber`,
	es: `Empleador`,
	fa: `کارفرما`,
	fil: `Tagapag-empleyo`,
	fr: `Employeur`,
	hi: `मालिक`,
	ht: `Anplwayè`,
	it: `Datore di lavoro`,
	ja: `雇用主`,
	ko: `고용주`,
	mww: `Tus tswv hauj lwm`,
	ps: `کارګمارونکی`,
	pt: `Empregador`,
	'pt-pt': `Empregador`,
	ru: `Работодатель`,
	sm: `Pule o le galuega`,
	so: `Shaqaale`,
	th: `นายจ้าง`,
	ur: `آجر`,
	vi: `Nhà tuyển dụng`,
	'zh-hans': `雇主`,
	'zh-hant': `雇主`,
	en: `Employer`
};

export const loc_employerReview: Record<Locale, string> = {
	ar: `مراجعة صاحب العمل`,
	de: `Arbeitgeberbewertung`,
	es: `Revisión del empleador`,
	fa: `بررسی کارفرما`,
	fil: `Pagsusuri ng employer`,
	fr: `Avis de l’employeur`,
	hi: `नियोक्ता की समीक्षा`,
	ht: `Revizyon anplwayè`,
	it: `Revisione del datore di lavoro`,
	ja: `雇用主レビュー`,
	ko: `고용주 검토`,
	mww: `Kev tshuaj xyuas ntawm tus tswv hauj lwm`,
	ps: `د کارګمارونکی بیاکتنه`,
	pt: `Avaliação do empregador`,
	'pt-pt': `Revisão do empregador`,
	ru: `Проверка работодателем`,
	sm: `Iloiloga a le pule o le galuega`,
	so: `Dib-u-eegista shaqo-bixiyeyaasha`,
	th: `การทบทวนนายจ้าง`,
	ur: `آجر کا جائزہ`,
	vi: `Đánh giá của nhà tuyển dụng`,
	'zh-hans': `雇主审查`,
	'zh-hant': `雇主審查`,
	en: `Employer review`
};

export const loc_end: Record<Locale, string> = {
	ar: `النهاية`,
	de: `Ende`,
	es: `Fin`,
	fa: `پایان`,
	fil: `Wakas`,
	fr: `Fin`,
	hi: `समाप्त`,
	ht: `Fen`,
	it: `Fine`,
	ja: `終わり`,
	ko: `끝`,
	mww: `xaus`,
	ps: `پای`,
	pt: `Fim`,
	'pt-pt': `Fim`,
	ru: `Конец`,
	sm: `Fa'ai'uga`,
	so: `Dhammaad`,
	th: `จบ`,
	ur: `اختتام`,
	vi: `Kết thúc`,
	'zh-hans': `结束`,
	'zh-hant': `結束`,
	en: `End`
};

export const loc_endDate: Record<Locale, string> = {
	ar: `تاريخ النهاية`,
	de: `Enddatum`,
	es: `Fecha de finalización`,
	fa: `تاریخ پایان`,
	fil: `Petsa ng pagtatapos`,
	fr: `Date de fin`,
	hi: `समाप्ति तिथि`,
	ht: `Dat fen`,
	it: `Data di fine`,
	ja: `終了日`,
	ko: `종료일`,
	mww: `Hnub xaus`,
	ps: `د پای نېټه`,
	pt: `Data de término`,
	'pt-pt': `Data de fim`,
	ru: `Дата окончания`,
	sm: `Aso fa'amutaina`,
	so: `Taariikhda dhammaadka`,
	th: `วันที่สิ้นสุด`,
	ur: `اختتام کی تاریخ`,
	vi: `Ngày kết thúc`,
	'zh-hans': `结束日期`,
	'zh-hant': `結束日期`,
	en: `End date`
};

export const loc_endTime: Record<Locale, string> = {
	ar: `نهاية الزمن`,
	de: `Endzeit`,
	es: `Fin del tiempo`,
	fa: `پایان زمان`,
	fil: `Oras ng pagtatapos`,
	fr: `Fin des temps`,
	hi: `समाप्ति समय`,
	ht: `Fen tan`,
	it: `Fine dei tempi`,
	ja: `終焉`,
	ko: `종말`,
	mww: `Lub sijhawm xaus`,
	ps: `د پای وخت`,
	pt: `Fim dos tempos`,
	'pt-pt': `Fim dos tempos`,
	ru: `Конец`,
	sm: `Taimi faamutaina`,
	so: `Waqtiga dhammaadka`,
	th: `เวลาสิ้นสุด`,
	ur: `اختتامی وقت`,
	vi: `Thời gian kết thúc`,
	'zh-hans': `末日`,
	'zh-hant': `終結時間`,
	en: `End time`
};

export const loc_enroll: Record<Locale, string> = {
	ar: `التسجيل`,
	de: `Einschreibung`,
	es: `Inscribirse`,
	fa: `ثبت نام`,
	fil: `Email Address *`,
	fr: `Inscrivez-vous`,
	hi: `दाखिला लेना`,
	ht: `Enskri`,
	it: `Iscriviti`,
	ja: `入学`,
	ko: `등록하세요`,
	mww: `Sau npe`,
	ps: `ثبت نام`,
	pt: `Matricular-se`,
	'pt-pt': `Inscreva-se`,
	ru: `Записаться`,
	sm: `Lesitala`,
	so: `Diiwaangelinta`,
	th: `ลงทะเบียน`,
	ur: `اندراج کریں`,
	vi: `Đăng ký`,
	'zh-hans': `报名`,
	'zh-hant': `報名`,
	en: `Enroll`
};

export const loc_enrolled: Record<Locale, string> = {
	ar: `مسجلون`,
	de: `Eingeschrieben`,
	es: `Matriculados`,
	fa: `ثبت نام شده`,
	fil: `Nagpatala`,
	fr: `Inscrit`,
	hi: `नामांकित`,
	ht: `Enskri`,
	it: `Iscritti`,
	ja: `入学者`,
	ko: `등록`,
	mww: `Sau npe`,
	ps: `ثبت شوی`,
	pt: `Matriculados`,
	'pt-pt': `Inscritos`,
	ru: `Поступил`,
	sm: `Lesitala`,
	so: `Iska diiwaangelinta`,
	th: `ลงทะเบียนแล้ว`,
	ur: `اندراج شدہ`,
	vi: `Đã ghi danh`,
	'zh-hans': `注册`,
	'zh-hant': `註冊`,
	en: `Enrolled`
};

export const loc_enrolledWith: Record<Locale, (name: unknown) => string> = {
	ar: (name) => `مسجل في ${name}`,
	de: (name) => `Eingeschrieben mit ${name}`,
	es: (name) => `Matriculado en ${name}`,
	fa: (name) => `ثبت نام با ${name}`,
	fil: (name) => `Email: ${name}`,
	fr: (name) => `Inscrit au ${name}`,
	hi: (name) => `${name} के साथ नामांकित`,
	ht: (name) => `Enskri nan ${name}`,
	it: (name) => `Iscritto al ${name}`,
	ja: (name) => `${name}に登録`,
	ko: (name) => `${name}에 등록됨`,
	mww: (name) => `Sau npe nrog ${name}`,
	ps: (name) => `د ${name} سره ثبت شوی`,
	pt: (name) => `Matriculado no ${name}`,
	'pt-pt': (name) => `Inscrito no ${name}`,
	ru: (name) => `Зарегистрирован по ${name}`,
	sm: (name) => `Lesitala i le ${name}`,
	so: (name) => `Waxaa lagu diiwaangeliyey ${name}`,
	th: (name) => `ลงทะเบียนกับ ${name}`,
	ur: (name) => `${name} کے ساتھ اندراج کیا گیا`,
	vi: (name) => `Đã đăng ký với ${name}`,
	'zh-hans': (name) => `注册电话为 ${name}`,
	'zh-hant': (name) => `已透過${name}報名`,
	en: (name) => `Enrolled with ${name}`
};

export const loc_enterAddressManually: Record<Locale, string> = {
	ar: `لا أستطيع العثور على العنوان الذي أبحث عنه. أحتاج إلى إدخال العنوان يدويا.`,
	de: `Ich finde die Adresse, die ich suche, nicht. Ich muss die Adresse manuell eingeben.`,
	es: `No encuentro la dirección que busco. Necesito introducir la dirección manualmente.`,
	fa: `آدرسی که دنبالش هستم را پیدا نمی کنم. باید آدرس رو دستی وارد کنم.`,
	fil: `Hindi ko mahanap ang address na hinahanap ko. Kailangan kong manu-manong ipasok ang address.`,
	fr: `Je ne trouve pas l’adresse que je cherche. Je dois entrer l’adresse manuellement.`,
	hi: `मुझे वह पता नहीं मिल रहा है जिसे मैं ढूंढ रहा हूं। मुझे मैन्युअल रूप से पता दर्ज करने की आवश्यकता है।`,
	ht: `Mwen pa ka jwenn adrès la mwen ap chèche pou. Mwen bezwen antre adrès la manyèlman.`,
	it: `Non riesco a trovare l'indirizzo che sto cercando. Devo inserire l'indirizzo manualmente.`,
	ja: `探している住所が見つかりません。住所を手動で入力する必要があります。`,
	ko: `내가 찾는 주소를 못 찾겠어. 주소를 수동으로 입력해야 합니다.`,
	mww: `Kuv nrhiav tsis tau qhov chaw nyob uas kuv tab tom nrhiav. Kuv yuav tsum tau sau qhov chaw nyob manually.`,
	ps: `زه هغه پته نه شم موندلی چې زه یې لټوم. زه باید پته په لاس داخل کړم.`,
	pt: `Não consigo encontrar o endereço que estou procurando. Preciso inserir o endereço manualmente.`,
	'pt-pt': `Não consigo encontrar a morada que procuro. Preciso de introduzir o endereço manualmente.`,
	ru: `Я не могу найти нужный адрес. Мне нужно ввести адрес вручную.`,
	sm: `E le mafai ona ou mauaina le tuatusi o lo'o ou sailia. E tatau ona ou ulufale i le tuatusi i le lima.`,
	so: `Ma heli karo cinwaanka aan raadinayo. Waxaan u baahanahay inaan cinwaanka gacanta ku geliyo.`,
	th: `ฉันไม่พบที่อยู่ที่ฉันกําลังมองหา ฉันต้องป้อนที่อยู่ด้วยตนเอง`,
	ur: `مجھے وہ پتہ نہیں مل رہا جس کی میں تلاش کر رہا ہوں۔ مجھے ایڈریس دستی طور پر درج کرنا ہے۔`,
	vi: `Tôi không thể tìm thấy địa chỉ mà tôi đang tìm kiếm. Tôi cần nhập địa chỉ theo cách thủ công.`,
	'zh-hans': `我找不到我要找的地址。我需要手动输入地址。`,
	'zh-hant': `我找不到我要找的地址。我需要手動輸入地址。`,
	en: `I can't find the address I'm looking for. I need to enter the address manually.`
};

export const loc_enterEmailForNextSteps: Record<Locale, string> = {
	ar: `أدخل بريدك الإلكتروني لتصلك الخطوات التالية.`,
	de: `Geben Sie Ihre E-Mail-Adresse ein, um die nächsten Schritte zu erhalten.`,
	es: `Introduce tu correo electrónico para recibir los siguientes pasos.`,
	fa: `ایمیل خود را وارد کنید تا مراحل بعدی را دریافت کنید.`,
	fil: `Ipasok ang iyong email upang matanggap ang mga susunod na hakbang.`,
	fr: `Saisissez votre adresse e-mail pour recevoir les prochaines étapes.`,
	hi: `अगले चरण प्राप्त करने के लिए अपना ईमेल दर्ज करें।`,
	ht: `Antre imèl ou pou resevwa pwochen etap yo.`,
	it: `Inserisci la tua email per ricevere i prossimi passi.`,
	ja: `次のステップを受け取るためにメールアドレスを入力してください。`,
	ko: `다음 단계를 받으려면 이메일을 입력하세요.`,
	mww: `Sau koj tus email kom tau txais cov kauj ruam tom ntej.`,
	ps: `خپل ایمیل داخل کړئ ترڅو راتلونکی ګامونه ترلاسه کړئ.`,
	pt: `Insira seu e-mail para receber os próximos passos.`,
	'pt-pt': `Insira o seu email para receber os próximos passos.`,
	ru: `Введите свой email, чтобы получать дальнейшие шаги.`,
	sm: `Ulufale i lau imeli e maua ai laasaga e sosoo ai.`,
	so: `Geli email-kaaga si aad u hesho tallaabooyinka xiga.`,
	th: `ป้อนอีเมลของคุณเพื่อรับขั้นตอนต่อไป`,
	ur: `اگلے اقدامات حاصل کرنے کے لیے اپنا ای میل درج کریں۔`,
	vi: `Nhập email của bạn để nhận các bước tiếp theo.`,
	'zh-hans': `输入您的电子邮件以接收下一步步骤。`,
	'zh-hant': `請輸入您的電子郵件以接收後續步驟。`,
	en: `Enter your email to receive next steps.`
};

export const loc_enterOneTimeCode: Record<Locale, string> = {
	ar: `أدخل رمز المرة الواحدة من تطبيق المصادقة الخاص بك.`,
	de: `Geben Sie den Einmalcode aus Ihrer Authenticator-App ein.`,
	es: `Introduce el código de un solo uso desde tu aplicación de autenticación.`,
	fa: `کد یک بار مصرف را از اپلیکیشن احراز هویت خود وارد کنید.`,
	fil: `Ipasok ang one-time code mula sa iyong authenticator app.`,
	fr: `Saisissez le code à usage unique depuis votre application d’authentification.`,
	hi: `अपने प्रमाणक ऐप से एक बार का कोड दर्ज करें।`,
	ht: `Antre kòd la yon sèl-fwa soti nan app otantifikatè ou.`,
	it: `Inserisci il codice monouso dalla tua app autenticatrice.`,
	ja: `認証アプリから一度きりのコードを入力してください。`,
	ko: `인증 앱에서 일회용 코드를 입력하세요.`,
	mww: `Sau tus lej ib zaug los ntawm koj lub authenticator app.`,
	ps: `د خپل تصدیق کوونکی اپلیکیشن څخه یو ځل کوډ داخل کړئ.`,
	pt: `Insira o código de uso único do seu aplicativo autenticador.`,
	'pt-pt': `Insira o código de utilização única na sua aplicação de autenticação.`,
	ru: `Введите одноразовый код из приложения аутентификации.`,
	sm: `Ulu atu i le code e tasi le taimi mai lau authenticator app.`,
	so: `Geli koodhka hal mar ee app-kaaga authenticator-ka.`,
	th: `ป้อนรหัสแบบใช้ครั้งเดียวจากแอปตัวยืนยันตัวตนของคุณ`,
	ur: `اپنے آتھنٹی کیٹر ایپ سے ون ٹائم کوڈ درج کریں۔`,
	vi: `Nhập mã dùng một lần từ ứng dụng xác thực.`,
	'zh-hans': `输入你认证器应用中的一次性验证码。`,
	'zh-hant': `輸入你驗證器應用程式的一次性驗證碼。`,
	en: `Enter the one-time code from your authenticator app.`
};

export const loc_entityTypeFieldFormat: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `مجال ${type}`,
	de: (type) => `${type}`,
	es: (type) => `${type}`,
	fa: (type) => `حوزه ${type}`,
	fil: (type) => `Larangan ${type}`,
	fr: (type) => `${type}`,
	hi: (type) => `${type} क्षेत्र`,
	ht: (type) => `${type} an`,
	it: (type) => `Campo ${type}`,
	ja: (type) => `${type}`,
	ko: (type) => `${type} 분야`,
	mww: (type) => `${type} teb`,
	ps: (type) => `${type} ساحه`,
	pt: (type) => `Campo ${type}`,
	'pt-pt': (type) => `${type}`,
	ru: (type) => `${type}`,
	sm: (type) => `${type} fanua`,
	so: (type) => `${type}`,
	th: (type) => `ฟิลด์${type}`,
	ur: (type) => `${type} میدان`,
	vi: (type) => `Lĩnh vực ${type}`,
	'zh-hans': (type) => `${type} 领域`,
	'zh-hant': (type) => `${type} 領域`,
	en: (type) => `${type} field`
};

export const loc_entityTypeReportFormat: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `تقرير ${type}`,
	de: (type) => `${type}`,
	es: (type) => `Informe ${type}`,
	fa: (type) => `گزارش ${type}`,
	fil: (type) => `Ulat ng ${type}`,
	fr: (type) => `Rapport ${type}`,
	hi: (type) => `${type} की रिपोर्ट`,
	ht: (type) => `${type} an`,
	it: (type) => `Rapporto ${type}`,
	ja: (type) => `${type} 報告`,
	ko: (type) => `${type} 보고서`,
	mww: (type) => `${type}`,
	ps: (type) => `${type} راپور`,
	pt: (type) => `Relatório ${type}`,
	'pt-pt': (type) => `Relatório ${type}`,
	ru: (type) => `${type}`,
	sm: (type) => `Lipoti a ${type}`,
	so: (type) => `${type}`,
	th: (type) => `รายงาน${type}`,
	ur: (type) => `${type} رپورٹ`,
	vi: (type) => `Báo cáo ${type}`,
	'zh-hans': (type) => `${type} 报告`,
	'zh-hant': (type) => `${type} 報告`,
	en: (type) => `${type} report`
};

export const loc_entries: Record<Locale, string> = {
	ar: `المشاركات`,
	de: `Einträge`,
	es: `Inscripciones`,
	fa: `ورودی ها`,
	fil: `Mga Entry`,
	fr: `Participations`,
	hi: `प्रविष्टियाँ`,
	ht: `Antre yo`,
	it: `Iscrizioni`,
	ja: `エントリー`,
	ko: `출전`,
	mww: `Nkag`,
	ps: `داخلې`,
	pt: `Inscrições`,
	'pt-pt': `Inscrições`,
	ru: `Участники`,
	sm: `Ulufale`,
	so: `Diiwaangelinta`,
	th: `ผลงาน`,
	ur: `اندراجات`,
	vi: `Bài dự thi`,
	'zh-hans': `参赛作品`,
	'zh-hant': `參賽作品`,
	en: `Entries`
};

export const loc_entry: Record<Locale, string> = {
	ar: `الدخول`,
	de: `Eintritt`,
	es: `Entrada`,
	fa: `ورود`,
	fil: `Entry`,
	fr: `Entrée`,
	hi: `प्रवेश-द्वार`,
	ht: `Antre`,
	it: `Partecipazione`,
	ja: `エントリー`,
	ko: `입국`,
	mww: `Nkag mus`,
	ps: `داخلې`,
	pt: `Entrada`,
	'pt-pt': `Entrada`,
	ru: `Запись`,
	sm: `Ulufale`,
	so: `Gelitaanka`,
	th: `รายการ`,
	ur: `انٹری`,
	vi: `Nhập cảnh`,
	'zh-hans': `参赛`,
	'zh-hant': `參賽`,
	en: `Entry`
};

export const loc_entryX: Record<Locale, string> = {
	ar: `المدخل العاشر`,
	de: `Eintrag X`,
	es: `Entrada X`,
	fa: `ورودی X`,
	fil: `Entry X`,
	fr: `Entrée X`,
	hi: `प्रवेश X`,
	ht: `Antre X`,
	it: `Voce X`,
	ja: `エントリーX`,
	ko: `기록 X`,
	mww: `Nkag X`,
	ps: `ننوت X`,
	pt: `Entrada X`,
	'pt-pt': `Entrada X`,
	ru: `Запись X`,
	sm: `Ulufale X`,
	so: `Gelitaanka X`,
	th: `รายการ X`,
	ur: `اندراج X`,
	vi: `Mục X`,
	'zh-hans': `条目X。`,
	'zh-hant': `條目X。`,
	en: `Entry X`
};

export const loc_entryY: Record<Locale, string> = {
	ar: `المدخل Y`,
	de: `Eintrag Y`,
	es: `Entrada Y`,
	fa: `ورودی Y`,
	fil: `Entry Y`,
	fr: `Entrée Y`,
	hi: `प्रवेश Y`,
	ht: `Antre Y`,
	it: `Voce Y`,
	ja: `エントリー Y`,
	ko: `항목 Y`,
	mww: `Nkag Y`,
	ps: `داخلی Y`,
	pt: `Entrada Y`,
	'pt-pt': `Entrada Y`,
	ru: `Запись Y`,
	sm: `Ulufale Y`,
	so: `Gelitaanka Y`,
	th: `รายการ Y`,
	ur: `اندراج Y`,
	vi: `Mục nhập Y`,
	'zh-hans': `条目 Y`,
	'zh-hant': `條目 Y`,
	en: `Entry Y`
};

export const loc_error: Record<Locale, string> = {
	ar: `خطأ`,
	de: `Fehler`,
	es: `Error`,
	fa: `خطا`,
	fil: `Error`,
	fr: `Erreur`,
	hi: `चूक`,
	ht: `Erè`,
	it: `Errore`,
	ja: `エラー`,
	ko: `오류`,
	mww: `yuam kev`,
	ps: `تېروتنه`,
	pt: `Erro`,
	'pt-pt': `Erro`,
	ru: `Ошибка`,
	sm: `Mea sese`,
	so: `Khalad`,
	th: `ข้อผิดพลาด`,
	ur: `غلطی`,
	vi: `lỗi`,
	'zh-hans': `错误`,
	'zh-hant': `錯誤`,
	en: `Error`
};

export const loc_errorPageLinksInstructions: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `اختر أحد الروابط أدناه للوصول إلى منطقة أخرى من ${cumulus}.`,
	de: (cumulus) => `Wählen Sie einen der untenstehenden Links, um auf einen weiteren ${cumulus} zuzugreifen.`,
	es: (cumulus) => `Selecciona uno de los enlaces a continuación para acceder a otra zona de ${cumulus}.`,
	fa: (cumulus) => `یکی از لینک های زیر را انتخاب کنید تا به منطقه دیگری از ${cumulus} دسترسی پیدا کنید.`,
	fil: (cumulus) => `Pumili ng isa sa mga link sa ibaba upang ma-access ang isa pang lugar ng ${cumulus}.`,
	fr: (cumulus) => `Sélectionnez l’un des liens ci-dessous pour accéder à une autre zone de ${cumulus}.`,
	hi: (cumulus) => `${cumulus} के किसी अन्य क्षेत्र तक पहुंचने के लिए नीचे दिए गए लिंक में से एक का चयन करें।`,
	ht: (cumulus) => `Chwazi youn nan lyen ki anba yo jwenn aksè nan yon lòt zòn ${cumulus}.`,
	it: (cumulus) => `Seleziona uno dei link qui sotto per accedere a un'altra area di ${cumulus}.`,
	ja: (cumulus) => `下のリンクのいずれかを選択して、 ${cumulus}の別のエリアにアクセスしてください。`,
	ko: (cumulus) => `아래 링크 중 하나를 선택하여 ${cumulus}의 다른 영역에 접속하세요.`,
	mww: (cumulus) => `Xaiv ib qho ntawm cov kev txuas hauv qab no kom nkag mus rau lwm qhov chaw ntawm ${cumulus}.`,
	ps: (cumulus) => `لاندې لینکونو څخه یو انتخاب کړئ ترڅو د ${cumulus} بلې سیمې ته لاسرسی ولرئ.`,
	pt: (cumulus) => `Selecione um dos links abaixo para acessar outra área de ${cumulus}.`,
	'pt-pt': (cumulus) => `Selecione um dos links abaixo para aceder a outra área de ${cumulus}.`,
	ru: (cumulus) => `Выберите одну из ссылок ниже, чтобы получить доступ к другой части ${cumulus}.`,
	sm: (cumulus) => `Filifili se tasi o feso'ota'iga o lo'o i lalo e ulufale ai i se isi vaega o ${cumulus}.`,
	so: (cumulus) => `Dooro mid ka mid ah xiriiriyeyaasha hoose si aad u gasho aag kale oo ${cumulus} ah.`,
	th: (cumulus) => `เลือกลิงก์ใดลิงก์หนึ่งด้านล่างเพื่อเข้าถึงพื้นที่อื่นของ ${cumulus}`,
	ur: (cumulus) => `نیچے دیے گئے لنکس میں سے کسی ایک کو منتخب کریں تاکہ ${cumulus} کے دوسرے علاقے تک رسائی حاصل کی جا سکے۔`,
	vi: (cumulus) => `Chọn một trong các liên kết bên dưới để truy cập một khu vực khác của ${cumulus}.`,
	'zh-hans': (cumulus) => `请选择以下链接之一，访问 ${cumulus}的另一个区域。`,
	'zh-hant': (cumulus) => `請選擇以下連結之一，即可進入 ${cumulus} 的另一個區域。`,
	en: (cumulus) => `Select one of the links below to access another area of ${cumulus}.`
};

export const loc_ethnicity: Record<Locale, string> = {
	ar: `العرق`,
	de: `Ethnizität`,
	es: `Etnia`,
	fa: `قومیت`,
	fil: `Etnisidad`,
	fr: `Ethnicité`,
	hi: `जातीयता`,
	ht: `Etnisite`,
	it: `Etnicità`,
	ja: `民族`,
	ko: `민족`,
	mww: `Haiv Neeg`,
	ps: `قومیت`,
	pt: `Etnia`,
	'pt-pt': `Etnia`,
	ru: `Этническая принадлежность`,
	sm: `Ituaiga`,
	so: `Qowmiyad`,
	th: `เชื้อชาติ`,
	ur: `نسلی شناخت`,
	vi: `Dân tộc`,
	'zh-hans': `族裔`,
	'zh-hant': `族群`,
	en: `Ethnicity`
};

export const loc_event: Record<Locale, string> = {
	ar: `الحدث`,
	de: `Veranstaltung`,
	es: `Evento`,
	fa: `رویداد`,
	fil: `Kaganapan`,
	fr: `Événement`,
	hi: `आयोजन`,
	ht: `Evènman an`,
	it: `Evento`,
	ja: `イベント`,
	ko: `행사`,
	mww: `Kev tshwm sim`,
	ps: `پیښه`,
	pt: `Evento`,
	'pt-pt': `Evento`,
	ru: `Событие`,
	sm: `Mea na tupu`,
	so: `Dhacdo`,
	th: `เหตุการณ์`,
	ur: `تقریب`,
	vi: `Sự kiện`,
	'zh-hans': `事件`,
	'zh-hant': `活動`,
	en: `Event`
};

export const loc_eventDetails: Record<Locale, string> = {
	ar: `تفاصيل الحدث`,
	de: `Veranstaltungsdetails`,
	es: `Detalles del evento`,
	fa: `جزئیات رویداد`,
	fil: `Mga detalye ng kaganapan`,
	fr: `Détails de l’événement`,
	hi: `घटना विवरण`,
	ht: `Detay evènman an`,
	it: `Dettagli dell'evento`,
	ja: `イベントの詳細`,
	ko: `행사 세부 정보`,
	mww: `Cov ntsiab lus xwm txheej`,
	ps: `د پیښې تفصیلات`,
	pt: `Detalhes do evento`,
	'pt-pt': `Detalhes do evento`,
	ru: `Подробности мероприятия`,
	sm: `Auiliiliga o mea na tutupu`,
	so: `Faahfaahinta dhacdada`,
	th: `รายละเอียดกิจกรรม`,
	ur: `ایونٹ کی تفصیلات`,
	vi: `Chi tiết sự kiện`,
	'zh-hans': `活动详情`,
	'zh-hant': `活動詳情`,
	en: `Event details`
};

export const loc_eventEnrollmentAllCaughtUp: Record<Locale, string> = {
	ar: `لقد وصلتم بالركب`,
	de: `Du bist ganz auf dem neuesten Stand`,
	es: `Ya estáis al día`,
	fa: `همه چیز رو به روز کردی`,
	fil: `Nakahabol ka na`,
	fr: `Tu es à jour`,
	hi: `तुम सब उलझे हुए हो`,
	ht: `Nou tout kenbe`,
	it: `Sei completamente aggiornato`,
	ja: `もう全部追いついたよ`,
	ko: `다 따라잡았네`,
	mww: `Koj twb paub tag lawm`,
	ps: `ته ټول معلومات ترلاسه کړې`,
	pt: `Você está totalmente em dia`,
	'pt-pt': `Já estás em dia`,
	ru: `Вы всё в курсе`,
	sm: `Ua outou maua uma i luga`,
	so: `Dhammaan waad la socotaa`,
	th: `คุณตามทันหมดแล้ว`,
	ur: `آپ سب کچھ اپ ڈیٹ کر چکے ہیں`,
	vi: `Bạn đã nắm bắt hết rồi`,
	'zh-hans': `你都跟上了`,
	'zh-hant': `你已經全部追上進度了`,
	en: `You're all caught up`
};

export const loc_eventEnrollmentComplete: Record<Locale, string> = {
	ar: `اكتمال الحدث`,
	de: `Veranstaltung abgeschlossen`,
	es: `Evento completado`,
	fa: `رویداد کامل شد`,
	fil: `Natapos na ang kaganapan`,
	fr: `Événement terminé`,
	hi: `घटना पूर्ण`,
	ht: `Evènman konplè`,
	it: `Evento completato`,
	ja: `イベント完了`,
	ko: `이벤트 완료`,
	mww: `Kev tshwm sim tiav lawm`,
	ps: `پیښه بشپړه شوه`,
	pt: `Evento concluído`,
	'pt-pt': `Evento concluído`,
	ru: `Мероприятие завершено`,
	sm: `Mae'a le mea na tupu`,
	so: `Dhacdada la dhammeystiray`,
	th: `กิจกรรมเสร็จสมบูรณ์`,
	ur: `ایونٹ مکمل`,
	vi: `Sự kiện hoàn thành`,
	'zh-hans': `活动结束`,
	'zh-hant': `活動完成`,
	en: `Event complete`
};

export const loc_eventEnrollmentCompleteDescription: Record<Locale, string> = {
	ar: `انتهى هذا الحدث.`,
	de: `Dieses Ereignis ist beendet.`,
	es: `Este evento ha terminado.`,
	fa: `این رویداد به پایان رسیده است.`,
	fil: `Tapos na ang kaganapang ito.`,
	fr: `Cet événement est terminé.`,
	hi: `यह घटना समाप्त हो गई है।`,
	ht: `Evènman sa a te fini.`,
	it: `Questo evento è finito.`,
	ja: `このイベントは終了しました。`,
	ko: `이 행사는 끝났습니다.`,
	mww: `Qhov kev tshwm sim no twb xaus lawm.`,
	ps: `دا پیښه پای ته ورسېده.`,
	pt: `Este evento acabou.`,
	'pt-pt': `Este evento terminou.`,
	ru: `Это мероприятие закончилось.`,
	sm: `Ua mae'a lenei mea na tupu.`,
	so: `Dhacdadan waa dhammaatay.`,
	th: `งานนี้จบลงแล้ว`,
	ur: `یہ واقعہ ختم ہو چکا ہے۔`,
	vi: `Sự kiện này đã kết thúc.`,
	'zh-hans': `这个活动已经结束。`,
	'zh-hant': `這個活動已經結束了。`,
	en: `This event has ended.`
};

export const loc_eventEnrollmentEmailNotice: Record<Locale, string> = {
	ar: `من خلال تقديم هذا النموذج، توافق على تلقي رسائل بريد إلكتروني حول هذا الحدث، بما في ذلك تحديثات التسجيل، والنماذج المطلوبة، وتغييرات الجدول، والتذكيرات.`,
	de: `Mit dem Einreichen dieses Formulars stimmen Sie zu, E-Mails zu dieser Veranstaltung zu erhalten, einschließlich Aktualisierungen zur Anmeldung, erforderlichen Formularen, Terminänderungen und Erinnerungen.`,
	es: `Al enviar este formulario, aceptas recibir correos electrónicos sobre este evento, incluyendo actualizaciones sobre inscripciones, formularios obligatorios, cambios de horario y recordatorios.`,
	fa: `با ارسال این فرم، شما موافقت می کنید که ایمیل هایی درباره این رویداد دریافت کنید، از جمله به روزرسانی های ثبت نام، فرم های الزامی، تغییرات برنامه زمانی و یادآوری ها.`,
	fil: `Sa pagsusumite ng form na ito, sumasang-ayon kang makatanggap ng mga email tungkol sa event na ito, kabilang ang mga update sa enrollment, mga kinakailangang form, pagbabago sa iskedyul, at mga paalala.`,
	fr: `En soumettant ce formulaire, vous acceptez de recevoir des e-mails concernant cet événement, incluant des mises à jour sur les inscriptions, les formulaires obligatoires, les modifications du calendrier et les rappels.`,
	hi: `इस फॉर्म को सबमिट करके, आप इस ईवेंट के बारे में ईमेल प्राप्त करने के लिए सहमत होते हैं, जिसमें नामांकन अपडेट, आवश्यक फॉर्म, शेड्यूल परिवर्तन और अनुस्मारक शामिल हैं।`,
	ht: `Lè w soumèt fòm sa a, ou dakò pou resevwa imèl sou evènman sa a, ki gen ladan mizajou enskripsyon, fòm obligatwa, chanjman orè ak rapèl.`,
	it: `Inviando questo modulo, accetti di ricevere email relative a questo evento, inclusi aggiornamenti sulle iscrizioni, moduli richiesti, modifiche al calendario e promemoria.`,
	ja: `このフォームを提出することで、登録状況の更新、必要なフォーム、スケジュール変更、リマインダーなどのメールを受け取ることに同意したことになります。`,
	ko: `이 양식을 제출함으로써 등록 업데이트, 필수 양식, 일정 변경 및 알림 등 이 행사에 관한 이메일을 받기로 동의하는 것입니다.`,
	mww: `Los ntawm kev xa daim foos no, koj pom zoo txais email txog qhov kev tshwm sim no, suav nrog kev hloov tshiab sau npe, cov foos tsim nyog, hloov sijhawm, thiab kev ceeb toom.`,
	ps: `د دې فورمې سپارلو سره، تاسو موافقه کوئ چې د دې پیښې په اړه ایمیلونه ترلاسه کړئ، چې پکې د نوم لیکنې تازه معلومات، اړین فورمې، مهالویش بدلونونه، او یادونې شاملې دی.`,
	pt: `Ao enviar este formulário, você concorda em receber e-mails sobre este evento, incluindo atualizações sobre inscrições, formulários obrigatórios, alterações de agenda e lembretes.`,
	'pt-pt': `Ao submeter este formulário, concorda em receber emails sobre este evento, incluindo atualizações sobre inscrições, formulários obrigatórios, alterações no horário e lembretes.`,
	ru: `Отправляя эту форму, вы соглашаетесь получать письма по электронной почте об этом событии, включая обновления о регистрации, необходимые формы, изменения расписания и напоминания.`,
	sm: `E ala i le tu'uina atu o lenei fomu, ua e malilie e maua imeli e uiga i lenei mea na tupu, e aofia ai fa'afouga o le lesitalaina, fomu mana'omia, suiga o le fa'asologa, ma fa'amanatuga.`,
	so: `Adigoo gudbinaya foomkan, waxaad ogolaatay inaad hesho iimaylo ku saabsan dhacdadan, oo ay ku jiraan cusbooneysiinta diiwaangelinta, foomamka loo baahan yahay, isbeddelada jadwalka, iyo xusuusinta.`,
	th: `โดยการส่งแบบฟอร์มนี้ คุณตกลงที่จะได้รับอีเมลเกี่ยวกับกิจกรรมนี้ รวมถึงการอัปเดตการลงทะเบียน แบบฟอร์มที่จําเป็น การเปลี่ยนแปลงตารางเวลา และการเตือนความจํา`,
	ur: `یہ فارم جمع کروا کر، آپ اس واقعے کے بارے میں ای میلز وصول کرنے سے اتفاق کرتے ہیں، جن میں اندراج کی تازہ کاری، ضروری فارم، شیڈول میں تبدیلیاں، اور یاد دہانیاں شامل ہیں۔`,
	vi: `Bằng cách gửi biểu mẫu này, bạn đồng ý nhận email về sự kiện này, bao gồm cập nhật đăng ký, biểu mẫu bắt buộc, thay đổi lịch trình và nhắc nhở.`,
	'zh-hans': `提交此表格即表示您同意接收有关本次活动的电子邮件，包括报名更新、必需表格、日程变更和提醒。`,
	'zh-hant': `提交此表單即表示您同意接收有關本次活動的電子郵件，包括報名更新、必需表格、行程變更及提醒。`,
	en: `By submitting this form, you agree to receive emails about this event, including enrollment updates, required forms, schedule changes, and reminders.`
};

export const loc_eventEnrollmentEnrolled: Record<Locale, string> = {
	ar: `أنت مسجلة`,
	de: `Du bist eingeschrieben`,
	es: `Estás matriculado`,
	fa: `شما ثبت نام کرده اید`,
	fil: `Naka-enroll ka na`,
	fr: `Vous êtes inscrit`,
	hi: `आप नामांकित हैं`,
	ht: `Ou enskri`,
	it: `Sei iscritto`,
	ja: `あなたは登録済みです`,
	ko: `등록 완료`,
	mww: `Koj tau sau npe lawm`,
	ps: `ته نوم لیکنه کړې`,
	pt: `Você está matriculado`,
	'pt-pt': `Estás inscrito`,
	ru: `Ты зачислен`,
	sm: `Ua e lesitala`,
	so: `Waad is diiwaan gashay`,
	th: `คุณลงทะเบียนแล้ว`,
	ur: `آپ داخل ہیں`,
	vi: `Bạn đã đăng ký`,
	'zh-hans': `你已经注册了`,
	'zh-hant': `你已經註冊了`,
	en: `You're enrolled`
};

export const loc_eventEnrollmentEnrolledDescription: Record<Locale, string> = {
	ar: `تم تأكيد تسجيلك.`,
	de: `Ihre Einschreibung wurde bestätigt.`,
	es: `Tu matrícula ha sido confirmada.`,
	fa: `ثبت نام شما تأیید شده است.`,
	fil: `Nakumpirma na ang iyong pag-enroll.`,
	fr: `Votre inscription a été confirmée.`,
	hi: `आपके नामांकन की पुष्टि हो गई है।`,
	ht: `Yo te konfime enskripsyon ou.`,
	it: `La tua iscrizione è stata confermata.`,
	ja: `あなたの登録は確認されました。`,
	ko: `등록이 확정되었습니다.`,
	mww: `Koj qhov kev sau npe tau lees paub lawm.`,
	ps: `ستاسو نوم لیکنه تایید شوه.`,
	pt: `Sua matrícula foi confirmada.`,
	'pt-pt': `A sua inscrição foi confirmada.`,
	ru: `Ваша регистрация подтверждена.`,
	sm: `Ua fa'amaonia lau lesitalaina.`,
	so: `Diiwaangelintaada waa la xaqiijiyay.`,
	th: `การลงทะเบียนของคุณได้รับการยืนยันแล้ว`,
	ur: `آپ کی داخلہ کی تصدیق ہو گئی ہے۔`,
	vi: `Việc đăng ký của bạn đã được xác nhận.`,
	'zh-hans': `您的注册已确认。`,
	'zh-hant': `您的註冊已確認。`,
	en: `Your enrollment has been confirmed.`
};

export const loc_eventEnrollmentFillInstructions: Record<Locale, string> = {
	ar: `هذا النموذج جزء من تسجيلك في الفعالية. أكملوه أدناه. بعد تقديمه، ستعود إلى صفحة التسجيل في الفعالية.`,
	de: `Dieses Formular ist Teil Ihrer Veranstaltungsanmeldung. Füllen Sie es unten aus. Nachdem Sie es abgegeben haben, kehren Sie zu Ihrer Veranstaltungsanmeldeseite zurück.`,
	es: `Este formulario forma parte de tu inscripción al evento. Rellena a continuación. Después de enviarlo, volverás a tu página de inscripción al evento.`,
	fa: `این فرم بخشی از ثبت نام رویداد شماست. آن را در ادامه تکمیل کنید. پس از ارسال، به صفحه ثبت نام رویداد خود بازخواهید گشت.`,
	fil: `Ang form na ito ay bahagi ng iyong event enrollment. Punan mo ito sa ibaba. Pagkatapos mong isumite, babalik ka sa iyong event enrollment page.`,
	fr: `Ce formulaire fait partie de votre inscription à l’événement. Remplissez-le ci-dessous. Après l’avoir soumis, vous retournerez à votre page d’inscription à l’événement.`,
	hi: `यह फ़ॉर्म आपके ईवेंट नामांकन का हिस्सा है. इसे नीचे पूरा करें. इसे सबमिट करने के बाद, आप अपने ईवेंट नामांकन पृष्ठ पर वापस आ जाएंगे.`,
	ht: `Fòm sa a fè pati enskripsyon evènman ou. Ranpli li anba a. Apre ou fin soumèt li, ou pral retounen nan paj enskripsyon evènman ou an.`,
	it: `Questo modulo fa parte della tua iscrizione all'evento. Compilalo qui sotto. Dopo averlo inviato, tornerai alla pagina di iscrizione all'evento.`,
	ja: `このフォームはイベント登録の一部です。下記に記入してください。提出後、イベント登録ページに戻ります。`,
	ko: `이 양식은 이벤트 등록의 일부입니다. 아래에 작성해 주세요. 제출 후 이벤트 등록 페이지로 돌아가게 됩니다.`,
	mww: `Daim foos no yog ib feem ntawm koj qhov kev sau npe kev tshwm sim. Sau nws hauv qab no. Tom qab koj xa nws, koj yuav rov qab mus rau koj nplooj ntawv sau npe kev tshwm sim.`,
	ps: `دا فورمه ستاسو د پیښو د ثبت یوه برخه ده. لاندې یې بشپړه کړئ. کله چې تاسو دا وسپارئ، تاسو به خپل د پیښې د نوم لیکنې پاڼې ته ستانه شئ.`,
	pt: `Este formulário faz parte da sua inscrição no evento. Preencha abaixo. Após enviá-lo, você retornará à sua página de inscrição no evento.`,
	'pt-pt': `Este formulário faz parte da sua inscrição no evento. Preencha-o abaixo. Depois de o submeter, deverá voltar à página de inscrição no seu evento.`,
	ru: `Эта форма является частью вашей регистрации на мероприятие. Заполните её ниже. После отправки вы вернётесь на страницу регистрации на мероприятие.`,
	sm: `O lenei fomu o se vaega o lau lesitala i le mea na tupu. Fa'atumu i lalo. A mae'a ona e tu'uina atu, o le a e toe fo'i i lau itulau lesitala o mea na tutupu.`,
	so: `Foomkan waa qayb ka mid ah diiwaangelinta dhacdadaada. Buuxi hoos. Markaad gudbiso, waxaad ku soo laaban doontaa bogga diiwaangelinta dhacdadaada.`,
	th: `แบบฟอร์มนี้เป็นส่วนหนึ่งของการลงทะเบียนกิจกรรมของคุณกรอกข้อมูลด้านล่างหลังจากที่คุณส่งแบบฟอร์มแล้ว คุณจะกลับไปยังหน้าลงทะเบียนกิจกรรมของคุณ`,
	ur: `یہ فارم آپ کے ایونٹ انرولمنٹ کا حصہ ہے۔ اسے نیچے مکمل کریں۔ جمع کروانے کے بعد، آپ اپنے ایونٹ انرولمنٹ پیج پر واپس جائیں گے۔`,
	vi: `Biểu mẫu này là một phần của đăng ký sự kiện của bạn. Hoàn thành bên dưới. Sau khi bạn gửi, bạn sẽ quay lại trang đăng ký sự kiện của mình.`,
	'zh-hans': `此表格是您活动报名的一部分。请填写下方。提交后，您将返回您的活动报名页面。`,
	'zh-hant': `此表單是您活動報名的一部分。請在下方填寫。提交後，您將返回活動報名頁面。`,
	en: `This form is part of your event enrollment. Complete it below. After you submit it, you'll return to your event enrollment page.`
};

export const loc_eventEnrollmentLinkMessage: Record<Locale, (url: unknown) => string> = {
	ar: (url) => `استخدم هذا الرابط لعرض تسجيلك في الحدث والخطوات التالية: ${url}`,
	de: (url) => `Nutzen Sie diesen Link, um Ihre Veranstaltungsanmeldung und die nächsten Schritte einzusehen: ${url}`,
	es: (url) => `Utiliza este enlace para ver tu inscripción en el evento y los siguientes pasos: ${url}`,
	fa: (url) => `از این لینک برای مشاهده ثبت نام رویداد و مراحل بعدی استفاده کنید: ${url}`,
	fil: (url) => `Gamitin ang link na ito upang makita ang iyong pag-enroll sa event at mga susunod na hakbang: ${url}`,
	fr: (url) => `Utilisez ce lien pour consulter votre inscription à l’événement et les prochaines étapes : ${url}`,
	hi: (url) => `अपने ईवेंट नामांकन और अगले चरणों को देखने के लिए इस लिंक का उपयोग करें: ${url}`,
	ht: (url) => `Sèvi ak lyen sa a pou w wè enskripsyon evènman ou ak pwochen etap yo: ${url}`,
	it: (url) => `Usa questo link per visualizzare l'iscrizione all'evento e i prossimi passaggi: ${url}`,
	ja: (url) => `こちらのリンクからイベント登録状況と今後のステップを確認できます: ${url}`,
	ko: (url) => `이 링크를 이용해 이벤트 등록 및 다음 단계를 확인하세요: ${url}`,
	mww: (url) => `Siv qhov txuas no los saib koj qhov kev sau npe thiab cov kauj ruam tom ntej: ${url}`,
	ps: (url) => `دا لینک وکاروئ ترڅو د خپل پیښو نوم لیکنه او راتلونکی ګامونه وګورئ: ${url}`,
	pt: (url) => `Use este link para ver sua inscrição no evento e os próximos passos: ${url}`,
	'pt-pt': (url) => `Use este link para ver a inscrição no seu evento e os próximos passos: ${url}`,
	ru: (url) => `Используйте эту ссылку, чтобы увидеть регистрацию на мероприятие и следующие шаги: ${url}`,
	sm: (url) => `Fa'aaoga lenei feso'ota'iga e va'ai ai i lau lesitala ma isi la'asaga: ${url}`,
	so: (url) => `Isticmaal xiriirkan si aad u aragto diiwaangelinta dhacdadaada iyo tallaabooyinka xiga: ${url}`,
	th: (url) => `ใช้ลิงก์นี้เพื่อดูการลงทะเบียนกิจกรรมและขั้นตอนถัดไป: ${url}`,
	ur: (url) => `اپنے ایونٹ میں اندراج اور اگلے اقدامات دیکھنے کے لیے اس لنک کا استعمال کریں: ${url}`,
	vi: (url) => `Sử dụng liên kết này để xem việc đăng ký sự kiện và các bước tiếp theo: ${url}`,
	'zh-hans': (url) => `请使用此链接查看您的活动报名情况及下一步步骤： ${url}`,
	'zh-hant': (url) => `使用此連結查看您的活動報名及後續步驟： ${url}`,
	en: (url) => `Use this link to view your event enrollment and next steps: ${url}`
};

export const loc_eventEnrollmentMeetingPending: Record<Locale, string> = {
	ar: `ستكون معلومات الاجتماعات متاحة بمجرد تأكيد تسجيلك.`,
	de: `Informationen zu den Sitzungen werden verfügbar sein, sobald Ihre Einschreibung bestätigt ist.`,
	es: `La información sobre la reunión estará disponible una vez confirmada tu inscripción.`,
	fa: `اطلاعات جلسه پس از تأیید ثبت نام شما در دسترس خواهد بود.`,
	fil: `Ang impormasyon tungkol sa meeting ay magiging available kapag nakumpirma na ang iyong enrollment.`,
	fr: `Les informations sur la réunion seront disponibles une fois votre inscription confirmée.`,
	hi: `आपके नामांकन की पुष्टि होने के बाद मीटिंग की जानकारी उपलब्ध होगी।`,
	ht: `Enfòmasyon sou reyinyon yo ap disponib yon fwa yo konfime enskripsyon ou.`,
	it: `Le informazioni sugli incontri saranno disponibili una volta confermata la tua iscrizione.`,
	ja: `登録が確認され次第、ミーティング情報が公開されます。`,
	ko: `등록이 확정되면 회의 정보가 제공됩니다.`,
	mww: `Cov ntaub ntawv txog kev sib tham yuav muaj thaum koj tau lees paub kev sau npe.`,
	ps: `د غونډې معلومات به هغه وخت ترلاسه شی کله چې ستاسو نوم لیکنه تایید شی.`,
	pt: `As informações sobre a reunião estarão disponíveis assim que sua matrícula for confirmada.`,
	'pt-pt': `A informação sobre a reunião estará disponível assim que a sua inscrição for confirmada.`,
	ru: `Информация о встрече будет доступна после подтверждения вашей регистрации.`,
	sm: `O le a maua fa'amatalaga o fonotaga pe a mae'a ona fa'amaonia lau lesitala.`,
	so: `Macluumaadka shirarka ayaa la heli doonaa marka diiwaangelintaada la xaqiijiyo.`,
	th: `ข้อมูลการประชุมจะพร้อมใช้งานเมื่อการลงทะเบียนของคุณได้รับการยืนยันแล้ว`,
	ur: `میٹنگ کی معلومات آپ کے اندراج کی تصدیق کے بعد دستیاب ہو جائے گی۔`,
	vi: `Thông tin về cuộc họp sẽ được cung cấp khi bạn xác nhận đăng ký.`,
	'zh-hans': `一旦你的报名确认，会议信息将会公布。`,
	'zh-hant': `會議資訊將在您的報名確認後公布。`,
	en: `Meeting information will be available once your enrollment is confirmed.`
};

export const loc_eventEnrollmentNextStep: Record<Locale, string> = {
	ar: `الخطوة التالية`,
	de: `Nächster Schritt`,
	es: `Siguiente paso`,
	fa: `گام بعدی`,
	fil: `Susunod na hakbang`,
	fr: `Étape suivante`,
	hi: `अगला कदम`,
	ht: `Pwochen etap`,
	it: `Passo successivo`,
	ja: `次のステップ`,
	ko: `다음 단계`,
	mww: `Kauj ruam tom ntej`,
	ps: `بل ګام`,
	pt: `Próximo passo`,
	'pt-pt': `Próximo passo`,
	ru: `Следующий шаг`,
	sm: `O le isi laasaga`,
	so: `Tallaabada xigta`,
	th: `ขั้นตอนถัดไป`,
	ur: `اگلا مرحلہ`,
	vi: `Bước tiếp theo`,
	'zh-hans': `下一步`,
	'zh-hant': `下一步`,
	en: `Next step`
};

export const loc_eventEnrollmentNotCompleted: Record<Locale, string> = {
	ar: `لم يكتمل`,
	de: `Nicht fertiggestellt`,
	es: `No completado`,
	fa: `تکمیل نشده`,
	fil: `Hindi pa natapos`,
	fr: `Non terminé`,
	hi: `पूरा नहीं हुआ`,
	ht: `Pa fini`,
	it: `Non completato`,
	ja: `未完成`,
	ko: `완성되지 않음`,
	mww: `Tsis tau tiav`,
	ps: `بشپړ شوی نه دی`,
	pt: `Não concluído`,
	'pt-pt': `Não concluído`,
	ru: `Не завершено`,
	sm: `E le'i mae'a`,
	so: `Lama dhammeystirin`,
	th: `ยังไม่เสร็จสมบูรณ์`,
	ur: `مکمل نہیں ہوا`,
	vi: `Chưa hoàn thành`,
	'zh-hans': `未完成`,
	'zh-hant': `未完成`,
	en: `Not completed`
};

export const loc_eventEnrollmentPageTitle: Record<Locale, string> = {
	ar: `تسجيل الفعاليات`,
	de: `Teilnehmerzahl an Veranstaltungen`,
	es: `Inscripción en eventos`,
	fa: `ثبت نام در رویدادها`,
	fil: `Pag-enroll sa mga kaganapan`,
	fr: `Inscription aux événements`,
	hi: `इवेंट नामांकन`,
	ht: `Enskripsyon evènman an`,
	it: `Iscrizione agli eventi`,
	ja: `イベント登録`,
	ko: `행사 등록`,
	mww: `Kev sau npe rau kev tshwm sim`,
	ps: `د پیښو نوم لیکنه`,
	pt: `Inscrição em eventos`,
	'pt-pt': `Inscrição em eventos`,
	ru: `Количество участников на мероприятиях`,
	sm: `Lesitala o mea na tutupu`,
	so: `Diiwaangelinta dhacdooyinka`,
	th: `การรับสมัครเข้าร่วมกิจกรรม`,
	ur: `ایونٹ میں داخلہ`,
	vi: `Đăng ký sự kiện`,
	'zh-hans': `活动报名`,
	'zh-hant': `活動報名`,
	en: `Event enrollment`
};

export const loc_eventEnrollmentPending: Record<Locale, string> = {
	ar: `الالتحاق المقرر`,
	de: `Einschreibung steht noch aus`,
	es: `Matrícula pendiente`,
	fa: `ثبت نام در انتظار`,
	fil: `Nakabinbin ang enrollment`,
	fr: `Inscription en attente`,
	hi: `नामांकन लंबित है`,
	ht: `Annatant enskripsyon an`,
	it: `Iscrizione in attesa`,
	ja: `入学予定`,
	ko: `등록 진행 대기 중입니다`,
	mww: `Kev sau npe tseem tos`,
	ps: `نوم لیکنه لا هم نه ده`,
	pt: `Matrícula pendente`,
	'pt-pt': `Inscrição pendente`,
	ru: `Регистрация находится на стадии`,
	sm: `Lesitala o lo'o fa'atali`,
	so: `Diiwaangelinta ayaa sugaysa`,
	th: `รอการลงทะเบียน`,
	ur: `داخلہ زیر التوا`,
	vi: `Đang chờ đăng ký`,
	'zh-hans': `注册待定`,
	'zh-hant': `註冊待定`,
	en: `Enrollment pending`
};

export const loc_eventEnrollmentPendingDescription: Record<Locale, string> = {
	ar: `يتم مراجعة تسجيلك.`,
	de: `Ihre Einschreibung wird überprüft.`,
	es: `Tu matrícula está siendo revisada.`,
	fa: `ثبت نام شما در حال بررسی است.`,
	fil: `Sinusuri ang iyong enrollment.`,
	fr: `Votre inscription est en cours d’examen.`,
	hi: `आपके नामांकन की समीक्षा की जा रही है।`,
	ht: `Yo revize enskripsyon ou an.`,
	it: `La tua iscrizione è in fase di revisione.`,
	ja: `あなたの登録は審査中です。`,
	ko: `등록 기록이 검토 중입니다.`,
	mww: `Koj qhov kev sau npe tab tom raug tshuaj xyuas.`,
	ps: `ستاسو نوم لیکنه ارزول کېږی.`,
	pt: `Sua matrícula está sendo revisada.`,
	'pt-pt': `A sua inscrição está a ser revista.`,
	ru: `Ваша регистрация пересматривается.`,
	sm: `O lo'o toe iloiloina lau lesitalaina.`,
	so: `Diiwaangelintaada ayaa dib loo eegayaa.`,
	th: `การลงทะเบียนของคุณกําลังถูกตรวจสอบ`,
	ur: `آپ کی رجسٹریشن کا جائزہ لیا جا رہا ہے۔`,
	vi: `Việc đăng ký của bạn đang được xem xét.`,
	'zh-hans': `你的注册正在被审核。`,
	'zh-hant': `你的登記正在被審查。`,
	en: `Your enrollment is being reviewed.`
};

export const loc_eventEnrollmentViewUpcoming: Record<Locale, string> = {
	ar: `عرض المواد القادمة`,
	de: `Sehen Sie kommende Artikel an`,
	es: `Ver próximos artículos`,
	fa: `موارد آینده را مشاهده کنید`,
	fil: `Tingnan ang mga paparating na item`,
	fr: `Voir les prochains articles`,
	hi: `आगामी आइटम देखें`,
	ht: `Gade atik kap vini yo`,
	it: `Visualizza i prossimi articoli`,
	ja: `今後の商品を見る`,
	ko: `다가오는 항목 보기`,
	mww: `Saib cov khoom uas yuav los tom ntej`,
	ps: `راتلونکی توکی وګورئ`,
	pt: `Veja os próximos itens`,
	'pt-pt': `Ver os próximos artigos`,
	ru: `Просмотр предстоящих материалов`,
	sm: `Va'ai aitema o lo'o lumana'i`,
	so: `Daawo alaabooyinka soo socda`,
	th: `ดูสินค้าที่จะมาถึง`,
	ur: `آئندہ آئٹمز دیکھیں`,
	vi: `Xem các mặt hàng sắp tới`,
	'zh-hans': `查看即将发布的内容`,
	'zh-hant': `查看即將推出的項目`,
	en: `View upcoming items`
};

export const loc_eventSchedule: Record<Locale, string> = {
	ar: `جدول الفعاليات`,
	de: `Veranstaltungsplan`,
	es: `Calendario de eventos`,
	fa: `برنامه رویدادها`,
	fil: `Iskedyul ng kaganapan`,
	fr: `Programme des événements`,
	hi: `कार्यक्रम कार्यक्रम`,
	ht: `Orè evènman an`,
	it: `Programma degli eventi`,
	ja: `イベントスケジュール`,
	ko: `행사 일정`,
	mww: `Cov sij hawm tshwm sim`,
	ps: `د پیښو مهالویش`,
	pt: `Programação de eventos`,
	'pt-pt': `Calendário de eventos`,
	ru: `Расписание мероприятий`,
	sm: `Faasologa o mea na tutupu`,
	so: `Jadwalka Tartanka`,
	th: `กําหนดการกิจกรรม`,
	ur: `ایونٹ شیڈول`,
	vi: `Lịch trình sự kiện`,
	'zh-hans': `活动日程`,
	'zh-hant': `活動行程`,
	en: `Event schedule`
};

export const loc_existingAccountFormat: Record<Locale, (email: unknown) => TemplateResult> = {
	ar: (email) => html`لديك حساب <strong>${email}</strong>.`,
	de: (email) => html`Du hast bereits ein Konto für <strong>${email}</strong>.`,
	es: (email) => html`Ya tienes una cuenta para <strong>${email}</strong>.`,
	fa: (email) => html`شما قبلا برای <strong>${email}</strong> حساب کاربری دارید.`,
	fil: (email) => html`Mayroon ka nang account para <strong>${email}</strong>.`,
	fr: (email) => html`Vous avez déjà un compte pour <strong>${email}</strong>.`,
	hi: (email) => html`आपके पास पहले से ही <strong>${email}</strong> लिए एक खाता है।`,
	ht: (email) => html`Ou deja gen yon kont pou <strong>${email}</strong>`,
	it: (email) => html`Hai già un account per <strong>${email}</strong>.`,
	ja: (email) => html`すでに <strong>${email}</strong> のアカウントを持っています。`,
	ko: (email) => html`이미 <strong>${email}</strong> 계정이 있으시네요.`,
	mww: (email) => html`Koj twb muaj ib tug account rau <strong>${email}</strong>.`,
	ps: (email) => html`ته لا دمخه حساب <strong>${email}</strong>.`,
	pt: (email) => html`Você já tem uma conta <strong>${email}</strong>.`,
	'pt-pt': (email) => html`Já tens uma conta para <strong>${email}</strong>.`,
	ru: (email) => html`У вас уже есть аккаунт <strong>${email}</strong>.`,
	sm: (email) => html`Ua uma ona i ai sau teuga tupe mo <strong>${email}</strong>.`,
	so: (email) => html`Waxaad horey u leedahay <strong>${email}</strong>.`,
	th: (email) => html`คุณมีบัญชีสําหรับ <strong>${email}</strong> อยู่แล้ว`,
	ur: (email) => html`آپ کے پاس <strong>${email}</strong> کا اکاؤنٹ ہے۔`,
	vi: (email) => html`Bạn đã có tài khoản cho <strong>${email}</strong>.`,
	'zh-hans': (email) => html`你已经有 <strong>${email}</strong> 账户了。`,
	'zh-hant': (email) => html`你已經有 <strong>${email}</strong> 帳號了。`,
	en: (email) => html`You already have an account for <strong>${email}</strong>.`
};

export const loc_expiredRecommendationDescription: Record<Locale, (activityHref: unknown, max_age: unknown) => TemplateResult> = {
	ar: (activityHref, max_age) => html`النشاط <a href="${activityHref}">الأخير</a> عمره أكثر ${max_age} يوما. يجب إنشاء نشاط جديد.`,
	de: (activityHref, max_age) => html`Die <a href="${activityHref}">jüngste Aktivität</a> ist älter als ${max_age} Tage. Eine neue Aktivität muss geschaffen werden.`,
	es: (activityHref, max_age) => html`La <a href="${activityHref}">actividad más reciente</a> tiene más de ${max_age} días. Debe crearse una nueva actividad.`,
	fa: (activityHref, max_age) => html`<a href="${activityHref}">جدیدترین فعالیت</a> بیش از ${max_age} روز قدمت دارد. باید فعالیت جدیدی ایجاد شود.`,
	fil: (activityHref, max_age) => html`Ang <a href="${activityHref}">pinakahuling aktibidad</a> ay higit sa ${max_age} araw gulang. Kailangang lumikha ng isang bagong aktibidad.`,
	fr: (activityHref, max_age) => html`<a href="${activityHref}">L’activité la plus récente</a> date de plus ${max_age} jours. Une nouvelle activité doit être créée.`,
	hi: (activityHref, max_age) => html`<a href="${activityHref}">सबसे हालिया गतिविधि</a> ${max_age} दिनों से अधिक पुरानी है। एक नई गतिविधि बनाई जानी चाहिए।`,
	ht: (activityHref, max_age) => html`<a href="${activityHref}">Aktivite ki pi resan</a> an gen plis pase ${max_age} jou. Yon nouvo aktivite dwe kreye.`,
	it: (activityHref, max_age) => html`<a href="${activityHref}">L'attività più recente</a> ha più di ${max_age} giorni. Deve essere creata una nuova attività.`,
	ja: (activityHref, max_age) => html`最近の <a href="${activityHref}">活動</a> は ${max_age} 日以上前です。新しい活動を創出しなければなりません。`,
	ko: (activityHref, max_age) => html`<a href="${activityHref}">가장 최근의 활동</a>은 ${max_age}일이 넘었어요. 새로운 활동이 만들어져야 합니다.`,
	mww: (activityHref, max_age) => html`Qhov <a href="${activityHref}">kev ua ub no tsis ntev los</a> no yog ntau dua ${max_age} hnub. Ib qho haujlwm tshiab yuav tsum tau tsim.`,
	ps: (activityHref, max_age) => html`<a href="${activityHref}">وروستی فعالیت</a> له ${max_age} ورځو څخه زیات عمر لری. یو نوی فعالیت باید رامنځته شی.`,
	pt: (activityHref, max_age) => html`A <a href="${activityHref}">atividade mais recente</a> tem mais de ${max_age} dias. Uma nova atividade precisa ser criada.`,
	'pt-pt': (activityHref, max_age) => html`A <a href="${activityHref}">atividade mais recente</a> tem mais de ${max_age} dias. É preciso criar uma nova atividade.`,
	ru: (activityHref, max_age) => html`<a href="${activityHref}">Последняя активность</a> существует более ${max_age} дней. Нужно создать новое занятие.`,
	sm: (activityHref, max_age) => html`O le <a href="${activityHref}">gaioiga aupito lata mai</a> ua silia ma ${max_age} aso le matua. E tatau ona fausiaina se gaoioiga fou.`,
	so: (activityHref, max_age) => html`<a href="${activityHref}">Dhaqdhaqaaqii ugu dambeeyay</a> waa in ka badan ${max_age} maalmood jir. Hawl cusub waa in la abuuraa.`,
	th: (activityHref, max_age) => html`<a href="${activityHref}">กิจกรรมล่าสุด</a>มีอายุมากกว่า ${max_age} วัน ต้องสร้างกิจกรรมใหม่`,
	ur: (activityHref, max_age) => html`<a href="${activityHref}">تازہ ترین سرگرمی</a> ${max_age} دن سے زیادہ پرانی ہے۔ ایک نئی سرگرمی تخلیق کی جانی چاہیے۔`,
	vi: (activityHref, max_age) => html`<a href="${activityHref}">Hoạt động gần đây nhất</a> đã hơn ${max_age} ngày. Một hoạt động mới phải được tạo.`,
	'zh-hans': (activityHref, max_age) => html`最近一次 <a href="${activityHref}">活动</a> 已经超过 ${max_age} 天了。必须创造一项新的活动。`,
	'zh-hant': (activityHref, max_age) => html`最近一次 <a href="${activityHref}">活動</a> 已經超過 ${max_age} 天了。必須創造一項新活動。`,
	en: (activityHref, max_age) => html`The <a href="${activityHref}">most recent activity</a> is more than ${max_age} days old. A new activity must be created.`
};

export const loc_expires: Record<Locale, string> = {
	ar: `انتهاء الصلاحية`,
	de: `Gültigkeit`,
	es: `Caduca`,
	fa: `تاریخ انقضا`,
	fil: `Nag-e-expire`,
	fr: `Expiration`,
	hi: `समय सीमा समाप्त होती है`,
	ht: `ekspire`,
	it: `Scadenza`,
	ja: `期限切れ`,
	ko: `만료`,
	mww: `tas sij hawm`,
	ps: `ختم شوی`,
	pt: `Expira`,
	'pt-pt': `Expira`,
	ru: `Срок исполнения`,
	sm: `Fa'amutaina`,
	so: `Wuu dhacayaa`,
	th: `หมดอายุ`,
	ur: `میعاد ختم ہو جاتا ہے`,
	vi: `Hết hạn`,
	'zh-hans': `过期`,
	'zh-hant': `過期`,
	en: `Expires`
};

export const loc_explore: Record<Locale, string> = {
	ar: `استكشاف`,
	de: `Entdecken Sie`,
	es: `Explorar`,
	fa: `کاوش`,
	fil: `Galugarin`,
	fr: `Explorer`,
	hi: `पता लगाना`,
	ht: `Eksplore`,
	it: `Esplora`,
	ja: `探索`,
	ko: `탐험해 보세요`,
	mww: `Tshawb nrhiav`,
	ps: `پلټنه`,
	pt: `Explore`,
	'pt-pt': `Explorar`,
	ru: `Исследуйте`,
	sm: `Su'esu'e`,
	so: `Sahamin`,
	th: `สํารวจ`,
	ur: `دریافت کریں`,
	vi: `Khám phá`,
	'zh-hans': `探索`,
	'zh-hant': `探索`,
	en: `Explore`
};

export const loc_extension: Record<Locale, TemplateResult> = {
	ar: html`الامتداد<span class="sr-only"></span>`,
	de: html`Außer<span class="sr-only">Ension</span>`,
	es: html`<span class="sr-only">Extensión</span>`,
	fa: html`گسترش<span class="sr-only"></span>`,
	fil: html`Ext<span class="sr-only">ension</span>`,
	fr: html`<span class="sr-only">Extension de la direction</span>`,
	hi: html`विस्तार<span class="sr-only"></span>`,
	ht: html`Ext<span class="sr-only">ension</span>`,
	it: html`<span class="sr-only">Estensione</span>`,
	ja: html`外<span class="sr-only">延</span>`,
	ko: html`익스텐<span class="sr-only">션</span>`,
	mww: html`Ext<span class="sr-only">ension</span>`,
	ps: html`Ext<span class="sr-only">ension</span>`,
	pt: html`<span class="sr-only">Extensão</span>`,
	'pt-pt': html`<span class="sr-only">Extensão</span>`,
	ru: html`Ext<span class="sr-only">ension</span>`,
	sm: html`Ext<span class="sr-only">ension</span>`,
	so: html`<span class="sr-only">Ballaarinta</span>`,
	th: html`ขยาย<span class="sr-only"></span>`,
	ur: html`توسیع<span class="sr-only"></span>`,
	vi: html`Mở rộng<span class="sr-only"></span>`,
	'zh-hans': html`延伸<span class="sr-only"></span>`,
	'zh-hant': html`延<span class="sr-only">展</span>`,
	en: html`Ext<span class="sr-only">ension</span>`
};

export const loc_externalID: Record<Locale, string> = {
	ar: `المعرف الخارجي`,
	de: `Externe ID`,
	es: `ID externo`,
	fa: `شناسه خارجی`,
	fil: `Panlabas na ID`,
	fr: `ID externe`,
	hi: `बाहरी आईडी`,
	ht: `ID ekstèn`,
	it: `ID esterno`,
	ja: `外部ID`,
	ko: `외부 ID`,
	mww: `Tus ID sab nraud`,
	ps: `بهرنی ID`,
	pt: `ID externo`,
	'pt-pt': `ID externo`,
	ru: `Внешний идентификатор`,
	sm: `ID i fafo`,
	so: `Aqoonsiga Dibadda`,
	th: `รหัสภายนอก`,
	ur: `بیرونی شناختی کارڈ`,
	vi: `ID bên ngoài`,
	'zh-hans': `外部标识`,
	'zh-hant': `外部識別碼`,
	en: `External ID`
};

export const loc_externalUsage: Record<Locale, string> = {
	ar: `الاستخدام الخارجي`,
	de: `Externe Verwendung`,
	es: `Uso externo`,
	fa: `کاربرد خارجی`,
	fil: `Panlabas na paggamit`,
	fr: `Usage externe`,
	hi: `बाहरी उपयोग`,
	ht: `Itilizasyon ekstèn`,
	it: `Uso esterno`,
	ja: `外部での使用`,
	ko: `외부 사용`,
	mww: `Kev siv sab nraud`,
	ps: `بهرنی کارونه`,
	pt: `Uso externo`,
	'pt-pt': `Utilização externa`,
	ru: `Внешнее использование`,
	sm: `Faaaogaina i fafo`,
	so: `Isticmaalka dibadda`,
	th: `การใช้งานภายนอก`,
	ur: `بیرونی استعمال`,
	vi: `Sử dụng bên ngoài`,
	'zh-hans': `外部用法`,
	'zh-hant': `外部用途`,
	en: `External usage`
};

export const loc_facilitators: Record<Locale, string> = {
	ar: `الميسرون`,
	de: `Moderatoren`,
	es: `Facilitadores`,
	fa: `تسهیل گران`,
	fil: `Mga Tagapagpadala`,
	fr: `Facilitateurs`,
	hi: `सूत्रधार`,
	ht: `Fasilitatè yo`,
	it: `Facilitatori`,
	ja: `ファシリテーター`,
	ko: `진행자`,
	mww: `Cov neeg pab txhawb`,
	ps: `تسهیل کوونکی`,
	pt: `Facilitadores`,
	'pt-pt': `Facilitadores`,
	ru: `Фасилитаторы`,
	sm: `Tagata e Faagaoioia`,
	so: `Fududeeyayaal`,
	th: `ผู้ดําเนินการ`,
	ur: `سہولت کار`,
	vi: `Người điều phối`,
	'zh-hans': `主持人`,
	'zh-hant': `主持人`,
	en: `Facilitators`
};

export const loc_federalAgency: Record<Locale, string> = {
	ar: `الوكالة الفيدرالية`,
	de: `Bundesbehörde`,
	es: `Agencia Federal`,
	fa: `آژانس فدرال`,
	fil: `Ahensya ng Pederal`,
	fr: `Agence fédérale`,
	hi: `संघीय एजेंसी`,
	ht: `Ajans Federal`,
	it: `Agenzia Federale`,
	ja: `連邦機関`,
	ko: `연방 기관`,
	mww: `Tsoom Fwv Teb Chaws Lub Koom Haum`,
	ps: `فدرالی اداره`,
	pt: `Agência Federal`,
	'pt-pt': `Agência Federal`,
	ru: `Федеральное агентство`,
	sm: `Ofisa Feterale`,
	so: `Hay'adda Federaalka`,
	th: `หน่วยงานของรัฐบาลกลาง`,
	ur: `وفاقی ایجنسی`,
	vi: `Cơ quan liên bang`,
	'zh-hans': `联邦机构`,
	'zh-hant': `聯邦機構`,
	en: `Federal Agency`
};

export const loc_female: Record<Locale, string> = {
	ar: `أنثى`,
	de: `Weiblich`,
	es: `Femenino`,
	fa: `زن`,
	fil: `Babae`,
	fr: `Féminin`,
	hi: `महिला`,
	ht: `Fi`,
	it: `Femmina`,
	ja: `女性`,
	ko: `여성`,
	mww: `poj niam`,
	ps: `ښځینه`,
	pt: `Feminino`,
	'pt-pt': `Feminino`,
	ru: `Женский`,
	sm: `Tama'ita'i`,
	so: `Dumar`,
	th: `หญิง`,
	ur: `خاتون`,
	vi: `Nữ`,
	'zh-hans': `女性`,
	'zh-hant': `女性`,
	en: `Female`
};

export const loc_field: Record<Locale, string> = {
	ar: `الميدان`,
	de: `Spielfeld`,
	es: `Campo`,
	fa: `میدان`,
	fil: `Larangan`,
	fr: `Terrain`,
	hi: `फ़ील्ड`,
	ht: `Jaden an`,
	it: `Campo`,
	ja: `フィールド`,
	ko: `필드`,
	mww: `Daim teb`,
	ps: `میدان`,
	pt: `Campo`,
	'pt-pt': `Campo`,
	ru: `Поле`,
	sm: `Fanua`,
	so: `Garoonka`,
	th: `ฟิลด์`,
	ur: `میدان`,
	vi: `Lĩnh vực`,
	'zh-hans': `场地`,
	'zh-hant': `場地`,
	en: `Field`
};

export const loc_fields: Record<Locale, string> = {
	ar: `الحقول`,
	de: `Felder`,
	es: `Campos`,
	fa: `زمین ها`,
	fil: `Mga patlang`,
	fr: `Champs`,
	hi: `फ़ील्ड्स`,
	ht: `Jaden yo`,
	it: `Campi`,
	ja: `フィールド`,
	ko: `필드`,
	mww: `Liaj teb`,
	ps: `میدانونه`,
	pt: `Campos`,
	'pt-pt': `Campos`,
	ru: `Области`,
	sm: `Fanua`,
	so: `Garoomada`,
	th: `ฟิลด์`,
	ur: `میدانیں`,
	vi: `Trường`,
	'zh-hans': `场`,
	'zh-hant': `場`,
	en: `Fields`
};

export const loc_fiftyMiles: Record<Locale, string> = {
	ar: `50 ميلا`,
	de: `50 Meilen`,
	es: `50 millas`,
	fa: `۵۰ مایل`,
	fil: `50 milya`,
	fr: `50 miles`,
	hi: `50 मील`,
	ht: `50 mil`,
	it: `50 miglia`,
	ja: `50マイル`,
	ko: `50마일`,
	mww: `50 mais`,
	ps: `۵۰ میل`,
	pt: `50 milhas`,
	'pt-pt': `50 milhas`,
	ru: `50 миль`,
	sm: `50 maila`,
	so: `50 mayl`,
	th: `80.1 กม.`,
	ur: `50 میل`,
	vi: `50 dặm`,
	'zh-hans': `50英里`,
	'zh-hant': `50英里`,
	en: `50 miles`
};

export const loc_fileIsEmptyFormat: Record<Locale, (filename: unknown) => string> = {
	ar: (filename) => `الملف فارغ: "${filename}".`,
	de: (filename) => `Datei ist leer: "${filename}".`,
	es: (filename) => `El archivo está vacío: "${filename}".`,
	fa: (filename) => `فایل خالی است: «${filename}».`,
	fil: (filename) => `Walang laman ang file: "${filename}".`,
	fr: (filename) => `Le fichier est vide : « ${filename} ».`,
	hi: (filename) => `फ़ाइल खाली है: "${filename}.`,
	ht: (filename) => `Dosye vid: "${filename}".`,
	it: (filename) => `File vuoto: "${filename}".`,
	ja: (filename) => `ファイルは空:「${filename}」。`,
	ko: (filename) => `파일은 비어 있습니다: "${filename}".`,
	mww: (filename) => `Cov ntaub ntawv khoob: "${filename}".`,
	ps: (filename) => `فایل خالی دی: "${filename}".`,
	pt: (filename) => `O arquivo está vazio: "${filename}".`,
	'pt-pt': (filename) => `O ficheiro está vazio: "${filename}".`,
	ru: (filename) => `Файл пустой: «${filename}».`,
	sm: (filename) => `E gaogao le faila: "${filename}".`,
	so: (filename) => `Faylku waa madhan yahay: ${filename}".`,
	th: (filename) => `ไฟล์ว่างเปล่า: "${filename}"`,
	ur: (filename) => `فائل خالی ہے: "${filename}"۔`,
	vi: (filename) => `Tệp trống: "${filename}".`,
	'zh-hans': (filename) => `文件为空：“${filename}”。`,
	'zh-hant': (filename) => `檔案為空：「${filename}」。`,
	en: (filename) => `File is empty: "${filename}".`
};

export const loc_filename: Record<Locale, string> = {
	ar: `اسم الملف`,
	de: `Dateiname`,
	es: `Nombre del archivo`,
	fa: `نام فایل`,
	fil: `Pangalan ng File`,
	fr: `Nom de fichier`,
	hi: `फ़ाइल का नाम`,
	ht: `Non dosye a`,
	it: `Nome file`,
	ja: `ファイル名`,
	ko: `파일네임`,
	mww: `Lub npe filename`,
	ps: `د فایل نوم`,
	pt: `Nome do arquivo`,
	'pt-pt': `Nome do ficheiro`,
	ru: `Имя файла`,
	sm: `Igoa o le faila`,
	so: `Magaca faylka`,
	th: `ชื่อไฟล์`,
	ur: `فائل نیم`,
	vi: `Tên tập tin`,
	'zh-hans': `文件名`,
	'zh-hant': `檔案名稱`,
	en: `Filename`
};

export const loc_filenameTooLongFormat: Record<Locale, (filename: unknown, maxLength: unknown) => string> = {
	ar: (filename, maxLength) => `اسم الملف طويل جدا: "${filename}". يجب أن تكون أسماء الملفات ${maxLength} حرف أو أقل.`,
	de: (filename, maxLength) => `Dateiname zu lang: "${filename}". Dateinamen müssen ${maxLength} Zeichen oder weniger sein.`,
	es: (filename, maxLength) => `Nombre de archivo demasiado largo: "${filename}". Los nombres de archivo deben tener ${maxLength} caracteres o menos.`,
	fa: (filename, maxLength) => `نام فایل خیلی طولانی است: «${filename}». نام فایل ها باید ${maxLength} کاراکتر یا کمتر باشند.`,
	fil: (filename, maxLength) => `Masyadong mahaba ang filename: "${filename}". Ang mga pangalan ng file ay dapat na ${maxLength} character o mas mababa.`,
	fr: (filename, maxLength) => `Nom de fichier trop long : « ${filename} ». Les noms de fichiers doivent faire ${maxLength} caractères ou moins.`,
	hi: (filename, maxLength) => `फ़ाइल नाम बहुत लंबा: "${filename}"। फ़ाइल नाम ${maxLength} वर्ण या उससे कम होने चाहिए।`,
	ht: (filename, maxLength) => `Non dosye twò lontan: "${filename}". Non dosye yo dwe ${maxLength} karaktè oswa mwens.`,
	it: (filename, maxLength) => `Nome file troppo lungo: "${filename}". I nomi dei file devono avere ${maxLength} caratteri.`,
	ja: (filename, maxLength) => `ファイル名が長すぎる:「${filename}」ファイル名は ${maxLength} 文字以内でなければなりません。`,
	ko: (filename, maxLength) => `파일 이름이 너무 길어요: "${filename}". 파일 이름은 ${maxLength} 자 이내여야 합니다.`,
	mww: (filename, maxLength) => `Filename ntev dhau: "${filename}". Cov npe filenames yuav tsum yog ${maxLength} cim lossis tsawg dua.`,
	ps: (filename, maxLength) => `د فایل نوم ډېر اوږد دی: "${filename}". د فایل نومونه باید ${maxLength} کرکټرونه یا کم وی.`,
	pt: (filename, maxLength) => `Nome do arquivo muito longo: "${filename}". Os nomes dos arquivos devem ter ${maxLength} caracteres ou menos.`,
	'pt-pt': (filename, maxLength) => `Nome do ficheiro demasiado longo: "${filename}". Os nomes dos ficheiros devem ter ${maxLength} caracteres ou menos.`,
	ru: (filename, maxLength) => `Название файла слишком длинное: «${filename}». Имена файлов должны быть ${maxLength} символов.`,
	sm: (filename, maxLength) => `Igoa o le faila e umi tele: "${filename}". O igoa o faila e tatau ona ${maxLength} mataitusi pe itiiti ifo.`,
	so: (filename, maxLength) => `Magaca faylka aad u dheer: "${filename}". Magacyada faylasha waa in ay ${maxLength} xaraf ama ka yar.`,
	th: (filename, maxLength) => `ชื่อไฟล์ยาวเกินไป: "${filename}" ชื่อไฟล์ต้องมีอักขระไม่เกิน ${maxLength} ตัว`,
	ur: (filename, maxLength) => `فائل نیم بہت لمبا ہے: "${filename}"۔ فائل نام ${maxLength} حروف یا اس سے کم ہونے چاہئیں۔`,
	vi: (filename, maxLength) => `Tên tệp quá dài: "${filename}". Tên tệp phải có từ ${maxLength} ký tự trở xuống.`,
	'zh-hans': (filename, maxLength) => `文件名太长：“${filename}”。文件名必须不超过 ${maxLength} 字符。`,
	'zh-hant': (filename, maxLength) => `檔名太長：「${filename}」。檔名必須不超過 ${maxLength} 字元。`,
	en: (filename, maxLength) => `Filename too long: "${filename}". Filenames must be ${maxLength} characters or less.`
};

export const loc_fileTooLargeFormat: Record<Locale, (filename: unknown, extension: unknown, maxSize: unknown) => string> = {
	ar: (filename, extension, maxSize) => `ملف كبير جدا: "${filename}". الحد الأقصى لحجم الملف لملفات "${extension}" هو ${maxSize}.`,
	de: (filename, extension, maxSize) => `Datei zu groß: "${filename}". Die maximale Dateigröße für "${extension}"-Dateien beträgt ${maxSize}.`,
	es: (filename, extension, maxSize) => `Archivo demasiado grande: "${filename}". El tamaño máximo de archivo para archivos "${extension}" es ${maxSize}.`,
	fa: (filename, extension, maxSize) => `فایل خیلی بزرگ است: «${filename}». حداکثر حجم فایل برای فایل های «${extension}» ${maxSize} است.`,
	fil: (filename, extension, maxSize) => `File masyadong malaki: "${filename}". Ang maximum na laki ng file para sa "${extension}" na mga file ay ${maxSize}.`,
	fr: (filename, extension, maxSize) => `Fichier trop grand : « ${filename} ». La taille maximale des fichiers « ${extension} » est ${maxSize}.`,
	hi: (filename, extension, maxSize) => `फ़ाइल बहुत बड़ी है: "${filename}"। "${extension}" फ़ाइलों के लिए अधिकतम फ़ाइल आकार ${maxSize} है।`,
	ht: (filename, extension, maxSize) => `Dosye twò gwo: "${filename}". Gwosè a ranpli maksimòm pou "${extension}" fichiers se ${maxSize}.`,
	it: (filename, extension, maxSize) => `File troppo grande: "${filename}". La dimensione massima dei file per i file "${extension}" è ${maxSize}.`,
	ja: (filename, extension, maxSize) => `ファイルが大きすぎる:「${filename}」です。「${extension}」ファイルの最大ファイルサイズは ${maxSize}です。`,
	ko: (filename, extension, maxSize) => `파일 크기가 너무 커: "${filename}". "${extension}" 파일의 최대 파일 크기는 ${maxSize}입니다.`,
	mww: (filename, extension, maxSize) => `Cov ntaub ntawv loj dhau: ${filename}". Qhov siab tshaj plaws cov ntaub ntawv loj rau cov ntaub ntawv "${extension}" yog ${maxSize}.`,
	ps: (filename, extension, maxSize) => `دوسیه ډېره لویه ده: "${filename}". د "${extension}" فایلونو لپاره اعظمی فایل اندازه ${maxSize} ده.`,
	pt: (filename, extension, maxSize) => `Arquivo muito grande: "${filename}". O tamanho máximo de arquivo para arquivos "${extension}" é ${maxSize}.`,
	'pt-pt': (filename, extension, maxSize) => `Ficheiro demasiado grande: "${filename}". O tamanho máximo do ficheiro para ficheiros "${extension}" é ${maxSize}.`,
	ru: (filename, extension, maxSize) => `Файл слишком большой: «${filename}». Максимальный размер файла для "${extension}" — ${maxSize}.`,
	sm: (filename, extension, maxSize) => `Faila tele tele: "${filename}". O le lapo'a faila aupito maualuga mo faila "${extension}" o ${maxSize}.`,
	so: (filename, extension, maxSize) => `Fayl aad u weyn: ${filename}". Cabbirka ugu badan ee faylasha "${extension}" waa ${maxSize}.`,
	th: (filename, extension, maxSize) => `ไฟล์ใหญ่เกินไป: "${filename}" ขนาดไฟล์สูงสุดสําหรับไฟล์ "${extension}" คือ ${maxSize}`,
	ur: (filename, extension, maxSize) => `فائل بہت بڑی ہے: "${filename}"۔ "${extension}" فائلز کے لیے زیادہ سے زیادہ فائل سائز ${maxSize} ہے۔`,
	vi: (filename, extension, maxSize) => `Tệp quá lớn: "${filename}". Kích thước tệp tối đa cho tệp "${extension}" là ${maxSize}.`,
	'zh-hans': (filename, extension, maxSize) => `文件太大：“${filename}”。“${extension}”文件的最大文件大小为 ${maxSize}。`,
	'zh-hant': (filename, extension, maxSize) => `檔案太大：「${filename}」。「${extension}」檔案的最大檔案大小為 ${maxSize}。`,
	en: (filename, extension, maxSize) => `File too large: "${filename}". The maximum file size for "${extension}" files is ${maxSize}.`
};

export const loc_fillPageInstructions: Record<Locale, (senderName: unknown, senderGivenName: unknown, senderEmail: unknown, expires: unknown) => TemplateResult> = {
	ar: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} أرسل لك هذا النموذج لتكمله. إذا كان لديك أسئلة، تواصل ${senderGivenName} عبر البريد الإلكتروني <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. ستنتهي صلاحية هذا النموذج ${expires}`,
	de: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} hat Ihnen dieses Formular zum Ausfüllen geschickt. Wenn Sie Fragen haben, kontaktieren ${senderGivenName} per E-Mail unter <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Dieses Formular läuft ${expires}`,
	es: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} te envió este formulario para que lo rellenes. Si tienes preguntas, contacta ${senderGivenName} por correo electrónico en <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulario caducará ${expires}`,
	fa: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} این فرم را برای تکمیل برایت فرستاده است. اگر سوالی دارید، با ${senderGivenName} از طریق ایمیل <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> تماس بگیرید. این فرم ${expires} منقضی خواهد شد.`,
	fil: (senderName, senderGivenName, senderEmail, expires) => html`Ipinadala sa iyo ${senderName} ang form na ito upang kumpletuhin ang form na ito. Kung mayroon kang mga katanungan, makipag-ugnay kay ${senderGivenName} sa pamamagitan ng email sa <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Ang form na ito ay mag-e-expire ${expires}`,
	fr: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} t’a envoyé ce formulaire à remplir. Si vous avez des questions, contactez ${senderGivenName} par email à <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Ce formulaire expirera ${expires}`,
	hi: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} ने आपको यह फॉर्म पूरा करने के लिए भेजा है। यदि आपके कोई प्रश्न हैं, तो <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> ईमेल के माध्यम से ${senderGivenName} संपर्क करें। यह फॉर्म ${expires} समाप्त हो जाएगा।`,
	ht: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} voye ou fòm sa a pou w ranpli. Si ou gen kesyon, kontakte ${senderGivenName} pa imèl nan <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Fòm sa a ap ekspire ${expires}`,
	it: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} ti ha inviato questo modulo da compilare. Se hai domande, contatta ${senderGivenName} via email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Questo modulo scadrà ${expires}`,
	ja: (senderName, senderGivenName, senderEmail, expires) => html`${senderName}このフォームを送ってきました。ご質問がある場合は、<a class="Link--primary" href="${senderEmail}">${senderEmail}</a> までメールで${senderGivenName}にご連絡ください。このフォームは${expires}で期限切れとなります。`,
	ko: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} 이 양식을 작성하라고 보냈습니다. 궁금한 점이 있으면 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> 로 이메일을 ${senderGivenName}에게 연락해 주세요. 이 양식은 ${expires}에 만료됩니다.`,
	mww: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} tau xa daim ntawv no rau koj kom tiav. Yog tias koj muaj lus nug, hu rau ${senderGivenName} ntawm email ntawm <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Daim ntawv no yuav tas sij hawm ${expires}`,
	ps: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} دا فورمه درلیږلې چې بشپړه یې کړې. که پوښتنه لرئ، ${senderGivenName} ته په ایمیل کې <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. دا فورمه به ${expires} پای ته ورسېږی.`,
	pt: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} enviou este formulário para você preencher. Se tiver dúvidas, entre em contato ${senderGivenName} por e-mail <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulário expirará ${expires}`,
	'pt-pt': (senderName, senderGivenName, senderEmail, expires) => html`${senderName} enviou-lhe este formulário para preencher. Se tiver dúvidas, contacte ${senderGivenName} por email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulário expira ${expires}`,
	ru: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} прислал вам эту форму для заполнения. Если у вас есть вопросы, свяжитесь ${senderGivenName} по электронной почте <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Эта форма истекает ${expires}`,
	sm: (senderName, senderGivenName, senderEmail, expires) => html`Na auina atu ${senderName} le fomu lenei e faatumu. Afai ei ai ni au fesili, fa'afeso'ota'i ${senderGivenName} e ala i le imeli i le <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. O lenei fomu o le a muta ${expires}`,
	so: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} ayaa kuu soo diray foomkan si aad u buuxiso. Haddii aad su'aalo qabtid, la xiriir ${senderGivenName} email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Foomkan wuxuu dhici ${expires}`,
	th: (senderName, senderGivenName, senderEmail, expires) => html`${senderName}ส่งแบบฟอร์มนี้ให้คุณกรอก หากคุณมีคําถาม โปรดติดต่อ${senderGivenName}ทางอีเมลที่ <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> แบบฟอร์มนี้จะหมดอายุใน${expires}`,
	ur: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} نے آپ کو یہ فارم مکمل کرنے کے لیے بھیجا ہے۔ اگر آپ کے سوالات ہیں تو ${senderGivenName} سے ای میل <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> پر رابطہ کریں۔ یہ فارم ${expires} ختم ہو جائے گا۔`,
	vi: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} đã gửi cho bạn biểu mẫu này để hoàn thành. Nếu bạn có thắc mắc, hãy liên hệ với ${senderGivenName} qua email theo số <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Biểu mẫu này sẽ hết hạn vào ${expires}`,
	'zh-hans': (senderName, senderGivenName, senderEmail, expires) => html`${senderName} 寄给你填写这份表格。如有疑问，请通过电子邮件联系 ${senderGivenName} ，邮箱为 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>。该表格将于 ${expires}）到期。`,
	'zh-hant': (senderName, senderGivenName, senderEmail, expires) => html`${senderName} 寄給你這份表格，請你填寫。如有疑問，請透過電子郵件聯絡 ${senderGivenName} ，電子郵件為 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>。此表格將於 ${expires}）到期。`,
	en: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} sent you this form to complete. If you have questions, contact ${senderGivenName} via email at <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. This form will expire ${expires}.`
};

export const loc_filterActivities: Record<Locale, string> = {
	ar: `أنشطة التصفية`,
	de: `Filteraktivitäten`,
	es: `Actividades de filtrado`,
	fa: `فعالیت های فیلتر`,
	fil: `I-filter ang mga aktibidad`,
	fr: `Activités de filtrage`,
	hi: `फ़िल्टर गतिविधियाँ`,
	ht: `Filtre aktivite`,
	it: `Attività di filtro`,
	ja: `フィルター活動`,
	ko: `필터 활동`,
	mww: `Lim cov kev ua ub no`,
	ps: `فلټر فعالیتونه`,
	pt: `Atividades de filtro`,
	'pt-pt': `Atividades de filtro`,
	ru: `Фильтрующие активности`,
	sm: `Gaoioiga faamama`,
	so: `Hawlaha filter-ka`,
	th: `กรองกิจกรรม`,
	ur: `فلٹر سرگرمیاں`,
	vi: `Lọc hoạt động`,
	'zh-hans': `过滤活动`,
	'zh-hant': `過濾活動`,
	en: `Filter activities`
};

export const loc_filterDashboards: Record<Locale, string> = {
	ar: `لوحات معلومات التصفية`,
	de: `Filter-Dashboards`,
	es: `Paneles de control de filtros`,
	fa: `داشبوردهای فیلتر`,
	fil: `I-filter ang mga dashboard`,
	fr: `Tableaux de bord à filtres`,
	hi: `डैशबोर्ड फ़िल्टर करें`,
	ht: `Filtre tablodbò`,
	it: `Dashboard a filtro`,
	ja: `フィルターダッシュボード`,
	ko: `필터 대시보드`,
	mww: `Lim dashboards`,
	ps: `فلټر ډشبورډونه`,
	pt: `Dashboards de filtro`,
	'pt-pt': `Painéis de painel de filtros`,
	ru: `Панели фильтров`,
	sm: `Faamama dashboards`,
	so: `Dashboards-ka filter-ka`,
	th: `กรองแดชบอร์ด`,
	ur: `فلٹر ڈیش بورڈز`,
	vi: `Lọc bảng thông tin`,
	'zh-hans': `过滤器仪表盘`,
	'zh-hant': `篩選儀表板`,
	en: `Filter dashboards`
};

export const loc_filterEllipses: Record<Locale, string> = {
	ar: `فلتر...`,
	de: `Filter...`,
	es: `Filtro...`,
	fa: `فیلتر...`,
	fil: `Filter ...`,
	fr: `Filtre...`,
	hi: `फ़िल्टर.`,
	ht: `Filtre ...`,
	it: `Filtro...`,
	ja: `フィルター...`,
	ko: `필터...`,
	mww: `Lim...`,
	ps: `فلټر...`,
	pt: `Filtro...`,
	'pt-pt': `Filtro...`,
	ru: `Фильтр...`,
	sm: `Faamama ...`,
	so: `Shaandhee...`,
	th: `กรอง...`,
	ur: `فلٹر...`,
	vi: `Bộ lọc...`,
	'zh-hans': `过滤......`,
	'zh-hant': `過濾器......`,
	en: `Filter...`
};

export const loc_filterReports: Record<Locale, string> = {
	ar: `تقارير التصفية`,
	de: `Filterberichte`,
	es: `Informes de filtros`,
	fa: `گزارش های فیلتر`,
	fil: `I-filter ang mga ulat`,
	fr: `Rapports de filtres`,
	hi: `रिपोर्ट फ़िल्टर करें`,
	ht: `Filtre rapò`,
	it: `Rapporti di filtro`,
	ja: `フィルターレポート`,
	ko: `필터 보고서`,
	mww: `Lim cov ntawv ceeb toom`,
	ps: `د فلټر راپورونه`,
	pt: `Relatórios de filtro`,
	'pt-pt': `Relatórios de filtro`,
	ru: `Отчёты фильтров`,
	sm: `Faamama lipoti`,
	so: `Warbixinnada filter-ka`,
	th: `กรองรายงาน`,
	ur: `فلٹر رپورٹس`,
	vi: `Lọc báo cáo`,
	'zh-hans': `过滤器报告`,
	'zh-hant': `過濾器報告`,
	en: `Filter reports`
};

export const loc_findAssignee: Record<Locale, string> = {
	ar: `ابحث عن الموكيل`,
	de: `Finde den Zugewiesenen`,
	es: `Encontrar asignado`,
	fa: `یافتن مأمور`,
	fil: `Email Address *`,
	fr: `Trouver l’assigné`,
	hi: `असाइनी खोजें`,
	ht: `Jwenn asiyen`,
	it: `Trova l'assegnato`,
	ja: `譲受人を探す`,
	ko: `양도인 찾기`,
	mww: `Nrhiav tus neeg ua hauj lwm`,
	ps: `ټاکل شوی پیدا کړئ`,
	pt: `Encontrar o designado`,
	'pt-pt': `Encontrar o cedente`,
	ru: `Найти правообладателя`,
	sm: `Saili le tagata ua tofia`,
	so: `Raadi qofka loo wareejiyay`,
	th: `ค้นหาผู้รับมอบหมาย`,
	ur: `تفویض شدہ کو تلاش کریں`,
	vi: `Tìm người được giao`,
	'zh-hans': `查找受让人`,
	'zh-hant': `尋找受讓人`,
	en: `Find assignee`
};

export const loc_findDuplicates: Record<Locale, string> = {
	ar: `ابحث عن النسخ المكررة`,
	de: `Finde Duplikate`,
	es: `Encontrar duplicados`,
	fa: `یافتن نسخه های تکراری`,
	fil: `Maghanap ng mga duplicate`,
	fr: `Trouver des doublons`,
	hi: `डुप्लिकेट खोजें`,
	ht: `Jwenn doublons`,
	it: `Trova duplicati`,
	ja: `重複の発見`,
	ko: `중복 찾기`,
	mww: `Nrhiav duplicates`,
	ps: `نقلونه پیدا کړئ`,
	pt: `Encontre duplicatas`,
	'pt-pt': `Encontrar duplicados`,
	ru: `Найти дубликаты`,
	sm: `Saili ni kopi`,
	so: `Raadi heesaha laba-laab ah`,
	th: `ค้นหารายการที่ซ้ํากัน`,
	ur: `ڈپلیکیٹس تلاش کریں`,
	vi: `Tìm bản sao`,
	'zh-hans': `寻找重复的`,
	'zh-hant': `尋找重複的`,
	en: `Find duplicates`
};

export const loc_findEvents: Record<Locale, string> = {
	ar: `ابحث عن الأحداث`,
	de: `Finden Sie Veranstaltungen`,
	es: `Encontrar eventos`,
	fa: `رویدادها را پیدا کنید`,
	fil: `Maghanap ng mga kaganapan`,
	fr: `Trouver des événements`,
	hi: `ईवेंट ढूंढें`,
	ht: `Jwenn evènman yo`,
	it: `Trova eventi`,
	ja: `イベントを探す`,
	ko: `이벤트 찾기`,
	mww: `Nrhiav cov xwm txheej`,
	ps: `د پیښو موندنه`,
	pt: `Encontre eventos`,
	'pt-pt': `Encontre eventos`,
	ru: `Найти события`,
	sm: `Saili mea na tutupu`,
	so: `Hel dhacdooyinka`,
	th: `ค้นหากิจกรรม`,
	ur: `ایونٹس تلاش کریں`,
	vi: `Tìm sự kiện`,
	'zh-hans': `查找活动`,
	'zh-hant': `尋找活動`,
	en: `Find events`
};

export const loc_findEventsDescription: Record<Locale, string> = {
	ar: `ابحث عن الفعاليات الحالية والقادمة وسجل عبر الإنترنت.`,
	de: `Suchen Sie nach aktuellen und bevorstehenden Veranstaltungen und melden Sie sich online an.`,
	es: `Busca eventos actuales y próximos y regístrate online.`,
	fa: `رویدادهای جاری و آینده را جستجو کنید و به صورت آنلاین ثبت نام کنید.`,
	fil: `Maghanap ng mga kasalukuyan at paparating na kaganapan at magparehistro online.`,
	fr: `Recherchez les événements actuels et à venir et inscrivez-vous en ligne.`,
	hi: `वर्तमान और आगामी घटनाओं को खोजें और ऑनलाइन पंजीकरण करें।`,
	ht: `Rechèch evènman aktyèl ak kap vini yo epi enskri sou entènèt`,
	it: `Cerca eventi attuali e prossimi e registrati online.`,
	ja: `現在および今後のイベントを検索し、オンラインで登録してください。`,
	ko: `현재 및 예정된 행사를 검색하고 온라인으로 등록하세요.`,
	mww: `Nrhiav cov xwm txheej tam sim no thiab tom ntej thiab sau npe hauv online.`,
	ps: `اوسنی او راتلونکې پیښې ولټوئ او آنلاین ثبت نام وکړئ.`,
	pt: `Pesquise eventos atuais e futuros e inscreva-se online.`,
	'pt-pt': `Pesquise eventos atuais e futuros e inscreva-se online.`,
	ru: `Ищите текущие и предстоящие события и зарегистрируйтесь онлайн.`,
	sm: `Su'e mea o lo'o tutupu i le taimi nei ma le lumana'i ma lesitala i luga ole laiga.`,
	so: `Ka raadi dhacdooyinka hadda socda iyo kuwa soo socda oo iska diiwaangeli online.`,
	th: `ค้นหากิจกรรมปัจจุบันและที่จะเกิดขึ้น และลงทะเบียนออนไลน์`,
	ur: `موجودہ اور آنے والے ایونٹس تلاش کریں اور آن لائن رجسٹر کریں۔`,
	vi: `Tìm kiếm các sự kiện hiện tại và sắp tới và đăng ký trực tuyến.`,
	'zh-hans': `搜索当前和即将举行的活动并在线注册。`,
	'zh-hant': `搜尋當前及即將舉辦的活動並線上報名。`,
	en: `Search current and upcoming events and register online.`
};

export const loc_findLang: Record<Locale, string> = {
	ar: `البحث عن اللغة`,
	de: `Sprache finden`,
	es: `Encontrar lenguaje`,
	fa: `زبان پیدا کن`,
	fil: `Email Address *`,
	fr: `Trouver la langue`,
	hi: `भाषा खोजें`,
	ht: `Jwenn lang`,
	it: `Trova la lingua`,
	ja: `言語を見つける`,
	ko: `언어를 찾아`,
	mww: `Nrhiav lus`,
	ps: `د ژبې موندل`,
	pt: `Encontrar linguagem`,
	'pt-pt': `Encontrar linguagem`,
	ru: `Найти язык`,
	sm: `Su'e le gagana`,
	so: `Raadi luqadda`,
	th: `ค้นหาภาษา`,
	ur: `زبان تلاش کریں`,
	vi: `Tìm ngôn ngữ`,
	'zh-hans': `寻找语言`,
	'zh-hant': `尋找語言`,
	en: `Find language`
};

export const loc_findOpenActivities: Record<Locale, string> = {
	ar: `ابحث عن أنشطة مفتوحة:`,
	de: `Finden Sie offene Aktivitäten:`,
	es: `Encuentra actividades abiertas:`,
	fa: `فعالیت های باز را پیدا کنید:`,
	fil: `Maghanap ng mga bukas na aktibidad:`,
	fr: `Trouvez des activités ouvertes :`,
	hi: `खुली गतिविधियाँ खोजें:`,
	ht: `Jwenn aktivite ouvè:`,
	it: `Trova attività aperte:`,
	ja: `オープンなアクティビティの探し方:`,
	ko: `열린 활동 찾기:`,
	mww: `Nrhiav cov kev ua ub no qhib:`,
	ps: `خلاص فعالیتونه پیدا کړئ:`,
	pt: `Encontre atividades abertas:`,
	'pt-pt': `Encontre atividades abertas:`,
	ru: `Найдите открытые активности:`,
	sm: `Saili gaoioiga tatala:`,
	so: `Ka hel hawlo furan:`,
	th: `ค้นหากิจกรรมที่เปิดอยู่:`,
	ur: `کھلی سرگرمیاں تلاش کریں:`,
	vi: `Tìm các hoạt động mở:`,
	'zh-hans': `寻找开放活动：`,
	'zh-hant': `尋找開放活動：`,
	en: `Find open activities:`
};

export const loc_firstName: Record<Locale, string> = {
	ar: `الاسم الأول`,
	de: `Vorname`,
	es: `Nombre de pila`,
	fa: `نام کوچک`,
	fil: `Unang pangalan`,
	fr: `Prénom`,
	hi: `पहला नाम`,
	ht: `Premye non`,
	it: `Nome di battesimo`,
	ja: `名前`,
	ko: `이름`,
	mww: `Lub npe`,
	ps: `لومړی نوم`,
	pt: `Primeiro nome`,
	'pt-pt': `Primeiro nome`,
	ru: `Имя`,
	sm: `Igoa muamua`,
	so: `Magaca koowaad`,
	th: `ชื่อจริง`,
	ur: `پہلا نام`,
	vi: `Tên`,
	'zh-hans': `名字`,
	'zh-hant': `名字`,
	en: `First name`
};

export const loc_forbidden: Record<Locale, string> = {
	ar: `ممنوع`,
	de: `Verboten`,
	es: `Prohibido`,
	fa: `ممنوعه`,
	fil: `Ipinagbabawal`,
	fr: `Interdit`,
	hi: `निषिद्ध`,
	ht: `Entèdi`,
	it: `Proibito`,
	ja: `禁断`,
	ko: `금지`,
	mww: `txwv tsis pub`,
	ps: `ممنوع`,
	pt: `Proibido`,
	'pt-pt': `Proibido`,
	ru: `Запрещено`,
	sm: `Faasaina`,
	so: `Mamnuuc`,
	th: `ต้องห้าม`,
	ur: `ممنوعہ`,
	vi: `Bị cấm`,
	'zh-hans': `禁止`,
	'zh-hant': `禁止`,
	en: `Forbidden`
};

export const loc_forbiddenDescription: Record<Locale, string> = {
	ar: `هذه الصفحة موجودة لكن دورك أو عضوية المنظمة لا تمنحك إذنا للوصول إليها.`,
	de: `Diese Seite existiert, aber Ihre Rolle oder Mitgliedschaft in der Organisation gewährt Ihnen keinen Zugriff darauf.`,
	es: `Esta página existe, pero tu rol u organización no te otorga permiso de acceso a ella.`,
	fa: `این صفحه وجود دارد اما نقش یا عضویت سازمان شما اجازه دسترسی به آن را نمی دهد.`,
	fil: `Umiiral ang pahinang ito ngunit ang iyong tungkulin o pagiging miyembro ng organisasyon ay hindi nagbibigay sa iyo ng pahintulot na ma-access ito.`,
	fr: `Cette page existe mais votre rôle ou votre appartenance à l’organisation ne vous accorde pas la permission d’y accéder.`,
	hi: `यह पृष्ठ मौजूद है लेकिन आपकी भूमिका या संगठन सदस्यता आपको उस तक पहुँच की अनुमति नहीं देती है.`,
	ht: `Paj sa a egziste men wòl ou oswa manm òganizasyon ou pa ba ou pèmisyon aksè nan li.`,
	it: `Questa pagina esiste, ma il tuo ruolo o l'appartenenza all'organizzazione non ti concedono il permesso di accedervi.`,
	ja: `このページは存在しますが、あなたの役割や組織のメンバーシップによってアクセス権は与えられません。`,
	ko: `이 페이지는 존재하지만, 귀하의 역할이나 조직 회원 자격이 접근 권한을 부여하지 않습니다.`,
	mww: `Nplooj ntawv no muaj tab sis koj lub luag haujlwm lossis lub koom haum ua tswv cuab tsis tso cai rau koj nkag mus rau nws.`,
	ps: `دا پاڼه شته خو ستاسو رول یا سازمان غړیتوب تاسو ته اجازه نه درکوی چې ورته لاسرسی ولرئ.`,
	pt: `Esta página existe, mas seu papel ou associação à organização não concede permissão para acessá-la.`,
	'pt-pt': `Esta página existe, mas a sua participação no cargo ou na organização não lhe concede permissão de acesso a ela.`,
	ru: `Эта страница существует, но членство в вашей роли или организации не даёт вам разрешения на доступ к ней.`,
	sm: `O loo i ai le itulau lenei, ae o lau matafaioi po o le avea ma sui auai o le faalapotopotoga e le tuuina atu ia te oe se faatagaga e faaaoga ai.`,
	so: `Boggan wuu jiraa laakiin doorkaaga ama xubinnimadaada ururka ma siinayso ogolaanshaha.`,
	th: `เพจนี้มีอยู่ แต่บทบาทหรือการเป็นสมาชิกองค์กรของคุณไม่ได้ให้สิทธิ์การเข้าถึงเพจนี้`,
	ur: `یہ صفحہ موجود ہے لیکن آپ کا کردار یا تنظیم کی رکنیت آپ کو اس تک رسائی کی اجازت نہیں دیتی۔`,
	vi: `Trang này tồn tại nhưng vai trò hoặc tư cách thành viên tổ chức của bạn không cấp cho bạn quyền truy cập vào trang này.`,
	'zh-hans': `本页面存在，但您的角色或组织成员身份不授予您访问权限。`,
	'zh-hant': `本頁面存在，但您的角色或組織會員身份不授予您存取權限。`,
	en: `This page exists but your role or organization membership does not grant you permission access to it.`
};

export const loc_forbiddenMessage: Record<Locale, string> = {
	ar: `ليس لديك حق الوصول إلى هذه الصفحة.`,
	de: `Sie haben keinen Zugriff auf diese Seite.`,
	es: `No tienes acceso a esta página.`,
	fa: `شما به این صفحه دسترسی ندارید.`,
	fil: `Wala kang access sa pahinang ito.`,
	fr: `Vous n’avez pas accès à cette page.`,
	hi: `आपके पास इस पृष्ठ तक पहुँच नहीं है.`,
	ht: `Ou pa gen aksè a paj sa a.`,
	it: `Non hai accesso a questa pagina.`,
	ja: `このページへのアクセスはできません。`,
	ko: `이 페이지에 접근할 수 없습니다.`,
	mww: `Koj tsis muaj kev nkag mus rau nplooj ntawv no.`,
	ps: `ته دې پاڼې ته لاسرسی نه لرې.`,
	pt: `Você não tem acesso a esta página.`,
	'pt-pt': `Não tem acesso a esta página.`,
	ru: `У вас нет доступа к этой странице.`,
	sm: `E le mafai ona e ulufale i lenei itulau.`,
	so: `Ma heli kartid boggan.`,
	th: `คุณไม่มีสิทธิ์เข้าถึงหน้านี้`,
	ur: `آپ کو اس صفحے تک رسائی حاصل نہیں ہے۔`,
	vi: `Bạn không có quyền truy cập vào trang này.`,
	'zh-hans': `您无法访问本页面。`,
	'zh-hant': `您無法存取此頁面。`,
	en: `You do not have access to this page.`
};

export const loc_frequentlyViewed: Record<Locale, string> = {
	ar: `مشاهدات متكررة`,
	de: `Häufig angesehen`,
	es: `Frecuentes`,
	fa: `پربازدید`,
	fil: `Madalas na tiningnan`,
	fr: `Fréquemment visionné`,
	hi: `अक्सर देखे जाने वाले`,
	ht: `Wè souvan`,
	it: `Frequentemente visto`,
	ja: `よく見られます`,
	ko: `자주 조회되는`,
	mww: `Nquag saib`,
	ps: `ډېر لیدل کېږی`,
	pt: `Frequentemente assistido`,
	'pt-pt': `Frequentemente visto`,
	ru: `Часто просматриваемые`,
	sm: `E masani ona va'aia`,
	so: `Si joogto ah loo daawado`,
	th: `ดูบ่อย`,
	ur: `اکثر دیکھا جاتا ہے`,
	vi: `Thường xem`,
	'zh-hans': `常见内容`,
	'zh-hant': `常見觀眾`,
	en: `Frequently viewed`
};

export const loc_frequentlyViewedByYou: Record<Locale, string> = {
	ar: `مشاهدته بشكل متكرر من قبلك`,
	de: `Häufig von Ihnen angesehen`,
	es: `Lo ves con frecuencia`,
	fa: `اغلب توسط شما مشاهده می شود`,
	fil: `Madalas mong panoorin`,
	fr: `Souvent regardé par vous`,
	hi: `आपके द्वारा अक्सर देखा जाता है`,
	ht: `Souvan wè pa ou`,
	it: `Spesso visto da te`,
	ja: `頻繁に見ている`,
	ko: `자주 보는 네가`,
	mww: `Nquag saib los ntawm koj`,
	ps: `تاسو ډېر ځله ګورئ`,
	pt: `Frequentemente assistido por você`,
	'pt-pt': `Frequentemente visto por ti`,
	ru: `Часто просматривается вами`,
	sm: `E masani ona e va'ai i ai`,
	so: `Adiga oo si joogto ah u daawado`,
	th: `คุณดูบ่อย`,
	ur: `آپ اکثر دیکھتے ہیں`,
	vi: `Bạn thường xuyên xem`,
	'zh-hans': `你经常看到`,
	'zh-hant': `你經常看到`,
	en: `Frequently viewed by you`
};

export const loc_freshRecommendationDescription: Record<Locale, (activityHref: unknown, max_age: unknown) => TemplateResult> = {
	ar: (activityHref, max_age) => html`أحدث <a href="${activityHref}">نشاط</a> عمره أقل ${max_age} يوما. لا حاجة لأي إجراء.`,
	de: (activityHref, max_age) => html`Die <a href="${activityHref}">jüngste Aktivität</a> ist weniger als ${max_age} Tage alt. Es sind keine Maßnahmen erforderlich.`,
	es: (activityHref, max_age) => html`La <a href="${activityHref}">actividad más reciente</a> tiene menos de ${max_age} días. No se requiere ninguna acción.`,
	fa: (activityHref, max_age) => html`<a href="${activityHref}">جدیدترین فعالیت</a> کمتر از ${max_age} روز قدمت دارد. هیچ اقدامی لازم نیست.`,
	fil: (activityHref, max_age) => html`Ang <a href="${activityHref}">pinakahuling aktibidad</a> ay mas mababa sa ${max_age} araw gulang. Walang kinakailangang pagkilos.`,
	fr: (activityHref, max_age) => html`<a href="${activityHref}">L’activité la plus récente</a> a moins de ${max_age} jours. Aucune action n’est requise.`,
	hi: (activityHref, max_age) => html`<a href="${activityHref}">सबसे हालिया गतिविधि</a> ${max_age} दिनों से कम पुरानी है। किसी कार्रवाई की आवश्यकता नहीं है।`,
	ht: (activityHref, max_age) => html`<a href="${activityHref}">Aktivite ki pi resan</a> an se mwens pase ${max_age} jou fin vye granmoun. Pa gen okenn aksyon ki nesesè.`,
	it: (activityHref, max_age) => html`<a href="${activityHref}">L'attività più recente</a> ha meno di ${max_age} giorni. Non è necessaria alcuna azione.`,
	ja: (activityHref, max_age) => html`<a href="${activityHref}">最新の活動</a>は${max_age}日未満です。何の対応も必要ありません。`,
	ko: (activityHref, max_age) => html`<a href="${activityHref}">가장 최근의 활동</a>은 ${max_age}일도 채 되지 않았습니다. 별도의 조치는 필요 없습니다.`,
	mww: (activityHref, max_age) => html`Qhov <a href="${activityHref}">kev ua ub no tsis ntev los</a> no yog hnub nyoog tsawg ${max_age} hnub. Tsis tas yuav nqis tes ua.`,
	ps: (activityHref, max_age) => html`<a href="${activityHref}">وروستی فعالیت</a> له ${max_age} عمر لری. هیڅ اقدام ته اړتیا نشته.`,
	pt: (activityHref, max_age) => html`A <a href="${activityHref}">atividade mais recente</a> tem menos de ${max_age} dias. Nenhuma ação é necessária.`,
	'pt-pt': (activityHref, max_age) => html`A <a href="${activityHref}">atividade mais recente</a> tem menos de ${max_age} dias. Não é necessária qualquer ação.`,
	ru: (activityHref, max_age) => html`<a href="${activityHref}">Последняя активность</a> существует менее ${max_age} дней. Никаких действий не требуется.`,
	sm: (activityHref, max_age) => html`O le <a href="${activityHref}">gaioiga aupito lata mai</a> e itiiti ifo i le ${max_age} aso le matua. E leai se gaioiga e mana'omia.`,
	so: (activityHref, max_age) => html`<a href="${activityHref}">Dhaqdhaqaaqa ugu dambeeyay</a> waa wax ka yar ${max_age} maalmood. Tallaabo looma baahna.`,
	th: (activityHref, max_age) => html`<a href="${activityHref}">กิจกรรมล่าสุด</a>มีอายุน้อยกว่า ${max_age} วัน ไม่จําเป็นต้องดําเนินการใดๆ`,
	ur: (activityHref, max_age) => html`<a href="${activityHref}">تازہ ترین سرگرمی</a> ${max_age} دن سے کم پرانی ہے۔ کسی کارروائی کی ضرورت نہیں۔`,
	vi: (activityHref, max_age) => html`<a href="${activityHref}">Hoạt động gần đây nhất</a> chưa đầy ${max_age} ngày. Không cần thực hiện hành động nào.`,
	'zh-hans': (activityHref, max_age) => html`<a href="${activityHref}">最近的一次活动</a>不到${max_age}天。无需采取任何行动。`,
	'zh-hant': (activityHref, max_age) => html`最近一次 <a href="${activityHref}">活動</a> 不到 ${max_age} 天。不需要採取行動。`,
	en: (activityHref, max_age) => html`The <a href="${activityHref}">most recent activity</a> is less than ${max_age} days old. No action is required.`
};

export const loc_fromDate: Record<Locale, string> = {
	ar: `من التاريخ`,
	de: `Ab dem Datum`,
	es: `De la fecha`,
	fa: `از تاریخ`,
	fil: `Mula sa petsa`,
	fr: `Depuis la date`,
	hi: `तिथि से`,
	ht: `Soti nan dat`,
	it: `Dalla data`,
	ja: `日付から`,
	ko: `날짜부터`,
	mww: `Txij hnub tim`,
	ps: `له نیټې څخه`,
	pt: `A partir da data`,
	'pt-pt': `Desde a data`,
	ru: `С момента`,
	sm: `Mai le aso`,
	so: `Laga bilaabo taariikhda`,
	th: `ตั้งแต่วันที่`,
	ur: `تاریخ سے`,
	vi: `Từ ngày`,
	'zh-hans': `自那时起`,
	'zh-hant': `自現以來`,
	en: `From date`
};

export const loc_fullName: Record<Locale, string> = {
	ar: `الاسم الكامل`,
	de: `Vollständiger Name`,
	es: `Nombre completo`,
	fa: `نام کامل`,
	fil: `Buong pangalan`,
	fr: `Nom complet`,
	hi: `पूरा नाम`,
	ht: `Non konplè`,
	it: `Nome completo`,
	ja: `フルネーム`,
	ko: `전체 이름`,
	mww: `Lub npe tag nrho`,
	ps: `بشپړ نوم`,
	pt: `Nome completo`,
	'pt-pt': `Nome completo`,
	ru: `Полное имя`,
	sm: `Igoa atoa`,
	so: `Magaca buuxa`,
	th: `ชื่อเต็ม`,
	ur: `پورا نام`,
	vi: `Họ và tên`,
	'zh-hans': `全名`,
	'zh-hant': `全名`,
	en: `Full name`
};

export const loc_gender: Record<Locale, string> = {
	ar: `الجنس`,
	de: `Geschlecht`,
	es: `Género`,
	fa: `جنسیت`,
	fil: `Kasarian`,
	fr: `Genre`,
	hi: `लिंग`,
	ht: `Sèks`,
	it: `Genere`,
	ja: `性別`,
	ko: `성별`,
	mww: `Poj niam txiv neej`,
	ps: `جنسیت`,
	pt: `Gênero`,
	'pt-pt': `Género`,
	ru: `Пол`,
	sm: `Itupa`,
	so: `Jinsiga`,
	th: `เพศ`,
	ur: `جنس`,
	vi: `Giới tính`,
	'zh-hans': `性别`,
	'zh-hant': `性別`,
	en: `Gender`
};

export const loc_genderIdentity: Record<Locale, string> = {
	ar: `الهوية الجندرية`,
	de: `Geschlechtsidentität`,
	es: `Identidad de género`,
	fa: `هویت جنسیتی`,
	fil: `Pagkakakilanlan ng kasarian`,
	fr: `Identité de genre`,
	hi: `लिंग पहचान`,
	ht: `Idantite sèks`,
	it: `Identità di genere`,
	ja: `性自認`,
	ko: `성 정체성`,
	mww: `Poj niam txiv neej yog leej twg`,
	ps: `جنسیتی هویت`,
	pt: `Identidade de gênero`,
	'pt-pt': `Identidade de género`,
	ru: `Гендерная идентичность`,
	sm: `Fa'asinomaga o itupa`,
	so: `Aqoonsiga jinsiga`,
	th: `อัตลักษณ์ทางเพศ`,
	ur: `جنس کی شناخت`,
	vi: `Bản dạng giới`,
	'zh-hans': `性别认同`,
	'zh-hant': `性別認同`,
	en: `Gender identity`
};

export const loc_getMoreInformation: Record<Locale, string> = {
	ar: `احصل على مزيد من المعلومات`,
	de: `Weitere Informationen erhalten`,
	es: `Obtén más información`,
	fa: `اطلاعات بیشتر`,
	fil: `Kumuha ng karagdagang impormasyon`,
	fr: `Obtenez plus d’informations`,
	hi: `अधिक जानकारी प्राप्त करें`,
	ht: `Jwenn plis enfòmasyon`,
	it: `Ottieni maggiori informazioni`,
	ja: `詳細情報`,
	ko: `더 많은 정보 보기`,
	mww: `Tau txais cov ntaub ntawv ntxiv`,
	ps: `نور معلومات ترلاسه کړئ`,
	pt: `Obtenha mais informações`,
	'pt-pt': `Obtenha mais informações`,
	ru: `Узнайте больше`,
	sm: `Maua nisi fa'amatalaga`,
	so: `Hel macluumaad dheeraad ah`,
	th: `ดูข้อมูลเพิ่มเติม`,
	ur: `مزید معلومات حاصل کریں`,
	vi: `Xem thêm thông tin`,
	'zh-hans': `获取更多信息`,
	'zh-hant': `獲取更多資訊`,
	en: `Get more information`
};

export const loc_goBack: Record<Locale, string> = {
	ar: `الرجوع للخلف`,
	de: `Geh zurück`,
	es: `Vuelve atrás`,
	fa: `برگرد`,
	fil: `Bumalik`,
	fr: `Retourne`,
	hi: `पस जाओ`,
	ht: `Tounen`,
	it: `Torna indietro`,
	ja: `戻って`,
	ko: `돌아가`,
	mww: `Mus rov qab`,
	ps: `بیرته لاړ شه`,
	pt: `Volte`,
	'pt-pt': `Volta para trás`,
	ru: `Возвращайся`,
	sm: `Toe fo'i`,
	so: `Soo laabo`,
	th: `ย้อนกลับไป`,
	ur: `واپس جاؤ`,
	vi: `Quay lại`,
	'zh-hans': `回去`,
	'zh-hant': `回去`,
	en: `Go back`
};

export const loc_goToActivity: Record<Locale, string> = {
	ar: `اذهب إلى النشاط`,
	de: `Geh zur Aktivität`,
	es: `Ir a actividad`,
	fa: `به فعالیت بروید`,
	fil: `Pumunta sa Aktibidad`,
	fr: `Aller à l’activité`,
	hi: `गतिविधि पर जाएँ`,
	ht: `Ale nan aktivite`,
	it: `Vai all'attività`,
	ja: `活動開始`,
	ko: `활동 시작`,
	mww: `Mus ua si`,
	ps: `فعالیت ته لاړ شه`,
	pt: `Ir para atividade`,
	'pt-pt': `Ir para atividade`,
	ru: `Перейти к активности`,
	sm: `Alu i le gaoioiga`,
	so: `U gudub hawlaha`,
	th: `ไปที่กิจกรรม`,
	ur: `سرگرمی میں جائیں`,
	vi: `Đi đến hoạt động`,
	'zh-hans': `进入活动`,
	'zh-hant': `進入活動`,
	en: `Go to activity`
};

export const loc_goToEvent: Record<Locale, string> = {
	ar: `اذهب إلى الحدث`,
	de: `Geh zur Veranstaltung`,
	es: `Ir al evento`,
	fa: `به رویداد بروید`,
	fil: `Email Address *`,
	fr: `Rendez-vous à l’événement`,
	hi: `इवेंट पर जाएं`,
	ht: `Ale nan evènman an`,
	it: `Partecipa all'evento`,
	ja: `イベントに行こう`,
	ko: `행사 참석`,
	mww: `Mus rau qhov kev tshwm sim`,
	ps: `پیښې ته لاړ شه`,
	pt: `Vá ao evento`,
	'pt-pt': `Ir ao evento`,
	ru: `Перейти на мероприятие`,
	sm: `Alu i le mea na tupu`,
	so: `Tag dhacdada`,
	th: `ไปที่กิจกรรม`,
	ur: `ایونٹ میں جائیں`,
	vi: `Đi đến sự kiện`,
	'zh-hans': `前往活动`,
	'zh-hant': `前往活動`,
	en: `Go to event`
};

export const loc_hasAccessToAssociatedActivity: Record<Locale, string> = {
	ar: `حصلت على وصول من خلال نشاط مرتبط.`,
	de: `Erhielt Zugriff über eine zugehörige Aktivität.`,
	es: `Recibimos acceso a través de una actividad asociada.`,
	fa: `دسترسی از طریق فعالیت مرتبط دریافت کرد.`,
	fil: `Nakatanggap ng access sa pamamagitan ng isang kaugnay na aktibidad.`,
	fr: `Accès reçu via une activité associée.`,
	hi: `किसी संबद्ध गतिविधि के माध्यम से पहुँच प्राप्त की.`,
	ht: `Resevwa aksè atravè yon aktivite ki asosye`,
	it: `Ricevuto accesso tramite un'attività associata.`,
	ja: `関連アクティビティを通じてアクセス権を得ました。`,
	ko: `관련 활동을 통해 접근 권한을 받았습니다.`,
	mww: `Tau txais kev nkag mus los ntawm ib qho kev ua ub no.`,
	ps: `د اړوند فعالیت له لارې لاسرسی ترلاسه کړ.`,
	pt: `Recebi acesso por meio de uma atividade associada.`,
	'pt-pt': `Recebi acesso através de uma atividade associada.`,
	ru: `Получен доступ через сопутствующую активность.`,
	sm: `Mauaina le avanoa e ala i se gaoioiga e fesootai i ai.`,
	so: `Helitaanka marin iyada oo loo marayo hawl la xiriira.`,
	th: `ได้รับสิทธิ์การเข้าถึงผ่านกิจกรรมที่เกี่ยวข้อง`,
	ur: `کسی متعلقہ سرگرمی کے ذریعے رسائی حاصل کی۔`,
	vi: `Đã nhận quyền truy cập thông qua một hoạt động được liên kết.`,
	'zh-hans': `通过相关活动获得了访问权限。`,
	'zh-hant': `透過相關活動獲得存取權限。`,
	en: `Received access through an associated activity.`
};

export const loc_hasAccessToReferencingActivity: Record<Locale, string> = {
	ar: `حصلت على وصول من خلال نشاط يشير إلى هذا النشاط.`,
	de: `Habe Zugriff über eine Aktivität erhalten, die auf diese Aktivität verweist.`,
	es: `Recibimos acceso a través de una actividad que hace referencia a esta actividad.`,
	fa: `دسترسی از طریق فعالیتی که به این فعالیت اشاره دارد دریافت کردم.`,
	fil: `Nakatanggap ng access sa pamamagitan ng isang aktibidad na tumutukoy sa aktibidad na ito.`,
	fr: `Accès reçu via une activité qui fait référence à cette activité.`,
	hi: `इस गतिविधि को संदर्भित करने वाली गतिविधि के माध्यम से पहुँच प्राप्त की.`,
	ht: `Resevwa aksè atravè yon aktivite ki referans aktivite sa a.`,
	it: `Accesso ricevuto tramite un'attività che fa riferimento a questa attività.`,
	ja: `このアクティビティを参照するアクティビティを通じてアクセス権を取得しました。`,
	ko: `이 활동을 참조하는 활동을 통해 접근 권한을 받았습니다.`,
	mww: `Tau txais kev nkag los ntawm ib qho kev ua ub no uas hais txog qhov kev ua no.`,
	ps: `د یوې فعالیې له لارې لاسرسی ترلاسه کړ چې دې فعالیت ته اشاره کوی.`,
	pt: `Recebi acesso por meio de uma atividade que faz referência a essa atividade.`,
	'pt-pt': `Recebi acesso através de uma atividade que faz referência a esta atividade.`,
	ru: `Получен доступ через активность, ссылающуюся на эту активность.`,
	sm: `Na maua le avanoa e ala i se gaoioiga e faasino i lenei gaoioiga.`,
	so: `Waxaa loo helay marin hawl tixraacaya hawlgalkan.`,
	th: `ได้รับสิทธิ์เข้าถึงผ่านกิจกรรมที่อ้างอิงกิจกรรมนี้`,
	ur: `اس سرگرمی کے ذریعے رسائی حاصل کی گئی ہے جو اس سرگرمی کا حوالہ دیتی ہے۔`,
	vi: `Nhận quyền truy cập thông qua một hoạt động tham chiếu đến hoạt động này.`,
	'zh-hans': `通过一个与该活动相关的内容获得了访问权限。`,
	'zh-hant': `透過一個與此活動相關的活動獲得存取權限。`,
	en: `Received access through an activity that references this activity.`
};

export const loc_hasAssignedMembers: Record<Locale, string> = {
	ar: `لديه أعضاء تم تعيينهم في هذا النشاط.`,
	de: `Hat Mitglieder, die dieser Aktivität zugeteilt wurden.`,
	es: `Tiene miembros asignados a esta actividad.`,
	fa: `اعضایی دارد که به این فعالیت اختصاص داده شده اند.`,
	fil: `May mga miyembro na naatasan sa aktibidad na ito.`,
	fr: `A des membres qui ont été affectés à cette activité.`,
	hi: `ऐसे सदस्य हैं जिन्हें इस गतिविधि के लिए सौंपा गया था।`,
	ht: `Gen manm yo te asiyen nan aktivite sa a.`,
	it: `Ha membri assegnati a questa attività.`,
	ja: `この活動に割り当てられたメンバーがいます。`,
	ko: `이 활동에 배정된 회원들이 있습니다.`,
	mww: `Muaj cov tswv cuab uas tau raug xa mus rau qhov kev ua no.`,
	ps: `هغه غړی لری چې دې فعالیت ته ټاکل شوی وو.`,
	pt: `Tem membros que foram designados para essa atividade.`,
	'pt-pt': `Tem membros que foram atribuídos a esta atividade.`,
	ru: `Есть участники, назначенные на эту деятельность.`,
	sm: `O loo i ai tagata o e na tofia i lenei gaoioiga.`,
	so: `Waxay leedahay xubno loo xilsaaray hawshan.`,
	th: `มีสมาชิกที่ได้รับมอบหมายให้ทํากิจกรรมนี้`,
	ur: `اس کے ارکان اس سرگرمی کے لیے مقرر کیے گئے ہیں۔`,
	vi: `Có các tín hữu đã được chỉ định cho sinh hoạt này.`,
	'zh-hans': `有成员被分配到这项活动。`,
	'zh-hant': `有成員被指派參與這項活動。`,
	en: `Has members who were assigned to this activity.`
};

export const loc_hasMentionedMembers: Record<Locale, string> = {
	ar: `لديه أعضاء تم ذكرهم في هذا النشاط.`,
	de: `Hat Mitglieder, die in dieser Aktivität erwähnt wurden.`,
	es: `Tiene miembros que fueron mencionados en esta actividad.`,
	fa: `اعضایی دارد که در این فعالیت ذکر شده اند.`,
	fil: `May mga miyembro na binanggit sa aktibidad na ito.`,
	fr: `A des membres mentionnés dans cette activité.`,
	hi: `इस कार्यकलाप में जिन सदस्यों का उल्लेख किया गया था, उनके पास है।`,
	ht: `Gen manm yo mansyone nan aktivite sa a.`,
	it: `Ha membri menzionati in questa attività.`,
	ja: `この活動で言及されたメンバーがいます。`,
	ko: `이 활동에서 언급된 멤버들이 있습니다.`,
	mww: `Muaj cov tswv cuab uas tau hais hauv qhov kev ua no.`,
	ps: `هغه غړی لری چې په دې فعالیت کې یاد شوی دی.`,
	pt: `Tem membros mencionados nesta atividade.`,
	'pt-pt': `Tem membros mencionados nesta atividade.`,
	ru: `Есть участники, упомянутые в этом мероприятии.`,
	sm: `E i ai tagata o le ekalesia o e na ta'ua i lenei gaoioiga.`,
	so: `Waxay leedahay xubno lagu xusay hawshan.`,
	th: `มีสมาชิกที่กล่าวถึงในกิจกรรมนี้`,
	ur: `اس کے ارکان جن کا ذکر اس سرگرمی میں کیا گیا تھا۔`,
	vi: `Có các tín hữu đã được đề cập trong sinh hoạt này.`,
	'zh-hans': `有成员在本活动中被提及。`,
	'zh-hant': `成員在本活動中被提及。`,
	en: `Has members who were mentioned in this activity.`
};

export const loc_heading: Record<Locale, string> = {
	ar: `العنوان`,
	de: `Kurs`,
	es: `Rumbos`,
	fa: `سربندی`,
	fil: `Pamagat`,
	fr: `Tête`,
	hi: `शीर्षक`,
	ht: `Heading`,
	it: `Intestazione`,
	ja: `見出し`,
	ko: `제목`,
	mww: `Lub taub hau`,
	ps: `سرلیک`,
	pt: `Rumo`,
	'pt-pt': `Rumo`,
	ru: `Заголовок`,
	sm: `Ulutala`,
	so: `Jihada`,
	th: `หัวเรื่อง`,
	ur: `سرخی`,
	vi: `Tiêu đề`,
	'zh-hans': `标题`,
	'zh-hant': `標題`,
	en: `Heading`
};

export const loc_helpWithThisPage: Record<Locale, string> = {
	ar: `مساعدة في هذه الصفحة`,
	de: `Hilfe mit dieser Seite`,
	es: `Ayuda con esta página`,
	fa: `کمک به این صفحه`,
	fil: `Tulong sa pahinang ito`,
	fr: `Aide pour cette page`,
	hi: `इस पृष्ठ के साथ सहायता`,
	ht: `Èd ak paj sa a`,
	it: `Aiuto con questa pagina`,
	ja: `このページの助け`,
	ko: `이 페이지에 대한 도움`,
	mww: `Pab nrog nplooj ntawv no`,
	ps: `د دې پاڼې سره مرسته`,
	pt: `Ajuda com esta página`,
	'pt-pt': `Ajuda com esta página`,
	ru: `Помогите с этой страницей`,
	sm: `Fesoasoani i lenei itulau`,
	so: `Caawimaad boggan`,
	th: `ความช่วยเหลือเกี่ยวกับหน้านี้`,
	ur: `اس صفحے کے بارے میں مدد`,
	vi: `Trợ giúp với trang này`,
	'zh-hans': `本页求助`,
	'zh-hant': `本頁求助`,
	en: `Help with this page`
};

export const loc_hiddenItemsFormat: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} عناصر مخفية.`,
	de: (count) => `${count} versteckte Gegenstände.`,
	es: (count) => `${count} objetos ocultos.`,
	fa: (count) => `${count} آیتم مخفی.`,
	fil: (count) => `${count} nakatagong mga item.`,
	fr: (count) => `${count} objets cachés.`,
	hi: (count) => `${count} छिपी हुई आइटम।`,
	ht: (count) => `${count} atik kache`,
	it: (count) => `${count} oggetti nascosti.`,
	ja: (count) => `隠しアイテム${count}つ。`,
	ko: (count) => `${count} 개.`,
	mww: (count) => `${count} yam zais.`,
	ps: (count) => `${count} پټ توکی.`,
	pt: (count) => `${count} itens escondidos.`,
	'pt-pt': (count) => `${count} itens escondidos.`,
	ru: (count) => `${count} скрытых предмета.`,
	sm: (count) => `${count} mea natia.`,
	so: (count) => `${count} shay oo qarsoon.`,
	th: (count) => `${count} รายการที่ซ่อนอยู่`,
	ur: (count) => `${count} چھپے ہوئے اشیاء۔`,
	vi: (count) => `${count} vật phẩm ẩn.`,
	'zh-hans': (count) => `${count} 个隐藏物品。`,
	'zh-hant': (count) => `${count} 個隱藏物品。`,
	en: (count) => `${count} hidden items.`
};

export const loc_history: Record<Locale, string> = {
	ar: `التاريخ`,
	de: `Geschichte`,
	es: `Historia`,
	fa: `تاریخچه`,
	fil: `Kasaysayan`,
	fr: `Histoire`,
	hi: `इतिहास`,
	ht: `Istwa`,
	it: `Storia`,
	ja: `歴史`,
	ko: `역사`,
	mww: `Keeb Kwm`,
	ps: `تاریخچه`,
	pt: `História`,
	'pt-pt': `História`,
	ru: `История`,
	sm: `Talafaasolopito`,
	so: `Taariikhda`,
	th: `ประวัติ`,
	ur: `تاریخ`,
	vi: `Lịch sử`,
	'zh-hans': `历史`,
	'zh-hant': `歷史`,
	en: `History`
};

export const loc_home: Record<Locale, string> = {
	ar: `المنزل`,
	de: `Zuhause`,
	es: `Inicio`,
	fa: `خانه`,
	fil: `Tahanan`,
	fr: `Accueil`,
	hi: `घर`,
	ht: `Kay`,
	it: `Casa`,
	ja: `ホーム`,
	ko: `홈`,
	mww: `Tsev`,
	ps: `کور`,
	pt: `Casa`,
	'pt-pt': `Casa`,
	ru: `Дом`,
	sm: `Aiga`,
	so: `Guriga`,
	th: `หน้าแรก`,
	ur: `گھر`,
	vi: `Trang chủ`,
	'zh-hans': `首页`,
	'zh-hant': `首頁`,
	en: `Home`
};

export const loc_hospitalization: Record<Locale, string> = {
	ar: `الدخول إلى المستشفى`,
	de: `Krankenhausaufenthalt`,
	es: `Hospitalización`,
	fa: `بستری شدن`,
	fil: `Pag-ospital`,
	fr: `Hospitalisation`,
	hi: `अस्पताल में भर्ती`,
	ht: `Hospitalisation`,
	it: `Ricovero`,
	ja: `入院`,
	ko: `입원`,
	mww: `Mus pw hauv tsev kho mob`,
	ps: `روغتون ته داخلېدل`,
	pt: `Hospitalização`,
	'pt-pt': `Hospitalização`,
	ru: `Госпитализация`,
	sm: `Falema'i`,
	so: `Isbitaal`,
	th: `การรักษาในโรงพยาบาล`,
	ur: `ہسپتال میں داخل ہونا`,
	vi: `Nhập viện`,
	'zh-hans': `住院`,
	'zh-hant': `住院`,
	en: `Hospitalization`
};

export const loc_hours: Record<Locale, string> = {
	ar: `ساعات العمل`,
	de: `Öffnungszeiten`,
	es: `Horarios`,
	fa: `ساعات کاری`,
	fil: `Mga Oras`,
	fr: `Horaires`,
	hi: `घंटे`,
	ht: `èdtan`,
	it: `Orari`,
	ja: `営業時間`,
	ko: `운영 시간`,
	mww: `Cov Sij Hawm`,
	ps: `ساعتونه`,
	pt: `Horário`,
	'pt-pt': `Horário`,
	ru: `Часы работы`,
	sm: `Itula`,
	so: `Saacadaha`,
	th: `เวลาทําการ`,
	ur: `اوقات`,
	vi: `Giờ`,
	'zh-hans': `开放时间`,
	'zh-hant': `營業時間`,
	en: `Hours`
};

export const loc_howCanWeHelp: Record<Locale, string> = {
	ar: `نحن هنا للمساعدة. دعونا نتحدث عن كيف يمكن لكومولوس دعم أهدافك.`,
	de: `Wir sind hier, um zu helfen. Lassen Sie uns darüber sprechen, wie Cumulus Ihre Ziele unterstützen kann.`,
	es: `Estamos aquí para ayudarte. Hablemos de cómo Cumulus puede apoyar tus objetivos.`,
	fa: `ما اینجاییم که کمک کنیم. بیایید درباره اینکه چگونه Cumulus می تواند اهداف شما را حمایت کند صحبت کنیم.`,
	fil: `Narito kami upang tumulong. Pag-usapan natin kung paano masuportahan ng Cumulus ang iyong mga layunin.`,
	fr: `Nous sommes là pour vous aider. Parlons de la façon dont Cumulus peut soutenir vos objectifs.`,
	hi: `हमलोग यहां सहायता करने के लिए हैं। आइए बात करते हैं कि क्यूम्यलस आपके लक्ष्यों का समर्थन कैसे कर सकता है।`,
	ht: `Nou la pou nou ede. Ann pale sou ki jan Cumulus ka sipòte objektif ou yo.`,
	it: `Siamo qui per aiutarti. Parliamo di come Cumulus possa supportare i tuoi obiettivi.`,
	ja: `私たちはお手伝いします。Cumulusがどのようにあなたの目標を支援できるかについて話しましょう。`,
	ko: `저희가 도와드리러 왔습니다. Cumulus가 어떻게 여러분의 목표를 지원할 수 있는지 이야기해 봅시다.`,
	mww: `Peb nyob ntawm no los pab. Cia peb tham txog yuav ua li cas Cumulus tuaj yeem txhawb koj lub hom phiaj.`,
	ps: `موږ دلته د مرستې لپاره یو. راځئ خبرې وکړو چې څنګه Cumulus ستاسو هدفونه ملاتړ کولی شی.`,
	pt: `Estamos aqui para ajudar. Vamos falar sobre como o Cumulus pode apoiar seus objetivos.`,
	'pt-pt': `Estamos aqui para ajudar. Vamos falar sobre como a Cumulus pode apoiar os seus objetivos.`,
	ru: `Мы здесь, чтобы помочь. Давайте поговорим о том, как Cumulus может поддерживать ваши цели.`,
	sm: `Ua matou i ai iinei e fesoasoani. Se'i o tatou talanoa e uiga i le auala e mafai ai e Cumulus ona lagolagoina au sini.`,
	so: `Waxaan halkan u joognaa inaan caawino. Aan ka hadalno sida Cumulus ay u taageeri karto yoolalkaaga.`,
	th: `เราพร้อมให้ความช่วยเหลือ มาพูดถึงวิธีที่ Cumulus สามารถสนับสนุนเป้าหมายของคุณได้`,
	ur: `ہم مدد کے لیے یہاں ہیں۔ آئیے بات کرتے ہیں کہ Cumulus آپ کے مقاصد کی کس طرح حمایت کر سکتا ہے۔`,
	vi: `Chúng tôi sẵn sàng trợ giúp. Hãy nói về cách Cumulus có thể hỗ trợ mục tiêu của bạn.`,
	'zh-hans': `我们来帮你。让我们来谈谈Cumulus如何支持你的目标。`,
	'zh-hant': `我們在這裡協助你。讓我們來談談 Cumulus 如何支持你的目標。`,
	en: `We're here to help. Let’s talk about how Cumulus can support your goals.`
};

export const loc_howToManageActivityDefs: Record<Locale, string> = {
	ar: `تتم إدارة تعريفات الأنشطة في إعدادات المشاريع الخاصة بمؤسستك.`,
	de: `Aktivitätendefinitionen werden in den Projekteinstellungen Ihrer Organisation verwaltet.`,
	es: `Las definiciones de actividades se gestionan en la configuración del proyecto de tu organización.`,
	fa: `تعاریف فعالیت ها در محیط های پروژه سازمان شما مدیریت می شوند.`,
	fil: `Ang mga kahulugan ng aktibidad ay pinamamahalaan sa mga setting ng proyekto ng iyong organisasyon.`,
	fr: `Les définitions d’activités sont gérées dans les paramètres de projet de votre organisation.`,
	hi: `गतिविधि परिभाषाएँ आपके संगठन की प्रोजेक्ट सेटिंग्स में प्रबंधित की जाती हैं.`,
	ht: `Definisyon aktivite yo jere nan anviwònman pwojè òganizasyon ou an.`,
	it: `Le definizioni di attività sono gestite nelle impostazioni del progetto della tua organizzazione.`,
	ja: `アクティビティの定義は、組織のプロジェクト設定で管理されます。`,
	ko: `활동 정의는 조직의 프로젝트 환경에서 관리됩니다.`,
	mww: `Cov lus txhais ntawm kev ua ub no yog tswj nyob rau hauv koj lub koom haum qhov project chaw.`,
	ps: `د فعالیتونو تعریفونه ستاسو د سازمان د پروژې په چوکاټ کې مدیریت کیږی.`,
	pt: `As definições de atividades são gerenciadas nas configurações do projeto da sua organização.`,
	'pt-pt': `As definições de atividades são geridas nas definições do projeto da sua organização.`,
	ru: `Определения деятельности управляются в настройках проекта вашей организации.`,
	sm: `O faauigaga o gaoioiga o loo pulea i faatulagaga o galuega faatino a lau faalapotopotoga.`,
	so: `Qeexitaannada hawlaha waxaa lagu maamulaa dejinta mashruuca ururkaaga.`,
	th: `คําจํากัดความของกิจกรรมได้รับการจัดการในการตั้งค่าโครงการขององค์กรของคุณ`,
	ur: `سرگرمی کی تعریفیں آپ کی تنظیم کے پروجیکٹ سیٹنگز میں منظم کی جاتی ہیں۔`,
	vi: `Định nghĩa hoạt động được quản lý trong cài đặt dự án của tổ chức bạn.`,
	'zh-hans': `活动定义在您组织的项目设置中进行管理。`,
	'zh-hant': `活動定義會在您組織的專案設定中管理。`,
	en: `Activity definitions are managed in your organization's project settings.`
};

export const loc_humanResources: Record<Locale, string> = {
	ar: `الموارد البشرية`,
	de: `Personalwesen`,
	es: `Recursos humanos`,
	fa: `منابع انسانی`,
	fil: `Mga mapagkukunan ng tao`,
	fr: `Ressources humaines`,
	hi: `मानव संसाधन`,
	ht: `Resous imen`,
	it: `Risorse umane`,
	ja: `人事`,
	ko: `인사 자원`,
	mww: `Cov peev txheej tib neeg`,
	ps: `بشری سرچینې`,
	pt: `Recursos humanos`,
	'pt-pt': `Recursos humanos`,
	ru: `Кадры`,
	sm: `Punaoa a tagata`,
	so: `Kheyraadka aadanaha`,
	th: `ทรัพยากรบุคคล`,
	ur: `انسانی وسائل`,
	vi: `Nguồn nhân lực`,
	'zh-hans': `人力资源`,
	'zh-hant': `人力資源`,
	en: `Human resources`
};

export const loc_id: Record<Locale, string> = {
	ar: `ID`,
	de: `ID`,
	es: `ID`,
	fa: `شناسه`,
	fil: `ID`,
	fr: `ID`,
	hi: `परिचय`,
	ht: `Didantite`,
	it: `ID`,
	ja: `身分証`,
	ko: `신분증`,
	mww: `ID`,
	ps: `ID`,
	pt: `ID`,
	'pt-pt': `ID`,
	ru: `ID`,
	sm: `ID`,
	so: `Aqoonsiga`,
	th: `บัตรประจําตัว`,
	ur: `آئی ڈی`,
	vi: `ID`,
	'zh-hans': `身份证`,
	'zh-hant': `身分證`,
	en: `ID`
};

export const loc_identifiers: Record<Locale, string> = {
	ar: `المعرفات`,
	de: `Kennungen`,
	es: `Identificadores`,
	fa: `شناسه ها`,
	fil: `Mga Identifier`,
	fr: `Identifiants`,
	hi: `पहचानकर्ता`,
	ht: `Idantifyan yo`,
	it: `Identificatori`,
	ja: `識別子`,
	ko: `식별자`,
	mww: `Cov cim qhia txog`,
	ps: `پیژندونکی`,
	pt: `Identificadores`,
	'pt-pt': `Identificadores`,
	ru: `Идентификаторы`,
	sm: `Fa'ailoaina`,
	so: `Aqoonsiyada`,
	th: `ตัวระบุ`,
	ur: `شناخت کنندگان`,
	vi: `Mã định danh`,
	'zh-hans': `标识符`,
	'zh-hant': `識別碼`,
	en: `Identifiers`
};

export const loc_image: Record<Locale, string> = {
	ar: `صورة`,
	de: `Bild`,
	es: `Imagen`,
	fa: `تصویر`,
	fil: `Imahe`,
	fr: `Image`,
	hi: `छवि`,
	ht: `Imaj`,
	it: `Immagine`,
	ja: `画像`,
	ko: `이미지`,
	mww: `Duab`,
	ps: `انځور`,
	pt: `Imagem`,
	'pt-pt': `Imagem`,
	ru: `Изображение`,
	sm: `Ata`,
	so: `Sawir`,
	th: `ภาพ`,
	ur: `تصویر`,
	vi: `Hình Ảnh`,
	'zh-hans': `图片`,
	'zh-hant': `圖片`,
	en: `Image`
};

export const loc_imAUser: Record<Locale, string> = {
	ar: `أنا أستخدم Cumulus بالفعل وأحتاج إلى الدعم`,
	de: `Ich benutze bereits Cumulus und brauche Unterstützung`,
	es: `Ya uso Cumulus y necesito apoyo`,
	fa: `من قبلا از Cumulus استفاده می کنم و به پشتیبانی نیاز دارم`,
	fil: `Gumagamit na ako ng Cumulus at kailangan ko ng suporta`,
	fr: `J’utilise déjà Cumulus et j’ai besoin de soutien`,
	hi: `मैं पहले से ही क्यूमुलस का उपयोग करता हूं और समर्थन की आवश्यकता है`,
	ht: `Mwen deja itilize Cumulus epi mwen bezwen sipò`,
	it: `Uso già Cumulus e ho bisogno di supporto`,
	ja: `私はすでにCumulusを使っていて、サポートが必要です`,
	ko: `저는 이미 Cumulus를 사용 중이고 지원이 필요합니다`,
	mww: `Kuv twb siv Cumulus thiab xav tau kev txhawb nqa`,
	ps: `زه لا دمخه Cumulus کاروم او ملاتړ ته اړتیا لرم`,
	pt: `Já uso o Cumulus e preciso de suporte`,
	'pt-pt': `Já uso o Cumulus e preciso de apoio`,
	ru: `Я уже использую Cumulus и мне нужна поддержка`,
	sm: `Ua uma ona ou fa'aaogaina Cumulus ma mana'omia le lagolago`,
	so: `Anigu hore ayaan u isticmaalaa Cumulus waxaanan u baahanahay taageero`,
	th: `ฉันใช้ Cumulus อยู่แล้วและต้องการการสนับสนุน`,
	ur: `میں پہلے ہی Cumulus استعمال کرتا ہوں اور مجھے سپورٹ کی ضرورت ہے`,
	vi: `Tôi đã sử dụng Cumulus và cần hỗ trợ`,
	'zh-hans': `我已经用Cumulus了，需要支持。`,
	'zh-hant': `我已經在用 Cumulus，需要支援`,
	en: `I already use Cumulus and need support`
};

export const loc_important: Record<Locale, string> = {
	ar: `مهم`,
	de: `Wichtig`,
	es: `Importante`,
	fa: `مهم`,
	fil: `Mahalaga`,
	fr: `Important`,
	hi: `महत्वपूर्ण`,
	ht: `Ki enpòtan`,
	it: `Importante`,
	ja: `重要`,
	ko: `중요`,
	mww: `Tseem ceeb`,
	ps: `مهم`,
	pt: `Importante`,
	'pt-pt': `Importante`,
	ru: `Важно`,
	sm: `Taua`,
	so: `Muhiim`,
	th: `ข้อสําคัญ`,
	ur: `اہم`,
	vi: `Quan trọng`,
	'zh-hans': `重要`,
	'zh-hant': `重要`,
	en: `Important`
};

export const loc_importExport: Record<Locale, string> = {
	ar: `الاستيراد / التصدير`,
	de: `Import / Export`,
	es: `Importación / Exportación`,
	fa: `واردات / صادرات`,
	fil: `Pag-import / Pag-export`,
	fr: `Importation / Exportation`,
	hi: `आयात/निर्यात`,
	ht: `Enpòte / Ekspòtasyon`,
	it: `Importazione / Esportazione`,
	ja: `輸入/輸出`,
	ko: `수입/수출`,
	mww: `Ntshuam / Export`,
	ps: `واردات / صادرات`,
	pt: `Importação / Exportação`,
	'pt-pt': `Importação / Exportação`,
	ru: `Импорт / Экспорт`,
	sm: `Fa'aulufale mai / auina atu i fafo`,
	so: `Soo dejinta / Dhoofinta`,
	th: `นําเข้า / ส่งออก`,
	ur: `درآمد / برآمد`,
	vi: `Xuất nhập khẩu`,
	'zh-hans': `进口/出口`,
	'zh-hant': `進口/出口`,
	en: `Import / Export`
};

export const loc_imports: Record<Locale, string> = {
	ar: `الواردات`,
	de: `Importe`,
	es: `Importaciones`,
	fa: `واردات`,
	fil: `Mga Pag-import`,
	fr: `Importations`,
	hi: `आयात`,
	ht: `Enpòtasyon`,
	it: `Importazioni`,
	ja: `輸入`,
	ko: `수입`,
	mww: `Kev Ntshuam`,
	ps: `وارداتی`,
	pt: `Importações`,
	'pt-pt': `Importações`,
	ru: `Импорт`,
	sm: `Fa'aulufale mai`,
	so: `Soo dejinta`,
	th: `การนําเข้า`,
	ur: `درآمدات`,
	vi: `Nhập khẩu`,
	'zh-hans': `进口`,
	'zh-hant': `進口車`,
	en: `Imports`
};

export const loc_inactive: Record<Locale, string> = {
	ar: `غير نشط`,
	de: `Inaktiv`,
	es: `Inactivo`,
	fa: `غیرفعال`,
	fil: `Hindi aktibo`,
	fr: `Inactifs`,
	hi: `निष्क्रिय`,
	ht: `Inaktif`,
	it: `Inattivi`,
	ja: `非稼働`,
	ko: `비활성화`,
	mww: `Tsis ua hauj lwm`,
	ps: `غیر فعال`,
	pt: `Inativo`,
	'pt-pt': `Inativo`,
	ru: `Неактивна`,
	sm: `Le toaga`,
	so: `Aan firfircoonayn`,
	th: `ไม่ได้ใช้งาน`,
	ur: `غیر فعال`,
	vi: `Không hoạt động`,
	'zh-hans': `已停用`,
	'zh-hant': `已停用`,
	en: `Inactive`
};

export const loc_individualConsent: Record<Locale, string> = {
	ar: `الموافقة`,
	de: `Zustimmung`,
	es: `Consentimiento`,
	fa: `رضایت`,
	fil: `Pahintulot`,
	fr: `Consentement`,
	hi: `अनुमति`,
	ht: `Konsantman`,
	it: `Consenso`,
	ja: `同意`,
	ko: `동의`,
	mww: `Kev tso cai`,
	ps: `رضا`,
	pt: `Consentimento`,
	'pt-pt': `Consentimento`,
	ru: `Согласие`,
	sm: `Maliega`,
	so: `Ogolaansho`,
	th: `ความยินยอม`,
	ur: `رضامندی`,
	vi: `Sự đồng ý`,
	'zh-hans': `同意`,
	'zh-hant': `同意`,
	en: `Consent`
};

export const loc_individualConsentDesc: Record<Locale, string> = {
	ar: `سجل لاتفاق لجمع أو الوصول أو الاستخدام أو الكشف (المشاركة) للمعلومات.`,
	de: `Eine Aufzeichnung einer Vereinbarung zur Sammlung, zum Zugriff darauf, Nutzung oder zur Offenlegung (Weitergabe) von Informationen.`,
	es: `Un registro de un acuerdo para recopilar, acceder, usar o divulgar (compartir) información.`,
	fa: `رکوردی از توافق برای جمع آوری، دسترسی، استفاده یا افشای (به اشتراک گذاری) اطلاعات.`,
	fil: `Isang talaan ng isang kasunduan upang mangolekta, ma-access, gamitin o ibunyag (ibahagi) ang impormasyon.`,
	fr: `Un enregistrement d’un accord de collecte, d’accès, d’utilisation ou de divulgation (partage) d’informations.`,
	hi: `जानकारी एकत्र करने, उस तक पहुँचने, उपयोग करने या प्रकट करने (साझा) करने के लिए किसी अनुबंध का रिकॉर्ड.`,
	ht: `Yon dosye sou yon akò pou kolekte, aksè, itilize oswa divilge (pataje) enfòmasyon.`,
	it: `Un documento di un accordo per raccogliere, accedere, utilizzare o divulgare (condividere) informazioni.`,
	ja: `情報の収集、アクセス、使用、開示(共有)に関する合意の記録。`,
	ko: `정보 수집, 접근, 사용 또는 공개(공유) 합의의 기록.`,
	mww: `Ib daim ntawv teev tseg ntawm kev pom zoo los sau, nkag mus, siv lossis qhia tawm (sib qhia) cov ntaub ntawv.`,
	ps: `د معلوماتو راټولول، لاسرسی، کارولو یا افشا کولو (شریکول) د تړون ریکارډ.`,
	pt: `Um registro de um acordo para coletar, acessar, usar ou divulgar (compartilhar) informações.`,
	'pt-pt': `Um registo de um acordo para recolher, aceder, utilizar ou divulgar (partilhar) informação.`,
	ru: `Запись соглашения о сборе, доступе, использовании или раскрытии (распространении) информации.`,
	sm: `O se fa'amaumauga o se maliega e aoina, fa'aaogaina, fa'aaoga pe fa'aalia (fa'asoa) fa'amatalaga.`,
	so: `Diiwaanka heshiis lagu ururinayo, gelina, isticmaalka ama la shaacinayo (wadaagista) macluumaadka.`,
	th: `บันทึกข้อตกลงในการเก็บรวบรวม เข้าถึง ใช้ หรือเปิดเผย (แบ่งปัน) ข้อมูล`,
	ur: `معلومات جمع کرنے، رسائی، استعمال کرنے یا ظاہر کرنے (اشتراک) کے معاہدے کا ریکارڈ۔`,
	vi: `Hồ sơ về thỏa thuận thu thập, truy cập, sử dụng hoặc tiết lộ (chia sẻ) thông tin.`,
	'zh-hans': `一份关于收集、访问、使用或披露（共享）信息协议的记录。`,
	'zh-hant': `一份關於收集、存取、使用或揭露（分享）資訊的協議紀錄。`,
	en: `A record of an agreement to collect, access, use or disclose (share) information.`
};

export const loc_individualEncounter: Record<Locale, string> = {
	ar: `اللقاء`,
	de: `Begegnung`,
	es: `Encuentro`,
	fa: `برخورد`,
	fil: `Tagpo`,
	fr: `Rencontre`,
	hi: `मुठभेड़`,
	ht: `Rankont`,
	it: `Incontro`,
	ja: `遭遇`,
	ko: `만남`,
	mww: `ntsib`,
	ps: `مخامخ کېدل`,
	pt: `Encontro`,
	'pt-pt': `Encontro`,
	ru: `Встреча`,
	sm: `Feiloa'iga`,
	so: `Kulanka`,
	th: `การเผชิญหน้า`,
	ur: `ملاقات`,
	vi: `Gặp gỡ`,
	'zh-hans': `遭遇`,
	'zh-hant': `遭遇`,
	en: `Encounter`
};

export const loc_individualEncounterDesc: Record<Locale, string> = {
	ar: `تفاعل بين المريض ومقدم الرعاية الصحية لغرض تقديم خدمات صحية أو تقييم الحالة الصحية للمريض.`,
	de: `Eine Interaktion zwischen einem Patienten und Gesundheitsdienstleistern mit dem Ziel, Gesundheitsdienstleistungen bereitzustellen oder den Gesundheitszustand eines Patienten zu bewerten.`,
	es: `Una interacción entre un paciente y o(s) profesional(es) sanitario(s) con el propósito de proporcionar o/s servicio(s) sanitario(s) o evaluar el estado de salud de un paciente.`,
	fa: `تعامل بین بیمار و ارائه دهنده(های) مراقبت های بهداشتی به منظور ارائه خدمات درمانی یا ارزیابی وضعیت سلامت بیمار.`,
	fil: `Isang pakikipag-ugnayan sa pagitan ng isang pasyente at (mga) tagapagbigay ng pangangalagang pangkalusugan para sa layunin ng pagbibigay ng (mga) serbisyo sa pangangalagang pangkalusugan o pagtatasa ng katayuan sa kalusugan ng isang pasyente.`,
	fr: `Une interaction entre un patient et un ou plusieurs prestataires de soins de santé dans le but de fournir un ou plusieurs services de santé ou d’évaluer l’état de santé d’un patient.`,
	hi: `स्वास्थ्य सेवा प्रदान करने या रोगी की स्वास्थ्य स्थिति का आकलन करने के उद्देश्य से रोगी और स्वास्थ्य सेवा प्रदाता (प्रदाताओं) के बीच बातचीत।`,
	ht: `Yon entèraksyon ant yon pasyan ak founisè swen sante (yo) nan bi pou yo bay sèvis (yo) swen sante (yo) oswa evalye eta sante yon pasyan.`,
	it: `Un'interazione tra un paziente e un operatore sanitario al fine di fornire un servizio sanitario o di valutare lo stato di salute di un paziente.`,
	ja: `患者と医療提供者の間で、医療サービスの提供や患者の健康状態を評価するためのやり取り。`,
	ko: `환자와 의료 제공자 간의 상호작용을 의미하며, 의료 서비스를 제공하거나 환자의 건강 상태를 평가하기 위한 것입니다.`,
	mww: `Ib qho kev sib cuam tshuam ntawm tus neeg mob thiab tus neeg saib xyuas kev noj qab haus huv rau lub hom phiaj ntawm kev muab kev pabcuam (cov) kev noj qab haus huv lossis ntsuas qhov kev noj qab haus huv ntawm tus neeg mob.`,
	ps: `د ناروغ او روغتیایی خدماتو وړاندې کوونکی(ونو) ترمنځ تعامل، د روغتیایی خدمتونو وړاندې کولو یا د ناروغ د روغتیا وضعیت ارزولو لپاره.`,
	pt: `Uma interação entre um paciente e o(s) provedor(es) de saúde(s) com o objetivo de fornecer o(s) serviço(s) de saúde ou avaliar o estado de saúde de um paciente.`,
	'pt-pt': `Uma interação entre um paciente e o(s) prestador(es) de cuidados de saúde com o objetivo de prestar o(s) serviço(s) de saúde ou avaliar o estado de saúde de um paciente.`,
	ru: `Взаимодействие между пациентом и медицинским работником(ами) с целью предоставления медицинских услуг или оценки состояния здоровья пациента.`,
	sm: `O se fegalegaleaiga i le va o se tagata ma'i ma le tausi soifua maloloina mo le fa'amoemoe o le tu'uina atu o auaunaga tau soifua maloloina po'o le iloiloina o le tulaga o le soifua maloloina o se tagata ma'i.`,
	so: `Is-dhexgal u dhexeeya bukaanka iyo bixiyeyaasha daryeelka caafimaadka si loo bixiyo adeegyo caafimaad ama qiimeyn xaaladda caafimaad ee bukaanka.`,
	th: `ปฏิสัมพันธ์ระหว่างผู้ป่วยและผู้ให้บริการด้านการดูแลสุขภาพเพื่อวัตถุประสงค์ในการให้บริการด้านสุขภาพหรือประเมินสถานะสุขภาพของผู้ป่วย`,
	ur: `مریض اور صحت کی دیکھ بھال فراہم کرنے والے کے درمیان ایک تعامل، صحت کی خدمات فراہم کرنے یا مریض کی صحت کی حالت کا جائزہ لینے کے لیے۔`,
	vi: `Tương tác giữa bệnh nhân và (các) nhà cung cấp dịch vụ chăm sóc sức khỏe nhằm mục đích cung cấp (các) dịch vụ chăm sóc sức khỏe hoặc đánh giá tình trạng sức khỏe của bệnh nhân.`,
	'zh-hans': `患者与医疗服务提供者之间的互动，目的是提供医疗服务或评估患者的健康状况。`,
	'zh-hant': `患者與醫療提供者之間的互動，目的是提供醫療服務或評估患者的健康狀況。`,
	en: `An interaction between a patient and healthcare provider(s) for the purpose of providing healthcare service(s) or assessing the health status of a patient.`
};

export const loc_individualEpisode: Record<Locale, string> = {
	ar: `حلقة الرعاية`,
	de: `Pflegeepisode`,
	es: `Episodio de atención`,
	fa: `دوره مراقبت`,
	fil: `Episode ng pangangalaga`,
	fr: `Épisode de soins`,
	hi: `देखभाल का एपिसोड`,
	ht: `Episode nan swen`,
	it: `Episodio di cura`,
	ja: `ケアのエピソード`,
	ko: `돌봄 에피소드`,
	mww: `Tshooj ntawm kev saib xyuas`,
	ps: `د پاملرنې برخه`,
	pt: `Episódio de cuidado`,
	'pt-pt': `Episódio de cuidados`,
	ru: `Эпизод ухода`,
	sm: `Vaega o le tausiga`,
	so: `Qaybta daryeelka`,
	th: `ตอนของการดูแล`,
	ur: `دیکھ بھال کا واقعہ`,
	vi: `Giai đoạn chăm sóc`,
	'zh-hans': `护理发作`,
	'zh-hant': `照護時期`,
	en: `Episode of care`
};

export const loc_individualEpisodeDesc: Record<Locale, string> = {
	ar: `ارتباط بين المريض ومنظمة / مقدم الرعاية الصحية قد تحدث خلالها لقاءات. تتحمل المنظمة الإدارية مستوى من المسؤولية تجاه المريض خلال هذه الفترة.`,
	de: `Eine Verbindung zwischen einem Patienten und einer Organisation bzw. medizinischen Fachkräften, während der Zeiträume Begegnungen stattfinden können. Die leitende Organisation übernimmt in dieser Zeit eine gewisse Verantwortung für den Patienten.`,
	es: `Una asociación entre un paciente y una organización o proveedor sanitario durante la cual pueden producirse encuentros. La organización gestora asume un nivel de responsabilidad sobre el paciente durante este tiempo.`,
	fa: `ارتباطی بین یک بیمار و یک سازمان / ارائه دهنده خدمات بهداشتی که در آن ممکن است برخوردهایی رخ دهد. سازمان مدیریتی در این مدت سطحی از مسئولیت را نسبت به بیمار بر عهده می گیرد.`,
	fil: `Isang asosasyon sa pagitan ng isang pasyente at isang organisasyon / tagapagbigay ng pangangalagang pangkalusugan kung saan maaaring mangyari ang mga nakatagpo ng oras. Ang pamamahala ng organisasyon ay may antas ng responsibilidad para sa pasyente sa panahong ito.`,
	fr: `Une association entre un patient et une organisation / prestataire de soins de santé durant laquelle des rencontres peuvent avoir lieu. L’organisation gestionnaire assume un certain niveau de responsabilité envers le patient durant cette période.`,
	hi: `एक रोगी और एक संगठन/स्वास्थ्य सेवा प्रदाता (प्रदाताओं) के बीच एक संबंध जिसके दौरान मुठभेड़ हो सकती है। प्रबंध संगठन इस समय के दौरान रोगी के लिए जिम्मेदारी का एक स्तर मानता है।`,
	ht: `Yon asosyasyon ant yon pasyan ak yon òganizasyon / founisè swen sante (yo) pandan ki tan rankont ka rive. Òganizasyon an jere sipoze yon nivo responsablite pou pasyan an pandan tan sa a.`,
	it: `Un'associazione tra un paziente e un'organizzazione / operatore sanitario durante la quale possono verificarsi incontri. L'organizzazione gestore assume un certo livello di responsabilità per il paziente durante questo periodo.`,
	ja: `患者と組織や医療提供者との間に、接触が行われる可能性のある関係。管理組織はこの期間中、患者に対して一定の責任を負います。`,
	ko: `환자와 조직 또는 의료 제공자 간의 연관성으로, 그 기간 동안 만남이 발생할 수 있습니다. 관리 조직은 이 기간 동안 환자에 대한 책임을 일정 수준 부담합니다.`,
	mww: `Ib qho kev sib raug zoo ntawm tus neeg mob thiab ib lub koom haum / tus neeg saib xyuas kev noj qab haus huv thaum lub sijhawm yuav tshwm sim. Lub koom haum tswj hwm coj ib theem ntawm lub luag haujlwm rau tus neeg mob thaum lub sijhawm no.`,
	ps: `د ناروغ او یو سازمان/روغتیایی چمتو کوونکی(ونو) ترمنځ اړیکه چې په دې موده کې ممکنه پېښې رامنځته شی. د مدیریت اداره په دې موده کې د ناروغ لپاره یوه کچه مسؤلیت پر غاړه اخلی.`,
	pt: `Uma associação entre um paciente e uma organização/prestador(es) de saúde(s) durante a qual podem ocorrer encontros. A organização gestora assume um nível de responsabilidade pelo paciente durante esse período.`,
	'pt-pt': `Uma associação entre um paciente e uma organização / prestador(es) de cuidados de saúde durante a qual podem ocorrer encontros. A organização gestora assume um certo nível de responsabilidade pelo paciente durante este período.`,
	ru: `Ассоциация между пациентом и организацией / медицинским работником(ами), в течение которых могут происходить встречи. Управляющая организация берёт на себя определённый уровень ответственности за пациента в этот период.`,
	sm: `O se feso'ota'iga i le va o se tagata ma'i ma se fa'alapotopotoga / tausi soifua maloloina (s) i le taimi e ono tupu ai feiloaiga. O le fa'alapotopotoga fa'atautaia o lo'o i ai se tulaga o le tiutetauave mo le tagata ma'i i lenei taimi.`,
	so: `Xiriir u dhexeeya bukaanka iyo hay'adda/bixiyaha daryeelka caafimaadka, muddadaas ay kulamo ka dhici karaan. Hay'adda maareynta ayaa qaadata heer mas'uuliyad u ah bukaanka inta lagu jiro waqtigan.`,
	th: `ความสัมพันธ์ระหว่างผู้ป่วยกับองค์กร / ผู้ให้บริการด้านการดูแลสุขภาพในช่วงเวลาที่อาจเกิดการเผชิญหน้า องค์กรจัดการถือว่ามีความรับผิดชอบต่อผู้ป่วยในช่วงเวลานี้`,
	ur: `مریض اور ایک تنظیم/صحت کی دیکھ بھال فراہم کنندہ(ز) کے درمیان ایک تعلق جس دوران ملاقاتیں ہو سکتی ہیں۔ انتظامی تنظیم اس دوران مریض کی ایک سطح کی ذمہ داری سنبھالتی ہے۔`,
	vi: `Mối liên hệ giữa bệnh nhân và (các) tổ chức / nhà cung cấp dịch vụ chăm sóc sức khỏe trong thời gian đó có thể xảy ra các cuộc gặp gỡ. Tổ chức quản lý đảm nhận một mức độ trách nhiệm đối với bệnh nhân trong thời gian này.`,
	'zh-hans': `患者与组织/医疗服务提供者之间的关联，在此期间可能会发生接触。管理机构在此期间承担患者一定的责任。`,
	'zh-hant': `指患者與組織/醫療提供者之間的關聯，期間可能會發生接觸。管理組織在此期間對病患承擔一定責任。`,
	en: `An association between a patient and an organization / healthcare provider(s) during which time encounters may occur. The managing organization assumes a level of responsibility for the patient during this time.`
};

export const loc_individualQuestionnaire: Record<Locale, string> = {
	ar: `الاستبيان`,
	de: `Fragebogen`,
	es: `Cuestionario`,
	fa: `پرسشنامه`,
	fil: `Talatanungan`,
	fr: `Questionnaire`,
	hi: `प्रश्‍नावली`,
	ht: `Kesyonè`,
	it: `Questionario`,
	ja: `アンケート`,
	ko: `설문지`,
	mww: `Cov lus nug`,
	ps: `پوښتنلیک`,
	pt: `Questionário`,
	'pt-pt': `Questionário`,
	ru: `Анкета`,
	sm: `Fesili`,
	so: `Su'aalo`,
	th: `แบบสอบถาม`,
	ur: `سوالنامہ`,
	vi: `Bảng câu hỏi`,
	'zh-hans': `问卷`,
	'zh-hant': `問卷`,
	en: `Questionnaire`
};

export const loc_individualQuestionnaireDesc: Record<Locale, string> = {
	ar: `مجموعة منظمة من الأسئلة المتعلقة بالعميل، تهدف إلى توجيه جمع الإجابات من المستخدمين النهائيين.`,
	de: `Ein strukturierter Satz von Fragen zu einem Kunden, der die Sammlung von Antworten von Endnutzern leiten soll.`,
	es: `Un conjunto estructurado de preguntas relacionadas con un cliente, destinado a guiar la recopilación de respuestas de los usuarios finales.`,
	fa: `مجموعه ای ساختاریافته از سوالات مرتبط با یک مشتری، که هدف آن هدایت جمع آوری پاسخ ها از کاربران نهایی است.`,
	fil: `Isang nakabalangkas na hanay ng mga katanungan na may kaugnayan sa isang kliyente, na inilaan upang gabayan ang koleksyon ng mga sagot mula sa mga end-user.`,
	fr: `Un ensemble structuré de questions liées à un client, destiné à guider la collecte des réponses des utilisateurs finaux.`,
	hi: `एक ग्राहक से संबंधित प्रश्नों का एक संरचित सेट, जिसका उद्देश्य अंतिम उपयोगकर्ताओं से उत्तरों के संग्रह का मार्गदर्शन करना है।`,
	ht: `Yon seri estriktire nan kesyon ki gen rapò ak yon kliyan, gen entansyon gide koleksyon an nan repons soti nan itilizatè fen.`,
	it: `Un insieme strutturato di domande relative a un cliente, pensato per guidare la raccolta delle risposte degli utenti finali.`,
	ja: `クライアントに関連する構造化された質問のセットで、エンドユーザーからの回答収集を導くことを目的としています。`,
	ko: `클라이언트와 관련된 구조화된 질문 집합으로, 최종 사용자로부터 답변을 수집하는 것을 안내하기 위한 것입니다.`,
	mww: `Ib qho txheej txheem ntawm cov lus nug ntsig txog tus neeg siv khoom, npaj los coj kev sau cov lus teb los ntawm cov neeg siv kawg.`,
	ps: `د کلاینټ اړوند یو منظم پوښتنو ټولګه، چې هدف یې د پای کاروونکو څخه د ځوابونو راټولولو لارښوونه ده.`,
	pt: `Um conjunto estruturado de perguntas relacionadas a um cliente, destinado a guiar a coleta de respostas dos usuários finais.`,
	'pt-pt': `Um conjunto estruturado de perguntas relacionadas com um cliente, destinado a orientar a recolha de respostas dos utilizadores finais.`,
	ru: `Структурированный набор вопросов, связанных с клиентом, предназначенный для руководства сбором ответов от конечных пользователей.`,
	sm: `O se seti fa'atulagaina o fesili e feso'ota'i ma se tagata fa'atau, fa'amoemoe e ta'ita'ia le aoina o tali mai tagata fa'aoga.`,
	so: `Waa su'aalo nidaamsan oo la xiriira macmiil, looguna talagalay in lagu hago ururinta jawaabaha ka yimaada isticmaaleyaasha dhammaadka.`,
	th: `ชุดคําถามที่มีโครงสร้างที่เกี่ยวข้องกับลูกค้า ซึ่งมีจุดประสงค์เพื่อเป็นแนวทางในการรวบรวมคําตอบจากผู้ใช้ปลายทาง`,
	ur: `کلائنٹ سے متعلق ایک منظم سوالات کا مجموعہ، جس کا مقصد صارفین سے جوابات جمع کرنے کی رہنمائی کرنا ہے۔`,
	vi: `Một tập hợp các câu hỏi có cấu trúc liên quan đến khách hàng, nhằm hướng dẫn thu thập câu trả lời từ người dùng cuối.`,
	'zh-hans': `一组结构化的问题，与客户相关，旨在引导最终用户的回答收集。`,
	'zh-hant': `一組與客戶相關的結構化問題，旨在引導最終使用者的回答收集。`,
	en: `A structured set of questions related to a client, intended to guide the collection of answers from end-users.`
};

export const loc_individualReferral: Record<Locale, string> = {
	ar: `الإحالة`,
	de: `Vermittlung`,
	es: `Recomendación`,
	fa: `ارجاع`,
	fil: `Email Address *`,
	fr: `Recommandation`,
	hi: `रेफरल`,
	ht: `Referans`,
	it: `Segnalazione`,
	ja: `紹介`,
	ko: `의뢰`,
	mww: `Kev xa mus rau`,
	ps: `راجع کول`,
	pt: `Encaminhamento`,
	'pt-pt': `Encaminhamento`,
	ru: `Направление`,
	sm: `Fa'asino`,
	so: `Tixraac`,
	th: `การอ้างอิง`,
	ur: `حوالہ`,
	vi: `Giới thiệu`,
	'zh-hans': `转诊`,
	'zh-hant': `轉介`,
	en: `Referral`
};

export const loc_individualReferralDesc: Record<Locale, string> = {
	ar: `سجل لطلب الخدمة مثل التحقيقات التشخيصية أو العلاجات أو العمليات التي يجب إجراؤها.`,
	de: `Eine Aufzeichnung einer Bitte um eine Dienstleistung wie diagnostische Untersuchungen, Behandlungen oder durchzuführende Operationen.`,
	es: `Un registro de una solicitud de servicio, como investigaciones diagnósticas, tratamientos u operaciones a realizar.`,
	fa: `رکوردی از درخواست خدمات مانند بررسی های تشخیصی، درمان ها یا جراحی هایی که باید انجام شوند.`,
	fil: `Isang talaan ng isang kahilingan para sa serbisyo tulad ng mga pagsisiyasat sa diagnostic, paggamot, o operasyon na isasagawa.`,
	fr: `Un enregistrement d’une demande de service telle que des examens diagnostiques, des traitements ou des opérations à effectuer.`,
	hi: `सेवा के लिए अनुरोध का एक रिकॉर्ड जैसे नैदानिक जांच, उपचार, या किए जाने वाले ऑपरेशन।`,
	ht: `Dosye yon demann pou sèvis tankou envestigasyon dyagnostik, tretman oswa operasyon ki dwe fèt.`,
	it: `Un registro di una richiesta di servizio come indagini diagnostiche, trattamenti o operazioni da eseguire.`,
	ja: `診断検査、治療、または実施される手術などのサービス要請の記録。`,
	ko: `진단 조사, 치료 또는 시행할 수술과 같은 서비스 요청 기록입니다.`,
	mww: `Ib daim ntawv teev tseg ntawm kev thov kev pabcuam xws li kev kuaj mob, kev kho mob, lossis kev ua haujlwm.`,
	ps: `د خدمت غوښتنې ریکارډ لکه تشخیصی تحقیقات، درملنې، یا د ترسره کولو عملیات.`,
	pt: `Um registro de um pedido de serviço, como investigações diagnósticas, tratamentos ou operações a serem realizadas.`,
	'pt-pt': `Um registo de um pedido de serviço, como investigações diagnósticas, tratamentos ou operações a realizar.`,
	ru: `Запись запроса на получение услуг, такой как диагностические исследования, лечение или операции, которые должны быть проведены.`,
	sm: `O se fa'amaumauga o se talosaga mo auaunaga e pei o su'esu'ega fa'ama'i, togafitiga, po'o taotoga e fa'atinoina.`,
	so: `Diiwaanka codsiga adeegga sida baaritaannada baaritaanka, daaweynta, ama qalliinnada la samaynayo.`,
	th: `บันทึกการร้องขอบริการ เช่น การตรวจวินิจฉัย การรักษา หรือการผ่าตัดที่จะดําเนินการ`,
	ur: `ایسی سروس کی درخواست کا ریکارڈ، جیسے تشخیصی تحقیقات، علاج، یا انجام دینے والے آپریشنز۔`,
	vi: `Hồ sơ yêu cầu dịch vụ như điều tra chẩn đoán, điều trị hoặc phẫu thuật sẽ được thực hiện.`,
	'zh-hans': `请求服务的记录，如诊断检查、治疗或手术。`,
	'zh-hant': `關於服務請求的紀錄，例如診斷檢查、治療或手術。`,
	en: `A record of a request for service such as diagnostic investigations, treatments, or operations to be performed.`
};

export const loc_individualTask: Record<Locale, string> = {
	ar: `المهمة`,
	de: `Aufgabe`,
	es: `Tarea`,
	fa: `وظیفه`,
	fil: `Gawain`,
	fr: `Tâche`,
	hi: `नियत कार्य`,
	ht: `Travay la`,
	it: `Compito`,
	ja: `任務`,
	ko: `임무`,
	mww: `Tes haujlwm`,
	ps: `دنده`,
	pt: `Tarefa`,
	'pt-pt': `Tarefa`,
	ru: `Задача`,
	sm: `Galuega`,
	so: `Hawl`,
	th: `งาน`,
	ur: `کام`,
	vi: `Nhiệm vụ`,
	'zh-hans': `任务`,
	'zh-hant': `任務`,
	en: `Task`
};

export const loc_individualTaskDesc: Record<Locale, string> = {
	ar: `مهمة متعلقة بالعميل مثل متابعة يمكن تنفيذها.`,
	de: `Eine Aufgabe, die mit einem Kunden zusammenhängt, wie zum Beispiel eine Nachverfolgung, die ausgeführt werden kann.`,
	es: `Una tarea relacionada con un cliente, como un seguimiento que pueda realizarse.`,
	fa: `یک وظیفه مرتبط با یک مشتری مانند پیگیری که قابل انجام است.`,
	fil: `Isang gawain na may kaugnayan sa isang kliyente tulad ng isang follow-up na maaaring maisagawa.`,
	fr: `Une tâche liée à un client, comme un suivi pouvant être effectué.`,
	hi: `किसी ग्राहक से संबंधित कार्य जैसे अनुवर्ती कार्य जिसे किया जा सकता है।`,
	ht: `Yon travay ki gen rapò ak yon kliyan tankou yon swivi ki ka fèt.`,
	it: `Un compito correlato a un cliente, come un follow-up, che può essere eseguito.`,
	ja: `クライアントに関連するタスク、例えばフォローアップを行うこと。`,
	ko: `수행 가능한 후속 조치와 같은 클라이언트와 관련된 작업입니다.`,
	mww: `Ib txoj haujlwm ntsig txog tus neeg siv khoom xws li kev taug qab uas tuaj yeem ua tau.`,
	ps: `یو کار چې د مراجع سره تړاو لری لکه تعقیبی چې ترسره کېدای شی.`,
	pt: `Uma tarefa relacionada a um cliente, como um acompanhamento, que pode ser realizada.`,
	'pt-pt': `Uma tarefa relacionada com um cliente, como um seguimento, que pode ser realizada.`,
	ru: `Задача, связанная с клиентом, например, последующий контакт, который можно выполнить.`,
	sm: `O se galuega e feso'ota'i ma se tagata fa'atau e pei o se tulitatao e mafai ona fa'atinoina.`,
	so: `Hawl la xiriirta macmiil sida raac la qaban karo.`,
	th: `งานที่เกี่ยวข้องกับลูกค้า เช่น การติดตามผลที่สามารถทําได้`,
	ur: `ایک ایسا کام جو کلائنٹ سے متعلق ہو، جیسے کہ فالو اپ جو انجام دیا جا سکے۔`,
	vi: `Một nhiệm vụ liên quan đến khách hàng, chẳng hạn như theo dõi có thể được thực hiện.`,
	'zh-hans': `与客户相关的任务，比如可以执行的后续跟踪。`,
	'zh-hant': `與客戶相關的任務，例如可以執行的後續追蹤。`,
	en: `A task related to a client such as a follow-up that can be performed.`
};

export const loc_inProgress: Record<Locale, string> = {
	ar: `قيد التنفيذ`,
	de: `In Arbeit`,
	es: `En progreso`,
	fa: `در حال انجام`,
	fil: `Sa pag-unlad`,
	fr: `En cours`,
	hi: `प्रगति पर है`,
	ht: `An pwogrè`,
	it: `In corso`,
	ja: `進行中`,
	ko: `진행 중입니다`,
	mww: `Nyob rau hauv kev kawm`,
	ps: `په جریان کې`,
	pt: `Em andamento`,
	'pt-pt': `Em progresso`,
	ru: `В процессе`,
	sm: `O loo faagasolo`,
	so: `Soconaya`,
	th: `กําลังดําเนินการ`,
	ur: `جاری`,
	vi: `Đang tiến hành`,
	'zh-hans': `进行中`,
	'zh-hant': `進行中`,
	en: `In progress`
};

export const loc_inProgressStatusDesc: Record<Locale, string> = {
	ar: `تم بدء النشاط لكنه لم يكتمل بعد.`,
	de: `Die Aktivität wurde begonnen, ist aber noch nicht abgeschlossen.`,
	es: `La actividad ya ha comenzado pero aún no está completa.`,
	fa: `فعالیت آغاز شده اما هنوز کامل نشده است.`,
	fil: `Sinimulan na ang aktibidad ngunit hindi pa rin kumpleto.`,
	fr: `L’activité a commencé mais n’est pas encore terminée.`,
	hi: `गतिविधि शुरू कर दी गई है लेकिन अभी तक पूरी नहीं हुई है।`,
	ht: `Aktivite a te kòmanse, men li poko fini.`,
	it: `L'attività è già iniziata ma non è ancora completata.`,
	ja: `活動は開始されていますが、まだ完了していません。`,
	ko: `활동은 시작되었지만 아직 완료되지는 않았습니다.`,
	mww: `Qhov kev ua haujlwm tau pib tab sis tseem tsis tau tiav.`,
	ps: `فعالیت پیل شوی خو لا بشپړ شوی نه دی.`,
	pt: `A atividade já foi iniciada, mas ainda não está concluída.`,
	'pt-pt': `A atividade já foi iniciada, mas ainda não está concluída.`,
	ru: `Деятельность уже начата, но ещё не завершена.`,
	sm: `Ua uma ona amataina le gaoioiga ae e le'i mae'a.`,
	so: `Hawlgalka waa la bilaabay balse weli lama dhameystirin.`,
	th: `กิจกรรมได้เริ่มต้นแล้ว แต่ยังไม่เสร็จสมบูรณ์`,
	ur: `یہ سرگرمی شروع ہو چکی ہے لیکن ابھی مکمل نہیں ہوئی۔`,
	vi: `Hoạt động đã được bắt đầu nhưng chưa hoàn tất.`,
	'zh-hans': `该活动已启动，但尚未完成。`,
	'zh-hant': `該活動已開始，但尚未完成。`,
	en: `The activity has been started but is not yet complete.`
};

export const loc_inquiryReceived: Record<Locale, string> = {
	ar: `تم استلام الاستفسار`,
	de: `Anfrage erhalten`,
	es: `Consulta recibida`,
	fa: `استعلام دریافت شد`,
	fil: `Natanggap ang pagtatanong`,
	fr: `Demande reçue`,
	hi: `जांच प्राप्त हुई`,
	ht: `Rechèch te resevwa`,
	it: `Richiesta ricevuta`,
	ja: `問い合わせ受理`,
	ko: `문의 접수`,
	mww: `Kev nug tau txais`,
	ps: `پلټنه ترلاسه شوه`,
	pt: `Consulta recebida`,
	'pt-pt': `Inquérito recebido`,
	ru: `Запрос получен`,
	sm: `Mauaina le suesuega`,
	so: `Baaritaan la helay`,
	th: `ได้รับคําถาม`,
	ur: `انکوائری موصول ہوئی`,
	vi: `Yêu cầu đã nhận được`,
	'zh-hans': `已收到询问`,
	'zh-hant': `收到的詢問`,
	en: `Inquiry received`
};

export const loc_inquiryReceivedMessage: Record<Locale, (mailto: unknown, email: unknown) => TemplateResult> = {
	ar: (mailto, email) => html`تم استلام استفسارك! سنتواصل معك قريبا. يمكنك أيضا التواصل معنا مباشرة على <a href="${mailto}">${email}</a>.`,
	de: (mailto, email) => html`Ihre Anfrage ist eingegangen! Wir werden uns in Kürze melden. Sie können uns auch direkt unter <a href="${mailto}">${email}</a> kontaktieren.`,
	es: (mailto, email) => html`¡Ha recibido su consulta! Nos pondremos en contacto con ella en breve. También puedes contactarnos directamente en <a href="${mailto}">${email}</a>.`,
	fa: (mailto, email) => html`درخواست شما دریافت شد! به زودی با شما تماس خواهیم گرفت. همچنین می توانید مستقیما با ما از <a href="${mailto}">${email}</a> تماس بگیرید.`,
	fil: (mailto, email) => html`Natanggap na ang inyong pagtatanong! Maabot namin sa lalong madaling panahon. Maaari ka ring makipag-ugnay sa amin nang direkta sa <a href="${mailto}">${email}</a>.`,
	fr: (mailto, email) => html`Votre demande a été reçue ! Nous vous contacterons sous peu. Vous pouvez également nous contacter directement à <a href="${mailto}">${email}</a>.`,
	hi: (mailto, email) => html`आपकी पूछताछ प्राप्त हो गई है! हम जल्द ही संपर्क करेंगे। आप हमसे सीधे <a href="${mailto}">${email}</a> पर भी संपर्क कर सकते हैं।`,
	ht: (mailto, email) => html`Rechèch ou an te resevwa! Nou pral kontakte yon ti tan Ou kapab tou kontakte nou dirèkteman nan <a href="${mailto}">${email}</a>.`,
	it: (mailto, email) => html`La tua richiesta è stata ricevuta! Ti contatteremo a breve. Puoi anche contattarci direttamente <a href="${mailto}">${email}</a>.`,
	ja: (mailto, email) => html`お問い合わせはお届けしました!近いうちにご連絡いたします。また、 <a href="${mailto}">${email}</a> まで直接お問い合わせいただくことも可能です。`,
	ko: (mailto, email) => html`문의가 접수되었습니다! 곧 연락드리겠습니다. <a href="${mailto}">${email}</a> 에서도 직접 연락하실 수 있습니다.`,
	mww: (mailto, email) => html`Koj qhov kev nug tau txais! Peb yuav ncav tes sai sai. Koj tseem tuaj yeem tiv tauj peb ncaj qha ntawm <a href="${mailto}">${email}</a>.`,
	ps: (mailto, email) => html`ستاسو پوښتنه ترلاسه شوه! موږ به ژر اړیکه ونیسو. تاسو کولی شئ موږ سره مستقیم په <a href="${mailto}">${email}</a> اړیکه ونیسئ.`,
	pt: (mailto, email) => html`Sua consulta foi recebida! Entraremos em contato em breve. Você também pode nos contatar diretamente pelo <a href="${mailto}">${email}</a>.`,
	'pt-pt': (mailto, email) => html`A sua consulta foi recebida! Entraremos em contacto em breve. Também pode contactar-nos diretamente através <a href="${mailto}">${email}</a>.`,
	ru: (mailto, email) => html`Ваш запрос получен! Мы скоро свяжемся с нами. Вы также можете связаться с нами напрямую по <a href="${mailto}">${email}</a>.`,
	sm: (mailto, email) => html`Ua mae'a lau su'esu'ega! O le a tatou aapa atu i se taimi lata mai. E mafai foi ona e fa'afeso'ota'i sa'o mai matou i le <a href="${mailto}">${email}</a>.`,
	so: (mailto, email) => html`Su'aashaada waa la helay! Waxaan dhowaan la xiriiri doonaa. Waxaad sidoo kale nala soo xiriiri kartaa si toos ah <a href="${mailto}">${email}</a>.`,
	th: (mailto, email) => html`ได้รับคําถามของคุณแล้ว! เราจะติดต่อในไม่ช้า คุณสามารถติดต่อเราได้โดยตรงที่ <a href="${mailto}">${email}</a>`,
	ur: (mailto, email) => html`آپ کی استفسار موصول ہو گئی ہے! ہم جلد ہی رابطہ کریں گے۔ آپ ہم سے <a href="${mailto}">${email}</a> پر بھی رابطہ کر سکتے ہیں۔`,
	vi: (mailto, email) => html`Yêu cầu của bạn đã được nhận! Chúng tôi sẽ liên hệ trong thời gian ngắn. Bạn cũng có thể liên hệ trực tiếp với chúng tôi tại <a href="${mailto}">${email}</a>.`,
	'zh-hans': (mailto, email) => html`您的咨询已收到！我们很快会联系你。您也可以直接通过 <a href="${mailto}">${email}</a> 联系我们。`,
	'zh-hant': (mailto, email) => html`您的詢問已收到！我們很快就會聯絡你。您也可以直接透過 <a href="${mailto}">${email}</a> 與我們聯繫。`,
	en: (mailto, email) => html`Your inquiry has been received! We'll be reaching out shortly. You can also contact us directly at <a href="${mailto}">${email}</a>.`
};

export const loc_instructions: Record<Locale, string> = {
	ar: `التعليمات`,
	de: `Anleitung`,
	es: `Instrucciones`,
	fa: `دستورالعمل ها`,
	fil: `Mga tagubilin`,
	fr: `Instructions`,
	hi: `अनुदेश`,
	ht: `Enstriksyon yo`,
	it: `Istruzioni`,
	ja: `指示`,
	ko: `지침`,
	mww: `Cov lus qhia`,
	ps: `لارښوونې`,
	pt: `Instruções`,
	'pt-pt': `Instruções`,
	ru: `Инструкции`,
	sm: `Faatonuga`,
	so: `Tilmaamaha`,
	th: `คําแนะนํา`,
	ur: `ہدایات`,
	vi: `Hướng dẫn`,
	'zh-hans': `说明书`,
	'zh-hant': `說明`,
	en: `Instructions`
};

export const loc_instructionsPlaceholder: Record<Locale, (entityType: unknown) => string> = {
	ar: (entityType) => `توفير تعليمات ${entityType}`,
	de: (entityType) => `Geben Sie ${entityType} bereit`,
	es: (entityType) => `Proporcionar instrucciones ${entityType}`,
	fa: (entityType) => `دستورالعمل ${entityType} را ارائه دهید`,
	fil: (entityType) => `Magbigay ng mga tagubilin ${entityType}`,
	fr: (entityType) => `Fournir des instructions ${entityType}`,
	hi: (entityType) => `${entityType} निर्देश प्रदान करें`,
	ht: (entityType) => `Bay ${entityType} yo`,
	it: (entityType) => `Fornire istruzioni ${entityType}`,
	ja: (entityType) => `${entityType}指示を提供する`,
	ko: (entityType) => `${entityType} 지침을 제공하세요`,
	mww: (entityType) => `Muab cov lus ${entityType}`,
	ps: (entityType) => `${entityType} لارښوونې ورکول`,
	pt: (entityType) => `Forneça instruções ${entityType}`,
	'pt-pt': (entityType) => `Forneça instruções ${entityType}`,
	ru: (entityType) => `Предоставьте ${entityType}`,
	sm: (entityType) => `Tuuina atu faatonuga ${entityType}`,
	so: (entityType) => `Bixi ${entityType}`,
	th: (entityType) => `ให้คําแนะนํา${entityType}`,
	ur: (entityType) => `${entityType} کی ہدایات فراہم کریں`,
	vi: (entityType) => `Cung cấp hướng dẫn ${entityType}`,
	'zh-hans': (entityType) => `提供 ${entityType} 指令`,
	'zh-hant': (entityType) => `提供 ${entityType} 指令`,
	en: (entityType) => `Provide ${entityType} instructions`
};

export const loc_insuranceCompany: Record<Locale, string> = {
	ar: `شركة التأمين`,
	de: `Versicherungsgesellschaft`,
	es: `Compañía de seguros`,
	fa: `شرکت بیمه`,
	fil: `Kumpanya ng Seguro`,
	fr: `Compagnie d’assurance`,
	hi: `बीमा कंपनी`,
	ht: `Konpayi asirans`,
	it: `Compagnia di assicurazioni`,
	ja: `保険会社`,
	ko: `보험회사`,
	mww: `Lub Tuam Txhab Pov Hwm`,
	ps: `د بیمې شرکت`,
	pt: `Companhia de Seguros`,
	'pt-pt': `Companhia de Seguros`,
	ru: `Страховая компания`,
	sm: `Kamupani Inisiua`,
	so: `Shirkadda Caymiska`,
	th: `บริษัทประกันภัย`,
	ur: `انشورنس کمپنی`,
	vi: `Công ty bảo hiểm`,
	'zh-hans': `保险公司`,
	'zh-hant': `保險公司`,
	en: `Insurance Company`
};

export const loc_internalServerError: Record<Locale, string> = {
	ar: `خطأ داخلي في الخادم`,
	de: `Interner Serverfehler`,
	es: `Error interno del servidor`,
	fa: `خطای داخلی سرور`,
	fil: `Error sa panloob na server`,
	fr: `Erreur interne du serveur`,
	hi: `आंतरिक सर्वर त्रुटि`,
	ht: `Erè sèvè entèn`,
	it: `Errore interno del server`,
	ja: `内部サーバーエラー`,
	ko: `내부 서버 오류`,
	mww: `Sab hauv neeg rau zaub mov yuam kev`,
	ps: `داخلی سرور تېروتنه`,
	pt: `Erro interno do servidor`,
	'pt-pt': `Erro interno do servidor`,
	ru: `Ошибка внутреннего сервера`,
	sm: `Mea sese i totonu o le server`,
	so: `Khalad server gudaha ah`,
	th: `ข้อผิดพลาดภายในเซิร์ฟเวอร์`,
	ur: `اندرونی سرور کی خرابی`,
	vi: `Lỗi máy chủ nội bộ`,
	'zh-hans': `内部服务器错误`,
	'zh-hant': `內部伺服器錯誤`,
	en: `Internal server error`
};

export const loc_internalServerErrorDescription: Record<Locale, string> = {
	ar: `حدث خطأ أثناء معالجة طلبك. تم تنبيه فريق كومولوس. إذا استمرت المشكلة أو كان لديك أي أسئلة، يرجى التواصل مع الدعم.`,
	de: `Während der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Das Cumulus-Team wurde alarmiert. Wenn das Problem weiterhin besteht oder Sie Fragen haben, wenden Sie sich bitte an den Support.`,
	es: `Se produjo un error mientras procesaba tu solicitud. El equipo de Cumulus ha sido alertado. Si el problema persiste o tienes alguna pregunta, por favor contacta con el soporte técnico.`,
	fa: `در حین پردازش درخواست شما، خطایی رخ داده است. تیم کومولوس مطلع شده است. اگر مشکل ادامه داشت یا سوالی داشتید، لطفا با پشتیبانی تماس بگیرید.`,
	fil: `Nagkaroon ng error habang pinoproseso ang iyong kahilingan. Inalerto na ang Cumulus team. Kung ang problema ay nagpapatuloy o mayroon kang anumang mga katanungan, mangyaring makipag-ugnay sa suporta.`,
	fr: `Une erreur s’est produite lors du traitement de votre demande. L’équipe Cumulus a été alertée. Si le problème persiste ou si vous avez des questions, veuillez contacter le support.`,
	hi: `आपके अनुरोध को संसाधित करते समय कोई त्रुटि उत्पन्न हुई. क्यूमुलस टीम को सतर्क कर दिया गया है। यदि समस्या बनी रहती है या आपके कोई प्रश्न हैं, तो कृपया सहायता से संपर्क करें।`,
	ht: `Yon erè te rive pandan y ap trete demann ou an. Ekip Cumulus la te alèt Si pwoblèm nan kontinye oswa ou gen nenpòt kesyon, tanpri kontakte sipò.`,
	it: `Si è verificato un errore durante l'elaborazione della tua richiesta. Il team Cumulus è stato allertato. Se il problema persiste o hai domande, contatta l'assistenza.`,
	ja: `リクエスト処理中にエラーが発生しました。キュムラスチームに通報済み。問題が続く場合や質問がある場合は、サポートにご連絡ください。`,
	ko: `요청을 처리하는 과정에서 오류가 발생했습니다. 큐뮬러스 팀에 경보가 들어갔습니다. 문제가 계속되거나 궁금한 점이 있으면 고객 지원에 연락해 주세요.`,
	mww: `Ib qho yuam kev tshwm sim thaum ua koj qhov kev thov. Pab pawg Cumulus tau ceeb toom. Yog tias qhov teeb meem tseem txuas ntxiv lossis koj muaj lus nug, thov hu rau cov kev txhawb nqa.`,
	ps: `ستاسو د غوښتنې د پروسس پر مهال یوه تېروتنه رامنځته شوه. د کومیولس ټیم خبر شوی دی. که ستونزه دوام ولری یا کومه پوښتنه لرئ، مهربانی وکړئ له ملاتړ سره اړیکه ونیسئ.`,
	pt: `Ocorreu um erro durante o processamento do seu pedido. A equipe Cumulus foi alertada. Se o problema persistir ou você tiver alguma dúvida, por favor, entre em contato com o suporte.`,
	'pt-pt': `Ocorreu um erro durante o processamento do seu pedido. A equipa Cumulus foi alertada. Se o problema persistir ou tiver alguma dúvida, por favor contacte o suporte.`,
	ru: `Во время обработки вашего запроса произошла ошибка. Команда Кумулус была предупреждена. Если проблема сохраняется или у вас есть вопросы, пожалуйста, свяжитесь с поддержкой.`,
	sm: `Sa i ai se mea sese a o faagaoioia lau talosaga. Ua lapataia le 'au a Cumulus. Afai o lo'o fa'aauau pea le fa'afitauli pe ei ai ni au fesili, fa'amolemole fa'afeso'ota'i le lagolago.`,
	so: `Khalad ayaa dhacay intii lagu guda jiray codsigaaga. Kooxda Cumulus waa la ogeysiiyay. Haddii dhibaatadu sii socoto ama aad su'aalo qabto, fadlan la xiriir taageerada.`,
	th: `เกิดข้อผิดพลาดขณะประมวลผลคําขอของคุณ ทีม Cumulus ได้รับการแจ้งเตือนแล้ว หากปัญหายังคงอยู่หรือคุณมีคําถามใดๆ โปรดติดต่อฝ่ายสนับสนุน`,
	ur: `آپ کی درخواست پر عمل کرتے ہوئے ایک غلطی پیش آئی۔ کومیولس ٹیم کو اطلاع مل گئی ہے۔ اگر مسئلہ برقرار رہے یا آپ کے کوئی سوالات ہوں تو براہ کرم سپورٹ سے رابطہ کریں۔`,
	vi: `Đã xảy ra lỗi trong khi xử lý yêu cầu của bạn. Nhóm Cumulus đã được cảnh báo. Nếu sự cố vẫn tiếp diễn hoặc bạn có bất kỳ câu hỏi nào, vui lòng liên hệ với bộ phận hỗ trợ.`,
	'zh-hans': `处理您的请求时发生了错误。积云团队已被通知。如果问题依旧或有任何疑问，请联系客服。`,
	'zh-hant': `在處理您的申請時發生錯誤。Cumulus團隊已被通知。如果問題持續存在或有任何問題，請聯絡客服。`,
	en: `An error occurred while processing your request. The Cumulus team has been alerted. If the problem persists or you have any questions, please contact support.`
};

export const loc_internalServerErrorMessage: Record<Locale, string> = {
	ar: `حدث خطأ ما من جانبنا.`,
	de: `Bei uns ist etwas schiefgelaufen.`,
	es: `Algo salió mal por nuestra parte.`,
	fa: `یه مشکلی از طرف ما پیش اومد.`,
	fil: `May mali sa dulo namin.`,
	fr: `Quelque chose a mal tourné de notre côté.`,
	hi: `हमारी ओर से कुछ गलत हो गया।`,
	ht: `Yon bagay te ale mal sou bò nou an.`,
	it: `Qualcosa è andato storto da parte nostra.`,
	ja: `うちで何か問題が起きたんだ。`,
	ko: `우리 쪽에서 뭔가 잘못됐어.`,
	mww: `Ib yam dab tsi mus tsis ncaj ncees lawm ntawm peb kawg.`,
	ps: `زموږ له خوا څه غلط شول.`,
	pt: `Algo deu errado do nosso lado.`,
	'pt-pt': `Algo correu mal do nosso lado.`,
	ru: `Что-то пошло не так с нашей стороны.`,
	sm: `Sa i ai se mea na sese i lo matou itu.`,
	so: `Waxbaa naga qaldamay.`,
	th: `มีบางอย่างผิดพลาดในตอนท้ายของเรา`,
	ur: `ہماری طرف سے کچھ غلط ہو گیا۔`,
	vi: `Có điều gì đó không ổn từ phía chúng tôi.`,
	'zh-hans': `我们这边出了点问题。`,
	'zh-hant': `我們這邊出了點問題。`,
	en: `Something went wrong on our end.`
};

export const loc_interoperability: Record<Locale, string> = {
	ar: `التشغيل البيني`,
	de: `Interoperabilität`,
	es: `Interoperabilidad`,
	fa: `قابلیت همکاری`,
	fil: `Interoperability`,
	fr: `Interopérabilité`,
	hi: `इंटरऑपरेबिलिटी`,
	ht: `Entèoperabilite`,
	it: `Interoperabilità`,
	ja: `相互運用性`,
	ko: `상호운용성`,
	mww: `Kev sib cuam tshuam`,
	ps: `همغږی`,
	pt: `Interoperabilidade`,
	'pt-pt': `Interoperabilidade`,
	ru: `Совместимость`,
	sm: `Feso'ota'iga`,
	so: `Is-waafajinta`,
	th: `การทํางานร่วมกัน`,
	ur: `انٹرآپریبلٹی`,
	vi: `Khả năng tương tác`,
	'zh-hans': `互操作性`,
	'zh-hant': `互通性`,
	en: `Interoperability`
};

export const loc_invalidDate: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `يجب أن يكون ${label} بصيغة MM/DD/YYYY.`,
	de: (label) => `${label} muss im Format MM/DD/YYYY sein.`,
	es: (label) => `${label} debe estar en el formato MM/DD/YYYY.`,
	fa: (label) => `${label} باید در قالب MM/DD/YYYY باشد.`,
	fil: (label) => `Ang ${label} ay dapat na nasa format na MM/DD/YYYYY.`,
	fr: (label) => `${label} doit être au format MM/DD/YYYY.`,
	hi: (label) => `${label} MM/DD/YYYY प्रारूप में होनी चाहिए।`,
	ht: (label) => `${label} dwe nan fòma MM/JJ/AAAA.`,
	it: (label) => `${label} deve essere nel formato MM/DD/YYYY.`,
	ja: (label) => `${label} はMM/DD/YYYYのフォーマットでなければなりません。`,
	ko: (label) => `${label} 은 MM/DD/YYYY 형식이어야 합니다.`,
	mww: (label) => `${label} yuav tsum yog hom ntawv MM/DD/YYYY.`,
	ps: (label) => `${label} ورځ باید د MM/DD/YYYY په بڼه وی.`,
	pt: (label) => `${label} deve estar no formato MM/DD/YYYY.`,
	'pt-pt': (label) => `${label} deve estar no formato MM/DD/YYYY.`,
	ru: (label) => `${label} рождения должна быть в формате MM/DD/YYYY.`,
	sm: (label) => `${label} e tatau ona i ai i le faatulagaga MM / DD / YYYY.`,
	so: (label) => `${label} waa in ay ku jirtaa qaabka MM/DD/YYYY.`,
	th: (label) => `${label} ต้องอยู่ในรูปแบบ MM/DD/YYYY`,
	ur: (label) => `${label} پیدائش لازمی طور پر MM/DD/YYYY فارمیٹ میں ہونی چاہیے۔`,
	vi: (label) => `${label} ở định dạng MM / DD / YYYY.`,
	'zh-hans': (label) => `${label} 必须是MM/DD/YYYY格式。`,
	'zh-hant': (label) => `${label} 必須是MM/DD/YYYY格式。`,
	en: (label) => `${label} must be in the format MM/DD/YYYY.`
};

export const loc_invalidEmail: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `يجب ${label} بصيغة name@example.com.`,
	de: (label) => `${label} muss im Format name@example.com sein.`,
	es: (label) => `${label} debe estar en el formato name@example.com.`,
	fa: (label) => `${label} باید در قالب name@example.com باشد.`,
	fil: (label) => `Ang ${label} ay dapat na nasa format na name@example.com.`,
	fr: (label) => `${label} doit être au format name@example.com.`,
	hi: (label) => `${label} name@example.com प्रारूप में होना चाहिए।`,
	ht: (label) => `${label} dwe nan fòma name@example.com.`,
	it: (label) => `${label} deve essere nel formato name@example.com.`,
	ja: (label) => `${label} name@example.com のフォーマットでなければなりません。`,
	ko: (label) => `${label} name@example.com 형식이어야 합니다.`,
	mww: (label) => `${label} yuav tsum nyob rau hauv hom ntawv name@example.com.`,
	ps: (label) => `${label} باید په هغه بڼه وی چې name@example.com.`,
	pt: (label) => `${label} deve estar no formato name@example.com.`,
	'pt-pt': (label) => `${label} deve estar no formato name@example.com.`,
	ru: (label) => `${label} должна быть в формате name@example.com.`,
	sm: (label) => `${label} e tatau ona i ai i le faatulagaga name@example.com.`,
	so: (label) => `${label} waa inuu ku jiraa qaabka name@example.com.`,
	th: (label) => `${label} ต้องอยู่ในรูปแบบ name@example.com`,
	ur: (label) => `${label} اس فارمیٹ میں ہونی چاہیے name@example.com ہے۔`,
	vi: (label) => `${label} phải ở định dạng name@example.com.`,
	'zh-hans': (label) => `电子邮件${label}符合 name@example.com。`,
	'zh-hant': (label) => `${label} 格式必須符合 name@example.com。`,
	en: (label) => `${label} must be in the format name@example.com.`
};

export const loc_invalidFileExtensionFormat: Record<Locale, (extension: unknown, filename: unknown, supportedExtensions: unknown) => string> = {
	ar: (extension, filename, supportedExtensions) => `امتداد غير صالح "${extension}" في "${filename}". الإضافات المدعومة هي ${supportedExtensions}.`,
	de: (extension, filename, supportedExtensions) => `Ungültige Erweiterung "${extension}" in "${filename}". Unterstützte Erweiterungen sind ${supportedExtensions}.`,
	es: (extension, filename, supportedExtensions) => `Extensión inválida "${extension}" en "${filename}". Las extensiones soportadas son ${supportedExtensions}.`,
	fa: (extension, filename, supportedExtensions) => `پسوند «${extension}» در «${filename}» نامعتبر است. افزونه های پشتیبانی شده ${supportedExtensions} هستند.`,
	fil: (extension, filename, supportedExtensions) => `Hindi wastong extension na "${extension}" sa "${filename}". Ang mga suportadong extension ay ${supportedExtensions}.`,
	fr: (extension, filename, supportedExtensions) => `Extension invalide « ${extension} » dans « ${filename} ». Les extensions prises en charge sont ${supportedExtensions}.`,
	hi: (extension, filename, supportedExtensions) => `अमान्य एक्सटेंशन "${filename} में "${extension}"। समर्थित एक्सटेंशन ${supportedExtensions} हैं।`,
	ht: (extension, filename, supportedExtensions) => `Ekstansyon envalid "${extension}" nan "${filename}". Sipòte ekstansyon yo se ${supportedExtensions}.`,
	it: (extension, filename, supportedExtensions) => `Estensione invalida "${extension}" in "${filename}". Le estensioni supportate sono ${supportedExtensions}.`,
	ja: (extension, filename, supportedExtensions) => `「${filename}」の無効な拡張「${extension}」。対応している拡張子は${supportedExtensions}です。`,
	ko: (extension, filename, supportedExtensions) => `"${filename}"에 잘못된 확장 프로그램 "${extension}"가 있습니다. 지원되는 확장자는 ${supportedExtensions}입니다.`,
	mww: (extension, filename, supportedExtensions) => `Kev txuas ntxiv tsis raug "${extension}" hauv "${filename}". Cov kev txhawb nqa txuas ntxiv yog ${supportedExtensions}.`,
	ps: (extension, filename, supportedExtensions) => `د "${extension}" په "${filename}" کې ناسم پسوند "". ملاتړ شوی پراخونې ${supportedExtensions} دی.`,
	pt: (extension, filename, supportedExtensions) => `Extensão inválida "${extension}" em "${filename}". Extensões suportadas são ${supportedExtensions}.`,
	'pt-pt': (extension, filename, supportedExtensions) => `Extensão inválida "${extension}" em "${filename}". As extensões suportadas são ${supportedExtensions}.`,
	ru: (extension, filename, supportedExtensions) => `Недействительное расширение «${extension}» в «${filename}». Поддерживаемые расширения — ${supportedExtensions}.`,
	sm: (extension, filename, supportedExtensions) => `Fa'aopoopoga le aoga "${extension}" i le "${filename}". Lagolagoina fa'aopoopoga o ${supportedExtensions}.`,
	so: (extension, filename, supportedExtensions) => `Kordhin aan sax ahayn "${extension}" oo ku jira "${filename}". Kordhinta la taageero waa ${supportedExtensions}.`,
	th: (extension, filename, supportedExtensions) => `นามสกุล "${extension}" ใน "${filename}" ไม่ถูกต้อง ส่วนขยายที่รองรับคือ ${supportedExtensions}`,
	ur: (extension, filename, supportedExtensions) => `غلط ایکسٹینشن "${extension}" میں "${filename}"۔ سپورٹڈ ایکسٹینشنز ${supportedExtensions} ہیں۔`,
	vi: (extension, filename, supportedExtensions) => `Phần mở rộng "${extension}" không hợp lệ trong "${filename}". Các tiện ích mở rộng được hỗ trợ là ${supportedExtensions}.`,
	'zh-hans': (extension, filename, supportedExtensions) => `“${filename}”中的无效扩展名“${extension}”。支持的扩展名有${supportedExtensions}。`,
	'zh-hant': (extension, filename, supportedExtensions) => `「${filename}」中的無效擴展名「${extension}」。支援的副檔名有 ${supportedExtensions}。`,
	en: (extension, filename, supportedExtensions) => `Invalid extension "${extension}" in "${filename}". Supported extensions are ${supportedExtensions}.`
};

export const loc_invalidFilenameFormat: Record<Locale, (filename: unknown) => string> = {
	ar: (filename) => `اسم الملف غير صالح: "${filename}".`,
	de: (filename) => `Ungültiger Dateiname: "${filename}".`,
	es: (filename) => `Nombre de archivo inválido: "${filename}".`,
	fa: (filename) => `نام فایل نامعتبر: «${filename}».`,
	fil: (filename) => `Hindi wastong pangalan ng file: "${filename}".`,
	fr: (filename) => `Nom de fichier invalide : « ${filename} ».`,
	hi: (filename) => `अमान्य फ़ाइल नाम: "${filename}"।`,
	ht: (filename) => `Non dosye ki pa valid: "${filename}".`,
	it: (filename) => `Nome file non valido: "${filename}".`,
	ja: (filename) => `無効なファイル名:「${filename}」。`,
	ko: (filename) => `유효하지 않은 파일명: "${filename}".`,
	mww: (filename) => `Cov ntaub ntawv tsis raug: "${filename}".`,
	ps: (filename) => `ناسم فایل نوم: "${filename}".`,
	pt: (filename) => `Nome de arquivo inválido: "${filename}".`,
	'pt-pt': (filename) => `Nome de ficheiro inválido: "${filename}".`,
	ru: (filename) => `Неверное имя файла: "${filename}".`,
	sm: (filename) => `Igoa faila e le aoga: "${filename}".`,
	so: (filename) => `Magac faylka oo aan sax ahayn: ${filename}".`,
	th: (filename) => `ชื่อไฟล์ไม่ถูกต้อง: "${filename}"`,
	ur: (filename) => `غلط فائل نام: "${filename}"۔`,
	vi: (filename) => `Tên tệp không hợp lệ: "${filename}".`,
	'zh-hans': (filename) => `文件名无效：“${filename}”。`,
	'zh-hant': (filename) => `檔案名稱無效：「${filename}」。`,
	en: (filename) => `Invalid filename: "${filename}".`
};

export const loc_invalidFormat: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `${label} منسق بشكل غير صحيح.`,
	de: (label) => `${label} ist falsch formatiert.`,
	es: (label) => `${label} está mal formateado.`,
	fa: (label) => `${label} به اشتباه قالب بندی شده است.`,
	fil: (label) => `Mali ang format ng ${label}.`,
	fr: (label) => `${label} est mal formaté.`,
	hi: (label) => `${label} गलत तरीके से स्वरूपित किया गया है।`,
	ht: (label) => `${label} se fòma mal.`,
	it: (label) => `${label} è formattato in modo errato.`,
	ja: (label) => `${label} のフォーマットが誤っています。`,
	ko: (label) => `${label} 이 잘못 서식되어 있습니다.`,
	mww: (label) => `${label} tsis ncaj ncees lawm.`,
	ps: (label) => `${label} غلط فارمیټ شوی دی.`,
	pt: (label) => `${label} está formatado incorretamente.`,
	'pt-pt': (label) => `${label} está formatado incorretamente.`,
	ru: (label) => `${label} неправильно отформатировано.`,
	sm: (label) => `E le sa'o le ${label}.`,
	so: (label) => `${label} si khaldan ayaa loo qaabeeyay.`,
	th: (label) => `${label} ถูกจัดรูปแบบไม่ถูกต้อง`,
	ur: (label) => `${label} غلط فارمیٹ کیا گیا ہے۔`,
	vi: (label) => `${label} được định dạng không chính xác.`,
	'zh-hans': (label) => `${label} 格式错误。`,
	'zh-hant': (label) => `${label} 格式錯誤。`,
	en: (label) => `${label} is incorrectly formatted.`
};

export const loc_invalidGeneral: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `${label} غير صالح.`,
	de: (label) => `${label} ist ungültig.`,
	es: (label) => `El ${label} no es válido.`,
	fa: (label) => `${label} نامعتبر است.`,
	fil: (label) => `Hindi wasto ang ${label}.`,
	fr: (label) => `${label} est invalide.`,
	hi: (label) => `${label} अमान्य है।`,
	ht: (label) => `${label} envalid`,
	it: (label) => `Il ${label} non è valido.`,
	ja: (label) => `${label} は無効です。`,
	ko: (label) => `${label} 이 유효하지 않아요.`,
	mww: (label) => `${label} tsis raug.`,
	ps: (label) => `${label} ناسم دی.`,
	pt: (label) => `${label} é inválido.`,
	'pt-pt': (label) => `${label} é inválido.`,
	ru: (label) => `${label} недействительно.`,
	sm: (label) => `E le o sa'o ${label}.`,
	so: (label) => `${label} waa mid aan sax ahayn.`,
	th: (label) => `${label} ไม่ถูกต้อง`,
	ur: (label) => `${label} غلط ہے۔`,
	vi: (label) => `${label} không hợp lệ.`,
	'zh-hans': (label) => `${label} 无效。`,
	'zh-hant': (label) => `${label} 無效。`,
	en: (label) => `${label} is invalid.`
};

export const loc_invalidInteger: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `${label} لا يسمح بالكسور.`,
	de: (label) => `${label} erlaubt keine Brüche.`,
	es: (label) => `${label} no permite fracciones.`,
	fa: (label) => `${label} اجازه کسرها را نمی دهد.`,
	fil: (label) => `Hindi pinapayagan ${label} ang mga fraction.`,
	fr: (label) => `${label} n’autorise pas les fractions.`,
	hi: (label) => `${label} भिन्नों की अनुमति नहीं देता है।`,
	ht: (label) => `${label} pa pèmèt fraksyon.`,
	it: (label) => `${label} non permette frazioni.`,
	ja: (label) => `${label} では分数は許されません。`,
	ko: (label) => `${label} 은 분수를 허용하지 않습니다.`,
	mww: (label) => `${label} tsis pub cov zauv feem.`,
	ps: (label) => `${label} د کسرونو اجازه نه ورکوی.`,
	pt: (label) => `${label} não permite frações.`,
	'pt-pt': (label) => `${label} não permite frações.`,
	ru: (label) => `${label} не допускает дроби.`,
	sm: (label) => `E le faatagaina e ${label} ni vaega ninii.`,
	so: (label) => `${label} ma oggola jajabyo.`,
	th: (label) => `${label} ไม่อนุญาตให้ใช้เศษส่วน`,
	ur: (label) => `${label} میں کسروں کی اجازت نہیں ہے۔`,
	vi: (label) => `${label} không cho phép phân số.`,
	'zh-hans': (label) => `${label} 不允许分数。`,
	'zh-hant': (label) => `${label} 不允許分數。`,
	en: (label) => `${label} does not permit fractions.`
};

export const loc_invalidLess: Record<Locale, (label: unknown, maxLabel: unknown) => string> = {
	ar: (label, maxLabel) => `${label} أقل من ${maxLabel}.`,
	de: (label, maxLabel) => `Das ${label} muss kürzer als ${maxLabel} sein.`,
	es: (label, maxLabel) => `La ${label} debe ser inferior a ${maxLabel}.`,
	fa: (label, maxLabel) => `${label} باید کمتر از ${maxLabel} باشد.`,
	fil: (label, maxLabel) => `Ang ${label} ay dapat na mas mababa kaysa sa ${maxLabel}.`,
	fr: (label, maxLabel) => `${label} doit être inférieure à ${maxLabel}.`,
	hi: (label, maxLabel) => `${label} ${maxLabel} कम होना चाहिए.`,
	ht: (label, maxLabel) => `${label} dwe mwens pase ${maxLabel}`,
	it: (label, maxLabel) => `${label} deve essere inferiore alla ${maxLabel}.`,
	ja: (label, maxLabel) => `${label} は ${maxLabel}より短い必要があります。`,
	ko: (label, maxLabel) => `${label} 은 ${maxLabel}보다 짧아야 합니다.`,
	mww: (label, maxLabel) => `${label} yuav tsum tsawg dua ${maxLabel}.`,
	ps: (label, maxLabel) => `${label} باید د ${maxLabel} څخه کمه وی.`,
	pt: (label, maxLabel) => `${label} deve ser inferior à ${maxLabel}.`,
	'pt-pt': (label, maxLabel) => `${label} deve ser inferior à ${maxLabel}.`,
	ru: (label, maxLabel) => `${label} работы должна быть ниже ${maxLabel}.`,
	sm: (label, maxLabel) => `O le ${label} e tatau ona itiiti ifo nai lo le ${maxLabel} ai.`,
	so: (label, maxLabel) => `${label} waa inay ka yar ${maxLabel}.`,
	th: (label, maxLabel) => `${label}ต้องน้อยกว่า${maxLabel}`,
	ur: (label, maxLabel) => `${label} ${maxLabel} سے کم ہونی چاہیے۔`,
	vi: (label, maxLabel) => `${label} phải nhỏ hơn ${maxLabel}.`,
	'zh-hans': (label, maxLabel) => `${label} 必须小 ${maxLabel}。`,
	'zh-hant': (label, maxLabel) => `${label} 必須小 ${maxLabel}。`,
	en: (label, maxLabel) => `${label} must be less than ${maxLabel}.`
};

export const loc_invalidLessOrEqual: Record<Locale, (label: unknown, maxLabel: unknown) => string> = {
	ar: (label, maxLabel) => `${label} أقل أو يساوي ${maxLabel}.`,
	de: (label, maxLabel) => `Das ${label} muss kleiner oder gleich dem ${maxLabel} sein.`,
	es: (label, maxLabel) => `${label} debe ser menor o igual a ${maxLabel}.`,
	fa: (label, maxLabel) => `${label} باید کمتر یا برابر با ${maxLabel} باشد.`,
	fil: (label, maxLabel) => `Ang ${label} ay dapat na mas mababa o katumbas ng ${maxLabel}.`,
	fr: (label, maxLabel) => `${label} doit être inférieure ou égale à ${maxLabel}.`,
	hi: (label, maxLabel) => `${label} ${maxLabel} से कम या उसके बराबर होना चाहिए.`,
	ht: (label, maxLabel) => `${label} dwe mwens pase oswa egal a ${maxLabel}`,
	it: (label, maxLabel) => `${label} deve essere inferiore o uguale alla ${maxLabel}.`,
	ja: (label, maxLabel) => `${label} は ${maxLabel}より下でなければなりません。`,
	ko: (label, maxLabel) => `${label} 은 ${maxLabel}보다 작아야 합니다.`,
	mww: (label, maxLabel) => `${label} yuav tsum tsawg dua los yog sib npaug rau ${maxLabel}.`,
	ps: (label, maxLabel) => `${label} باید د ${maxLabel} څخه کمه یا مساوی وی.`,
	pt: (label, maxLabel) => `${label} deve ser menor ou igual à ${maxLabel}.`,
	'pt-pt': (label, maxLabel) => `${label} deve ser inferior ou igual à ${maxLabel}.`,
	ru: (label, maxLabel) => `${label} работы должна быть меньше или равна ${maxLabel}.`,
	sm: (label, maxLabel) => `O le ${label} e tatau ona itiiti ifo pe tutusa foi ma le ${maxLabel} ai.`,
	so: (label, maxLabel) => `${label} waa inay ka yar tahay ama la mid ${maxLabel}.`,
	th: (label, maxLabel) => `${label}ต้องน้อยกว่าหรือเท่ากับ${maxLabel}`,
	ur: (label, maxLabel) => `${label} ${maxLabel} ہونے کی تاریخ سے کم یا اس کے برابر ہونی چاہیے۔`,
	vi: (label, maxLabel) => `${label} phải nhỏ hơn hoặc bằng ${maxLabel}.`,
	'zh-hans': (label, maxLabel) => `${label} 必须小于或等于 ${maxLabel}。`,
	'zh-hant': (label, maxLabel) => `${label} 必須小於或等於 ${maxLabel}。`,
	en: (label, maxLabel) => `${label} must be less than or equal to ${maxLabel}.`
};

export const loc_invalidLogin: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `قد يحتوي ${label} على حروف أو أرقام أو شرطة واحدة فقط، ولا يمكن أن يبدأ أو ينتهي بشرطة.`,
	de: (label) => `${label} darf nur Buchstaben, Zahlen oder einzelne Bindestriche enthalten und darf nicht mit einem Bindestrich beginnen oder enden.`,
	es: (label) => `El ${label} puede contener solo letras, números o guiones individuales, y no puede comenzar ni terminar con un guion.`,
	fa: (label) => `${label} ممکن است فقط شامل حروف، اعداد یا خط تیره های منفرد باشد و نمی تواند با خط تیره شروع یا پایان یابد.`,
	fil: (label) => `${label} ay maaaring maglaman lamang ng mga titik, numero, o solong hyphen, at hindi maaaring magsimula o magtapos sa isang hyphen.`,
	fr: (label) => `${label} ne peut contenir que des lettres, des chiffres ou des traits d’union simples, et ne peut ni commencer ni se terminer par un trait d’union.`,
	hi: (label) => `${label} में केवल अक्षर, संख्याएँ या एकल हाइफ़न हो सकते हैं, और हाइफ़न के साथ प्रारंभ या अंत नहीं हो सकता है।`,
	ht: (label) => `${label} ka gen sèlman lèt, nimewo, oswa tirè sèl, epi yo pa ka kòmanse oswa fini ak yon tirè.`,
	it: (label) => `${label} può contenere solo lettere, numeri o trattini singoli e non può iniziare o terminare con un trattino.`,
	ja: (label) => `${label} は文字、数字、または単一のハイフンのみで構成されることができ、ハイフンで始まったり終わったりすることはできません。`,
	ko: (label) => `${label} 은 글자, 숫자 또는 단일 하이픈만 포함할 수 있으며, 하이픈으로 시작하거나 끝날 수 없습니다.`,
	mww: (label) => `${label} tsuas muaj cov tsiaj ntawv, cov zauv, lossis ib tus zauv xwb, thiab tsis tuaj yeem pib lossis xaus nrog tus zawm zawm.`,
	ps: (label) => `${label} کېدای شی یوازې توری، شمېرې، یا یو واحد هایفن ولری، او نشی کولای د هایفن سره پیل یا پای ته ورسیږی.`,
	pt: (label) => `${label} pode conter apenas letras, números ou hífens simples, e não pode começar ou terminar com hífen.`,
	'pt-pt': (label) => `${label} pode conter apenas letras, números ou hífens simples, e não pode começar nem terminar com um hífen.`,
	ru: (label) => `${label} может содержать только буквы, цифры или отдельные дефисы и не может начинаться или заканчиваться дефисом.`,
	sm: (label) => `${label} e mafai ona na o mataitusi, fuainumera, po o vase se tasi, ma e le mafai ona amata pe faaiu i se vase upu.`,
	so: (label) => `${label} wuxuu ka koobnaan karaa oo kaliya xarfo, tirooyin, ama xarfaha hal xariiq, mana ku bilaabi karo ama ku dhammaan karo xarfaha xarfaha isku xiran.`,
	th: (label) => `${label} ต้องมีเฉพาะตัวอักษร ตัวเลข หรือยัติภังค์เดี่ยว และไม่สามารถขึ้นต้นหรือลงท้ายด้วยยัติภังค์ได้`,
	ur: (label) => `${label} میں صرف حروف، اعداد یا سنگل ہائفن شامل ہو سکتے ہیں، اور یہ ہائفن سے شروع یا ختم نہیں ہو سکتا۔`,
	vi: (label) => `${label} chỉ có thể chứa các chữ cái, số hoặc dấu gạch nối đơn lẻ và không được bắt đầu hoặc kết thúc bằng dấu gạch nối.`,
	'zh-hans': (label) => `${label} 只能包含字母、数字或单连字符，且不能以连字符开头或结尾。`,
	'zh-hant': (label) => `${label} 只能包含字母、數字或單連字號，且不得以連字號開頭或結尾。`,
	en: (label) => `${label} may only contain letters, numbers, or single hyphens, and cannot begin or end with a hyphen.`
};

export const loc_invalidMaxCount: Record<Locale, (length: unknown) => string> = {
	ar: (length) => `الحد الأقصى لعدد العناصر هو ${length}.`,
	de: (length) => `Die maximale Anzahl an Gegenständen beträgt ${length}.`,
	es: (length) => `El número máximo de objetos es ${length}.`,
	fa: (length) => `حداکثر تعداد آیتم ${length} است.`,
	fil: (length) => `Ang maximum na bilang ng mga item ay ${length}.`,
	fr: (length) => `Le nombre maximal d’objets est ${length}.`,
	hi: (length) => `वस्तुओं की अधिकतम संख्या ${length} है।`,
	ht: (length) => `Maksimòm kantite atik se ${length}`,
	it: (length) => `Il numero massimo di oggetti è ${length}.`,
	ja: (length) => `最大アイテム数は ${length}点です。`,
	ko: (length) => `최대 아이템 수는 ${length}개입니다.`,
	mww: (length) => `Qhov siab tshaj plaws ntawm cov khoom yog ${length}.`,
	ps: (length) => `اعظمی توکی ${length} دی.`,
	pt: (length) => `O número máximo de itens é ${length}.`,
	'pt-pt': (length) => `O número máximo de itens é ${length}.`,
	ru: (length) => `Максимальное количество предметов — ${length}.`,
	sm: (length) => `O le aofa'i aupito maualuga o aitema o le ${length}.`,
	so: (length) => `Tirada ugu badan ee alaabta waa ${length}.`,
	th: (length) => `จํานวนรายการสูงสุดคือ ${length} รายการ`,
	ur: (length) => `زیادہ سے زیادہ اشیاء ${length} ہے۔`,
	vi: (length) => `Số lượng mặt hàng tối đa là ${length}.`,
	'zh-hans': (length) => `最多可携带 ${length}件物品。`,
	'zh-hant': (length) => `最多可藏 ${length}件。`,
	en: (length) => `Maximum number of items is ${length}.`
};

export const loc_invalidMaxLength: Record<Locale, (label: unknown, max: unknown) => string> = {
	ar: (label, max) => `لا يمكن ${label} أطول ${max} حرفا.`,
	de: (label, max) => `${label} darf nicht länger als ${max} Zeichen sein.`,
	es: (label, max) => `El ${label} no puede superar ${max} caracteres.`,
	fa: (label, max) => `${label} نباید بیش از ${max} کاراکتر باشد.`,
	fil: (label, max) => `${label} ay hindi maaaring lumampas sa ${max} character.`,
	fr: (label, max) => `Le ${label} ne peut pas dépasser ${max} caractères.`,
	hi: (label, max) => `${label} ${max} वर्णों से अधिक लंबा नहीं हो सकता.`,
	ht: (label, max) => `${label} pa ka pi long pase ${max} karaktè.`,
	it: (label, max) => `Il ${label} non può superare ${max} caratteri.`,
	ja: (label, max) => `${label} は ${max} 文字を超えてはなりません。`,
	ko: (label, max) => `${label} 은 ${max} 자를 넘을 수 없습니다.`,
	mww: (label, max) => `${label} tsis tuaj yeem ntev tshaj ${max} tus cim.`,
	ps: (label, max) => `${label} باید له ${max} تورو څخه اوږد نه وی.`,
	pt: (label, max) => `${label} não pode ter mais de ${max} caracteres.`,
	'pt-pt': (label, max) => `${label} não pode ter mais de ${max} caracteres.`,
	ru: (label, max) => `${label} не должно быть длиннее ${max} символов.`,
	sm: (label, max) => `E le mafai ona sili atu ma ${max} mataitusi le ${label}.`,
	so: (label, max) => `${label} ma noqon karo mid ka badan ${max} xaraf.`,
	th: (label, max) => `${label} ต้องมีความยาวไม่เกิน ${max} อักขระ`,
	ur: (label, max) => `${label} ${max} حروف سے زیادہ لمبا نہیں ہونا چاہیے۔`,
	vi: (label, max) => `${label} không được dài hơn ${max} ký tự.`,
	'zh-hans': (label, max) => `${label} 不得超过 ${max} 个字符。`,
	'zh-hant': (label, max) => `${label} 不得超過 ${max} 個字元。`,
	en: (label, max) => `${label} cannot be longer than ${max} characters.`
};

export const loc_invalidMaxNumber: Record<Locale, (label: unknown, max: unknown) => string> = {
	ar: (label, max) => `لا يمكن ${label} أكبر ${max}.`,
	de: (label, max) => `${label} darf nicht größer als ${max} sein.`,
	es: (label, max) => `El ${label} no puede ser mayor de ${max}.`,
	fa: (label, max) => `${label} نباید بیشتر ${max} باشد.`,
	fil: (label, max) => `${label} ay hindi maaaring hihigit sa ${max}.`,
	fr: (label, max) => `${label} ne peut pas dépasser ${max}.`,
	hi: (label, max) => `${label} ${max} से अधिक नहीं हो सकता।`,
	ht: (label, max) => `${label} pa ka pi gran pase ${max}`,
	it: (label, max) => `${label} non può superare ${max}.`,
	ja: (label, max) => `${label} は ${max}を超えてはいけません。`,
	ko: (label, max) => `${label} 은 ${max}을 넘을 수 없습니다.`,
	mww: (label, max) => `${label} tsis tuaj yeem ntau tshaj ${max}.`,
	ps: (label, max) => `${label} باید له ${max} څخه زیات نه وی.`,
	pt: (label, max) => `${label} não pode ser maior que ${max}.`,
	'pt-pt': (label, max) => `${label} não pode ser superior ${max}.`,
	ru: (label, max) => `${label} не может быть больше ${max}.`,
	sm: (label, max) => `O ${label} le mafai ona sili atu nai lo ${max}.`,
	so: (label, max) => `${label} ma noqon karo mid ka weyn ${max}.`,
	th: (label, max) => `${label}ต้องไม่เกิน ${max}`,
	ur: (label, max) => `${label} ${max} سے زیادہ نہیں ہو سکتا۔`,
	vi: (label, max) => `${label} không được lớn hơn ${max}.`,
	'zh-hans': (label, max) => `${label} 不能超过 ${max}。`,
	'zh-hant': (label, max) => `${label} 不能超過 ${max}。`,
	en: (label, max) => `${label} cannot be greater than ${max}.`
};

export const loc_invalidMinLength: Record<Locale, (label: unknown, min: unknown) => string> = {
	ar: (label, min) => `يجب أن يكون ${label} على ${min} أحرف فقط.`,
	de: (label, min) => `${label} muss mindestens ${min} Zeichen umfassen.`,
	es: (label, min) => `El ${label} debe tener al ${min} caracteres.`,
	fa: (label, min) => `${label} باید حداقل ${min} کاراکتر باشد.`,
	fil: (label, min) => `${label} ay dapat na hindi bababa sa ${min} character.`,
	fr: (label, min) => `Le ${label} doit comporter au ${min} caractères.`,
	hi: (label, min) => `${label} कम से कम ${min} अक्षरों का होना चाहिए।`,
	ht: (label, min) => `${label} dwe omwen ${min} karaktè.`,
	it: (label, min) => `Il ${label} deve avere almeno ${min} caratteri.`,
	ja: (label, min) => `${label} は最低 ${min} 文字でなければなりません。`,
	ko: (label, min) => `${label} 은 최소 ${min} 자 이상이어야 합니다.`,
	mww: (label, min) => `${label} yuav tsum muaj tsawg ${min} tus cim.`,
	ps: (label, min) => `${label} باید لږ تر لږه ${min} کرکټرونه وی.`,
	pt: (label, min) => `${label} deve ter pelo ${min} caracteres.`,
	'pt-pt': (label, min) => `${label} deve ter pelo ${min} caracteres.`,
	ru: (label, min) => `${label} должно быть не менее ${min} символов.`,
	sm: (label, min) => `${label} e tatau ona le itiiti ifo ma ${min} mataitusi.`,
	so: (label, min) => `${label} waa inuu noqdaa ugu yaraan ${min} xaraf.`,
	th: (label, min) => `${label} ต้องมีอย่างน้อย ${min} อักขระ`,
	ur: (label, min) => `${label} کم از کم ${min} حروف پر مشتمل ہونا چاہیے۔`,
	vi: (label, min) => `${label} phải có ít nhất ${min} ký tự.`,
	'zh-hans': (label, min) => `${label} 必须至少有 ${min} 个字符。`,
	'zh-hant': (label, min) => `${label} 必須至少有 ${min} 字元。`,
	en: (label, min) => `${label} must be at least ${min} characters.`
};

export const loc_invalidMinNumber: Record<Locale, (label: unknown, min: unknown) => string> = {
	ar: (label, min) => `لا يمكن أن يكون ${label} أقل ${min}.`,
	de: (label, min) => `${label} darf nicht kleiner als ${min} sein.`,
	es: (label, min) => `${label} no puede ser menor de ${min}.`,
	fa: (label, min) => `${label} نباید کمتر ${min} باشد.`,
	fil: (label, min) => `${label} ay hindi maaaring mas mababa sa ${min}.`,
	fr: (label, min) => `${label} ne doit pas être inférieur ${min}.`,
	hi: (label, min) => `${label} ${min} से कम नहीं हो सकता।`,
	ht: (label, min) => `${label} pa ka mwens pase ${min}`,
	it: (label, min) => `${label} non può essere inferiore ${min}.`,
	ja: (label, min) => `${label} は ${min}未満であってはならない。`,
	ko: (label, min) => `${label} 이 ${min} 이하일 수 없습니다.`,
	mww: (label, min) => `${label} tsis tuaj yeem tsawg ${min}.`,
	ps: (label, min) => `${label} باید له ${min} څخه کم نه وی.`,
	pt: (label, min) => `${label} não pode ser menor que ${min}.`,
	'pt-pt': (label, min) => `${label} não pode ser inferior ${min}.`,
	ru: (label, min) => `${label} не может быть меньше ${min}.`,
	sm: (label, min) => `${label} e le mafai ona itiiti ifo ma ${min}.`,
	so: (label, min) => `${label} ma noqon karo mid ka yar ${min}.`,
	th: (label, min) => `${label}ต้องไม่น้อยกว่า ${min}`,
	ur: (label, min) => `${label} ${min} سے کم نہیں ہو سکتا۔`,
	vi: (label, min) => `${label} không được nhỏ hơn ${min}.`,
	'zh-hans': (label, min) => `${label} 不能少于 ${min}。`,
	'zh-hant': (label, min) => `${label} 不能少於 ${min}。`,
	en: (label, min) => `${label} cannot be less than ${min}.`
};

export const loc_invalidMultiple: Record<Locale, (label: unknown, step: unknown) => string> = {
	ar: (label, step) => `يجب ${label} مضاعفا ${step}`,
	de: (label, step) => `${label} muss ein Vielfaches von ${step} sein`,
	es: (label, step) => `${label} debe ser múltiplo de ${step}`,
	fa: (label, step) => `${label} باید مضربی ${step} باشد`,
	fil: (label, step) => `Ang ${label} ay dapat na maramihang ${step}`,
	fr: (label, step) => `${label} doit être un multiple de ${step}`,
	hi: (label, step) => `${label} ${step} का गुणज होना चाहिए`,
	ht: (label, step) => `${label} dwe yon miltip nan ${step}`,
	it: (label, step) => `${label} deve essere un multiplo di ${step}`,
	ja: (label, step) => `${label}は${step}の倍数でなければなりません`,
	ko: (label, step) => `${label}은 ${step}의 배수여야 합니다`,
	mww: (label, step) => `${label} yuav tsum yog qhov sib npaug ntawm ${step}`,
	ps: (label, step) => `${label} باید د ${step} ضرب وی`,
	pt: (label, step) => `${label} deve ser múltiplo de ${step}`,
	'pt-pt': (label, step) => `${label} deve ser múltiplo de ${step}`,
	ru: (label, step) => `${label} должно быть кратным ${step}`,
	sm: (label, step) => `${label} e tatau ona i ai se numera o le ${step}`,
	so: (label, step) => `${label} waa inuu noqdaa tiro ${step}`,
	th: (label, step) => `${label} ต้องเป็นทวีคูณของ ${step}`,
	ur: (label, step) => `${label} ${step} کا مضرب ہونا چاہیے`,
	vi: (label, step) => `${label} phải là bội số của ${step}`,
	'zh-hans': (label, step) => `${label}必须是${step}的倍数`,
	'zh-hant': (label, step) => `${label}必須是${step}的倍數`,
	en: (label, step) => `${label} must be a multiple of ${step}`
};

export const loc_invalidMultipleTime: Record<Locale, (label: unknown, step: unknown) => string> = {
	ar: (label, step) => `يجب أن يكون ${label} بفترات ${step} دقيقة.`,
	de: (label, step) => `${label} muss in ${step} Minuten angegeben werden.`,
	es: (label, step) => `El ${label} debe estar en incrementos de ${step} minutos.`,
	fa: (label, step) => `${label} باید در بازه ${step} دقیقه ای باشد.`,
	fil: (label, step) => `${label} ay dapat na nasa increments ng ${step} minuto.`,
	fr: (label, step) => `Le ${label} doit être fait par incréments de ${step} minutes.`,
	hi: (label, step) => `${label} ${step} मिनट की वृद्धि में होना चाहिए।`,
	ht: (label, step) => `${label} dwe nan ogmantasyon ${step} minit.`,
	it: (label, step) => `Il ${label} deve essere fatto a intervalli di ${step} minuti.`,
	ja: (label, step) => `${label} は ${step} 分単位で記載してください。`,
	ko: (label, step) => `${label} 은 ${step} 분 단위로 표시해야 합니다.`,
	mww: (label, step) => `${label} yuav tsum nce ${step} feeb.`,
	ps: (label, step) => `${label} باید په ${step} دقیقو کې وی.`,
	pt: (label, step) => `${label} deve ser em incrementos de ${step} minutos.`,
	'pt-pt': (label, step) => `O ${label} deve estar em incrementos de ${step} minutos.`,
	ru: (label, step) => `${label} должно быть написано с ${step} минут.`,
	sm: (label, step) => `${label} e tatau ona i ai i se faaopoopoga o le ${step} minute.`,
	so: (label, step) => `${label} waa inuu noqdaa qayb ${step} daqiiqo.`,
	th: (label, step) => `${label} ต้องเพิ่มขึ้นทีละ ${step} นาที`,
	ur: (label, step) => `${label} ${step} منٹ کے وقفوں میں ہونا چاہیے۔`,
	vi: (label, step) => `${label} phải tăng dần ${step} phút.`,
	'zh-hans': (label, step) => `${label} 必须以 ${step} 分钟为单位。`,
	'zh-hant': (label, step) => `${label} 必須以 ${step} 分鐘為單位。`,
	en: (label, step) => `${label} must be in increments of ${step} minutes.`
};

export const loc_invalidRequired: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `${label} مطلوب.`,
	de: (label) => `${label} ist erforderlich.`,
	es: (label) => `Se ${label}.`,
	fa: (label) => `${label} لازم است.`,
	fil: (label) => `Kinakailangan ang ${label}.`,
	fr: (label) => `${label} est requis.`,
	hi: (label) => `${label} की आवश्यकता है।`,
	ht: (label) => `${label} obligatwa`,
	it: (label) => `Il ${label} è richiesto.`,
	ja: (label) => `${label} が必要です。`,
	ko: (label) => `${label} 이 필요합니다.`,
	mww: (label) => `Yuav tsum ${label}.`,
	ps: (label) => `${label} اړین دی.`,
	pt: (label) => `${label} é obrigatório.`,
	'pt-pt': (label) => `${label} é obrigatório.`,
	ru: (label) => `${label} обязательно.`,
	sm: (label) => `E mana'omia le ${label}.`,
	so: (label) => `${label} ayaa loo baahan yahay.`,
	th: (label) => `ต้องระบุ${label}`,
	ur: (label) => `${label} درکار ہے۔`,
	vi: (label) => `${label} là bắt buộc.`,
	'zh-hans': (label) => `需要${label}。`,
	'zh-hant': (label) => `需${label}。`,
	en: (label) => `${label} is required.`
};

export const loc_invalidTime: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `يجب أن يكون ${label} صالحا مع صباح أو مساء، مثل 7 صباحا أو 7:15 مساء.`,
	de: (label) => `${label} muss mit morgens oder abends gültig sein, zum Beispiel 7 Uhr morgens oder 19:15 Uhr.`,
	es: (label) => `${label} debe ser válida con la mañana o la tarde, como las 7 o las 7:15 de la tarde.`,
	fa: (label) => `${label} باید با ساعت صبح یا عصر معتبر باشد، مثلا ساعت ۷ صبح یا ۷:۱۵ عصر.`,
	fil: (label) => `${label} ay dapat na isang wastong oras sa AM o PM, tulad ng 7am o 7:15pm.`,
	fr: (label) => `${label} doit être valide avec le matin ou le soir, comme 7h ou 19h15.`,
	hi: (label) => `${label} सुबह या शाम के साथ एक वैध समय होना चाहिए, जैसे सुबह 7 बजे या शाम 7:15 बजे।`,
	ht: (label) => `${label} dwe yon tan valab ak AM oswa PM, tankou 7am oswa 7:15pm.`,
	it: (label) => `${label} deve essere valido con il mattino o il pomeriggio, ad esempio le 7:00 o le 19:15.`,
	ja: (label) => `${label} は午前または午後の有効な時間でなければなりません。例えば、午前7時や午後7時15分などです。`,
	ko: (label) => `${label} 오전 또는 오후 기준 유효 시간이어야 하며, 예를 들어 오전 7시 또는 오후 7시 15분이어야 합니다.`,
	mww: (label) => `${label} yuav tsum yog lub sijhawm siv tau nrog teev sawv ntxov lossis teev tsaus ntuj, xws li 7 teev sawv ntxov lossis 7:15 teev tsaus ntuj.`,
	ps: (label) => `${label} باید د سهار یا ماښام سره معتبر وی، لکه سهار ۷ بجې یا ۷:۱۵ ماښام.`,
	pt: (label) => `${label} deve ser válido com a manhã ou a tarde, como 7h ou 19h15.`,
	'pt-pt': (label) => `${label} deve ser válida com a manhã ou a tarde, como às 7h ou às 19h15.`,
	ru: (label) => `${label} должно быть действительным с утра или вечером, например, в 7 утра или 19:15.`,
	sm: (label) => `${label} e tatau ona avea ma taimi aoga ma le AM po'o le PM, e pei o le 7am po'o le 7:15pm.`,
	so: (label) => `${label} waa inuu ahaadaa waqti sax ah marka la isticmaalo subaxnimo ama galabnimo, sida 7 subaxnimo ama 7:15 fiidnimo.`,
	th: (label) => `${label} ต้องเป็นเวลาที่ถูกต้องกับ AM หรือ PM เช่น 7.00 น. หรือ 19.15 น.`,
	ur: (label) => `${label} صبح یا شام کے ساتھ درست وقت ہونا چاہیے، جیسے صبح 7 بجے یا شام 7:15 بجے۔`,
	vi: (label) => `${label} phải là thời gian hợp lệ với AM hoặc PM, chẳng hạn như 7 giờ sáng hoặc 7:15 tối.`,
	'zh-hans': (label) => `${label} 必须为有效的时间，包括上午或晚上，如早上7点或晚上7点15分。`,
	'zh-hant': (label) => `${label} 必須是有效的時間，包括上午或下午，例如早上7點或晚上7點15分。`,
	en: (label) => `${label} must be a valid time with AM or PM, such as 7am or 7:15pm.`
};

export const loc_invalidUnique: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `يجب ${label} فريدا.`,
	de: (label) => `${label} muss einzigartig sein.`,
	es: (label) => `El ${label} debe ser único.`,
	fa: (label) => `${label} باید منحصر به فرد باشد.`,
	fil: (label) => `${label} ay dapat na natatangi.`,
	fr: (label) => `Le ${label} doit être unique.`,
	hi: (label) => `${label} अद्वितीय होना चाहिए।`,
	ht: (label) => `${label} dwe inik.`,
	it: (label) => `${label} deve essere unico.`,
	ja: (label) => `${label} は唯一無二でなければなりません。`,
	ko: (label) => `${label} 은 고유해야 합니다.`,
	mww: (label) => `${label} yuav tsum yog qhov tshwj xeeb.`,
	ps: (label) => `${label} باید ځانګړی وی.`,
	pt: (label) => `${label} precisa ser único.`,
	'pt-pt': (label) => `${label} tem de ser único.`,
	ru: (label) => `${label} должно быть уникальным.`,
	sm: (label) => `${label} e tatau ona tulaga ese.`,
	so: (label) => `${label} waa inuu noqdaa mid gaar ah.`,
	th: (label) => `${label} ต้องไม่ซ้ํากัน`,
	ur: (label) => `${label} منفرد ہونا چاہیے۔`,
	vi: (label) => `${label} phải là duy nhất.`,
	'zh-hans': (label) => `${label} 必须是唯一的。`,
	'zh-hant': (label) => `${label} 必須是唯一的。`,
	en: (label) => `${label} must be unique.`
};

export const loc_invalidUniqueCount: Record<Locale, (label: unknown, count: unknown) => string> = {
	ar: (label, count) => `يمكن اختيار نفس ${label} ${count} فقط.`,
	de: (label, count) => `Derselbe ${label} kann nur ${count} ausgewählt werden.`,
	es: (label, count) => `El ${label} solo puede seleccionarse ${count} veces.`,
	fa: (label, count) => `همان ${label} فقط ${count} بار قابل انتخاب است.`,
	fil: (label, count) => `Dalawang ${count} mapipili ang ${label}.`,
	fr: (label, count) => `Le même ${label} ne peut être sélectionné que ${count} fois.`,
	hi: (label, count) => `एक ही ${label} केवल ${count} बार चुना जा सकता है।`,
	ht: (label, count) => `Menm ${label} an ka sèlman ${count} fwa.`,
	it: (label, count) => `Lo stesso ${label} può essere selezionato solo ${count} volte.`,
	ja: (label, count) => `同じ ${label} は ${count} 回しか選択できません。`,
	ko: (label, count) => `같은 ${label} 은 ${count} 만 선택할 수 있습니다.`,
	mww: (label, count) => `Tib ${label} tsuas xaiv ${count} zaug.`,
	ps: (label, count) => `یو ${label} یوازې ${count} ځله انتخاب کېدای شی.`,
	pt: (label, count) => `O mesmo ${label} só pode ser selecionado ${count} vezes.`,
	'pt-pt': (label, count) => `O mesmo ${label} só pode ser ${count} vezes.`,
	ru: (label, count) => `Одно ${label} можно выбрать ${count} раза.`,
	sm: (label, count) => `O le ${label} lava lea e tasi e mafai ona filifilia na o ${count} taimi.`,
	so: (label, count) => `${label} isku mid ah waa la dooran ${count} jeer oo kaliya.`,
	th: (label, count) => `${label}เดียวกันได้เพียง ${count} ครั้งเท่านั้น`,
	ur: (label, count) => `ایک ${label} صرف ${count} بار منتخب کیا جا سکتا ہے۔`,
	vi: (label, count) => `Cùng một ${label} chỉ có thể được chọn ${count} lần.`,
	'zh-hans': (label, count) => `同 ${label} 只能选择 ${count} 。`,
	'zh-hant': (label, count) => `同 ${label} 只能選 ${count} 。`,
	en: (label, count) => `The same ${label} can only be selected ${count} times.`
};

export const loc_invitationRequired: Record<Locale, string> = {
	ar: `دعوة مطلوبة`,
	de: `Einladung erforderlich`,
	es: `Invitación requerida`,
	fa: `دعوت نامه لازم است`,
	fil: `Kailangan ng imbitasyon`,
	fr: `Invitation requise`,
	hi: `निमंत्रण आवश्यक है`,
	ht: `Envitasyon obligatwa`,
	it: `Invito richiesto`,
	ja: `招待が必要です`,
	ko: `초대장 필요`,
	mww: `Yuav tsum tau caw`,
	ps: `بلنه اړینه ده`,
	pt: `Convite necessário`,
	'pt-pt': `Convite obrigatório`,
	ru: `Требуется приглашение`,
	sm: `Manaomia le valaaulia`,
	so: `Casuumaad ayaa loo baahan yahay`,
	th: `ต้องได้รับคําเชิญ`,
	ur: `دعوت نامہ درکار`,
	vi: `Yêu cầu lời mời`,
	'zh-hans': `需邀请`,
	'zh-hant': `需邀請函`,
	en: `Invitation required`
};

export const loc_invitationRequiredMessageFormat: Record<Locale, (email: unknown) => TemplateResult> = {
	ar: (email) => html`لم يتم العثور على دعوة مفتوحة <span class="text-bold">${email}</span>. إذا تلقيت بريد دعوة إلكتروني، تأكد أنك تستخدم نفس عنوان البريد الإلكتروني الذي أرسلت إليه الدعوة. وإلا، اطلب من المسؤول إرسال دعوة جديدة.`,
	de: (email) => html`Keine offene Einladung für <span class="text-bold">${email}</span> gefunden. Wenn Sie eine Einladung per E-Mail erhalten haben, bestätigen Sie, dass Sie dieselbe E-Mail-Adresse verwenden, an die die Einladung gesendet wurde. Ansonsten bitten Sie Ihren Administrator, eine neue Einladung zu senden.`,
	es: (email) => html`No se encontró ninguna invitación abierta para <span class="text-bold">${email}</span>. Si recibiste un correo de invitación, confirma que estás usando la misma dirección de correo a la que se envió la invitación. Si no, pide a tu administrador que envíe una nueva invitación.`,
	fa: (email) => html`هیچ دعوت نامه باز برای <span class="text-bold">${email}</span> پیدا نشد. اگر ایمیل دعوت نامه دریافت کرده اید، تأیید کنید که از همان آدرس ایمیلی که دعوت نامه به آن ارسال شده استفاده می کنید. در غیر این صورت، از مدیر خود بخواهید دعوت نامه جدیدی ارسال کند.`,
	fil: (email) => html`Walang natagpuang bukas na imbitasyon para <span class="text-bold">${email}</span>. Kung nakatanggap ka ng email ng imbitasyon, kumpirmahin na ginagamit mo ang parehong email address na ipinadala sa imbitasyon. Kung hindi, hilingin sa iyong administrator na magpadala ng bagong imbitasyon.`,
	fr: (email) => html`Aucune invitation ouverte n’a été trouvée pour <span class="text-bold">${email}</span>. Si vous avez reçu un e-mail d’invitation, confirmez que vous utilisez la même adresse e-mail à laquelle l’invitation a été envoyée. Sinon, demandez à votre administrateur d’envoyer une nouvelle invitation.`,
	hi: (email) => html`<span class="text-bold">${email}</span> लिए कोई खुला आमंत्रण नहीं मिला। अगर आपको कोई आमंत्रण ईमेल प्राप्त हुआ है, तो पुष्टि करें कि आप उसी ईमेल पते का उपयोग कर रहे हैं जिस पर आमंत्रण भेजा गया था. अन्यथा, अपने व्यवस्थापक से एक नया आमंत्रण भेजने के लिए कहें.`,
	ht: (email) => html`Pa gen envitasyon louvri yo te jwenn pou <span class="text-bold">${email}</span> Si ou te resevwa yon imèl envitasyon, konfime w ap itilize menm adrès imel envitasyon an te voye. Sinon, mande administratè ou a voye yon nouvo envitasyon.`,
	it: (email) => html`Nessun invito aperto per <span class="text-bold">${email}</span>. Se hai ricevuto un'email di invito, conferma di utilizzare lo stesso indirizzo email a cui è stato inviato l'invito. Altrimenti, chiedi al tuo amministratore di inviare un nuovo invito.`,
	ja: (email) => html`<span class="text-bold">${email}</span> にオープンな招待状は見つかりませんでした。招待メールを受け取った場合は、招待状が送られたメールアドレスと同じアドレスを使っているか確認してください。そうでなければ、管理者に新しい招待状を送ってもらうよう依頼してください。`,
	ko: (email) => html`<span class="text-bold">${email}</span> 에 대한 공개 초대는 찾지 못했습니다. 초대 이메일을 받았다면, 초대장이 발송된 이메일 주소와 동일한지 확인하세요. 그렇지 않으면 관리자에게 새 초대장을 보내달라고 요청하세요.`,
	mww: (email) => html`Tsis muaj kev caw qhib pom <span class="text-bold">${email}</span>. Yog tias koj tau txais email caw, paub tseeb tias koj siv tib tus email chaw nyob uas qhov kev caw tau xa mus. Txwv tsis pub, nug koj tus thawj tswj hwm kom xa ib daim ntawv caw tshiab.`,
	ps: (email) => html`هیڅ خلاصه بلنه نه ده موندل <span class="text-bold">${email}</span>. که تاسو د بلنې ایمیل ترلاسه کړی، تایید کړئ چې تاسو هماغه ایمیل پته کاروئ چې بلنه ورته لیږل شوې وه. که نه، خپل مدیر ته ووایه چې نوې بلنه واستوی.`,
	pt: (email) => html`Não foi encontrado nenhum convite aberto para <span class="text-bold">${email}</span>. Se você recebeu um e-mail de convite, confirme que está usando o mesmo endereço de e-mail para o qual o convite foi enviado. Caso contrário, peça ao seu administrador para enviar um novo convite.`,
	'pt-pt': (email) => html`Não foi encontrado nenhum convite aberto para <span class="text-bold">${email}</span>. Se recebeu um e-mail de convite, confirme que está a usar o mesmo endereço de email para onde o convite foi enviado. Caso contrário, peça ao seu administrador para enviar um novo convite.`,
	ru: (email) => html`Открытого приглашения для <span class="text-bold">${email}</span> не найдено. Если вы получили приглашение, подтвердите, что используете тот же адрес, на который было отправлено приглашение. В противном случае попросите администратора отправить новое приглашение.`,
	sm: (email) => html`E leai se valaaulia tatala na maua mo <span class="text-bold">${email}</span>. Afai na e mauaina se imeli valaaulia, ia faamaonia o loo e faaaogaina le tuatusi imeli lava lea e tasi na auina atu i ai le valaaulia. A leai, fai atu i lou pule e auina mai se valaaulia fou.`,
	so: (email) => html`Ma jirto casuumaad furan <span class="text-bold">${email}</span>. Haddii aad heshay email casuumaad ah, xaqiiji inaad isticmaalayso isla cinwaanka email-ka ee casuumaadku loo diray. Haddii kale, weydii maamulahaaga inuu soo diro casuumaad cusub.`,
	th: (email) => html`ไม่พบคําเชิญที่เปิดอยู่สําหรับ <span class="text-bold">${email}</span> หากคุณได้รับอีเมลคําเชิญ ให้ยืนยันว่าคุณใช้ที่อยู่อีเมลเดียวกันกับที่ส่งคําเชิญไปให้ มิฉะนั้น ให้ขอให้ผู้ดูแลระบบส่งคําเชิญใหม่`,
	ur: (email) => html`<span class="text-bold">${email}</span> کے لیے کوئی کھلا دعوت نامہ نہیں ملا۔ اگر آپ کو دعوت نامہ ای میل موصول ہوا ہے تو تصدیق کریں کہ آپ وہی ای میل ایڈریس استعمال کر رہے ہیں جس پر دعوت نامہ بھیجا گیا تھا۔ ورنہ، اپنے ایڈمنسٹریٹر سے کہیں کہ نیا دعوت نامہ بھیجے۔`,
	vi: (email) => html`Không tìm thấy lời mời mở cho <span class="text-bold">${email}</span>. Nếu bạn nhận được email mời, hãy xác nhận rằng bạn đang sử dụng cùng địa chỉ email mà lời mời được gửi đến. Nếu không, hãy yêu cầu quản trị viên của bạn gửi lời mời mới.`,
	'zh-hans': (email) => html`没有找到任何公开邀请 <span class="text-bold">${email}</span>。如果你收到了邀请邮件，请确认你使用的是邀请邮件发送的同一个邮箱地址。否则，请你的管理员重新发送邀请函。`,
	'zh-hant': (email) => html`沒有找到任何公開邀請 <span class="text-bold">${email}</span>。如果你收到邀請信，請確認你使用的是邀請函寄出的同一個電子郵件地址。否則，請你的管理員重新寄出邀請函。`,
	en: (email) => html`No open invitation found for <span class="text-bold">${email}</span>. If you received an invitation email, confirm you're using the same email address the invitation was sent to. Otherwise, ask your administrator to send a new invitation.`
};

export const loc_inviteAMemberOf: Record<Locale, (login: unknown) => string> = {
	ar: (login) => `ادع عضوا في ${login}`,
	de: (login) => `Lade ein Mitglied von ${login} ein`,
	es: (login) => `Invita a un miembro de ${login}`,
	fa: (login) => `عضوی از ${login} را دعوت کنید`,
	fil: (login) => `Mag-imbita ng isang miyembro ng ${login}`,
	fr: (login) => `Invitez un membre de ${login}`,
	hi: (login) => `${login} के किसी सदस्य को आमंत्रित करें`,
	ht: (login) => `Envite yon manm ${login}`,
	it: (login) => `Invita un membro di ${login}`,
	ja: (login) => `${login}のメンバーを招待してください`,
	ko: (login) => `${login}의 회원을 초대하세요`,
	mww: (login) => `Caw ib tug tswv cuab ntawm ${login}`,
	ps: (login) => `د ${login} غړی راوبلل`,
	pt: (login) => `Convide um membro do ${login}`,
	'pt-pt': (login) => `Convide um membro do ${login}`,
	ru: (login) => `Пригласите члена ${login}`,
	sm: (login) => `Valaaulia se tagata o le ${login}`,
	so: (login) => `Casuum xubin ${login}`,
	th: (login) => `เชิญสมาชิกของ ${login}`,
	ur: (login) => `${login} کے کسی رکن کو مدعو کریں`,
	vi: (login) => `Mời một thành viên của ${login}`,
	'zh-hans': (login) => `邀请${login}的一位成员`,
	'zh-hant': (login) => `邀請${login}的成員`,
	en: (login) => `Invite a member of ${login}`
};

export const loc_invoices: Record<Locale, string> = {
	ar: `الفواتير`,
	de: `Rechnungen`,
	es: `Facturas`,
	fa: `فاکتورها`,
	fil: `Email Address *`,
	fr: `Factures`,
	hi: `चालान`,
	ht: `Fakti yo`,
	it: `Fatture`,
	ja: `請求書`,
	ko: `송장`,
	mww: `Cov ntawv sau nqi`,
	ps: `رسیدونه`,
	pt: `Faturas`,
	'pt-pt': `Faturas`,
	ru: `Счета`,
	sm: `Pili`,
	so: `Biilasha`,
	th: `ใบแจ้งหนี้`,
	ur: `انوائسز`,
	vi: `Hóa đơn`,
	'zh-hans': `发票`,
	'zh-hant': `發票`,
	en: `Invoices`
};

export const loc_iUnderstand: Record<Locale, string> = {
	ar: `أنا أفهم`,
	de: `Ich verstehe`,
	es: `Lo entiendo`,
	fa: `متوجه شدم`,
	fil: `Naiintindihan ko`,
	fr: `Je comprends`,
	hi: `मैं समझता हूँ`,
	ht: `Mwen konprann`,
	it: `Capisco`,
	ja: `わかりました`,
	ko: `이해합니다`,
	mww: `Kuv nkag siab`,
	ps: `زه پوهېږم`,
	pt: `Eu entendo`,
	'pt-pt': `Compreendo`,
	ru: `Понимаю`,
	sm: `Oute malamalama`,
	so: `Waan ku fahmaa`,
	th: `ฉันเข้าใจ`,
	ur: `میں سمجھتا ہوں`,
	vi: `Tôi hiểu`,
	'zh-hans': `我明白`,
	'zh-hant': `我明白`,
	en: `I understand`
};

export const loc_iWantToLearnMore: Record<Locale, string> = {
	ar: `أنا أستكشف Cumulus لمنظمتي`,
	de: `Ich erkunde Cumulus für meine Organisation`,
	es: `Estoy explorando Cumulus para mi organización`,
	fa: `من در حال کاوش در Cumulus برای سازمانم هستم`,
	fil: `Ginalugad ko ang Cumulus para sa aking organisasyon`,
	fr: `J’explore Cumulus pour mon organisation`,
	hi: `मैं अपने संगठन के लिए क्यूम्यलस की खोज कर रहा हूं`,
	ht: `Mwen eksplore Cumulus pou òganizasyon mwen an`,
	it: `Sto esplorando Cumulus per la mia organizzazione`,
	ja: `私は自分の組織のためにCumulusを探求しています`,
	ko: `저는 제 조직을 위해 Cumulus를 탐색하고 있습니다`,
	mww: `Kuv tabtom tshawb nrhiav Cumulus rau kuv lub koom haum`,
	ps: `زه د خپل سازمان لپاره Cumulus سپړم`,
	pt: `Estou explorando o Cumulus para minha organização`,
	'pt-pt': `Estou a explorar o Cumulus para a minha organização`,
	ru: `Я изучаю Cumulus для своей организации`,
	sm: `O lo'o ou su'esu'eina Cumulus mo la'u fa'alapotopotoga`,
	so: `Waxaan baarayaa Cumulus ee ururkayga`,
	th: `ฉันกําลังสํารวจ Cumulus สําหรับองค์กรของฉัน`,
	ur: `میں اپنی تنظیم کے لیے Cumulus کو دریافت کر رہا ہوں`,
	vi: `Tôi đang khám phá Cumulus cho tổ chức của mình`,
	'zh-hans': `我正在为我的组织探索Cumulus`,
	'zh-hant': `我正在為我的組織探索 Cumulus`,
	en: `I am exploring Cumulus for my organization`
};

export const loc_keep: Record<Locale, string> = {
	ar: `احتفظ`,
	de: `Keep`,
	es: `Mantener`,
	fa: `نگه داشتن`,
	fil: `Panatilihin`,
	fr: `Garde`,
	hi: `रखना`,
	ht: `Kenbe`,
	it: `Tieni`,
	ja: `キープ`,
	ko: `지키세요`,
	mww: `khaws cia`,
	ps: `وساته`,
	pt: `Fique`,
	'pt-pt': `Manter`,
	ru: `Держи`,
	sm: `Tausia`,
	so: `Hayso`,
	th: `เก็บ`,
	ur: `رکھو`,
	vi: `Giữ`,
	'zh-hans': `守`,
	'zh-hant': `守住`,
	en: `Keep`
};

export const loc_languageSelector: Record<Locale, (language: unknown) => string> = {
	ar: (language) => `محدد لغة المحتوى. حاليا تم ضبطه على ${language}`,
	de: (language) => `Inhaltssprachauswahl. Derzeit auf ${language} eingestellt`,
	es: (language) => `Selector de lenguaje de contenido. Actualmente configurado en ${language}`,
	fa: (language) => `انتخاب کننده زبان محتوا. در حال حاضر به ${language} تنظیم شده است`,
	fil: (language) => `Tagapili ng wika ng nilalaman. Kasalukuyang nakatakda sa ${language}`,
	fr: (language) => `Sélecteur de langage de contenu. Actuellement en ${language}`,
	hi: (language) => `सामग्री भाषा चयनकर्ता. वर्तमान में ${language} पर सेट है`,
	ht: (language) => `Seleksyon lang kontni Kounye a mete nan ${language}`,
	it: (language) => `Selettore del linguaggio dei contenuti. Attualmente impostato in ${language}`,
	ja: (language) => `コンテンツ言語セレクター。現在は${language}設定`,
	ko: (language) => `콘텐츠 언어 선택기. 현재 ${language}로 설정됨`,
	mww: (language) => `Cov ntsiab lus selector. Tam sim no teem rau ${language}`,
	ps: (language) => `د محتوا ژبې ټاکونکی. اوس مهال ${language} ته تنظیم شوی`,
	pt: (language) => `Seletor de linguagem de conteúdo. Atualmente configurado para ${language}`,
	'pt-pt': (language) => `Seletor de linguagem de conteúdo. Atualmente definido para ${language}`,
	ru: (language) => `Селектор языка контента. В настоящее время настроено на ${language}`,
	sm: (language) => `Tagata filifilia o le gagana o le anotusi. O lo'o fa'atulagaina nei i le ${language}`,
	so: (language) => `Xulaha luqadda nuxurka. Hadda waxaa loo dejiyay ${language}`,
	th: (language) => `ตัวเลือกภาษาของเนื้อหา ปัจจุบันตั้งค่าเป็น ${language}`,
	ur: (language) => `کنٹینٹ لینگویج سلیکٹر۔ فی الحال ${language} پر سیٹ ہے`,
	vi: (language) => `Bộ chọn ngôn ngữ nội dung. Hiện được đặt thành ${language}`,
	'zh-hans': (language) => `内容语言选择器。目前已设置为 ${language}`,
	'zh-hant': (language) => `內容語言選擇器。目前設定為 ${language}`,
	en: (language) => `Content language selector. Currently set to ${language}`
};

export const loc_largeQRCode: Record<Locale, string> = {
	ar: `عرض رمز QR كبير`,
	de: `Großen QR-Code anzeigen`,
	es: `Ver código QR grande`,
	fa: `مشاهده کد QR بزرگ`,
	fil: `Tingnan ang malaking QR code`,
	fr: `Voir un grand code QR`,
	hi: `बड़ा क्यूआर कोड देखें`,
	ht: `Gade gwo kòd QR`,
	it: `Visualizza il codice QR in grandi dimensioni`,
	ja: `大きなQRコードを表示`,
	ko: `큰 QR 코드 보기`,
	mww: `Saib QR code loj`,
	ps: `لوی QR کوډ وګورئ`,
	pt: `Veja o código QR grande`,
	'pt-pt': `Ver código QR grande`,
	ru: `Просмотр большого QR-кода`,
	sm: `Va'ai tele QR code`,
	so: `Eeg QR code weyn`,
	th: `ดูรหัส QR ขนาดใหญ่`,
	ur: `بڑا QR کوڈ دیکھیں`,
	vi: `Xem mã QR lớn`,
	'zh-hans': `查看大型二维码`,
	'zh-hant': `查看大型 QR 碼`,
	en: `View large QR code`
};

export const loc_lastName: Record<Locale, string> = {
	ar: `الاسم الأخير`,
	de: `Nachname`,
	es: `Apellido`,
	fa: `نام خانوادگی`,
	fil: `Apelyido`,
	fr: `Nom de famille`,
	hi: `अंतिम नाम`,
	ht: `Siyati`,
	it: `Cognome`,
	ja: `姓`,
	ko: `성`,
	mww: `Lub xeem`,
	ps: `تخلص`,
	pt: `Sobrenome`,
	'pt-pt': `Apelido`,
	ru: `Фамилия`,
	sm: `Igoa faaiu`,
	so: `Magaca dambe`,
	th: `นามสกุล`,
	ur: `آخری نام`,
	vi: `Họ`,
	'zh-hans': `姓氏`,
	'zh-hant': `姓氏`,
	en: `Last name`
};

export const loc_latestEndDate: Record<Locale, string> = {
	ar: `آخر تاريخ نهاية`,
	de: `Letztes Enddatum`,
	es: `Fecha de finalización más tardía`,
	fa: `آخرین تاریخ پایان`,
	fil: `Pinakabagong petsa ng pagtatapos`,
	fr: `Date de fin la plus tardive`,
	hi: `नवीनतम समाप्ति तिथि`,
	ht: `Dènye dat fen`,
	it: `Data di fine più recente`,
	ja: `最も遅い終了日`,
	ko: `가장 늦은 종료일`,
	mww: `Hnub kawg kawg`,
	ps: `وروستی پای نیټه`,
	pt: `Data de término mais recente`,
	'pt-pt': `Data de término mais recente`,
	ru: `Последняя дата окончания`,
	sm: `Aso lata mai e faamuta ai`,
	so: `Taariikhda ugu dambeysa ee dhammaadka`,
	th: `วันที่สิ้นสุดล่าสุด`,
	ur: `تازہ ترین اختتامی تاریخ`,
	vi: `Ngày kết thúc muộn nhất`,
	'zh-hans': `最晚结束日期`,
	'zh-hant': `最晚結束日期`,
	en: `Latest end date`
};

export const loc_latestStartDate: Record<Locale, string> = {
	ar: `أحدث تاريخ بدء`,
	de: `Letztes Startdatum`,
	es: `Fecha de inicio más tardía`,
	fa: `آخرین تاریخ شروع`,
	fil: `Pinakabagong petsa ng pagsisimula`,
	fr: `Date de début la plus récente`,
	hi: `नवीनतम प्रारंभ तिथि`,
	ht: `Dènye dat kòmanse`,
	it: `Data di inizio più recente`,
	ja: `最新の開始日`,
	ko: `최근 시작일`,
	mww: `Hnub pib kawg`,
	ps: `وروستی پیل نیټه`,
	pt: `Data de início mais recente`,
	'pt-pt': `Data de início mais recente`,
	ru: `Поздняя дата начала работы`,
	sm: `Aso amata lata mai`,
	so: `Taariikhda ugu dambeysa ee bilowga`,
	th: `วันที่เริ่มต้นล่าสุด`,
	ur: `تازہ ترین آغاز کی تاریخ`,
	vi: `Ngày bắt đầu muộn nhất`,
	'zh-hans': `最晚开工日期`,
	'zh-hant': `最晚開播日期`,
	en: `Latest start date`
};

export const loc_learnMore: Record<Locale, string> = {
	ar: `تعرف على المزيد`,
	de: `Erfahren Sie mehr`,
	es: `Más información`,
	fa: `بیشتر بدانید`,
	fil: `Email Address *`,
	fr: `En savoir plus`,
	hi: `और जानो`,
	ht: `Aprann plis`,
	it: `Scopri di più`,
	ja: `詳しくはこちら`,
	ko: `더 알아보기`,
	mww: `Kawm ntxiv`,
	ps: `نور زده کړئ`,
	pt: `Saiba mais`,
	'pt-pt': `Saiba mais`,
	ru: `Узнать больше`,
	sm: `Su'esu'e atili`,
	so: `Waxbadan baro`,
	th: `เรียนรู้เพิ่มเติม`,
	ur: `مزید جانیں`,
	vi: `Tìm hiểu thêm`,
	'zh-hans': `了解更多`,
	'zh-hant': `了解更多`,
	en: `Learn more`
};

export const loc_leastRecentlyCreated: Record<Locale, string> = {
	ar: `الأقل إنشاء مؤخرا`,
	de: `Am wenigsten kürzlich erschaffen`,
	es: `Menos recientemente creado`,
	fa: `کمترین شکل اخیر`,
	fil: `Hindi bababa sa kamakailan-lamang na nilikha`,
	fr: `Le moins récemment créé`,
	hi: `कम से कम हाल ही में बनाया गया`,
	ht: `Pi piti resamman kreye`,
	it: `Meno recente creato`,
	ja: `最も最近作られたもの`,
	ko: `가장 최근에 생성된 것`,
	mww: `Tsawg kawg tsis ntev los no tsim`,
	ps: `تر ټولو لږ تازه جوړ شوی`,
	pt: `Menos recentemente criado`,
	'pt-pt': `Menos recentemente criado`,
	ru: `Наименее недавно созданный`,
	sm: `E le'i leva ona faia`,
	so: `Ugu yaraan dhawaan la sameeyay`,
	th: `สร้างล่าสุด`,
	ur: `سب سے کم حال ہی میں تخلیق شدہ`,
	vi: `Được tạo gần đây nhất`,
	'zh-hans': `最近创建的`,
	'zh-hant': `最不近期創建`,
	en: `Least recently created`
};

export const loc_leastRecentlyUpdated: Record<Locale, string> = {
	ar: `الأقل تحديثا مؤخرا`,
	de: `Am wenigsten kürzlich aktualisiert`,
	es: `Menos recientemente actualizado`,
	fa: `کمترین به روزرسانی اخیر`,
	fil: `Hindi bababa sa kamakailan-lamang na na-update`,
	fr: `Mise à jour la moins récente`,
	hi: `कम से कम हाल ही में अपडेट किया गया`,
	ht: `Pi piti dènyèman mete ajou`,
	it: `Aggiornato meno recentemente`,
	ja: `最近更新が遅い`,
	ko: `가장 최근에 업데이트된 것`,
	mww: `Tsawg kawg tsis ntev los no hloov kho`,
	ps: `تر ټولو لږ تازه شوی`,
	pt: `Atualização menos recente`,
	'pt-pt': `Atualização menos recente`,
	ru: `Наименее недавно обновлено`,
	sm: `Fa'afouina talu ai nei`,
	so: `Ugu yaraan dhawaan la cusbooneysiiyay`,
	th: `อัปเดตล่าสุด`,
	ur: `سب سے کم حال ہی میں اپ ڈیٹ`,
	vi: `Cập nhật ít gần đây nhất`,
	'zh-hans': `更新最少`,
	'zh-hant': `更新最少`,
	en: `Least recently updated`
};

export const loc_leaveAComment: Record<Locale, string> = {
	ar: `اترك تعليقا`,
	de: `Hinterlasse einen Kommentar`,
	es: `Deja un comentario`,
	fa: `یک نظر بگذارید`,
	fil: `Mag-iwan ng komento`,
	fr: `Laissez un commentaire`,
	hi: `एक टिप्पणी छोड़ें`,
	ht: `Kite yon kòmantè`,
	it: `Lascia un commento`,
	ja: `コメントを残してください`,
	ko: `댓글을 남겨주세요`,
	mww: `Cia ib saib`,
	ps: `تبصره پرېږدئ`,
	pt: `Deixe um comentário`,
	'pt-pt': `Deixe um comentário`,
	ru: `Оставьте комментарий`,
	sm: `Tu'u se fa'amatalaga`,
	so: `Ka tag faallo`,
	th: `ทิ้งข้อความไว้`,
	ur: `تبصرہ کریں`,
	vi: `Để lại một bình luận`,
	'zh-hans': `欢迎留言`,
	'zh-hant': `歡迎留言`,
	en: `Leave a comment`
};

export const loc_lessTemplates: Record<Locale, string> = {
	ar: `قوالب أقل`,
	de: `Weniger Vorlagen`,
	es: `Menos plantillas`,
	fa: `قالب های کمتر`,
	fil: `Mas kaunting mga template`,
	fr: `Moins de modèles`,
	hi: `कम टेम्पलेट्स`,
	ht: `Mwens modèl`,
	it: `Meno template`,
	ja: `テンプレートを減らす`,
	ko: `템플릿 감소`,
	mww: `Tsawg templates`,
	ps: `کمې قالبونه`,
	pt: `Menos modelos`,
	'pt-pt': `Menos modelos`,
	ru: `Меньше шаблонов`,
	sm: `Itiiti mamanu`,
	so: `Templates yar`,
	th: `เทมเพลตน้อยลง`,
	ur: `کم ٹیمپلیٹس`,
	vi: `Ít mẫu hơn`,
	'zh-hans': `模板减少`,
	'zh-hant': `減少範本`,
	en: `Less templates`
};

export const loc_lightColorblind: Record<Locale, string> = {
	ar: `بروتانوبيا الضوء وديوتيرانوبيا`,
	de: `Lichtprotanopie & Deuteranopie`,
	es: `Protanopía y Deuteranopía Ligera`,
	fa: `پروتانوپیا روشن و دوترانوپیا`,
	fil: `Banayad na Protanopia at Deuteranopia`,
	fr: `Protanopie légère et deutéranopie`,
	hi: `लाइट प्रोटानोपिया और ड्यूटेरानोपिया`,
	ht: `Protanopia limyè & Deuteranopia`,
	it: `Protanopia e Deuteranopia Leggera`,
	ja: `軽いプロタノピアとデュウテラノピア`,
	ko: `라이트 프로타노피아 및 도테라노피아`,
	mww: `Lub teeb Protanopia & Deuteranopia`,
	ps: `رڼا پروتانوپیا او ډیوترانوپیا`,
	pt: `Protanopia e Deuteranopia Leve`,
	'pt-pt': `Protanopia e Deuteranopia Leve`,
	ru: `Лёгкая протанопия и дейтеранопия`,
	sm: `Malamalama Protanopia ma Deuteranopia`,
	so: `Protanopia Fudud & Deuteranopia`,
	th: `โปรตาโนเปียเบา & ดิวเทราโนเปีย`,
	ur: `لائٹ پروٹانوپیا اور ڈیوٹیرانوپیا`,
	vi: `Protanopia nhẹ & Deuteranopia`,
	'zh-hans': `浅色红盲与杜特拉诺皮亚`,
	'zh-hant': `輕度色盲與杜特拉諾皮亞`,
	en: `Light Protanopia & Deuteranopia`
};

export const loc_lightDefault: Record<Locale, string> = {
	ar: `الوضع الافتراضي للضوء`,
	de: `Leichter Standard`,
	es: `Luz predeterminada`,
	fa: `پیش فرض نور`,
	fil: `Banayad na Default`,
	fr: `Lumière par défaut`,
	hi: `लाइट डिफॉल्ट`,
	ht: `Limyè Default`,
	it: `Luce predefinita`,
	ja: `ライトデフォルト`,
	ko: `라이트 디폴트`,
	mww: `Lub Teeb Neej Ntawd`,
	ps: `رڼا ډیفالټ`,
	pt: `Padrão de Luz`,
	'pt-pt': `Padrão de Luz`,
	ru: `Light Default`,
	sm: `Fa'aletonu Malamalama`,
	so: `Light Default`,
	th: `ค่าเริ่มต้นของแสง`,
	ur: `لائٹ ڈیفالٹ`,
	vi: `Mặc định ánh sáng`,
	'zh-hans': `光明默认`,
	'zh-hant': `光照預設`,
	en: `Light Default`
};

export const loc_lightHighContrast: Record<Locale, string> = {
	ar: `الضوء عالي التباين`,
	de: `Lichthoher Kontrast`,
	es: `Luz de alto contraste`,
	fa: `کنتراست نور بالا`,
	fil: `Banayad na Mataas na Pagkakaiba`,
	fr: `Contraste lumineux et élevé`,
	hi: `लाइट हाई कंट्रास्ट`,
	ht: `Limyè Segondè kontras`,
	it: `Luce ad alto contrasto`,
	ja: `光のハイコントラスト`,
	ko: `빛 고대비`,
	mww: `Lub teeb Siab Sib Piv`,
	ps: `سپک لوړ کنټراست`,
	pt: `Luz Alto Contraste`,
	'pt-pt': `Luz de Alto Contraste`,
	ru: `Свет с высоким контрастом`,
	sm: `Malamalama Maualuga Eseesega`,
	so: `Light High Contrast`,
	th: `แสงคอนทราสต์สูง`,
	ur: `لائٹ ہائی کنٹراسٹ`,
	vi: `Độ tương phản cao ánh sáng`,
	'zh-hans': `光高对比`,
	'zh-hant': `光線高對比`,
	en: `Light High Contrast`
};

export const loc_lightTritanopia: Record<Locale, string> = {
	ar: `تريتانوبيا الخفيفة`,
	de: `Leichte Tritanopie`,
	es: `Tritanopia ligera`,
	fa: `لایت تریتانوپیا`,
	fil: `Banayad na Tritanopia`,
	fr: `Tritanopie légère`,
	hi: `लाइट ट्रिटानोपिया`,
	ht: `Limyè Tritanopia`,
	it: `Tritanopia Leggera`,
	ja: `ライトトリタノピア`,
	ko: `라이트 트리타노피아`,
	mww: `Lub teeb Tritanopia`,
	ps: `رڼا ټریټانوپیا`,
	pt: `Tritanopia Leve`,
	'pt-pt': `Tritanopia Leve`,
	ru: `Лёгкая тританопия`,
	sm: `Tritanopia Malamalama`,
	so: `Tritanopia Iftiinka`,
	th: `ไลท์ไทรตาโนเปีย`,
	ur: `لائٹ ٹرائیٹانوپیا`,
	vi: `Tritanopia ánh sáng`,
	'zh-hans': `轻型三叶目`,
	'zh-hant': `輕度三葉目`,
	en: `Light Tritanopia`
};

export const loc_link: Record<Locale, string> = {
	ar: `رابط`,
	de: `Link`,
	es: `Enlace`,
	fa: `لینک`,
	fil: `Link`,
	fr: `Lien`,
	hi: `संपर्क`,
	ht: `Lyen`,
	it: `Link`,
	ja: `リンク`,
	ko: `링크`,
	mww: `Txuas`,
	ps: `لینک`,
	pt: `Link`,
	'pt-pt': `Link`,
	ru: `Ссылка`,
	sm: `Sootaga`,
	so: `Xiriir`,
	th: `ลิงก์`,
	ur: `لنک`,
	vi: `Liên kết`,
	'zh-hans': `链接`,
	'zh-hant': `連結`,
	en: `Link`
};

export const loc_linkAccounts: Record<Locale, string> = {
	ar: `اربط حساباتك`,
	de: `Verknüpfe deine Konten`,
	es: `Vincula tus cuentas`,
	fa: `حساب های خود را لینک کنید`,
	fil: `I-link ang iyong mga account`,
	fr: `Liez vos comptes`,
	hi: `अपने खाते लिंक करें`,
	ht: `Konekte kont ou yo`,
	it: `Collega i tuoi account`,
	ja: `アカウントをリンクしてください`,
	ko: `계좌 연동`,
	mww: `Txuas koj cov nyiaj`,
	ps: `خپل حسابونه وصل کړئ`,
	pt: `Vincule suas contas`,
	'pt-pt': `Liga as tuas contas`,
	ru: `Свяжите свои аккаунты`,
	sm: `Fa'afeso'ota'i au teuga tupe`,
	so: `Isku xir akoonnadaada`,
	th: `ลิงก์บัญชี`,
	ur: `اپنے اکاؤنٹس لنک کریں`,
	vi: `Liên kết tài khoản của bạn`,
	'zh-hans': `关联你的账户`,
	'zh-hant': `連結你的帳號`,
	en: `Link your accounts`
};

export const loc_linkExpired: Record<Locale, string> = {
	ar: `انتهت صلاحية الرابط`,
	de: `Link ist abgelaufen`,
	es: `Enlace expirado`,
	fa: `لینک منقضی شده است`,
	fil: `Nag-expire na ang link`,
	fr: `Lien expiré`,
	hi: `लिंक की समय सीमा समाप्त हो गई`,
	ht: `Link ekspire`,
	it: `Link scaduto`,
	ja: `リンクは期限切れ`,
	ko: `링크 만료`,
	mww: `Txuas tas sij hawm`,
	ps: `لینک ختم شو`,
	pt: `Link expirado`,
	'pt-pt': `Link expirado`,
	ru: `Связь истекла`,
	sm: `Ua mae'a le feso'ota'iga`,
	so: `Xiriirkii wuu dhacay`,
	th: `ลิงก์หมดอายุ`,
	ur: `لنک کی میعاد ختم ہو گئی`,
	vi: `Link hết hạn`,
	'zh-hans': `链接已过期`,
	'zh-hant': `連結已過期`,
	en: `Link expired`
};

export const loc_linkExpiredEnterEmail: Record<Locale, string> = {
	ar: `انتهت صلاحية الرابط. أدخل بريدك الإلكتروني لتصلك رابطا جديدا.`,
	de: `Link ist abgestorben. Geben Sie Ihre E-Mail-Adresse ein, um einen neuen Link zu erhalten.`,
	es: `El enlace caducó. Introduce tu correo electrónico para recibir un nuevo enlace.`,
	fa: `لینک منقضی شد. ایمیل خود را وارد کنید تا لینک جدیدی دریافت کنید.`,
	fil: `Nag-expire na ang link. Ipasok ang iyong email upang makatanggap ng isang bagong link.`,
	fr: `Lien expiré. Saisissez votre adresse e-mail pour recevoir un nouveau lien.`,
	hi: `लिंक की समय सीमा समाप्त हो गई है। नया लिंक प्राप्त करने के लिए अपना ईमेल दर्ज करें।`,
	ht: `Link ekspire Antre imèl ou pou resevwa yon nouvo lyen.`,
	it: `Il collegamento è scaduto. Inserisci la tua email per ricevere un nuovo link.`,
	ja: `リンクは亡くなった。メールアドレスを入力して新しいリンクを受け取ってください。`,
	ko: `링크는 죽었다. 이메일을 입력하면 새 링크를 받아보세요.`,
	mww: `Txuas tas sij hawm. Sau koj tus email kom tau txais qhov txuas tshiab.`,
	ps: `لینک ختم شو. خپل ایمیل داخل کړئ ترڅو نوی لینک ترلاسه کړئ.`,
	pt: `Link expirou. Digite seu e-mail para receber um novo link.`,
	'pt-pt': `O link expirou. Introduza o seu email para receber um novo link.`,
	ru: `Связь истекла. Введите свой email, чтобы получить новую ссылку.`,
	sm: `Ua mae'a le feso'ota'iga. Ulufale i lau imeli e maua ai se feso'ota'iga fou.`,
	so: `Xiriirku wuu dhacay. Geli email-kaaga si aad u hesho xiriir cusub.`,
	th: `ลิงก์หมดอายุ ป้อนอีเมลของคุณเพื่อรับลิงก์ใหม่`,
	ur: `لنک کی میعاد ختم ہو گئی۔ نیا لنک حاصل کرنے کے لیے اپنا ای میل درج کریں۔`,
	vi: `Liên kết đã hết hạn. Nhập email của bạn để nhận liên kết mới.`,
	'zh-hans': `林克死去了。输入您的电子邮件即可接收新链接。`,
	'zh-hant': `連結已過世。輸入您的電子郵件即可接收新連結。`,
	en: `Link expired. Enter your email to receive a new link.`
};

export const loc_linkExpiredFormat: Record<Locale, (when: unknown) => TemplateResult> = {
	ar: (when) => html`<span>انتهت صلاحية الرابط ${when}</span>`,
	de: (when) => html`<span>Link ist ${when} abgelaufen</span>`,
	es: (when) => html`<span>El enlace ${when}</span>`,
	fa: (when) => html`<span>لینک ${when} منقضی شد</span>`,
	fil: (when) => html`<span>Nag-expire ang link ${when}</span>`,
	fr: (when) => html`<span>Le lien a ${when}</span>`,
	hi: (when) => html`<span>लिंक की समय सीमा 5 ${when} हो गई</span>`,
	ht: (when) => html`<span>Link ekspire ${when}</span>`,
	it: (when) => html`<span>Il link è ${when}</span>`,
	ja: (when) => html`<span>リンクは${when}期限切れになりました</span>`,
	ko: (when) => html`<span>링크가 ${when} 만료됐어요</span>`,
	mww: (when) => html`<span>Txuas tas sij ${when}</span>`,
	ps: (when) => html`<span>لینک ${when} ختم شو</span>`,
	pt: (when) => html`<span>Link ${when}</span>`,
	'pt-pt': (when) => html`<span>O link ${when}</span>`,
	ru: (when) => html`<span>Ссылка ${when}</span>`,
	sm: (when) => html`<span>Link expired ${when}</span>`,
	so: (when) => html`<span>Xiriirku wuu dhacay ${when}</span>`,
	th: (when) => html`<span>ลิงก์หมดอายุเมื่อ ${when}</span>`,
	ur: (when) => html`<span>لنک ${when} ختم ہو چکا ہے</span>`,
	vi: (when) => html`<span>Link hết hạn ${when}</span>`,
	'zh-hans': (when) => html`<span>链接${when}前过期了</span>`,
	'zh-hant': (when) => html`<span>連結${when}過期了</span>`,
	en: (when) => html`<span>Link expired ${when}</span>`
};

export const loc_loadingEllipses: Record<Locale, string> = {
	ar: `جار التحميل...`,
	de: `Lädt...`,
	es: `Cargando...`,
	fa: `در حال بارگذاری...`,
	fil: `Naglo-load...`,
	fr: `Chargement...`,
	hi: `लोड हो रहा है...`,
	ht: `Chaje ...`,
	it: `Caricamento...`,
	ja: `読み込み中...`,
	ko: `로딩 중...`,
	mww: `Chaw thau khoom...`,
	ps: `بارېږی...`,
	pt: `Carregando...`,
	'pt-pt': `A carregar...`,
	ru: `Загрузка...`,
	sm: `Utaina ...`,
	so: `Soo ridaya...`,
	th: `กําลังโหลด...`,
	ur: `لوڈ ہو رہا ہے...`,
	vi: `Đang tải...`,
	'zh-hans': `加载中......`,
	'zh-hant': `載入中......`,
	en: `Loading...`
};

export const loc_loadMoreEllipses: Record<Locale, string> = {
	ar: `حمل المزيد...`,
	de: `Mehr laden...`,
	es: `Carga más...`,
	fa: `بیشتر بارگذاری کن...`,
	fil: `Mag-load ng higit pa ...`,
	fr: `Chargez plus...`,
	hi: `अधिक लोड करें...`,
	ht: `Chaje plis...`,
	it: `Carica ancora...`,
	ja: `もっと読み込んで...`,
	ko: `더 불러와...`,
	mww: `Load ntxiv...`,
	ps: `نور بار کړه...`,
	pt: `Carregue mais...`,
	'pt-pt': `Carrega mais...`,
	ru: `Загрузить ещё...`,
	sm: `Uta atili ...`,
	so: `Rar dheeraad ah...`,
	th: `โหลดเพิ่มเติม...`,
	ur: `مزید لوڈ کرو...`,
	vi: `Tải thêm...`,
	'zh-hans': `加载更多......`,
	'zh-hant': `繼續載入......`,
	en: `Load more...`
};

export const loc_location: Record<Locale, string> = {
	ar: `الموقع`,
	de: `Lage`,
	es: `Ubicación`,
	fa: `موقعیت`,
	fil: `Lokasyon`,
	fr: `Emplacement`,
	hi: `स्थान`,
	ht: `Kote yo ye`,
	it: `Posizione`,
	ja: `所在地`,
	ko: `위치`,
	mww: `Qhov chaw nyob`,
	ps: `موقعیت`,
	pt: `Localização`,
	'pt-pt': `Localização`,
	ru: `Расположение`,
	sm: `Nofoaga`,
	so: `Goobta`,
	th: `ที่ตั้ง`,
	ur: `مقام`,
	vi: `Địa điểm`,
	'zh-hans': `位置`,
	'zh-hant': `地理位置`,
	en: `Location`
};

export const loc_locationRequiredForDistance: Record<Locale, string> = {
	ar: `أدخل موقعا لتصفية أو فرز الأحداث حسب المسافة.`,
	de: `Geben Sie einen Ort ein, um Ereignisse nach Entfernung zu filtern oder zu sortieren.`,
	es: `Introduce una ubicación para filtrar o ordenar los eventos por distancia.`,
	fa: `یک مکان را وارد کنید تا رویدادها را بر اساس فاصله فیلتر یا مرتب کنید.`,
	fil: `Maglagay ng lokasyon para i-filter o ayusin ang mga event ayon sa distansya.`,
	fr: `Saisissez un lieu pour filtrer ou trier les événements par distance.`,
	hi: `दूरी के आधार पर ईवेंट को फ़िल्टर करने या सॉर्ट करने के लिए कोई स्थान डालें.`,
	ht: `Antre nan yon kote pou filtre oswa sòt evènman pa distans`,
	it: `Inserisci una posizione per filtrare o ordinare gli eventi per distanza.`,
	ja: `場所を入力して、イベントを距離で絞り込みやソートしてください。`,
	ko: `위치를 입력하면 이벤트를 거리별로 필터링하거나 정렬하세요.`,
	mww: `Sau ib qho chaw kom lim lossis txiav txim cov xwm txheej raws li deb.`,
	ps: `یو ځای داخل کړئ ترڅو پیښې د واټن له مخې فلټر یا ترتیب شی.`,
	pt: `Insira um local para filtrar ou ordenar eventos por distância.`,
	'pt-pt': `Insira um local para filtrar ou ordenar eventos por distância.`,
	ru: `Введите место, чтобы фильтровать или сортировать события по расстоянию.`,
	sm: `Ulu atu i se nofoaga e faamama pe faavasega ai mea na tutupu i le mamao.`,
	so: `Geli goob si aad u shaandheyso ama u kala saarto dhacdooyinka masaafada.`,
	th: `กรอกตําแหน่งเพื่อกรองหรือจัดเรียงเหตุการณ์ตามระยะทาง`,
	ur: `فاصلے کے لحاظ سے واقعات کو فلٹر یا ترتیب دینے کے لیے کوئی مقام درج کریں۔`,
	vi: `Nhập vị trí để lọc hoặc sắp xếp sự kiện theo khoảng cách.`,
	'zh-hans': `输入地点以筛选或排序事件的距离。`,
	'zh-hant': `輸入地點以篩選或排序事件距離。`,
	en: `Enter a location to filter or sort events by distance.`
};

export const loc_locationSearchDescription: Record<Locale, string> = {
	ar: `ابحث عن عنوان، مدينة، ولاية، رمز بريد أو استخدم موقعك الحالي.`,
	de: `Suchen Sie nach einer Adresse, Stadt, Bundesstaat, Postleitzahl oder verwenden Sie Ihren aktuellen Standort.`,
	es: `Busca una dirección, ciudad, estado, código postal o utiliza tu ubicación actual.`,
	fa: `به دنبال آدرس، شهر، ایالت، کد پستی یا استفاده از موقعیت فعلی خود بگردید.`,
	fil: `Maghanap para sa isang address, lungsod, estado, zip o gamitin ang iyong kasalukuyang lokasyon.`,
	fr: `Recherchez une adresse, une ville, un État, un code postal ou utilisez votre localisation actuelle.`,
	hi: `पता, शहर, राज्य, ज़िप खोजें या अपने वर्तमान स्थान का उपयोग करें।`,
	ht: `Rechèch pou yon adrès, vil, eta, postal oswa sèvi ak kote ou ye kounye a.`,
	it: `Cerca un indirizzo, città, stato, codice postale o usa la tua posizione attuale.`,
	ja: `住所、市、州、郵便番号、または現在の所在地を検索してください。`,
	ko: `주소, 도시, 주, 우편번호를 검색하거나 현재 위치를 사용하세요.`,
	mww: `Nrhiav chaw nyob, nroog, xeev, zip lossis siv koj qhov chaw nyob tam sim no.`,
	ps: `د پته، ښار، ایالت، زپ یا خپل اوسنی ځای وپلټئ.`,
	pt: `Procure por endereço, cidade, estado, código postal ou use sua localização atual.`,
	'pt-pt': `Procure morada, cidade, estado, código postal ou use a sua localização atual.`,
	ru: `Найдите адрес, город, штат, индекс или используйте своё текущее местоположение.`,
	sm: `Saili mo se tuatusi, taulaga, setete, zip pe fa'aaoga lou nofoaga o lo'o i ai nei.`,
	so: `Raadi cinwaan, magaalo, gobol, zip ama isticmaal goobtaada hadda.`,
	th: `ค้นหาที่อยู่ เมือง รัฐ ซิป หรือใช้ตําแหน่งปัจจุบันของคุณ`,
	ur: `کسی پتہ، شہر، ریاست، زپ (zip) تلاش کریں یا اپنی موجودہ جگہ استعمال کریں۔`,
	vi: `Tìm kiếm địa chỉ, thành phố, tiểu bang, zip hoặc sử dụng vị trí hiện tại của bạn.`,
	'zh-hans': `搜索地址、城市、州、邮编或使用您当前所在的位置。`,
	'zh-hant': `搜尋地址、城市、州、郵遞區號或使用您目前所在的位置。`,
	en: `Search for an address, city, state, zip or use your current location.`
};

export const loc_log: Record<Locale, string> = {
	ar: `سجل`,
	de: `Log`,
	es: `Registro`,
	fa: `گزارش`,
	fil: `Email Address *`,
	fr: `Journal`,
	hi: `लट्ठा`,
	ht: `Boutèy demi lit`,
	it: `Log`,
	ja: `ログ`,
	ko: `로그`,
	mww: `cav`,
	ps: `لاګ`,
	pt: `Registro`,
	'pt-pt': `Log`,
	ru: `Бревно`,
	sm: `Ogalaau`,
	so: `Diiwaanka`,
	th: `บันทึก`,
	ur: `لاگ`,
	vi: `Nhật ký`,
	'zh-hans': `日志`,
	'zh-hant': `日誌`,
	en: `Log`
};

export const loc_loginDescription: Record<Locale, string> = {
	ar: `يستخدمها زملاؤك لذكرك في التعليقات. الحروف، الأرقام، والشرطات فقط.`,
	de: `Wird von Teamkollegen verwendet, um dich in den Kommentaren zu erwähnen. Nur Buchstaben, Zahlen und Bindestriche.`,
	es: `Usado por compañeros para mencionarte en los comentarios. Solo letras, números y guiones.`,
	fa: `توسط هم تیمی ها برای اشاره به شما در کامنت ها استفاده می شود. فقط حروف، اعداد و خط تیره ها.`,
	fil: `Ginamit ng mga kasamahan sa koponan para banggitin ka sa mga komento. Mga titik, numero, at hyphens lamang.`,
	fr: `Utilisé par mes coéquipiers pour te mentionner dans les commentaires. Lettres, chiffres et traits d’union uniquement.`,
	hi: `टीम के साथियों द्वारा आपका उल्लेख करने के लिए उपयोग किया जाता है टिप्पणियाँ. केवल अक्षर, संख्याएँ और हाइफ़न।`,
	ht: `Itilize pa koekipye mansyone ou nan kòmantè. Lèt, nimewo, ak tirè sèlman.`,
	it: `Usato dai compagni di squadra per menzionarti nei commenti. Solo lettere, numeri e trattini.`,
	ja: `チームメイトがコメントであなたを紹介するために使っています。文字、数字、ハイフンのみ。`,
	ko: `팀원들이 댓글에서 당신을 언급할 때 사용했습니다. 오직 문자, 숫자, 하이픈만.`,
	mww: `Siv los ntawm teammates los hais txog koj hauv cov lus. Cov tsiaj ntawv, cov zauv thiab cov zauv xwb.`,
	ps: `د ټیم ملګرو لخوا د تبصرو لپاره کارول شوی. یوازې حروف، شمېرې، او هایفنونه.`,
	pt: `Usado pelos colegas de equipe para te mencionar nos comentários. Apenas letras, números e hífens.`,
	'pt-pt': `Usado pelos colegas de equipa para te mencionar nos comentários. Apenas letras, números e hífens.`,
	ru: `Его используют товарищи по команде, чтобы упоминать тебя в комментариях. Только буквы, цифры и дефисы.`,
	sm: `Fa'aaogaina e le 'au e ta'u atu ai oe i fa'amatalaga. Na'o mataitusi, fuainumera, ma vase fa'apitoa.`,
	so: `Xubnaha kooxda ayaa u isticmaalay inay ku xusaan faallooyinka. Xarfo, lambarrada, iyo xarfaha kala duwan oo kaliya.`,
	th: `เพื่อนร่วมทีมใช้เพื่อกล่าวถึงคุณในความคิดเห็น ตัวอักษร ตัวเลข และยัติภังค์เท่านั้น`,
	ur: `ٹیم کے ساتھی کمنٹس میں آپ کا ذکر کرنے کے لیے استعمال کرتے ہیں۔ صرف حروف، اعداد اور ہائفنز کے لیے۔`,
	vi: `Được đồng đội sử dụng để nhắc đến bạn trong bình luận. Chỉ chữ cái, số và dấu gạch nối.`,
	'zh-hans': `队友们用来在评论里提到你。仅限字母、数字和连字符。`,
	'zh-hant': `隊友用來在留言中提到你。只允許字母、數字和連字號。`,
	en: `Used by teammates to mention you in comments. Letters, numbers, and hyphens only.`
};

export const loc_mailing: Record<Locale, string> = {
	ar: `البريد`,
	de: `Versand`,
	es: `Envío postal`,
	fa: `ارسال پستی`,
	fil: `Email Address *`,
	fr: `Envoi postal`,
	hi: `मेलिंग`,
	ht: `Voye pa lapòs`,
	it: `Spedizione postale`,
	ja: `郵送`,
	ko: `우편 발송`,
	mww: `Kev Xa Ntawv`,
	ps: `میل کول`,
	pt: `Envio por correspondência`,
	'pt-pt': `Envio postal`,
	ru: `Рассылка`,
	sm: `Meli`,
	so: `Boostada`,
	th: `การส่งจดหมาย`,
	ur: `ڈاک`,
	vi: `Gửi thư`,
	'zh-hans': `邮寄`,
	'zh-hant': `郵寄`,
	en: `Mailing`
};

export const loc_makeACopy: Record<Locale, string> = {
	ar: `اصنع نسخة`,
	de: `Mach eine Kopie`,
	es: `Haz una copia`,
	fa: `یک کپی تهیه کنید`,
	fil: `Gumawa ng kopya`,
	fr: `Faites-en une copie`,
	hi: `एक प्रतिलिपि बनाएँ`,
	ht: `Fè yon kopi`,
	it: `Fai una copia`,
	ja: `コピーを作って`,
	ko: `복사해`,
	mww: `theej`,
	ps: `یوه کاپی جوړ کړه`,
	pt: `Faça uma cópia`,
	'pt-pt': `Faz uma cópia`,
	ru: `Сделай копию`,
	sm: `Fai se kopi`,
	so: `Samee nuqul`,
	th: `ทําสําเนา`,
	ur: `ایک نقل بنائیں`,
	vi: `Tạo một bản sao`,
	'zh-hans': `复印一份`,
	'zh-hant': `複製一份`,
	en: `Make a copy`
};

export const loc_makeDefaultSignature: Record<Locale, string> = {
	ar: `اجعل هذا توقيعي الافتراضي`,
	de: `Mach das zu meiner Standardsignatur`,
	es: `Haz de esta mi firma por defecto`,
	fa: `این را امضای پیش فرض من قرار دهید`,
	fil: `Gawin itong default na lagda ko`,
	fr: `Faites de ceci ma signature par défaut`,
	hi: `इसे मेरा डिफ़ॉल्ट हस्ताक्षर बनाएं`,
	ht: `Fè sa a siyati default mwen an`,
	it: `Fai in modo che questa sia la mia firma predefinita`,
	ja: `これをデフォルトの署名にしてください`,
	ko: `이걸 내 기본 서명으로 만들어`,
	mww: `Ua qhov no kuv lub neej ntawd kos npe`,
	ps: `دا زما اصلی لاسلیک کړه`,
	pt: `Faça disso minha assinatura padrão`,
	'pt-pt': `Faz desta a minha assinatura padrão`,
	ru: `Сделайте это своей подписью по умолчанию`,
	sm: `Fai lenei mea o la'u saini faaletonu`,
	so: `Ka dhig tan saxiixa aan leeyahay`,
	th: `ทําให้ลายเซ็นนี้เป็นลายเซ็นเริ่มต้นของฉัน`,
	ur: `اسے میرا ڈیفالٹ دستخط بنائیں`,
	vi: `Đặt đây là chữ ký mặc định của tôi`,
	'zh-hans': `把它设为默认签名`,
	'zh-hant': `把這個設為我的預設簽名`,
	en: `Make this my default signature`
};

export const loc_manualOtpEnrollInstructions: Record<Locale, string> = {
	ar: `أدخل الرمز التالي يدويا في تطبيق المصادقة المفضل لديك ثم أدخل الرمز المؤقت المرفق أدناه.`,
	de: `Geben Sie den folgenden Code manuell in Ihre bevorzugte Authenticator-App ein und geben Sie dann den unten angegebenen Einmalcode ein.`,
	es: `Introduce manualmente el siguiente código en tu aplicación de autenticación preferida y luego introduce el código único proporcionado a continuación.`,
	fa: `کد زیر را به صورت دستی در اپلیکیشن احراز هویت مورد علاقه خود وارد کنید و سپس کد یک بار مصرف ارائه شده را در زیر وارد کنید.`,
	fil: `Manu-manong ipasok ang sumusunod na code sa iyong ginustong authenticator app at pagkatapos ay ipasok ang ibinigay na one-time code sa ibaba.`,
	fr: `Saisissez manuellement le code suivant dans votre application d’authentification préférée, puis saisissez le code à usage unique fourni ci-dessous.`,
	hi: `अपने पसंदीदा प्रमाणक ऐप में मैन्युअल रूप से निम्न कोड दर्ज करें और फिर नीचे दिए गए वन-टाइम कोड को दर्ज करें।`,
	ht: `Manyèlman antre kòd sa yo nan app otantifikatè ou pi pito ak Lè sa a, antre nan kòd la bay yon sèl-fwa anba a.`,
	it: `Inserisci manualmente il seguente codice nell'app autenticatrice preferita e poi inserisci il codice monouso fornito qui sotto.`,
	ja: `以下のコードを手動でお好みの認証アプリに入力し、下記の一度限りのコードを入力してください。`,
	ko: `다음 코드를 직접 원하는 인증 앱에 입력한 후, 아래에 제공된 일회용 코드를 입력하세요.`,
	mww: `Manually sau cov cai hauv qab no rau hauv koj nyiam authenticator app thiab tom qab ntawd nkag mus rau tus lej ib-zaug hauv qab no.`,
	ps: `لاندې کوډ په لاسی ډول خپل خوښ شوی تصدیق کوونکی اپلیکیشن ته داخل کړئ او بیا لاندې ورکړل شوی یو ځل کوډ داخل کړئ.`,
	pt: `Insira manualmente o código a seguir no seu aplicativo autenticador preferido e então insira o código único fornecido abaixo.`,
	'pt-pt': `Introduza manualmente o seguinte código na sua aplicação de autenticação preferida e depois introduza o código único fornecido abaixo.`,
	ru: `Вручную введите следующий код в выбранное приложение аутентификации, а затем введите предоставленный единовременный код ниже.`,
	sm: `Ulufale lima i le code lenei i lau authenticator app e te fiafia i ai ona ulu atu lea i le code e tasi le taimi o loo i lalo.`,
	so: `Si gacanta ah ugu geli koodhka soo socda app-ka authenticator-ka aad doorbideyso, kadibna geli koodhka hal mar ee hoos ku xusan.`,
	th: `ป้อนรหัสต่อไปนี้ลงในแอปยืนยันตัวตนที่คุณต้องการด้วยตนเอง จากนั้นป้อนรหัสแบบใช้ครั้งเดียวที่ให้ไว้ด้านล่าง`,
	ur: `اپنی پسندیدہ آتھنٹی کیٹر ایپ میں درج ذیل کوڈ دستی طور پر درج کریں اور پھر نیچے دیا گیا ون ٹائم کوڈ درج کریں۔`,
	vi: `Nhập thủ công mã sau vào ứng dụng xác thực ưa thích của bạn, sau đó nhập mã dùng một lần được cung cấp bên dưới.`,
	'zh-hans': `手动将以下验证码输入您偏好的认证应用，然后输入下方提供的一次性验证码。`,
	'zh-hant': `請手動輸入以下驗證碼到您偏好的驗證應用程式，然後輸入下方提供的一次性驗證碼。`,
	en: `Manually enter the following code into your preferred authenticator app and then enter the provided one-time code below.`
};

export const loc_maritalStatus: Record<Locale, string> = {
	ar: `الحالة الاجتماعية`,
	de: `Familienstand`,
	es: `Estado civil`,
	fa: `وضعیت تأهل`,
	fil: `Katayuan sa pag-aasawa`,
	fr: `État civil`,
	hi: `वैवाहिक स्थिति`,
	ht: `Sitiyasyon sivil la`,
	it: `Stato civile`,
	ja: `婚姻状況`,
	ko: `결혼 상태`,
	mww: `Xwm txheej txij nkawm`,
	ps: `واده شوی حالت`,
	pt: `Estado civil`,
	'pt-pt': `Estado civil`,
	ru: `Семейное положение`,
	sm: `Tulaga fa'aipoipo`,
	so: `Xaaladda guurka`,
	th: `สถานภาพสมรส`,
	ur: `ازدواجی حیثیت`,
	vi: `Tình trạng hôn nhân`,
	'zh-hans': `婚姻状况`,
	'zh-hant': `婚姻狀況`,
	en: `Marital status`
};

export const loc_markdown: Record<Locale, string> = {
	ar: `ماركداون`,
	de: `Markdown`,
	es: `Descuento`,
	fa: `مارک داون`,
	fil: `Markdown`,
	fr: `Markdown`,
	hi: `मार्कडाउन`,
	ht: `Markdown`,
	it: `Sconto`,
	ja: `割引`,
	ko: `할인`,
	mww: `Markdown`,
	ps: `مارک ډاون`,
	pt: `Markdown`,
	'pt-pt': `Markdown`,
	ru: `Markdown`,
	sm: `Markdown`,
	so: `Qiimo dhimis`,
	th: `มาร์กดาวน์`,
	ur: `مارک ڈاؤن`,
	vi: `Đánh dấu`,
	'zh-hans': `折扣`,
	'zh-hant': `折扣`,
	en: `Markdown`
};

export const loc_matches: Record<Locale, string> = {
	ar: `المباريات`,
	de: `Spiele`,
	es: `Partidos`,
	fa: `مسابقات`,
	fil: `Mga Tugma`,
	fr: `Matchs`,
	hi: `मैच`,
	ht: `Alimèt yo`,
	it: `Partite`,
	ja: `試合`,
	ko: `경기`,
	mww: `Cov ntais ntawv`,
	ps: `سیالۍ`,
	pt: `Partidas`,
	'pt-pt': `Jogos`,
	ru: `Матчи`,
	sm: `Ta'aloga`,
	so: `Kulamada`,
	th: `แมตช์`,
	ur: `میچز`,
	vi: `Các trận đấu`,
	'zh-hans': `比赛`,
	'zh-hant': `比賽`,
	en: `Matches`
};

export const loc_mbi: Record<Locale, string> = {
	ar: `MBI`,
	de: `MBI`,
	es: `MBI`,
	fa: `MBI`,
	fil: `MBI`,
	fr: `MBI`,
	hi: `एमबीआई`,
	ht: `MBI`,
	it: `MBI`,
	ja: `MBI`,
	ko: `MBI`,
	mww: `MBI`,
	ps: `MBI`,
	pt: `MBI`,
	'pt-pt': `MBI`,
	ru: `MBI`,
	sm: `MBI`,
	so: `MBI`,
	th: `MBI`,
	ur: `ایم بی آئی`,
	vi: `MBI`,
	'zh-hans': `MBI`,
	'zh-hant': `MBI`,
	en: `MBI`
};

export const loc_medicaid: Record<Locale, string> = {
	ar: `ميديكيد`,
	de: `Medicaid`,
	es: `Medicaid`,
	fa: `مدیکید`,
	fil: `Medicaid`,
	fr: `Medicaid`,
	hi: `मेडिकेड`,
	ht: `Medicaid`,
	it: `Medicaid`,
	ja: `メディケイド`,
	ko: `메디케이드`,
	mww: `Medicaid`,
	ps: `میډیکېډ`,
	pt: `Medicaid`,
	'pt-pt': `Medicaid`,
	ru: `Medicaid`,
	sm: `Medicaid`,
	so: `Medicaid`,
	th: `เมดิเคด`,
	ur: `میڈیکیڈ`,
	vi: `Medicaid`,
	'zh-hans': `医疗补助`,
	'zh-hant': `醫療補助`,
	en: `Medicaid`
};

export const loc_medicaidID: Record<Locale, string> = {
	ar: `معرف ميديكيد`,
	de: `Medicaid-ID`,
	es: `Identificación de Medicaid`,
	fa: `شناسه مدیکید`,
	fil: `Medicaid ID`,
	fr: `Identifiant Medicaid`,
	hi: `मेडिकेड आईडी`,
	ht: `Medicaid ID`,
	it: `Medicaid ID`,
	ja: `メディケイドID`,
	ko: `메디케이드 신분증`,
	mww: `Medicaid ID`,
	ps: `د میډیکېډ ID`,
	pt: `Identificação do Medicaid`,
	'pt-pt': `Medicaid ID`,
	ru: `Medicaid ID`,
	sm: `Medicaid ID`,
	so: `Aqoonsiga Medicaid`,
	th: `รหัส Medicaid`,
	ur: `میڈیکیڈ آئی ڈی`,
	vi: `Medicaid ID`,
	'zh-hans': `医疗补助身份证`,
	'zh-hant': `醫療補助識別碼`,
	en: `Medicaid ID`
};

export const loc_medicareBeneficiaryId: Record<Locale, string> = {
	ar: `معرف المستفيد من ميديكير (MBI)`,
	de: `Medicare-Begünstigten-ID (MBI)`,
	es: `Identificador de Beneficiario de Medicare (MBI)`,
	fa: `شناسه ذینفع مدیکر (MBI)`,
	fil: `Medicare Beneficiary ID (MBI)`,
	fr: `Identifiant de bénéficiaire Medicare (MBI)`,
	hi: `मेडिकेयर लाभार्थी आईडी (एमबीआई)`,
	ht: `ID Benefisyè Medicare (MBI)`,
	it: `Identificazione Beneficiario Medicare (MBI)`,
	ja: `メディケア受取人識別番号(MBI)`,
	ko: `메디케어 수혜자 식별 번호(MBI)`,
	mww: `Medicare Beneficiary ID (MBI)`,
	ps: `د میډکېر ګټه اخیستونکی ID (MBI)`,
	pt: `Identificação de Beneficiário do Medicare (MBI)`,
	'pt-pt': `ID de Beneficiário do Medicare (MBI)`,
	ru: `Удостоверение личности бенефициара по Medicare (MBI)`,
	sm: `Medicare Beneficiary ID (MBI)`,
	so: `Aqoonsiga Faa'iidada Medicare (MBI)`,
	th: `บัตรประจําตัวผู้รับผลประโยชน์ Medicare (MBI)`,
	ur: `میڈیکیئر بینیفشری آئی ڈی (MBI)`,
	vi: `Mã số Người thụ hưởng Medicare (MBI)`,
	'zh-hans': `医疗保险受益人身份识别码（MBI）`,
	'zh-hant': `醫療保險受益人識別碼（MBI）`,
	en: `Medicare Beneficiary ID (MBI)`
};

export const loc_medication: Record<Locale, string> = {
	ar: `الأدوية`,
	de: `Medikamente`,
	es: `Medicación`,
	fa: `دارو`,
	fil: `Gamot`,
	fr: `Médication`,
	hi: `इलाज`,
	ht: `Medikaman`,
	it: `Farmaci`,
	ja: `薬物治療`,
	ko: `약물 치료`,
	mww: `tshuaj`,
	ps: `درمل`,
	pt: `Medicação`,
	'pt-pt': `Medicação`,
	ru: `Медикаменты`,
	sm: `Vaila'au`,
	so: `Daawo`,
	th: `ยา`,
	ur: `ادویات`,
	vi: `Thuốc`,
	'zh-hans': `用药`,
	'zh-hant': `藥物治療`,
	en: `Medication`
};

export const loc_medicationInteractions: Record<Locale, string> = {
	ar: `تفاعلات الأدوية`,
	de: `Medikamentenwechselwirkungen`,
	es: `Interacciones con medicamentos`,
	fa: `تداخلات دارویی`,
	fil: `Mga pakikipag-ugnayan sa gamot`,
	fr: `Interactions médicamenteuses`,
	hi: `दवा इंटरैक्शन`,
	ht: `Dwòg entèraksyon`,
	it: `Interazioni farmacologiche`,
	ja: `薬物相互作用`,
	ko: `약물 상호작용`,
	mww: `Kev sib cuam tshuam tshuaj`,
	ps: `د درملو تعاملات`,
	pt: `Interações com medicamentos`,
	'pt-pt': `Interações com medicação`,
	ru: `Взаимодействие лекарств`,
	sm: `Fegalegaleaiga o vaila'au`,
	so: `Is-dhexgalka daawooyinka`,
	th: `ปฏิสัมพันธ์ของยา`,
	ur: `ادویات کے تعاملات`,
	vi: `Tương tác thuốc`,
	'zh-hans': `药物相互作用`,
	'zh-hant': `藥物交互作用`,
	en: `Medication interactions`
};

export const loc_medicationInteractionsZeroState: Record<Locale, string> = {
	ar: `لم يتم العثور على أي تداخلات دوائية`,
	de: `Keine Medikamentenwechselwirkungen gefunden`,
	es: `No se encontraron interacciones con medicación`,
	fa: `هیچ تداخل دارویی یافت نشد`,
	fil: `Walang natagpuang pakikipag-ugnayan sa gamot`,
	fr: `Aucune interaction médicamenteuse n’a été trouvée`,
	hi: `कोई दवा इंटरैक्शन नहीं मिला`,
	ht: `Pa gen entèraksyon medikaman yo te jwenn`,
	it: `Nessuna interazione farmacologica riscontrata`,
	ja: `薬剤の相互作用は見つかりませんでした`,
	ko: `약물 상호작용은 발견되지 않았습니다`,
	mww: `Tsis muaj kev sib cuam tshuam nrog tshuaj pom`,
	ps: `د درملو تداخلات ونه موندل شول`,
	pt: `Nenhuma interação com medicamentos foi encontrada`,
	'pt-pt': `Não foram encontradas interações com medicação`,
	ru: `Взаимодействия лекарств не обнаружено`,
	sm: `Leai ni fegalegaleaiga o vailaau na maua`,
	so: `Wax is-dhexgal daawo ah lama helin`,
	th: `ไม่พบปฏิกิริยาระหว่างยา`,
	ur: `کوئی دوا کے ساتھ تعامل نہیں ملا`,
	vi: `Không tìm thấy tương tác thuốc`,
	'zh-hans': `未发现药物相互作用`,
	'zh-hant': `沒有發現藥物交互作用`,
	en: `No medication interactions found`
};

export const loc_medicationNameStrengthRouteForm: Record<Locale, string> = {
	ar: `الاسم، القوة، المسار، الشكل`,
	de: `Name, Stärke, Route, Form`,
	es: `Nombre, fuerza, ruta, forma`,
	fa: `نام، قدرت، مسیر، فرم`,
	fil: `Pangalan, lakas, ruta, anyo`,
	fr: `Nom, force, itinéraire, forme`,
	hi: `नाम, शक्ति, मार्ग, रूप`,
	ht: `Non, fòs, wout, fòm`,
	it: `Nome, forza, percorso, forma`,
	ja: `名前、強さ、ルート、形式`,
	ko: `이름, 힘, 경로, 형태`,
	mww: `Lub npe, lub zog, txoj kev, daim ntawv`,
	ps: `نوم، ځواک، لاره، بڼه`,
	pt: `Nome, força, rota, forma`,
	'pt-pt': `Nome, força, rota, forma`,
	ru: `Имя, сила, маршрут, форма`,
	sm: `Igoa, malosi, auala, fomu`,
	so: `Magaca, xoogga, jidka, qaabka`,
	th: `ชื่อ ความแข็งแรง เส้นทาง แบบฟอร์ม`,
	ur: `نام، طاقت، راستہ، شکل`,
	vi: `Tên, sức mạnh, tuyến đường, hình thức`,
	'zh-hans': `名称、力量、路线、形态`,
	'zh-hant': `名稱、力量、路線、形態`,
	en: `Name, strength, route, form`
};

export const loc_medications: Record<Locale, string> = {
	ar: `الأدوية`,
	de: `Medikamente`,
	es: `Medicamentos`,
	fa: `داروها`,
	fil: `Mga gamot`,
	fr: `Médicaments`,
	hi: `दवाओं`,
	ht: `Medikaman yo`,
	it: `Farmaci`,
	ja: `薬剤`,
	ko: `약물`,
	mww: `Tshuaj`,
	ps: `درمل`,
	pt: `Medicamentos`,
	'pt-pt': `Medicamentos`,
	ru: `Медикаменты`,
	sm: `Vaila'au`,
	so: `Daawooyinka`,
	th: `ยา`,
	ur: `ادویات`,
	vi: `Thuốc`,
	'zh-hans': `药物`,
	'zh-hant': `藥物`,
	en: `Medications`
};

export const loc_medicationsDocs: Record<Locale, string> = {
	ar: `أطباء الأدوية`,
	de: `Medikamenten-Ärzte`,
	es: `Médicos de medicamentos`,
	fa: `پزشکان داروها`,
	fil: `Mga Gamot Docs`,
	fr: `Médecins médicamentaires`,
	hi: `दवाएं डॉक्स`,
	ht: `Medikaman Docs`,
	it: `Medici medici`,
	ja: `薬の医師`,
	ko: `약물 의사`,
	mww: `Cov tshuaj docs`,
	ps: `د درملو ډاکټران`,
	pt: `Médicos de medicamentos`,
	'pt-pt': `Médicos de medicação`,
	ru: `Врачи по медикаментам`,
	sm: `Vaila'au Docs`,
	so: `Daawooyinka dukumentiyada`,
	th: `เอกสารยา`,
	ur: `ادویات کے ڈاکٹرز`,
	vi: `Tài liệu thuốc`,
	'zh-hans': `药物医生`,
	'zh-hant': `藥物醫師`,
	en: `Medications docs`
};

export const loc_medicationsZeroState: Record<Locale, string> = {
	ar: `لا توجد أدوية`,
	de: `Es gibt keine Medikamente`,
	es: `No hay medicamentos`,
	fa: `هیچ دارویی وجود ندارد`,
	fil: `Walang gamot`,
	fr: `Il n’y a pas de médicaments`,
	hi: `कोई दवा नहीं है`,
	ht: `Pa gen medikaman`,
	it: `Non ci sono farmaci`,
	ja: `薬は使われていません`,
	ko: `약은 없습니다`,
	mww: `Tsis muaj tshuaj`,
	ps: `هیڅ درمل نشته`,
	pt: `Não existem medicamentos`,
	'pt-pt': `Não existem medicamentos`,
	ru: `Нет никаких лекарств`,
	sm: `E leai ni vaila'au`,
	so: `Daawo ma jiraan`,
	th: `ไม่มียา`,
	ur: `کوئی دوا نہیں ہے`,
	vi: `Không có thuốc`,
	'zh-hans': `没有药物`,
	'zh-hant': `沒有藥物`,
	en: `There are no medications`
};

export const loc_meetingId: Record<Locale, string> = {
	ar: `معرف الاجتماع`,
	de: `Meeting-ID`,
	es: `ID de la reunión`,
	fa: `شناسه جلسه`,
	fil: `Meeting ID`,
	fr: `ID de réunion`,
	hi: `मीटिंग आईडी`,
	ht: `ID reyinyon an`,
	it: `ID riunione`,
	ja: `ミーティングID`,
	ko: `회의 ID`,
	mww: `Kev Sib Tham ID`,
	ps: `د غونډې ID`,
	pt: `ID da Reunião`,
	'pt-pt': `ID da Reunião`,
	ru: `Идентификатор встречи`,
	sm: `ID o le fonotaga`,
	so: `Aqoonsiga Kulanka`,
	th: `รหัสการประชุม`,
	ur: `میٹنگ آئی ڈی`,
	vi: `ID cuộc họp`,
	'zh-hans': `会议编号`,
	'zh-hant': `會議編號`,
	en: `Meeting ID`
};

export const loc_meetingInformation: Record<Locale, string> = {
	ar: `معلومات الاجتماع`,
	de: `Meetinginformationen`,
	es: `Información de la reunión`,
	fa: `اطلاعات جلسه`,
	fil: `Impormasyon tungkol sa pagpupulong`,
	fr: `Informations sur les réunions`,
	hi: `बैठक की जानकारी`,
	ht: `Reyinyon enfòmasyon`,
	it: `Informazioni sulla riunione`,
	ja: `会議情報`,
	ko: `회의 정보`,
	mww: `Cov ntaub ntawv sib tham`,
	ps: `د غونډې معلومات`,
	pt: `Informações sobre a reunião`,
	'pt-pt': `Informações sobre a reunião`,
	ru: `Информация о встрече`,
	sm: `Faamatalaga o le fonotaga`,
	so: `Macluumaadka shirarka`,
	th: `ข้อมูลการประชุม`,
	ur: `میٹنگ کی معلومات`,
	vi: `Thông tin về cuộc họp`,
	'zh-hans': `会议信息`,
	'zh-hant': `會議資訊`,
	en: `Meeting information`
};

export const loc_meetingLink: Record<Locale, string> = {
	ar: `رابط الاجتماع`,
	de: `Treffenverbindung`,
	es: `Enlace de encuentro`,
	fa: `لینک جلسه`,
	fil: `Link ng pagpupulong`,
	fr: `Lien de rencontre`,
	hi: `मीटिंग लिंक`,
	ht: `Reyinyon lyen`,
	it: `Collegamento dell'incontro`,
	ja: `会議リンク`,
	ko: `회의 링크`,
	mww: `Kev txuas sib tham`,
	ps: `د غونډې لینک`,
	pt: `Link de encontro`,
	'pt-pt': `Link de encontro`,
	ru: `Ссылка на встречу`,
	sm: `Feso'ota'iga o le fonotaga`,
	so: `Xiriirka kulanka`,
	th: `ลิงก์การประชุม`,
	ur: `میٹنگ لنک`,
	vi: `Liên kết cuộc họp`,
	'zh-hans': `会议链接`,
	'zh-hant': `會議連結`,
	en: `Meeting link`
};

export const loc_meetingPasscode: Record<Locale, string> = {
	ar: `رمز مرور الاجتماع`,
	de: `Meeting-Code`,
	es: `Código de acceso para reuniones`,
	fa: `رمز عبور جلسه`,
	fil: `Passcode ng pagpupulong`,
	fr: `Code d’accès pour les réunions`,
	hi: `मीटिंग पासकोड`,
	ht: `Modpas reyinyon an`,
	it: `Codice di accesso per l'incontro`,
	ja: `ミーティングパスコード`,
	ko: `회의 비밀번호`,
	mww: `Password sib tham`,
	ps: `د غونډې پاسکوډ`,
	pt: `Código de acesso para reuniões`,
	'pt-pt': `Código de acesso para reuniões`,
	ru: `Код доступа к встрече`,
	sm: `Fonotaga passcode`,
	so: `Koodhka shirarka`,
	th: `รหัสผ่านการประชุม`,
	ur: `میٹنگ پاس کوڈ`,
	vi: `Mã truy cập cuộc họp`,
	'zh-hans': `会议密码`,
	'zh-hant': `會議密碼`,
	en: `Meeting passcode`
};

export const loc_memberOfAssignedOrg: Record<Locale, string> = {
	ar: `عضو في المنظمة الذي كلف بهذا النشاط.`,
	de: `Mitglied der Organisation, der diese Tätigkeit zugewiesen wurde.`,
	es: `Miembro de la organización asignada a esta actividad.`,
	fa: `عضوی از سازمانی که این فعالیت را بر عهده داشت.`,
	fil: `Miyembro ng organisasyon na naatasan sa aktibidad na ito.`,
	fr: `Membre de l’organisation qui s’est vu confier cette activité.`,
	hi: `संगठन के सदस्य जिन्हें यह गतिविधि सौंपी गई थी।`,
	ht: `Manm òganizasyon ki te asiyen aktivite sa a.`,
	it: `Membro dell'organizzazione a cui è stata assegnata questa attività.`,
	ja: `この活動を担当した組織のメンバー。`,
	ko: `이 활동을 담당한 조직의 구성원.`,
	mww: `Tus tswv cuab ntawm lub koom haum uas tau muab txoj haujlwm no.`,
	ps: `د هغه سازمان غړی چې دا فعالیت ورته سپارل شوی و.`,
	pt: `Membro da organização que foi designado para essa atividade.`,
	'pt-pt': `Membro da organização que foi designado para esta atividade.`,
	ru: `Член организации, которому поручили эту деятельность.`,
	sm: `Sui o le faalapotopotoga lea na tofia i lenei gaoioiga.`,
	so: `Xubin ka tirsan ururka loo xilsaaray hawshan.`,
	th: `สมาชิกขององค์กรที่ได้รับมอบหมายกิจกรรมนี้`,
	ur: `تنظیم کا رکن جسے یہ سرگرمی سونپی گئی تھی۔`,
	vi: `Thành viên của tổ chức được giao hoạt động này.`,
	'zh-hans': `组织成员，负责这项任务。`,
	'zh-hant': `負責此活動的組織成員。`,
	en: `Member of organization who was assigned this activity.`
};

export const loc_memberOfContractingOrg: Record<Locale, string> = {
	ar: `عضو في منظمة تعاقدت مع هذا النشاط.`,
	de: `Mitglied einer Organisation, die diese Tätigkeit beauftragt hat.`,
	es: `Miembro de una organización que contrató esta actividad.`,
	fa: `عضو سازمانی که این فعالیت را به دست آورده است.`,
	fil: `Miyembro ng isang organisasyon na nakipagkumpitensya sa aktibidad na ito.`,
	fr: `Membre d’une organisation qui a souscrit cette activité.`,
	hi: `एक संगठन के सदस्य जिसने इस गतिविधि को अनुबंधित किया।`,
	ht: `Manm yon òganizasyon ki te kontrakte aktivite sa a.`,
	it: `Membro di un'organizzazione che ha contrattato questa attività.`,
	ja: `この活動を契約した組織のメンバー。`,
	ko: `이 활동을 계약한 조직의 일원입니다.`,
	mww: `Tus tswv cuab ntawm ib lub koom haum uas tau cog lus rau qhov kev ua no.`,
	ps: `د یوې ادارې غړی چې دا فعالیت یې قرارداد کړی.`,
	pt: `Membro de uma organização que contratou essa atividade.`,
	'pt-pt': `Membro de uma organização que contratou esta atividade.`,
	ru: `Член организации, которая заключила заказ на эту деятельность.`,
	sm: `Sui o se fa'alapotopotoga na fa'atautaia lenei fa'alapotopotoga.`,
	so: `Xubin ka tirsan urur qandaraas ka qaatay hawshan.`,
	th: `สมาชิกขององค์กรที่ทําสัญญากับกิจกรรมนี้`,
	ur: `اس تنظیم کا رکن جس نے یہ سرگرمی حاصل کی۔`,
	vi: `Thành viên của một tổ chức đã ký hợp đồng với hoạt động này.`,
	'zh-hans': `曾参与过类似活动的组织成员。`,
	'zh-hant': `是承包這項活動的組織成員。`,
	en: `Member of an organization that contracted this activity.`
};

export const loc_memberOfCreateOrg: Record<Locale, string> = {
	ar: `عضو في المنظمة التي أنشأت هذا النشاط.`,
	de: `Mitglied der Organisation, die diese Aktivität ins Leben gerufen hat.`,
	es: `Miembro de la organización que creó esta actividad.`,
	fa: `عضوی از سازمانی که این فعالیت را ایجاد کرده است.`,
	fil: `Miyembro ng organisasyon na lumikha ng aktibidad na ito.`,
	fr: `Membre de l’organisation qui a créé cette activité.`,
	hi: `संगठन के सदस्य जिन्होंने इस गतिविधि को बनाया है।`,
	ht: `Manm òganizasyon ki kreye aktivite sa a.`,
	it: `Membro dell'organizzazione che ha creato questa attività.`,
	ja: `この活動を創設した組織のメンバー。`,
	ko: `이 활동을 만든 조직의 회원입니다.`,
	mww: `Tus tswv cuab ntawm lub koom haum uas tsim qhov kev ua no.`,
	ps: `د هغه سازمان غړی چې دا فعالیت یې رامنځته کړی.`,
	pt: `Membro da organização que criou essa atividade.`,
	'pt-pt': `Membro da organização que criou esta atividade.`,
	ru: `Член организации, создавшей эту деятельность.`,
	sm: `Sui o le faalapotopotoga na faavaeina lenei gaoioiga.`,
	so: `Xubin ka tirsan ururka abuuray hawshan.`,
	th: `สมาชิกขององค์กรที่สร้างกิจกรรมนี้`,
	ur: `اس تنظیم کے رکن جس نے یہ سرگرمی تخلیق کی۔`,
	vi: `Thành viên của tổ chức đã tạo hoạt động này.`,
	'zh-hans': `创建此活动的组织成员。`,
	'zh-hant': `創立此活動的組織成員。`,
	en: `Member of organization who created this activity.`
};

export const loc_memberOfMentionedOrg: Record<Locale, string> = {
	ar: `عضو في المنظمة الذي ذكر في هذا النشاط.`,
	de: `Mitglied der Organisation, die in dieser Aktivität erwähnt wurde.`,
	es: `Miembro de la organización que fue mencionado en esta actividad.`,
	fa: `عضو سازمانی که در این فعالیت ذکر شده است.`,
	fil: `Miyembro ng organisasyon na binanggit sa aktibidad na ito.`,
	fr: `Membre de l’organisation mentionné dans cette activité.`,
	hi: `संगठन के सदस्य जिनका उल्लेख इस गतिविधि में किया गया था।`,
	ht: `Manm òganizasyon ki mansyone nan aktivite sa a.`,
	it: `Membro dell'organizzazione menzionato in questa attività.`,
	ja: `この活動で言及された組織のメンバー。`,
	ko: `이 활동에 언급된 조직의 일원입니다.`,
	mww: `Tus tswv cuab ntawm lub koom haum uas tau hais hauv qhov kev ua no.`,
	ps: `د سازمان غړی چې په دې فعالیت کې یاد شوی و.`,
	pt: `Membro da organização que foi mencionado nesta atividade.`,
	'pt-pt': `Membro da organização que foi mencionado nesta atividade.`,
	ru: `Член организации, упомянутый в этом мероприятии.`,
	sm: `Sui o le faalapotopotoga lea na ta'ua i lenei gaoioiga.`,
	so: `Xubin ka tirsan ururka oo lagu xusay hawshan.`,
	th: `สมาชิกขององค์กรที่กล่าวถึงในกิจกรรมนี้`,
	ur: `اس تنظیم کے رکن جس کا اس سرگرمی میں ذکر کیا گیا۔`,
	vi: `Thành viên của tổ chức được đề cập trong hoạt động này.`,
	'zh-hans': `该组织成员曾被提及。`,
	'zh-hant': `該組織成員曾被提及。`,
	en: `Member of organization who was mentioned in this activity.`
};

export const loc_memberOfOrgSupervisor: Record<Locale, string> = {
	ar: `عضو في منظمة تشرف على منظمة أخرى تشارك في هذا النشاط.`,
	de: `Mitglied einer Organisation, die eine andere Organisation beaufsichtigt, die an dieser Aktivität teilnimmt.`,
	es: `Miembro de una organización que supervisa a otra organización que participa en esta actividad.`,
	fa: `عضو سازمانی که بر سازمان دیگری که در این فعالیت شرکت دارد نظارت دارد.`,
	fil: `Miyembro ng isang organisasyon na nangangasiwa sa ibang organisasyon na nakikilahok sa aktibidad na ito.`,
	fr: `Membre d’une organisation supervisant une autre organisation participant à cette activité.`,
	hi: `एक संगठन का सदस्य जो इस गतिविधि में भाग लेने वाले किसी अन्य संगठन की देखरेख करता है।`,
	ht: `Manm yon òganizasyon ki sipèvize yon lòt òganizasyon k ap patisipe nan aktivite sa a.`,
	it: `Membro di un'organizzazione che supervisiona un'altra organizzazione partecipante a questa attività.`,
	ja: `この活動に参加している他の組織を監督する組織のメンバー。`,
	ko: `이 활동에 참여하는 다른 조직을 감독하는 조직의 회원.`,
	mww: `Tus tswv cuab ntawm ib lub koom haum uas saib xyuas lwm lub koom haum uas koom nrog txoj haujlwm no.`,
	ps: `د یوې ادارې غړی چې بل سازمان څاری.`,
	pt: `Membro de uma organização que supervisiona outra organização que participe dessa atividade.`,
	'pt-pt': `Membro de uma organização que supervisiona outra organização que participe nesta atividade.`,
	ru: `Член организации, которая курирует другую организацию, принимающую участие в этой деятельности.`,
	sm: `Sui o se faalapotopotoga o loo vaavaaia se isi faalapotopotoga o loo auai i lenei gaoioiga.`,
	so: `Xubin ka tirsan urur kormeera urur kale oo ka qayb qaadanaya hawshan.`,
	th: `สมาชิกขององค์กรที่ดูแลองค์กรอื่นที่เข้าร่วมกิจกรรมนี้`,
	ur: `ایسی تنظیم کا رکن جو اس سرگرمی میں حصہ لینے والی دوسری تنظیم کی نگرانی کرتی ہے۔`,
	vi: `Thành viên của một tổ chức giám sát một tổ chức khác tham gia hoạt động này.`,
	'zh-hans': `隶属于监督参与该活动的另一个组织的组织。`,
	'zh-hant': `隸屬於監督參與此活動的另一個組織的組織成員。`,
	en: `Member of an organization that supervises another organization participating in this activity.`
};

export const loc_memberOfProjectSupervisorOrg: Record<Locale, (project: unknown) => string> = {
	ar: (project) => `عضو في منظمة تشرف على مشروع ${project} .`,
	de: (project) => `Mitglied einer Organisation, die das ${project} überwacht.`,
	es: (project) => `Miembro de una organización que supervisa el proyecto ${project} .`,
	fa: (project) => `عضو سازمانی که پروژه ${project} را نظارت می کند.`,
	fil: (project) => `Miyembro ng isang organisasyon na nangangasiwa sa ${project} .`,
	fr: (project) => `Membre d’une organisation qui supervise le projet ${project} .`,
	hi: (project) => `एक संगठन के सदस्य जो ${project} परियोजना की देखरेख करता है।`,
	ht: (project) => `Manm yon òganizasyon ki sipèvize pwojè ${project} la.`,
	it: (project) => `Membro di un'organizzazione che supervisiona il progetto ${project} .`,
	ja: (project) => `${project}プロジェクトを監督する組織のメンバー。`,
	ko: (project) => `${project} 프로젝트를 감독하는 조직의 일원입니다.`,
	mww: (project) => `Tus tswv cuab ntawm ib lub koom haum uas saib xyuas txoj haujlwm ${project} .`,
	ps: (project) => `د یوې ادارې غړی چې ${project} پروژه څاری.`,
	pt: (project) => `Membro de uma organização que supervisiona o projeto ${project} .`,
	'pt-pt': (project) => `Membro de uma organização que supervisiona o projeto ${project} .`,
	ru: (project) => `Член организации, которая контролирует проект ${project} .`,
	sm: (project) => `Sui o se fa'alapotopotoga o lo'o va'ava'aia le poloketi o ${project} .`,
	so: (project) => `Xubin ka tirsan urur kormeera mashruuca ${project} karo.`,
	th: (project) => `สมาชิกขององค์กรที่ดูแลโครงการ${project}`,
	ur: (project) => `ایک ایسی تنظیم کا رکن جو ${project} کے منصوبے کی نگرانی کرتی ہے۔`,
	vi: (project) => `Thành viên của một tổ chức giám sát dự án ${project} .`,
	'zh-hans': (project) => `是负责监督 ${project} 项目的组织成员。`,
	'zh-hant': (project) => `是監督 ${project} 計畫的組織成員。`,
	en: (project) => `Member of an organization that supervises the ${project} project.`
};

export const loc_mentions: Record<Locale, string> = {
	ar: `الإشارات`,
	de: `Erwähnungen`,
	es: `Menciones`,
	fa: `ذکرها`,
	fil: `Mga pagbanggit`,
	fr: `Mentions`,
	hi: `उल्लेख`,
	ht: `Mansyone`,
	it: `Menzioni`,
	ja: `言及`,
	ko: `언급`,
	mww: `Cov lus hais`,
	ps: `یادونه`,
	pt: `Menções`,
	'pt-pt': `Menções`,
	ru: `Упоминания`,
	sm: `Ta'ua`,
	so: `Xuska`,
	th: `กล่าวถึง`,
	ur: `ذکر`,
	vi: `Đề cập`,
	'zh-hans': `提及`,
	'zh-hant': `提及`,
	en: `Mentions`
};

export const loc_mentionsYou: Record<Locale, string> = {
	ar: `يذكرك`,
	de: `Erwähnt dich`,
	es: `Te menciona`,
	fa: `اسم تو رو می بره.`,
	fil: `Binanggit ka`,
	fr: `Te mentionne`,
	hi: `आपका उल्लेख करता है`,
	ht: `Mansyone ou`,
	it: `Ti menziona`,
	ja: `君のことを言及してる`,
	ko: `너 얘기해`,
	mww: `Hais txog koj`,
	ps: `ستا یادونه کوی`,
	pt: `Menciona você`,
	'pt-pt': `Menciona-te`,
	ru: `Упоминает тебя`,
	sm: `Ta'ua oe`,
	so: `Adiga ayaa lagu xusay`,
	th: `กล่าวถึงคุณ`,
	ur: `تمہارا ذکر کرتا ہے`,
	vi: `Đề cập đến bạn`,
	'zh-hans': `提到你`,
	'zh-hant': `提到你`,
	en: `Mentions you`
};

export const loc_menuIsLoading: Record<Locale, string> = {
	ar: `القائمة قيد التحميل`,
	de: `Menü lädt gerade`,
	es: `El menú está cargando`,
	fa: `منو در حال بارگذاری است`,
	fil: `Naglo-load ang menu`,
	fr: `Le menu se charge`,
	hi: `मेनू लोड हो रहा है`,
	ht: `Meni ap chaje`,
	it: `Il menu si sta caricando`,
	ja: `メニューが読み込まれています`,
	ko: `메뉴가 로딩 중입니다`,
	mww: `Ntawv qhia zaub mov yog chaw thau khoom`,
	ps: `مینو پورته کېږی`,
	pt: `O cardápio está carregando`,
	'pt-pt': `O menu está a carregar`,
	ru: `Меню загружается`,
	sm: `O lo'o utaina le lisi`,
	so: `Menu-ga waa la shubanayaa`,
	th: `เมนูกําลังโหลด`,
	ur: `مینو لوڈ ہو رہا ہے`,
	vi: `Menu đang tải`,
	'zh-hans': `菜单正在加载中`,
	'zh-hant': `選單正在載入`,
	en: `Menu is loading`
};

export const loc_merge: Record<Locale, string> = {
	ar: `الاندماج`,
	de: `Zusammenführung`,
	es: `Fusión`,
	fa: `ادغام`,
	fil: `Pagsamahin`,
	fr: `Fusion`,
	hi: `मर्ज करें`,
	ht: `Rantre nan`,
	it: `Fusione`,
	ja: `合併`,
	ko: `합병`,
	mww: `Kev sib koom ua ke`,
	ps: `یوځای کول`,
	pt: `Fusão`,
	'pt-pt': `Fusão`,
	ru: `Слияние`,
	sm: `Tuufaatasi`,
	so: `Isku-darka`,
	th: `ผสาน`,
	ur: `انضمام`,
	vi: `Hợp nhất`,
	'zh-hans': `合并`,
	'zh-hant': `合併`,
	en: `Merge`
};

export const loc_mergeConfirmation: Record<Locale, (title: unknown) => string> = {
	ar: (title) => `هل أنت متأكد أنك تريد دمج "${title}"؟ سيتم حذف هذا السجل وسيتم نقل أنشطته إلى السجل المستهدف.`,
	de: (title) => `Bist du sicher, dass du "${title}" fusionieren willst? Dieser Datensatz wird gelöscht und seine Aktivitäten werden auf den Zieldatensatz verschoben.`,
	es: (title) => `¿Estás seguro de que quieres fusionar "${title}"? Este registro será eliminado y sus actividades se trasladarán al registro objetivo.`,
	fa: (title) => `مطمئنی می خواهی «${title}» را ادغام کنی؟ این رکورد حذف خواهد شد و فعالیت های آن به رکورد هدف منتقل خواهد شد.`,
	fil: (title) => `Sigurado ka bang gusto mong i-merge ang "${title}"? Ang rekord na ito ay tatanggalin at ang mga aktibidad nito ay ililipat sa target na talaan.`,
	fr: (title) => `Êtes-vous sûr de vouloir fusionner « ${title} » ? Cet enregistrement sera supprimé et ses activités transférées vers l’enregistrement cible.`,
	hi: (title) => `क्या आप वाकई "${title} को मर्ज करना चाहते हैं? यह रिकॉर्ड हटा दिया जाएगा और इसकी गतिविधियों को लक्ष्य रिकॉर्ड में ले जाया जाएगा.`,
	ht: (title) => `Èske ou sèten ou vle rantre "${title}"? Dosye sa a pral efase ak aktivite li yo pral deplase nan dosye sib la.`,
	it: (title) => `Sei sicuro di voler unire "${title}"? Questo record sarà cancellato e le sue attività trasferite al record target.`,
	ja: (title) => `「${title}」を合併するつもりですか?このレコードは削除され、そのアクティビティはターゲットレコードに移動します。`,
	ko: (title) => `"${title}"를 합치고 싶은 게 확실해? 이 레코드는 삭제되며, 그 활동은 대상 레코드로 이동합니다.`,
	mww: (title) => `Koj puas paub tseeb tias koj xav sib koom ua ke "${title}"? Cov ntaub ntawv no yuav raug tshem tawm thiab nws cov kev ua ub no yuav raug tsiv mus rau lub hom phiaj ntaub ntawv.`,
	ps: (title) => `ته ډاډه یې چې غواړې "${title}" سره یو ځای کړې؟ دا ریکارډ به حذف شی او فعالیتونه به یې هدف ریکارډ ته انتقال شی.`,
	pt: (title) => `Você tem certeza de que quer fundir "${title}"? Esse registro será excluído e suas atividades serão transferidas para o registro alvo.`,
	'pt-pt': (title) => `Tens a certeza de que queres fundir "${title}"? Este registo será eliminado e as suas atividades serão transferidas para o registo alvo.`,
	ru: (title) => `Ты уверен, что хочешь объединить «${title}»? Эта запись будет удалена, а её деятельность перенесена в целевую запись.`,
	sm: (title) => `E te mautinoa e te mana'o e tu'ufa'atasia le "${title}"? O lenei faamaumauga o le a aveesea ma o le a siitia ana gaoioiga i le faamaumauga faamoemoeina.`,
	so: (title) => `Ma hubtaa inaad rabto inaad isku darto "${title}"? Diiwaankan waa la tirtiri doonaa waxaana hawlihiisa loo wareejin doonaa diiwaanka bartilmaameedka.`,
	th: (title) => `คุณแน่ใจหรือไม่ว่าต้องการรวม "${title}" เข้าด้วยกัน? เรกคอร์ดนี้จะถูกลบและกิจกรรมจะถูกย้ายไปยังเรกคอร์ดเป้าหมาย`,
	ur: (title) => `کیا آپ واقعی "${title}" کو ضم کرنا چاہتے ہیں؟ یہ ریکارڈ حذف کر دیا جائے گا اور اس کی سرگرمیاں ہدف ریکارڈ پر منتقل کر دی جائیں گی۔`,
	vi: (title) => `Bạn có chắc chắn muốn hợp nhất "${title}" không? Bản ghi này sẽ bị xóa và các hoạt động của nó sẽ được chuyển đến bản ghi đích.`,
	'zh-hans': (title) => `你确定要合并“${title}吗？该记录将被删除，其活动将被移至目标记录。`,
	'zh-hant': (title) => `你確定要合併「${title}」嗎？此紀錄將被刪除，其活動將移至目標紀錄。`,
	en: (title) => `Are you sure you want to merge "${title}"? This record will be deleted and its activities will be moved to the target record.`
};

export const loc_mergeDeletePersonDesc: Record<Locale, string> = {
	ar: `سيتم حذف هذا الشخص وسيتم نقل نشاطاته إلى شخص "الاحتفاظ به".`,
	de: `Diese Person wird gelöscht und ihre Aktivitäten werden auf die "Behalten"-Person verschoben.`,
	es: `Esta persona será eliminada y sus actividades pasarán a la persona de "Conservar".`,
	fa: `این فرد حذف می شود و فعالیت هایش به شخص «نگه دار» منتقل می شود.`,
	fil: `Ang taong ito ay tatanggalin at ang kanilang mga aktibidad ay ililipat sa taong "Panatilihin."`,
	fr: `Cette personne sera supprimée et ses activités transférées à la personne « Conserver ».`,
	hi: `इस व्यक्ति को हटा दिया जाएगा और उनकी गतिविधियों को "कीप" व्यक्ति के पास ले जाया जाएगा।`,
	ht: `Moun sa a pral efase ak aktivite yo pral demenaje ale rete nan moun nan"Kenbe".`,
	it: `Questa persona verrà eliminata e le sue attività saranno trasferite alla persona "Conserva".`,
	ja: `この人は削除され、その活動は「キープ」担当者に移されます。`,
	ko: `이 사람은 삭제되며, 활동은 '유지' 담당자에게 옮겨집니다.`,
	mww: `Tus neeg no yuav raug tshem tawm thiab nws cov haujlwm yuav raug tsiv mus rau tus neeg "Khaws cia".`,
	ps: `دا کس به حذف شی او فعالیتونه به یې "Keep" کس ته انتقال شی.`,
	pt: `Essa pessoa será deletada e suas atividades serão transferidas para a pessoa "Guardar".`,
	'pt-pt': `Esta pessoa será eliminada e as suas atividades serão transferidas para a pessoa "Guardar".`,
	ru: `Этот человек будет удалён, а его деятельность переведена к человеку «Сохранить».`,
	sm: `O lenei tagata o le a ave'esea ma o le a siitia atu a latou gaioiga i le tagata "Keep".`,
	so: `Qofkan waa la tirtiri doonaa waxaana hawlihiisa loo wareejin doonaa qofka "Keep".`,
	th: `บุคคลนี้จะถูกลบและกิจกรรมของพวกเขาจะถูกย้ายไปยังบุคคล "เก็บ"`,
	ur: `اس شخص کو حذف کر دیا جائے گا اور اس کی سرگرمیاں "Keep" والے شخص کو منتقل کر دی جائیں گی۔`,
	vi: `Người này sẽ bị xóa và hoạt động của họ sẽ được chuyển sang người "Keep".`,
	'zh-hans': `这个人会被删除，他们的活动会转移到“保留”的人手中。`,
	'zh-hant': `此人將被刪除，其活動將移至「保留」者。`,
	en: `This person will be deleted and their activities will be moved to the "Keep" person.`
};

export const loc_mergeEllipses: Record<Locale, string> = {
	ar: `اندمج...`,
	de: `Verschmelzen...`,
	es: `Fusionar...`,
	fa: `ادغام...`,
	fil: `Pagsamahin ...`,
	fr: `Fusion...`,
	hi: `मर्ज करें...`,
	ht: `Rantre ...`,
	it: `Fusione...`,
	ja: `合流...`,
	ko: `합병...`,
	mww: `Sib koom ua ke...`,
	ps: `یوځای شه...`,
	pt: `Fusão...`,
	'pt-pt': `Fusão...`,
	ru: `Слияние...`,
	sm: `Tu'ufa'atasia...`,
	so: `Isku biir...`,
	th: `ผสาน...`,
	ur: `مرج...`,
	vi: `Hợp nhất...`,
	'zh-hans': `合并......`,
	'zh-hant': `合併......`,
	en: `Merge...`
};

export const loc_mergeKeepPersonDesc: Record<Locale, string> = {
	ar: `سيحصل هذا الشخص على الأنشطة من شخص "الدمج".`,
	de: `Diese Person erhält die Aktivitäten von der "Merge"-Person.`,
	es: `Esta persona recibirá las actividades de la persona de "Fusionar".`,
	fa: `این فرد فعالیت ها را از فرد «ادغام» دریافت خواهد کرد.`,
	fil: `Ang taong ito ay makakatanggap ng mga aktibidad mula sa "Merge" na tao.`,
	fr: `Cette personne recevra les activités de la personne « Fusion ».`,
	hi: `यह व्यक्ति "मर्ज" व्यक्ति से गतिविधियाँ प्राप्त करेगा।`,
	ht: `Moun sa a ap resevwa aktivite yo nan men moun nan"Fusione".`,
	it: `Questa persona riceverà le attività dalla persona "Merge".`,
	ja: `この人は「マージ」担当者から活動を受け取ります。`,
	ko: `이 사람은 '합병' 담당자로부터 활동을 받게 됩니다.`,
	mww: `Tus neeg no yuav tau txais cov kev ua ub no los ntawm tus neeg "Merge".`,
	ps: `دا کس به فعالیتونه د "Merge" کس څخه ترلاسه کړی.`,
	pt: `Essa pessoa receberá as atividades da pessoa "Fusão".`,
	'pt-pt': `Esta pessoa receberá as atividades da pessoa "Fusão".`,
	ru: `Этот человек получит действия от участника «Слияния».`,
	sm: `O lenei tagata o le a mauaina gaoioiga mai le tagata "Tuufaatasia".`,
	so: `Qofkan wuxuu ka heli doonaa hawlaha qofka "Merge".`,
	th: `บุคคลนี้จะได้รับกิจกรรมจากบุคคล "ผสาน"`,
	ur: `یہ شخص "مرج" شخص سے سرگرمیاں وصول کرے گا۔`,
	vi: `Người này sẽ nhận được các hoạt động từ người "Hợp nhất".`,
	'zh-hans': `该人将从“合并”者那里获得活动。`,
	'zh-hant': `此人將從「合併」者那裡接收活動。`,
	en: `This person will receive the activities from the "Merge" person.`
};

export const loc_mergePeopleRecords: Record<Locale, string> = {
	ar: `سجلات دمج الناس`,
	de: `Merge People Records`,
	es: `Registros de la fusión de personas`,
	fa: `رکوردهای Merge People`,
	fil: `Pagsamahin ang mga talaan ng mga tao`,
	fr: `Fusion des dossiers de personnes`,
	hi: `लोगों के रिकॉर्ड मर्ज करना`,
	ht: `Rantre dosye moun`,
	it: `Fusione dei record delle persone`,
	ja: `人々の記録を統合する`,
	ko: `기록 합병`,
	mww: `Merge tib neeg cov ntaub ntawv`,
	ps: `د خلکو د یوځای کولو ریکارډونه`,
	pt: `Fusão de registros de pessoas`,
	'pt-pt': `Fusão de registos de pessoas`,
	ru: `Записи Merge People`,
	sm: `Tuufaatasi faamaumauga a tagata`,
	so: `Isku-darka diiwaanka dadka`,
	th: `รวมเรกคอร์ดบุคคล`,
	ur: `مرج پیپل ریکارڈز`,
	vi: `Hợp nhất bản ghi mọi người`,
	'zh-hans': `合并人物记录`,
	'zh-hant': `合併人員紀錄`,
	en: `Merge people records`
};

export const loc_message: Record<Locale, string> = {
	ar: `الرسالة`,
	de: `Botschaft`,
	es: `Mensaje`,
	fa: `پیام`,
	fil: `Mensahe`,
	fr: `Message`,
	hi: `संदेश`,
	ht: `Mesaj`,
	it: `Messaggio`,
	ja: `メッセージ`,
	ko: `메시지`,
	mww: `Lus`,
	ps: `پیغام`,
	pt: `Mensagem`,
	'pt-pt': `Mensagem`,
	ru: `Сообщение`,
	sm: `Savali`,
	so: `Fariin`,
	th: `ข้อความ`,
	ur: `پیغام`,
	vi: `Thông điệp`,
	'zh-hans': `信息`,
	'zh-hant': `訊息`,
	en: `Message`
};

export const loc_metric: Record<Locale, string> = {
	ar: `القياس`,
	de: `Metrik`,
	es: `Métrica`,
	fa: `متریک`,
	fil: `Sukatan`,
	fr: `Métrique`,
	hi: `परिमाणात्‍मक`,
	ht: `Metrik`,
	it: `Metrica`,
	ja: `メートル法`,
	ko: `미터법`,
	mww: `Kev ntsuas`,
	ps: `متریک`,
	pt: `Métrica`,
	'pt-pt': `Métrica`,
	ru: `Метрика`,
	sm: `Metric`,
	so: `Metric`,
	th: `เมตริก`,
	ur: `میٹرک`,
	vi: `Số liệu`,
	'zh-hans': `度规`,
	'zh-hant': `公制`,
	en: `Metric`
};

export const loc_metroArea: Record<Locale, string> = {
	ar: `المنطقة الحضرية`,
	de: `Metropolregion`,
	es: `Área metropolitana`,
	fa: `منطقه کلان شهری`,
	fil: `Lugar ng Metro`,
	fr: `Zone métropolitaine`,
	hi: `मेट्रो क्षेत्र`,
	ht: `Zòn métro`,
	it: `Area metropolitana`,
	ja: `都市圏`,
	ko: `대도시권`,
	mww: `Metro cheeb tsam`,
	ps: `میټرو سیمه`,
	pt: `Área metropolitana`,
	'pt-pt': `Área metropolitana`,
	ru: `Столичный район`,
	sm: `Eria o le metro`,
	so: `Aagga metro-ga`,
	th: `เขตรถไฟใต้ดิน`,
	ur: `میٹرو علاقہ`,
	vi: `Khu vực tàu điện ngầm`,
	'zh-hans': `大都会区`,
	'zh-hant': `都會區`,
	en: `Metro area`
};

export const loc_mfaRequiredSidebarNotice: Record<Locale, string> = {
	ar: `🔒 سيكون مطلوبا الحصول على الماجستير في 13/11.`,
	de: `🔒 Ein MFA ist am 13.11. erforderlich.`,
	es: `🔒 El MFA será obligatorio el 13/11.`,
	fa: `🔒 MFA در تاریخ ۱۳/۱۱ الزامی خواهد بود.`,
	fil: `🔒 Kinakailangan ang MFA sa 11/13.`,
	fr: `🔒 Le MFA sera obligatoire le 13/11.`,
	hi: `🔒 11/13 को एमएफए की आवश्यकता होगी।`,
	ht: `🔒 MFA yo pral obligatwa sou 11/13`,
	it: `🔒 L'MFA sarà richiesto il 13/11.`,
	ja: `🔒 MFAは11月13日に必須となります。`,
	ko: `🔒 MFA는 11월 13일에 필수입니다.`,
	mww: `🔒 MFA yuav tsum tau nyob rau hnub tim 11/13.`,
	ps: `🔒 MFA به د 11/13 نېټه اړین وی.`,
	pt: `🔒 O MFA será exigido em 13/11.`,
	'pt-pt': `🔒 O MFA será obrigatório a 13/11.`,
	ru: `🔒 MFA будет обязательным 13.11.`,
	sm: `🔒 MFA o le a mana'omia i le 11/13.`,
	so: `🔒 MFA waxaa loo baahan doonaa 11/13.`,
	th: `🔒 จะต้องมี MFA ในวันที่ 13/11`,
	ur: `🔒 MFA 13/11 کو لازمی ہوگا۔`,
	vi: `🔒 MFA sẽ được yêu cầu vào ngày 13/11.`,
	'zh-hans': `🔒 MFA将于11月13日完成。`,
	'zh-hant': `🔒 11月13日將要求完成MFA。`,
	en: `🔒 MFA will be required on 11/13.`
};

export const loc_middleName: Record<Locale, string> = {
	ar: `الاسم الأوسط`,
	de: `Zweiter Vorname`,
	es: `Segundo nombre`,
	fa: `نام میانی`,
	fil: `Gitnang pangalan`,
	fr: `Deuxième prénom`,
	hi: `मध्य नाम`,
	ht: `Non presegondè`,
	it: `Secondo nome`,
	ja: `ミドルネーム`,
	ko: `중간 이름`,
	mww: `Lub npe nruab nrab`,
	ps: `منځنی نوم`,
	pt: `Nome do meio`,
	'pt-pt': `Nome do meio`,
	ru: `Второе имя`,
	sm: `Igoa ogatotonu`,
	so: `Magaca dhexe`,
	th: `ชื่อกลาง`,
	ur: `درمیانی نام`,
	vi: `Tên đệm`,
	'zh-hans': `中间名`,
	'zh-hant': `中間名`,
	en: `Middle name`
};

export const loc_milesAwayFormat: Record<Locale, (distance: unknown) => string> = {
	ar: (distance) => `${distance} أميال`,
	de: (distance) => `${distance} Meilen entfernt`,
	es: (distance) => `${distance} millas de distancia`,
	fa: (distance) => `${distance} مایل دورتر`,
	fil: (distance) => `${distance} km ang layo`,
	fr: (distance) => `${distance} miles de là`,
	hi: (distance) => `${distance} मील दूर`,
	ht: (distance) => `${distance} kilomèt lwen`,
	it: (distance) => `${distance} miglia di distanza`,
	ja: (distance) => `${distance} マイル離れています`,
	ko: (distance) => `${distance} 마일 떨어져 있어`,
	mww: (distance) => `${distance} mais deb`,
	ps: (distance) => `${distance} میل لرې`,
	pt: (distance) => `${distance} milhas de distância`,
	'pt-pt': (distance) => `${distance} milhas de distância`,
	ru: (distance) => `${distance} миль отсюда`,
	sm: (distance) => `${distance} maila le mamao`,
	so: (distance) => `${distance} mayl u jirta`,
	th: (distance) => `ห่างออกไป ${distance} กม.`,
	ur: (distance) => `${distance} میل دور`,
	vi: (distance) => `Cách ${distance} km`,
	'zh-hans': (distance) => `${distance} 英里外`,
	'zh-hant': (distance) => `距離${distance}英里`,
	en: (distance) => `${distance} miles away`
};

export const loc_missingFileExtensionFormat: Record<Locale, (filename: unknown) => string> = {
	ar: (filename) => `اسم ملف غير صحيح: "${filename}". يجب أن يتضمن اسم الملف امتدادا.`,
	de: (filename) => `Ungültiger Dateiname: "${filename}". Der Dateiname muss eine Erweiterung enthalten.`,
	es: (filename) => `Nombre de archivo inválido: "${filename}". El nombre del archivo debe incluir una extensión.`,
	fa: (filename) => `نام فایل نامعتبر: «${filename}». نام فایل باید شامل پسوند باشد.`,
	fil: (filename) => `Hindi wastong pangalan ng file: "${filename}". Ang pangalan ng file ay dapat magsama ng isang extension.`,
	fr: (filename) => `Nom de fichier invalide : « ${filename} ». Le nom du fichier doit inclure une extension.`,
	hi: (filename) => `अमान्य फ़ाइल नाम: "${filename}"। फ़ाइल नाम में एक एक्सटेंशन शामिल होना चाहिए।`,
	ht: (filename) => `Non dosye ki pa valid: "${filename}". Non dosye dwe gen ladan yon ekstansyon.`,
	it: (filename) => `Nome file non valido: "${filename}". Il nome del file deve includere un'estensione.`,
	ja: (filename) => `無効なファイル名:「${filename}」。ファイル名には拡張子を含める必要があります。`,
	ko: (filename) => `유효하지 않은 파일명: "${filename}". 파일 이름에는 확장자가 반드시 포함되어야 합니다.`,
	mww: (filename) => `Cov ntaub ntawv tsis raug: "${filename}". Filename yuav tsum muaj ib qho txuas ntxiv.`,
	ps: (filename) => `ناسمه فایل نوم: "${filename}". د فایل نوم باید پسوند ولری.`,
	pt: (filename) => `Nome de arquivo inválido: "${filename}". O nome do arquivo deve incluir uma extensão.`,
	'pt-pt': (filename) => `Nome de ficheiro inválido: "${filename}". O nome do ficheiro deve incluir uma extensão.`,
	ru: (filename) => `Неверное имя файла: "${filename}". Имя файла должно содержать расширение.`,
	sm: (filename) => `Igoa faila e le aoga: "${filename}". O le igoa o le faila e tatau ona aofia ai se faaopoopoga.`,
	so: (filename) => `Magac fayl aan sax ahayn: "${filename}". Magaca faylka waa inuu ku jiro kordhin.`,
	th: (filename) => `ชื่อไฟล์ไม่ถูกต้อง: "${filename}" ชื่อไฟล์ต้องมีนามสกุล`,
	ur: (filename) => `غلط فائل نام: "${filename}"۔ فائل نیم میں ایک توسیع شامل ہونی چاہیے۔`,
	vi: (filename) => `Tên tệp không hợp lệ: "${filename}". Tên tệp phải bao gồm phần mở rộng.`,
	'zh-hans': (filename) => `文件名无效：“${filename}”。文件名必须包含扩展名。`,
	'zh-hant': (filename) => `檔案名稱無效：「${filename}」。檔名必須包含副檔名。`,
	en: (filename) => `Invalid filename: "${filename}". Filename must include an extension.`
};

export const loc_more: Record<Locale, string> = {
	ar: `المزيد`,
	de: `Mehr`,
	es: `Más`,
	fa: `بیشتر`,
	fil: `Higit pa`,
	fr: `Plus`,
	hi: `अधिक`,
	ht: `Plis`,
	it: `Altro`,
	ja: `続き`,
	ko: `더 보기`,
	mww: `Ntau`,
	ps: `نور`,
	pt: `Mais`,
	'pt-pt': `Mais`,
	ru: `Подробнее`,
	sm: `Sili atu`,
	so: `Wax badan`,
	th: `มากกว่า`,
	ur: `مزید`,
	vi: `Xem thêm`,
	'zh-hans': `更多`,
	'zh-hant': `更多`,
	en: `More`
};

export const loc_moreORGProgramsFormat: Record<Locale, (org: unknown) => TemplateResult> = {
	ar: (org) => html`<span>المزيد من برامج ${org}</span>`,
	de: (org) => html`<span>Weitere ${org}</span>`,
	es: (org) => html`<span>Más programas ${org}</span>`,
	fa: (org) => html`<span>برنامه های ${org}</span>`,
	fil: (org) => html`<span>Higit pang mga programa ${org}</span>`,
	fr: (org) => html`<span>Plus de programmes ${org}</span>`,
	hi: (org) => html`<span>अधिक ${org} कार्यक्रम</span>`,
	ht: (org) => html`<span>Plis ${org}</span>`,
	it: (org) => html`<span>Altri programmi ${org}</span>`,
	ja: (org) => html`<span>さらに多くの ${org} プログラム</span>`,
	ko: (org) => html`<span>더 많은 ${org} 프로그램</span>`,
	mww: (org) => html`<span>Ntau ${org} cov kev pab cuam</span>`,
	ps: (org) => html`<span>نور ${org} پروګرامونه</span>`,
	pt: (org) => html`<span>Mais programas ${org}</span>`,
	'pt-pt': (org) => html`<span>Mais programas ${org}</span>`,
	ru: (org) => html`<span>Больше программ ${org}</span>`,
	sm: (org) => html`<span>Isi polokalame ${org}</span>`,
	so: (org) => html`<span>Barnaamijyo ${org} ah</span>`,
	th: (org) => html`<span>โปรแกรม ${org} เพิ่มเติม</span>`,
	ur: (org) => html`<span>${org} پروگرامز</span>`,
	vi: (org) => html`<span>Các chương trình ${org} khác</span>`,
	'zh-hans': (org) => html`<span>更多 ${org} 项目</span>`,
	'zh-hant': (org) => html`<span>更多 ${org} 計畫</span>`,
	en: (org) => html`<span>More ${org} programs</span>`
};

export const loc_moreTemplates: Record<Locale, string> = {
	ar: `المزيد من القوالب`,
	de: `Weitere Vorlagen`,
	es: `Más plantillas`,
	fa: `قالب های بیشتر`,
	fil: `Higit pang mga template`,
	fr: `Plus de modèles`,
	hi: `अधिक टेम्पलेट`,
	ht: `Plis modèl`,
	it: `Altri modelli`,
	ja: `さらにテンプレート`,
	ko: `더 많은 템플릿`,
	mww: `Ntau templates`,
	ps: `نور قالبونه`,
	pt: `Mais modelos`,
	'pt-pt': `Mais modelos`,
	ru: `Больше шаблонов`,
	sm: `Nisi fa'ata'ita'iga`,
	so: `Templates dheeraad ah`,
	th: `เทมเพลตเพิ่มเติม`,
	ur: `مزید ٹیمپلیٹس`,
	vi: `Các mẫu khác`,
	'zh-hans': `更多模板`,
	'zh-hant': `更多範本`,
	en: `More templates`
};

export const loc_multiFactorAuthentication: Record<Locale, string> = {
	ar: `المصادقة متعددة العوامل (MFA)`,
	de: `Multi-Faktor-Authentifizierung (MFA)`,
	es: `Autenticación multifactor (MFA)`,
	fa: `احراز هویت چندعاملی (MFA)`,
	fil: `Multi-factor na pagpapatunay (MFA)`,
	fr: `Authentification multifacteur (MFA)`,
	hi: `बहु-कारक प्रमाणीकरण (MFA)`,
	ht: `Multi-faktè otantifikasyon (MFA)`,
	it: `Autenticazione multifattore (MFA)`,
	ja: `多要素認証(MFA)`,
	ko: `다중인증(MFA)`,
	mww: `Multi-factor authentication (MFA)`,
	ps: `څو-فکتوری تصدیق (MFA)`,
	pt: `Autenticação multifator (MFA)`,
	'pt-pt': `Autenticação multifator (MFA)`,
	ru: `Многофакторная аутентификация (MFA)`,
	sm: `Fa'amaoniga Fa'apitoa (MFA)`,
	so: `Multi-factor authentication (MFA)`,
	th: `การรับรองความถูกต้องแบบหลายปัจจัย (MFA)`,
	ur: `ملٹی فیکٹر تصدیق (MFA)`,
	vi: `Xác thực đa yếu tố (MFA)`,
	'zh-hans': `多因素认证（MFA）`,
	'zh-hant': `多重驗證（MFA）`,
	en: `Multi-factor authentication (MFA)`
};

export const loc_multipleAttachments: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} ملحقات`,
	de: (count) => `${count} Anhänge`,
	es: (count) => `${count} accesorios`,
	fa: (count) => `${count} ضمیمه`,
	fil: (count) => `${count} Mga Attachment`,
	fr: (count) => `${count} pièces jointes`,
	hi: (count) => `${count} संलग्नक`,
	ht: (count) => `${count} atachman`,
	it: (count) => `${count} allegati`,
	ja: (count) => `${count} つの付属品`,
	ko: (count) => `${count} 부속품`,
	mww: (count) => `${count} Attachments`,
	ps: (count) => `${count} ضمیمې`,
	pt: (count) => `${count} anexos`,
	'pt-pt': (count) => `${count} anexos`,
	ru: (count) => `${count} Вложений`,
	sm: (count) => `${count} fa'apipi'i`,
	so: (count) => `${count} Lifaaq`,
	th: (count) => `${count} ไฟล์แนบ`,
	ur: (count) => `${count} اٹیچمنٹس`,
	vi: (count) => `${count} tệp đính kèm`,
	'zh-hans': (count) => `${count} 附件`,
	'zh-hant': (count) => `${count} 附件`,
	en: (count) => `${count} attachments`
};

export const loc_multipleClinicsFormat: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} عيادات`,
	de: (count) => `${count} Kliniken`,
	es: (count) => `${count} clínicas`,
	fa: (count) => `${count} کلینیک`,
	fil: (count) => `${count} Mga klinika`,
	fr: (count) => `${count} cliniques`,
	hi: (count) => `${count} क्लीनिक`,
	ht: (count) => `${count} klinik`,
	it: (count) => `${count} cliniche`,
	ja: (count) => `${count} つのクリニック`,
	ko: (count) => `${count} 개의 클리닉`,
	mww: (count) => `${count} lub tsev kho mob`,
	ps: (count) => `${count} کلینیکونه`,
	pt: (count) => `${count} clínicas`,
	'pt-pt': (count) => `${count} clínicas`,
	ru: (count) => `${count} клиник`,
	sm: (count) => `${count} falema'i`,
	so: (count) => `${count} Kliniko`,
	th: (count) => `${count} คลินิก`,
	ur: (count) => `${count} کلینکس`,
	vi: (count) => `${count} phòng khám`,
	'zh-hans': (count) => `${count} 个诊所`,
	'zh-hant': (count) => `${count} 間診所`,
	en: (count) => `${count} clinics`
};

export const loc_multipleContributors: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} مساهمين`,
	de: (count) => `${count} Mitwirkende`,
	es: (count) => `${count} colaboradores`,
	fa: (count) => `${count} مشارکت کننده`,
	fil: (count) => `${count} mga nag-ambag`,
	fr: (count) => `${count} contributeurs`,
	hi: (count) => `${count} योगदानकर्ता`,
	ht: (count) => `${count} kontribitè yo`,
	it: (count) => `${count} collaboratori`,
	ja: (count) => `${count} 人の寄稿者`,
	ko: (count) => `${count} 명의 기여자`,
	mww: (count) => `${count} cov neeg koom tes`,
	ps: (count) => `${count} همکاران`,
	pt: (count) => `${count} colaboradores`,
	'pt-pt': (count) => `${count} colaboradores`,
	ru: (count) => `${count} участников`,
	sm: (count) => `${count} tagata fai saofaga`,
	so: (count) => `${count} qoraayaal`,
	th: (count) => `ผู้ร่วมให้ข้อมูล ${count} คน`,
	ur: (count) => `${count} معاونین`,
	vi: (count) => `${count} người đóng góp`,
	'zh-hans': (count) => `${count} 位贡献者`,
	'zh-hant': (count) => `${count} 位貢獻者`,
	en: (count) => `${count} contributors`
};

export const loc_multipleEarlierVersions: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} إصدارات سابقة`,
	de: (count) => `${count} Frühere Versionen`,
	es: (count) => `${count} versiones anteriores`,
	fa: (count) => `${count} نسخه های قبلی`,
	fil: (count) => `${count} naunang mga bersyon`,
	fr: (count) => `${count} versions antérieures`,
	hi: (count) => `${count} पुराने संस्करण`,
	ht: (count) => `${count} vèsyon anvan yo`,
	it: (count) => `${count} versioni precedenti`,
	ja: (count) => `${count} つの初期バージョン`,
	ko: (count) => `${count} 개의 이전 버전`,
	mww: (count) => `${count} ua ntej versions`,
	ps: (count) => `${count} پخوانۍ نسخې`,
	pt: (count) => `${count} versões anteriores`,
	'pt-pt': (count) => `${count} versões anteriores`,
	ru: (count) => `${count} ранних версий`,
	sm: (count) => `${count} lomiga muamua`,
	so: (count) => `${count} nooc oo hore`,
	th: (count) => `${count} เวอร์ชันก่อนหน้า`,
	ur: (count) => `${count} پرانے ورژنز`,
	vi: (count) => `${count} Phiên bản trước đó`,
	'zh-hans': (count) => `${count} 个早期版本`,
	'zh-hant': (count) => `${count} 個早期版本`,
	en: (count) => `${count} earlier versions`
};

export const loc_multipleEventsFoundFormat: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} أحداث تم العثور عليها`,
	de: (count) => `${count} gefundene Ereignisse`,
	es: (count) => `${count} eventos encontrados`,
	fa: (count) => `${count} رویداد یافت شده`,
	fil: (count) => `${count} kaganapan na natagpuan`,
	fr: (count) => `${count} événements trouvés`,
	hi: (count) => `${count} इवेंट मिले`,
	ht: (count) => `${count} Evènman yo te jwenn`,
	it: (count) => `${count} eventi trovati`,
	ja: (count) => `${count} つの出来事が発見されました`,
	ko: (count) => `${count} 개의 사건이 발견되었습니다`,
	mww: (count) => `${count} qhov xwm txheej pom`,
	ps: (count) => `${count} پیښې موندل شوې`,
	pt: (count) => `${count} eventos encontrados`,
	'pt-pt': (count) => `${count} eventos encontrados`,
	ru: (count) => `${count} найденных событий`,
	sm: (count) => `${count} mea na tutupu na maua`,
	so: (count) => `${count} dhacdo oo la helay`,
	th: (count) => `พบเหตุการณ์ ${count} รายการ`,
	ur: (count) => `${count} واقعات`,
	vi: (count) => `Tìm thấy ${count} sự kiện`,
	'zh-hans': (count) => `5个${count}`,
	'zh-hant': (count) => `5 ${count}`,
	en: (count) => `${count} events found`
};

export const loc_multipleFilesFormat: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} ملفات`,
	de: (count) => `${count} Akten`,
	es: (count) => `${count} archivos`,
	fa: (count) => `${count} فایل`,
	fil: (count) => `${count} Mga File`,
	fr: (count) => `${count} fichiers`,
	hi: (count) => `${count} फ़ाइलें`,
	ht: (count) => `${count} dosye`,
	it: (count) => `${count} file`,
	ja: (count) => `${count} つのファイル`,
	ko: (count) => `${count} 개의 파일`,
	mww: (count) => `${count} cov ntaub ntawv`,
	ps: (count) => `${count} فایلونه`,
	pt: (count) => `${count} arquivos`,
	'pt-pt': (count) => `${count} ficheiros`,
	ru: (count) => `${count} файла`,
	sm: (count) => `${count} faila`,
	so: (count) => `${count} faylal`,
	th: (count) => `${count} ไฟล์`,
	ur: (count) => `${count} فائلیں`,
	vi: (count) => `${count} tập tin`,
	'zh-hans': (count) => `${count} 个文件`,
	'zh-hant': (count) => `${count} 個檔案`,
	en: (count) => `${count} files`
};

export const loc_multipleMedicationsFormat: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} أدوية`,
	de: (count) => `${count} Medikamente`,
	es: (count) => `${count} medicamentos`,
	fa: (count) => `${count} دارو`,
	fil: (count) => `${count} gamot`,
	fr: (count) => `${count} médicaments`,
	hi: (count) => `${count} दवाएं`,
	ht: (count) => `${count} medikaman`,
	it: (count) => `${count} farmaci`,
	ja: (count) => `${count} つの薬`,
	ko: (count) => `${count} 가지 약물`,
	mww: (count) => `${count} tshuaj`,
	ps: (count) => `${count} درمل`,
	pt: (count) => `${count} medicamentos`,
	'pt-pt': (count) => `${count} medicamentos`,
	ru: (count) => `${count} лекарства`,
	sm: (count) => `${count} vaila'au`,
	so: (count) => `${count} Daawo`,
	th: (count) => `${count} ยา`,
	ur: (count) => `${count} ادویات`,
	vi: (count) => `${count} Thuốc`,
	'zh-hans': (count) => `${count} 种药物`,
	'zh-hant': (count) => `${count} 種藥物`,
	en: (count) => `${count} medications`
};

export const loc_multipleOrganizations: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} منظمات`,
	de: (count) => `${count} Organisationen`,
	es: (count) => `${count} organizaciones`,
	fa: (count) => `${count} سازمان`,
	fil: (count) => `${count} Mga Organisasyon`,
	fr: (count) => `${count} organisations`,
	hi: (count) => `${count} संगठन`,
	ht: (count) => `${count} òganizasyon`,
	it: (count) => `${count} organizzazioni`,
	ja: (count) => `${count} つの組織`,
	ko: (count) => `${count} 개 조직`,
	mww: (count) => `${count} lub koom haum`,
	ps: (count) => `${count} سازمانونه`,
	pt: (count) => `${count} organizações`,
	'pt-pt': (count) => `${count} organizações`,
	ru: (count) => `${count} организаций`,
	sm: (count) => `${count} fa'alapotopotoga`,
	so: (count) => `${count} Urur`,
	th: (count) => `${count} องค์กร`,
	ur: (count) => `${count} تنظیمیں`,
	vi: (count) => `${count} Tổ chức`,
	'zh-hans': (count) => `${count} 个组织`,
	'zh-hant': (count) => `${count} 個組織`,
	en: (count) => `${count} organizations`
};

export const loc_multipleParticipants: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} مشاركون`,
	de: (count) => `${count} Teilnehmer`,
	es: (count) => `${count} participantes`,
	fa: (count) => `${count} شرکت کننده`,
	fil: (count) => `${count} kalahok`,
	fr: (count) => `${count} participants`,
	hi: (count) => `${count} प्रतिभागी`,
	ht: (count) => `${count} patisipan yo`,
	it: (count) => `${count} partecipanti`,
	ja: (count) => `${count} 名`,
	ko: (count) => `${count} 명의 참가자`,
	mww: (count) => `${count} tus neeg koom nrog`,
	ps: (count) => `${count} ګډونوال`,
	pt: (count) => `${count} participantes`,
	'pt-pt': (count) => `${count} participantes`,
	ru: (count) => `${count} участников`,
	sm: (count) => `${count} tagata auai`,
	so: (count) => `${count} ka qaybgalayaal`,
	th: (count) => `ผู้เข้าร่วม ${count} คน`,
	ur: (count) => `${count} شرکاء`,
	vi: (count) => `${count} người tham gia`,
	'zh-hans': (count) => `${count} 名参赛者`,
	'zh-hant': (count) => `${count} 名參賽者`,
	en: (count) => `${count} participants`
};

export const loc_multipleSignaturesFormat: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} توقيعات`,
	de: (count) => `${count} Unterschriften`,
	es: (count) => `${count} firmas`,
	fa: (count) => `${count} امضا`,
	fil: (count) => `${count} lagda`,
	fr: (count) => `${count} signatures`,
	hi: (count) => `${count} हस्ताक्षर`,
	ht: (count) => `${count} siyati`,
	it: (count) => `${count} firme`,
	ja: (count) => `${count} つの署名`,
	ko: (count) => `${count} 개`,
	mww: (count) => `${count} kos npe`,
	ps: (count) => `${count} لاسلیکونه`,
	pt: (count) => `${count} assinaturas`,
	'pt-pt': (count) => `${count} assinaturas`,
	ru: (count) => `${count} подписи`,
	sm: (count) => `${count} saini`,
	so: (count) => `${count} saxiix`,
	th: (count) => `${count} ลายเซ็น`,
	ur: (count) => `${count} دستخط`,
	vi: (count) => `${count} chữ ký`,
	'zh-hans': (count) => `${count} 个签名`,
	'zh-hant': (count) => `${count} 個簽名`,
	en: (count) => `${count} signatures`
};

export const loc_myLocation: Record<Locale, string> = {
	ar: `موقعي`,
	de: `Mein Standort`,
	es: `Mi ubicación`,
	fa: `موقعیت من`,
	fil: `Ang aking lokasyon`,
	fr: `Ma localisation`,
	hi: `मेरा स्थान`,
	ht: `Kote mwen an`,
	it: `La mia posizione`,
	ja: `私の居場所`,
	ko: `내 위치`,
	mww: `Kuv qhov chaw nyob`,
	ps: `زما ځای`,
	pt: `Minha localização`,
	'pt-pt': `A minha localização`,
	ru: `Моё местоположение`,
	sm: `O lo'u nofoaga`,
	so: `Goobtayda`,
	th: `ตําแหน่งที่ตั้งของฉัน`,
	ur: `میرا مقام`,
	vi: `Vị trí của tôi`,
	'zh-hans': `我的位置`,
	'zh-hant': `我的位置`,
	en: `My location`
};

export const loc_name: Record<Locale, string> = {
	ar: `الاسم`,
	de: `Name`,
	es: `Nombre`,
	fa: `نام`,
	fil: `Pangalan`,
	fr: `Nom`,
	hi: `नाम`,
	ht: `Fe-apel`,
	it: `Nome`,
	ja: `名称`,
	ko: `이름`,
	mww: `Lub Npe`,
	ps: `نوم`,
	pt: `Nome`,
	'pt-pt': `Nome`,
	ru: `Название`,
	sm: `Igoa`,
	so: `Magaca`,
	th: `ชื่อ`,
	ur: `نام`,
	vi: `Tên`,
	'zh-hans': `名称`,
	'zh-hant': `名稱`,
	en: `Name`
};

export const loc_navigation: Record<Locale, string> = {
	ar: `الملاحة`,
	de: `Navigation`,
	es: `Navegación`,
	fa: `ناوبری`,
	fil: `Nabigasyon`,
	fr: `Navigation`,
	hi: `नेविगेशन`,
	ht: `Navigasyon`,
	it: `Navigazione`,
	ja: `ナビゲーション`,
	ko: `항해`,
	mww: `Kev taw qhia`,
	ps: `نیویګیشن`,
	pt: `Navegação`,
	'pt-pt': `Navegação`,
	ru: `Навигация`,
	sm: `Fa'atautaia`,
	so: `Navigation-ka`,
	th: `การเดินเรือ`,
	ur: `نیویگیشن`,
	vi: `Điều hướng`,
	'zh-hans': `导航`,
	'zh-hant': `導航`,
	en: `Navigation`
};

export const loc_nearAddressFormat: Record<Locale, (address: unknown) => string> = {
	ar: (address) => `بالقرب من ${address}`,
	de: (address) => `In der Nähe ${address}`,
	es: (address) => `Cerca ${address}`,
	fa: (address) => `نزدیک ${address}`,
	fil: (address) => `Malapit sa ${address}`,
	fr: (address) => `Près ${address}`,
	hi: (address) => `${address} के पास`,
	ht: (address) => `Toupre ${address}`,
	it: (address) => `Vicino ${address}`,
	ja: (address) => `ワシントン${address}番地付近`,
	ko: (address) => `워${address} 근처입니다.`,
	mww: (address) => `Nyob ze ${address}`,
	ps: (address) => `د ${address} ته نږدې`,
	pt: (address) => `Perto ${address}`,
	'pt-pt': (address) => `Perto ${address}`,
	ru: (address) => `Рядом с ${address}`,
	sm: (address) => `Latalata i ${address}`,
	so: (address) => `Agagaarka ${address}`,
	th: (address) => `Near ${address}`,
	ur: (address) => `${address} کے قریب`,
	vi: (address) => `Gần ${address}`,
	'zh-hans': (address) => `靠近${address}号`,
	'zh-hant': (address) => `靠近${address}號`,
	en: (address) => `Near ${address}`
};

export const loc_neighborhood: Record<Locale, string> = {
	ar: `الحي`,
	de: `Nachbarschaft`,
	es: `Barrio`,
	fa: `محله`,
	fil: `Kapitbahayan`,
	fr: `Quartier`,
	hi: `पड़ोस`,
	ht: `Katye`,
	it: `Quartiere`,
	ja: `近隣`,
	ko: `동네`,
	mww: `Neeg Zej Zog`,
	ps: `ګاونډ`,
	pt: `Bairro`,
	'pt-pt': `Bairro`,
	ru: `Район`,
	sm: `Tuaoi`,
	so: `Xaafadda`,
	th: `ย่านที่พัก`,
	ur: `محلہ`,
	vi: `Khu vực lân cận`,
	'zh-hans': `社区`,
	'zh-hant': `社區`,
	en: `Neighborhood`
};

export const loc_never: Record<Locale, string> = {
	ar: `أبدا`,
	de: `Niemals`,
	es: `Nunca`,
	fa: `هرگز`,
	fil: `Hindi kailanman`,
	fr: `Jamais`,
	hi: `कभी नहीं`,
	ht: `Pa janm`,
	it: `Mai`,
	ja: `絶対に`,
	ko: `절대 안 돼`,
	mww: `yeej tsis tau`,
	ps: `هیڅکله`,
	pt: `Nunca`,
	'pt-pt': `Nunca`,
	ru: `Никогда`,
	sm: `E le'i`,
	so: `Marnaba`,
	th: `ไม่เคย`,
	ur: `کبھی نہیں`,
	vi: `Không bao giờ`,
	'zh-hans': `绝不`,
	'zh-hant': `絕不`,
	en: `Never`
};

export const loc_new: Record<Locale, string> = {
	ar: `الجديد`,
	de: `Neu`,
	es: `Nuevo`,
	fa: `جدید`,
	fil: `Bago`,
	fr: `Nouveau`,
	hi: `नया`,
	ht: `Nouvo`,
	it: `Nuovo`,
	ja: `新作`,
	ko: `신규`,
	mww: `Tshiab`,
	ps: `نوی`,
	pt: `Novo`,
	'pt-pt': `Novo`,
	ru: `Новинка`,
	sm: `Fou`,
	so: `Cusub`,
	th: `ใหม่`,
	ur: `نیا`,
	vi: `Mới`,
	'zh-hans': `新`,
	'zh-hant': `新`,
	en: `New`
};

export const loc_newActivity: Record<Locale, string> = {
	ar: `نشاط جديد`,
	de: `Neue Aktivitäten`,
	es: `Nueva actividad`,
	fa: `فعالیت های جدید`,
	fil: `Bagong aktibidad`,
	fr: `Nouvelle activité`,
	hi: `नई गतिविधि`,
	ht: `Nouvo aktivite`,
	it: `Nuove attività`,
	ja: `新しい活動`,
	ko: `새로운 활동`,
	mww: `Kev ua haujlwm tshiab`,
	ps: `نوې فعالیت`,
	pt: `Nova atividade`,
	'pt-pt': `Nova atividade`,
	ru: `Новая деятельность`,
	sm: `Gaoioiga fou`,
	so: `Hawlaha cusub`,
	th: `กิจกรรมใหม่`,
	ur: `نئی سرگرمی`,
	vi: `Hoạt động mới`,
	'zh-hans': `新活动`,
	'zh-hant': `新活動`,
	en: `New activity`
};

export const loc_newActivityDefinition: Record<Locale, string> = {
	ar: `تعريف النشاط الجديد`,
	de: `Neue Aktivitätsdefinition`,
	es: `Nueva definición de actividad`,
	fa: `تعریف جدید فعالیت`,
	fil: `Bagong kahulugan ng aktibidad`,
	fr: `Nouvelle définition de l’activité`,
	hi: `नई गतिविधि परिभाषा`,
	ht: `Nouvo definisyon aktivite`,
	it: `Nuova definizione di attività`,
	ja: `新しい活動の定義`,
	ko: `새로운 활동 정의`,
	mww: `Tshiab kev ua ub no txhais`,
	ps: `نوې فعالیت تعریف`,
	pt: `Nova definição de atividade`,
	'pt-pt': `Nova definição de atividade`,
	ru: `Новое определение деятельности`,
	sm: `Fa'auigaga fou o gaioiga`,
	so: `Qeexid hawl cusub`,
	th: `คําจํากัดความกิจกรรมใหม่`,
	ur: `نئی سرگرمی کی تعریف`,
	vi: `Định nghĩa hoạt động mới`,
	'zh-hans': `新活动定义`,
	'zh-hant': `新活動定義`,
	en: `New activity definition`
};

export const loc_newActivityPersonCreateFormat: Record<Locale, (activityTitle: unknown) => TemplateResult> = {
	ar: (activityTitle) => html`<strong>${activityTitle} جديدة</strong>: أنشئ شخصا جديدا`,
	de: (activityTitle) => html`<strong>Neue ${activityTitle}</strong> Erstelle eine neue Person`,
	es: (activityTitle) => html`<strong>Nueva ${activityTitle}</strong>: crea una nueva persona`,
	fa: (activityTitle) => html`<strong>${activityTitle} جدید</strong>: ایجاد یک فرد جدید`,
	fil: (activityTitle) => html`<strong>Bagong ${activityTitle}</strong>: Lumikha ng Bagong Tao`,
	fr: (activityTitle) => html`<strong>Nouvelle ${activityTitle}</strong> : créez une nouvelle personne`,
	hi: (activityTitle) => html`<strong>नया ${activityTitle}</strong>: एक नया व्यक्ति बनाएं`,
	ht: (activityTitle) => html`<strong>Nouvo ${activityTitle}</strong>: kreye yon nouvo moun`,
	it: (activityTitle) => html`<strong>Nuova ${activityTitle}</strong>: crea una nuova persona`,
	ja: (activityTitle) => html`<strong>新しい ${activityTitle}</strong>:新しい人を作成する`,
	ko: (activityTitle) => html`<strong>새 ${activityTitle}</strong>: 새로운 사람을 만드세요`,
	mww: (activityTitle) => html`Kev <strong>${activityTitle} mus</strong> tshiab: tsim ib tus neeg tshiab`,
	ps: (activityTitle) => html`<strong>نوې ${activityTitle}</strong>: یو نوی کس پیدا کړئ`,
	pt: (activityTitle) => html`<strong>Nova ${activityTitle}</strong>: crie uma nova pessoa`,
	'pt-pt': (activityTitle) => html`<strong>Nova ${activityTitle}</strong>: crie uma nova pessoa`,
	ru: (activityTitle) => html`<strong>Новая ${activityTitle}</strong>: создайте нового человека`,
	sm: (activityTitle) => html`<strong>${activityTitle}</strong>: Fausia se Tagata Fou`,
	so: (activityTitle) => html`<strong>${activityTitle} cusub</strong>: samee qof cusub`,
	th: (activityTitle) => html`<strong>${activityTitle}ใหม่</strong>: สร้างบุคคลใหม่`,
	ur: (activityTitle) => html`<strong>نیا ${activityTitle}</strong>: ایک نیا شخص بنائیں`,
	vi: (activityTitle) => html`Giới <strong>${activityTitle} mới</strong>: tạo người mới`,
	'zh-hans': (activityTitle) => html`<strong>新 ${activityTitle}</strong>：创建一个新人`,
	'zh-hant': (activityTitle) => html`<strong>新 ${activityTitle}</strong>：創建新對象`,
	en: (activityTitle) => html`<strong>New ${activityTitle}</strong>: create a new person`
};

export const loc_newActivityPersonSearchFormat: Record<Locale, (activityTitle: unknown) => TemplateResult> = {
	ar: (activityTitle) => html`<strong>${activityTitle} جديدة</strong>: ابحث عن شخص`,
	de: (activityTitle) => html`<strong>Neue ${activityTitle}</strong> Suche nach einer Person`,
	es: (activityTitle) => html`<strong>Nueva ${activityTitle}</strong>: busca a una persona`,
	fa: (activityTitle) => html`<strong>${activityTitle} جدید</strong>: جستجو برای یک فرد`,
	fil: (activityTitle) => html`<strong>Bagong ${activityTitle}</strong>: Paghahanap ng Isang Tao`,
	fr: (activityTitle) => html`<strong>Nouvelle ${activityTitle}</strong> : recherche une personne`,
	hi: (activityTitle) => html`<strong>नया ${activityTitle}</strong>: किसी व्यक्ति की खोज करें`,
	ht: (activityTitle) => html`<strong>Nouvo ${activityTitle}</strong>: rechèch pou yon moun`,
	it: (activityTitle) => html`<strong>Nuova ${activityTitle}</strong>: cerca una persona`,
	ja: (activityTitle) => html`<strong>新しい ${activityTitle}</strong>:人を検索する`,
	ko: (activityTitle) => html`<strong>새 ${activityTitle}</strong>: 사람을 찾아`,
	mww: (activityTitle) => html`Kev <strong>${activityTitle} tshiab</strong>: nrhiav ib tus neeg`,
	ps: (activityTitle) => html`<strong>نوې ${activityTitle}</strong> کول: د یو کس لټون وکړئ`,
	pt: (activityTitle) => html`<strong>Nova ${activityTitle}</strong>: procure por uma pessoa`,
	'pt-pt': (activityTitle) => html`<strong>Nova ${activityTitle}</strong>: procura uma pessoa`,
	ru: (activityTitle) => html`<strong>Новое ${activityTitle}</strong>: поиск человека`,
	sm: (activityTitle) => html`<strong>${activityTitle}</strong>: Saili se Tagata`,
	so: (activityTitle) => html`<strong>${activityTitle} cusub</strong>: raadi qof`,
	th: (activityTitle) => html`<strong>${activityTitle}ใหม่</strong>: ค้นหาบุคคล`,
	ur: (activityTitle) => html`<strong>نیا ${activityTitle}</strong>: کسی شخص کی تلاش کریں`,
	vi: (activityTitle) => html`Giới <strong>${activityTitle} mới</strong>: tìm kiếm một người`,
	'zh-hans': (activityTitle) => html`<strong>新 ${activityTitle}</strong>：搜索某人`,
	'zh-hant': (activityTitle) => html`<strong>新 ${activityTitle}</strong>：搜尋某人`,
	en: (activityTitle) => html`<strong>New ${activityTitle}</strong>: search for a person`
};

export const loc_newActivitySelectParentActivityFormat: Record<Locale, (activityTitle: unknown) => TemplateResult> = {
	ar: (activityTitle) => html`<strong>${activityTitle} جديدة</strong>: اختر النشاط الذي سيرتبط به ${activityTitle} الجديدة`,
	de: (activityTitle) => html`<strong>Neue ${activityTitle}</strong>: Wählen Sie die Aktivität aus, mit der die neue ${activityTitle} verknüpft sein wird`,
	es: (activityTitle) => html`<strong>Nueva ${activityTitle}</strong>: selecciona la actividad con la que se asociará la nueva ${activityTitle}`,
	fa: (activityTitle) => html`<strong>${activityTitle} جدید</strong>: فعالیتی را انتخاب کنید که ${activityTitle} جدید با آن مرتبط خواهد بود`,
	fil: (activityTitle) => html`<strong>Bagong ${activityTitle}</strong>: piliin ang aktibidad na maiuugnay sa bagong ${activityTitle}`,
	fr: (activityTitle) => html`<strong>Nouvelle ${activityTitle}</strong> : sélectionnez l’activité à laquelle la nouvelle ${activityTitle} sera associée`,
	hi: (activityTitle) => html`<strong>नया ${activityTitle}</strong>: उस गतिविधि का चयन करें जिससे नया ${activityTitle} संबद्ध होगा`,
	ht: (activityTitle) => html`<strong>Nouvo ${activityTitle}</strong>: chwazi aktivite nouvo ${activityTitle} lan pral asosye avèk`,
	it: (activityTitle) => html`<strong>Nuova ${activityTitle}</strong>: seleziona l'attività a cui la nuova ${activityTitle} sarà associata`,
	ja: (activityTitle) => html`<strong>新しい ${activityTitle}</strong>:新しい ${activityTitle} が関連付けられる活動を選択します`,
	ko: (activityTitle) => html`<strong>신규 ${activityTitle}</strong>: 새 ${activityTitle} 가 연관될 활동을 선택하세요`,
	mww: (activityTitle) => html`Kev <strong>${activityTitle} mus tshiab</strong>: xaiv qhov haujlwm uas yuav ${activityTitle} lwm tus tshiab`,
	ps: (activityTitle) => html`<strong>نوې ${activityTitle}</strong>: هغه فعالیت وټاکه چې نوی ${activityTitle} کول به ورسره تړاو ولری`,
	pt: (activityTitle) => html`<strong>Nova ${activityTitle}</strong>: selecione a atividade à qual a nova ${activityTitle} estará associada`,
	'pt-pt': (activityTitle) => html`<strong>Nova ${activityTitle}</strong>: selecione a atividade à qual a nova ${activityTitle} estará associada`,
	ru: (activityTitle) => html`<strong>Новое ${activityTitle}</strong>: выберите деятельность, с которой будет ${activityTitle}`,
	sm: (activityTitle) => html`<strong>${activityTitle} fou</strong>: filifili le gaioiga o le a feso'ota'i ma le ${activityTitle} fou`,
	so: (activityTitle) => html`<strong>${activityTitle} cusub</strong>: dooro hawsha uu ${activityTitle} cusub la xiriiri doono`,
	th: (activityTitle) => html`<strong>${activityTitle}ใหม่</strong>: เลือกกิจกรรมที่จะเชื่อมโยงกับ${activityTitle}ใหม่`,
	ur: (activityTitle) => html`<strong>نیا ${activityTitle}</strong>: اس سرگرمی کا انتخاب کریں جس سے نیا ${activityTitle} منسلک ہوگا`,
	vi: (activityTitle) => html`Giới <strong>${activityTitle} mới</strong>: chọn hoạt động mà ${activityTitle} mới sẽ được liên kết`,
	'zh-hans': (activityTitle) => html`<strong>新 ${activityTitle}</strong>：选择新 ${activityTitle} 将关联的活动`,
	'zh-hant': (activityTitle) => html`<strong>新 ${activityTitle}</strong>：選擇該轉 ${activityTitle} 將關聯的活動`,
	en: (activityTitle) => html`<strong>New ${activityTitle}</strong>: select the activity the new ${activityTitle} will be associated with`
};

export const loc_newDashboard: Record<Locale, string> = {
	ar: `لوحة تحكم جديدة`,
	de: `Neues Armaturenbrett`,
	es: `Nuevo salpicadero`,
	fa: `داشبورد جدید`,
	fil: `Bagong dashboard`,
	fr: `Nouveau tableau de bord`,
	hi: `नया डैशबोर्ड`,
	ht: `Nouvo tablodbò`,
	it: `Nuovo cruscotto`,
	ja: `新しいダッシュボード`,
	ko: `새 대시보드`,
	mww: `Tshiab dashboard`,
	ps: `نوی ډشبورډ`,
	pt: `Novo painel`,
	'pt-pt': `Novo painel de instrumentos`,
	ru: `Новая панель управления`,
	sm: `Dashboard fou`,
	so: `Dashboard cusub`,
	th: `แดชบอร์ดใหม่`,
	ur: `نیا ڈیش بورڈ`,
	vi: `Bảng điều khiển mới`,
	'zh-hans': `新仪表盘`,
	'zh-hant': `新儀表板`,
	en: `New dashboard`
};

export const loc_newEntity: Record<Locale, (entity: unknown) => string> = {
	ar: (entity) => `${entity} جديد`,
	de: (entity) => `Neuer ${entity}`,
	es: (entity) => `${entity}`,
	fa: (entity) => `${entity} جدید`,
	fil: (entity) => `Bagong ${entity}`,
	fr: (entity) => `Nouvel ${entity}`,
	hi: (entity) => `नया ${entity}`,
	ht: (entity) => `Nouvo ${entity}`,
	it: (entity) => `Nuovo ${entity}`,
	ja: (entity) => `新 ${entity}`,
	ko: (entity) => `신 ${entity}`,
	mww: (entity) => `${entity}`,
	ps: (entity) => `نوې ${entity}`,
	pt: (entity) => `Novo ${entity}`,
	'pt-pt': (entity) => `${entity}`,
	ru: (entity) => `Новый ${entity}`,
	sm: (entity) => `${entity} fou`,
	so: (entity) => `Shayga ${entity} cusub`,
	th: (entity) => `${entity}ใหม่`,
	ur: (entity) => `نیا ${entity}`,
	vi: (entity) => `${entity} mới`,
	'zh-hans': (entity) => `新 ${entity}`,
	'zh-hant': (entity) => `新 ${entity}`,
	en: (entity) => `New ${entity}`
};

export const loc_newer: Record<Locale, string> = {
	ar: `أحدث`,
	de: `Neuere`,
	es: `Más recientes`,
	fa: `جدیدتر`,
	fil: `Mas bagong`,
	fr: `Plus récent`,
	hi: `नया`,
	ht: `Pi nouvo`,
	it: `Più recenti`,
	ja: `新しい`,
	ko: `더 신형`,
	mww: `Tshiab dua`,
	ps: `نوې`,
	pt: `Mais recentes`,
	'pt-pt': `Mais recentes`,
	ru: `Новые`,
	sm: `Fou`,
	so: `Cusub`,
	th: `ใหม่กว่า`,
	ur: `نیا`,
	vi: `Mới hơn`,
	'zh-hans': `较新的`,
	'zh-hant': `較新的`,
	en: `Newer`
};

export const loc_newPerson: Record<Locale, string> = {
	ar: `شخص جديد`,
	de: `Neue Person`,
	es: `Nueva persona`,
	fa: `شخص جدید`,
	fil: `Bagong tao`,
	fr: `Nouvelle personne`,
	hi: `नया व्यक्ति`,
	ht: `Nouvo moun`,
	it: `Persona nuova`,
	ja: `新しい人物`,
	ko: `새로운 사람`,
	mww: `tus tshiab`,
	ps: `نوی کس`,
	pt: `Pessoa nova`,
	'pt-pt': `Pessoa nova`,
	ru: `Новый человек`,
	sm: `Tagata fou`,
	so: `Qof cusub`,
	th: `คนใหม่`,
	ur: `نیا شخص`,
	vi: `Người mới`,
	'zh-hans': `新成员`,
	'zh-hant': `新成員`,
	en: `New person`
};

export const loc_newq: Record<Locale, string> = {
	ar: `جديد؟`,
	de: `Neu?`,
	es: `¿Nuevo?`,
	fa: `جدید؟`,
	fil: `Bago?`,
	fr: `Nouveau ?`,
	hi: `नया?`,
	ht: `Nouvo?`,
	it: `Nuovo?`,
	ja: `新しい?`,
	ko: `새로 온 거야?`,
	mww: `Tshiab?`,
	ps: `نوی?`,
	pt: `Novo?`,
	'pt-pt': `Novo?`,
	ru: `Новый?`,
	sm: `Fou?`,
	so: `Cusub?`,
	th: `ใหม่?`,
	ur: `نیا؟`,
	vi: `Mới?`,
	'zh-hans': `新来的？`,
	'zh-hant': `新來的？`,
	en: `New?`
};

export const loc_newReport: Record<Locale, string> = {
	ar: `تقرير جديد`,
	de: `Neuer Bericht`,
	es: `Nuevo informe`,
	fa: `گزارش جدید`,
	fil: `Bagong ulat`,
	fr: `Nouveau rapport`,
	hi: `नई रिपोर्ट`,
	ht: `Nouvo rapò`,
	it: `Nuovo rapporto`,
	ja: `新しい報告書`,
	ko: `새 보고서`,
	mww: `Daim ntawv qhia tshiab`,
	ps: `نوې راپور`,
	pt: `Novo relatório`,
	'pt-pt': `Novo relatório`,
	ru: `Новый отчет`,
	sm: `Lipoti fou`,
	so: `Warbixin cusub`,
	th: `รายงานใหม่`,
	ur: `نئی رپورٹ`,
	vi: `Báo cáo mới`,
	'zh-hans': `新报告`,
	'zh-hant': `新報告`,
	en: `New report`
};

export const loc_news: Record<Locale, string> = {
	ar: `الأخبار`,
	de: `Nachrichten`,
	es: `Noticias`,
	fa: `اخبار`,
	fil: `Balita`,
	fr: `Actualités`,
	hi: `समाचार`,
	ht: `Nouvèl`,
	it: `Notizie`,
	ja: `ニュース`,
	ko: `뉴스`,
	mww: `Xov xwm`,
	ps: `خبرونه`,
	pt: `Notícias`,
	'pt-pt': `Notícias`,
	ru: `Новости`,
	sm: `Tala Fou`,
	so: `Wararka`,
	th: `ข่าวสาร`,
	ur: `خبریں`,
	vi: `Tin tức`,
	'zh-hans': `新闻`,
	'zh-hant': `新聞`,
	en: `News`
};

export const loc_newService: Record<Locale, string> = {
	ar: `الخدمة الجديدة`,
	de: `Neuer Dienst`,
	es: `Nuevo servicio`,
	fa: `خدمت جدید`,
	fil: `Bagong serbisyo`,
	fr: `Nouveau service`,
	hi: `नई सेवा`,
	ht: `Nouvo sèvis`,
	it: `Nuovo servizio`,
	ja: `新サービス`,
	ko: `신규 서비스`,
	mww: `Kev pabcuam tshiab`,
	ps: `نوې خدمت`,
	pt: `Novo serviço`,
	'pt-pt': `Novo serviço`,
	ru: `Новая служба`,
	sm: `Auaunaga fou`,
	so: `Adeeg cusub`,
	th: `บริการใหม่`,
	ur: `نئی سروس`,
	vi: `Dịch vụ mới`,
	'zh-hans': `新服务`,
	'zh-hant': `新服務`,
	en: `New service`
};

export const loc_newServiceAuthorization: Record<Locale, string> = {
	ar: `تفويض الخدمة الجديد`,
	de: `Neue Dienstgenehmigung`,
	es: `Nueva autorización de servicio`,
	fa: `مجوز سرویس جدید`,
	fil: `Bagong pahintulot sa serbisyo`,
	fr: `Nouvelle autorisation de service`,
	hi: `नई सेवा प्राधिकरण`,
	ht: `Nouvo otorizasyon sèvis`,
	it: `Nuova autorizzazione al servizio`,
	ja: `新規サービス認可`,
	ko: `신규 서비스 승인`,
	mww: `Kev tso cai pabcuam tshiab`,
	ps: `د نوې خدمت اجازه`,
	pt: `Nova autorização de serviço`,
	'pt-pt': `Nova autorização de serviço`,
	ru: `Новое разрешение на службу`,
	sm: `Faatagaga Auaunaga Fou`,
	so: `Oggolaansho adeeg cusub`,
	th: `การอนุญาตบริการใหม่`,
	ur: `نئی سروس کی اجازت`,
	vi: `Ủy quyền dịch vụ mới`,
	'zh-hans': `新服役授权`,
	'zh-hant': `新服役授權`,
	en: `New service authorization`
};

export const loc_newTimesheet: Record<Locale, string> = {
	ar: `جدول زمني جديد`,
	de: `Neuer Stundenzettel`,
	es: `Nueva hoja de horas`,
	fa: `جدول زمانی جدید`,
	fil: `Bagong timesheet`,
	fr: `Nouvelle feuille de temps`,
	hi: `नई समय पत्रक`,
	ht: `Nouvo Timesheet`,
	it: `Nuovo foglio orari`,
	ja: `新しいタイムシート`,
	ko: `새 시간표`,
	mww: `Daim ntawv qhia sijhawm tshiab`,
	ps: `نوې وخت پاڼه`,
	pt: `Nova folha de ponto`,
	'pt-pt': `Nova folha de horas`,
	ru: `Новый табель времени`,
	sm: `Pepa o taimi fou`,
	so: `Jadwalka cusub`,
	th: `ไทม์ชีทใหม่`,
	ur: `نیا ٹائم شیٹ`,
	vi: `Bảng chấm công mới`,
	'zh-hans': `新工时表`,
	'zh-hant': `新時間表`,
	en: `New timesheet`
};

export const loc_next: Record<Locale, string> = {
	ar: `التالي`,
	de: `Als Nächstes`,
	es: `Siguiente`,
	fa: `بعدی`,
	fil: `Susunod`,
	fr: `Suivant`,
	hi: `अगला`,
	ht: `Next`,
	it: `Prossimo`,
	ja: `次`,
	ko: `다음`,
	mww: `Tom ntej no`,
	ps: `بل`,
	pt: `Próximo`,
	'pt-pt': `Próximo`,
	ru: `Далее`,
	sm: `Sosoo ai`,
	so: `Xiga`,
	th: `ต่อไป`,
	ur: `اگلا`,
	vi: `Kế tiếp`,
	'zh-hans': `下一个`,
	'zh-hant': `下一篇`,
	en: `Next`
};

export const loc_nextOfKin: Record<Locale, string> = {
	ar: `القريب من العائلة`,
	de: `Nachwuchsangehöriger`,
	es: `Parientes más cercanos`,
	fa: `خویشاوند نزدیک`,
	fil: `Susunod na kamag-anak`,
	fr: `Proche parent`,
	hi: `परिजनों के बगल में`,
	ht: `Next-of-Kin`,
	it: `Parenti più prossimi`,
	ja: `親族次`,
	ko: `친척`,
	mww: `Tom ntej-ntawm-Kin`,
	ps: `نږدې د خپلوانو`,
	pt: `Parentes mais próximos`,
	'pt-pt': `Parentes mais próximos`,
	ru: `Ближайший родственник`,
	sm: `Aiga e sosoo ai`,
	so: `Qaraabada Dhow`,
	th: `ญาติคนใกล้ชิด`,
	ur: `قریبی رشتہ دار`,
	vi: `Người thân gần nhất`,
	'zh-hans': `近亲`,
	'zh-hant': `近親`,
	en: `Next-of-Kin`
};

export const loc_nextPage: Record<Locale, string> = {
	ar: `الصفحة التالية`,
	de: `Nächste Seite`,
	es: `Página siguiente`,
	fa: `صفحه بعد`,
	fil: `Susunod na pahina`,
	fr: `Page suivante`,
	hi: `अगला पृष्ठ`,
	ht: `Pwochen paj la`,
	it: `Pagina successiva`,
	ja: `次のページ`,
	ko: `다음 페이지`,
	mww: `Nplooj ntawv tom ntej`,
	ps: `بله پاڼه`,
	pt: `Próxima página`,
	'pt-pt': `Página seguinte`,
	ru: `Следующая страница`,
	sm: `Itulau e sosoo ai`,
	so: `Bogga xiga`,
	th: `หน้าถัดไป`,
	ur: `اگلا صفحہ`,
	vi: `Trang tiếp theo`,
	'zh-hans': `下一页`,
	'zh-hant': `下一頁`,
	en: `Next page`
};

export const loc_nextSteps: Record<Locale, string> = {
	ar: `الخطوات التالية`,
	de: `Nächste Schritte`,
	es: `Próximos pasos`,
	fa: `گام های بعدی`,
	fil: `Mga susunod na hakbang`,
	fr: `Prochaines étapes`,
	hi: `अगले चरण`,
	ht: `Pwochen etap yo`,
	it: `Passi successivi`,
	ja: `今後のステップ`,
	ko: `다음 단계`,
	mww: `Kauj ruam tom ntej`,
	ps: `راتلونکی ګامونه`,
	pt: `Próximos passos`,
	'pt-pt': `Próximos passos`,
	ru: `Следующие шаги`,
	sm: `Laasaga e sosoo ai`,
	so: `Tallaabooyinka xiga`,
	th: `ขั้นตอนถัดไป`,
	ur: `اگلے اقدامات`,
	vi: `Các bước tiếp theo`,
	'zh-hans': `下一步`,
	'zh-hant': `下一步`,
	en: `Next steps`
};

export const loc_nickname: Record<Locale, string> = {
	ar: `اللقب`,
	de: `Spitzname`,
	es: `Apodo`,
	fa: `لقب`,
	fil: `Palayaw`,
	fr: `Surnom`,
	hi: `उपनाम`,
	ht: `Tinon`,
	it: `Soprannome`,
	ja: `ニックネーム`,
	ko: `별명`,
	mww: `Npe menyuam yaus`,
	ps: `لقب`,
	pt: `Apelido`,
	'pt-pt': `Alcunha`,
	ru: `Прозвище`,
	sm: `Igoa tauvalaau`,
	so: `Naanays`,
	th: `ชื่อเล่น`,
	ur: `عرفیت`,
	vi: `Biệt danh`,
	'zh-hans': `昵称`,
	'zh-hant': `綽號`,
	en: `Nickname`
};

export const loc_no: Record<Locale, string> = {
	ar: `لا`,
	de: `Nein`,
	es: `No`,
	fa: `نه`,
	fil: `Hindi`,
	fr: `Non`,
	hi: `नहीं`,
	ht: `Non`,
	it: `No`,
	ja: `いいえ`,
	ko: `아니`,
	mww: `Tsis yog`,
	ps: `نا`,
	pt: `Não`,
	'pt-pt': `Não`,
	ru: `Нет`,
	sm: `Leai`,
	so: `Maya`,
	th: `ไม่`,
	ur: `نہیں`,
	vi: `Không`,
	'zh-hans': `不`,
	'zh-hant': `不`,
	en: `No`
};

export const loc_noActiveContractWithAssignee: Record<Locale, string> = {
	ar: `لا توجد أي منظمة لديها عقد نشط مع الشخص الذي تم التفويض إليه المختار.`,
	de: `Keine Organisation hat einen aktiven Vertrag mit dem ausgewählten Empfänger.`,
	es: `Ninguna organización tiene un contrato activo con el cesionario seleccionado.`,
	fa: `هیچ سازمانی قرارداد فعالی با مأمور انتخاب شده نداشته است.`,
	fil: `Walang organisasyon ang may aktibong kontrata sa napiling assignee.`,
	fr: `Aucune organisation n’a de contrat actif avec le cessionnaire sélectionné.`,
	hi: `चयनित असाइनी के साथ किसी भी संगठन का सक्रिय अनुबंध नहीं है.`,
	ht: `Pa gen òganizasyon ki gen yon kontra aktif ak asiyen chwazi a.`,
	it: `Nessuna organizzazione ha un contratto attivo con l'assegnato selezionato.`,
	ja: `どの組織も選ばれた譲受人と有効な契約を結んでいます。`,
	ko: `어떤 조직도 선정된 파견인과 활성 계약을 맺고 있지 않습니다.`,
	mww: `Tsis muaj ib lub koom haum muaj daim ntawv cog lus nquag nrog tus neeg xaiv tsa.`,
	ps: `هیڅ سازمان د ټاکل شوی ټاکل شوی سره فعال قرارداد نه لری.`,
	pt: `Nenhuma organização possui um contrato ativo com o cessionário selecionado.`,
	'pt-pt': `Nenhuma organização tem um contrato ativo com o cessionário selecionado.`,
	ru: `Ни одна организация не имеет действующего контракта с выбранным правопреступником.`,
	sm: `E leai se fa'alapotopotoga o lo'o i ai se konekarate fa'apitoa ma le tagata ua filifilia.`,
	so: `Ma jiraan ururo heshiis firfircoon la leh qofka la doortay.`,
	th: `ไม่มีองค์กรใดที่มีสัญญาที่ใช้งานอยู่กับผู้รับมอบหมายที่เลือก`,
	ur: `کسی بھی تنظیم کا منتخب کردہ اسائنی کے ساتھ فعال معاہدہ نہیں ہوتا۔`,
	vi: `Không có tổ chức nào có hợp đồng đang hoạt động với người được chuyển nhượng đã chọn.`,
	'zh-hans': `没有任何组织与被选中的受让人签订有效合同。`,
	'zh-hant': `沒有任何組織與被選中的受派人員有有效合約。`,
	en: `No organizations have an active contract with the selected assignee.`
};

export const loc_noActiveEmployees: Record<Locale, string> = {
	ar: `لا يوجد موظفون نشطون`,
	de: `Keine aktiven Mitarbeiter`,
	es: `No hay empleados activos`,
	fa: `هیچ کارمند فعالی وجود ندارد`,
	fil: `Walang aktibong empleyado`,
	fr: `Aucun employé actif`,
	hi: `कोई सक्रिय कर्मचारी नहीं`,
	ht: `Pa gen anplwaye aktif`,
	it: `Nessun dipendente attivo`,
	ja: `現役の従業員はいない`,
	ko: `현역 직원은 없습니다`,
	mww: `Tsis muaj cov neeg ua haujlwm nquag`,
	ps: `هیڅ فعال کارکوونکی نشته`,
	pt: `Nenhum funcionário ativo`,
	'pt-pt': `Sem funcionários ativos`,
	ru: `Нет действующих сотрудников`,
	sm: `Leai ni tagata faigaluega`,
	so: `Shaqaale firfircoon ma jiraan`,
	th: `ไม่มีพนักงานที่ใช้งานอยู่`,
	ur: `کوئی فعال ملازم نہیں`,
	vi: `Không có nhân viên tích cực`,
	'zh-hans': `没有现役员工`,
	'zh-hant': `沒有現役員工`,
	en: `No active employees`
};

export const loc_noActiveOrUpcomingEvents: Record<Locale, string> = {
	ar: `لا توجد فعاليات نشطة أو قادمة`,
	de: `Keine aktiven oder bevorstehenden Veranstaltungen`,
	es: `No hay eventos activos ni próximos`,
	fa: `هیچ رویداد فعال یا آینده ای وجود ندارد`,
	fil: `Walang aktibo o paparating na mga kaganapan`,
	fr: `Aucun événement actif ou à venir`,
	hi: `कोई सक्रिय या आगामी कार्यक्रम नहीं`,
	ht: `Pa gen evènman aktif oswa kap vini`,
	it: `Nessun evento attivo o in arrivo`,
	ja: `現在進行中のイベントや今後のイベントはありません`,
	ko: `진행 중이거나 예정된 행사는 없습니다`,
	mww: `Tsis muaj active los yog tom ntej no cov txheej xwm`,
	ps: `هیڅ فعاله یا راتلونکې پیښې نشته`,
	pt: `Nenhum evento ativo ou próximo`,
	'pt-pt': `Sem eventos ativos ou futuros`,
	ru: `Активных или предстоящих мероприятий нет.`,
	sm: `Leai ni mea e tutupu pe o lo'o lumana'i`,
	so: `Ma jiraan dhacdooyin firfircoon ama soo socda`,
	th: `ไม่มีกิจกรรมที่ใช้งานอยู่หรือที่กําลังจะเกิดขึ้น`,
	ur: `کوئی فعال یا آنے والا ایونٹ نہیں`,
	vi: `Không có sự kiện đang hoạt động hoặc sắp tới`,
	'zh-hans': `没有正在进行或即将举行的活动`,
	'zh-hant': `沒有活動或即將舉辦的活動`,
	en: `No active or upcoming events`
};

export const loc_noActivities: Record<Locale, string> = {
	ar: `لا أنشطة`,
	de: `Keine Aktivitäten`,
	es: `Sin actividades`,
	fa: `هیچ فعالیتی وجود ندارد`,
	fil: `Walang mga aktibidad`,
	fr: `Aucune activité`,
	hi: `कोई गतिविधि नहीं`,
	ht: `Pa gen aktivite`,
	it: `Nessuna attività`,
	ja: `アクティビティはありません`,
	ko: `활동 없음`,
	mww: `Tsis muaj kev ua ub no`,
	ps: `هیڅ فعالیت نشته`,
	pt: `Sem atividades`,
	'pt-pt': `Sem atividades`,
	ru: `Никаких мероприятий`,
	sm: `Leai ni gaoioiga`,
	so: `Hawlo ma jiraan`,
	th: `ไม่มีกิจกรรม`,
	ur: `کوئی سرگرمی نہیں`,
	vi: `Không có hoạt động`,
	'zh-hans': `无活动`,
	'zh-hant': `無活動`,
	en: `No activities`
};

export const loc_noApplicableActivityDefinitions: Record<Locale, string> = {
	ar: `لا توجد تعريفات نشاط قابلة للتطبيق`,
	de: `Keine anwendbaren Aktivitätsdefinitionen`,
	es: `No hay definiciones de actividades aplicables`,
	fa: `هیچ تعریف فعالیتی برای فعالیت ها وجود ندارد`,
	fil: `Walang naaangkop na mga kahulugan ng aktibidad`,
	fr: `Aucune définition d’activité applicable`,
	hi: `कोई लागू गतिविधि परिभाषा नहीं`,
	ht: `Pa gen definisyon aktivite ki aplikab`,
	it: `Nessuna definizione applicabile di attività`,
	ja: `適用可能な活動定義はありません`,
	ko: `적용 가능한 활동 정의 없음`,
	mww: `Tsis muaj kev txhais ua haujlwm siv tau`,
	ps: `د فعالیت تعریفونه نشته`,
	pt: `Nenhuma definição de atividade aplicável`,
	'pt-pt': `Sem definições de atividade aplicáveis`,
	ru: `Нет применимых определений деятельности`,
	sm: `E leai ni faauigaga talafeagai o gaoioiga`,
	so: `Ma jiraan qeexitaanno hawleed oo khuseynaya`,
	th: `ไม่มีคําจํากัดความของกิจกรรมที่เกี่ยวข้อง`,
	ur: `کوئی قابل اطلاق سرگرمی کی تعریفیں نہیں`,
	vi: `Không có định nghĩa hoạt động áp dụng`,
	'zh-hans': `无适用的活动定义`,
	'zh-hant': `無適用的活動定義`,
	en: `No applicable activity definitions`
};

export const loc_noAssociatedActivities: Record<Locale, string> = {
	ar: `لا توجد أنشطة مرتبطة`,
	de: `Es gibt keine damit verbundenen Aktivitäten`,
	es: `No hay actividades asociadas`,
	fa: `هیچ فعالیت مرتبطی وجود ندارد`,
	fil: `Walang mga kaugnay na aktibidad`,
	fr: `Il n’y a pas d’activités associées`,
	hi: `कोई संबद्ध गतिविधियाँ नहीं हैं`,
	ht: `Pa gen okenn aktivite ki asosye`,
	it: `Non ci sono attività associate`,
	ja: `関連する活動はありません`,
	ko: `관련 활동은 없습니다`,
	mww: `Tsis muaj kev ua ub no`,
	ps: `هیڅ اړوند فعالیتونه نشته`,
	pt: `Não há atividades associadas`,
	'pt-pt': `Não existem atividades associadas`,
	ru: `Сопутствующих активностей нет.`,
	sm: `E leai ni gaioiga e feso'ota'i`,
	so: `Ma jiraan hawlo la xiriira`,
	th: `ไม่มีกิจกรรมที่เกี่ยวข้อง`,
	ur: `کوئی متعلقہ سرگرمیاں نہیں ہیں`,
	vi: `Không có hoạt động liên quan`,
	'zh-hans': `没有相关的活动`,
	'zh-hant': `沒有相關的活動`,
	en: `There are no associated activities`
};

export const loc_noAssociatedActivitiesOnThisPage: Record<Locale, string> = {
	ar: `لا توجد أنشطة مرتبطة بهذه الصفحة`,
	de: `Auf dieser Seite gibt es keine zugehörigen Aktivitäten`,
	es: `No hay actividades asociadas en esta página`,
	fa: `هیچ فعالیت مرتبطی در این صفحه وجود ندارد`,
	fil: `Walang mga kaugnay na aktibidad sa pahinang ito`,
	fr: `Aucune activité associée n’est disponible sur cette page`,
	hi: `इस पृष्ठ पर कोई संबद्ध गतिविधियाँ नहीं हैं`,
	ht: `Pa gen okenn aktivite ki asosye sou paj sa a`,
	it: `Non ci sono attività associate a questa pagina`,
	ja: `このページには関連するアクティビティはありません`,
	ko: `이 페이지에는 관련 활동이 없습니다`,
	mww: `Tsis muaj cov haujlwm cuam tshuam rau ntawm nplooj ntawv no`,
	ps: `په دې پاڼه کې هیڅ اړوند فعالیتونه نشته`,
	pt: `Não há atividades associadas nesta página`,
	'pt-pt': `Não existem atividades associadas nesta página`,
	ru: `На этой странице нет связанных с этим занятий`,
	sm: `E leai ni gaioiga e feso'ota'i i luga o lenei itulau`,
	so: `Boggan ma jiraan hawlo la xiriira`,
	th: `ไม่มีกิจกรรมที่เกี่ยวข้องในหน้านี้`,
	ur: `اس صفحے پر کوئی متعلقہ سرگرمیاں نہیں ہیں`,
	vi: `Không có hoạt động nào được liên kết trên trang này`,
	'zh-hans': `本页无相关活动`,
	'zh-hant': `本頁無相關活動`,
	en: `There are no associated activities on this page`
};

export const loc_noBudgetsFound: Record<Locale, string> = {
	ar: `لم يتم العثور على ميزانيات`,
	de: `Keine Budgets gefunden`,
	es: `No se han encontrado presupuestos`,
	fa: `بودجه ای پیدا نشد.`,
	fil: `Walang natagpuang badyet`,
	fr: `Aucun budget trouvé`,
	hi: `कोई बजट नहीं मिला`,
	ht: `Pa gen bidjè yo te jwenn`,
	it: `Nessun budget trovato`,
	ja: `予算は見つかりませんでした`,
	ko: `예산은 찾지 못했습니다`,
	mww: `Tsis muaj peev nyiaj nrhiav tau`,
	ps: `هیڅ بودیجه ونه موندل شوه`,
	pt: `Nenhum orçamento encontrado`,
	'pt-pt': `Sem orçamentos encontrados`,
	ru: `Бюджетов не найдено`,
	sm: `E leai ni paketi na maua`,
	so: `Miisaaniyad lama helin`,
	th: `ไม่พบงบประมาณ`,
	ur: `کوئی بجٹ نہیں ملا`,
	vi: `Không tìm thấy ngân sách`,
	'zh-hans': `未找到预算`,
	'zh-hant': `未找到任何預算`,
	en: `No budgets found`
};

export const loc_noCaps: Record<Locale, string> = {
	ar: `لا توجد أغطية`,
	de: `Keine Kappen`,
	es: `Sin gorras`,
	fa: `بدون درپوش`,
	fil: `Walang mga takip`,
	fr: `Pas de capuchons`,
	hi: `कोई टोपी नहीं`,
	ht: `Pa gen bouchon`,
	it: `Senza cappucci`,
	ja: `大文字は使わない`,
	ko: `대문자 없음`,
	mww: `Tsis muaj lub kaus mom`,
	ps: `هیڅ کپونه نشته`,
	pt: `Sem tampas`,
	'pt-pt': `Sem tampas`,
	ru: `Без кепков`,
	sm: `Leai ni pulou`,
	so: `Ma jiraan koobab`,
	th: `ไม่มีตัวพิมพ์ใหญ่`,
	ur: `کوئی کیپ نہیں`,
	vi: `Không có chữ hoa`,
	'zh-hans': `没有大写`,
	'zh-hant': `沒有大寫`,
	en: `No caps`
};

export const loc_noCaseManager: Record<Locale, string> = {
	ar: `لا يوجد مدير حالة معين`,
	de: `Kein Fallmanager zugewiesen`,
	es: `No hay gestor de caso asignado`,
	fa: `هیچ مدیر پرونده ای تعیین نشده است`,
	fil: `Walang case manager na nakatalaga`,
	fr: `Aucun gestionnaire de dossier assigné`,
	hi: `कोई मामला प्रबंधक असाइन नहीं किया गया`,
	ht: `Pa gen manadjè ka asiyen`,
	it: `Nessun case manager assegnato`,
	ja: `ケースマネージャーは割り当てられていません`,
	ko: `사례 관리자 배치 없음`,
	mww: `Tsis muaj tus neeg saib xyuas rooj plaub`,
	ps: `د قضیې مدیر نه دی ټاکل شوی`,
	pt: `Nenhum gerente de caso designado`,
	'pt-pt': `Sem gestor de caso atribuído`,
	ru: `Менеджер по делу не назначен`,
	sm: `E leai se pule o mataupu ua tofia`,
	so: `Maareeye kiis lama magacaabin`,
	th: `ไม่มีการกําหนดผู้จัดการเคส`,
	ur: `کوئی کیس مینیجر مقرر نہیں کیا گیا`,
	vi: `Không có người quản lý hồ sơ nào được chỉ định`,
	'zh-hans': `没有指定个案经理`,
	'zh-hant': `沒有指派個案管理員`,
	en: `No case manager assigned`
};

export const loc_noChildActivitiesDescriptionFormat: Record<Locale, (parentHref: unknown, parentType: unknown) => TemplateResult> = {
	ar: (parentHref, parentType) => html`للمتابعة، أنشئ السجل من <a href="${parentHref}">${parentType}</a>.`,
	de: (parentHref, parentType) => html`Um fortzufahren, erstellen Sie den Datensatz aus der <a href="${parentHref}">${parentType}</a>.`,
	es: (parentHref, parentType) => html`Para continuar, crea el registro a partir de la <a href="${parentHref}">${parentType}</a>.`,
	fa: (parentHref, parentType) => html`برای ادامه، رکورد را از <a href="${parentHref}">${parentType}</a> ایجاد کنید.`,
	fil: (parentHref, parentType) => html`Upang magpatuloy, lumikha ng talaan mula sa <a href="${parentHref}">${parentType}</a>.`,
	fr: (parentHref, parentType) => html`Pour continuer, créez le dossier à partir de la <a href="${parentHref}">${parentType}</a>.`,
	hi: (parentHref, parentType) => html`जारी रखने के लिए, <a href="${parentHref}">${parentType}</a> से रिकॉर्ड बनाएं।`,
	ht: (parentHref, parentType) => html`Pou kontinye, kreye dosye a soti nan <a href="${parentHref}">${parentType}</a> la.`,
	it: (parentHref, parentType) => html`Per continuare, crea il record dal <a href="${parentHref}">${parentType}</a>.`,
	ja: (parentHref, parentType) => html`続けて、 <a href="${parentHref}">${parentType}</a>から記録を作成してください。`,
	ko: (parentHref, parentType) => html`계속하려면, <a href="${parentHref}">${parentType}</a>에서 기록을 생성하세요.`,
	mww: (parentHref, parentType) => html`Txhawm rau txuas ntxiv, tsim cov ntaub ntawv los ntawm <a href="${parentHref}">${parentType}</a>.`,
	ps: (parentHref, parentType) => html`د دوام لپاره، د <a href="${parentHref}">${parentType}</a> کولو ریکارډ جوړ کړئ.`,
	pt: (parentHref, parentType) => html`Para continuar, crie o registro a partir do <a href="${parentHref}">${parentType}</a>.`,
	'pt-pt': (parentHref, parentType) => html`Para continuar, crie o registo a partir do <a href="${parentHref}">${parentType}</a>.`,
	ru: (parentHref, parentType) => html`Чтобы продолжить, создайте запись по <a href="${parentHref}">${parentType}</a>.`,
	sm: (parentHref, parentType) => html`Ina ia fa'aauau, fa'apipi'i le fa'amaumauga mai le <a href="${parentHref}">${parentType}</a>.`,
	so: (parentHref, parentType) => html`Si aad u sii waddo, samee diiwaanka <a href="${parentHref}">${parentType}</a>.`,
	th: (parentHref, parentType) => html`หากต้องการดําเนินการต่อ ให้สร้างบันทึกจากการ<a href="${parentHref}">${parentType}</a>`,
	ur: (parentHref, parentType) => html`آگے بڑھنے کے لیے، <a href="${parentHref}">${parentType}</a> سے ریکارڈ تیار کریں۔`,
	vi: (parentHref, parentType) => html`Để tiếp tục, hãy tạo bản ghi từ <a href="${parentHref}">${parentType}</a>.`,
	'zh-hans': (parentHref, parentType) => html`继续，从 <a href="${parentHref}">${parentType}</a>中创建记录。`,
	'zh-hant': (parentHref, parentType) => html`繼續，請從 <a href="${parentHref}">${parentType}</a>建立紀錄。`,
	en: (parentHref, parentType) => html`To continue, create the record from the <a href="${parentHref}">${parentType}</a>.`
};

export const loc_noChildActivitiesTitleFormat: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `${type} لا تسمح بأنشطة الأطفال`,
	de: (type) => `Die ${type} erlaubt keine Aktivitäten für Kinder`,
	es: (type) => `La ${type} no permite actividades infantiles`,
	fa: (type) => `${type} اجازه فعالیت های کودکان را نمی دهد`,
	fil: (type) => `Hindi pinapayagan ng ${type} ang mga aktibidad ng bata`,
	fr: (type) => `La ${type} n’autorise pas les activités pour enfants`,
	hi: (type) => `${type} बच्चे की गतिविधियों की अनुमति नहीं देता है`,
	ht: (type) => `${type} pa pèmèt aktivite timoun yo`,
	it: (type) => `Il ${type} non consente attività per bambini`,
	ja: (type) => `${type} 子どもの活動を許可していません`,
	ko: (type) => `${type} 아동 활동을 허용하지 않습니다`,
	mww: (type) => `Kev ${type} tsis pub ua si rau menyuam yaus`,
	ps: (type) => `${type} کول د ماشومانو فعالیتونو اجازه نه ورکوی`,
	pt: (type) => `${type} não permite atividades infantis`,
	'pt-pt': (type) => `${type} não permite atividades para crianças`,
	ru: (type) => `${type} на дом не разрешает занятия с детьми`,
	sm: (type) => `E le fa'atagaina e le ${type} gaioiga a tamaiti`,
	so: (type) => `${type} lagu keeno ma oggola hawlaha carruurta`,
	th: (type) => `การส่ง${type}ไม่อนุญาตให้มีกิจกรรมสําหรับเด็ก`,
	ur: (type) => `${type} بچوں کی سرگرمیوں کی اجازت نہیں دیتی`,
	vi: (type) => `Giới ${type} không cho phép các hoạt động của trẻ em`,
	'zh-hans': (type) => `送${type}不允许儿童参与活动`,
	'zh-hant': (type) => `送${type}不允許兒童活動`,
	en: (type) => `${type} does not permit child activities`
};

export const loc_noClosedActivities: Record<Locale, string> = {
	ar: `لا توجد أنشطة مغلقة`,
	de: `Keine geschlossenen Aktivitäten`,
	es: `No hay actividades cerradas`,
	fa: `فعالیت های بسته ممنوع`,
	fil: `Walang saradong aktibidad`,
	fr: `Aucune activité fermée`,
	hi: `कोई बंद गतिविधि नहीं`,
	ht: `Pa gen aktivite fèmen`,
	it: `Niente attività chiuse`,
	ja: `閉鎖された活動はありません`,
	ko: `폐쇄 활동은 없습니다`,
	mww: `Tsis muaj kev ua ub no kaw`,
	ps: `هیڅ تړلی فعالیتونه نشته`,
	pt: `Nenhuma atividade fechada`,
	'pt-pt': `Sem atividades encerradas`,
	ru: `Закрытые мероприятия запрещены`,
	sm: `Leai ni gaoioiga tapunia`,
	so: `Ma jiraan hawlo xiran`,
	th: `ไม่มีกิจกรรมปิด`,
	ur: `کوئی بند سرگرمیاں نہیں`,
	vi: `Không có hoạt động đóng cửa`,
	'zh-hans': `禁止闭门活动`,
	'zh-hant': `禁止閉門活動`,
	en: `No closed activities`
};

export const loc_noCurrentAndUpcomingFormat: Record<Locale, (org: unknown, activityTitle: unknown) => string> = {
	ar: (org, activityTitle) => `لا توجد أنشطة ${activityTitle} في ${org}.`,
	de: (org, activityTitle) => `${org} hat keine Aktivitäten für ${activityTitle} geplant.`,
	es: (org, activityTitle) => `${org} no tiene actividades programadas para ${activityTitle} .`,
	fa: (org, activityTitle) => `مرکز ${org} هیچ فعالیت ${activityTitle} برنامه ریزی نشده است.`,
	fil: (org, activityTitle) => `Ang ${org} ay walang naka-iskedyul na mga aktibidad sa ${activityTitle}.`,
	fr: (org, activityTitle) => `${org} n’a pas d’activités de ${activityTitle} programmées.`,
	hi: (org, activityTitle) => `${org} कोई ${activityTitle} गतिविधियां निर्धारित नहीं हैं।`,
	ht: (org, activityTitle) => `${org} pa gen okenn ${activityTitle} pwograme.`,
	it: (org, activityTitle) => `${org} non prevede attività di ${activityTitle} .`,
	ja: (org, activityTitle) => `${org} ングは ${activityTitle} の活動を予定していません。`,
	ko: (org, activityTitle) => `${org} ${activityTitle} 활동이 예정되어 있지 않습니다.`,
	mww: (org, activityTitle) => `${org} tsis muaj cov haujlwm hauv tsev ${activityTitle} tau teem tseg.`,
	ps: (org, activityTitle) => `${org} د ${activityTitle} فعالیتونه مهالویش نه لری.`,
	pt: (org, activityTitle) => `${org} não tem atividades ${activityTitle} .`,
	'pt-pt': (org, activityTitle) => `${org} não tem atividades ${activityTitle} .`,
	ru: (org, activityTitle) => `${org} нет запланированных ${activityTitle} .`,
	sm: (org, activityTitle) => `${org} e leai ni gaioiga a le ${activityTitle} o tui ua fa'atulagaina.`,
	so: (org, activityTitle) => `${org} ma laha hawlo ${activityTitle} oo la qorsheeyay.`,
	th: (org, activityTitle) => `${org} ไม่มีกําหนดกิจกรรม${activityTitle}`,
	ur: (org, activityTitle) => `${org} میں ${activityTitle} کی کوئی سرگرمیاں شیڈول نہیں ہیں۔`,
	vi: (org, activityTitle) => `${org} không có hoạt động ${activityTitle} nào được lên lịch.`,
	'zh-hans': (org, activityTitle) => `河${org}中心没有安排${activityTitle}活动。`,
	'zh-hant': (org, activityTitle) => `${org} 目前沒有疫苗 ${activityTitle} 活動安排。`,
	en: (org, activityTitle) => `${org} has no ${activityTitle} activities scheduled.`
};

export const loc_noDashboards: Record<Locale, string> = {
	ar: `لا توجد لوحات تحكم`,
	de: `Keine Dashboards`,
	es: `Sin salpicaderos`,
	fa: `بدون داشبورد`,
	fil: `Walang mga dashboard`,
	fr: `Pas de tableaux de bord`,
	hi: `कोई डैशबोर्ड नहीं`,
	ht: `Pa gen tablodbò`,
	it: `Nessuna cruscotta`,
	ja: `ダッシュボードはなし`,
	ko: `대시보드 없음`,
	mww: `Tsis muaj dashboards`,
	ps: `هیڅ ډشبورډ نشته`,
	pt: `Sem painéis de controle`,
	'pt-pt': `Sem tabliers`,
	ru: `Нет дашбордов`,
	sm: `Leai ni dashboard`,
	so: `Ma jiraan dashboards`,
	th: `ไม่มีแดชบอร์ด`,
	ur: `کوئی ڈیش بورڈز نہیں`,
	vi: `Không có bảng điều khiển`,
	'zh-hans': `没有仪表盘`,
	'zh-hant': `沒有儀表板`,
	en: `No dashboards`
};

export const loc_noDashboardsCreated: Record<Locale, string> = {
	ar: `لم يتم إنشاء أي لوحات تحكم حتى الآن.`,
	de: `Es wurden noch keine Dashboards erstellt.`,
	es: `Aún no se han creado paneles de control.`,
	fa: `هنوز داشبوردی ایجاد نشده است.`,
	fil: `Wala pang mga dashboard na nilikha.`,
	fr: `Aucun tableau de bord n’a encore été créé.`,
	hi: `अभी तक कोई डैशबोर्ड नहीं बनाया गया है।`,
	ht: `Pa gen tablodbò yo te kreye ankò.`,
	it: `Non sono ancora state create dashboard.`,
	ja: `ダッシュボードはまだ作成されていません。`,
	ko: `아직 대시보드는 만들어지지 않았습니다.`,
	mww: `Tsis muaj dashboards tsis tau tsim.`,
	ps: `تر اوسه هیڅ ډشبورډ نه دی جوړ شوی.`,
	pt: `Ainda não foram criados dashboards.`,
	'pt-pt': `Ainda não foram criados dashboards.`,
	ru: `Пока не созданы дашборды.`,
	sm: `E le'i faia ni dashboard i le taimi nei.`,
	so: `Dashboards weli lama abuurin.`,
	th: `ยังไม่มีการสร้างแดชบอร์ด`,
	ur: `ابھی تک کوئی ڈیش بورڈ نہیں بنایا گیا۔`,
	vi: `Chưa có bảng thông tin nào được tạo.`,
	'zh-hans': `目前还没有创建任何仪表盘。`,
	'zh-hant': `目前還沒有建立儀表板。`,
	en: `No dashboards have been created yet.`
};

export const loc_noDashboardsShared: Record<Locale, string> = {
	ar: `لم يتم مشاركة أي لوحات تحكم معك.`,
	de: `Es wurden keine Dashboards mit Ihnen geteilt.`,
	es: `No se ha compartido ningún panel contigo.`,
	fa: `هیچ داشبوردی با شما به اشتراک گذاشته نشده است.`,
	fil: `Walang mga dashboard na ibinahagi sa iyo.`,
	fr: `Aucun tableau de bord ne vous a été communiqué.`,
	hi: `आपके साथ कोई डैशबोर्ड साझा नहीं किया गया है।`,
	ht: `Pa gen tablodbò yo te pataje avèk ou.`,
	it: `Non ti sono state condivise dashboard.`,
	ja: `ダッシュボードは共有されていません。`,
	ko: `대시보드는 공유되지 않았습니다.`,
	mww: `Tsis muaj dashboards tau muab qhia rau koj.`,
	ps: `هیڅ ډشبورډ له تاسو سره نه دی شریک شوی.`,
	pt: `Nenhum painel foi compartilhado com você.`,
	'pt-pt': `Nenhum painel de controlo foi partilhado consigo.`,
	ru: `С вами не делятся панели управления.`,
	sm: `E leai ni fa'ata'ita'iga na tufatufaina atu ia te oe.`,
	so: `Dashboards laguma wadaagin adiga.`,
	th: `ไม่มีการแชร์แดชบอร์ดกับคุณ`,
	ur: `آپ کے ساتھ کوئی ڈیش بورڈ شیئر نہیں کیا گیا۔`,
	vi: `Không có bảng thông tin nào được chia sẻ với bạn.`,
	'zh-hans': `没有任何仪表盘被分享给你。`,
	'zh-hant': `沒有任何儀表板被分享給你。`,
	en: `No dashboards have been shared with you.`
};

export const loc_noDefaultSignature: Record<Locale, string> = {
	ar: `لا يوجد توقيع افتراضي`,
	de: `Keine Standardsignatur`,
	es: `Sin firma predeterminada`,
	fa: `بدون امضای پیش فرض`,
	fil: `Walang default na lagda`,
	fr: `Pas de signature par défaut`,
	hi: `कोई डिफ़ॉल्ट हस्ताक्षर नहीं`,
	ht: `Pa gen siyati default`,
	it: `Nessuna firma predefinita`,
	ja: `デフォルトの署名はありません`,
	ko: `기본 서명은 없습니다`,
	mww: `Tsis muaj lub neej ntawd kos npe`,
	ps: `هیڅ ډیفالټ لاسلیک نشته`,
	pt: `Sem assinatura padrão`,
	'pt-pt': `Sem assinatura padrão`,
	ru: `Нет стандартной подписи`,
	sm: `E leai se saini faaletonu`,
	so: `Ma jiro saxiix default ah`,
	th: `ไม่มีลายเซ็นเริ่มต้น`,
	ur: `کوئی ڈیفالٹ دستخط نہیں`,
	vi: `Không có chữ ký mặc định`,
	'zh-hans': `没有默认签名`,
	'zh-hant': `沒有預設簽名`,
	en: `No default signature`
};

export const loc_noDefaultSignatureDescription: Record<Locale, TemplateResult> = {
	ar: html`ليس لديك توقيع افتراضي بعد. استخدم زر التوقيع لتوقيع النشاط وحدد خيار <em>جعل هذا المربع الافتراضي لحفظ</em> التوقيع للاستخدام المستقبلي.`,
	de: html`Du hast noch keine Standardsignatur. Benutze die Unterschrift-Schaltfläche, um die Aktivität zu signieren, und aktiviere <em>das Feld "Mach dies zu meiner Standardsignatur",</em> um die Signatur für die Zukunft zu speichern.`,
	es: html`Aún no tienes una firma predeterminada. Usa el botón de firmar para firmar la actividad y marca la <em>casilla de hacer que esta sea mi firma predeterminada</em> para guardar la firma para uso futuro.`,
	fa: html`شما هنوز امضای پیش فرض ندارید. از دکمه امضا برای امضای فعالیت استفاده کنید و گزینه « <em>این را به عنوان امضای پیش فرض من بسازم</em> » را علامت بزنید تا امضا را برای استفاده های بعدی ذخیره کنید.`,
	fil: html`Wala ka pa ring default signature. Gamitin ang sign button para lagdaan ang aktibidad at lagyan ng tsek ang <em>kahon na gawing default kong lagda ito</em> para mai-save ang lagda para magamit sa hinaharap.`,
	fr: html`Vous n’avez pas encore de signature par défaut. Utilisez le bouton de signature pour signer l’activité et cochez la case <em>« faire de cette signature » ma signature par défaut</em> pour sauvegarder la signature pour une utilisation ultérieure.`,
	hi: html`आपके पास अभी तक कोई डिफ़ॉल्ट हस्ताक्षर नहीं है. गतिविधि पर हस्ताक्षर करने के लिए साइन बटन का उपयोग करें और भविष्य में उपयोग के लिए हस्ताक्षर को सहेजने के लिए <em>इसे मेरा डिफ़ॉल्ट हस्ताक्षर बनाएं</em> बॉक्स को चेक करें।`,
	ht: html`Ou pa gen yon siyati default ankò. Sèvi ak bouton an siyen siyen aktivite a epi tcheke la fè sa a bwat <em>siyati default mwen</em> an pou konsève pou siyati a pou itilizasyon nan lavni.`,
	it: html`Non hai ancora una firma predefinita. Usa il pulsante di firma per firmare l'attività e seleziona la casella <em>''fai questa firma di default</em> ' per salvarla per un uso futuro.`,
	ja: html`まだデフォルトの署名は持っていません。署名ボタンを使って活動に署名し、「 <em>これをデフォルトの署名にする</em> 」ボックスにチェックを入れて、署名を保存して後回の使用に使ってください。`,
	ko: html`아직 기본 서명이 없으신 거예요. 서명 버튼을 사용해 활동에 서명하고, 서명을 저장하기 위해 ' <em>이 항목을 기본 서명으로 만들기</em> ' 박스를 체크하세요.`,
	mww: html`Koj tseem tsis tau kos npe rau lub neej ntawd. Siv lub pob kos npe kos npe rau qhov kev ua ub no thiab khij <em>qhov ua qhov no kuv lub neej ntawd kos npe</em> lub thawv kom txuag tau kos npe rau yav tom ntej siv.`,
	ps: html`ته لا هم اصلی لاسلیک نه لرې. د فعالیت لاسلیک لپاره د نښې تڼۍ وکاروئ او د ' <em>دا زما د اصلی لاسلیک</em> بکس کړئ' وټاکئ ترڅو لاسلیک د راتلونکی کارونې لپاره وساتم.`,
	pt: html`Você ainda não tem uma assinatura padrão. Use o botão de assinar para assinar a atividade e marque a caixa <em>''faça essa minha assinatura padrão</em> ' para salvar a assinatura para uso futuro.`,
	'pt-pt': html`Ainda não tens uma assinatura por defeito. Usa o botão de assinar para assinar a atividade e marca a caixa <em>de 'fazer esta a minha assinatura predefinida</em> ' para guardar a assinatura para uso futuro.`,
	ru: html`У вас ещё нет стандартной подписи. Используйте кнопку подписи, чтобы подписать активность, и поставьте галочку « <em>сделать это моей стандартной подписью</em> », чтобы сохранить подпись для будущего использования.`,
	sm: html`E te le'i mauaina se saini faaletonu i le taimi nei. Faaaoga le faamau faailoga e saini ai le gaoioiga ma siaki le pusa ia <em>avea lenei ma la'u saini faaletonu</em> e sefe ai le saini mo le faaaogaina i le lumanai.`,
	so: html`Weli ma haysatid saxiix caadi ah. Isticmaal badhanka saxiixa si aad u saxiixdo hawsha oo hubiso <em>sanduuqa 'make this my default signature</em> si loo keydiyo saxiixa mustaqbalka.`,
	th: html`คุณยังไม่มีลายเซ็นเริ่มต้น ใช้ปุ่มลงชื่อเข้าใช้เพื่อลงนามในกิจกรรมและทําเครื่องหมายที่ช่อง <em>ทําให้เป็นลายเซ็นเริ่มต้นของฉัน</em> เพื่อบันทึกลายเซ็นเพื่อใช้ในอนาคต`,
	ur: html`آپ کے پاس ابھی تک ڈیفالٹ دستخط نہیں ہیں۔ سائن بٹن استعمال کریں تاکہ ایکٹیویٹی پر دستخط کریں اور ' <em>Make This my default signature</em> box' کو چیک کریں تاکہ دستخط مستقبل کے لیے محفوظ رہیں۔`,
	vi: html`Bạn chưa có chữ ký mặc định. Sử dụng nút ký để ký hoạt động và chọn hộp <em>đặt chữ ký mặc định này của tôi</em> để lưu chữ ký để sử dụng trong tương lai.`,
	'zh-hans': html`你还没有默认签名。使用签名按钮签署活动，并勾选 <em>“设为默认签名</em> ”框以保存签名以备将来使用。`,
	'zh-hant': html`你還沒有預設簽名。使用簽名按鈕簽署活動，並勾選 <em>「設為我的預設簽名</em> 」方框，以保存簽名以備未來使用。`,
	en: html`You don't have a default signature yet. Use the sign button to sign the activity and check the <em>make this my default signature</em> box to save the signature for future use.`
};

export const loc_noEntries: Record<Locale, string> = {
	ar: `لا مشاركات`,
	de: `Keine Einträge`,
	es: `No participaciones`,
	fa: `هیچ ورودی ای وجود ندارد`,
	fil: `Email Address *`,
	fr: `Aucune participation`,
	hi: `कोई प्रविष्टियाँ नहीं`,
	ht: `Pa gen antre`,
	it: `Nessuna partecipazione`,
	ja: `エントリーはありません`,
	ko: `출품 금지`,
	mww: `Tsis muaj nkag`,
	ps: `هیڅ ګډون نشته`,
	pt: `Sem inscrições`,
	'pt-pt': `Sem inscrições`,
	ru: `Заявок нет`,
	sm: `Leai ni fa'amatalaga`,
	so: `Ma jiraan wax ka qaybgal ah`,
	th: `ไม่มีรายการ`,
	ur: `کوئی اندراجات نہیں`,
	vi: `Không có mục nhập`,
	'zh-hans': `无条目`,
	'zh-hant': `無條目`,
	en: `No entries`
};

export const loc_noEventsFound: Record<Locale, string> = {
	ar: `لم يتم العثور على أحداث`,
	de: `Keine Ereignisse gefunden`,
	es: `No se han encontrado eventos`,
	fa: `رویدادی یافت نشد`,
	fil: `Walang natagpuang kaganapan`,
	fr: `Aucun événement trouvé`,
	hi: `कोई ईवेंट नहीं मिला`,
	ht: `Pa gen evènman yo te jwenn`,
	it: `Nessun evento trovato`,
	ja: `イベントは見つかりませんでした`,
	ko: `사건은 발견되지 않았습니다`,
	mww: `Tsis pom kev tshwm sim`,
	ps: `هیڅ پېښه ونه موندل شوه`,
	pt: `Nenhum evento encontrado`,
	'pt-pt': `Nenhum evento encontrado`,
	ru: `Событий не обнаружено`,
	sm: `E leai ni mea na tutupu na maua`,
	so: `Wax dhacdooyin ah lama helin`,
	th: `ไม่พบเหตุการณ์ใด ๆ`,
	ur: `کوئی واقعہ نہیں ملا`,
	vi: `Không tìm thấy sự kiện nào`,
	'zh-hans': `未发现事件`,
	'zh-hant': `未發現事件`,
	en: `No events found`
};

export const loc_noEventsFoundDescription: Record<Locale, string> = {
	ar: `حاول تغيير أو مسح واحد أو أكثر من فلاتر البحث.`,
	de: `Versuche, einen oder mehrere Suchfilter zu ändern oder zu löschen.`,
	es: `Prueba a cambiar o borrar uno o más filtros de búsqueda.`,
	fa: `سعی کنید یک یا چند فیلتر جستجو را تغییر دهید یا پاک کنید.`,
	fil: `Subukang baguhin o i-clear ang isa o higit pang search filters.`,
	fr: `Essayez de changer ou de supprimer un ou plusieurs filtres de recherche.`,
	hi: `एक या अधिक खोज फ़िल्टर बदलने या साफ़ करने का प्रयास करें.`,
	ht: `Eseye chanje oswa netwaye youn oswa plis filtè rechèch.`,
	it: `Prova a cambiare o cancellare uno o più filtri di ricerca.`,
	ja: `検索フィルターを1つ以上変更またはクリアしてみてください。`,
	ko: `하나 이상의 검색 필터를 변경하거나 지워보세요.`,
	mww: `Sim hloov lossis tshem tawm ib lossis ntau qhov lim tshawb nrhiav.`,
	ps: `یو یا څو لټون فلټرونه بدل یا پاک کړئ.`,
	pt: `Tente mudar ou limpar um ou mais filtros de busca.`,
	'pt-pt': `Tente mudar ou apagar um ou mais filtros de pesquisa.`,
	ru: `Попробуйте изменить или очистить один или несколько фильтров поиска.`,
	sm: `Taumafai e sui pe kilia se tasi pe sili atu faamama o sailiga.`,
	so: `Isku day inaad beddesho ama ka saarto hal ama in ka badan shaandhada raadinta.`,
	th: `ลองเปลี่ยนหรือล้างตัวกรองการค้นหาหนึ่งรายการหรือมากกว่านั้น`,
	ur: `ایک یا زیادہ سرچ فلٹرز کو تبدیل یا صاف کرنے کی کوشش کریں۔`,
	vi: `Hãy thử thay đổi hoặc xóa một hoặc nhiều bộ lọc tìm kiếm.`,
	'zh-hans': `试着更改或清除一个或多个搜索筛选条件。`,
	'zh-hant': `試著更改或清除一個或多個搜尋篩選器。`,
	en: `Try changing or clearing one or more search filters.`
};

export const loc_noInvoices: Record<Locale, string> = {
	ar: `لا توجد فواتير`,
	de: `Keine Rechnungen`,
	es: `Sin facturas`,
	fa: `بدون فاکتور`,
	fil: `Walang mga invoice`,
	fr: `Pas de factures`,
	hi: `कोई चालान नहीं`,
	ht: `Pa gen bòdwo`,
	it: `Nessuna fattura`,
	ja: `請求書はありません`,
	ko: `청구서가 없습니다`,
	mww: `Tsis muaj cov ntawv sau nqi`,
	ps: `هیڅ رسیدونه نشته`,
	pt: `Sem faturas`,
	'pt-pt': `Sem faturas`,
	ru: `Счетов нет.`,
	sm: `Leai ni pili`,
	so: `Ma jiraan biilal`,
	th: `ไม่มีใบแจ้งหนี้`,
	ur: `کوئی انوائس نہیں`,
	vi: `Không có hóa đơn`,
	'zh-hans': `没有发票`,
	'zh-hant': `沒有發票`,
	en: `No invoices`
};

export const loc_none: Record<Locale, string> = {
	ar: `لا شيء`,
	de: `Keine`,
	es: `Ninguno`,
	fa: `هیچ کدام`,
	fil: `Wala`,
	fr: `Aucun`,
	hi: `कोई नहीं`,
	ht: `Pa gen yonn`,
	it: `Nessuna`,
	ja: `全くありません`,
	ko: `전혀 없습니다`,
	mww: `Tsis muaj`,
	ps: `هیڅ نشته`,
	pt: `Nenhum`,
	'pt-pt': `Nenhuma`,
	ru: `Нет`,
	sm: `Leai se tasi`,
	so: `Midna ma jiro`,
	th: `ไม่มี`,
	ur: `کوئی نہیں`,
	vi: `Không có`,
	'zh-hans': `没有`,
	'zh-hant': `沒有`,
	en: `None`
};

export const loc_noOpenActivities: Record<Locale, string> = {
	ar: `لا توجد أنشطة مفتوحة`,
	de: `Keine offenen Aktivitäten`,
	es: `No hay actividades abiertas`,
	fa: `فعالیت های آزاد ممنوع است`,
	fil: `Walang bukas na aktibidad`,
	fr: `Pas d’activités ouvertes`,
	hi: `कोई खुली गतिविधि नहीं`,
	ht: `Pa gen aktivite ouvè`,
	it: `Niente attività aperte`,
	ja: `公開活動はありません`,
	ko: `공개 활동 금지`,
	mww: `Tsis muaj kev qhib kev ua ub no`,
	ps: `هیڅ خلاص فعالیت نشته`,
	pt: `Sem atividades abertas`,
	'pt-pt': `Sem atividades abertas`,
	ru: `Открытых мероприятий запрещено`,
	sm: `Leai ni gaoioiga tatala`,
	so: `Ma jiraan hawlo furan`,
	th: `ไม่มีกิจกรรมเปิด`,
	ur: `کوئی کھلی سرگرمیاں نہیں`,
	vi: `Không có hoạt động mở`,
	'zh-hans': `禁止开放活动`,
	'zh-hant': `無開放活動`,
	en: `No open activities`
};

export const loc_noOpenActivitiesFormat: Record<Locale, (name: unknown) => string> = {
	ar: (name) => `${name} لا توجد أنشطة مفتوحة`,
	de: (name) => `${name} hat keine offenen Aktivitäten`,
	es: (name) => `${name} no tiene actividades abiertas`,
	fa: (name) => `${name} هیچ فعالیت باز ندارد`,
	fil: (name) => `Si ${name} ay walang mga aktibidad na may kinalaman sa pag-aalaga`,
	fr: (name) => `${name} n’a aucune activité ouverte`,
	hi: (name) => `${name} के पास कोई खुली गतिविधि नहीं है`,
	ht: (name) => `${name} pa gen okenn aktivite ouvè`,
	it: (name) => `${name} non ha attività aperte`,
	ja: (name) => `ス${name}にはオープンな活動はありません`,
	ko: (name) => `${name} 은 공개 활동이 없습니다`,
	mww: (name) => `${name} tsis muaj kev qhib kev ua ub no`,
	ps: (name) => `${name} هیڅ خلاص فعالیتونه نه لری`,
	pt: (name) => `${name} não tem atividades abertas`,
	'pt-pt': (name) => `${name} não tem atividades abertas`,
	ru: (name) => `${name} нет открытых мероприятий`,
	sm: (name) => `${name} e leai ni gaoioiga tatala`,
	so: (name) => `${name} ma laha hawlo furan`,
	th: (name) => `${name} ไม่มีกิจกรรมเปิด`,
	ur: (name) => `${name} کے پاس کوئی کھلی سرگرمیاں نہیں ہیں`,
	vi: (name) => `${name} không có bất kỳ hoạt động mở nào`,
	'zh-hans': (name) => `史${name}没有任何公开活动`,
	'zh-hant': (name) => `史${name}沒有任何開放活動`,
	en: (name) => `${name} does not have any open activities`
};

export const loc_noParticipants: Record<Locale, string> = {
	ar: `لا يوجد مشاركون`,
	de: `Keine Teilnehmer`,
	es: `Sin participantes`,
	fa: `بدون شرکت کننده`,
	fil: `Walang mga kalahok`,
	fr: `Aucun participant`,
	hi: `कोई प्रतिभागी नहीं`,
	ht: `Pa gen patisipan yo`,
	it: `Nessun partecipante`,
	ja: `参加者はいません`,
	ko: `참가자 없음`,
	mww: `Tsis muaj neeg koom nrog`,
	ps: `هیڅ ګډونوال نشته`,
	pt: `Sem participantes`,
	'pt-pt': `Sem participantes`,
	ru: `Участников нет`,
	sm: `Leai ni tagata auai`,
	so: `Ma jiraan ka qaybgalayaal`,
	th: `ไม่มีผู้เข้าร่วม`,
	ur: `کوئی شرکاء نہیں`,
	vi: `Không có người tham gia`,
	'zh-hans': `无参与者`,
	'zh-hant': `無參與者`,
	en: `No participants`
};

export const loc_noParticipantsDescription: Record<Locale, string> = {
	ar: `حسابك غير مرتبط بأي مشارك بشكل نشط. إذا كنت تعتقد أن هذا خطأ، يرجى التواصل مع ممثل وكالتك.`,
	de: `Dein Konto ist nicht aktiv mit irgendwelchen Teilnehmern verknüpft. Wenn Sie denken, dass dies ein Fehler ist, wenden Sie sich bitte an Ihren Vertreter der Agentur.`,
	es: `Tu cuenta no está activamente asociada con ningún participante. Si crees que esto es un error, por favor contacta con el representante de tu agencia.`,
	fa: `حساب شما به طور فعال با هیچ شرکت کننده ای مرتبط نیست. اگر فکر می کنید این یک اشتباه است، لطفا با نماینده آژانس خود تماس بگیرید.`,
	fil: `Ang iyong account ay hindi aktibong nauugnay sa anumang mga kalahok. Kung sa palagay mo ay isang pagkakamali ito, mangyaring makipag-ugnay sa kinatawan ng iyong ahensya.`,
	fr: `Votre compte n’est pas activement associé à des participants. Si vous pensez qu’il s’agit d’une erreur, veuillez contacter votre représentant d’agence.`,
	hi: `आपका खाता किसी भी प्रतिभागी के साथ सक्रिय रूप से संबद्ध नहीं है. अगर आपको लगता है कि यह गलती है, तो कृपया अपनी एजेंसी के प्रतिनिधि से संपर्क करें।`,
	ht: `Kont ou se pa aktivman asosye ak nenpòt patisipan yo. Si ou panse sa a se yon erè, tanpri kontakte reprezantan ajans ou an.`,
	it: `Il tuo account non è attivamente associato a nessun partecipante. Se pensi che sia un errore, contatta il rappresentante della tua agenzia.`,
	ja: `あなたのアカウントは参加者と積極的に連携していません。もしこれが間違いだと思う場合は、所属機関の担当者にご連絡ください。`,
	ko: `귀하의 계정은 어떤 참가자와도 적극적으로 연결되어 있지 않습니다. 이것이 실수라고 생각된다면, 기관 담당자에게 연락해 주세요.`,
	mww: `Koj tus as khauj tsis nquag koom nrog ib tus neeg koom nrog. Yog koj xav tias qhov no yog ib qho yuam kev, thov hu rau koj tus neeg sawv cev rau lub koom haum.`,
	ps: `ستاسو حساب فعاله له هېڅ ګډونوال سره تړاو نه لری. که فکر کوئ دا اشتباه ده، مهربانی وکړئ له خپل ادارې استازی سره اړیکه ونیسئ.`,
	pt: `Sua conta não está ativamente associada a nenhum participante. Se você acha que isso é um erro, por favor, entre em contato com o representante da sua agência.`,
	'pt-pt': `A sua conta não está ativamente associada a nenhum participante. Se achar que isto é um erro, por favor contacte o representante da sua agência.`,
	ru: `Ваш аккаунт не связан активно с участниками. Если вы считаете, что это ошибка, пожалуйста, свяжитесь с представителем вашего агентства.`,
	sm: `E le o feso'ota'i malosi lau teuga tupe ma so'o se tagata auai. Afai e te manatu o se mea sese lenei, faamolemole faafesootai le sui o lou ofisa.`,
	so: `Akoonkaaga si firfircoon looma xiriirin cidna ka qaybgalayaasha. Haddii aad u malaynayso in tani ay khalad tahay, fadlan la xiriir wakiilka hay'addaada.`,
	th: `บัญชีของคุณไม่ได้เชื่อมโยงกับผู้เข้าร่วมใด ๆ หากคุณคิดว่านี่เป็นความผิดพลาด โปรดติดต่อตัวแทนเอเจนซี่ของคุณ`,
	ur: `آپ کا اکاؤنٹ کسی بھی شرکاء سے فعال طور پر منسلک نہیں ہے۔ اگر آپ کو لگتا ہے کہ یہ غلطی ہے تو براہ کرم اپنے ایجنسی کے نمائندے سے رابطہ کریں۔`,
	vi: `Tài khoản của bạn không được liên kết tích cực với bất kỳ người tham gia nào. Nếu bạn cho rằng đây là một sai lầm, vui lòng liên hệ với đại diện đại lý của bạn.`,
	'zh-hans': `您的账户并未与任何参与者有关联。如果您认为这是错误，请联系您的机构代表。`,
	'zh-hant': `您的帳號並未與任何參與者有積極關聯。如果您認為這是錯誤，請聯繫您的機構代表。`,
	en: `Your account is not actively associated with any participants. If you think this is a mistake, please contact your agency representative.`
};

export const loc_noReportsCreated: Record<Locale, string> = {
	ar: `لم يتم إصدار أي تقارير حتى الآن.`,
	de: `Es wurden bisher keine Berichte erstellt.`,
	es: `Aún no se han creado informes.`,
	fa: `هنوز گزارشی منتشر نشده است.`,
	fil: `Wala pang mga ulat na nabuo.`,
	fr: `Aucun rapport n’a encore été créé.`,
	hi: `अभी तक कोई रिपोर्ट नहीं बनाई गई है।`,
	ht: `Pa gen rapò yo te kreye ankò.`,
	it: `Non sono ancora state create segnalazioni.`,
	ja: `まだ報告は作成されていません。`,
	ko: `아직 보고는 접수되지 않았습니다.`,
	mww: `Tsis muaj ntawv ceeb toom tseem tsis tau tsim.`,
	ps: `تر اوسه کوم راپور نه دی جوړ شوی.`,
	pt: `Ainda não foram criados relatórios.`,
	'pt-pt': `Ainda não foram criados relatórios.`,
	ru: `Пока отчёты не составлены.`,
	sm: `E le'i faia ni lipoti i le taimi nei.`,
	so: `Warbixino weli lama helin.`,
	th: `ยังไม่มีการสร้างรายงาน`,
	ur: `ابھی تک کوئی رپورٹ تیار نہیں کی گئی ہے۔`,
	vi: `Chưa có báo cáo nào được tạo.`,
	'zh-hans': `目前还没有报告。`,
	'zh-hant': `目前尚未收到任何報告。`,
	en: `No reports have been created yet.`
};

export const loc_noResultsFound: Record<Locale, string> = {
	ar: `لم يتم العثور على نتائج`,
	de: `Keine Ergebnisse gefunden`,
	es: `No se encontraron resultados`,
	fa: `هیچ نتیجه ای یافت نشد`,
	fil: `Walang natagpuang resulta`,
	fr: `Aucun résultat trouvé`,
	hi: `कोई परिणाम नहीं मिला`,
	ht: `Pa gen rezilta yo te jwenn`,
	it: `Nessun risultato trovato`,
	ja: `結果は見つかりませんでした`,
	ko: `검색 결과가 없음`,
	mww: `Tsis muaj txiaj ntsig pom`,
	ps: `هیڅ نتیجه ونه موندل شوه`,
	pt: `Nenhum resultado encontrado`,
	'pt-pt': `Sem resultados encontrados`,
	ru: `Результатов не найдено`,
	sm: `E leai ni taunuuga na maua`,
	so: `Natiijo lama helin`,
	th: `ไม่พบผลลัพธ์`,
	ur: `کوئی نتائج نہیں ملے`,
	vi: `Không tìm thấy kết quả`,
	'zh-hans': `未找到结果`,
	'zh-hant': `未找到結果`,
	en: `No results found`
};

export const loc_noResultsMatchedSearch: Record<Locale, string> = {
	ar: `لم تتطابق أي نتائج مع بحثك.`,
	de: `Keine Ergebnisse passten zu deiner Suche.`,
	es: `Ningún resultado coincidía con tu búsqueda.`,
	fa: `هیچ نتیجه ای با جستجوی شما مطابقت نداشت.`,
	fil: `Walang mga resulta na tumutugma sa iyong paghahanap.`,
	fr: `Aucun résultat ne correspond à votre recherche.`,
	hi: `आपकी खोज से कोई मेल नहीं खाता.`,
	ht: `Pa gen rezilta matche ak rechèch ou an.`,
	it: `Nessun risultato corrispondeva alla tua ricerca.`,
	ja: `検索結果に一致するものはありませんでした。`,
	ko: `검색 결과와 일치하는 것은 없습니다.`,
	mww: `Tsis muaj cov txiaj ntsig phim koj txoj kev tshawb nrhiav.`,
	ps: `هیڅ نتیجه ستا د لټون سره برابره نه وه.`,
	pt: `Nenhum resultado correspondeu à sua busca.`,
	'pt-pt': `Nenhum resultado corresponde à sua pesquisa.`,
	ru: `Результаты не совпали с вашим поиском.`,
	sm: `E leai ni taunuuga e tutusa ma lau sailiga.`,
	so: `Natiijooyin ma aysan la mid ahayn raadintaada.`,
	th: `ไม่มีผลลัพธ์ที่ตรงกับการค้นหาของคุณ`,
	ur: `کوئی بھی نتیجہ آپ کی تلاش سے میل نہیں کھاتا۔`,
	vi: `Không có kết quả nào khớp với tìm kiếm của bạn.`,
	'zh-hans': `没有结果与你的搜索结果相符。`,
	'zh-hant': `沒有結果符合你的搜尋結果。`,
	en: `No results matched your search.`
};

export const loc_noServiceAuthorizations: Record<Locale, string> = {
	ar: `لا توجد تصاريح خدمة`,
	de: `Keine Service-Autorisierungen`,
	es: `No hay autorizaciones de servicio`,
	fa: `بدون مجوز خدمات`,
	fil: `Walang mga pahintulot sa serbisyo`,
	fr: `Aucune autorisation de service`,
	hi: `कोई सेवा प्राधिकरण नहीं`,
	ht: `Pa gen otorizasyon sèvis`,
	it: `Nessuna autorizzazione al servizio`,
	ja: `サービス承認なし`,
	ko: `서비스 승인 없음`,
	mww: `Tsis muaj kev tso cai pabcuam`,
	ps: `هیڅ خدمت اجازه نشته`,
	pt: `Sem autorizações de serviço`,
	'pt-pt': `Sem autorizações de serviço`,
	ru: `Нет разрешения на обслуживание`,
	sm: `Leai ni fa'atagaga tautua`,
	so: `Ma jirto oggolaansho adeeg`,
	th: `ไม่มีการอนุญาตบริการ`,
	ur: `کوئی سروس اجازتیں نہیں`,
	vi: `Không có ủy quyền dịch vụ`,
	'zh-hans': `无服务授权`,
	'zh-hant': `無服務授權`,
	en: `No service authorizations`
};

export const loc_noServices: Record<Locale, string> = {
	ar: `لا توجد خدمات`,
	de: `Keine Verbindungen`,
	es: `Sin servicios`,
	fa: `هیچ خدماتی وجود ندارد`,
	fil: `Walang Mga Serbisyo`,
	fr: `Aucun service`,
	hi: `कोई सेवा नहीं`,
	ht: `Pa gen sèvis`,
	it: `Nessun servizio`,
	ja: `サービスはありません`,
	ko: `서비스 없음`,
	mww: `Tsis muaj kev pabcuam`,
	ps: `هیڅ خدمت نشته`,
	pt: `Sem serviços`,
	'pt-pt': `Sem serviços`,
	ru: `Отсутствие услуг`,
	sm: `Leai se auaunaga`,
	so: `Adeegyo ma jiraan`,
	th: `ไม่มีบริการ`,
	ur: `کوئی سروس نہیں`,
	vi: `Không có dịch vụ`,
	'zh-hans': `无服务`,
	'zh-hant': `無服務`,
	en: `No services`
};

export const loc_noStartDate: Record<Locale, string> = {
	ar: `لا يوجد تاريخ بدء متاح`,
	de: `Kein Starttermin verfügbar`,
	es: `No hay fecha de inicio disponible`,
	fa: `تاریخ شروع در دسترس نیست`,
	fil: `Walang available na petsa ng pagsisimula`,
	fr: `Aucune date de début disponible`,
	hi: `कोई प्रारंभ तिथि उपलब्ध नहीं है`,
	ht: `Pa gen dat kòmanse ki disponib`,
	it: `Nessuna data di inizio disponibile`,
	ja: `開始日は不明です`,
	ko: `시작 날짜는 알려지지 않았습니다`,
	mww: `Tsis muaj hnub pib muaj`,
	ps: `د پیل نېټه نشته`,
	pt: `Sem data de início disponível`,
	'pt-pt': `Não há data de início disponível`,
	ru: `Дата начала работы неизвестна`,
	sm: `E leai se aso amata e maua`,
	so: `Taariikh bilaabasho lama heli karo`,
	th: `ไม่มีวันที่เริ่มต้น`,
	ur: `کوئی شروع ہونے کی تاریخ دستیاب نہیں ہے`,
	vi: `Không có ngày bắt đầu`,
	'zh-hans': `尚无开学日期`,
	'zh-hant': `尚無開學日期`,
	en: `No start date available`
};

export const loc_noStatementsAvailableYet: Record<Locale, string> = {
	ar: `لا توجد بيانات متوفرة حتى الآن.`,
	de: `Noch keine Auszüge verfügbar.`,
	es: `Aún no hay declaraciones disponibles.`,
	fa: `هنوز بیانیه ای در دسترس نیست.`,
	fil: `Wala pang available na statements.`,
	fr: `Aucune déclaration n’est encore disponible.`,
	hi: `अभी तक कोई बयान उपलब्ध नहीं है।`,
	ht: `Pa gen deklarasyon ki disponib ankò.`,
	it: `Nessuna dichiarazione è ancora disponibile.`,
	ja: `まだ声明は出ていません。`,
	ko: `아직 성명은 나오지 않았습니다.`,
	mww: `Tsis muaj daim ntawv qhia nyiaj txiag tam sim no.`,
	ps: `تر اوسه کوم بیان نشته.`,
	pt: `Ainda não há extratos disponíveis.`,
	'pt-pt': `Ainda não há extratos disponíveis.`,
	ru: `Пока нет заявлений.`,
	sm: `E leai ni fa'amatalaga o lo'o maua i le taimi nei.`,
	so: `Wali wax hadal ah lama heli karo.`,
	th: `ยังไม่มีใบแจ้งยอด`,
	ur: `ابھی تک کوئی بیانات دستیاب نہیں ہیں۔`,
	vi: `Chưa có sao kê.`,
	'zh-hans': `目前尚无任何声明可用。`,
	'zh-hant': `目前尚無可取得的聲明。`,
	en: `No statements available yet.`
};

export const loc_notAssigned: Record<Locale, string> = {
	ar: `لم يتم تعيينه`,
	de: `Nicht zugewiesen`,
	es: `No asignado`,
	fa: `اختصاص داده نشده`,
	fil: `Hindi nakatalaga`,
	fr: `Non assigné`,
	hi: `असाइन नहीं किया गया`,
	ht: `Pa asiyen`,
	it: `Non assegnato`,
	ja: `割り当てられていません`,
	ko: `배정되지 않음`,
	mww: `Tsis raug xa mus`,
	ps: `ټاکل شوی نه دی`,
	pt: `Não atribuído`,
	'pt-pt': `Não atribuído`,
	ru: `Не назначен`,
	sm: `E le'i tofia`,
	so: `Lama xilsaarin`,
	th: `ไม่ได้มอบหมาย`,
	ur: `تفویض نہیں کیا گیا`,
	vi: `Không được chỉ định`,
	'zh-hans': `未分配`,
	'zh-hant': `未分配`,
	en: `Not assigned`
};

export const loc_notAuthorized: Record<Locale, string> = {
	ar: `غير مصرح به`,
	de: `Nicht autorisiert`,
	es: `No autorizado`,
	fa: `مجاز نیست`,
	fil: `Hindi awtorisado`,
	fr: `Non autorisé`,
	hi: `अधिकृत नहीं`,
	ht: `Pa otorize`,
	it: `Non autorizzato`,
	ja: `許可されていません`,
	ko: `허가되지 않았습니다`,
	mww: `Tsis tau tso cai`,
	ps: `اجازه نه ده ورکړل شوې`,
	pt: `Não autorizado`,
	'pt-pt': `Não autorizado`,
	ru: `Не разрешено`,
	sm: `E le faatagaina`,
	so: `Lama oggolaan`,
	th: `ไม่ได้รับอนุญาต`,
	ur: `اجازت نہیں`,
	vi: `Không được phép`,
	'zh-hans': `未获授权`,
	'zh-hant': `未經授權`,
	en: `Not authorized`
};

export const loc_notAuthorizedDescription: Record<Locale, string> = {
	ar: `يجب أن تكون مسجلا الدخول للوصول إلى هذه الصفحة.`,
	de: `Sie müssen angemeldet sein, um auf diese Seite zugreifen zu können.`,
	es: `Debes estar conectado para acceder a esta página.`,
	fa: `برای دسترسی به این صفحه باید وارد شوید.`,
	fil: `Kailangan mong mag-sign in upang ma-access ang pahinang ito.`,
	fr: `Vous devez être connecté pour accéder à cette page.`,
	hi: `इस पृष्ठ तक पहुँचने के लिए आपको साइन-इन करना आवश्यक है.`,
	ht: `Ou dwe siyen nan jwenn aksè nan paj sa a.`,
	it: `Devi essere connesso per accedere a questa pagina.`,
	ja: `このページにアクセスするにはサインインが必要です。`,
	ko: `이 페이지에 접근하려면 로그인해야 합니다.`,
	mww: `Koj yuav tsum tau kos npe rau hauv thiaj li nkag mus rau nplooj ntawv no.`,
	ps: `تاسو باید د دې پاڼې د لاسرسی لپاره ننوتل شوی یاست.`,
	pt: `Você deve estar logado para acessar esta página.`,
	'pt-pt': `Tem de estar iniciado sessão para aceder a esta página.`,
	ru: `Для доступа к этой странице необходимо войти в систему.`,
	sm: `E tatau ona e saini i totonu e ulufale ai i lenei itulau.`,
	so: `Waa inaad isdiiwaangelisaa si aad u gasho boggan.`,
	th: `คุณต้องลงชื่อเข้าใช้เพื่อเข้าถึงหน้านี้`,
	ur: `اس صفحے تک رسائی کے لیے آپ کو سائن ان ہونا ضروری ہے۔`,
	vi: `Bạn phải đăng nhập để truy cập trang này.`,
	'zh-hans': `您必须登录后才能访问此页面。`,
	'zh-hant': `您必須登入才能存取此頁面。`,
	en: `You must be signed-in to access this page.`
};

export const loc_notAuthorizedMessage: Record<Locale, string> = {
	ar: `سجل الدخول للوصول إلى هذه الصفحة.`,
	de: `Melden Sie sich an, um auf diese Seite zuzugreifen.`,
	es: `Inicia sesión para acceder a esta página.`,
	fa: `برای دسترسی به این صفحه وارد شوید.`,
	fil: `Mag-sign in upang ma-access ang pahinang ito.`,
	fr: `Connectez-vous pour accéder à cette page.`,
	hi: `इस पृष्ठ तक पहुँचने के लिए साइन इन करें।`,
	ht: `Siyen pou jwenn aksè nan paj sa a.`,
	it: `Accedi per accedere a questa pagina.`,
	ja: `このページにアクセスするにはサインインしてください。`,
	ko: `이 페이지에 접근하려면 로그인하세요.`,
	mww: `Kos npe nkag mus rau nplooj ntawv no.`,
	ps: `د دې پاڼې د لاسرسی لپاره ننوتل وکړئ.`,
	pt: `Faça login para acessar esta página.`,
	'pt-pt': `Inicie sessão para aceder a esta página.`,
	ru: `Войдите в систему, чтобы получить доступ к этой странице.`,
	sm: `Saini i totonu e ulufale ai i lenei itulau.`,
	so: `Gali si aad u gasho boggan.`,
	th: `ลงชื่อเข้าใช้เพื่อเข้าสู่หน้านี้`,
	ur: `اس صفحے تک رسائی کے لیے سائن ان کریں۔`,
	vi: `Đăng nhập để truy cập trang này.`,
	'zh-hans': `登录以访问此页面。`,
	'zh-hant': `登入以進入此頁面。`,
	en: `Sign in to access this page.`
};

export const loc_notAuthorizedToProvideServicesFormat: Record<Locale, (date: unknown) => string> = {
	ar: (date) => `غير مصرح له بتقديم الخدمات في ${date}`,
	de: (date) => `Am ${date} nicht autorisiert, Dienstleistungen zu erbringen`,
	es: (date) => `No autorizado para prestar servicios el ${date}`,
	fa: (date) => `مجوز ارائه خدمات در ${date} را نداشتم`,
	fil: (date) => `Hindi pinahihintulutan na magbigay ng mga serbisyo sa ${date}`,
	fr: (date) => `Non autorisé à fournir des services le ${date}`,
	hi: (date) => `${date} को सेवाएं प्रदान करने के लिए अधिकृत नहीं है`,
	ht: (date) => `Pa gen otorizasyon pou bay sèvis sou ${date}`,
	it: (date) => `Non autorizzato a fornire servizi il ${date}`,
	ja: (date) => `${date}日にはサービス提供の許可なし`,
	ko: (date) => `${date}일에 서비스 제공 권한이 없음`,
	mww: (date) => `Tsis tau kev tso cai muab kev pab rau hnub ${date}`,
	ps: (date) => `د ${date} نېټه د خدمتونو وړاندې کولو اجازه نه ده`,
	pt: (date) => `Não autorizado a prestar serviços em ${date}`,
	'pt-pt': (date) => `Não autorizado a prestar serviços a ${date}`,
	ru: (date) => `Не уполномочен на предоставление услуг ${date}`,
	sm: (date) => `E le fa'atagaina e tu'uina atu auaunaga i le ${date}`,
	so: (date) => `Looma oggolaan inay adeegyo bixiso ${date}`,
	th: (date) => `ไม่ได้รับอนุญาตให้ให้บริการในวันที่ ${date}`,
	ur: (date) => `${date} کو خدمات فراہم کرنے کی اجازت نہیں`,
	vi: (date) => `Không được phép cung cấp dịch vụ vào ngày ${date}`,
	'zh-hans': (date) => `4${date}日未获授权提供服务`,
	'zh-hant': (date) => `4${date}日未獲授權提供服務`,
	en: (date) => `Not authorized to provide services on ${date}`
};

export const loc_notEnrolled: Record<Locale, string> = {
	ar: `غير مسجلة`,
	de: `Nicht eingeschrieben`,
	es: `No matriculado`,
	fa: `ثبت نام نشده`,
	fil: `Hindi nakatala`,
	fr: `Non inscrit`,
	hi: `नामांकित नहीं`,
	ht: `Pa enskri`,
	it: `Non iscritto`,
	ja: `未登録`,
	ko: `등록하지 않았습니다`,
	mww: `Tsis muaj npe`,
	ps: `ثبت شوی نه یم`,
	pt: `Não matriculado`,
	'pt-pt': `Não inscritos`,
	ru: `Не зарегистрирован`,
	sm: `E le'i lesitala`,
	so: `Ma diiwaan gelin`,
	th: `ไม่ได้ลงทะเบียน`,
	ur: `داخل نہیں ہوا`,
	vi: `Chưa đăng ký`,
	'zh-hans': `未注册`,
	'zh-hant': `未註冊`,
	en: `Not enrolled`
};

export const loc_notes: Record<Locale, string> = {
	ar: `ملاحظات`,
	de: `Anmerkungen`,
	es: `Notas`,
	fa: `یادداشت ها`,
	fil: `Mga Tala`,
	fr: `Notes`,
	hi: `टिप्पणियाँ`,
	ht: `Nòt yo`,
	it: `Note`,
	ja: `注記`,
	ko: `주석`,
	mww: `Cov ntawv sau tseg`,
	ps: `یادښتونه`,
	pt: `Notas`,
	'pt-pt': `Notas`,
	ru: `Примечания`,
	sm: `Faamatalaga`,
	so: `Xusuusin`,
	th: `หมายเหตุ`,
	ur: `نوٹس`,
	vi: `Ghi chú`,
	'zh-hans': `注释`,
	'zh-hant': `註釋`,
	en: `Notes`
};

export const loc_notFound: Record<Locale, string> = {
	ar: `لم يعثر عليه`,
	de: `Nicht gefunden`,
	es: `No encontrado`,
	fa: `پیدا نشد`,
	fil: `Hindi natagpuan`,
	fr: `Non trouvé`,
	hi: `नहीं मिला`,
	ht: `Pa jwenn`,
	it: `Non trovato`,
	ja: `見つかりません`,
	ko: `찾지 못했습니다`,
	mww: `Tsis pom`,
	ps: `ونه موندل شول`,
	pt: `Não encontrado`,
	'pt-pt': `Não encontrado`,
	ru: `Не найдено`,
	sm: `E le'i maua`,
	so: `Lama helin`,
	th: `ไม่พบ`,
	ur: `نہیں ملا`,
	vi: `Không tìm thấy`,
	'zh-hans': `未找到`,
	'zh-hant': `未找到`,
	en: `Not found`
};

export const loc_notFoundDescription: Record<Locale, string> = {
	ar: `قد يكون الرابط مكتوبا بشكل خاطئ أو أن الصفحة التي تبحث عنها لم تعد متاحة.`,
	de: `Die URL kann falsch geschrieben sein oder die gesuchte Seite ist nicht mehr verfügbar.`,
	es: `La URL puede estar mal escrita o la página que buscas ya no esté disponible.`,
	fa: `ممکن است آدرس اینترنتی اشتباه نوشته شده باشد یا صفحه ای که به دنبال آن هستید دیگر در دسترس نباشد.`,
	fil: `Maaaring mali ang spelling ng URL o hindi na available ang pahinang hinahanap mo.`,
	fr: `L’URL peut être mal orthographiée ou la page que vous cherchez n’est plus disponible.`,
	hi: `हो सकता है कि URL की वर्तनी गलत हो या आप जिस पृष्ठ की तलाश कर रहे हैं वह अब उपलब्ध न हो.`,
	ht: `URL la ka ekri mal oswa paj ou ap chèche a pa disponib ankò.`,
	it: `L'URL potrebbe essere scritto male o la pagina che cerchi non è più disponibile.`,
	ja: `URLのスペルミスや、お探しのページがもう利用できていない可能性があります。`,
	ko: `URL이 잘못 쓰였거나, 찾고 있는 페이지가 더 이상 제공되지 않을 수도 있습니다.`,
	mww: `Qhov URL yuav raug sau yuam kev lossis nplooj ntawv koj tab tom nrhiav tsis muaj lawm.`,
	ps: `ممکن URL غلط لیکل شوی وی یا هغه پاڼه چې تاسو یې لټوئ نور شتون ونه لری.`,
	pt: `A URL pode estar com erros ortográficos ou a página que você procura não está mais disponível.`,
	'pt-pt': `O URL pode estar mal escrito ou a página que procura já não está disponível.`,
	ru: `URL может быть написан с ошибкой или страница, которую вы ищете, больше недоступна.`,
	sm: `E mafai ona sese le sipelaga o le URL pe o le itulau o lo'o e sailia e le o toe maua.`,
	so: `URL-ka waxaa laga yaabaa inuu khaldan yahay ama bogga aad raadineyso hadda lama heli karo.`,
	th: `URL อาจสะกดผิดหรือหน้าเว็บที่คุณกําลังมองหาไม่พร้อมใช้งานอีกต่อไป`,
	ur: `یو آر ایل غلط املا ہو سکتا ہے یا جس صفحے کی آپ تلاش کر رہے ہیں وہ اب دستیاب نہیں ہے۔`,
	vi: `URL có thể bị sai chính tả hoặc trang bạn đang tìm kiếm không còn nữa.`,
	'zh-hans': `URL可能拼写错误，或者你想要的页面已不再可用。`,
	'zh-hant': `網址可能拼錯，或你尋找的頁面已無法取得。`,
	en: `The URL may be misspelled or the page you're looking for is no longer available.`
};

export const loc_notFoundMessage: Record<Locale, string> = {
	ar: `لا يمكن العثور على الصفحة التي طلبتها.`,
	de: `Die von Ihnen angeforderte Seite kann nicht gefunden werden.`,
	es: `No se puede encontrar la página que solicitaste.`,
	fa: `صفحه ای که درخواست کرده بودید پیدا نمی شود.`,
	fil: `Hindi matagpuan ang pahinang hiniling mo.`,
	fr: `La page que vous avez demandée est introuvable.`,
	hi: `आपके द्वारा अनुरोधित पृष्ठ नहीं ढूँढा जा सकता.`,
	ht: `Paj ou mande a pa ka jwenn.`,
	it: `La pagina che hai richiesto non è disponibile.`,
	ja: `ご依頼のページは見つかりません。`,
	ko: `요청하신 페이지를 찾을 수 없습니다.`,
	mww: `Nplooj ntawv koj thov nrhiav tsis tau.`,
	ps: `هغه پاڼه چې تا غوښتې نه ده موندل کېدای.`,
	pt: `A página que você solicitou não pode ser encontrada.`,
	'pt-pt': `A página que pediu não pode ser encontrada.`,
	ru: `Страница, которую вы запросили, не найдена.`,
	sm: `E le mafai ona maua le itulau na e talosagaina.`,
	so: `Bogga aad codsatay lama heli karo.`,
	th: `ไม่พบหน้าที่คุณร้องขอ`,
	ur: `وہ صفحہ جو آپ نے درخواست کی تھی وہ نہیں مل رہا۔`,
	vi: `Không thể tìm thấy trang bạn yêu cầu.`,
	'zh-hans': `您请求的页面无法找到。`,
	'zh-hant': `您所要求的頁面無法找到。`,
	en: `The page you requested cannot be found.`
};

export const loc_nothingToPreview: Record<Locale, string> = {
	ar: `لا يوجد شيء للمعاينة`,
	de: `Nichts zum Vorschauen`,
	es: `Nada que previsualizar`,
	fa: `چیزی برای پیش نمایش وجود ندارد`,
	fil: `Walang dapat i-preview`,
	fr: `Rien à prévisualiser`,
	hi: `पूर्वावलोकन करने के लिए कुछ भी नहीं`,
	ht: `Pa gen anyen pou aperçu`,
	it: `Niente da anticipare`,
	ja: `プレビューするものは何もありません`,
	ko: `미리 볼 만한 것은 없습니다`,
	mww: `Tsis muaj dab tsi los saib ua ntej`,
	ps: `هیڅ نښې نشته چې مخکې وګورم`,
	pt: `Nada para pré-visualizar`,
	'pt-pt': `Nada para pré-visualizar`,
	ru: `Нечего предварить`,
	sm: `Leai se mea e muai va'ai`,
	so: `Waxba ma jiraan oo la saadaalin karo`,
	th: `ไม่มีอะไรให้ดูตัวอย่าง`,
	ur: `پیش نظارہ کرنے کے لیے کچھ نہیں`,
	vi: `Không có gì để xem trước`,
	'zh-hans': `没有什么可预览的`,
	'zh-hant': `沒有什麼好預覽的`,
	en: `Nothing to preview`
};

export const loc_notificationReasonAssignee: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `أنت تتلقى إشعارات لأن هذا ${type} تم تعيينه لك.`,
	de: (type) => `Du bekommst Benachrichtigungen, weil dir diese ${type} zugewiesen wurde.`,
	es: (type) => `Estás recibiendo notificaciones porque te asignaron esta ${type}.`,
	fa: (type) => `شما اعلان دریافت می کنید چون این ${type} به شما اختصاص داده شده است.`,
	fil: (type) => `Tumatanggap ka ng mga abiso dahil naatasan ka sa ${type} na ito.`,
	fr: (type) => `Vous recevez des notifications parce que cette ${type} vous a été attribuée.`,
	hi: (type) => `आपको सूचनाएं मिल रही हैं क्योंकि आपको यह ${type} असाइन की गई थी.`,
	ht: (type) => `Ou ap resevwa notifikasyon paske yo te asiyen ${type} sa a.`,
	it: (type) => `Stai ricevendo notifiche perché ti è stata assegnata questa ${type}.`,
	ja: (type) => `この ${type}が割り当てられたため通知が届いています。`,
	ko: (type) => `이 ${type}이 할당되었기 때문에 알림을 받는 것입니다.`,
	mww: (type) => `Koj tab tom tau txais cov ntawv ceeb toom vim tias koj tau muab txoj ${type} no.`,
	ps: (type) => `ته خبرتیاوې ترلاسه کوې ځکه چې دا ${type} درکړل شوی.`,
	pt: (type) => `Você está recebendo notificações porque foi designado para essa ${type}.`,
	'pt-pt': (type) => `Está a receber notificações porque lhe foi atribuída esta ${type}.`,
	ru: (type) => `Вы получаете уведомления, потому что вам назначили эту ${type}.`,
	sm: (type) => `O loo e mauaina ni faasilasilaga ona sa tofia oe i lenei ${type}`,
	so: (type) => `Waxaad helaysaa ogeysiisyo sababtoo ah waxaa laguu ${type}.`,
	th: (type) => `คุณได้รับการแจ้งเตือนเนื่องจากคุณได้รับมอบหมาย ${type}นี้`,
	ur: (type) => `آپ کو نوٹیفیکیشنز اس لیے مل رہی ہیں کیونکہ آپ کو یہ ${type} تفویض کی گئی ہے۔`,
	vi: (type) => `Bạn nhận được thông báo vì bạn được chỉ định ${type} này.`,
	'zh-hans': (type) => `你收到通知是因为你被分配了这项 ${type}。`,
	'zh-hant': (type) => `你收到通知是因為你被分配了這個 ${type}。`,
	en: (type) => `You're receiving notifications because you were assigned this ${type}.`
};

export const loc_notificationReasonAutomatic: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `أنت تتلقى إشعارات لأنك تم الاشتراك تلقائيا في هذا ${type}.`,
	de: (type) => `Du bekommst Benachrichtigungen, weil du automatisch für diese ${type} abonniert wurdest.`,
	es: (type) => `Estás recibiendo notificaciones porque estabas suscrito automáticamente a esta ${type}.`,
	fa: (type) => `شما اعلان دریافت می کنید چون به طور خودکار در این ${type} مشترک شده اید.`,
	fil: (type) => `Tumatanggap ka ng mga abiso dahil awtomatikong naka-subscribe ka sa ${type} na ito.`,
	fr: (type) => `Vous recevez des notifications parce que vous étiez automatiquement abonné à cette ${type}.`,
	hi: (type) => `आपको सूचनाएं मिल रही हैं क्योंकि आपने इस ${type} की स्वचालित सदस्यता ले ली है.`,
	ht: (type) => `Ou ap resevwa notifikasyon paske ou te enskri otomatikman nan ${type} sa a.`,
	it: (type) => `Ricevi notifiche perché sei stato automaticamente iscritto a questa ${type}.`,
	ja: (type) => `この ${type}に自動的に登録されたため通知を受け取っています。`,
	ko: (type) => `이 ${type}에 자동으로 구독되었기 때문에 알림을 받는 것입니다.`,
	mww: (type) => `Koj tab tom tau txais cov ntawv ceeb toom vim tias koj tau cia li sau npe rau qhov ${type} no.`,
	ps: (type) => `تاسو خبرتیاوې ترلاسه کوئ ځکه چې تاسو په اتومات ډول د دې ${type} ګډون کړی یاست.`,
	pt: (type) => `Você está recebendo notificações porque foi automaticamente assinado ${type}.`,
	'pt-pt': (type) => `Está a receber notificações porque foi automaticamente subscrito a esta ${type}.`,
	ru: (type) => `Вы получаете уведомления, потому что автоматически подписались на эту ${type}.`,
	sm: (type) => `O loo e mauaina ni faasilasilaga ona sa otometi lava ona e lesitala i lenei ${type}`,
	so: (type) => `Waxaad helaysaa ogeysiisyo sababtoo ah si toos ah ayaa laguu diiwaan geliyay ${type}.`,
	th: (type) => `คุณได้รับการแจ้งเตือนเนื่องจากคุณสมัครรับ ${type}นี้โดยอัตโนมัติ`,
	ur: (type) => `آپ کو نوٹیفیکیشنز اس لیے مل رہی ہیں کیونکہ آپ خود بخود اس ${type} کو سبسکرائب کر چکے ہیں۔`,
	vi: (type) => `Bạn nhận được thông báo vì bạn đã tự động đăng ký ${type} này.`,
	'zh-hans': (type) => `你收到通知是因为你被自动订阅了这个 ${type}。`,
	'zh-hant': (type) => `你收到通知是因為你被自動訂閱了這個 ${type}。`,
	en: (type) => `You're receiving notifications because you were automatically subscribed to this ${type}.`
};

export const loc_notificationReasonCommentor: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `أنت تتلقى إشعارات لأنك علقت على هذا ${type}.`,
	de: (type) => `Du bekommst Benachrichtigungen, weil du zu dieser ${type} kommentiert hast.`,
	es: (type) => `Estás recibiendo notificaciones porque has comentado sobre esta ${type}.`,
	fa: (type) => `شما اعلان دریافت می کنید چون درباره این ${type} نظر دادید.`,
	fil: (type) => `Tumatanggap ka ng mga abiso dahil nagkomento ka sa ${type} na ito.`,
	fr: (type) => `Vous recevez des notifications parce que vous avez commenté cette ${type}.`,
	hi: (type) => `आपको सूचनाएं मिल रही हैं क्योंकि आपने इस ${type} पर टिप्पणी की है.`,
	ht: (type) => `Ou ap resevwa notifikasyon paske ou te fè kòmantè sou ${type} sa a.`,
	it: (type) => `Ricevi notifiche perché hai commentato questa ${type}.`,
	ja: (type) => `この ${type}にコメントしたことで通知が届くのです。`,
	ko: (type) => `이 ${type}에 댓글을 달았기 때문에 알림을 받는 거예요.`,
	mww: (type) => `Koj tau txais cov ntawv ceeb toom vim tias koj tau tawm tswv yim txog qhov ${type} no.`,
	ps: (type) => `تاسو خبرتیاوې ترلاسه کوئ ځکه چې تاسو په ${type} تبصره کړې ده.`,
	pt: (type) => `Você está recebendo notificações porque comentou sobre essa ${type}.`,
	'pt-pt': (type) => `Está a receber notificações porque comentou esta ${type}.`,
	ru: (type) => `Вы получаете уведомления, потому что прокомментировали эту ${type}.`,
	sm: (type) => `O lo'o e mauaina ni fa'asilasilaga ona ua e fa'amatalaina lenei ${type}.`,
	so: (type) => `Waxaad helaysaa ogeysiisyo sababtoo ah waxaad faallo ka bixisay ${type}.`,
	th: (type) => `คุณได้รับการแจ้งเตือนเนื่องจากคุณแสดงความคิดเห็นเกี่ยวกับ ${type}นี้`,
	ur: (type) => `آپ کو اس ${type} پر تبصرہ کرنے کی وجہ سے نوٹیفیکیشنز مل رہی ہیں۔`,
	vi: (type) => `Bạn nhận được thông báo vì bạn đã nhận xét về ${type} này.`,
	'zh-hans': (type) => `你收到通知是因为你评论了这项 ${type}。`,
	'zh-hant': (type) => `你收到通知是因為你對 ${type}留言。`,
	en: (type) => `You're receiving notifications because you commented on this ${type}.`
};

export const loc_notificationReasonCreator: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `أنت تتلقى إشعارات لأنك أنشأت هذا ${type}.`,
	de: (type) => `Du bekommst Benachrichtigungen, weil du diese ${type} erstellt hast.`,
	es: (type) => `Estás recibiendo notificaciones porque has creado esta ${type}.`,
	fa: (type) => `شما اعلان دریافت می کنید چون این ${type} را ایجاد کرده اید.`,
	fil: (type) => `Tumatanggap ka ng mga abiso dahil nilikha mo ang ${type} na ito.`,
	fr: (type) => `Vous recevez des notifications parce que vous avez créé cette ${type}.`,
	hi: (type) => `आपको सूचनाएं मिल रही हैं क्योंकि आपने यह ${type} बनाई है.`,
	ht: (type) => `Ou ap resevwa notifikasyon paske ou te kreye ${type} sa a.`,
	it: (type) => `Ricevi notifiche perché hai creato questa ${type}.`,
	ja: (type) => `あなたがこの ${type}を作成したために通知を受け取っているのです。`,
	ko: (type) => `이 ${type} 생성했기 때문에 알림을 받는 것입니다.`,
	mww: (type) => `Koj tau txais cov ntawv ceeb toom vim tias koj tau tsim qhov ${type} no.`,
	ps: (type) => `تاسو خبرتیاوې ترلاسه کوئ ځکه چې تاسو دا ${type} جوړ کړی دی.`,
	pt: (type) => `Você está recebendo notificações porque criou essa ${type}.`,
	'pt-pt': (type) => `Está a receber notificações porque criou esta ${type}.`,
	ru: (type) => `Вы получаете уведомления, потому что создали эту ${type}.`,
	sm: (type) => `O loo e mauaina ni faasilasilaga ona sa e fatuina lenei ${type}.`,
	so: (type) => `Waxaad helaysaa ogeysiisyo sababtoo ah adigu waad ${type}.`,
	th: (type) => `คุณได้รับการแจ้งเตือนเนื่องจากคุณสร้าง ${type}นี้`,
	ur: (type) => `آپ کو نوٹیفیکیشنز اس لیے مل رہی ہیں کیونکہ آپ نے یہ ${type} بنائی ہے۔`,
	vi: (type) => `Bạn nhận được thông báo vì đã tạo ${type} này.`,
	'zh-hans': (type) => `你收到通知是因为你创建了这个 ${type}。`,
	'zh-hant': (type) => `你收到通知是因為你建立了這個 ${type}。`,
	en: (type) => `You're receiving notifications because you created this ${type}.`
};

export const loc_notificationReasonManual: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `أنت تتلقى إشعارات لأنك اشتركت في هذا ${type}.`,
	de: (type) => `Sie erhalten Benachrichtigungen, weil Sie diese ${type} abonniert haben.`,
	es: (type) => `Estás recibiendo notificaciones porque te suscribiste a esta ${type}.`,
	fa: (type) => `شما اعلان دریافت می کنید چون در این ${type} عضو شده اید.`,
	fil: (type) => `Tumatanggap ka ng mga abiso dahil nag-subscribe ka sa ${type} na ito.`,
	fr: (type) => `Vous recevez des notifications parce que vous vous êtes abonné à cette ${type}.`,
	hi: (type) => `आपको सूचनाएं प्राप्त हो रही हैं क्योंकि आपने इस ${type} की सदस्यता ली है.`,
	ht: (type) => `Ou ap resevwa notifikasyon paske ou te abònman nan ${type} sa a.`,
	it: (type) => `Stai ricevendo notifiche perché ti sei iscritto a questa ${type}.`,
	ja: (type) => `この ${type}を購読したため通知を受け取っています。`,
	ko: (type) => `이 ${type} 구독했기 때문에 알림을 받는 것입니다.`,
	mww: (type) => `Koj tau txais cov ntawv ceeb toom vim tias koj tau sau npe rau qhov ${type} no.`,
	ps: (type) => `ته خبرتیاوې ترلاسه کوې ځکه چې ته دې ${type} ته ګډون کړی دی.`,
	pt: (type) => `Você está recebendo notificações porque se inscreveu ${type}.`,
	'pt-pt': (type) => `Está a receber notificações porque subscreveu esta ${type}.`,
	ru: (type) => `Вы получаете уведомления, потому что подписались на эту ${type}.`,
	sm: (type) => `O lo'o e mauaina fa'asilasilaga ona ua e lesitala i lenei ${type}.`,
	so: (type) => `Waxaad helaysaa ogeysiisyo sababtoo ah waxaad isdiiwaangelisay ${type}.`,
	th: (type) => `คุณได้รับการแจ้งเตือนเนื่องจากคุณสมัครรับ ${type}นี้`,
	ur: (type) => `آپ کو نوٹیفیکیشنز اس لیے مل رہی ہیں کیونکہ آپ نے اس ${type} کو سبسکرائب کیا ہے۔`,
	vi: (type) => `Bạn nhận được thông báo vì đã đăng ký ${type} này.`,
	'zh-hans': (type) => `你收到通知是因为你订阅了这个 ${type}。`,
	'zh-hant': (type) => `你收到通知是因為你訂閱了這個 ${type}。`,
	en: (type) => `You're receiving notifications because you subscribed to this ${type}.`
};

export const loc_notificationReasonMentioned: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `أنت تتلقى إشعارات لأنك ذكرت مباشرة في هذا ${type}.`,
	de: (type) => `Sie erhalten Benachrichtigungen, weil Sie in dieser ${type} direkt erwähnt wurden.`,
	es: (type) => `Estás recibiendo notificaciones porque te mencionaron directamente en esta ${type}.`,
	fa: (type) => `شما اعلان دریافت می کنید چون مستقیما در این ${type} نام برده شده اید.`,
	fil: (type) => `Tumatanggap ka ng mga abiso dahil direktang binanggit ka sa ${type} na ito.`,
	fr: (type) => `Vous recevez des notifications parce que vous avez été directement mentionné dans cette ${type}.`,
	hi: (type) => `आपको सूचनाएं मिल रही हैं क्योंकि इस ${type} में आपका सीधे उल्लेख किया गया था.`,
	ht: (type) => `Ou ap resevwa notifikasyon paske ou te mansyone dirèkteman nan ${type} sa a.`,
	it: (type) => `Stai ricevendo notifiche perché sei stato menzionato direttamente in questa ${type}.`,
	ja: (type) => `あなたが通知を受け取っているのは、この ${type}で直接言及されたからです。`,
	ko: (type) => `이 ${type}에서 직접 언급되었기 때문에 알림을 받는 거예요.`,
	mww: (type) => `Koj tau txais cov ntawv ceeb toom vim tias koj tau hais ncaj qha hauv qhov ${type} no.`,
	ps: (type) => `تاسو خبرتیاوې ترلاسه کوئ ځکه چې په ${type} کې مستقیم یاد شوی یاست.`,
	pt: (type) => `Você está recebendo notificações porque foi mencionado diretamente nesta ${type}.`,
	'pt-pt': (type) => `Estás a receber notificações porque foste mencionado diretamente nesta ${type}.`,
	ru: (type) => `Вы получаете уведомления, потому что вас напрямую упомянули в ${type}.`,
	sm: (type) => `O loo e mauaina ni faasilasilaga ona sa ta'ua sa'o lava oe i lenei ${type}`,
	so: (type) => `Waxaad helaysaa ogeysiisyo sababtoo ah si toos ah laguu xusay ${type}.`,
	th: (type) => `คุณได้รับการแจ้งเตือนเนื่องจากมีการกล่าวถึงคุณโดยตรงใน ${type}นี้`,
	ur: (type) => `آپ کو نوٹیفیکیشنز اس لیے مل رہی ہیں کیونکہ آپ کا براہ راست ذکر اس ${type} میں کیا گیا تھا۔`,
	vi: (type) => `Bạn nhận được thông báo vì bạn được đề cập trực tiếp trong ${type} này.`,
	'zh-hans': (type) => `你收到通知是因为你在这次 ${type}中被直接提及。`,
	'zh-hant': (type) => `你收到通知是因為你被直接提到了這個 ${type}。`,
	en: (type) => `You're receiving notifications because you were directly mentioned in this ${type}.`
};

export const loc_notificationReasonNone: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `أنت لا تتلقى إشعارات لهذا ${type}.`,
	de: (type) => `Sie erhalten keine Benachrichtigungen für diese ${type}.`,
	es: (type) => `No estás recibiendo notificaciones de esta ${type}.`,
	fa: (type) => `شما برای این ${type} اعلان دریافت نمی کنید.`,
	fil: (type) => `Hindi ka nakakatanggap ng mga abiso para sa ${type} na ito.`,
	fr: (type) => `Vous ne recevez pas de notifications pour cette ${type}.`,
	hi: (type) => `आपको इस ${type} के लिए सूचनाएं नहीं मिल रही हैं.`,
	ht: (type) => `Ou pa resevwa notifikasyon pou ${type} sa a.`,
	it: (type) => `Non ricevi notifiche per questa ${type}.`,
	ja: (type) => `この ${type}に関する通知は届いていません。`,
	ko: (type) => `이 ${type}에 대한 알림을 받지 못하고 있습니다.`,
	mww: (type) => `Koj tsis tau txais kev ceeb toom rau ${type}.`,
	ps: (type) => `ته د ${type} لپاره خبرتیاوې نه ترلاسه کوې.`,
	pt: (type) => `Você não está recebendo notificações dessa ${type}.`,
	'pt-pt': (type) => `Não está a receber notificações desta ${type}.`,
	ru: (type) => `Вы не получаете уведомления об этой ${type}.`,
	sm: (type) => `E te le o mauaina ni faasilasilaga mo lenei ${type}`,
	so: (type) => `Ma helaysid ogeysiisyo ku saabsan ${type}.`,
	th: (type) => `คุณไม่ได้รับการแจ้งเตือนสําหรับ ${type}นี้`,
	ur: (type) => `آپ کو اس ${type} کے لیے نوٹیفکیشن موصول نہیں ہو رہے۔`,
	vi: (type) => `Bạn không nhận được thông báo về ${type} này.`,
	'zh-hans': (type) => `你不会收到这个 ${type}的通知。`,
	'zh-hant': (type) => `你不會收到這項 ${type}的通知。`,
	en: (type) => `You're not receiving notifications for this ${type}.`
};

export const loc_notificationReasonTeamMentioned: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `أنت تتلقى إشعارات لأن فريقا أنت عضو فيه ذكر في هذا ${type}.`,
	de: (type) => `Sie erhalten Benachrichtigungen, weil ein Team, dem Sie angehören, in dieser ${type} erwähnt wurde.`,
	es: (type) => `Estás recibiendo notificaciones porque se mencionó a un equipo del que eres miembro en esta ${type}.`,
	fa: (type) => `شما اعلان دریافت می کنید چون تیمی که عضو آن هستید در این ${type} ذکر شده است.`,
	fil: (type) => `Tumatanggap ka ng mga abiso dahil ang isang koponan na iyong kinabibilangan ay binanggit sa ${type} na ito.`,
	fr: (type) => `Vous recevez des notifications parce qu’une équipe dont vous faites partie a été mentionnée dans cette ${type}.`,
	hi: (type) => `आपको सूचनाएं प्राप्त हो रही हैं क्योंकि इस ${type} में आप जिस टीम के सदस्य हैं, उसका उल्लेख किया गया था.`,
	ht: (type) => `Ou ap resevwa notifikasyon paske yon ekip ou se yon manm nan te mansyone nan ${type} sa a.`,
	it: (type) => `Ricevi notifiche perché in questa ${type} è stato menzionato un team di cui fai parte.`,
	ja: (type) => `あなたが所属しているチームがこの ${type}で言及されたために通知を受け取っています。`,
	ko: (type) => `당신이 속한 팀이 이 ${type}에 언급되어 알림을 받는 것입니다.`,
	mww: (type) => `Koj tab tom tau txais cov ntawv ceeb toom vim tias ib pab neeg koj yog ib tus tswv cuab tau hais hauv qhov ${type} no.`,
	ps: (type) => `تاسو خبرتیاوې ترلاسه کوئ ځکه چې یو ټیم چې تاسو یې غړی یاست، په دې ${type} کې یاد شوی و.`,
	pt: (type) => `Você está recebendo notificações porque uma equipe da qual faz parte foi mencionada nesta ${type}.`,
	'pt-pt': (type) => `Estás a receber notificações porque uma equipa da qual fazes parte foi mencionada nesta ${type}.`,
	ru: (type) => `Вы получаете уведомления, потому что в этой ${type} была упомянута команда, в которой вы являетесь.`,
	sm: (type) => `O lo'o e mauaina ni fa'asilasilaga ona o se 'au o oe o se sui na ta'ua i lenei ${type}.`,
	so: (type) => `Waxaad helaysaa ogeysiisyo sababtoo ah koox aad xubin ka tahay ayaa lagu xusay ${type}.`,
	th: (type) => `คุณได้รับการแจ้งเตือนเนื่องจากมีการกล่าวถึงทีมที่คุณเป็นสมาชิกใน ${type}นี้`,
	ur: (type) => `آپ کو نوٹیفیکیشنز اس لیے مل رہی ہیں کیونکہ اس ${type} میں جس ٹیم کا آپ رکن ہیں اس کا ذکر کیا گیا تھا۔`,
	vi: (type) => `Bạn nhận được thông báo vì nhóm mà bạn là thành viên đã được đề cập trong ${type} này.`,
	'zh-hans': (type) => `你收到通知是因为你所在的团队在本次 ${type}中被提及。`,
	'zh-hant': (type) => `你收到通知是因為你所屬的團隊被提及。${type}`,
	en: (type) => `You're receiving notifications because a team you're a member of was mentioned in this ${type}.`
};

export const loc_notificationReasonUnsubscribed: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `أنت لا تتلقى إشعارات لهذا ${type} لأنك ألغيت الاشتراك.`,
	de: (type) => `Du bekommst keine Benachrichtigungen für diese ${type} , weil du dich abgemeldet hast.`,
	es: (type) => `No estás recibiendo notificaciones de esta ${type} porque te has dado de baja.`,
	fa: (type) => `برای این ${type} اعلان دریافت نمی کنید چون لغو اشتراک کرده اید.`,
	fil: (type) => `Hindi ka nakakatanggap ng mga abiso para sa ${type} na ito dahil nag-unsubscribe ka.`,
	fr: (type) => `Vous ne recevez pas de notifications pour cette ${type} parce que vous vous êtes désabonné.`,
	hi: (type) => `आपको इस ${type} के लिए सूचनाएं नहीं मिल रही हैं, क्योंकि आपने सदस्यता समाप्त कर दी है.`,
	ht: (type) => `Ou pa resevwa notifikasyon pou ${type} sa a paske ou koupe abònman.`,
	it: (type) => `Non ricevi notifiche per questa ${type} perché ti sei disiscritto.`,
	ja: (type) => `購読を解除したため、この ${type} の通知を受け取れません。`,
	ko: (type) => `구독을 취소했기 때문에 이 ${type} 에 대한 알림이 오지 않습니다.`,
	mww: (type) => `Koj tsis tau txais cov ntawv ceeb toom rau qhov ${type} no vim tias koj unsubscribed.`,
	ps: (type) => `تاسو د ${type} لپاره خبرتیاوې نه ترلاسه کوئ ځکه چې تاسو لغوه کړی یاست.`,
	pt: (type) => `Você não está recebendo notificações dessa ${type} porque cancelou a inscrição.`,
	'pt-pt': (type) => `Não estás a receber notificações desta ${type} porque cancelaste a subscrição.`,
	ru: (type) => `Вы не получаете уведомления об этой ${type} , потому что отписались.`,
	sm: (type) => `E te le mauaina ni faasilasilaga mo lenei ${type} ona ua e le lesitalaina.`,
	so: (type) => `Ma helaysid ogeysiisyo ku saabsan ${type} sababtoo ah waad ka baxday isdiiwaangelinta.`,
	th: (type) => `คุณไม่ได้รับการแจ้งเตือนสําหรับ ${type} นี้เนื่องจากคุณยกเลิกการสมัครรับข้อมูล`,
	ur: (type) => `آپ کو اس ${type} کی اطلاع اس لیے نہیں مل رہی کیونکہ آپ نے ان سبسکرائب کر دیا ہے۔`,
	vi: (type) => `Bạn không nhận được thông báo về ${type} này vì bạn đã hủy đăng ký.`,
	'zh-hans': (type) => `你因为取消订阅而没有收到这 ${type} 的通知。`,
	'zh-hant': (type) => `你因為取消訂閱而收不到這 ${type} 的通知。`,
	en: (type) => `You're not receiving notifications for this ${type} because you unsubscribed.`
};

export const loc_notificationReasonUpdator: Record<Locale, (type: unknown) => string> = {
	ar: (type) => `أنت تتلقى إشعارات لأنك قمت بتحديث هذا ${type}.`,
	de: (type) => `Du bekommst Benachrichtigungen, weil du diese ${type} aktualisiert hast.`,
	es: (type) => `Estás recibiendo notificaciones porque has actualizado esta ${type}.`,
	fa: (type) => `شما اعلان دریافت می کنید چون این ${type} را به روزرسانی کرده اید.`,
	fil: (type) => `Tumatanggap ka ng mga notification dahil na-update mo ang ${type} na ito.`,
	fr: (type) => `Vous recevez des notifications parce que vous avez mis à jour cette ${type}.`,
	hi: (type) => `आपको सूचनाएं मिल रही हैं क्योंकि आपने इस ${type} को अपडेट किया है.`,
	ht: (type) => `Ou resevwa notifikasyon paske ou mete ajou ${type} sa a.`,
	it: (type) => `Ricevi notifiche perché hai aggiornato questa ${type}.`,
	ja: (type) => `この ${type}を更新したことで通知が届くのです。`,
	ko: (type) => `이 ${type} 업데이트해서 알림을 받는 거예요.`,
	mww: (type) => `Koj tau txais cov ntawv ceeb toom vim tias koj tau hloov kho qhov ${type} no.`,
	ps: (type) => `تاسو خبرتیاوې ترلاسه کوئ ځکه چې تاسو ${type} تازه کړی دی.`,
	pt: (type) => `Você está recebendo notificações porque atualizou essa ${type}.`,
	'pt-pt': (type) => `Está a receber notificações porque atualizou esta ${type}.`,
	ru: (type) => `Вы получаете уведомления, потому что обновили ${type}.`,
	sm: (type) => `O loo e mauaina ni faasilasilaga ona ua e faafouina lenei ${type}.`,
	so: (type) => `Waxaad helaysaa ogeysiisyo sababtoo ah waxaad cusbooneysiisay ${type}.`,
	th: (type) => `คุณได้รับการแจ้งเตือนเนื่องจากคุณอัปเดต ${type}นี้`,
	ur: (type) => `آپ کو نوٹیفکیشن اس لیے مل رہے ہیں کیونکہ آپ نے یہ ${type} اپ ڈیٹ کی ہے۔`,
	vi: (type) => `Bạn nhận được thông báo vì bạn đã cập nhật ${type} này.`,
	'zh-hans': (type) => `你收到通知是因为你更新了 ${type}。`,
	'zh-hant': (type) => `你收到通知是因為你更新了這個 ${type}。`,
	en: (type) => `You're receiving notifications because you updated this ${type}.`
};

export const loc_noTimesheets: Record<Locale, string> = {
	ar: `لا جداول زمنية`,
	de: `Keine Stundenzettel`,
	es: `Sin hojas de horas`,
	fa: `هیچ برگه زمانی وجود ندارد`,
	fil: `Walang mga timesheet`,
	fr: `Pas de feuilles de temps`,
	hi: `कोई टाइमशीट नहीं`,
	ht: `Pa gen Timesheets`,
	it: `Nessun foglo orario`,
	ja: `タイムシートはなし`,
	ko: `근무 시간표는 없어`,
	mww: `Tsis muaj daim ntawv teev sijhawm`,
	ps: `هیڅ وخت پاڼې نشته`,
	pt: `Sem folhas de ponto`,
	'pt-pt': `Sem folhas de horas`,
	ru: `Нет табелей времени`,
	sm: `Leai ni pepa o taimi`,
	so: `Ma jiraan jadwalka waqtiga`,
	th: `ไม่มีไทม์ชีท`,
	ur: `کوئی ٹائم شیٹ نہیں`,
	vi: `Không có bảng chấm công`,
	'zh-hans': `没有工时表`,
	'zh-hant': `沒有工時表`,
	en: `No timesheets`
};

export const loc_notSubscribed: Record<Locale, string> = {
	ar: `غير مشترك`,
	de: `Nicht abonniert`,
	es: `No suscrito`,
	fa: `مشترک نیستم`,
	fil: `Hindi naka-subscribe`,
	fr: `Non abonné`,
	hi: `सदस्यता नहीं ली गई`,
	ht: `Pa abone`,
	it: `Non abbonato`,
	ja: `購読していません`,
	ko: `구독하지 않았습니다`,
	mww: `Tsis sau npe`,
	ps: `ګډون نه لرم`,
	pt: `Não assinado`,
	'pt-pt': `Não subscrito`,
	ru: `Не подписан`,
	sm: `E le'i lesitala`,
	so: `Ma aha mid isdiiwaangelin`,
	th: `ไม่ได้สมัครสมาชิก`,
	ur: `سبسکرائب نہیں ہوا`,
	vi: `Chưa đăng ký`,
	'zh-hans': `未订阅`,
	'zh-hant': `未訂閱`,
	en: `Not subscribed`
};

export const loc_noUpcomingEvents: Record<Locale, string> = {
	ar: `لا توجد فعاليات قادمة`,
	de: `Keine bevorstehenden Veranstaltungen`,
	es: `No hay eventos próximos`,
	fa: `هیچ رویداد آینده ای وجود ندارد`,
	fil: `Walang paparating na mga kaganapan`,
	fr: `Aucun événement à venir`,
	hi: `कोई आगामी कार्यक्रम नहीं`,
	ht: `Pa gen evènman kap vini yo`,
	it: `Nessun evento in arrivo`,
	ja: `今後のイベントはありません`,
	ko: `예정된 행사는 없습니다`,
	mww: `Tsis muaj kev tshwm sim tom ntej`,
	ps: `راتلونکې پیښې نشته`,
	pt: `Sem eventos futuros`,
	'pt-pt': `Sem eventos próximos`,
	ru: `Предстоящих мероприятий нет.`,
	sm: `Leai ni mea e tutupu i le lumana'i`,
	so: `Ma jiraan dhacdooyin soo socda`,
	th: `ไม่มีกิจกรรมที่จะเกิดขึ้น`,
	ur: `کوئی آنے والے ایونٹس نہیں`,
	vi: `Không có sự kiện sắp tới`,
	'zh-hans': `没有即将举办的活动`,
	'zh-hant': `沒有即將舉辦的活動`,
	en: `No upcoming events`
};

export const loc_noUpcomingEventsDescription: Record<Locale, string> = {
	ar: `سيتم إدراج الفعاليات القادمة هنا.`,
	de: `Bevorstehende Veranstaltungen werden hier aufgeführt.`,
	es: `Los próximos eventos se listarán aquí.`,
	fa: `رویدادهای آینده در اینجا فهرست خواهند شد.`,
	fil: `Ang mga paparating na kaganapan ay ililista dito.`,
	fr: `Les prochains événements seront listés ici.`,
	hi: `आगामी घटनाओं को यहां सूचीबद्ध किया जाएगा।`,
	ht: `Evènman kap vini yo pral ki nan lis isit la.`,
	it: `Gli eventi in programma saranno elencati qui.`,
	ja: `今後のイベントはこちらに掲載します。`,
	ko: `다가오는 행사는 여기에 나열될 예정입니다.`,
	mww: `Cov xwm txheej tom ntej yuav raug teev tseg ntawm no.`,
	ps: `راتلونکې پیښې به دلته لیست شی.`,
	pt: `Os próximos eventos serão listados aqui.`,
	'pt-pt': `Os próximos eventos serão listados aqui.`,
	ru: `Здесь будут перечислены предстоящие события.`,
	sm: `O mea o lo'o lumana'i o le a lisiina iinei.`,
	so: `Dhacdooyinka soo socda waxaa lagu taxi doonaa halkan.`,
	th: `กิจกรรมที่จะเกิดขึ้นจะถูกระบุไว้ที่นี่`,
	ur: `آنے والے ایونٹس یہاں درج کیے جائیں گے۔`,
	vi: `Các sự kiện sắp tới sẽ được liệt kê tại đây.`,
	'zh-hans': `即将举办的活动将在这里列出。`,
	'zh-hant': `即將舉辦的活動將在此列出。`,
	en: `Upcoming events will be listed here.`
};

export const loc_noUpcomingVaccineClinics: Record<Locale, string> = {
	ar: `لا توجد عيادات لقاح قادمة`,
	de: `Keine bevorstehenden Impfkliniken`,
	es: `No hay próximas clínicas de vacunación`,
	fa: `هیچ کلینیک واکسنی در آینده وجود ندارد`,
	fil: `Walang paparating na mga klinika sa bakuna`,
	fr: `Aucune clinique de vaccination à venir`,
	hi: `कोई आगामी वैक्सीन क्लीनिक नहीं`,
	ht: `Pa gen klinik vaksen kap vini yo`,
	it: `Nessuna clinica vaccinale in programma`,
	ja: `今後のワクチンクリニックはありません`,
	ko: `곧 있을 백신 클리닉은 없습니다`,
	mww: `Tsis muaj cov chaw txhaj tshuaj tiv thaiv tom ntej`,
	ps: `راتلونکی واکسین کلینیکونه نشته`,
	pt: `Não há próximas clínicas de vacinação`,
	'pt-pt': `Não há clínicas de vacinação previstas`,
	ru: `В ближайшие клиники вакцинации не будет.`,
	sm: `Leai se falema'i tui o lo'o lumana'i`,
	so: `Ma jiraan rugaha tallaalka ee soo socda`,
	th: `ไม่มีคลินิกวัคซีนที่กําลังจะมาถึง`,
	ur: `کوئی آنے والا ویکسین کلینک نہیں`,
	vi: `Không có phòng khám vắc-xin sắp tới`,
	'zh-hans': `没有即将到来的疫苗诊所`,
	'zh-hant': `沒有即將舉辦的疫苗診所`,
	en: `No upcoming vaccine clinics`
};

export const loc_noUpcomingVaccineClinicsDescription: Record<Locale, string> = {
	ar: `سيتم إدراج عيادات اللقاحات القادمة ضمن النطاق المختار هنا.`,
	de: `Kommende Impfkliniken im ausgewählten Bereich werden hier aufgeführt.`,
	es: `Aquí se listarán las próximas clínicas de vacunación dentro del rango seleccionado.`,
	fa: `کلینیک های واکسن آینده در محدوده انتخاب شده در اینجا فهرست خواهند شد.`,
	fil: `Ang mga paparating na klinika ng bakuna sa loob ng napiling saklaw ay nakalista dito.`,
	fr: `Les prochains cliniques de vaccination dans la plage sélectionnée seront listées ici.`,
	hi: `चयनित सीमा के भीतर आगामी वैक्सीन क्लीनिकों को यहां सूचीबद्ध किया जाएगा।`,
	ht: `Klinik vaksen kap vini yo nan seri chwazi a pral nan lis isit la.`,
	it: `Le prossime cliniche vaccinali all'interno dell'intervallo selezionato saranno elencate qui.`,
	ja: `選定範囲内の今後のワクチンクリニックはここに掲載されます。`,
	ko: `선택된 범위 내의 곧 개설될 백신 클리닉은 여기에 나열됩니다.`,
	mww: `Cov chaw txhaj tshuaj tiv thaiv kab mob tom ntej nyob rau hauv qhov kev xaiv yuav muab teev tseg ntawm no.`,
	ps: `راتلونکې واکسین کلینیکونه چې د ټاکل شوی حد دننه دی، دلته لیست کیږی.`,
	pt: `As próximas clínicas de vacinação dentro da faixa selecionada serão listadas aqui.`,
	'pt-pt': `As próximas clínicas de vacinação dentro do intervalo selecionado serão listadas aqui.`,
	ru: `Здесь будут перечислены будущие клиники вакцинации в выбранном диапазоне.`,
	sm: `O falema'i o lo'o lumana'i i totonu o le vaega filifilia o le a lisiina iinei.`,
	so: `Rugaha tallaalka ee soo socda ee ku jira xadka la doortay ayaa halkan lagu taxi doonaa.`,
	th: `คลินิกวัคซีนที่กําลังจะมาถึงภายในช่วงที่เลือกจะแสดงไว้ที่นี่`,
	ur: `منتخب کردہ رینج میں آنے والے ویکسین کلینکس یہاں درج کیے جائیں گے۔`,
	vi: `Các phòng khám vắc-xin sắp tới trong phạm vi đã chọn sẽ được liệt kê tại đây.`,
	'zh-hans': `选定范围内即将开设的疫苗诊所将在此列出。`,
	'zh-hant': `選定範圍內即將開設的疫苗診所將在此列出。`,
	en: `Upcoming vaccine clinics within the selected range will be listed here.`
};

export const loc_older: Record<Locale, string> = {
	ar: `أقدم`,
	de: `Älter`,
	es: `Más antigua`,
	fa: `قدیمی تر`,
	fil: `Mas matanda`,
	fr: `Plus anciens`,
	hi: `पुराना`,
	ht: `Pi gran`,
	it: `Più antichi`,
	ja: `年上`,
	ko: `더 오래된`,
	mww: `laus`,
	ps: `زوړ`,
	pt: `Mais antigos`,
	'pt-pt': `Mais antigos`,
	ru: `Старше`,
	sm: `Matutua`,
	so: `Da'da weyn`,
	th: `เก่ากว่า`,
	ur: `پرانا`,
	vi: `Cũ hơn`,
	'zh-hans': `年长`,
	'zh-hant': `較早`,
	en: `Older`
};

export const loc_oneActivity: Record<Locale, string> = {
	ar: `نشاط واحد`,
	de: `1 Aktivität`,
	es: `1 Actividad`,
	fa: `۱ فعالیت`,
	fil: `1 aktibidad`,
	fr: `1 Activité`,
	hi: `1 गतिविधि`,
	ht: `1 aktivite`,
	it: `1 Attività`,
	ja: `1 活動`,
	ko: `1 활동`,
	mww: `1 kev ua si`,
	ps: `۱ فعالیت`,
	pt: `1 Atividade`,
	'pt-pt': `1 Atividade`,
	ru: `1 Деятельность`,
	sm: `1 Gaoioiga`,
	so: `1 Hawlaha`,
	th: `1 กิจกรรม`,
	ur: `1 سرگرمی`,
	vi: `1 hoạt động`,
	'zh-hans': `1 活动`,
	'zh-hant': `1 活動`,
	en: `1 activity`
};

export const loc_oneClinic: Record<Locale, string> = {
	ar: `عيادة واحدة`,
	de: `Eine Klinik`,
	es: `Una clínica`,
	fa: `یک کلینیک`,
	fil: `Isang klinika`,
	fr: `Une clinique`,
	hi: `एक क्लिनिक`,
	ht: `Yon klinik`,
	it: `Una clinica`,
	ja: `1つのクリニック`,
	ko: `한 개의 클리닉`,
	mww: `Ib lub tsev kho mob`,
	ps: `یوه کلینیک`,
	pt: `Uma clínica`,
	'pt-pt': `Uma clínica`,
	ru: `Одна клиника`,
	sm: `Tasi le falema'i`,
	so: `Hal rug caafimaad`,
	th: `คลินิก 1 แห่ง`,
	ur: `ایک کلینک`,
	vi: `Một phòng khám`,
	'zh-hans': `一家诊所`,
	'zh-hant': `一間診所`,
	en: `One clinic`
};

export const loc_oneEventFound: Record<Locale, string> = {
	ar: `حدث واحد تم العثور عليه`,
	de: `Ein gefundenes Ereignis`,
	es: `Un evento encontrado`,
	fa: `یک رویداد یافت شد`,
	fil: `Isang pangyayari ang natagpuan`,
	fr: `Un événement trouvé`,
	hi: `एक घटना मिली`,
	ht: `Yon sèl evènman te jwenn`,
	it: `Un evento trovato`,
	ja: `一つの出来事が見つかった`,
	ko: `한 가지 사건이 발견되었습니다`,
	mww: `Ib qho xwm txheej pom`,
	ps: `یوه پېښه وموندل شوه`,
	pt: `Um evento encontrado`,
	'pt-pt': `Um evento encontrado`,
	ru: `Одно из найденных событий`,
	sm: `Tasi le mea na tupu na maua`,
	so: `Hal dhacdo ayaa la helay`,
	th: `พบเหตุการณ์หนึ่ง`,
	ur: `ایک واقعہ ملا`,
	vi: `Phát hiện một sự kiện`,
	'zh-hans': `发现了一件事`,
	'zh-hant': `發現一個事件`,
	en: `One event found`
};

export const loc_oneFile: Record<Locale, string> = {
	ar: `ملف واحد`,
	de: `1 Datei`,
	es: `1 archivo`,
	fa: `۱ فایل`,
	fil: `1 file`,
	fr: `1 dossier`,
	hi: `1 फ़ाइल`,
	ht: `1 dosye`,
	it: `1 file`,
	ja: `1ファイル`,
	ko: `1 파일`,
	mww: `1 ntaub ntawv`,
	ps: `۱ فایل`,
	pt: `1 arquivo`,
	'pt-pt': `1 ficheiro`,
	ru: `1 файл`,
	sm: `1 faila`,
	so: `1 fayl`,
	th: `1 ไฟล์`,
	ur: `1 فائل`,
	vi: `1 tập tin`,
	'zh-hans': `1个文件`,
	'zh-hant': `1 檔案`,
	en: `1 file`
};

export const loc_oneHundredMiles: Record<Locale, string> = {
	ar: `100 ميل`,
	de: `100 Meilen`,
	es: `100 millas`,
	fa: `۱۰۰ مایل`,
	fil: `100 milya`,
	fr: `100 miles`,
	hi: `100 मील`,
	ht: `100 mil`,
	it: `100 miglia`,
	ja: `100マイル`,
	ko: `100마일`,
	mww: `100 mais`,
	ps: `۱۰۰ میل`,
	pt: `100 milhas`,
	'pt-pt': `100 milhas`,
	ru: `100 миль`,
	sm: `100 maila`,
	so: `100 mayl`,
	th: `100.1 กม.`,
	ur: `100 میل`,
	vi: `100 dặm`,
	'zh-hans': `100英里`,
	'zh-hant': `100英里`,
	en: `100 miles`
};

export const loc_oneMedication: Record<Locale, string> = {
	ar: `دواء واحد`,
	de: `Ein Medikament`,
	es: `Un medicamento`,
	fa: `یک دارو`,
	fil: `Isang gamot`,
	fr: `Un médicament`,
	hi: `एक दवा`,
	ht: `Yon medikaman`,
	it: `Un farmaco`,
	ja: `1種類の薬`,
	ko: `약 한 가지`,
	mww: `Ib qho tshuaj`,
	ps: `یوه درمل`,
	pt: `Um medicamento`,
	'pt-pt': `Um medicamento`,
	ru: `Одно лекарство`,
	sm: `Tasi le vaila'au`,
	so: `Hal daawo`,
	th: `ยาหนึ่งตัว`,
	ur: `ایک دوا`,
	vi: `Một loại thuốc`,
	'zh-hans': `一种药物`,
	'zh-hant': `一種藥物`,
	en: `One medication`
};

export const loc_oneSignature: Record<Locale, string> = {
	ar: `توقيع واحد`,
	de: `1 Signatur`,
	es: `1 firma`,
	fa: `۱ امضا`,
	fil: `1 lagda`,
	fr: `1 signature`,
	hi: `1 हस्ताक्षर`,
	ht: `1 siyati`,
	it: `1 firma`,
	ja: `1つの署名`,
	ko: `서명 1개`,
	mww: `1 kos npe`,
	ps: `۱ لاسلیک`,
	pt: `1 assinatura`,
	'pt-pt': `1 assinatura`,
	ru: `1 подпись`,
	sm: `1 saini`,
	so: `1 saxiix`,
	th: `1 ลายเซ็น`,
	ur: `1 دستخط`,
	vi: `1 chữ ký`,
	'zh-hans': `1个签名`,
	'zh-hant': `1 個簽名`,
	en: `1 signature`
};

export const loc_oneSubscriber: Record<Locale, string> = {
	ar: `مشترك واحد`,
	de: `Ein Abonnent`,
	es: `Un suscriptor`,
	fa: `یک مشترک`,
	fil: `Isang tagasuskribi`,
	fr: `Un abonné`,
	hi: `एक ग्राहक`,
	ht: `Yon abònen`,
	it: `Un abbonato`,
	ja: `加入者1名`,
	ko: `가입자 1명`,
	mww: `Ib tus neeg rau npe`,
	ps: `یو ګډونوال`,
	pt: `Um assinante`,
	'pt-pt': `Um assinante`,
	ru: `Один подписчик`,
	sm: `Tasi le tagata fai saofaga`,
	so: `Hal macaamiil`,
	th: `สมาชิกหนึ่งคน`,
	ur: `ایک سبسکرائبر`,
	vi: `Một người đăng ký`,
	'zh-hans': `一名订阅者`,
	'zh-hant': `一名訂閱者`,
	en: `One subscriber`
};

export const loc_oneTimeCode: Record<Locale, string> = {
	ar: `رمز لمرة واحدة`,
	de: `Einmalcode`,
	es: `Código de un solo uso`,
	fa: `کد یک بار مصرف`,
	fil: `Isang beses na code`,
	fr: `Code à usage unique`,
	hi: `एक बार का कोड`,
	ht: `Yon sèl fwa kòd`,
	it: `Codice monouso`,
	ja: `ワンタイムコード`,
	ko: `일회성 코드`,
	mww: `Ib-lub sij hawm code`,
	ps: `یو ځل کوډ`,
	pt: `Código de uso único`,
	'pt-pt': `Código de uso único`,
	ru: `Одноразовый код`,
	sm: `Tasi le taimi code`,
	so: `Koodh hal mar ah`,
	th: `รหัสแบบใช้ครั้งเดียว`,
	ur: `ایک وقتی کوڈ`,
	vi: `Mã một lần`,
	'zh-hans': `一次性代码`,
	'zh-hant': `一次性代碼`,
	en: `One-time code`
};

export const loc_oneViewPastMonthFormat: Record<Locale, string> = {
	ar: `عرض واحد في الشهر الماضي`,
	de: `1 Ansicht im vergangenen Monat`,
	es: `1 visualización en el último mes`,
	fa: `۱ بازدید در ماه گذشته`,
	fil: `1 view sa nakaraang buwan`,
	fr: `1 vue le mois dernier`,
	hi: `पिछले महीने में 1 दृश्य`,
	ht: `1 View nan mwa ki sot pase yo`,
	it: `1 visualizzazione nell'ultimo mese`,
	ja: `過去1か月の閲覧数`,
	ko: `지난 한 달간 1회 조회수`,
	mww: `1 saib nyob rau hauv lub hli dhau los`,
	ps: `په تېرو میاشتو کې ۱ لید`,
	pt: `1 visualização no último mês`,
	'pt-pt': `1 visualização no último mês`,
	ru: `1 просмотр за последний месяц`,
	sm: `1 vaaiga i le masina talu ai`,
	so: `1 aragti bishii la soo dhaafay`,
	th: `ดู 1 ครั้งในเดือนที่ผ่านมา`,
	ur: `گزشتہ مہینے میں 1 منظر`,
	vi: `1 lượt xem trong tháng qua`,
	'zh-hans': `过去一个月的1次浏览`,
	'zh-hant': `過去一個月的1次瀏覽`,
	en: `1 view in past month`
};

export const loc_ongoing: Record<Locale, string> = {
	ar: `مستمر`,
	de: `Laufend`,
	es: `En curso`,
	fa: `ادامه دارد`,
	fil: `Patuloy`,
	fr: `En cours`,
	hi: `सतत`,
	ht: `Kontinyèl`,
	it: `In corso`,
	ja: `進行中`,
	ko: `진행 중`,
	mww: `Tsis tu ncua`,
	ps: `روان دی`,
	pt: `Em andamento`,
	'pt-pt': `Em curso`,
	ru: `Продолжается`,
	sm: `Fa'aauau pea`,
	so: `Socda`,
	th: `ต่อเนื่อง`,
	ur: `جاری`,
	vi: `Đang diễn ra`,
	'zh-hans': `正在进行中`,
	'zh-hant': `持續進行中`,
	en: `Ongoing`
};

export const loc_onHold: Record<Locale, string> = {
	ar: `على الانتظار`,
	de: `In der Warteschleife`,
	es: `En espera`,
	fa: `در انتظار`,
	fil: `Naka-hold`,
	fr: `En attente`,
	hi: `होल्ड पर`,
	ht: `Sou kenbe`,
	it: `In attesa`,
	ja: `保留中`,
	ko: `대기 중입니다`,
	mww: `Tuav`,
	ps: `په انتظار کې`,
	pt: `Em espera`,
	'pt-pt': `Em espera`,
	ru: `На удержании`,
	sm: `O lo'o taofia`,
	so: `Ku jirta hakad`,
	th: `พักสาย`,
	ur: `ہولڈ پر`,
	vi: `Tạm dừng`,
	'zh-hans': `等待中`,
	'zh-hant': `等待中`,
	en: `On hold`
};

export const loc_onHoldStatusDesc: Record<Locale, string> = {
	ar: `تم بدء النشاط لكن تم إيقاف العمل.`,
	de: `Die Aktivität wurde aufgenommen, aber die Arbeit wurde pausiert.`,
	es: `La actividad ya ha comenzado, pero el trabajo se ha pausado.`,
	fa: `فعالیت آغاز شده اما کار متوقف شده است.`,
	fil: `Sinimulan na ang aktibidad ngunit natigil pa rin ang trabaho.`,
	fr: `L’activité a été lancée mais les travaux ont été mis en pause.`,
	hi: `गतिविधि शुरू कर दी गई है लेकिन काम रोक दिया गया है।`,
	ht: `Aktivite a te kòmanse, men travay la te poze.`,
	it: `L'attività è già iniziata ma i lavori sono stati sospesi.`,
	ja: `活動は始まっていますが、作業は一時中断されています。`,
	ko: `활동은 시작되었으나 작업이 중단되었습니다.`,
	mww: `Qhov kev ua haujlwm tau pib tab sis kev ua haujlwm tau ncua.`,
	ps: `فعالیت پیل شوی خو کار ودرول شوی دی.`,
	pt: `A atividade já foi iniciada, mas o trabalho foi pausado.`,
	'pt-pt': `A atividade já foi iniciada, mas os trabalhos foram suspensos.`,
	ru: `Активность начата, но работа приостановлена.`,
	sm: `Ua amataina le gaoioiga, ae ua taofi le galuega.`,
	so: `Hawlgalka waa la bilaabay laakiin shaqada waa la hakiyay.`,
	th: `กิจกรรมได้เริ่มต้นแล้ว แต่งานถูกหยุดชั่วคราว`,
	ur: `سرگرمی شروع ہو چکی ہے لیکن کام روک دیا گیا ہے۔`,
	vi: `Hoạt động đã được bắt đầu nhưng công việc đã bị tạm dừng.`,
	'zh-hans': `活动已经开始，但工作暂时暂停。`,
	'zh-hant': `活動已開始，但工程暫停。`,
	en: `The activity has been started but work has been paused.`
};

export const loc_open: Record<Locale, string> = {
	ar: `مفتوح`,
	de: `Offen`,
	es: `Abierto`,
	fa: `باز`,
	fil: `Buksan`,
	fr: `Ouvre`,
	hi: `खोलना`,
	ht: `ouvè`,
	it: `Open`,
	ja: `開けて`,
	ko: `오픈`,
	mww: `qhib`,
	ps: `خلاص کړه`,
	pt: `Aberto`,
	'pt-pt': `Aberto`,
	ru: `Открыть`,
	sm: `Tatala`,
	so: `Fur`,
	th: `เปิด`,
	ur: `اوپن`,
	vi: `Mở`,
	'zh-hans': `开门`,
	'zh-hant': `開場`,
	en: `Open`
};

export const loc_openActivities: Record<Locale, string> = {
	ar: `الأنشطة المفتوحة`,
	de: `Offene Aktivitäten`,
	es: `Actividades abiertas`,
	fa: `فعالیت های آزاد`,
	fil: `Mga Bukas na Aktibidad`,
	fr: `Activités ouvertes`,
	hi: `खुली गतिविधियाँ`,
	ht: `Louvri aktivite yo`,
	it: `Attività aperte`,
	ja: `オープン活動`,
	ko: `오픈 활동`,
	mww: `Qhib kev ua si`,
	ps: `پرانیستې فعالیتونه`,
	pt: `Atividades abertas`,
	'pt-pt': `Atividades abertas`,
	ru: `Открытые мероприятия`,
	sm: `Gaoioiga tatala`,
	so: `Hawlaha furan`,
	th: `กิจกรรมแบบเปิด`,
	ur: `کھلی سرگرمیاں`,
	vi: `Hoạt động mở`,
	'zh-hans': `开放活动`,
	'zh-hant': `開放活動`,
	en: `Open activities`
};

export const loc_openActivitiesDesc: Record<Locale, string> = {
	ar: `سيتم إدراج أنشطة المسودة، والجاهز، والجارية، والأنشطة المعلقة هنا.`,
	de: `Entwurf-, Ready-, In-Progress- und In-Hold-Aktivitäten werden hier aufgeführt.`,
	es: `Aquí se listarán las actividades en borrador, listas, en curso y en espera.`,
	fa: `فعالیت های پیش نویس، آماده، در حال انجام و در حالت انتظار در اینجا فهرست خواهند شد.`,
	fil: `Ang mga draft, handa, in-progress, at on-hold na mga aktibidad ay nakalista dito.`,
	fr: `Les activités de brouillon, prêtes, en cours et en attente seront listées ici.`,
	hi: `ड्राफ्ट, तैयार, प्रगति पर और ऑन-होल्ड गतिविधियों को यहां सूचीबद्ध किया जाएगा।`,
	ht: `Draft, pare, nan-pwogrè ak sou kenbe aktivite yo pral ki nan lis isit la.`,
	it: `Le attività di bozza, pronte, in corso e in sospeso saranno elencate qui.`,
	ja: `ドラフト、準備中、進行中、保留中のアクティビティはここに掲載されます。`,
	ko: `초안, 준비 완료, 진행 중, 보류 활동이 여기에 나열됩니다.`,
	mww: `Cov ntawv sau, npaj txhij, tab tom ua, thiab tuav cov haujlwm yuav muaj teev nyob ntawm no.`,
	ps: `مسوده، چمتو، روانه او په انتظار کې فعالیتونه به دلته لیست شی.`,
	pt: `Atividades de rascunho, prontas, em andamento e em espera serão listadas aqui.`,
	'pt-pt': `Atividades de rascunho, prontas, em curso e em espera serão listadas aqui.`,
	ru: `Здесь будут перечислены проекты, готовые, текущие и находящиеся на удержании.`,
	sm: `O gaioiga fa'ata'ita'i, saunia, o lo'o alualu i luma, ma o lo'o taofia o le a lisiina iinei.`,
	so: `Hawlaha la qabtay, diyaar, socda, iyo kuwa la sugayo ayaa halkan lagu taxi doonaa.`,
	th: `กิจกรรมแบบร่าง พร้อม อยู่ระหว่างดําเนินการ และระงับจะแสดงรายการที่นี่`,
	ur: `ڈرافٹ، ریڈی، جاری اور ہولڈ سرگرمیاں یہاں درج ہوں گی۔`,
	vi: `Các hoạt động nháp, sẵn sàng, đang tiến hành và tạm dừng sẽ được liệt kê tại đây.`,
	'zh-hans': `草稿、准备中、进行中和暂停活动将在这里列出。`,
	'zh-hant': `草稿、已完成、進行中及暫停活動將在此列出。`,
	en: `Draft, ready, in-progress, and on-hold activities will be listed here.`
};

export const loc_openCount: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} مفتوح`,
	de: (count) => `${count} offen`,
	es: (count) => `${count} abiertos`,
	fa: (count) => `${count} باز`,
	fil: (count) => `${count} Buksan`,
	fr: (count) => `${count} ouvert`,
	hi: (count) => `${count} खुला`,
	ht: (count) => `${count} louvri`,
	it: (count) => `${count} open`,
	ja: (count) => `${count} オープン`,
	ko: (count) => `${count} 오픈`,
	mww: (count) => `${count} qhib`,
	ps: (count) => `${count} خلاص`,
	pt: (count) => `${count} abertos`,
	'pt-pt': (count) => `${count} abertos`,
	ru: (count) => `${count} открытых`,
	sm: (count) => `${count} tatala`,
	so: (count) => `${count} furan`,
	th: (count) => `${count} เปิด`,
	ur: (count) => `${count} کھلا`,
	vi: (count) => `${count} Mở`,
	'zh-hans': (count) => `${count} 号开放`,
	'zh-hant': (count) => `${count} 空檔`,
	en: (count) => `${count} open`
};

export const loc_openEpisodesAndRelations: Record<Locale, string> = {
	ar: `الحلقات المفتوحة والعلاقات`,
	de: `Offene Episoden & Beziehungen`,
	es: `Episodios abiertos y relaciones`,
	fa: `قسمت های باز و روابط`,
	fil: `Mga Bukas na Episode at Relasyon`,
	fr: `Épisodes ouverts et relations`,
	hi: `खुले एपिसोड और संबंध`,
	ht: `Epizòd louvri & relasyon`,
	it: `Episodi aperti e relazioni`,
	ja: `公開エピソードと関係`,
	ko: `공개 에피소드 및 관계`,
	mww: `Qhib ntu & kev sib raug zoo`,
	ps: `خلاصې برخې او اړیکې`,
	pt: `Episódios abertos e relações`,
	'pt-pt': `Episódios abertos e relações`,
	ru: `Открытые эпизоды и отношения`,
	sm: `Tatala vaega ma sootaga`,
	so: `Qaybaha furan iyo xiriirka`,
	th: `เปิดตอนและความสัมพันธ์`,
	ur: `کھلے اقساط اور تعلقات`,
	vi: `Mở các tập và mối quan hệ`,
	'zh-hans': `公开剧集与关系`,
	'zh-hant': `公開集數與關係`,
	en: `Open episodes & relations`
};

export const loc_openStatus: Record<Locale, string> = {
	ar: `الحالات المفتوحة`,
	de: `Offene Status`,
	es: `Estatus abiertos`,
	fa: `وضعیت های باز`,
	fil: `Mga Bukas na Katayuan`,
	fr: `Statuts ouverts`,
	hi: `खुली स्थितियाँ`,
	ht: `Estati louvri`,
	it: `Status aperti`,
	ja: `オープンステータス`,
	ko: `오픈 상태`,
	mww: `Qhib cov xwm txheej`,
	ps: `پرانیستې حالتونه`,
	pt: `Status abertos`,
	'pt-pt': `Estatutos abertos`,
	ru: `Открытые статусы`,
	sm: `Tatala tulaga`,
	so: `Xaaladaha furan`,
	th: `สถานะเปิด`,
	ur: `کھلی حالتیں`,
	vi: `Trạng thái mở`,
	'zh-hans': `公开状态`,
	'zh-hant': `公開狀態`,
	en: `Open statuses`
};

export const loc_or: Record<Locale, string> = {
	ar: `أو`,
	de: `Oder`,
	es: `O`,
	fa: `یا`,
	fil: `O`,
	fr: `Ou`,
	hi: `या`,
	ht: `oswa`,
	it: `Oppure`,
	ja: `あるいは`,
	ko: `또는`,
	mww: `los yog`,
	ps: `یا`,
	pt: `Ou`,
	'pt-pt': `Ou`,
	ru: `Или`,
	sm: `po'o le`,
	so: `Ama`,
	th: `หรือ`,
	ur: `یا`,
	vi: `hoặc`,
	'zh-hans': `或者`,
	'zh-hant': `或者`,
	en: `Or`
};

export const loc_organization: Record<Locale, string> = {
	ar: `التنظيم`,
	de: `Organisation`,
	es: `Organización`,
	fa: `سازماندهی`,
	fil: `Organisasyon`,
	fr: `Organisation`,
	hi: `संगठन`,
	ht: `Òganizasyon an`,
	it: `Organizzazione`,
	ja: `組織`,
	ko: `조직`,
	mww: `Lub koom haum`,
	ps: `سازمان`,
	pt: `Organização`,
	'pt-pt': `Organização`,
	ru: `Организация`,
	sm: `Fa'alapotopotoga`,
	so: `Qaab-dhismeedka`,
	th: `องค์กร`,
	ur: `تنظیم`,
	vi: `Tổ chức`,
	'zh-hans': `组织结构`,
	'zh-hant': `組織架構`,
	en: `Organization`
};

export const loc_organizationActivities: Record<Locale, string> = {
	ar: `أنشطة المنظمة`,
	de: `Organisationsaktivitäten`,
	es: `Actividades organizativas`,
	fa: `فعالیت های سازمانی`,
	fil: `Mga aktibidad ng organisasyon`,
	fr: `Activités organisationnelles`,
	hi: `संगठन की गतिविधियाँ`,
	ht: `Aktivite òganizasyon an`,
	it: `Attività organizzative`,
	ja: `組織活動`,
	ko: `조직 활동`,
	mww: `Lub koom haum kev ua ub no`,
	ps: `د سازمان فعالیتونه`,
	pt: `Atividades organizacionais`,
	'pt-pt': `Atividades organizacionais`,
	ru: `Деятельность организации`,
	sm: `Gaoioiga a le faalapotopotoga`,
	so: `Hawlaha ururka`,
	th: `กิจกรรมขององค์กร`,
	ur: `تنظیمی سرگرمیاں`,
	vi: `Hoạt động tổ chức`,
	'zh-hans': `组织活动`,
	'zh-hant': `組織活動`,
	en: `Organization activities`
};

export const loc_organizationAgencyDesc: Record<Locale, string> = {
	ar: `منظمة تشارك في المشروع لا يمتلك مستخدموها حسابات Cumulus.`,
	de: `Eine Organisation, die am Projekt teilnimmt und deren Nutzer keine Cumulus-Konten haben.`,
	es: `Una organización que participa en el proyecto cuyos usuarios no tienen cuentas de Cumulus.`,
	fa: `سازمانی که در پروژه شرکت دارد و کاربرانش حساب Cumulus ندارند.`,
	fil: `Isang organisasyon na lumahok sa proyekto na ang mga gumagamit ay walang Cumulus account.`,
	fr: `Une organisation participant au projet dont les utilisateurs n’ont pas de compte Cumulus.`,
	hi: `परियोजना में भाग लेने वाला एक संगठन जिसके उपयोगकर्ताओं के पास क्यूम्यलस खाते नहीं हैं।`,
	ht: `Yon òganizasyon k ap patisipe nan pwojè a ki gen itilizatè yo pa gen kont Cumulus`,
	it: `Un'organizzazione che partecipa al progetto i cui utenti non hanno account Cumulus.`,
	ja: `Cumulusアカウントを持たないユーザーでプロジェクトに参加している組織。`,
	ko: `Cumulus 계정이 없는 사용자가 참여하는 조직입니다.`,
	mww: `Ib lub koom haum koom nrog txoj haujlwm uas nws cov neeg siv tsis muaj tus account Cumulus.`,
	ps: `یوه اداره چې په پروژه کې برخه لری او کاروونکی یې د Cumulus حسابونه نه لری.`,
	pt: `Uma organização que participa do projeto cujos usuários não possuem contas Cumulus.`,
	'pt-pt': `Uma organização que participa no projeto cujos utilizadores não têm contas Cumulus.`,
	ru: `Организация, участвующая в проекте, пользователи которой не имеют аккаунтов Cumulus.`,
	sm: `O se fa'alapotopotoga o lo'o auai i le poloketi o ona tagata fa'aoga e leai ni teuga tupe a Cumulus.`,
	so: `Hay'ad ka qayb qaadanaysa mashruuca oo isticmaalayaashiisu aysan lahayn xisaab Cumulus ah.`,
	th: `องค์กรที่เข้าร่วมในโครงการที่ผู้ใช้ไม่มีบัญชี Cumulus`,
	ur: `ایک تنظیم جو اس منصوبے میں شامل ہے اور جس کے صارفین کے پاس Cumulus اکاؤنٹس نہیں ہیں۔`,
	vi: `Một tổ chức tham gia vào dự án có người dùng không có tài khoản Cumulus.`,
	'zh-hans': `参与该项目的组织，其用户没有Cumulus账户。`,
	'zh-hant': `一個參與專案的組織，其用戶沒有 Cumulus 帳號。`,
	en: `An organization participating in the project whose users do not have Cumulus accounts.`
};

export const loc_organizationContactsDescription: Record<Locale, (membersHref: unknown) => TemplateResult> = {
	ar: (membersHref) => html`سجل جهات الاتصال الإدارية والفوترية وأنواع أخرى من الاتصالات. استخدم <a class="Link--secondary text-bold" href="${membersHref}">قسم الأعضاء</a> لإضافة مستخدمين إلى منظمتك.`,
	de: (membersHref) => html`Erfassen Sie Verwaltungs-, Abrechnungs- und andere Kontakte. Nutzen Sie den <a class="Link--secondary text-bold" href="${membersHref}">Mitgliederbereich</a> , um Benutzer zu Ihrer Organisation hinzuzufügen.`,
	es: (membersHref) => html`Registrar contactos administrativos, de facturación y de otros tipos de contactos. Utiliza la <a class="Link--secondary text-bold" href="${membersHref}">sección de miembros</a> para añadir usuarios a tu organización.`,
	fa: (membersHref) => html`تماس های اداری، صورتحساب و سایر انواع تماس ها را ثبت کنید. از <a class="Link--secondary text-bold" href="${membersHref}">بخش اعضا</a> برای افزودن کاربران به سازمان خود استفاده کنید.`,
	fil: (membersHref) => html`I-record ang mga administratibo, pagsingil, at iba pang mga uri ng mga contact. Gamitin ang <a class="Link--secondary text-bold" href="${membersHref}">seksyon ng mga miyembro</a> upang magdagdag ng mga gumagamit sa iyong samahan.`,
	fr: (membersHref) => html`Enregistrez les contacts administratifs, facturants et autres. Utilisez la <a class="Link--secondary text-bold" href="${membersHref}">section membres</a> pour ajouter des utilisateurs à votre organisation.`,
	hi: (membersHref) => html`प्रशासनिक, बिलिंग और अन्य प्रकार के संपर्कों को रिकॉर्ड करें. उपयोगकर्ताओं को अपने संगठन में जोड़ने के लिए <a class="Link--secondary text-bold" href="${membersHref}">सदस्य अनुभाग</a> का उपयोग करें.`,
	ht: (membersHref) => html`Dosye administratif, bòdwo, ak lòt kalite kontak. Sèvi ak <a class="Link--secondary text-bold" href="${membersHref}">seksyon manm</a> yo ajoute itilizatè yo nan òganizasyon ou an.`,
	it: (membersHref) => html`Registra contatti amministrativi, di fatturazione e di altri tipi di contatti. Usa la <a class="Link--secondary text-bold" href="${membersHref}">sezione membri</a> per aggiungere utenti alla tua organizzazione.`,
	ja: (membersHref) => html`管理、請求、その他の連絡を記録する。メンバー <a class="Link--secondary text-bold" href="${membersHref}">セクション</a> を使ってユーザーを組織に追加してください。`,
	ko: (membersHref) => html`행정, 청구 및 기타 연락처를 기록하세요. <a class="Link--secondary text-bold" href="${membersHref}">회원 섹션</a> 을 이용해 조직에 사용자를 추가하세요.`,
	mww: (membersHref) => html`Sau cov ntaub ntawv tswj hwm, them nqi thiab lwm yam kev sib cuag. Siv cov <a class="Link--secondary text-bold" href="${membersHref}">tswv cuab seem</a> ntxiv cov neeg siv rau koj lub koom haum.`,
	ps: (membersHref) => html`اداری، بیلینګ، او نور ډول اړیکې ثبت کړئ. د <a class="Link--secondary text-bold" href="${membersHref}">غړو برخه</a> وکاروئ ترڅو خپل سازمان ته کاروونکی اضافه کړئ.`,
	pt: (membersHref) => html`Registre contatos administrativos, de faturamento e outros tipos. Use a <a class="Link--secondary text-bold" href="${membersHref}">seção de membros</a> para adicionar usuários à sua organização.`,
	'pt-pt': (membersHref) => html`Registar contactos administrativos, de faturação e outros tipos de contactos. Use a <a class="Link--secondary text-bold" href="${membersHref}">secção de membros</a> para adicionar utilizadores à sua organização.`,
	ru: (membersHref) => html`Фиксируйте административные, выставленные и другие контакты. Используйте <a class="Link--secondary text-bold" href="${membersHref}">раздел участников</a> , чтобы добавить пользователей в вашу организацию.`,
	sm: (membersHref) => html`Faamaumau faamaumauga o le pulega, pili, ma isi ituaiga o fesootaiga. Faaaoga le vaega o tagata <a class="Link--secondary text-bold" href="${membersHref}">o le ekalesia</a> e faaopoopo ai tagata faaaoga i lau faalapotopotoga.`,
	so: (membersHref) => html`Diiwaangeli xiriirada maamulka, biilka, iyo noocyada kale ee xiriirka. Isticmaal <a class="Link--secondary text-bold" href="${membersHref}">qaybta xubnaha</a> si aad ugu darsato isticmaaleyaal ururkaaga.`,
	th: (membersHref) => html`บันทึกผู้ดูแลระบบ การเรียกเก็บเงิน และผู้ติดต่อชนิดอื่นๆ ใช้ <a class="Link--secondary text-bold" href="${membersHref}">ส่วนสมาชิก</a> เพื่อเพิ่มผู้ใช้ในองค์กรของคุณ`,
	ur: (membersHref) => html`انتظامی، بلنگ اور دیگر اقسام کے رابطوں کو ریکارڈ کریں۔ اپنی تنظیم میں صارفین شامل کرنے کے <a class="Link--secondary text-bold" href="${membersHref}">لیے ممبرز سیکشن</a> استعمال کریں۔`,
	vi: (membersHref) => html`Ghi lại các loại liên hệ quản trị, thanh toán và các loại liên hệ khác. Sử dụng <a class="Link--secondary text-bold" href="${membersHref}">phần thành viên</a> để thêm người dùng vào tổ chức của bạn.`,
	'zh-hans': (membersHref) => html`记录行政、账单及其他类型的联系。使用 <a class="Link--secondary text-bold" href="${membersHref}">成员部分</a> 添加用户到你的组织。`,
	'zh-hant': (membersHref) => html`記錄行政、帳單及其他類型的聯絡。使用 <a class="Link--secondary text-bold" href="${membersHref}">會員區</a> 塊來新增使用者到你的組織。`,
	en: (membersHref) => html`Record administrative, billing, and other types of contacts. Use the <a class="Link--secondary text-bold" href="${membersHref}">members section</a> to add users to your organization.`
};

export const loc_organizationEvent: Record<Locale, string> = {
	ar: `الحدث`,
	de: `Veranstaltung`,
	es: `Evento`,
	fa: `رویداد`,
	fil: `Kaganapan`,
	fr: `Événement`,
	hi: `आयोजन`,
	ht: `Evènman an`,
	it: `Evento`,
	ja: `イベント`,
	ko: `행사`,
	mww: `Kev tshwm sim`,
	ps: `پیښه`,
	pt: `Evento`,
	'pt-pt': `Evento`,
	ru: `Событие`,
	sm: `Mea na tupu`,
	so: `Dhacdo`,
	th: `เหตุการณ์`,
	ur: `تقریب`,
	vi: `Sự kiện`,
	'zh-hans': `事件`,
	'zh-hant': `活動`,
	en: `Event`
};

export const loc_organizationEventDesc: Record<Locale, string> = {
	ar: `حدث مباشر أو حملة أو نشاط آخر يستهدف مجموعة من الأفراد.`,
	de: `Eine Live-Veranstaltung, Kampagne oder andere Aktivität, die sich an eine Gruppe von Personen richtet.`,
	es: `Un evento presencial en vivo, campaña u otra actividad dirigida a un grupo de personas.`,
	fa: `یک رویداد زنده، کمپین یا فعالیت حضوری که گروهی از افراد را هدف قرار می دهد.`,
	fil: `Isang personal na live na kaganapan, kampanya, o iba pang aktibidad na nagta-target sa isang pangkat ng mga indibidwal.`,
	fr: `Un événement en présentiel, une campagne ou une autre activité ciblant un groupe d’individus.`,
	hi: `व्यक्तियों के समूह को लक्षित करने वाला एक व्यक्तिगत लाइव इवेंट, अभियान या अन्य गतिविधि.`,
	ht: `Yon evènman an dirèk an pèsòn, kanpay, oswa lòt aktivite ki vize yon gwoup moun.`,
	it: `Un evento dal vivo in presenza, una campagna o un'altra attività rivolta a un gruppo di persone.`,
	ja: `個人グループを対象とした対面のライブイベント、キャンペーン、またはその他の活動。`,
	ko: `개인을 대상으로 한 대면 라이브 이벤트, 캠페인 또는 기타 활동.`,
	mww: `Ib qho kev tshwm sim nyob ntawm tus kheej, phiaj xwm, lossis lwm yam haujlwm uas tsom rau ib pab pawg neeg.`,
	ps: `یو حضوری ژوندۍ پیښه، کمپاین، یا بل فعالیت چې د افرادو یوې ډلې ته هدف وی.`,
	pt: `Um evento presencial ao vivo, campanha ou outra atividade voltada para um grupo de pessoas.`,
	'pt-pt': `Um evento presencial ao vivo, campanha ou outra atividade direcionada a um grupo de indivíduos.`,
	ru: `Живое мероприятие, кампания или другое мероприятие, ориентированное на группу людей.`,
	sm: `O se mea na tupu i le tagata lava ia, tauiviga, po'o isi gaioiga e fa'atatau i se vaega o tagata ta'ito'atasi.`,
	so: `Dhacdo toos ah, ololaha, ama hawl kale oo lagu beegsanayo koox shakhsiyaad ah.`,
	th: `กิจกรรมถ่ายทอดสดแบบตัวต่อตัว แคมเปญ หรือกิจกรรมอื่นๆ ที่กําหนดเป้าหมายไปยังกลุ่มบุคคล`,
	ur: `ذاتی طور پر لائیو ایونٹ، مہم، یا کوئی اور سرگرمی جو افراد کے ایک گروپ کو ہدف بناتی ہو۔`,
	vi: `Sự kiện trực tiếp, chiến dịch hoặc hoạt động khác nhắm mục tiêu đến một nhóm cá nhân.`,
	'zh-hans': `针对一群人的现场活动、活动或其他活动。`,
	'zh-hant': `針對一群人舉辦的現場活動、活動或其他活動。`,
	en: `An in-person live event, campaign, or other activity targeting a group of individuals.`
};

export const loc_organizationMember: Record<Locale, string> = {
	ar: `عضو في المنظمة`,
	de: `Mitglied der Organisation`,
	es: `Miembro de la organización`,
	fa: `عضو سازمان`,
	fil: `Miyembro ng organisasyon`,
	fr: `Membre de l’organisation`,
	hi: `संगठन के सदस्य`,
	ht: `Manm òganizasyon an`,
	it: `Membro dell'organizzazione`,
	ja: `組織メンバー`,
	ko: `조직 회원`,
	mww: `Tus tswv cuab ntawm lub koom haum`,
	ps: `د سازمان غړی`,
	pt: `Membro da organização`,
	'pt-pt': `Membro da organização`,
	ru: `Член организации`,
	sm: `Sui o le faalapotopotoga`,
	so: `Xubin urur`,
	th: `สมาชิกองค์กร`,
	ur: `تنظیم کا رکن`,
	vi: `Thành viên tổ chức`,
	'zh-hans': `组织成员`,
	'zh-hant': `組織成員`,
	en: `Organization member`
};

export const loc_organizationMembers: Record<Locale, string> = {
	ar: `أعضاء المنظمة`,
	de: `Mitglieder der Organisation`,
	es: `Miembros de la organización`,
	fa: `اعضای سازمان`,
	fil: `Mga miyembro ng organisasyon`,
	fr: `Membres de l’organisation`,
	hi: `संगठन के सदस्य`,
	ht: `Manm òganizasyon an`,
	it: `Membri dell'organizzazione`,
	ja: `組織メンバー`,
	ko: `조직 구성원`,
	mww: `Cov tswv cuab ntawm lub koom haum`,
	ps: `د سازمان غړی`,
	pt: `Membros da organização`,
	'pt-pt': `Membros da organização`,
	ru: `Члены организации`,
	sm: `Sui o le faalapotopotoga`,
	so: `Xubnaha ururka`,
	th: `สมาชิกองค์กร`,
	ur: `تنظیم کے ارکان`,
	vi: `Thành viên tổ chức`,
	'zh-hans': `组织成员`,
	'zh-hant': `組織成員`,
	en: `Organization members`
};

export const loc_organizationPeriodDesc: Record<Locale, string> = {
	ar: `إطار زمني يستخدم لمحاذاة تواريخ بدء ونهاية النشاط مع نطاق زمني محدد.`,
	de: `Ein Zeitrahmen, der verwendet wird, um Start- und Enddaten der Aktivitäten auf einen bestimmten Zeitraum abzustimmen.`,
	es: `Un marco temporal utilizado para alinear las fechas de inicio y fin de la actividad con un rango de fechas específico.`,
	fa: `یک بازه زمانی برای هماهنگ کردن تاریخ های شروع و پایان فعالیت با یک بازه زمانی مشخص استفاده می شود.`,
	fil: `Isang time-frame na ginagamit upang ihanay ang mga petsa ng pagsisimula at pagtatapos ng aktibidad sa isang tiyak na hanay ng petsa.`,
	fr: `Un délai utilisé pour aligner les dates de début et de fin des activités à une plage de dates spécifique.`,
	hi: `गतिविधि प्रारंभ और समाप्ति तिथियों को किसी विशिष्ट दिनांक सीमा से संरेखित करने के लिए उपयोग की जाने वाली समय-सीमा.`,
	ht: `Yon tan-ankadreman itilize pou aliman dat kòmanse ak fen aktivite nan yon seri dat espesifik.`,
	it: `Un intervallo temporale utilizzato per allineare le date di inizio e fine delle attività a un intervallo di date specifico.`,
	ja: `活動開始日と終了日を特定の日付範囲に合わせるための時間枠です。`,
	ko: `활동 시작일과 종료일을 특정 날짜 범위에 맞추기 위해 사용되는 시간 프레임입니다.`,
	mww: `Ib lub sij hawm siv los kho cov hnub pib thiab xaus rau ib lub sijhawm tshwj xeeb.`,
	ps: `یو وخت چوکاټ چې د فعالیت د پیل او پای نیټې د یوې ځانګړې نېټې سره د تطابق لپاره کارول کېږی.`,
	pt: `Um período de tempo usado para alinhar as datas de início e término das atividades a um intervalo de datas específico.`,
	'pt-pt': `Um marco temporal usado para alinhar as datas de início e fim da atividade a um intervalo de datas específico.`,
	ru: `Временной промежуток, используемый для согласования дат начала и окончания деятельности с определённым диапазоном дат.`,
	sm: `O se taimi fa'atulagaina e fa'aaoga e fa'afetaui ai aso amata ma fa'ai'u o gaioiga i se aso fa'apitoa.`,
	so: `Waqti loo isticmaalo in lagu waafajiyo taariikhaha bilowga iyo dhammaadka hawlaha si loo waafajiyo taariikh gaar ah.`,
	th: `กรอบเวลาที่ใช้ในการจัดตําแหน่งวันที่เริ่มต้นและสิ้นสุดของกิจกรรมให้ตรงกับช่วงวันที่ที่ระบุ`,
	ur: `ایک وقت کا فریم جو سرگرمی کے آغاز اور اختتام کی تاریخوں کو مخصوص تاریخ کی حد کے مطابق ترتیب دینے کے لیے استعمال ہوتا ہے۔`,
	vi: `Khung thời gian được sử dụng để căn chỉnh ngày bắt đầu và ngày kết thúc hoạt động theo một phạm vi ngày cụ thể.`,
	'zh-hans': `一个时间框架，用于将活动开始和结束日期对齐到特定的日期范围。`,
	'zh-hant': `一個用來將活動開始與結束日期對齊特定日期範圍的時間框架。`,
	en: `A time-frame used to align activity start and end dates to a specific date range.`
};

export const loc_organizationQuestionnaire: Record<Locale, string> = {
	ar: `استبيان التنظيم`,
	de: `Organisationsfragebogen`,
	es: `Cuestionario de organización`,
	fa: `پرسشنامه سازمانی`,
	fil: `Talatanungan ng organisasyon`,
	fr: `Questionnaire sur l’organisation`,
	hi: `संगठन प्रश्नावली`,
	ht: `Kesyonè òganizasyon an`,
	it: `Questionario organizzativo`,
	ja: `組織アンケート`,
	ko: `조직 설문지`,
	mww: `Cov lus nug ntawm lub koom haum`,
	ps: `د سازمان پوښتنلیک`,
	pt: `Questionário da organização`,
	'pt-pt': `Questionário da organização`,
	ru: `Организационная анкета`,
	sm: `Fesili a le faalapotopotoga`,
	so: `Su'aalaha ururka`,
	th: `แบบสอบถามองค์กร`,
	ur: `تنظیمی سوالنامہ`,
	vi: `Bảng câu hỏi tổ chức`,
	'zh-hans': `组织问卷`,
	'zh-hant': `組織問卷`,
	en: `Organization questionnaire`
};

export const loc_organizationQuestionnaireDesc: Record<Locale, string> = {
	ar: `مجموعة من الأسئلة المتعلقة بمنظمة أو مستخدم، غير مرتبطة بعميل معين.`,
	de: `Eine Reihe von Fragen, die sich auf eine Organisation oder einen Nutzer beziehen, aber nichts mit einem bestimmten Kunden zu tun haben.`,
	es: `Un conjunto de preguntas relacionadas con una organización o usuario, no relacionadas con un cliente específico.`,
	fa: `مجموعه ای از سوالات مرتبط با یک سازمان یا کاربر، که به یک مشتری خاص مرتبط نیست.`,
	fil: `Isang hanay ng mga katanungan na may kaugnayan sa isang organisasyon o gumagamit, na walang kaugnayan sa isang partikular na kliyente.`,
	fr: `Un ensemble de questions liées à une organisation ou à un utilisateur, sans rapport avec un client spécifique.`,
	hi: `किसी संगठन या उपयोगकर्ता से संबंधित प्रश्नों का एक सेट, जो किसी विशिष्ट क्लाइंट से असंबंधित होता है.`,
	ht: `Yon seri kesyon ki gen rapò ak yon òganizasyon oswa itilizatè, ki pa gen rapò ak yon kliyan espesifik.`,
	it: `Un insieme di domande relative a un'organizzazione o a un utente, non collegate a un cliente specifico.`,
	ja: `特定のクライアントとは関係のない、組織やユーザーに関する一連の質問です。`,
	ko: `특정 클라이언트와는 무관한 조직이나 사용자와 관련된 질문 집합입니다.`,
	mww: `Ib pawg ntawm cov lus nug ntsig txog ib lub koom haum lossis tus neeg siv, tsis cuam tshuam nrog tus neeg siv khoom tshwj xeeb.`,
	ps: `د یوې ادارې یا کارونکی اړوند پوښتنو ټولګه، چې له ځانګړی پیرودونکی سره تړاو نه لری.`,
	pt: `Um conjunto de perguntas relacionadas a uma organização ou usuário, sem relação com um cliente específico.`,
	'pt-pt': `Um conjunto de perguntas relacionadas com uma organização ou utilizador, não relacionadas com um cliente específico.`,
	ru: `Набор вопросов, связанных с организацией или пользователем, не связанных с конкретным клиентом.`,
	sm: `O se seti o fesili e feso'ota'i ma se fa'alapotopotoga po'o se tagata fa'aaoga, e le feso'ota'i ma se tagata fa'apitoa.`,
	so: `Su'aalo la xiriira urur ama isticmaale, oo aan la xiriirin macmiil gaar ah.`,
	th: `ชุดคําถามที่เกี่ยวข้องกับองค์กรหรือผู้ใช้ ซึ่งไม่เกี่ยวข้องกับไคลเอ็นต์เฉพาะ`,
	ur: `کسی تنظیم یا صارف سے متعلق سوالات کا مجموعہ، جو کسی مخصوص کلائنٹ سے متعلق نہیں ہے۔`,
	vi: `Một tập hợp các câu hỏi liên quan đến một tổ chức hoặc người dùng, không liên quan đến một khách hàng cụ thể.`,
	'zh-hans': `一组与某个组织或用户相关的问题，与特定客户无关。`,
	'zh-hant': `一組與組織或使用者相關的問題，與特定客戶無關。`,
	en: `A set of questions related to an organization or user, unrelated to a specific client.`
};

export const loc_organizations: Record<Locale, string> = {
	ar: `المنظمات`,
	de: `Organisationen`,
	es: `Organizaciones`,
	fa: `سازمان ها`,
	fil: `Mga Organisasyon`,
	fr: `Organisations`,
	hi: `संगठनों`,
	ht: `Òganizasyon yo`,
	it: `Organizzazioni`,
	ja: `組織`,
	ko: `단체`,
	mww: `Cov koom haum`,
	ps: `سازمانونه`,
	pt: `Organizações`,
	'pt-pt': `Organizações`,
	ru: `Организации`,
	sm: `Fa'alapotopotoga`,
	so: `Ururada`,
	th: `องค์กร`,
	ur: `تنظیمیں`,
	vi: `Tổ chức`,
	'zh-hans': `组织`,
	'zh-hant': `組織`,
	en: `Organizations`
};

export const loc_organizationSiteDesc: Record<Locale, string> = {
	ar: `موقع تجري فيه المنظمة عملياتها.`,
	de: `Ein Ort, an dem eine Organisation tätig ist.`,
	es: `Un lugar donde una organización realiza sus operaciones.`,
	fa: `مکانی که یک سازمان در آن عملیات انجام می دهد.`,
	fil: `Isang lugar kung saan ang isang organisasyon ay nagsasagawa ng mga operasyon.`,
	fr: `Un lieu où une organisation mène ses opérations.`,
	hi: `एक स्थान जहां एक संगठन संचालन करता है।`,
	ht: `Yon kote yon òganizasyon ap fè operasyon.`,
	it: `Un luogo dove un'organizzazione conduce operazioni.`,
	ja: `組織が作戦を行う場所。`,
	ko: `조직이 운영을 수행하는 장소입니다.`,
	mww: `Ib qho chaw uas ib lub koom haum ua haujlwm.`,
	ps: `یو ځای چې یوه اداره پکې عملیات ترسره کوی.`,
	pt: `Um local onde uma organização realiza operações.`,
	'pt-pt': `Um local onde uma organização realiza operações.`,
	ru: `Место, где организация проводит операции.`,
	sm: `O se nofoaga e fa'atautaia ai e se fa'alapotopotoga gaioiga.`,
	so: `Goob ay urur ka hawlgallo ka wado.`,
	th: `สถานที่ที่องค์กรดําเนินการ`,
	ur: `ایک ایسی جگہ جہاں کوئی تنظیم آپریشنز کرتی ہے۔`,
	vi: `Một địa điểm mà một tổ chức tiến hành các hoạt động.`,
	'zh-hans': `一个组织进行运营的地点。`,
	'zh-hant': `一個組織進行運作的地點。`,
	en: `A location where an organization conducts operations.`
};

export const loc_organizationSitesDescription: Record<Locale, string> = {
	ar: `سجل اسم ورقم هاتف وعنوان المواقع التي تعمل فيها شركتك.`,
	de: `Notieren Sie den Namen, die Telefonnummer und die Adresse der Standorte, an denen Ihr Unternehmen tätig ist.`,
	es: `Registra el nombre, número de teléfono y dirección de los sitios donde opera tu organización.`,
	fa: `نام، شماره تلفن و آدرس سایت هایی که سازمان شما در آن فعالیت می کند را ثبت کنید.`,
	fil: `Itala ang pangalan, numero ng telepono, at address ng mga site kung saan nagpapatakbo ang iyong samahan.`,
	fr: `Notez le nom, le numéro de téléphone et l’adresse des sites où votre organisation opère.`,
	hi: `उन साइटों का नाम, फ़ोन नंबर और पता रिकॉर्ड करें जहाँ आपका संगठन संचालित होता है.`,
	ht: `Anrejistre non, nimewo telefòn, ak adrès sit kote òganizasyon w lan ap travay.`,
	it: `Annota nome, numero di telefono e indirizzo dei siti dove opera la tua organizzazione.`,
	ja: `組織が運営している場所の名前、電話番号、住所を記録してください。`,
	ko: `조직이 운영하는 사이트의 이름, 전화번호, 주소를 기록하세요.`,
	mww: `Sau lub npe, xov tooj, thiab chaw nyob ntawm cov chaw uas koj lub koom haum ua haujlwm.`,
	ps: `د هغو سایټونو نوم، تلیفون شمېره، او پته ثبت کړئ چې ستاسو اداره پکې فعالیت کوی.`,
	pt: `Registre o nome, telefone e endereço dos sites onde sua organização opera.`,
	'pt-pt': `Registe o nome, número de telefone e morada dos sites onde a sua organização opera.`,
	ru: `Запишите название, номер телефона и адрес сайтов, где работает ваша организация.`,
	sm: `Faamaumau le igoa, numera o le telefoni, ma le tuatusi o nofoaga o loo faagaoioia ai lau faalapotopotoga.`,
	so: `Diiwaangeli magaca, lambarka telefoonka, iyo cinwaanka goobaha ay ururkaagu ka shaqeeyo.`,
	th: `บันทึกชื่อ หมายเลขโทรศัพท์ และที่อยู่ของเว็บไซต์ที่องค์กรของคุณดําเนินการอยู่`,
	ur: `ان سائٹس کا نام، فون نمبر، اور پتہ ریکارڈ کریں جہاں آپ کی تنظیم کام کرتی ہے۔`,
	vi: `Ghi lại tên, số điện thoại và địa chỉ của các trang web nơi tổ chức của bạn hoạt động.`,
	'zh-hans': `记录贵组织运营地点的名称、电话号码和地址。`,
	'zh-hant': `記錄你組織營運地點的名稱、電話號碼和地址。`,
	en: `Record the name, phone number, and address of sites where your organization operates.`
};

export const loc_organizationsWithConsentFormat: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `${label} منظمة أخرى لديها وصول عن طريق الموافقة`,
	de: (label) => `${label} weitere Organisationen haben Zugang per Zustimmung`,
	es: (label) => `${label} organizaciones más tienen acceso mediante consentimiento`,
	fa: (label) => `۱۲ ${label} از طریق رضایت دسترسی دارند`,
	fil: (label) => `${label} higit pang mga organisasyon ang may access sa pamamagitan ng pahintulot`,
	fr: (label) => `${label} autres organisations y ont accès par consentement`,
	hi: (label) => `${label} और संगठनों के पास सहमति के माध्यम से पहुंच है`,
	ht: (label) => `${label} plis òganizasyon gen aksè atravè konsantman`,
	it: (label) => `${label} organizzazioni hanno accesso tramite consenso`,
	ja: (label) => `さらに${label}の団体が同意によるアクセス権を持っています`,
	ko: (label) => `${label} 개 이상의 단체가 동의를 통해 접근할 수 있습니다`,
	mww: (label) => `${label} lub koom haum ntxiv muaj kev nkag mus los ntawm kev pom zoo`,
	ps: (label) => `۱۲ ${label} سازمانونه د رضایت له لارې لاسرسی لری`,
	pt: (label) => `Mais ${label} organizações têm acesso por consentimento`,
	'pt-pt': (label) => `Mais ${label} organizações têm acesso por consentimento`,
	ru: (label) => `${label} организаций имеют доступ по согласию`,
	sm: (label) => `${label} isi fa'alapotopotoga e mafai ona maua e ala i le maliega`,
	so: (label) => `${label} urur oo kale ayaa helaya ogolaansho`,
	th: (label) => `อีก ${label} องค์กรสามารถเข้าถึงได้ผ่านความยินยอม`,
	ur: (label) => `مزید ${label} تنظیموں کو اجازت کے ذریعے رسائی حاصل ہے`,
	vi: (label) => `${label} tổ chức khác có quyền truy cập thông qua sự đồng ý`,
	'zh-hans': (label) => `另外${label}个组织通过同意获得了访问权限`,
	'zh-hant': (label) => `另外${label}個組織可透過同意取得存取權`,
	en: (label) => `${label} more organizations have access via consent`
};

export const loc_organizationTask: Record<Locale, string> = {
	ar: `مهمة التنظيم`,
	de: `Organisationsaufgabe`,
	es: `Tareas organizativas`,
	fa: `وظیفه سازماندهی`,
	fil: `Gawain ng organisasyon`,
	fr: `Tâche d’organisation`,
	hi: `संगठन कार्य`,
	ht: `Travay òganizasyon an`,
	it: `Compito organizzativo`,
	ja: `組織課題`,
	ko: `조직 과제`,
	mww: `Lub koom haum ua haujlwm`,
	ps: `د تنظیم دنده`,
	pt: `Tarefa de organização`,
	'pt-pt': `Tarefa de organização`,
	ru: `Организационная задача`,
	sm: `Galuega a le faalapotopotoga`,
	so: `Hawsha abaabulka`,
	th: `งานขององค์กร`,
	ur: `تنظیمی کام`,
	vi: `Nhiệm vụ tổ chức`,
	'zh-hans': `组织任务`,
	'zh-hant': `組織任務`,
	en: `Organization task`
};

export const loc_organizationTaskDesc: Record<Locale, string> = {
	ar: `مهمة تستهدف منظمة أو مستخدما، غير مرتبطة بعميل معين.`,
	de: `Eine Aufgabe, die sich an eine Organisation oder einen Nutzer richtet und nichts mit einem bestimmten Kunden zu tun hat.`,
	es: `Una tarea dirigida a una organización o usuario, sin relación con un cliente específico.`,
	fa: `وظیفه ای که یک سازمان یا کاربر را هدف قرار می دهد و ارتباطی با یک مشتری خاص ندارد.`,
	fil: `Isang gawain na nagta-target sa isang organisasyon o gumagamit, na walang kaugnayan sa isang tukoy na kliyente.`,
	fr: `Une tâche ciblant une organisation ou un utilisateur, sans lien avec un client spécifique.`,
	hi: `किसी संगठन या उपयोगकर्ता को लक्षित करने वाला कार्य, जो किसी विशिष्ट क्लाइंट से असंबंधित है.`,
	ht: `Yon travay ki vize yon òganizasyon oswa itilizatè, ki pa gen rapò ak yon kliyan espesifik.`,
	it: `Un compito rivolto a un'organizzazione o a un utente, non correlato a un client specifico.`,
	ja: `特定のクライアントとは無関係な組織やユーザーを対象としたタスク。`,
	ko: `특정 클라이언트와 관련 없는 조직이나 사용자를 대상으로 한 작업입니다.`,
	mww: `Ib txoj haujlwm tsom rau ib lub koom haum lossis tus neeg siv, tsis muaj feem xyuam rau tus neeg siv khoom tshwj xeeb.`,
	ps: `یوه دنده چې یوه اداره یا کاروونکی هدف ګرځوی، او له ځانګړی پیرودونکی سره تړاو نه لری.`,
	pt: `Uma tarefa direcionada a uma organização ou usuário, sem relação com um cliente específico.`,
	'pt-pt': `Uma tarefa direcionada a uma organização ou utilizador, sem relação com um cliente específico.`,
	ru: `Задача, направленная на организацию или пользователя, не связанная с конкретным клиентом.`,
	sm: `O se galuega e fa'atatau i se fa'alapotopotoga po'o se tagata fa'aaoga, e le feso'ota'i ma se tagata fa'atau fa'apitoa.`,
	so: `Hawl bartilmaameedsatay urur ama isticmaale, oo aan la xiriirin macmiil gaar ah.`,
	th: `งานที่กําหนดเป้าหมายองค์กรหรือผู้ใช้ ซึ่งไม่เกี่ยวข้องกับไคลเอ็นต์ที่เฉพาะเจาะจง`,
	ur: `ایک ایسا کام جو کسی تنظیم یا صارف کو ہدف بناتا ہے، جو کسی مخصوص کلائنٹ سے متعلق نہیں ہے۔`,
	vi: `Một nhiệm vụ nhắm mục tiêu đến một tổ chức hoặc người dùng, không liên quan đến một khách hàng cụ thể.`,
	'zh-hans': `针对某个组织或用户的任务，与特定客户无关。`,
	'zh-hant': `針對組織或使用者的任務，與特定客戶無關。`,
	en: `A task targeting an organization or user, unrelated to a specific client.`
};

export const loc_organizationWithConsent: Record<Locale, string> = {
	ar: `منظمة أخرى لديها وصول عن طريق الموافقة`,
	de: `Eine weitere Organisation hat Zugang per Einwilligung`,
	es: `1 Otra organización tiene acceso mediante consentimiento`,
	fa: `یک سازمان دیگر از طریق رضایت دسترسی دارد`,
	fil: `1 higit pang organisasyon ang may access sa pamamagitan ng pahintulot`,
	fr: `1 Organisation supplémentaire a accès par consentement`,
	hi: `1 और संगठन के पास सहमति के माध्यम से पहुंच है`,
	ht: `1 plis òganizasyon gen aksè atravè konsantman`,
	it: `1 un'altra organizzazione ha accesso tramite consenso`,
	ja: `1つの組織が同意によりアクセス権を持つ`,
	ko: `1개 이상의 단체가 동의를 통해 접근 권한을 가질 수 있습니다`,
	mww: `1 lub koom haum ntxiv muaj kev nkag mus los ntawm kev tso cai`,
	ps: `۱ نور سازمان د رضایت له لارې لاسرسی لری`,
	pt: `1 Mais uma organização tem acesso por consentimento`,
	'pt-pt': `1 Mais uma organização tem acesso por consentimento`,
	ru: `Ещё одна организация имеет доступ по согласию`,
	sm: `1 isi fa'alapotopotoga e mafai ona fa'aaogaina e ala i le maliega`,
	so: `1 urur oo kale ayaa heli kara ogolaansho`,
	th: `อีก 1 องค์กรสามารถเข้าถึงได้ผ่านความยินยอม`,
	ur: `1 مزید تنظیم کو اجازت کے ذریعے رسائی حاصل ہے`,
	vi: `Thêm 1 tổ chức có quyền truy cập thông qua sự đồng ý`,
	'zh-hans': `1 另一个组织通过同意获得访问权限`,
	'zh-hant': `1 個組織可透過同意取得存取權`,
	en: `1 more organization has access via consent`
};

export const loc_ourTeam: Record<Locale, string> = {
	ar: `فريقنا`,
	de: `Unser Team`,
	es: `Nuestro equipo`,
	fa: `تیم ما`,
	fil: `Ang aming koponan`,
	fr: `Notre équipe`,
	hi: `हमारी टीम`,
	ht: `Ekip nou an`,
	it: `La nostra squadra`,
	ja: `私たちのチーム`,
	ko: `우리 팀`,
	mww: `Peb pab neeg`,
	ps: `زموږ ټیم`,
	pt: `Nossa equipe`,
	'pt-pt': `A nossa equipa`,
	ru: `Наша команда`,
	sm: `O la matou 'au`,
	so: `Kooxdeena`,
	th: `ทีมงานของเรา`,
	ur: `ہماری ٹیم`,
	vi: `Đội ngũ của chúng tôi`,
	'zh-hans': `我们的团队`,
	'zh-hant': `我們的團隊`,
	en: `Our team`
};

export const loc_outOfOffice: Record<Locale, string> = {
	ar: `خارج المنصب`,
	de: `Nicht im Amt`,
	es: `Fuera del cargo`,
	fa: `خارج از سمت`,
	fil: `Sa labas ng opisina`,
	fr: `Hors du pouvoir`,
	hi: `कार्यालय से बाहर`,
	ht: `Soti nan biwo`,
	it: `Fuori dall'incarico`,
	ja: `公職外`,
	ko: `공직 후`,
	mww: `Tawm ntawm chaw ua haujlwm`,
	ps: `له دفتره بهر`,
	pt: `Fora do cargo`,
	'pt-pt': `Fora do cargo`,
	ru: `Вне должности`,
	sm: `Fafo atu o le ofisa`,
	so: `Xafiiska ka maqan`,
	th: `ไม่อยู่ที่สํานักงาน`,
	ur: `عہدے سے باہر`,
	vi: `Vắng mặt tại văn phòng`,
	'zh-hans': `离开任期`,
	'zh-hant': `離任`,
	en: `Out of office`
};

export const loc_outOfOfficeIndicatorDescription: Record<Locale, string> = {
	ar: `هل أعرض مؤشر خروج من المكتب ورسالة اختيارية للمشاركين؟`,
	de: `Eine Abwesenheitsanzeige und eine optionale Nachricht an die Mitarbeitenden anzeigen?`,
	es: `¿Mostrar un indicador de ausencia y un mensaje opcional a los colaboradores?`,
	fa: `نمایش یک علامت خروج از دفتر و پیام اختیاری برای همکاران؟`,
	fil: `Magpakita ng out of office indicator at opsyonal na mensahe sa mga collaborator?`,
	fr: `Afficher un indicateur d’absence du bureau et un message optionnel aux collaborateurs ?`,
	hi: `सहयोगियों को कार्यालय से बाहर संकेतक और वैकल्पिक संदेश प्रदर्शित करें?`,
	ht: `Montre yon endikatè soti nan biwo ak mesaj opsyonèl bay kolaboratè?`,
	it: `Mostrare un indicatore di assenza e un messaggio opzionale ai collaboratori?`,
	ja: `不在時のインジケーターと、協力者に任意のメッセージを表示する?`,
	ko: `부재 표시기와 선택적 메시지를 협업자에게 표시할 수 있을까요?`,
	mww: `Tso saib qhov qhia tawm ntawm chaw ua haujlwm thiab cov lus xaiv rau cov neeg koom tes?`,
	ps: `د دفتر څخه بهر نښه او اختیاری پیغام همکارانو ته وښیم؟`,
	pt: `Exibir um indicador de ausência do escritório e uma mensagem opcional para colaboradores?`,
	'pt-pt': `Mostrar um indicador de ausência do escritório e uma mensagem opcional aos colaboradores?`,
	ru: `Показывать индикатор отсутствия офиса и необязательное сообщение для сотрудников?`,
	sm: `Fa'aali se fa'ailoga i fafo atu o le ofisa ma se fe'au fa'apitoa i tagata faigaluega?`,
	so: `Ma muujin kartaa tilmaame ka baxsan xafiiska iyo fariin ikhtiyaari ah oo loogu talagalay wada-shaqeeyayaasha?`,
	th: `แสดงตัวบ่งชี้การไม่อยู่ที่สํานักงานและข้อความเสริมถึงผู้ทํางานร่วมกันใช่ไหม`,
	ur: `دفتر سے باہر کا اشارہ اور ساتھیوں کو اختیاری پیغام دکھانا؟`,
	vi: `Hiển thị chỉ báo vắng mặt và thông báo tùy chọn cho cộng tác viên?`,
	'zh-hans': `给协作者显示出出勤指示和可选消息？`,
	'zh-hant': `顯示不在辦公室的指示器和可選訊息給合作夥伴？`,
	en: `Display an out of office indicator and optional message to collaborators?`
};

export const loc_outOfOfficeMessage: Record<Locale, string> = {
	ar: `رسالة خارج المكتب`,
	de: `Abwesenheitsnachricht`,
	es: `Mensaje de ausencia`,
	fa: `پیام خارج از دفتر`,
	fil: `Mensahe sa labas ng opisina`,
	fr: `Message d’absence`,
	hi: `कार्यालय से बाहर संदेश`,
	ht: `Soti nan mesaj biwo`,
	it: `Messaggio fuori ufficio`,
	ja: `オフィス外からのメッセージ`,
	ko: `부재 메시지`,
	mww: `Tawm ntawm chaw ua hauj lwm lus`,
	ps: `د دفتر څخه بهر پیغام`,
	pt: `Mensagem fora do escritório`,
	'pt-pt': `Mensagem fora do escritório`,
	ru: `Сообщение о вне офиса`,
	sm: `Savali i fafo atu o le ofisa`,
	so: `Farriinta ka baxsan xafiiska`,
	th: `ข้อความไม่อยู่ที่สํานักงาน`,
	ur: `دفتر سے باہر پیغام`,
	vi: `Thông báo vắng mặt`,
	'zh-hans': `离岗消息`,
	'zh-hant': `離職訊息`,
	en: `Out of office message`
};

export const loc_overtime: Record<Locale, string> = {
	ar: `الوقت الإضافي`,
	de: `Verlängerung`,
	es: `Prórroga`,
	fa: `وقت اضافه`,
	fil: `Paglipas ng oras`,
	fr: `Prolongation`,
	hi: `ओवरटाइम`,
	ht: `Siplemantè`,
	it: `Tempo supplementare`,
	ja: `延長戦`,
	ko: `연장전`,
	mww: `Sijhawm dhau sijhawm`,
	ps: `اضافی وخت`,
	pt: `Prorrogação`,
	'pt-pt': `Prorrogação`,
	ru: `Овертайм`,
	sm: `Ovataimi`,
	so: `Waqti dheeri ah`,
	th: `การทํางานล่วงเวลา`,
	ur: `اوور ٹائم`,
	vi: `Làm thêm giờ`,
	'zh-hans': `加时赛`,
	'zh-hant': `加時賽`,
	en: `Overtime`
};

export const loc_overview: Record<Locale, string> = {
	ar: `نظرة عامة`,
	de: `Überblick`,
	es: `Resumen`,
	fa: `بررسی اجمالی`,
	fil: `Pangkalahatang-ideya`,
	fr: `Aperçu`,
	hi: `विहंगावलोकन`,
	ht: `Apèsi sou lekòl la`,
	it: `Panoramica`,
	ja: `概要`,
	ko: `개요`,
	mww: `Txheej txheem cej luam`,
	ps: `عمومی کتنه`,
	pt: `Visão geral`,
	'pt-pt': `Visão geral`,
	ru: `Обзор`,
	sm: `Aotelega`,
	so: `Guudmar`,
	th: `ภาพรวม`,
	ur: `جائزہ`,
	vi: `Tổng quan`,
	'zh-hans': `概述`,
	'zh-hant': `概述`,
	en: `Overview`
};

export const loc_page: Record<Locale, string> = {
	ar: `صفحة`,
	de: `Page`,
	es: `Página`,
	fa: `صفحه`,
	fil: `Pahina`,
	fr: `Page`,
	hi: `पृष्ठ`,
	ht: `Paj`,
	it: `Pagina`,
	ja: `ページ`,
	ko: `페이지`,
	mww: `Nplooj ntawv`,
	ps: `پاڼه`,
	pt: `Page`,
	'pt-pt': `Página`,
	ru: `Страница`,
	sm: `Itulau`,
	so: `Bog`,
	th: `หน้า`,
	ur: `صفحہ`,
	vi: `Trang`,
	'zh-hans': `页面`,
	'zh-hant': `頁`,
	en: `Page`
};

export const loc_pagination: Record<Locale, string> = {
	ar: `تقسيم الصفحات`,
	de: `Paginierung`,
	es: `Paginación`,
	fa: `صفحه بندی`,
	fil: `Pagination`,
	fr: `Pagination`,
	hi: `पेजिनेशन`,
	ht: `Paginasyon`,
	it: `Paginazione`,
	ja: `ページ分け`,
	ko: `페이지 배치`,
	mww: `Pagination`,
	ps: `پاڼه بندی`,
	pt: `Paginação`,
	'pt-pt': `Paginação`,
	ru: `Пагинирование`,
	sm: `Itulau`,
	so: `Qaybinta`,
	th: `การแบ่งหน้า`,
	ur: `صفحہ بندی`,
	vi: `Phân trang`,
	'zh-hans': `分页`,
	'zh-hant': `頁碼`,
	en: `Pagination`
};

export const loc_parentActivity: Record<Locale, string> = {
	ar: `نشاط الوالدين`,
	de: `Elterntätigkeit`,
	es: `Actividad principal`,
	fa: `فعالیت والدین`,
	fil: `Aktibidad ng magulang`,
	fr: `Activité parentale`,
	hi: `माता-पिता की गतिविधि`,
	ht: `Aktivite paran yo`,
	it: `Attività genitore`,
	ja: `親の活動`,
	ko: `부모 활동`,
	mww: `Niam txiv kev ua ub no`,
	ps: `د مور او پلار فعالیت`,
	pt: `Atividade dos pais`,
	'pt-pt': `Atividade parental`,
	ru: `Родительская деятельность`,
	sm: `Gaoioiga a matua`,
	so: `Hawlaha waalidka`,
	th: `กิจกรรมของผู้ปกครอง`,
	ur: `والدین کی سرگرمیاں`,
	vi: `Hoạt động của cha mẹ`,
	'zh-hans': `家长活动`,
	'zh-hant': `家長活動`,
	en: `Parent activity`
};

export const loc_participantConsumerReviewInstruction: Record<Locale, TemplateResult> = {
	ar: html`كل عميل ترتبط به مدرج أدناه. يرجى مراجعة المعلومات الموجودة في الملف. إذا بدا أي شيء غير صحيح، <a href="/support">تواصل مع الدعم</a>.`,
	de: html`Jeder Kunde, mit dem Sie verbunden sind, ist unten aufgeführt. Bitte überprüfen Sie die Informationen, die wir haben. Wenn etwas falsch aussieht, <a href="/support">kontaktiere den Support</a>.`,
	es: html`Cada consumidor con el que estás asociado se muestra a continuación. Por favor, revise la información que tenemos archivada. Si algo no te parece correcto, <a href="/support">contacta con el soporte</a> técnico.`,
	fa: html`هر مشتری ای که با آن ارتباط دارید در زیر فهرست شده است. لطفا اطلاعات موجود در پرونده را مرور کنید. اگر چیزی اشتباه به نظر می رسد، <a href="/support">با پشتیبانی تماس بگیرید</a>.`,
	fil: html`Ang bawat mamimili na nauugnay sa iyo ay nakalista sa ibaba. Mangyaring suriin ang impormasyong nasa file namin. Kung ang anumang bagay ay mukhang mali, <a href="/support">makipag-ugnay sa suporta.</a>`,
	fr: html`Chaque consommateur auquel vous êtes associé est listé ci-dessous. Veuillez consulter les informations que nous avons dans nos dossiers. Si quelque chose semble incorrect, <a href="/support">contactez le support.</a>`,
	hi: html`आप जिस भी उपभोक्ता से जुड़े हैं, वह नीचे सूचीबद्ध है. कृपया फ़ाइल पर हमारे पास मौजूद जानकारी की समीक्षा करें। यदि कुछ भी गलत लगता है, <a href="/support">तो समर्थन से संपर्क करें</a>।`,
	ht: html`Chak konsomatè w ap asosye avèk yo ki nan lis anba a. Tanpri revize enfòmasyon nou genyen nan dosye. Si anyen sanble mal, <a href="/support">kontakte sipò.</a>`,
	it: html`Ogni consumatore con cui sei associato è elencato di seguito. Per favore, esamina le informazioni che abbiamo in archivio. Se qualcosa non ti sembra corretto, <a href="/support">contatta l'assistenza</a>.`,
	ja: html`あなたが関わっている各消費者は以下の通りです。当サイトの情報を確認してください。何かおかしい点があれば <a href="/support">サポートに連絡</a>してください。`,
	ko: html`여러분이 연관된 각 소비자는 아래에 나열되어 있습니다. 저희가 보유한 정보를 검토해 주시기 바랍니다. 이상한 점이 있으면 <a href="/support">고객 지원에 연락</a>하세요.`,
	mww: html`Txhua tus neeg tau txais kev pab uas koj koom nrog muaj npe hauv qab no. Thov saib cov ntaub ntawv peb muaj nyob rau hauv cov ntaub ntawv. Yog tias muaj dab tsi zoo li tsis raug, <a href="/support">hu rau kev txhawb nqa</a>.`,
	ps: html`هر مصرف کوونکی چې تاسو ورسره تړلی یاست، لاندې لیست شوی دی. مهربانی وکړئ هغه معلومات وګورئ چې موږ په دوسیه کې لرو. که څه ناسم ښکاری، <a href="/support">له ملاتړ سره اړیکه ونیسئ</a>.`,
	pt: html`Cada consumidor com quem você está associado está listado abaixo. Por favor, revise as informações que temos em arquivo. Se algo parecer errado, <a href="/support">entre em contato com o suporte</a>.`,
	'pt-pt': html`Cada consumidor com quem está associado está listado abaixo. Por favor, reveja a informação que temos em arquivo. Se algo parecer errado, <a href="/support">contacte o suporte</a>.`,
	ru: html`Каждый потребитель, с которым вы связаны, перечислен ниже. Пожалуйста, ознакомьтесь с имеющейся у нас информацией. Если что-то кажется неправильным, <a href="/support">обращайтесь в поддержку</a>.`,
	sm: html`O tagata fa'atau ta'itasi o lo'o e feso'ota'i ma oe o lo'o lisiina atu i lalo. Fa'amolemole siaki fa'amatalaga o lo'o ia i matou i le faila. Afai e i ai se mea e foliga mai e le sa'o, <a href="/support">fa'afeso'ota'i le lagolago</a>.`,
	so: html`Macaamiil kasta oo aad la xiriirto waa lagu taxay hoos. Fadlan dib u eeg macluumaadka aan hayno kaydka. Haddii wax qaldan muuqdaan, <a href="/support">la xiriir taageerada</a>.`,
	th: html`ผู้บริโภคแต่ละรายที่คุณเชื่อมโยงด้วยแสดงอยู่ด้านล่าง โปรดตรวจสอบข้อมูลที่เรามีในไฟล์ หากมีสิ่งใดไม่ถูกต้อง <a href="/support">โปรดติดต่อฝ่ายสนับสนุน</a>`,
	ur: html`ہر صارف جس سے آپ وابستہ ہیں، نیچے درج ہے۔ براہ کرم ہمارے پاس موجود معلومات کا جائزہ لیں۔ اگر کچھ غلط لگے تو <a href="/support">سپورٹ سے رابطہ</a> کریں۔`,
	vi: html`Mỗi người tiêu dùng mà bạn liên kết được liệt kê dưới đây. Vui lòng xem lại thông tin chúng tôi có trong hồ sơ. Nếu có bất kỳ điều gì không chính xác, <a href="/support">hãy liên hệ với bộ phận hỗ trợ</a>.`,
	'zh-hans': html`你所关联的每一位消费者名单如下。请查看我们所存档案中的信息。如果有任何异常， <a href="/support">请联系客服</a>。`,
	'zh-hant': html`你所關聯的每位消費者名單如下。請審閱我們所存的資訊。如果有任何異常，請 <a href="/support">聯絡客服</a>。`,
	en: html`Each consumer you're associated with is listed below. Please review the information we have on file. If anything looks incorrect, <a href="/support">contact support</a>.`
};

export const loc_participantLink: Record<Locale, string> = {
	ar: `رابط المشاركين`,
	de: `Teilnehmer-Link`,
	es: `Enlace de participantes`,
	fa: `لینک شرکت کننده`,
	fil: `Link ng kalahok`,
	fr: `Lien participant`,
	hi: `प्रतिभागी लिंक`,
	ht: `Lyen patisipan yo`,
	it: `Collegamento dei partecipanti`,
	ja: `参加者リンク`,
	ko: `참가자 링크`,
	mww: `Txuas rau cov neeg koom`,
	ps: `د ګډونوال لینک`,
	pt: `Link de participante`,
	'pt-pt': `Link de participantes`,
	ru: `Ссылка на участника`,
	sm: `Feso'ota'iga a le tagata auai`,
	so: `Xiriirka ka qaybgalka`,
	th: `ลิงก์ผู้เข้าร่วม`,
	ur: `شرکاء کا لنک`,
	vi: `Liên kết người tham gia`,
	'zh-hans': `参与者链接`,
	'zh-hant': `參與者連結`,
	en: `Participant link`
};

export const loc_participantPortal: Record<Locale, string> = {
	ar: `بوابة المشاركين`,
	de: `Teilnehmerportal`,
	es: `Portal de Participantes`,
	fa: `پورتال شرکت کنندگان`,
	fil: `Portal ng Kalahok`,
	fr: `Portail des participants`,
	hi: `प्रतिभागी पोर्टल`,
	ht: `Patisipan Portal`,
	it: `Portale Partecipanti`,
	ja: `参加者ポータル`,
	ko: `참여자 포털`,
	mww: `Cov Neeg Koom Portal`,
	ps: `د ګډونوال پورټل`,
	pt: `Portal de Participantes`,
	'pt-pt': `Portal de Participantes`,
	ru: `Портал участников`,
	sm: `Faitotoa a le Tagata Auai`,
	so: `Albaabka Ka Qaybgalayaasha`,
	th: `พอร์ทัลผู้เข้าร่วม`,
	ur: `شرکاء کا پورٹل`,
	vi: `Cổng thông tin người tham gia`,
	'zh-hans': `参与者门户`,
	'zh-hant': `參與者入口網站`,
	en: `Participant Portal`
};

export const loc_participantPortalDescription: Record<Locale, string> = {
	ar: `قدم جداول الزمن، وتتبع الإنفاق، ونظم رعايتك في مكان واحد.`,
	de: `Reichen Sie Stundenzettel ein, verfolgen Sie die Ausgaben und verwalten Sie Ihre Betreuung an einem Ort.`,
	es: `Envía hojas de horas, registra los gastos y gestiona tu atención en un solo lugar.`,
	fa: `برگه های زمان بندی را ارسال کنید، هزینه ها را پیگیری کنید و مراقبت خود را در یک مکان مدیریت کنید.`,
	fil: `Magsumite ng mga timesheet, subaybayan ang paggastos, at pamahalaan ang iyong pangangalaga sa isang lugar.`,
	fr: `Soumettez des feuilles de temps, suivez vos dépenses et gérez vos soins en un seul endroit.`,
	hi: `टाइमशीट जमा करें, खर्च पर नज़र रखें और एक ही स्थान पर अपनी देखभाल का प्रबंधन करें।`,
	ht: `Soumèt fich tan, swiv depanse, ak jere swen ou nan yon sèl kote.`,
	it: `Invia i fogli di servizio, tieni traccia delle spese e gestisci la tua assistenza in un unico posto.`,
	ja: `タイムシートの提出、支出の追跡、ケア管理を一か所で行えます。`,
	ko: `근무 시간표를 제출하고, 지출을 추적하며, 한 곳에서 진료를 관리하세요.`,
	mww: `Xa cov ntawv teev sijhawm, taug qab kev siv nyiaj, thiab tswj koj txoj kev saib xyuas hauv ib qho chaw.`,
	ps: `د وخت پاڼې وسپارئ، لګښتونه تعقیب کړئ، او خپل پاملرنه په یوه ځای کې مدیریت کړئ.`,
	pt: `Envie folhas de ponto, acompanhe os gastos e gerencie seu cuidado em um só lugar.`,
	'pt-pt': `Envie folhas de horas, acompanhe os gastos e gere os seus cuidados num só local.`,
	ru: `Отправляйте табели рабочего времени, отслеживайте расходы и управляйте своим уходом в одном месте.`,
	sm: `Tu'uina atu pepa o taimi, siaki tupe fa'aalu, ma fa'atautaia lau tausiga i le nofoaga e tasi.`,
	so: `Soo gudbi jadwalka waqtiyada, la soco kharashaadka, oo maaree daryeelkaaga hal meel.`,
	th: `ส่งไทม์ชีท ติดตามการใช้จ่าย และจัดการการดูแลของคุณในที่เดียว`,
	ur: `ٹائم شیٹس جمع کروائیں، اخراجات کو ٹریک کریں، اور اپنی دیکھ بھال کو ایک ہی جگہ پر منظم کریں۔`,
	vi: `Gửi bảng chấm công, theo dõi chi tiêu và quản lý dịch vụ chăm sóc của bạn ở một nơi.`,
	'zh-hans': `提交工时表、跟踪支出，并管理您的护理工作。`,
	'zh-hant': `提交工時表、追蹤支出，並在同一地點管理您的照護。`,
	en: `Submit timesheets, track spending, and manage your care in one place.`
};

export const loc_participantPortalViewAsFlashFormat: Record<Locale, (name: unknown, expires: unknown) => TemplateResult> = {
	ar: (name, expires) => html`يعرض البوابة باسم <strong>${name}</strong>. ينتهي صلاحيته ${expires}.`,
	de: (name, expires) => html`Das <strong>${name}</strong> betrachtet. Läuft ${expires} ab.`,
	es: (name, expires) => html`Observando el portal como <strong>${name}</strong>. ${expires}.`,
	fa: (name, expires) => html`در حال مشاهده پورتال به عنوان <strong>${name}</strong>. ${expires} منقضی می شود.`,
	fil: (name, expires) => html`Tinitingnan ang portal bilang <strong>${name}</strong>. ${expires} nang mag-expire.`,
	fr: (name, expires) => html`Regardant le portail en <strong>${name}</strong>. ${expires}.`,
	hi: (name, expires) => html`पोर्टल को <strong>${name}</strong> के रूप में देखना। जल्द ${expires} समाप्त हो रहा है।`,
	ht: (name, expires) => html`Gade pòtal la kòm <strong>${name}</strong> Ekspire ${expires}`,
	it: (name, expires) => html`Guardando il portale come <strong>${name}</strong>. Sta ${expires} scadere.`,
	ja: (name, expires) => html`<strong>${name}</strong>としてポータルを見ている。${expires}期限切れだ。`,
	ko: (name, expires) => html`<strong>${name}</strong>로 포털을 보고 있어. ${expires} 만료돼.`,
	mww: (name, expires) => html`Saib lub portal ua <strong>${name}</strong>. Yuav xaus ${expires} no.`,
	ps: (name, expires) => html`دروازه د <strong>${name}</strong> په توګه ګوری. ${expires} ختمیږی.`,
	pt: (name, expires) => html`Vendo o portal como <strong>${name}</strong>. ${expires}.`,
	'pt-pt': (name, expires) => html`A ver o portal como <strong>${name}</strong>. ${expires}.`,
	ru: (name, expires) => html`Смотря на портал как <strong>${name}</strong>. ${expires} истекает.`,
	sm: (name, expires) => html`Va'ai i le faitoto'a o <strong>${name}</strong>. E ${expires}.`,
	so: (name, expires) => html`Wuxuu daawanayaa albaabka sida <strong>${name}</strong>. Wuxuu ${expires}.`,
	th: (name, expires) => html`มองประตูมิติในชื่อ<strong>${name}</strong>จะหมดอายุ${expires}`,
	ur: (name, expires) => html`<strong>${name}</strong> کے طور پر دیکھنا۔ ${expires} ختم ہو جائے گا۔`,
	vi: (name, expires) => html`Xem cổng dịch chuyển như <strong>${name}</strong>. Sắp hết hạn ${expires}.`,
	'zh-hans': (name, expires) => html`以 <strong>${name}</strong>的身份查看传送门。 ${expires}过期。`,
	'zh-hant': (name, expires) => html`以 <strong>${name}</strong>的身份觀看傳送門。 ${expires}過期。`,
	en: (name, expires) => html`Viewing the portal as <strong>${name}</strong>. Expires ${expires}.`
};

export const loc_participantPortalViewAsMutationNotAllowed: Record<Locale, string> = {
	ar: `لا يمكن إجراء تعديلات أثناء مشاهدة بوابة المشاركين كمستخدم آخر.`,
	de: `Änderungen können nicht vorgenommen werden, während man das Teilnehmerportal als anderer Nutzer betrachtet.`,
	es: `No se pueden hacer modificaciones mientras se visualiza el portal de participantes como otro usuario.`,
	fa: `هنگام مشاهده پورتال شرکت کننده به عنوان کاربر دیگر، تغییراتی اعمال نمی شود.`,
	fil: `Hindi maaaring gawin ang mga pagbabago habang tinitingnan ang participant portal bilang ibang user.`,
	fr: `Aucune modification ne peut être effectuée en consultant le portail participant en tant qu’utilisateur d’un autre.`,
	hi: `प्रतिभागी पोर्टल को किसी अन्य उपयोगकर्ता के रूप में देखते समय संशोधन नहीं किए जा सकते.`,
	ht: `Modifikasyon pa ka fèt pandan y ap gade pòtal patisipan an kòm yon lòt itilizatè.`,
	it: `Non possono essere apportate modifiche mentre si visualizza il portale partecipante come un altro utente.`,
	ja: `参加者ポータルを他のユーザーとして閲覧している間は変更できません。`,
	ko: `다른 사용자로 참여자 포털을 볼 때는 수정이 불가능합니다.`,
	mww: `Tsis tuaj yeem hloov kho thaum saib lub portal koom nrog ua ib tug neeg siv lwm tus.`,
	ps: `د ګډون کوونکی پورټل د بل کارونکی په توګه کتل پر مهال تعدیلات نشی کېدای.`,
	pt: `Modificações não podem ser feitas enquanto visualizam o portal de participantes como outro usuário.`,
	'pt-pt': `Não podem ser feitas modificações enquanto se visualiza o portal do participante como outro utilizador.`,
	ru: `Изменения нельзя, когда портал участника отображается как другой пользователь.`,
	sm: `E le mafai ona faia ni suiga a o maimoa i le faitotoa o tagata auai o se isi tagata faaaoga.`,
	so: `Wax ka beddel lama samayn karo marka la arko portal-ka ka qaybgalka sida isticmaale kale.`,
	th: `ไม่สามารถแก้ไขได้ขณะดูพอร์ทัลผู้เข้าร่วมในฐานะผู้ใช้คนอื่น`,
	ur: `شرکاء کے پورٹل کو دوسرے صارف کے طور پر دیکھتے ہوئے تبدیلیاں نہیں کی جا سکتیں۔`,
	vi: `Không thể thực hiện chỉnh sửa khi đang xem cổng thông tin người tham gia với tư cách người dùng khác.`,
	'zh-hans': `在以其他用户身份查看参与者门户时，不能进行修改。`,
	'zh-hant': `在以其他使用者身份查看參與者入口時，無法進行修改。`,
	en: `Modifications cannot be made while viewing the participant portal as another user.`
};

export const loc_participantPortalViewAsStop: Record<Locale, string> = {
	ar: `توقف عن المشاهدة`,
	de: `Hören Sie auf zu schauen`,
	es: `Dejar de ver`,
	fa: `تماشا را متوقف کنید`,
	fil: `Itigil ang pagtingin`,
	fr: `Arrêter de regarder`,
	hi: `देखना बंद करें`,
	ht: `Sispann gade`,
	it: `Interrompi la visione`,
	ja: `視聴をやめてください`,
	ko: `시청 중지`,
	mww: `Nres saib`,
	ps: `کتل بند کړئ`,
	pt: `Parar de assistir`,
	'pt-pt': `Parar de ver`,
	ru: `Прекратить просмотр`,
	sm: `Taofi le maimoaina`,
	so: `Jooji daawashada`,
	th: `หยุดดู`,
	ur: `دیکھنا بند کریں`,
	vi: `Dừng xem`,
	'zh-hans': `停止观看`,
	'zh-hant': `停止觀看`,
	en: `Stop viewing`
};

export const loc_participants: Record<Locale, string> = {
	ar: `المشاركون`,
	de: `Teilnehmer`,
	es: `Participantes`,
	fa: `شرکت کنندگان`,
	fil: `Mga Kalahok`,
	fr: `Participants`,
	hi: `प्रतिभागियों`,
	ht: `Patisipan yo`,
	it: `Partecipanti`,
	ja: `参加者`,
	ko: `참가자`,
	mww: `Cov neeg koom`,
	ps: `ګډونوال`,
	pt: `Participantes`,
	'pt-pt': `Participantes`,
	ru: `Участники`,
	sm: `Tagata auai`,
	so: `Ka qaybgalayaasha`,
	th: `ผู้เข้าร่วม`,
	ur: `شرکاء`,
	vi: `Các thành viên tham gia`,
	'zh-hans': `参赛者`,
	'zh-hant': `參與者`,
	en: `Participants`
};

export const loc_participantUser: Record<Locale, string> = {
	ar: `المستخدم المشارك`,
	de: `Teilnehmer-Nutzer`,
	es: `Usuario participante`,
	fa: `کاربر شرکت کننده`,
	fil: `Gumagamit ng kalahok`,
	fr: `Utilisateur participant`,
	hi: `प्रतिभागी उपयोगकर्ता`,
	ht: `Itilizatè patisipan yo`,
	it: `Utente partecipante`,
	ja: `参加者ユーザー`,
	ko: `참여 사용자`,
	mww: `Tus neeg koom nrog`,
	ps: `ګډونوال کاروونکی`,
	pt: `Usuário participante`,
	'pt-pt': `Utilizador participante`,
	ru: `Участник-пользователь`,
	sm: `Tagata auai`,
	so: `Isticmaalaha ka qaybgalka`,
	th: `ผู้ใช้ที่เข้าร่วม`,
	ur: `شریک صارف`,
	vi: `Người dùng tham gia`,
	'zh-hans': `参与用户`,
	'zh-hant': `參與者使用者`,
	en: `Participant user`
};

export const loc_passcode: Record<Locale, string> = {
	ar: `رمز المرور`,
	de: `Passcode`,
	es: `Código de acceso`,
	fa: `رمز عبور`,
	fil: `Passcode`,
	fr: `Code d’accès`,
	hi: `पासकोड`,
	ht: `Passcode`,
	it: `Codice di accesso`,
	ja: `パスコード`,
	ko: `비밀번호`,
	mww: `Passcode`,
	ps: `پاسکوډ`,
	pt: `Código de acesso`,
	'pt-pt': `Código de acesso`,
	ru: `Пароль`,
	sm: `Passcode`,
	so: `Koodhka sirta ah`,
	th: `รหัสผ่าน`,
	ur: `پاس کوڈ`,
	vi: `Mã truy cập`,
	'zh-hans': `密码`,
	'zh-hant': `密碼`,
	en: `Passcode`
};

export const loc_password: Record<Locale, string> = {
	ar: `كلمة المرور`,
	de: `Passwort`,
	es: `Contraseña`,
	fa: `رمز عبور`,
	fil: `Password`,
	fr: `Mot de passe`,
	hi: `पासवर्ड`,
	ht: `Modpas`,
	it: `Password`,
	ja: `パスワード`,
	ko: `비밀번호`,
	mww: `Lo lus zais`,
	ps: `رمز`,
	pt: `Senha`,
	'pt-pt': `Palavra-passe`,
	ru: `Пароль`,
	sm: `Upu faataga`,
	so: `Erayga sirta ah`,
	th: `รหัสผ่าน`,
	ur: `پاس ورڈ`,
	vi: `Mật khẩu`,
	'zh-hans': `密码`,
	'zh-hant': `密碼`,
	en: `Password`
};

export const loc_passwordRequirements: Record<Locale, (minLength: unknown) => string> = {
	ar: (minLength) => `على الأقل ${minLength} شخصيات. نقوم بحجب كلمات المرور وبيانات الاعتماد الشائعة المعروفة بأنها تم اختراقها.`,
	de: (minLength) => `Mindestens ${minLength} Zeichen. Wir blockieren gängige Passwörter und Zugangsdaten, von denen bekannt ist, dass sie gehackt wurden.`,
	es: (minLength) => `Al menos ${minLength} personajes. Bloqueamos contraseñas y credenciales comunes que se sabe que han sido vulneradas.`,
	fa: (minLength) => `حداقل ${minLength} شخصیت. ما رمزهای عبور و اطلاعات ورود رایجی که شناخته شده نقض شده اند را مسدود می کنیم.`,
	fil: (minLength) => `Hindi bababa sa ${minLength} character. Hinaharangan namin ang mga karaniwang password at kredensyal na alam na nilabag.`,
	fr: (minLength) => `Au moins ${minLength} personnages. Nous bloqueons les mots de passe et identifiants courants dont on sait qu’ils ont été violés.`,
	hi: (minLength) => `कम से कम ${minLength} वर्ण। हम उन सामान्य पासवर्ड और क्रेडेंशियल्स को ब्लॉक करते हैं जिन्हें उल्लंघन के लिए जाना जाता है।`,
	ht: (minLength) => `Omwen ${minLength} karaktè Nou bloke modpas komen ak kalifikasyon yo konnen yo te vyole.`,
	it: (minLength) => `Almeno ${minLength} personaggi. Blocchiamo password e credenziali comuni che si sa siano state violate.`,
	ja: (minLength) => `少なくとも ${minLength} 文字は必要です。私たちは、侵害が確認されている一般的なパスワードや認証情報をブロックしています。`,
	ko: (minLength) => `최소 ${minLength} 명의 캐릭터가 필요합니다. 우리는 유출된 것으로 알려진 일반적인 비밀번호와 자격 증명을 차단합니다.`,
	mww: (minLength) => `Tsawg kawg ${minLength} cim. Peb thaiv cov lus zais thiab cov ntawv pov thawj uas paub tias tau ua txhaum.`,
	ps: (minLength) => `لږ تر لږه ${minLength} کرکټرونه. موږ عام پاسورډونه او اسناد بندوو چې پیژندل شوی دی چې مات شوی دی.`,
	pt: (minLength) => `Pelo menos ${minLength} personagens. Bloqueamos senhas e credenciais comuns que se sabe terem sido violadas.`,
	'pt-pt': (minLength) => `Pelo menos ${minLength} personagens. Bloqueamos palavras-passe e credenciais comuns que se sabe terem sido violadas.`,
	ru: (minLength) => `Минимум ${minLength} персонажей. Мы блокируем распространённые пароли и учетные данные, которые известны как взломаны.`,
	sm: (minLength) => `Le itiiti ifo ma ${minLength} mataitusi. Matou te poloka upu faataga masani ma fa'amaoniga ua iloa ua solia.`,
	so: (minLength) => `Ugu yaraan ${minLength} xaraf. Waxaan xannibanaa erayada sirta ah iyo aqoonsiga caadiga ah ee la ogyahay in la jebiyay.`,
	th: (minLength) => `อย่างน้อย ${minLength} ตัวอักษร เราบล็อกรหัสผ่านและข้อมูลประจําตัวทั่วไปที่ทราบว่าถูกละเมิด`,
	ur: (minLength) => `کم از کم ${minLength} کردار۔ ہم عام پاس ورڈز اور اسناد کو بلاک کر دیتے ہیں جن کے خلاف خلاف ورزی کا علم ہوتا ہے۔`,
	vi: (minLength) => `Ít nhất ${minLength} ký tự. Chúng tôi chặn các mật khẩu và thông tin đăng nhập phổ biến được biết là đã bị vi phạm.`,
	'zh-hans': (minLength) => `至少有 ${minLength} 个角色。我们会屏蔽已知被泄露的常见密码和凭证。`,
	'zh-hant': (minLength) => `至少 ${minLength} 個角色。我們會封鎖已知被入侵的常見密碼和憑證。`,
	en: (minLength) => `At least ${minLength} characters. We block common passwords and credentials that are known to have been breached.`
};

export const loc_payerFiles: Record<Locale, string> = {
	ar: `ملفات جهة الدفع`,
	de: `Kostenträgerdateien`,
	es: `Archivos del pagador`,
	fa: `پرونده‌های پرداخت‌کننده`,
	fil: `Mga file ng nagbabayad`,
	fr: `Fichiers du payeur`,
	hi: `भुगतानकर्ता फ़ाइलें`,
	ht: `Fichye peyè`,
	it: `File del pagatore`,
	ja: `支払者ファイル`,
	ko: `지급자 파일`,
	mww: `Tus neeg them nyiaj cov ntaub ntawv`,
	ps: `د تادیه کوونکي فایلونه`,
	pt: `Arquivos do pagador`,
	'pt-pt': `Ficheiros do pagador`,
	ru: `Файлы плательщика`,
	sm: `Faila a le tagata totogi`,
	so: `Faylasha bixiyaha`,
	th: `ไฟล์ผู้ชำระเงิน`,
	ur: `ادائیگی کنندہ کی فائلیں`,
	vi: `Tệp bên thanh toán`,
	'zh-hans': `付款方文件`,
	'zh-hant': `付款方檔案`,
	en: `Payer files`
};

export const loc_payor: Record<Locale, string> = {
	ar: `العامل`,
	de: `Zahler`,
	es: `Pagador`,
	fa: `پرداخت کننده`,
	fil: `Nagbabayad`,
	fr: `Payeur`,
	hi: `भुगतानकर्ता`,
	ht: `Payor`,
	it: `Pagatore`,
	ja: `支払者`,
	ko: `지급자`,
	mww: `Tus neeg them nyiaj`,
	ps: `پایور`,
	pt: `Pagador`,
	'pt-pt': `Pagador`,
	ru: `Плательщик`,
	sm: `Tagata totogi`,
	so: `Bixiyaha`,
	th: `ผู้จ่ายเงิน`,
	ur: `پیئر`,
	vi: `Người thanh toán`,
	'zh-hans': `付款方`,
	'zh-hant': `付款方`,
	en: `Payor`
};

export const loc_payPeriod: Record<Locale, string> = {
	ar: `فترة الدفع`,
	de: `Abrechnungszeitraum`,
	es: `Periodo de pago`,
	fa: `دوره پرداخت`,
	fil: `Panahon ng Pagbabayad`,
	fr: `Période de paie`,
	hi: `भुगतान अवधि`,
	ht: `Peryòd peman an`,
	it: `Periodo di paga`,
	ja: `給与期間`,
	ko: `급여 기간`,
	mww: `Lub sijhawm them nyiaj`,
	ps: `د معاش موده`,
	pt: `Período de pagamento`,
	'pt-pt': `Período de pagamento`,
	ru: `Период оплаты`,
	sm: `Vaitaimi o totogi`,
	so: `Muddada mushaharka`,
	th: `ระยะเวลาการจ่ายเงิน`,
	ur: `تنخواہ کا دورانیہ`,
	vi: `Thời gian thanh toán`,
	'zh-hans': `发薪周期`,
	'zh-hant': `薪資期間`,
	en: `Pay period`
};

export const loc_pdfTemplates: Record<Locale, string> = {
	ar: `قوالب PDF`,
	de: `PDF-Vorlagen`,
	es: `Plantillas PDF`,
	fa: `قالب های PDF`,
	fil: `Mga template ng PDF`,
	fr: `Modèles PDF`,
	hi: `पीडीएफ टेम्पलेट्स`,
	ht: `Modèl PDF`,
	it: `Modelli PDF`,
	ja: `PDFテンプレート`,
	ko: `PDF 템플릿`,
	mww: `PDF templates`,
	ps: `PDF ټیمپلیټونه`,
	pt: `Modelos PDF`,
	'pt-pt': `Modelos PDF`,
	ru: `Шаблоны PDF`,
	sm: `PDF templates`,
	so: `Qaababka PDF`,
	th: `เทมเพลต PDF`,
	ur: `پی ڈی ایف ٹیمپلیٹس`,
	vi: `Mẫu PDF`,
	'zh-hans': `PDF模板`,
	'zh-hant': `PDF 範本`,
	en: `PDF templates`
};

export const loc_pending: Record<Locale, string> = {
	ar: `قيد الانتظار`,
	de: `Ausstehend`,
	es: `Pendiente`,
	fa: `در انتظار`,
	fil: `Nakabinbin`,
	fr: `En attente`,
	hi: `लंबित`,
	ht: `Annatant`,
	it: `In attesa`,
	ja: `保留中`,
	ko: `대기 중입니다`,
	mww: `Tos`,
	ps: `انتظار کې دی`,
	pt: `Pendente`,
	'pt-pt': `Pendente`,
	ru: `В ожидании`,
	sm: `Fa'atali`,
	so: `Sugaya`,
	th: `รอดําเนินการ`,
	ur: `زیر التواء`,
	vi: `Đang chờ xử lý`,
	'zh-hans': `待处理`,
	'zh-hant': `待定`,
	en: `Pending`
};

export const loc_pendingSignatureRequestsPlural: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} توقيع معلقان`,
	de: (count) => `${count} ausstehende Unterschriftsanfragen`,
	es: (count) => `${count} solicitudes de firma pendientes`,
	fa: (count) => `${count} درخواست امضا در انتظار`,
	fil: (count) => `${count} nakabinbing mga kahilingan sa lagda`,
	fr: (count) => `${count} demandes de signature en attente`,
	hi: (count) => `${count} लंबित हस्ताक्षर अनुरोध`,
	ht: (count) => `${count} annatant demann siyati`,
	it: (count) => `${count} richieste di firma pendenti`,
	ja: (count) => `${count} 件の保留中の署名要求`,
	ko: (count) => `${count} 개의 대기 서명 요청`,
	mww: (count) => `${count} Tos kos npe thov`,
	ps: (count) => `${count} د لاسلیک غوښتنې پاتې دی`,
	pt: (count) => `${count} pedidos de assinatura pendentes`,
	'pt-pt': (count) => `${count} pedidos de assinatura pendentes`,
	ru: (count) => `${count} Ожидающие запросы на подпись`,
	sm: (count) => `${count} talosaga o saini o loo faatalitali`,
	so: (count) => `${count} codsi saxiix oo sugaya`,
	th: (count) => `คําขอลายเซ็นที่รอดําเนินการ ${count} รายการ`,
	ur: (count) => `${count} زیر التوا دستخط کی درخواستیں`,
	vi: (count) => `${count} yêu cầu chữ ký đang chờ xử lý`,
	'zh-hans': (count) => `${count} 个待处理签名请求`,
	'zh-hant': (count) => `${count} 個待處理的簽章請求`,
	en: (count) => `${count} pending signature requests`
};

export const loc_pendingSignatureRequestsSingular: Record<Locale, string> = {
	ar: `طلب توقيع معلق واحد`,
	de: `1 ausstehende Unterschriftsanfrage`,
	es: `1 solicitud de firma pendiente`,
	fa: `۱ درخواست امضا در انتظار`,
	fil: `1 nakabinbin na kahilingan sa lagda`,
	fr: `1 demande de signature en attente`,
	hi: `1 लंबित हस्ताक्षर अनुरोध`,
	ht: `1 annatant demann siyati`,
	it: `1 richiesta di firma in attesa`,
	ja: `署名申請保留1件`,
	ko: `서명 요청 1건 대기 중입니다`,
	mww: `1 Tos kos npe thov`,
	ps: `۱ د لاسلیک غوښتنه پاتې ده`,
	pt: `1 pedido de assinatura pendente`,
	'pt-pt': `1 pedido de assinatura pendente`,
	ru: `1 Ожидающий запрос на подпись`,
	sm: `1 talosaga o saini o loo faatalitali`,
	so: `1 codsi saxiix oo sugaya`,
	th: `1 คําขอลายเซ็นที่รอดําเนินการ`,
	ur: `1 زیر التواء دستخط کی درخواست`,
	vi: `1 yêu cầu chữ ký đang chờ xử lý`,
	'zh-hans': `1个待签签名请求`,
	'zh-hant': `1 個待簽收請求`,
	en: `1 pending signature request`
};

export const loc_people: Record<Locale, string> = {
	ar: `الأشخاص`,
	de: `Personen`,
	es: `Personas`,
	fa: `افراد`,
	fil: `Mga Tao`,
	fr: `Personnalités`,
	hi: `लोग`,
	ht: `Moun`,
	it: `Persone`,
	ja: `人々`,
	ko: `인물`,
	mww: `Cov neeg`,
	ps: `خلک`,
	pt: `Pessoas`,
	'pt-pt': `Pessoas`,
	ru: `Люди`,
	sm: `Tagata`,
	so: `Dadka`,
	th: `บุคลากร`,
	ur: `لوگ`,
	vi: `Con người`,
	'zh-hans': `人物`,
	'zh-hant': `人物`,
	en: `People`
};

export const loc_performance: Record<Locale, string> = {
	ar: `الأداء`,
	de: `Leistung`,
	es: `Rendimiento`,
	fa: `عملکرد`,
	fil: `Pagganap`,
	fr: `Performances`,
	hi: `प्रदर्शन`,
	ht: `Pèfòmans`,
	it: `Prestazioni`,
	ja: `パフォーマンス`,
	ko: `성능`,
	mww: `Kev ua tau zoo`,
	ps: `فعالیت`,
	pt: `Desempenho`,
	'pt-pt': `Desempenho`,
	ru: `Характеристики`,
	sm: `Fa'atinoga`,
	so: `Waxqabadka`,
	th: `ประสิทธิภาพ`,
	ur: `کارکردگی`,
	vi: `Hiệu suất bay`,
	'zh-hans': `性能`,
	'zh-hant': `性能`,
	en: `Performance`
};

export const loc_period: Record<Locale, string> = {
	ar: `نقطة على السطر`,
	de: `Punkt`,
	es: `Punto`,
	fa: `تمام.`,
	fil: `Panahon`,
	fr: `Point`,
	hi: `अवधि`,
	ht: `Peryòd`,
	it: `Punto`,
	ja: `以上`,
	ko: `끝`,
	mww: `Lub Sij Hawm`,
	ps: `بس`,
	pt: `Ponto final`,
	'pt-pt': `Ponto final`,
	ru: `Точка`,
	sm: `Vaitaimi`,
	so: `Muddada`,
	th: `ระยะเวลา`,
	ur: `ختم`,
	vi: `Thời gian`,
	'zh-hans': `就这样`,
	'zh-hant': `就這樣`,
	en: `Period`
};

export const loc_permitAnonymous: Record<Locale, string> = {
	ar: `التصريح المجهول`,
	de: `Genehmigung anonym`,
	es: `Permiso anónimo`,
	fa: `مجوز ناشناس`,
	fil: `Pahintulutan na hindi nagpapakilala`,
	fr: `Permis anonyme`,
	hi: `अनाम की अनुमति दें`,
	ht: `Pèmi anonim`,
	it: `Permesso anonimo`,
	ja: `許可証は匿名で`,
	ko: `익명 허가`,
	mww: `Tso cai tsis qhia npe`,
	ps: `اجازه نامه بې نومه`,
	pt: `Permissão anônima`,
	'pt-pt': `Permissão anónima`,
	ru: `Анонимный разрешитель`,
	sm: `Fa'atagaina le le fa'ailoaina`,
	so: `Permit anonymous`,
	th: `อนุญาตแบบไม่ระบุชื่อ`,
	ur: `پرمٹ گمنام`,
	vi: `Cho phép ẩn danh`,
	'zh-hans': `匿名许可`,
	'zh-hant': `許可匿名`,
	en: `Permit anonymous`
};

export const loc_permitAnonymousOptionDesc: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `يمكن تسجيل الاستبيانات التي تسمح بالدخول المجهول دون ارتباط بشخص مسجل في ${cumulus}.`,
	de: (cumulus) => `Fragebögen, die anonyme Einreise erlauben, können ohne Zuordnung zu einer registrierten ${cumulus} eingetragen werden.`,
	es: (cumulus) => `Los cuestionarios que permiten la entrada anónima pueden registrarse sin asociación con una persona registrada en ${cumulus}.`,
	fa: (cumulus) => `پرسشنامه هایی که اجازه ورود ناشناس را می دهند، می توانند بدون ارتباط با فرد ثبت شده در ${cumulus} ثبت شوند.`,
	fil: (cumulus) => `Ang mga questionnaire na nagpapahintulot sa hindi nagpapakilalang pagpasok ay maaaring maitala nang walang kaugnayan sa isang rehistradong tao sa ${cumulus}.`,
	fr: (cumulus) => `Les questionnaires permettant l’entrée anonyme peuvent être enregistrés sans association avec une personne enregistrée à ${cumulus}.`,
	hi: (cumulus) => `प्रश्नावली जो गुमनाम प्रविष्टि की अनुमति देती है, उसे ${cumulus} में एक पंजीकृत व्यक्ति के साथ संबंध के बिना दर्ज किया जा सकता है।`,
	ht: (cumulus) => `Kesyonè ki pèmèt antre anonim ka anrejistre san asosyasyon ak yon moun ki anrejistre nan ${cumulus}.`,
	it: (cumulus) => `I questionari che consentono l'ingresso anonimo possono essere registrati senza associazione con una persona registrata a ${cumulus}.`,
	ja: (cumulus) => `匿名参加を許可するアンケートは、 ${cumulus}に登録された人物と関係なく記録することができます。`,
	ko: (cumulus) => `익명 참여가 가능한 설문지는 ${cumulus}에 등록된 사람과 연관없이 기록할 수 있습니다.`,
	mww: (cumulus) => `Cov lus nug uas tso cai nkag mus tsis qhia npe tuaj yeem sau tseg yam tsis muaj kev koom tes nrog ib tus neeg sau npe hauv ${cumulus}.`,
	ps: (cumulus) => `هغه پوښتنلیکونه چې د نامعلوم داخلېدو اجازه ورکوی، پرته له دې چې ${cumulus} کې له ثبت شوی کس سره تړاو ولری، ثبت کېدای شی.`,
	pt: (cumulus) => `Questionários que permitem entrada anônima podem ser registrados sem associação com uma pessoa registrada em ${cumulus}.`,
	'pt-pt': (cumulus) => `Os questionários que permitem a entrada anónima podem ser registados sem associação com uma pessoa registada em ${cumulus}.`,
	ru: (cumulus) => `Анкеты, разрешающие анонимный вход, могут быть записаны без связи с зарегистрированным лицом в ${cumulus}.`,
	sm: (cumulus) => `O fesili e fa'atagaina ai le ulufale e le fa'ailoaina e mafai ona pu'eina e aunoa ma le feso'ota'iga ma se tagata lesitala i ${cumulus}.`,
	so: (cumulus) => `Su'aalaha oggolaanaya gelitaanka magac la'aanta ah waa la diiwaan gelin karaa iyada oo aan la xiriirin qof diiwaangashan oo ku sugan ${cumulus}.`,
	th: (cumulus) => `แบบสอบถามที่อนุญาตให้เข้าโดยไม่ระบุชื่อสามารถบันทึกได้โดยไม่ต้องเกี่ยวข้องกับบุคคลที่ลงทะเบียนใน ${cumulus}`,
	ur: (cumulus) => `وہ سوالنامے جو گمنام داخلے کی اجازت دیتے ہیں، ${cumulus} میں رجسٹرڈ شخص سے وابستگی کے بغیر ریکارڈ کیے جا سکتے ہیں۔`,
	vi: (cumulus) => `Bảng câu hỏi cho phép nhập cảnh ẩn danh có thể được ghi lại mà không liên quan đến người đã đăng ký trong ${cumulus}.`,
	'zh-hans': (cumulus) => `允许匿名访问的问卷可以在不与 ${cumulus}注册人有关联的情况下进行记录。`,
	'zh-hant': (cumulus) => `允許匿名填寫的問卷可在 ${cumulus} 中無需與登記人有關聯的情況下進行記錄。`,
	en: (cumulus) => `Questionnaires which permit anonymous entry can be recorded without association with a registered person in ${cumulus}.`
};

export const loc_person: Record<Locale, string> = {
	ar: `الشخصية`,
	de: `Person`,
	es: `Persona`,
	fa: `شخص`,
	fil: `Tao`,
	fr: `Personne`,
	hi: `व्यक्ति`,
	ht: `Moun`,
	it: `Persona`,
	ja: `人物`,
	ko: `인물`,
	mww: `neeg`,
	ps: `شخص`,
	pt: `Pessoa`,
	'pt-pt': `Pessoa`,
	ru: `Персонаж`,
	sm: `Tagata`,
	so: `Qof`,
	th: `คน`,
	ur: `شخص`,
	vi: `Người`,
	'zh-hans': `人物`,
	'zh-hant': `人物`,
	en: `Person`
};

export const loc_personalMessage: Record<Locale, string> = {
	ar: `رسالة شخصية`,
	de: `Persönliche Botschaft`,
	es: `Mensaje personal`,
	fa: `پیام شخصی`,
	fil: `Personal na mensahe`,
	fr: `Message personnel`,
	hi: `व्यक्तिगत संदेश`,
	ht: `Mesaj pèsonèl`,
	it: `Messaggio personale`,
	ja: `個人的なメッセージ`,
	ko: `개인 메시지`,
	mww: `Cov lus ntawm tus kheej`,
	ps: `شخصی پیغام`,
	pt: `Mensagem pessoal`,
	'pt-pt': `Mensagem pessoal`,
	ru: `Личное сообщение`,
	sm: `Savali patino`,
	so: `Fariin shaqsi ah`,
	th: `ข้อความส่วนตัว`,
	ur: `ذاتی پیغام`,
	vi: `Tin nhắn cá nhân`,
	'zh-hans': `个人留言`,
	'zh-hant': `個人訊息`,
	en: `Personal message`
};

export const loc_personalMessageDesc: Record<Locale, string> = {
	ar: `رسالة اختيارية لتضمينها في البريد الإلكتروني إلى هذا الموقع.`,
	de: `Optionale Nachricht, die in die E-Mail an diesen Unterzeichner aufgenommen werden kann.`,
	es: `Mensaje opcional para incluir en el correo electrónico a este firmante.`,
	fa: `پیام اختیاری برای درج در ایمیل به این امضا کننده.`,
	fil: `Opsyonal na mensahe na isama sa email sa lumagda na ito.`,
	fr: `Message optionnel à inclure dans l’email à ce signataire.`,
	hi: `इस हस्ताक्षरकर्ता को ईमेल में शामिल करने के लिए वैकल्पिक संदेश.`,
	ht: `Si ou vle mesaj yo enkli nan imèl la bay siyen sa a.`,
	it: `Messaggio opzionale da includere nell'email a questo firmatario.`,
	ja: `この署名者へのメールに含める任意のメッセージです。`,
	ko: `이 서명자에게 보내는 이메일에 포함할 수 있는 선택적 메시지입니다.`,
	mww: `Yeem cov lus kom suav nrog hauv email rau tus neeg kos npe no.`,
	ps: `اختیاری پیغام چې په ایمیل کې دې لاسلیک کوونکی ته شامل شی.`,
	pt: `Mensagem opcional para incluir no e-mail para este signatário.`,
	'pt-pt': `Mensagem opcional a incluir no email para este signatário.`,
	ru: `Необязательное сообщение для включения в письмо этому подписанту.`,
	sm: `Savali e filifili ai e aofia ai i le imeli i le tagata saini lenei.`,
	so: `Fariin ikhtiyaari ah oo lagu dari karo email-ka saxiixaha.`,
	th: `ข้อความที่ไม่บังคับที่จะรวมไว้ในอีเมลถึงผู้ลงนามรายนี้`,
	ur: `اس دستخط کنندہ کو ای میل میں شامل کرنے کے لیے اختیاری پیغام۔`,
	vi: `Tin nhắn tùy chọn để đưa vào email cho người ký này.`,
	'zh-hans': `发给该签署人的邮件中可附的可选信息。`,
	'zh-hant': `請在寄給此簽署人的電子郵件中附上可選訊息。`,
	en: `Optional message to include in the email to this signer.`
};

export const loc_personRelationship: Record<Locale, string> = {
	ar: `العلاقة الشخصية`,
	de: `Personenbeziehung`,
	es: `Relación con la persona`,
	fa: `رابطه فردی`,
	fil: `Relasyon ng tao`,
	fr: `Relation avec la personne`,
	hi: `व्यक्ति संबंध`,
	ht: `Relasyon moun`,
	it: `Relazione con la persona`,
	ja: `人間関係`,
	ko: `인물 관계`,
	mww: `Kev sib raug zoo ntawm tus neeg`,
	ps: `شخصی اړیکه`,
	pt: `Relacionamento entre pessoas`,
	'pt-pt': `Relação com a pessoa`,
	ru: `Личностные отношения`,
	sm: `Sootaga a le tagata`,
	so: `Xiriirka shaqsiga`,
	th: `ความสัมพันธ์ของบุคคล`,
	ur: `شخصی تعلق`,
	vi: `Mối quan hệ con người`,
	'zh-hans': `人际关系`,
	'zh-hant': `人與人關係`,
	en: `Person relationship`
};

export const loc_personRelationshipDesc: Record<Locale, string> = {
	ar: `سجل يثبت العلاقة القائمة على الدور بين شخصين، مثل مقدم الرعاية ومتلقي الرعاية أو الموظف وصاحب العمل.`,
	de: `Ein Dokument, das die rollenbasierte Beziehung zwischen zwei Personen festlegt, wie etwa Pflegeperson und Pflegeempfänger oder Arbeitnehmer und Arbeitgeber.`,
	es: `Un registro que establezca la relación basada en el rol entre dos personas, como cuidador y beneficiario de cuidado o empleado y empleador.`,
	fa: `یک سابقه که رابطه مبتنی بر نقش بین دو فرد، مانند مراقب و دریافت کننده مراقبت یا کارمند و کارفرما را اثبات می کند.`,
	fil: `Isang talaan na nagtatatag ng relasyon na nakabatay sa papel sa pagitan ng dalawang indibidwal, tulad ng tagapag-alaga at tatanggap ng pangangalaga o empleyado at employer.`,
	fr: `Un document établissant la relation basée sur le rôle entre deux individus, tels que l’aidant et le bénéficiaire de soins ou l’employé et l’employeur.`,
	hi: `दो व्यक्तियों, जैसे देखभाल करने वाले और देखभाल प्राप्तकर्ता या कर्मचारी और नियोक्ता के बीच भूमिका-आधारित संबंध स्थापित करने वाला एक रिकॉर्ड।`,
	ht: `Yon dosye ki etabli relasyon ki baze sou wòl ant de moun, tankou moun kap bay swen ak moun k ap resevwa swen oswa anplwaye ak anplwayè.`,
	it: `Un documento che attesti la relazione basata sul ruolo tra due individui, come caregiver e beneficiario di assistenza o dipendente e datore di lavoro.`,
	ja: `介護者と介護を受ける者、または従業員と雇用主など、二人の個人との役割に基づく関係を確立する記録。`,
	ko: `보호자와 보호자 또는 직원과 고용주 등 두 개인 간의 역할 기반 관계를 확립하는 기록입니다.`,
	mww: `Ib daim ntaub ntawv teev tseg txog kev sib raug zoo ntawm ob tug neeg, xws li tus neeg saib xyuas thiab tus neeg tau txais kev saib xyuas lossis tus neeg ua hauj lwm thiab chaw ua hauj lwm.`,
	ps: `یو ریکارډ چې د دوو افرادو ترمنځ د رول پر بنسټ اړیکه ثابتوی، لکه د پاملرنې کوونکی او پاملرنې ترلاسه کوونکی یا کارکوونکی او کارګمارونکی.`,
	pt: `Um registro que estabeleça a relação baseada em funções entre dois indivíduos, como cuidador e beneficiário de cuidados ou empregado e empregador.`,
	'pt-pt': `Um registo que estabelece a relação baseada no papel entre dois indivíduos, como cuidador e beneficiário de cuidados ou empregado e empregador.`,
	ru: `Запись, устанавливающая ролевые отношения между двумя людьми, такими как опекун и получатель опекуны или сотрудник и работодатель.`,
	sm: `O se fa'amaumauga e fa'amautuina ai le sootaga fa'avae i le va o tagata e to'alua, e pei o le tagata tausi ma le tagata e mauaina le tausiga po'o le tagata faigaluega ma le kamupani.`,
	so: `Diiwaan muujinaya xiriirka ku saleysan doorka u dhexeeya laba qof, sida daryeelaha iyo qaataha daryeelka ama shaqaale iyo shaqo-bixiye.`,
	th: `บันทึกการสร้างความสัมพันธ์ตามบทบาทระหว่างบุคคลสองคน เช่น ผู้ดูแลและผู้รับการดูแล หรือลูกจ้างและนายจ้าง`,
	ur: `ایک ریکارڈ جو دو افراد، جیسے نگہداشت کرنے والا، دیکھ بھال کرنے والا، یا ملازم اور آجر کے درمیان کردار پر مبنی تعلق قائم کرتا ہے۔`,
	vi: `Hồ sơ thiết lập mối quan hệ dựa trên vai trò giữa hai cá nhân, chẳng hạn như người chăm sóc và người nhận chăm sóc hoặc nhân viên và chủ lao động.`,
	'zh-hans': `建立两个人之间基于角色的关系的记录，例如照护者与照护者，或雇员与雇主。`,
	'zh-hant': `建立兩個人之間基於角色的關係紀錄，例如照護者與照護者，或員工與雇主。`,
	en: `A record establishing the role-based relationship between two individuals, such as caregiver and care recipient or employee and employer.`
};

export const loc_personReportDescription: Record<Locale, string> = {
	ar: `الديموغرافيا، العناوين، البريد الإلكتروني، والهواتف.`,
	de: `Demografie, Adressen, E-Mails und Telefone.`,
	es: `Demografía, direcciones, correos electrónicos y teléfonos.`,
	fa: `جمعیت شناسی، آدرس ها، ایمیل ها و تلفن ها.`,
	fil: `Demograpiko, address, email, at telepono.`,
	fr: `Démographie, adresses, e-mails et téléphones.`,
	hi: `जनसांख्यिकी, पते, ईमेल और फोन।`,
	ht: `Demografik, adrès, imèl, ak telefòn.`,
	it: `Demografia, indirizzi, email e telefoni.`,
	ja: `人口統計、住所、メール、電話番号。`,
	ko: `인구 통계, 주소, 이메일, 전화번호 등.`,
	mww: `Cov pej xeem, chaw nyob, email thiab xov tooj.`,
	ps: `ډیموګرافی، پته، ایمیلونه، او تلیفونونه.`,
	pt: `Demografia, endereços, e-mails e telefones.`,
	'pt-pt': `Demografia, moradas, emails e telefones.`,
	ru: `Демография, адреса, электронная почта и телефоны.`,
	sm: `Faitau aofai o tagata, tuatusi, imeli, ma telefoni.`,
	so: `Tirakoobka, cinwaanada, emailada, iyo telefoonada.`,
	th: `ข้อมูลประชากร ที่อยู่ อีเมล และโทรศัพท์`,
	ur: `آبادیات، پتے، ای میلز، اور فونز۔`,
	vi: `Nhân khẩu học, địa chỉ, email và điện thoại.`,
	'zh-hans': `人口统计、地址、电子邮件和电话。`,
	'zh-hant': `人口統計、地址、電子郵件和電話。`,
	en: `Demographics, addresses, emails, and phones.`
};

export const loc_phone: Record<Locale, string> = {
	ar: `الهاتف`,
	de: `Telefon`,
	es: `Teléfono`,
	fa: `تلفن`,
	fil: `Telepono`,
	fr: `Téléphone`,
	hi: `फ़ोन`,
	ht: `Telefòn`,
	it: `Telefono`,
	ja: `電話`,
	ko: `전화`,
	mww: `Xov tooj`,
	ps: `تلیفون`,
	pt: `Telefone`,
	'pt-pt': `Telefone`,
	ru: `Телефон`,
	sm: `Telefoni`,
	so: `Telefoon`,
	th: `โทรศัพท์`,
	ur: `فون`,
	vi: `Điện thoại`,
	'zh-hans': `电话`,
	'zh-hant': `電話`,
	en: `Phone`
};

export const loc_phoneNumber: Record<Locale, string> = {
	ar: `رقم الهاتف`,
	de: `Telefonnummer`,
	es: `Número de teléfono`,
	fa: `شماره تلفن`,
	fil: `Numero ng telepono`,
	fr: `Numéro de téléphone`,
	hi: `फोन संख्या`,
	ht: `Nimewo telefòn`,
	it: `Numero di telefono`,
	ja: `電話番号`,
	ko: `전화번호`,
	mww: `Tus xov tooj`,
	ps: `د تلیفون شمېره`,
	pt: `Número de telefone`,
	'pt-pt': `Número de telefone`,
	ru: `Номер телефона`,
	sm: `Numera o le telefoni`,
	so: `Lambarka telefoonka`,
	th: `หมายเลขโทรศัพท์`,
	ur: `فون نمبر`,
	vi: `Số điện thoại`,
	'zh-hans': `电话号码`,
	'zh-hant': `電話號碼`,
	en: `Phone number`
};

export const loc_phones: Record<Locale, string> = {
	ar: `الهواتف`,
	de: `Telefone`,
	es: `Teléfonos`,
	fa: `تلفن ها`,
	fil: `Mga Telepono`,
	fr: `Téléphones`,
	hi: `फ़ोन`,
	ht: `Telefòn yo`,
	it: `Telefoni`,
	ja: `電話`,
	ko: `전화기`,
	mww: `Cov xov tooj`,
	ps: `تلیفونونه`,
	pt: `Telefones`,
	'pt-pt': `Telemóveis`,
	ru: `Телефоны`,
	sm: `Telefoni`,
	so: `Telefoonada`,
	th: `โทรศัพท์`,
	ur: `فونز`,
	vi: `Điện thoại`,
	'zh-hans': `电话`,
	'zh-hant': `電話`,
	en: `Phones`
};

export const loc_phoneSMS: Record<Locale, string> = {
	ar: `الهاتف (SMS)`,
	de: `Telefon (SMS)`,
	es: `Teléfono (SMS)`,
	fa: `تلفن (پیامک)`,
	fil: `Telepono (SMS)`,
	fr: `Téléphone (SMS)`,
	hi: `फोन (एसएमएस)`,
	ht: `Telefòn (SMS)`,
	it: `Telefono (SMS)`,
	ja: `電話(SMS)`,
	ko: `전화 (SMS)`,
	mww: `Xov tooj (SMS)`,
	ps: `تلیفون (SMS)`,
	pt: `Telefone (SMS)`,
	'pt-pt': `Telefone (SMS)`,
	ru: `Телефон (SMS)`,
	sm: `Telefoni (SMS)`,
	so: `Telefoon (SMS)`,
	th: `โทรศัพท์ (SMS)`,
	ur: `فون (ایس ایم ایس)`,
	vi: `Điện thoại (SMS)`,
	'zh-hans': `电话（短信）`,
	'zh-hant': `電話（簡訊）`,
	en: `Phone (SMS)`
};

export const loc_physical: Record<Locale, string> = {
	ar: `الجسدية`,
	de: `Physisch`,
	es: `Físico`,
	fa: `از نظر فیزیکی`,
	fil: `Pisikal`,
	fr: `Physique`,
	hi: `भौतिक`,
	ht: `Fizik`,
	it: `Fisica`,
	ja: `物理的`,
	ko: `신체`,
	mww: `Lub cev nqaij daim tawv`,
	ps: `فزیکی`,
	pt: `Físico`,
	'pt-pt': `Físico`,
	ru: `Физические характеристики`,
	sm: `Faaletino`,
	so: `Jirka`,
	th: `ทางกายภาพ`,
	ur: `جسمانی`,
	vi: `Vật lý`,
	'zh-hans': `物理`,
	'zh-hant': `物理`,
	en: `Physical`
};

export const loc_platformSite: Record<Locale, string> = {
	ar: `موقع الرصيف`,
	de: `Plattformstandort`,
	es: `Emplazamiento del andén`,
	fa: `محل سکوها`,
	fil: `Site ng Platform`,
	fr: `Site du quai`,
	hi: `प्लेटफार्म साइट`,
	ht: `Sit platfòm`,
	it: `Sito della banchina`,
	ja: `プラットフォームサイト`,
	ko: `플랫폼 사이트`,
	mww: `Platform site`,
	ps: `د پلاتفورم ځای`,
	pt: `Site da plataforma`,
	'pt-pt': `Site da plataforma`,
	ru: `Площадка платформы`,
	sm: `Nofoaga o le tulaga`,
	so: `Goobta madal`,
	th: `เว็บไซต์แพลตฟอร์ม`,
	ur: `پلیٹ فارم سائٹ`,
	vi: `Trang web nền tảng`,
	'zh-hans': `站台网站`,
	'zh-hant': `月台網站`,
	en: `Platform site`
};

export const loc_potentialDuplicatesOrRelations: Record<Locale, string> = {
	ar: `التكرارات أو العلاقات المحتملة`,
	de: `Mögliche Duplikate oder Beziehungen`,
	es: `Duplicados o relaciones potenciales`,
	fa: `تکرارها یا روابط احتمالی`,
	fil: `Mga potensyal na duplicate o relasyon`,
	fr: `Doubles ou relations potentielles`,
	hi: `संभावित डुप्लिकेट या संबंध`,
	ht: `Kopi potansyèl oswa relasyon`,
	it: `Potenziali duplicati o relazioni`,
	ja: `潜在的な重複や関係`,
	ko: `잠재적 중복 또는 관계`,
	mww: `Tej zaum duplicates los yog kev sib raug zoo`,
	ps: `احتمالی نقلونه یا اړیکې`,
	pt: `Potenciais duplicados ou relações`,
	'pt-pt': `Potenciais duplicados ou relações`,
	ru: `Возможные дубликаты или отношения`,
	sm: `Ono fa'aluaina po'o feso'ota'iga`,
	so: `Nuqullo suurtagal ah ama xiriirro`,
	th: `ความซ้ําซ้อนหรือความสัมพันธ์ที่อาจเกิดขึ้น`,
	ur: `ممکنہ نقول یا تعلقات`,
	vi: `Các bản sao hoặc mối quan hệ tiềm ẩn`,
	'zh-hans': `潜在的重复或关系`,
	'zh-hant': `潛在的重複或關聯`,
	en: `Potential duplicates or relations`
};

export const loc_poweredByCumulus: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `مدعوم من ${cumulus}`,
	de: (cumulus) => `Angetrieben von ${cumulus}`,
	es: (cumulus) => `Impulsado por ${cumulus}`,
	fa: (cumulus) => `با قدرت ${cumulus}`,
	fil: (cumulus) => `Username: ${cumulus}`,
	fr: (cumulus) => `Propulsé par ${cumulus}`,
	hi: (cumulus) => `${cumulus} द्वारा संचालित`,
	ht: (cumulus) => `Patrone pa ${cumulus}`,
	it: (cumulus) => `Alimentato ${cumulus}`,
	ja: (cumulus) => `${cumulus}による提供`,
	ko: (cumulus) => `${cumulus} 제공`,
	mww: (cumulus) => `Powered los ntawm ${cumulus}`,
	ps: (cumulus) => `د ${cumulus} لخوا ځواکمن شوی`,
	pt: (cumulus) => `Equipado com ${cumulus}`,
	'pt-pt': (cumulus) => `Alimentado por ${cumulus}`,
	ru: (cumulus) => `Работает ${cumulus}`,
	sm: (cumulus) => `Fa'amalosia e ${cumulus}`,
	so: (cumulus) => `Waxaa ku shaqeeya ${cumulus}`,
	th: (cumulus) => `ขับเคลื่อนโดย ${cumulus}`,
	ur: (cumulus) => `پاورڈ بائی ${cumulus}`,
	vi: (cumulus) => `Được cung cấp bởi ${cumulus}`,
	'zh-hans': (cumulus) => `由${cumulus}提供动力`,
	'zh-hant': (cumulus) => `由 ${cumulus} 提供動力`,
	en: (cumulus) => `Powered by ${cumulus}`
};

export const loc_preciseLocation: Record<Locale, string> = {
	ar: `الموقع الدقيق`,
	de: `Genauer Ort`,
	es: `Ubicación precisa`,
	fa: `موقعیت دقیق`,
	fil: `Tumpak na lokasyon`,
	fr: `Emplacement précis`,
	hi: `सटीक स्थान`,
	ht: `Kote egzak`,
	it: `Posizione precisa`,
	ja: `正確な位置`,
	ko: `정확한 위치`,
	mww: `Qhov chaw meej`,
	ps: `دقیق ځای`,
	pt: `Localização precisa`,
	'pt-pt': `Localização precisa`,
	ru: `Точное расположение`,
	sm: `Nofoaga tonu`,
	so: `Goobta saxda ah`,
	th: `ตําแหน่งที่แม่นยํา`,
	ur: `درست مقام`,
	vi: `Vị trí chính xác`,
	'zh-hans': `精确位置`,
	'zh-hant': `精確位置`,
	en: `Precise location`
};

export const loc_precision: Record<Locale, string> = {
	ar: `الدقة`,
	de: `Präzision`,
	es: `Precisión`,
	fa: `دقت`,
	fil: `Katumpakan`,
	fr: `Précision`,
	hi: `शुद्धता`,
	ht: `Presizyon`,
	it: `Precisione`,
	ja: `精密さ`,
	ko: `정밀도`,
	mww: `Qhov tseeb`,
	ps: `دقت`,
	pt: `Precisão`,
	'pt-pt': `Precisão`,
	ru: `Точность`,
	sm: `Sa'o`,
	so: `Saxnaan`,
	th: `ความแม่นยํา`,
	ur: `درستگی`,
	vi: `Độ chính xác`,
	'zh-hans': `精度`,
	'zh-hant': `精度`,
	en: `Precision`
};

export const loc_prepareDocuments: Record<Locale, string> = {
	ar: `تحضير الوثائق`,
	de: `Bereite Dokumente vor`,
	es: `Prepara documentos`,
	fa: `تهیه اسناد`,
	fil: `Maghanda ng mga dokumento`,
	fr: `Préparer les documents`,
	hi: `दस्तावेज़ तैयार करें`,
	ht: `Prepare dokiman yo`,
	it: `Preparare i documenti`,
	ja: `書類を準備してください`,
	ko: `문서 준비`,
	mww: `Npaj cov ntaub ntawv`,
	ps: `اسناد چمتو کړئ`,
	pt: `Preparar documentos`,
	'pt-pt': `Preparar documentos`,
	ru: `Подготовьте документы`,
	sm: `Saunia pepa aloaia`,
	so: `Diyaari dukumentiyada`,
	th: `เตรียมเอกสาร`,
	ur: `دستاویزات تیار کریں`,
	vi: `Chuẩn bị hồ sơ`,
	'zh-hans': `准备文件`,
	'zh-hant': `準備文件`,
	en: `Prepare documents`
};

export const loc_prescriber: Record<Locale, string> = {
	ar: `الطبيب`,
	de: `Verschreiber`,
	es: `Prescriptor`,
	fa: `تجویزکننده`,
	fil: `Tagapagreseta`,
	fr: `Prescripteur`,
	hi: `प्रिस्क्राइबर`,
	ht: `Preskri`,
	it: `Prescrittore`,
	ja: `処方者`,
	ko: `처방자`,
	mww: `Tus kws sau ntawv`,
	ps: `نسخه لیکونکی`,
	pt: `Prescritor`,
	'pt-pt': `Prescritor`,
	ru: `Врач`,
	sm: `Prescriber`,
	so: `Qoraa`,
	th: `ผู้สั่งจ่ายยา`,
	ur: `تجویز کنندہ`,
	vi: `Người kê đơn`,
	'zh-hans': `开药者`,
	'zh-hant': `開藥者`,
	en: `Prescriber`
};

export const loc_press: Record<Locale, string> = {
	ar: `الصحافة`,
	de: `Presse`,
	es: `Prensa`,
	fa: `مطبوعات`,
	fil: `Pindutin`,
	fr: `Presse`,
	hi: `दबाना`,
	ht: `Peze`,
	it: `Stampa`,
	ja: `報道`,
	ko: `언론`,
	mww: `Xovxwm`,
	ps: `مطبوعات`,
	pt: `Imprensa`,
	'pt-pt': `Imprensa`,
	ru: `Пресса`,
	sm: `Fa'asalalau`,
	so: `Warbaahinta`,
	th: `ข่าวประชา`,
	ur: `پریس`,
	vi: `Ấn Bản`,
	'zh-hans': `媒体`,
	'zh-hant': `媒體報導`,
	en: `Press`
};

export const loc_preview: Record<Locale, string> = {
	ar: `معاينة`,
	de: `Vorschau`,
	es: `Avance`,
	fa: `پیش نمایش`,
	fil: `Preview`,
	fr: `Aperçu`,
	hi: `पूर्वसमीक्षा`,
	ht: `Preview`,
	it: `Anteprima`,
	ja: `プレビュー`,
	ko: `미리보기`,
	mww: `Saib ua ntej`,
	ps: `مخکتنه`,
	pt: `Prévia`,
	'pt-pt': `Pré-visualização`,
	ru: `Превью`,
	sm: `Muai vaaiga`,
	so: `Hordhac`,
	th: `ตัวอย่าง`,
	ur: `پیش نظارہ`,
	vi: `Xem trước`,
	'zh-hans': `预览`,
	'zh-hant': `預覽`,
	en: `Preview`
};

export const loc_previous: Record<Locale, string> = {
	ar: `السابق`,
	de: `Früher`,
	es: `Anterior`,
	fa: `گذشته`,
	fil: `Nakaraan`,
	fr: `Précédent`,
	hi: `पिछला`,
	ht: `Previousin`,
	it: `Precedente`,
	ja: `過去`,
	ko: `이전`,
	mww: `Yav dhau los`,
	ps: `پخوانی`,
	pt: `Anterior`,
	'pt-pt': `Anterior`,
	ru: `Предыдущие`,
	sm: `Muamua`,
	so: `Hore`,
	th: `ก่อนหน้า`,
	ur: `پچھلا`,
	vi: `Trước`,
	'zh-hans': `之前`,
	'zh-hant': `先前`,
	en: `Previous`
};

export const loc_previousPage: Record<Locale, string> = {
	ar: `الصفحة السابقة`,
	de: `Vorherige Seite`,
	es: `Página anterior`,
	fa: `صفحه قبلی`,
	fil: `Nakaraang pahina`,
	fr: `Page précédente`,
	hi: `पिछला पृष्ठ`,
	ht: `Paj anvan an`,
	it: `Pagina precedente`,
	ja: `前のページ`,
	ko: `이전 페이지`,
	mww: `Nplooj ntawv dhau los`,
	ps: `مخکېنی پاڼه`,
	pt: `Página anterior`,
	'pt-pt': `Página anterior`,
	ru: `Предыдущая страница`,
	sm: `Itulau talu ai`,
	so: `Boggii hore`,
	th: `หน้าก่อนหน้า`,
	ur: `پچھلا صفحہ`,
	vi: `Trang trước`,
	'zh-hans': `上一页`,
	'zh-hant': `上一頁`,
	en: `Previous page`
};

export const loc_previousPayPeriod: Record<Locale, string> = {
	ar: `فترة الدفع السابقة`,
	de: `Frühere Abrechnungsperiode`,
	es: `Periodo de pago anterior`,
	fa: `دوره پرداخت قبلی`,
	fil: `Nakaraang panahon ng suweldo`,
	fr: `Période de paie précédente`,
	hi: `पिछली वेतन अवधि`,
	ht: `Peryòd peman anvan an`,
	it: `Periodo di paga precedente`,
	ja: `前回の給与期間`,
	ko: `이전 급여 기간`,
	mww: `Lub sijhawm them nyiaj yav dhau los`,
	ps: `مخکینی معاش دوره`,
	pt: `Período de pagamento anterior`,
	'pt-pt': `Período de pagamento anterior`,
	ru: `Предыдущий платёжный период`,
	sm: `Vaitau o totogi talu ai`,
	so: `Muddadii mushaharkii hore`,
	th: `รอบระยะเวลาการจ่ายเงินก่อนหน้า`,
	ur: `پچھلی تنخواہ کی مدت`,
	vi: `Kỳ trả lương trước`,
	'zh-hans': `上一期工资`,
	'zh-hant': `前一薪資期間`,
	en: `Previous pay period`
};

export const loc_primary: Record<Locale, string> = {
	ar: `الابتدائي`,
	de: `Grundschule`,
	es: `Primaria`,
	fa: `انتخابات مقدماتی`,
	fil: `Pangunahin`,
	fr: `Primaire`,
	hi: `प्राथमिक`,
	ht: `Prensipal`,
	it: `Primarie`,
	ja: `小学校`,
	ko: `초등학교`,
	mww: `thawj zaug`,
	ps: `لومړنی پړاو`,
	pt: `Primária`,
	'pt-pt': `Primária`,
	ru: `Первичная школа`,
	sm: `Peraimeri`,
	so: `Doorashooyinka Aasaasiga ah`,
	th: `ประถมศึกษา`,
	ur: `پرائمری`,
	vi: `Tiểu học`,
	'zh-hans': `小学`,
	'zh-hant': `小學`,
	en: `Primary`
};

export const loc_primaryEmergencyContact: Record<Locale, string> = {
	ar: `جهة الاتصال الرئيسية للطوارئ`,
	de: `Primärer Notfallkontakt`,
	es: `Contacto de Emergencia Principal`,
	fa: `تماس اضطراری اصلی`,
	fil: `Pangunahing Emergency Contact`,
	fr: `Contact d’urgence principal`,
	hi: `प्राथमिक आपातकालीन संपर्क`,
	ht: `Kontak Ijans Prensipal`,
	it: `Contatto Primaria di Emergenza`,
	ja: `主な緊急連絡先`,
	ko: `주요 긴급 연락처`,
	mww: `Thawj Kev Tiv Tauj Thaum Muaj Xwm Txheej Ceev`,
	ps: `اصلی بیړنی تماس`,
	pt: `Contato Primário de Emergência`,
	'pt-pt': `Contacto Primário de Emergência`,
	ru: `Основной контакт для экстренных ситуаций`,
	sm: `Tagata e Faafesootai i le Peraimeri mo Faalavelave Tutupu Faafuasei`,
	so: `Xiriirka Degdegga ah ee Muhiimka ah`,
	th: `ผู้ติดต่อฉุกเฉินเบื้องต้น`,
	ur: `بنیادی ہنگامی رابطہ`,
	vi: `Liên hệ khẩn cấp chính`,
	'zh-hans': `主要紧急联系人`,
	'zh-hant': `主要緊急聯絡人`,
	en: `Primary Emergency Contact`
};

export const loc_primaryLanguage: Record<Locale, string> = {
	ar: `اللغة الأساسية`,
	de: `Hauptsprache`,
	es: `Lengua primaria`,
	fa: `زبان اصلی`,
	fil: `Pangunahing wika`,
	fr: `Langue principale`,
	hi: `प्राथमिक भाषा`,
	ht: `Premye lang`,
	it: `Lingua primaria`,
	ja: `主な言語`,
	ko: `주요 언어`,
	mww: `Thawj hom lus`,
	ps: `اصلی ژبه`,
	pt: `Língua primária`,
	'pt-pt': `Língua principal`,
	ru: `Основной язык`,
	sm: `Gagana autu`,
	so: `Luuqadda Koowaad`,
	th: `ภาษาหลัก`,
	ur: `بنیادی زبان`,
	vi: `Ngôn ngữ chính`,
	'zh-hans': `主要语言`,
	'zh-hant': `主要語言`,
	en: `Primary language`
};

export const loc_primaryMailingAddress: Record<Locale, string> = {
	ar: `العنوان البريدي الرئيسي`,
	de: `Hauptpostadresse`,
	es: `Dirección postal principal`,
	fa: `نشانی پستی اصلی`,
	fil: `Pangunahing address ng koreo`,
	fr: `Adresse postale principale`,
	hi: `प्राथमिक डाक पता`,
	ht: `Adrès postal prensipal`,
	it: `Indirizzo postale principale`,
	ja: `主な郵送先住所`,
	ko: `주요 우편 주소`,
	mww: `Thawj qhov chaw nyob xa ntawv`,
	ps: `اصلی د پوستې پته`,
	pt: `Endereço principal de correspondência`,
	'pt-pt': `Endereço postal principal`,
	ru: `Основной почтовый адрес`,
	sm: `Tuatusi meli autu`,
	so: `Cinwaanka boostada ugu weyn`,
	th: `ที่อยู่ทางไปรษณีย์หลัก`,
	ur: `بنیادی ڈاک کا پتہ`,
	vi: `Địa chỉ gửi thư chính`,
	'zh-hans': `主要邮寄地址`,
	'zh-hant': `主要郵寄地址`,
	en: `Primary mailing address`
};

export const loc_primaryPhysicalAddress: Record<Locale, string> = {
	ar: `العنوان الفيزيائي الأساسي`,
	de: `Primäre physische Adresse`,
	es: `Dirección física principal`,
	fa: `آدرس فیزیکی اصلی`,
	fil: `Pangunahing pisikal na address`,
	fr: `Adresse physique principale`,
	hi: `प्राथमिक भौतिक पता`,
	ht: `Adrès fizik prensipal`,
	it: `Indirizzo fisico principale`,
	ja: `プライマリ物理アドレス`,
	ko: `주요 물리적 주소`,
	mww: `Thawj qhov chaw nyob ntawm lub cev`,
	ps: `اصلی فزیکی پته`,
	pt: `Endereço físico principal`,
	'pt-pt': `Endereço físico principal`,
	ru: `Основной физический адрес`,
	sm: `Tuatusi faaletino o le Peraimeri`,
	so: `Cinwaanka ugu weyn ee jirka`,
	th: `ที่อยู่ทางกายภาพหลัก`,
	ur: `بنیادی جسمانی پتہ`,
	vi: `Địa chỉ thực tế chính`,
	'zh-hans': `主要物理地址`,
	'zh-hant': `主要實體地址`,
	en: `Primary physical address`
};

export const loc_print: Record<Locale, string> = {
	ar: `الطباعة`,
	de: `Druck`,
	es: `Impresión`,
	fa: `چاپ`,
	fil: `I-print`,
	fr: `Imprimé`,
	hi: `फ़ोटो`,
	ht: `Ekri an lèt detache`,
	it: `Stampa`,
	ja: `印刷物`,
	ko: `인쇄`,
	mww: `Luam tawm`,
	ps: `چاپ`,
	pt: `Impressão`,
	'pt-pt': `Impressão`,
	ru: `Печать`,
	sm: `Lolomi`,
	so: `Daabacaad`,
	th: `พิมพ์`,
	ur: `پرنٹ`,
	vi: `In ấn`,
	'zh-hans': `印刷`,
	'zh-hant': `印刷品`,
	en: `Print`
};

export const loc_printDetails: Record<Locale, string> = {
	ar: `تفاصيل الطباعة`,
	de: `Printdetails`,
	es: `Detalles de impresión`,
	fa: `جزئیات چاپ`,
	fil: `Email Address *`,
	fr: `Détails imprimés`,
	hi: `प्रिंट विवरण`,
	ht: `Ekri an lèt detache detay`,
	it: `Dettagli di stampa`,
	ja: `印刷詳細`,
	ko: `인쇄 정보`,
	mww: `Luam tawm cov ntsiab lus`,
	ps: `د چاپ تفصیلات`,
	pt: `Detalhes da impressão`,
	'pt-pt': `Detalhes de impressão`,
	ru: `Детали печати`,
	sm: `Lolomi auiliiliga`,
	so: `Faahfaahinta daabacaadda`,
	th: `พิมพ์รายละเอียด`,
	ur: `پرنٹ تفصیلات`,
	vi: `In chi tiết`,
	'zh-hans': `印刷详情`,
	'zh-hant': `印刷詳情`,
	en: `Print details`
};

export const loc_printSummary: Record<Locale, string> = {
	ar: `ملخص الطباعة`,
	de: `Druckzusammenfassung`,
	es: `Resumen impreso`,
	fa: `خلاصه چاپ`,
	fil: `I-print ang buod`,
	fr: `Résumé imprimé`,
	hi: `प्रिंट सारांश`,
	ht: `Rezime enprime`,
	it: `Riassunto cartaceato`,
	ja: `印刷概要`,
	ko: `인쇄 요약`,
	mww: `Sau cov ntsiab lus`,
	ps: `د چاپ لنډیز`,
	pt: `Resumo impresso`,
	'pt-pt': `Resumo impresso`,
	ru: `Краткое содержание печати`,
	sm: `Lolomi le aotelega`,
	so: `Soo koobid daabacaad`,
	th: `สรุปการพิมพ์`,
	ur: `پرنٹ خلاصہ`,
	vi: `In tóm tắt`,
	'zh-hans': `印刷摘要`,
	'zh-hant': `印刷摘要`,
	en: `Print summary`
};

export const loc_printSummaryWithHistory: Record<Locale, string> = {
	ar: `ملخص مطبوع مع التاريخ`,
	de: `Druckzusammenfassung mit Geschichte`,
	es: `Resumen impreso con historia`,
	fa: `خلاصه چاپی همراه با تاریخچه`,
	fil: `I-print ang buod na may kasaysayan`,
	fr: `Résumé imprimé avec histoire`,
	hi: `इतिहास के साथ सारांश प्रिंट करें`,
	ht: `Enprime rezime ak istwa`,
	it: `Riassunto stampato con la storia`,
	ja: `歴史付き印刷要約`,
	ko: `역사가 포함된 인쇄 요약`,
	mww: `Luam tawm cov ntsiab lus nrog keeb kwm`,
	ps: `د تاریخ سره د چاپ لنډیز`,
	pt: `Resumo impresso com histórico`,
	'pt-pt': `Resumo impresso com história`,
	ru: `Краткое содержание печати с историей`,
	sm: `Lolomi le aotelega ma le talafaasolopito`,
	so: `Soo koobid daabacaad oo leh taariikh`,
	th: `พิมพ์สรุปพร้อมประวัติ`,
	ur: `پرنٹ خلاصہ تاریخ کے ساتھ`,
	vi: `In tóm tắt với lịch sử`,
	'zh-hans': `印刷摘要及历史`,
	'zh-hant': `印刷摘要及歷史`,
	en: `Print summary with history`
};

export const loc_priorBalance: Record<Locale, string> = {
	ar: `التوازن السابق`,
	de: `Prior-Saldo`,
	es: `Saldo previo`,
	fa: `مانده قبلی`,
	fil: `Naunang balanse`,
	fr: `Solde antérieur`,
	hi: `पूर्व शेष`,
	ht: `Balans anvan`,
	it: `Saldo precedente`,
	ja: `事前残高`,
	ko: `선전 잔액`,
	mww: `Nyiaj tshuav ua ntej`,
	ps: `مخکینی توازن`,
	pt: `Saldo anterior`,
	'pt-pt': `Saldo anterior`,
	ru: `Предыдущий баланс`,
	sm: `Paleni muamua`,
	so: `Xisaabtii hore`,
	th: `ยอดคงเหลือก่อนหน้า`,
	ur: `سابقہ بیلنس`,
	vi: `Số dư trước`,
	'zh-hans': `先行余额`,
	'zh-hant': `先行餘額`,
	en: `Prior balance`
};

export const loc_privacy: Record<Locale, string> = {
	ar: `الخصوصية`,
	de: `Privatsphäre`,
	es: `Privacidad`,
	fa: `حریم خصوصی`,
	fil: `Pagkapribado`,
	fr: `Confidentialité`,
	hi: `गोपनीयता`,
	ht: `Konfidansyalite`,
	it: `Privacy`,
	ja: `プライバシー`,
	ko: `프라이버시`,
	mww: `Tsis pub twg paub`,
	ps: `محرمیت`,
	pt: `Privacidade`,
	'pt-pt': `Privacidade`,
	ru: `Конфиденциальность`,
	sm: `Le faalauaiteleina`,
	so: `Asturnaanta`,
	th: `ความเป็นส่วนตัว`,
	ur: `پرائیویسی`,
	vi: `Quyền riêng tư`,
	'zh-hans': `隐私`,
	'zh-hant': `隱私`,
	en: `Privacy`
};

export const loc_private: Record<Locale, string> = {
	ar: `جندي خاص`,
	de: `Gefreiter`,
	es: `Soldado`,
	fa: `خصوصی`,
	fil: `Pribado`,
	fr: `Privé`,
	hi: `मामूली सिपाही`,
	ht: `Prive`,
	it: `Privato`,
	ja: `私立`,
	ko: `사설`,
	mww: `Ntiag tug`,
	ps: `خصوصی`,
	pt: `Privado`,
	'pt-pt': `Privado`,
	ru: `Частная служба`,
	sm: `Tumaoti`,
	so: `Gaarka ah`,
	th: `ส่วนตัว`,
	ur: `پرائیویٹ`,
	vi: `Riêng tư`,
	'zh-hans': `私人`,
	'zh-hant': `私人`,
	en: `Private`
};

export const loc_processed: Record<Locale, string> = {
	ar: `تمت معالجته`,
	de: `Verarbeitet`,
	es: `Procesado`,
	fa: `پردازش شده`,
	fil: `Naproseso`,
	fr: `Traité`,
	hi: `संसाधित`,
	ht: `Trete`,
	it: `Processato`,
	ja: `処理`,
	ko: `가공`,
	mww: `Ua tiav`,
	ps: `پروسس شوی`,
	pt: `Processado`,
	'pt-pt': `Processado`,
	ru: `Обработка`,
	sm: `Fa'agasologa`,
	so: `La farsameeyay`,
	th: `ประมวลผลแล้ว`,
	ur: `پراسیس شدہ`,
	vi: `Đã xử lý`,
	'zh-hans': `加工`,
	'zh-hant': `加工`,
	en: `Processed`
};

export const loc_processing: Record<Locale, string> = {
	ar: `المعالجة`,
	de: `Verarbeitung`,
	es: `Procesamiento`,
	fa: `پردازش`,
	fil: `Pagproseso`,
	fr: `Traitement`,
	hi: `प्रसंस्करण`,
	ht: `Pwosesis`,
	it: `Lavorazione`,
	ja: `加工`,
	ko: `가공`,
	mww: `Kev Ua Haujlwm`,
	ps: `پروسس کول`,
	pt: `Processamento`,
	'pt-pt': `Processamento`,
	ru: `Обработка`,
	sm: `Fa'agasologa`,
	so: `Habaynta`,
	th: `การประมวลผล`,
	ur: `پروسیسنگ`,
	vi: `Chế biến`,
	'zh-hans': `加工`,
	'zh-hant': `加工`,
	en: `Processing`
};

export const loc_product: Record<Locale, string> = {
	ar: `المنتج`,
	de: `Produkt`,
	es: `Producto`,
	fa: `محصول`,
	fil: `Produkto`,
	fr: `Produit`,
	hi: `गुणनफल`,
	ht: `Pwodwi`,
	it: `Prodotto`,
	ja: `製品`,
	ko: `제품`,
	mww: `Cov khoom lag luam`,
	ps: `محصول`,
	pt: `Produto`,
	'pt-pt': `Produto`,
	ru: `Продукт`,
	sm: `Oloa`,
	so: `Alaabta`,
	th: `ผลิตภัณฑ์`,
	ur: `پروڈکٹ`,
	vi: `Sản phẩm`,
	'zh-hans': `产品`,
	'zh-hant': `產品`,
	en: `Product`
};

export const loc_productionSite: Record<Locale, string> = {
	ar: `موقع الإنتاج`,
	de: `Produktionsstätte`,
	es: `Lugar de producción`,
	fa: `محل تولید`,
	fil: `Email Address *`,
	fr: `Site de production`,
	hi: `उत्पादन स्थल`,
	ht: `Sit pwodiksyon an`,
	it: `Sito di produzione`,
	ja: `生産拠点`,
	ko: `생산 현장`,
	mww: `Qhov chaw tsim khoom`,
	ps: `د تولید ځای`,
	pt: `Local de produção`,
	'pt-pt': `Local de produção`,
	ru: `Площадка производства`,
	sm: `Nofoaga o gaosiga`,
	so: `Goobta wax-soo-saarka`,
	th: `สถานที่ผลิต`,
	ur: `پروڈکشن سائٹ`,
	vi: `Địa điểm sản xuất`,
	'zh-hans': `生产基地`,
	'zh-hant': `製作場地`,
	en: `Production site`
};

export const loc_profile: Record<Locale, string> = {
	ar: `الملف الشخصي`,
	de: `Profil`,
	es: `Perfil`,
	fa: `پروفایل`,
	fil: `Profile`,
	fr: `Profil`,
	hi: `ख़ाका`,
	ht: `Pwofil`,
	it: `Profilo`,
	ja: `プロフィール`,
	ko: `프로필`,
	mww: `Profile`,
	ps: `پروفایل`,
	pt: `Perfil`,
	'pt-pt': `Perfil`,
	ru: `Профиль`,
	sm: `Talaaga otooto`,
	so: `Xogta`,
	th: `ข้อมูลส่วนตัว`,
	ur: `پروفائل`,
	vi: `Tiểu sử`,
	'zh-hans': `简介`,
	'zh-hant': `簡介`,
	en: `Profile`
};

export const loc_profilePicture: Record<Locale, string> = {
	ar: `صورة الملف الشخصي`,
	de: `Profilbild`,
	es: `Foto de perfil`,
	fa: `عکس پروفایل`,
	fil: `Email Address *`,
	fr: `Photo de profil`,
	hi: `प्रोफ़ाइल चित्र`,
	ht: `Foto pwofil`,
	it: `Foto profilo`,
	ja: `プロフィール写真`,
	ko: `프로필 사진`,
	mww: `Daim duab profile`,
	ps: `د پروفایل عکس`,
	pt: `Foto de perfil`,
	'pt-pt': `Foto de perfil`,
	ru: `Профильная фотография`,
	sm: `Ata o le talaaga otooto`,
	so: `Sawirka profile`,
	th: `รูปโปรไฟล์`,
	ur: `پروفائل تصویر`,
	vi: `Ảnh hồ sơ`,
	'zh-hans': `头像`,
	'zh-hant': `個人頭像`,
	en: `Profile picture`
};

export const loc_profileVisibilityDescription: Record<Locale, string> = {
	ar: `اسمك، سيرتك الذاتية، وصورتك مرئية للجمهور على Cumulus. عنوان بريدك الإلكتروني، أرقام هواتفك، وحالة خارجك من المكتب مرئية فقط لأعضاء Cumulus الذين تتعاون معهم.`,
	de: `Dein Name, deine Bio und dein Bild sind auf Cumulus öffentlich sichtbar. Ihre E-Mail-Adresse, Ihre Telefonnummern und Ihr Abwesenheitsstatus sind nur für Cumulus-Mitglieder sichtbar, mit denen Sie zusammenarbeiten.`,
	es: `Tu nombre, biografía y foto son visibles públicamente en Cumulus. Tu dirección de correo electrónico, números de teléfono y estado de ausencia solo son visibles para los miembros de Cumulus con los que colabores.`,
	fa: `نام، بیوگرافی و عکس شما به صورت عمومی در Cumulus قابل مشاهده است. آدرس ایمیل، شماره تلفن و وضعیت خارج از دفتر شما فقط برای اعضای Cumulus که با آن ها همکاری می کنید قابل مشاهده است.`,
	fil: `Ang iyong pangalan, bio, at larawan ay makikita sa publiko sa Cumulus. Ang iyong email address, numero ng telepono, at katayuan sa labas ng opisina ay makikita lamang ng mga miyembro ng Cumulus na nakikipagtulungan ka.`,
	fr: `Votre nom, votre biographie et votre photo sont visibles publiquement sur Cumulus. Votre adresse e-mail, vos numéros de téléphone et votre statut d’absence ne sont visibles que pour les membres Cumulus avec lesquels vous collaborez.`,
	hi: `आपका नाम, बायो और तस्वीर क्यूम्यलस पर सार्वजनिक रूप से दिखाई दे रही है। आपका ईमेल पता, फ़ोन नंबर और कार्यालय से बाहर की स्थिति केवल उन क्यूम्यलस सदस्यों को दिखाई देती है जिनके साथ आप सहयोग कर रहे हैं।`,
	ht: `Non ou, bio ak foto yo piblikman vizib sou Cumulus. Adrès imel ou, nimewo telefòn ou, ak estati ou-of-biwo yo sèlman vizib pou manm Cumulus ou ap kolabore avèk yo.`,
	it: `Il tuo nome, la tua biografia e la tua foto sono visibili pubblicamente su Cumulus. Il tuo indirizzo email, numeri di telefono e stato di assenza sono visibili solo ai membri Cumulus con cui collabori.`,
	ja: `あなたの名前、プロフィール、写真はCumulusで公開されています。メールアドレス、電話番号、不在状況は、協力しているCumulusメンバーのみに公開されます。`,
	ko: `당신의 이름, 약력, 사진은 Cumulus에 공개되어 있습니다. 이메일 주소, 전화번호, 부재 여부는 협업 중인 Cumulus 회원에게만 볼 수 있습니다.`,
	mww: `Koj lub npe, bio thiab daim duab yog pej xeem pom ntawm Cumulus. Koj tus email chaw nyob, xov tooj, thiab cov xwm txheej tawm ntawm chaw ua haujlwm tsuas yog pom rau Cumulus cov tswv cuab uas koj koom tes nrog.`,
	ps: `ستاسو نوم، ژوندلیک، او عکس په کومیولس کې عام محضر کې ښکاره دی. ستاسو د ایمیل پته، د تلیفون شمیرې، او د دفتر څخه بهر حالت یوازې د Cumulus هغو غړو ته ښکاره کیږی چې تاسو ورسره همکاری کوئ.`,
	pt: `Seu nome, biografia e foto estão publicamente visíveis no Cumulus. Seu endereço de e-mail, números de telefone e status de ausência são visíveis apenas para os membros da Cumulus com quem você está colaborando.`,
	'pt-pt': `O teu nome, biografia e fotografia são visíveis publicamente na Cumulus. O seu endereço de email, números de telefone e estado de ausência só são visíveis para os membros da Cumulus com quem colabora.`,
	ru: `Ваше имя, биография и фотография публично видны на Cumulus. Ваш адрес электронной почты, номера телефонов и статус вне офиса видны только участникам Cumulus, с которыми вы сотрудничаете.`,
	sm: `O lou igoa, bio, ma le ata o lo'o fa'aalia lautele i luga o Cumulus. O lau tuatusi imeli, numera telefoni, ma le tulaga i fafo atu o le ofisa e na'o tagata o le Cumulus o lo'o e galulue fa'atasi e va'aia.`,
	so: `Magacaaga, taariikhdaada, iyo sawirkaaga si guud ayaa looga arki karaa Cumulus. Cinwaankaaga email-ka, lambarrada telefoonka, iyo xaaladda xafiiska ka baxsan waa la arki karaa oo kaliya xubnaha Cumulus ee aad la shaqeyneyso.`,
	th: `ชื่อ ประวัติ และรูปภาพของคุณปรากฏต่อสาธารณะบน Cumulus ที่อยู่อีเมล หมายเลขโทรศัพท์ และสถานะไม่อยู่ที่สํานักงานของคุณจะปรากฏต่อสมาชิก Cumulus ที่คุณกําลังทํางานร่วมกันเท่านั้น`,
	ur: `آپ کا نام، سوانح عمری، اور تصویر Cumulus پر عوامی طور پر نظر آتی ہے۔ آپ کا ای میل ایڈریس، فون نمبرز، اور دفتر سے باہر ہونے کی حالت صرف ان کیومیولس ممبران کو نظر آتی ہے جن کے ساتھ آپ تعاون کر رہے ہیں۔`,
	vi: `Tên, tiểu sử và hình ảnh của bạn được hiển thị công khai trên Cumulus. Địa chỉ email, số điện thoại và trạng thái vắng mặt của bạn chỉ hiển thị với các thành viên Cumulus mà bạn đang cộng tác.`,
	'zh-hans': `你的姓名、简介和照片都已在Cumulus上公开可见。您的电子邮件地址、电话号码和休假状态仅对您合作的 Cumulus 成员可见。`,
	'zh-hant': `你的姓名、簡介和照片會在 Cumulus 上公開顯示。您的電子郵件地址、電話號碼及休假狀態僅對您合作的 Cumulus 會員可見。`,
	en: `Your name, bio, and picture are publicly visible on Cumulus. Your email address, phone numbers, and out-of-office status are only visible to Cumulus members you are collaborating with.`
};

export const loc_project: Record<Locale, string> = {
	ar: `المشروع`,
	de: `Projekt`,
	es: `Proyecto`,
	fa: `پروژه`,
	fil: `Proyekto`,
	fr: `Projet`,
	hi: `परियोजना`,
	ht: `Pwojè`,
	it: `Progetto`,
	ja: `プロジェクト`,
	ko: `프로젝트`,
	mww: `Qhov project`,
	ps: `پروژه`,
	pt: `Projeto`,
	'pt-pt': `Projeto`,
	ru: `Проект`,
	sm: `Galuega faatino`,
	so: `Mashruuc`,
	th: `โครงการ`,
	ur: `پروجیکٹ`,
	vi: `Dự án`,
	'zh-hans': `项目`,
	'zh-hant': `計畫`,
	en: `Project`
};

export const loc_projectOrganization: Record<Locale, string> = {
	ar: `تنظيم المشروع`,
	de: `Projektorganisation`,
	es: `Organización del proyecto`,
	fa: `سازماندهی پروژه`,
	fil: `Organisasyon ng proyekto`,
	fr: `Organisation du projet`,
	hi: `परियोजना संगठन`,
	ht: `Òganizasyon pwojè a`,
	it: `Organizzazione del progetto`,
	ja: `プロジェクト編成`,
	ko: `프로젝트 조직`,
	mww: `Lub koom haum Project`,
	ps: `د پروژې تنظیم`,
	pt: `Organização do projeto`,
	'pt-pt': `Organização do projeto`,
	ru: `Организация проекта`,
	sm: `Fa'alapotopotoga o poloketi`,
	so: `Qaab-dhismeedka mashruuca`,
	th: `องค์กรโครงการ`,
	ur: `منصوبے کی تنظیم`,
	vi: `Tổ chức dự án`,
	'zh-hans': `项目组织`,
	'zh-hant': `專案組織`,
	en: `Project organization`
};

export const loc_projectOrganizationReportDescription: Record<Locale, string> = {
	ar: `المنظمات التي تتعاون في المشاريع التي تشارك فيها.`,
	de: `Organisationen, die an Projekten zusammenarbeiten, an denen Sie teilnehmen.`,
	es: `Organizaciones que colaboran en proyectos en los que participas.`,
	fa: `سازمان هایی که روی پروژه هایی که شما در آن ها شرکت می کنید همکاری می کنند.`,
	fil: `Mga organisasyong nakikipagtulungan sa mga proyektong iyong kinabibilangan.`,
	fr: `Des organisations qui collaborent sur des projets auxquels vous participez.`,
	hi: `जिन संगठनों में आप भाग ले रहे हैं, उन पर सहयोग कर रहे हैं।`,
	ht: `Òganizasyon k ap kolabore sou pwojè w ap patisipe nan.`,
	it: `Organizzazioni che collaborano su progetti a cui partecipi.`,
	ja: `あなたが参加しているプロジェクトで協力している組織。`,
	ko: `여러분이 참여하는 프로젝트에 협력하는 조직들.`,
	mww: `Cov koom haum koom tes ntawm cov haujlwm uas koj tab tom koom nrog.`,
	ps: `هغه سازمانونه چې په هغو پروژو کې همکاری کوی چې ته پکې برخه اخلی.`,
	pt: `Organizações colaborando em projetos dos quais você está participando.`,
	'pt-pt': `Organizações que colaboram em projetos em que está a participar.`,
	ru: `Организации, которые сотрудничают над проектами, в которых вы участвуете.`,
	sm: `Fa'alapotopotoga o lo'o galulue fa'atasi i poloketi o lo'o e auai.`,
	so: `Ururada iska kaashanaya mashaariicda aad ka qayb qaadanayso.`,
	th: `องค์กรที่ทํางานร่วมกันในโครงการที่คุณเข้าร่วม`,
	ur: `وہ تنظیمیں جو آپ کے ان منصوبوں پر تعاون کر رہی ہیں جن میں آپ حصہ لے رہے ہیں۔`,
	vi: `Các tổ chức cộng tác trong các dự án mà bạn đang tham gia.`,
	'zh-hans': `组织与你参与的项目合作。`,
	'zh-hant': `組織與你合作參與的專案。`,
	en: `Organizations collaborating on projects you are participating in.`
};

export const loc_projectOrganizations: Record<Locale, string> = {
	ar: `منظمات المشروع`,
	de: `Projektorganisationen`,
	es: `Organizaciones del proyecto`,
	fa: `سازمان های پروژه`,
	fil: `Mga organisasyon ng proyekto`,
	fr: `Organisations de projet`,
	hi: `परियोजना संगठन`,
	ht: `Òganizasyon pwojè yo`,
	it: `Organizzazioni di progetto`,
	ja: `プロジェクト組織`,
	ko: `프로젝트 조직`,
	mww: `Cov koom haum Project`,
	ps: `د پروژې سازمانونه`,
	pt: `Organizações do projeto`,
	'pt-pt': `Organizações de projeto`,
	ru: `Организации проектов`,
	sm: `Fa'alapotopotoga o Poloketi`,
	so: `Ururada mashruuca`,
	th: `องค์กรโครงการ`,
	ur: `پروجیکٹ تنظیمیں`,
	vi: `Tổ chức dự án`,
	'zh-hans': `项目组织`,
	'zh-hant': `專案組織`,
	en: `Project organizations`
};

export const loc_projects: Record<Locale, string> = {
	ar: `المشاريع`,
	de: `Projekte`,
	es: `Proyectos`,
	fa: `پروژه ها`,
	fil: `Mga proyekto`,
	fr: `Projets`,
	hi: `परियोजनाओं`,
	ht: `Pwojè yo`,
	it: `Progetti`,
	ja: `プロジェクト`,
	ko: `프로젝트`,
	mww: `Tej yaam num`,
	ps: `پروژې`,
	pt: `Projetos`,
	'pt-pt': `Projetos`,
	ru: `Проекты`,
	sm: `Galuega faatino`,
	so: `Mashaariicda`,
	th: `โครงการ`,
	ur: `منصوبے`,
	vi: `Dự án`,
	'zh-hans': `项目`,
	'zh-hant': `專案`,
	en: `Projects`
};

export const loc_projectSettings: Record<Locale, string> = {
	ar: `إعدادات المشروع`,
	de: `Projektsettings`,
	es: `Configuración del proyecto`,
	fa: `تنظیمات پروژه`,
	fil: `Mga setting ng proyekto`,
	fr: `Paramètres du projet`,
	hi: `प्रोजेक्ट सेटिंग्स`,
	ht: `Anviwònman pwojè`,
	it: `Ambientazioni del progetto`,
	ja: `プロジェクト設定`,
	ko: `프로젝트 설정`,
	mww: `Cov phiaj xwm teeb tsa`,
	ps: `د پروژې تنظیمات`,
	pt: `Configurações do projeto`,
	'pt-pt': `Cenários do projeto`,
	ru: `Настройки проекта`,
	sm: `Tulaga o galuega faatino`,
	so: `Dejinta mashruuca`,
	th: `การตั้งค่าโครงการ`,
	ur: `پروجیکٹ سیٹنگز`,
	vi: `Cài đặt dự án`,
	'zh-hans': `项目设置`,
	'zh-hant': `專案設定`,
	en: `Project settings`
};

export const loc_providedByOrgViaProgram: Record<Locale, (org: unknown, project: unknown) => TemplateResult> = {
	ar: (org, project) => html`<span>مقدم من ${org} من خلال مشروع ${project} .</span>`,
	de: (org, project) => html`<span>Bereitgestellt von ${org} im Rahmen des ${project} Projekts.</span>`,
	es: (org, project) => html`<span>Proporcionado por ${org} a través del proyecto ${project} .</span>`,
	fa: (org, project) => html`<span>ارائه شده توسط ${org} از طریق ${project} .</span>`,
	fil: (org, project) => html`<span>Ibinigay ng ${org} sa pamamagitan ng proyekto ng ${project} .</span>`,
	fr: (org, project) => html`<span>Fourni par ${org} via le projet ${project} Project.</span>`,
	hi: (org, project) => html`<span>${project} परियोजना के माध्यम से ${org} द्वारा प्रदान किया गया।</span>`,
	ht: (org, project) => html`<span>Founi ${org} atravè pwojè ${project} a.</span>`,
	it: (org, project) => html`<span>Fornito da ${org} attraverso il progetto ${project} .</span>`,
	ja: (org, project) => html`<span>リ ${org} が ${project} を通じて提供しています。</span>`,
	ko: (org, project) => html`<span>리 ${org} 드는 ${project} 프로젝트를 통해 제공했습니다.</span>`,
	mww: (org, project) => html`<span>Muab los ntawm ${org} los ntawm ${project} project.</span>`,
	ps: (org, project) => html`<span>د ${org} لخوا د ${project} پروژې له لارې برابر شوی.</span>`,
	pt: (org, project) => html`<span>Fornecido pelo ${org} através do projeto ${project} Project.</span>`,
	'pt-pt': (org, project) => html`<span>Fornecido pela ${org} através do projeto ${project} .</span>`,
	ru: (org, project) => html`<span>Предоставлено ${org} через проект ${project} .</span>`,
	sm: (org, project) => html`<span>Saunia e ${org} e ala i le poloketi o le ${project} .</span>`,
	so: (org, project) => html`<span>Waxaa bixiyay ${org} iyada oo loo marayo mashruuca ${project} .</span>`,
	th: (org, project) => html`<span>จัดทําโดย ${org} ผ่านโครงการ${project}</span>`,
	ur: (org, project) => html`<span>${org} کی جانب سے ${project} پروجیکٹ کے ذریعے فراہم کیا گیا۔</span>`,
	vi: (org, project) => html`<span>Được cung cấp bởi ${org} thông qua dự ${project} .</span>`,
	'zh-hans': (org, project) => html`<span>由 ${org} 通过 ${project} 提供。</span>`,
	'zh-hant': (org, project) => html`<span>由 ${org} 透過 ${project} 提供。</span>`,
	en: (org, project) => html`<span>Provided by ${org} through the ${project} project.</span>`
};

export const loc_public: Record<Locale, string> = {
	ar: `العام`,
	de: `Öffentlich`,
	es: `Público`,
	fa: `عموم`,
	fil: `Publiko`,
	fr: `Public`,
	hi: `सार्वजनिक`,
	ht: `Piblik`,
	it: `Pubblico`,
	ja: `公共`,
	ko: `공공`,
	mww: `Pej xeem`,
	ps: `عامه`,
	pt: `Público`,
	'pt-pt': `Público`,
	ru: `Общественность`,
	sm: `Tagata lautele`,
	so: `Dadweynaha`,
	th: `สาธารณะ`,
	ur: `عوامی`,
	vi: `Công cộng`,
	'zh-hans': `公共`,
	'zh-hant': `公共`,
	en: `Public`
};

export const loc_publicAccessToThisQuestionnaire: Record<Locale, string> = {
	ar: `الوصول العام إلى هذا الاستبيان`,
	de: `Öffentlicher Zugang zu diesem Fragebogen`,
	es: `Acceso público a este cuestionario`,
	fa: `دسترسی عمومی به این پرسشنامه`,
	fil: `Pag-access ng publiko sa palatanungan na ito`,
	fr: `Accès public à ce questionnaire`,
	hi: `इस प्रश्नावली तक सार्वजनिक पहुंच`,
	ht: `Aksè piblik la a kesyonè sa a`,
	it: `Accesso pubblico a questo questionario`,
	ja: `このアンケートへの一般公開アクセス`,
	ko: `이 설문지에 대한 대중 접근`,
	mww: `Pej xeem nkag mus rau cov lus nug no`,
	ps: `د دې پوښتنلیک ته عامه لاسرسی`,
	pt: `Acesso público a este questionário`,
	'pt-pt': `Acesso público a este questionário`,
	ru: `Общественный доступ к этому опроснику`,
	sm: `Avanoa lautele i lenei fesili`,
	so: `Helitaanka dadweynaha ee su'aalahan`,
	th: `การเข้าถึงแบบสอบถามนี้โดยสาธารณะ`,
	ur: `اس سوالنامے تک عوامی رسائی`,
	vi: `Truy cập công khai vào bảng câu hỏi này`,
	'zh-hans': `公众可访问此问卷`,
	'zh-hant': `公眾可取得此問卷`,
	en: `Public access to this questionnaire`
};

export const loc_publicActivityAlreadyEnded: Record<Locale, string> = {
	ar: `لم تعد المشاركات مقبولة.`,
	de: `Einsendungen werden nicht mehr angenommen.`,
	es: `Ya no se aceptan propuestas.`,
	fa: `ارسال ها دیگر پذیرفته نمی شوند.`,
	fil: `Hindi na tinatanggap ang mga pagsusumite.`,
	fr: `Les soumissions ne sont plus acceptées.`,
	hi: `प्रस्तुतियाँ अब स्वीकार नहीं की जा रही हैं।`,
	ht: `Soumèt yo pa aksepte ankò.`,
	it: `Le proposte non vengono più accettate.`,
	ja: `投稿はもう受け付けていません。`,
	ko: `더 이상 제출이 접수되지 않습니다.`,
	mww: `Kev xa tawm tsis raug lees txais lawm.`,
	ps: `سپارښتنې نور نه منل کېږی.`,
	pt: `As inscrições não estão mais sendo aceitas.`,
	'pt-pt': `As submissões já não estão a ser aceites.`,
	ru: `Публикации больше не принимаются.`,
	sm: `E le o toe taliaina talosaga.`,
	so: `Soo gudbinta hadda lama aqbalo.`,
	th: `การส่งไม่ได้รับการยอมรับอีกต่อไป`,
	ur: `جمع کرائی گئی درخواستیں اب قبول نہیں کی جا رہیں۔`,
	vi: `Bài dự thi không còn được chấp nhận.`,
	'zh-hans': `投稿不再接受。`,
	'zh-hant': `投稿已不再接受。`,
	en: `Submissions are no longer being accepted.`
};

export const loc_publicActivityAlreadyEndedFormat: Record<Locale, (parentType: unknown, endDate: unknown) => string> = {
	ar: (parentType, endDate) => `لم تعد المشاركات مقبولة. انتهت المشاركات لهذا ${parentType} في ${endDate}.`,
	de: (parentType, endDate) => `Einsendungen werden nicht mehr angenommen. Die Einreichungen für diese ${parentType} endeten am ${endDate}.`,
	es: (parentType, endDate) => `Ya no se aceptan propuestas. Las inscripciones para este ${parentType} finalizaron el ${endDate}.`,
	fa: (parentType, endDate) => `ارسال ها دیگر پذیرفته نمی شوند. ارسال آثار برای این ${parentType} در ${endDate} به پایان رسید.`,
	fil: (parentType, endDate) => `Hindi na tinatanggap ang mga pagsusumite. Natapos ang mga pagsusumite para sa ${parentType} ito noong ${endDate}.`,
	fr: (parentType, endDate) => `Les soumissions ne sont plus acceptées. Les soumissions pour cet ${parentType} se sont terminées le ${endDate}.`,
	hi: (parentType, endDate) => `प्रस्तुतियाँ अब स्वीकार नहीं की जा रही हैं। इस ${parentType} के लिए प्रस्तुतियाँ ${endDate} को समाप्त हो गईं।`,
	ht: (parentType, endDate) => `Soumèt yo pa aksepte ankò. Soumèt yo te fini pou ${parentType} sa a ${endDate}`,
	it: (parentType, endDate) => `Le proposte non vengono più accettate. Le iscrizioni per questo ${parentType} si sono concluse il ${endDate}.`,
	ja: (parentType, endDate) => `投稿はもう受け付けていません。この ${parentType} の応募は ${endDate}日に締め切られました。`,
	ko: (parentType, endDate) => `더 이상 제출이 접수되지 않습니다. 이 ${parentType} 의 제출 마감 ${endDate}일입니다.`,
	mww: (parentType, endDate) => `Kev xa tawm tsis raug lees txais lawm. Kev xa tawm xaus rau qhov ${parentType} no thaum ${endDate}.`,
	ps: (parentType, endDate) => `سپارښتنې نور نه منل کېږی. د دې ${parentType} لپاره سپارښتنې د ${endDate} پای ته ورسېدې.`,
	pt: (parentType, endDate) => `As inscrições não estão mais sendo aceitas. As inscrições para este ${parentType} terminaram em ${endDate}.`,
	'pt-pt': (parentType, endDate) => `As submissões já não estão a ser aceites. As submissões para este ${parentType} terminaram a ${endDate}.`,
	ru: (parentType, endDate) => `Публикации больше не принимаются. Приём заявок на ${parentType} ${endDate}.`,
	sm: (parentType, endDate) => `E le o toe taliaina talosaga. O le aso ${endDate} na fa'amutaina ai le talosaga mo lenei ${parentType}.`,
	so: (parentType, endDate) => `Soo gudbinta hadda lama aqbalo. Soo gudbinta tartankan waxay ${parentType} ${endDate}.`,
	th: (parentType, endDate) => `การส่งไม่ได้รับการยอมรับอีกต่อไป การส่งผลงานสิ้นสุดลงสําหรับ${parentType}นี้ในวันที่ ${endDate}`,
	ur: (parentType, endDate) => `جمع کرائی گئی درخواستیں اب قبول نہیں کی جا رہیں۔ اس ${parentType} کے لیے سبمیشنز ${endDate}`,
	vi: (parentType, endDate) => `Bài dự thi không còn được chấp nhận. Việc gửi kết thúc cho ${parentType} này vào ${endDate}.`,
	'zh-hans': (parentType, endDate) => `投稿不再接受。本次 ${parentType} 的投稿截止日期为 ${endDate}日。`,
	'zh-hant': (parentType, endDate) => `投稿已不再接受。本次 ${parentType} 的投稿截止日期為 ${endDate}日。`,
	en: (parentType, endDate) => `Submissions are no longer being accepted. Submissions ended for this ${parentType} on ${endDate}.`
};

export const loc_publicActivityCancelled: Record<Locale, (parentType: unknown) => string> = {
	ar: (parentType) => `تم إلغاء هذا ${parentType} . لا يتم قبول المشاركات في الوقت الحالي.`,
	de: (parentType) => `Diese ${parentType} wurde abgesagt. Einsendungen werden derzeit nicht entgegengenommen.`,
	es: (parentType) => `Este ${parentType} fue cancelado. No se aceptan propuestas en este momento.`,
	fa: (parentType) => `این ${parentType} لغو شد. در حال حاضر ارسال ها پذیرفته نمی شوند.`,
	fil: (parentType) => `Kinansela ang ${parentType} na ito. Ang mga pagsusumite ay hindi tinatanggap sa oras na ito.`,
	fr: (parentType) => `Cet ${parentType} a été annulé. Les soumissions ne sont pas acceptées pour le moment.`,
	hi: (parentType) => `इस ${parentType} को रद्द कर दिया गया था। इस समय प्रस्तुतियाँ स्वीकार नहीं की जा रही हैं।`,
	ht: (parentType) => `${parentType} sa a te anile Soumèt yo pa aksepte nan moman sa a.`,
	it: (parentType) => `Questo ${parentType} è stato cancellato. Al momento non vengono accettate candidature.`,
	ja: (parentType) => `この ${parentType} は中止されました。現時点では投稿を受け付けていません。`,
	ko: (parentType) => `이 ${parentType} 는 취소되었습니다. 현재 제출 접수되지 않고 있습니다.`,
	mww: (parentType) => `Qhov ${parentType} no tau muab tso tseg. Cov ntawv xa tawm tsis raug lees txais lub sijhawm no.`,
	ps: (parentType) => `دا ${parentType} لغوه شوه. دا مهال سپارښتنې نه منل کېږی.`,
	pt: (parentType) => `Esse ${parentType} foi cancelado. As submissões não estão sendo aceitas no momento.`,
	'pt-pt': (parentType) => `Este ${parentType} foi cancelado. As submissões não estão a ser aceites neste momento.`,
	ru: (parentType) => `${parentType} было отменено. В настоящее время заявки не принимаются.`,
	sm: (parentType) => `O lenei ${parentType} na faaleaogaina. E le o taliaina talosaga i le taimi nei.`,
	so: (parentType) => `${parentType} waa la joojiyay. Soo gudbinta lama aqbalayo waqtigan.`,
	th: (parentType) => `${parentType}นี้ถูกยกเลิก การส่งยังไม่ได้รับการยอมรับในขณะนี้`,
	ur: (parentType) => `یہ ${parentType} منسوخ کر دیا گیا۔ اس وقت جمع کرائی گئی درخواستیں قبول نہیں کی جا رہیں۔`,
	vi: (parentType) => `${parentType} này đã bị hủy bỏ. Bài dự thi không được chấp nhận tại thời điểm này.`,
	'zh-hans': (parentType) => `该 ${parentType} 被取消。目前不接受投稿。`,
	'zh-hant': (parentType) => `該 ${parentType} 被取消。目前不接受投稿。`,
	en: (parentType) => `This ${parentType} was cancelled. Submissions are not being accepted at this time.`
};

export const loc_publicActivityNotStarted: Record<Locale, string> = {
	ar: `التقديم لم يفتح بعد.`,
	de: `Die Einreichungen sind noch nicht geöffnet.`,
	es: `Las inscripciones aún no están abiertas.`,
	fa: `ارسال آثار هنوز باز نشده است.`,
	fil: `Hindi pa bukas ang mga pagsusumite.`,
	fr: `Les soumissions ne sont pas encore ouvertes.`,
	hi: `सबमिशन अभी तक खुले नहीं हैं।`,
	ht: `Soumèt yo pa louvri ankò.`,
	it: `Le candidature non sono ancora aperte.`,
	ja: `応募はまだ受付していません。`,
	ko: `아직 제출이 시작되지 않았습니다.`,
	mww: `Kev xa tawm tseem tsis tau qhib.`,
	ps: `سپارښتنې لا نه دی پرانیستې.`,
	pt: `As inscrições ainda não estão abertas.`,
	'pt-pt': `As submissões ainda não estão abertas.`,
	ru: `Приём заявок ещё не открыт.`,
	sm: `E le'i tatala talosaga i le taimi nei.`,
	so: `Soo gudbinta weli ma furan.`,
	th: `ยังไม่เปิดการส่งผลงาน`,
	ur: `جمع کرانے کی درخواستیں ابھی تک کھلی نہیں ہیں۔`,
	vi: `Bài dự thi vẫn chưa mở.`,
	'zh-hans': `投稿尚未开放。`,
	'zh-hant': `投稿尚未開放。`,
	en: `Submissions are not open yet.`
};

export const loc_publicActivityNotStartedFormat: Record<Locale, (parentType: unknown, startDate: unknown) => string> = {
	ar: (parentType, startDate) => `التقديم لم يفتح بعد. يمكنك التقديم لهذا ${parentType} بدءا من ${startDate}.`,
	de: (parentType, startDate) => `Die Einreichungen sind noch nicht geöffnet. Sie können sich für diese ${parentType} ab ${startDate} bewerben.`,
	es: (parentType, startDate) => `Las inscripciones aún no están abiertas. Puedes postularte para este ${parentType} a partir del ${startDate}.`,
	fa: (parentType, startDate) => `ارسال آثار هنوز باز نشده است. شما می توانید از ${startDate} برای این ${parentType} ثبت نام کنید.`,
	fil: (parentType, startDate) => `Hindi pa bukas ang mga pagsusumite. Maaari kang magsumite para sa ${parentType} ito simula sa ${startDate}.`,
	fr: (parentType, startDate) => `Les soumissions ne sont pas encore ouvertes. Vous pouvez postuler pour cet ${parentType} à partir du ${startDate}.`,
	hi: (parentType, startDate) => `सबमिशन अभी तक खुले नहीं हैं। आप ${startDate} से शुरू होने वाले इस ${parentType} के लिए सबमिट कर सकते हैं।`,
	ht: (parentType, startDate) => `Soumèt yo pa louvri ankò. Ou ka soumèt pou ${parentType} sa a apati ${startDate}`,
	it: (parentType, startDate) => `Le candidature non sono ancora aperte. Puoi candidarti a questo ${parentType} a partire dal ${startDate}.`,
	ja: (parentType, startDate) => `応募はまだ受付していません。この ${parentType} への応募は ${startDate}日から始まります。`,
	ko: (parentType, startDate) => `아직 제출이 시작되지 않았습니다. ${startDate}일부터 이 ${parentType}에 지원하실 수 있습니다.`,
	mww: (parentType, startDate) => `Kev xa tawm tseem tsis tau qhib. Koj tuaj yeem xa rau qhov ${parentType} no pib thaum ${startDate}.`,
	ps: (parentType, startDate) => `سپارښتنې لا نه دی پرانیستې. تاسو کولی شئ د دې ${parentType} لپاره د ${startDate} څخه پیل وکړئ.`,
	pt: (parentType, startDate) => `As inscrições ainda não estão abertas. Você pode se inscrever para este ${parentType} a partir de ${startDate}.`,
	'pt-pt': (parentType, startDate) => `As submissões ainda não estão abertas. Pode submeter-se para este ${parentType} a partir de ${startDate}.`,
	ru: (parentType, startDate) => `Приём заявок ещё не открыт. Вы можете подать заявку на это ${parentType} , начиная ${startDate}.`,
	sm: (parentType, startDate) => `E le'i tatala talosaga i le taimi nei. E mafai ona e tu'uina atu lenei ${parentType} e amata ia ${startDate}.`,
	so: (parentType, startDate) => `Soo gudbinta weli ma furan. Waxaad u gudbin kartaa ${parentType} laga bilaabo ${startDate}.`,
	th: (parentType, startDate) => `ยังไม่เปิดการส่งผลงาน คุณสามารถส่งเข้าร่วม${parentType}นี้ได้ตั้งแต่วันที่ ${startDate}`,
	ur: (parentType, startDate) => `جمع کرانے کی درخواستیں ابھی تک کھلی نہیں ہیں۔ آپ اس ${parentType} کے لیے ${startDate} سے درخواست جمع کرا سکتے ہیں۔`,
	vi: (parentType, startDate) => `Bài dự thi vẫn chưa mở. Bạn có thể gửi cho ${parentType} này bắt đầu từ ${startDate}.`,
	'zh-hans': (parentType, startDate) => `投稿尚未开放。您可以从${startDate}日开始报名参加本次${parentType}。`,
	'zh-hant': (parentType, startDate) => `投稿尚未開放。您可以從${startDate}日開始報名參加此${parentType}。`,
	en: (parentType, startDate) => `Submissions are not open yet. You can submit for this ${parentType} starting on ${startDate}.`
};

export const loc_publicActivityOnHold: Record<Locale, (parentType: unknown) => string> = {
	ar: (parentType) => `هذا ${parentType} معلق. لا يتم قبول المشاركات في الوقت الحالي.`,
	de: (parentType) => `Diese ${parentType} ist ausgesetzt. Einsendungen werden derzeit nicht entgegengenommen.`,
	es: (parentType) => `Este ${parentType} está en pausa. No se aceptan propuestas en este momento.`,
	fa: (parentType) => `این ${parentType} متوقف شده است. در حال حاضر ارسال ها پذیرفته نمی شوند.`,
	fil: (parentType) => `Ang ${parentType} ay naka-hold. Ang mga pagsusumite ay hindi tinatanggap sa oras na ito.`,
	fr: (parentType) => `Cet ${parentType} est en pause. Les soumissions ne sont pas acceptées pour le moment.`,
	hi: (parentType) => `यह ${parentType} ऑन-होल्ड है। इस समय प्रस्तुतियाँ स्वीकार नहीं की जा रही हैं।`,
	ht: (parentType) => `${parentType} sa a se sou-kenbe Soumèt yo pa aksepte nan moman sa a.`,
	it: (parentType) => `Questo ${parentType} è in sospeso. Al momento non vengono accettate candidature.`,
	ja: (parentType) => `この ${parentType} は保留中です。現時点では投稿を受け付けていません。`,
	ko: (parentType) => `이 ${parentType} 는 보류 중입니다. 현재 제출 접수되지 않고 있습니다.`,
	mww: (parentType) => `Qhov ${parentType} no yog tuav. Cov ntawv xa tawm tsis raug lees txais lub sijhawm no.`,
	ps: (parentType) => `دا ${parentType} ځنډول شوې ده. دا مهال سپارښتنې نه منل کېږی.`,
	pt: (parentType) => `Este ${parentType} está em espera. As submissões não estão sendo aceitas no momento.`,
	'pt-pt': (parentType) => `Este ${parentType} está suspenso. As submissões não estão a ser aceites neste momento.`,
	ru: (parentType) => `${parentType} приостановлено. В настоящее время заявки не принимаются.`,
	sm: (parentType) => `O lenei ${parentType} o lo'o taofiofia. E le o taliaina talosaga i le taimi nei.`,
	so: (parentType) => `${parentType} waa la hakiyay. Soo gudbinta lama aqbalayo waqtigan.`,
	th: (parentType) => `${parentType}นี้ถูกระงับ การส่งยังไม่ได้รับการยอมรับในขณะนี้`,
	ur: (parentType) => `یہ ${parentType} معطل ہے۔ اس وقت جمع کرائی گئی درخواستیں قبول نہیں کی جا رہیں۔`,
	vi: (parentType) => `${parentType} này đang bị tạm dừng. Bài dự thi không được chấp nhận tại thời điểm này.`,
	'zh-hans': (parentType) => `本次 ${parentType} 暂停。目前不接受投稿。`,
	'zh-hant': (parentType) => `此 ${parentType} 暫停。目前不接受投稿。`,
	en: (parentType) => `This ${parentType} is on-hold. Submissions are not being accepted at this time.`
};

export const loc_publicActivityRedirectedFrom: Record<Locale, (activityHref: unknown, title: unknown, endDate: unknown) => TemplateResult> = {
	ar: (activityHref, title, endDate) => html`تم التحويل من <a href="${activityHref}">${title}</a> التي انتهت في ${endDate}.`,
	de: (activityHref, title, endDate) => html`Weitergeleitet von <a href="${activityHref}">${title}</a> , die am ${endDate} endete.`,
	es: (activityHref, title, endDate) => html`Redirigido desde <a href="${activityHref}">${title}</a> , que terminó el ${endDate}.`,
	fa: (activityHref, title, endDate) => html`از <a href="${activityHref}">${title}</a> که در ${endDate} پایان یافت، هدایت شده است.`,
	fil: (activityHref, title, endDate) => html`Idinirekta mula sa <a href="${activityHref}">${title}</a> na natapos noong ${endDate}`,
	fr: (activityHref, title, endDate) => html`Redirigé depuis <a href="${activityHref}">${title}</a> , qui s’est terminée le ${endDate}.`,
	hi: (activityHref, title, endDate) => html`<a href="${activityHref}">${title}</a> से अनुप्रेषित जो ${endDate} को समाप्त हुआ।`,
	ht: (activityHref, title, endDate) => html`Redireksyon soti nan <a href="${activityHref}">${title}</a> ki te fini ${endDate}`,
	it: (activityHref, title, endDate) => html`Reindirizzato dalla <a href="${activityHref}">${title}</a> , che si è conclusa il ${endDate}.`,
	ja: (activityHref, title, endDate) => html`7${endDate}日に終了した<a href="${activityHref}">${title}</a>からリダイレクトされました。`,
	ko: (activityHref, title, endDate) => html`7${endDate}일에 종료된 <a href="${activityHref}">${title}</a>에서 리디렉션되었습니다.`,
	mww: (activityHref, title, endDate) => html`Redirected los ntawm <a href="${activityHref}">${title}</a> uas xaus rau ${endDate}.`,
	ps: (activityHref, title, endDate) => html`د <a href="${activityHref}">${title}</a> څخه چې ${endDate} پای ته ورسېد، بیا لارښوونه شوه.`,
	pt: (activityHref, title, endDate) => html`Redirecionado da <a href="${activityHref}">${title}</a> , que terminou em ${endDate}.`,
	'pt-pt': (activityHref, title, endDate) => html`Redirecionado de <a href="${activityHref}">${title}</a> , que terminou a ${endDate}.`,
	ru: (activityHref, title, endDate) => html`Перенаправлено с <a href="${activityHref}">${title}</a> , которая завершилась ${endDate}.`,
	sm: (activityHref, title, endDate) => html`Toe fa'afo'i mai le <a href="${activityHref}">${title}</a> lea na fa'amutaina ia ${endDate}.`,
	so: (activityHref, title, endDate) => html`Waxaa loo wareejiyay <a href="${activityHref}">${title}</a> oo dhammaatay July ${endDate}.`,
	th: (activityHref, title, endDate) => html`เปลี่ยนทางจาก <a href="${activityHref}">${title}</a> ซึ่งสิ้นสุดเมื่อวันที่ ${endDate}`,
	ur: (activityHref, title, endDate) => html`<a href="${activityHref}">${title}</a> سے ری ڈائریکٹ کیا گیا جو ${endDate} کو ختم ہوا۔`,
	vi: (activityHref, title, endDate) => html`đổi hướng từ <a href="${activityHref}">${title}</a> which ended on ${endDate}.`,
	'zh-hans': (activityHref, title, endDate) => html`重定向自7${endDate}日结束的<a href="${activityHref}">${title}</a>。`,
	'zh-hant': (activityHref, title, endDate) => html`已從7${endDate}日結束的<a href="${activityHref}">${title}</a>重新導向。`,
	en: (activityHref, title, endDate) => html`Redirected from <a href="${activityHref}">${title}</a> which ended on ${endDate}.`
};

export const loc_publicQuestionnaireOptionDesc: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `يمكن ربط الاستبيانات العامة بالفعاليات وتعبئتها من قبل أشخاص لا يملكون حسابا ${cumulus} .`,
	de: (cumulus) => `Öffentliche Fragebögen können mit Veranstaltungen verknüpft und von Personen ohne ${cumulus} ausgefüllt werden.`,
	es: (cumulus) => `Los cuestionarios públicos pueden estar asociados a eventos y ser rellenados por personas sin cuenta ${cumulus} .`,
	fa: (cumulus) => `پرسشنامه های عمومی می توانند با رویدادها مرتبط شوند و توسط افرادی که حساب ${cumulus} ندارند پر شوند.`,
	fil: (cumulus) => `Ang mga pampublikong questionnaire ay maaaring maiugnay sa mga kaganapan at punan ng mga indibidwal na walang ${cumulus} account.`,
	fr: (cumulus) => `Les questionnaires publics peuvent être associés à des événements et remplis par des personnes sans compte ${cumulus} .`,
	hi: (cumulus) => `सार्वजनिक प्रश्नावली को घटनाओं से जोड़ा जा सकता है और ${cumulus} खाते के बिना व्यक्तियों द्वारा भरा जा सकता है।`,
	ht: (cumulus) => `Piblik kesyonè yo ka Asosye avèk evènman yo ak ranpli pa Moun ki pa gen okenn ${cumulus} kont.`,
	it: (cumulus) => `I questionari pubblici possono essere associati agli eventi e compilati da persone senza un account ${cumulus} .`,
	ja: (cumulus) => `公開アンケートはイベントに関連付けられ、 ${cumulus} アカウントを持たない個人でも記入可能です。`,
	ko: (cumulus) => `공개 설문지는 행사와 연관되어 ${cumulus} 계정이 없는 개인도 작성할 수 있습니다.`,
	mww: (cumulus) => `Cov lus nug pej xeem tuaj yeem cuam tshuam nrog cov xwm txheej thiab sau los ntawm cov tib neeg uas tsis muaj tus ${cumulus} .`,
	ps: (cumulus) => `عامه پوښتنلیکونه د پیښو سره تړلی کیدای شی او د هغو کسانو لخوا ډک شی چې ${cumulus} حساب نه لری.`,
	pt: (cumulus) => `Questionários públicos podem ser associados a eventos e preenchidos por pessoas sem conta ${cumulus} .`,
	'pt-pt': (cumulus) => `Questionários públicos podem estar associados a eventos e preenchidos por indivíduos sem conta ${cumulus} .`,
	ru: (cumulus) => `Публичные анкеты могут быть связаны с мероприятиями и заполнены лицами без ${cumulus} .`,
	sm: (cumulus) => `O fesili lautele e mafai ona feso'ota'i ma mea na tutupu ma fa'atumuina e tagata ta'ito'atasi e aunoa ma se ${cumulus} account.`,
	so: (cumulus) => `Su'aalaha dadweynaha waxaa lala xiriirin karaa dhacdooyinka, waxaana buuxin kara shakhsiyaad aan lahayn akoon ${cumulus} ah.`,
	th: (cumulus) => `แบบสอบถามสาธารณะสามารถเชื่อมโยงกับกิจกรรมและกรอกโดยบุคคลที่ไม่มีบัญชี ${cumulus}`,
	ur: (cumulus) => `عوامی سوالنامے واقعات سے منسلک کیے جا سکتے ہیں اور ایسے افراد کے ذریعے بھرے جا سکتے ہیں جن کے ${cumulus} اکاؤنٹ نہیں ہوتا۔`,
	vi: (cumulus) => `Bảng câu hỏi công khai có thể được liên kết với các sự kiện và được điền bởi các cá nhân không có tài khoản ${cumulus} .`,
	'zh-hans': (cumulus) => `公开问卷可以关联事件，并由没有 ${cumulus} 账户的个人填写。`,
	'zh-hant': (cumulus) => `公開問卷可與活動相關聯，並由沒有 ${cumulus} 帳號的個人填寫。`,
	en: (cumulus) => `Public questionnaires can be associated with events and filled out by individuals without a ${cumulus} account.`
};

export const loc_publicQuestionnairePrintable: Record<Locale, string> = {
	ar: `استبيان عام (قابل للطباعة)`,
	de: `Öffentlicher Fragebogen (ausdruckbar)`,
	es: `Cuestionario público (imprimible)`,
	fa: `پرسشنامه عمومی (قابل چاپ)`,
	fil: `Pampublikong palatanungan (mai-print)`,
	fr: `Questionnaire public (imprimable)`,
	hi: `सार्वजनिक प्रश्नावली (प्रिंट करने योग्य)`,
	ht: `Kesyonè piblik (enprime)`,
	it: `Questionario pubblico (stampabile)`,
	ja: `公開アンケート(印刷可能)`,
	ko: `공개 설문지 (인쇄 가능)`,
	mww: `Cov lus nug rau pej xeem (luam tawm)`,
	ps: `عامه پوښتنلیک (چاپ کېدونکی)`,
	pt: `Questionário público (imprimível)`,
	'pt-pt': `Questionário público (imprimível)`,
	ru: `Публичный опросник (распечатанный)`,
	sm: `Fesili a le Malo (lolomiina)`,
	so: `Su'aalaha dadweynaha (la daabaco)`,
	th: `แบบสอบถามสาธารณะ (พิมพ์ได้)`,
	ur: `عوامی سوالنامہ (پرنٹ ایبل)`,
	vi: `Bảng câu hỏi công khai (có thể in)`,
	'zh-hans': `公开问卷（可打印）`,
	'zh-hant': `公開問卷（可列印）`,
	en: `Public questionnaire (printable)`
};

export const loc_publicUrlNote: Record<Locale, string> = {
	ar: `ستكون الرابط العام، ورمز QR، وورقة العمل القابلة للطباعة متاحة بعد الحفظ.`,
	de: `Öffentliche URL, QR-Code und ausdruckbares Arbeitsblatt sind nach dem Speichern verfügbar.`,
	es: `La URL pública, el código QR y la hoja de trabajo imprimible estarán disponibles tras guardar.`,
	fa: `آدرس عمومی، کد QR و برگه قابل چاپ پس از ذخیره در دسترس خواهند بود.`,
	fil: `Ang pampublikong url, QR code, at mai-print na worksheet ay magagamit pagkatapos i-save.`,
	fr: `URL publique, code QR et fiche d’exercices imprimables seront disponibles après sauvegarde.`,
	hi: `सहेजने के बाद सार्वजनिक यूआरएल, क्यूआर कोड और प्रिंट करने योग्य वर्कशीट उपलब्ध होगी।`,
	ht: `Url piblik, kòd QR, ak Fèy travay ki ka enprime yo ap disponib apre ekonomize`,
	it: `URL pubblico, codice QR e scheda stampabile saranno disponibili dopo il salvataggio.`,
	ja: `保存後は公開URL、QRコード、印刷可能なワークシートが利用可能になります。`,
	ko: `공개 URL, QR 코드, 인쇄 가능한 워크시트는 저장 후 제공됩니다.`,
	mww: `Pej xeem url, QR code, thiab printable worksheet yuav muaj tom qab txuag tau.`,
	ps: `عامه URL، QR کوډ، او چاپېدونکی ورک شیټ به د خوندی کولو وروسته شتون ولری.`,
	pt: `URL pública, código QR e planilha imprimível estarão disponíveis após salvar.`,
	'pt-pt': `URL público, código QR e folha de trabalho imprimível estarão disponíveis após a gravação.`,
	ru: `Публичный URL, QR-код и распечатанный рабочий лист будут доступны после сохранения.`,
	sm: `O le a maua le URL lautele, QR code, ma le pepa o galuega e mafai ona lolomiina pe a uma ona sefeina.`,
	so: `URL-ka dadweynaha, koodhka QR, iyo xaashida shaqada ee la daabaci karo ayaa la heli doonaa marka la keydiyo.`,
	th: `URL สาธารณะ รหัส QR และแผ่นงานที่พิมพ์ได้จะพร้อมใช้งานหลังจากบันทึก`,
	ur: `پبلک یو آر ایل، کیو آر کوڈ، اور پرنٹ ایبل ورک شیٹ محفوظ کرنے کے بعد دستیاب ہوں گے۔`,
	vi: `URL công khai, mã QR và bảng tính có thể in sẽ có sẵn sau khi lưu.`,
	'zh-hans': `保存后将提供公开网址、二维码和可打印的工作表。`,
	'zh-hant': `儲存後將開放公開網址、QR 碼及可列印工作表。`,
	en: `Public url, QR code, and printable worksheet will be available after saving.`
};

export const loc_qrCode: Record<Locale, string> = {
	ar: `رمز QR`,
	de: `QR-Code`,
	es: `Código QR`,
	fa: `کد QR`,
	fil: `Email Address *`,
	fr: `Code QR`,
	hi: `QR कोड`,
	ht: `Kòd QR`,
	it: `Codice QR`,
	ja: `QRコード`,
	ko: `QR 코드`,
	mww: `QR code`,
	ps: `QR کوډ`,
	pt: `Código QR`,
	'pt-pt': `Código QR`,
	ru: `QR-код`,
	sm: `QR code`,
	so: `QR code`,
	th: `คิวอาร์โค้ด`,
	ur: `کیو آر کوڈ`,
	vi: `Mã QR`,
	'zh-hans': `二维码`,
	'zh-hant': `QR 碼`,
	en: `QR code`
};

export const loc_qrCodeInstructions: Record<Locale, TemplateResult> = {
	ar: html`<ol><li>افتح تطبيق الكاميرا.</li><li>اختر الكاميرا المواجهة للخلف في وضع الصورة أو الكاميرا.</li><li>ضع رمز الاستجابة السريعة في مركز الشاشة وثبت هاتفك لبضع ثوان.</li><li>اضغط على الإشعار الذي يظهر لفتح الرابط.</li></ol>`,
	de: html`<ol><li>Öffne die Kamera-App.</li><li>Wählen Sie die Rückkamera im Foto- oder Kameramodus.</li><li>Zentriere den QR-Code auf dem Bildschirm und halte dein Handy für ein paar Sekunden ruhig.</li><li>Tippe auf die Benachrichtigung, die erscheint, um den Link zu öffnen.</li></ol>`,
	es: html`<ol><li>Abre la app de la cámara.</li><li>Selecciona la cámara trasera en modo Foto o Cámara.</li><li>Centra el código QR en la pantalla y mantén el móvil firme durante un par de segundos.</li><li>Toca la notificación que aparece para abrir el enlace.</li></ol>`,
	fa: html`<ol><li>اپلیکیشن دوربین را باز کن.</li><li>دوربین عقب را در حالت عکس یا دوربین انتخاب کنید.</li><li>کد QR را روی صفحه قرار دهید و گوشی را چند ثانیه ثابت نگه دارید.</li><li>روی اعلان که ظاهر می شود ضربه بزنید تا لینک باز شود.</li></ol>`,
	fil: html`<ol><li>Buksan ang app ng camera.</li><li>Piliin ang camera na nakaharap sa likuran sa mode ng Larawan o Camera.</li><li>Isentro ang QR code sa screen at hawakan nang matatag ang iyong telepono nang ilang segundo.</li><li>I-tap ang abiso na nag-pop up upang buksan ang link.</li></ol>`,
	fr: html`<ol><li>Ouvre l’application caméra.</li><li>Sélectionnez l’appareil photo arrière en mode Photo ou Appareil photo.</li><li>Centrez le code QR sur l’écran et maintenez votre téléphone stable pendant quelques secondes.</li><li>Tapez sur la notification qui apparaît pour ouvrir le lien.</li></ol>`,
	hi: html`<ol><li>कैमरा ऐप खोलें।</li><li>फ़ोटो या कैमरा मोड में पीछे की ओर वाले कैमरे का चयन करें।</li><li>क्यूआर कोड को स्क्रीन पर केंद्रित करें और अपने फोन को कुछ सेकंड के लिए स्थिर रखें।</li><li>लिंक खोलने के लिए पॉप अप होने वाली सूचना पर टैप करें.</li></ol>`,
	ht: html`<ol><li>Louvri app kamera a.</li><li>Chwazi dèyè fè fas a kamera nan mòd foto oswa kamera</li><li>Sant kòd QR la sou ekran an epi kenbe telefòn ou fiks pou yon koup la segonn.</li><li>Tape notifikasyon an ki pete moute pou louvri lyen an.</li></ol>`,
	it: html`<ol><li>Apri l'app della fotocamera.</li><li>Seleziona la fotocamera posteriore in modalità Foto o Fotocamera.</li><li>Centra il codice QR sullo schermo e tieni il telefono fermo per qualche secondo.</li><li>Tocca la notifica che appare per aprire il link.</li></ol>`,
	ja: html`<ol><li>カメラアプリを開いてください。</li><li>写真モードまたはカメラモードで後ろ向きカメラを選択してください。</li><li>QRコードを画面の中央に合わせ、数秒間スマホをしっかり持っておきます。</li><li>表示される通知をタップしてリンクを開きます。</li></ol>`,
	ko: html`<ol><li>카메라 앱을 열어보세요.</li><li>사진 또는 카메라 모드에서 후면 카메라를 선택하세요.</li><li>QR 코드를 화면 중앙에 맞추고 휴대폰을 몇 초간 안정적으로 잡으세요.</li><li>알림이 뜨는 것을 탭하면 링크를 열어보세요.</li></ol>`,
	mww: html`<ol><li>Qhib lub koob yees duab app.</li><li>Xaiv lub koob yees duab rov qab hauv hom Diam duab lossis Lub Koob Yees Duab.</li><li>Center QR code rau ntawm qhov screen thiab tuav koj lub xov tooj ruaj khov rau ib tug ob peb vib nas this.</li><li>Coj mus rhaub qhov kev ceeb toom uas pops mus qhib qhov txuas.</li></ol>`,
	ps: html`<ol><li>د کمرې اپلیکیشن خلاص کړه.</li><li>شاته مخامخ کامره په عکس یا کامره حالت کې وټاکئ.</li><li>QR کوډ په سکرین کې مرکز کړئ او خپل موبایل څو ثانیې ثابت وساتئ.</li><li>هغه خبرتیا چې راښکاره کېږی، ټک وهه چې لینک پرانیزی.</li></ol>`,
	pt: html`<ol><li>Abra o aplicativo da câmera.</li><li>Selecione a câmera traseira no modo Foto ou Câmera.</li><li>Centralize o código QR na tela e mantenha o celular estável por alguns segundos.</li><li>Toque na notificação que aparece para abrir o link.</li></ol>`,
	'pt-pt': html`<ol><li>Abre a aplicação da câmara.</li><li>Selecione a câmara traseira em modo Foto ou Câmara.</li><li>Centra o código QR no ecrã e mantém o telemóvel estável durante alguns segundos.</li><li>Toque na notificação que aparece para abrir o link.</li></ol>`,
	ru: html`<ol><li>Откройте приложение камеры.</li><li>Выберите заднюю камеру в режиме Фото или Камера.</li><li>Центрируйте QR-код на экране и удержите телефон на пару секунд.</li><li>Нажмите на уведомление, которое появится, чтобы открыть ссылку.</li></ol>`,
	sm: html`<ol><li>Tatala le polokalama o le mea pu'eata.</li><li>Filifili le mea pu'eata i tua i le Ata po'o le Mea Pueata.</li><li>Fa'apipi'i le QR code i luga o le lau ma taofi lau telefoni mo ni nai sekone.</li><li>Kiliki i le fa'asilasilaga o lo'o oso a'e i luga e tatala ai le sootaga.</li></ol>`,
	so: html`<ol><li>Fur app-ka kamaradda.</li><li>Dooro kamaradda gadaal u jeeda habka Sawir ama Kamarad.</li><li>Bartamaha QR code-ka shaashadda ku hay oo telefoonkaaga si deggan u hay dhowr ilbiriqsi.</li><li>Taabo ogeysiiska soo baxaya si aad u furto xiriirka.</li></ol>`,
	th: html`<ol><li>เปิดแอปกล้องถ่ายรูป</li><li>เลือกกล้องหลังในโหมดภาพถ่ายหรือกล้อง</li><li>วางคิวอาร์โค้ดไว้ตรงกลางหน้าจอและถือโทรศัพท์ให้นิ่งสองสามวินาที</li><li>แตะการแจ้งเตือนที่ปรากฏขึ้นเพื่อเปิดลิงก์</li></ol>`,
	ur: html`<ol><li>کیمرہ ایپ کھولو۔</li><li>فوٹو یا کیمرہ موڈ میں ریئر فیسنگ کیمرہ منتخب کریں۔</li><li>کیو آر کوڈ کو اسکرین پر مرکز میں رکھیں اور فون کو چند سیکنڈ کے لیے مستحکم رکھیں۔</li><li>لنک کھولنے کے لیے پاپ اپ ہونے والی نوٹیفکیشن پر ٹیپ کریں۔</li></ol>`,
	vi: html`<ol><li>Mở ứng dụng máy ảnh.</li><li>Chọn camera phía sau ở chế độ Ảnh hoặc Máy ảnh.</li><li>Căn giữa mã QR trên màn hình và giữ điện thoại của bạn ổn định trong vài giây.</li><li>Nhấn vào thông báo bật lên để mở liên kết.</li></ol>`,
	'zh-hans': html`<ol><li>打开相机应用。</li><li>在拍照或相机模式中选择后置摄像头。</li><li>将二维码置中，手机稳稳地握住几秒钟。</li><li>点击弹出的通知即可打开链接。</li></ol>`,
	'zh-hant': html`<ol><li>打開相機應用程式。</li><li>在拍照或相機模式中選擇後置相機。</li><li>將 QR 碼置中，並穩定握住手機幾秒鐘。</li><li>點擊跳出的通知即可開啟連結。</li></ol>`,
	en: html`<ol><li>Open the camera app.</li><li>Select the rear-facing camera in Photo or Camera mode.</li><li>Center the QR code on the screen and hold your phone steady for a couple of seconds.</li><li>Tap the notification that pops up to open the link.</li></ol>`
};

export const loc_questionnaire: Record<Locale, string> = {
	ar: `الاستبيان`,
	de: `Fragebogen`,
	es: `Cuestionario`,
	fa: `پرسشنامه`,
	fil: `Talatanungan`,
	fr: `Questionnaire`,
	hi: `प्रश्‍नावली`,
	ht: `Kesyonè`,
	it: `Questionario`,
	ja: `アンケート`,
	ko: `설문지`,
	mww: `Cov lus nug`,
	ps: `پوښتنلیک`,
	pt: `Questionário`,
	'pt-pt': `Questionário`,
	ru: `Анкета`,
	sm: `Fesili`,
	so: `Su'aalo`,
	th: `แบบสอบถาม`,
	ur: `سوالنامہ`,
	vi: `Bảng câu hỏi`,
	'zh-hans': `问卷`,
	'zh-hant': `問卷`,
	en: `Questionnaire`
};

export const loc_questionnaires: Record<Locale, string> = {
	ar: `الاستبيانات`,
	de: `Fragebögen`,
	es: `Cuestionarios`,
	fa: `پرسشنامه ها`,
	fil: `Mga talatanungan`,
	fr: `Questionnaires`,
	hi: `प्रश्नावली`,
	ht: `Kesyonè yo`,
	it: `Questionari`,
	ja: `アンケート`,
	ko: `설문지`,
	mww: `Cov lus nug`,
	ps: `پوښتنلیکونه`,
	pt: `Questionários`,
	'pt-pt': `Questionários`,
	ru: `Анкеты`,
	sm: `Fesili`,
	so: `Su'aalaha`,
	th: `แบบสอบถาม`,
	ur: `سوالنامے`,
	vi: `Bảng câu hỏi`,
	'zh-hans': `问卷`,
	'zh-hant': `問卷`,
	en: `Questionnaires`
};

export const loc_quickFilters: Record<Locale, string> = {
	ar: `فلاتر سريعة`,
	de: `Schnelle Filter`,
	es: `Filtros rápidos`,
	fa: `فیلترهای سریع`,
	fil: `Mabilis na mga filter`,
	fr: `Filtres rapides`,
	hi: `त्वरित फिल्टर`,
	ht: `Filtè rapid`,
	it: `Filtri rapidi`,
	ja: `クイックフィルター`,
	ko: `빠른 필터`,
	mww: `Cov ntxaij lim dej ceev`,
	ps: `چټک فلټرونه`,
	pt: `Filtros rápidos`,
	'pt-pt': `Filtros rápidos`,
	ru: `Быстрые фильтры`,
	sm: `Faamama vave`,
	so: `Shaandheeyada degdega ah`,
	th: `ตัวกรองด่วน`,
	ur: `فوری فلٹرز`,
	vi: `Bộ lọc nhanh`,
	'zh-hans': `快速过滤`,
	'zh-hant': `快速篩選`,
	en: `Quick filters`
};

export const loc_quoteReply: Record<Locale, string> = {
	ar: `رد اقتباس`,
	de: `Zitatantantwort`,
	es: `Respuesta de la cita`,
	fa: `پاسخ نقل قول`,
	fil: `Email Address *`,
	fr: `Réponse de citation`,
	hi: `उद्धरण उत्तर`,
	ht: `Quote reply`,
	it: `Risposta a citazione`,
	ja: `引用返信`,
	ko: `인용 답변`,
	mww: `Quote teb`,
	ps: `د اقتباس ځواب`,
	pt: `Resposta de citação`,
	'pt-pt': `Resposta de citação`,
	ru: `Ответ цитаты`,
	sm: `Upusii tali`,
	so: `Jawaab xigasho`,
	th: `อ้างคําตอบ`,
	ur: `حوالہ جواب`,
	vi: `Trích dẫn trả lời`,
	'zh-hans': `引用回复`,
	'zh-hant': `引用回覆`,
	en: `Quote reply`
};

export const loc_race: Record<Locale, string> = {
	ar: `السباق`,
	de: `Rennen`,
	es: `Carrera`,
	fa: `مسابقه`,
	fil: `Lahi`,
	fr: `Course`,
	hi: `दौड़`,
	ht: `Ras`,
	it: `Gara`,
	ja: `レース`,
	ko: `레이스`,
	mww: `haiv neeg`,
	ps: `سیالی`,
	pt: `Corrida`,
	'pt-pt': `Corrida`,
	ru: `Гонка`,
	sm: `Tuuga`,
	so: `Tartanka`,
	th: `การแข่งขัน`,
	ur: `ریس`,
	vi: `Cuộc đua`,
	'zh-hans': `比赛`,
	'zh-hant': `比賽`,
	en: `Race`
};

export const loc_range: Record<Locale, string> = {
	ar: `النطاق`,
	de: `Verbreitung`,
	es: `Distribución`,
	fa: `پراکندگی`,
	fil: `Saklaw`,
	fr: `Répartition`,
	hi: `सीमा`,
	ht: `Ranje`,
	it: `Distribuzione`,
	ja: `分布域`,
	ko: `분포`,
	mww: `Ntau yam`,
	ps: `ساحه`,
	pt: `Distribuição`,
	'pt-pt': `Distribuição`,
	ru: `Ареал`,
	sm: `Tele`,
	so: `Baaxadda`,
	th: `พิสัย`,
	ur: `رینج`,
	vi: `Phạm vi`,
	'zh-hans': `分布范围`,
	'zh-hant': `分布範圍`,
	en: `Range`
};

export const loc_ready: Record<Locale, string> = {
	ar: `جاهز`,
	de: `Bereit`,
	es: `Listo`,
	fa: `آماده ام`,
	fil: `Handa na`,
	fr: `Prêt`,
	hi: `तैयार`,
	ht: `Pare`,
	it: `Pronto`,
	ja: `準備`,
	ko: `준비됐어`,
	mww: `npaj txhij`,
	ps: `چمتو یم`,
	pt: `Pronto`,
	'pt-pt': `Pronto`,
	ru: `Готовы`,
	sm: `Sauni`,
	so: `Diyaar`,
	th: `พร้อม`,
	ur: `تیار`,
	vi: `Sẵn sàng`,
	'zh-hans': `准备好了`,
	'zh-hant': `準備好了`,
	en: `Ready`
};

export const loc_readyStatusDesc: Record<Locale, string> = {
	ar: `النشاط جاهز للتنفيذ، لكن لم يتم اتخاذ أي إجراء بعد. `,
	de: `Die Aktivität ist bereit, durchgeführt zu werden, aber es wurde noch keine Maßnahme ergriffen. `,
	es: `La actividad está lista para realizarse, pero aún no se ha tomado ninguna medida. `,
	fa: `این فعالیت آماده انجام است، اما هنوز اقدامی صورت نگرفته است. `,
	fil: `Handa nang isagawa ang aktibidad, ngunit wala pang aksyon na ginawa. `,
	fr: `L’activité est prête à être réalisée, mais aucune action n’a encore été prise. `,
	hi: `गतिविधि प्रदर्शन के लिए तैयार है, लेकिन अभी तक कोई कार्रवाई नहीं की गई है। `,
	ht: `Aktivite a se pare yo dwe fèt, men pa gen okenn aksyon ankò yo te pran. `,
	it: `L'attività è pronta per essere eseguita, ma non è ancora stata intrapresa alcuna azione. `,
	ja: `活動は実施の準備が整っていますが、まだ具体的な行動は取られていません。 `,
	ko: `활동은 준비가 되어 있으나 아직 조치가 취해지지 않았습니다. `,
	mww: `Qhov kev ua haujlwm tau npaj txhij los ua, tab sis tseem tsis tau nqis tes ua. `,
	ps: `فعالیت د ترسره کولو لپاره چمتو دی، خو تر اوسه هیڅ اقدام نه دی شوی. `,
	pt: `A atividade está pronta para ser realizada, mas nenhuma ação foi tomada ainda. `,
	'pt-pt': `A atividade está pronta para ser realizada, mas ainda não foi tomada qualquer ação. `,
	ru: `Активность готова к проведению, но пока никаких действий не предпринято. `,
	sm: `O le gaioiga ua sauni e faatino, ae e leai se gaioiga na faia. `,
	so: `Hawlgalku waa diyaar in la qabto, laakiin weli wax tallaabo ah lama qaadin. `,
	th: `กิจกรรมนี้พร้อมที่จะดําเนินการ แต่ยังไม่มีการดําเนินการใดๆ `,
	ur: `یہ سرگرمی انجام دینے کے لیے تیار ہے، لیکن ابھی تک کوئی کارروائی نہیں کی گئی۔ `,
	vi: `Hoạt động đã sẵn sàng để thực hiện, nhưng chưa có hành động nào được thực hiện. `,
	'zh-hans': `活动已准备就绪，但尚未采取任何行动。 `,
	'zh-hant': `活動已準備好進行，但尚未採取任何行動。 `,
	en: `The activity is ready to be performed, but no action has yet been taken. `
};

export const loc_readyToCreate: Record<Locale, string> = {
	ar: `جاهز للإبداع`,
	de: `Bereit zum Erstellen`,
	es: `Listo para crear`,
	fa: `آماده خلق`,
	fil: `Handa nang lumikha`,
	fr: `Prêt à créer`,
	hi: `बनाने के लिए तैयार`,
	ht: `Pare pou kreye`,
	it: `Pronto a creare`,
	ja: `創造の準備ができました`,
	ko: `창조할 준비가 되어 있습니다`,
	mww: `Npaj txhij los tsim`,
	ps: `د جوړولو لپاره چمتو یم`,
	pt: `Pronto para criar`,
	'pt-pt': `Pronto para criar`,
	ru: `Готов к творчеству`,
	sm: `Sauni e fausiaina`,
	so: `Diyaar u ah abuurista`,
	th: `พร้อมที่จะสร้าง`,
	ur: `تخلیق کے لیے تیار`,
	vi: `Sẵn sàng sáng tạo`,
	'zh-hans': `准备创作`,
	'zh-hant': `準備創作`,
	en: `Ready to create`
};

export const loc_reason: Record<Locale, string> = {
	ar: `السبب`,
	de: `Grund`,
	es: `Motivo`,
	fa: `دلیل`,
	fil: `Dahilan`,
	fr: `Raison`,
	hi: `कारण`,
	ht: `Rezon ki fè`,
	it: `Motivo`,
	ja: `理由`,
	ko: `이유`,
	mww: `Vim li cas`,
	ps: `دلیل`,
	pt: `Motivo`,
	'pt-pt': `Razão`,
	ru: `Причина`,
	sm: `Mafua'aga`,
	so: `Sababta`,
	th: `เหตุผล`,
	ur: `وجہ`,
	vi: `Lý do`,
	'zh-hans': `原因`,
	'zh-hant': `原因`,
	en: `Reason`
};

export const loc_recaptchaLegal: Record<Locale, TemplateResult> = {
	ar: html`هذا الموقع محمي بموجب reCAPTCHA <a class="Link--secondary" href="https://policies.google.com/privacy">وسياسة الخصوصية</a> <a class="Link--secondary" href="https://policies.google.com/terms">وشروط الخدمة</a> الخاصة بجوجل تنطبق.`,
	de: html`Diese Seite ist durch reCAPTCHA geschützt und die <a class="Link--secondary" href="https://policies.google.com/privacy">Google-Datenschutzrichtlinie</a> sowie <a class="Link--secondary" href="https://policies.google.com/terms">Nutzungsbedingungen</a> gelten.`,
	es: html`Este sitio está protegido por reCAPTCHA y se aplican la <a class="Link--secondary" href="https://policies.google.com/privacy">Política de Privacidad</a> y <a class="Link--secondary" href="https://policies.google.com/terms">los Términos de Servicio</a> de Google.`,
	fa: html`این سایت توسط reCAPTCHA محافظت می شود و <a class="Link--secondary" href="https://policies.google.com/privacy">سیاست حفظ حریم خصوصی</a> و <a class="Link--secondary" href="https://policies.google.com/terms">شرایط خدمات</a> گوگل اعمال می شود.`,
	fil: html`Ang site na ito ay protektado ng reCAPTCHA at nalalapat ang <a class="Link--secondary" href="https://policies.google.com/privacy">Patakaran sa Privacy</a> at <a class="Link--secondary" href="https://policies.google.com/terms">Mga Tuntunin ng Serbisyo</a> ng Google.`,
	fr: html`Ce site est protégé par reCAPTCHA et la <a class="Link--secondary" href="https://policies.google.com/privacy">politique de confidentialité</a> ainsi que les <a class="Link--secondary" href="https://policies.google.com/terms">Conditions d’utilisation</a> de Google s’appliquent.`,
	hi: html`यह साइट reCAPTCHA द्वारा सुरक्षित है और Google <a class="Link--secondary" href="https://policies.google.com/privacy">गोपनीयता नीति</a> और <a class="Link--secondary" href="https://policies.google.com/terms">सेवा की शर्तें</a> लागू होती हैं।`,
	ht: html`Sit sa a pwoteje pa reCAPTCHA ak Google <a class="Link--secondary" href="https://policies.google.com/privacy">Règleman sou enfòmasyon prive</a> ak <a class="Link--secondary" href="https://policies.google.com/terms">Regleman pou Sèvis</a> aplike.`,
	it: html`Questo sito è protetto da reCAPTCHA e si applicano <a class="Link--secondary" href="https://policies.google.com/privacy">l'Informativa sulla Privacy</a> di Google e <a class="Link--secondary" href="https://policies.google.com/terms">i Termini di Servizio</a> .`,
	ja: html`このサイトはreCAPTCHAによって保護されており、Googleの <a class="Link--secondary" href="https://policies.google.com/privacy">プライバシーポリシー</a> および <a class="Link--secondary" href="https://policies.google.com/terms">利用規約</a> が適用されます。`,
	ko: html`이 사이트는 reCAPTCHA에 의해 보호되며, 구글 <a class="Link--secondary" href="https://policies.google.com/privacy">개인정보처리방침</a> 과 <a class="Link--secondary" href="https://policies.google.com/terms">이용 약관</a> 이 적용됩니다.`,
	mww: html`Lub xaib no muaj kev tiv thaiv los ntawm reCAPTCHA thiab Google <a class="Link--secondary" href="https://policies.google.com/privacy">Txoj Cai Tswjfwm Ntiag Tug</a> thiab <a class="Link--secondary" href="https://policies.google.com/terms">Cov Lus Cog Tseg ntawm Kev Pabcuam</a> siv.`,
	ps: html`دا سایټ د reCAPTCHA لخوا خوندی دی او د ګوګل <a class="Link--secondary" href="https://policies.google.com/privacy">د محرمیت پالیسۍ</a> او <a class="Link--secondary" href="https://policies.google.com/terms">د خدمت شرایط</a> تطبیق کیږی.`,
	pt: html`Este site é protegido pelo reCAPTCHA e a <a class="Link--secondary" href="https://policies.google.com/privacy">Política de Privacidade</a> e <a class="Link--secondary" href="https://policies.google.com/terms">os Termos de Serviço</a> do Google se aplicam.`,
	'pt-pt': html`Este site está protegido pelo reCAPTCHA e aplicam-se a <a class="Link--secondary" href="https://policies.google.com/privacy">Política de Privacidade</a> e <a class="Link--secondary" href="https://policies.google.com/terms">os Termos de Serviço</a> da Google.`,
	ru: html`Этот сайт защищён reCAPTCHA, и применяются <a class="Link--secondary" href="https://policies.google.com/privacy">Политика конфиденциальности</a> Google и <a class="Link--secondary" href="https://policies.google.com/terms">Условия использования</a> .`,
	sm: html`O lenei 'upega tafa'ilagi e puipuia e le reCAPTCHA ma le Google <a class="Link--secondary" href="https://policies.google.com/privacy">faalauaiteleina Faiga Faavae</a> ma <a class="Link--secondary" href="https://policies.google.com/terms">Tuutuuga o Auaunaga fa'aaogaina</a> .`,
	so: html`Boggan waxaa ilaaliya reCAPTCHA, waxaana khuseeya <a class="Link--secondary" href="https://policies.google.com/privacy">Siyaasadda Asturnaanta</a> Google iyo <a class="Link--secondary" href="https://policies.google.com/terms">Shuruudaha Adeegga</a> .`,
	th: html`เว็บไซต์นี้ได้รับการคุ้มครองโดย reCAPTCHA และ <a class="Link--secondary" href="https://policies.google.com/privacy">นโยบายความเป็นส่วนตัว</a> และ <a class="Link--secondary" href="https://policies.google.com/terms">ข้อกําหนดในการให้บริการ</a> ของ Google มีผลบังคับใช้`,
	ur: html`یہ سائٹ reCAPTCHA کے تحت محفوظ ہے اور گوگل <a class="Link--secondary" href="https://policies.google.com/privacy">کی پرائیویسی پالیسی</a> اور <a class="Link--secondary" href="https://policies.google.com/terms">سروس کی شرائط</a> لاگو ہوتی ہیں۔`,
	vi: html`Trang web này được bảo vệ bởi reCAPTCHA và áp dụng <a class="Link--secondary" href="https://policies.google.com/privacy">Chính sách quyền riêng tư</a> và <a class="Link--secondary" href="https://policies.google.com/terms">Điều khoản dịch vụ</a> của Google.`,
	'zh-hans': html`本网站受reCAPTCHA保护，并适用谷歌 <a class="Link--secondary" href="https://policies.google.com/privacy">隐私政策</a> 和 <a class="Link--secondary" href="https://policies.google.com/terms">服务条款</a> 。`,
	'zh-hant': html`本網站受 reCAPTCHA 保護，並適用 Google <a class="Link--secondary" href="https://policies.google.com/privacy">隱私政策</a> 及 <a class="Link--secondary" href="https://policies.google.com/terms">服務條款</a> 。`,
	en: html`This site is protected by reCAPTCHA and the Google <a class="Link--secondary" href="https://policies.google.com/privacy">Privacy Policy</a> and <a class="Link--secondary" href="https://policies.google.com/terms">Terms of Service</a> apply.`
};

export const loc_recentlyAccessed: Record<Locale, string> = {
	ar: `تم الوصول إليها مؤخرا`,
	de: `Kürzlich aufgerufen`,
	es: `Consultado recientemente`,
	fa: `دسترسی اخیر`,
	fil: `Kamakailan lamang na na-access`,
	fr: `Récemment consulté`,
	hi: `हाल ही में एक्सेस किया गया`,
	ht: `Aksè dènyèman`,
	it: `Accesso recente`,
	ja: `最近アクセス`,
	ko: `최근 접속`,
	mww: `Tsis ntev los no nkag mus`,
	ps: `تازه لاسرسی`,
	pt: `Acessado recentemente`,
	'pt-pt': `Acedido recentemente`,
	ru: `Недавно доступно`,
	sm: `Mauaina talu ai nei`,
	so: `Dhawaan la helay`,
	th: `เข้าถึงล่าสุด`,
	ur: `حال ہی میں رسائی حاصل کی گئی`,
	vi: `Truy cập gần đây`,
	'zh-hans': `最近访问`,
	'zh-hant': `近期存取`,
	en: `Recently accessed`
};

export const loc_recentlyCreated: Record<Locale, string> = {
	ar: `تم إنشاؤه مؤخرا`,
	de: `Kürzlich geschaffen`,
	es: `Creado recientemente`,
	fa: `تازه تأسیس شده`,
	fil: `Kamakailan-lamang na nilikha`,
	fr: `Récemment créée`,
	hi: `हाल ही में बनाया गया`,
	ht: `Dènyèman kreye`,
	it: `Creato di recente`,
	ja: `最近作成されました`,
	ko: `최근 제작`,
	mww: `Tsis ntev los no tsim`,
	ps: `تازه جوړ شوی`,
	pt: `Criado recentemente`,
	'pt-pt': `Criado recentemente`,
	ru: `Недавно создано`,
	sm: `Talu ai nei na foafoaina`,
	so: `Dhawaan la abuuray`,
	th: `สร้างล่าสุด`,
	ur: `حال ہی میں تخلیق شدہ`,
	vi: `Tạo gần đây`,
	'zh-hans': `最近创建`,
	'zh-hant': `近期創建`,
	en: `Recently created`
};

export const loc_recentlyCreatedByFormat: Record<Locale, (date: unknown, user: unknown) => TemplateResult> = {
	ar: (date, user) => html`<span>تم إنشاؤه ${date} بواسطة ${user}</span>`,
	de: (date, user) => html`<span>Vor ${date} erstellt von ${user}</span>`,
	es: (date, user) => html`<span>Creado ${date} por ${user}</span>`,
	fa: (date, user) => html`<span>${date} توسط ${user} است</span>`,
	fil: (date, user) => html`<span>Nilikha 5 ${date} sa pamamagitan ng ${user}</span>`,
	fr: (date, user) => html`<span>Créé ${date} par ${user}</span>`,
	hi: (date, user) => html`<span>द्वारा निर्मित ${date} ${user}</span>`,
	ht: (date, user) => html`<span>Te kreye ${date} pa ${user}</span>`,
	it: (date, user) => html`<span>Creato ${date} da ${user}</span>`,
	ja: (date, user) => html`<span>${date}に${user}によって作成されました</span>`,
	ko: (date, user) => html`<span>${date} ${user}가 작성함</span>`,
	mww: (date, user) => html`<span>Tsim ${date} los ntawm ${user}</span>`,
	ps: (date, user) => html`<span>${date} ${user} لخوا جوړ شوی</span>`,
	pt: (date, user) => html`<span>Criado ${date} por ${user}</span>`,
	'pt-pt': (date, user) => html`<span>Criado ${date} por ${user}</span>`,
	ru: (date, user) => html`<span>Создано ${date} ${user}</span>`,
	sm: (date, user) => html`<span>Faia 5 ${date} e ${user}</span>`,
	so: (date, user) => html`<span>Waxaa abuuray ${date} hor ${user}</span>`,
	th: (date, user) => html`<span>สร้างเมื่อ ${date} โดย ${user}</span>`,
	ur: (date, user) => html`<span>${date} ${user} نے تخلیق کیا</span>`,
	vi: (date, user) => html`<span>Được tạo cách ${date} ${user}</span>`,
	'zh-hans': (date, user) => html`<span>由${user}于${date}创建</span>`,
	'zh-hant': (date, user) => html`<span>由 ${user} 於 ${date}前創建</span>`,
	en: (date, user) => html`<span>Created ${date} by ${user}</span>`
};

export const loc_recentlyCreatedByYou: Record<Locale, string> = {
	ar: `تم إنشاؤه مؤخرا من قبلك`,
	de: `Kürzlich von dir erstellt`,
	es: `Creado recientemente por ti`,
	fa: `اخیرا توسط شما ساخته شده است`,
	fil: `Kamakailan lamang ay nilikha mo`,
	fr: `Récemment créé par toi`,
	hi: `हाल ही में आपके द्वारा बनाया गया`,
	ht: `Dènyèman te kreye pa ou`,
	it: `Recentemente creato da te`,
	ja: `最近あなたが作ったものです`,
	ko: `최근에 당신이 만든 것`,
	mww: `Tsis ntev los no tsim los ntawm koj`,
	ps: `تازه ستا لخوا جوړ شوی`,
	pt: `Criado recentemente por você`,
	'pt-pt': `Recentemente criado por ti`,
	ru: `Недавно создано вами`,
	sm: `Faauta, sa ia lei faia ea mo oe se faataitaiga lelei?`,
	so: `Dhawaan adiga ayaa abuuray`,
	th: `คุณเพิ่งสร้าง`,
	ur: `حال ہی میں آپ نے تخلیق کیا`,
	vi: `Gần đây do bạn tạo`,
	'zh-hans': `最近由你创建`,
	'zh-hant': `最近由你創作`,
	en: `Recently created by you`
};

export const loc_recentlyUpdated: Record<Locale, string> = {
	ar: `تم التحديث مؤخرا`,
	de: `Kürzlich aktualisiert`,
	es: `Actualizado recientemente`,
	fa: `اخیرا به روزرسانی شده`,
	fil: `Kamakailan-lamang na na-update`,
	fr: `Mise à jour récente`,
	hi: `हाल ही में अपडेट किया गया`,
	ht: `Dènyèman mete ajou`,
	it: `Aggiornato di recente`,
	ja: `最近更新済み`,
	ko: `최근 업데이트`,
	mww: `Tsis ntev los no hloov kho`,
	ps: `تازه تازه شوی`,
	pt: `Atualizado recentemente`,
	'pt-pt': `Atualizado recentemente`,
	ru: `Недавно обновлено`,
	sm: `Fa'afouina talu ai nei`,
	so: `Dhawaan la cusbooneysiiyay`,
	th: `อัพเดทล่าสุด`,
	ur: `حال ہی میں اپ ڈیٹ ہوا ہے`,
	vi: `Cập nhật gần đây`,
	'zh-hans': `最近更新`,
	'zh-hant': `最近更新`,
	en: `Recently updated`
};

export const loc_recentlyViewedByYou: Record<Locale, string> = {
	ar: `تمت مشاهدته مؤخرا من قبلك`,
	de: `Kürzlich von dir angesehen`,
	es: `Visto recientemente por ti`,
	fa: `اخیرا توسط شما مشاهده شده است`,
	fil: `Kamakailan lamang ay tiningnan mo`,
	fr: `Récemment regardé par vous`,
	hi: `हाल ही में आपके द्वारा देखा गया`,
	ht: `Dènyèman wè pa ou`,
	it: `Recentemente visto da te`,
	ja: `最近あなたが閲覧した`,
	ko: `최근에 당신이 본 글`,
	mww: `Tsis ntev los no saib los ntawm koj`,
	ps: `ستا لخوا تازه لیدل شوی`,
	pt: `Recentemente assistido por você`,
	'pt-pt': `Recentemente visto por ti`,
	ru: `Недавно просмотрено вами`,
	sm: `Talu ai nei na e va'ai ai`,
	so: `Dhawaan ayaad daawateen`,
	th: `คุณเพิ่งดู`,
	ur: `حال ہی میں آپ نے دیکھا`,
	vi: `Bạn đã xem gần đây`,
	'zh-hans': `最近被你观看`,
	'zh-hant': `最近被你瀏覽`,
	en: `Recently viewed by you`
};

export const loc_recipients: Record<Locale, string> = {
	ar: `الحاصلون على الجائزة`,
	de: `Preisträger`,
	es: `Galardonados`,
	fa: `دریافت کنندگان`,
	fil: `Mga tatanggap`,
	fr: `Récipiendaires`,
	hi: `प्राप्तकर्ता`,
	ht: `Moun k ap resevwa yo`,
	it: `Vincitori`,
	ja: `受賞者`,
	ko: `수상자`,
	mww: `Cov neeg tau txais kev pab`,
	ps: `ترلاسه کوونکی`,
	pt: `Recipientes`,
	'pt-pt': `Recipientes`,
	ru: `Лауреаты`,
	sm: `Tagata e mauaina`,
	so: `Ku guuleystayaasha`,
	th: `ผู้รับ`,
	ur: `وصول کنندگان`,
	vi: `Người nhận`,
	'zh-hans': `获奖者`,
	'zh-hant': `得獎者`,
	en: `Recipients`
};

export const loc_recommendation: Record<Locale, string> = {
	ar: `التوصية`,
	de: `Empfehlung`,
	es: `Recomendación`,
	fa: `توصیه نامه`,
	fil: `Rekomendasyon`,
	fr: `Recommandation`,
	hi: `सिफ़ारिश`,
	ht: `Rekòmandasyon`,
	it: `Raccomandazione`,
	ja: `推奨事項`,
	ko: `추천`,
	mww: `Kev pom zoo`,
	ps: `سپارښتنه`,
	pt: `Recomendação`,
	'pt-pt': `Recomendação`,
	ru: `Рекомендация`,
	sm: `Fautuaga`,
	so: `Talo`,
	th: `แนะนํา`,
	ur: `سفارش`,
	vi: `Khuyến nghị`,
	'zh-hans': `推荐`,
	'zh-hant': `推薦`,
	en: `Recommendation`
};

export const loc_recommended: Record<Locale, string> = {
	ar: `موصى به`,
	de: `Empfohlen`,
	es: `Recomendado`,
	fa: `توصیه شده`,
	fil: `Inirerekumenda`,
	fr: `Recommandé`,
	hi: `अधिक:`,
	ht: `Rekòmande`,
	it: `Consigliato`,
	ja: `おすすめ`,
	ko: `추천`,
	mww: `pom zoo`,
	ps: `سپارښتنه شوې`,
	pt: `Recomendado`,
	'pt-pt': `Recomendado`,
	ru: `Рекомендуем`,
	sm: `Fautuaina`,
	so: `Waxaa lagu taliyay`,
	th: `แนะนํา`,
	ur: `تجویز کردہ`,
	vi: `Đề xuất`,
	'zh-hans': `推荐阅读`,
	'zh-hant': `推薦`,
	en: `Recommended`
};

export const loc_recoveryCode: Record<Locale, string> = {
	ar: `رمز الاسترداد`,
	de: `Wiederherstellungscode`,
	es: `Código de recuperación`,
	fa: `کد بازیابی`,
	fil: `Code ng pagbawi`,
	fr: `Code de récupération`,
	hi: `पुनर्प्राप्ति कोड`,
	ht: `Kòd Recovery`,
	it: `Codice di recupero`,
	ja: `リカバリーコード`,
	ko: `복구 코드`,
	mww: `Rov qab code`,
	ps: `د بیا رغونې کوډ`,
	pt: `Código de recuperação`,
	'pt-pt': `Código de recuperação`,
	ru: `Код восстановления`,
	sm: `Numera o le toe faaleleia`,
	so: `Koodhka soo kabashada`,
	th: `รหัสกู้คืน`,
	ur: `ریکوری کوڈ`,
	vi: `Mã khôi phục`,
	'zh-hans': `恢复码`,
	'zh-hant': `復原代碼`,
	en: `Recovery code`
};

export const loc_redirectingEllipses: Record<Locale, string> = {
	ar: `إعادة توجيه...`,
	de: `Umleitung...`,
	es: `Redirigiendo...`,
	fa: `در حال تغییر مسیر...`,
	fil: `Pag-redirect ...`,
	fr: `Redirigeant...`,
	hi: `पुनर्निर्देशन...`,
	ht: `Redireksyon ...`,
	it: `Sto reindirizzando...`,
	ja: `方向転換...`,
	ko: `방향 전환 중...`,
	mww: `Redirecting...`,
	ps: `بیا لارښوونه کوم...`,
	pt: `Redirecionando...`,
	'pt-pt': `Redirecionar...`,
	ru: `Перенаправление...`,
	sm: `Toe fa'afo'i...`,
	so: `Dib u jihayn...`,
	th: `การเปลี่ยนเส้นทาง...`,
	ur: `ری ڈائریکٹ...`,
	vi: `Đang chuyển hướng...`,
	'zh-hans': `转向......`,
	'zh-hant': `轉移注意力......`,
	en: `Redirecting...`
};

export const loc_refer: Record<Locale, string> = {
	ar: `راجع`,
	de: `Siehe`,
	es: `Consulta`,
	fa: `مراجعه کنید`,
	fil: `Sumangguni`,
	fr: `Voir`,
	hi: `रेफर करना`,
	ht: `Al gade`,
	it: `Consulta`,
	ja: `参照`,
	ko: `참조`,
	mww: `Xa mus`,
	ps: `رجوع وکړئ`,
	pt: `Consulte`,
	'pt-pt': `Consulte`,
	ru: `См.`,
	sm: `Fa'asino`,
	so: `Tixraac`,
	th: `อ้างอิง`,
	ur: `حوالہ`,
	vi: `Tham khảo`,
	'zh-hans': `参考文献`,
	'zh-hant': `參考資料`,
	en: `Refer`
};

export const loc_referral: Record<Locale, string> = {
	ar: `الإحالة`,
	de: `Vermittlung`,
	es: `Recomendación`,
	fa: `ارجاع`,
	fil: `Email Address *`,
	fr: `Recommandation`,
	hi: `रेफरल`,
	ht: `Referans`,
	it: `Segnalazione`,
	ja: `紹介`,
	ko: `의뢰`,
	mww: `Kev xa mus rau`,
	ps: `راجع کول`,
	pt: `Encaminhamento`,
	'pt-pt': `Encaminhamento`,
	ru: `Направление`,
	sm: `Fa'asino`,
	so: `Tixraac`,
	th: `การอ้างอิง`,
	ur: `حوالہ`,
	vi: `Giới thiệu`,
	'zh-hans': `转诊`,
	'zh-hant': `轉介`,
	en: `Referral`
};

export const loc_regenerate: Record<Locale, string> = {
	ar: `التجديد`,
	de: `Regenerieren`,
	es: `Regenera`,
	fa: `بازسازی`,
	fil: `Muling Pagbuo`,
	fr: `Régénération`,
	hi: `पुन: उत्पन्न करें`,
	ht: `Rejenerasyon`,
	it: `Rigenerazione`,
	ja: `再生`,
	ko: `재생`,
	mww: `rov tsim dua tshiab`,
	ps: `بیا رغونه`,
	pt: `Regenerar`,
	'pt-pt': `Regenerar`,
	ru: `Регенерация`,
	sm: `Toe fa'afouina`,
	so: `Regenerate`,
	th: `ฟื้นฟู`,
	ur: `ری جنریٹ`,
	vi: `Tái tạo`,
	'zh-hans': `再生`,
	'zh-hant': `再生`,
	en: `Regenerate`
};

export const loc_regenerateRecoveryCode: Record<Locale, string> = {
	ar: `إعادة توليد رمز الاسترداد`,
	de: `Regenerieren von Wiederherstellungscode`,
	es: `Código de recuperación de regeneración`,
	fa: `بازسازی کد بازیابی`,
	fil: `Muling buuin ang code ng pagbawi`,
	fr: `Régénérer le code de récupération`,
	hi: `पुनर्प्राप्ति कोड पुन: उत्पन्न करें`,
	ht: `Rejenere kòd rekiperasyon`,
	it: `Rigenerare codice di recupero`,
	ja: `リカバリーコードを再生`,
	ko: `복구 코드 재생`,
	mww: `Regenerate rov qab code`,
	ps: `د بیا رغونې کوډ بیا تولید`,
	pt: `Código de recuperação de regeneração`,
	'pt-pt': `Regenerar código de recuperação`,
	ru: `Регенерировать код восстановления`,
	sm: `Toe faafouina le numera o le toe faaleleia`,
	so: `Dib u soo celi koodhka soo kabashada`,
	th: `สร้างรหัสการกู้คืนใหม่`,
	ur: `ریکوری کوڈ کو دوبارہ جنریٹ کریں`,
	vi: `Tạo lại mã khôi phục`,
	'zh-hans': `重新生成恢复码`,
	'zh-hant': `重新生成復原碼`,
	en: `Regenerate recovery code`
};

export const loc_regenerateRecoveryCodeDescription: Record<Locale, string> = {
	ar: `أعد توليد الكود الذي يمكنك استخدامه لتسجيل الدخول عندما لا يكون لديك وصول إلى جهاز أو أجهزة المصادقة الخاص بك.`,
	de: `Regeneriere den Code, mit dem du dich anmelden kannst, wenn du keinen Zugriff auf dein Authenticator-Gerät hast.`,
	es: `Regenera el código que puedes usar para iniciar sesión cuando no tengas acceso a tu(s) dispositivo(s) autenticador(es).`,
	fa: `کدی را که می توانید هنگام دسترسی به دستگاه(های) احراز هویت خود برای ورود استفاده کنید، دوباره تولید کنید.`,
	fil: `I-regenerate ang code na maaari mong gamitin upang mag-login kapag wala kang access sa iyong (mga) authenticator device.`,
	fr: `Régénérez le code que vous pouvez utiliser pour vous connecter lorsque vous n’avez pas accès à votre ou vos appareils authentificateurs.`,
	hi: `उस कोड को पुन: जनरेट करें जिसका उपयोग आप लॉगिन करने के लिए कर सकते हैं जब आपके पास अपने प्रमाणक डिवाइस तक पहुंच नहीं है।`,
	ht: `Rejenere kòd ou ka itilize pou konekte lè ou pa gen aksè a aparèy (yo) otantifikasyon ou a.`,
	it: `Rigenera il codice che puoi usare per accedere quando non hai accesso ai tuoi dispositivi autenticatori.`,
	ja: `認証デバイスにアクセスできないときにログインできるコードを再生成してください。`,
	ko: `인증 장치에 접근할 수 없을 때 로그인할 수 있는 코드를 다시 생성하세요.`,
	mww: `Rov tsim cov lej uas koj tuaj yeem siv los nkag mus thaum koj tsis muaj kev nkag mus rau koj lub cuab yeej (cov) authenticator.`,
	ps: `هغه کوډ بیا جوړ کړئ چې کله تاسو خپل تصدیق کوونکی وسایلو ته لاسرسی نه لرئ، د ننوتلو لپاره یې کارولی شئ.`,
	pt: `Regenere o código que você pode usar para fazer login quando não tiver acesso a(s) seu(s) dispositivo(s) autenticador(es).`,
	'pt-pt': `Regenere o código que pode usar para iniciar sessão quando não tiver acesso ao(s) seu(s) dispositivo(s) autenticador(es).`,
	ru: `Перегенерируйте код, который можно использовать для входа, если у вас нет доступа к устройству-аутентификатору.`,
	sm: `Toe fa'afouina le code e mafai ona e fa'aaogaina e login ai pe a leai sau avanoa i lau masini fa'amaonia.`,
	so: `Dib u soo celi koodhka aad u isticmaali karto inaad gasho marka aadan heli karin qalabka authenticator-kaaga.`,
	th: `สร้างรหัสใหม่ที่คุณสามารถใช้เพื่อเข้าสู่ระบบเมื่อคุณไม่สามารถเข้าถึงอุปกรณ์ยืนยันตัวตนของคุณได้`,
	ur: `وہ کوڈ دوبارہ جنریٹ کریں جسے آپ لاگ ان کرنے کے لیے استعمال کر سکتے ہیں جب آپ کے پاس اپنے آتھنٹیکیٹر ڈیوائسز تک رسائی نہ ہو۔`,
	vi: `Tạo lại mã bạn có thể sử dụng để đăng nhập khi bạn không có quyền truy cập vào (các) thiết bị xác thực của mình.`,
	'zh-hans': `重新生成你无法访问认证器设备时用来登录的代码。`,
	'zh-hant': `重新產生你無法使用驗證器裝置時可用來登入的程式碼。`,
	en: `Regenerate the code you can use to login when you do not have access to your authenticator device(s).`
};

export const loc_region: Record<Locale, string> = {
	ar: `المنطقة`,
	de: `Region`,
	es: `Región`,
	fa: `منطقه`,
	fil: `Rehiyon`,
	fr: `Région`,
	hi: `क्षेत्र`,
	ht: `Rejyon an`,
	it: `Regione`,
	ja: `地域`,
	ko: `지역`,
	mww: `Cheeb Tsam`,
	ps: `سیمه`,
	pt: `Região`,
	'pt-pt': `Região`,
	ru: `Регион`,
	sm: `Itulagi`,
	so: `Gobol`,
	th: `ภูมิภาค`,
	ur: `علاقہ`,
	vi: `Khu vực`,
	'zh-hans': `地区`,
	'zh-hant': `區域`,
	en: `Region`
};

export const loc_registrationCloses: Record<Locale, string> = {
	ar: `إغلاق التسجيل`,
	de: `Die Anmeldung schließt`,
	es: `Cierre de inscripciones`,
	fa: `ثبت نام بسته می شود`,
	fil: `Nagsasara ang pagpaparehistro`,
	fr: `Clôture des inscriptions`,
	hi: `पंजीकरण बंद हो जाता है`,
	ht: `Enskripsyon an fèmen`,
	it: `Chiusura delle iscrizioni`,
	ja: `登録締切`,
	ko: `등록 마감`,
	mww: `Kev sau npe kaw`,
	ps: `ثبت وتړل شو`,
	pt: `Encerramento das inscrições`,
	'pt-pt': `Encerramento do registo`,
	ru: `Регистрация закрывается`,
	sm: `Tapunia le lesitala`,
	so: `Diiwaangelintu way xirtay`,
	th: `ปิดรับสมัคร`,
	ur: `رجسٹریشن بند ہو گئی`,
	vi: `Đăng ký đóng`,
	'zh-hans': `报名截止`,
	'zh-hant': `報名截止`,
	en: `Registration closes`
};

export const loc_regular: Record<Locale, string> = {
	ar: `منتظم`,
	de: `Regulär`,
	es: `Regular`,
	fa: `منظم`,
	fil: `Regular`,
	fr: `Régulier`,
	hi: `नियमित सैनिक`,
	ht: `Regilye`,
	it: `Regolare`,
	ja: `レギュラー`,
	ko: `정규`,
	mww: `tsis tu ncua`,
	ps: `منظم`,
	pt: `Regular`,
	'pt-pt': `Regular`,
	ru: `Регулярные`,
	sm: `Masani`,
	so: `Joogto`,
	th: `ปกติ`,
	ur: `ریگولر`,
	vi: `Thường xuyên`,
	'zh-hans': `常规`,
	'zh-hant': `常規`,
	en: `Regular`
};

export const loc_related: Record<Locale, string> = {
	ar: `ذات صلة`,
	de: `Verwandte Themen`,
	es: `Relacionado`,
	fa: `مرتبط`,
	fil: `Kaugnay`,
	fr: `Connexe`,
	hi: `सम्बंधित`,
	ht: `Ki gen rapò ak`,
	it: `Correlati`,
	ja: `関連`,
	ko: `관련`,
	mww: `Muaj feem xyuam`,
	ps: `اړوند`,
	pt: `Relacionado`,
	'pt-pt': `Relacionado`,
	ru: `Связанное`,
	sm: `Feso'ota'iga`,
	so: `La xiriira`,
	th: `ที่เกี่ยวข้อง`,
	ur: `متعلقہ`,
	vi: `Sản phẩm liên quan`,
	'zh-hans': `相关`,
	'zh-hant': `相關`,
	en: `Related`
};

export const loc_releaseNotes: Record<Locale, string> = {
	ar: `ملاحظات الإصدار`,
	de: `Veröffentlichungsnotizen`,
	es: `Notas de lanzamiento`,
	fa: `یادداشت های انتشار`,
	fil: `Mga tala ng paglabas`,
	fr: `Notes de sortie`,
	hi: `रिलीज नोट्स`,
	ht: `nòt lage`,
	it: `Note di pubblicazione`,
	ja: `リリースノート`,
	ko: `출시 노트`,
	mww: `Cov ntawv tso tawm`,
	ps: `د خپرولو یادښتونه`,
	pt: `Notas de lançamento`,
	'pt-pt': `Notas de lançamento`,
	ru: `Примечания к релизу`,
	sm: `Fa'amatalaga fa'asalalau`,
	so: `Qoraallo sii deynta`,
	th: `บันทึกประจํารุ่น`,
	ur: `ریلیز نوٹس`,
	vi: `Ghi chú phát hành`,
	'zh-hans': `发行说明`,
	'zh-hant': `發行說明`,
	en: `Release notes`
};

export const loc_remind: Record<Locale, string> = {
	ar: `ذكر`,
	de: `Erinnere dich`,
	es: `Recuerda`,
	fa: `یادآوری کن`,
	fil: `Paalalahanan`,
	fr: `Rappeler`,
	hi: `याद कराना`,
	ht: `Sonje`,
	it: `Ricorda`,
	ja: `リマインド`,
	ko: `상기시켜 주세요`,
	mww: `nco ntsoov`,
	ps: `یادونه وکړه`,
	pt: `Lembre`,
	'pt-pt': `Lembrar`,
	ru: `Напомни`,
	sm: `Faamanatu`,
	so: `Xasuusi`,
	th: `เตือน`,
	ur: `یاد دلائیں`,
	vi: `Nhắc nhở`,
	'zh-hans': `提醒一下`,
	'zh-hant': `提醒一下`,
	en: `Remind`
};

export const loc_remittances: Record<Locale, string> = {
	ar: `تحويلات`,
	de: `Überweisungen`,
	es: `Remesas`,
	fa: `حواله ها`,
	fil: `Mga Remittances`,
	fr: `Envois de fonds`,
	hi: `प्रेषण`,
	ht: `Refè`,
	it: `Rimesse`,
	ja: `送金`,
	ko: `송금`,
	mww: `Cov nyiaj xa tawm`,
	ps: `لیږل شوی پیسې`,
	pt: `Remessas`,
	'pt-pt': `Remessas`,
	ru: `Денежные переводы`,
	sm: `Tupe Totogi`,
	so: `Diraacaada`,
	th: `การโอนเงิน`,
	ur: `ترسیلات زر`,
	vi: `Kiều hối`,
	'zh-hans': `汇款`,
	'zh-hant': `匯款`,
	en: `Remittances`
};

export const loc_remove: Record<Locale, string> = {
	ar: `إزالة`,
	de: `Entfernen`,
	es: `Eliminar`,
	fa: `حذف`,
	fil: `Alisin`,
	fr: `Retirer`,
	hi: `हटाना`,
	ht: `Retire`,
	it: `Rimuovere`,
	ja: `削除`,
	ko: `제거`,
	mww: `tshem tawm`,
	ps: `لرې کول`,
	pt: `Remover`,
	'pt-pt': `Remover`,
	ru: `Удалить`,
	sm: `Aveese`,
	so: `Ka saar`,
	th: `ลบ`,
	ur: `ہٹا دیا جائے`,
	vi: `Loại bỏ`,
	'zh-hans': `删除`,
	'zh-hant': `移除`,
	en: `Remove`
};

export const loc_removeAddress: Record<Locale, string> = {
	ar: `إزالة العنوان`,
	de: `Adresse entfernen`,
	es: `Eliminar dirección`,
	fa: `حذف آدرس`,
	fil: `Tanggalin ang address`,
	fr: `Supprimer l’adresse`,
	hi: `पता हटाना`,
	ht: `Retire adrès`,
	it: `Rimuovere indirizzo`,
	ja: `アドレスを削除`,
	ko: `주소 제거`,
	mww: `Tshem tawm qhov chaw nyob`,
	ps: `پته لرې کړه`,
	pt: `Remover endereço`,
	'pt-pt': `Remover endereço`,
	ru: `Удалить адрес`,
	sm: `Aveese le tuatusi`,
	so: `Ka saar cinwaanka`,
	th: `ลบที่อยู่`,
	ur: `پتہ ہٹا دیں`,
	vi: `Xóa địa chỉ`,
	'zh-hans': `删除地址`,
	'zh-hant': `移除地址`,
	en: `Remove address`
};

export const loc_removeConfirmation: Record<Locale, (title: unknown) => string> = {
	ar: (title) => `هل أنت متأكد أنك تريد إزالة ${title}؟`,
	de: (title) => `Bist du sicher, dass du ${title} entfernen möchtest?`,
	es: (title) => `¿Estás seguro de que quieres eliminar ${title}?`,
	fa: (title) => `مطمئنی می خواهی ${title} را حذف کنی؟`,
	fil: (title) => `Sigurado ka bang nais mong tanggalin ang ${title}?`,
	fr: (title) => `Êtes-vous sûr de vouloir supprimer ${title} ?`,
	hi: (title) => `क्या आप वाकई ${title} को हटाना चाहते हैं?`,
	ht: (title) => `Èske ou asire w ke ou vle retire ${title}?`,
	it: (title) => `Sei sicuro di voler rimuovere ${title}?`,
	ja: (title) => `本当に ${title}を削除したいですか?`,
	ko: (title) => `정말 ${title} 제거하고 싶으신가요?`,
	mww: (title) => `Koj puas paub tseeb tias koj xav tshem tawm ${title}?`,
	ps: (title) => `ته ډاډه یې چې ${title} لرې کړې؟`,
	pt: (title) => `Você tem certeza de que quer remover ${title}?`,
	'pt-pt': (title) => `Tem a certeza de que quer remover ${title}?`,
	ru: (title) => `Вы уверены, что хотите удалить ${title}?`,
	sm: (title) => `E te mautinoa e te mana'o e aveese le ${title}?`,
	so: (title) => `Ma hubtaa inaad rabto inaad ka saarto ${title}?`,
	th: (title) => `คุณแน่ใจหรือไม่ว่าต้องการลบ${title}`,
	ur: (title) => `کیا آپ واقعی ${title} کو ہٹانا چاہتے ہیں؟`,
	vi: (title) => `Bạn có chắc chắn muốn xóa ${title} không?`,
	'zh-hans': (title) => `你确定要移除 ${title}吗？`,
	'zh-hant': (title) => `你確定要移除 ${title}嗎？`,
	en: (title) => `Are you sure you want to remove ${title}?`
};

export const loc_removeContact: Record<Locale, string> = {
	ar: `إزالة الاتصال`,
	de: `Kontakt entfernen`,
	es: `Eliminar el contacto`,
	fa: `قطع تماس`,
	fil: `Tanggalin ang contact`,
	fr: `Coupez le contact`,
	hi: `संपर्क हटाएं`,
	ht: `Retire kontak`,
	it: `Rimuovere il contatto`,
	ja: `連絡を断つ`,
	ko: `연락을 끊으세요`,
	mww: `Tshem tawm kev sib cuag`,
	ps: `تماس لرې کړئ`,
	pt: `Remover contato`,
	'pt-pt': `Remover contacto`,
	ru: `Удалить контакт`,
	sm: `Aveese le fesootaiga`,
	so: `Ka saar xiriirka`,
	th: `ลบผู้ติดต่อ`,
	ur: `رابطہ ہٹا دیں`,
	vi: `Xóa liên hệ`,
	'zh-hans': `切断联系`,
	'zh-hant': `斷開聯絡`,
	en: `Remove contact`
};

export const loc_removeEmail: Record<Locale, string> = {
	ar: `إزالة البريد الإلكتروني`,
	de: `E-Mail entfernen`,
	es: `Eliminar el correo electrónico`,
	fa: `حذف ایمیل`,
	fil: `Email Address *`,
	fr: `Supprimer l’email`,
	hi: `ईमेल हटाएं`,
	ht: `Retire imèl`,
	it: `Rimuovi l'email`,
	ja: `メールを削除してください`,
	ko: `이메일 삭제`,
	mww: `Tshem tawm email`,
	ps: `ایمیل لرې کول`,
	pt: `Remover e-mail`,
	'pt-pt': `Remover email`,
	ru: `Удалить электронную почту`,
	sm: `Aveese imeli`,
	so: `Ka saar email-ka`,
	th: `ลบอีเมล`,
	ur: `ای میل ہٹا دیں`,
	vi: `Xóa email`,
	'zh-hans': `删除邮箱`,
	'zh-hant': `移除電子郵件`,
	en: `Remove email`
};

export const loc_removePhone: Record<Locale, string> = {
	ar: `إزالة الهاتف`,
	de: `Nimm das Handy weg`,
	es: `Quitar teléfono`,
	fa: `گوشی را حذف کنید`,
	fil: `Tanggalin ang telepono`,
	fr: `Supprimer le téléphone`,
	hi: `फ़ोन हटाएँ`,
	ht: `Retire telefòn`,
	it: `Rimuovi il telefono`,
	ja: `電話を取り除け`,
	ko: `휴대폰 제거`,
	mww: `Tshem tawm xov tooj`,
	ps: `تلیفون لرې کړه`,
	pt: `Remover o telefone`,
	'pt-pt': `Remover o telefone`,
	ru: `Удалить телефон`,
	sm: `Aveese le telefoni`,
	so: `Ka saar telefoonka`,
	th: `ลบโทรศัพท์`,
	ur: `فون ہٹا دیں`,
	vi: `Xóa điện thoại`,
	'zh-hans': `移除手机`,
	'zh-hant': `移除手機`,
	en: `Remove phone`
};

export const loc_removeSite: Record<Locale, string> = {
	ar: `إزالة الموقع`,
	de: `Entfernen der Website`,
	es: `Eliminar el sitio`,
	fa: `حذف سایت`,
	fil: `Tanggalin ang site`,
	fr: `Supprimer le site`,
	hi: `साइट हटाना`,
	ht: `Retire sit`,
	it: `Rimuovere il sito`,
	ja: `サイトを削除してください`,
	ko: `사이트 삭제`,
	mww: `Tshem tawm qhov chaw`,
	ps: `سایټ لرې کول`,
	pt: `Remover o site`,
	'pt-pt': `Remover o site`,
	ru: `Удалить сайт`,
	sm: `Aveese le saite`,
	so: `Ka saar goobta`,
	th: `ลบเว็บไซต์`,
	ur: `سائٹ ہٹا دیں`,
	vi: `Xóa trang web`,
	'zh-hans': `删除网站`,
	'zh-hant': `移除網站`,
	en: `Remove site`
};

export const loc_report: Record<Locale, string> = {
	ar: `التقرير`,
	de: `Bericht`,
	es: `Informe`,
	fa: `گزارش`,
	fil: `Ulat`,
	fr: `Rapport`,
	hi: `रिपोर्ट`,
	ht: `Rapò`,
	it: `Rapporto`,
	ja: `レポート`,
	ko: `리포트`,
	mww: `Daim ntawv qhia`,
	ps: `راپور`,
	pt: `Relatório`,
	'pt-pt': `Relatório`,
	ru: `Отчёт`,
	sm: `Lipoti`,
	so: `Warbixin`,
	th: `รายงาน`,
	ur: `رپورٹ`,
	vi: `Báo cáo`,
	'zh-hans': `报道`,
	'zh-hant': `賽事報導`,
	en: `Report`
};

export const loc_reportLinks: Record<Locale, string> = {
	ar: `روابط التقرير`,
	de: `Berichtslinks`,
	es: `Enlaces de reporte`,
	fa: `لینک های گزارش`,
	fil: `Email Address *`,
	fr: `Liens de rapport`,
	hi: `रिपोर्ट लिंक`,
	ht: `Rapò lyen`,
	it: `Link dei rapporti`,
	ja: `レポートリンク`,
	ko: `보고 링크`,
	mww: `Daim ntawv qhia txog kev sib txuas`,
	ps: `د راپور لینکونه`,
	pt: `Links de reportagem`,
	'pt-pt': `Links para reportar`,
	ru: `Ссылки на отчеты`,
	sm: `Lipoti feso'ota'iga`,
	so: `Xiriiriyeyaasha warbixinta`,
	th: `ลิงก์รายงาน`,
	ur: `رپورٹ کے روابط`,
	vi: `Đường liên kết báo cáo`,
	'zh-hans': `报告链接`,
	'zh-hant': `報告連結`,
	en: `Report links`
};

export const loc_reportReadonlyMessageForReader: Record<Locale, (entity: unknown, organization: unknown, role: unknown) => TemplateResult> = {
	ar: (entity, organization, role) => html`${entity} غير قابل للتعديل لأن دورك في <strong>${organization}</strong> هو <strong>${role}</strong>`,
	de: (entity, organization, role) => html`${entity} ist nicht bearbeitbar, weil deine Rolle in <strong>${organization}</strong> <strong>${role}</strong> ist`,
	es: (entity, organization, role) => html`El ${entity} no es editable porque tu rol en <strong>${organization}</strong> es <strong>${role}</strong>`,
	fa: (entity, organization, role) => html`${entity} قابل ویرایش نیست چون نقش شما در <strong>${organization}</strong> <strong>${role}</strong> است`,
	fil: (entity, organization, role) => html`Hindi mai-edit ang ${entity} dahil ang papel mo sa <strong>${organization}</strong> ay <strong>${role}</strong>`,
	fr: (entity, organization, role) => html`${entity} n’est pas modifiable car votre rôle dans <strong>${organization}</strong> est <strong>${role}</strong>`,
	hi: (entity, organization, role) => html`${entity} संपादन योग्य नहीं है क्योंकि <strong>${organization}</strong> में आपकी भूमिका <strong>${role}</strong> है`,
	ht: (entity, organization, role) => html`${entity} pa editable paske wòl ou nan <strong>${organization}</strong> se <strong>${role}</strong>`,
	it: (entity, organization, role) => html`Il ${entity} non è modificabile perché il tuo ruolo in <strong>${organization}</strong> è <strong>${role}</strong>`,
	ja: (entity, organization, role) => html`${entity}は編集できません。なぜなら、<strong>${organization}</strong>におけるあなたの役割は<strong>${role}</strong>だからです`,
	ko: (entity, organization, role) => html`${entity}는 편집할 수 없는데, 리<strong>${organization}</strong>에서 당신의 역할이 <strong>${role}</strong>이기 때문입니다`,
	mww: (entity, organization, role) => html`${entity} tsis tuaj yeem kho tau vim tias koj lub luag haujlwm hauv <strong>${organization}</strong> yog <strong>${role}</strong> Ntawv`,
	ps: (entity, organization, role) => html`${entity} ایډیټ کېدای نشی ځکه چې ستاسو رول <strong>${organization}</strong> <strong>${role}</strong> دی`,
	pt: (entity, organization, role) => html`${entity} não é editável porque seu papel na <strong>${organization}</strong> é <strong>${role}</strong>`,
	'pt-pt': (entity, organization, role) => html`${entity} não é editável porque o seu papel na <strong>${organization}</strong> é <strong>${role}</strong>`,
	ru: (entity, organization, role) => html`${entity} не подлежит редактированию, потому что ваша роль в <strong>${organization}</strong> — <strong>${role}</strong>`,
	sm: (entity, organization, role) => html`${entity} le mafai ona fa'asa'oina le lipoti aua o lau matafaioi i <strong>${organization}</strong> o <strong>${role}</strong>`,
	so: (entity, organization, role) => html`${entity} lama tafatiri karo sababtoo ah doorkaaga <strong>${organization}</strong> waa <strong>${role}</strong>`,
	th: (entity, organization, role) => html`${entity} ไม่สามารถแก้ไขได้เนื่องจากบทบาทของคุณใน <strong>${organization}</strong> คือ <strong>${role}</strong>`,
	ur: (entity, organization, role) => html`${entity} ایڈیٹنگ کے قابل نہیں کیونکہ <strong>${organization}</strong> میں <strong>${role}</strong> ہے`,
	vi: (entity, organization, role) => html`${entity} không thể chỉnh sửa được vì vai trò của bạn trong <strong>${organization}</strong> là <strong>${role}</strong>`,
	'zh-hans': (entity, organization, role) => html`${entity} 不可编辑，因为您在 <strong>${organization}</strong> 中的角色是 <strong>${role}</strong>`,
	'zh-hant': (entity, organization, role) => html`${entity} 不可編輯，因為您在 <strong>${organization}</strong> 的角色是 <strong>${role}</strong>`,
	en: (entity, organization, role) => html`${entity} is not editable because your role in <strong>${organization}</strong> is <strong>${role}</strong>`
};

export const loc_reportReadonlyMessageForWriter: Record<Locale, (entity: unknown) => TemplateResult> = {
	ar: (entity) => html`${entity} المشتركة لا يمكن تعديلها إلا من قبل منشئ المحتوى أو أعضاء منظمة المبدع الذين يكونون <strong>بدور المالك</strong> أو <strong>المسؤول</strong>.`,
	de: (entity) => html`Geteilte ${entity} können nur vom Ersteller oder von Mitgliedern der Organisation des Erstellers mit der <strong>Rolle Eigentümer</strong> oder <strong>Administrator</strong> bearbeitet werden.`,
	es: (entity) => html`Los ${entity} compartidos solo pueden ser editados por su creador o miembros de la organización del creador con el rol <strong>de Propietario</strong> o <strong>Administrador</strong> .`,
	fa: (entity) => html`${entity} های به اشتراک گذاشته شده فقط توسط خالق خود یا اعضای سازمان سازنده با نقش <strong>مالک</strong> یا <strong>مدیر</strong> قابل ویرایش هستند.`,
	fil: (entity) => html`Ang mga ibinahaging ${entity} ay maaaring i-edit lamang ng tagalikha nito o ng mga miyembro ng organisasyon ng tagalikha na may papel na <strong>May-ari</strong> o <strong>Admin</strong> .`,
	fr: (entity) => html`Les ${entity} partagés ne peuvent être modifiés que par leur créateur ou les membres de l’organisation du créateur ayant les rôles <strong>de Propriétaire</strong> ou <strong>d’Administrateur</strong> .`,
	hi: (entity) => html`साझा की गई ${entity} केवल उनके निर्माता या निर्माता के संगठन के सदस्यों द्वारा <strong>स्वामी या</strong> <strong>व्यवस्थापक</strong> भूमिका के साथ संपादित की जा सकती हैं.`,
	ht: (entity) => html`${entity} pataje yo sèlman editab pa kreyatè yo oswa manm nan òganizasyon kreyatè a ki gen wòl <strong>Pwopriyetè</strong> oswa <strong>Admin</strong>.`,
	it: (entity) => html`I ${entity} condivisi sono modificabili solo dal loro creatore o dai membri dell'organizzazione del creatore con il ruolo <strong>di Proprietario</strong> o <strong>Amministratore</strong> .`,
	ja: (entity) => html`共有 ${entity} は、作成者本人またはその組織のメンバーが <strong>所有者</strong> または <strong>管理者</strong> の役割を持つ者のみが編集可能です。`,
	ko: (entity) => html`공유 ${entity} 는 오직 창작자 또는 창작자 조직의 <strong>소유자</strong> 또는 <strong>관리자</strong> 역할의 회원만이 편집할 수 있습니다.`,
	mww: (entity) => html`Cov ${entity} sib koom tsuas yog kho tau los ntawm lawv tus tsim lossis cov tswv cuab ntawm tus tsim lub koom haum nrog <strong>Tus Tswv</strong> lossis <strong>Tus Thawj Tswj</strong> Hwm lub luag haujlwm.`,
	ps: (entity) => html`شریک ${entity} یوازې د خپل خالق یا د خالق د سازمان غړو لخوا چې <strong>مالک</strong> یا <strong>مدیر</strong> رول لری، ایډیټ کیدی شی.`,
	pt: (entity) => html`${entity} compartilhados só podem ser editados pelo criador ou membros da organização do criador com a função <strong>de Proprietário</strong> ou <strong>Administrador</strong>.`,
	'pt-pt': (entity) => html`${entity} partilhados só podem ser editados pelo criador ou membros da organização do criador com as funções <strong>de Proprietário</strong> ou <strong>Administrador</strong>.`,
	ru: (entity) => html`Общие ${entity} могут редактировать только их создатель или члены организации создателя с <strong>ролью Владельца</strong> или <strong>Администратора</strong> .`,
	sm: (entity) => html`O ${entity} fa'asoa e na'o le mafai ona fa'asa'oina e le latou foafoa po'o sui o le fa'alapotopotoga a le foafoa ma le <strong>Matafaioi</strong> a le Pule po'o le <strong>Pule.</strong>`,
	so: (entity) => html`${entity} la wadaago waxaa kaliya wax ka beddeli kara abuuraha ama xubnaha ururka abuuraha oo leh doorka <strong>Milkiilaha</strong> ama <strong>Maamulaha</strong>.`,
	th: (entity) => html`${entity}ที่แชร์จะแก้ไขได้โดยผู้สร้างหรือสมาชิกในองค์กรของครีเอเตอร์ที่มีบทบาท<strong>เป็นเจ้าของ</strong>หรือ<strong>ผู้ดูแลระบบ</strong>เท่านั้น`,
	ur: (entity) => html`شیئرڈ ${entity} صرف ان کے تخلیق کار یا تخلیق کار کی تنظیم کے ارکان کے ذریعے ایڈٹ کی جا سکتی ہیں جن کا <strong>کردار مالک</strong> یا <strong>ایڈمن</strong> کا کردار ہوتا ہے۔`,
	vi: (entity) => html`${entity} được chia sẻ chỉ có thể chỉnh sửa bởi người tạo hoặc thành viên trong tổ chức của người sáng tạo có vai trò <strong>Chủ sở hữu</strong> hoặc <strong>Quản trị viên</strong>.`,
	'zh-hans': (entity) => html`共享 ${entity} 只能由其创作者或其组织成员以 <strong>所有者</strong> 或 <strong>管理员</strong> 身份编辑。`,
	'zh-hant': (entity) => html`共享 ${entity} 僅能由創作者本人或其組織中以 <strong>擁有者</strong> 或 <strong>管理員</strong> 角色的成員編輯。`,
	en: (entity) => html`Shared ${entity} are only editable by their creator or members of the creator's organization with the <strong>Owner</strong> or <strong>Admin</strong> role.`
};

export const loc_reports: Record<Locale, string> = {
	ar: `التقارير`,
	de: `Berichte`,
	es: `Informes`,
	fa: `گزارش ها`,
	fil: `Mga Ulat`,
	fr: `Rapports`,
	hi: `रिपोर्ट`,
	ht: `Rapò yo`,
	it: `Rapporti`,
	ja: `報告書`,
	ko: `보고서`,
	mww: `Cov ntawv ceeb toom`,
	ps: `راپورونه`,
	pt: `Relatórios`,
	'pt-pt': `Relatórios`,
	ru: `Отчёты`,
	sm: `Lipoti`,
	so: `Warbixinno`,
	th: `รายงาน`,
	ur: `رپورٹس`,
	vi: `Báo cáo`,
	'zh-hans': `报告`,
	'zh-hant': `報告`,
	en: `Reports`
};

export const loc_requiredParens: Record<Locale, string> = {
	ar: `(مطلوب)`,
	de: `(Erforderlich)`,
	es: `(Obligatorio)`,
	fa: `(الزامی)`,
	fil: `(Kinakailangan)`,
	fr: `(Obligatoire)`,
	hi: `(आवश्यक)`,
	ht: `(Obligatwa)`,
	it: `(Richiesto)`,
	ja: `(必須)`,
	ko: `(필수)`,
	mww: `(Yuav tsum tau)`,
	ps: `(اړین دی)`,
	pt: `(Obrigatório)`,
	'pt-pt': `(Obrigatório)`,
	ru: `(Обязательно)`,
	sm: `(Mana'omia)`,
	so: `(Loo baahan yahay)`,
	th: `(จําเป็น)`,
	ur: `(ضروری)`,
	vi: `(Bắt buộc)`,
	'zh-hans': `（必修）`,
	'zh-hant': `（必修）`,
	en: `(Required)`
};

export const loc_requiredRecommendationValidationMessage: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `"${label}" مطلوبة ويجب إنشاؤها قبل تحديث حالة هذا السجل. التراجع عن التغيير إلى الحالة، الحفظ، ثم إنشاء "${label}" قبل محاولة تحديث حالة هذا السجل.`,
	de: (label) => `Eine "${label}" ist erforderlich und muss erstellt werden, bevor der Status dieses Datensatzes aktualisiert werden kann. Statusänderung rückgängig machen, speichern und dann "${label}" erstellen, bevor Sie versuchen, den Status dieses Datensatzes zu aktualisieren.`,
	es: (label) => `Se requiere la "${label}" y debe crearse antes de que se pueda actualizar el estado de este registro. Deshacer el cambio de estado, guardarlo y luego crear una "${label}" antes de intentar actualizar el estado de este registro.`,
	fa: (label) => `«${label} بودن» الزامی است و باید قبل از به روزرسانی وضعیت این رکورد ایجاد شود. قبل از تلاش برای به روزرسانی وضعیت این رکورد، تغییر وضعیت را لغو کنید، ذخیره کنید، سپس «${label}» را ایجاد کنید.`,
	fil: (label) => `Kinakailangan ang "${label}" at dapat likhain bago ma-update ang katayuan ng rekord na ito. I-undo ang pagbabago sa katayuan, i-save, pagkatapos ay lumikha ${label}" bago subukang i-update ang katayuan ng rekord na ito.`,
	fr: (label) => `La « ${label} » est requise et doit être créée avant que le statut de ce dossier puisse être mis à jour. Annulez le changement de statut, enregistrez, puis créez « ${label} » avant de tenter de mettre à jour le statut de ce dossier.`,
	hi: (label) => `"${label}" आवश्यक है और इस रिकॉर्ड की स्थिति को अपडेट करने से पहले इसे बनाया जाना चाहिए। स्थिति में परिवर्तन को पूर्ववत करें, सहेजें, फिर इस रिकॉर्ड की स्थिति को अद्यतन करने का प्रयास करने से पहले "पात्रता ${label}" बनाएं।`,
	ht: (label) => `"${label}" obligatwa epi yo dwe kreye anvan estati dosye sa a ka mete ajou. Defèt chanjman nan estati, sove, Lè sa a, kreye "${label}" anvan ou eseye mete ajou estati dosye sa a.`,
	it: (label) => `È richiesta la "${label}" che deve essere creata prima che lo stato di questo documento possa essere aggiornato. Annulla la modifica dello stato, salva, poi crea la "${label}" prima di tentare di aggiornare lo stato di questo registro.`,
	ja: (label) => `「${label}」が必要であり、この記録のステータスを更新する前に作成する必要があります。ステータスの変更を元に戻し、保存してから「${label}」を作成し、このレコードの状態を更新しようとします。`,
	ko: (label) => `"${label}서"가 필요하며, 이 기록의 상태를 갱신하기 전에 반드시 작성되어야 합니다. 상태 변경 취소 후 저장한 뒤, "${label}"을 생성한 후 이 기록의 상태를 업데이트하려고 시도하세요.`,
	mww: (label) => `Yuav tsum tau "${label}" thiab yuav tsum tau tsim ua ntej cov xwm txheej ntawm cov ntaub ntawv no tuaj yeem hloov kho. Thim rov qab hloov mus rau qhov xwm txheej, txuag, tom qab ntawd tsim "${label}" ua ntej sim hloov kho cov ntaub ntawv no.`,
	ps: (label) => `"${label}" اړین دی او باید جوړ شی مخکې له دې چې د دې ریکارډ حالت تازه شی. د حالت بدلون بیرته واخلئ، ذخیره کړئ، بیا "${label}" جوړ کړئ مخکې له دې چې د دې ریکارډ حالت تازه کړئ.`,
	pt: (label) => `A "${label}" é necessária e deve ser criada antes que o status deste registro possa ser atualizado. Desfaça a alteração de status, salve e depois crie a "${label}" antes de tentar atualizar o status deste registro.`,
	'pt-pt': (label) => `É necessária a "${label}" e deve ser criada antes que o estado deste registo possa ser atualizado. Desfaça a alteração de estado, guarde e depois crie a "${label}" antes de tentar atualizar o estado deste registo.`,
	ru: (label) => `Требуется «${label}» и должно быть создано до обновления статуса этой записи. Отмените изменение статуса, сохраните, затем создайте «${label} соответствие» перед попыткой обновить статус этой записи.`,
	sm: (label) => `E mana'omia le "${label}" ma e tatau ona fatuina a'o le'i mafai ona fa'afouina le tulaga o lenei fa'amaumauga. Faaleaogaina le suiga i le tulaga, sefe, ona fatu lea o le "${label} agavaa" a o lei taumafai e faafou le tulaga o lenei faamaumauga.`,
	so: (label) => `"${label}" waa in la abuuraa ka hor inta aan la cusbooneysiin xaaladda diiwaankan. Ka noqo beddelka xaaladda, kaydi, kadibna abuur "${label}" ka hor inta aan la isku dayin inaad cusbooneysiiso xaaladda diiwaankan.`,
	th: (label) => `จําเป็นต้องมี "${label}" และต้องสร้างขึ้นก่อนจึงจะสามารถอัปเดตสถานะของเรกคอร์ดนี้ได้ เลิกทําการเปลี่ยนแปลงสถานะ บันทึก จากนั้นสร้าง "${label}" ก่อนที่จะพยายามอัปเดตสถานะของเรกคอร์ดนี้`,
	ur: (label) => `"${label}" ضروری ہے اور اس ریکارڈ کی حیثیت کو اپ ڈیٹ کرنے سے پہلے اسے تیار کرنا ضروری ہے۔ اسٹیٹس میں تبدیلی کو واپس کریں، محفوظ کریں، پھر "${label}" بنائیں اس ریکارڈ کی حالت کو اپ ڈیٹ کرنے کی کوشش کرنے سے پہلے۔`,
	vi: (label) => `"${label}" là bắt buộc và phải được tạo trước khi có thể cập nhật trạng thái của hồ sơ này. Hoàn tác thay đổi trạng thái, lưu, sau đó tạo "${label}" trước khi cố gắng cập nhật trạng thái của bản ghi này.`,
	'zh-hans': (label) => `“${label}”是必需的，必须先创建，才能更新本记录状态。撤销状态更改，保存，然后创建“${label}”，再尝试更新该记录的状态。`,
	'zh-hant': (label) => `「${label}」必須先建立，才能更新本紀錄狀態。先還原狀態變更，儲存後建立「${label}」，再嘗試更新此紀錄狀態。`,
	en: (label) => `"${label}" is required and must be created before the status of this record can be updated. Undo change to status, save, then create "${label}" before attempting to update this record's status.`
};

export const loc_reset: Record<Locale, string> = {
	ar: `إعادة التعيين`,
	de: `Reset`,
	es: `Reinicio`,
	fa: `بازنشانی`,
	fil: `I-reset`,
	fr: `Réinitialisation`,
	hi: `रीसेट करें`,
	ht: `Reyajiste`,
	it: `Reset`,
	ja: `リセット`,
	ko: `리셋`,
	mww: `Rov pib dua`,
	ps: `بیا تنظیم`,
	pt: `Reiniciar`,
	'pt-pt': `Reiniciar`,
	ru: `Сброс`,
	sm: `Toe setiina`,
	so: `Dib u dejin`,
	th: `รีเซ็ต`,
	ur: `ری سیٹ کریں`,
	vi: `Xóa và làm lại`,
	'zh-hans': `重置`,
	'zh-hant': `重置`,
	en: `Reset`
};

export const loc_resetDefaultSignature: Record<Locale, string> = {
	ar: `إعادة تعيين التوقيع الافتراضي`,
	de: `Standardsignatur zurücksetzen`,
	es: `Restablecer firma predeterminada`,
	fa: `بازنشانی امضای پیش فرض`,
	fil: `I-reset ang default na lagda`,
	fr: `Réinitialiser la signature par défaut`,
	hi: `डिफ़ॉल्ट हस्ताक्षर रीसेट करें`,
	ht: `Reyajiste default siyati`,
	it: `Reset della firma predefinita`,
	ja: `デフォルト署名をリセットする`,
	ko: `기본 서명 재설정`,
	mww: `Rov pib dua lub neej ntawd kos npe`,
	ps: `اصلی لاسلیک بیا تنظیم کړئ`,
	pt: `Redefinir assinatura padrão`,
	'pt-pt': `Redefinir assinatura por defeito`,
	ru: `Сбросить стандартную подпись`,
	sm: `Toe seti le saini faaletonu`,
	so: `Dib u celi saxiixa caadiga ah`,
	th: `รีเซ็ตลายเซ็นเริ่มต้น`,
	ur: `ڈیفالٹ دستخط کو ری سیٹ کریں`,
	vi: `Đặt lại chữ ký mặc định`,
	'zh-hans': `重置默认签名`,
	'zh-hant': `重設預設簽章`,
	en: `Reset default signature`
};

export const loc_resolveAddressGeolocation: Record<Locale, (preciseLocation: unknown) => string> = {
	ar: (preciseLocation) => `لحل هذه المشكلة، قم بتعديل العنوان الفعلي الأساسي واختيار اقتراح صالح ليظهر مؤشر "${preciseLocation}".`,
	de: (preciseLocation) => `Um dieses Problem zu lösen, bearbeite die primäre physische Adresse und wähle einen gültigen Vorschlag aus, sodass der Indikator "${preciseLocation}" erscheint.`,
	es: (preciseLocation) => `Para resolver este problema, edita la dirección física principal y selecciona una sugerencia válida para que aparezca el indicador "${preciseLocation}".`,
	fa: (preciseLocation) => `برای حل این مشکل، آدرس فیزیکی اصلی را ویرایش کنید و یک پیشنهاد معتبر انتخاب کنید تا شاخص «${preciseLocation}» ظاهر شود.`,
	fil: (preciseLocation) => `Upang malutas ang isyung ito, i-edit ang pangunahing pisikal na address at pumili ng valid na mungkahi upang lumabas ang indicator na "${preciseLocation}".`,
	fr: (preciseLocation) => `Pour résoudre ce problème, modifiez l’adresse physique principale et sélectionnez une suggestion valide afin que l’indicateur « ${preciseLocation} » apparaisse.`,
	hi: (preciseLocation) => `इस समस्या को हल करने के लिए, प्राथमिक भौतिक पते को संपादित करें और एक मान्य सुझाव का चयन करें ताकि "${preciseLocation}" संकेतक दिखाई दे।`,
	ht: (preciseLocation) => `Pou rezoud pwoblèm sa a, edite adrès fizik prensipal la epi chwazi yon sijesyon ki valab pou endikatè "${preciseLocation}" la parèt.`,
	it: (preciseLocation) => `Per risolvere questo problema, modifica l'indirizzo fisico principale e seleziona un suggerimento valido in modo che appaia l'indicatore "${preciseLocation}".`,
	ja: (preciseLocation) => `この問題を解決するには、プライマリの物理アドレスを編集し、「${preciseLocation}」インジケーターが表示される有効な提案を選択してください。`,
	ko: (preciseLocation) => `이 문제를 해결하려면 기본 물리적 주소를 편집하고 유효한 제안을 선택하여 "${preciseLocation}" 표시가 나타납니다.`,
	mww: (preciseLocation) => `Txhawm rau daws qhov teeb meem no, kho qhov chaw nyob tseem ceeb thiab xaiv ib qho kev pom zoo kom muaj "${preciseLocation}" qhia.`,
	ps: (preciseLocation) => `د دې ستونزې د حل لپاره، اصلی فزیکی پته ایډیټ کړئ او یو معتبر وړاندیز وټاکئ ترڅو د "${preciseLocation}" نښه ښکاره شی.`,
	pt: (preciseLocation) => `Para resolver esse problema, edite o endereço físico principal e selecione uma sugestão válida para que o indicador "${preciseLocation}" apareça.`,
	'pt-pt': (preciseLocation) => `Para resolver este problema, edite o endereço físico principal e selecione uma sugestão válida para que apareça o indicador "${preciseLocation}".`,
	ru: (preciseLocation) => `Чтобы решить эту проблему, отредактируйте основной физический адрес и выберите допустимое предложение, чтобы появился индикатор «${preciseLocation}».`,
	sm: (preciseLocation) => `Ina ia foia lenei faafitauli, faasa'o le tuatusi autu faaletino ma filifili se fautuaga aoga ina ia faaali mai le faailo o le "${preciseLocation}".`,
	so: (preciseLocation) => `Si arrintan loo xalliyo, wax ka beddel cinwaanka jireed ee ugu muhiimsan oo dooro talo sax ah si uu u muuqdo tilmaamaha "${preciseLocation}".`,
	th: (preciseLocation) => `เพื่อแก้ไขปัญหานี้ ให้แก้ไขที่อยู่ทางกายภาพหลักและเลือกคําแนะนําที่ถูกต้องเพื่อให้แสดงตัวบ่งชี้ "${preciseLocation}" ปรากฏขึ้น`,
	ur: (preciseLocation) => `اس مسئلے کو حل کرنے کے لیے، پرائمری فزیکل ایڈریس ایڈٹ کریں اور ایک درست تجویز منتخب کریں تاکہ "${preciseLocation}" انڈیکیٹر ظاہر ہو۔`,
	vi: (preciseLocation) => `Để giải quyết vấn đề này, hãy chỉnh sửa địa chỉ vật lý chính và chọn một gợi ý hợp lệ để chỉ báo "${preciseLocation}" xuất hiện.`,
	'zh-hans': (preciseLocation) => `要解决这个问题，请编辑主地址并选择一个有效的建议，使“${preciseLocation}”指示器出现。`,
	'zh-hant': (preciseLocation) => `要解決這個問題，請編輯主要實體地址並選擇有效的建議，讓「${preciseLocation}」指示器出現。`,
	en: (preciseLocation) => `To resolve this issue, edit the primary physical address and select a valid suggestion so the “${preciseLocation}” indicator appears.`
};

export const loc_resources: Record<Locale, string> = {
	ar: `الموارد`,
	de: `Ressourcen`,
	es: `Recursos`,
	fa: `منابع`,
	fil: `Mga Mapagkukunan`,
	fr: `Ressources`,
	hi: `उपयुक्त संसाधन चुनें`,
	ht: `Resous yo`,
	it: `Risorse`,
	ja: `資料`,
	ko: `자료`,
	mww: `Cov peev txheej`,
	ps: `سرچینې`,
	pt: `Recursos`,
	'pt-pt': `Recursos`,
	ru: `Ресурсы`,
	sm: `Punaoa`,
	so: `Ilo`,
	th: `แหล่งข้อมูล`,
	ur: `وسائل`,
	vi: `Tài nguyên`,
	'zh-hans': `资源`,
	'zh-hant': `資源`,
	en: `Resources`
};

export const loc_responses: Record<Locale, string> = {
	ar: `الردود`,
	de: `Antworten`,
	es: `Respuestas`,
	fa: `پاسخ ها`,
	fil: `Mga tugon`,
	fr: `Réponses`,
	hi: `जवाब`,
	ht: `Repons yo`,
	it: `Risposte`,
	ja: `回答`,
	ko: `반응`,
	mww: `Cov lus teb`,
	ps: `ځوابونه`,
	pt: `Respostas`,
	'pt-pt': `Respostas`,
	ru: `Ответы`,
	sm: `Tali`,
	so: `Jawaabaha`,
	th: `คําตอบ`,
	ur: `جوابات`,
	vi: `Câu trả lời`,
	'zh-hans': `回应`,
	'zh-hant': `回應`,
	en: `Responses`
};

export const loc_review: Record<Locale, string> = {
	ar: `مراجعة`,
	de: `Rezension`,
	es: `Reseña`,
	fa: `بررسی`,
	fil: `Repasuhin`,
	fr: `Critique`,
	hi: `समीक्षा`,
	ht: `Revizyon`,
	it: `Recensione`,
	ja: `レビュー`,
	ko: `리뷰`,
	mww: `Kev Ntsuam Xyuas`,
	ps: `بیاکتنه`,
	pt: `Análise`,
	'pt-pt': `Crítica`,
	ru: `Обзор`,
	sm: `Iloiloga`,
	so: `Dib u eegis`,
	th: `ทบทวน`,
	ur: `جائزہ`,
	vi: `Đánh giá`,
	'zh-hans': `影评`,
	'zh-hant': `評論`,
	en: `Review`
};

export const loc_reviewAndEditInstructions: Record<Locale, string> = {
	ar: `راجع وحرر باستخدام العارض على اليسار.`,
	de: `Überprüfen und bearbeiten Sie mit dem Betrachter links.`,
	es: `Revisa y edita usando el visor de la izquierda.`,
	fa: `بازبینی و ویرایش با استفاده از نمایشگر سمت چپ.`,
	fil: `Suriin at i-edit gamit ang viewer sa kaliwa.`,
	fr: `Examinez et éditez en utilisant le visualiseur à gauche.`,
	hi: `बाईं ओर के व्यूअर का इस्तेमाल करके समीक्षा करें और उसमें बदलाव करें.`,
	ht: `Revize ak modifye lè l sèvi avèk visualiseur a sou bò gòch la.`,
	it: `Rivedi e modifica usando il visualizzatore a sinistra.`,
	ja: `左側のビューアーを使ってレビューと編集を行います。`,
	ko: `왼쪽 뷰어를 사용해 검토하고 편집하세요.`,
	mww: `Xyuas thiab hloov siv tus saib rau sab laug.`,
	ps: `د کیڼ اړخ لیدونکی په کارولو سره بیاکتنه او ایډیټ کړئ.`,
	pt: `Revise e edite usando o visualizador à esquerda.`,
	'pt-pt': `Revê e edita usando o visualizador à esquerda.`,
	ru: `Просматривайте и редактируйте с помощью зрителя слева.`,
	sm: `Toe iloilo ma faasa'o e faaaoga ai le tagata matamata i le itu tauagavale.`,
	so: `Dib u eegis iyo tafatir adigoo adeegsanaya daawadayaasha bidixda.`,
	th: `ตรวจสอบและแก้ไขโดยใช้โปรแกรมดูทางด้านซ้าย`,
	ur: `بائیں طرف والے ویوئر کا استعمال کرتے ہوئے جائزہ اور ترمیم کریں۔`,
	vi: `Xem lại và chỉnh sửa bằng trình xem ở bên trái.`,
	'zh-hans': `请使用左侧的查看器进行审核和编辑。`,
	'zh-hant': `請使用左側的檢視器檢視並編輯。`,
	en: `Review and edit using the viewer on the left.`
};

export const loc_reviewAndSubmit: Record<Locale, string> = {
	ar: `مراجعة وتقديم`,
	de: `Überprüfen und reichen Sie ein`,
	es: `Revisar y enviar`,
	fa: `بازبینی و ارسال`,
	fil: `Suriin at isumite`,
	fr: `Examiner et soumettre`,
	hi: `समीक्षा करें और सबमिट करें`,
	ht: `Revize epi soumèt`,
	it: `Revisiona e invia`,
	ja: `審査と提出`,
	ko: `검토 및 제출`,
	mww: `Txheeb xyuas thiab xa`,
	ps: `بیاکتنه او سپارل`,
	pt: `Revise e envie`,
	'pt-pt': `Rever e submeter`,
	ru: `Просмотр и отправка`,
	sm: `Iloilo ma auina atu`,
	so: `Dib u eeg oo soo gudbi`,
	th: `ตรวจสอบและส่ง`,
	ur: `جائزہ لیں اور جمع کرائیں`,
	vi: `Xem xét và gửi`,
	'zh-hans': `审核并提交`,
	'zh-hant': `審核並提交`,
	en: `Review and submit`
};

export const loc_reviewTimesheet: Record<Locale, string> = {
	ar: `جدول المراجعة`,
	de: `Überprüfungs-Stundenzettel`,
	es: `Hoja de horas de revisión`,
	fa: `جدول زمانی مرور`,
	fil: `Suriin ang timesheet`,
	fr: `Feuille de temps de révision`,
	hi: `टाइमशीट की समीक्षा करें`,
	ht: `Revize Timesheet`,
	it: `Foglio orario di revisione`,
	ja: `復習タイムシート`,
	ko: `복습 시간표`,
	mww: `Txheeb xyuas daim ntawv teev sijhawm`,
	ps: `د بیاکتنې وخت پاڼه`,
	pt: `Revisar a folha de ponto`,
	'pt-pt': `Revisão da folha de horas`,
	ru: `Табель повторения`,
	sm: `Toe iloilo le pepa o taimi`,
	so: `Waqtiga dib-u-eegista`,
	th: `ตรวจสอบไทม์ชีท`,
	ur: `جائزہ ٹائم شیٹ`,
	vi: `Xem lại bảng chấm công`,
	'zh-hans': `复习时间表`,
	'zh-hant': `回顧時間表`,
	en: `Review timesheet`
};

export const loc_roleReadOnlyMessage: Record<Locale, string> = {
	ar: `دورك لا يسمح لك بتحرير هذا السجل.`,
	de: `Ihre Rolle erlaubt es Ihnen nicht, diesen Datensatz zu bearbeiten.`,
	es: `Tu función no te permite editar este registro.`,
	fa: `نقش شما اجازه ویرایش این پرونده را نمی دهد.`,
	fil: `Hindi ka pinapayagan ng iyong tungkulin na i-edit ang talaang ito.`,
	fr: `Votre rôle ne vous permet pas de modifier ce dossier.`,
	hi: `आपकी भूमिका आपको इस रिकॉर्ड को संपादित करने की अनुमति नहीं देती है.`,
	ht: `Wòl ou pa pèmèt ou edite dosye sa a.`,
	it: `Il tuo ruolo non ti permette di modificare questo registro.`,
	ja: `あなたの役割ではこの記録を編集することはできません。`,
	ko: `당신의 역할상 이 기록을 편집할 수 없습니다.`,
	mww: `Koj lub luag haujlwm tsis tso cai rau koj los kho cov ntaub ntawv no.`,
	ps: `ستاسو رول تاسو ته اجازه نه درکوی چې دا ریکارډ ایډیټ کړئ.`,
	pt: `Seu cargo não permite que você edite este registro.`,
	'pt-pt': `O seu cargo não lhe permite editar este registo.`,
	ru: `Ваша роль не позволяет вам редактировать эту запись.`,
	sm: `E le faatagaina oe e lau matafaioi ona faasa'o lenei faamaumauga.`,
	so: `Doorkaaga ma ogola inaad tafatirto rikoodhkan.`,
	th: `บทบาทของคุณไม่อนุญาตให้คุณแก้ไขเรกคอร์ดนี้`,
	ur: `آپ کا کردار آپ کو اس ریکارڈ میں ترمیم کرنے کی اجازت نہیں دیتا۔`,
	vi: `Vai trò của bạn không cho phép bạn chỉnh sửa bản ghi này.`,
	'zh-hans': `你的职责不允许你编辑这份记录。`,
	'zh-hant': `你的職務不允許你編輯此紀錄。`,
	en: `Your role does not permit you to edit this record.`
};

export const loc_rooftopX: Record<Locale, string> = {
	ar: `روفتوب إكس`,
	de: `Rooftop X`,
	es: `Azotea X`,
	fa: `روف تاپ ایکس`,
	fil: `Bubong X`,
	fr: `Toit X`,
	hi: `रूफटॉप एक्स`,
	ht: `Do kay X`,
	it: `Tetto X`,
	ja: `ルーフトップX`,
	ko: `루프탑 X`,
	mww: `Lub ru tsev X`,
	ps: `روفټاپ ایکس`,
	pt: `Rooftop X`,
	'pt-pt': `Telhado X`,
	ru: `Rooftop X`,
	sm: `Taualuga X`,
	so: `Saqafka X`,
	th: `รูฟท็อป X`,
	ur: `روف ٹاپ ایکس`,
	vi: `Tầng thượng X`,
	'zh-hans': `屋顶X`,
	'zh-hant': `屋頂X`,
	en: `Rooftop X`
};

export const loc_rooftopY: Record<Locale, string> = {
	ar: `سطح Y`,
	de: `Decke Y`,
	es: `Azotea Y`,
	fa: `پشت بام وای`,
	fil: `Bubong Y`,
	fr: `Toit Y`,
	hi: `रूफटॉप वाई`,
	ht: `Do-kay Y`,
	it: `Tetto Y`,
	ja: `屋上Y`,
	ko: `옥상 Y`,
	mww: `Ru tsev Y`,
	ps: `چت Y`,
	pt: `Telhado Y`,
	'pt-pt': `Telhado Y`,
	ru: `Крыша Y`,
	sm: `Taualuga Y`,
	so: `Saqafka Y`,
	th: `รูฟท็อป Y`,
	ur: `چھت Y`,
	vi: `Tầng thượng Y`,
	'zh-hans': `屋顶Y型`,
	'zh-hant': `屋頂Y型`,
	en: `Rooftop Y`
};

export const loc_sameAsConsumer: Record<Locale, string> = {
	ar: `نفس الشيء كمستهلك (موجه ذاتيا)`,
	de: `Dasselbe wie Konsument (selbstgesteuert)`,
	es: `Lo mismo que el consumidor (autodirigido)`,
	fa: `همانند مصرف کننده (خودگردان)`,
	fil: `Katulad ng mamimili (self-directed)`,
	fr: `C’est pareil pour le consommateur (auto-dirigé)`,
	hi: `उपभोक्ता के समान (स्व-निर्देशित)`,
	ht: `Menm jan ak konsomatè (pwòp tèt ou-dirije)`,
	it: `Stessa cosa per il consumatore (autogestito)`,
	ja: `消費者(自己主導型)と同じです`,
	ko: `소비자(자율)와 동일합니다`,
	mww: `Tib yam li tus neeg tau txais kev pab (tus kheej)`,
	ps: `د مصرف کوونکی (خپلواکه لارښوونه) په څېر`,
	pt: `O mesmo que o consumidor (autodirigido)`,
	'pt-pt': `O mesmo que o consumidor (autodirigido)`,
	ru: `То же самое, что и потребитель (самостоятельный)`,
	sm: `E pei lava o le tagata fa'atau (fa'atonutonu e le tagata lava ia)`,
	so: `Sida macaamiisha (is-maamul)`,
	th: `เช่นเดียวกับผู้บริโภค (กํากับตนเอง)`,
	ur: `صارف (خود ہدایت کار) کی طرح`,
	vi: `Tương tự như người tiêu dùng (tự định hướng)`,
	'zh-hans': `和消费者（自我导向）一样`,
	'zh-hant': `和消費者（自我導向）一樣`,
	en: `Same as consumer (self-directed)`
};

export const loc_save: Record<Locale, string> = {
	ar: `حفظ`,
	de: `Speichern`,
	es: `Salvar`,
	fa: `ذخیره`,
	fil: `I-save`,
	fr: `Sauvegarder`,
	hi: `सहेजें`,
	ht: `Sove`,
	it: `Salva`,
	ja: `セーブ`,
	ko: `저장`,
	mww: `txuag`,
	ps: `ژغورنه`,
	pt: `Salvar`,
	'pt-pt': `Guardar`,
	ru: `Сохранить`,
	sm: `Sefe`,
	so: `Badbaadi`,
	th: `บันทึก`,
	ur: `سیو`,
	vi: `Lưu`,
	'zh-hans': `保存`,
	'zh-hant': `存檔`,
	en: `Save`
};

export const loc_saveAndAddAnother: Record<Locale, string> = {
	ar: `احفظ وأضف آخر`,
	de: `Speichere und füge einen weiteren hinzu`,
	es: `Guardar y añadir otro`,
	fa: `ذخیره کنید و یکی دیگر اضافه کنید`,
	fil: `I-save at magdagdag ng isa pa`,
	fr: `Sauvegarder et ajouter un autre`,
	hi: `सहेजें और एक और जोड़ें`,
	ht: `Sove & ajoute yon lòt`,
	it: `Salva e aggiungine un'altra`,
	ja: `保存して別のものを追加してください`,
	ko: `저장 후 다른 사람 추가하기`,
	mww: `Txuag & ntxiv lwm`,
	ps: `خوندی کړه او بل اضافه کړه`,
	pt: `Salvar e adicionar outro`,
	'pt-pt': `Guardar e adicionar outro`,
	ru: `Сохраните и добавьте ещё один`,
	sm: `Sefe ma faaopoopo se isi`,
	so: `Kaydi oo ku dar mid kale`,
	th: `บันทึกและเพิ่มอีก`,
	ur: `محفوظ کریں اور ایک اور شامل کریں`,
	vi: `Lưu và thêm một`,
	'zh-hans': `保存并添加另一个`,
	'zh-hant': `儲存並新增另一個`,
	en: `Save & add another`
};

export const loc_saveDraft: Record<Locale, string> = {
	ar: `مسودة الحفظ`,
	de: `Wehrpflicht speichern`,
	es: `Borrador de salvación`,
	fa: `درفت ذخیره`,
	fil: `I-save ang draft`,
	fr: `Draft de sauvegarde`,
	hi: `ड्राफ्ट सहेजें`,
	ht: `Sove bouyon`,
	it: `Salvezza draft`,
	ja: `セーブドラフト`,
	ko: `세이브 드래프트`,
	mww: `Txuag draft`,
	ps: `د خوندی کولو مسوده`,
	pt: `Salve o rascunho`,
	'pt-pt': `Draft de salvamento`,
	ru: `Сохранение черновика`,
	sm: `Sefe le ata`,
	so: `Save draft`,
	th: `บันทึกแบบร่าง`,
	ur: `سیو ڈرافٹ`,
	vi: `Lưu bản nháp`,
	'zh-hans': `保存选秀`,
	'zh-hant': `儲存選秀`,
	en: `Save draft`
};

export const loc_saveTimesheet: Record<Locale, string> = {
	ar: `سجل الحفظ`,
	de: `Stundenzettel speichern`,
	es: `Hoja de horas de ahorro`,
	fa: `برگه زمان ذخیره`,
	fil: `I-save ang timesheet`,
	fr: `Feuille de temps économisée`,
	hi: `टाइमशीट सहेजें`,
	ht: `Save Timesheet`,
	it: `Risparmia il foglio di tempo`,
	ja: `保存タイムシート`,
	ko: `타임시트 저장`,
	mww: `Txuag daim ntawv teev sijhawm`,
	ps: `د وخت پاڼه خوندی کړه`,
	pt: `Folha de ponto para economizar`,
	'pt-pt': `Poupar folha de horas`,
	ru: `Сохранить табель хранения времени`,
	sm: `Sefe le pepa o taimi`,
	so: `Kaydi waqti`,
	th: `บันทึกไทม์ชีท`,
	ur: `ٹائم شیٹ محفوظ کریں`,
	vi: `Lưu bảng chấm công`,
	'zh-hans': `保存时间表`,
	'zh-hant': `儲存時間表`,
	en: `Save timesheet`
};

export const loc_scrollToTop: Record<Locale, string> = {
	ar: `التمرير إلى الأعلى`,
	de: `Scroll nach oben`,
	es: `Desplázate hasta arriba`,
	fa: `اسکرول به بالا`,
	fil: `Mag-scroll sa itaas`,
	fr: `Défiler vers le haut`,
	hi: `शीर्ष पर स्क्रॉल करें`,
	ht: `Scroll nan tèt`,
	it: `Scorri fino in alto`,
	ja: `スクロールしてトップへ`,
	ko: `맨 위로 스크롤`,
	mww: `Scroll mus rau sab saum`,
	ps: `پورته ته سکرول کړئ`,
	pt: `Rolar até o topo`,
	'pt-pt': `Deslocar até ao topo`,
	ru: `Прокрутите наверх`,
	sm: `Tusi i le pito i luga`,
	so: `U rog sare`,
	th: `เลื่อนไปด้านบน`,
	ur: `اوپر سکرول کریں`,
	vi: `Di chuyển lên đầu trang`,
	'zh-hans': `滚动到顶部`,
	'zh-hant': `往上捲動`,
	en: `Scroll to top`
};

export const loc_scsepParticipantId: Record<Locale, string> = {
	ar: `معرف المشاركين SCSEP`,
	de: `SCSEP-Teilnehmer-ID`,
	es: `ID de participante SCSEP`,
	fa: `شناسه شرکت کننده SCSEP`,
	fil: `ID ng Kalahok ng SCSEP`,
	fr: `Identifiant participant SCSEP`,
	hi: `एससीएसईपी प्रतिभागी आईडी`,
	ht: `ID patisipan SCSEP`,
	it: `ID partecipante SCSEP`,
	ja: `SCSEP参加者ID`,
	ko: `SCSEP 참가자 ID`,
	mww: `SCSEP Tus Neeg Koom Daim ID`,
	ps: `د SCSEP ګډونوال ID`,
	pt: `ID de Participante SCSEP`,
	'pt-pt': `ID de participante SCSEP`,
	ru: `Идентификатор участника SCSEP`,
	sm: `SCSEP ID Tagata Auai`,
	so: `Aqoonsiga Ka-qaybgalaha SCSEP`,
	th: `รหัสผู้เข้าร่วม SCSEP`,
	ur: `SCSEP شرکاء کی شناخت`,
	vi: `ID người tham gia SCSEP`,
	'zh-hans': `SCSEP参与者ID`,
	'zh-hant': `SCSEP 參與者識別碼`,
	en: `SCSEP Participant ID`
};

export const loc_search: Record<Locale, string> = {
	ar: `البحث`,
	de: `Suche`,
	es: `Búsqueda`,
	fa: `جستجو`,
	fil: `Paghahanap`,
	fr: `Recherche`,
	hi: `खोज`,
	ht: `Rechèch`,
	it: `Ricerca`,
	ja: `検索`,
	ko: `검색`,
	mww: `Tshawb nrhiav`,
	ps: `لټون`,
	pt: `Busca`,
	'pt-pt': `Pesquisa`,
	ru: `Поиск`,
	sm: `Saili`,
	so: `Raadinta`,
	th: `ค้นหา`,
	ur: `تلاش`,
	vi: `Tìm kiếm`,
	'zh-hans': `搜索`,
	'zh-hant': `搜尋`,
	en: `Search`
};

export const loc_searchByCodeOrDesc: Record<Locale, string> = {
	ar: `البحث حسب الرمز أو الوصف`,
	de: `Suche nach Code oder Beschreibung`,
	es: `Buscar por código o descripción`,
	fa: `جستجو بر اساس کد یا توصیف`,
	fil: `Maghanap sa pamamagitan ng code o paglalarawan`,
	fr: `Recherche par code ou description`,
	hi: `कोड या विवरण के आधार पर खोजें`,
	ht: `Search pa kòd oswa deskripsyon`,
	it: `Cerca per codice o descrizione`,
	ja: `コードまたは説明による検索`,
	ko: `코드 또는 설명으로 검색`,
	mww: `Tshawb nrhiav los ntawm tus lej lossis cov lus piav qhia`,
	ps: `د کوډ یا تشریح له مخې لټون`,
	pt: `Busque por código ou descrição`,
	'pt-pt': `Pesquisa por código ou descrição`,
	ru: `Поиск по коду или описанию`,
	sm: `Saili e ala i le code po o le faamatalaga`,
	so: `Raadi koodh ama sharaxaad`,
	th: `ค้นหาตามรหัสหรือคําอธิบาย`,
	ur: `کوڈ یا تفصیل کے ذریعے تلاش کریں`,
	vi: `Tìm kiếm theo mã hoặc mô tả`,
	'zh-hans': `按代码或描述搜索`,
	'zh-hant': `依代碼或描述搜尋`,
	en: `Search by code or description`
};

export const loc_searchByTitle: Record<Locale, string> = {
	ar: `البحث حسب العنوان`,
	de: `Suche nach Titel`,
	es: `Buscar por título`,
	fa: `جستجو بر اساس عنوان`,
	fil: `Maghanap ayon sa pamagat`,
	fr: `Recherche par titre`,
	hi: `शीर्षक के आधार पर खोजें`,
	ht: `Rechèch pa`,
	it: `Ricerca per titolo`,
	ja: `タイトルによる検索`,
	ko: `제목별 검색`,
	mww: `Tshawb nrhiav los ntawm lub npe`,
	ps: `د سرلیک له مخې لټون`,
	pt: `Busca por título`,
	'pt-pt': `Pesquisa por título`,
	ru: `Поиск по названию`,
	sm: `Saili i le ulutala`,
	so: `Raadinta cinwaanka`,
	th: `ค้นหาตามชื่อเรื่อง`,
	ur: `عنوان کے لحاظ سے تلاش`,
	vi: `Tìm kiếm theo tiêu đề`,
	'zh-hans': `按标题搜索`,
	'zh-hant': `以標題搜尋`,
	en: `Search by title`
};

export const loc_searchEllipses: Record<Locale, string> = {
	ar: `بحث...`,
	de: `Suche...`,
	es: `Buscar...`,
	fa: `جستجو...`,
	fil: `Paghahanap...`,
	fr: `Chercher...`,
	hi: `खोजें...`,
	ht: `Rechèch...`,
	it: `Cerca...`,
	ja: `捜索...`,
	ko: `수색...`,
	mww: `Tshawb nrhiav...`,
	ps: `پلټنه...`,
	pt: `Procurar...`,
	'pt-pt': `Procurar...`,
	ru: `Поиски...`,
	sm: `Su'esu'e...`,
	so: `Raadi...`,
	th: `ค้นหา...`,
	ur: `تلاش کرو...`,
	vi: `Tìm kiếm...`,
	'zh-hans': `搜索......`,
	'zh-hant': `搜尋......`,
	en: `Search...`
};

export const loc_searchEventsDescription: Record<Locale, string> = {
	ar: `ابحث حسب عنوان الحدث أو وصفه أو الميسر.`,
	de: `Suchen Sie nach Veranstaltungstitel, Beschreibung oder Moderator.`,
	es: `Busca por título del evento, descripción o facilitador.`,
	fa: `بر اساس عنوان رویداد، توضیحات یا تسهیل گر جستجو کنید.`,
	fil: `Maghanap ayon sa pamagat ng event, paglalarawan, o facilitator.`,
	fr: `Recherchez par titre de l’événement, description ou animateur.`,
	hi: `ईवेंट शीर्षक, विवरण या सुविधाकर्ता के आधार पर खोजें।`,
	ht: `Rechèch pa evènman, deskripsyon, oswa fasilitatè`,
	it: `Cerca per titolo dell'evento, descrizione o facilitatore.`,
	ja: `イベントタイトル、説明、ファシリテーターで検索できます。`,
	ko: `행사 제목, 설명, 진행자로 검색하세요.`,
	mww: `Nrhiav raws li lub npe kev tshwm sim, piav qhia, lossis tus neeg pab.`,
	ps: `د پیښې سرلیک، تشریح، یا تسهیل کوونکی له مخې لټون وکړئ.`,
	pt: `Pesquise por título do evento, descrição ou facilitador.`,
	'pt-pt': `Pesquise por título do evento, descrição ou facilitador.`,
	ru: `Ищите по названию мероприятия, описанию или фасилитатору.`,
	sm: `Saili e ala i le ulutala o le mea na tupu, faamatalaga, po o le tagata e faagaoioia.`,
	so: `Raadi cinwaanka dhacdada, sharaxaadda, ama fududeeyaha.`,
	th: `ค้นหาตามชื่อกิจกรรม คําอธิบาย หรือผู้ดําเนินรายการ`,
	ur: `ایونٹ کے عنوان، تفصیل، یا سہولت کار کے ذریعے تلاش کریں۔`,
	vi: `Tìm kiếm theo tiêu đề sự kiện, mô tả hoặc người điều phối.`,
	'zh-hans': `按活动标题、描述或主持人搜索。`,
	'zh-hant': `依活動標題、描述或主持人搜尋。`,
	en: `Search by event title, description, or facilitator.`
};

export const loc_searchForDuplicatesFormat: Record<Locale, (person: unknown) => string> = {
	ar: (person) => `البحث عن نسخ مكررة ${person}`,
	de: (person) => `Suche nach Duplikaten von ${person}`,
	es: (person) => `Búsqueda de duplicados de ${person}`,
	fa: (person) => `جستجو برای نسخه های تکراری ${person}`,
	fil: (person) => `Hanapin ang mga kopya ng ${person}`,
	fr: (person) => `Recherche de duplicatas de ${person}`,
	hi: (person) => `${person} के डुप्लिकेट खोजें`,
	ht: (person) => `Rechèch pou doublon John ${person}`,
	it: (person) => `Ricerca di duplicati di ${person}`,
	ja: (person) => `${person}重複を探す`,
	ko: (person) => `${person}의 중복 검색`,
	mww: (person) => `Tshawb rau cov ntawv theej tawm ntawm ${person}`,
	ps: (person) => `${person} د نقلونو لټون`,
	pt: (person) => `Busca por duplicatas de ${person}`,
	'pt-pt': (person) => `Procura por duplicados de ${person}`,
	ru: (person) => `Поиск копий ${person}`,
	sm: (person) => `Saili mo kopi o ${person}`,
	so: (person) => `Raadinta nuqulo ${person}`,
	th: (person) => `ค้นหาสําเนาของ ${person}`,
	ur: (person) => `${person} کی نقلیں تلاش کریں`,
	vi: (person) => `Tìm kiếm bản sao của ${person}`,
	'zh-hans': (person) => `搜索${person}的重复篇`,
	'zh-hant': (person) => `搜尋${person}的重複作品`,
	en: (person) => `Search for duplicates of ${person}`
};

export const loc_searchHistoryEllipses: Record<Locale, string> = {
	ar: `سجل البحث...`,
	de: `Suchverlauf...`,
	es: `Historial de búsquedas...`,
	fa: `تاریخچه جستجو...`,
	fil: `Kasaysayan ng Paghahanap ...`,
	fr: `Historique de recherche...`,
	hi: `खोज इतिहास...`,
	ht: `Istwa rechèch...`,
	it: `Cronologia delle ricerche...`,
	ja: `検索履歴...`,
	ko: `검색 기록...`,
	mww: `Tshawb nrhiav keeb kwm...`,
	ps: `د لټون تاریخچه...`,
	pt: `Histórico de buscas...`,
	'pt-pt': `Histórico de pesquisas...`,
	ru: `История поиска...`,
	sm: `Su'esu'e talafa'asolopito ...`,
	so: `Taariikhda raadinta...`,
	th: `ประวัติการค้นหา...`,
	ur: `سرچ ہسٹری...`,
	vi: `Lịch sử tìm kiếm...`,
	'zh-hans': `搜索历史......`,
	'zh-hant': `搜尋紀錄......`,
	en: `Search history...`
};

export const loc_searchPeople: Record<Locale, string> = {
	ar: `ابحث الناس`,
	de: `Suchpersonen`,
	es: `Buscar personas`,
	fa: `افراد جستجو`,
	fil: `Maghanap ng mga tao`,
	fr: `Rechercher des personnes`,
	hi: `लोगों को खोजें`,
	ht: `Chèche moun`,
	it: `Cerca persone`,
	ja: `検索対象`,
	ko: `인물을 찾아`,
	mww: `Tshawb nrhiav neeg`,
	ps: `د خلکو لټون`,
	pt: `Pesquisar pessoas`,
	'pt-pt': `Pesquisar pessoas`,
	ru: `Поиск людей`,
	sm: `Saili tagata`,
	so: `Raadinta dadka`,
	th: `ค้นหาบุคคล`,
	ur: `تلاش کرنے والے لوگ`,
	vi: `Tìm kiếm mọi người`,
	'zh-hans': `搜寻人员`,
	'zh-hant': `搜尋人員`,
	en: `Search people`
};

export const loc_secureYourAcountSMS: Record<Locale, string> = {
	ar: `تأمين حسابك باستخدام الهاتف (SMS)`,
	de: `Sichern Sie Ihr Konto mit Telefon (SMS)`,
	es: `Protege tu cuenta usando el teléfono (SMS)`,
	fa: `حساب خود را با استفاده از تلفن (پیامک) ایمن کنید`,
	fil: `I-secure ang iyong account gamit ang Telepono (SMS)`,
	fr: `Sécurisez votre compte par téléphone (SMS)`,
	hi: `फ़ोन (SMS) का उपयोग करके अपना खाता सुरक्षित करें`,
	ht: `Sekirite kont ou lè l sèvi avèk Telefòn (SMS)`,
	it: `Proteggi il tuo account tramite telefono (SMS)`,
	ja: `電話(SMS)でアカウントを安全に保つ`,
	ko: `휴대폰(SMS)으로 계정을 보호하세요`,
	mww: `Ruaj ntseg koj tus account siv Xov tooj (SMS)`,
	ps: `خپل حساب د تلیفون (SMS) له لارې خوندی کړئ`,
	pt: `Proteja sua conta usando Telefone (SMS)`,
	'pt-pt': `Proteja a sua conta através do Telefone (SMS)`,
	ru: `Защитите свой аккаунт с помощью телефона (SMS)`,
	sm: `Malupuipuia lau teuga tupe e ala i le Telefoni (SMS)`,
	so: `Sug akoonkaaga adigoo adeegsanaya Telefoonka (SMS)`,
	th: `รักษาความปลอดภัยให้กับบัญชีของคุณโดยใช้โทรศัพท์ (SMS)`,
	ur: `فون (SMS) کے ذریعے اپنا اکاؤنٹ محفوظ بنائیں`,
	vi: `Bảo mật tài khoản của bạn bằng Điện thoại (SMS)`,
	'zh-hans': `使用手机（短信）保护您的账户安全`,
	'zh-hant': `使用手機（簡訊）保護您的帳號`,
	en: `Secure your account using Phone (SMS)`
};

export const loc_secureYourAcountTOTP: Record<Locale, string> = {
	ar: `أمن حسابك باستخدام كلمة المرور لمرة واحدة (TOTP) القائمة على الوقت`,
	de: `Sichern Sie Ihr Konto mit dem zeitbasierten Einmalpasswort (TOTP)`,
	es: `Protege tu cuenta usando la Contraseña de Un Solo Uso Basada en el Tiempo (TOTP)`,
	fa: `حساب خود را با استفاده از رمز عبور یک بار مصرف مبتنی بر زمان (TOTP) ایمن کنید.`,
	fil: `I-secure ang iyong account gamit ang Time-based One-Time Password (TOTP)`,
	fr: `Sécurisez votre compte avec un mot de passe à usage unique basé sur le temps (TOTP)`,
	hi: `समय-आधारित वन-टाइम पासवर्ड (TOTP) का उपयोग करके अपना खाता सुरक्षित करें`,
	ht: `Sekirite kont ou lè l sèvi avèk Tan ki baze sou yon sèl-fwa modpas (TOTP)`,
	it: `Proteggi il tuo account usando la Password Uni-Uso Basata sul Tempo (TOTP)`,
	ja: `タイムベースワンタイムパスワード(TOTP)でアカウントを保護しましょう`,
	ko: `시간 기반 일회용 비밀번호(TOTP)로 계정을 안전하게 보호하세요`,
	mww: `Ruaj ntseg koj tus account siv Time-based One-Time Password (TOTP)`,
	ps: `خپل حساب د وخت پر بنسټ یو ځل پاسورډ (TOTP) په کارولو خوندی کړئ`,
	pt: `Proteja sua conta usando a Senha Única Baseada em Tempo (TOTP)`,
	'pt-pt': `Proteja a sua conta usando uma palavra-passe de uso único baseada no tempo (TOTP)`,
	ru: `Защитите свой аккаунт с помощью одноразового пароля на основе времени (TOTP)`,
	sm: `Fa'amautu lau teuga tupe e fa'aaoga ai le Time-Based One-Time Password (TOTP)`,
	so: `Sug akoonkaaga adigoo adeegsanaya Time-based One-Time Password (TOTP)`,
	th: `รักษาความปลอดภัยให้กับบัญชีของคุณโดยใช้รหัสผ่านแบบใช้ครั้งเดียวตามเวลา (TOTP)`,
	ur: `اپنے اکاؤنٹ کو ٹائم بیسڈ ون ٹائم پاس ورڈ (TOTP) کے ذریعے محفوظ بنائیں`,
	vi: `Bảo mật tài khoản của bạn bằng Mật khẩu một lần dựa trên thời gian (TOTP)`,
	'zh-hans': `使用基于时间的一次性密码（TOTP）保护您的账户安全`,
	'zh-hant': `使用基於時間的一次性密碼（TOTP）保護您的帳戶`,
	en: `Secure your account using Time-based One-Time Password (TOTP)`
};

export const loc_selectALanguage: Record<Locale, string> = {
	ar: `اختر لغة`,
	de: `Wähle eine Sprache aus`,
	es: `Seleccione un idioma`,
	fa: `یک زبان انتخاب کنید`,
	fil: `Pumili ng Wika`,
	fr: `Sélectionnez une langue`,
	hi: `एक भाषा का चयन करें`,
	ht: `Chwazi yon lang`,
	it: `Seleziona una lingua`,
	ja: `言語を選択する`,
	ko: `언어를 선택하세요`,
	mww: `Xaiv ib hom lus`,
	ps: `یوه ژبه انتخاب کړئ`,
	pt: `Selecione um idioma`,
	'pt-pt': `Selecione uma língua`,
	ru: `Выберите язык`,
	sm: `Filifili se gagana`,
	so: `Xulo luqad`,
	th: `เลือกภาษา`,
	ur: `زبان کا انتخاب کریں`,
	vi: `Chọn ngôn ngữ`,
	'zh-hans': `选择一种语言`,
	'zh-hant': `選擇一種語言`,
	en: `Select a language`
};

export const loc_selectAll: Record<Locale, string> = {
	ar: `اختر الجميع`,
	de: `Alle auswählen`,
	es: `Seleccionar todo`,
	fa: `همه را انتخاب کنید`,
	fil: `Email Address *`,
	fr: `Sélectionner tout`,
	hi: `सभी का चयन करें`,
	ht: `Chwazi tout`,
	it: `Seleziona tutti`,
	ja: `すべて選択`,
	ko: `모두 선택`,
	mww: `Xaiv tag nrho`,
	ps: `ټول انتخاب کړئ`,
	pt: `Selecionar todos`,
	'pt-pt': `Selecionar todos`,
	ru: `Выберите все`,
	sm: `Filifili uma`,
	so: `Xulo dhammaan`,
	th: `เลือกทั้งหมด`,
	ur: `سب منتخب کریں`,
	vi: `Chọn tất cả`,
	'zh-hans': `全部选择`,
	'zh-hant': `全部選擇`,
	en: `Select all`
};

export const loc_selectAService: Record<Locale, string> = {
	ar: `(اختر خدمة)`,
	de: `(Einen Service auswählen)`,
	es: `(Seleccione un servicio)`,
	fa: `(یک سرویس انتخاب کنید)`,
	fil: `(Pumili ng Serbisyo)`,
	fr: `(Sélectionnez un service)`,
	hi: `(एक सेवा का चयन करें)`,
	ht: `(Chwazi yon sèvis)`,
	it: `(Seleziona un servizio)`,
	ja: `(サービスを選択する)`,
	ko: `(서비스 선택)`,
	mww: `(Xaiv ib qho kev pabcuam)`,
	ps: `(خدمت انتخاب کړئ)`,
	pt: `(Selecione um serviço)`,
	'pt-pt': `(Selecione um serviço)`,
	ru: `(Выберите службу)`,
	sm: `(Filifili se auaunaga)`,
	so: `(Xulo adeeg)`,
	th: `(เลือกบริการ)`,
	ur: `(سروس منتخب کریں)`,
	vi: `(Chọn một dịch vụ)`,
	'zh-hans': `（选择服务）`,
	'zh-hant': `（選擇服務）`,
	en: `(Select a service)`
};

export const loc_selectDashboard: Record<Locale, string> = {
	ar: `اختيار لوحة التحكم`,
	de: `Dashboard auswählen`,
	es: `Seleccionar panel`,
	fa: `داشبورد را انتخاب کنید`,
	fil: `Piliin ang dashboard`,
	fr: `Sélectionner tableau de bord`,
	hi: `डैशबोर्ड का चयन करें`,
	ht: `Chwazi tablodbò`,
	it: `Seleziona dashboard`,
	ja: `Selectダッシュボード`,
	ko: `대시보드 선택`,
	mww: `Xaiv dashboard`,
	ps: `ډشبورډ انتخاب کړئ`,
	pt: `Selecionar painel`,
	'pt-pt': `Selecionar painel`,
	ru: `Выберите панель управления`,
	sm: `Filifili le dashboard`,
	so: `Select dashboard`,
	th: `เลือกแดชบอร์ด`,
	ur: `ڈیش بورڈ منتخب کریں`,
	vi: `Chọn bảng điều khiển`,
	'zh-hans': `选择仪表盘`,
	'zh-hant': `選擇儀表板`,
	en: `Select dashboard`
};

export const loc_selectDashboardCurrent: Record<Locale, string> = {
	ar: `اختر لوحة التحكم. الحالي:`,
	de: `Wähle Dashboard. Aktuell:`,
	es: `Selecciona el panel de control. Actualidad:`,
	fa: `داشبورد را انتخاب کنید. وضعیت جاری:`,
	fil: `Piliin ang dashboard. Kasalukuyang:`,
	fr: `Sélectionnez tableau de bord. Actuel :`,
	hi: `डैशबोर्ड चुनें. वर्तमान:`,
	ht: `Chwazi tablodbò Aktyèl:`,
	it: `Seleziona dashboard. Attuali:`,
	ja: `ダッシュボードを選択します。現在:`,
	ko: `대시보드를 선택하세요. 현재:`,
	mww: `Xaiv dashboard. Tam sim no:`,
	ps: `ډشبورډ انتخاب کړه. اوسنی:`,
	pt: `Selecione o painel. Atual:`,
	'pt-pt': `Selecione o painel de controlo. Atual:`,
	ru: `Выберите дашборд. Текущая:`,
	sm: `Filifili le dashboard. Taimi nei:`,
	so: `Dooro dashboard-ka. Hadda:`,
	th: `เลือกแดชบอร์ด ปัจจุบัน:`,
	ur: `ڈیش بورڈ منتخب کریں۔ موجودہ:`,
	vi: `Chọn bảng điều khiển. Hiện tại:`,
	'zh-hans': `选择仪表盘。现状：`,
	'zh-hant': `選擇儀表板。目前：`,
	en: `Select dashboard. Current:`
};

export const loc_selectedDocuments: Record<Locale, string> = {
	ar: `وثائق مختارة`,
	de: `Ausgewählte Dokumente`,
	es: `Documentos seleccionados`,
	fa: `اسناد منتخب`,
	fil: `Email Address *`,
	fr: `Documents sélectionnés`,
	hi: `चयनित दस्तावेज`,
	ht: `Chwazi dokiman yo`,
	it: `Documenti selezionati`,
	ja: `主な文書`,
	ko: `선택된 문서`,
	mww: `Cov ntaub ntawv xaiv`,
	ps: `منتخب اسناد`,
	pt: `Documentos selecionados`,
	'pt-pt': `Documentos selecionados`,
	ru: `Избранные документы`,
	sm: `Pepa aloaia filifilia`,
	so: `Dukumentiyo la xushay`,
	th: `เอกสารที่เลือก`,
	ur: `منتخب دستاویزات`,
	vi: `Tài liệu được chọn`,
	'zh-hans': `精选文献`,
	'zh-hant': `精選文件`,
	en: `Selected documents`
};

export const loc_selectFiles: Record<Locale, string> = {
	ar: `اختيار الملفات`,
	de: `Dateien auswählen`,
	es: `Archivos seleccionados`,
	fa: `انتخاب فایل ها`,
	fil: `Email Address *`,
	fr: `Sélection de fichiers`,
	hi: `फ़ाइलों का चयन करें`,
	ht: `Chwazi dosye yo`,
	it: `Seleziona file`,
	ja: `ファイル選択`,
	ko: `파일 선택`,
	mww: `Xaiv cov ntaub ntawv`,
	ps: `انتخاب فایلونه`,
	pt: `Arquivos selecionados`,
	'pt-pt': `Ficheiros selecionados`,
	ru: `Выберите файлы`,
	sm: `Filifili faila`,
	so: `Faylasha la xushay`,
	th: `เลือกไฟล์`,
	ur: `فائلز منتخب کریں`,
	vi: `Chọn tệp`,
	'zh-hans': `选择文件`,
	'zh-hant': `選擇檔案`,
	en: `Select files`
};

export const loc_selectLanguage: Record<Locale, string> = {
	ar: `لغة مختارة`,
	de: `Ausgewählte Sprache`,
	es: `Idioma seleccionado`,
	fa: `زبان منتخب`,
	fil: `Pumili ng wika`,
	fr: `Langue choisie`,
	hi: `भाषा का चयन करें`,
	ht: `Chwazi lang`,
	it: `Linguaggio selezionato`,
	ja: `言語選択`,
	ko: `선택 언어`,
	mww: `Xaiv hom lus`,
	ps: `ټاکل شوې ژبه`,
	pt: `Idioma selecionado`,
	'pt-pt': `Língua selecionada`,
	ru: `Избранные языки`,
	sm: `Filifili le gagana`,
	so: `Luuqad la xushay`,
	th: `เลือกภาษา`,
	ur: `منتخب زبان`,
	vi: `Chọn ngôn ngữ`,
	'zh-hans': `选择语言`,
	'zh-hant': `選擇語言`,
	en: `Select language`
};

export const loc_selectNone: Record<Locale, string> = {
	ar: `لا يختار أي`,
	de: `Wähle keine aus`,
	es: `No selecciones ninguno`,
	fa: `هیچ کدام را انتخاب نکنید`,
	fil: `Pumili ng wala`,
	fr: `Aucun n’en sélectionner`,
	hi: `कोई नहीं चुनें`,
	ht: `Chwazi okenn`,
	it: `Non ne seleziona nessuno`,
	ja: `選択なし`,
	ko: `선택하지 않음`,
	mww: `Xaiv tsis muaj`,
	ps: `هیڅ انتخاب نه کړئ`,
	pt: `Nenhuma escolha`,
	'pt-pt': `Não selecione nenhuma`,
	ru: `Выберите ни одного`,
	sm: `Filifili se tasi`,
	so: `Xulasho midna`,
	th: `เลือกไม่มี`,
	ur: `کوئی نہ منتخب نہ کریں`,
	vi: `Chọn không có`,
	'zh-hans': `选择无`,
	'zh-hant': `選擇無`,
	en: `Select none`
};

export const loc_selectOnlyOne: Record<Locale, string> = {
	ar: `اختر واحدا فقط`,
	de: `Wählen Sie nur eine aus`,
	es: `Selecciona solo uno`,
	fa: `فقط یکی را انتخاب کنید`,
	fil: `Pumili lamang ng isa`,
	fr: `Sélectionne-en un seul`,
	hi: `केवल एक का चयन करें`,
	ht: `Chwazi sèlman yon sèl`,
	it: `Selezionane solo uno`,
	ja: `一つだけ選んでください`,
	ko: `하나만 선택하세요`,
	mww: `Xaiv ib qho xwb`,
	ps: `یوازې یو انتخاب کړئ`,
	pt: `Selecione apenas um`,
	'pt-pt': `Selecione apenas um`,
	ru: `Выберите только один`,
	sm: `Filifili na o le tasi`,
	so: `Dooro hal qof oo kaliya`,
	th: `เลือกเพียงหนึ่งรายการ`,
	ur: `صرف ایک منتخب کریں`,
	vi: `Chỉ chọn một`,
	'zh-hans': `只选一个`,
	'zh-hant': `只選一個`,
	en: `Select only one`
};

export const loc_selectWetInk: Record<Locale, string> = {
	ar: `اختر الحبر الرطب`,
	de: `Wähle Nass-Tinte`,
	es: `Tinta húmeda Select`,
	fa: `انتخاب جوهر مرطوب`,
	fil: `Pumili ng basang tinta`,
	fr: `Sélectionner l’encre humide`,
	hi: `गीली स्याही का चयन करें`,
	ht: `Chwazi lank mouye`,
	it: `Seleziona l'inchiostro umido`,
	ja: `ウェットインクを選択してください`,
	ko: `습식 잉크 선택`,
	mww: `Xaiv tus cwj mem ntub`,
	ps: `لوند رنګ انتخاب کړئ`,
	pt: `Selecione tinta úmida`,
	'pt-pt': `Tinta húmida selecionada`,
	ru: `Выберите влажные чернила`,
	sm: `Filifili vaitusi susu`,
	so: `Xulo khad qoyan`,
	th: `เลือกหมึกเปียก`,
	ur: `ویٹ انک منتخب کریں`,
	vi: `Chọn mực ướt`,
	'zh-hans': `选择湿墨水`,
	'zh-hant': `選擇濕墨水`,
	en: `Select wet ink`
};

export const loc_send: Record<Locale, string> = {
	ar: `أرسلني`,
	de: `Senden`,
	es: `Envía`,
	fa: `ارسال`,
	fil: `Email Address *`,
	fr: `Envoyer`,
	hi: `भेजें`,
	ht: `Voye`,
	it: `Invia`,
	ja: `送信`,
	ko: `보내세요`,
	mww: `Xa`,
	ps: `واستوه`,
	pt: `Enviar`,
	'pt-pt': `Enviar`,
	ru: `Отправить`,
	sm: `Auina atu`,
	so: `Dir`,
	th: `ส่ง`,
	ur: `بھیجیں`,
	vi: `Gửi`,
	'zh-hans': `发送`,
	'zh-hant': `發送`,
	en: `Send`
};

export const loc_sendEllipses: Record<Locale, string> = {
	ar: `أرسل...`,
	de: `Schick...`,
	es: `Enviar...`,
	fa: `ارسال...`,
	fil: `Magpadala...`,
	fr: `Envoyer...`,
	hi: `भेजें...`,
	ht: `Voye ...`,
	it: `Invia...`,
	ja: `送信...`,
	ko: `보내...`,
	mww: `Xa ...`,
	ps: `واستوه...`,
	pt: `Enviar...`,
	'pt-pt': `Enviar...`,
	ru: `Отправь...`,
	sm: `Auina atu...`,
	so: `Dir...`,
	th: `ส่ง...`,
	ur: `بھیجو...`,
	vi: `Gửi...`,
	'zh-hans': `发送......`,
	'zh-hant': `傳送......`,
	en: `Send...`
};

export const loc_senderNoLongerActive: Record<Locale, string> = {
	ar: `لم يعد المرسل نشطا في المشروع.`,
	de: `Absender ist im Projekt nicht mehr aktiv.`,
	es: `El remitente ya no está activo en el proyecto.`,
	fa: `فرستنده دیگر در پروژه فعال نیست.`,
	fil: `Hindi na aktibo sa proyekto ang Tagalog.`,
	fr: `L’expéditeur n’est plus actif dans le projet.`,
	hi: `प्रेषक अब प्रोजेक्ट में सक्रिय नहीं है।`,
	ht: `Moun k pa aktif ankò nan pwojè a.`,
	it: `Il mittente non è più attivo nel progetto.`,
	ja: `送信者はプロジェクトで活動していません。`,
	ko: `발신자는 더 이상 프로젝트에서 활동하지 않습니다.`,
	mww: `Sender tsis active nyob rau hauv qhov project lawm.`,
	ps: `لیږونکی نور په پروژه کې فعال نه دی.`,
	pt: `O remetente não está mais ativo no projeto.`,
	'pt-pt': `O remetente já não está ativo no projeto.`,
	ru: `Отправитель больше не участвует в проекте.`,
	sm: `E le o toe toaga le tagata auina atu i le galuega faatino.`,
	so: `Sender mar dambe ma ka qaybqaato mashruuca.`,
	th: `ผู้ส่งไม่ได้ใช้งานในโครงการอีกต่อไป`,
	ur: `سینڈر اب اس پروجیکٹ میں سرگرم نہیں رہا۔`,
	vi: `Người gửi không còn hoạt động trong dự án.`,
	'zh-hans': `发件人已不再活跃于该项目。`,
	'zh-hant': `寄件人已不再參與該專案。`,
	en: `Sender no longer active in the project.`
};

export const loc_sendForFill: Record<Locale, string> = {
	ar: `أرسل للإكمال`,
	de: `Senden Sie zum Abschluss`,
	es: `Enviar para completar`,
	fa: `ارسال برای تکمیل`,
	fil: `Ipadala para sa pagkumpleto`,
	fr: `Envoyer pour complétion`,
	hi: `पूरा करने के लिए भेजें`,
	ht: `Voye pou fini`,
	it: `Invia per il completamento`,
	ja: `完了のために送信`,
	ko: `완성을 위해 보내세요`,
	mww: `Xa rau kev ua tiav`,
	ps: `د بشپړولو لپاره واستول`,
	pt: `Envie para conclusão`,
	'pt-pt': `Enviar para conclusão`,
	ru: `Отправьте на завершение`,
	sm: `Auina atu mo le faamaeaina`,
	so: `U dir dhammaystirka`,
	th: `ส่งให้เสร็จสมบูรณ์`,
	ur: `تکمیل کے لیے بھیجیں`,
	vi: `Gửi để hoàn thành`,
	'zh-hans': `发送完成`,
	'zh-hant': `發送補完`,
	en: `Send for completion`
};

export const loc_sendForFillDesc: Record<Locale, string> = {
	ar: `أرسل رابطا لشخص ما لإنشاء هذا التسجيل إلكترونيا.`,
	de: `Schicke jemandem einen Link, um diesen Datensatz elektronisch zu erstellen.`,
	es: `Envía a alguien un enlace para crear este registro electrónicamente.`,
	fa: `لینکی برای ساخت این آلبوم به صورت الکترونیکی به کسی بفرستید.`,
	fil: `Magpadala ng link sa isang tao para lumikha ng rekord na ito sa elektronikong paraan.`,
	fr: `Envoyez un lien à quelqu’un pour créer ce dossier électroniquement.`,
	hi: `इस रिकॉर्ड को इलेक्ट्रॉनिक रूप से बनाने के लिए किसी को एक लिंक भेजें।`,
	ht: `Voye yon moun yon lyen pou kreye dosye sa elektwonik.`,
	it: `Invia a qualcuno un link per creare questo record elettronicamente.`,
	ja: `誰かにリンクを送って、この記録を電子的に作成してください。`,
	ko: `이 기록을 전자적으로 만들 수 있는 링크를 누군가에게 보내주세요.`,
	mww: `Xa ib tus neeg txuas los tsim cov ntaub ntawv no hauv tshuab hluav taws xob.`,
	ps: `چا ته لینک واستوه چې دا ریکارډ الکترونیکی جوړ کړی.`,
	pt: `Envie um link para alguém criar esse registro eletronicamente.`,
	'pt-pt': `Envie a alguém um link para criar este registo eletronicamente.`,
	ru: `Отправьте кому-нибудь ссылку для создания этой записи в электронном виде.`,
	sm: `Auina atu i se tasi se sootaga e fatu ai lenei faamaumauga faaeletonika.`,
	so: `U dir qof xiriir si uu u sameeyo rikoodhkan elektaroonik ahaan.`,
	th: `ส่งลิงก์ให้ผู้อื่นเพื่อสร้างระเบียนนี้ทางอิเล็กทรอนิกส์`,
	ur: `کسی کو اس ریکارڈ کو الیکٹرانک طور پر بنانے کے لیے لنک بھیجیں۔`,
	vi: `Gửi cho ai đó một liên kết để tạo bản ghi này bằng điện tử.`,
	'zh-hans': `给某人发链接，电子制作这份记录。`,
	'zh-hant': `請寄給某人一個連結，讓他能電子化製作這份紀錄。`,
	en: `Send someone a link to create this record electronically.`
};

export const loc_sendForSignature: Record<Locale, string> = {
	ar: `أرسل طلبا للتوقيع`,
	de: `Unterschrift schicken`,
	es: `Pide firma`,
	fa: `برای امضا ارسال کنید`,
	fil: `Email Address *`,
	fr: `Envoyez la signature`,
	hi: `हस्ताक्षर के लिए भेजें`,
	ht: `Voye pou siyati`,
	it: `Mandate la firma`,
	ja: `署名を依頼してください`,
	ko: `서명 요청하세요`,
	mww: `Xa mus kos npe`,
	ps: `د لاسلیک غوښتنه وکړئ`,
	pt: `Peça assinatura`,
	'pt-pt': `Pede assinatura`,
	ru: `Отправьте подпись`,
	sm: `Auina atu mo le saini`,
	so: `U dir saxiix`,
	th: `ส่งเพื่อขอลายเซ็น`,
	ur: `دستخط کے لیے بھیجیں`,
	vi: `Gửi chữ ký`,
	'zh-hans': `请送签`,
	'zh-hant': `請簽名`,
	en: `Send for signature`
};

export const loc_sendForSignatureDesc: Record<Locale, string> = {
	ar: `أرسل رابطا لشخص ما ليوقع هذا الألبوم إلكترونيا.`,
	de: `Schick jemandem einen Link, um diesen Untergrund elektronisch zu unterschreiben.`,
	es: `Envía a alguien un enlace para que firme este expediente electrónicamente.`,
	fa: `لینکی برای امضای الکترونیکی این آلبوم به کسی بفرستید.`,
	fil: `Magpadala ng link sa isang tao para lagdaan ang talaang ito sa elektronikong paraan.`,
	fr: `Envoyez un lien à quelqu’un pour signer ce document électroniquement.`,
	hi: `इस रिकॉर्ड पर इलेक्ट्रॉनिक रूप से हस्ताक्षर करने के लिए किसी को एक लिंक भेजें।`,
	ht: `Voye yon moun yon lyen pou siyen dosye sa elektwonikman.`,
	it: `Invia a qualcuno un link per firmare questo documento elettronicamente.`,
	ja: `このレコードに電子的に署名するためのリンクを誰かに送ってください。`,
	ko: `이 기록에 전자적으로 서명할 수 있는 링크를 누군가에게 보내주세요.`,
	mww: `Xa ib tus neeg txuas mus kos npe rau cov ntaub ntawv no hauv tshuab hluav taws xob.`,
	ps: `چا ته لینک واستوه چې دا ریکارډ الکترونیکی لاسلیک کړی.`,
	pt: `Envie um link para alguém assinar esse registro eletronicamente.`,
	'pt-pt': `Envie a alguém um link para assinar este registo eletronicamente.`,
	ru: `Отправьте кому-нибудь ссылку для электронной подписи этой записи.`,
	sm: `Auina atu i se tasi se sootaga e saini faaeletonika ai lenei faamaumauga.`,
	so: `U dir qof xiriir si uu diiwaankan si elektaroonik ah u saxiixo.`,
	th: `ส่งลิงก์ให้ผู้อื่นเพื่อลงนามในบันทึกนี้ทางอิเล็กทรอนิกส์`,
	ur: `کسی کو اس ریکارڈ پر الیکٹرانک دستخط کے لیے لنک بھیجیں۔`,
	vi: `Gửi cho ai đó một liên kết để ký vào hồ sơ này bằng điện tử.`,
	'zh-hans': `给某人发链接，电子签名这张唱片。`,
	'zh-hant': `請寄連結給某人電子簽名這張紀錄。`,
	en: `Send someone a link to sign this record electronically.`
};

export const loc_sendingDisabledDesc: Record<Locale, string> = {
	ar: `إرسال تعطيل. يتطلب مستند أو أكثر توقيع حبر مبلل.`,
	de: `Senden deaktiviert. Ein oder mehrere Dokumente erfordern eine Nass-Tinten-Unterschrift.`,
	es: `Envío deshabilitado. Uno o más documentos requieren firma de tinta húmeda.`,
	fa: `ارسال غیرفعال شدن. یک یا چند سند نیاز به امضای جوهر مرطوب دارند.`,
	fil: `Hindi pinagana ang pagpapadala. Ang isa o higit pang mga dokumento ay nangangailangan ng lagda ng wet ink.`,
	fr: `Envoi désactivé. Un ou plusieurs documents nécessitent une signature à l’encre humide.`,
	hi: `अक्षम भेजना। एक या अधिक दस्तावेज़ों के लिए गीली स्याही हस्ताक्षर की आवश्यकता होती है।`,
	ht: `Voye enfim Youn oswa plis dokiman mande pou siyati lank mouye.`,
	it: `Invio disabilitato. Uno o più documenti richiedono la firma dell'inchiostro umido.`,
	ja: `送信が無効です。1つ以上の文書にはウェットインク署名が必要です。`,
	ko: `전송 비활성화. 하나 이상의 문서는 습식 잉크 서명이 필요합니다.`,
	mww: `Xa xiam oob qhab. Ib los yog ntau cov ntaub ntawv yuav tsum tau kos npe number case ntub dej.`,
	ps: `غیر فعال لیږل. یو یا څو اسناد لوند رنګ لاسلیک ته اړتیا لری.`,
	pt: `Envio desativado. Um ou mais documentos exigem assinatura de tinta úmida.`,
	'pt-pt': `Envio desativado. Um ou mais documentos requerem assinatura de tinta húmida.`,
	ru: `Отправка отключена. Один или несколько документов требуют подписи влажными чернилами.`,
	sm: `Auina atu le atoatoa. E tasi pe sili atu pepa o faamatalaga e manaomia ai le saini vaitusi susu.`,
	so: `Diritaanka waa la naafiyaday. Hal ama in ka badan dukumentiyo waxay u baahan yihiin saxiix khad qoyan.`,
	th: `การส่งถูกปิดใช้งาน เอกสารอย่างน้อยหนึ่งฉบับต้องมีลายเซ็นหมึกเปียก`,
	ur: `غیر فعال بھیج رہا ہوں۔ ایک یا زیادہ دستاویزات کے لیے گیلی سیاہی کے دستخط درکار ہوتے ہیں۔`,
	vi: `Đang gửi bị vô hiệu hóa. Một hoặc nhiều tài liệu yêu cầu chữ ký mực ướt.`,
	'zh-hans': `发送被禁用。一份或多份文件需要湿墨水签名。`,
	'zh-hant': `傳送已停用。一份或多份文件需要濕墨水簽名。`,
	en: `Sending disabled. One or more documents require wet ink signature.`
};

export const loc_sendViaEmail: Record<Locale, string> = {
	ar: `أرسل عبر البريد الإلكتروني`,
	de: `Per E-Mail senden`,
	es: `Enviar por correo electrónico`,
	fa: `ارسال از طریق ایمیل`,
	fil: `Email:`,
	fr: `Envoyer par e-mail`,
	hi: `ईमेल के माध्यम से भेजें`,
	ht: `Voye pa Imèl`,
	it: `Invia via email`,
	ja: `メールで送信`,
	ko: `이메일로 보내기`,
	mww: `Xa ntawm Email`,
	ps: `د ایمیل له لارې واستول`,
	pt: `Envie por e-mail`,
	'pt-pt': `Enviar por Email`,
	ru: `Отправьте по электронной почте`,
	sm: `Auina atu e ala i le imeli`,
	so: `U dir email`,
	th: `ส่งทางอีเมล`,
	ur: `ای میل کے ذریعے بھیجیں`,
	vi: `Gửi qua email`,
	'zh-hans': `通过电子邮件发送`,
	'zh-hant': `透過電子郵件發送`,
	en: `Send via Email`
};

export const loc_sendViaSMS: Record<Locale, string> = {
	ar: `إرسال عبر رسالة نصية`,
	de: `Per SMS senden`,
	es: `Enviar por mensaje de texto`,
	fa: `ارسال از طریق پیامک`,
	fil: `Email: Text Message`,
	fr: `Envoyer par message texte`,
	hi: `पाठ संदेश के माध्यम से भेजें`,
	ht: `Voye pa mesaj tèks`,
	it: `Invia via messaggio di testo`,
	ja: `テキストメッセージで送信`,
	ko: `문자 메시지로 보내기`,
	mww: `Xa los ntawm Cov Ntawv Nyeem`,
	ps: `د متن پیغام له لارې واستول`,
	pt: `Enviar por Mensagem de Texto`,
	'pt-pt': `Enviar por Mensagem de Texto`,
	ru: `Отправить через текстовое сообщение`,
	sm: `Auina atu e ala i feau tusitusia`,
	so: `Fariin qoraal ah u dir`,
	th: `ส่งทางข้อความ`,
	ur: `ٹیکسٹ میسج کے ذریعے بھیجیں`,
	vi: `Gửi qua tin nhắn văn bản`,
	'zh-hans': `通过短信发送`,
	'zh-hant': `透過簡訊發送`,
	en: `Send via Text Message`
};

export const loc_service: Record<Locale, string> = {
	ar: `الخدمة`,
	de: `Dienst`,
	es: `Servicio`,
	fa: `خدمت`,
	fil: `Serbisyo`,
	fr: `Service`,
	hi: `सेवा`,
	ht: `Sèvis`,
	it: `Servizio`,
	ja: `運用`,
	ko: `운용`,
	mww: `Kev Pabcuam`,
	ps: `خدمت`,
	pt: `Serviço`,
	'pt-pt': `Serviço`,
	ru: `Служба`,
	sm: `Auaunaga`,
	so: `Adeegga`,
	th: `บริการ`,
	ur: `خدمات`,
	vi: `Dịch vụ`,
	'zh-hans': `服役经历`,
	'zh-hant': `服役`,
	en: `Service`
};

export const loc_serviceAuthorization: Record<Locale, string> = {
	ar: `تفويض الخدمة`,
	de: `Dienstgenehmigung`,
	es: `Autorización de servicio`,
	fa: `مجوز خدمت`,
	fil: `Pahintulot sa serbisyo`,
	fr: `Autorisation de service`,
	hi: `सेवा प्राधिकरण`,
	ht: `Sèvis otorizasyon`,
	it: `Autorizzazione al servizio`,
	ja: `サービス承認`,
	ko: `서비스 승인`,
	mww: `Kev tso cai pabcuam`,
	ps: `د خدمت اجازه`,
	pt: `Autorização de serviço`,
	'pt-pt': `Autorização de serviço`,
	ru: `Авторизация сервиса`,
	sm: `Faatagaga o auaunaga`,
	so: `Oggolaanshaha adeegga`,
	th: `การอนุญาตบริการ`,
	ur: `سروس کی اجازت`,
	vi: `Ủy quyền dịch vụ`,
	'zh-hans': `服务授权`,
	'zh-hant': `服務授權`,
	en: `Service authorization`
};

export const loc_serviceAuthorizations: Record<Locale, string> = {
	ar: `تصاريح الخدمة`,
	de: `Dienstgenehmigungen`,
	es: `Autorizaciones de servicio`,
	fa: `مجوزهای خدمت`,
	fil: `Mga pahintulot sa serbisyo`,
	fr: `Autorisations de service`,
	hi: `सेवा प्राधिकरण`,
	ht: `Otorizasyon sèvis yo`,
	it: `Autorizzazioni al servizio`,
	ja: `サービス承認`,
	ko: `서비스 승인`,
	mww: `Kev tso cai pabcuam`,
	ps: `د خدمت اجازې`,
	pt: `Autorizações de serviço`,
	'pt-pt': `Autorizações de serviço`,
	ru: `Авторизации на услуги`,
	sm: `Fa'atagaga tautua`,
	so: `Ogolaanshaha adeegga`,
	th: `การอนุญาตบริการ`,
	ur: `سروس اجازتیں`,
	vi: `Ủy quyền dịch vụ`,
	'zh-hans': `服役授权`,
	'zh-hant': `服務授權`,
	en: `Service authorizations`
};

export const loc_sessionExpired: Record<Locale, string> = {
	ar: `انتهت الجلسة`,
	de: `Die Sitzung endete`,
	es: `Sesión finalizada`,
	fa: `جلسه به پایان رسید`,
	fil: `Nag-expire na ang sesyon`,
	fr: `Session expirée`,
	hi: `सत्र की समय सीमा समाप्त हो गई`,
	ht: `Sesyon ekspire`,
	it: `Sessione terminata`,
	ja: `会期終了`,
	ko: `회기 종료`,
	mww: `Kev sib kho tas sij hawm`,
	ps: `غونډه پای ته ورسېده`,
	pt: `Sessão encerrada`,
	'pt-pt': `Sessão terminada`,
	ru: `Сессия закончилась`,
	sm: `Ua uma le aoga o le sauniga`,
	so: `Kalfadhiga wuu dhammaaday`,
	th: `เซสชันหมดอายุ`,
	ur: `سیشن ختم ہو گیا`,
	vi: `Phiên đã hết hạn`,
	'zh-hans': `会议结束`,
	'zh-hant': `會期已結束`,
	en: `Session expired`
};

export const loc_sessionFormat: Record<Locale, string> = {
	ar: `صيغة الجلسة`,
	de: `Sitzungsformat`,
	es: `Formato de la sesión`,
	fa: `فرمت جلسه`,
	fil: `Format ng sesyon`,
	fr: `Format de la session`,
	hi: `सत्र प्रारूप`,
	ht: `Fòma sesyon an`,
	it: `Formato della sessione`,
	ja: `セッション形式`,
	ko: `세션 형식`,
	mww: `Qauv kev sib tham`,
	ps: `د سیشن فورمټ`,
	pt: `Formato da sessão`,
	'pt-pt': `Formato da sessão`,
	ru: `Формат сессии`,
	sm: `Faatulagaga o le sauniga`,
	so: `Qaabka kalfadhiga`,
	th: `รูปแบบเซสชัน`,
	ur: `سیشن فارمیٹ`,
	vi: `Định dạng phiên làm việc`,
	'zh-hans': `会话格式`,
	'zh-hant': `會話形式`,
	en: `Session format`
};

export const loc_setStatus: Record<Locale, (status: unknown) => string> = {
	ar: (status) => `${status} الديكور`,
	de: (status) => `${status}`,
	es: (status) => `${status}`,
	fa: (status) => `${status}`,
	fil: (status) => `${status}`,
	fr: (status) => `${status}`,
	hi: (status) => `सेट ${status}`,
	ht: (status) => `${status}`,
	it: (status) => `${status}`,
	ja: (status) => `${status}`,
	ko: (status) => `${status}`,
	mww: (status) => `Teeb ${status}`,
	ps: (status) => `سیټ ${status}`,
	pt: (status) => `${status}`,
	'pt-pt': (status) => `${status}`,
	ru: (status) => `${status}`,
	sm: (status) => `${status}`,
	so: (status) => `${status}`,
	th: (status) => `เซ็ต ${status}`,
	ur: (status) => `سیٹ ${status}`,
	vi: (status) => `Bộ đã ${status}`,
	'zh-hans': (status) => `布景 ${status}`,
	'zh-hant': (status) => `${status}`,
	en: (status) => `Set ${status}`
};

export const loc_settings: Record<Locale, string> = {
	ar: `الإعدادات`,
	de: `Einstellungen`,
	es: `Escenarios`,
	fa: `محیط ها`,
	fil: `Mga Setting`,
	fr: `Décors`,
	hi: `सेटिंग`,
	ht: `Anviwònman yo`,
	it: `Impostazioni`,
	ja: `舞台設定`,
	ko: `설정`,
	mww: `Cov chaw`,
	ps: `تنظیمات`,
	pt: `Configurações`,
	'pt-pt': `Configurações`,
	ru: `Места действия`,
	sm: `Tulaga`,
	so: `Dejinta`,
	th: `การตั้งค่า`,
	ur: `سیٹنگز`,
	vi: `Cài đặt`,
	'zh-hans': `背景设定`,
	'zh-hant': `場景設定`,
	en: `Settings`
};

export const loc_sex: Record<Locale, string> = {
	ar: `الجنس`,
	de: `Geschlecht`,
	es: `Sexo`,
	fa: `Sex`,
	fil: `Kasarian`,
	fr: `Sex`,
	hi: `लिंग`,
	ht: `Sèks`,
	it: `Sex`,
	ja: `性別`,
	ko: `성별`,
	mww: `Poj niam txiv `,
	ps: `Sex`,
	pt: `Sexo`,
	'pt-pt': `Sexo`,
	ru: `Пол`,
	sm: `Feusuaiga`,
	so: `Sex`,
	th: `เพศ`,
	ur: `جنس`,
	vi: `Giới tính`,
	'zh-hans': `性别`,
	'zh-hant': `性別`,
	en: `Sex`
};

export const loc_sexualOrientation: Record<Locale, string> = {
	ar: `التوجه الجنسي`,
	de: `Sexuelle Orientierung`,
	es: `Orientación sexual`,
	fa: `گرایش جنسی`,
	fil: `Sekswal na oryentasyon`,
	fr: `Orientation sexuelle`,
	hi: `यौन अभिविन्यास`,
	ht: `oryantasyon seksyèl`,
	it: `Orientamento sessuale`,
	ja: `性的指向`,
	ko: `성적 지향`,
	mww: `Kev sib deev`,
	ps: `جنسی تمایل`,
	pt: `Orientação sexual`,
	'pt-pt': `Orientação sexual`,
	ru: `Сексуальная ориентация`,
	sm: `Fa'afeusuaiga`,
	so: `Jihada galmada`,
	th: `รสนิยมทางเพศ`,
	ur: `جنسی رجحان`,
	vi: `Khuynh hướng tình dục`,
	'zh-hans': `性取向`,
	'zh-hant': `性取向`,
	en: `Sexual orientation`
};

export const loc_shareableLinkNote: Record<Locale, string> = {
	ar: `سيكون الرابط القابل للمشاركة متاحا بعد الحفظ.`,
	de: `Ein teilbarer Link wird nach dem Speichern verfügbar sein.`,
	es: `El enlace compartible estará disponible tras guardar.`,
	fa: `لینک قابل اشتراک گذاری پس از ذخیره در دسترس خواهد بود.`,
	fil: `Magagamit ang shareable link pagkatapos i-save.`,
	fr: `Un lien partageable sera disponible après la sauvegarde.`,
	hi: `सहेजने के बाद साझा करने योग्य लिंक उपलब्ध होगा।`,
	ht: `Lyen pataje ap disponib apre ekonomize`,
	it: `Il link condivisibile sarà disponibile dopo aver salvato.`,
	ja: `保存後、共有可能なリンクが利用可能になります。`,
	ko: `저장 후 공유 가능한 링크가 제공됩니다.`,
	mww: `Sib koom txuas yuav muaj tom qab khaws cia.`,
	ps: `شریکېدونکی لینک به د خوندی کولو وروسته شتون ولری.`,
	pt: `O link compartilhável estará disponível após salvar.`,
	'pt-pt': `Um link partilhável estará disponível após a gravação.`,
	ru: `Ссылка для обмена будет доступна после сохранения.`,
	sm: `O le a maua le sootaga e mafai ona faasoa atu pe a uma ona faasaoina.`,
	so: `Xiriirka la wadaagi karo ayaa la heli doonaa marka la keydiyo.`,
	th: `ลิงก์ที่แชร์ได้จะพร้อมใช้งานหลังจากบันทึก`,
	ur: `شیئر ایبل لنک محفوظ کرنے کے بعد دستیاب ہوگا۔`,
	vi: `Liên kết có thể chia sẻ sẽ có sẵn sau khi lưu.`,
	'zh-hans': `保存后会开放可分享的链接。`,
	'zh-hant': `儲存後會開放可分享連結。`,
	en: `Shareable link will be available after saving.`
};

export const loc_sharedWithOrganization: Record<Locale, string> = {
	ar: `مشارك مع المنظمة`,
	de: `Geteilt mit der Organisation`,
	es: `Compartido con la organización`,
	fa: `به اشتراک گذاشته شده با سازمان`,
	fil: `Ibinahagi sa organisasyon`,
	fr: `Partagé avec l’organisation`,
	hi: `संगठन के साथ साझा किया गया`,
	ht: `Pataje ak òganizasyon`,
	it: `Condiviso con l'organizzazione`,
	ja: `組織と共有`,
	ko: `조직과 공유됨`,
	mww: `Qhia rau lub koom haum`,
	ps: `له سازمان سره شریک شوی`,
	pt: `Compartilhado com a organização`,
	'pt-pt': `Partilhado com a organização`,
	ru: `Совместное с организацией`,
	sm: `Fa'asoa ma le fa'alapotopotoga`,
	so: `La wadaag ururka`,
	th: `แชร์กับองค์กร`,
	ur: `تنظیم کے ساتھ شیئر کیا گیا`,
	vi: `Chia sẻ với tổ chức`,
	'zh-hans': `与组织共享`,
	'zh-hant': `與組織共享`,
	en: `Shared with organization`
};

export const loc_sharedWithProjectFormat: Record<Locale, (project: unknown) => string> = {
	ar: (project) => `مشارك مع ${project}`,
	de: (project) => `Geteilt mit ${project}`,
	es: (project) => `Compartido con el proyecto ${project}`,
	fa: (project) => `به اشتراک گذاشته شده با ${project}`,
	fil: (project) => `Ibinahagi sa proyekto ${project}`,
	fr: (project) => `Partagé avec le projet ${project}`,
	hi: (project) => `${project} परियोजना के साथ साझा किया गया`,
	ht: (project) => `Pataje ak ${project}`,
	it: (project) => `Condiviso con il progetto ${project}`,
	ja: (project) => `${project}プロジェクトと共有`,
	ko: (project) => `${project} 프로젝트와 공유됨`,
	mww: (project) => `Qhia nrog ${project} project`,
	ps: (project) => `د ${project} پروژې سره شریک شوی`,
	pt: (project) => `Compartilhado com o projeto ${project}`,
	'pt-pt': (project) => `Partilhado com o projeto ${project}`,
	ru: (project) => `Совместно с ${project}`,
	sm: (project) => `Fa'asoa ma ${project}`,
	so: (project) => `La wadaagay ${project}`,
	th: (project) => `ใช้ร่วมกับโครงการ ${project}`,
	ur: (project) => `${project} پروجیکٹ کے ساتھ شیئر کیا گیا`,
	vi: (project) => `Chia sẻ với dự án ${project}`,
	'zh-hans': (project) => `与 ${project} 项目共享`,
	'zh-hant': (project) => `與 ${project} 專案共享`,
	en: (project) => `Shared with ${project} project`
};

export const loc_sidebarMarketingFormat: Record<Locale, (cumulus: unknown, org: unknown) => TemplateResult> = {
	ar: (cumulus, org) => html`<span>هل ترغب في استخدام ${cumulus} لبرامج ${org} الأخرى؟</span>`,
	de: (cumulus, org) => html`<span>Möchten Sie Cumulus für andere ${org} verwenden?${cumulus}</span>`,
	es: (cumulus, org) => html`<span>¿Quieres usar ${cumulus} para otros programas ${org} ?</span>`,
	fa: (cumulus, org) => html`<span>می خواهید ${cumulus} برای برنامه های ${org} استفاده کنید؟</span>`,
	fil: (cumulus, org) => html`<span>Gusto mo bang gamitin ang ${cumulus} para sa iba pang mga programa ng ${org}</span>`,
	fr: (cumulus, org) => html`<span>Vous souhaitez utiliser ${cumulus} pour d’autres programmes ${org} ?</span>`,
	hi: (cumulus, org) => html`<span>अन्य ${org} कार्यक्रमों के लिए ${cumulus} का उपयोग करना चाहते हैं?</span>`,
	ht: (cumulus, org) => html`<span>Vle sèvi ak ${cumulus} pou lòt pwogram ${org} ?</span>`,
	it: (cumulus, org) => html`<span>Vuoi usare ${cumulus} per altri programmi ${org} ?</span>`,
	ja: (cumulus, org) => html`<span>他の${org}プログラムで${cumulus}を使いたいですか?</span>`,
	ko: (cumulus, org) => html`<span>다른 ${org} 프로그램에서 ${cumulus}를 사용하고 싶으신가요?</span>`,
	mww: (cumulus, org) => html`<span>Xav siv ${cumulus} rau lwm cov ${org} ?</span>`,
	ps: (cumulus, org) => html`<span>غواړئ ${cumulus} د نورو ${org} پروګرامونو لپاره وکاروئ؟</span>`,
	pt: (cumulus, org) => html`<span>Quer usar ${cumulus} para outros programas ${org} ?</span>`,
	'pt-pt': (cumulus, org) => html`<span>Quer usar ${cumulus} para outros programas ${org} ?</span>`,
	ru: (cumulus, org) => html`<span>Хотите использовать ${cumulus} для других ${org} ?</span>`,
	sm: (cumulus, org) => html`<span>E te mana'o e ${cumulus} mo isi ${org}</span>`,
	so: (cumulus, org) => html`<span>Ma rabtaa inaad ${cumulus} barnaamijyada ${org} ?</span>`,
	th: (cumulus, org) => html`<span>ต้องการใช้ ${cumulus} สําหรับโปรแกรม ${org} อื่นๆ หรือไม่?</span>`,
	ur: (cumulus, org) => html`<span>کیا آپ ${cumulus} کو دوسرے ${org} پروگرامز کے لیے استعمال کرنا چاہتے ہیں؟</span>`,
	vi: (cumulus, org) => html`<span>Bạn muốn sử dụng ${cumulus} cho các chương trình ${org} khác?</span>`,
	'zh-hans': (cumulus, org) => html`<span>想用 ${cumulus} 做其他 ${org} 项目吗？</span>`,
	'zh-hant': (cumulus, org) => html`<span>想用 ${cumulus} 做其他 ${org} 計畫嗎？</span>`,
	en: (cumulus, org) => html`<span>Want to use ${cumulus} for other ${org} programs?</span>`
};

export const loc_sign: Record<Locale, string> = {
	ar: `الإشارة`,
	de: `Zeichen`,
	es: `Signo`,
	fa: `تابلو`,
	fil: `Mag-sign`,
	fr: `Signe`,
	hi: `संकेत`,
	ht: `Siy`,
	it: `Insegna`,
	ja: `看板`,
	ko: `징후`,
	mww: `kos npe`,
	ps: `لاسلیک`,
	pt: `Placa`,
	'pt-pt': `Placa`,
	ru: `Знак`,
	sm: `Saini`,
	so: `Calaamad`,
	th: `ลงชื่อ`,
	ur: `سائن`,
	vi: `Ký hiệu`,
	'zh-hans': `标志`,
	'zh-hant': `標誌`,
	en: `Sign`
};

export const loc_signature: Record<Locale, string> = {
	ar: `التوقيع`,
	de: `Signatur`,
	es: `Firma`,
	fa: `امضا`,
	fil: `Lagda`,
	fr: `Signature`,
	hi: `दस्‍तख़त देखिए।`,
	ht: `Siyati`,
	it: `Firma`,
	ja: `署名`,
	ko: `시그니처`,
	mww: `Kos Npe`,
	ps: `لاسلیک`,
	pt: `Assinatura`,
	'pt-pt': `Assinatura`,
	ru: `Подпись`,
	sm: `Saini`,
	so: `Saxiixa`,
	th: `ลายเซ็น`,
	ur: `دستخط`,
	vi: `Chữ ký`,
	'zh-hans': `签名`,
	'zh-hant': `簽名`,
	en: `Signature`
};

export const loc_signatureAlreadyProvidedDesc: Record<Locale, string> = {
	ar: `تم بالفعل تقديم توقيع لهذا السؤال. لطلب توقيع جديد، احذف أولا أي توقيعات موجودة في هذا `,
	de: `Für diese Frage wurde bereits eine Unterschrift vorgelegt. Um eine neue Signatur anzufordern, löschen Sie zunächst alle bestehenden Signaturen darin `,
	es: `Ya se ha proporcionado una firma para esta pregunta. Para solicitar una nueva firma, primero elimina cualquier firma existente en este `,
	fa: `برای این سؤال قبلا امضایی ارائه شده است. برای درخواست امضای جدید، ابتدا هر امضای موجود را در این بخش حذف کنید `,
	fil: `Isang lagda ang ibinigay para sa tanong na ito. Upang humiling ng bagong lagda, tanggalin muna ang anumang umiiral na lagda dito `,
	fr: `Une signature a déjà été fournie pour cette question. Pour demander une nouvelle signature, supprimez d’abord toutes les signatures existantes dans ce site `,
	hi: `इस प्रश्न के लिए एक हस्ताक्षर पहले ही प्रदान किया जा चुका है। नए हस्ताक्षर का अनुरोध करने के लिए, पहले इसमें मौजूद किसी भी हस्ताक्षर को हटा दें `,
	ht: `Yo deja bay yon siyati pou kesyon sa a. Pou mande yon nouvo siyati, premye efase nenpòt ki siyati ki deja egziste nan sa a `,
	it: `È già stata fornita una firma per questa domanda. Per richiedere una nuova firma, prima elimina tutte le firme esistenti in questo `,
	ja: `この質問にはすでに署名が提供されています。新しい署名を要求するには、まずこの署名内の既存の署名を削除してください `,
	ko: `이 질문에 대한 서명은 이미 제출되었습니다. 새 서명을 요청하려면 먼저 이 사이트에 있는 기존 서명을 삭제하세요 `,
	mww: `Twb tau muab ib daim ntawv kos npe rau lo lus nug no. Txhawm rau thov kev kos npe tshiab, ua ntej rho tawm cov kos npe uas twb muaj lawm hauv qhov no `,
	ps: `د دې پوښتنې لپاره لاسلیک مخکې ورکړل شوی دی. د نوی لاسلیک غوښتلو لپاره، لومړی موجود لاسلیکونه په دې کې حذف کړئ `,
	pt: `Uma assinatura já foi fornecida para essa pergunta. Para solicitar uma nova assinatura, primeiro exclua quaisquer assinaturas existentes neste `,
	'pt-pt': `Já foi fornecida uma assinatura para esta questão. Para solicitar uma nova assinatura, primeiro elimine quaisquer assinaturas existentes neste `,
	ru: `Подпись на этот вопрос уже предоставлена. Чтобы запросить новую подпись, сначала удалите все существующие подписи в этой `,
	sm: `Ua uma ona tuuina atu se saini mo lenei fesili. Ina ia talosagaina se saini fou, tape muamua soo se saini o loo i ai i lenei `,
	so: `Saxiix hore ayaa loo bixiyay su'aashan. Si aad u codsato saxiix cusub, marka hore tirtir saxiixyada hore ee ku jira `,
	th: `มีลายเซ็นสําหรับคําถามนี้แล้ว หากต้องการขอลายเซ็นใหม่ ให้ลบลายเซ็นที่มีอยู่ในนี้ก่อน `,
	ur: `اس سوال کے لیے دستخط پہلے ہی فراہم کیے جا چکے ہیں۔ نئے دستخط کی درخواست کرنے کے لیے، پہلے اس میں موجود دستخط حذف کر دیں `,
	vi: `Một chữ ký đã được cung cấp cho câu hỏi này. Để yêu cầu chữ ký mới, trước tiên hãy xóa mọi chữ ký hiện có trong `,
	'zh-hans': `这个问题已经有人签名了。要请求新的签名，首先删除该签名中所有现有的签名 `,
	'zh-hant': `此問題已提供簽名。要申請新的簽章，請先刪除此中所有現有的簽章 `,
	en: `A signature has already been provided for this question. To request a new signature, first delete any existing signatures in this `
};

export const loc_signatureDocNotFound: Record<Locale, string> = {
	ar: `لم يتم العثور على وثيقة التوقيع.`,
	de: `Unterschriftsdokument nicht gefunden.`,
	es: `Documento de firma no encontrado.`,
	fa: `سند امضا پیدا نشد.`,
	fil: `Hindi natagpuan ang dokumento ng lagda.`,
	fr: `Document de signature non trouvé.`,
	hi: `हस्ताक्षर दस्तावेज़ नहीं मिला.`,
	ht: `Dokiman siyati pa jwenn`,
	it: `Documento di firma non trovato.`,
	ja: `署名書類が見つかりません。`,
	ko: `서명 문서를 찾지 못했습니다.`,
	mww: `Daim ntawv kos npe tsis pom.`,
	ps: `د لاسلیک سند نه دی موندل شوی.`,
	pt: `Documento de assinatura não encontrado.`,
	'pt-pt': `Documento de assinatura não encontrado.`,
	ru: `Документ с подписью не найден.`,
	sm: `E le o maua le pepa o faamatalaga o le saini.`,
	so: `Dukumentiga saxiixa lama helin.`,
	th: `ไม่พบเอกสารลายเซ็น`,
	ur: `دستخطی دستاویز نہیں ملی۔`,
	vi: `Không tìm thấy tài liệu chữ ký.`,
	'zh-hans': `找不到签名文件。`,
	'zh-hant': `找不到簽名文件。`,
	en: `Signature document not found.`
};

export const loc_signatureLinkWarning: Record<Locale, string> = {
	ar: `سينتهي صلاحية رابط النموذج بعد 7 أيام. أي شخص يستلم الرابط سيتمكن من الوصول إلى النموذج حتى ينتهي صلاحيته أو يكمل.`,
	de: `Der Link zum Formular läuft nach 7 Tagen ab. Jeder, der den Link erhält, kann auf das Formular zugreifen, bis es abläuft oder ausgefüllt ist.`,
	es: `El enlace al formulario caducará después de 7 días. Cualquiera que reciba el enlace podrá acceder al formulario hasta que expire o se complete.`,
	fa: `لینک فرم پس از ۷ روز منقضی می شود. هر کسی که لینک را دریافت کند، می تواند تا زمان انقضا یا تکمیل فرم به آن دسترسی داشته باشد.`,
	fil: `Ang link sa form ay mag-e-expire pagkatapos ng 7 araw. Ang sinumang makakatanggap ng link ay maaaring ma-access ang form hanggang sa mag-expire ito o makumpleto.`,
	fr: `Le lien vers le formulaire expirera après 7 jours. Toute personne recevant le lien pourra accéder au formulaire jusqu’à son expiration ou sa remplissage.`,
	hi: `फॉर्म का लिंक 7 दिनों के बाद समाप्त हो जाएगा। लिंक प्राप्त करने वाला कोई भी व्यक्ति फॉर्म को समाप्त होने या पूरा होने तक एक्सेस कर सकेगा।`,
	ht: `Lyen ki mennen nan fòm nan ap ekspire apre 7 jou. Nenpòt moun k ap resevwa lyen an ap kapab jwenn aksè nan fòm lan jiskaske li ekspire oswa fini.`,
	it: `Il link al modulo scade dopo 7 giorni. Chiunque riceva il link potrà accedere al modulo fino alla sua scadenza o completamento.`,
	ja: `フォームへのリンクは7日後に期限切れになります。リンクを受け取った人は、フォームが有効期限になるか完了するまでアクセスできます。`,
	ko: `양식 링크는 7일 후에 만료됩니다. 링크를 받은 사람은 양식이 만료되거나 완료될 때까지 접근할 수 있습니다.`,
	mww: `Qhov txuas rau daim foos yuav tas sij hawm tom qab 7 hnub. Txhua tus neeg uas tau txais qhov txuas yuav tuaj yeem nkag mus rau daim foos kom txog thaum nws tas sijhawm lossis ua tiav.`,
	ps: `د فورم لینک به له ۷ ورځو وروسته ختم شی. هر څوک چې لینک ترلاسه کړی، کولی شی فورمه تر هغه وخته وګوری چې پای ته ورسیږی یا بشپړ شی.`,
	pt: `O link para o formulário expirará após 7 dias. Qualquer pessoa que receber o link poderá acessar o formulário até que ele expire ou seja preenchido.`,
	'pt-pt': `O link para o formulário expira após 7 dias. Qualquer pessoa que receba o link poderá aceder ao formulário até expirar ou ser preenchido.`,
	ru: `Ссылка на форму истечёт через 7 дней. Любой, кто получит ссылку, сможет получить доступ к форме до её истечения срока действия или заполнения.`,
	sm: `O le feso'ota'iga i le fomu o le a fa'amutaina pe a mae'a le 7 aso. So'o se tasi e mauaina le feso'ota'iga o le a mafai ona maua le fomu se'ia mae'a pe fa'amae'aina.`,
	so: `Xiriirka foomka wuxuu dhacayaa 7 maalmood kadib. Qof kasta oo helaya link-ka wuxuu heli karaa foomka ilaa uu dhaco ama la dhammeeyo.`,
	th: `ลิงก์ไปยังแบบฟอร์มจะหมดอายุหลังจาก 7 วัน ทุกคนที่ได้รับลิงก์จะสามารถเข้าถึงแบบฟอร์มได้จนกว่าจะหมดอายุหรือเสร็จสมบูรณ์`,
	ur: `فارم کا لنک 7 دن بعد ختم ہو جائے گا۔ جو بھی لنک وصول کرے گا، وہ فارم تک اس وقت تک رسائی حاصل کر سکے گا جب تک یہ ختم نہ ہو جائے یا مکمل نہ ہو جائے۔`,
	vi: `Liên kết đến biểu mẫu sẽ hết hạn sau 7 ngày. Bất kỳ ai nhận được liên kết sẽ có thể truy cập biểu mẫu cho đến khi nó hết hạn hoặc hoàn thành.`,
	'zh-hans': `表格链接将在7天后失效。收到链接的人都可以访问该表格，直到表格过期或填写完毕。`,
	'zh-hant': `表格連結將於7天後失效。任何收到連結的人都能存取該表格，直到表格過期或完成為止。`,
	en: `The link to the form will expire after 7 days. Anyone receiving the link will be able to access the form until it expires or is completed.`
};

export const loc_signaturePageInstructions: Record<Locale, (senderName: unknown, senderGivenName: unknown, senderEmail: unknown, expires: unknown) => TemplateResult> = {
	ar: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} أرسل لك هذا النموذج لتوقيعه. راجع المعلومات أدناه <a href="#sign-button">ووقع في الأسفل</a>. إذا كان لديك أسئلة، تواصل ${senderGivenName} عبر البريد الإلكتروني <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. ستنتهي صلاحية هذا النموذج ${expires}`,
	de: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} hat Ihnen dieses Formular zum Unterschreiben geschickt. Lesen Sie die untenstehenden Informationen und <a href="#sign-button">unterschreiben Sie unten</a>. Wenn Sie Fragen haben, kontaktieren ${senderGivenName} per E-Mail unter <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Dieses Formular läuft ${expires}`,
	es: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} te envió este formulario para que firmes. Revisa la información de abajo y <a href="#sign-button">firma al final</a>. Si tienes preguntas, contacta ${senderGivenName} por correo electrónico <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulario caducará ${expires}`,
	fa: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} این فرم را برای امضا فرستاد. اطلاعات زیر را مرور کنید و <a href="#sign-button">در پایین امضا</a> کنید. اگر سوالی دارید، از طریق ایمیل با ${senderGivenName} به <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> تماس بگیرید. این فرم ${expires} منقضی خواهد شد.`,
	fil: (senderName, senderGivenName, senderEmail, expires) => html`Ipinadala sa iyo ${senderName} ang form na ito upang pirmahan. Suriin ang impormasyon sa ibaba at <a href="#sign-button">mag-sign sa ibaba</a>. Kung mayroon kang mga katanungan, makipag-ugnay kay ${senderGivenName} sa pamamagitan ng email sa <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Ang form na ito ay mag-e-expire ${expires}`,
	fr: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} t’a envoyé ce formulaire à signer. Consultez les informations ci-dessous et <a href="#sign-button">signez en bas</a>. Si vous avez des questions, contactez ${senderGivenName} par email à <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Ce formulaire expirera ${expires}`,
	hi: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} ने आपको यह फॉर्म साइन करने के लिए भेजा है। नीचे दी गई जानकारी की समीक्षा करें और <a href="#sign-button">नीचे हस्ताक्षर करें</a>। यदि आपके कोई प्रश्न हैं, तो <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> ईमेल के माध्यम से ${senderGivenName} संपर्क करें। यह फॉर्म ${expires} समाप्त हो जाएगा।`,
	ht: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} voye ou fòm sa a pou siyen. Revize enfòmasyon ki anba yo epi <a href="#sign-button">siyen nan pati anba a</a>. Si ou gen kesyon, kontakte ${senderGivenName} pa imèl nan <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Fòm sa a ap ekspire ${expires}`,
	it: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} ti ha mandato questo modulo da firmare. Consulta le informazioni qui sotto e <a href="#sign-button">firma in fondo</a>. Se hai domande, contatta ${senderGivenName} via email al <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Questo modulo scadrà ${expires}`,
	ja: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} この書類に署名を求めて送った。以下の情報をよく確認し、 <a href="#sign-button">最後に署名してください</a>。ご質問がある場合は、 ${senderGivenName} にメールでご連絡ください。 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>。このフォームは ${expires}で期限切れとなります。`,
	ko: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} 이 서류를 보냈습니다. 아래 정보를 검토하고 <a href="#sign-button">하단에 서명해</a> 주세요. 궁금한 점이 있으면 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> 로 이메일을 통해 ${senderGivenName}에게 연락해 주세요. 이 양식은 ${expires}에 만료됩니다.`,
	mww: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} tau xa daim ntawv no rau koj kos npe. Txheeb xyuas cov ntaub ntawv hauv qab no thiab <a href="#sign-button">kos npe rau hauv qab</a>. Yog tias koj muaj lus nug, hu rau ${senderGivenName} ntawm email ntawm <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Daim ntawv no yuav tas sij hawm ${expires}`,
	ps: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} تا ته دا فورمه د لاسلیک لپاره راولېږله. لاندې معلومات وګورئ او <a href="#sign-button">په پای کې لاسلیک</a> کړئ. که پوښتنې لرئ، ${senderGivenName} ته په ایمیل کې <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. دا فورمه به ${expires} پای ته ورسېږی.`,
	pt: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} enviou este formulário para você assinar. Revise as informações abaixo e <a href="#sign-button">assine no final</a>. Se tiver dúvidas, entre em contato ${senderGivenName} por e-mail <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulário expirará ${expires}`,
	'pt-pt': (senderName, senderGivenName, senderEmail, expires) => html`${senderName} enviou-lhe este formulário para assinar. Consulte a informação abaixo e <a href="#sign-button">assine no final</a>. Se tiver dúvidas, contacte ${senderGivenName} por email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulário expira ${expires}`,
	ru: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} прислал тебе эту форму для подписи. Ознакомьтесь с информацией ниже и <a href="#sign-button">распишитесь внизу</a>. Если у вас есть вопросы, свяжитесь ${senderGivenName} по электронной почте <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Эта форма истекает ${expires}`,
	sm: (senderName, senderGivenName, senderEmail, expires) => html`Na auina atu ${senderName} te oe lenei fomu e saini ai. Toe iloilo le faamatalaga o loo i lalo ma <a href="#sign-button">saini i le pito i lalo</a>. Afai ei ai ni au fesili, fa'afeso'ota'i ${senderGivenName} e ala i le imeli i le <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. O lenei fomu o le a muta ${expires}`,
	so: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} ayaa kuu soo diray foomkan si aad u saxiixdo. Eeg macluumaadka hoose oo <a href="#sign-button">saxiix hoos</a>. Haddii aad su'aalo qabto, ${senderGivenName} email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Foomkan wuxuu dhici ${expires}`,
	th: (senderName, senderGivenName, senderEmail, expires) => html`${senderName}ส่งแบบฟอร์มนี้ให้คุณลงนาม ตรวจสอบข้อมูลด้านล่างและ<a href="#sign-button">ลงชื่อที่ด้านล่าง</a> หากคุณมีคําถาม โปรดติดต่อ${senderGivenName}ทางอีเมลที่ <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> แบบฟอร์มนี้จะหมดอายุใน${expires}`,
	ur: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} نے تمہیں یہ فارم دستخط کرنے کے لیے بھیجا ہے۔ نیچے دی گئی معلومات کا جائزہ لیں اور <a href="#sign-button">نیچے دستخط کریں۔</a> اگر آپ کے کوئی سوالات ہیں تو ${senderGivenName} سے ای میل <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> پر رابطہ کریں۔ یہ فارم ${expires} ختم ہو جائے گا۔`,
	vi: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} đã gửi cho bạn mẫu này để ký. Xem lại thông tin bên dưới và <a href="#sign-button">ký tên ở dưới cùng</a>. Nếu bạn có thắc mắc, hãy liên hệ với ${senderGivenName} qua email theo số <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Biểu mẫu này sẽ hết hạn vào ${expires}`,
	'zh-hans': (senderName, senderGivenName, senderEmail, expires) => html`${senderName} 寄给你这份表格让你签字。请查看以下信息并在 <a href="#sign-button">底部签名</a>。如有疑问，请通过电子邮件联系 ${senderGivenName} ，邮箱 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>。该表格将于 ${expires}）到期。`,
	'zh-hant': (senderName, senderGivenName, senderEmail, expires) => html`${senderName} 寄給你這份表格要你簽名。請參考以下資訊並在 <a href="#sign-button">底部簽名</a>。如有疑問，請透過電子郵件聯絡 ${senderGivenName} ，地址為 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>。此表格將於 ${expires}）到期。`,
	en: (senderName, senderGivenName, senderEmail, expires) => html`${senderName} sent you this form to sign. Review the information below and <a href="#sign-button">sign at the bottom</a>. If you have questions, contact ${senderGivenName} via email at <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. This form will expire ${expires}.`
};

export const loc_signatureQRCodeInstructions: Record<Locale, string> = {
	ar: `للإرسال باستخدام هاتفك، امسح رمز QR باستخدام تطبيق الكاميرا.`,
	de: `Um mit Ihrem Handy zu senden, scannen Sie den QR-Code mit Ihrer Kamera-App.`,
	es: `Para enviar con tu teléfono, escanea el código QR con la aplicación de la cámara.`,
	fa: `برای ارسال با گوشی خود، کد QR را با اپلیکیشن دوربین اسکن کنید.`,
	fil: `Upang magpadala gamit ang iyong telepono, i-scan ang QR code gamit ang iyong camera app.`,
	fr: `Pour envoyer avec votre téléphone, scannez le code QR avec votre application caméra.`,
	hi: `अपने फ़ोन का उपयोग करके भेजने के लिए, अपने कैमरा ऐप से क्यूआर कोड को स्कैन करें।`,
	ht: `Pou voye lè l sèvi avèk telefòn ou, eskane kòd QR la ak app kamera ou.`,
	it: `Per inviare con il telefono, scansiona il codice QR con l'app della fotocamera.`,
	ja: `スマホで送信するには、カメラアプリでQRコードをスキャンしてください。`,
	ko: `휴대폰으로 보내려면 카메라 앱으로 QR 코드를 스캔하세요.`,
	mww: `Txhawm rau xa koj lub xov tooj, luam theej duab QR code nrog koj lub koob yees duab app.`,
	ps: `د خپل موبایل له لارې د لیږلو لپاره، QR کوډ د خپل کمرې اپلیکیشن سره سکین کړئ.`,
	pt: `Para enviar pelo celular, escaneie o código QR com o aplicativo da câmera.`,
	'pt-pt': `Para enviar usando o telemóvel, digitalize o código QR com a aplicação da câmara.`,
	ru: `Чтобы отправить с телефона, отсканируйте QR-код с помощью приложения камеры.`,
	sm: `Ina ia lafoina e fa'aaoga ai lau telefoni, fa'ata'ita'i le QR code ma lau mea pu'eata polokalama.`,
	so: `Si aad u dirto adigoo adeegsanaya taleefankaaga, baar koodhka QR adigoo adeegsanaya app-ka kamaraddaada.`,
	th: `หากต้องการส่งโดยใช้โทรศัพท์ ให้สแกนคิวอาร์โค้ดด้วยแอพกล้องถ่ายรูป`,
	ur: `اپنے فون سے بھیجنے کے لیے، اپنے کیمرہ ایپ سے QR کوڈ اسکین کریں۔`,
	vi: `Để gửi bằng điện thoại của bạn, hãy quét mã QR bằng ứng dụng máy ảnh của bạn.`,
	'zh-hans': `用手机发送时，用相机应用扫描二维码。`,
	'zh-hant': `要用手機發送，請用相機App掃描QR碼。`,
	en: `To send using your phone, scan the QR code with your camera app.`
};

export const loc_signatureRequestExpired: Record<Locale, string> = {
	ar: `انتهت صلاحية طلب التوقيع`,
	de: `Unterschriftsanfrage abgelaufen`,
	es: `Solicitud de firma expirada`,
	fa: `درخواست امضا منقضی شد`,
	fil: `Nag-expire na ang kahilingan sa lagda`,
	fr: `Demande de signature expirée`,
	hi: `हस्ताक्षर अनुरोध की समय सीमा समाप्त हो गई`,
	ht: `Demann siyati ekspire`,
	it: `Richiesta di firma scaduta`,
	ja: `署名申請が期限切れとなりました`,
	ko: `서명 요청이 만료되었습니다`,
	mww: `Kev thov kos npe tas sij hawm`,
	ps: `د لاسلیک غوښتنه پای ته ورسېده`,
	pt: `Pedido de assinatura expirado`,
	'pt-pt': `Pedido de assinatura expirado`,
	ru: `Запрос на подпись истёк`,
	sm: `Ua uma le aoga o le talosaga mo saini`,
	so: `Codsiga saxiixa wuu dhacay`,
	th: `คําขอลายเซ็นหมดอายุ`,
	ur: `دستخط کی درخواست ختم ہو گئی`,
	vi: `Yêu cầu chữ ký đã hết hạn`,
	'zh-hans': `签名请求已过期`,
	'zh-hant': `簽名申請已過期`,
	en: `Signature request expired`
};

export const loc_signatureRequestExpiredDescFormat: Record<Locale, (when: unknown) => TemplateResult> = {
	ar: (when) => html`<p>انتهى هذا الطلب للتوقيع ${when}.</p>`,
	de: (when) => html`<p>Diese Unterschriftsanfrage ist ${when} abgelaufen.</p>`,
	es: (when) => html`<p>Esta solicitud de firma ${when}.</p>`,
	fa: (when) => html`<p>این درخواست امضا ${when} منقضی شده.</p>`,
	fil: (when) => html`<p>Ang kahilingan na ito para sa lagda ay nag-expire ${when}.</p>`,
	fr: (when) => html`<p>Cette demande de signature a ${when}.</p>`,
	hi: (when) => html`<p>हस्ताक्षर के लिए यह अनुरोध ${when} समाप्त हो गया था।</p>`,
	ht: (when) => html`<p>Demann sa a pou siyati ekspire ${when}</p>`,
	it: (when) => html`<p>Questa richiesta di firma è ${when}.</p>`,
	ja: (when) => html`<p>この署名請求は ${when}期限切れです。</p>`,
	ko: (when) => html`<p>서명 요청은 ${when} 만료되었습니다.</p>`,
	mww: (when) => html`<p>Qhov kev thov kos npe no tau tas sijhawm ${when}.</p>`,
	ps: (when) => html`<p>دا د لاسلیک غوښتنه ${when} پای ته رسېدلې.</p>`,
	pt: (when) => html`<p>Esse pedido de assinatura ${when}.</p>`,
	'pt-pt': (when) => html`<p>Este pedido de assinatura ${when}.</p>`,
	ru: (when) => html`<p>Этот запрос на подпись истёк ${when}.</p>`,
	sm: (when) => html`<p>O lenei talosaga mo le saini na faamutaina ${when}.</p>`,
	so: (when) => html`<p>Codsigan saxiixa wuxuu dhacay ${when}.</p>`,
	th: (when) => html`<p>คําขอลายเซ็นนี้หมดอายุเมื่อ ${when}</p>`,
	ur: (when) => html`<p>یہ دستخط کی درخواست ${when} ختم ہو چکی ہے۔</p>`,
	vi: (when) => html`<p>Yêu cầu chữ ký này đã hết hạn ${when}.</p>`,
	'zh-hans': (when) => html`<p>这个签名请求在 ${when}过期了。</p>`,
	'zh-hant': (when) => html`<p>這個簽名申請在 ${when}過期。</p>`,
	en: (when) => html`<p>This request for signature expired ${when}.</p>`
};

export const loc_signatureRequests: Record<Locale, string> = {
	ar: `طلبات التوقيع`,
	de: `Unterschriftsanfragen`,
	es: `Solicitudes de firma`,
	fa: `درخواست های امضا`,
	fil: `Email Address *`,
	fr: `Demandes de signature`,
	hi: `हस्ताक्षर अनुरोध`,
	ht: `Demann siyati`,
	it: `Richieste di firma`,
	ja: `署名要求`,
	ko: `서명 요청`,
	mww: `Kev thov kos npe`,
	ps: `د لاسلیک غوښتنې`,
	pt: `Pedidos de assinatura`,
	'pt-pt': `Pedidos de assinatura`,
	ru: `Запросы на подпись`,
	sm: `Talosaga saini`,
	so: `Codsiyada saxiixa`,
	th: `คําขอลายเซ็น`,
	ur: `دستخط کی درخواستیں`,
	vi: `Yêu cầu chữ ký`,
	'zh-hans': `签名请求`,
	'zh-hant': `簽名請求`,
	en: `Signature requests`
};

export const loc_signedInAs: Record<Locale, (login: unknown) => string> = {
	ar: (login) => `سجل الدخول باسم ${login}`,
	de: (login) => `Eingetragen als ${login}`,
	es: (login) => `Iniciado como ${login}`,
	fa: (login) => `ثبت نام ${login}`,
	fil: (login) => `Naka-sign in bilang ${login}`,
	fr: (login) => `Enregistré sous le nom ${login}`,
	hi: (login) => `${login} के रूप में साइन इन किया`,
	ht: (login) => `Siyen nan kòm ${login}`,
	it: (login) => `Registrato come ${login}`,
	ja: (login) => `${login}名義でサインイン`,
	ko: (login) => `${login}으로 로그인됨`,
	mww: (login) => `Kos npe rau hauv raws li ${login}`,
	ps: (login) => `د ${login} په نوم لاسلیک شوی`,
	pt: (login) => `Registrado como ${login}`,
	'pt-pt': (login) => `Assinado como ${login}`,
	ru: (login) => `Регистрация под ${login}`,
	sm: (login) => `Saini i totonu o ${login}`,
	so: (login) => `Waxaa lagu saxiixay ${login}`,
	th: (login) => `ลงชื่อเข้าใช้ในฐานะ ${login}`,
	ur: (login) => `${login} کے نام سے سائن ان کیا گیا`,
	vi: (login) => `Đăng ${login} cách John`,
	'zh-hans': (login) => `登录 ${login}`,
	'zh-hant': (login) => `登入時以 ${login}`,
	en: (login) => `Signed in as ${login}`
};

export const loc_signedInMessage: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `أنت مسجل الدخول إلى ${cumulus}.`,
	de: (cumulus) => `Du bist bei ${cumulus} angemeldet.`,
	es: (cumulus) => `Estás registrado en ${cumulus}.`,
	fa: (cumulus) => `شما وارد ${cumulus} شده اید.`,
	fil: (cumulus) => `Naka-sign ka na sa ${cumulus}.`,
	fr: (cumulus) => `Vous êtes inscrit à ${cumulus}.`,
	hi: (cumulus) => `आप ${cumulus} में साइन इन हैं।`,
	ht: (cumulus) => `Ou siyen nan ${cumulus}.`,
	it: (cumulus) => `Sei registrato in ${cumulus}.`,
	ja: (cumulus) => `あなたは ${cumulus}に登録されています。`,
	ko: (cumulus) => `당신은 ${cumulus}에 로그인되어 있습니다.`,
	mww: (cumulus) => `Koj tau kos npe rau hauv ${cumulus}.`,
	ps: (cumulus) => `ته ${cumulus} کې ثبت شوی یې.`,
	pt: (cumulus) => `Você está registrado na ${cumulus}.`,
	'pt-pt': (cumulus) => `Estás registado na ${cumulus}.`,
	ru: (cumulus) => `Вы подписаны в ${cumulus}.`,
	sm: (cumulus) => `Ua e saini i ${cumulus}.`,
	so: (cumulus) => `Waxaad ku jirtaa ${cumulus}.`,
	th: (cumulus) => `คุณลงชื่อเข้าใช้ ${cumulus}แล้ว`,
	ur: (cumulus) => `آپ ${cumulus} میں سائن ان ہیں۔`,
	vi: (cumulus) => `Bạn đã đăng nhập ${cumulus}.`,
	'zh-hans': (cumulus) => `你已登录 ${cumulus}。`,
	'zh-hant': (cumulus) => `你已登入 ${cumulus}。`,
	en: (cumulus) => `You are signed into ${cumulus}.`
};

export const loc_signedOutMessage: Record<Locale, string> = {
	ar: `أنت مسجلة خارج Cumulus. أراكم لاحقا!`,
	de: `Du bist bei Cumulus ausgetragen. Wir sehen uns!`,
	es: `Estás registrado fuera de Cumulus. ¡Nos vemos!`,
	fa: `شما از Cumulus خارج شده اید. می بینمت!`,
	fil: `Naka-sign out ka na sa Cumulus. See you around!`,
	fr: `Vous êtes déconnecté de Cumulus. À plus tard !`,
	hi: `आपने क्यूम्यलस से साइन आउट किया है। फिर मिलते हैं!`,
	ht: `Ou siyen soti nan Cumulus Wè ou alantou!`,
	it: `Sei stato registrato fuori da Cumulus. Ci vediamo in giro!`,
	ja: `あなたはCumulusからサインアウトされました。また会いましょう!`,
	ko: `당신은 Cumulus에서 로그아웃되었습니다. 또 봐요!`,
	mww: `Koj tau kos npe tawm ntawm Cumulus. Pom koj nyob ib puag ncig!`,
	ps: `ته د کومیولس څخه لاسلیک شوی یې. د بیا لیدلو په هیله!`,
	pt: `Você está registrado para sair da Cumulus. Até mais!`,
	'pt-pt': `Estás desligado da Cumulus. Até à próxima!`,
	ru: `Вы вышли из Cumulus. Увидимся!`,
	sm: `Ua e saini mai Cumulus. Toe fetaui!`,
	so: `Waxaad ka baxday Cumulus. An isku aragno meelaha!`,
	th: `คุณลงชื่อออกจาก Cumulus แล้ว แล้วพบกันใหม่!`,
	ur: `آپ Cumulus سے سائن آؤٹ ہو چکے ہیں۔ پھر ملیں گے!`,
	vi: `Bạn đã đăng xuất khỏi Cumulus. Hẹn gặp lại!`,
	'zh-hans': `你已经被Cumulus签出了。回头见！`,
	'zh-hant': `你已經被Cumulus登出。回頭見！`,
	en: `You are signed out of Cumulus. See you around!`
};

export const loc_signIn: Record<Locale, string> = {
	ar: `تسجيل الدخول`,
	de: `Anmelden`,
	es: `Iniciar sesión`,
	fa: `ورود`,
	fil: `Mag-sign in`,
	fr: `Connexion`,
	hi: `साइन इन करें`,
	ht: `Antre`,
	it: `Accedi`,
	ja: `サインイン`,
	ko: `로그인`,
	mww: `Sau npe nkag mus`,
	ps: `دننه شه`,
	pt: `Faça login`,
	'pt-pt': `Iniciar sessão`,
	ru: `Войти`,
	sm: `Saini`,
	so: `Gal`,
	th: `ลงชื่อเข้าใช้`,
	ur: `سائن ان کریں`,
	vi: `Đăng nhập`,
	'zh-hans': `登录`,
	'zh-hant': `登入`,
	en: `Sign in`
};

export const loc_signInSuccessful: Record<Locale, string> = {
	ar: `تسجيل الدخول بنجاح`,
	de: `Anmeldung erfolgreich`,
	es: `Inicio de sesión exitoso`,
	fa: `ورود موفقیت آمیز`,
	fil: `Mag-sign in nang matagumpay`,
	fr: `Connexion réussie`,
	hi: `सफल साइन इन करें`,
	ht: `Siyen nan siksè`,
	it: `Accesso riuscito`,
	ja: `サインイン成功`,
	ko: `로그인 성공`,
	mww: `Kos npe rau hauv kev vam meej`,
	ps: `ننوتل بریالی شو`,
	pt: `Iniciar sessão com sucesso`,
	'pt-pt': `Iniciar sessão bem-sucedida`,
	ru: `Войти успешно`,
	sm: `Saini manuia`,
	so: `Saxiix guul leh`,
	th: `ลงชื่อเข้าใช้สําเร็จ`,
	ur: `سائن ان کامیاب ہوا`,
	vi: `Đăng nhập thành công`,
	'zh-hans': `登录成功`,
	'zh-hant': `登入成功`,
	en: `Sign in successful`
};

export const loc_signInToLinkFormat: Record<Locale, (provider: unknown) => string> = {
	ar: (provider) => `سجل الدخول باستخدام بريدك الإلكتروني وكلمة المرور لربط حساب ${provider} الخاص بك.`,
	de: (provider) => `Melden Sie sich mit Ihrer E-Mail und Ihrem Passwort an, um Ihr ${provider} zu verknüpfen.`,
	es: (provider) => `Inicia sesión con tu correo electrónico y contraseña para conectar tu cuenta ${provider} .`,
	fa: (provider) => `با ایمیل و رمز عبور خود وارد شوید تا حساب ${provider} خود را متصل کنید.`,
	fil: (provider) => `Mag-sign in gamit ang iyong email at password upang ikonekta ang iyong ${provider} account.`,
	fr: (provider) => `Connectez-vous avec votre adresse e-mail et votre mot de passe pour connecter votre compte ${provider} .`,
	hi: (provider) => `अपना ${provider} खाता कनेक्ट करने के लिए अपने ईमेल और पासवर्ड से साइन इन करें.`,
	ht: (provider) => `Siyen nan ak imèl ou ak modpas ou konekte kont ${provider} ou.`,
	it: (provider) => `Accedi con email e password per collegare il tuo account ${provider} .`,
	ja: (provider) => `Google ${provider} 接続するには、メールアドレスとパスワードでサインインしてください。`,
	ko: (provider) => `이메일과 비밀번호로 로그인하여 ${provider} 계정을 연결하세요.`,
	mww: (provider) => `Kos npe rau hauv nrog koj tus email thiab lo lus zais los txuas koj tus account ${provider} .`,
	ps: (provider) => `د خپل ایمیل او پاسورډ سره ننوتل وکړئ ترڅو ${provider} حساب وصل کړئ.`,
	pt: (provider) => `Faça login com seu e-mail e senha para conectar sua conta ${provider} .`,
	'pt-pt': (provider) => `Inicie sessão com o seu email e palavra-passe para ligar a sua conta ${provider} .`,
	ru: (provider) => `Войдите с помощью электронной почты и пароля, чтобы подключить свой ${provider} .`,
	sm: (provider) => `Saini i totonu ma lau imeli ma le upu faataga e fesootai ai lau ${provider} account.`,
	so: (provider) => `Gali adigoo isticmaalaya email-kaaga iyo erayga sirta ah si aad ugu xirmaan ${provider} .`,
	th: (provider) => `ลงชื่อเข้าใช้ด้วยอีเมลและรหัสผ่านเพื่อเชื่อมต่อบัญชี ${provider}`,
	ur: (provider) => `اپنے ای میل اور پاس ورڈ کے ساتھ سائن ان کریں تاکہ ${provider} اکاؤنٹ کنیکٹ کر سکیں۔`,
	vi: (provider) => `Đăng nhập bằng email và mật khẩu để kết nối tài khoản ${provider} của bạn.`,
	'zh-hans': (provider) => `使用您的电子邮件和密码登录以连接 ${provider} 账户。`,
	'zh-hant': (provider) => `請用電子郵件和密碼登入，連結你的 ${provider} 帳號。`,
	en: (provider) => `Sign in with your email and password to connect your ${provider} account.`
};

export const loc_signOut: Record<Locale, string> = {
	ar: `تسجيل الخروج`,
	de: `Abmelden`,
	es: `Desconectarse`,
	fa: `خروج`,
	fil: `Mag-sign out`,
	fr: `Déconnectez-vous`,
	hi: `साइन आउट करें`,
	ht: `Siyen soti`,
	it: `Disconnettiti`,
	ja: `サインアウト`,
	ko: `로그아웃`,
	mww: `Kos npe tawm`,
	ps: `وتل`,
	pt: `Sair`,
	'pt-pt': `Desligar`,
	ru: `Выход`,
	sm: `Saini i fafo`,
	so: `Ka bax`,
	th: `ออกจากระบบ`,
	ur: `سائن آؤٹ کریں`,
	vi: `Đăng xuất`,
	'zh-hans': `签出`,
	'zh-hant': `登出`,
	en: `Sign out`
};

export const loc_signOutSuccessful: Record<Locale, string> = {
	ar: `تسجيل الخروج بنجاح`,
	de: `Erfolgreich ausloggen`,
	es: `Cierre de sesión exitoso`,
	fa: `خروج موفق`,
	fil: `Mag-sign out nang matagumpay`,
	fr: `Déconnexion réussie`,
	hi: `सफल साइन आउट करें`,
	ht: `Siyen soti siksè`,
	it: `Disconnettimento riuscito`,
	ja: `サインアウト成功`,
	ko: `로그아웃 성공`,
	mww: `Kos npe tawm ua tiav`,
	ps: `په بریالیتوب سره ووتنه`,
	pt: `Desconectar com sucesso`,
	'pt-pt': `Desligar com sucesso`,
	ru: `Успешный выход`,
	sm: `Saini i fafo ma le manuia`,
	so: `Si guul leh uga bax`,
	th: `ออกจากระบบสําเร็จ`,
	ur: `کامیابی سے سائن آؤٹ کرنا`,
	vi: `Đăng xuất thành công`,
	'zh-hans': `签出成功`,
	'zh-hant': `簽出成功`,
	en: `Sign out successful`
};

export const loc_signOutSuccessfulMessage: Record<Locale, string> = {
	ar: `أنت الآن وقع خارج شركة Cumulus.`,
	de: `Du bist jetzt bei Cumulus ausgeloggt.`,
	es: `Ahora estás registrado en Cumulus.`,
	fa: `شما اکنون از Cumulus خارج شده اید.`,
	fil: `Ngayon ay naka-sign out ka na sa Cumulus.`,
	fr: `Vous êtes maintenant déconnecté de Cumulus.`,
	hi: `अब आप क्यूम्यलस से साइन आउट हो गए हैं।`,
	ht: `Ou se kounye a siyen soti nan cumulus`,
	it: `Ora sei registrato fuori da Cumulus.`,
	ja: `あなたはCumulusからサインアウトしました。`,
	ko: `이제 Cumulus에서 계약을 종료하셨습니다.`,
	mww: `Koj tam sim no kos npe tawm ntawm Cumulus.`,
	ps: `ته اوس د کومیولس څخه لاسلیک شوی یې.`,
	pt: `Agora você está registrado para sair da Cumulus.`,
	'pt-pt': `Agora está desligado da Cumulus.`,
	ru: `Теперь вы вышли из Cumulus.`,
	sm: `O lenei ua e saini ese mai Cumulus.`,
	so: `Hadda waad ka baxday Cumulus.`,
	th: `ตอนนี้คุณลงชื่อออกจาก Cumulus แล้ว`,
	ur: `آپ اب Cumulus سے سائن آؤٹ ہو چکے ہیں۔`,
	vi: `Bây giờ bạn đã đăng xuất khỏi Cumulus.`,
	'zh-hans': `你现在已经被Cumulus签出了。`,
	'zh-hant': `你現在已經簽出 Cumulus。`,
	en: `You are now signed out of Cumulus.`
};

export const loc_signUp: Record<Locale, string> = {
	ar: `سجل`,
	de: `Melden Sie sich an`,
	es: `Regístrate`,
	fa: `ثبت نام کنید`,
	fil: `Email Address *`,
	fr: `Inscrivez-vous`,
	hi: `नाम लिखो`,
	ht: `Enskri`,
	it: `Iscriviti`,
	ja: `サインアップ`,
	ko: `가입하기`,
	mww: `Cuv npe`,
	ps: `ګډون وکړه`,
	pt: `Inscreva-se`,
	'pt-pt': `Inscreva-se`,
	ru: `Зарегистрируйтесь`,
	sm: `Resitala`,
	so: `Diiwaangeli`,
	th: `ลงทะเบียน`,
	ur: `سائن اپ کریں`,
	vi: `Đăng ký`,
	'zh-hans': `注册`,
	'zh-hant': `註冊`,
	en: `Sign up`
};

export const loc_signUpForCumulus: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `سجل في ${cumulus}`,
	de: (cumulus) => `Melden Sie sich für ${cumulus} an`,
	es: (cumulus) => `Apúntate a ${cumulus}`,
	fa: (cumulus) => `برای ${cumulus} ثبت نام کنید`,
	fil: (cumulus) => `Mag-sign up para sa ${cumulus}`,
	fr: (cumulus) => `Inscrivez-vous à ${cumulus}`,
	hi: (cumulus) => `${cumulus} के लिए साइन अप करें`,
	ht: (cumulus) => `Enskri pou ${cumulus}`,
	it: (cumulus) => `Iscriviti a ${cumulus}`,
	ja: (cumulus) => `${cumulus}に登録してください`,
	ko: (cumulus) => `${cumulus}에 가입하세요`,
	mww: (cumulus) => `Sau npe rau ${cumulus}`,
	ps: (cumulus) => `${cumulus} لپاره نوم لیکنه وکړئ`,
	pt: (cumulus) => `Inscreva-se no ${cumulus}`,
	'pt-pt': (cumulus) => `Inscreva-se no ${cumulus}`,
	ru: (cumulus) => `Зарегистрируйтесь на ${cumulus}`,
	sm: (cumulus) => `Saini mo ${cumulus}`,
	so: (cumulus) => `Isdiiwaangeli ${cumulus}`,
	th: (cumulus) => `ลงทะเบียน ${cumulus}`,
	ur: (cumulus) => `${cumulus} کے لیے سائن اپ کریں`,
	vi: (cumulus) => `Đăng ký ${cumulus}`,
	'zh-hans': (cumulus) => `注册 ${cumulus}`,
	'zh-hant': (cumulus) => `註冊 ${cumulus}`,
	en: (cumulus) => `Sign up for ${cumulus}`
};

export const loc_signUpTerms: Record<Locale, TemplateResult> = {
	ar: html`بالنقر على "التسجيل"، فإنك توافق على <a class="target-subtle" href="/terms" target="_blank">شروط الاستخدام</a> <a class="target-subtle" href="/privacy" target="_blank">وسياسة الخصوصية</a> الخاصة بنا. سنرسل لك أحيانا رسائل إلكترونية متعلقة بالحساب.`,
	de: html`Indem Sie auf "Registrieren" klicken, stimmen Sie unseren <a class="target-subtle" href="/terms" target="_blank">Nutzungsbedingungen</a> und <a class="target-subtle" href="/privacy" target="_blank">Datenschutzrichtlinien</a> zu. Gelegentlich senden wir Ihnen kontobezogene E-Mails.`,
	es: html`Al hacer clic en "Regístrate", aceptas nuestros <a class="target-subtle" href="/terms" target="_blank">Términos de Uso</a> y <a class="target-subtle" href="/privacy" target="_blank">Política de Privacidad</a>. De vez en cuando te enviaremos correos electrónicos relacionados con la cuenta.`,
	fa: html`با کلیک روی «ثبت نام»، شما با <a class="target-subtle" href="/terms" target="_blank">شرایط استفاده</a> و <a class="target-subtle" href="/privacy" target="_blank">سیاست حفظ حریم خصوصی</a> ما موافقت می کنید. گاهی اوقات ایمیل های مرتبط با حساب کاربری برایتان ارسال می کنیم.`,
	fil: html`Sa pamamagitan ng pag-click sa "Mag-sign up", sumasang-ayon ka sa aming <a class="target-subtle" href="/terms" target="_blank">Mga Tuntunin ng Paggamit</a> at <a class="target-subtle" href="/privacy" target="_blank">Patakaran sa Pagkapribado</a>. Paminsan-minsan ay magpapadala kami sa iyo ng mga email na may kaugnayan sa account.`,
	fr: html`En cliquant sur « S’inscrire », vous acceptez nos <a class="target-subtle" href="/terms" target="_blank">Conditions d’utilisation</a> et notre <a class="target-subtle" href="/privacy" target="_blank">Politique de confidentialité</a>. Nous vous enverrons parfois des emails liés à votre compte.`,
	hi: html`"साइन अप" पर क्लिक करके, आप हमारी <a class="target-subtle" href="/terms" target="_blank">उपयोग की शर्तों</a> और <a class="target-subtle" href="/privacy" target="_blank">गोपनीयता नीति</a> से सहमत होते हैं। हम कभी-कभी आपको खाते से संबंधित ईमेल भेजेंगे.`,
	ht: html`Lè w klike sou "Enskri", ou dakò ak <a class="target-subtle" href="/terms" target="_blank">nou an Regleman pou Itilize</a> ak <a class="target-subtle" href="/privacy" target="_blank">Règleman sou enfòmasyon prive</a>. Nou pral voye ba ou Imèl kont ki gen rapò ak detanzantan.`,
	it: html`Cliccando su "Iscriviti", accetti i <a class="target-subtle" href="/terms" target="_blank">nostri Termini di Utilizzo</a> e <a class="target-subtle" href="/privacy" target="_blank">l'Informativa sulla Privacy</a>. Occasionalmente ti invieremo email relative all'account.`,
	ja: html`「サインアップ」をクリックすると<a class="target-subtle" href="/terms" target="_blank">、利用規約および</a><a class="target-subtle" href="/privacy" target="_blank">プライバシーポリシー</a>に同意したことになります。時折、アカウント関連のメールをお送りします。`,
	ko: html`"가입"을 클릭하면 이용 <a class="target-subtle" href="/terms" target="_blank">약관</a> 과 <a class="target-subtle" href="/privacy" target="_blank">개인정보처리방침</a>에 동의하는 것으로 간주됩니다. 가끔 계정 관련 이메일을 보내드릴 예정입니다.`,
	mww: html`Los ntawm nias "Sau npe", koj pom zoo rau peb <a class="target-subtle" href="/terms" target="_blank">Cov Lus Cog Tseg ntawm Kev Siv</a> thiab <a class="target-subtle" href="/privacy" target="_blank">Txoj Cai Tswjfwm Ntiag Tug</a>. Peb mam li qee zaum xa koj cov email ntsig txog tus account.`,
	ps: html`د "ثبت نام" په کلیک کولو سره، تاسو زموږ <a class="target-subtle" href="/terms" target="_blank">د کارونې شرایطو</a> او <a class="target-subtle" href="/privacy" target="_blank">محرمیت پالیسۍ سره موافقه کوئ</a>. موږ به کله ناکله تا ته د حساب اړوند ایمیلونه واستوو.`,
	pt: html`Ao clicar em "Cadastrar", você concorda com nossos <a class="target-subtle" href="/terms" target="_blank">Termos de Uso</a> e <a class="target-subtle" href="/privacy" target="_blank">Política de Privacidade</a>. Ocasionalmente, enviaremos e-mails relacionados à sua conta.`,
	'pt-pt': html`Ao clicar em "Registar-se", concorda com os nossos <a class="target-subtle" href="/terms" target="_blank">Termos de Utilização</a> e <a class="target-subtle" href="/privacy" target="_blank">Política de Privacidade</a>. Ocasionalmente, enviamos-lhe emails relacionados com a conta.`,
	ru: html`Нажав «Зарегистрироваться», вы соглашаетесь с нашими <a class="target-subtle" href="/terms" target="_blank">Условиями использования</a> и <a class="target-subtle" href="/privacy" target="_blank">Политикой конфиденциальности</a>. Иногда мы отправляем вам письма, связанные с аккаунтом.`,
	sm: html`I le kilikiina o le "Saini i luga", ua e malilie i a matou <a class="target-subtle" href="/terms" target="_blank">Tuutuuga o Fa'aaoga ma Fa'alilolilo</a> <a class="target-subtle" href="/privacy" target="_blank">Faiga Fa'avae</a>. O nisi taimi matou te lafoina atu ia te oe imeli e feso'ota'i ma teuga tupe.`,
	so: html`Adigoo gujinaya "Isdiiwaangelin", waxaad ogolaatay <a class="target-subtle" href="/terms" target="_blank">Shuruudaha Isticmaalka</a> iyo <a class="target-subtle" href="/privacy" target="_blank">Siyaasadda Asturnaanta</a>. Mararka qaar waxaan kuu soo diri doonaa emails la xiriira akoonka.`,
	th: html`เมื่อคลิก "ลงทะเบียน" แสดงว่าคุณยอมรับ <a class="target-subtle" href="/terms" target="_blank">ข้อกําหนดการใช้งาน</a> และ <a class="target-subtle" href="/privacy" target="_blank">นโยบายความเป็นส่วนตัว</a>ของเรา เราจะส่งอีเมลเกี่ยวกับบัญชีให้คุณเป็นครั้งคราว`,
	ur: html`"سائن اپ" پر کلک کر کے، آپ ہماری <a class="target-subtle" href="/terms" target="_blank">شرائط استعمال</a> اور <a class="target-subtle" href="/privacy" target="_blank">پرائیویسی پالیسی</a> سے اتفاق کرتے ہیں۔ ہم کبھی کبھار آپ کو اکاؤنٹ سے متعلق ای میلز بھیجیں گے۔`,
	vi: html`Bằng cách nhấp vào "Đăng ký", bạn đồng ý với <a class="target-subtle" href="/terms" target="_blank">Điều khoản sử dụng</a> và <a class="target-subtle" href="/privacy" target="_blank">Chính sách quyền riêng tư</a> của chúng tôi. Thỉnh thoảng, chúng tôi sẽ gửi cho bạn các email liên quan đến tài khoản.`,
	'zh-hans': html`点击“注册”即表示您同意我们的 <a class="target-subtle" href="/terms" target="_blank">使用条款</a> 和 <a class="target-subtle" href="/privacy" target="_blank">隐私政策</a>。我们偶尔会向您发送与账户相关的邮件。`,
	'zh-hant': html`點擊「註冊」即表示您同意我們的 <a class="target-subtle" href="/terms" target="_blank">使用條款</a> 及 <a class="target-subtle" href="/privacy" target="_blank">隱私政策</a>。我們偶爾會寄送與帳戶相關的電子郵件給您。`,
	en: html`By clicking "Sign up", you agree to our <a class="target-subtle" href="/terms" target="_blank">Terms of Use</a> and <a class="target-subtle" href="/privacy" target="_blank">Privacy Policy</a>. We’ll occasionally send you account related emails.`
};

export const loc_signWithDefaultSignature: Record<Locale, string> = {
	ar: `وقع بتوقيعك الافتراضي`,
	de: `Unterschreiben Sie mit Ihrer Standardsignatur`,
	es: `Firma con tu firma predeterminada`,
	fa: `با امضای پیش فرض خود امضا کنید`,
	fil: `Mag-sign gamit ang iyong default na lagda`,
	fr: `Signez avec votre signature par défaut`,
	hi: `अपने डिफ़ॉल्ट हस्ताक्षर के साथ हस्ताक्षर करें`,
	ht: `Siyen ak siyati default ou`,
	it: `Firma con la tua firma predefinita`,
	ja: `デフォルトの署名で署名してください`,
	ko: `기본 서명으로 서명하세요`,
	mww: `Kos npe nrog koj lub neej ntawd kos npe`,
	ps: `د خپل اصلی لاسلیک سره لاسلیک وکړئ`,
	pt: `Assine com sua assinatura padrão`,
	'pt-pt': `Assine com a sua assinatura padrão`,
	ru: `Подпишитесь своей стандартной подписью`,
	sm: `Saini i lau saini faaletonu`,
	so: `Saxiix saxiixaaga caadiga ah`,
	th: `ลงนามด้วยลายเซ็นเริ่มต้นของคุณ`,
	ur: `اپنے ڈیفالٹ دستخط کے ساتھ دستخط کریں`,
	vi: `Ký bằng chữ ký mặc định của bạn`,
	'zh-hans': `用你的默认签名签名`,
	'zh-hant': `用你的預設簽名簽名`,
	en: `Sign with your default signature`
};

export const loc_singularAttachment: Record<Locale, string> = {
	ar: `1 ملحق`,
	de: `1 Anhang`,
	es: `1 Anexo`,
	fa: `۱ ضمیمه`,
	fil: `1 attachment`,
	fr: `1 pièce jointe`,
	hi: `1 संलग्नक`,
	ht: `1 atachman`,
	it: `1 Allegazione`,
	ja: `1 アタッチメント`,
	ko: `1 부착물`,
	mww: `1 txuas`,
	ps: `۱ ضمیمه`,
	pt: `1 Anexo`,
	'pt-pt': `1 anexo`,
	ru: `1 прикрепление`,
	sm: `1 fa'apipi'i`,
	so: `1 Lifaaq`,
	th: `1 สิ่งที่แนบมา`,
	ur: `1 منسلکہ`,
	vi: `1 tệp đính kèm`,
	'zh-hans': `1 附件`,
	'zh-hant': `1 附件`,
	en: `1 attachment`
};

export const loc_singularContributor: Record<Locale, string> = {
	ar: `مساهم واحد`,
	de: `1 Mitwirkender`,
	es: `1 colaborador`,
	fa: `۱ مشارکت کننده`,
	fil: `1 nag-ambag`,
	fr: `1 contributeur`,
	hi: `1 योगदानकर्ता`,
	ht: `1 kontribitè`,
	it: `1 collaboratore`,
	ja: `1名の寄稿者`,
	ko: `1명의 기여자`,
	mww: `1 tus neeg koom tes`,
	ps: `۱ همکار`,
	pt: `1 colaborador`,
	'pt-pt': `1 colaborador`,
	ru: `1 участник`,
	sm: `1 tagata fai saofaga`,
	so: `1 ka qaybqaate`,
	th: `ผู้ร่วมให้ข้อมูล 1 คน`,
	ur: `1 معاون`,
	vi: `1 người đóng góp`,
	'zh-hans': `1位贡献者`,
	'zh-hant': `1位貢獻者`,
	en: `1 contributor`
};

export const loc_singularEarlierVersion: Record<Locale, string> = {
	ar: `نسخة سابقة واحدة`,
	de: `1 Frühere Version`,
	es: `1 Versión anterior`,
	fa: `۱ نسخه قبلی`,
	fil: `1 naunang bersyon`,
	fr: `1 Version antérieure`,
	hi: `1 पुराना संस्करण`,
	ht: `1 vèsyon pi bonè`,
	it: `1 Versione precedente`,
	ja: `1 初期のバージョン`,
	ko: `1 이전 버전`,
	mww: `1 ua ntej version`,
	ps: `۱ پخوانۍ نسخه`,
	pt: `1 Versão anterior`,
	'pt-pt': `1 Versão anterior`,
	ru: `1 Ранняя версия`,
	sm: `1 lomiga muamua`,
	so: `1 nooc hore`,
	th: `1 เวอร์ชั่นก่อนหน้า`,
	ur: `1 پرانا ورژن`,
	vi: `1 Phiên bản cũ hơn`,
	'zh-hans': `1 早期版本`,
	'zh-hant': `1 早期版本`,
	en: `1 earlier version`
};

export const loc_singularOrganization: Record<Locale, string> = {
	ar: `1 التنظيم`,
	de: `1 Organisation`,
	es: `1 Organización`,
	fa: `۱ سازمان`,
	fil: `1 organisasyon`,
	fr: `1 Organisation`,
	hi: `1 संगठन`,
	ht: `1 òganizasyon`,
	it: `1 Organizzazione`,
	ja: `1 組織`,
	ko: `1 조직`,
	mww: `1 lub koom haum`,
	ps: `۱ سازمان`,
	pt: `1 Organização`,
	'pt-pt': `1 Organização`,
	ru: `1 Организация`,
	sm: `1 faalapotopotoga`,
	so: `1 Urur`,
	th: `1 องค์กร`,
	ur: `1 تنظیم`,
	vi: `1 Tổ chức`,
	'zh-hans': `1 组织`,
	'zh-hant': `1 組織`,
	en: `1 organization`
};

export const loc_singularParticipant: Record<Locale, string> = {
	ar: `مشارك واحد`,
	de: `1 Teilnehmer`,
	es: `1 participante`,
	fa: `۱ شرکت کننده`,
	fil: `1 kalahok`,
	fr: `1 participant`,
	hi: `1 प्रतिभागी`,
	ht: `1 patisipan`,
	it: `1 partecipante`,
	ja: `参加者1名`,
	ko: `참가자 1명`,
	mww: `1 tus neeg koom nrog`,
	ps: `۱ ګډونوال`,
	pt: `1 participante`,
	'pt-pt': `1 participante`,
	ru: `1 участник`,
	sm: `1 tagata auai`,
	so: `1 ka qaybgale`,
	th: `ผู้เข้าร่วม 1 คน`,
	ur: `1 شریک`,
	vi: `1 người tham gia`,
	'zh-hans': `1名参与者`,
	'zh-hant': `1名參與者`,
	en: `1 participant`
};

export const loc_site: Record<Locale, string> = {
	ar: `الموقع`,
	de: `Standort`,
	es: `Emplazamiento`,
	fa: `محوطه`,
	fil: `Email Address *`,
	fr: `Site`,
	hi: `साइट`,
	ht: `Sit`,
	it: `Sito`,
	ja: `遺跡`,
	ko: `부지`,
	mww: `Qhov chaw`,
	ps: `ځای`,
	pt: `Local`,
	'pt-pt': `Local`,
	ru: `Место`,
	sm: `Nofoaga`,
	so: `Goobta`,
	th: `เว็บไซต์`,
	ur: `مقام`,
	vi: `Địa điểm`,
	'zh-hans': `遗址`,
	'zh-hant': `地點`,
	en: `Site`
};

export const loc_sites: Record<Locale, string> = {
	ar: `المواقع`,
	de: `Stätten`,
	es: `Lugares`,
	fa: `مکان ها`,
	fil: `Mga Site`,
	fr: `Sites`,
	hi: `साइटें`,
	ht: `Sit yo`,
	it: `Siti`,
	ja: `遺跡`,
	ko: `유적지`,
	mww: `Cov chaw`,
	ps: `ځایونه`,
	pt: `Locais`,
	'pt-pt': `Locais`,
	ru: `Объекты`,
	sm: `Nofoaga`,
	so: `Goobaha`,
	th: `ไซต์`,
	ur: `مقامات`,
	vi: `Trang web`,
	'zh-hans': `遗址`,
	'zh-hant': `景點`,
	en: `Sites`
};

export const loc_siteWideLinks: Record<Locale, string> = {
	ar: `روابط على مستوى الموقع`,
	de: `Siteweite Links`,
	es: `Enlaces a nivel de sitio`,
	fa: `لینک های سراسری سایت`,
	fil: `Mga link sa buong site`,
	fr: `Liens à l’échelle du site`,
	hi: `साइट-व्यापी लिंक`,
	ht: `Sit lajè-lyen`,
	it: `Collegamenti a livello di sito`,
	ja: `サイト全体のリンク`,
	ko: `사이트 전체 링크`,
	mww: `Qhov chaw txuas thoob plaws`,
	ps: `د ټولې سایټ لینکونه`,
	pt: `Links em todo o site`,
	'pt-pt': `Ligações em todo o site`,
	ru: `Ссылки на весь сайт`,
	sm: `Feso'ota'iga lautele`,
	so: `Xiriirro guud oo goobta ah`,
	th: `ลิงก์ทั่วทั้งเว็บไซต์`,
	ur: `سائٹ بھر کے روابط`,
	vi: `Đường liên kết trên toàn trang web`,
	'zh-hans': `全站链接`,
	'zh-hant': `全站連結`,
	en: `Site-wide links`
};

export const loc_smallQRCode: Record<Locale, string> = {
	ar: `عرض رمز QR صغير`,
	de: `Kleiner QR-Code anzeigen`,
	es: `Ver pequeño código QR`,
	fa: `مشاهده کد QR کوچک`,
	fil: `Tingnan ang maliit na QR code`,
	fr: `Voir un petit code QR`,
	hi: `छोटा क्यूआर कोड देखें`,
	ht: `Gade ti kòd QR`,
	it: `Visualizza il piccolo codice QR`,
	ja: `小さなQRコードを表示`,
	ko: `작은 QR 코드 보기`,
	mww: `Saib me me QR code`,
	ps: `کوچنی QR کوډ وګورئ`,
	pt: `Veja o pequeno código QR`,
	'pt-pt': `Ver pequeno código QR`,
	ru: `Просмотр малого QR-кода`,
	sm: `Va'ai la'ititi QR code`,
	so: `Eeg QR code yar`,
	th: `ดูรหัส QR ขนาดเล็ก`,
	ur: `چھوٹا QR کوڈ دیکھیں`,
	vi: `Xem mã QR nhỏ`,
	'zh-hans': `查看小型二维码`,
	'zh-hant': `查看小型 QR 碼`,
	en: `View small QR code`
};

export const loc_smsComplete: Record<Locale, string> = {
	ar: `اكتمل تسجيل الهاتف (SMS)`,
	de: `Telefon- (SMS) Anmeldung abgeschlossen`,
	es: `Inscripción telefónica (SMS) completada`,
	fa: `ثبت نام تلفنی (پیامک) تکمیل شد`,
	fil: `Nakumpleto ang pagpapatala sa telepono (SMS)`,
	fr: `Inscription au téléphone (SMS) terminée`,
	hi: `फोन (एसएमएस) नामांकन पूरा हो गया है`,
	ht: `Enskripsyon nan telefòn (SMS) fini`,
	it: `Iscrizione telefonica (SMS) completata`,
	ja: `電話(SMS)登録完了`,
	ko: `전화(SMS) 등록 완료`,
	mww: `Kev sau npe hu xov tooj (SMS) tiav`,
	ps: `د ټیلیفون (SMS) نوم لیکنه بشپړه شوه`,
	pt: `Inscrição por telefone (SMS) concluída`,
	'pt-pt': `Inscrição por telefone (SMS) concluída`,
	ru: `Регистрация по телефону (SMS) завершена`,
	sm: `Ua maea le lesitala i le telefoni (SMS)`,
	so: `Diiwaangelinta telefoonka (SMS) waa la dhammeeyay`,
	th: `การลงทะเบียนทางโทรศัพท์ (SMS) เสร็จสมบูรณ์`,
	ur: `فون (ایس ایم ایس) کا اندراج مکمل ہو گیا`,
	vi: `Đăng ký qua điện thoại (SMS) đã hoàn tất`,
	'zh-hans': `电话（短信）注册完成`,
	'zh-hant': `電話（SMS）登記完成`,
	en: `Phone (SMS) enrollment completed`
};

export const loc_sockMarketingBody: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `اربط الشركاء والفرق، وشارك المعلومات، وإدارة العملاء، وأجري التقييمات، وأجري الإحالات، وتتبع الفعاليات، وأكثر من ذلك. استبدل جداول البيانات والورق والبريد الإلكتروني بسير عمل ${cumulus} ، والنماذج الآلية، والاستطلاعات، والمهام.`,
	de: (cumulus) => `Vernetzen Sie Partner und Teams, teilen Sie Informationen, verwalten Sie Kunden, führen Sie Bewertungen durch, geben Sie Empfehlungen, verfolgen Sie Ereignisse und mehr. Ersetzen Sie Tabellenkalkulationen, Papier und E-Mails durch ${cumulus} , automatisierte Formulare, Umfragen und Aufgaben.`,
	es: (cumulus) => `Conecta socios y equipos, comparte información, gestiona clientes, realiza evaluaciones, haz referencias, registra eventos y mucho más. Sustituye hojas de cálculo, papel y correos electrónicos por flujos de trabajo ${cumulus} , formularios automatizados, encuestas y tareas.`,
	fa: (cumulus) => `شرکا و تیم ها را به هم متصل کنید، اطلاعات را به اشتراک بگذارید، مشتریان را مدیریت کنید، ارزیابی انجام دهید، ارجاع دهید، رویدادها را پیگیری کنید و موارد دیگر. صفحات گسترده، کاغذ و ایمیل ها را با جریان های کاری ${cumulus} ، فرم های خودکار، نظرسنجی ها و وظایف جایگزین کنید.`,
	fil: (cumulus) => `Ikonekta ang mga kasosyo at koponan, magbahagi ng impormasyon, pamahalaan ang mga kliyente, magsagawa ng mga pagtatasa, gumawa ng mga referral, subaybayan ang mga kaganapan, at marami pa. Palitan ang mga spreadsheet, papel, at email ng mga daloy ng trabaho ${cumulus} , awtomatikong mga form, survey, at gawain.`,
	fr: (cumulus) => `Connectez partenaires et équipes, partagez des informations, gérez des clients, effectuez des évaluations, faites des recommandations, suivez les événements, et bien plus encore. Remplacez les tableaux Tableur, papier et e-mails par des flux de travail ${cumulus} , des formulaires automatisés, des enquêtes et des tâches.`,
	hi: (cumulus) => `भागीदारों और टीमों को कनेक्ट करें, जानकारी साझा करें, ग्राहकों का प्रबंधन करें, आकलन करें, रेफरल करें, घटनाओं को ट्रैक करें, और बहुत कुछ। स्प्रेडशीट, पेपर और ईमेल को ${cumulus} वर्कफ़्लोज़, स्वचालित फ़ॉर्म, सर्वेक्षण और कार्यों से बदलें।`,
	ht: (cumulus) => `Konekte patnè ak ekip, pataje enfòmasyon, jere kliyan, fè evalyasyon yo, fè referans, swiv evènman ak plis ankò. Ranplase calcul, papye, ak Imèl ak ${cumulus} workflows, fòm otomatik, sondaj, ak travay.`,
	it: (cumulus) => `Connetti partner e team, condividi informazioni, gestisci i clienti, conduci valutazioni, effettua referenze, monitora eventi e altro ancora. Sostituisci fogli di calcolo, carta ed email con flussi di lavoro ${cumulus} , moduli automatizzati, sondaggi e attività.`,
	ja: (cumulus) => `パートナーやチームのつながり、情報共有、クライアント管理、評価の実施、紹介、イベントの追跡など。スプレッドシートや紙、メールを ${cumulus} のワークフロー、自動フォーム、アンケート、タスクに置き換えましょう。`,
	ko: (cumulus) => `파트너와 팀을 연결하고, 정보를 공유하며, 고객을 관리하고, 평가를 실시하고, 추천을 하며, 이벤트 추적 등을 할 수 있습니다. 스프레드시트, 종이, 이메일을 ${cumulus} 워크플로우, 자동화 양식, 설문조사, 작업으로 대체하세요.`,
	mww: (cumulus) => `Txuas cov neeg koom tes thiab pab pawg, sib qhia cov ntaub ntawv, tswj cov neeg siv khoom, ua cov kev ntsuam xyuas, xa mus, taug qab cov xwm txheej, thiab lwm yam. Hloov cov ntawv qhia, ntawv, thiab email nrog ${cumulus} workflows, tsis siv neeg daim ntawv, kev tshawb fawb thiab cov haujlwm.`,
	ps: (cumulus) => `شریکان او ټیمونه سره وصل کړئ، معلومات شریک کړئ، مشتریان مدیریت کړئ، ارزونې ترسره کړئ، راجع کول وکړئ، پیښې تعقیب کړئ، او نور. سپریډشیټونه، کاغذونه، او ایمیلونه د ${cumulus} کاری کاری، اتومات فورمونو، سروې ګانو او دندو سره بدل کړئ.`,
	pt: (cumulus) => `Conecte parceiros e equipes, compartilhe informações, gerencie clientes, realize avaliações, faça indicações, acompanhe eventos e muito mais. Substitua planilhas, papel e e-mails por fluxos de trabalho ${cumulus} , formulários automatizados, pesquisas e tarefas.`,
	'pt-pt': (cumulus) => `Ligue parceiros e equipas, partilhe informações, gere clientes, realize avaliações, faça referências, acompanhe eventos e muito mais. Substitua folhas de cálculo, papel e emails por fluxos de trabalho ${cumulus} , formulários automatizados, inquéritos e tarefas.`,
	ru: (cumulus) => `Соединяйте партнеров и команды, делитесь информацией, управляйте клиентами, проводите оценки, делайте рекомендации, отслеживайте события и многое другое. Замените электронные таблицы, бумагу и электронную почту на рабочие ${cumulus} , автоматизированные формы, опросы и задачи.`,
	sm: (cumulus) => `Fa'afeso'ota'i pa'aga ma 'au, fefa'asoaa'i fa'amatalaga, fa'atautaia tagata fa'atau, fa'atautaia iloiloga, faia fa'asino mea, siaki mea na tutupu, ma sili atu. Suia spreadsheets, pepa, ma imeli i ${cumulus} workflows, otometi fomu, su'esu'ega, ma galuega.`,
	so: (cumulus) => `Isku xir la-hawlgalayaasha iyo kooxaha, wadaag macluumaadka, maareeya macaamiisha, samee qiimeyn, samee tixraacyo, la soco dhacdooyinka, iyo waxyaabo kale. Bedel xaashiyaha xisaabta, warqadda, iyo emails-ka adigoo adeegsanaya ${cumulus} , foomamka otomaatiga ah, sahanno, iyo hawlo.`,
	th: (cumulus) => `เชื่อมต่อคู่ค้าและทีม แบ่งปันข้อมูล จัดการลูกค้า ดําเนินการประเมิน แนะนํา ติดตามกิจกรรม และอื่นๆ แทนที่สเปรดชีต กระดาษ และอีเมลด้วยเวิร์กโฟลว์ ${cumulus} แบบฟอร์มอัตโนมัติ แบบสํารวจ และงาน`,
	ur: (cumulus) => `شراکت داروں اور ٹیموں کو جوڑیں، معلومات کا تبادلہ کریں، کلائنٹس کا انتظام کریں، جائزے کریں، ریفرلز کریں، ایونٹس کو ٹریک کریں، اور بہت کچھ۔ اسپریڈشیٹس، پیپر، اور ای میلز کو ${cumulus} ورک فلو، خودکار فارموں، سروے، اور کاموں سے تبدیل کریں۔`,
	vi: (cumulus) => `Kết nối đối tác và nhóm, chia sẻ thông tin, quản lý khách hàng, tiến hành đánh giá, giới thiệu, theo dõi sự kiện, v.v. Thay thế bảng tính, giấy và email bằng quy trình làm việc ${cumulus} , biểu mẫu, khảo sát và nhiệm vụ tự động.`,
	'zh-hans': (cumulus) => `连接合作伙伴和团队，分享信息，管理客户，进行评估，进行推荐，跟踪事件，等等。用 ${cumulus} 的工作流程、自动化表单、调查和任务取代电子表格、纸质和电子邮件。`,
	'zh-hant': (cumulus) => `連結合作夥伴與團隊、分享資訊、管理客戶、進行評估、轉介、追蹤事件等多項服務。用 ${cumulus} 工作流程、自動化表單、調查和任務取代試算表、紙本和電子郵件。`,
	en: (cumulus) => `Connect partners and teams, share information, manage clients, conduct assessments, make referrals, track events, and more. Replace spreadsheets, paper, and emails with ${cumulus} workflows, automated forms, surveys, and tasks.`
};

export const loc_sockMarketingHeading: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `ما الذي يمكنك استخدام ${cumulus} له أيضا؟`,
	de: (cumulus) => `Wofür könnte man ${cumulus} sonst noch verwenden?`,
	es: (cumulus) => `¿Para qué más podrías usar ${cumulus} ?`,
	fa: (cumulus) => `برای چه کارهای دیگری می توانید ${cumulus} استفاده کنید؟`,
	fil: (cumulus) => `Ano pa ang maaari mong gamitin ang ${cumulus} para sa?`,
	fr: (cumulus) => `À quoi pourriez-vous faire ${cumulus} ?`,
	hi: (cumulus) => `आप ${cumulus} उपयोग और किस लिए कर सकते हैं?`,
	ht: (cumulus) => `Ki lòt bagay ou ta ka itilize ${cumulus} pou?`,
	it: (cumulus) => `Cos'altro potresti usare ${cumulus} ?`,
	ja: (cumulus) => `${cumulus}は他に何に使えるでしょうか?`,
	ko: (cumulus) => `${cumulus}를 다른 용도로 사용할 수 있을까요?`,
	mww: (cumulus) => `Dab tsi ntxiv koj tuaj yeem siv ${cumulus} rau?`,
	ps: (cumulus) => `ته نور څه لپاره ${cumulus} کارولی شې؟`,
	pt: (cumulus) => `Para que mais você poderia usar ${cumulus} ?`,
	'pt-pt': (cumulus) => `Para que mais poderias usar ${cumulus} ?`,
	ru: (cumulus) => `Для чего ещё ${cumulus} ?`,
	sm: (cumulus) => `O le a se isi mea e mafai ona e fa'aaogaina ${cumulus} mo?`,
	so: (cumulus) => `Maxaa kale oo ${cumulus} loo isticmaali karaa?`,
	th: (cumulus) => `คุณสามารถใช้ ${cumulus} ทําอะไรได้อีก?`,
	ur: (cumulus) => `${cumulus} کو اور کس کام کے لیے استعمال کر سکتے ہیں؟`,
	vi: (cumulus) => `Bạn có thể sử dụng ${cumulus} để làm gì khác?`,
	'zh-hans': (cumulus) => `${cumulus}还能做什么？`,
	'zh-hant': (cumulus) => `${cumulus} 還能用來做什麼？`,
	en: (cumulus) => `What else could you use ${cumulus} for?`
};

export const loc_solutions: Record<Locale, string> = {
	ar: `الحلول`,
	de: `Lösungen`,
	es: `Soluciones`,
	fa: `راه حل ها`,
	fil: `Mga Solusyon`,
	fr: `Solutions`,
	hi: `समाधान`,
	ht: `Solisyon yo`,
	it: `Soluzioni`,
	ja: `解決策`,
	ko: `해결책`,
	mww: `Kev daws teeb meem`,
	ps: `حل لارې`,
	pt: `Soluções`,
	'pt-pt': `Soluções`,
	ru: `Решения`,
	sm: `Fofo`,
	so: `Xalalka`,
	th: `โซลูชั่น`,
	ur: `حل`,
	vi: `Giải pháp`,
	'zh-hans': `解决方案`,
	'zh-hant': `解決方案`,
	en: `Solutions`
};

export const loc_somethingWentWrong: Record<Locale, TemplateResult> = {
	ar: html`حدث خطأ ما. لقد سجلنا الخطأ. يرجى <a class="Link--primary text-bold" href="/support">التواصل مع الدعم</a> إذا استمرت المشكلة.`,
	de: html`Etwas ist schiefgelaufen. Wir haben den Fehler protokolliert. Bitte <a class="Link--primary text-bold" href="/support">kontaktieren Sie den Support,</a> falls das Problem weiterhin besteht.`,
	es: html`Algo salió mal. Hemos registrado el error. Por favor <a class="Link--primary text-bold" href="/support">, contacta con el soporte</a> si el problema persiste.`,
	fa: html`یه چیزی اشتباه پیش اومد. ما خطا را ثبت کرده ایم. لطفا اگر مشکل ادامه داشت <a class="Link--primary text-bold" href="/support">با پشتیبانی تماس بگیرید</a> .`,
	fil: html`May nangyaring mali. Na-log na namin ang error. Mangyaring <a class="Link--primary text-bold" href="/support">makipag-ugnay sa suporta</a> kung magpapatuloy ang isyu.`,
	fr: html`Quelque chose a mal tourné. Nous avons enregistré l’erreur. Merci <a class="Link--primary text-bold" href="/support">de contacter le support</a> si le problème persiste.`,
	hi: html`कुछ गलत हो गया। हमने त्रुटि लॉग कर दी है। यदि समस्या बनी रहती है तो <a class="Link--primary text-bold" href="/support">कृपया समर्थन से संपर्क करें</a> ।`,
	ht: html`Yon bagay ale mal. Nou te anrejistre erè a Tanpri <a class="Link--primary text-bold" href="/support">kontakte sipò</a> si pwoblèm nan pèsiste.`,
	it: html`Qualcosa è andato storto. Abbiamo registrato l'errore. Per <a class="Link--primary text-bold" href="/support">favore, contatta l'assistenza</a> se il problema persiste.`,
	ja: html`何かがうまくいかなかった。エラーは記録済みです。問題が続く場合は <a class="Link--primary text-bold" href="/support">サポートにご連絡</a> ください。`,
	ko: html`뭔가 잘못됐어. 오류를 기록했습니다. 문제가 계속되면 <a class="Link--primary text-bold" href="/support">고객 지원에 연락</a> 해 주세요.`,
	mww: html`Ib yam dab tsi mus tsis ncaj ncees lawm. Peb tau teev qhov yuam kev. Thov <a class="Link--primary text-bold" href="/support">hu rau kev txhawb nqa</a> yog tias qhov teeb meem tseem nyob.`,
	ps: html`یو څه غلط شول. موږ تېروتنه ثبت کړې ده. مهربانی وکړئ که ستونزه دوام ولری، <a class="Link--primary text-bold" href="/support">له ملاتړ سره اړیکه ونیسئ</a> .`,
	pt: html`Algo deu errado. Registramos o erro. Por favor <a class="Link--primary text-bold" href="/support">, entre em contato com o suporte</a> se o problema persistir.`,
	'pt-pt': html`Algo correu mal. Já registámos o erro. Por favor <a class="Link--primary text-bold" href="/support">, contacte o suporte</a> se o problema persistir.`,
	ru: html`Что-то пошло не так. Мы зафиксировали ошибку. Пожалуйста <a class="Link--primary text-bold" href="/support">, свяжитесь с поддержкой</a> , если проблема сохраняется.`,
	sm: html`Sa i ai se mea na sese. Ua matou fa'amauina le mea sese. <a class="Link--primary text-bold" href="/support">Fa'amolemole fa'afeso'ota'i le lagolago pe</a> a fa'aauau pea le fa'afitauli.`,
	so: html`Waxbaa qaldamay. Waxaan diiwaangelinay qaladka. Fadlan <a class="Link--primary text-bold" href="/support">la xiriir taageerada</a> haddii arrintu sii jirto.`,
	th: html`มีบางอย่างผิดพลาด เราได้บันทึกข้อผิดพลาดแล้ว โปรดติดต่อ <a class="Link--primary text-bold" href="/support">ฝ่ายสนับสนุน</a> หากปัญหายังคงอยู่`,
	ur: html`کچھ غلط ہو گیا۔ ہم نے ایرر کو لاگ کر لیا ہے۔ اگر مسئلہ برقرار رہے تو <a class="Link--primary text-bold" href="/support">براہ کرم سپورٹ سے رابطہ کریں۔</a>`,
	vi: html`Đã xảy ra sự cố. Chúng tôi đã ghi lại lỗi. Vui lòng <a class="Link--primary text-bold" href="/support">liên hệ với bộ phận hỗ trợ</a> nếu sự cố vẫn tiếp diễn.`,
	'zh-hans': html`出了点问题。我们已经记录了错误。如果问题依旧，请联系 <a class="Link--primary text-bold" href="/support">客服</a> 。`,
	'zh-hant': html`出了問題。我們已經記錄錯誤。如果問題持續，請 <a class="Link--primary text-bold" href="/support">聯絡客服</a> 。`,
	en: html`Something went wrong. We've logged the error. Please <a class="Link--primary text-bold" href="/support">contact support</a> if the issue persists.`
};

export const loc_sort: Record<Locale, string> = {
	ar: `الترتيب`,
	de: `Sortieren`,
	es: `Ordenar`,
	fa: `مرتب کن`,
	fil: `Ayusin`,
	fr: `Trier`,
	hi: `क्रमबद्ध करें`,
	ht: `Sòt`,
	it: `Ordina`,
	ja: `ソート`,
	ko: `정렬`,
	mww: `Txheeb`,
	ps: `Sort`,
	pt: `Sortem`,
	'pt-pt': `Ordenar`,
	ru: `Сортировка`,
	sm: `Fa'avasega`,
	so: `Kala sooc`,
	th: `เรียงลําดับ`,
	ur: `ترتیب`,
	vi: `Sắp xếp`,
	'zh-hans': `排序`,
	'zh-hant': `排序`,
	en: `Sort`
};

export const loc_ssn: Record<Locale, string> = {
	ar: `رقم الضمان الاجتماعي`,
	de: `SSN`,
	es: `SSN`,
	fa: `شماره تأمین اجتماعی`,
	fil: `SSN`,
	fr: `Numéro de sécurité sociale`,
	hi: `एसएसएन`,
	ht: `SSN`,
	it: `SSN`,
	ja: `社会保障番号(SSN)`,
	ko: `SSN`,
	mww: `SSN`,
	ps: `SSN`,
	pt: `SSN`,
	'pt-pt': `SSN`,
	ru: `SSN`,
	sm: `SSN`,
	so: `SSN`,
	th: `เอสเอสเอ็น`,
	ur: `SSN`,
	vi: `SSN`,
	'zh-hans': `社会安全号码`,
	'zh-hant': `社會安全號碼`,
	en: `SSN`
};

export const loc_staff: Record<Locale, string> = {
	ar: `الطاقم`,
	de: `Personal`,
	es: `Personal`,
	fa: `کارکنان`,
	fil: `Mga Tauhan`,
	fr: `Personnel`,
	hi: `स्टाफ़`,
	ht: `Anplwaye yo`,
	it: `Personale`,
	ja: `スタッフ`,
	ko: `교직원`,
	mww: `Cov neeg ua hauj lwm`,
	ps: `کارکوونکی`,
	pt: `Equipe`,
	'pt-pt': `Equipa`,
	ru: `Персонал`,
	sm: `Aufaigaluega`,
	so: `Shaqaalaha`,
	th: `บุคลากร`,
	ur: `عملہ`,
	vi: `Nhân sự`,
	'zh-hans': `工作人员`,
	'zh-hant': `教職員`,
	en: `Staff`
};

export const loc_start: Record<Locale, string> = {
	ar: `ابدأ`,
	de: `Start`,
	es: `Comienzo`,
	fa: `شروع`,
	fil: `Simulan`,
	fr: `Début`,
	hi: `चौंक`,
	ht: `Kòmanse`,
	it: `Inizio`,
	ja: `開始`,
	ko: `시작`,
	mww: `pib`,
	ps: `پیل کړه`,
	pt: `Comece`,
	'pt-pt': `Início`,
	ru: `Начало`,
	sm: `Amata`,
	so: `Bilow`,
	th: `เริ่มต้น`,
	ur: `شروع کریں`,
	vi: `Bắt đầu`,
	'zh-hans': `开始`,
	'zh-hant': `開始`,
	en: `Start`
};

export const loc_startAndEndDates: Record<Locale, string> = {
	ar: `تواريخ البداية والنهاية`,
	de: `Start- und Endtermine`,
	es: `Fechas de inicio y fin`,
	fa: `تاریخ های شروع و پایان`,
	fil: `Mga Petsa ng Pagsisimula at Pagtatapos`,
	fr: `Dates de début et de fin`,
	hi: `प्रारंभ और समाप्ति तिथियां`,
	ht: `Kòmanse & Fen dat`,
	it: `Date di inizio e fine`,
	ja: `開始日と終了日`,
	ko: `시작일과 종료일도`,
	mww: `Pib & hnub xaus`,
	ps: `د پیل او پای نیټې`,
	pt: `Datas de início e fim`,
	'pt-pt': `Datas de início e fim`,
	ru: `Даты начала и окончания`,
	sm: `Aso amata ma fa'ai'u`,
	so: `Taariikhaha bilowga iyo dhammaadka`,
	th: `วันที่เริ่มต้นและสิ้นสุด`,
	ur: `آغاز اور اختتام کی تاریخیں`,
	vi: `Ngày bắt đầu và ngày kết thúc`,
	'zh-hans': `开始与结束日期`,
	'zh-hant': `開始與結束日期`,
	en: `Start & end dates`
};

export const loc_startDate: Record<Locale, string> = {
	ar: `تاريخ البدء`,
	de: `Startdatum`,
	es: `Fecha de inicio`,
	fa: `تاریخ شروع`,
	fil: `Petsa ng pagsisimula`,
	fr: `Date de début`,
	hi: `प्रारंभ दिनांक`,
	ht: `Kòmanse dat`,
	it: `Data di inizio`,
	ja: `開始日`,
	ko: `시작일`,
	mww: `Hnub pib`,
	ps: `د پیل نېټه`,
	pt: `Data de início`,
	'pt-pt': `Data de início`,
	ru: `Дата начала работы`,
	sm: `Aso amata`,
	so: `Taariikhda bilowga`,
	th: `วันที่เริ่มต้น`,
	ur: `آغاز کی تاریخ`,
	vi: `Ngày bắt đầu`,
	'zh-hans': `开始日期`,
	'zh-hant': `開始日期`,
	en: `Start date`
};

export const loc_startEndDates: Record<Locale, string> = {
	ar: `تواريخ البدء/النهاية`,
	de: `Start-/Endtermine`,
	es: `Fechas de inicio/final`,
	fa: `تاریخ های شروع/پایان`,
	fil: `Mga petsa ng pagsisimula / pagtatapos`,
	fr: `Dates de début/fin`,
	hi: `प्रारंभ/समाप्ति तिथियां`,
	ht: `Kòmanse / fen dat`,
	it: `Date di inizio/fine`,
	ja: `開始・終了日`,
	ko: `시작/종료 날짜`,
	mww: `Hnub pib/xaus`,
	ps: `د پیل/پای نیټې`,
	pt: `Datas de início/término`,
	'pt-pt': `Datas de início/fim`,
	ru: `Даты начала и окончания`,
	sm: `Aso amata / fa'ai'u`,
	so: `Taariikhaha bilowga/dhammaadka`,
	th: `วันที่เริ่มต้น/สิ้นสุด`,
	ur: `شروع/اختتام کی تاریخیں`,
	vi: `Ngày bắt đầu/kết thúc`,
	'zh-hans': `开始/结束日期`,
	'zh-hant': `開始/結束日期`,
	en: `Start/end dates`
};

export const loc_startTime: Record<Locale, string> = {
	ar: `وقت البدء`,
	de: `Startzeit`,
	es: `Hora de inicio`,
	fa: `زمان شروع`,
	fil: `Email Address *`,
	fr: `Heure de début`,
	hi: `प्रारंभ समय`,
	ht: `Kòmanse tan`,
	it: `Orario di inizio`,
	ja: `開始時間`,
	ko: `시작 시간`,
	mww: `Lub sijhawm pib`,
	ps: `د پیل وخت`,
	pt: `Horário de início`,
	'pt-pt': `Hora de início`,
	ru: `Время начала`,
	sm: `Taimi amata`,
	so: `Waqtiga bilowga`,
	th: `เวลาเริ่มต้น`,
	ur: `شروع ہونے کا وقت`,
	vi: `Thời gian bắt đầu`,
	'zh-hans': `开赛时间`,
	'zh-hant': `開賽時間`,
	en: `Start time`
};

export const loc_state: Record<Locale, string> = {
	ar: `الدولة`,
	de: `Bundesstaat`,
	es: `Estado`,
	fa: `ایالت`,
	fil: `Estado`,
	fr: `État`,
	hi: `राज्य`,
	ht: `Eta`,
	it: `Stato`,
	ja: `州`,
	ko: `국가`,
	mww: `Lub xeev`,
	ps: `ایالت`,
	pt: `Estado`,
	'pt-pt': `Estado`,
	ru: `Штат`,
	sm: `Setete`,
	so: `Gobolka`,
	th: `สถานะ`,
	ur: `ریاست`,
	vi: `Tiểu bang`,
	'zh-hans': `州际`,
	'zh-hant': `州`,
	en: `State`
};

export const loc_stateAgency: Record<Locale, string> = {
	ar: `وكالة الدولة`,
	de: `Staatliche Behörde`,
	es: `Agencia Estatal`,
	fa: `سازمان دولتی`,
	fil: `Ahensya ng Estado`,
	fr: `Agence d’État`,
	hi: `राज्य एजेंसी`,
	ht: `Ajans Leta`,
	it: `Agenzia statale`,
	ja: `国家機関`,
	ko: `국가 기관`,
	mww: `Lub Xeev Lub Koom Haum`,
	ps: `دولتی اداره`,
	pt: `Agência Estatal`,
	'pt-pt': `Agência Estatal`,
	ru: `Государственное агентство`,
	sm: `Ofisa o le Setete`,
	so: `Hay'adda Gobolka`,
	th: `หน่วยงานของรัฐ`,
	ur: `ریاستی ایجنسی`,
	vi: `Cơ quan nhà nước`,
	'zh-hans': `国家机构`,
	'zh-hant': `國家機構`,
	en: `State Agency`
};

export const loc_statement: Record<Locale, string> = {
	ar: `البيان`,
	de: `Aussage`,
	es: `Enunciado`,
	fa: `بیانیه`,
	fil: `Pahayag`,
	fr: `Énoncé`,
	hi: `वक्तव्‍य`,
	ht: `Deklarasyon`,
	it: `Enunciato`,
	ja: `命題`,
	ko: `진술`,
	mww: `Lus Qhia`,
	ps: `بیان`,
	pt: `Enunciado`,
	'pt-pt': `Enunciado`,
	ru: `Утверждение`,
	sm: `Fa'amatalaga`,
	so: `Bayaanka`,
	th: `คําแถลง`,
	ur: `بیان`,
	vi: `Phát biểu`,
	'zh-hans': `命题`,
	'zh-hant': `陳述`,
	en: `Statement`
};

export const loc_statements: Record<Locale, string> = {
	ar: `التصريحات`,
	de: `Aussagen`,
	es: `Declaraciones`,
	fa: `بیانیه ها`,
	fil: `Mga Pahayag`,
	fr: `Déclarations`,
	hi: `कथन`,
	ht: `Deklarasyon yo`,
	it: `Dichiarazioni`,
	ja: `声明`,
	ko: `진술`,
	mww: `Lus Qhia`,
	ps: `بیانونه`,
	pt: `Declarações`,
	'pt-pt': `Declarações`,
	ru: `Утверждения`,
	sm: `Fa'amatalaga`,
	so: `Bayaanno`,
	th: `คําแถลง`,
	ur: `بیانات`,
	vi: `Phát biểu`,
	'zh-hans': `陈述`,
	'zh-hant': `陳述`,
	en: `Statements`
};

export const loc_stateRequiredValidationMessage: Record<Locale, (label: unknown) => string> = {
	ar: (label) => `${label} مطلوبة. أدخل عنوان شارع وسيملأ الباقي تلقائيا.`,
	de: (label) => `${label} ist vorgeschrieben. Geben Sie eine Straßenadresse ein, der Rest wird automatisch ausgefüllt.`,
	es: (label) => `Se requiere ${label}. Introduce una dirección y el resto se completará automáticamente.`,
	fa: (label) => `${label} الزامی است. یک آدرس خیابان وارد کنید و بقیه به طور خودکار پر می شوند.`,
	fil: (label) => `Kinakailangan ang ${label}. Magpasok ng isang address ng kalye at ang natitira ay awtomatikong punan.`,
	fr: (label) => `${label} est obligatoire. Entrez une adresse et le reste se remplira automatiquement.`,
	hi: (label) => `${label} की आवश्यकता है। एक सड़क का पता दर्ज करें और बाकी अपने आप भर जाएगा।`,
	ht: (label) => `${label} obligatwa. Antre yon adrès lari ak rès la pral ranpli otomatikman.`,
	it: (label) => `${label} . Inserisci un indirizzo e il resto si completerà automaticamente.`,
	ja: (label) => `${label} 必須です。住所を入力すれば、他の部分は自動的に埋められます。`,
	ko: (label) => `${label} )가 필수입니다. 거리 주소를 입력하면 나머지는 자동으로 채워집니다.`,
	mww: (label) => `${label} yuav tsum tau ua. Sau ib txoj kev chaw nyob thiab tus so yuav sau cia li.`,
	ps: (label) => `${label} اړین دی. د کوڅې پته داخل کړئ او پاتې به په اوتومات ډول ډک شی.`,
	pt: (label) => `${label} é exigido. Digite um endereço e o restante será preenchido automaticamente.`,
	'pt-pt': (label) => `${label} é obrigatório. Introduza uma morada e o resto será preenchido automaticamente.`,
	ru: (label) => `${label} Введите уличный адрес, и остальные автоматически заполняются.`,
	sm: (label) => `E mana'omia le ${label}. Ulufale i se tuatusi auala ma o le a otometi lava ona fa'atumu le vaega o totoe.`,
	so: (label) => `${label} ayaa loo baahan yahay. Geli cinwaanka waddada, inta kalena si toos ah ayay u buuxin doonaan.`,
	th: (label) => `${label} ป้อนที่อยู่และส่วนที่เหลือจะกรอกโดยอัตโนมัติ`,
	ur: (label) => `${label} لازمی ہے۔ اسٹریٹ ایڈریس درج کریں اور باقی خود بخود بھر جائیں گے۔`,
	vi: (label) => `${label} là bắt buộc. Nhập địa chỉ đường phố và phần còn lại sẽ tự động điền.`,
	'zh-hans': (label) => `州${label}说明。输入街道地址，其他地址会自动填写。`,
	'zh-hant': (label) => `州${label}。輸入街道地址，其他地址會自動填寫。`,
	en: (label) => `${label} is required. Enter a street address and the rest will fill in automatically.`
};

export const loc_status: Record<Locale, string> = {
	ar: `الحالة`,
	de: `Status`,
	es: `Estado`,
	fa: `وضعیت`,
	fil: `Katayuan`,
	fr: `Statut`,
	hi: `स्थिति`,
	ht: `Estati`,
	it: `Stato`,
	ja: `現状`,
	ko: `현황`,
	mww: `Cov xwm txheej`,
	ps: `وضعیت`,
	pt: `Status`,
	'pt-pt': `Estado`,
	ru: `Статус`,
	sm: `Tulaga`,
	so: `Xaaladda`,
	th: `สถานะ`,
	ur: `حیثیت`,
	vi: `Trạng thái`,
	'zh-hans': `现状`,
	'zh-hant': `現況`,
	en: `Status`
};

export const loc_statusAsOfDate: Record<Locale, (status: unknown, statusDate: unknown) => TemplateResult> = {
	ar: (status, statusDate) => html`<span>${status} اعتبارا من ${statusDate}</span>`,
	de: (status, statusDate) => html`<span>${status} am ${statusDate}</span>`,
	es: (status, statusDate) => html`<span>${status} a ${statusDate}</span>`,
	fa: (status, statusDate) => html`<span>${status} شده تا ${statusDate}</span>`,
	fil: (status, statusDate) => html`<span>${status} noong ${statusDate}</span>`,
	fr: (status, statusDate) => html`<span>${status} au ${statusDate}</span>`,
	hi: (status, statusDate) => html`<span>${statusDate} तक ${status}</span>`,
	ht: (status, statusDate) => html`<span>${status} ${statusDate}</span>`,
	it: (status, statusDate) => html`<span>${status} al ${statusDate}</span>`,
	ja: (status, statusDate) => html`<span>${statusDate}日をもって${status}</span>`,
	ko: (status, statusDate) => html`<span>${statusDate}일 ${status}</span>`,
	mww: (status, statusDate) => html`<span>${status} raws li ${statusDate}</span>`,
	ps: (status, statusDate) => html`<span>د ${statusDate} پورې ${status}</span>`,
	pt: (status, statusDate) => html`<span>${status} em ${statusDate}</span>`,
	'pt-pt': (status, statusDate) => html`<span>${status} a ${statusDate}</span>`,
	ru: (status, statusDate) => html`<span>${status} по состоянию на ${statusDate}</span>`,
	sm: (status, statusDate) => html`<span>${status} i le ${statusDate}</span>`,
	so: (status, statusDate) => html`<span>${status} ilaa ${statusDate}</span>`,
	th: (status, statusDate) => html`<span>${status} ณ วันที่ ${statusDate}</span>`,
	ur: (status, statusDate) => html`<span>${statusDate} تک ${status}</span>`,
	vi: (status, statusDate) => html`<span>${status} kể từ ngày ${statusDate}</span>`,
	'zh-hans': (status, statusDate) => html`<span>截至${statusDate}${status}</span>`,
	'zh-hant': (status, statusDate) => html`<span>於${statusDate}日${status}</span>`,
	en: (status, statusDate) => html`<span>${status} as of ${statusDate}</span>`
};

export const loc_streetAddress: Record<Locale, string> = {
	ar: `عنوان الشارع`,
	de: `Straßenadresse`,
	es: `Dirección`,
	fa: `آدرس خیابان`,
	fil: `Email Address`,
	fr: `Adresse de rue`,
	hi: `सड़क का पता`,
	ht: `Adrès lari`,
	it: `Indirizzo`,
	ja: `住所`,
	ko: `거리 주소`,
	mww: `Chaw nyob ntawm txoj kev`,
	ps: `د کوڅې پته`,
	pt: `Endereço da rua`,
	'pt-pt': `Endereço`,
	ru: `Адрес улицы`,
	sm: `Tuatusi o le auala`,
	so: `Cinwaanka waddada`,
	th: `ที่ตั้ง`,
	ur: `گلی کا پتہ`,
	vi: `Địa chỉ đường phố`,
	'zh-hans': `街道地址`,
	'zh-hant': `街道地址`,
	en: `Street address`
};

export const loc_streetAddressPrompt: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `ابدأ بكتابة عنوان شارع وسيملأ ${cumulus} الباقي`,
	de: (cumulus) => `Fang an, eine Straßenadresse einzugeben, und ${cumulus} füllt den Rest aus`,
	es: (cumulus) => `Empieza a escribir una dirección y ${cumulus} completará el resto`,
	fa: (cumulus) => `شروع به تایپ یک آدرس خیابان کنید و ${cumulus} بقیه را پر می کند`,
	fil: (cumulus) => `Simulan ang pag-type ng address ng kalye at ${cumulus} ang natitira`,
	fr: (cumulus) => `Commencez à taper une adresse et ${cumulus} complétera le reste`,
	hi: (cumulus) => `एक सड़क का पता टाइप करना शुरू करें और ${cumulus} बाकी को भर देगा`,
	ht: (cumulus) => `Kòmanse tape yon adrès lari ak ${cumulus} pral ranpli rès la`,
	it: (cumulus) => `Inizia a digitare un indirizzo e ${cumulus} completerà il resto`,
	ja: (cumulus) => `住所を入力し始めれば ${cumulus} が残りを埋めてくれます`,
	ko: (cumulus) => `거리 주소를 타이핑하기 시작하면 ${cumulus} 가 나머지를 채워줄 거예요`,
	mww: (cumulus) => `Pib ntaus ib txoj kev chaw nyob thiab ${cumulus} yuav sau rau hauv tus so`,
	ps: (cumulus) => `د کوڅې پته ټایپ کړه او ${cumulus} به پاتې معلومات ډک کړی`,
	pt: (cumulus) => `Comece a digitar um endereço e ${cumulus} preenche o restante`,
	'pt-pt': (cumulus) => `Comece a escrever uma morada e ${cumulus} preenche o resto`,
	ru: (cumulus) => `Начните вводить уличный адрес, ${cumulus} заполнит остальное`,
	sm: (cumulus) => `Amata ona taina se tuatusi o le auala ma o le a faatumuina e ${cumulus} le vaega o totoe`,
	so: (cumulus) => `Bilow inaad qorto cinwaanka waddada, ${cumulus} ayaa buuxin doonta inta kale`,
	th: (cumulus) => `เริ่มพิมพ์ที่อยู่และ ${cumulus} จะกรอกข้อมูลที่เหลือ`,
	ur: (cumulus) => `اسٹریٹ ایڈریس ٹائپ کرنا شروع کریں اور ${cumulus} باقی بھر دے گا`,
	vi: (cumulus) => `Bắt đầu nhập địa chỉ đường phố và ${cumulus} sẽ điền vào phần còn lại`,
	'zh-hans': (cumulus) => `开始输入街道地址， ${cumulus} 会帮你填补剩下的`,
	'zh-hant': (cumulus) => `開始輸入街道地址， ${cumulus} 會幫你填補剩下的`,
	en: (cumulus) => `Start typing a street address and ${cumulus} will fill in the rest`
};

export const loc_style: Record<Locale, string> = {
	ar: `الأسلوب`,
	de: `Stil`,
	es: `Estilo`,
	fa: `سبک`,
	fil: `Estilo`,
	fr: `Style`,
	hi: `वर्तिका`,
	ht: `Style`,
	it: `Stile`,
	ja: `スタイル`,
	ko: `스타일`,
	mww: `Qauv`,
	ps: `سبک`,
	pt: `Estilo`,
	'pt-pt': `Estilo`,
	ru: `Стиль`,
	sm: `Sitaili`,
	so: `Qaabka`,
	th: `สไตล์`,
	ur: `انداز`,
	vi: `Phong cách`,
	'zh-hans': `风格`,
	'zh-hant': `風格`,
	en: `Style`
};

export const loc_stylingWithMarkdown: Record<Locale, string> = {
	ar: `التصميم باستخدام ماركداون مدعوم`,
	de: `Styling mit Markdown wird unterstützt`,
	es: `Se soporta el estilismo con Markdown`,
	fa: `طراحی با مارک داون پشتیبانی می شود`,
	fil: `Sinusuportahan ang pag-istilo gamit ang Markdown`,
	fr: `Le styling avec Markdown est supporté`,
	hi: `मार्कडाउन के साथ स्टाइलिंग समर्थित है`,
	ht: `Manier ak Markdown sipòte`,
	it: `Lo stile con Markdown è supportato`,
	ja: `Markdownによるスタイリングもサポートしています`,
	ko: `Markdown 스타일링도 지원합니다`,
	mww: `Styling nrog Markdown tau txais kev txhawb nqa`,
	ps: `د Markdown سره ډیزاین ملاتړ کیږی`,
	pt: `O estilo com Markdown é suportado`,
	'pt-pt': `O estilo com Markdown é suportado`,
	ru: `Поддерживается стилизация с Markdown`,
	sm: `E lagolagoina le fa'ata'ita'iga ma le Markdown`,
	so: `Naqshadeynta Markdown waa la taageeraa`,
	th: `รองรับการจัดแต่งทรงผมด้วย Markdown`,
	ur: `مارک ڈاؤن کے ساتھ اسٹائلنگ کی حمایت کی جاتی ہے`,
	vi: `Hỗ trợ tạo kiểu bằng Markdown`,
	'zh-hans': `支持Markdown样式`,
	'zh-hant': `支援使用 Markdown 的樣式設計`,
	en: `Styling with Markdown is supported`
};

export const loc_subAddress: Record<Locale, string> = {
	ar: `شقة / جناح / وحدة`,
	de: `Wohnung / Suite / Einheit`,
	es: `Apartamento / suite / unidad`,
	fa: `آپارتمان / سوئیت / واحد`,
	fil: `Apartment / suite / unit`,
	fr: `Appartement / suite / unité`,
	hi: `अपार्टमेंट/सुइट/यूनिट`,
	ht: `Apatman / suite / inite`,
	it: `Appartamento / suite / unità`,
	ja: `アパートメント/スイート/ユニット`,
	ko: `아파트 / 스위트룸 / 유닛`,
	mww: `Chav tsev / suite / chav tsev`,
	ps: `اپارتمان / سویټ / واحد`,
	pt: `Apartamento / suíte / unidade`,
	'pt-pt': `Apartamento / suite / unidade`,
	ru: `Квартира / люкс / квартира`,
	sm: `Fale mautotogi / suite / iunite`,
	so: `Guri / qol / unug`,
	th: `อพาร์ทเมนท์ / ห้องสวีท / ยูนิต`,
	ur: `اپارٹمنٹ / سوئٹ / یونٹ`,
	vi: `Căn hộ / suite / căn hộ`,
	'zh-hans': `公寓 / 套房 / 单元`,
	'zh-hant': `公寓/套房/單位`,
	en: `Apartment / suite / unit`
};

export const loc_submit: Record<Locale, string> = {
	ar: `التقديم`,
	de: `Einreichen`,
	es: `Enviar`,
	fa: `ارسال کنید`,
	fil: `Email Address *`,
	fr: `Soumettre`,
	hi: `जमा करें`,
	ht: `Soumèt`,
	it: `Invia`,
	ja: `提出`,
	ko: `제출하세요`,
	mww: `zwm`,
	ps: `وړاندې کړه`,
	pt: `Enviar`,
	'pt-pt': `Submeter`,
	ru: `Отправить`,
	sm: `Alu e ave i totonu`,
	so: `Gudbi`,
	th: `ส่ง`,
	ur: `جمع کروائیں`,
	vi: `Gửi`,
	'zh-hans': `提交`,
	'zh-hant': `提交`,
	en: `Submit`
};

export const loc_submitted: Record<Locale, string> = {
	ar: `تم التقديم`,
	de: `Eingereicht`,
	es: `Enviado`,
	fa: `ارسال شده`,
	fil: `Isinumite`,
	fr: `Soumis`,
	hi: `सबमिट किया गया`,
	ht: `Soumèt`,
	it: `Inviato`,
	ja: `提出`,
	ko: `제출됨`,
	mww: `Xa`,
	ps: `سپارل شوی`,
	pt: `Submetido`,
	'pt-pt': `Submetido`,
	ru: `Отправлено`,
	sm: `Auina atu`,
	so: `La gudbiyey`,
	th: `ส่งแล้ว`,
	ur: `جمع کرایا گیا`,
	vi: `Đã gửi`,
	'zh-hans': `提交`,
	'zh-hant': `提交`,
	en: `Submitted`
};

export const loc_submitTimesheet: Record<Locale, string> = {
	ar: `إرسال جدول المواعيد`,
	de: `Stundenzettel einreichen`,
	es: `Enviar la hoja de horas`,
	fa: `ارسال برگه زمان بندی`,
	fil: `Email Address *`,
	fr: `Soumettre la feuille de temps`,
	hi: `टाइमशीट जमा करें`,
	ht: `Soumèt Timesheet`,
	it: `Invia il foglio orario`,
	ja: `タイムシートを提出してください`,
	ko: `근무 시간표 제출`,
	mww: `Xa daim ntawv qhia sijhawm`,
	ps: `د وخت پاڼه وسپارئ`,
	pt: `Envie a folha de ponto`,
	'pt-pt': `Submeter folha de horas`,
	ru: `Отправить табель времени`,
	sm: `Auina atu le pepa o taimi`,
	so: `Soo gudbi jadwalka waqtiga`,
	th: `ส่งไทม์ชีท`,
	ur: `ٹائم شیٹ جمع کروائیں`,
	vi: `Gửi bảng chấm công`,
	'zh-hans': `提交工时表`,
	'zh-hant': `提交工時表`,
	en: `Submit timesheet`
};

export const loc_submitTimesheetForApproval: Record<Locale, string> = {
	ar: `قدم جدول الدوام للموافقة عليه`,
	de: `Stundenzettel zur Genehmigung einreichen`,
	es: `Envía la hoja de horas para su aprobación`,
	fa: `برگه زمان بندی را برای تأیید ارسال کنید`,
	fil: `Magsumite ng timesheet para sa pag-apruba`,
	fr: `Soumettez la feuille de temps pour approbation`,
	hi: `अनुमोदन के लिए टाइमशीट जमा करें`,
	ht: `Soumèt Timesheet pou apwobasyon`,
	it: `Invia il foglio presenze per l'approvazione`,
	ja: `タイムシートを承認のために提出してください`,
	ko: `승인을 위해 근무 시간표를 제출하세요`,
	mww: `Xa daim ntawv teev sijhawm rau kev pom zoo`,
	ps: `د تایید لپاره وخت پاڼه وسپارئ`,
	pt: `Envie a folha de ponto para aprovação`,
	'pt-pt': `Submeta a folha de horas para aprovação`,
	ru: `Отправьте табель для утверждения`,
	sm: `Auina atu le pepa o taimi mo le faamaoniga`,
	so: `Soo gudbi jadwalka waqtiga si loo ansixiyo`,
	th: `ส่งไทม์ชีทเพื่อขออนุมัติ`,
	ur: `منظوری کے لیے ٹائم شیٹ جمع کروائیں`,
	vi: `Gửi bảng chấm công để phê duyệt`,
	'zh-hans': `提交工时表以供审批`,
	'zh-hant': `提交工時表以供核准`,
	en: `Submit timesheet for approval`
};

export const loc_subscribe: Record<Locale, string> = {
	ar: `اشترك`,
	de: `Abonnieren`,
	es: `Suscríbete`,
	fa: `اشتراک کنید`,
	fil: `Email Address *`,
	fr: `Abonnez-vous`,
	hi: `सदस्यता लें`,
	ht: `Abònman`,
	it: `Abbonati`,
	ja: `購読`,
	ko: `구독하세요`,
	mww: `Sau npe yuav`,
	ps: `ګډون وکړئ`,
	pt: `Assine`,
	'pt-pt': `Subscreva`,
	ru: `Подписаться`,
	sm: `Lesitala`,
	so: `Isdiiwaangeli`,
	th: `สมัครสมาชิก`,
	ur: `سبسکرائب کریں`,
	vi: `Đăng ký`,
	'zh-hans': `订阅`,
	'zh-hant': `訂閱`,
	en: `Subscribe`
};

export const loc_subscribed: Record<Locale, string> = {
	ar: `مشترك`,
	de: `Abonniert`,
	es: `Suscrito`,
	fa: `مشترک شده`,
	fil: `Email Address *`,
	fr: `Abonné`,
	hi: `सदस्यता ली`,
	ht: `Abònman`,
	it: `Abbonato`,
	ja: `購読者`,
	ko: `구독 완료`,
	mww: `Sau npe`,
	ps: `ګډون شوی`,
	pt: `Assinado`,
	'pt-pt': `Subscrevido`,
	ru: `Подписан`,
	sm: `Lesitala`,
	so: `Isdiiwaangeliyey`,
	th: `สมัครสมาชิก`,
	ur: `سبسکرائب کیا گیا`,
	vi: `Đã đăng ký`,
	'zh-hans': `订阅`,
	'zh-hant': `訂閱中`,
	en: `Subscribed`
};

export const loc_subscribers: Record<Locale, string> = {
	ar: `المشتركون`,
	de: `Abonnenten`,
	es: `Suscriptores`,
	fa: `مشترکین`,
	fil: `Mga Tagasuskribi`,
	fr: `Abonnés`,
	hi: `अंशदान`,
	ht: `Abonnés yo`,
	it: `Abbonati`,
	ja: `加入者`,
	ko: `구독자`,
	mww: `Cov neeg rau npe`,
	ps: `ګډونوال`,
	pt: `Assinantes`,
	'pt-pt': `Assinantes`,
	ru: `Подписчики`,
	sm: `Tagata fai saofaga`,
	so: `Macaamiisha`,
	th: `สมาชิก`,
	ur: `سبسکرائبرز`,
	vi: `Người đăng ký`,
	'zh-hans': `订阅者`,
	'zh-hant': `訂閱者`,
	en: `Subscribers`
};

export const loc_subscribersCountFormat: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} مشتركا`,
	de: (count) => `${count} Abonnenten`,
	es: (count) => `${count} suscriptores`,
	fa: (count) => `${count} مشترک`,
	fil: (count) => `${count} mga tagasuskribi`,
	fr: (count) => `${count} abonnés`,
	hi: (count) => `${count} ग्राहक`,
	ht: (count) => `${count} abonnés`,
	it: (count) => `${count} abbonati`,
	ja: (count) => `${count} 人の加入者`,
	ko: (count) => `${count} 명`,
	mww: (count) => `${count} tus neeg rau npe`,
	ps: (count) => `${count} ګډونوال`,
	pt: (count) => `${count} assinantes`,
	'pt-pt': (count) => `${count} subscritores`,
	ru: (count) => `${count} подписчиков`,
	sm: (count) => `${count} tagata fai saofaga`,
	so: (count) => `${count} macaamiil`,
	th: (count) => `สมาชิก ${count} คน`,
	ur: (count) => `${count} سبسکرائبرز`,
	vi: (count) => `${count} người đăng ký`,
	'zh-hans': (count) => `${count} 名订阅者`,
	'zh-hant': (count) => `${count} 名訂閱者`,
	en: (count) => `${count} subscribers`
};

export const loc_suffix: Record<Locale, string> = {
	ar: `اللاحقة`,
	de: `Suffix`,
	es: `Sufijo`,
	fa: `پسوند`,
	fil: `Suffix`,
	fr: `Suffixe`,
	hi: `अनुलग्‍न`,
	ht: `Sifiks`,
	it: `Suffisso`,
	ja: `接尾辞`,
	ko: `접미사`,
	mww: `suffix`,
	ps: `پسوند`,
	pt: `Sufixo`,
	'pt-pt': `Sufixo`,
	ru: `Суффикс`,
	sm: `Suffix`,
	so: `Dhammaad`,
	th: `คําต่อท้าย`,
	ur: `لاحقہ`,
	vi: `Hậu tố`,
	'zh-hans': `后缀`,
	'zh-hant': `後綴`,
	en: `Suffix`
};

export const loc_summary: Record<Locale, string> = {
	ar: `الملخص`,
	de: `Zusammenfassung`,
	es: `Resumen`,
	fa: `خلاصه`,
	fil: `Buod`,
	fr: `Résumé`,
	hi: `सारांश`,
	ht: `Rezime`,
	it: `Sommario`,
	ja: `概要`,
	ko: `요약`,
	mww: `Ntsiab lus`,
	ps: `لنډیز`,
	pt: `Resumo`,
	'pt-pt': `Resumo`,
	ru: `Краткое содержание`,
	sm: `Aotelega`,
	so: `Soo koobid`,
	th: `สรุป`,
	ur: `خلاصہ`,
	vi: `Tóm tắt`,
	'zh-hans': `摘要`,
	'zh-hant': `摘要`,
	en: `Summary`
};

export const loc_supervisesAnOrganization: Record<Locale, string> = {
	ar: `يشرف على منظمة تشارك في هذا النشاط.`,
	de: `Überwacht eine Organisation, die an dieser Aktivität teilnimmt.`,
	es: `Supervisa a una organización que participa en esta actividad.`,
	fa: `نظارت بر سازمانی که در این فعالیت شرکت دارد.`,
	fil: `Pangasiwaan ang isang organisasyon na nakikilahok sa aktibidad na ito.`,
	fr: `Supervise une organisation participant à cette activité.`,
	hi: `इस गतिविधि में भाग लेने वाले संगठन की देखरेख करता है।`,
	ht: `Sipèvize yon òganizasyon k ap patisipe nan aktivite sa a.`,
	it: `Supervisiona un'organizzazione che partecipa a questa attività.`,
	ja: `この活動に参加する組織を監督します。`,
	ko: `이 활동에 참여하는 조직을 감독합니다.`,
	mww: `Saib xyuas ib lub koom haum uas koom nrog txoj haujlwm no.`,
	ps: `هغه سازمان څاری چې په دې فعالیت کې برخه اخلی.`,
	pt: `Supervisiona uma organização que participa dessa atividade.`,
	'pt-pt': `Supervisiona uma organização que participa nesta atividade.`,
	ru: `Курирует организацию, участвующую в этой деятельности.`,
	sm: `Vaavaaia se faalapotopotoga o loo auai i lenei gaoioiga.`,
	so: `Waxay kormeertaa urur ka qayb qaadanaya hawshan.`,
	th: `กํากับดูแลองค์กรที่เข้าร่วมกิจกรรมนี้`,
	ur: `اس سرگرمی میں حصہ لینے والی تنظیم کی نگرانی کرتا ہے۔`,
	vi: `Giám sát một tổ chức tham gia hoạt động này.`,
	'zh-hans': `监督参与该活动的组织。`,
	'zh-hant': `監督參與此活動的組織。`,
	en: `Supervises an organization participating in this activity.`
};

export const loc_supervisesTheProject: Record<Locale, (project: unknown) => string> = {
	ar: (project) => `يشرف على مشروع ${project} .`,
	de: (project) => `Überwacht das ${project} .`,
	es: (project) => `Supervisa el proyecto ${project} .`,
	fa: (project) => `نظارت بر پروژه ${project} .`,
	fil: (project) => `Pangangasiwa sa ${project} .`,
	fr: (project) => `Supervise le projet ${project} .`,
	hi: (project) => `${project} परियोजना की देखरेख करता है।`,
	ht: (project) => `Sipèvize pwojè ${project} la.`,
	it: (project) => `Supervisiona il progetto ${project} .`,
	ja: (project) => `${project}プロジェクトを監督します。`,
	ko: (project) => `${project} 프로젝트를 감독합니다.`,
	mww: (project) => `Saib xyuas txoj haujlwm ${project} .`,
	ps: (project) => `د ${project} پروژه څاری.`,
	pt: (project) => `Supervisiona o projeto ${project} .`,
	'pt-pt': (project) => `Supervisiona o projeto ${project} .`,
	ru: (project) => `Курирует проект ${project} .`,
	sm: (project) => `Va'ava'aia le poloketi ${project} .`,
	so: (project) => `Waxay kormeertaa mashruuca ${project} karo.`,
	th: (project) => `ดูแลโครงการ${project}`,
	ur: (project) => `${project} کے منصوبے کی نگرانی کرتا ہے۔`,
	vi: (project) => `Giám sát dự án ${project} .`,
	'zh-hans': (project) => `监督 ${project} 项目。`,
	'zh-hant': (project) => `監督 ${project} 計畫。`,
	en: (project) => `Supervises the ${project} project.`
};

export const loc_support: Record<Locale, string> = {
	ar: `الدعم`,
	de: `Unterstützung`,
	es: `Apoyo`,
	fa: `پشتیبانی`,
	fil: `Suporta`,
	fr: `Soutien`,
	hi: `जीविका`,
	ht: `Sipò`,
	it: `Supporto`,
	ja: `支援`,
	ko: `지원`,
	mww: `Kev them nyiaj yug`,
	ps: `ملاتړ`,
	pt: `Apoio`,
	'pt-pt': `Apoio`,
	ru: `Поддержка`,
	sm: `Lagolago`,
	so: `Taageero`,
	th: `การสนับสนุน`,
	ur: `حمایت`,
	vi: `Hỗ trợ`,
	'zh-hans': `支持`,
	'zh-hant': `支持`,
	en: `Support`
};

export const loc_suspended: Record<Locale, string> = {
	ar: `تم تعليق الإيقاف`,
	de: `Suspendiert`,
	es: `Suspendido`,
	fa: `تعلیق شده`,
	fil: `Sinuspinde`,
	fr: `Suspendu`,
	hi: `निलंबित`,
	ht: `Sispansyon`,
	it: `Sospesi`,
	ja: `停職中`,
	ko: `정지`,
	mww: `raug tshem tawm`,
	ps: `تعلیق شوی`,
	pt: `Suspenso`,
	'pt-pt': `Suspenso`,
	ru: `Отстранённый`,
	sm: `Fa'amalolo`,
	so: `Joojiyay`,
	th: `ถูกระงับ`,
	ur: `معطل`,
	vi: `Tạm ngưng`,
	'zh-hans': `停赛`,
	'zh-hant': `停賽`,
	en: `Suspended`
};

export const loc_suspension: Record<Locale, string> = {
	ar: `نظام التعليق`,
	de: `Aufhängung`,
	es: `Suspensión`,
	fa: `تعلیق`,
	fil: `Suspensyon`,
	fr: `Suspension`,
	hi: `निलंबन`,
	ht: `Sispansyon`,
	it: `Sospensioni`,
	ja: `サスペンション`,
	ko: `서스펜션`,
	mww: `Kev ncua`,
	ps: `تعلیق`,
	pt: `Suspensão`,
	'pt-pt': `Suspensão`,
	ru: `Подвеска`,
	sm: `Fa'amalolo`,
	so: `Joojinta`,
	th: `การระงับ`,
	ur: `معطلی`,
	vi: `Đình chỉ`,
	'zh-hans': `悬挂`,
	'zh-hant': `懸吊系統`,
	en: `Suspension`
};

export const loc_suspensions: Record<Locale, string> = {
	ar: `التعليقات`,
	de: `Aufhängungen`,
	es: `Suspensiones`,
	fa: `تعلیق ها`,
	fil: `Mga Suspensyon`,
	fr: `Suspensions`,
	hi: `निलंबन`,
	ht: `Sispansyon`,
	it: `Sospensioni`,
	ja: `サスペンション`,
	ko: `서스펜션`,
	mww: `Kev Ncua Kev Kawm Ntawv`,
	ps: `تعلیق شوی`,
	pt: `Suspensões`,
	'pt-pt': `Suspensões`,
	ru: `Подвески`,
	sm: `Fa'amalolo`,
	so: `Joojinta`,
	th: `การระงับ`,
	ur: `معطلیاں`,
	vi: `Đình chỉ`,
	'zh-hans': `悬挂`,
	'zh-hant': `懸掛系統`,
	en: `Suspensions`
};

export const loc_swapEllipses: Record<Locale, string> = {
	ar: `استبدال...`,
	de: `Tauschen...`,
	es: `Intercambiar...`,
	fa: `تعویض...`,
	fil: `Palitan ...`,
	fr: `Échanger...`,
	hi: `विनिमय करना।।।`,
	ht: `Swap ...`,
	it: `Scambia...`,
	ja: `スワップ...`,
	ko: `스왑...`,
	mww: `Sib pauv...`,
	ps: `بدلول...`,
	pt: `Trocar...`,
	'pt-pt': `Trocar...`,
	ru: `Обмен...`,
	sm: `Fesuia'i...`,
	so: `Isweydaarsi...`,
	th: `สลับ...`,
	ur: `بدلو...`,
	vi: `Hoán đổi...`,
	'zh-hans': `交换......`,
	'zh-hant': `交換......`,
	en: `Swap...`
};

export const loc_swapMergeKeep: Record<Locale, string> = {
	ar: `تبديل الدمج والاستمرار في ال...`,
	de: `Tauschen, zusammenführen und behalten...`,
	es: `Intercambiar, fusionar y mantener...`,
	fa: `تعویض، ادغام و نگه داشتن...`,
	fil: `Swap, pagsamahin at panatilihin ...`,
	fr: `Échanger, fusionner et garder...`,
	hi: `स्वैप, मर्ज और कीप...`,
	ht: `Swap rantre & kenbe...`,
	it: `Scambia, fondi e tieni...`,
	ja: `スワップ、マージ、そしてキープ...`,
	ko: `스왑, 합병, 그리고 유지...`,
	mww: `Swap merge & khaws cia ...`,
	ps: `تبادله یوځای کړه او وساته...`,
	pt: `Trocar, mesclar e manter...`,
	'pt-pt': `Trocar, fundir e manter...`,
	ru: `Обмен, слияние и сохранение...`,
	sm: `Fa'apipi'i fa'apipi'i ma fa'apipi'i ...`,
	so: `Is-weydaarsi, isku dar, oo sii hay...`,
	th: `สลับผสานและเก็บ...`,
	ur: `تبدیل کریں، مرج کریں اور برقرار رکھیں...`,
	vi: `Hoán đổi, hợp nhất và giữ...`,
	'zh-hans': `交换合并并保持......`,
	'zh-hant': `交換合併並保持......`,
	en: `Swap merge & keep...`
};

export const loc_systemDefault: Record<Locale, string> = {
	ar: `نظام الافتراضي`,
	de: `Systemstandard`,
	es: `Sistema predeterminado`,
	fa: `پیش فرض سیستم`,
	fil: `System Default`,
	fr: `Par défaut système`,
	hi: `सिस्टम डिफ़ॉल्ट`,
	ht: `Sistèm Default`,
	it: `Sistema predefinito`,
	ja: `システムデフォルト`,
	ko: `시스템 기본 상태`,
	mww: `System Default`,
	ps: `سیسټم ډیفالټ`,
	pt: `Sistema Padrão`,
	'pt-pt': `Padrão do Sistema`,
	ru: `Система по умолчанию`,
	sm: `Fa'aletonu o le Faiga`,
	so: `Nidaamka Default`,
	th: `ค่าเริ่มต้นของระบบ`,
	ur: `سسٹم ڈیفالٹ`,
	vi: `Mặc định hệ thống`,
	'zh-hans': `系统默认`,
	'zh-hant': `系統預設`,
	en: `System Default`
};

export const loc_task: Record<Locale, string> = {
	ar: `المهمة`,
	de: `Aufgabe`,
	es: `Tarea`,
	fa: `وظیفه`,
	fil: `Gawain`,
	fr: `Tâche`,
	hi: `नियत कार्य`,
	ht: `Travay la`,
	it: `Compito`,
	ja: `任務`,
	ko: `임무`,
	mww: `Tes haujlwm`,
	ps: `دنده`,
	pt: `Tarefa`,
	'pt-pt': `Tarefa`,
	ru: `Задача`,
	sm: `Galuega`,
	so: `Hawl`,
	th: `งาน`,
	ur: `کام`,
	vi: `Nhiệm vụ`,
	'zh-hans': `任务`,
	'zh-hant': `任務`,
	en: `Task`
};

export const loc_telecom: Record<Locale, string> = {
	ar: `الاتصالات`,
	de: `Telekommunikation`,
	es: `Telecomunicaciones`,
	fa: `مخابرات`,
	fil: `Email Address *`,
	fr: `Télécom`,
	hi: `दूरसंचार`,
	ht: `Telecom`,
	it: `Telecomunicazioni`,
	ja: `テレコム`,
	ko: `통신`,
	mww: `Telecom`,
	ps: `ټیلیکام`,
	pt: `Telecomunicações`,
	'pt-pt': `Telecomunicações`,
	ru: `Телеком`,
	sm: `Feso'ota'iga`,
	so: `Telecom`,
	th: `โทรคมนาคม`,
	ur: `ٹیلی کام`,
	vi: `Viễn thông`,
	'zh-hans': `电信`,
	'zh-hant': `電信`,
	en: `Telecom`
};

export const loc_tenMiles: Record<Locale, string> = {
	ar: `10 أميال`,
	de: `10 Meilen`,
	es: `10 millas`,
	fa: `۱۰ مایل`,
	fil: `10 milya`,
	fr: `10 miles`,
	hi: `10 मील`,
	ht: `10 mil`,
	it: `10 miglia`,
	ja: `10マイル`,
	ko: `10마일`,
	mww: `10 mais`,
	ps: `۱۰ میله`,
	pt: `10 milhas`,
	'pt-pt': `10 milhas`,
	ru: `10 миль`,
	sm: `10 maila`,
	so: `10 mayl`,
	th: `16.1 กม.`,
	ur: `10 میل`,
	vi: `10 dặm`,
	'zh-hans': `10英里`,
	'zh-hant': `10英里`,
	en: `10 miles`
};

export const loc_termsOfUse: Record<Locale, string> = {
	ar: `شروط الاستخدام`,
	de: `Nutzungsbedingungen`,
	es: `Términos de uso`,
	fa: `شرایط استفاده`,
	fil: `Mga Tuntunin ng Paggamit`,
	fr: `Conditions d’utilisation`,
	hi: `उपयोग की शर्तें`,
	ht: `Regleman pou Itilize`,
	it: `Termini di utilizzo`,
	ja: `利用規約`,
	ko: `이용 약관`,
	mww: `Cov ntsiab lus ntawm Kev Siv`,
	ps: `د کارونې شرایط`,
	pt: `Termos de Uso`,
	'pt-pt': `Termos de Utilização`,
	ru: `Условия использования`,
	sm: `Tuutuuga o le Faaaogaina`,
	so: `Shuruudaha Isticmaalka`,
	th: `เงื่อนไขการใช้งาน`,
	ur: `استعمال کی شرائط`,
	vi: `Điều khoản sử dụng`,
	'zh-hans': `使用条款`,
	'zh-hant': `使用條款`,
	en: `Terms of Use`
};

export const loc_text: Record<Locale, string> = {
	ar: `النص`,
	de: `Text`,
	es: `Texto`,
	fa: `متن`,
	fil: `Text`,
	fr: `Texte`,
	hi: `टेक्स्ट`,
	ht: `Mesaj tèks`,
	it: `Testo`,
	ja: `本文`,
	ko: `본문`,
	mww: `Sau ntawv saum xov tooj`,
	ps: `متن`,
	pt: `Texto`,
	'pt-pt': `Texto`,
	ru: `Текст`,
	sm: `Tusitusiga`,
	so: `Qoraalka`,
	th: `ข้อความ`,
	ur: `متن`,
	vi: `Văn bản`,
	'zh-hans': `正文`,
	'zh-hant': `正文`,
	en: `Text`
};

export const loc_thankYouForParticipating: Record<Locale, (href: unknown) => TemplateResult> = {
	ar: (href) => html`شكرا لمشاركتك! يمكنك إغلاق هذه الصفحة أو <a href="${href}">بدء مشاركة أخرى</a> لشخص آخر.`,
	de: (href) => html`Vielen Dank für Ihre Einsendung! Sie können diese Seite schließen oder für jemand anderen eine <a href="${href}">neue Einreichung starten</a> .`,
	es: (href) => html`¡Gracias por tu aportación! Puedes cerrar esta página o <a href="${href}">iniciar otra publicación</a> para otra persona.`,
	fa: (href) => html`از ارسال شما سپاسگزاریم! می توانید این صفحه را ببندید یا <a href="${href}">ارسال دیگری برای</a> شخص دیگری شروع کنید.`,
	fil: (href) => html`Salamat sa iyong pagsusumite! Maaari mong isara ang pahinang ito o <a href="${href}">magsimula ng panibagong pagsusumite</a> para sa iba.`,
	fr: (href) => html`Merci pour votre contribution ! Vous pouvez fermer cette page ou <a href="${href}">en commencer une autre</a> pour quelqu’un d’autre.`,
	hi: (href) => html`आपके सबमिशन के लिए धन्यवाद! आप इस पृष्ठ को बंद कर सकते हैं या किसी और के लिए <a href="${href}">एक और सबमिशन शुरू कर</a> सकते हैं।`,
	ht: (href) => html`Mèsi pou soumèt ou! Ou ka fèmen paj sa a oswa <a href="${href}">kòmanse yon lòt soumèt</a> pou yon lòt moun.`,
	it: (href) => html`Grazie per la tua segnalazione! Puoi chiudere questa pagina o <a href="${href}">iniziare un'altra pubblicazione</a> per qualcun altro.`,
	ja: (href) => html`ご投稿ありがとうございます!このページを閉じるか、他の方のために <a href="${href}">別の投稿を始め</a> てください。`,
	ko: (href) => html`제출해 주셔서 감사합니다! 이 페이지를 닫거나 다른 분을 위해 <a href="${href}">다른 글을 제출</a> 하실 수 있습니다.`,
	mww: (href) => html`Ua tsaug rau koj qhov kev xa ntawv! Koj tuaj yeem kaw nplooj ntawv no lossis <a href="${href}">pib xa ntawv tshiab</a> rau lwm tus.`,
	ps: (href) => html`ستاسو د سپارلو لپاره مننه! تاسو کولای شئ دا پاڼه وتړې یا <a href="${href}">بل چا ته بل لیکنه پیل</a> کړئ.`,
	pt: (href) => html`Obrigado pela sua publicação! Você pode fechar esta página ou <a href="${href}">começar outra postagem</a> para outra pessoa.`,
	'pt-pt': (href) => html`Obrigado pela sua submissão! Pode fechar esta página ou <a href="${href}">iniciar outra submissão</a> para outra pessoa.`,
	ru: (href) => html`Спасибо за вашу публикацию! Вы можете закрыть эту страницу или <a href="${href}">начать новую работу</a> для кого-то другого.`,
	sm: (href) => html`Fa'afetai mo lau tu'uina atu! E mafai ona e tapunia lenei itulau pe <a href="${href}">amata se isi tusiga</a> mo se isi tagata.`,
	so: (href) => html`Waad ku mahadsan tahay soo gudbintaada! Waad xiran kartaa boggan ama <a href="${href}">waxaad bilaabi kartaa</a> qoraal kale oo qof kale ah.`,
	th: (href) => html`ขอบคุณสําหรับการส่งโพสต์ของคุณ!คุณสามารถปิดหน้านี้หรือ <a href="${href}">เริ่มส่งโพสต์ใหม่</a> ให้กับคนอื่นได้`,
	ur: (href) => html`آپ کی جمع کرائی گئی تحریر کا شکریہ! آپ یہ صفحہ بند کر سکتے ہیں یا کسی اور کے لیے <a href="${href}">دوسرا سبمیشن شروع</a> کر سکتے ہیں۔`,
	vi: (href) => html`Cảm ơn bạn đã gửi bài! Bạn có thể đóng trang này hoặc <a href="${href}">bắt đầu gửi bài khác</a> cho người khác.`,
	'zh-hans': (href) => html`感谢您的投稿！您可以关闭本页面或 <a href="${href}">为他人重新提交</a> 。`,
	'zh-hant': (href) => html`感謝您的投稿！您可以關閉此頁面或 <a href="${href}">為他人重新投稿</a> 。`,
	en: (href) => html`Thank you for your submission! You may close this page or <a href="${href}">start another submission</a> for someone else.`
};

export const loc_thankYouForSubmitting: Record<Locale, string> = {
	ar: `شكرا على ردك!`,
	de: `Danke für deine Antwort!`,
	es: `¡Gracias por responder!`,
	fa: `ممنون که پاسخ دادید!`,
	fil: `Salamat sa pagtugon!`,
	fr: `Merci pour votre réponse !`,
	hi: `प्रतिक्रिया देने के लिए धन्यवाद!`,
	ht: `Mèsi pou reponn!`,
	it: `Grazie per aver risposto!`,
	ja: `ご返信ありがとうございます!`,
	ko: `답변해 주셔서 감사합니다!`,
	mww: `Ua tsaug rau koj teb!`,
	ps: `مننه چې ځواب دې راکړ!`,
	pt: `Obrigado por responder!`,
	'pt-pt': `Obrigado pela resposta!`,
	ru: `Спасибо за ответ!`,
	sm: `Fa'afetai mo le tali mai!`,
	so: `Waad ku mahadsan tahay jawaabta!`,
	th: `ขอบคุณสําหรับการตอบกลับ!`,
	ur: `جواب دینے کا شکریہ!`,
	vi: `Cảm ơn bạn đã trả lời!`,
	'zh-hans': `谢谢你的回复！`,
	'zh-hant': `謝謝你的回覆！`,
	en: `Thank you for responding!`
};

export const loc_theme: Record<Locale, string> = {
	ar: `الموضوع`,
	de: `Thema`,
	es: `Tema`,
	fa: `تم`,
	fil: `Tema`,
	fr: `Thème`,
	hi: `थीम`,
	ht: `Tèm`,
	it: `Tema`,
	ja: `テーマ`,
	ko: `주제`,
	mww: `Ntsiab lus`,
	ps: `موضوع`,
	pt: `Tema`,
	'pt-pt': `Tema`,
	ru: `Тема`,
	sm: `Autu`,
	so: `Mawduuca`,
	th: `ธีม`,
	ur: `موضوع`,
	vi: `Chủ đề`,
	'zh-hans': `主题`,
	'zh-hant': `主題`,
	en: `Theme`
};

export const loc_thereAreNoAddresses: Record<Locale, string> = {
	ar: `لا توجد عناوين`,
	de: `Es gibt keine Adressen`,
	es: `No hay direcciones`,
	fa: `آدرسی وجود ندارد`,
	fil: `Walang Address`,
	fr: `Il n’y a pas d’adresses`,
	hi: `कोई पता नहीं है`,
	ht: `Pa gen adrès`,
	it: `Non ci sono indirizzi`,
	ja: `住所は存在しません`,
	ko: `주소는 없습니다`,
	mww: `Tsis muaj chaw nyob`,
	ps: `هیڅ پته نشته`,
	pt: `Não há endereços`,
	'pt-pt': `Não há endereços`,
	ru: `Адресов нет`,
	sm: `E leai ni tuatusi`,
	so: `Cinwaano ma jiraan`,
	th: `ไม่มีที่อยู่`,
	ur: `کوئی پتہ نہیں ہے`,
	vi: `Không có địa chỉ`,
	'zh-hans': `没有地址`,
	'zh-hant': `沒有地址`,
	en: `There are no addresses`
};

export const loc_thereAreNoContacts: Record<Locale, string> = {
	ar: `لا توجد جهات اتصال`,
	de: `Es gibt keine Kontakte.`,
	es: `No hay contactos`,
	fa: `هیچ تماسی وجود ندارد`,
	fil: `Walang mga contact`,
	fr: `Il n’y a pas de contacts`,
	hi: `कोई संपर्क नहीं हैं`,
	ht: `Pa gen okenn kontak`,
	it: `Non ci sono contatti`,
	ja: `接触者はいない`,
	ko: `접촉자가 없어`,
	mww: `Tsis muaj kev sib cuag`,
	ps: `هیڅ تماسونه نشته`,
	pt: `Não há contatos`,
	'pt-pt': `Não há contactos`,
	ru: `Контактов нет`,
	sm: `E leai ni feso'ota'iga`,
	so: `Ma jiraan xiriir`,
	th: `ไม่มีผู้ติดต่อ`,
	ur: `کوئی رابطے نہیں ہیں`,
	vi: `Không có liên hệ`,
	'zh-hans': `没有接触`,
	'zh-hant': `沒有接觸`,
	en: `There are no contacts`
};

export const loc_thereAreNoEmails: Record<Locale, string> = {
	ar: `لا توجد رسائل بريد إلكتروني`,
	de: `Es gibt keine E-Mails`,
	es: `No hay correos electrónicos`,
	fa: `هیچ ایمیلی وجود ندارد`,
	fil: `Walang mga email`,
	fr: `Il n’y a pas d’emails`,
	hi: `कोई ईमेल नहीं हैं`,
	ht: `Pa gen okenn Imèl`,
	it: `Non ci sono email`,
	ja: `メールは一切ありません`,
	ko: `이메일은 없습니다`,
	mww: `Tsis muaj email`,
	ps: `هیڅ ایمیلونه نشته`,
	pt: `Não há e-mails`,
	'pt-pt': `Não há emails`,
	ru: `Нет никаких писем`,
	sm: `E leai ni imeli`,
	so: `Email ma jiraan`,
	th: `ไม่มีอีเมล`,
	ur: `کوئی ای میلز نہیں ہیں`,
	vi: `Không có email`,
	'zh-hans': `没有邮件`,
	'zh-hant': `沒有電子郵件`,
	en: `There are no emails`
};

export const loc_thereAreNoPhones: Record<Locale, string> = {
	ar: `لا توجد هواتف`,
	de: `Es gibt keine Telefone`,
	es: `No hay teléfonos`,
	fa: `تلفن وجود ندارد`,
	fil: `Walang Mga Telepono`,
	fr: `Il n’y a pas de téléphones`,
	hi: `कोई फोन नहीं हैं`,
	ht: `Pa gen okenn telefòn`,
	it: `Non ci sono telefoni`,
	ja: `電話はない`,
	ko: `전화기가 없어`,
	mww: `Tsis muaj xov tooj`,
	ps: `هیڅ تلیفونونه نشته`,
	pt: `Não há telefones`,
	'pt-pt': `Não há telefones`,
	ru: `Телефонов нет.`,
	sm: `E leai ni telefoni feavea'i`,
	so: `Telefoon ma jiraan`,
	th: `ไม่มีโทรศัพท์`,
	ur: `فون نہیں ہیں`,
	vi: `Không có điện thoại`,
	'zh-hans': `没有电话`,
	'zh-hant': `沒有電話`,
	en: `There are no phones`
};

export const loc_thereAreNoSites: Record<Locale, string> = {
	ar: `لا توجد مواقع`,
	de: `Es gibt keine Standorte`,
	es: `No hay sitios`,
	fa: `هیچ سایتی وجود ندارد`,
	fil: `Walang mga site`,
	fr: `Il n’y a pas de sites`,
	hi: `कोई साइट नहीं है`,
	ht: `Pa gen okenn sit`,
	it: `Non ci sono siti`,
	ja: `サイトはありません`,
	ko: `사이트는 없습니다`,
	mww: `Tsis muaj qhov chaw`,
	ps: `هیڅ ځایونه نشته`,
	pt: `Não há locais`,
	'pt-pt': `Não existem locais`,
	ru: `Здесь нет никаких объектов`,
	sm: `E leai ni nofoaga`,
	so: `Goobaha ma jiraan`,
	th: `ไม่มีเว็บไซต์`,
	ur: `کوئی سائٹس نہیں ہیں`,
	vi: `Không có trang web`,
	'zh-hans': `没有遗址`,
	'zh-hant': `沒有遺址`,
	en: `There are no sites`
};

export const loc_theresAProblem: Record<Locale, string> = {
	ar: `هناك مشكلة`,
	de: `Es gibt ein Problem`,
	es: `Hay un problema`,
	fa: `یه مشکلی هست`,
	fil: `May problema`,
	fr: `Il y a un problème`,
	hi: `एक समस्या है`,
	ht: `Gen yon pwoblèm`,
	it: `C'è un problema`,
	ja: `問題がある`,
	ko: `문제가 생겼어`,
	mww: `Muaj teeb meem`,
	ps: `یوه ستونزه ده`,
	pt: `Tem um problema`,
	'pt-pt': `Há um problema`,
	ru: `Есть проблема`,
	sm: `O loo i ai se faafitauli`,
	so: `Waxaa jira dhibaato`,
	th: `มีปัญหา`,
	ur: `ایک مسئلہ ہے`,
	vi: `Có một vấn đề`,
	'zh-hans': `出了问题`,
	'zh-hant': `有問題了`,
	en: `There's a problem`
};

export const loc_thinking: Record<Locale, string> = {
	ar: `التفكير`,
	de: `Denken`,
	es: `Pensamiento`,
	fa: `تفکر`,
	fil: `Pag-iisip`,
	fr: `Réflexion`,
	hi: `विचारशील`,
	ht: `Panse`,
	it: `Pensiero`,
	ja: `思考`,
	ko: `사고`,
	mww: `Kev xav`,
	ps: `فکر کول`,
	pt: `Pensamento`,
	'pt-pt': `Pensar`,
	ru: `Мышление`,
	sm: `Mafaufau`,
	so: `Fikirka`,
	th: `การคิด`,
	ur: `سوچ`,
	vi: `Suy nghĩ`,
	'zh-hans': `思考`,
	'zh-hant': `思考`,
	en: `Thinking`
};

export const loc_timesheet: Record<Locale, string> = {
	ar: `جدول المواعيد`,
	de: `Stundenzettel`,
	es: `Hoja de horas`,
	fa: `جدول زمانی`,
	fil: `Timesheet`,
	fr: `Feuille de temps`,
	hi: `समय पत्रक`,
	ht: `Fèy tan`,
	it: `Foglio delle ore`,
	ja: `タイムシート`,
	ko: `타임시트`,
	mww: `Daim ntawv teev sij hawm`,
	ps: `د وخت پاڼه`,
	pt: `Folha de ponto`,
	'pt-pt': `Folha de Horas`,
	ru: `Табель рабочего времени`,
	sm: `Pepa o taimi`,
	so: `Jadwalka Waqtiga`,
	th: `ไทม์ชีท`,
	ur: `ٹائم شیٹ`,
	vi: `Bảng chấm công`,
	'zh-hans': `时间表`,
	'zh-hant': `時表`,
	en: `Timesheet`
};

export const loc_timesheetApprovalLegal: Record<Locale, string> = {
	ar: `أؤكد بموجب هذا أن الإدخالات في هذا السجل تمثل بيانا حقيقيا ودقيقا وكاملا لساعات العمل وأنشطة العمل، وأفوض معالجة الساعات المبلغ عنها للدفع. أفهم أن تقديم أو الموافقة على أي إدخال زمني كاذب أو غير دقيق أو مبالغ فيه قد يعتبر احتيالا وقد يؤدي إلى إنهاء فوري و/أو ملاحقة قضائية.`,
	de: `Hiermit bestätige ich, dass die Einträge in diesem Datensatz eine wahre, genaue und vollständige Darstellung der gearbeiteten Stunden und Arbeitsaktivitäten darstellen und autorisiere, dass die gemeldeten Stunden zur Zahlung verarbeitet werden. Ich verstehe, dass die Einreichung oder Genehmigung einer falschen, ungenauen oder übertriebenen Zeiteingabe als Betrug angesehen werden kann und zu sofortiger Kündigung und/oder Strafverfolgung führen kann.`,
	es: `Por la presente certifico que las entradas en este registro representan una declaración verdadera, precisa y completa de las horas trabajadas y actividades laborales, y autorizo que las horas reportadas sean procesadas para su pago. Entiendo que la presentación o aprobación de cualquier entrada de tiempo falsa, inexacta o inflada puede considerarse fraude y puede resultar en despido inmediato y/o procesamiento.`,
	fa: `بدین وسیله تأیید می کنم که ورودی های این پرونده گزارشی واقعی، دقیق و کامل از ساعات کاری و فعالیت های کاری هستند و اجازه می دهم ساعات گزارش شده برای پرداخت پردازش شوند. می دانم که ارسال یا تأیید هرگونه ورودی زمان نادرست، نادرست یا اغراق آمیز ممکن است تقلب محسوب شود و منجر به اخراج فوری و/یا پیگرد قانونی گردد.`,
	fil: `Pinatutunayan ko na ang mga entry sa talaang ito ay kumakatawan sa totoo, tumpak, at kumpletong pahayag ng mga oras na nagtrabaho at mga aktibidad sa trabaho, at pinahihintulutan ko ang mga iniulat na oras na iproseso para sa pagbabayad. Nauunawaan ko na ang pagsusumite o pag-apruba ng anumang mali, hindi tumpak, o pinalaki na pagpasok ng oras ay maaaring ituring na pandaraya at maaaring magresulta sa agarang pagwawakas at / o pag-uusig.`,
	fr: `Je certifie par la présente que les entrées figurant dans ce dossier représentent une déclaration vraie, exacte et complète des heures travaillées et des activités de travail, et j’autorise le traitement des heures déclarées pour paiement. Je comprends que la soumission ou l’approbation de toute saisie de temps fausse, inexacte ou exagérée peut être considérée comme une fraude et entraîner un licenciement immédiat et/ou des poursuites.`,
	hi: `मैं एतद्द्वारा प्रमाणित करता हूं कि इस रिकॉर्ड पर प्रविष्टियां काम के घंटों और कार्य गतिविधियों के एक सच्चे, सटीक और पूर्ण विवरण का प्रतिनिधित्व करती हैं, और मैं भुगतान के लिए संसाधित होने के लिए रिपोर्ट किए गए घंटों को अधिकृत करता हूं। मैं समझता हूं कि किसी भी झूठी, गलत, या बढ़ी हुई समय प्रविष्टि को प्रस्तुत करना या अनुमोदन करना धोखाधड़ी माना जा सकता है और इसके परिणामस्वरूप तत्काल समाप्ति और/या अभियोजन हो सकता है।`,
	ht: `Mwen sètifye nan dokiman sa a ke antre yo nan dosye sa a reprezante yon deklarasyon reyèl, egzat ak konplè nan èdtan travay ak aktivite travay, epi mwen otorize èdtan yo rapòte yo dwe trete pou peman. Mwen konprann ke soumèt oswa apwobasyon nan nenpòt ki fo, kòrèk, oswa gonfle antre tan ka konsidere kòm fwod epi yo ka lakòz revokasyon imedyat ak / oswa pouswit pouswit.`,
	it: `Certifico con la presente che le voci in questo registro rappresentano una dichiarazione vera, accurata e completa delle ore lavorate e delle attività lavorative, e autorizzo l'elaborazione delle ore riportate per il pagamento. Capisco che la presentazione o l'approvazione di qualsiasi inserimento di tempo falso, inaccurato o gonfiato possa essere considerata frode e comportare il licenziamento immediato e/o la procedura penale.`,
	ja: `本記録の記録が勤務時間および業務活動の真実で正確かつ完全な記述であることをここに証明し、報告された労働時間の支払い処理を許可します。虚偽、不正確、または誇張された時間の入力の提出や承認は詐欺とみなされ、即時解雇や起訴につながる可能性があることは理解しています。`,
	ko: `이 기록에 기재된 항목들이 근무 시간과 업무 활동에 대한 진실되고 정확하며 완전한 진술임을 증명하며, 보고된 시간에 대한 지급 처리를 승인합니다. 허위, 부정확, 부풀린 시간 입력을 제출하거나 승인하는 것은 사기로 간주될 수 있으며, 즉각적인 해고 및/또는 기소로 이어질 수 있음을 이해합니다.`,
	mww: `Kuv lees paub ntawm no tias cov ntaub ntawv hauv cov ntaub ntawv no sawv cev rau ib daim ntawv qhia tseeb, raug, thiab tag nrho cov sij hawm ua hauj lwm thiab kev ua hauj lwm, thiab kuv tso cai rau cov sij hawm uas tau tshaj tawm los ua kom them nyiaj. Kuv nkag siab tias kev xa lossis kev pom zoo ntawm ib qho kev nkag tsis tseeb, tsis raug, lossis lub sijhawm nkag mus yuav raug suav tias yog kev dag ntxias thiab tej zaum yuav ua rau kev txiav tawm thiab / lossis raug foob tam sim ntawd.`,
	ps: `زه دلته تصدیق کوم چې په دې ریکارډ کې داخلې د کار او کاری فعالیتونو ریښتینی، دقیق، او بشپړ بیان دی، او زه اجازه ورکوم چې راپور شوی ساعتونه د پیسو لپاره پروسس شی. زه پوهېږم چې د هر ډول غلط، ناسم، یا مبالغه شوې وخت لیکنې سپارل یا تصویب کول ممکن درغلی وګڼل شی او سمدستی د ختمولو او/یا تعقیب لامل شی.`,
	pt: `Certifico que as entradas neste registro representam uma declaração verdadeira, precisa e completa das horas trabalhadas e das atividades de trabalho, e autorizo que as horas reportadas sejam processadas para pagamento. Entendo que a submissão ou aprovação de qualquer registro de tempo falso, impreciso ou inflado pode ser considerada fraude e pode resultar em demissão imediata e/ou processo judicial.`,
	'pt-pt': `Certifico que as entradas neste registo representam uma declaração verdadeira, precisa e completa das horas trabalhadas e das atividades de trabalho, e autorizo o processamento das horas reportadas para pagamento. Compreendo que a submissão ou aprovação de qualquer entrada de tempo falsa, imprecisa ou inflacionada pode ser considerada fraude e pode resultar em rescisão imediata e/ou acusação.`,
	ru: `Я настоящим подтверждаю, что записи в данном записи представляют собой истинное, точное и полное описание отработанных часов и рабочих действий, и разрешаю обработку этих часов для оплаты. Я понимаю, что подача или одобрение любой ложной, неточной или завышенной записи может считаться мошенничеством и привести к немедленному увольнению и/или уголовному преследованию.`,
	sm: `Ou te faamaonia atu o faamatalaga i luga o lenei faamaumauga e fai ma sui o se faamatalaga moni, sa'o, ma atoatoa o itula faigaluega ma gaoioiga faigaluega, ma ou te faatagaina itula ua lipotia mai ina ia faagaoioia mo le totogiina. Ou te malamalama o le tu'uina atu po'o le fa'amaonia o so'o se sese, le sa'o, po'o le fa'ateleina o le taimi e mafai ona manatu o se taufaasese ma e mafai ona i'u ai i le vave fa'amutaina ma / po'o le moliaga.`,
	so: `Waxaan halkan ku xaqiijinayaa in diiwaankan ay yihiin warbixin sax ah, oo dhamaystiran oo ku saabsan saacadaha shaqada iyo hawlaha shaqada, waxaanan oggolaanayaa in saacadaha la soo sheegay la farsameeyo si loo bixiyo lacag. Waxaan fahamsanahay in gudbinta ama ansixinta wakhti been ah, aan sax ahayn, ama la buufin gelin karo loo tixgelin karo khiyaano isla markaana ay keeni karto in si degdeg ah loo joojiyo iyo/ama dacwad.`,
	th: `ข้าพเจ้าขอรับรองว่ารายการในบันทึกนี้แสดงถึงคําชี้แจงที่แท้จริง ถูกต้อง และครบถ้วนเกี่ยวกับชั่วโมงทํางานและกิจกรรมการทํางาน และข้าพเจ้าอนุญาตให้ดําเนินการชั่วโมงที่รายงานเพื่อดําเนินการชําระเงิน ข้าพเจ้าเข้าใจว่าการส่งหรืออนุมัติการป้อนเวลาที่เป็นเท็จ ไม่ถูกต้อง หรือเกินจริงอาจถือเป็นการฉ้อโกง และอาจส่งผลให้ถูกยกเลิกและ/หรือถูกดําเนินคดีทันที`,
	ur: `میں یہاں تصدیق کرتا ہوں کہ اس ریکارڈ پر موجود اندراجات کام کے گھنٹوں اور سرگرمیوں کا حقیقی، درست اور مکمل بیان پیش کرتے ہیں، اور میں رپورٹ شدہ گھنٹوں کو ادائیگی کے لیے پراسیس کرنے کی اجازت دیتا ہوں۔ میں سمجھتا ہوں کہ کسی بھی جھوٹی، غلط، یا بڑھا چڑھا کر دی گئی وقت کی اندراج کی منظوری فراڈ سمجھی جا سکتی ہے اور فوری برطرفی اور/یا قانونی کارروائی کا باعث بن سکتی ہے۔`,
	vi: `Tôi xác nhận rằng các mục trong hồ sơ này đại diện cho một tuyên bố trung thực, chính xác và đầy đủ về số giờ làm việc và hoạt động làm việc, và tôi cho phép số giờ được báo cáo được xử lý để thanh toán. Tôi hiểu rằng việc gửi hoặc phê duyệt bất kỳ mục nhập thời gian sai, không chính xác hoặc thổi phồng nào có thể bị coi là gian lận và có thể dẫn đến việc chấm dứt và/hoặc truy tố ngay lập tức.`,
	'zh-hans': `我在此证明本记录上的记录代表了真实、准确且完整的工作时间和工作活动陈述，并授权对报告工时进行处理以进行支付。我理解提交或批准任何虚假、不准确或夸大的工时记录可能被视为欺诈，可能导致立即解雇和/或起诉。`,
	'zh-hant': `我在此證明本紀錄上的記錄代表真實、準確且完整的工作時數及工作活動陳述，並授權處理申報工時以進行支付。我了解任何虛假、不準確或誇大時間紀錄的提交或批准，可能被視為詐欺，可能導致立即解僱及/或起訴。`,
	en: `I hereby certify that the entries on this record represent a true, accurate, and complete statement of hours worked and work activities, and I authorize the reported hours to be processed for payment. I understand that submission or approval of any false, inaccurate, or inflated time entry may be considered fraud and may result in immediate termination and/or prosecution.`
};

export const loc_timesheetDocsAndSupport: Record<Locale, TemplateResult> = {
	ar: html`هل تحتاج مساعدة في جدول الساعات الخاص بك؟ اقرأ <a href="/docs">تعليمات جدول المواعيد</a>.`,
	de: html`Brauchen Sie Hilfe bei Ihrem Stundenzettel? Lies die <a href="/docs">Anweisungen zum Stundenzettel</a>.`,
	es: html`¿Necesitas ayuda con tu hoja de horas? Lee las <a href="/docs">instrucciones de la hoja de horas</a>.`,
	fa: html`نیاز به کمک برای برگه زمان بندی خود دارید؟ <a href="/docs">دستورالعمل های برگه زمان</a> بندی را بخوانید.`,
	fil: html`Kailangan mo ba ng tulong sa iyong timesheet? Basahin ang <a href="/docs">mga tagubilin sa timesheet</a>.`,
	fr: html`Besoin d’aide pour votre feuille de temps ? Lisez les <a href="/docs">instructions de la feuille de temps</a>.`,
	hi: html`अपनी टाइमशीट के साथ मदद चाहिए? <a href="/docs">टाइमशीट निर्देश</a> पढ़ें।`,
	ht: html`Bezwen èd ak Fèy tan ou? Li <a href="/docs">enstriksyon Fèy tan</a> yo`,
	it: html`Hai bisogno di aiuto con il tuo foglio presenze? Leggi <a href="/docs">le istruzioni del foglio presenze</a>.`,
	ja: html`タイムシートの助けが必要ですか? <a href="/docs">タイムシートの指示</a>を読んでください。`,
	ko: html`근무 시간표 작성에 도움이 필요하신가요? <a href="/docs">근무 시간표 설명서를 읽어보세요</a>.`,
	mww: html`Xav tau kev pab nrog koj daim ntawv teev sijhawm? Nyeem cov <a href="/docs">lus qhia txog daim ntawv teev sijhawm</a>.`,
	ps: html`د خپل وخت په جدول کې مرسته پکار ده؟ <a href="/docs">د وخت پاڼې لارښوونې</a> ولوله.`,
	pt: html`Precisa de ajuda com sua folha de ponto? Leia as <a href="/docs">instruções da folha de ponto</a>.`,
	'pt-pt': html`Precisa de ajuda com a sua folha de horas? Leia as <a href="/docs">instruções da folha de horas</a>.`,
	ru: html`Нужна помощь с табелем рабочего времени? Прочитайте <a href="/docs">инструкции к табелю рабочего времени</a>.`,
	sm: html`Mana'omia se fesoasoani i lau pepa o taimi? Faitau <a href="/docs">faatonuga o le pepa o taimi</a>.`,
	so: html`Ma u baahan tahay caawimaad waqtigaaga? Akhri <a href="/docs">tilmaamaha jadwalka waqtiga</a>.`,
	th: html`ต้องการความช่วยเหลือเกี่ยวกับไทม์ชีทของคุณหรือไม่? อ่านคําแนะนําใน<a href="/docs">ไทม์ชีท</a>`,
	ur: html`کیا آپ کو اپنے ٹائم شیٹ میں مدد چاہیے؟ <a href="/docs">ٹائم شیٹ کی ہدایاتیں</a> پڑھیں۔`,
	vi: html`Bạn cần trợ giúp về bảng chấm công? Đọc <a href="/docs">hướng dẫn bảng chấm công</a>.`,
	'zh-hans': html`需要时间表上的帮助吗？ <a href="/docs">阅读工时说明</a>。`,
	'zh-hant': html`需要工時表的協助嗎？ <a href="/docs">請閱讀工時說明</a>。`,
	en: html`Need help with your timesheet? Read the <a href="/docs">timesheet instructions</a>.`
};

export const loc_timesheetEntryInstructions: Record<Locale, TemplateResult> = {
	ar: html`أدخل أوقات الصباح أو المساء بفترات مدتها 15 دقيقة. أمثلة: <em>10 صباحا</em>، <em>9 مساء</em>، <em>9:15 صباحا</em>، <em>12:30 ظهرا</em>، <em>1:45 ظهرا</em>.`,
	de: html`Geben Sie die Zeiten mit AM oder PM in 15-Minuten-Intervallen ein. Beispiele: <em>10 Uhr</em>, <em>21 Uhr</em>, <em>9:15 Uhr</em>, <em>12:30 Uhr</em>, <em>13:45 Uhr</em>.`,
	es: html`Introduce los horarios con AM o PM en incrementos de 15 minutos. Ejemplos: <em>10:00</em>, <em>21:00</em>, <em>9:15,</em> <em>12:30,</em> <em>13:45.</em>`,
	fa: html`زمان های صبح یا عصر را در بازه های ۱۵ دقیقه ای وارد کنید. نمونه ها: <em>ساعت ۱۰ صبح</em>، <em>۹ شب</em>، <em>۹:۱۵ صبح</em>، <em>۱۲:۳۰ ظهر</em>، <em>۱:۴۵ بعدازظهر</em>.`,
	fil: html`Ipasok ang mga oras na may AM o PM sa 15 minutong pagtaas. Mga halimbawa: <em>10a</em>, <em>9p</em>, <em>9:15am</em>, <em>12:30pm</em>, <em>1.45pm</em>.`,
	fr: html`Entrez les heures du matin ou du soir par tranches de 15 minutes. Exemples : <em>10h</em>, <em>21h</em>, <em>9h15,</em> <em>12h30</em>, <em>13h45</em>.`,
	hi: html`15 मिनट की वृद्धि में AM या PM के साथ समय दर्ज करें। उदाहरण: <em>10a</em>, <em>9p</em>, <em>9:15am,</em> <em>12:30pm</em>, <em>1.45pm</em>.`,
	ht: html`Antre nan tan ak AM oswa PM nan 15 minit. Egzanp: <em>10a</em>, <em>9p</em>, <em>9:15am</em>, <em>12:30pm</em>, <em>1.45pm</em>.`,
	it: html`Inserisci gli orari con AM o PM in intervalli di 15 minuti. Esempi: <em>10:00</em>, <em>21:</em>00, <em>9:15,</em> <em>12:30</em>, <em>13:45</em>.`,
	ja: html`午前または午後の時刻を15分単位で入力してください。例: <em>午前10</em>時、 <em>午後9</em>時、 <em>午前9時15</em>分、 <em>午後12時30</em>分、 <em>午後1時45</em>分。`,
	ko: html`오전 또는 오후 시간을 15분 단위로 입력하세요. 예시: <em>오전 10</em>시, <em>오후 9</em><em>시, 오전 9시 15</em>분, <em>오후 12시 30</em>분, <em>오후 1시 45</em>분.`,
	mww: html`Sau cov sij hawm nrog AM lossis PM hauv 15 feeb nce ntxiv. Piv txwv: <em>10a</em>, <em>9p</em>, <em>9:15am</em>, <em>12:30pm</em>, <em>1.45pm</em>.`,
	ps: html`د AM یا PM وختونه په ۱۵ دقیقو کې داخل کړئ. بیلګې: <em>۱۰ بجې</em>، <em>۹ بجې</em>، <em>۹:۱۵ سهار</em>، <em>۱۲:۳۰ غرمه</em>، <em>۱:۴۵ ماسپښین</em>.`,
	pt: html`Insira os horários com AM ou PM em incrementos de 15 minutos. Exemplos: <em>10h</em>, <em>21h</em>, <em>9h15h</em>, <em>12h30</em>, <em>13h45</em>.`,
	'pt-pt': html`Insira os horários com AM ou PM em incrementos de 15 minutos. Exemplos: <em>10h</em>, <em>21h</em>, <em>9h15h</em>, <em>12h30</em>, <em>13h45</em>.`,
	ru: html`Вводите время с утра или вечером с интервалами по 15 минут. Примеры: <em>10:</em>00, <em>9:</em><em>15</em>, <em>12:30</em>, <em>13:45</em>.`,
	sm: html`Ulufale taimi i le AM po'o le PM i le 15-minute fa'aopoopoga. Fa'ata'ita'iga: <em>10a</em>, <em>9p</em>, <em>9:15am</em>, <em>12:30pm</em>, <em>1.45pm</em>.`,
	so: html`Geli waqtiyada subaxnimo ama galabnimo 15-daqiiqo ah. Tusaalooyin: <em>10 subaxnimo</em>, <em>9 galabnimo</em>, <em>9:15 subaxnimo</em>, <em>12:30 duhurnimo</em>, <em>1:45 duhurnimo</em>.`,
	th: html`ป้อนเวลาด้วย AM หรือ PM โดยเพิ่มทีละ 15 นาที ตัวอย่าง: <em>10a</em>, <em>9p</em>, <em>9:15 น</em>., <em>12:30 น</em>., <em>13.45 น</em>.`,
	ur: html`صبح یا شام کے اوقات 15 منٹ کے وقفوں میں درج کریں۔ مثالیں: <em>صبح 10</em>، <em>9 بجے</em>، <em>9:15 بجے</em>، <em>12:30 دوپہر</em>، <em>1:45 دوپہر</em>۔`,
	vi: html`Nhập thời gian với AM hoặc PM theo gia số 15 phút. Ví dụ: <em>10a</em>, <em>9p</em>, <em>9:15 sáng</em>, <em>12:30 trưa</em>, <em>1:45 chiều</em>.`,
	'zh-hans': html`请以15分钟为单位输入上午或下午时间。例如：<em>上午10</em>点、<em>晚上9</em><em>点、上午9点15</em>分、<em>中午12点30</em>分、<em>下午1点45</em>分。`,
	'zh-hant': html`請以 15 分鐘為單位輸入 AM 或 PM 時段。例如：<em>上午10</em>點、<em>晚上9</em><em>點、上午9點15</em>分、<em>中午12點30</em>分、<em>下午1點45</em>分。`,
	en: html`Enter times with AM or PM in 15-minute increments. Examples: <em>10a</em>, <em>9p</em>, <em>9:15am</em>, <em>12:30pm</em>, <em>1.45pm</em>.`
};

export const loc_timesheetEntryRequired: Record<Locale, string> = {
	ar: `يشترط دخول مرة واحدة على الأقل. لا يمكن تقديم أو الموافقة على جداول الساعات التي تحتوي على ساعات صفرية.`,
	de: `Mindestens eine einmalige Teilnahme ist erforderlich. Stundenzettel mit null Stunden können nicht eingereicht oder genehmigt werden.`,
	es: `Se requiere al menos una entrada puntual. No se pueden enviar ni aprobar hojas de horas sin horas.`,
	fa: `حداقل یک بار ورود به صورت یک باره الزامی است. برگه های ساعت کاری بدون ساعت قابل ارسال یا تأیید نیستند.`,
	fil: `Kinakailangan ng hindi bababa sa isang beses na pagpasok. Ang mga timesheet na may zero na oras ay hindi maaaring isumite o maaprubahan.`,
	fr: `Au moins une entrée unique est requise. Les feuilles de temps sans aucune heure ne peuvent pas être soumises ni approuvées.`,
	hi: `कम से कम एक बार प्रविष्टि की आवश्यकता है। शून्य घंटे वाली टाइमशीट सबमिट या अनुमोदित नहीं की जा सकती.`,
	ht: `Omwen yon sèl fwa antre obligatwa. Timesheets ak zèwo èdtan pa ka soumèt oswa apwouve.`,
	it: `È richiesta almeno una partecipazione puntuale. I fogli presenze con zero ore non possono essere inviati o approvati.`,
	ja: `少なくとも一度は参加が必要です。時間がゼロのタイムシートは提出または承認できません。`,
	ko: `최소 한 번의 출전 절차가 필요합니다. 근무 시간이 0인 타임시트는 제출하거나 승인할 수 없습니다.`,
	mww: `Yuav tsum tau nkag tsawg kawg ib zaug. Cov sij hawm uas tsis muaj xoom teev xa tsis tau los yog pom zoo tsis tau.`,
	ps: `لږ تر لږه یو ځل داخلېدل اړین دی. د صفر ساعتونو ټایم شیټونه نه شی سپارل کېدای او نه تصویب کېدای شی.`,
	pt: `É necessário pelo menos uma inscrição em horário único. Folhas de ponto com zero horas não podem ser enviadas ou aprovadas.`,
	'pt-pt': `É obrigatório pelo menos uma entrada pontual. Folhas de ponto com zero horas não podem ser submetidas nem aprovadas.`,
	ru: `Требуется хотя бы один раз. Табели рабочего времени с нулем часов не могут быть представлены или утверждены.`,
	sm: `E mana'omia le itiiti ifo ma le tasi le taimi e ulufale ai. E le mafai ona auina atu pe faamaonia ia pepa o taimi e leai ni itula.`,
	so: `Ugu yaraan hal mar ayaa loo baahan yahay in la geliyo. Waqtiyada leh saacado eber lama gudbin karo ama lama ansixin karo.`,
	th: `ต้องเข้าอย่างน้อยหนึ่งครั้ง ไม่สามารถส่งหรืออนุมัติไทม์ชีทที่มีชั่วโมงเป็นศูนย์ได้`,
	ur: `کم از کم ایک بار انٹری ضروری ہے۔ زیرو آورز والی ٹائم شیٹس جمع کرائی یا منظور نہیں کی جا سکتیں۔`,
	vi: `Cần có ít nhất một lần nhập cảnh. Bảng chấm công không có giờ không thể được gửi hoặc phê duyệt.`,
	'zh-hans': `至少需要一次入场。工时为零的工时表不能提交或批准。`,
	'zh-hant': `至少需參加一次。工時為零的工時表無法提交或核准。`,
	en: `At least one time entry is required. Timesheets with zero hours cannot be submitted or approved.`
};

export const loc_timesheetErrorsMessageFormat: Record<Locale, (duration: unknown) => TemplateResult> = {
	ar: (duration) => html`الإدخالات التي تبلغ مدتها ${duration} تحتوي على أخطاء ولا يمكن دفع أجورها حتى يتم تصحيحها. راجع الأخطاء أدناه، ثم <a href="?edit">عدل جدول الأوقات</a> لتصحيحها. <strong>لا تؤخر تقديم جدول الأوقات بسبب هذه الأخطاء. قدمه في الوقت المحدد، ثم تواصل مع ممثل وكالتك في أقرب وقت ممكن لتصحيح الأخطاء.</strong>`,
	de: (duration) => html`Einträge mit einer Gesamtlaufzeit ${duration} enthalten Fehler und können erst bezahlt werden, wenn sie korrigiert wurden. Überprüfen Sie die untenstehenden Fehler und <a href="?edit">bearbeiten Sie dann den Stundenzettel</a> , um sie zu korrigieren. <strong>Zögern Sie nicht mit der Einreichung Ihres Stundenzettels wegen dieser Fehler. Reichen Sie ihn pünktlich ein und kontaktieren Sie dann so schnell wie möglich Ihren Vertreter der Agentur, um die Fehler korrigieren zu lassen.</strong>`,
	es: (duration) => html`Las entradas que suman ${duration} tienen errores y no pueden pagarse hasta que se corrigan. Revisa los errores a continuación y <a href="?edit">luego edita la hoja de horas</a> para corregirlos. <strong>No retrases la presentación de tu hoja de horas por estos errores. Envíala a tiempo y luego contacta con tu representante de la agencia lo antes posible para que los corrija.</strong>`,
	fa: (duration) => html`ورودی هایی که مجموعا ${duration} طول می کشند دارای خطا هستند و تا زمانی که اصلاح نشوند، قابل پرداخت نیستند. خطاهای زیر را مرور کنید و سپس <a href="?edit">جدول زمان</a> بندی را ویرایش کنید تا اصلاح شوند. به <strong>خاطر این خطاها ارسال برگه زمان بندی خود را به تأخیر نیندازید. آن را به موقع ارسال کنید و سپس هرچه سریع تر با نماینده آژانس خود تماس بگیرید تا اشتباهات اصلاح شود.</strong>`,
	fil: (duration) => html`Ang mga entry na may kabuuang ${duration} ay may mga error at hindi maaaring bayaran hangga't hindi ito naitama. Suriin ang mga error sa ibaba, pagkatapos ay <a href="?edit">i-edit ang timesheet</a> upang ayusin ang mga ito. <strong>Huwag ipagpaliban ang pagsusumite ng iyong timesheet dahil sa mga error na ito. Isumite ito sa tamang oras, pagkatapos ay kontakin ang kinatawan ng iyong ahensya sa lalong madaling panahon upang maitama ang mga error.</strong>`,
	fr: (duration) => html`Les entrées ${duration} comportent des erreurs et ne peuvent être payées tant qu’elles n’ont pas été corrigées. Examinez les erreurs ci-dessous, puis <a href="?edit">modifiez la feuille de temps</a> pour les corriger. <strong>Ne retardez pas la soumission de votre feuille de temps à cause de ces erreurs. Soumettez-la à temps, puis contactez votre représentant d’agence dès que possible pour corriger les erreurs.</strong>`,
	hi: (duration) => html`कुल ${duration} की प्रविष्टियों में त्रुटियां हैं और उन्हें ठीक किए जाने तक भुगतान नहीं किया जा सकता है। नीचे दी गई त्रुटियों की समीक्षा करें, फिर उन्हें ठीक करने <a href="?edit">के लिए टाइमशीट संपादित करें</a> । <strong>इन त्रुटियों के कारण अपनी टाइमशीट सबमिट करने में देरी न करें। इसे समय पर सबमिट करें, फिर त्रुटियों को ठीक करने के लिए जितनी जल्दी हो सके अपने एजेंसी प्रतिनिधि से संपर्क करें।</strong>`,
	ht: (duration) => html`Antre ki totalize ${duration} gen erè epi yo pa ka peye jiskaske yo korije. Revize erè ki anba a, Lè sa a, <a href="?edit">modifye Fèy tan an</a> pou ranje yo. <strong>Pa reta soumèt Fèy tan ou paske nan erè sa yo. Soumèt li alè, Lè sa a, kontakte reprezantan ajans ou a pi vit ke posib yo korije erè yo.</strong>`,
	it: (duration) => html`Le voci per un totale ${duration} presentano errori e non possono essere pagate finché non vengono corrette. Rivedi gli errori qui sotto, poi <a href="?edit">modifica il foglio presenze</a> per correggerli. <strong>Non ritardare l'invio del foglio presenze a causa di questi errori. Consegnalo puntualmente, poi contatta il rappresentante della tua agenzia il prima possibile per correggere gli errori.</strong>`,
	ja: (duration) => html`合計 ${duration} のエントリーには誤りがあり、修正されるまで支払いができません。以下の誤りを確認し、タイム <a href="?edit">シートを修正</a> してください。 <strong>これらの誤りのためにタイムシートの提出を遅らせないでください。期限内に提出し、できるだけ早く代理店の担当者に連絡して誤りを修正してください。</strong>`,
	ko: (duration) => html`총 ${duration} 분량의 입력 기록에는 오류가 있으며, 수정될 때까지 지급할 수 없습니다. 아래의 오류를 검토한 후 <a href="?edit">타임시트를 수정</a> 해 수정하세요. <strong>이러한 오류 때문에 타임시트 제출을 미루지 마세요. 제때 제출한 후 가능한 한 빨리 에이전시 담당자에게 연락하여 오류를 수정받으시기 바랍니다.</strong>`,
	mww: (duration) => html`Cov ntawv sau tag nrho ${duration} muaj kev yuam kev thiab tsis tuaj yeem them nyiaj kom txog thaum lawv raug kho. Xyuas cov yuam kev hauv qab no, tom qab ntawd <a href="?edit">kho daim ntawv sijhawm</a> kom kho tau. <strong>Tsis txhob ncua sijhawm xa koj daim ntawv sijhawm vim cov yuam kev no. Xa nws raws sijhawm, tom qab ntawd hu rau koj tus neeg sawv cev ntawm koj lub koom haum sai li sai tau kom kho cov yuam kev.</strong>`,
	ps: (duration) => html`ټولټال ${duration} لیکنې تېروتنې لری او تر هغه وخته پورې پیسې نه شی ورکول کېدای چې اصلاح شی. لاندې تېروتنې وګورئ، بیا <a href="?edit">د وخت پاڼه سم</a> کړئ ترڅو اصلاح یې کړئ. د <strong>دې تېروتنو له امله خپل وخت پاڼه مه ځنډوئ. پر وخت یې وسپارئ، بیا ژر تر ژره د خپلې ادارې استازی سره اړیکه ونیسئ ترڅو تېروتنې اصلاح شی.</strong>`,
	pt: (duration) => html`Entradas ${duration} apresentam erros e não podem ser pagas até serem corrigidas. Revise os erros abaixo e <a href="?edit">depois edite a folha de ponto</a> para corrigi-los. <strong>Não atrase o envio da sua folha de ponto por causa desses erros. Envie-a no prazo e entre em contato com o representante da agência o quanto antes para corrigir os erros.</strong>`,
	'pt-pt': (duration) => html`Entradas com ${duration} apresentam erros e não podem ser pagas até serem corrigidas. Revise os erros abaixo e <a href="?edit">depois edite a folha de horas</a> para os corrigir. <strong>Não atrase a entrega da sua folha de horas devido a esses erros. Submeta-a a tempo e contacte o representante da sua agência o mais rapidamente possível para corrigir os erros.</strong>`,
	ru: (duration) => html`Записи общей ${duration} минут содержат ошибки и не могут быть оплачены до их исправления. Ознакомьтесь с ошибками ниже, затем <a href="?edit">отредактируйте табель</a>, чтобы их исправить. <strong>Не откладывайте отправку табеля из-за этих ошибок. Отправляйте его вовремя, а затем как можно скорее свяжитесь с представителем агентства, чтобы исправить ошибки</strong>.`,
	sm: (duration) => html`O fa'amatalaga e ${duration} o lo'o i ai ni mea sese ma e le mafai ona totogiina se'i vagana ua fa'asa'oina. Toe iloilo mea sese o lo'o i lalo, ona <a href="?edit">fa'asa'o lea o le pepa o taimi e fa'asa'o</a> ai. <strong>Aua le fa'atuai le tu'uina atu o lau pepa o taimi ona o nei mea sese. Auina atu i le taimi sa'o, ona fa'afeso'ota'i lea o lau sui ofisa i se taimi vave e mafai ai e fa'asa'o mea sese.</strong>`,
	so: (duration) => html`Qoraallada wadarta ${duration} waxay leeyihiin khaladaad mana la bixin karo ilaa la saxo. Dib u eeg khaladaadka hoose, kadibna <a href="?edit">wax ka beddel jadwalka</a> waqtiga si aad u saxdo. <strong>Ha dib u dhigin gudbinta jadwalka waqtigaaga sababo la xiriira khaladaadkan. Soo gudbi waqtiga waqtiga, kadibna la xiriir wakiilka hay'addaada sida ugu dhaqsaha badan si khaladaadka loo saxo.</strong>`,
	th: (duration) => html`บันทึกที่มีความยาวรวม ${duration} จะมีข้อผิดพลาดและไม่สามารถจ่ายเงินได้จนกว่าจะได้รับการแก้ไขตรวจสอบข้อผิดพลาดด้านล่าง จากนั้น <a href="?edit">แก้ไขตารางเวลา</a> เพื่อแก้ไข <strong>อย่าล่าช้าในการส่งบันทึกเวลาเพราะข้อผิดพลาดเหล่านี้ส่งตรงเวลา จากนั้นติดต่อตัวแทนของบริษัทโดยเร็วที่สุดเพื่อแก้ไขข้อผิดพลาด</strong>`,
	ur: (duration) => html`${duration} کی اندراجات میں غلطیاں ہوتی ہیں اور انہیں درست کیے بغیر ادائیگی نہیں کی جا سکتی۔ نیچے دی گئی غلطیوں کا جائزہ لیں، پھر انہیں درست کرنے کے لیے <a href="?edit">ٹائم شیٹ میں ترمیم</a> کریں۔ <strong>ان غلطیوں کی وجہ سے اپنی ٹائم شیٹ جمع کروانے میں تاخیر نہ کریں۔ وقت پر جمع کرواؤ، پھر جلد از جلد اپنی ایجنسی کے نمائندے سے رابطہ کریں تاکہ غلطیاں درست کی جا</strong> سکیں۔`,
	vi: (duration) => html`Các mục ghi tổng cộng ${duration} đều có lỗi và không thể thanh toán cho đến khi được sửa. Xem lại các lỗi bên dưới, sau đó <a href="?edit">chỉnh sửa bảng chấm công</a> để khắc phục. <strong>Đừng trì hoãn việc nộp bảng chấm công chỉ vì những lỗi này. Nộp đúng hạn, sau đó liên hệ với đại diện đại lý càng sớm càng tốt để sửa lỗi.</strong>`,
	'zh-hans': (duration) => html`总计6 ${duration} 的记录存在错误，且在纠正前无法支付。请查看下面的错误，然后 <a href="?edit">编辑工时表</a> 进行修正。 <strong>不要因为这些错误而拖延提交工时表。按时提交，然后尽快联系你的机构代表，要求纠正错误。</strong>`,
	'zh-hant': (duration) => html`總計 ${duration} 的報案有錯誤，且在修正前無法支付。請檢視以下錯誤，然後 <a href="?edit">編輯工時表</a> 修正。 <strong>切勿因這些錯誤而延遲提交工時表。準時提交，然後盡快聯絡你的代理代表，請他們更正錯誤。</strong>`,
	en: (duration) => html`Entries totaling ${duration} have errors and cannot be paid until they are corrected. Review the errors below, then <a href="?edit">edit the timesheet</a> to fix them. <strong>Do not delay submitting your timesheet because of these errors. Submit it on time, then contact your agency representative as soon as possible to have the errors corrected.</strong>`
};

export const loc_timesheetExistsMessage: Record<Locale, string> = {
	ar: `جدول زمني لهذه الفترة موجود بالفعل. لا يسمح بوجود عدة جداول زمنية لنفس الفترة.`,
	de: `Ein Stundenzettel für diesen Abrechnungszeitraum existiert bereits. Mehrere Stundenzettel für denselben Zeitraum sind nicht erlaubt.`,
	es: `Ya existe una hoja de horas para este periodo de pago. No se permiten múltiples hojas de horas para el mismo periodo.`,
	fa: `یک جدول زمانی برای این دوره پرداخت قبلا وجود دارد. چندین برگه زمان برای یک دوره زمانی مجاز نیست.`,
	fil: `Umiiral na ang timesheet para sa pay period na ito. Hindi pinapayagan ang maramihang mga timesheet para sa parehong panahon.`,
	fr: `Une feuille de temps pour cette période de paie existe déjà. Plusieurs feuilles de temps pour la même période ne sont pas autorisées.`,
	hi: `इस वेतन अवधि के लिए एक समय पत्रक पहले से मौजूद है। एक ही अवधि के लिए एकाधिक टाइमशीट की अनुमति नहीं है।`,
	ht: `Yon fèy tan pou peryòd peman sa a deja egziste. Fich tan miltip pou menm peryòd la pa pèmèt.`,
	it: `Esiste già un foglio di pagamento per questo periodo di paga. Non è consentito avere più fogli orario per lo stesso periodo.`,
	ja: `この給与期間のタイムシートはすでに存在します。同じ期間の複数のタイムシートは許可されていません。`,
	ko: `이 급여 기간에 대한 근무 시간표는 이미 존재합니다. 같은 기간에 대해 여러 개의 근무 시간표를 작성하는 것은 허용되지 않습니다.`,
	mww: `Ib daim ntawv qhia txog lub sijhawm them nyiaj no twb muaj lawm. Tsis pub muaj ntau daim ntawv teev sij hawm rau tib lub sijhawm.`,
	ps: `د دې معاش مودې لپاره وخت پاڼه لا دمخه شته. د یوې مودې لپاره څو وخت پاڼې اجازه نه لری.`,
	pt: `Já existe uma folha de ponto para esse período de pagamento. Não é permitido usar múltiplos folhas de ponto para o mesmo período.`,
	'pt-pt': `Já existe uma folha de horas para este período de pagamento. Não é permitido usar várias folhas de ponto para o mesmo período.`,
	ru: `Табель рабочего времени для этого платёжного периода уже существует. Несколько табелей рабочего времени за один и тот же период не допускаются.`,
	sm: `Ua uma ona i ai se pepa o taimi mo lenei vaitau o totogi. E le fa'atagaina le tele o taimi mo le vaitaimi lava e tasi.`,
	so: `Jadwalka waqtiga mushaharkan hore ayaa jira. Jadwalka waqtiyada badan ee isla muddadaas lama oggola.`,
	th: `มีไทม์ชีทสําหรับรอบระยะเวลาการจ่ายเงินนี้อยู่แล้ว ไม่อนุญาตให้ใช้แผ่นเวลาหลายแผ่นในช่วงเวลาเดียวกัน`,
	ur: `اس تنخواہ کی مدت کے لیے ایک ٹائم شیٹ پہلے سے موجود ہے۔ ایک ہی مدت کے لیے متعدد ٹائم شیٹس کی اجازت نہیں ہے۔`,
	vi: `Bảng chấm công cho kỳ trả lương này đã tồn tại. Không được phép sử dụng nhiều bảng chấm công trong cùng một khoảng thời gian.`,
	'zh-hans': `该工资期的工时表已经存在。同一期间不允许填写多份工时表。`,
	'zh-hant': `這個薪資期的工時表已經存在。同一期間不允許多份工時表。`,
	en: `A timesheet for this pay period already exists. Multiple timesheets for the same period are not allowed.`
};

export const loc_timesheetNoLongerEditableMessage: Record<Locale, string> = {
	ar: `لم تحفظ تغييراتك لأن هذه الورقة الزمنية لم تعد في حالة المسودة. قد تكون تغيرت بعد فتح هذه الصفحة. قم بتحديث الصفحة لعرض حالتها الحالية.`,
	de: `Ihre Änderungen wurden nicht gespeichert, da dieser Stundenzettel nicht mehr im Entwurfsstatus ist. Er könnte sich geändert haben, nachdem Sie diese Seite geöffnet haben. Aktualisieren Sie die Seite, um ihren aktuellen Status anzuzeigen.`,
	es: `Tus cambios no se guardaron porque esta hoja de horas ya no está en estado de borrador. Puede que haya cambiado después de que abrieras esta página. Actualiza la página para ver su estado actual.`,
	fa: `تغییرات شما ذخیره نشده اند چون این برگه زمان دیگر در وضعیت پیش نویس نیست. ممکن است پس از باز کردن این صفحه تغییر کرده باشد. صفحه را تازه کنید تا وضعیت فعلی آن را مشاهده کنید.`,
	fil: `Hindi na-save ang iyong mga pagbabago dahil ang timesheet na ito ay wala na sa draft status. Maaaring nagbago ito matapos mong buksan ang pahinang ito. I-refresh ang pahina upang makita ang kasalukuyang status nito.`,
	fr: `Vos modifications n’ont pas été sauvegardées car cette feuille de temps n’est plus en statut de brouillon. Elle a peut-être changé après l’ouverture de cette page. Rafraîchissez la page pour voir son statut actuel.`,
	hi: `आपके परिवर्तन सहेजे नहीं गए थे क्योंकि यह समयपत्रक अब ड्राफ़्ट स्थिति में नहीं है. हो सकता है कि यह पृष्ठ खोलने के बाद परिवर्तित हो गया हो. पृष्ठ की वर्तमान स्थिति देखने के लिए उसे ताज़ा करें.`,
	ht: `Chanjman ou yo pa t sove paske Fèy delè sa a pa nan estati bouyon ankò. Li ka chanje apre ou louvri paj sa a. Rafrechi paj la pou wè estati li ye kounye a.`,
	it: `Le tue modifiche non sono state salvate perché questo foglio orario non è più in stato di bozza. Potrebbe essere cambiato dopo che hai aperto questa pagina. Aggiorna la pagina per visualizzare lo stato attuale.`,
	ja: `変更が保存されていないのは、このタイムシートがドラフト状態からなくなったためです。このページを開いた後に変更された可能性があります。ページを更新して現在のステータスを確認してください。`,
	ko: `변경 사항이 저장되지 않은 이유는 이 타임시트가 더 이상 초안 상태가 아니기 때문입니다. 이 페이지를 열었을 때 변경되었을 수도 있습니다. 페이지를 새로고침하여 현재 상태를 확인하세요.`,
	mww: `Koj cov kev hloov tsis tau khaws cia vim daim ntawv sijhawm no tsis nyob hauv qhov xwm txheej draft lawm. Tej zaum nws tau hloov tom qab koj qhib nplooj ntawv no. Rov kho nplooj ntawv kom pom nws qhov xwm txheej tam sim no.`,
	ps: `ستاسو بدلونونه خوندی نه شول ځکه چې دا ټایم شیټ نور د مسودې حالت کې نه دی. کېدای شی دا له هغه وروسته بدل شوی وی چې تاسو دا پاڼه خلاصه کړه. پاڼه تازه کړئ ترڅو اوسنی حالت ووینی.`,
	pt: `Suas alterações não foram salvas porque essa folha de ponto não está mais em status de rascunho. Pode ter mudado depois que você abriu esta página. Atualize a página para ver seu status atual.`,
	'pt-pt': `As suas alterações não foram guardadas porque esta folha de horas já não está em estado de rascunho. Pode ter mudado depois de abrir esta página. Atualize a página para ver o seu estado atual.`,
	ru: `Ваши изменения не были сохранены, потому что этот табель времени больше не находится в черновике. Возможно, он изменился после открытия этой страницы. Обновите страницу, чтобы увидеть её текущий статус.`,
	sm: `E le'i sefeina au suiga ona o lenei pepa o taimi e le o toe i ai i le tulaga o le fa'ata'ita'iga. Atonu na suia ina ua uma ona e tatalaina lenei itulau. Fa'afouina le itulau e va'ai ai i lona tulaga o lo'o i ai nei.`,
	so: `Isbeddelladaada lama keydinin sababtoo ah jadwalkan waqtigan hadda ma jiro qoraal cusub. Waxaa laga yaabaa inuu isbeddelay ka dib markii aad boggan furtay. Cusbooneysii bogga si aad u aragto xaaladdiisa hadda.`,
	th: `การเปลี่ยนแปลงของคุณไม่ได้ถูกบันทึกเนื่องจากแผ่นเวลานี้ไม่ได้อยู่ในสถานะร่างอีกต่อไปอาจมีการเปลี่ยนแปลงหลังจากที่คุณเปิดหน้านี้รีเฟรชหน้าเพื่อดูสถานะปัจจุบัน`,
	ur: `آپ کی تبدیلیاں محفوظ نہیں ہوئیں کیونکہ یہ ٹائم شیٹ اب ڈرافٹ اسٹیٹس میں نہیں ہے۔ ممکن ہے کہ یہ آپ کے اس صفحے کو کھولنے کے بعد بدل گئی ہو۔ صفحہ کو تازہ کریں تاکہ اس کی موجودہ حالت دیکھ سکیں۔`,
	vi: `Các thay đổi của bạn không được lưu vì bảng chấm công này không còn ở trạng thái bản nháp. Có thể nó đã thay đổi sau khi bạn mở trang này. Làm mới trang để xem trạng thái hiện tại.`,
	'zh-hans': `你的更改未被保存，因为该工时表已不再处于草稿状态。它可能在你打开此页面后发生了变化。刷新页面以查看其当前状态。`,
	'zh-hant': `您的變更未被儲存，因為此工時表已不再處於草稿狀態。您開啟此頁面後，變更可能已發生變更。重新整理頁面以查看其目前狀態。`,
	en: `Your changes were not saved because this timesheet is no longer in draft status. It may have changed after you opened this page. Refresh the page to view its current status.`
};

export const loc_timesheets: Record<Locale, string> = {
	ar: `جداول زمنية`,
	de: `Stundenzettel`,
	es: `Hojas de horas`,
	fa: `جدول های زمانی`,
	fil: `Mga Timesheet`,
	fr: `Feuilles de temps`,
	hi: `समय पत्रक`,
	ht: `Timesheets`,
	it: `Fogli temporali`,
	ja: `タイムシート`,
	ko: `타임시트`,
	mww: `Cov ntawv teev sijhawm`,
	ps: `د وخت پاڼې`,
	pt: `Folhas de ponto`,
	'pt-pt': `Folhas de horas`,
	ru: `Табели рабочего времени`,
	sm: `Pepa o taimi`,
	so: `Jadwalka Waqtiga`,
	th: `ไทม์ชีท`,
	ur: `ٹائم شیٹس`,
	vi: `Bảng chấm công`,
	'zh-hans': `时间表`,
	'zh-hant': `工時表`,
	en: `Timesheets`
};

export const loc_timesheetSubmissionInstructionsFormat: Record<Locale, (days: unknown) => string> = {
	ar: (days) => `تنتهي فترة الدفع بعد ${days}. انتظر حتى يتم إدخال جميع ساعات فترة الدفع الكاملة قبل التقديم. يسمح فقط بوجود جدول زمني واحد لكل موظف في كل فترة راتب.`,
	de: (days) => `Die Abrechnungsperiode endet in ${days}. Warte, bis alle Stunden des vollen Abrechnungszeitraums eingetragen wurden, bevor du einreichst. Es ist pro Gehaltsperiode nur ein Stundenzettel pro Mitarbeiter erlaubt.`,
	es: (days) => `El periodo de pago termina en ${days}. Espera a que se hayan introducido todas las horas del periodo completo de pago antes de enviar. Solo se permite una hoja de horas por empleado por periodo de pago.`,
	fa: (days) => `دوره پرداخت در ${days} به پایان می رسد. صبر کنید تا تمام ساعات دوره پرداخت کامل وارد شود و سپس ارسال کنید. فقط یک برگه زمانی برای هر کارمند در هر دوره پرداخت مجاز است.`,
	fil: (days) => `Ang panahon ng sweldo ay magtatapos sa ${days}. Maghintay hanggang sa maipasok ang lahat ng oras para sa buong panahon ng suweldo bago isumite. Isang timesheet lamang ang pinapayagan sa bawat empleyado sa bawat panahon ng suweldo.`,
	fr: (days) => `La période de paie se termine dans ${days}. Attendez que toutes les heures de la période de paie complète soient entrées avant de soumettre. Une seule feuille de temps par employé par période de paie est autorisée.`,
	hi: (days) => `वेतन अवधि ${days} में समाप्त हो जाती है। जमा करने से पहले पूर्ण वेतन अवधि के लिए सभी घंटे दर्ज किए जाने तक प्रतीक्षा करें। प्रति कर्मचारी प्रति वेतन अवधि केवल एक टाइमशीट की अनुमति है।`,
	ht: (days) => `Peryòd peman an fini nan ${days}. Tann jiskaske tout èdtan pou peryòd peman konplè a antre anvan ou soumèt Se sèlman yon Fèy tan pou chak anplwaye pou chak peryòd peman pèmèt.`,
	it: (days) => `Il periodo di paga termina tra ${days}. Aspetta che tutte le ore dell'intero periodo di paga siano state inserite prima di inviare. È consentito solo un foglio presenze per dipendente per periodo di paga.`,
	ja: (days) => `給与期間は ${days}に終了します。全給与期間のすべての勤務時間を入力し終えるまで、提出を待ちましょう。給与期間ごとに従業員1人あたりのタイムシートは1枚までしか許可されていません。`,
	ko: (days) => `급여 기간은 ${days} 후에 종료됩니다. 전체 급여 기간의 모든 시간을 입력한 후 제출하세요. 급여 기간당 직원당 한 장의 근무 시간표만 허용됩니다.`,
	mww: (days) => `Lub sijhawm them nyiaj xaus rau ${days}. Tos kom txog thaum tag nrho cov xuab moos rau lub sijhawm them tag nrho tau nkag mus ua ntej xa mus. Tsuas tso cai rau ib daim ntawv teev sijhawm rau ib tus neeg ua haujlwm rau ib lub sijhawm them nyiaj.`,
	ps: (days) => `د معاش موده په ${days} کې پای ته رسیږی. تر هغه وخته انتظار وکړئ چې د بشپړ معاش موده ټول ساعتونه ثبت شی، بیا یې سپارل وکړئ. هر کارکوونکی ته په هر معاش موده کې یوازې یو وخت پاڼه اجازه لری.`,
	pt: (days) => `O período de pagamento termina em ${days}. Espere até que todas as horas do período completo de pagamento sejam inseridas antes de enviar. Apenas uma folha de ponto por funcionário por período de pagamento é permitida.`,
	'pt-pt': (days) => `O período de pagamento termina em ${days}. Espere até que todas as horas do período completo de pagamento tenham sido introduzidas antes de submeter. Apenas uma folha de horas por funcionário por período de pagamento é permitida.`,
	ru: (days) => `Платёжный период заканчивается ${days}. Подождите, пока не будут введены все часы полного платёжного периода, прежде чем отправлять заявку. На каждого сотрудника разрешено иметь только один табель рабочего времени за каждый платёжный период.`,
	sm: (days) => `O le vaitaimi o le totogi e fa'amutaina i totonu o ${days}. Faatali seia oo ina taina i totonu itula uma mo le vaitau atoa o le totogi a o lei auina atu. E na'o le tasi le taimi mo le tagata faigaluega i le vaitaimi totogi e fa'atagaina.`,
	so: (days) => `Muddada mushaharka waxay ku dhammaanaysaa ${days} gudahood. Sug ilaa saacadaha oo dhan ee muddada mushaarka buuxa la geliyo ka hor intaadan gudbin. Kaliya hal xaashi waqti oo shaqaale ah ayaa la oggol yahay xilliga mushaharka.`,
	th: (days) => `ระยะเวลาการจ่ายเงินจะสิ้นสุดใน ${days} รอจนกว่าจะป้อนระยะเวลาการจ่ายเงินเต็มจํานวนก่อนส่ง อนุญาตให้ใช้แผ่นเวลาหนึ่งแผ่นต่อพนักงานต่อรอบระยะเวลาการจ่ายเงินเท่านั้น`,
	ur: (days) => `تنخواہ کی مدت ${days} میں ختم ہو جاتی ہے۔ مکمل ادائیگی کی مدت کے تمام گھنٹے داخل ہونے تک انتظار کریں، پھر جمع کروائیں۔ فی ملازم فی تنخواہ کی مدت میں صرف ایک ٹائم شیٹ کی اجازت ہے۔`,
	vi: (days) => `Thời hạn trả lương kết thúc sau ${days}. Chờ cho đến khi tất cả các giờ để nhập đầy đủ thời hạn thanh toán trước khi gửi. Chỉ cho phép một bảng chấm công cho mỗi nhân viên trong mỗi kỳ trả lương.`,
	'zh-hans': (days) => `发薪期将在 ${days}后结束。请等所有工资周期的工时都填写完毕后再提交。每个工资周期每位员工只能填写一份工时表。`,
	'zh-hant': (days) => `薪資期還有 ${days}就結束了。請等所有薪資期間的工時都輸入完畢後再提交。每個薪資期每位員工只允許一張工時表。`,
	en: (days) => `The pay period ends in ${days}. Wait until all hours for the full pay period have been entered before submitting. Only one timesheet per employee per pay period is allowed.`
};

export const loc_title: Record<Locale, string> = {
	ar: `العنوان`,
	de: `Titel`,
	es: `Título`,
	fa: `عنوان`,
	fil: `Pamagat`,
	fr: `Titre`,
	hi: `शीर्षक`,
	ht: `Title`,
	it: `Titolo`,
	ja: `タイトル`,
	ko: `제목`,
	mww: `Npe`,
	ps: `سرلیک`,
	pt: `Título`,
	'pt-pt': `Título`,
	ru: `Название`,
	sm: `Ulutala`,
	so: `Cinwaanka`,
	th: `ชื่อเรื่อง`,
	ur: `عنوان`,
	vi: `Tiêu đề`,
	'zh-hans': `标题`,
	'zh-hant': `標題`,
	en: `Title`
};

export const loc_toDate: Record<Locale, string> = {
	ar: `حتى الآن`,
	de: `Bis heute`,
	es: `Hasta la fecha`,
	fa: `تا به امروز`,
	fil: `Hanggang ngayon`,
	fr: `À ce jour`,
	hi: `आज तक`,
	ht: `Jiska dat`,
	it: `Ad oggi`,
	ja: `現在まで`,
	ko: `현재까지`,
	mww: `Txog rau hnub no`,
	ps: `تر اوسه`,
	pt: `Até o momento`,
	'pt-pt': `Até à data`,
	ru: `На сегодняшний день`,
	sm: `E oo mai i le taimi nei`,
	so: `Ilaa hadda`,
	th: `จนถึงปัจจุบัน`,
	ur: `اب تک`,
	vi: `Tính đến nay`,
	'zh-hans': `迄今为止`,
	'zh-hant': `至今`,
	en: `To date`
};

export const loc_toggleDropdown: Record<Locale, string> = {
	ar: `قائمة التبديل المنسدلة`,
	de: `Umschalt-Dropdown-Menü`,
	es: `Desplegable de alternancia`,
	fa: `کشویی تغییر وضعیت`,
	fil: `Toggle dropdown`,
	fr: `Menu déroulant à basculer`,
	hi: `ड्रॉपडाउन टॉगल करें`,
	ht: `Toggle dropdown`,
	it: `Menu a tendina toggle`,
	ja: `トグルドロップダウン`,
	ko: `토글 드롭다운`,
	mww: `Toggle dropdown`,
	ps: `د ټوګل ډراپ ډاون`,
	pt: `Menu suspenso para alternar`,
	'pt-pt': `Menu suspenso de alternar`,
	ru: `Выпадающее меню переключения`,
	sm: `Toggle dropdown`,
	so: `Toggle dropdown`,
	th: `สลับดรอปดาวน์`,
	ur: `ٹوگل ڈراپ ڈاؤن`,
	vi: `Chuyển đổi menu thả xuống`,
	'zh-hans': `切换下拉菜单`,
	'zh-hant': `切換下拉選單`,
	en: `Toggle dropdown`
};

export const loc_toggleSearch: Record<Locale, string> = {
	ar: `البحث في التبديل`,
	de: `Umschalt-Suche`,
	es: `Alternar búsqueda`,
	fa: `جستجوی تغییر وضعیت`,
	fil: `Email Address *`,
	fr: `Basculer la recherche`,
	hi: `खोज टॉगल करें`,
	ht: `Toggle rechèch`,
	it: `Ricerca a toggle`,
	ja: `トグル検索`,
	ko: `토글 검색`,
	mww: `Toggle nrhiav`,
	ps: `د ټوګل لټون`,
	pt: `Alternar busca`,
	'pt-pt': `Alternar pesquisa`,
	ru: `Поиск по переключению`,
	sm: `Toggle search`,
	so: `Raadinta beddelka`,
	th: `สลับการค้นหา`,
	ur: `ٹوگل سرچ`,
	vi: `Chuyển đổi tìm kiếm`,
	'zh-hans': `切换搜索`,
	'zh-hant': `切換搜尋`,
	en: `Toggle search`
};

export const loc_toggleSidebar: Record<Locale, string> = {
	ar: `تبديل الشريط الجانبي`,
	de: `Seitenleiste umschalten`,
	es: `Barra lateral alternar`,
	fa: `کلید کناری تغییر وضعیت`,
	fil: `I-toggle sidebar`,
	fr: `Barre-encadré basculante`,
	hi: `साइडबार टॉगल करें`,
	ht: `Toggle ankèt lateral`,
	it: `Barra laterale toggle`,
	ja: `サイドバーを切り替える`,
	ko: `토글 사이드바`,
	mww: `Toggle sidebar`,
	ps: `سایډبار ټوګل کړئ`,
	pt: `Barra lateral alternar`,
	'pt-pt': `Barra lateral de alternar`,
	ru: `Боковая панель переключения`,
	sm: `Toggle sidebar`,
	so: `Toggle sidebar`,
	th: `สลับแถบด้านข้าง`,
	ur: `سائیڈبار کو ٹوگل کریں`,
	vi: `Chuyển đổi thanh bên`,
	'zh-hans': `切换侧边栏`,
	'zh-hant': `切換側邊欄`,
	en: `Toggle sidebar`
};

export const loc_toggleStatusMenu: Record<Locale, string> = {
	ar: `تبديل قائمة الحالة`,
	de: `Statusmenü umschalten`,
	es: `Alternar menú de estado`,
	fa: `منوی وضعیت تغییر وضعیت`,
	fil: `I-toggle ang menu ng katayuan`,
	fr: `Basculer le menu d’état`,
	hi: `स्थिति मेनू टॉगल करें`,
	ht: `Toggle meni estati`,
	it: `Attiva il menu di stato`,
	ja: `ステータスメニューの切り替え`,
	ko: `상태 메뉴 토글`,
	mww: `Toggle cov xwm txheej ntawv qhia zaub mov`,
	ps: `د حالت مینو ټوګل کړئ`,
	pt: `Alternar menu de status`,
	'pt-pt': `Alternar menu de estado`,
	ru: `Меню переключения статуса`,
	sm: `Toggle status menu`,
	so: `Toggle status menu`,
	th: `สลับเมนูสถานะ`,
	ur: `ٹوگل اسٹیٹس مینو`,
	vi: `Chuyển đổi menu trạng thái`,
	'zh-hans': `切换状态菜单`,
	'zh-hant': `切換狀態選單`,
	en: `Toggle status menu`
};

export const loc_top: Record<Locale, string> = {
	ar: `الأعلى`,
	de: `Top`,
	es: `Arriba`,
	fa: `تاپ`,
	fil: `Tuktok`,
	fr: `Haut`,
	hi: `शीर्ष`,
	ht: `Tèt`,
	it: `Top`,
	ja: `トップ`,
	ko: `상단`,
	mww: `Sab saum toj`,
	ps: `پورته`,
	pt: `Topo`,
	'pt-pt': `Topo`,
	ru: `Верх`,
	sm: `Luga`,
	so: `Top`,
	th: `ด้านบน`,
	ur: `اوپر`,
	vi: `Đầu trang`,
	'zh-hans': `顶部`,
	'zh-hant': `頂端`,
	en: `Top`
};

export const loc_total: Record<Locale, string> = {
	ar: `المجموع`,
	de: `Gesamt`,
	es: `Total`,
	fa: `کل`,
	fil: `Kabuuang`,
	fr: `Total`,
	hi: `कुल`,
	ht: `Total`,
	it: `Totale`,
	ja: `合計`,
	ko: `총`,
	mww: `Tag Nrho`,
	ps: `ټول`,
	pt: `Total`,
	'pt-pt': `Total`,
	ru: `Total`,
	sm: `Aofai`,
	so: `Wadarta guud`,
	th: `รวม`,
	ur: `کل`,
	vi: `Tổng cộng`,
	'zh-hans': `总计`,
	'zh-hant': `總計`,
	en: `Total`
};

export const loc_totalHours: Record<Locale, string> = {
	ar: `إجمالي الساعات`,
	de: `Gesamtstunden`,
	es: `Horas totales`,
	fa: `کل ساعات کاری`,
	fil: `Kabuuang oras`,
	fr: `Heures totales`,
	hi: `कुल घंटे`,
	ht: `Total èdtan`,
	it: `Ore totali`,
	ja: `総労働時間`,
	ko: `총 근무 시간`,
	mww: `Tag nrho cov xuab moos`,
	ps: `ټول ساعتونه`,
	pt: `Horas totais`,
	'pt-pt': `Horas totais`,
	ru: `Общее количество часов`,
	sm: `Aofai o itula`,
	so: `Saacadaha guud`,
	th: `ชั่วโมงรวม`,
	ur: `کل اوقات`,
	vi: `Tổng số giờ`,
	'zh-hans': `总工时`,
	'zh-hant': `總工時`,
	en: `Total hours`
};

export const loc_totalSessions: Record<Locale, string> = {
	ar: `إجمالي الجلسات`,
	de: `Gesamtzahl der Sitzungen`,
	es: `Total de sesiones`,
	fa: `کل جلسات`,
	fil: `Kabuuang mga sesyon`,
	fr: `Total des sessions`,
	hi: `कुल सत्र`,
	ht: `Sesyon total`,
	it: `Totale delle sessioni`,
	ja: `総セッション数`,
	ko: `총 세션 수`,
	mww: `Tag nrho cov rooj sib tham`,
	ps: `ټول غونډې`,
	pt: `Total de sessões`,
	'pt-pt': `Total de sessões`,
	ru: `Общее количество сессий`,
	sm: `Aofai o sauniga`,
	so: `Wadarta kalfadhiyada`,
	th: `จํานวนเซสชันทั้งหมด`,
	ur: `کل سیشنز`,
	vi: `Tổng số phiên làm việc`,
	'zh-hans': `总场次`,
	'zh-hant': `總場次`,
	en: `Total sessions`
};

export const loc_totp: Record<Locale, string> = {
	ar: `كلمة المرور لمرة واحدة معتمدة على الزمن (TOTP)`,
	de: `Zeitbasiertes Einmalpasswort (TOTP)`,
	es: `Contraseña de un solo uso basada en el tiempo (TOTP)`,
	fa: `رمز عبور یک بار مصرف مبتنی بر زمان (TOTP)`,
	fil: `Time-based One-Time Password (TOTP)`,
	fr: `Mot de passe à usage unique basé sur le temps (TOTP)`,
	hi: `समय-आधारित वन-टाइम पासवर्ड (TOTP)`,
	ht: `Tan ki baze sou yon sèl-fwa modpas (TOTP)`,
	it: `Password Uniusa Basata sul Tempo (TOTP)`,
	ja: `時間ベースのワンタイムパスワード(TOTP)`,
	ko: `시간 기반 일회용 비밀번호(TOTP)`,
	mww: `Lub sij hawm raws li ib lub sij hawm lo lus zais (TOTP)`,
	ps: `د وخت پر بنسټ یو ځل رمز (TOTP)`,
	pt: `Senha Única Baseada em Tempo (TOTP)`,
	'pt-pt': `Palavra-passe única baseada no tempo (TOTP)`,
	ru: `Одноразовый пароль на основе времени (TOTP)`,
	sm: `Taimi Fa'avae Tasi-Taimi Fa'aupuga (TOTP)`,
	so: `Erayga Sirta Keliya ee Waqtiga ku saleysan (TOTP)`,
	th: `รหัสผ่านแบบใช้ครั้งเดียวตามเวลา (TOTP)`,
	ur: `وقت پر مبنی ایک وقتی پاس ورڈ (TOTP)`,
	vi: `Mật khẩu dùng một lần dựa trên thời gian (TOTP)`,
	'zh-hans': `基于时间的一次性密码（TOTP）`,
	'zh-hant': `基於時間的一次性密碼（TOTP）`,
	en: `Time-based One-Time Password (TOTP)`
};

export const loc_totpComplete: Record<Locale, string> = {
	ar: `اكتمل التسجيل في كلمة المرور الزمنية الواحدة (TOTP)!`,
	de: `Anmeldung zum zeitbasierten Einmalpasswort (TOTP) abgeschlossen!`,
	es: `¡Inscripción con la Contraseña de Un Solo Uso (TOTP) basada en tiempo completada!`,
	fa: `ثبت نام رمز عبور یک بار مصرف مبتنی بر زمان (TOTP) کامل شد!`,
	fil: `Kumpleto na ang pagpapatala ng One-Time Password (TOTP) na nakabatay sa oras!`,
	fr: `Inscription au mot de passe à usage unique (TOTP) basé sur le temps terminée !`,
	hi: `समय-आधारित वन-टाइम पासवर्ड (TOTP) नामांकन पूर्ण!`,
	ht: `Tan ki baze sou yon sèl-fwa modpas (TOTP) enskripsyon konplè!`,
	it: `Iscrizione completata alla Password Unica Basata sul Tempo (TOTP)!`,
	ja: `時間ベースのワンタイムパスワード(TOTP)登録完了!`,
	ko: `시간 기반 일회용 비밀번호(TOTP) 등록 완료!`,
	mww: `Sij hawm raws li One-Time Password (TOTP) sau npe tiav lawm!`,
	ps: `د وخت پر بنسټ یو ځل پاسورډ (TOTP) نوم لیکنه بشپړه شوه!`,
	pt: `Inscrição com Senha Única Baseada em Tempo (TOTP) concluída!`,
	'pt-pt': `Inscrição com Palavra-Passe Única (TOTP) baseada no tempo concluída!`,
	ru: `Регистрация одноразового пароля (TOTP) по времени завершена!`,
	sm: `Ua mae'a le lesitalaina o le Time-Based One-Time Password (TOTP)!`,
	so: `Diiwaangelinta Furaha Sirta Hal Mar (TOTP) ee ku saleysan waqtiga ayaa dhammaatay!`,
	th: `การลงทะเบียนรหัสผ่านแบบใช้ครั้งเดียวตามเวลา (TOTP) เสร็จสมบูรณ์!`,
	ur: `ٹائم بیسڈ ون ٹائم پاس ورڈ (TOTP) کا اندراج مکمل!`,
	vi: `Đăng ký Mật khẩu dùng một lần theo thời gian (TOTP) đã hoàn tất!`,
	'zh-hans': `基于时间的一次性密码（TOTP）注册完成！`,
	'zh-hant': `基於時間的一次性密碼（TOTP）註冊完成！`,
	en: `Time-based One-Time Password (TOTP) enrollment complete!`
};

export const loc_trackSendRequestProgressDesc: Record<Locale, (activityHref: unknown) => TemplateResult> = {
	ar: (activityHref) => html`طلبك قيد المعالجة. تتبع التقدم والوصول إلى الوثيقة المكتمل حول <a href="${activityHref}">النشاط</a>. قد يستغرق الأمر دقيقة أو دقيقتين لإرسال الرسائل الإلكترونية إلى المستلمين.`,
	de: (activityHref) => html`Deine Anfrage wird gerade bearbeitet. Verfolgen Sie den Fortschritt und greifen Sie auf das ausgefüllte Dokument zur <a href="${activityHref}">Aktivität</a> zu. Es kann ein oder zwei Minuten dauern, bis E-Mails an die Empfänger gesendet werden.`,
	es: (activityHref) => html`Tu solicitud está en proceso. Haz un seguimiento del progreso y accede al documento completado sobre la <a href="${activityHref}">actividad</a>. Puede que los correos electrónicos se envíen a los destinatarios tardar uno o dos minutos.`,
	fa: (activityHref) => html`درخواست شما در حال پردازش است. پیشرفت را پیگیری کنید و به سند تکمیل <a href="${activityHref}">شده فعالیت</a> دسترسی پیدا کنید. ممکن است یک یا دو دقیقه طول بکشد تا ایمیل ها به گیرندگان ارسال شود.`,
	fil: (activityHref) => html`Pinoproseso ang iyong kahilingan. Subaybayan ang pag-unlad at i-access ang nakumpletong dokumento sa <a href="${activityHref}">aktibidad</a>. Maaaring tumagal ng isa o dalawang minuto bago maipadala ang mga email sa mga tatanggap.`,
	fr: (activityHref) => html`Votre demande est en cours de traitement. Suivez l’avancement et accédez au document complété sur <a href="${activityHref}">l’activité</a>. Il peut falloir une minute ou deux pour que les emails soient envoyés aux destinataires.`,
	hi: (activityHref) => html`आपका अनुरोध संसाधित हो रहा है। प्रगति को ट्रैक करें और <a href="${activityHref}">गतिविधि</a> पर पूर्ण दस्तावेज़ तक पहुंचें। प्राप्तकर्ताओं को ईमेल भेजने में एक या दो मिनट लग सकते हैं।`,
	ht: (activityHref) => html`Demann ou an ap trete Swiv pwogrè ak jwenn aksè nan dokiman an ranpli sou <a href="${activityHref}">aktivite</a> a. Li ka pran yon minit oswa de pou imèl yo dwe voye bay moun k ap resevwa yo.`,
	it: (activityHref) => html`La tua richiesta è in fase di elaborazione. Monitorare i progressi e accedere al documento completato <a href="${activityHref}">sull'attività</a>. Potrebbero volerci uno o due minuti prima che le email vengano inviate ai destinatari.`,
	ja: (activityHref) => html`あなたのリクエストは処理中です。進捗を追跡し、 <a href="${activityHref}">活動</a>に関する完成した文書にアクセスしましょう。メールが受信者に送信されるまでに1〜2分かかることもあります。`,
	ko: (activityHref) => html`귀하의 요청은 처리 중입니다. 진행 상황을 추적하고 <a href="${activityHref}">활동</a>에 관한 완성된 문서에 접근할 수 있습니다. 이메일이 수신자에게 전달되기까지 한두 분이 걸릴 수 있습니다.`,
	mww: (activityHref) => html`Koj qhov kev thov tab tom ua tiav. Taug qab kev nce qib thiab nkag mus rau daim ntawv ua tiav ntawm <a href="${activityHref}">qhov kev ua ub no</a>. Tej zaum nws yuav siv sijhawm ib feeb lossis ob feeb rau cov email xa mus rau cov neeg tau txais.`,
	ps: (activityHref) => html`ستا غوښتنه پروسس کېږی. پرمختګ تعقیب کړئ او د <a href="${activityHref}">فعالیت</a> بشپړ شوی سند ته لاسرسی ولرئ. ممکن یو یا دوه دقیقې وخت ونیسی چې ایمیلونه ترلاسه کوونکو ته واستول شی.`,
	pt: (activityHref) => html`Seu pedido está sendo processado. Acompanhe o progresso e acesse o documento concluído na <a href="${activityHref}">atividade</a>. Pode levar um ou dois minutos para que os e-mails sejam enviados aos destinatários.`,
	'pt-pt': (activityHref) => html`O seu pedido está a ser processado. Acompanhe o progresso e aceda ao documento concluído na <a href="${activityHref}">atividade</a>. Pode demorar um ou dois minutos até que os emails sejam enviados aos destinatários.`,
	ru: (activityHref) => html`Ваш запрос обрабатывается. Отслеживайте прогресс и получайте доступ к завершённому документу <a href="${activityHref}">по заданию</a>. Письмо может занять минуту или две, чтобы отправить получателям.`,
	sm: (activityHref) => html`O loo faagaoioia lau talosaga. Siaki le alualu i luma ma faaaoga le pepa o faamatalaga ua maea i luga o le <a href="${activityHref}">gaoioiga</a>. Atonu e alu ai se minute pe lua mo le auina atu o imeli i tagata e mauaina.`,
	so: (activityHref) => html`Codsigaaga waa la shaqeynayaa. La soco horumarka oo hel dukumentiga la dhammeystiray <a href="${activityHref}">ee hawsha</a>. Waxay qaadan kartaa hal daqiiqo ama labo in email-yada loo diro dadka qaata.`,
	th: (activityHref) => html`คําขอของคุณกําลังดําเนินการ ติดตามความคืบหน้าและเข้าถึงเอกสารที่เสร็จสมบูรณ์เกี่ยวกับ <a href="${activityHref}">กิจกรรม</a> อาจใช้เวลาหนึ่งหรือสองนาทีในการส่งอีเมลไปยังผู้รับ`,
	ur: (activityHref) => html`آپ کی درخواست پراسیس ہو رہی ہے۔ <a href="${activityHref}">سرگرمی</a> کی پیش رفت کو ٹریک کریں اور مکمل شدہ دستاویز تک رسائی حاصل کریں۔ ای میلز وصول کنندگان کو بھیجنے میں ایک یا دو منٹ لگ سکتے ہیں۔`,
	vi: (activityHref) => html`Yêu cầu của bạn đang được xử lý. Theo dõi tiến độ và truy cập tài liệu đã hoàn thành về <a href="${activityHref}">hoạt động</a>. Có thể mất một hoặc hai phút để email được gửi đến người nhận.`,
	'zh-hans': (activityHref) => html`您的请求正在处理中。跟踪进度并访问活动的完成 <a href="${activityHref}">文档。</a>邮件发送到收件人可能需要一两分钟。`,
	'zh-hant': (activityHref) => html`您的申請正在處理中。追蹤進度並取得完成 <a href="${activityHref}">的文件。</a>郵件寄送給收件人可能需要一兩分鐘。`,
	en: (activityHref) => html`Your request is processing. Track progress and access the completed document on the <a href="${activityHref}">activity</a>. It may take a minute or two for emails to be sent to the recipients.`
};

export const loc_trainingEditProfileDisabled: Record<Locale, TemplateResult> = {
	ar: html`تحرير الملف الشخصي معطل في موقع التدريب. قم بتعديل ملفك الشخصي في <a href="https://cumulus.care/settings/profile">موقع الإنتاج</a> وسيتم مزامنة تغييراتك مع موقع التدريب خلال عشر دقائق.`,
	de: html`Profilbearbeitung ist auf der Schulungsseite deaktiviert. Bearbeiten Sie Ihr Profil auf der <a href="https://cumulus.care/settings/profile">Produktionsseite</a> und Ihre Änderungen werden innerhalb von zehn Minuten mit dem Trainingsstandort synchronisiert.`,
	es: html`La edición de perfil está deshabilitada en el sitio de formación. Edita tu perfil en el <a href="https://cumulus.care/settings/profile">lugar de producción</a> y tus cambios se sincronizarán con el lugar de formación en menos de diez minutos.`,
	fa: html`ویرایش پروفایل در سایت آموزشی غیرفعال است. پروفایل خود را در <a href="https://cumulus.care/settings/profile">سایت تولید</a> ویرایش کنید و تغییرات شما ظرف ده دقیقه با سایت آموزش همگام سازی خواهد شد.`,
	fil: html`Hindi pinagana ang pag-edit ng profile sa site ng pagsasanay. I-edit ang iyong profile sa <a href="https://cumulus.care/settings/profile">site ng produksyon</a> at ang iyong mga pagbabago ay mai-synchronize sa site ng pagsasanay sa loob ng sampung minuto.`,
	fr: html`L’édition de profil est désactivée sur le site de formation. Modifiez votre profil sur le <a href="https://cumulus.care/settings/profile">site de production</a> et vos modifications seront synchronisées avec le site de formation en dix minutes.`,
	hi: html`प्रोफ़ाइल संपादन प्रशिक्षण साइट पर अक्षम किया गया है। <a href="https://cumulus.care/settings/profile">उत्पादन साइट</a> पर अपनी प्रोफ़ाइल संपादित करें और आपके परिवर्तन दस मिनट के भीतर प्रशिक्षण साइट पर सिंक्रनाइज़ हो जाएंगे।`,
	ht: html`Pwofil koreksyon se enfim sou sit la fòmasyon Edite pwofil ou sou <a href="https://cumulus.care/settings/profile">sit pwodiksyon</a> an ak chanjman ou yo pral senkronize nan sit fòmasyon an nan dis minit.`,
	it: html`La modifica del profilo è disabilitata sul sito di formazione. Modifica il tuo profilo sul <a href="https://cumulus.care/settings/profile">sito di produzione</a> e le tue modifiche saranno sincronizzate con il sito di formazione entro dieci minuti.`,
	ja: html`トレーニングサイトではプロフィール編集が無効になっています。 <a href="https://cumulus.care/settings/profile">本番サイト</a> でプロフィールを編集すれば、変更内容は10分以内にトレーニングサイトに同期されます。`,
	ko: html`교육 사이트에서는 프로필 편집이 비활성화되어 있습니다. <a href="https://cumulus.care/settings/profile">운영 사이트</a> 에서 프로필을 편집하면 변경 사항이 10분 이내에 교육 사이트와 동기화됩니다.`,
	mww: html`Profile editing yog xiam oob qhab ntawm qhov chaw cob qhia. Kho koj qhov profile ntawm qhov <a href="https://cumulus.care/settings/profile">chaw tsim</a> khoom thiab koj cov kev hloov pauv yuav raug synchronized rau qhov chaw cob qhia tsis pub dhau kaum feeb.`,
	ps: html`د روزنې په سایټ کې د پروفایل ایډیټ کول غیر فعال دی. خپل پروفایل په <a href="https://cumulus.care/settings/profile">تولیدی سایټ</a> کې ایډیټ کړئ او ستاسو بدلونونه به په لسو دقیقو کې د روزنې سایټ سره همغږی شی.`,
	pt: html`A edição de perfil está desativada no site de treinamento. Edite seu perfil no <a href="https://cumulus.care/settings/profile">local de produção</a> e suas mudanças serão sincronizadas com o local de treinamento em dez minutos.`,
	'pt-pt': html`A edição de perfil está desativada no site de formação. Edita o teu perfil no <a href="https://cumulus.care/settings/profile">local de produção</a> e as tuas alterações serão sincronizadas com o local de formação em dez minutos.`,
	ru: html`Редактирование профиля отключено на обучающем сайте. Отредактируйте свой профиль на <a href="https://cumulus.care/settings/profile">производственном сайте</a> , и ваши изменения будут синхронизированы с обучающим сайтом в течение десяти минут.`,
	sm: html`E le mafai ona faasa'oina le talaaga otooto i luga o le saite o aoaoga. Faasa'o lou talaaga otooto i luga o le <a href="https://cumulus.care/settings/profile">saite o le gaosiga</a> ma o le a faalaugatasia au suiga i le saite o aoaoga i totonu o le sefulu minute.`,
	so: html`Tafatirka profile-ka waa la joojiyay goobta tababarka. Wax ka beddel profile-kaaga <a href="https://cumulus.care/settings/profile">goobta wax-soo-saarka</a> , isbeddelkaaga waxaa lagu waafajin doonaa goobta tababarka muddo toban daqiiqo gudahood ah.`,
	th: html`การแก้ไขโปรไฟล์ถูกปิดใช้งานในไซต์การฝึกอบรม แก้ไขโปรไฟล์ของคุณบน <a href="https://cumulus.care/settings/profile">ไซต์การผลิต</a> และการเปลี่ยนแปลงของคุณจะถูกซิงโครไนซ์กับไซต์การฝึกอบรมภายในสิบนาที`,
	ur: html`تربیتی سائٹ پر پروفائل ایڈیٹنگ غیر فعال ہے۔ <a href="https://cumulus.care/settings/profile">پروڈکشن سائٹ</a> پر اپنا پروفائل ایڈٹ کریں اور آپ کی تبدیلیاں دس منٹ کے اندر ٹریننگ سائٹ کے ساتھ ہم آہنگ ہو جائیں گی۔`,
	vi: html`Chỉnh sửa hồ sơ bị tắt trên trang web đào tạo. Chỉnh sửa hồ sơ của bạn trên <a href="https://cumulus.care/settings/profile">trang web sản xuất</a> và các thay đổi của bạn sẽ được đồng bộ hóa với trang web đào tạo trong vòng mười phút.`,
	'zh-hans': html`培训网站上的个人资料编辑功能已关闭。在 <a href="https://cumulus.care/settings/profile">生产站点</a> 编辑你的个人资料，你的更改将在十分钟内同步到培训站点。`,
	'zh-hant': html`培訓網站上的個人檔案編輯功能已關閉。在 <a href="https://cumulus.care/settings/profile">生產網站上</a> 編輯你的個人檔案，你的變更會在十分鐘內同步到訓練網站。`,
	en: html`Profile editing is disabled on the training site. Edit your profile on the <a href="https://cumulus.care/settings/profile">production site</a> and your changes will be synchronized to the training site within ten minutes.`
};

export const loc_trainingFlash: Record<Locale, TemplateResult> = {
	ar: html`<span class="text-bold">هذا الموقع مخصص لأغراض التدريب فقط.</span> راجع <a href="/docs/training-site">الوثائق</a> لمزيد من المعلومات أو توجه <a href="https://cumulus.care/">إلى موقع الإنتاج</a>.`,
	de: html`<span class="text-bold">Diese Seite dient ausschließlich Schulungszwecken.</span> Weitere Informationen finden Sie in der <a href="/docs/training-site">Dokumentation</a> oder besuchen Sie den <a href="https://cumulus.care/">Produktionsstandort</a>.`,
	es: html`<span class="text-bold">Este sitio es únicamente para fines de formación.</span> Consulta la <a href="/docs/training-site">documentación</a> para más información o acude al <a href="https://cumulus.care/">lugar de producción</a>.`,
	fa: html`<span class="text-bold">این سایت صرفا برای اهداف آموزشی است.</span> برای اطلاعات بیشتر به <a href="/docs/training-site">مستندات</a> مراجعه کنید یا به <a href="https://cumulus.care/">محل تولید</a> مراجعه کنید.`,
	fil: html`<span class="text-bold">Ang site na ito ay para sa mga layunin ng pagsasanay lamang.</span> Sumangguni sa <a href="/docs/training-site">dokumentasyon</a> para sa karagdagang impormasyon o pumunta sa <a href="https://cumulus.care/">site ng produksyon</a>.`,
	fr: html`<span class="text-bold">Ce site est uniquement destiné à la formation.</span> Consultez la <a href="/docs/training-site">documentation</a> pour plus d’informations ou rendez-vous sur <a href="https://cumulus.care/">le site de production</a>.`,
	hi: html`<span class="text-bold">यह साइट केवल प्रशिक्षण उद्देश्यों के लिए है।</span> अधिक जानकारी के लिए <a href="/docs/training-site">दस्तावेज़</a> देखें या <a href="https://cumulus.care/">उत्पादन स्थल</a> पर जाएँ।`,
	ht: html`<span class="text-bold">Sit sa a se pou rezon fòmasyon sèlman.</span> Al gade nan <a href="/docs/training-site">dokiman</a> an pou plis enfòmasyon oswa ale nan <a href="https://cumulus.care/">sit pwodiksyon</a> an.`,
	it: html`<span class="text-bold">Questo sito è solo a scopo di formazione.</span> Consulta la <a href="/docs/training-site">documentazione</a> per maggiori informazioni o vai al <a href="https://cumulus.care/">sito di produzione</a>.`,
	ja: html`<span class="text-bold">このサイトはトレーニング目的のみを目的としています。</span> 詳細は <a href="/docs/training-site">ドキュメント</a> を参照するか、 <a href="https://cumulus.care/">生産現場</a>をご覧ください。`,
	ko: html`<span class="text-bold">이 사이트는 교육 목적으로만 운영됩니다.</span> 자세한 내용은 <a href="/docs/training-site">문서를</a> 참조하거나 <a href="https://cumulus.care/">생산 현장</a>을 방문하세요.`,
	mww: html`<span class="text-bold">Lub xaib no yog rau kev cob qhia xwb.</span> Saib cov <a href="/docs/training-site">ntaub ntawv</a> rau cov ntaub ntawv ntxiv lossis mus rau qhov <a href="https://cumulus.care/">chaw tsim</a> khoom.`,
	ps: html`<span class="text-bold">دا سایټ یوازې د روزنې لپاره دی.</span> د نورو معلوماتو لپاره <a href="/docs/training-site">اسنادو</a> ته مراجعه وکړئ یا <a href="https://cumulus.care/">د تولید سایټ</a> ته لاړ شئ.`,
	pt: html`<span class="text-bold">Este site é apenas para fins de treinamento.</span> Consulte a <a href="/docs/training-site">documentação</a> para mais informações ou vá ao <a href="https://cumulus.care/">local de produção</a>.`,
	'pt-pt': html`<span class="text-bold">Este site destina-se apenas a fins de formação.</span> Consulte a <a href="/docs/training-site">documentação</a> para mais informações ou dirija-se ao <a href="https://cumulus.care/">local de produção</a>.`,
	ru: html`<span class="text-bold">Этот сайт предназначен исключительно для учебных целей.</span> Обратитесь к <a href="/docs/training-site">документации</a> для получения дополнительной информации или посетите <a href="https://cumulus.care/">производственный сайт</a>.`,
	sm: html`<span class="text-bold">O lenei 'upega tafa'ilagi e mo na'o a'oa'oga fa'amoemoega.</span> Va'ai i le <a href="/docs/training-site">fa'amaumauga</a> mo nisi fa'amatalaga pe alu i le <a href="https://cumulus.care/">nofoaga o gaosiga</a>.`,
	so: html`<span class="text-bold">Boggan waxaa loogu talagalay ujeeddooyin tababar oo kaliya.</span> Eeg <a href="/docs/training-site">dukumentiyada</a> wixii macluumaad dheeraad ah ama booqo <a href="https://cumulus.care/">goobta soo saarista</a>.`,
	th: html`<span class="text-bold">เว็บไซต์นี้มีวัตถุประสงค์เพื่อการฝึกอบรมเท่านั้น</span> โปรดดู<a href="/docs/training-site">เอกสารประกอบ</a>สําหรับข้อมูลเพิ่มเติมหรือไปที่<a href="https://cumulus.care/">ไซต์การผลิต</a>`,
	ur: html`<span class="text-bold">یہ سائٹ صرف تربیتی مقاصد کے لیے ہے۔</span> مزید معلومات کے لیے <a href="/docs/training-site">دستاویزات</a> دیکھیں یا <a href="https://cumulus.care/">پروڈکشن سائٹ</a> پر جائیں۔`,
	vi: html`<span class="text-bold">Trang web này chỉ dành cho mục đích đào tạo.</span> Tham khảo <a href="/docs/training-site">tài liệu</a> để biết thêm thông tin hoặc truy cập <a href="https://cumulus.care/">trang web sản xuất</a>.`,
	'zh-hans': html`<span class="text-bold">本网站仅供培训用途。</span> 更多信息请参阅 <a href="/docs/training-site">文档</a> 或访问 <a href="https://cumulus.care/">制作现场</a>。`,
	'zh-hant': html`<span class="text-bold">本網站僅供培訓用途。</span> 請參閱 <a href="/docs/training-site">文件</a> 以獲得更多資訊，或前往 <a href="https://cumulus.care/">製作現場</a>。`,
	en: html`<span class="text-bold">This site is for training purposes only.</span> Refer to the <a href="/docs/training-site">documentation</a> for more information or go to the <a href="https://cumulus.care/">production site</a>.`
};

export const loc_trainingSignUpDisabled: Record<Locale, TemplateResult> = {
	ar: html`تم تعطيل تسجيل الحساب الجديد في موقع التدريب. سجل في <a href="https://cumulus.care/sign-up">موقع الإنتاج</a> وسيتم مزامنة حسابك مع موقع التدريب خلال عشر دقائق.`,
	de: html`Die Registrierung eines neuen Kontos ist auf der Trainingsseite deaktiviert. Melde dich auf der <a href="https://cumulus.care/sign-up">Produktionsseite</a> an und dein Konto wird innerhalb von zehn Minuten mit dem Trainingsstandort synchronisiert.`,
	es: html`El registro de nueva cuenta está deshabilitado en la página de formación. Regístrate en el <a href="https://cumulus.care/sign-up">sitio de producción</a> y tu cuenta estará sincronizada con el lugar de entrenamiento en menos de diez minutos.`,
	fa: html`ثبت نام حساب جدید در سایت آموزشی غیرفعال شده است. در <a href="https://cumulus.care/sign-up">سایت تولید</a> ثبت نام کنید و حساب شما ظرف ده دقیقه با محل آموزش همگام سازی خواهد شد.`,
	fil: html`Hindi pinagana ang pagpaparehistro ng bagong account sa site ng pagsasanay. Mag-sign up sa <a href="https://cumulus.care/sign-up">site ng produksyon</a> at ang iyong account ay mai-synchronize sa site ng pagsasanay sa loob ng sampung minuto.`,
	fr: html`L’enregistrement du nouveau compte est désactivé sur le site de formation. Inscrivez-vous sur le <a href="https://cumulus.care/sign-up">site de production</a> et votre compte sera synchronisé avec le site de formation en dix minutes.`,
	hi: html`प्रशिक्षण साइट पर नया खाता पंजीकरण अक्षम कर दिया गया है। <a href="https://cumulus.care/sign-up">उत्पादन स्थल</a> पर साइन अप करें और आपका खाता दस मिनट के भीतर प्रशिक्षण स्थल पर सिंक्रनाइज़ हो जाएगा।`,
	ht: html`Nouvo enskripsyon kont se enfim sou sit la fòmasyon Enskri sou <a href="https://cumulus.care/sign-up">sit la pwodiksyon</a> ak kont ou pral senkronize nan sit fòmasyon an nan dis minit.`,
	it: html`La registrazione del nuovo account è disabilitata sul sito di formazione. Iscriviti sul <a href="https://cumulus.care/sign-up">sito di produzione</a> e il tuo account sarà sincronizzato con il sito di formazione entro dieci minuti.`,
	ja: html`トレーニングサイトでは新規アカウント登録が無効になっています。 <a href="https://cumulus.care/sign-up">本番サイト</a> に登録すれば、10分以内にアカウントがトレーニングサイトと同期されます。`,
	ko: html`교육 사이트에서는 신규 계정 등록이 비활성화되어 있습니다. <a href="https://cumulus.care/sign-up">운영 사이트</a> 에서 가입하면 10분 이내에 귀하의 계정이 교육 사이트와 동기화됩니다.`,
	mww: html`Kev sau npe tus account tshiab yog xiam oob qhab ntawm qhov chaw cob qhia. Sau npe rau ntawm qhov <a href="https://cumulus.care/sign-up">chaw tsim</a> khoom thiab koj tus account yuav raug synchronized rau qhov chaw cob qhia tsis pub dhau kaum feeb.`,
	ps: html`د روزنې سایټ کې د نوی حساب ثبتول غیر فعال دی. په <a href="https://cumulus.care/sign-up">تولیدی سایټ</a> کې نوم لیکنه وکړئ او ستاسو حساب به په لسو دقیقو کې د روزنې ځای سره همغږی شی.`,
	pt: html`O registro da nova conta está desativado no site de treinamento. Cadastre-se no <a href="https://cumulus.care/sign-up">local de produção</a> e sua conta será sincronizada com o local de treinamento em dez minutos.`,
	'pt-pt': html`O registo da nova conta está desativado no site de formação. Registe-se no <a href="https://cumulus.care/sign-up">local de produção</a> e a sua conta será sincronizada com o local de treino em dez minutos.`,
	ru: html`Регистрация нового аккаунта на обучающем сайте отключена. Зарегистрируйтесь на <a href="https://cumulus.care/sign-up">производственном сайте</a> , и ваш аккаунт будет синхронизирован с обучающим сайтом в течение десяти минут.`,
	sm: html`O le lesitalaina o le faitotoa fou e le mafai ona lesitalaina i luga o le saite o aoaoga. Saini i luga o le <a href="https://cumulus.care/sign-up">'upega tafa'ilagi o le gaosiga</a> ma o lau teuga tupe o le a fa'afeso'ota'i i le nofoaga o a'oa'oga i totonu o le sefulu minute.`,
	so: html`Diiwaangelinta akoonka cusub waa la joojiyay goobta tababarka. Iska diiwaangeli <a href="https://cumulus.care/sign-up">goobta wax-soo-saarka</a> , xisaabtaadana waxaa lagu waafajin doonaa goobta tababarka muddo toban daqiiqo gudahood.`,
	th: html`การลงทะเบียนบัญชีใหม่ถูกปิดใช้งานบนเว็บไซต์การฝึกอบรม ลงทะเบียนบนเว็บไซต์ <a href="https://cumulus.care/sign-up">การผลิต</a> และบัญชีของคุณจะถูกซิงโครไนซ์กับไซต์การฝึกอบรมภายในสิบนาที`,
	ur: html`ٹریننگ سائٹ پر نیا اکاؤنٹ رجسٹریشن غیر فعال کر دیا گیا ہے۔ <a href="https://cumulus.care/sign-up">پروڈکشن سائٹ</a> پر سائن اپ کریں اور آپ کا اکاؤنٹ دس منٹ کے اندر تربیتی سائٹ کے ساتھ ہم آہنگ ہو جائے گا۔`,
	vi: html`Đăng ký tài khoản mới bị vô hiệu hóa trên trang web đào tạo. Đăng ký trên <a href="https://cumulus.care/sign-up">trang web sản xuất</a> và tài khoản của bạn sẽ được đồng bộ hóa với trang web đào tạo trong vòng mười phút.`,
	'zh-hans': html`培训网站上的新账户注册功能已被禁用。在 <a href="https://cumulus.care/sign-up">生产网站</a> 注册，你的账户将在十分钟内同步到培训网站。`,
	'zh-hant': html`培訓網站上的新帳號註冊功能已被停用。在 <a href="https://cumulus.care/sign-up">生產線上</a> 註冊，帳號將在十分鐘內同步到培訓網站。`,
	en: html`New account registration is disabled on the training site. Sign up on the <a href="https://cumulus.care/sign-up">production site</a> and your account will be synchronized to the training site within ten minutes.`
};

export const loc_trainingWelcome: Record<Locale, (cumulus: unknown) => string> = {
	ar: (cumulus) => `مرحبا بكم في موقع تدريب ${cumulus} !`,
	de: (cumulus) => `Willkommen auf der ${cumulus} !`,
	es: (cumulus) => `¡Bienvenidos al sitio de entrenamiento ${cumulus} !`,
	fa: (cumulus) => `به سایت آموزشی ${cumulus} خوش آمدید!`,
	fil: (cumulus) => `Maligayang pagdating sa site ng pagsasanay ${cumulus} !`,
	fr: (cumulus) => `Bienvenue sur le site d’entraînement ${cumulus} !`,
	hi: (cumulus) => `${cumulus} प्रशिक्षण स्थल में आपका स्वागत है!`,
	ht: (cumulus) => `Byenveni nan sit fòmasyon ${cumulus} la!`,
	it: (cumulus) => `Benvenuti nel sito di addestramento ${cumulus} !`,
	ja: (cumulus) => `${cumulus}トレーニングサイトへようこそ!`,
	ko: (cumulus) => `${cumulus} 훈련장에 오신 것을 환영합니다!`,
	mww: (cumulus) => `Zoo siab txais tos rau ${cumulus} kev cob qhia qhov chaw!`,
	ps: (cumulus) => `د ${cumulus} د روزنې ځای ته ښه راغلاست!`,
	pt: (cumulus) => `Bem-vindo ao site de treinamento ${cumulus} !`,
	'pt-pt': (cumulus) => `Bem-vindo ao local de treino ${cumulus} !`,
	ru: (cumulus) => `Добро пожаловать на тренировочную ${cumulus} !`,
	sm: (cumulus) => `Fa'afeiloa'i i le 'upega tafa'ilagi a'oa'oga ${cumulus} !`,
	so: (cumulus) => `Ku soo dhawoow goobta tababarka ${cumulus} !`,
	th: (cumulus) => `ยินดีต้อนรับสู่ไซต์การฝึกอบรม ${cumulus} !`,
	ur: (cumulus) => `${cumulus} تربیتی سائٹ پر خوش آمدید!`,
	vi: (cumulus) => `Chào mừng bạn đến với trang web đào tạo ${cumulus} !`,
	'zh-hans': (cumulus) => `欢迎来到 ${cumulus} 训练基地！`,
	'zh-hant': (cumulus) => `歡迎來到 ${cumulus} 訓練基地！`,
	en: (cumulus) => `Welcome to the ${cumulus} training site!`
};

export const loc_translationInProgress: Record<Locale, string> = {
	ar: `نعمل على توفير ترجمة للغات المدرجة أدناه. ستظهر المناطق في الموقع التي لم تترجم بعد إلى اللغة الإنجليزية.`,
	de: `Wir arbeiten daran, Übersetzungen für die unten aufgeführten Sprachen bereitzustellen. Bereiche der Seite, die noch nicht übersetzt wurden, erscheinen auf Englisch.`,
	es: `Estamos trabajando en proporcionar traducción para los idiomas que se enumeran a continuación. Las áreas del sitio que aún no han sido traducidas aparecerán en inglés.`,
	fa: `ما در حال کار بر روی ارائه ترجمه برای زبان های فهرست شده در زیر هستیم. بخش هایی از سایت که هنوز ترجمه نشده اند، به زبان انگلیسی منتشر خواهند شد.`,
	fil: `Nagtatrabaho kami sa pagbibigay ng pagsasalin para sa mga wika na nakalista sa ibaba. Ang mga bahagi ng site na hindi pa isinalin ay lilitaw sa Ingles.`,
	fr: `Nous travaillons à fournir des traductions pour les langues listées ci-dessous. Les zones du site qui n’ont pas encore été traduites apparaîtront en anglais.`,
	hi: `हम नीचे सूचीबद्ध भाषाओं के लिए अनुवाद प्रदान करने पर काम कर रहे हैं। साइट के जिन क्षेत्रों का अभी तक अनुवाद नहीं किया गया है, वे अंग्रेजी में दिखाई देंगे।`,
	ht: `Nap travay pou bay tradiksyon pou lang ki nan lis anba yo. Zòn nan sit la ki pa gen ankò yo te tradui yo pral parèt nan lang angle.`,
	it: `Stiamo lavorando per fornire traduzioni per le lingue elencate di seguito. Le aree del sito che non sono ancora state tradotte appariranno in inglese.`,
	ja: `以下に挙げる言語の翻訳提供に取り組んでいます。まだ翻訳されていないサイトの一部は英語で掲載されます。`,
	ko: `아래에 나열된 언어들에 대한 번역을 제공하기 위해 노력하고 있습니다. 아직 번역되지 않은 부지 내 일부 지역은 영어로 공개될 예정입니다.`,
	mww: `Peb tab tom ua haujlwm ntawm kev muab kev txhais lus rau cov lus teev hauv qab no. Thaj chaw ntawm lub xaib uas tseem tsis tau txhais yuav tshwm sim ua lus Askiv.`,
	ps: `موږ د لاندې یادو ژبو لپاره ژباړه برابرولو کار کوو. د سایټ هغه برخې چې لا تر اوسه نه دی ژباړل شوی، به په انګلیسی ژبه خپره شی.`,
	pt: `Estamos trabalhando para fornecer tradução para os idiomas listados abaixo. Áreas do site que ainda não foram traduzidas aparecerão em inglês.`,
	'pt-pt': `Estamos a trabalhar para fornecer tradução para as línguas listadas abaixo. Áreas do site que ainda não foram traduzidas aparecerão em inglês.`,
	ru: `Мы работаем над предоставлением перевода для перечисленных ниже языков. Части сайта, которые ещё не были переведены, будут опубликованы на английском языке.`,
	sm: `O lo'o matou galulue i le tu'uina atu o fa'aliliuga mo gagana o lo'o lisiina atu i lalo. O vaega o le saite e le'i faaliliuina o le a faaali mai i le gagana Peretania.`,
	so: `Waxaan ka shaqeyneynaa bixinta turjumaadda luqadaha hoos ku xusan. Qaybo ka mid ah goobta aan weli la tarjumin ayaa lagu arki doonaa Ingiriis.`,
	th: `เรากําลังดําเนินการแปลภาษาที่ระบุไว้ด้านล่าง พื้นที่ของเว็บไซต์ที่ยังไม่ได้แปลจะปรากฏเป็นภาษาอังกฤษ`,
	ur: `ہم نیچے دی گئی زبانوں کے لیے ترجمہ فراہم کرنے پر کام کر رہے ہیں۔ سائٹ کے وہ حصے جو ابھی تک ترجمہ نہیں ہوئے، انگریزی میں شائع ہوں گے۔`,
	vi: `Chúng tôi đang làm việc để cung cấp bản dịch cho các ngôn ngữ được liệt kê dưới đây. Các khu vực của trang web chưa được dịch sẽ xuất hiện bằng tiếng Anh.`,
	'zh-hans': `我们正在为下列语言提供翻译服务。尚未翻译的网站区域将以英文形式呈现。`,
	'zh-hant': `我們正在為下列語言提供翻譯服務。尚未翻譯的網站區域將以英文呈現。`,
	en: `We're working on providing translation for the languages listed below. Areas of the site which have not yet been translated will appear in English.`
};

export const loc_troubleScanningQRCode: Record<Locale, string> = {
	ar: `هل تواجه مشكلة في مسح رمز الاستجابة السريعة؟`,
	de: `Probleme beim Scannen des QR-Codes?`,
	es: `¿Problemas para escanear el código QR?`,
	fa: `مشکل در اسکن کد QR دارید؟`,
	fil: `Problema sa pag-scan ng QR code?`,
	fr: `Problème pour scanner le code QR ?`,
	hi: `क्यूआर कोड स्कैन करने में परेशानी?`,
	ht: `Pwoblèm pou eskane kòd la QR?`,
	it: `Problemi a scansionare il codice QR?`,
	ja: `QRコードのスキャンに問題がありますか?`,
	ko: `QR 코드 스캔에 문제가 있나요?`,
	mww: `Teeb meem luam theej duab QR code?`,
	ps: `د QR کوډ سکین کولو کې ستونزه ده؟`,
	pt: `Problemas para escanear o código QR?`,
	'pt-pt': `Problemas a digitalizar o código QR?`,
	ru: `Проблемы с сканированием QR-кода?`,
	sm: `Fa'afitauli i le su'esu'eina o le QR code?`,
	so: `Dhibaato ku saabsan baaritaanka QR code-ka?`,
	th: `มีปัญหาในการสแกนรหัส QR?`,
	ur: `کیا کیو آر کوڈ اسکین کرنے میں مشکل پیش آئی؟`,
	vi: `Sự cố khi quét mã QR?`,
	'zh-hans': `扫描二维码有问题吗？`,
	'zh-hant': `掃描 QR 碼有困難嗎？`,
	en: `Trouble scanning the QR code?`
};

export const loc_tsEntryIssuesTitleFormat: Record<Locale, (date: unknown, time: unknown) => string> = {
	ar: (date, time) => `الأعداد ${date} — ${time}`,
	de: (date, time) => `Ausgaben für ${date} – ${time}`,
	es: (date, time) => `Números para ${date} — ${time}`,
	fa: (date, time) => `شماره ها برای ${date} — ${time}`,
	fil: (date, time) => `Mga isyu para sa ${date} — ${time}`,
	fr: (date, time) => `Numéros pour ${date} 5 — ${time}`,
	hi: (date, time) => `${date} - ${time} लिए मुद्दे`,
	ht: (date, time) => `Pwoblèm pou ${date} — ${time}`,
	it: (date, time) => `Numeri per ${date} — ${time}`,
	ja: (date, time) => `5 ${date} の号 — ${time}`,
	ko: (date, time) => `토 ${date} 일 — ${time}`,
	mww: (date, time) => `Cov teeb meem rau ${date} — ${time}`,
	ps: (date, time) => `د ${date} — ${time} ګڼې`,
	pt: (date, time) => `Edições para ${date} — ${time}`,
	'pt-pt': (date, time) => `Edições para ${date} — ${time}`,
	ru: (date, time) => `Выпуски для ${date} — ${time}`,
	sm: (date, time) => `Lomiga mo ${date} — ${time}`,
	so: (date, time) => `Arrimaha ${date} — ${time}`,
	th: (date, time) => `ปัญหาสําหรับ ${date} — ${time}`,
	ur: (date, time) => `${date} — ${time} بجے کے لیے شمارے`,
	vi: (date, time) => `Các vấn đề cho ${date} - ${time}`,
	'zh-hans': (date, time) => `5${date} — ${time}的问题`,
	'zh-hant': (date, time) => `週${date} — ${time} 的期刊`,
	en: (date, time) => `Issues for ${date} — ${time}`
};

export const loc_tsErrorBudgetNotActiveOnWorkDateDesc: Record<Locale, string> = {
	ar: `تاريخ العمل ليس ضمن تاريخ بداية ونهاية سجل الميزانية أو أن الميزانية في حالة إلغاء.`,
	de: `Das Arbeitsdatum liegt nicht im Budget-Datensatz für Anfangs- und Enddaten oder das Budget ist im Status "storniert".`,
	es: `La fecha de trabajo no está dentro de las fechas de inicio y fin del registro presupuestario o el presupuesto está en estado de cancelado.`,
	fa: `تاریخ کار در تاریخ های شروع و پایان رکورد بودجه نیست یا بودجه در وضعیت لغو قرار دارد.`,
	fil: `Ang petsa ng trabaho ay wala sa loob ng mga petsa ng pagsisimula at pagtatapos ng talaan ng badyet o ang badyet ay nasa katayuan ng kinansela.`,
	fr: `La date de travail ne figure pas dans les dates de début et de fin des registres budgétaires ou le budget est en état d’annulation.`,
	hi: `कार्य तिथि बजट रिकॉर्ड प्रारंभ और समाप्ति तिथियों के भीतर नहीं है या बजट रद्द की गई स्थिति में है.`,
	ht: `Dat travay la pa nan dat kòmansman ak fen dosye bidjè oswa bidjè a nan estati anile`,
	it: `La data di lavoro non rientra nelle date di inizio e fine del registro del bilancio o il budget è in stato di annullamento.`,
	ja: `作業日が予算記録の開始日および終了日に含まれていないか、予算がキャンセル状態です。`,
	ko: `작업 날짜가 예산 기록의 시작일과 종료일에 포함되지 않거나 예산이 취소된 상태일 수 있습니다.`,
	mww: `Hnub ua hauj lwm tsis nyob rau hauv cov ntaub ntawv pib thiab xaus los yog cov peev nyiaj yog nyob rau hauv cov ntaub ntawv muab tshem tawm.`,
	ps: `د کار نېټه د بودیجې د پیل او پای نیټو کې نه ده او نه هم بودیجه لغوه شوې ده.`,
	pt: `A data de trabalho não está dentro das datas de início e término do registro orçamentário ou o orçamento está em status de cancelado.`,
	'pt-pt': `A data de trabalho não está dentro das datas de início e fim do registo orçamental ou o orçamento está em estado de cancelamento.`,
	ru: `Дата работы не соответствует дате начала и окончания бюджетных записей, либо бюджет находится в статусе отмены.`,
	sm: `O le aso faigaluega e le o i totonu o le faamaumauga o le paketi e amata ma faamuta ai pe o loo faaleaogaina foi le paketi.`,
	so: `Taariikhda shaqada kuma jirto taariikhaha bilowga iyo dhammaadka diiwaanka miisaaniyadda ama miisaaniyadda waa la kansalay.`,
	th: `วันที่ทํางานไม่อยู่ภายในวันที่เริ่มต้นและวันที่สิ้นสุดของเรกคอร์ดงบประมาณ หรืองบประมาณอยู่ในสถานะยกเลิก`,
	ur: `کام کی تاریخ بجٹ ریکارڈ کے آغاز اور اختتام کی تاریخوں میں نہیں ہے یا بجٹ منسوخ شدہ حالت میں ہے۔`,
	vi: `Ngày làm việc không nằm trong ngày bắt đầu và ngày kết thúc của bản ghi ngân sách hoặc ngân sách ở trạng thái hủy bỏ.`,
	'zh-hans': `工作日期不在预算记录的开始和结束日期内，或者预算处于取消状态。`,
	'zh-hant': `工作日期不在預算記錄的開始與結束日期內，或是預算處於取消狀態。`,
	en: `The work date is not within the budget record start and end dates or the budget is in cancelled status.`
};

export const loc_tsErrorBudgetNotActiveOnWorkDateName: Record<Locale, string> = {
	ar: `الميزانية غير نشطة في تاريخ العمل`,
	de: `Budget am Arbeitstag nicht aktiv`,
	es: `Presupuesto no activo en la fecha de trabajo`,
	fa: `بودجه در تاریخ کاری فعال نیست`,
	fil: `Hindi aktibo ang badyet sa petsa ng trabaho`,
	fr: `Budget non actif à la date de travail`,
	hi: `काम की तारीख पर बजट सक्रिय नहीं`,
	ht: `Bidjè pa aktif nan dat travay`,
	it: `Budget non attivo alla data di lavoro`,
	ja: `作業日の予算は有効ではありません`,
	ko: `근무일에 예산이 활성화되지 않음`,
	mww: `Nyiaj txiag tsis siv rau hnub ua hauj lwm`,
	ps: `بودیجه د کار په نېټه فعاله نه ده`,
	pt: `Orçamento não ativo na data de trabalho`,
	'pt-pt': `Orçamento não ativo na data de trabalho`,
	ru: `Бюджет не активен на день работы`,
	sm: `E le o galue le paketi i le aso faigaluega`,
	so: `Miisaaniyadda ma firfircoon maalinta shaqada`,
	th: `งบประมาณไม่ได้ใช้งานในวันที่ทํางาน`,
	ur: `بجٹ کام کی تاریخ پر فعال نہیں ہے`,
	vi: `Ngân sách không hoạt động vào ngày làm việc`,
	'zh-hans': `工作日期预算未生效`,
	'zh-hant': `工作日期預算未生效`,
	en: `Budget not active on work date`
};

export const loc_tsErrorBudgetSuspendedDesc: Record<Locale, string> = {
	ar: `يغطي التعليق الاقتصادي تاريخ العمل.`,
	de: `Eine Budgetaussetzung deckt den Arbeitstermin ab.`,
	es: `Una suspensión presupuestaria cubre la fecha de trabajo.`,
	fa: `تعلیق بودجه ای تاریخ کاری را پوشش می دهد.`,
	fil: `Ang suspensyon ng badyet ay sumasaklaw sa petsa ng trabaho.`,
	fr: `Une suspension budgétaire couvre la date de travail.`,
	hi: `एक बजट निलंबन कार्य तिथि को कवर करता है।`,
	ht: `Yon sispansyon bidjè kouvri dat travay la.`,
	it: `Una sospensione di budget copre la data di lavoro.`,
	ja: `予算の一時停止は作業日をカバーします。`,
	ko: `예산 정지가 근무일을 보장합니다.`,
	mww: `Ib qho kev ncua nyiaj txiag them rau hnub ua haujlwm.`,
	ps: `د بودیجې تعلیق د کار نېټه پوښی.`,
	pt: `Uma suspensão orçamentária cobre a data de trabalho.`,
	'pt-pt': `Uma suspensão orçamental cobre a data de trabalho.`,
	ru: `Приостановка бюджета покрывает дату работы.`,
	sm: `O le fa'amalologa o le paketi e aofia ai le aso faigaluega.`,
	so: `Joojinta miisaaniyadda waxay daboolaysaa taariikhda shaqada.`,
	th: `การระงับงบประมาณครอบคลุมวันที่ทํางาน`,
	ur: `بجٹ معطلی کام کی تاریخ کو کور کرتی ہے۔`,
	vi: `Đình chỉ ngân sách bao gồm ngày làm việc.`,
	'zh-hans': `预算暂停涵盖工作日期。`,
	'zh-hant': `預算暫停則涵蓋工作日期。`,
	en: `A budget suspension covers the work date.`
};

export const loc_tsErrorBudgetSuspendedName: Record<Locale, string> = {
	ar: `تم تعليق الميزانية`,
	de: `Haushalt ausgesetzt`,
	es: `Presupuesto suspendido`,
	fa: `بودجه تعلیق شد`,
	fil: `Sinuspinde ang badyet`,
	fr: `Budget suspendu`,
	hi: `बजट निलंबित`,
	ht: `Bidjè sispann`,
	it: `Bilancio sospeso`,
	ja: `予算停止`,
	ko: `예산 정지`,
	mww: `Pob nyiaj tau raug tshem tawm`,
	ps: `بودیجه ځنډول شوې`,
	pt: `Orçamento suspenso`,
	'pt-pt': `Orçamento suspenso`,
	ru: `Бюджет приостановлен`,
	sm: `Fa'amalolo le paketi`,
	so: `Miisaaniyadda waa la hakiyay`,
	th: `งบประมาณถูกระงับ`,
	ur: `بجٹ معطل`,
	vi: `Ngân sách bị tạm ngưng`,
	'zh-hans': `预算暂停`,
	'zh-hant': `預算暫停`,
	en: `Budget suspended`
};

export const loc_tsErrorConfigDesc: Record<Locale, string> = {
	ar: `لا يمكن تشغيل التحقق من صحة الرواتب لأن إعداد المشروع المطلوب مفقود.`,
	de: `Die Lohnabrechnungsvalidierung kann nicht durchgeführt werden, da die erforderliche Projektkonfiguration fehlt.`,
	es: `La validación de nóminas no puede ejecutarse porque falta la configuración requerida del proyecto.`,
	fa: `اعتبارسنجی حقوق و دستمزد قابل اجرا نیست زیرا پیکربندی پروژه مورد نیاز وجود ندارد.`,
	fil: `Hindi maaaring tumakbo ang pagpapatunay ng payroll dahil nawawala ang kinakailangang pagsasaayos ng proyekto.`,
	fr: `La validation de la paie ne peut pas s’exécuter car la configuration requise du projet manque.`,
	hi: `भुगतान संबधी मान्यता नहीं चल सकती क्योंकि आवश्यक प्रोजेक्ट कॉन्फ़िगरेशन अनुपलब्ध है।`,
	ht: `Validation pewòl pa ka kouri paske konfigirasyon pwojè mande yo manke.`,
	it: `La validazione delle buste paga non può essere eseguita perché manca la configurazione richiesta del progetto.`,
	ja: `必要なプロジェクト構成が欠落しているため、給与検証は実行できません。`,
	ko: `급여 검증은 필요한 프로젝트 구성이 없어 실행될 수 없습니다.`,
	mww: `Payroll validation tsis tuaj yeem khiav vim tias qhov yuav tsum tau teeb tsa qhov project yog ploj lawm.`,
	ps: `د معاش تصدیق نشی چلول ځکه چې اړین پروژه تنظیم نشته.`,
	pt: `A validação de folha de pagamento não pode ser executada porque falta a configuração necessária do projeto.`,
	'pt-pt': `A validação de salários não pode ser executada porque falta a configuração necessária do projeto.`,
	ru: `Валидация заработной платы не может быть выполнена, потому что отсутствует необходимая конфигурация проекта.`,
	sm: `E le mafai ona faagaoioia le faamaoniga o le totogi ona o loo misi le faatulagaga o le galuega faatino e manaomia.`,
	so: `Hubinta mushaharka ma socon karto sababtoo ah qaabeynta mashruuca ee loo baahan yahay waa maqan tahay.`,
	th: `การตรวจสอบความถูกต้องของบัญชีเงินเดือนไม่สามารถทํางานได้เนื่องจากไม่มีการตั้งค่าคอนฟิกโครงการที่จําเป็น`,
	ur: `پے رول ویلیڈیشن نہیں چل سکتی کیونکہ مطلوبہ پروجیکٹ کنفیگریشن موجود نہیں ہے۔`,
	vi: `Xác thực bảng lương không thể chạy vì thiếu cấu hình dự án bắt buộc.`,
	'zh-hans': `工资验证无法运行，因为缺少所需的项目配置。`,
	'zh-hant': `薪資驗證無法執行，因為缺少所需的專案設定。`,
	en: `Payroll validation cannot run because required project configuration is missing.`
};

export const loc_tsErrorConfigName: Record<Locale, string> = {
	ar: `خطأ في تكوين الرواتب`,
	de: `Konfigurationsfehler in der Lohnabrechnung`,
	es: `Error de configuración de nómina`,
	fa: `خطای پیکربندی حقوق و دستمزد`,
	fil: `Error sa pagsasaayos ng payroll`,
	fr: `Erreur de configuration de la paie`,
	hi: `पेरोल कॉन्फ़िगरेशन त्रुटि`,
	ht: `Erè konfigirasyon pewòl`,
	it: `Errore di configurazione del libro paga`,
	ja: `給与設定エラー`,
	ko: `급여 구성 오류`,
	mww: `Them nyiaj teeb tsa yuam kev`,
	ps: `د معاش لیست تنظیم تېروتنه`,
	pt: `Erro de configuração da folha de pagamento`,
	'pt-pt': `Erro de configuração da folha de pagamento`,
	ru: `Ошибка настройки расчета заработной платы`,
	sm: `Mea sese i le faatulagaga o le totogi`,
	so: `Khalad qaabeynta mushaharka`,
	th: `ข้อผิดพลาดในการกําหนดค่าเงินเดือน`,
	ur: `پے رول کنفیگریشن کی غلطی`,
	vi: `Lỗi cấu hình bảng lương`,
	'zh-hans': `工资配置错误`,
	'zh-hant': `薪資設定錯誤`,
	en: `Payroll configuration error`
};

export const loc_tsErrorDuplicateTimesheetDesc: Record<Locale, string> = {
	ar: `هناك جدول زمني آخر لنفس الموظف، وصاحب العمل، وفترة الراتب.`,
	de: `Es gibt einen weiteren Stundenzettel für denselben Mitarbeiter, Arbeitgeber und Gehaltszeitraum.`,
	es: `Hay otra hoja de horas para el mismo empleado, empleador y periodo de pago.`,
	fa: `یک برگه زمانی دیگر برای همان کارمند، کارفرما و دوره پرداخت وجود دارد.`,
	fil: `May isa pang timesheet para sa parehong empleyado, employer, at pay period.`,
	fr: `Il existe une autre feuille de temps pour le même employé, employeur et période de paie.`,
	hi: `एक ही कर्मचारी, नियोक्ता और वेतन अवधि के लिए एक और समय पत्रक है।`,
	ht: `Gen yon lòt Fèy tan pou menm anplwaye, anplwayè, ak peryòd peye.`,
	it: `C'è un altro foglio orario per lo stesso dipendente, datore di lavoro e periodo di paga.`,
	ja: `同じ従業員、雇用主、給与期間の別のタイムシートがあります。`,
	ko: `같은 직원, 고용주, 급여 기간에 대한 또 다른 근무 시간표가 있습니다.`,
	mww: `Muaj lwm daim ntawv teev sij hawm rau tib tug neeg ua hauj lwm, tus tswv hauj lwm, thiab lub sij hawm them nyiaj.`,
	ps: `د هماغه کارکوونکی، کارګمارونکی، او د معاش دورې لپاره بله وخت پاڼه هم شته.`,
	pt: `Existe outra folha de ponto para o mesmo empregado, empregador e período de pagamento.`,
	'pt-pt': `Existe outra folha de horas para o mesmo empregado, empregador e período de pagamento.`,
	ru: `Есть ещё один табель рабочего времени для того же сотрудника, работодателя и платёжного периода.`,
	sm: `O loo i ai se isi pepa o taimi mo le tagata faigaluega lava lea e tasi, pule o le galuega, ma le vaitaimi o totogi.`,
	so: `Waxaa jira jadwal kale oo shaqo oo loogu talagalay isla shaqaalaha, shaqo-bixiyaha, iyo muddada mushaharka.`,
	th: `มีไทม์ชีทอื่นสําหรับพนักงาน นายจ้าง และงวดการจ่ายเงินเดียวกัน`,
	ur: `اسی ملازم، آجر، اور تنخواہ کی مدت کے لیے ایک اور ٹائم شیٹ بھی ہے۔`,
	vi: `Có một bảng chấm công khác cho cùng một nhân viên, người sử dụng lao động và kỳ trả lương.`,
	'zh-hans': `同一员工、雇主和工资周期还有另一份工时表。`,
	'zh-hant': `同一員工、雇主和薪資期間還有另一張工時表。`,
	en: `There is another timesheet for the same employee, employer, and pay period.`
};

export const loc_tsErrorDuplicateTimesheetName: Record<Locale, string> = {
	ar: `جدول زمني مكرر`,
	de: `Doppelter Stundenzettel`,
	es: `Hoja de horas duplicada`,
	fa: `جدول زمانی تکراری`,
	fil: `Duplicate timesheet`,
	fr: `Feuille de temps dupliquée`,
	hi: `डुप्लिकेट टाइमशीट`,
	ht: `Fèy tan kopi`,
	it: `Foglio orario duplicato`,
	ja: `重複タイムシート`,
	ko: `중복 근무 시간표`,
	mww: `Daim ntawv qhia sijhawm theej tawm`,
	ps: `تکراری وخت پاڼه`,
	pt: `Folha de ponto duplicada`,
	'pt-pt': `Folha de horas duplicada`,
	ru: `Дублирующий табель рабочего времени`,
	sm: `Pepa o taimi faaluaina`,
	so: `Jadwalka waqtiga ee la isku dayo`,
	th: `ไทม์ชีทที่ซ้ํากัน`,
	ur: `ڈپلیکیٹ ٹائم شیٹ`,
	vi: `Bảng chấm công trùng lặp`,
	'zh-hans': `重复工时表`,
	'zh-hant': `重複工時表`,
	en: `Duplicate timesheet`
};

export const loc_tsErrorEmployeeNotActiveOnWorkDateDesc: Record<Locale, string> = {
	ar: `تاريخ العمل ليس ضمن تاريخ بدء ونهاية سجل الموظف.`,
	de: `Das Arbeitsdatum ist nicht in den Anfangs- und Enddaten der Mitarbeiter enthalten.`,
	es: `La fecha de trabajo no está dentro de las fechas de inicio y finalización del registro de empleados.`,
	fa: `تاریخ کاری در تاریخ شروع و پایان سوابق کارکنان نیست.`,
	fil: `Ang petsa ng trabaho ay wala sa loob ng mga petsa ng pagsisimula at pagtatapos ng talaan ng empleyado.`,
	fr: `La date de travail ne figure pas dans les dates de début et de fin des dossiers des employés.`,
	hi: `कार्य तिथि कर्मचारी रिकॉर्ड प्रारंभ और समाप्ति तिथियों के भीतर नहीं है।`,
	ht: `Dat travay la pa nan dat kòmansman ak fen dosye anplwaye yo.`,
	it: `La data di lavoro non rientra nelle date di inizio e fine del registro dei dipendenti.`,
	ja: `作業日は従業員記録の開始日と終了日の中には含まれていません。`,
	ko: `근무일은 직원 기록의 시작일과 종료일에 포함되어 있지 않습니다.`,
	mww: `Hnub ua hauj lwm tsis nyob rau hauv cov neeg ua hauj lwm cov ntaub ntawv pib thiab hnub xaus.`,
	ps: `د کار نېټه د کارکوونکو د پیل او پای نیټو کې نه ده.`,
	pt: `A data de trabalho não está dentro das datas de início e término do registro do funcionário.`,
	'pt-pt': `A data de trabalho não está dentro das datas de início e fim do registo do funcionário.`,
	ru: `Дата работы не указана в дате начала и окончания записи сотрудников.`,
	sm: `O le aso faigaluega e le o i totonu o le faamaumauga o le tagata faigaluega aso amata ma aso faamutaina.`,
	so: `Taariikhda shaqada kuma jirto taariikhaha bilowga iyo dhammaadka diiwaanka shaqaalaha.`,
	th: `วันที่ทํางานไม่อยู่ภายในวันที่เริ่มต้นและวันที่สิ้นสุดของเรกคอร์ดพนักงาน`,
	ur: `کام کی تاریخ ملازمین کے ریکارڈ کے آغاز اور اختتام کی تاریخوں میں شامل نہیں ہے۔`,
	vi: `Ngày làm việc không nằm trong ngày bắt đầu và ngày kết thúc bản ghi nhân viên.`,
	'zh-hans': `工作日期不在员工记录的开始和结束日期内。`,
	'zh-hant': `工作日期不在員工紀錄的開始與結束日期內。`,
	en: `The work date is not within the employee record start and end dates.`
};

export const loc_tsErrorEmployeeNotActiveOnWorkDateName: Record<Locale, string> = {
	ar: `الموظف غير نشط في موعد العمل`,
	de: `Mitarbeiter am Arbeitstag nicht aktiv`,
	es: `Empleado no activo en la fecha de trabajo`,
	fa: `کارمند در تاریخ کاری فعال نیست`,
	fil: `Hindi aktibo ang empleyado sa petsa ng trabaho`,
	fr: `Employé non actif à la date de travail`,
	hi: `कर्मचारी कार्य तिथि पर सक्रिय नहीं है`,
	ht: `Anplwaye pa aktif nan dat travay`,
	it: `Dipendente non attivo durante la data di lavoro`,
	ja: `勤務日に従業員が活動していない`,
	ko: `근무일에 활동하지 않은 직원`,
	mww: `Tus neeg ua hauj lwm tsis ua hauj lwm rau hnub ua hauj lwm`,
	ps: `کارکوونکی د کار په نېټه فعال نه دی`,
	pt: `Funcionário não ativo na data de trabalho`,
	'pt-pt': `Funcionário não ativo na data de trabalho`,
	ru: `Сотрудник не активен в день работы`,
	sm: `E le o toaga le tagata faigaluega i le aso faigaluega`,
	so: `Shaqaale aan firfircoonayn maalinta shaqada`,
	th: `พนักงานไม่ทํางานในวันที่ทํางาน`,
	ur: `ملازم کام کی تاریخ پر فعال نہیں`,
	vi: `Nhân viên không hoạt động vào ngày làm việc`,
	'zh-hans': `员工在工作日期未被激活`,
	'zh-hant': `員工在工作日期未在職`,
	en: `Employee not active on work date`
};

export const loc_tsErrorEmployerNotActiveOnWorkDateDesc: Record<Locale, string> = {
	ar: `تاريخ العمل ليس ضمن تاريخ بدء ونهاية سجل صاحب العمل.`,
	de: `Das Arbeitsdatum ist nicht in den Anfangs- und Enddaten des Arbeitgebers enthalten.`,
	es: `La fecha de trabajo no está dentro de las fechas de inicio y finalización del registro del empleador.`,
	fa: `تاریخ کاری در تاریخ شروع و پایان سوابق کارفرما نیست.`,
	fil: `Ang petsa ng trabaho ay wala sa loob ng mga petsa ng pagsisimula at pagtatapos ng employer record.`,
	fr: `La date de travail ne figure pas dans les dates de début et de fin des dossiers de l’employeur.`,
	hi: `कार्य तिथि नियोक्ता रिकॉर्ड प्रारंभ और समाप्ति तिथियों के भीतर नहीं है।`,
	ht: `Dat travay la pa nan dat kòmansman ak fen dosye anplwayè a.`,
	it: `La data di lavoro non rientra nelle date di inizio e fine del registro del datore di lavoro.`,
	ja: `勤務日は雇用主記録の開始日と終了日の中に含まれていません。`,
	ko: `근무일은 고용주 기록의 시작일과 종료일에 포함되어 있지 않습니다.`,
	mww: `Hnub ua hauj lwm tsis nyob rau hauv qhov chaw ua hauj lwm cov ntaub ntawv pib thiab xaus.`,
	ps: `د کار نیټه د کارګمارونکی د ریکارډ د پیل او پای نیټو کې نه ده.`,
	pt: `A data de trabalho não está dentro do registro do empregador, datas de início e término.`,
	'pt-pt': `A data de trabalho não está dentro do registo do empregador, datas de início e término.`,
	ru: `Дата работы не соответствует дате начала и окончания в записи работодателя.`,
	sm: `O le aso faigaluega e le o i totonu o le faamaumauga o le falefaigaluega o aso amata ma aso e faaiu ai.`,
	so: `Taariikhda shaqada kuma jirto taariikhaha bilowga iyo dhammaadka diiwaanka shaqo-bixiyaha.`,
	th: `วันที่ทํางานไม่อยู่ภายในวันที่เริ่มต้นและวันที่สิ้นสุดของบันทึกนายจ้าง`,
	ur: `کام کی تاریخ آجر کے ریکارڈ کے آغاز اور اختتام کی تاریخوں میں شامل نہیں ہے۔`,
	vi: `Ngày làm việc không nằm trong ngày bắt đầu và ngày kết thúc hồ sơ của chủ lao động.`,
	'zh-hans': `工作日期不在雇主记录的开始和结束日期内。`,
	'zh-hant': `工作日期不在雇主紀錄的開始和結束日期內。`,
	en: `The work date is not within the employer record start and end dates.`
};

export const loc_tsErrorEmployerNotActiveOnWorkDateName: Record<Locale, string> = {
	ar: `صاحب العمل غير نشط في تاريخ العمل`,
	de: `Arbeitgeber am Arbeitstag nicht aktiv`,
	es: `El empleador no está activo en la fecha de trabajo`,
	fa: `کارفرما در تاریخ کاری فعال نیست`,
	fil: `Employer hindi aktibo sa petsa ng trabaho`,
	fr: `Employeur non actif lors de la date de travail`,
	hi: `नियोक्ता कार्य तिथि पर सक्रिय नहीं है`,
	ht: `Anplwayè pa aktif nan dat travay`,
	it: `Datore di lavoro non attivo durante la data di lavoro`,
	ja: `勤務日に勤務していない雇用主`,
	ko: `근무일에 고용주가 활동하지 않음`,
	mww: `Chaw ua hauj lwm tsis ua hauj lwm rau hnub ua hauj lwm`,
	ps: `کارګمارونکی د کار په ورځ فعال نه دی`,
	pt: `Empregador não ativo na data de trabalho`,
	'pt-pt': `Empregador não ativo na data de trabalho`,
	ru: `Работодатель не активен в день работы`,
	sm: `E le o toaga le pule o le galuega i le aso faigaluega`,
	so: `Shaqaaluhu ma firfircoon taariikhda shaqada`,
	th: `นายจ้างไม่ทํางานในวันที่ทํางาน`,
	ur: `آجر کام کی تاریخ پر فعال نہیں ہے`,
	vi: `Người sử dụng lao động không hoạt động vào ngày làm việc`,
	'zh-hans': `雇主在工作日期未在职`,
	'zh-hant': `雇主在工作日期未在職`,
	en: `Employer not active on work date`
};

export const loc_tsErrorExceedsAuthorizationAmountDesc: Record<Locale, string> = {
	ar: `المصروفات التراكمية لصاحب العمل لهذه التفويض أكبر من المبلغ المصرح به.`,
	de: `Die kumulierte Arbeitgeberkosten für diese Dienstgenehmigung sind höher als der genehmigte Betrag.`,
	es: `El gasto acumulado del empleador para esta autorización de servicio es mayor que la cantidad autorizada.`,
	fa: `هزینه تجمعی کارفرما برای این مجوز خدمات بیشتر از مبلغ مجاز است.`,
	fil: `Ang pinagsama-samang gastusin ng employer para sa pahintulot sa serbisyong ito ay mas malaki kaysa sa awtorisadong halaga.`,
	fr: `La charge cumulée de l’employeur pour cette autorisation de service est supérieure au montant autorisé.`,
	hi: `इस सेवा प्राधिकरण के लिए संचयी नियोक्ता व्यय अधिकृत राशि से अधिक है।`,
	ht: `Depans anplwayè kimilatif pou otorizasyon sèvis sa a pi gran pase kantite lajan otorize a.`,
	it: `La spesa cumulativa del datore di lavoro per questa autorizzazione al servizio è superiore all'importo autorizzato.`,
	ja: `このサービス承認のための雇用主の累積費用は、認可された金額を上回っています。`,
	ko: `이 서비스 승인에 대한 고용주 누적 비용이 승인된 금액보다 많습니다.`,
	mww: `Tus tswv hauj lwm cov nqi rau qhov kev tso cai no yog ntau tshaj qhov uas tau tso cai.`,
	ps: `د دې خدمت اجازه لپاره د کارګمارونکی ټولیز لګښت د مجاز مقدار څخه زیات دی.`,
	pt: `A despesa acumulada do empregador para essa autorização de serviço é maior do que o valor autorizado.`,
	'pt-pt': `A despesa acumulada do empregador para esta autorização de serviço é superior ao montante autorizado.`,
	ru: `Совокупные расходы работодателя на это разрешение превышают разрешённую сумму.`,
	sm: `O le aofaiga o tupe faaalu a le falefaigaluega mo lenei faatagaga o le auaunaga e sili atu nai lo le aofaiga ua faatagaina.`,
	so: `Kharashka guud ee shaqo-bixiyaha ee oggolaanshaha adeeggan waa ka badan yahay qadarka la oggol yahay.`,
	th: `ค่าใช้จ่ายสะสมของนายจ้างสําหรับการอนุมัติบริการนี้มากกว่าจํานวนเงินที่ได้รับอนุญาต`,
	ur: `اس سروس آتھورائزیشن کے لیے مجموعی آجر کا خرچ مجاز رقم سے زیادہ ہے۔`,
	vi: `Chi phí tích lũy của người sử dụng lao động cho việc ủy quyền dịch vụ này lớn hơn số tiền được ủy quyền.`,
	'zh-hans': `雇主为该服务授权所产生的累计费用高于授权金额。`,
	'zh-hant': `雇主為此服務授權所支付的累積費用超過核准金額。`,
	en: `The cumulative employer expense for this service authorization is greater than the authorized amount.`
};

export const loc_tsErrorExceedsAuthorizationAmountName: Record<Locale, string> = {
	ar: `مبلغ التفويض الذي تجاوز`,
	de: `Genehmigungsbetrag überschritten`,
	es: `Cantidad de autorización superada`,
	fa: `مبلغ مجاز تجاوز شده است`,
	fil: `Lumampas sa halaga ng awtorisasyon`,
	fr: `Montant d’autorisation dépassé`,
	hi: `प्राधिकरण राशि पार हो गई`,
	ht: `Kantite otorizasyon depase`,
	it: `Somma di autorizzazione superata`,
	ja: `承認金額超過`,
	ko: `승인 금액 초과`,
	mww: `Tus nqi tso cai tshaj`,
	ps: `د اجازې اندازه زیاته شوې`,
	pt: `Valor da autorização excedido`,
	'pt-pt': `Montante de autorização excedido`,
	ru: `Сумма авторизации превышена`,
	sm: `Ua silia le aofaiga o le faatagaga`,
	so: `Tirada oggolaanshuhu wuu dhaafay`,
	th: `เกินจํานวนเงินอนุมัติ`,
	ur: `اجازت کی رقم سے تجاوز کر گئی`,
	vi: `Vượt quá số tiền ủy quyền`,
	'zh-hans': `授权金额超支`,
	'zh-hant': `授權金額超過。`,
	en: `Authorization amount exceeded`
};

export const loc_tsErrorExceedsCapAmountDesc: Record<Locale, string> = {
	ar: `المصروفات التراكمية على صاحب العمل للحد الأقصى المطبق أكبر من مبلغ الحد الأعلى المحدد.`,
	de: `Die kumulierten Arbeitgeberkosten für die betreffende Obergrenze sind höher als der Obergrenzbetrag.`,
	es: `El gasto acumulado del empleador para el tope aplicable es mayor que el importe del tope salarial.`,
	fa: `هزینه تجمعی کارفرما برای سقف قابل اعمال بیشتر از مبلغ سقف است.`,
	fil: `Ang pinagsama-samang gastusin ng employer para sa naaangkop na cap ay mas malaki kaysa sa halaga ng cap.`,
	fr: `La charge cumulée de l’employeur pour le plafond applicable est supérieure au montant du plafond.`,
	hi: `लागू कैप के लिए संचयी नियोक्ता व्यय कैप राशि से अधिक है।`,
	ht: `Depans anplwayè kimilatif pou plafon aplikab la pi gran pase kantite lajan an bouchon.`,
	it: `La spesa cumulativa del datore di lavoro per il tetto applicabile è superiore all'importo del cap.`,
	ja: `適用される上限の累積雇用主費用は上限額を上回ります。`,
	ko: `적용 상한선에 대한 누적 고용주 비용이 상한선 금액보다 큽니다.`,
	mww: `Tus nqi ntawm tus tswv hauj lwm rau qhov siv tau yog ntau dua tus nqi cap.`,
	ps: `د تطبیق شوی حد لپاره د کارګمارونکی ټولیز لګښت د حد له حد څخه زیات دی.`,
	pt: `A despesa acumulada do empregador para o teto aplicável é maior que o valor do teto.`,
	'pt-pt': `A despesa acumulada do empregador para o limite aplicável é superior ao montante do teto.`,
	ru: `Совокупные расходы работодателя по применимому лимиту превышают сумму потолка.`,
	sm: `O le aofaiga o tupe faaalu a le falefaigaluega mo le tapulaa e faatatau i ai e sili atu nai lo le aofaiga o le tapulaa.`,
	so: `Kharashka guud ee shaqo-bixiyaha ee xadka la khuseeyo waa ka badan yahay xadka.`,
	th: `ค่าใช้จ่ายสะสมของนายจ้างสําหรับเพดานที่เกี่ยวข้องมากกว่าจํานวนเงินสูงสุด`,
	ur: `قابل اطلاق حد کے لیے مجموعی آجر کا خرچ کیپ کی رقم سے زیادہ ہوتا ہے۔`,
	vi: `Chi phí tích lũy của chủ lao động cho giới hạn áp dụng lớn hơn số tiền giới hạn.`,
	'zh-hans': `适用上限的累计雇主费用大于上限金额。`,
	'zh-hant': `適用上限的累積雇主費用高於上限金額。`,
	en: `The cumulative employer expense for the applicable cap is greater than the cap amount.`
};

export const loc_tsErrorExceedsCapAmountName: Record<Locale, string> = {
	ar: `مبلغ الحد الأقصى الذي تم تجاوزه`,
	de: `Obergrenze überschritten`,
	es: `Mayor cantidad de tope salarial`,
	fa: `سقف سقف تجاوز شده`,
	fil: `Lumampas ang halaga ng cap`,
	fr: `Montant du plafond dépassé`,
	hi: `कैप राशि पार हो गई`,
	ht: `Limit kantite lajan depase`,
	it: `Somma del tetto massimo superata`,
	ja: `上限額超過`,
	ko: `상한선 초과`,
	mww: `Cap npaum li cas tshaj`,
	ps: `د حد حد څخه زیات شوی`,
	pt: `Valor do teto salarial ultrapassado`,
	'pt-pt': `Valor do teto salarial ultrapassado`,
	ru: `Сумма потолка превышена`,
	sm: `O le aofaiga o le tapulaa ua sili atu`,
	so: `Xadka xadka la dhaafay`,
	th: `เกินจํานวนสูงสุดที่กําหนด`,
	ur: `کیپ کی رقم سے تجاوز کر گئی`,
	vi: `Vượt quá số tiền giới hạn`,
	'zh-hans': `超过上限金额`,
	'zh-hant': `上限超過上限`,
	en: `Cap amount exceeded`
};

export const loc_tsErrorExceedsDailyHourLimitDesc: Record<Locale, string> = {
	ar: `ولاية العمل هي الإقامة الدائمة أو الرقم السادس، وعمل الموظف أكثر من 8 ساعات إجمالية في هذا التاريخ.`,
	de: `Der Arbeitszustand ist PR oder VI, und der Mitarbeiter arbeitete an diesem Tag insgesamt mehr als 8 Stunden.`,
	es: `El estado laboral es PR o VI, y el empleado trabajó más de 8 horas en total en esa fecha.`,
	fa: `وضعیت کاری PR یا VI است و کارمند در این تاریخ بیش از ۸ ساعت کار کرده است.`,
	fil: `Ang estado ng trabaho ay PR o VI, at ang empleyado ay nagtrabaho ng higit sa 8 kabuuang oras sa petsang ito.`,
	fr: `L’État de travail est PR ou VI, et l’employé a travaillé plus de 8 heures au total à cette date.`,
	hi: `कार्य स्थिति पीआर या VI है, और कर्मचारी ने इस तिथि पर कुल 8 घंटे से अधिक काम किया।`,
	ht: `Eta travay la se PR oswa VI ak anplwaye a te travay plis pase 8 èdtan total nan dat sa a.`,
	it: `Lo stato lavorativo è PR o VI, e il dipendente ha lavorato più di 8 ore totali in questa data.`,
	ja: `労働州はPRまたはVIであり、従業員はこの日に合計8時間以上勤務していました。`,
	ko: `근무 상태는 PR 또는 VI이며, 해당 날짜에 총 8시간 이상 근무했습니다.`,
	mww: `Lub xeev ua haujlwm yog PR lossis VI, thiab tus neeg ua haujlwm tau ua haujlwm ntau dua 8 teev tag nrho rau hnub no.`,
	ps: `د کار ایالت PR یا VI دی، او کارکوونکی په دې نېټه له ۸ ساعتونو زیات کار کړی دی.`,
	pt: `O estado de trabalho é PR ou VI, e o funcionário trabalhou mais de 8 horas no total nessa data.`,
	'pt-pt': `O estado de trabalho é PR ou VI, e o funcionário trabalhou mais de 8 horas no total nessa data.`,
	ru: `Рабочее состояние — PR или VI, и сотрудник отработал более 8 часов в общей сложности на этот день.`,
	sm: `O le tulaga o le galuega o le PR po'o le VI, ma o le tagata faigaluega na galue i le sili atu i le 8 itula atoa i lenei aso.`,
	so: `Xaaladda shaqada waa PR ama VI, shaqaalahuna wuxuu shaqeeyay in ka badan 8 saacadood guud ahaan taariikhdan.`,
	th: `สถานะการทํางานคือ PR หรือ VI และพนักงานทํางานรวมมากกว่า 8 ชั่วโมงในวันที่นี้`,
	ur: `کام کی حالت PR یا VI ہے، اور ملازم نے اس تاریخ کو کل 8 گھنٹے سے زیادہ کام کیا۔`,
	vi: `Trạng thái làm việc là PR hoặc VI và nhân viên đã làm việc tổng cộng hơn 8 giờ vào ngày này.`,
	'zh-hans': `工作状态为永久居民（PR）或第六状态（VI），且员工在该日期总共工作超过8小时。`,
	'zh-hant': `工作狀態為永久居民（PR）或第六狀態（VI），且該員工在該日期總共工作超過8小時。`,
	en: `The work state is PR or VI, and the employee worked more than 8 total hours on this date.`
};

export const loc_tsErrorExceedsDailyHourLimitName: Record<Locale, string> = {
	ar: `تجاوز حد ساعات العمل اليومية`,
	de: `Tagesstundenlimit überschritten`,
	es: `Se supera el límite diario de horas`,
	fa: `تجاوز از محدودیت ساعات کاری روزانه`,
	fil: `Araw-araw na limitasyon ng oras na lumampas`,
	fr: `Limite d’heures quotidienne dépassée`,
	hi: `दैनिक घंटे की सीमा पार हो गई`,
	ht: `Limite èdtan chak jou depase`,
	it: `Limite giornaliero di ore superato`,
	ja: `1日の時間制限を超えました`,
	ko: `일일 시간 제한 초과`,
	mww: `Txhua hnub teev txwv dhau`,
	ps: `د ورځنی ساعت حد څخه زیات شوی`,
	pt: `Limite diário de horas ultrapassado`,
	'pt-pt': `Limite diário de horas ultrapassado`,
	ru: `Превышен дневной часовой лимит`,
	sm: `Ua silia le tapulaa o itula i aso taitasi`,
	so: `Xadka saacadda maalinlaha ah waa la dhaafay`,
	th: `เกินขีดจํากัดชั่วโมงรายวัน`,
	ur: `روزانہ کے گھنٹے کی حد سے تجاوز`,
	vi: `Vượt quá giới hạn giờ hàng ngày`,
	'zh-hans': `每日工作时间限制`,
	'zh-hant': `每日時數超過時數`,
	en: `Daily hour limit exceeded`
};

export const loc_tsErrorHospitalizationDesc: Record<Locale, string> = {
	ar: `موعد العمل يصادف أثناء دخول المستشفى، بعد الدخول وقبل الخروج.`,
	de: `Der Arbeitstermin fällt während eines Krankenhausaufenthalts, nach der Aufnahme und vor der Entlassung.`,
	es: `La fecha de trabajo se realiza durante la hospitalización, después del ingreso y antes del alta.`,
	fa: `تاریخ کاری در زمان بستری شدن در بیمارستان، پس از پذیرش و قبل از ترخیص تعیین می شود.`,
	fil: `Ang petsa ng trabaho ay bumabagsak sa panahon ng pag-ospital, pagkatapos ng pagpasok at bago ang paglabas.`,
	fr: `La date de travail tombe pendant une hospitalisation, après l’admission et avant la sortie.`,
	hi: `काम की तारीख अस्पताल में भर्ती होने के दौरान, प्रवेश के बाद और छुट्टी से पहले आती है।`,
	ht: `Dat travay la tonbe pandan yon lopital, apre admisyon ak anvan egzeyate.`,
	it: `La data di lavoro cade durante il ricovero, dopo il ricovero e prima della dimissione.`,
	ja: `作業日は入院中、入院後、退院前に該当します。`,
	ko: `근무 날짜는 입원 중, 입원 후, 퇴원 전입니다.`,
	mww: `Hnub ua haujlwm poob rau thaum mus pw hauv tsev kho mob, tom qab nkag mus thiab ua ntej tawm mus.`,
	ps: `د کار نیټه د روغتون ته د بستو پر مهال، د داخلېدو وروسته او له رخصتۍ مخکې راځی.`,
	pt: `A data de trabalho ocorre durante a hospitalização, após a internação e antes da alta.`,
	'pt-pt': `A data de trabalho ocorre durante uma hospitalização, após a admissão e antes da alta.`,
	ru: `Дата работы приходится на время госпитализации, после госпитализации и до выписки.`,
	sm: `O le aso faigaluega e pa'ū i le taimi o le falema'i, pe a mae'a le ulufale ma a'o le'i fa'amalolo.`,
	so: `Taariikhda shaqada waxay ku beegantaa inta lagu jiro isbitaal, ka dib gelitaanka iyo ka hor inta aan la sii deyn.`,
	th: `วันที่ทํางานตรงกับระหว่างการรักษาตัวในโรงพยาบาล หลังเข้ารับการรักษา และก่อนออกจากโรงพยาบาล`,
	ur: `کام کی تاریخ ہسپتال میں داخلے کے دوران، داخلے کے بعد اور ڈسچارج سے پہلے آتی ہے۔`,
	vi: `Ngày làm việc rơi vào thời gian nhập viện, sau khi nhập viện và trước khi xuất viện.`,
	'zh-hans': `工作日期是在住院期间、入院后和出院前。`,
	'zh-hant': `工作日期落在住院期間、入院後及出院前。`,
	en: `The work date falls during a hospitalization, after admission and before discharge.`
};

export const loc_tsErrorHospitalizationName: Record<Locale, string> = {
	ar: `الدخول إلى المستشفى`,
	de: `Krankenhausaufenthalt`,
	es: `Hospitalización`,
	fa: `بستری شدن`,
	fil: `Pag-ospital`,
	fr: `Hospitalisation`,
	hi: `अस्पताल में भर्ती`,
	ht: `Hospitalisation`,
	it: `Ricovero`,
	ja: `入院`,
	ko: `입원`,
	mww: `Mus pw hauv tsev kho mob`,
	ps: `روغتون ته داخلېدل`,
	pt: `Hospitalização`,
	'pt-pt': `Hospitalização`,
	ru: `Госпитализация`,
	sm: `Falema'i`,
	so: `Isbitaal`,
	th: `การรักษาในโรงพยาบาล`,
	ur: `ہسپتال میں داخل ہونا`,
	vi: `Nhập viện`,
	'zh-hans': `住院`,
	'zh-hant': `住院`,
	en: `Hospitalization`
};

export const loc_tsErrorMissingEmployeeI9Desc: Record<Locale, string> = {
	ar: `لا يوجد نموذج I-9 قيد التنفيذ أو مكتمل يغطي تاريخ العمل، مع الأخذ في الاعتبار أي تاريخ مصرح به للعمل حتى الوصول.`,
	de: `Kein laufender oder abgeschlossener I-9 deckt das Arbeitsdatum ab, wobei ein bis zu arbeitendes Datum genehmigt wird.`,
	es: `Ninguna fecha de trabajo en curso o completada de la I-9 cubre la fecha de trabajo, considerando cualquier fecha autorizada para trabajar hasta la fecha de trabajo.`,
	fa: `هیچ I-9 در حال پیشرفت یا تکمیل شده تاریخ کار را پوشش نمی دهد، با در نظر گرفتن تاریخ مجاز به کار تا کار.`,
	fil: `Walang in-progress o nakumpleto na I-9 na sumasaklaw sa petsa ng trabaho, isinasaalang-alang ang anumang awtorisadong-to-work-hanggang petsa.`,
	fr: `Aucun I-9 en cours ou complété ne couvre la date de travail, en tenant compte de toute date autorisée à travailler jusqu’à présent.`,
	hi: `कोई भी प्रगति या पूर्ण I-9 कार्य तिथि को कवर नहीं करता है, किसी भी अधिकृत-से-कार्य-तिथि को ध्यान में रखते हुए।`,
	ht: `Pa gen okenn nan-pwogrè oswa ranpli I-9 kouvri dat travay la, konsidere nenpòt ki otorize-a-travay-jouk dat.`,
	it: `Nessun I-9 in corso o completato copre la data di lavoro, considerando qualsiasi data autorizzata a lavorare fino a quando.`,
	ja: `作業中または完了したI-9は、承認された作業期限を考慮してその作業日をカバーしません。`,
	ko: `작업 중이거나 완료된 I-9는 작업 날짜를 포함하지 않으며, 승인된 작업 가능 날짜를 고려할 때는 없습니다.`,
	mww: `Tsis muaj nyob rau hauv kev kawm los yog ua tiav I-9 them rau hnub ua hauj lwm, xav txog tej kev tso cai-rau-ua hauj lwm-txog rau hnub tim.`,
	ps: `هیڅ I-9 د کار نېټه نه پوره کوی او نه هم د کار نیټې پوښی.`,
	pt: `Nenhum I-9 em andamento ou concluído cobre a data de trabalho, considerando qualquer data autorizada para trabalhar até o trabalho.`,
	'pt-pt': `Nenhum I-9 em curso ou concluído cobre a data de trabalho, considerando qualquer data autorizada a trabalhar até até.`,
	ru: `Ни один незавершённый или завершённый I-9 не охватывает дату работы, учитывая дату с разрешением на работу до срока.`,
	sm: `E leai se I-9 o lo'o fa'aauau pe mae'a e aofia ai le aso faigaluega, mafaufau i so'o se aso fa'atagaina-e-galuega-se'ia o'o i le aso.`,
	so: `Ma jiro I-9 oo socday ama la dhammeystiray oo daboolaya taariikhda shaqada, iyadoo la tixgelinayo taariikhda la oggolaaday in la shaqeeyo.`,
	th: `ไม่มี I-9 ที่กําลังดําเนินการหรือเสร็จสมบูรณ์ครอบคลุมวันที่ทํางาน โดยพิจารณาจากวันที่ได้รับอนุญาตให้ทํางานจนถึง`,
	ur: `کوئی بھی جاری یا مکمل شدہ I-9 کام کی تاریخ کو کور نہیں کرتا، خاص طور پر کسی بھی مجاز کام کرنے کی تاریخ کو مدنظر رکھتے ہوئے۔`,
	vi: `Không có I-9 đang tiến hành hoặc đã hoàn thành bao gồm ngày làm việc, xem xét bất kỳ ngày nào được phép làm việc cho đến nay.`,
	'zh-hans': `任何正在进行或已完成的I-9表格都不涵盖工作日期，前提是任何授权工作至工作日期。`,
	'zh-hant': `任何進行中或已完成的I-9表格都不涵蓋該工作日期，考慮任何授權工作至日期。`,
	en: `No in-progress or completed I-9 covers the work date, considering any authorized-to-work-until date.`
};

export const loc_tsErrorMissingEmployeeI9Name: Record<Locale, string> = {
	ar: `الموظف المفقود I-9`,
	de: `Vermisster Mitarbeiter I-9`,
	es: `Empleado desaparecido I-9`,
	fa: `کارمند مفقود شده I-9`,
	fil: `Nawawalang empleyado I-9`,
	fr: `Employé disparu I-9`,
	hi: `लापता कर्मचारी I-9`,
	ht: `Anplwaye I-9 ki manke`,
	it: `Dipendente scomparso I-9`,
	ja: `行方不明の従業員I-9`,
	ko: `실종된 직원 I-9`,
	mww: `Tus neeg ua hauj lwm uas ploj lawm I-9`,
	ps: `ورک شوی کارکوونکی I-9`,
	pt: `Funcionário desaparecido I-9`,
	'pt-pt': `Funcionário desaparecido I-9`,
	ru: `Пропавший сотрудник I-9`,
	sm: `Tagata faigaluega o lo'o misi I-9`,
	so: `Shaqaale maqan I-9`,
	th: `I-9 พนักงานหายไป`,
	ur: `گمشدہ ملازم I-9`,
	vi: `Nhân viên I-9 mất tích`,
	'zh-hans': `失踪员工I-9`,
	'zh-hant': `失蹤員工I-9`,
	en: `Missing employee I-9`
};

export const loc_tsErrorMissingEmployeeRateDesc: Record<Locale, string> = {
	ar: `لا يغطي أي معدل أجر للموظف قيد التنفيذ أو إكمال تاريخ العمل.`,
	de: `Kein laufender oder abgeschlossener Mitarbeiterlohn deckt den Arbeitstermin ab.`,
	es: `Ninguna tasa salarial en curso o completada cubre la fecha de trabajo.`,
	fa: `هیچ نرخ پرداخت در حال پیشرفت یا تکمیل شده ای برای کارکنان تاریخ کاری را پوشش نمی دهد.`,
	fil: `Walang in-progress o nakumpleto na rate ng suweldo ng empleyado na sumasaklaw sa petsa ng trabaho.`,
	fr: `Aucun taux de rémunération en cours ou terminé ne couvre la date de travail.`,
	hi: `कोई भी प्रगति या पूर्ण कर्मचारी वेतन दर कार्य तिथि को कवर नहीं करती है।`,
	ht: `Pa gen yon pousantaj nan salè anplwaye ki an pwogrè oswa ranpli ki kouvri dat travay la.`,
	it: `Nessuna tariffa salariale in corso o completata copre la data di lavoro.`,
	ja: `進行中の給与や完了した従業員の給与は、その作業日をカバーしていません。`,
	ko: `진행 중이거나 완료된 직원 급여 요율은 근무일을 포함하지 않습니다.`,
	mww: `Tsis muaj tus nqi them rau cov neeg ua hauj lwm tiav los yog ua tiav them rau hnub ua hauj lwm.`,
	ps: `هیڅ د کارکوونکو د معاش په جریان کې یا بشپړ شوی نرخ د کار نیټه نه پوښی.`,
	pt: `Nenhuma taxa de remuneração em andamento ou concluída do funcionário cobre a data de trabalho.`,
	'pt-pt': `Nenhuma taxa salarial em curso ou concluída cobre a data de trabalho.`,
	ru: `Ни одна ставка оплаты сотрудника в процессе или завершения не охватывает дату работы.`,
	sm: `E leai se totogi o tagata faigaluega o lo'o fa'aauau pea pe fa'amae'aina e aofia ai le aso faigaluega.`,
	so: `Ma jiro heerka mushaharka shaqaalaha ee socda ama la dhammeystiray oo daboolaya taariikhda shaqada.`,
	th: `ไม่มีอัตราค่าจ้างของพนักงานที่กําลังดําเนินการหรือเสร็จสมบูรณ์ครอบคลุมวันที่ทํางาน`,
	ur: `کوئی بھی زیر تکمیل یا مکمل شدہ ملازم کی تنخواہ اس کام کی تاریخ کو کور نہیں کرتی۔`,
	vi: `Không có mức lương của nhân viên đang tiến hành hoặc đã hoàn thành bao gồm ngày làm việc.`,
	'zh-hans': `没有任何在工或已完成的员工工资标准覆盖工作日期。`,
	'zh-hant': `在工或完成的員工薪資標準不涵蓋該工作日期。`,
	en: `No in-progress or completed employee rate of pay covers the work date.`
};

export const loc_tsErrorMissingEmployeeRateName: Record<Locale, string> = {
	ar: `معدل الراتب المفقود للموظف`,
	de: `Vergütung fehlender Mitarbeiter`,
	es: `Tarifa salarial por empleados ausentes`,
	fa: `نرخ پرداخت کارکنان از دست رفته`,
	fil: `Nawawalang rate ng suweldo ng empleyado`,
	fr: `Taux de rémunération des employés absents`,
	hi: `वेतन की गुम कर्मचारी दर`,
	ht: `Rate salè anplwaye ki manke`,
	it: `Tasso di retribuzione per dipendente assente`,
	ja: `従業員の賃金率が見つからない`,
	ko: `직원 급여 요율 누락`,
	mww: `Tus nqi them nyiaj ntawm cov neeg ua haujlwm uas ploj lawm`,
	ps: `د کارکوونکو د معاش نه شتون`,
	pt: `Taxa salarial de funcionário ausente`,
	'pt-pt': `Taxa salarial de empregado ausente`,
	ru: `Отсутствующая ставка оплаты труда сотрудникам`,
	sm: `O le leai o se totogi o tagata faigaluega`,
	so: `Heerka mushaharka shaqaalaha maqan`,
	th: `อัตราค่าจ้างของพนักงานขาดหายไป`,
	ur: `ملازمین کی تنخواہ کی شرح کی کمی`,
	vi: `Thiếu tỷ lệ lương của nhân viên`,
	'zh-hans': `员工工资率缺失`,
	'zh-hant': `缺少員工薪資標準`,
	en: `Missing employee rate of pay`
};

export const loc_tsErrorMissingEmployeeServiceDesc: Record<Locale, string> = {
	ar: `لا يشمل أي تعيين للموظف أو الخدمة أو تاريخ العمل.`,
	de: `Keine Mitarbeiter-Service-Zuordnung deckt den Mitarbeiter-, Service- und Arbeitstermin ab.`,
	es: `Ninguna asignación de servicio al empleado cubre al empleado, el servicio y la fecha de trabajo.`,
	fa: `هیچ مأموریت خدماتی کارمند، خدمت و تاریخ کاری را پوشش نمی دهد.`,
	fil: `Walang pagtatalaga sa serbisyo ng empleyado na sumasaklaw sa empleyado, serbisyo, at petsa ng trabaho.`,
	fr: `Aucune affectation de service aux employés ne couvre l’employé, le service et la date de travail.`,
	hi: `कोई भी कर्मचारी-सेवा असाइनमेंट कर्मचारी, सेवा और कार्य तिथि को कवर नहीं करता है।`,
	ht: `Pa gen anplwaye-sèvis afektasyon ki kouvri dat anplwaye, sèvis ak travay.`,
	it: `Nessuna assegnazione di servizio al dipendente copre il dipendente, il servizio e la data di lavoro.`,
	ja: `従業員サービス割り当ては、従業員、勤務、勤務日をカバーしません。`,
	ko: `직원 서비스 할당은 직원, 근무 기간, 근무 날짜를 모두 포함하지 않습니다.`,
	mww: `Tsis muaj ib qho kev pabcuam rau tus neeg ua haujlwm, kev pabcuam, thiab hnub ua haujlwm.`,
	ps: `هیڅ کارکوونکی-خدمت ټاکنه د کارکوونکی، خدمت، او د کار نیټه نه پوښی.`,
	pt: `Nenhuma designação de serviço ao funcionário cobre o funcionário, o serviço e a data de trabalho.`,
	'pt-pt': `Nenhuma atribuição de serviço ao empregado cobre o empregado, o serviço e a data de trabalho.`,
	ru: `Ни одно назначение по службе не охватывает сотрудника, службу и дату работы.`,
	sm: `E leai se tofiga o auaunaga a tagata faigaluega e aofia ai le tagata faigaluega, auaunaga, ma le aso faigaluega.`,
	so: `Shaqo shaqaale ma daboolayso taariikhda shaqaalaha, adeegga, iyo taariikhda shaqada.`,
	th: `ไม่มีการมอบหมายบริการพนักงานครอบคลุมพนักงาน บริการ และวันที่ทํางาน`,
	ur: `کوئی بھی ملازم-سروس اسائنمنٹ ملازم، سروس اور کام کی تاریخ کو کور نہیں کرتی۔`,
	vi: `Không có phân công dịch vụ nhân viên nào bao gồm nhân viên, dịch vụ và ngày làm việc.`,
	'zh-hans': `没有任何员工服务任务涵盖员工、服务和工作日期。`,
	'zh-hant': `沒有任何員工服務任務涵蓋員工、服務及工作日期。`,
	en: `No employee-service assignment covers the employee, service, and work date.`
};

export const loc_tsErrorMissingEmployeeServiceName: Record<Locale, string> = {
	ar: `خدمة الموظفين المفقودة`,
	de: `Vermisste Mitarbeiterleistung`,
	es: `Servicio de empleados desaparecidos`,
	fa: `غیبت خدمات کارکنان`,
	fil: `Nawawalang serbisyo ng empleyado`,
	fr: `Service des employés disparus`,
	hi: `गुम कर्मचारी सेवा`,
	ht: `Sèvis anplwaye ki manke`,
	it: `Servizio per dipendenti assenti`,
	ja: `従業員サービスの欠落`,
	ko: `직원 서비스 누락`,
	mww: `Uas ploj lawm cov neeg ua hauj lwm kev pab cuam`,
	ps: `د ورک شوی کارکوونکی خدمت`,
	pt: `Serviço de funcionários desaparecidos`,
	'pt-pt': `Serviço de funcionários desaparecidos`,
	ru: `Отсутствующая служба сотрудников`,
	sm: `Auaunaga a tagata faigaluega o loo misi`,
	so: `Adeegga shaqaalaha maqan`,
	th: `บริการพนักงานขาดหายไป`,
	ur: `گمشدہ ملازم سروس`,
	vi: `Thiếu dịch vụ nhân viên`,
	'zh-hans': `缺失的员工服务`,
	'zh-hant': `員工服務缺失`,
	en: `Missing employee service`
};

export const loc_tsErrorMissingEmployeeStateWithholdingElectionDesc: Record<Locale, string> = {
	ar: `لا يوجد انتخابات اقتطاع حكومية قيد التنفيذ أو مكتملة تغطي تاريخ العمل مع المعلومات المطلوبة من الولاية.`,
	de: `Keine laufende oder abgeschlossene staatliche Mitarbeiter-Quellenwahl deckt das Arbeitsdatum mit den erforderlichen staatlichen Informationen ab.`,
	es: `Ninguna elección de retención estatal en curso o completada cubre la fecha de trabajo con la información estatal requerida.`,
	fa: `هیچ انتخابات در حال انجام یا تکمیل شده کسر ایالتی کارمند، تاریخ کاری با اطلاعات ایالتی مورد نیاز را پوشش نمی دهد.`,
	fil: `Walang in-progress o nakumpleto na employee state withholding election na sumasaklaw sa petsa ng trabaho na may kinakailangang impormasyon ng estado.`,
	fr: `Aucune retenue d’État en cours ou complétée par l’employé ne couvre la date de travail avec les informations requises sur l’État.`,
	hi: `कोई भी प्रगति या पूर्ण कर्मचारी राज्य चुनाव को रोकता है जो आवश्यक राज्य की जानकारी के साथ कार्य तिथि को कवर नहीं करता है।`,
	ht: `Pa gen okenn eleksyon ki fèt an pwogrè oswa ki ranpli leta anplwaye kouvri dat travay la ak enfòmasyon leta yo mande yo.`,
	it: `Nessuna elezione di ritenzione statale in corso o completata copre la data di lavoro con le informazioni statali richieste.`,
	ja: `進行中または完了した従業員の州の差し止め支払い選択は、必要な州情報を含む作業日をカバーしていません。`,
	ko: `진행 중이거나 완료된 직원 주 보류 선거는 근무일과 필요한 주 정보를 모두 포함하지 않습니다.`,
	mww: `Tsis muaj kev xaiv tsa ua haujlwm tiav lossis ua tiav ntawm cov neeg ua haujlwm hauv lub xeev them rau hnub ua haujlwm nrog cov ntaub ntawv hauv lub xeev uas yuav tsum tau ua.`,
	ps: `هیڅ روان یا بشپړ شوی کارکوونکو ایالت د مخنیوی ټاکنې د کار نیټه د اړینو ایالتی معلوماتو سره نه پوښی.`,
	pt: `Nenhuma eleição de retenção estadual em andamento ou concluída cobre a data de trabalho com as informações estaduais exigidas.`,
	'pt-pt': `Nenhuma eleição de retenção estadual em curso ou concluída cobre a data de trabalho com a informação estadual exigida.`,
	ru: `Ни один текущий или завершённый выбор по удержанию сотрудников не охватывает дату работы с необходимой информацией штата.`,
	sm: `E leai se palota o le taofia o le setete o tagata faigaluega e aofia ai le aso faigaluega ma fa'amatalaga mana'omia a le setete.`,
	so: `Ma jiro doorasho gobol oo shaqaale oo socota ama la dhammeystiray oo daboolaya taariikhda shaqada iyadoo la adeegsanayo macluumaadka gobolka ee loo baahan yahay.`,
	th: `ไม่มีการเลือกตั้งการหัก ณ ที่จ่ายของพนักงานที่กําลังดําเนินการหรือเสร็จสมบูรณ์ครอบคลุมวันที่ทํางานด้วยข้อมูลของรัฐที่จําเป็น`,
	ur: `کوئی بھی جاری یا مکمل شدہ ملازم ریاستی ودہولڈنگ انتخاب مطلوبہ ریاستی معلومات کے ساتھ کام کی تاریخ کو کور نہیں کرتا۔`,
	vi: `Không có cuộc bầu cử khấu lưu của tiểu bang nhân viên đang tiến hành hoặc đã hoàn thành bao gồm ngày làm việc với thông tin tiểu bang bắt buộc.`,
	'zh-hans': `没有任何正在进行或已完成的员工州预扣选择涵盖工作日期及所需州信息。`,
	'zh-hant': `任何進行中或已完成的員工州級預扣決定，都無法涵蓋工作日期及所需州資訊。`,
	en: `No in-progress or completed employee state withholding election covers the work date with the required state information.`
};

export const loc_tsErrorMissingEmployeeStateWithholdingElectionName: Record<Locale, string> = {
	ar: `الموظف المفقود في ولاية حجب الانتخابات`,
	de: `Fehlende staatliche Wahl zur Mitarbeiterabhaltung`,
	es: `Elección estatal de retención de empleado ausente`,
	fa: `ایالت از دست دادن رأی کارمندان`,
	fil: `Nawawalang empleyado estado withholding halalan`,
	fr: `Candidat à la retenue de l’État pour employé manquant`,
	hi: `लापता कर्मचारी राज्य चुनाव रोक रहा है`,
	ht: `Ki manke eleksyon leta anplwaye ki manke`,
	it: `Scelta di ritenzione statale per dipendenti assenti`,
	ja: `州の選出差し欠け`,
	ko: `누락된 직원 주 선거 보류`,
	mww: `Ploj lawm cov neeg ua hauj lwm lub xeev txiav kev xaiv tsa`,
	ps: `ورک شوی کارکوونکی د ایالت ټاکنې نه دی منع کړی`,
	pt: `Eleição estadual de retenção de empregado ausente`,
	'pt-pt': `Eleição estadual de retenção de empregado ausente`,
	ru: `Отсутствие штата «Сотрудник» (штат лишения выборов)`,
	sm: `Missing employee state withholding election`,
	so: `Doorashada shaqaalaha maqan ee gobolka`,
	th: `การเลือกตั้งหัก ณ ที่จ่ายของรัฐพนักงานที่ขาดหายไป`,
	ur: `لاپتہ ملازم ریاست میں انتخاب روک رہا ہے`,
	vi: `Bầu cử khấu lưu của tiểu bang nhân viên vắng mặt`,
	'zh-hans': `缺失的员工州级保留选举`,
	'zh-hant': `缺少員工州的州際選擇`,
	en: `Missing employee state withholding election`
};

export const loc_tsErrorMissingEmployeeW4Desc: Record<Locale, string> = {
	ar: `لا يغطي أي انتخابات اقتطاع فيدرالية للموظفين قيد التنفيذ أو مكتملة تاريخ العمل.`,
	de: `Keine laufende oder abgeschlossene bundesinterne Mitarbeiter-Abzugswahl deckt das Arbeitsdatum ab.`,
	es: `Ninguna elección de retención federal en curso o completada cubre la fecha de trabajo.`,
	fa: `هیچ انتخابات فدرال در حال انجام یا تکمیل شده برای کسر مالیات کارکنان تاریخ کاری را پوشش نمی دهد.`,
	fil: `Walang in-progress o nakumpleto na pederal na withholding election ng empleyado na sumasaklaw sa petsa ng trabaho.`,
	fr: `Aucune retenue fédérale en cours ou terminée ne couvre la date de travail.`,
	hi: `कोई भी प्रगति या पूर्ण कर्मचारी संघीय रोक चुनाव काम की तारीख को कवर नहीं करता है।`,
	ht: `Pa gen okenn eleksyon prelèvman federal anplwaye ki an pwogrè oswa ki te fini pou kouvri dat travay la.`,
	it: `Nessuna elezione federale di ritenzione in corso o completata copre la data di lavoro.`,
	ja: `進行中または完了した連邦従業員の差し止め選択は、作業日をカバーしません。`,
	ko: `진행 중이거나 완료된 직원 연방 원천징수 선택은 작업 날짜를 포함하지 않습니다.`,
	mww: `Tsis muaj kev xaiv tsa ntawm cov neeg ua haujlwm ua tiav los yog ua tiav ntawm tsoom fwv teb chaws txiav nyiaj them rau hnub ua haujlwm.`,
	ps: `هیڅ جاری یا بشپړ شوی کارکوونکو فدرالی کسر ټاکنې د کار نیټه نه پوښی.`,
	pt: `Nenhuma eleição federal de retenção de empregado em andamento ou concluída cobre a data de trabalho.`,
	'pt-pt': `Nenhuma eleição de retenção federal em curso ou concluída cobre a data de trabalho.`,
	ru: `Ни одно федеральное удержание сотрудников не охватывает дату работы.`,
	sm: `E leai se palota o le taofia o tagata faigaluega a le malo e aofia ai le aso faigaluega.`,
	so: `Ma jiro doorasho shaqo oo federaal ah oo socota ama la dhammeystiray oo daboolaya taariikhda shaqada.`,
	th: `ไม่มีการเลือกตั้งหัก ณ ที่จ่ายของรัฐบาลกลางของพนักงานที่กําลังดําเนินการหรือเสร็จสมบูรณ์ครอบคลุมวันที่ทํางาน`,
	ur: `کوئی بھی جاری یا مکمل شدہ ملازم وفاقی ودہولڈنگ الیکشن کام کی تاریخ کو کور نہیں کرتا۔`,
	vi: `Không có cuộc bầu cử khấu lưu liên bang của nhân viên đang tiến hành hoặc đã hoàn thành bao gồm ngày làm việc.`,
	'zh-hans': `没有任何正在进行或已完成的联邦员工预扣选举涵盖该工作日期。`,
	'zh-hant': `沒有任何進行中或已完成的聯邦員工預扣選舉涵蓋該工作日期。`,
	en: `No in-progress or completed employee federal withholding election covers the work date.`
};

export const loc_tsErrorMissingEmployeeW4Name: Record<Locale, string> = {
	ar: `الموظف المفقود W-4`,
	de: `Vermisster Mitarbeiter W-4`,
	es: `Empleado desaparecido W-4`,
	fa: `کارمند مفقود W-4`,
	fil: `Nawawalang empleyado W-4`,
	fr: `Employé disparu W-4`,
	hi: `लापता कर्मचारी W-4`,
	ht: `Anplwaye ki manke W-4`,
	it: `Dipendente scomparso W-4`,
	ja: `行方不明の従業員W-4`,
	ko: `실종 직원 W-4`,
	mww: `Tus neeg ua hauj lwm uas ploj lawm W-4`,
	ps: `ورک شوی کارکوونکی W-4`,
	pt: `Funcionário desaparecido W-4`,
	'pt-pt': `Funcionário desaparecido W-4`,
	ru: `Пропавший сотрудник W-4`,
	sm: `Tagata faigaluega W-4 o lo'o misi`,
	so: `Shaqaale maqan W-4`,
	th: `พนักงานหายไป W-4`,
	ur: `گمشدہ ملازم W-4`,
	vi: `Nhân viên mất tích W-4`,
	'zh-hans': `失踪员工W-4表格`,
	'zh-hant': `失蹤員工W-4表格`,
	en: `Missing employee W-4`
};

export const loc_tsErrorMissingEmployerEinVerificationDesc: Record<Locale, string> = {
	ar: `لا يوجد تحقق مكتمل من صاحب العمل أو التحقق من رقم تعريف صاحب العمل يغطي تاريخ العمل.`,
	de: `Keine laufende oder abgeschlossene Arbeitgeber-EIN-Verifizierung deckt das Arbeitsdatum ab.`,
	es: `No hay verificación EIN del empleador en proceso o completada que cubra la fecha de trabajo.`,
	fa: `هیچ تأییدیه EIN در حال انجام یا تکمیل شده توسط کارفرما تاریخ کاری را پوشش نمی دهد.`,
	fil: `Walang in-progress o nakumpleto na pag-verify ng EIN ng employer na sumasaklaw sa petsa ng trabaho.`,
	fr: `Aucune vérification EIN en cours ou complète de l’employeur ne couvre la date de travail.`,
	hi: `कोई भी प्रगति या पूर्ण नियोक्ता ईआईएन सत्यापन कार्य तिथि को कवर नहीं करता है।`,
	ht: `Pa gen okenn verifikasyon EIN anplwayè ki an fèt oswa ki te ranpli ki kouvri dat travay la.`,
	it: `Nessuna verifica EIN in corso o completata dal datore di lavoro copre la data di lavoro.`,
	ja: `進行中や完了した雇用主のEIN確認は、その勤務日をカバーしません。`,
	ko: `진행 중이거나 완료된 고용주 EIN 확인은 근무일에 해당하지 않습니다.`,
	mww: `Tsis muaj qhov ua tiav los yog ua tiav qhov chaw ua hauj lwm EIN xyuas txog hnub ua hauj lwm.`,
	ps: `هیڅ د کار ځای د EIN تایید د کار نیټې نه پوښی.`,
	pt: `Nenhuma verificação EIN em andamento ou concluída pelo empregador cobre a data de trabalho.`,
	'pt-pt': `Nenhuma verificação EIN do empregador em andamento ou concluída cobre a data de trabalho.`,
	ru: `Ни одна текущая или завершённая проверка EIN работодателем не охватывает дату работы.`,
	sm: `E leai se faamaoniga o le EIN o loo faagasolo pe ua maea e aofia ai le aso faigaluega.`,
	so: `Ma jirto xaqiijin EIN oo socota ama la dhammeystiray oo shaqo-bixiye ah oo daboolaya taariikhda shaqada.`,
	th: `ไม่มีการตรวจสอบ EIN ของนายจ้างที่กําลังดําเนินการหรือเสร็จสมบูรณ์ครอบคลุมวันที่ทํางาน`,
	ur: `کام کی تاریخ کو کور کرنے کے لیے کوئی بھی کام جاری یا مکمل شدہ آجر کا EIN تصدیق نہیں ہوتا۔`,
	vi: `Không có xác minh EIN của chủ lao động đang tiến hành hoặc đã hoàn thành bao gồm ngày làm việc.`,
	'zh-hans': `没有正在进行或完成的雇主EIN核查涵盖工作日期。`,
	'zh-hant': `沒有進行中或已完成的雇主EIN驗證涵蓋該工作日期。`,
	en: `No in-progress or completed employer EIN verification covers the work date.`
};

export const loc_tsErrorMissingEmployerEinVerificationName: Record<Locale, string> = {
	ar: `التحقق من رقم تعريف صاحب العمل المفقود`,
	de: `Verifizierung der EIN fehlender Arbeitgeber`,
	es: `Verificación EIN del empleador ausente`,
	fa: `تأییدیه EIN کارفرما که از دست رفته است`,
	fil: `Nawawalang pag-verify ng EIN ng employer`,
	fr: `Vérification EIN de l’employeur manquant`,
	hi: `नियोक्ता ईआईएन सत्यापन गुम`,
	ht: `Anplwayè ki manke verifikasyon EIN`,
	it: `Verifica EIN del datore di lavoro mancante`,
	ja: `雇用主のEIN確認がありません`,
	ko: `고용주 EIN 확인 부재`,
	mww: `Qhov chaw ua hauj lwm uas ploj lawm EIN kev txheeb xyuas`,
	ps: `د کارګمارونکی د EIN تصدیق ورک شوی`,
	pt: `Verificação EIN do empregador ausente`,
	'pt-pt': `Verificação EIN do empregador em falta`,
	ru: `Отсутствует проверка EIN работодателя`,
	sm: `Misi le faamaoniga o le EIN o le pule o le galuega`,
	so: `Xaqiijinta EIN-ka ee shaqo-bixiyaha maqan`,
	th: `ไม่มีการยืนยัน EIN ของนายจ้าง`,
	ur: `آجر کی EIN تصدیق کی کمی`,
	vi: `Thiếu xác minh EIN của chủ lao động`,
	'zh-hans': `缺少雇主EIN验证`,
	'zh-hant': `缺少雇主EIN驗證`,
	en: `Missing employer EIN verification`
};

export const loc_tsErrorMissingEmployerSitAccountDesc: Record<Locale, string> = {
	ar: `لا يغطي أي حساب SIT لصاحب العمل قيد التنفيذ أو مكتمل تاريخ العمل في حالة الاقتطاع للموظف.`,
	de: `Kein laufendes oder abgeschlossenes Arbeitgeber-SIT-Konto deckt das Arbeitsdatum für den Zustand des Arbeitnehmers ab.`,
	es: `Ninguna cuenta SIT del empleador en curso o completada cubre la fecha de trabajo del estado de retención del empleado.`,
	fa: `هیچ حساب SIT کارفرما در حال انجام یا تکمیل شده تاریخ کاری ایالت کسر کارمند را پوشش نمی دهد.`,
	fil: `Walang in-progress o nakumpleto na SIT account ng employer na sumasaklaw sa petsa ng trabaho para sa estado ng withholding ng empleyado.`,
	fr: `Aucun compte SIT de l’employeur en cours ou complet ne couvre la date de travail de l’État de retenue de l’employé.`,
	hi: `कोई भी प्रगति या पूर्ण नियोक्ता एसआईटी खाता कर्मचारी की रोक राज्य के लिए कार्य तिथि को कवर नहीं करता है।`,
	ht: `Pa gen kont SIT anplwayè ki an pwogrè oswa ki konplè kouvri dat travay pou eta prelèvman anplwaye a.`,
	it: `Nessun conto SIT in corso o completato copre la data di lavoro dello stato di ritenuta dal dipendente.`,
	ja: `進行中または完了した雇用主のSITアカウントは、従業員の源泉徴収州の勤務日をカバーしていません。`,
	ko: `진행 중이거나 완료된 고용주 SIT 계좌는 직원의 원천징수 주의 근무일을 포함하지 않습니다.`,
	mww: `Tsis muaj ib tug tswv hauj lwm SIT account uas ua tiav los yog ua tiav rau hnub ua hauj lwm rau tus neeg ua hauj lwm lub xeev txiav nyiaj.`,
	ps: `هیڅ د کار ورکوونکی SIT حساب د کارګر د کمې کولو ایالت د کار نیټه نه پوښی.`,
	pt: `Nenhuma conta SIT do empregador em andamento ou concluída cobre a data de trabalho do estado de retenção do funcionário.`,
	'pt-pt': `Nenhuma conta SIT do empregador em andamento ou concluída cobre a data de trabalho do estado de retenção do empregado.`,
	ru: `Ни один текущий или заполнённый SIT счет работодателя не покрывает дату работы в штате удержания сотрудника.`,
	sm: `E leai se teugatupe SIT o lo'o fa'aauau pea pe fa'amae'aina e aofia ai le aso faigaluega mo le setete o le taofiofia o le tagata faigaluega.`,
	so: `Ma jiro akoon SIT oo shaqo-shaqo ah oo socday ama la dhammeystiray oo daboolaya taariikhda shaqada ee gobolka uu shaqaaluhu ka xayiro.`,
	th: `ไม่มีบัญชี SIT ของนายจ้างที่กําลังดําเนินการหรือเสร็จสมบูรณ์ครอบคลุมวันที่ทํางานสําหรับสถานะการหัก ณ ที่จ่ายของพนักงาน`,
	ur: `کوئی بھی جاری یا مکمل شدہ آجر SIT اکاؤنٹ ملازم کی ودہولڈنگ ریاست کی ورک ڈیٹ کو کور نہیں کرتا۔`,
	vi: `Không có tài khoản SIT nào của chủ lao động đang tiến hành hoặc đã hoàn thành bao gồm ngày làm việc cho trạng thái khấu lưu của nhân viên.`,
	'zh-hans': `没有任何正在进行或已完成的雇主SIT账户覆盖员工扣税州的工作日期。`,
	'zh-hant': `沒有任何正在進行或已完成的雇主SIT帳戶涵蓋員工扣繳州的工作日期。`,
	en: `No in-progress or completed employer SIT account covers the work date for the employee’s withholding state.`
};

export const loc_tsErrorMissingEmployerSitAccountName: Record<Locale, string> = {
	ar: `حساب SIT الخاص بصاحب العمل مفقود`,
	de: `Fehlendes Arbeitgeber-SIT-Konto`,
	es: `Cuenta SIT del empleador perdida`,
	fa: `نبود حساب SIT کارفرما`,
	fil: `Nawawalang SIT account ng employer`,
	fr: `Compte SIT employeur manquant`,
	hi: `नियोक्ता एसआईटी खाता गुम`,
	ht: `Kont SIT anplwayè ki manke`,
	it: `Conto SIT del datore di lavoro mancante`,
	ja: `雇用主のSITアカウントがありません`,
	ko: `고용주 SIT 계정 누락`,
	mww: `Tus tswv hauj lwm SIT account uas ploj lawm`,
	ps: `ورک شوی کارګمارونکی SIT حساب`,
	pt: `Conta SIT do empregador ausente`,
	'pt-pt': `Conta SIT do empregador em falta`,
	ru: `Отсутствует аккаунт SIT работодателя`,
	sm: `O loo misi le teugatupe a le pule o le SIT`,
	so: `Akoonka SIT ee shaqo-bixiyaha maqan`,
	th: `บัญชี SIT ของนายจ้างหายไป`,
	ur: `گمشدہ آجر SIT اکاؤنٹ`,
	vi: `Thiếu tài khoản SIT của chủ lao động`,
	'zh-hans': `缺少雇主SIT账户`,
	'zh-hant': `缺少雇主的 SIT 帳戶`,
	en: `Missing employer SIT account`
};

export const loc_tsErrorMissingEmployerSutaAccountDesc: Record<Locale, string> = {
	ar: `لا يغطي أي حساب SUTA لصاحب العمل قيد التنفيذ أو مكتمل تاريخ العمل.`,
	de: `Kein laufendes oder abgeschlossenes Arbeitgeber-SUTA-Konto deckt das Arbeitsdatum ab.`,
	es: `Ninguna cuenta SUTA del empleador en proceso o completada cubre la fecha de trabajo.`,
	fa: `هیچ حساب SUTA کارفرما در حال انجام یا تکمیل شده تاریخ کاری را پوشش نمی دهد.`,
	fil: `Walang in-progress o nakumpleto na SUTA account ng employer na sumasaklaw sa petsa ng trabaho.`,
	fr: `Aucun compte SUTA de l’employeur en cours ou complet ne couvre la date de travail.`,
	hi: `कोई भी प्रगति या पूर्ण नियोक्ता SUTA खाता कार्य तिथि को कवर नहीं करता है।`,
	ht: `Pa gen kont anplwayè SUTA ki nan pwogrè oswa ki te ranpli ki kouvri dat travay la.`,
	it: `Nessun conto SUTA in corso o completato copre la data di lavoro.`,
	ja: `作業期間中のSUTAアカウントや完了済みの雇用主SUTAアカウントは、その作業日をカバーしていません。`,
	ko: `진행 중이거나 완료된 고용주 SUTA 계좌는 해당 작업 날짜를 포함하지 않습니다.`,
	mww: `Tsis muaj ib qho kev ua tiav los yog ua tiav ntawm tus tswv hauj lwm SUTA account them rau hnub ua haujlwm.`,
	ps: `هیڅ د کار ورکوونکی SUTA حساب د کار نیټې پوښښ نه کوی.`,
	pt: `Nenhuma conta SUTA do empregador em andamento ou concluída cobre a data de trabalho.`,
	'pt-pt': `Nenhuma conta SUTA do empregador em andamento ou concluída cobre a data de trabalho.`,
	ru: `Ни один текущий или заполнённый аккаунт работодателя SUTA не покрывает дату работы.`,
	sm: `E leai se teugatupe SUTA o lo'o fa'aauau pea pe fa'amae'aina e aofia ai le aso faigaluega.`,
	so: `Ma jiro akoon SUTA oo shaqo-shaqo oo socday ama la dhammeystiray oo daboolaya taariikhda shaqada.`,
	th: `ไม่มีบัญชี SUTA ของนายจ้างที่กําลังดําเนินการหรือเสร็จสมบูรณ์ครอบคลุมวันที่ทํางาน`,
	ur: `کوئی بھی جاری یا مکمل شدہ آجر کا SUTA اکاؤنٹ کام کی تاریخ کو کور نہیں کرتا۔`,
	vi: `Không có tài khoản nào của nhà tuyển dụng đang tiến hành hoặc đã hoàn thành bao gồm ngày làm việc.`,
	'zh-hans': `没有任何正在进行或已完成的雇主UTA账户涵盖该工作日期。`,
	'zh-hant': `沒有正在進行或已完成的雇主SUTA帳戶涵蓋該工作日期。`,
	en: `No in-progress or completed employer SUTA account covers the work date.`
};

export const loc_tsErrorMissingEmployerSutaAccountName: Record<Locale, string> = {
	ar: `حساب صاحب العمل المفقود في حساب SUTA`,
	de: `SUTA-Konto fehlender Arbeitgeber`,
	es: `Cuenta SUTA del empleador desaparecida`,
	fa: `حساب SUTA کارفرما گم شده`,
	fil: `Nawawalang SUTA account ng employer`,
	fr: `Compte SUTA employeur manquant`,
	hi: `गुम नियोक्ता SUTA खाता`,
	ht: `Kont SUTA anplwayè ki manke`,
	it: `Account SUTA del datore di lavoro mancante`,
	ja: `雇用主のSUTAアカウントがありません`,
	ko: `고용주 SUTA 계정 누락`,
	mww: `Tus tswv hauj lwm SUTA tus account uas ploj lawm`,
	ps: `ورک شوی کارګمارونکی SUTA حساب`,
	pt: `Conta SUTA do empregador desaparecida`,
	'pt-pt': `Conta SUTA do empregador em falta`,
	ru: `Отсутствующий аккаунт SUTA работодателя`,
	sm: `O loo misi le faitotoa SUTA a le pule o le galuega`,
	so: `Xisaabta SUTA ee shaqo-shaqo ee maqan`,
	th: `บัญชี SUTA ของนายจ้างหายไป`,
	ur: `گمشدہ آجر کا SUTA اکاؤنٹ`,
	vi: `Thiếu tài khoản SUTA của nhà tuyển dụng`,
	'zh-hans': `缺少雇主SUTA账户`,
	'zh-hant': `缺少雇主 SUTA 帳戶`,
	en: `Missing employer SUTA account`
};

export const loc_tsErrorMissingEmployerSutaRateDesc: Record<Locale, string> = {
	ar: `لا يغطي تاريخ العمل أي معدل ضريبة SUTA قيد التنفيذ أو الاكتمال مع السعر وقيم الولاية.`,
	de: `Kein laufender oder abgeschlossener Arbeitgeber-SUTA-Steuersatz mit Steuersatz und staatlichen Werten deckt das Arbeitsdatum ab.`,
	es: `No existe la tasa impositiva SUTA del empleador en curso o completada, con la tasa y los valores estatales, que cubra la fecha de trabajo.`,
	fa: `هیچ نرخ مالیاتی SUTA کارفرما در حال انجام یا تکمیل شده با نرخ و ارزش های ایالتی تاریخ کاری را پوشش نمی دهد.`,
	fil: `Walang in-progress o nakumpleto na rate ng buwis ng employer SUTA na may rate at mga halaga ng estado na sumasaklaw sa petsa ng trabaho.`,
	fr: `Aucun taux d’imposition SUTA en cours ou terminé par l’employeur, avec taux et valeurs de l’État, ne couvre la date de travail.`,
	hi: `दर और राज्य मूल्यों के साथ कोई प्रगति या पूर्ण नियोक्ता SUTA कर दर कार्य तिथि को कवर नहीं करती है।`,
	ht: `Pa gen pousantaj taks SUTA anplwayè ki an pwogrè oswa ranpli ak pousantaj ak valè eta a kouvri dat travay la.`,
	it: `Nessuna aliquota fiscale SUTA in corso o completata del datore di lavoro, con aliquote e valori statali, copre la data di lavoro.`,
	ja: `進行中または完了した雇用主SUTA税率(税率および州の値付き)は、作業日をカバーしません。`,
	ko: `진행 중이거나 완료된 고용주 SUTA 세율과 세율 및 주 값이 작업 날짜를 포함하지 않습니다.`,
	mww: `Tsis muaj tus nqi se uas ua tiav los yog ua tiav tus tswv hauj lwm SUTA tus nqi nrog tus nqi thiab lub xeev cov nqi them rau hnub ua haujlwm.`,
	ps: `هیڅ د کار ورکوونکی په جریان یا بشپړ شوی SUTA مالیه نرخ د نرخ او ایالتی ارزښتونو سره د کار نیټې پوښی.`,
	pt: `Nenhuma alíquota de imposto SUTA do empregador em andamento ou concluída, com alíquota e valores estaduais, cobre a data de trabalho.`,
	'pt-pt': `Nenhuma taxa de imposto SUTA do empregador em andamento ou concluída, com taxa e valores estaduais, cobre a data de trabalho.`,
	ru: `Ни одна ставка налога SUTA от работодателя в процессе или не заполнена с учётом ставки и значениями штата, охватывающая дату работы.`,
	sm: `E leai se lafoga SUTA o lo'o fa'aauau pea ona fa'aauau pe fa'amae'aina le fua faatatau o le setete e aofia ai le aso faigaluega.`,
	so: `Ma jiro heerka canshuurta SUTA ee shaqo-bixiyaha oo socday ama la dhammeystiray oo leh heerka iyo qiimaha gobolka oo daboolaya taariikhda shaqada.`,
	th: `ไม่มีอัตราภาษี SUTA ของนายจ้างที่กําลังดําเนินการหรือเสร็จสมบูรณ์พร้อมอัตราและมูลค่าของรัฐครอบคลุมวันที่ทํางาน`,
	ur: `کوئی بھی جاری یا مکمل شدہ آجر SUTA ٹیکس ریٹ ریٹ اور ریاستی ویلیوز کے ساتھ کام کی تاریخ کو کور نہیں کرتا۔`,
	vi: `Không có thuế suất SUTA của chủ lao động đang tiến hành hoặc đã hoàn thành với tỷ lệ và giá trị tiểu bang bao gồm ngày làm việc.`,
	'zh-hans': `工作日期没有任何正在进行或已完成的雇主SUTA税率及税率和州值。`,
	'zh-hant': `工作日期不包含任何正在進行或已完成的雇主 SUTA 稅率及稅率及州值。`,
	en: `No in-progress or completed employer SUTA tax rate with rate and state values covers the work date.`
};

export const loc_tsErrorMissingEmployerSutaRateName: Record<Locale, string> = {
	ar: `معدل ضريبة التأمين الصحي الناقص لصاحب العمل`,
	de: `SUTA-Steuersatz fehlender Arbeitgeber`,
	es: `Tasa impositiva SUTA del empleador ausente`,
	fa: `نرخ مالیات SUTA از دست رفته توسط کارفرما`,
	fil: `Nawawalang rate ng buwis sa SUTA ng employer`,
	fr: `Taux d’imposition SUTA de l’employeur manquant`,
	hi: `लापता नियोक्ता SUTA कर दर`,
	ht: `Rate taks SUTA anplwayè ki manke`,
	it: `Aliquota fiscale SUTA del datore di lavoro mancante`,
	ja: `雇用主SUTA税率の欠落`,
	ko: `고용주 SUTA 세율 누락`,
	mww: `Tus nqi se ntawm tus tswv hauj lwm SUTA uas ploj lawm`,
	ps: `ورک شوی کارګمارونکی د SUTA مالیې نرخ`,
	pt: `Alíquota de imposto SUTA por empregador ausente`,
	'pt-pt': `Taxa de imposto SUTA do empregador ausente`,
	ru: `Отсутствующая ставка налога SUTA для работодателя`,
	sm: `O lo'o misi le fua faatatau o lafoga SUTA a le pule o le galuega`,
	so: `Heerka canshuurta SUTA ee shaqo-bixiyaha maqan`,
	th: `อัตราภาษี SUTA ของนายจ้างขาดหายไป`,
	ur: `گمشدہ آجر SUTA ٹیکس ریٹ`,
	vi: `Thiếu thuế suất SUTA của chủ lao động`,
	'zh-hans': `缺少雇主SUTA税率`,
	'zh-hant': `缺少雇主的 SUTA 稅率`,
	en: `Missing employer SUTA tax rate`
};

export const loc_tsErrorMissingEmployerWorkersCompensationPolicyDesc: Record<Locale, string> = {
	ar: `يطلب وجود بوليصة تعويضات عمال لتاريخ العمل، لكن لا توجد وثيقة قيد التنفيذ أو المكتملة تغطي هذا التاريخ.`,
	de: `Für den Arbeitstermin ist eine Arbeitsunfallversicherung erforderlich, aber keine laufende oder abgeschlossene Police deckt dieses Datum ab.`,
	es: `Se requiere una póliza de compensación laboral para la fecha de trabajo, pero ninguna póliza en curso o completada cubre esa fecha.`,
	fa: `بیمه جبران خسارت کارگران برای تاریخ کاری لازم است، اما هیچ بیمه نامه ای در حال تکمیل یا تکمیل آن تاریخ را پوشش نمی دهد.`,
	fil: `Ang isang patakaran sa kompensasyon ng mga manggagawa ay kinakailangan para sa petsa ng trabaho, ngunit walang in-progress o nakumpleto na patakaran na sumasaklaw sa petsang iyon.`,
	fr: `Une police d’indemnisation des travailleurs est requise pour la date de travail, mais aucune police en cours ou finalisée ne couvre cette date.`,
	hi: `काम की तारीख के लिए एक श्रमिक मुआवजा नीति की आवश्यकता होती है, लेकिन कोई भी प्रगति या पूर्ण नीति उस तारीख को कवर नहीं करती है।`,
	ht: `Yo mande yon politik konpansasyon pou travayè yo pou dat travay la, men pa gen okenn politik ki an pwogrè oswa ki fini ki kouvri dat sa a.`,
	it: `È richiesta una polizza contro l'infortunio dei lavoratori per la data di lavoro, ma nessuna polizza in corso o completata copre quella data.`,
	ja: `労災保険は作業日の日付に必須ですが、進行中や完了済みの保険はその日付をカバーしません。`,
	ko: `근로일에는 산재 보상 보험이 필요하지만, 진행 중이거나 완료된 보험은 해당 날짜를 포함하지 않습니다.`,
	mww: `Yuav tsum muaj ib txoj cai them nqi zog rau hnub ua haujlwm, tiam sis tsis muaj ib daim ntawv pov hwm uas tab tom ua tiav los yog ua tiav them rau hnub ntawd.`,
	ps: `د کار نیټې لپاره د کارګر جبران پالیسۍ اړین دی، خو هیڅ بشپړ شوی یا په جریان کې بیمه دا نیټه نه پوښی.`,
	pt: `Uma apólice de compensação trabalhista é necessária para a data de trabalho, mas nenhuma apólice em andamento ou concluída cobre essa data.`,
	'pt-pt': `É necessária uma apólice de compensação laboral para a data de trabalho, mas nenhuma apólice em curso ou concluída cobre essa data.`,
	ru: `Для даты работы требуется полис по компенсации работникам, но нет завершённого или завершённого полиса, который не покрывает эту дату.`,
	sm: `E mana'omia se aiaiga fa'avae mo taui a tagata faigaluega mo le aso faigaluega, ae leai se faiga fa'avae o lo'o alualu i luma pe mae'a e aofia ai lena aso.`,
	so: `Siyaasadda magdhowga shaqaalaha ayaa loo baahan yahay taariikhda shaqada, laakiin ma jirto siyaasad socota ama la dhammeystiray oo daboolaya taariikhdaas.`,
	th: `จําเป็นต้องมีนโยบายค่าตอบแทนคนงานสําหรับวันที่ทํางาน แต่ไม่มีนโยบายที่กําลังดําเนินการหรือเสร็จสมบูรณ์ครอบคลุมวันที่นั้น`,
	ur: `کام کی تاریخ کے لیے ورکرز کمپنسیشن پالیسی درکار ہوتی ہے، لیکن اس تاریخ کو کوئی بھی زیر تکمیل یا مکمل پالیسی کور نہیں کرتی۔`,
	vi: `Chính sách bồi thường cho người lao động là bắt buộc cho ngày làm việc, nhưng không có chính sách nào đang tiến hành hoặc đã hoàn thành bao gồm ngày đó.`,
	'zh-hans': `工伤赔偿保险是工作日期的必需，但没有任何正在进行或已完成的保单涵盖该日期。`,
	'zh-hant': `工作日期需投保勞工保險，但未包含該日期的進行中或已完成保單。`,
	en: `A workers compensation policy is required for the work date, but no in-progress or completed policy covers that date.`
};

export const loc_tsErrorMissingEmployerWorkersCompensationPolicyName: Record<Locale, string> = {
	ar: `بوليصة تعويضات العمال المفقودة`,
	de: `Fehlende Arbeitsunfallversicherung`,
	es: `Política de compensación laboral por desaparecidos`,
	fa: `بیمه جبران خسارت کارگران مفقود`,
	fil: `Patakaran sa kompensasyon ng mga nawawalang manggagawa`,
	fr: `Police d’indemnisation des travailleurs disparus`,
	hi: `लापता श्रमिकों मुआवजा नीति`,
	ht: `Politik konpansasyon travayè ki manke yo`,
	it: `Politica per l'indennizzo dei lavoratori assenti`,
	ja: `行方不明者補償保険`,
	ko: `실종 산재 보상 정책`,
	mww: `Txoj cai them nyiaj rau cov neeg ua haujlwm uas ploj lawm`,
	ps: `د ورک شویو کارکوونکو جبران پالیسۍ`,
	pt: `Política de compensação trabalhista desaparecida`,
	'pt-pt': `Política de compensação de trabalhadores desaparecidos`,
	ru: `Политика по пропавшим компенсациям работникам`,
	sm: `Faiga faavae o taui o tagata faigaluega o loo misi`,
	so: `Siyaasadda magdhowga shaqaalaha ee maqan`,
	th: `นโยบายการชดเชยคนงานที่ขาดหายไป`,
	ur: `گمشدہ ورکرز کمپنسیشن پالیسی`,
	vi: `Chính sách bồi thường cho người lao động mất tích`,
	'zh-hans': `失踪工伤赔偿政策`,
	'zh-hant': `失蹤勞工補償政策`,
	en: `Missing workers compensation policy`
};

export const loc_tsErrorOverlappingConsumerEntryDesc: Record<Locale, string> = {
	ar: `إدخال آخر في جدول الأوقات لنفس المستهلك يتداخل مع نطاق زمني هذا العدد.`,
	de: `Ein weiterer Stundenzetteleintrag für denselben Verbraucher überschneidet sich mit dem Zeitbereich dieses Eintrags.`,
	es: `Otra entrada en la hoja de horas para el mismo consumidor coincide con el rango temporal de esta entrada.`,
	fa: `یک ورودی دیگر در برگه زمان برای همان مصرف کننده با بازه زمانی این ورودی همپوشانی دارد.`,
	fil: `Ang isa pang timesheet entry para sa parehong mamimili ay nag-overlap sa saklaw ng oras ng entry na ito.`,
	fr: `Une autre entrée de feuille de temps pour le même consommateur recoupe la plage de temps de cette entrée.`,
	hi: `एक ही उपभोक्ता के लिए एक और टाइमशीट प्रविष्टि इस प्रविष्टि की समय सीमा को ओवरलैप करती है।`,
	ht: `Yon lòt antre Timesheet pou konsomatè a menm sipèpoze seri tan antre sa a.`,
	it: `Un'altra voce di tabella di tempo per lo stesso consumatore si sovrappone all'intervallo di tempo di questa voce.`,
	ja: `同じ消費者の別のタイムシート項目は、この記録の時間範囲と重複しています。`,
	ko: `같은 소비자의 또 다른 타임시트 항목이 이 항목의 시간 범위와 겹칩니다.`,
	mww: `Lwm daim ntawv teev sij hawm nkag rau tib tus neeg siv khoom sib tshooj lub sijhawm nkag no.`,
	ps: `د هماغه مصرف کوونکی لپاره بله ټایم شیټ د دې لیکنې د وخت له حدودو سره همپوشانی لری.`,
	pt: `Outra entrada de folha de ponto para o mesmo consumidor se sobrepõe ao intervalo de tempo desta entrada.`,
	'pt-pt': `Outra entrada de folha de horas para o mesmo consumidor sobrepõe-se ao intervalo temporal desta entrada.`,
	ru: `Другая запись в табеле для того же потребителя пересекается с временным диапазоном этой записи.`,
	sm: `O le isi timesheet entry mo le tagata fa'atau lava lea e tasi e fa'atatau i le taimi o lenei ulufale.`,
	so: `Qoraal kale oo timesheet ah oo loogu talagalay isla macaamiisha ayaa isku dhex jira waqtiga qaybtaan.`,
	th: `รายการไทม์ชีทอื่นสําหรับผู้บริโภครายเดียวกันทับซ้อนกับช่วงเวลาของรายการนี้`,
	ur: `اسی صارف کے لیے ایک اور ٹائم شیٹ اندراج اس اندراج کی ٹائم رینج سے اوورلیپ کرتا ہے۔`,
	vi: `Một mục nhập bảng chấm công khác cho cùng một người tiêu dùng trùng lặp với phạm vi thời gian của mục nhập này.`,
	'zh-hans': `同一消费者的另一条工时表条目与该条目的时间范围重叠。`,
	'zh-hant': `同一消費者的另一份工時表條目與該條目的時間範圍重疊。`,
	en: `Another timesheet entry for the same consumer overlaps this entry’s time range.`
};

export const loc_tsErrorOverlappingConsumerEntryName: Record<Locale, string> = {
	ar: `إدخال متداخل`,
	de: `Überlappende Einträge`,
	es: `Entrada solapada`,
	fa: `ورودی های همپوشان`,
	fil: `Magkakapatong na entry`,
	fr: `Entrée chevauchée`,
	hi: `ओवरलैपिंग प्रविष्टि`,
	ht: `Sipèpoze antre`,
	it: `Voce sovrapposta`,
	ja: `重複するエントリー`,
	ko: `중복 진입`,
	mww: `Kev nkag sib tshooj`,
	ps: `همغږی برخه`,
	pt: `Entrada sobreposta`,
	'pt-pt': `Entrada sobreposta`,
	ru: `Перекрывающаяся запись`,
	sm: `Overlapping entry`,
	so: `Gelitaanka is-dul saaran`,
	th: `รายการที่ทับซ้อนกัน`,
	ur: `اوورلیپنگ انٹری`,
	vi: `Mục nhập chồng chéo`,
	'zh-hans': `重叠入口`,
	'zh-hant': `重疊條目`,
	en: `Overlapping entry`
};

export const loc_tsErrorOverlappingEmployeeEntryDesc: Record<Locale, string> = {
	ar: `إدخال آخر في جدول الأوقات لنفس الموظف يتداخل مع نطاق زمني هذا التسجيل.`,
	de: `Ein weiterer Stundenzetteleintrag für denselben Mitarbeiter überschneidet sich mit dem Zeitrahmen dieses Eintrags.`,
	es: `Otra entrada de hoja de horas para el mismo empleado coincide con el rango temporal de esta entrada.`,
	fa: `ورودی دیگری در برگه زمان بندی همان کارمند با بازه زمانی این ورودی همپوشانی دارد.`,
	fil: `Ang isa pang timesheet entry para sa parehong empleyado ay nag-overlap sa saklaw ng oras ng entry na ito.`,
	fr: `Une autre entrée de feuille de temps pour le même employé recoupe la plage horaire de cette entrée.`,
	hi: `एक ही कर्मचारी के लिए अन्य टाइमशीट प्रविष्टि इस प्रविष्टि की समय सीमा को ओवरलैप करती है।`,
	ht: `Yon lòt antre Timesheet pou anplwaye a menm sipèpoze seri tan antre sa a.`,
	it: `Un'altra voce del foglio orario per lo stesso dipendente si sovrappone all'intervallo di questo momento.`,
	ja: `同じ従業員の別のタイムシートの記録が、この記録の時間範囲と重複しています。`,
	ko: `같은 직원의 또 다른 근무 시간표 항목이 이 기록의 시간 범위와 겹칩니다.`,
	mww: `Lwm lub sij hawm nkag rau tib tus neeg ua hauj lwm overlaps no nkag lub sij hawm range.`,
	ps: `د همدې کارکوونکی لپاره بله ټایم شیټ د دې لیکنې د وخت له حدودو سره تداخل لری.`,
	pt: `Outra entrada de folha de ponto para o mesmo funcionário se sobrepõe ao intervalo de tempo dessa entrada.`,
	'pt-pt': `Outra entrada na folha de horas para o mesmo funcionário sobrepõe-se ao intervalo temporal desta entrada.`,
	ru: `Другая запись в табеле рабочего времени для того же сотрудника пересекается с временным диапазоном этой записи.`,
	sm: `O le isi pepa o taimi mo le tagata faigaluega lava lea e tasi e fesiligia ai le taimi o lenei ulufale.`,
	so: `Qoraal kale oo timesheet ah oo loogu talagalay isla shaqaalahaas ayaa isku dul saaran waqtiga qoraalkan.`,
	th: `รายการแผ่นเวลาอื่นสําหรับพนักงานคนเดียวกันทับซ้อนกับช่วงเวลาของรายการนี้`,
	ur: `اسی ملازم کے لیے ایک اور ٹائم شیٹ اندراج اس اندراج کے وقت کی حد سے اوورلیپ کرتا ہے۔`,
	vi: `Một mục nhập bảng chấm công khác cho cùng một nhân viên trùng lặp với phạm vi thời gian của mục nhập này.`,
	'zh-hans': `同一员工的另一条工时表条目与该条目的时间范围重叠。`,
	'zh-hant': `同一員工的另一份工時記錄與該分錄的時間範圍重疊。`,
	en: `Another timesheet entry for the same employee overlaps this entry’s time range.`
};

export const loc_tsErrorOverlappingEmployeeEntryName: Record<Locale, string> = {
	ar: `دخول الموظفين المتداخل`,
	de: `Überlappende Mitarbeitereinträge`,
	es: `Entrada de empleados superpuesta`,
	fa: `ورود همپوشان کارکنان`,
	fil: `Magkakapatong na pagpasok ng empleyado`,
	fr: `Entrée chevauchante des employés`,
	hi: `ओवरलैपिंग कर्मचारी प्रविष्टि`,
	ht: `Antre anplwaye sipèpoze`,
	it: `Sovrapposizione di inserimento di dipendenti`,
	ja: `重複する従業員エントリー`,
	ko: `직원 입원 중복`,
	mww: `Cov neeg ua haujlwm nkag mus sib tshooj`,
	ps: `د کارکوونکو ګډې لیکنې`,
	pt: `Entrada sobreposta de funcionários`,
	'pt-pt': `Entrada sobreposta de funcionários`,
	ru: `Перекрывающиеся записи сотрудников`,
	sm: `Overlapping employee entry`,
	so: `Qoraallo shaqaale oo is dul saaran`,
	th: `รายการพนักงานที่ทับซ้อนกัน`,
	ur: `اوورلیپنگ ملازمین کی شمولیت`,
	vi: `Mục nhập nhân viên chồng chéo`,
	'zh-hans': `员工重叠入职`,
	'zh-hant': `員工重複輸入`,
	en: `Overlapping employee entry`
};

export const loc_tsErrorOvertimeNotPermittedDesc: Record<Locale, string> = {
	ar: `يشمل التسجيل العمل الإضافي، لكن الميزانية غير مسموح بالعمل الإضافي.`,
	de: `Der Eintrag beinhaltet Überstunden, aber Überstunden sind laut Budget nicht erlaubt.`,
	es: `La entrada incluye horas extra, pero el presupuesto no permite horas extra.`,
	fa: `ورود شامل اضافه کاری است، اما بودجه اجازه اضافه کاری را نمی دهد.`,
	fil: `Kasama sa entry ang overtime, ngunit hindi pinapayagan ng badyet ang overtime.`,
	fr: `L’entrée inclut les heures supplémentaires, mais le budget n’autorise pas les heures supplémentaires.`,
	hi: `प्रवेश में ओवरटाइम शामिल है, लेकिन बजट द्वारा ओवरटाइम की अनुमति नहीं है।`,
	ht: `Antre a gen ladan siplemantè, men lè siplemantè pa pèmèt pa bidjè a.`,
	it: `La voce include gli straordinari, ma il budget non è consentito.`,
	ja: `記録には残業が含まれていますが、残業は予算で認められていません。`,
	ko: `이 항목에는 초과근무가 포함되지만, 예산상 초과근무는 허용되지 않습니다.`,
	mww: `Kev nkag mus suav nrog kev ua haujlwm dhau sijhawm, tab sis kev ua haujlwm dhau sijhawm tsis raug tso cai los ntawm pob nyiaj siv.`,
	ps: `ګډون کې اضافی وخت شامل دی، خو د بودیجې له مخې اضافی وخت اجازه نه لری.`,
	pt: `A entrada inclui horas extras, mas o orçamento não permite horas extras.`,
	'pt-pt': `A entrada inclui horas extraordinárias, mas o orçamento não permite horas extraordinárias.`,
	ru: `Запись включает сверхурочные, но сверхурочные не разрешены бюджетом.`,
	sm: `O le ulufale e aofia ai ovataimi, ae e le faatagaina ovataimi e le paketi.`,
	so: `Gelitaanka waxaa ku jira saacado dheeraad ah, laakiin waqtiga dheeraadka ah ma oggola miisaaniyadda.`,
	th: `รายการรวมการทํางานล่วงเวลา แต่งบประมาณไม่อนุญาตให้ทํางานล่วงเวลา`,
	ur: `داخلہ میں اوور ٹائم شامل ہے، لیکن بجٹ میں اوور ٹائم کی اجازت نہیں ہے۔`,
	vi: `Nhập cảnh bao gồm làm thêm giờ, nhưng ngân sách không cho phép làm thêm giờ.`,
	'zh-hans': `录入包括加班，但预算不允许加班。`,
	'zh-hant': `報名包含加班，但預算不允許加班。`,
	en: `The entry includes overtime, but overtime is not allowed by the budget.`
};

export const loc_tsErrorOvertimeNotPermittedName: Record<Locale, string> = {
	ar: `العمل الإضافي غير مسموح به`,
	de: `Überstunden sind nicht erlaubt`,
	es: `No se permiten horas extra`,
	fa: `اضافه کاری مجاز نیست`,
	fil: `Hindi pinapayagan ang overtime`,
	fr: `Les heures supplémentaires non autorisées`,
	hi: `ओवरटाइम की अनुमति नहीं है`,
	ht: `Tan siplemantè pa pèmèt`,
	it: `Straordinari non consentiti`,
	ja: `残業禁止`,
	ko: `초과 근무는 허용되지 않습니다`,
	mww: `Tsis pub ua haujlwm dhau sijhawm`,
	ps: `اضافی وخت اجازه نه لری`,
	pt: `Hora extra não permitida`,
	'pt-pt': `Horas extraordinárias não permitidas`,
	ru: `Сверхурочные занятия запрещены`,
	sm: `E le faatagaina ovataimi`,
	so: `Waqti dheeri ah lama oggola`,
	th: `ไม่อนุญาตให้ทํางานล่วงเวลา`,
	ur: `اوور ٹائم کی اجازت نہیں`,
	vi: `Không được phép làm thêm giờ`,
	'zh-hans': `不允许加时`,
	'zh-hant': `不允許加班`,
	en: `Overtime not permitted`
};

export const loc_tsErrorPriorErrorsBlockOvertimeClassificationDesc: Record<Locale, string> = {
	ar: `لا يمكن تصنيف هذا الإدخال في العمل الإضافي للرواتب حتى يتم حل الأخطاء السابقة في نفس أسبوع العمل.`,
	de: `Dieser Überstundeneintrag kann nicht für die Lohnabrechnung klassifiziert werden, bis frühere Fehler in derselben Arbeitswoche behoben sind.`,
	es: `Esta entrada de horas extra no puede clasificarse para nómina hasta que se resuelvan errores anteriores en la misma semana laboral.`,
	fa: `این ورودی اضافه کاری تا زمانی که اشتباهات قبلی در همان هفته کاری برطرف نشود، نمی تواند برای حقوق و دستمزد طبقه بندی شود.`,
	fil: `Ang overtime entry na ito ay hindi maaaring maiuri para sa payroll hangga't hindi nalutas ang mga naunang pagkakamali sa parehong linggo ng trabaho.`,
	fr: `Cette saisie des heures supplémentaires ne peut pas être classée pour la paie tant que les erreurs antérieures de la même semaine de travail ne sont pas résolues.`,
	hi: `इस ओवरटाइम प्रविष्टि को पेरोल के लिए तब तक वर्गीकृत नहीं किया जा सकता जब तक कि एक ही कार्यसप्ताह में पहले की त्रुटियाँ हल नहीं हो जातीं।`,
	ht: `Antre siplemantè sa a pa ka klase pou pewòl jiskaske erè pi bonè nan semèn travay la menm rezoud.`,
	it: `Questa registrazione degli straordinari non può essere classificata per la busta paga finché non vengono risolti errori precedenti nella stessa settimana lavorativa.`,
	ja: `この残業記録は、同じ週の以前のエラーが解決されるまで給与計算に分類できません。`,
	ko: `이 초과근무 기록은 같은 근무 주에 발생한 이전 오류가 해결되기 전까지는 급여 처리에 포함되지 않습니다.`,
	mww: `Qhov kev nkag mus ua haujlwm dhau no tsis tuaj yeem muab cais rau cov nyiaj them poob haujlwm kom txog thaum daws cov kev ua yuam kev ua ntej hauv tib lub limtiam ua haujlwm.`,
	ps: `دا اضافی وخت ثبت تر هغه وخته پورې د معاش لپاره طبقه بندی نشی کېدای تر څو چې په هماغه کاری اونۍ کې پخوانۍ تېروتنې حل نه شی.`,
	pt: `Essa entrada de horas extras não pode ser classificada para folha de pagamento até que erros anteriores na mesma semana de trabalho sejam resolvidos.`,
	'pt-pt': `Este registo de horas extra não pode ser classificado para processamento salarial até que erros anteriores na mesma semana de trabalho sejam resolvidos.`,
	ru: `Эта запись о сверхурочной работе не может быть классифицирована для расчета зарплаты, пока не будут устранены предыдущие ошибки в той же рабочей неделе.`,
	sm: `E le mafai ona faavasegaina lenei faamaumauga o ovataimi mo le lisi o totogi sei vagana ua foia ni mea sese na muamua atu i le vaiaso faigaluega lava lea e tasi.`,
	so: `Qoraalkan saacadaha dheeraadka ah lama kala saari karo mushaharka ilaa khaladaadkii hore ee isla usbuuca shaqada la xalliyo.`,
	th: `รายการล่วงเวลานี้ไม่สามารถจัดประเภทสําหรับบัญชีเงินเดือนได้จนกว่าข้อผิดพลาดก่อนหน้านี้ในสัปดาห์ทํางานเดียวกันจะได้รับการแก้ไข`,
	ur: `یہ اوور ٹائم اندراج اس وقت تک پے رول کے لیے درجہ بند نہیں کیا جا سکتا جب تک کہ اسی ورک ویک میں پہلے کی غلطیاں دور نہ ہو جائیں۔`,
	vi: `Mục nhập làm thêm giờ này không thể được phân loại vào bảng lương cho đến khi các lỗi trước đó trong cùng một tuần làm việc được giải quyết.`,
	'zh-hans': `在解决同工作周早期错误之前，这种加班记录不能归类为工资单。`,
	'zh-hant': `此加班分錄必須先解決同一工作週內較早的錯誤，否則無法歸類為薪資。`,
	en: `This overtime entry cannot be classified for payroll until earlier errors in the same workweek are resolved.`
};

export const loc_tsErrorPriorErrorsBlockOvertimeClassificationName: Record<Locale, string> = {
	ar: `الأخطاء السابقة تمنع تصنيف العمل الإضافي`,
	de: `Prior-Fehler blocken die Überzeitklassifikation`,
	es: `Los errores previos bloquean la clasificación en tiempo extra`,
	fa: `خطاهای قبلی مانع طبقه بندی اضافه کاری می شوند`,
	fil: `Ang mga naunang pagkakamali ay nakaharang sa pag-uuri ng overtime`,
	fr: `Les erreurs antérieures bloquent la classification en temps additionnel`,
	hi: `पूर्व त्रुटियाँ ओवरटाइम वर्गीकरण को अवरुद्ध करती हैं`,
	ht: `Erè anvan yo bloke klasifikasyon siplemantè`,
	it: `Gli errori precedenti bloccano la classificazione degli overtime`,
	ja: `事前誤りは延長時間分類をブロックします`,
	ko: `사전 오류는 연장전 분류를 차단합니다`,
	mww: `Ua ntej yuam kev thaiv kev faib tawm sijhawm dhau sijhawm`,
	ps: `مخکینی تېروتنې د اضافی وخت طبقه بندی مخه نیسی`,
	pt: `Erros anteriores bloqueiam a classificação em tempo extra`,
	'pt-pt': `Erros anteriores bloqueiam a classificação em prolongamento`,
	ru: `Предыдущие ошибки блокируют классификацию овертайма`,
	sm: `O mea sese na muamua atu e poloka ai le faavasegaina o ovataimi`,
	so: `Khaladaadkii hore ayaa xannibay kala soocidda waqtiga dheeraadka ah`,
	th: `ข้อผิดพลาดก่อนหน้านี้บล็อกการจําแนกประเภทการทํางานล่วงเวลา`,
	ur: `سابقہ غلطیاں اوور ٹائم کی درجہ بندی کو روکتی ہیں`,
	vi: `Các lỗi trước đó chặn phân loại làm thêm giờ`,
	'zh-hans': `先验错误阻挡加时赛分类`,
	'zh-hant': `先前錯誤區塊加時分類`,
	en: `Prior errors block overtime classification`
};

export const loc_tsErrorWorkDateOutsideAuthorizationDatesDesc: Record<Locale, string> = {
	ar: `تاريخ العمل ليس ضمن تواريخ بدء وانتهاء تفويض الخدمة.`,
	de: `Das Arbeitsdatum liegt nicht im Start- und Enddatum der Dienstgenehmigung.`,
	es: `La fecha de trabajo no está dentro de las fechas de inicio y fin de la autorización de servicio.`,
	fa: `تاریخ کاری در تاریخ های شروع و پایان مجوز خدمت قرار نمی گیرد.`,
	fil: `Ang petsa ng trabaho ay hindi nasa loob ng mga petsa ng pagsisimula at pagtatapos ng pahintulot sa serbisyo.`,
	fr: `La date de travail ne correspond pas aux dates de début et de fin de l’autorisation de service.`,
	hi: `कार्य दिनांक सेवा प्राधिकरण प्रारंभ और समाप्ति दिनांक के भीतर नहीं है.`,
	ht: `Dat travay la pa nan dat otorizasyon sèvis la kòmanse ak fen`,
	it: `La data di lavoro non rientra nelle date di inizio e fine dell'autorizzazione al servizio.`,
	ja: `作業日はサービス承認の開始日と終了日内に含まれていません。`,
	ko: `작업 날짜는 서비스 승인 시작 및 종료일 내에 포함되어 있지 않습니다.`,
	mww: `Hnub ua hauj lwm tsis nyob rau hauv daim ntawv tso cai kev pab cuam pib thiab xaus hnub.`,
	ps: `د کار نېټه د خدمت د اجازه د پیل او پای نیټو دننه نه ده.`,
	pt: `A data de trabalho não está dentro das datas de início e término da autorização de serviço.`,
	'pt-pt': `A data de trabalho não está dentro das datas de início e fim da autorização de serviço.`,
	ru: `Дата работы не входит в даты начала и окончания разрешения на службу.`,
	sm: `O le aso faigaluega e le o i totonu o le aso amata ma le aso e faamuta ai le faatagaga o le auaunaga.`,
	so: `Taariikhda shaqada kuma jirto taariikhaha bilowga iyo dhammaadka ogolaanshaha adeegga.`,
	th: `วันที่ทํางานไม่อยู่ภายในวันที่เริ่มต้นและวันที่สิ้นสุดการอนุญาตบริการ`,
	ur: `کام کی تاریخ سروس آتھورائزیشن کے آغاز اور اختتام کی تاریخوں میں شامل نہیں ہے۔`,
	vi: `Ngày làm việc không nằm trong ngày bắt đầu và ngày kết thúc ủy quyền dịch vụ.`,
	'zh-hans': `工作日期不在服务授权的开始和结束日期内。`,
	'zh-hant': `工作日期不在服務授權的開始與結束日期內。`,
	en: `The work date is not within the service authorization start and end dates.`
};

export const loc_tsErrorWorkDateOutsideAuthorizationDatesName: Record<Locale, string> = {
	ar: `تاريخ العمل خارج تواريخ التفويض`,
	de: `Arbeitstermin außerhalb der Genehmigungsdaten`,
	es: `Fecha de trabajo fuera de las fechas de autorización`,
	fa: `تاریخ کاری خارج از تاریخ های مجوز`,
	fil: `Petsa ng trabaho sa labas ng mga petsa ng awtorisasyon`,
	fr: `Date de travail hors dates d’autorisation`,
	hi: `प्राधिकरण तिथियों के बाहर कार्य दिनांक`,
	ht: `Dat travay andeyò dat otorizasyon`,
	it: `Data di lavoro fuori dalle date di autorizzazione`,
	ja: `許可日外の作業日`,
	ko: `승인 날짜 외의 작업 날짜`,
	mww: `Hnub ua haujlwm sab nraud ntawm cov hnub tso cai`,
	ps: `د اجازې نیټو څخه بهر د کار نیټه`,
	pt: `Data de trabalho fora das datas de autorização`,
	'pt-pt': `Data de trabalho fora das datas de autorização`,
	ru: `Дата работы вне даты авторизации`,
	sm: `Aso faigaluega i fafo atu o aso e faataga ai`,
	so: `Taariikhda shaqada ee ka baxsan taariikhaha oggolaanshihiisa`,
	th: `วันที่ทํางานนอกวันที่ได้รับอนุญาต`,
	ur: `اجازت کی تاریخوں کے باہر کام کی تاریخ`,
	vi: `Ngày làm việc ngoài ngày ủy quyền`,
	'zh-hans': `工作日期超出授权日期`,
	'zh-hant': `工作日期超出授權日期`,
	en: `Work date outside authorization dates`
};

export const loc_type: Record<Locale, string> = {
	ar: `النوع`,
	de: `Typ`,
	es: `Tipo`,
	fa: `نوع`,
	fil: `Uri`,
	fr: `Type`,
	hi: `प्रकार`,
	ht: `Kalite`,
	it: `Tipo`,
	ja: `種類`,
	ko: `유형`,
	mww: `Hom`,
	ps: `ډول`,
	pt: `Tipo`,
	'pt-pt': `Tipo`,
	ru: `Тип`,
	sm: `Ituaiga`,
	so: `Nooca`,
	th: `ชนิดภาพเขียน`,
	ur: `قسم`,
	vi: `Kiểu`,
	'zh-hans': `类型`,
	'zh-hant': `類型`,
	en: `Type`
};

export const loc_unanswered: Record<Locale, string> = {
	ar: `بلا إجابة`,
	de: `Unbeantwortet`,
	es: `Sin respuesta`,
	fa: `بی پاسخ`,
	fil: `Hindi nasagot`,
	fr: `Sans réponse`,
	hi: `अनुत्तरित`,
	ht: `San repons`,
	it: `Senza risposta`,
	ja: `返事なし`,
	ko: `답변 없음`,
	mww: `Tsis teb`,
	ps: `بې ځوابه`,
	pt: `Sem resposta`,
	'pt-pt': `Sem resposta`,
	ru: `Без ответа`,
	sm: `E le'i taliina`,
	so: `Jawaab la'aan`,
	th: `ไม่มีคําตอบ`,
	ur: `جواب طلب`,
	vi: `Chưa được trả lời`,
	'zh-hans': `无人回应`,
	'zh-hant': `無人回應`,
	en: `Unanswered`
};

export const loc_unassigned: Record<Locale, string> = {
	ar: `غير مخصص`,
	de: `Nicht zugewiesen`,
	es: `Sin asignación`,
	fa: `بدون تخصیص`,
	fil: `Hindi nakatalaga`,
	fr: `Non attribué`,
	hi: `असाइन नहीं किया गया`,
	ht: `Ki pa asiyen`,
	it: `Non assegnati`,
	ja: `未配属`,
	ko: `미할당`,
	mww: `tsis raug tso cai`,
	ps: `غیر ټاکل شوی`,
	pt: `Não atribuído`,
	'pt-pt': `Não atribuído`,
	ru: `Без назначения`,
	sm: `E le'i tofia`,
	so: `Aan la xilsaarin`,
	th: `ไม่ได้มอบหมาย`,
	ur: `غیر تفویض شدہ`,
	vi: `Chưa được chỉ định`,
	'zh-hans': `未分配`,
	'zh-hant': `未分配`,
	en: `Unassigned`
};

export const loc_unavailable: Record<Locale, string> = {
	ar: `غير متوفر`,
	de: `Nicht verfügbar`,
	es: `No disponible`,
	fa: `در دسترس نیست`,
	fil: `Hindi magagamit`,
	fr: `Indisponible`,
	hi: `अनुपलब्ध`,
	ht: `Pa disponib`,
	it: `Non disponibile`,
	ja: `利用不可`,
	ko: `사용 불가`,
	mww: `Tsis muaj`,
	ps: `شتون نشته`,
	pt: `Não disponível`,
	'pt-pt': `Não disponível`,
	ru: `Недоступно`,
	sm: `E le maua`,
	so: `Lama heli karo`,
	th: `ไม่พร้อมใช้งาน`,
	ur: `دستیاب نہیں`,
	vi: `Không có sẵn`,
	'zh-hans': `不可用`,
	'zh-hant': `無法取得`,
	en: `Unavailable`
};

export const loc_undo: Record<Locale, string> = {
	ar: `التراجع`,
	de: `Rückgängig machen`,
	es: `Deshacer`,
	fa: `بازگردان`,
	fil: `I-undo`,
	fr: `Annuler`,
	hi: `पूर्ववत करें`,
	ht: `Defèt`,
	it: `Annulla`,
	ja: `元に戻す`,
	ko: `되돌리기`,
	mww: `thim rov qab`,
	ps: `بېرته واخلو`,
	pt: `Desfazer`,
	'pt-pt': `Desfazer`,
	ru: `Отменить`,
	sm: `Toe fa'afo'i`,
	so: `Undo`,
	th: `เลิกทํา`,
	ur: `واپس لوٹنا`,
	vi: `Hoàn tác`,
	'zh-hans': `撤销`,
	'zh-hant': `還原`,
	en: `Undo`
};

export const loc_unknown: Record<Locale, string> = {
	ar: `غير معروف`,
	de: `Unbekannt`,
	es: `Desconocido`,
	fa: `نامشخص`,
	fil: `Hindi kilala`,
	fr: `Inconnu`,
	hi: `अप्रसिद्घ व्यक्ति`,
	ht: `Enkoni`,
	it: `Sconosciuto`,
	ja: `不明`,
	ko: `미상`,
	mww: `Tsis paub`,
	ps: `نامعلوم`,
	pt: `Desconhecido`,
	'pt-pt': `Desconhecido`,
	ru: `Неизвестно`,
	sm: `E le iloa`,
	so: `Lama yaqaan`,
	th: `ไม่ทราบ`,
	ur: `نامعلوم`,
	vi: `Không xác định`,
	'zh-hans': `未知`,
	'zh-hant': `未知`,
	en: `Unknown`
};

export const loc_unspecified: Record<Locale, string> = {
	ar: `غير محدد`,
	de: `Unspezifiziert`,
	es: `No especificado`,
	fa: `نامشخص`,
	fil: `Hindi tinukoy`,
	fr: `Non précisé`,
	hi: `अनिर्दिष्ट`,
	ht: `Pa espesifye`,
	it: `Non specificato`,
	ja: `不明`,
	ko: `미지정`,
	mww: `Tsis paub meej`,
	ps: `نامعلوم`,
	pt: `Não especificado`,
	'pt-pt': `Não especificado`,
	ru: `Не уточнено`,
	sm: `E le'i fa'amaonia`,
	so: `Lama cayimin`,
	th: `ไม่ระบุ`,
	ur: `غیر متعین`,
	vi: `Không xác định`,
	'zh-hans': `未说明`,
	'zh-hant': `未具體說明`,
	en: `Unspecified`
};

export const loc_unspecifiedLocation: Record<Locale, string> = {
	ar: `موقع غير محدد`,
	de: `Nicht näher bezeichneter Ort`,
	es: `Ubicación no especificada`,
	fa: `مکان نامشخص`,
	fil: `Hindi tinukoy na lokasyon`,
	fr: `Emplacement non spécifié`,
	hi: `अनिर्दिष्ट स्थान`,
	ht: `Ki pa espesifye kote`,
	it: `Posizione non specificata`,
	ja: `場所不明`,
	ko: `미지정 위치`,
	mww: `Qhov chaw tsis tau teev tseg`,
	ps: `نامعلوم ځای`,
	pt: `Localização não especificada`,
	'pt-pt': `Localização não especificada`,
	ru: `Неуточнённое местоположение`,
	sm: `Nofoaga e le'i fa'amaonia`,
	so: `Goob aan la cayimin`,
	th: `สถานที่ที่ไม่ระบุ`,
	ur: `غیر متعین مقام`,
	vi: `Vị trí không xác định`,
	'zh-hans': `未指定地点`,
	'zh-hant': `地點未明`,
	en: `Unspecified location`
};

export const loc_unspecifiedSchedule: Record<Locale, string> = {
	ar: `جدول غير محدد`,
	de: `Nicht näher spezifizierter Zeitplan`,
	es: `Calendario no especificado`,
	fa: `برنامه زمانی نامشخص`,
	fil: `Hindi tinukoy na iskedyul`,
	fr: `Calendrier non précisé`,
	hi: `अनिर्दिष्ट कार्यक्रम`,
	ht: `Orè ki pa espesifye`,
	it: `Programma non specificato`,
	ja: `スケジュール不明`,
	ko: `일정 미상`,
	mww: `Tsis tau teev tseg`,
	ps: `نامعلوم مهالویش`,
	pt: `Cronograma não especificado`,
	'pt-pt': `Calendário não especificado`,
	ru: `Неуточнённое расписание`,
	sm: `Fa'asologa e le'i fa'amaonia`,
	so: `Jadwalka aan la cayimin`,
	th: `กําหนดการที่ไม่ระบุ`,
	ur: `غیر متعین شیڈول`,
	vi: `Lịch trình không xác định`,
	'zh-hans': `未注明的赛程`,
	'zh-hant': `未明確的賽程`,
	en: `Unspecified schedule`
};

export const loc_unspecifiedVaccinations: Record<Locale, string> = {
	ar: `لقاحات غير محددة`,
	de: `Nicht näher bezeichnete Impfungen`,
	es: `Vacunaciones no especificadas`,
	fa: `واکسیناسیون های نامشخص`,
	fil: `Mga hindi natukoy na pagbabakuna`,
	fr: `Vaccins non spécifiés`,
	hi: `अनिर्दिष्ट टीकाकरण`,
	ht: `Vaksinasyon ki pa espesifye`,
	it: `Vaccinazioni non specificate`,
	ja: `ワクチン接種の種類は不明です`,
	ko: `명시되지 않은 백신 접종`,
	mww: `Cov tshuaj tiv thaiv tsis tau teev tseg`,
	ps: `نامعلوم واکسینونه`,
	pt: `Vacinações não especificadas`,
	'pt-pt': `Vacinações não especificadas`,
	ru: `Неуточнённые вакцины`,
	sm: `Tui e le'i fa'amaonia`,
	so: `Tallaallo aan la cayimin`,
	th: `การฉีดวัคซีนที่ไม่ระบุรายละเอียด`,
	ur: `غیر متعین ویکسینیشن`,
	vi: `Tiêm chủng không xác định`,
	'zh-hans': `未具体说明的疫苗接种`,
	'zh-hant': `未具體說明的疫苗接種`,
	en: `Unspecified vaccinations`
};

export const loc_unsubscribe: Record<Locale, string> = {
	ar: `إلغاء الاشتراك`,
	de: `Abmelden`,
	es: `Cancelar suscripción`,
	fa: `لغو اشتراک`,
	fil: `Email Address *`,
	fr: `Désabonnement`,
	hi: `सदस्यता समाप्त करें`,
	ht: `Koupe abònman`,
	it: `Disiscriverti`,
	ja: `購読解除`,
	ko: `구독 취소`,
	mww: `Tshem tawm`,
	ps: `لغوه کړه`,
	pt: `Desinscrição`,
	'pt-pt': `Desassinar`,
	ru: `Отписаться`,
	sm: `Unsubscribe`,
	so: `Ka bax isdiiwaangelinta`,
	th: `ยกเลิกการสมัคร`,
	ur: `ان سبسکرائب کریں`,
	vi: `Hủy đăng ký`,
	'zh-hans': `取消订阅`,
	'zh-hant': `取消訂閱`,
	en: `Unsubscribe`
};

export const loc_unverifiedAddress: Record<Locale, string> = {
	ar: `عنوان غير موثق`,
	de: `Unbestätigte Adresse`,
	es: `Dirección no verificada`,
	fa: `آدرس تأییدنشده`,
	fil: `Hindi na-verify na address`,
	fr: `Adresse non vérifiée`,
	hi: `असत्यापित पता`,
	ht: `Adrès ki pa verifye`,
	it: `Indirizzo non verificato`,
	ja: `未確認の住所`,
	ko: `미확인 주소`,
	mww: `Qhov chaw nyob uas tsis tau txheeb xyuas`,
	ps: `نه تایید شوې پته`,
	pt: `Endereço não verificado`,
	'pt-pt': `Endereço não verificado`,
	ru: `Неподтверждённый адрес`,
	sm: `Tuatusi e le'i faamaonia`,
	so: `Cinwaan aan la xaqiijin`,
	th: `ที่อยู่ที่ไม่ได้รับการยืนยัน`,
	ur: `غیر تصدیق شدہ پتہ`,
	vi: `Địa chỉ chưa được xác minh`,
	'zh-hans': `未验证地址`,
	'zh-hant': `未驗證地址`,
	en: `Unverified address`
};

export const loc_upcoming: Record<Locale, string> = {
	ar: `قادم`,
	de: `Demnächst`,
	es: `Próximas`,
	fa: `در راه`,
	fil: `Paparating na`,
	fr: `À venir`,
	hi: `आगामी`,
	ht: `Kap vini an`,
	it: `Prossime`,
	ja: `今後の予定`,
	ko: `곧 있을 예정`,
	mww: `Yav tom ntej`,
	ps: `راتلونکی`,
	pt: `Próximos`,
	'pt-pt': `Próximos`,
	ru: `В ближайшем будущем`,
	sm: `O le a sosoo ai`,
	so: `Soo socda`,
	th: `กําลังจะมาถึง`,
	ur: `آنے والا`,
	vi: `Sắp tới`,
	'zh-hans': `即将到来`,
	'zh-hant': `即將推出`,
	en: `Upcoming`
};

export const loc_upcomingVaccineClinics: Record<Locale, string> = {
	ar: `عيادات اللقاحات القادمة`,
	de: `Bevorstehende Impfkliniken`,
	es: `Próximas clínicas de vacunación`,
	fa: `کلینیک های واکسن آینده`,
	fil: `Mga paparating na klinika sa bakuna`,
	fr: `Cliniques de vaccination à venir`,
	hi: `आगामी वैक्सीन क्लीनिक`,
	ht: `Klinik vaksen kap vini yo`,
	it: `Prossime cliniche per la vaccinazione`,
	ja: `今後のワクチンクリニック`,
	ko: `예정된 백신 클리닉`,
	mww: `Cov chaw txhaj tshuaj tiv thaiv tom ntej`,
	ps: `راتلونکی واکسین کلینیکونه`,
	pt: `Clínicas de vacinação futuras`,
	'pt-pt': `Clínicas de vacinação futuras`,
	ru: `Предстоящие клиники по вакцинации`,
	sm: `Falema'i o tui o lo'o lumana'i`,
	so: `Rugaha tallaalka ee soo socda`,
	th: `คลินิกวัคซีนที่กําลังจะมาถึง`,
	ur: `آنے والے ویکسین کلینکس`,
	vi: `Các phòng khám vắc-xin sắp tới`,
	'zh-hans': `即将开设的疫苗诊所`,
	'zh-hant': `即將舉辦的疫苗診所`,
	en: `Upcoming vaccine clinics`
};

export const loc_updateComment: Record<Locale, string> = {
	ar: `تحديث التعليق`,
	de: `Kommentar aktualisieren`,
	es: `Comentario de actualización`,
	fa: `به روزرسانی نظر`,
	fil: `I-update ang komento`,
	fr: `Commentaire à jour`,
	hi: `टिप्पणी अपडेट करें`,
	ht: `Kòmantè mete ajou`,
	it: `Commento aggiornato`,
	ja: `アップデートコメント`,
	ko: `업데이트 댓글`,
	mww: `Hloov kho tawm tswv yim`,
	ps: `د نظر تازه معلومات`,
	pt: `Comentário de atualização`,
	'pt-pt': `Comentário de atualização`,
	ru: `Комментарий к обновлению`,
	sm: `Fa'afouina fa'amatalaga`,
	so: `Faallo cusbooneysiin`,
	th: `อัปเดตความคิดเห็น`,
	ur: `تبصرہ اپ ڈیٹ کریں`,
	vi: `Cập nhật bình luận`,
	'zh-hans': `更新评论`,
	'zh-hant': `更新留言`,
	en: `Update comment`
};

export const loc_updated: Record<Locale, string> = {
	ar: `تحديث`,
	de: `Aktualisiert`,
	es: `Actualizado`,
	fa: `به روزرسانی شده`,
	fil: `Nai-update`,
	fr: `Mise à jour`,
	hi: `अपडेट किया गया`,
	ht: `Mizajou`,
	it: `Aggiornato`,
	ja: `更新`,
	ko: `업데이트됨`,
	mww: `Hloov tshiab`,
	ps: `تازه شوی`,
	pt: `Atualizado`,
	'pt-pt': `Atualizado`,
	ru: `Обновлено`,
	sm: `Fa'afouina`,
	so: `La cusbooneysiiyay`,
	th: `อัพเดท`,
	ur: `تازہ کاری`,
	vi: `Cập nhật`,
	'zh-hans': `更新`,
	'zh-hant': `更新`,
	en: `Updated`
};

export const loc_updatedFormat: Record<Locale, (date: unknown) => TemplateResult> = {
	ar: (date) => html`<span>تم التحديث ${date}</span>`,
	de: (date) => html`<span>Aktualisiert ${date}</span>`,
	es: (date) => html`<span>Actualizado ${date}</span>`,
	fa: (date) => html`<span>${date} به روزرسانی شد</span>`,
	fil: (date) => html`<span>Nai-update ${date}</span>`,
	fr: (date) => html`<span>Mise à jour ${date}</span>`,
	hi: (date) => html`<span>3 ${date} अपडेट किया गया</span>`,
	ht: (date) => html`<span>Mizajou ${date}</span>`,
	it: (date) => html`<span>Aggiornato ${date}</span>`,
	ja: (date) => html`<span>${date}に更新</span>`,
	ko: (date) => html`<span>${date} 업데이트됨</span>`,
	mww: (date) => html`<span>Hloov tshiab ${date}</span>`,
	ps: (date) => html`<span>${date} تازه شوی</span>`,
	pt: (date) => html`<span>Atualizado ${date}</span>`,
	'pt-pt': (date) => html`<span>Atualizado ${date}</span>`,
	ru: (date) => html`<span>${date}</span>`,
	sm: (date) => html`<span>Fa'afouina ${date}</span>`,
	so: (date) => html`<span>La cusbooneysiiyay ${date}</span>`,
	th: (date) => html`<span>อัพเดทเมื่อ ${date}</span>`,
	ur: (date) => html`<span>${date} اپ ڈیٹ کیا گیا</span>`,
	vi: (date) => html`<span>Cập nhật ${date}</span>`,
	'zh-hans': (date) => html`<span>更新 ${date}</span>`,
	'zh-hant': (date) => html`<span>更新 ${date}</span>`,
	en: (date) => html`<span>Updated ${date}</span>`
};

export const loc_updatedThisActivity: Record<Locale, string> = {
	ar: `قمت بتحديث هذا النشاط.`,
	de: `Diese Aktivität wurde aktualisiert.`,
	es: `He actualizado esta actividad.`,
	fa: `این فعالیت را به روزرسانی کردم.`,
	fil: `Na-update ang aktibidad na ito.`,
	fr: `Mise à jour de cette activité.`,
	hi: `इस गतिविधि को अपडेट किया गया।`,
	ht: `Mizajou aktivite sa a.`,
	it: `Aggiornato questa attività.`,
	ja: `この活動を更新しました。`,
	ko: `이 활동을 업데이트했습니다.`,
	mww: `Hloov kho qhov kev ua no.`,
	ps: `دا فعالیت تازه کړ.`,
	pt: `Atualizei esta atividade.`,
	'pt-pt': `Atualizei esta atividade.`,
	ru: `Обновил эту активность.`,
	sm: `Fa'afouina lenei gaoioiga.`,
	so: `Waxaan cusbooneysiiyay hawshan.`,
	th: `อัปเดตกิจกรรมนี้`,
	ur: `اس سرگرمی کو اپ ڈیٹ کیا گیا۔`,
	vi: `Cập nhật hoạt động này.`,
	'zh-hans': `更新了此活动。`,
	'zh-hant': `更新了此活動。`,
	en: `Updated this activity.`
};

export const loc_updatingEllipses: Record<Locale, string> = {
	ar: `جاري التحديث...`,
	de: `Aktualisierung...`,
	es: `Actualizando...`,
	fa: `در حال به روزرسانی...`,
	fil: `Pag-update...`,
	fr: `Mise à jour...`,
	hi: `अद्यतन कर रहा है...`,
	ht: `Mete ajou...`,
	it: `Aggiornamento...`,
	ja: `更新中...`,
	ko: `업데이트 중입니다...`,
	mww: `Hloov tshiab...`,
	ps: `تازه کول...`,
	pt: `Atualizando...`,
	'pt-pt': `Atualização...`,
	ru: `Обновление...`,
	sm: `Fa'afouina ...`,
	so: `Cusbooneysiin...`,
	th: `กําลังอัปเดต...`,
	ur: `اپ ڈیٹ کر رہا ہوں...`,
	vi: `Đang cập nhật...`,
	'zh-hans': `更新中......`,
	'zh-hant': `更新中......`,
	en: `Updating...`
};

export const loc_upload: Record<Locale, string> = {
	ar: `رفع`,
	de: `Hochladen`,
	es: `Subida`,
	fa: `بارگذاری`,
	fil: `Email Address *`,
	fr: `Téléverser`,
	hi: `अपलोड करें`,
	ht: `Voye`,
	it: `Caricamento`,
	ja: `アップロード`,
	ko: `업로드`,
	mww: `Upload`,
	ps: `اپلوډ`,
	pt: `Upload`,
	'pt-pt': `Upload`,
	ru: `Загрузка`,
	sm: `Fa'apipi'i`,
	so: `Soo gelin`,
	th: `อัปโหลด`,
	ur: `اپ لوڈ کریں`,
	vi: `Tải lên`,
	'zh-hans': `上传`,
	'zh-hant': `上傳`,
	en: `Upload`
};

export const loc_uploadFileErrorFormat: Record<Locale, (filename: unknown) => string> = {
	ar: (filename) => `خطأ في رفع "${filename}".`,
	de: (filename) => `Fehler beim Hochladen von "${filename}".`,
	es: (filename) => `Error al subir "${filename}".`,
	fa: (filename) => `خطا در بارگذاری «${filename}».`,
	fil: (filename) => `Error sa pag-upload ng "${filename}".`,
	fr: (filename) => `Erreur de téléchargement de « ${filename} ».`,
	hi: (filename) => `"${filename} अपलोड करने में त्रुटि।`,
	ht: (filename) => `Erè uploading "${filename}".`,
	it: (filename) => `Errore nel caricamento di "${filename}".`,
	ja: (filename) => `「${filename}」のアップロードエラーが発生しました。`,
	ko: (filename) => `"${filename}" 업로드 오류.`,
	mww: (filename) => `Yuam kev uploading "${filename}".`,
	ps: (filename) => `د "${filename}" اپلوډ کې تېروتنه ده.`,
	pt: (filename) => `Erro ao enviar "${filename}".`,
	'pt-pt': (filename) => `Erro ao carregar "${filename}".`,
	ru: (filename) => `Ошибка при загрузке "${filename}".`,
	sm: (filename) => `Error uploading "${filename}".`,
	so: (filename) => `Khalad ku jira upload-ka "${filename}".`,
	th: (filename) => `เกิดข้อผิดพลาดในการอัปโหลด "${filename}"`,
	ur: (filename) => `"${filename}" اپلوڈ کرنے میں خرابی۔`,
	vi: (filename) => `Lỗi tải lên "${filename}".`,
	'zh-hans': (filename) => `上传“${filename}”错误。`,
	'zh-hant': (filename) => `上傳「${filename}」錯誤。`,
	en: (filename) => `Error uploading "${filename}".`
};

export const loc_uploadFilesProgressFormat: Record<Locale, (index: unknown, length: unknown) => string> = {
	ar: (index, length) => `رفع ملفاتك... (${index}/${length})`,
	de: (index, length) => `Deine Dateien hochladen... (${index}/${length})`,
	es: (index, length) => `Subiendo tus archivos... (${index}/${length})`,
	fa: (index, length) => `فایل هایتان را آپلود می کنید... (${index}/${length})`,
	fil: (index, length) => `I-upload ang Iyong Mga File ... (${index}/${length})`,
	fr: (index, length) => `Téléchargement de tes fichiers... (${index}/${length})`,
	hi: (index, length) => `अपनी फ़ाइलें अपलोड कर रहा हूँ... (${index}/${length})`,
	ht: (index, length) => `Téléchargement fichiers ou ... (${index}/${length})`,
	it: (index, length) => `Caricamento dei tuoi file... (${index}/${length})`,
	ja: (index, length) => `ファイルをアップロード中...(${index}/${length})`,
	ko: (index, length) => `파일 업로드 중... (${index}/${length})`,
	mww: (index, length) => `Uploading koj cov ntaub ntawv... (${index}/${length})`,
	ps: (index, length) => `ستا فایلونه اپلوډ کول... (${index}/${length})`,
	pt: (index, length) => `Enviando seus arquivos... (${index}/${length})`,
	'pt-pt': (index, length) => `A carregar os teus ficheiros... (${index}/${length})`,
	ru: (index, length) => `Загружаю ваши файлы... (${index}/${length})`,
	sm: (index, length) => `Fa'apipi'i lau 'upega tafa'ilagi ... (${index}/${length})`,
	so: (index, length) => `Faylashaada la gelinayaa... (${index}/${length})`,
	th: (index, length) => `กําลังอัปโหลดไฟล์ของคุณ... (${index}/${length})`,
	ur: (index, length) => `آپ کی فائلیں اپلوڈ کر رہے ہیں... (${index}/${length})`,
	vi: (index, length) => `Đang tải lên tệp của bạn... (${index}/${length})`,
	'zh-hans': (index, length) => `上传你的文件......（${index}/${length}）`,
	'zh-hant': (index, length) => `上傳你的檔案......（${index}/${length}）`,
	en: (index, length) => `Uploading your files... (${index}/${length})`
};

export const loc_uploadNewPicture: Record<Locale, string> = {
	ar: `رفع صورة جديدة`,
	de: `Neues Bild hochladen`,
	es: `Subir nueva imagen`,
	fa: `آپلود عکس جدید`,
	fil: `Mag-upload ng bagong larawan`,
	fr: `Télécharger une nouvelle image`,
	hi: `नई तस्वीर अपलोड करें`,
	ht: `Voye nouvo foto`,
	it: `Carica nuova immagine`,
	ja: `新しい写真をアップロードする`,
	ko: `새 사진 업로드`,
	mww: `Upload daim duab tshiab`,
	ps: `نوې انځور پورته کړئ`,
	pt: `Enviar nova imagem`,
	'pt-pt': `Carregar nova imagem`,
	ru: `Загрузить новую фотографию`,
	sm: `Fa'apipi'i le ata fou`,
	so: `Soo geli sawir cusub`,
	th: `อัปโหลดรูปภาพใหม่`,
	ur: `نئی تصویر اپلوڈ کریں`,
	vi: `Tải lên hình ảnh mới`,
	'zh-hans': `上传新图片`,
	'zh-hant': `上傳新照片`,
	en: `Upload new picture`
};

export const loc_uploadPhotoDescription: Record<Locale, string> = {
	ar: `قم برفع صورة لنفسك لتخصيص حسابك ومساعدة الآخرين على التعرف عليك بسهولة عبر التطبيق.`,
	de: `Lade ein Foto von dir hoch, um dein Konto zu personalisieren und anderen zu helfen, dich in der App leicht wiederzuerkennen.`,
	es: `Sube una foto tuya para personalizar tu cuenta y ayudar a que los demás te reconozcan fácilmente a través de la app.`,
	fa: `یک عکس از خودتان بارگذاری کنید تا حساب کاربری تان شخصی سازی شود و به دیگران کمک کنید راحت تر شما را در اپلیکیشن بشناسند.`,
	fil: `Mag-upload ng larawan ng iyong sarili upang i-personalize ang iyong account at tulungan ang iba na madaling makilala ka sa buong app.`,
	fr: `Téléchargez une photo de vous pour personnaliser votre compte et aider les autres à vous reconnaître facilement sur l’application.`,
	hi: `अपने खाते को वैयक्तिकृत करने के लिए अपनी एक तस्वीर अपलोड करें और दूसरों को ऐप में आपको आसानी से पहचानने में मदद करें।`,
	ht: `Voye yon foto nan tèt ou pèsonalize kont ou epi ede lòt moun fasil rekonèt ou atravè app a.`,
	it: `Carica una foto di te stesso per personalizzare il tuo account e aiutare gli altri a riconoscerti facilmente sull'app.`,
	ja: `自分の写真をアップロードしてアカウントをパーソナライズし、アプリ内で他の人に簡単に認識されやすくなります。`,
	ko: `자신의 사진을 올려 계정을 개인화하고 앱 전반에서 다른 사람들이 쉽게 알아볼 수 있도록 하세요.`,
	mww: `Upload ib daim duab ntawm koj tus kheej los ua tus kheej koj tus account thiab pab lwm tus neeg yooj yim paub koj thoob plaws lub app.`,
	ps: `د خپل ځان عکس پورته کړئ ترڅو خپل حساب شخصی کړئ او نورو ته مرسته وکړئ چې تاسو په اسانۍ سره د اپلیکیشن له لارې وپیژنی.`,
	pt: `Envie uma foto sua para personalizar sua conta e ajudar os outros a te reconhecerem facilmente pelo aplicativo.`,
	'pt-pt': `Carrega uma foto tua para personalizar a tua conta e ajudar os outros a reconhecer-te facilmente através da aplicação.`,
	ru: `Загрузите свою фотографию, чтобы персонализировать аккаунт и помочь другим легко узнать вас в приложении.`,
	sm: `Fa'apipi'i se ata o oe lava e fa'apitoa ai lau teuga tupe ma fesoasoani i isi ia faigofie ona iloa oe i luga o le app.`,
	so: `Soo geli sawirkaaga si aad akoonkaaga u shakhsiyeen oo dadka kale si fudud kuugu aqoonsadaan app-ka.`,
	th: `อัปโหลดรูปภาพของตัวคุณเองเพื่อปรับแต่งบัญชีของคุณและช่วยให้ผู้อื่นจดจําคุณได้อย่างง่ายดายทั่วทั้งแอป`,
	ur: `اپنی تصویر اپلوڈ کریں تاکہ آپ کا اکاؤنٹ ذاتی نوعیت کا ہو اور دوسروں کو ایپ پر آسانی سے پہچاننے میں مدد ملے۔`,
	vi: `Tải lên ảnh của chính bạn để cá nhân hóa tài khoản của bạn và giúp người khác dễ dàng nhận ra bạn trên ứng dụng.`,
	'zh-hans': `上传一张自己的照片，个性化你的账号，帮助别人在应用中轻松认出你。`,
	'zh-hant': `上傳一張自己的照片，讓帳號更個人化，也讓別人在整個應用程式中更容易認出你。`,
	en: `Upload a photo of yourself to personalize your account and help others easily recognize you across the app.`
};

export const loc_usage: Record<Locale, string> = {
	ar: `الاستخدام`,
	de: `Verwendung`,
	es: `Uso`,
	fa: `کاربرد`,
	fil: `Paggamit`,
	fr: `Utilisation`,
	hi: `प्रयोग`,
	ht: `Itilizasyon`,
	it: `Utilizzo`,
	ja: `使用例`,
	ko: `사용`,
	mww: `Kev siv`,
	ps: `کارونه`,
	pt: `Uso`,
	'pt-pt': `Utilização`,
	ru: `Использование`,
	sm: `Fa'aaogaina`,
	so: `Isticmaalka`,
	th: `การใช้`,
	ur: `استعمال`,
	vi: `Sử dụng`,
	'zh-hans': `用途`,
	'zh-hant': `使用情況`,
	en: `Usage`
};

export const loc_user: Record<Locale, string> = {
	ar: `المستخدم`,
	de: `Nutzer`,
	es: `Usuario`,
	fa: `کاربر`,
	fil: `Gumagamit`,
	fr: `Utilisateur`,
	hi: `उपभोक्ता`,
	ht: `Itilizatè`,
	it: `Utente`,
	ja: `ユーザー`,
	ko: `사용자`,
	mww: `Tus neeg siv`,
	ps: `کارونکی`,
	pt: `Usuário`,
	'pt-pt': `Utilizador`,
	ru: `Пользователь`,
	sm: `Tagata fa'aaoga`,
	so: `Isticmaale`,
	th: `ผู้ใช้`,
	ur: `صارف`,
	vi: `Người dùng`,
	'zh-hans': `用户`,
	'zh-hant': `使用者`,
	en: `User`
};

export const loc_username: Record<Locale, string> = {
	ar: `اسم المستخدم`,
	de: `Benutzername`,
	es: `Nombre de usuario`,
	fa: `نام کاربری`,
	fil: `Username`,
	fr: `Nom d’utilisateur`,
	hi: `उपयोगकर्ता नाम`,
	ht: `Non itilizatè a`,
	it: `Nome utente`,
	ja: `ユーザー名`,
	ko: `사용자 이름`,
	mww: `Tus neeg siv npe`,
	ps: `کارن نوم`,
	pt: `Nome de usuário`,
	'pt-pt': `Nome de utilizador`,
	ru: `Имя пользователя`,
	sm: `Igoa faaaoga`,
	so: `Magaca Isticmaalaha`,
	th: `ชื่อผู้ใช้`,
	ur: `یوزر نیم`,
	vi: `Tên đăng nhập`,
	'zh-hans': `用户名`,
	'zh-hant': `用戶名`,
	en: `Username`
};

export const loc_usernameUnavailable: Record<Locale, string> = {
	ar: `اسم المستخدم غير متاح`,
	de: `Benutzername nicht verfügbar`,
	es: `Nombre de usuario no disponible`,
	fa: `نام کاربری در دسترس نیست`,
	fil: `Hindi magagamit ang username`,
	fr: `Nom d’utilisateur indisponible`,
	hi: `उपयोगकर्ता नाम अनुपलब्ध`,
	ht: `Non itilizatè pa disponib`,
	it: `Nome utente non disponibile`,
	ja: `ユーザー名が利用できません`,
	ko: `사용자 이름이 제공되지 않음`,
	mww: `Username tsis muaj`,
	ps: `کارن نوم شتون نلری`,
	pt: `Nome de usuário indisponível`,
	'pt-pt': `Nome de utilizador indisponível`,
	ru: `Имя пользователя недоступно`,
	sm: `E le o maua le igoa faaaoga`,
	so: `Magaca isticmaale lama heli karo`,
	th: `ชื่อผู้ใช้ไม่พร้อมใช้งาน`,
	ur: `یوزر نیم دستیاب نہیں`,
	vi: `Tên người dùng không khả dụng`,
	'zh-hans': `用户名不可用`,
	'zh-hant': `用戶名稱無法提供`,
	en: `Username unavailable`
};

export const loc_userOrganizationReportDescription: Record<Locale, string> = {
	ar: `أعضاء منظمتك والمتعاونون في المشاريع من منظمات خارجية.`,
	de: `Mitglieder Ihrer Organisation und Projektmitarbeiter von externen Organisationen.`,
	es: `Miembros de tu organización y colaboradores del proyecto de organizaciones externas.`,
	fa: `اعضای سازمان شما و همکاران پروژه از سازمان های خارجی.`,
	fil: `Mga miyembro ng iyong organisasyon at mga nakikipagtulungan sa proyekto mula sa mga panlabas na organisasyon.`,
	fr: `Des membres de votre organisation et des collaborateurs de projets provenant d’organisations extérieures.`,
	hi: `आपके संगठन के सदस्य और बाहरी संगठनों के परियोजना सहयोगी।`,
	ht: `Manm òganizasyon ou ak kolaboratè pwojè ki soti nan òganizasyon deyò yo.`,
	it: `Membri della tua organizzazione e collaboratori di progetto provenienti da organizzazioni esterne.`,
	ja: `あなたの組織のメンバーや外部組織のプロジェクト協力者。`,
	ko: `귀하의 조직 구성원과 외부 조직의 프로젝트 협력자들입니다.`,
	mww: `Cov tswv cuab ntawm koj lub koom haum thiab cov neeg koom tes ua haujlwm los ntawm cov koom haum sab nraud.`,
	ps: `ستاسو د سازمان غړی او د پروژې همکاران له بهرنیو سازمانونو.`,
	pt: `Membros da sua organização e colaboradores do projeto de organizações externas.`,
	'pt-pt': `Membros da sua organização e colaboradores do projeto de organizações externas.`,
	ru: `Члены вашей организации и соавторы проектов из внешних организаций.`,
	sm: `Tagata o lau fa'alapotopotoga ma tagata galulue fa'atasi mai fa'alapotopotoga i fafo.`,
	so: `Xubnaha ururkaaga iyo wada-shaqeeyayaal mashruuc oo ka socda ururo dibadda ah.`,
	th: `สมาชิกในองค์กรของคุณและผู้ทํางานร่วมกันในโครงการจากภายนอกองค์กร`,
	ur: `آپ کی تنظیم کے ارکان اور بیرونی تنظیموں کے پروجیکٹ کے شراکت دار۔`,
	vi: `Các thành viên trong tổ chức của bạn và cộng tác viên dự án từ các tổ chức bên ngoài.`,
	'zh-hans': `你所在组织的成员以及来自外部组织的项目合作者。`,
	'zh-hant': `你組織的成員以及來自外部組織的專案合作者。`,
	en: `Members of your organization and project collaborators from outside organizations.`
};

export const loc_usingActivities: Record<Locale, string> = {
	ar: `استخدام الأنشطة`,
	de: `Nutzung von Aktivitäten`,
	es: `Actividades de uso`,
	fa: `استفاده از فعالیت ها`,
	fil: `Paggamit ng mga aktibidad`,
	fr: `Utilisation des activités`,
	hi: `गतिविधियों का उपयोग करना`,
	ht: `Sèvi ak aktivite yo`,
	it: `Utilizzo delle attività`,
	ja: `アクティビティの利用`,
	ko: `활동 활용`,
	mww: `Siv cov kev ua ub no`,
	ps: `فعالیتونه کارول`,
	pt: `Uso de atividades`,
	'pt-pt': `Utilização de atividades`,
	ru: `Использование деятельности`,
	sm: `Faaaogaina o gaoioiga`,
	so: `Isticmaalka hawlaha`,
	th: `การใช้กิจกรรม`,
	ur: `سرگرمیاں استعمال کرنا`,
	vi: `Sử dụng hoạt động`,
	'zh-hans': `活动使用方法`,
	'zh-hant': `活動運用`,
	en: `Using activities`
};

export const loc_vaccine: Record<Locale, string> = {
	ar: `اللقاح`,
	de: `Impfstoff`,
	es: `Vacuna`,
	fa: `واکسن`,
	fil: `Bakuna`,
	fr: `Vaccin`,
	hi: `वैक्‍सीन`,
	ht: `Vaksen`,
	it: `Vaccino`,
	ja: `ワクチン`,
	ko: `백신`,
	mww: `tshuaj tiv thaiv kab mob`,
	ps: `واکسين`,
	pt: `Vacina`,
	'pt-pt': `Vacina`,
	ru: `Вакцина`,
	sm: `Tui`,
	so: `Tallaalka`,
	th: `วัคซีน`,
	ur: `ویکسین`,
	vi: `Vắc-xin`,
	'zh-hans': `疫苗`,
	'zh-hant': `疫苗`,
	en: `Vaccine`
};

export const loc_validateActivityChildrenCancelled: Record<Locale, string> = {
	ar: `لا يمكن إلغاء النشاط طالما أن أنشطته الفرعية لا تزال في حالة مفتوحة. انتقل إلى تبويب "الأنشطة المرتبطة" وأكمل أو ألغ الأنشطة المدرجة هناك قبل إلغاء هذا النشاط.`,
	de: `Eine Aktivität kann nicht abgebrochen werden, solange ihre Kinderaktivitäten noch offen sind. Gehen Sie zum Reiter "Assoziierte Aktivitäten" und schließen Sie die dort aufgeführten Aktivitäten ab oder kündigen Sie diese Aktivität, bevor Sie diese Aktivität abbrechen.`,
	es: `Una actividad no puede ser cancelada mientras sus actividades secundarias sigan en estado abierto. Accede a la pestaña "Actividades asociadas" y completa o cancela las actividades que aparecen allí antes de cancelar esta actividad.`,
	fa: `یک فعالیت نمی تواند لغو شود در حالی که فعالیت های فرزند آن هنوز در وضعیت باز هستند. به تب «فعالیت های مرتبط» بروید و قبل از لغو این فعالیت، فعالیت های فهرست شده در آنجا را کامل یا لغو کنید.`,
	fil: `Ang isang aktibidad ay hindi maaaring kanselahin habang ang mga aktibidad ng bata ay nasa bukas pa ring katayuan. Mag-navigate sa tab na "Mga Kaugnay na Aktibidad" at kumpletuhin o kanselahin ang mga aktibidad na nakalista doon bago kanselahin ang aktibidad na ito.`,
	fr: `Une activité ne peut pas être annulée tant que ses activités enfants sont encore en statut ouvert. Accédez à l’onglet « Activités associées » et complétez ou annulez les activités listées avant d’annuler cette activité.`,
	hi: `किसी गतिविधि को तब रद्द नहीं किया जा सकता जब उसकी चाइल्ड गतिविधियाँ अभी भी खुली स्थिति में हों. "संबद्ध गतिविधियाँ" टैब पर जाएँ और इस गतिविधि को रद्द करने से पहले वहां सूचीबद्ध गतिविधियों को पूरा या रद्द करें।`,
	ht: `Yon aktivite pa ka anile pandan aktivite pitit li yo toujou nan yon estati ouvè. Navige nan tab la "Aktivite ki asosye yo" epi ranpli oswa anile aktivite ki nan lis la anvan anile aktivite sa a.`,
	it: `Un'attività non può essere annullata finché le attività figlie sono ancora in stato aperto. Accedi alla scheda "Attività associate" e completa o annulla le attività elencate prima di cancellare questa attività.`,
	ja: `子活動がまだオープンな状態では、活動をキャンセルすることはできません。「関連アクティビティ」タブに移動し、そこに記載されたアクティビティをキャンセルする前に、完了またはキャンセルしてください。`,
	ko: `자식 활동이 아직 열려 있는 상태인 동안에는 활동을 취소할 수 없습니다. "관련 활동" 탭으로 이동하여 해당 활동을 완료하거나 취소한 후 이 활동을 취소하세요.`,
	mww: `Ib qho kev ua ub no tsis tuaj yeem raug tshem tawm thaum nws cov me nyuam cov kev ua ub no tseem qhib. Mus rau "Cov kev ua ub no txuam" tab thiab ua kom tiav lossis tshem tawm cov haujlwm uas tau teev tseg ua ntej tshem tawm qhov kev ua no.`,
	ps: `یو فعالیت نشی لغوه کېدای تر څو چې د ماشوم فعالیتونه یې لا هم خلاص حالت کې وی. د "اړوندو فعالیتونو" ټب ته لاړ شئ او هلته لیست شوی فعالیتونه بشپړ یا لغوه کړئ مخکې له دې چې دا فعالیت لغوه کړئ.`,
	pt: `Uma atividade não pode ser cancelada enquanto suas atividades filhas ainda estiverem em status aberto. Navegue até a aba "Atividades Associadas" e complete ou cancele as atividades listadas lá antes de cancelar essa atividade.`,
	'pt-pt': `Uma atividade não pode ser cancelada enquanto as suas atividades filhas ainda estiverem em estado aberto. Navegue até ao separador "Atividades Associadas" e complete ou cancele as atividades aí listadas antes de cancelar esta atividade.`,
	ru: `Активность не может быть отменена, пока её дочерние активности остаются в статусе открытости. Перейдите на вкладку «Связанные мероприятия» и завершите или отмените указанные там мероприятия перед отменой.`,
	sm: `E le mafai ona faaleaogaina se gaoioiga a o tatala pea ana gaoioiga a tamaiti. Alu i le faailoga o le "Gaoioiga e Fesootai i ai" ma faamaea pe faaleaogaina ia gaoioiga o loo lisiina atu iina a o lei faaleaogaina lenei gaoioiga.`,
	so: `Hawl lama joojin karo inta hawlaha carruurta ay weli furan yihiin. U gudub tabka "Hawlaha La Xiriira" oo dhammee ama jooji hawlaha ku taxan ka hor intaadan joojin hawshan.`,
	th: `กิจกรรมไม่สามารถยกเลิกได้ในขณะที่กิจกรรมย่อยยังอยู่ในสถานะเปิดอยู่ ไปที่แท็บ "กิจกรรมที่เกี่ยวข้อง" และดําเนินการให้เสร็จสมบูรณ์หรือยกเลิกกิจกรรมที่ระบุไว้ก่อนที่จะยกเลิกกิจกรรมนี้`,
	ur: `جب تک اس کی چائلڈ سرگرمیاں اوپن اسٹیٹس میں ہوں، کوئی سرگرمی منسوخ نہیں کی جا سکتی۔ "متعلقہ سرگرمیاں" ٹیب پر جائیں اور اس سرگرمی کو منسوخ کرنے سے پہلے وہاں درج سرگرمیاں مکمل یا منسوخ کر دیں۔`,
	vi: `Không thể hủy một hoạt động trong khi các hoạt động con của nó vẫn ở trạng thái mở. Điều hướng đến tab "Hoạt động liên kết" và hoàn thành hoặc hủy các hoạt động được liệt kê ở đó trước khi hủy hoạt động này.`,
	'zh-hans': `活动在其子活动仍处于开放状态时，不能被取消。进入“相关活动”标签页，完成或取消其中列出的活动后再取消该活动。`,
	'zh-hant': `活動在其子活動仍處於開放狀態時，不能被取消。請前往「相關活動」標籤，完成或取消該活動前完成或取消該活動。`,
	en: `An activity cannot be cancelled while its child activities are still in an open status. Navigate to the "Associated activities" tab and complete or cancel the activities listed there prior to cancelling this activity.`
};

export const loc_validateActivityChildrenCompleted: Record<Locale, string> = {
	ar: `لا يمكن إكمال النشاط طالما أن أنشطة الفرع لا تزال في حالة مفتوحة. انتقل إلى تبويب "الأنشطة المرتبطة" وأكمل أو ألغ الأنشطة المدرجة هناك قبل إكمال هذا النشاط.`,
	de: `Eine Aktivität kann nicht abgeschlossen werden, solange ihre Kinderaktivitäten noch offen sind. Navigieren Sie zum Reiter "Assoziierte Aktivitäten" und schließen Sie die dort aufgeführten Aktivitäten vor Abschluss dieser Aktivität ab oder kündigen Sie sie ab.`,
	es: `Una actividad no puede completarse mientras sus actividades menores sigan en estado abierto. Accede a la pestaña "Actividades asociadas" y completa o cancela las actividades que aparecen allí antes de completar esta actividad.`,
	fa: `یک فعالیت زمانی که فعالیت های فرزند آن هنوز در وضعیت باز هستند، قابل انجام نیست. به تب «فعالیت های مرتبط» بروید و فعالیت های فهرست شده در آنجا را قبل از تکمیل این فعالیت تکمیل یا لغو کنید.`,
	fil: `Ang isang aktibidad ay hindi maaaring makumpleto habang ang mga aktibidad ng bata ay nasa bukas na katayuan pa rin. Mag-navigate sa tab na "Mga Kaugnay na Aktibidad" at kumpletuhin o kanselahin ang mga aktibidad na nakalista doon bago makumpleto ang aktibidad na ito.`,
	fr: `Une activité ne peut pas être achevée tant que ses activités enfants sont encore en statut ouvert. Naviguez dans l’onglet « Activités associées » et complétez ou annulez les activités listées avant de terminer cette activité.`,
	hi: `कोई गतिविधि तब पूरी नहीं की जा सकती जब उसकी चाइल्ड गतिविधियाँ अभी भी खुली स्थिति में हों. "संबद्ध गतिविधियाँ" टैब पर जाएँ और इस गतिविधि को पूरा करने से पहले वहां सूचीबद्ध गतिविधियों को पूरा या रद्द करें।`,
	ht: `Yon aktivite pa ka konplete pandan aktivite pitit li yo toujou nan yon estati ouvè. Navige nan tab "Aktivite ki asosye yo" epi ranpli oswa anile aktivite ki nan lis la anvan ou fini aktivite sa a.`,
	it: `Un'attività non può essere completata finché le attività figlie sono ancora in stato aperto. Accedi alla scheda "Attività associate" e completa o annulla le attività elencate prima di completare questa attività.`,
	ja: `子活動がまだオープンな状態では、活動を完了することはできません。「関連アクティビティ」タブに移動し、そこに記載されたアクティビティをクリアまたはキャンセルしてからこのアクティビティを完了してください。`,
	ko: `활동이 자녀 활동이 아직 열려 있는 상태일 때는 완료할 수 없습니다. "관련 활동" 탭으로 이동하여 이 활동을 완료하기 전에 해당 활동을 완료하거나 취소하세요.`,
	mww: `Ib qho kev ua si tsis tuaj yeem ua tiav thaum nws cov kev ua ub no rau menyuam tseem qhib kev ua si. Mus rau "Cov kev ua ub no txuam" tab thiab ua kom tiav lossis tshem tawm cov kev ua ub no uas tau teev tseg ua ntej ua tiav qhov kev ua no.`,
	ps: `یو فعالیت نشی بشپړیدلی تر څو چې د ماشوم فعالیتونه یې لا هم خلاص حالت کې وی. د "اړوندو فعالیتونو" ټب ته لاړ شئ او هلته لیست شوی فعالیتونه بشپړ یا لغوه کړئ مخکې له دې چې دا فعالیت بشپړ کړئ.`,
	pt: `Uma atividade não pode ser concluída enquanto suas atividades filhas ainda estiverem em status aberto. Navegue até a aba "Atividades Associadas" e complete ou cancele as atividades listadas lá antes de concluir essa atividade.`,
	'pt-pt': `Uma atividade não pode ser concluída enquanto as suas atividades filhas ainda estiverem em estado aberto. Navegue até ao separador "Atividades Associadas" e complete ou cancele as atividades aí listadas antes de concluir esta atividade.`,
	ru: `Задание нельзя завершить, пока дочерние занятия находятся в открытом статусе. Перейдите на вкладку «Связанные активности» и завершите или отмените указанные там мероприятия до завершения этой активности.`,
	sm: `E le mafai ona faamaeaina se gaoioiga a o tatala pea ana gaoioiga a tamaiti. Alu i le faailoga o "Gaoioiga e faatatau i ai" ma faamaea pe faaleaogaina ia gaoioiga o loo lisiina iina a o lei faamaeaina lenei gaoioiga.`,
	so: `Hawl lama dhameystiri karo inta hawlaha carruurta ay weli furan yihiin. U gudub tabka "Hawlaha La Xiriira" oo dhameystir ama jooji hawlaha ku taxan ka hor intaadan dhammaystirin hawshan.`,
	th: `กิจกรรมไม่สามารถทําให้เสร็จสมบูรณ์ได้ในขณะที่กิจกรรมย่อยยังคงอยู่ในสถานะเปิด ไปที่แท็บ "กิจกรรมที่เกี่ยวข้อง" และทําหรือยกเลิกกิจกรรมที่ระบุไว้ก่อนที่จะทํากิจกรรมนี้ให้เสร็จสมบูรณ์`,
	ur: `کوئی سرگرمی اس وقت تک مکمل نہیں کی جا سکتی جب تک اس کی چائلڈ سرگرمیاں ابھی اوپن اسٹیٹس میں ہوں۔ "متعلقہ سرگرمیاں" ٹیب پر جائیں اور اس سرگرمی کو مکمل کرنے سے پہلے وہاں درج سرگرمیاں مکمل یا منسوخ کر دیں۔`,
	vi: `Không thể hoàn thành một hoạt động trong khi các hoạt động con của nó vẫn ở trạng thái mở. Điều hướng đến tab "Hoạt động liên quan" và hoàn thành hoặc hủy các hoạt động được liệt kê ở đó trước khi hoàn thành hoạt động này.`,
	'zh-hans': `活动在其子活动仍处于开放状态时无法完成。在完成此活动之前，请进入“关联活动”标签页，完成或取消其中列出的活动。`,
	'zh-hant': `活動在其子活動仍處於開放狀態時無法完成。請前往「相關活動」標籤，在完成此活動前完成或取消該頁面列出的活動。`,
	en: `An activity cannot be completed while its child activities are still in an open status. Navigate to the "Associated activities" tab and complete or cancel the activities listed there prior to completing this activity.`
};

export const loc_validationErrors: Record<Locale, string> = {
	ar: `أخطاء التحقق`,
	de: `Validierungsfehler`,
	es: `Errores de validación`,
	fa: `خطاهای اعتبارسنجی`,
	fil: `Mga error sa pagpapatunay`,
	fr: `Erreurs de validation`,
	hi: `सत्यापन त्रुटियाँ`,
	ht: `Erè validation`,
	it: `Errori di validazione`,
	ja: `検証エラー`,
	ko: `검증 오류`,
	mww: `Kev lees paub yuam kev`,
	ps: `د اعتبار تېروتنې`,
	pt: `Erros de validação`,
	'pt-pt': `Erros de validação`,
	ru: `Ошибки валидации`,
	sm: `Mea sese o le faamaoniga`,
	so: `Khaladaadka xaqiijinta`,
	th: `ข้อผิดพลาดในการตรวจสอบความถูกต้อง`,
	ur: `تصدیقی غلطیاں`,
	vi: `Lỗi xác thực`,
	'zh-hans': `验证错误`,
	'zh-hant': `驗證錯誤`,
	en: `Validation errors`
};

export const loc_vendor: Record<Locale, string> = {
	ar: `البائع`,
	de: `Anbieter`,
	es: `Proveedor`,
	fa: `فروشنده`,
	fil: `Nagbebenta`,
	fr: `Fournisseur`,
	hi: `विक्रेता`,
	ht: `Vandè`,
	it: `Fornitore`,
	ja: `ベンダー`,
	ko: `판매자`,
	mww: `Tus neeg muag khoom`,
	ps: `پلورونکی`,
	pt: `Fornecedor`,
	'pt-pt': `Fornecedor`,
	ru: `Продавец`,
	sm: `Tagata fa'atau`,
	so: `Iibiyaha`,
	th: `ผู้ขาย`,
	ur: `وینڈر`,
	vi: `Nhà cung cấp`,
	'zh-hans': `供应商`,
	'zh-hant': `供應商`,
	en: `Vendor`
};

export const loc_verifiedAddress: Record<Locale, string> = {
	ar: `عنوان موثق`,
	de: `Verifizierte Adresse`,
	es: `Dirección verificada`,
	fa: `آدرس تأییدشده`,
	fil: `Email Address`,
	fr: `Adresse vérifiée`,
	hi: `सत्यापित पता`,
	ht: `Adrès verifye`,
	it: `Indirizzo verificato`,
	ja: `認証済み住所`,
	ko: `확인된 주소`,
	mww: `Qhov chaw nyob uas tau txheeb xyuas`,
	ps: `تایید شوی پته`,
	pt: `Endereço verificado`,
	'pt-pt': `Endereço verificado`,
	ru: `Подтверждённый адрес`,
	sm: `Tuatusi faamaonia`,
	so: `Cinwaanka la xaqiijiyay`,
	th: `ที่อยู่ที่ยืนยันแล้ว`,
	ur: `تصدیق شدہ پتہ`,
	vi: `Địa chỉ đã xác minh`,
	'zh-hans': `已验证地址`,
	'zh-hant': `已驗證地址`,
	en: `Verified address`
};

export const loc_veteran: Record<Locale, string> = {
	ar: `المحارب القديم`,
	de: `Veteran`,
	es: `Veterano`,
	fa: `کهنه کار`,
	fil: `Beterano`,
	fr: `Vétéran`,
	hi: `पुराना आदमी`,
	ht: `Veteran`,
	it: `Veterano`,
	ja: `退役軍人`,
	ko: `베테랑`,
	mww: `Qub tub rog`,
	ps: `تجربه لرونکی`,
	pt: `Veterano`,
	'pt-pt': `Veterano`,
	ru: `Ветеран`,
	sm: `Veteran`,
	so: `Veteran`,
	th: `ทหารผ่านศึก`,
	ur: `سابق فوجی`,
	vi: `Cựu chiến binh`,
	'zh-hans': `老将`,
	'zh-hant': `老將`,
	en: `Veteran`
};

export const loc_veteranID: Record<Locale, string> = {
	ar: `هوية المحارب القديم`,
	de: `Veteranen-ID`,
	es: `Identificación de veterano`,
	fa: `شناسه کهنه سرباز`,
	fil: `ID ng Beterano`,
	fr: `Carte d’identité vétéran`,
	hi: `वयोवृद्ध आईडी`,
	ht: `Veteran ID`,
	it: `Tessera Veterano`,
	ja: `退役軍人ID`,
	ko: `재향군인 신분증`,
	mww: `Qub tub rog ID`,
	ps: `د پخوانی سرتېری پېژندنه`,
	pt: `Identificação de Veterano`,
	'pt-pt': `Identificação de Veterano`,
	ru: `Удостоверение ветерана`,
	sm: `Veteran ID`,
	so: `Aqoonsiga Veteran`,
	th: `บัตรประจําตัวทหารผ่านศึก`,
	ur: `سابق فوجی شناختی کارڈ`,
	vi: `ID cựu chiến binh`,
	'zh-hans': `退伍军人身份证`,
	'zh-hant': `退伍軍人識別證`,
	en: `Veteran ID`
};

export const loc_video: Record<Locale, string> = {
	ar: `الفيديو`,
	de: `Video`,
	es: `Vídeo`,
	fa: `ویدئو`,
	fil: `Video`,
	fr: `Vidéo`,
	hi: `वीडियो`,
	ht: `Videyo`,
	it: `Video`,
	ja: `ビデオ`,
	ko: `비디오`,
	mww: `Yees duab`,
	ps: `ویډیو`,
	pt: `Vídeo`,
	'pt-pt': `Vídeo`,
	ru: `Видео`,
	sm: `Vitio`,
	so: `Fiidiyow`,
	th: `วิดีโอ`,
	ur: `ویڈیو`,
	vi: `Băng hình`,
	'zh-hans': `视频`,
	'zh-hant': `影片`,
	en: `Video`
};

export const loc_view: Record<Locale, string> = {
	ar: `منظر`,
	de: `Ansicht`,
	es: `Vista`,
	fa: `نمای`,
	fil: `Tingnan`,
	fr: `Vue`,
	hi: `द्वारा`,
	ht: `Gade`,
	it: `Vista`,
	ja: `眺め`,
	ko: `전망`,
	mww: `Saib`,
	ps: `لید`,
	pt: `Visão`,
	'pt-pt': `Ver`,
	ru: `Вид`,
	sm: `Va'ai`,
	so: `Muuqaal`,
	th: `ดู`,
	ur: `منظر`,
	vi: `Xem`,
	'zh-hans': `景观`,
	'zh-hant': `景觀`,
	en: `View`
};

export const loc_viewAll: Record<Locale, string> = {
	ar: `عرض الجميع`,
	de: `Alle anzeigen`,
	es: `Ver todo`,
	fa: `همه را مشاهده کنید`,
	fil: `Tingnan ang lahat`,
	fr: `Voir tout`,
	hi: `सभी देखें`,
	ht: `Wè tout`,
	it: `Visualizza tutto`,
	ja: `全てを見る`,
	ko: `모두 보기`,
	mww: `Saib tag nrho`,
	ps: `ټول وګورئ`,
	pt: `Ver tudo`,
	'pt-pt': `Ver tudo`,
	ru: `Посмотреть всё`,
	sm: `Va'ai uma`,
	so: `Daawo dhammaan`,
	th: `ดูทั้งหมด`,
	ur: `سب دیکھیں`,
	vi: `Xem tất cả`,
	'zh-hans': `查看全部`,
	'zh-hant': `全部查看`,
	en: `View all`
};

export const loc_viewCountFormat: Record<Locale, (count: unknown) => string> = {
	ar: (count) => `${count} مشاهدة الشهر الماضي`,
	de: (count) => `${count} Aufrufe im letzten Monat`,
	es: (count) => `${count} visualizaciones el mes pasado`,
	fa: (count) => `${count} بازدید در ماه گذشته`,
	fil: (count) => `${count} views nakaraang buwan`,
	fr: (count) => `${count} vues le mois dernier`,
	hi: (count) => `पिछले महीने ${count} बार देखा गया`,
	ht: (count) => `${count} opinyon mwa pase`,
	it: (count) => `${count} visualizzazioni lo scorso mese`,
	ja: (count) => `過去${count}回の閲覧`,
	ko: (count) => `지난 한 달 ${count}회 조회수`,
	mww: (count) => `${count} views lub hli dhau los`,
	ps: (count) => `تېر میاشت ${count} لیدنې`,
	pt: (count) => `${count} visualizações no mês passado`,
	'pt-pt': (count) => `${count} visualizações no mês passado`,
	ru: (count) => `${count} просмотров за последний месяц`,
	sm: (count) => `${count} manatu i le masina talu ai`,
	so: (count) => `${count} daawasho bishii la soo dhaafay`,
	th: (count) => `${count} ครั้งในเดือนที่ผ่านมา`,
	ur: (count) => `گزشتہ ماہ ${count} ویوز`,
	vi: (count) => `${count} lượt xem tháng trước`,
	'zh-hans': (count) => `过去${count} 次浏览`,
	'zh-hant': (count) => `過去${count}次瀏覽`,
	en: (count) => `${count} views past month`
};

export const loc_viewDetailsAndRegister: Record<Locale, string> = {
	ar: `عرض التفاصيل والتسجيل`,
	de: `Details anzeigen und registrieren`,
	es: `Ver detalles y registrarse`,
	fa: `مشاهده جزئیات و ثبت نام`,
	fil: `Tingnan ang mga detalye at magparehistro`,
	fr: `Voir les détails et inscrire-toi`,
	hi: `विवरण देखें और पंजीकरण करें`,
	ht: `Gade detay & enskri`,
	it: `Visualizza dettagli e iscriviti`,
	ja: `詳細を見る・登録`,
	ko: `상세 정보 보기 및 등록`,
	mww: `Saib cov ntsiab lus & sau npe`,
	ps: `تفصیلات وګورئ او ثبت کړئ`,
	pt: `Veja detalhes e cadastro`,
	'pt-pt': `Ver detalhes e registar-se`,
	ru: `Посмотреть подробности и зарегистрироваться`,
	sm: `Va'ai auiliiliga & lesitala`,
	so: `Eeg faahfaahinta & diiwaangelinta`,
	th: `ดูรายละเอียด & ลงทะเบียน`,
	ur: `تفصیلات دیکھیں اور رجسٹریشن کریں`,
	vi: `Xem chi tiết & đăng ký`,
	'zh-hans': `查看详情及注册`,
	'zh-hant': `查看詳情與註冊`,
	en: `View details & register`
};

export const loc_viewDetailsAndRegisterForEventFormat: Record<Locale, (event: unknown) => string> = {
	ar: (event) => `عرض التفاصيل والتسجيل في ${event}`,
	de: (event) => `Details ansehen und sich für ${event} registrieren`,
	es: (event) => `Consulta los detalles y regístrate para ${event}`,
	fa: (event) => `مشاهده جزئیات و ثبت نام ${event}`,
	fil: (event) => `Tingnan ang mga detalye at magparehistro para sa ${event}`,
	fr: (event) => `Voir les détails et ${event}`,
	hi: (event) => `विवरण देखें और ${event} के लिए पंजीकरण करें`,
	ht: (event) => `Gade detay epi enskri pou ${event}`,
	it: (event) => `Visualizza i dettagli e registrati per ${event}`,
	ja: (event) => `太${event}の詳細と登録はこちら`,
	ko: (event) => `${event}권 세부 정보 보기 및 등록`,
	mww: (event) => `Saib cov ntsiab lus thiab sau npe rau ${event}`,
	ps: (event) => `تفصیلات وګورئ او د ${event} لپاره نوم لیکنه وکړئ`,
	pt: (event) => `Veja detalhes e inscreva-se no ${event}`,
	'pt-pt': (event) => `Veja detalhes e ${event}`,
	ru: (event) => `Посмотреть подробности и зарегистрироваться на ${event}`,
	sm: (event) => `Va'ai auiliiliga ma lesitala mo ${event}`,
	so: (event) => `Faahfaahinta eeg oo iska diiwaangeli ${event}`,
	th: (event) => `ดูรายละเอียดและลงทะเบียนเรียน ${event}`,
	ur: (event) => `تفصیلات دیکھیں اور ${event} کے لیے رجسٹر کریں`,
	vi: (event) => `Xem chi tiết và đăng ký ${event}`,
	'zh-hans': (event) => `查看详情并注册太 ${event}`,
	'zh-hant': (event) => `查看詳情並報名太 ${event}`,
	en: (event) => `View details and register for ${event}`
};

export const loc_viewDocument: Record<Locale, string> = {
	ar: `عرض الوثيقة`,
	de: `Dokument anzeigen`,
	es: `Ver documento`,
	fa: `مشاهده سند`,
	fil: `Tingnan ang dokumento`,
	fr: `Voir le document`,
	hi: `दस्तावेज़ देखें`,
	ht: `Gade dokiman`,
	it: `Visualizza il documento`,
	ja: `ドキュメントを見る`,
	ko: `문서 보기`,
	mww: `Saib daim ntawv`,
	ps: `سند وګوره`,
	pt: `Ver documento`,
	'pt-pt': `Ver documento`,
	ru: `Просмотр документа`,
	sm: `Tagai i le pepa aloaia`,
	so: `Eeg dukumentiga`,
	th: `ดูเอกสาร`,
	ur: `دستاویز دیکھیں`,
	vi: `Xem tài liệu`,
	'zh-hans': `查看文档`,
	'zh-hant': `檢視文件`,
	en: `View document`
};

export const loc_viewedDateFormat: Record<Locale, (date: unknown) => TemplateResult> = {
	ar: (date) => html`تمت المشاهدة <span>${date}</span>`,
	de: (date) => html`Vor <span>${date} angesehen</span>`,
	es: (date) => html`Visto <span>${date}</span>`,
	fa: (date) => html`مشاهده <span>${date}</span>`,
	fil: (date) => html`Tiningnan <span>${date}</span>`,
	fr: (date) => html`Vu <span>${date}</span>`,
	hi: (date) => html`<span>${date} देखा गया</span>`,
	ht: (date) => html`Wè <span>${date}</span>`,
	it: (date) => html`Visualizzato <span>${date}</span>`,
	ja: (date) => html`<span>${date}に閲覧</span>`,
	ko: (date) => html`<span>${date} 확인함</span>`,
	mww: (date) => html`Saib <span>${date}</span>`,
	ps: (date) => html`<span>${date} لیدل شوی</span>`,
	pt: (date) => html`Visualizado <span>${date}</span>`,
	'pt-pt': (date) => html`Visualizado <span>${date}</span>`,
	ru: (date) => html`Просмотрено <span>${date}</span>`,
	sm: (date) => html`Maimoaina <span>${date}</span>`,
	so: (date) => html`Waxaa la arkay <span>${date}</span>`,
	th: (date) => html`ดูเมื่อ <span>${date}</span>`,
	ur: (date) => html`<span>${date} دیکھا گیا</span>`,
	vi: (date) => html`Đã xem <span>${date}</span>`,
	'zh-hans': (date) => html`3<span>${date}查看</span>`,
	'zh-hant': (date) => html`三<span>${date}瀏覽</span>`,
	en: (date) => html`Viewed <span>${date}</span>`
};

export const loc_viewParticipantPortal: Record<Locale, string> = {
	ar: `عرض بوابة المشاركين`,
	de: `Teilnehmerportal anzeigen`,
	es: `Ver portal de participantes`,
	fa: `مشاهده پورتال شرکت کنندگان`,
	fil: `Tingnan ang portal ng kalahok`,
	fr: `Voir le portail des participants`,
	hi: `प्रतिभागी पोर्टल देखें`,
	ht: `Gade pòtal patisipan yo`,
	it: `Visualizza il portale partecipante`,
	ja: `参加者ポータルを見る`,
	ko: `참가자 포털 보기`,
	mww: `Saib portal rau cov neeg koom`,
	ps: `د ګډونوالو پورټل وګورئ`,
	pt: `Ver portal do participante`,
	'pt-pt': `Ver portal do participante`,
	ru: `Просмотр портала участников`,
	sm: `Maimoa i le faitotoa o tagata auai`,
	so: `Eeg bogga ka qaybgalayaasha`,
	th: `ดูพอร์ทัลผู้เข้าร่วม`,
	ur: `شرکاء کا پورٹل دیکھیں`,
	vi: `Xem cổng thông tin người tham gia`,
	'zh-hans': `查看参与者门户`,
	'zh-hant': `查看參與者入口網站`,
	en: `View participant portal`
};

export const loc_viewProfile: Record<Locale, string> = {
	ar: `عرض الملف الشخصي`,
	de: `Profil anzeigen`,
	es: `Ver perfil`,
	fa: `مشاهده پروفایل`,
	fil: `Tingnan ang profile`,
	fr: `Voir le profil`,
	hi: `प्रोफ़ाइल देखें`,
	ht: `Gade pwofil`,
	it: `Visualizza profilo`,
	ja: `プロフィールを見る`,
	ko: `프로필 보기`,
	mww: `Saib profile`,
	ps: `پروفایل وګورئ`,
	pt: `Ver perfil`,
	'pt-pt': `Ver perfil`,
	ru: `Посмотреть профиль`,
	sm: `Va'ai talaaga otooto`,
	so: `Muuqaalka profile`,
	th: `ดูโปรไฟล์`,
	ur: `پروفائل دیکھیں`,
	vi: `Xem hồ sơ`,
	'zh-hans': `查看个人资料`,
	'zh-hant': `查看個人資料`,
	en: `View profile`
};

export const loc_viewProfileAndMore: Record<Locale, string> = {
	ar: `عرض الملف الشخصي والمزيد`,
	de: `Profil ansehen und mehr`,
	es: `Ver perfil y más`,
	fa: `مشاهده پروفایل و موارد بیشتر`,
	fil: `Tingnan ang profile at higit pa`,
	fr: `Voir le profil et plus encore`,
	hi: `प्रोफ़ाइल और बहुत कुछ देखें`,
	ht: `Gade pwofil ak plis ankò`,
	it: `Visualizza profilo e altro ancora`,
	ja: `プロフィールの閲覧など`,
	ko: `프로필 보기 및 기타`,
	mww: `Saib profile thiab ntau ntxiv`,
	ps: `پروفایل او نور وګورئ`,
	pt: `Veja o perfil e muito mais`,
	'pt-pt': `Ver perfil e muito mais`,
	ru: `Просмотр профиля и многое другое`,
	sm: `Va'ai talaaga otooto ma sili atu`,
	so: `Daawo astaamaha iyo waxyaabo kale`,
	th: `ดูโปรไฟล์และอื่นๆ`,
	ur: `پروفائل دیکھیں اور مزید`,
	vi: `Xem hồ sơ và hơn thế nữa`,
	'zh-hans': `查看个人资料及更多内容`,
	'zh-hant': `查看個人檔案及更多資訊`,
	en: `View profile and more`
};

export const loc_viewSelectedTemplate: Record<Locale, string> = {
	ar: `عرض القالب المختار`,
	de: `Ausgewählte Vorlage anzeigen`,
	es: `Ver plantilla seleccionada`,
	fa: `مشاهده قالب منتخب`,
	fil: `Tingnan ang napiling template`,
	fr: `Voir le modèle sélectionné`,
	hi: `चयनित टेम्पलेट देखें`,
	ht: `Gade modèl chwazi`,
	it: `Visualizza modello selezionato`,
	ja: `選択したテンプレートを見る`,
	ko: `선택된 템플릿 보기`,
	mww: `Saib xaiv template`,
	ps: `ټاکل شوی قالب وګوره`,
	pt: `Ver modelo selecionado`,
	'pt-pt': `Ver modelo selecionado`,
	ru: `Просмотр выбранного шаблона`,
	sm: `Tagai i le mamanu ua filifilia`,
	so: `Eeg template-ka la doortay`,
	th: `ดูเทมเพลตที่เลือก`,
	ur: `منتخب ٹیمپلیٹ دیکھیں`,
	vi: `Xem mẫu đã chọn`,
	'zh-hans': `查看所选模板`,
	'zh-hant': `查看所選範本`,
	en: `View selected template`
};

export const loc_viewsPastMonthFormat: Record<Locale, (views: unknown) => string> = {
	ar: (views) => `${views} مشاهدة في الشهر الماضي`,
	de: (views) => `${views} Aufrufe im vergangenen Monat`,
	es: (views) => `${views} visualizaciones en el último mes`,
	fa: (views) => `${views} بازدید در ماه گذشته`,
	fil: (views) => `${views} views sa nakaraang buwan`,
	fr: (views) => `${views} vues le mois dernier`,
	hi: (views) => `पिछले महीने में ${views} बार देखा गया`,
	ht: (views) => `${views} opinyon nan mwa ki sot pase yo`,
	it: (views) => `${views} visualizzazioni nell'ultimo mese`,
	ja: (views) => `過去1か月で${views}回の閲覧`,
	ko: (views) => `지난 한 달간 ${views}회 조회수`,
	mww: (views) => `${views} views nyob rau hauv lub hli dhau los`,
	ps: (views) => `په تېرو میاشتو ${views} لیدنې`,
	pt: (views) => `${views} visualizações no último mês`,
	'pt-pt': (views) => `${views} visualizações no último mês`,
	ru: (views) => `${views} просмотров за последний месяц`,
	sm: (views) => `${views} manatu i le masina talu ai`,
	so: (views) => `${views} daawasho bishii la soo dhaafay`,
	th: (views) => `${views} ครั้งในเดือนที่ผ่านมา`,
	ur: (views) => `گزشتہ مہینے ${views} ویوز`,
	vi: (views) => `${views} lượt xem trong tháng qua`,
	'zh-hans': (views) => `过去一个月 ${views} 次浏览`,
	'zh-hant': (views) => `過去一個月有${views}次觀看`,
	en: (views) => `${views} views in past month`
};

export const loc_viewTimesheet: Record<Locale, string> = {
	ar: `عرض جدول الزمن`,
	de: `Stundenzettel anzeigen`,
	es: `Ver hoja de horas`,
	fa: `مشاهده برگه زمان`,
	fil: `Tingnan ang timesheet`,
	fr: `Voir la feuille de temps`,
	hi: `टाइमशीट देखें`,
	ht: `View Timesheet`,
	it: `Visualizza il foglio orario`,
	ja: `タイムシートを見る`,
	ko: `타임시트 보기`,
	mww: `Saib daim ntawv qhia sijhawm`,
	ps: `د وخت پاڼه وګورئ`,
	pt: `Ver folha de ponto`,
	'pt-pt': `Ver folha de horas`,
	ru: `Просмотр табеля рабочего времени`,
	sm: `Tagai i le pepa o taimi`,
	so: `Eeg jadwalka waqtiga`,
	th: `ดูไทม์ชีท`,
	ur: `ٹائم شیٹ دیکھیں`,
	vi: `Xem bảng chấm công`,
	'zh-hans': `查看时间表`,
	'zh-hant': `查看時間表`,
	en: `View timesheet`
};

export const loc_void: Record<Locale, string> = {
	ar: `الفراغ`,
	de: `Leere`,
	es: `Vacío`,
	fa: `خلأ`,
	fil: `Walang bisa`,
	fr: `Void`,
	hi: `शून्य`,
	ht: `vid`,
	it: `Void`,
	ja: `虚無`,
	ko: `공허`,
	mww: `tsis muaj dab tsi`,
	ps: `تشه`,
	pt: `Void`,
	'pt-pt': `Vazio`,
	ru: `Пустота`,
	sm: `Gaogao`,
	so: `Void`,
	th: `โมฆะ`,
	ur: `خلا`,
	vi: `Hư không`,
	'zh-hans': `虚空`,
	'zh-hant': `虛無`,
	en: `Void`
};

export const loc_voidSignatureRequest: Record<Locale, string> = {
	ar: `طلب توقيع الفراغ`,
	de: `Nichtigkeitsanfrage`,
	es: `Solicitud de firma nula`,
	fa: `درخواست امضای باطل`,
	fil: `Kahilingan sa lagda na walang bisa`,
	fr: `Demande de signature nulle`,
	hi: `शून्य हस्ताक्षर अनुरोध`,
	ht: `Anile demann siyati`,
	it: `Richiesta di firma nulla`,
	ja: `無効署名要求`,
	ko: `무효 서명 요청`,
	mww: `Thov kos npe tsis muaj dab tsi`,
	ps: `د خالی لاسلیک غوښتنه`,
	pt: `Solicitação de assinatura nula`,
	'pt-pt': `Pedido de assinatura nula`,
	ru: `Запрос на аннулированную подпись`,
	sm: `Talosaga faaleaogaina o le saini`,
	so: `Codsiga saxiixa void`,
	th: `ยกเลิกคําขอลายเซ็น`,
	ur: `خالی دستخط کی درخواست`,
	vi: `Yêu cầu chữ ký vô hiệu`,
	'zh-hans': `无效签名请求`,
	'zh-hant': `無效簽名請求`,
	en: `Void signature request`
};

export const loc_voidSignatureRequestMessage: Record<Locale, string> = {
	ar: `هل أنت متأكد أنك تريد إلغاء طلب التوقيع هذا؟ لا يمكن التراجع عن هذا الفعل.`,
	de: `Bist du sicher, dass du diese Unterschriftsanfrage für ungültig machen willst? Diese Maßnahme kann nicht rückgängig gemacht werden.`,
	es: `¿Estás seguro de que quieres anular esta solicitud de firma? Esta acción no puede deshacerse.`,
	fa: `مطمئنی می خواهی این درخواست امضا را باطل کنی؟ این عمل قابل بازگشت نیست.`,
	fil: `Sigurado ka bang nais mong ipawalang-bisa ang kahilingan sa lagda na ito? Ang pagkilos na ito ay hindi maaaring ipagwalang-bahala.`,
	fr: `Êtes-vous sûr de vouloir annuler cette demande de signature ? Cette action ne peut être annulée.`,
	hi: `क्या आप वाकई इस हस्ताक्षर अनुरोध को रद्द करना चाहते हैं? इस क्रिया को पूर्ववत नहीं किया जा सकता.`,
	ht: `Èske ou sèten ou vle anile demann siyati sa a? Aksyon sa a pa ka defèt.`,
	it: `Sei sicuro di voler annullare questa richiesta di firma? Questa azione non può essere annullata.`,
	ja: `この署名依頼を取り消したいのか?この行動は取り消せない。`,
	ko: `이 서명 요청을 무효로 하고 싶은 게 확실한가요? 이 행동은 되돌릴 수 없습니다.`,
	mww: `Koj puas paub tseeb tias koj xav tshem tawm qhov kev thov kos npe no? Qhov kev ua no tsis tuaj yeem thim rov qab.`,
	ps: `ته ډاډه یې چې غواړې دا لاسلیک غوښتنه لغوه کړې؟ دا عمل بیرته نه شی بدلیدلی.`,
	pt: `Tem certeza de que quer anular esse pedido de assinatura? Essa ação não pode ser desfeita.`,
	'pt-pt': `Tem a certeza de que quer anular este pedido de assinatura? Esta ação não pode ser desfeita.`,
	ru: `Вы уверены, что хотите аннулировать этот запрос на подпись? Это действие нельзя отменить.`,
	sm: `E te mautinoa e te manao e faaleaogaina lenei talosaga mo le saini? O lenei faatinoga e le mafai ona toe faaleaogaina.`,
	so: `Ma hubtaa inaad rabto inaad baabi'iso codsigan saxiixa? Ficilkan lama joojin karo.`,
	th: `คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคําขอลายเซ็นนี้? การดําเนินการนี้ไม่สามารถยกเลิกได้`,
	ur: `کیا آپ واقعی اس دستخط کی درخواست منسوخ کرنا چاہتے ہیں؟ یہ عمل واپس نہیں لیا جا سکتا۔`,
	vi: `Bạn có chắc chắn muốn vô hiệu hóa yêu cầu chữ ký này không? Hành động này không thể hoàn tác.`,
	'zh-hans': `你确定要取消这次签名请求吗？这一行为无法撤销。`,
	'zh-hant': `你確定要取消這個簽名請求嗎？這種行為無法撤銷。`,
	en: `Are you sure you want to void this signature request? This action cannot be undone.`
};

export const loc_wasAssignedToActivity: Record<Locale, string> = {
	ar: `تم تكليف هذا النشاط.`,
	de: `Diese Tätigkeit wurde mir zugewiesen.`,
	es: `Se me asignó esta actividad.`,
	fa: `این فعالیت به من محول شد.`,
	fil: `Inatasan siya sa aktibidad na ito.`,
	fr: `Cette activité m’a été assignée.`,
	hi: `यह गतिविधि सौंपी गई थी।`,
	ht: `Yo te asiyen aktivite sa a.`,
	it: `Mi è stata assegnata questa attività.`,
	ja: `この活動を割り当てられました。`,
	ko: `이 활동이 배정되었습니다.`,
	mww: `Tau muab rau qhov kev ua no.`,
	ps: `ما ته دا فعالیت ټاکل شوی و.`,
	pt: `Foi designado para essa atividade.`,
	'pt-pt': `Fui atribuída a esta atividade.`,
	ru: `Мне поручили эту задачу.`,
	sm: `Sa tofia i ai lenei gaoioiga.`,
	so: `Waxaa loo xilsaaray hawshan.`,
	th: `ได้รับมอบหมายให้ทํากิจกรรมนี้`,
	ur: `مجھے یہ سرگرمی سونپی گئی تھی۔`,
	vi: `Được giao hoạt động này.`,
	'zh-hans': `被分配了这项活动。`,
	'zh-hant': `被分配了這項活動。`,
	en: `Was assigned this activity.`
};

export const loc_wasAssociatedViaAutomation: Record<Locale, string> = {
	ar: `كان مرتبطا بهذا النشاط عبر الأتمتة.`,
	de: `War mit dieser Aktivität durch Automatisierung verbunden.`,
	es: `Estaba asociado a esta actividad mediante automatización.`,
	fa: `با این فعالیت از طریق اتوماسیون مرتبط بود.`,
	fil: `Ito ay nauugnay sa aktibidad na ito sa pamamagitan ng automation.`,
	fr: `Était associé à cette activité via l’automatisation.`,
	hi: `स्वचालन के माध्यम से इस गतिविधि से जुड़ा था।`,
	ht: `Te asosye ak aktivite sa a atravè automatisation.`,
	it: `Era associata a questa attività tramite automazione.`,
	ja: `自動化を通じてこの活動に関わりました。`,
	ko: `자동화를 통해 이 활동과 연관되어 있었습니다.`,
	mww: `Tau txuam nrog qhov kev ua no los ntawm automation.`,
	ps: `د دې فعالیت سره د اتومات له لارې تړاو درلود.`,
	pt: `Estava associada a essa atividade por meio de automação.`,
	'pt-pt': `Estava associada a esta atividade através da automação.`,
	ru: `Был связан с этой деятельностью через автоматизацию.`,
	sm: `Na feso'ota'i ma lenei gaioiga e ala i le otometi.`,
	so: `Waxay la xiriirtay hawshan iyada oo loo marayo otomaatiga.`,
	th: `เกี่ยวข้องกับกิจกรรมนี้ผ่านระบบอัตโนมัติ`,
	ur: `اس سرگرمی سے آٹومیشن کے ذریعے منسلک تھا۔`,
	vi: `Được liên kết với hoạt động này thông qua tự động hóa.`,
	'zh-hans': `我通过自动化参与了这项活动。`,
	'zh-hant': `我是透過自動化與這項活動產生關聯的。`,
	en: `Was associated with this activity via automation.`
};

export const loc_wasMentionedInActivity: Record<Locale, string> = {
	ar: `تم ذكره في هذا النشاط.`,
	de: `Wurde in dieser Aktivität erwähnt.`,
	es: `Se mencionó en esta actividad.`,
	fa: `در این فعالیت ذکر شده بود.`,
	fil: `Binanggit ito sa aktibidad na ito.`,
	fr: `A été mentionné dans cette activité.`,
	hi: `इस गतिविधि में उल्लेख किया गया था।`,
	ht: `Te mansyone nan aktivite sa a.`,
	it: `È stato menzionato in questa attività.`,
	ja: `この活動で言及されていました。`,
	ko: `이 활동에서 언급된 적이 있습니다.`,
	mww: `Tau hais nyob rau hauv qhov kev ua no.`,
	ps: `په دې فعالیت کې یاد شوی و.`,
	pt: `Foi mencionado nesta atividade.`,
	'pt-pt': `Foi mencionado nesta atividade.`,
	ru: `Был упомянут в этом задании.`,
	sm: `Sa ta'ua i lenei gaoioiga.`,
	so: `Waxaa lagu xusay hawshan.`,
	th: `ถูกกล่าวถึงในกิจกรรมนี้`,
	ur: `اس سرگرمی میں ذکر کیا گیا تھا۔`,
	vi: `Đã được đề cập trong hoạt động này.`,
	'zh-hans': `在这个活动中提到了。`,
	'zh-hant': `在這個活動中被提及。`,
	en: `Was mentioned in this activity.`
};

export const loc_wasSubscribedViaAutomation: Record<Locale, string> = {
	ar: `كنت مشتركا في هذا النشاط عبر الأتمتة.`,
	de: `Ich habe diese Aktivität über Automatisierung abonniert.`,
	es: `Estaba suscrito a esta actividad mediante automatización.`,
	fa: `در این فعالیت از طریق اتوماسیون مشترک شدم.`,
	fil: `Nag-subscribe sa aktibidad na ito sa pamamagitan ng automation.`,
	fr: `J’étais abonné à cette activité via l’automatisation.`,
	hi: `स्वचालन के माध्यम से इस गतिविधि की सदस्यता ली गई थी।`,
	ht: `Te abònman nan aktivite sa a atravè automatisation.`,
	it: `Ero iscritto a questa attività tramite automazione.`,
	ja: `この活動は自動化によって登録されました。`,
	ko: `자동화를 통해 이 활동에 가입했습니다.`,
	mww: `Tau sau npe rau qhov kev ua no los ntawm automation.`,
	ps: `ما د دې فعالیت لپاره د اتومات له لارې ګډون کړی و.`,
	pt: `Estava assinado nessa atividade via automação.`,
	'pt-pt': `Estava subscrito a esta atividade através de automação.`,
	ru: `Подписался на эту активность через автоматизацию.`,
	sm: `Sa lesitala i lenei gaoioiga e ala i le otometi.`,
	so: `Waxaan ku biiray hawshan iyada oo loo marayo otomaatiga.`,
	th: `สมัครเข้าร่วมกิจกรรมนี้ผ่านระบบอัตโนมัติ`,
	ur: `میں نے اس سرگرمی کو آٹومیشن کے ذریعے سبسکرائب کیا تھا۔`,
	vi: `Đã đăng ký hoạt động này thông qua tự động hóa.`,
	'zh-hans': `我通过自动化订阅了这项活动。`,
	'zh-hant': `我是透過自動化訂閱這個活動的。`,
	en: `Was subscribed to this activity via automation.`
};

export const loc_welcomeFormat: Record<Locale, (name: unknown) => string> = {
	ar: (name) => `مرحبا بك ${name}`,
	de: (name) => `Willkommen, ${name}`,
	es: (name) => `Bienvenido, ${name}`,
	fa: (name) => `خوش آمدی، ${name}`,
	fil: (name) => `Maligayang pagdating, ${name}`,
	fr: (name) => `Bienvenue, ${name}`,
	hi: (name) => `आपका स्वागत है, ${name}`,
	ht: (name) => `Byenveni ${name}`,
	it: (name) => `Benvenuto, ${name}`,
	ja: (name) => `ようこそ、 ${name}`,
	ko: (name) => `환영해, ${name}`,
	mww: (name) => `Zoo siab txais tos, ${name}`,
	ps: (name) => `ښه راغلاست، ${name}`,
	pt: (name) => `Bem-vindo, ${name}`,
	'pt-pt': (name) => `Bem-vindo, ${name}`,
	ru: (name) => `Добро пожаловать, ${name}`,
	sm: (name) => `Fa'afeiloa'i, ${name}`,
	so: (name) => `Soo dhawoow, ${name}`,
	th: (name) => `ยินดีต้อนรับ ${name}`,
	ur: (name) => `خوش آمدید، ${name}`,
	vi: (name) => `Chào mừng, ${name}`,
	'zh-hans': (name) => `欢迎你， ${name}`,
	'zh-hant': (name) => `歡迎你， ${name}`,
	en: (name) => `Welcome, ${name}`
};

export const loc_wetInk: Record<Locale, string> = {
	ar: `حبر رطب`,
	de: `Nass-Tinte`,
	es: `Tinta húmeda`,
	fa: `جوهر خیس`,
	fil: `Basang tinta`,
	fr: `Encre humide`,
	hi: `गीली स्याही`,
	ht: `Lank mouye`,
	it: `Inchiostro umido`,
	ja: `濡れたインク`,
	ko: `젖은 잉크`,
	mww: `number case ntub dej`,
	ps: `لوند رنګ`,
	pt: `Tinta úmida`,
	'pt-pt': `Tinta húmida`,
	ru: `Влажные чернила`,
	sm: `Vaitusi susu`,
	so: `Khad qoyan`,
	th: `หมึกเปียก`,
	ur: `گیلا سیاہی`,
	vi: `Mực ướt`,
	'zh-hans': `湿墨水`,
	'zh-hant': `濕墨水`,
	en: `Wet ink`
};

export const loc_weveUpdatedTerms: Record<Locale, (href: unknown) => TemplateResult> = {
	ar: (href) => html`قمنا بتحديث <a href="${href}">شروط الاستخدام</a> الخاصة بنا.`,
	de: (href) => html`Wir haben unsere <a href="${href}">Nutzungsbedingungen</a> aktualisiert.`,
	es: (href) => html`Hemos actualizado nuestros <a href="${href}">Términos de Uso</a>.`,
	fa: (href) => html`<a href="${href}">ما شرایط استفاده</a> خود را به روزرسانی کرده ایم.`,
	fil: (href) => html`Na-update namin ang aming <a href="${href}">Mga Tuntunin sa Paggamit</a>.`,
	fr: (href) => html`Nous avons mis à jour nos <a href="${href}">Conditions d’utilisation</a>.`,
	hi: (href) => html`हमने अपनी <a href="${href}">उपयोग की शर्तों</a> को अपडेट कर दिया है।`,
	ht: (href) => html`Nou te mete ajou <a href="${href}">Regleman pou Itilizasyon</a> nou an.`,
	it: (href) => html`Abbiamo aggiornato i <a href="${href}">nostri Termini di Utilizzo</a>.`,
	ja: (href) => html`<a href="${href}">利用規約</a>を更新しました。`,
	ko: (href) => html`이용 <a href="${href}">약관</a>을 업데이트했습니다.`,
	mww: (href) => html`Peb tau hloov kho peb <a href="${href}">Cov Lus Cog Tseg ntawm Kev Siv</a>.`,
	ps: (href) => html`موږ د <a href="${href}">کارونې شرایط</a> تازه کړی دی.`,
	pt: (href) => html`Atualizamos nossos <a href="${href}">Termos de Uso</a>.`,
	'pt-pt': (href) => html`Atualizámos os nossos <a href="${href}">Termos de Utilização</a>.`,
	ru: (href) => html`Мы обновили наши <a href="${href}">Условия использования</a>.`,
	sm: (href) => html`Ua matou fa'afouina a matou <a href="${href}">tuutuuga o fa'aaogaina</a>.`,
	so: (href) => html`Waxaan cusbooneysiinnay <a href="${href}">Shuruudaha Isticmaalka</a>.`,
	th: (href) => html`เราได้ปรับปรุง <a href="${href}">ข้อกําหนดการใช้งาน</a>ของเราแล้ว`,
	ur: (href) => html`ہم نے <a href="${href}">اپنی شرائط استعمال</a> کو اپ ڈیٹ کیا ہے۔`,
	vi: (href) => html`Chúng tôi đã cập nhật <a href="${href}">Điều khoản sử dụng</a> của mình.`,
	'zh-hans': (href) => html`我们已更新使用 <a href="${href}">条款</a>。`,
	'zh-hant': (href) => html`我們已更新使用 <a href="${href}">條款</a>。`,
	en: (href) => html`We've updated our <a href="${href}">Terms of Use</a>.`
};

export const loc_whatCanIHelpWith: Record<Locale, string> = {
	ar: `بماذا يمكنني المساعدة؟`,
	de: `Womit kann ich helfen?`,
	es: `¿En qué puedo ayudar?`,
	fa: `چطور می توانم کمک کنم؟`,
	fil: `Ano ang maaari kong makatulong?`,
	fr: `Que puis-je faire ?`,
	hi: `मैं क्या मदद कर सकता हूं?`,
	ht: `Ak kisa mwen ka ede?`,
	it: `In cosa posso aiutare?`,
	ja: `何かお手伝いできることはありますか?`,
	ko: `무엇을 도와드릴까요?`,
	mww: `Kuv tuaj yeem pab dab tsi?`,
	ps: `زه څه مرسته کولی شم؟`,
	pt: `Com o que posso ajudar?`,
	'pt-pt': `Em que posso ajudar?`,
	ru: `Чем могу помочь?`,
	sm: `O le a se mea e mafai ona ou fesoasoani i ai?`,
	so: `Maxaan kaa caawin karaa?`,
	th: `ฉันสามารถช่วยอะไรได้บ้าง?`,
	ur: `میں کس چیز میں مدد کر سکتا ہوں؟`,
	vi: `Tôi có thể giúp gì?`,
	'zh-hans': `我能帮上什么忙？`,
	'zh-hant': `我能幫忙什麼？`,
	en: `What can I help with?`
};

export const loc_when: Record<Locale, string> = {
	ar: `عندما`,
	de: `Wenn`,
	es: `Cuando`,
	fa: `زمانی که`,
	fil: `Kapag`,
	fr: `Quand`,
	hi: `कब`,
	ht: `Kile`,
	it: `Quando`,
	ja: `いつ`,
	ko: `언제`,
	mww: `Thauj tw`,
	ps: `کله چې`,
	pt: `Quando`,
	'pt-pt': `Quando`,
	ru: `Когда`,
	sm: `O afea`,
	so: `Goorma`,
	th: `เมื่อไหร่`,
	ur: `جب`,
	vi: `Khi nào`,
	'zh-hans': `当`,
	'zh-hant': `當`,
	en: `When`
};

export const loc_where: Record<Locale, string> = {
	ar: `حيث`,
	de: `Wobei`,
	es: `Donde`,
	fa: `که در آن`,
	fil: `Kung saan`,
	fr: `Où`,
	hi: `कहां है`,
	ht: `Kote`,
	it: `Dove`,
	ja: `ここで`,
	ko: `여기서`,
	mww: `Qhov twg`,
	ps: `چیرته`,
	pt: `Onde`,
	'pt-pt': `Onde`,
	ru: `Где`,
	sm: `O fea`,
	so: `Meesha`,
	th: `โดยที่`,
	ur: `جہاں`,
	vi: `Trong đó`,
	'zh-hans': `其中`,
	'zh-hant': `其中`,
	en: `Where`
};

export const loc_workflow: Record<Locale, string> = {
	ar: `سير العمل`,
	de: `Arbeitsablauf`,
	es: `Flujo de trabajo`,
	fa: `روند کاری`,
	fil: `Daloy ng Trabaho`,
	fr: `Flux de travail`,
	hi: `कार्यप्रवाह`,
	ht: `Workflow`,
	it: `Flusso di lavoro`,
	ja: `ワークフロー`,
	ko: `워크플로우`,
	mww: `Workflow`,
	ps: `کاری بهیر`,
	pt: `Fluxo de trabalho`,
	'pt-pt': `Fluxo de trabalho`,
	ru: `Рабочий процесс`,
	sm: `Fa'agaioiga`,
	so: `Habka Shaqada`,
	th: `เวิร์กโฟลว์`,
	ur: `ورک فلو`,
	vi: `Quy trình làm việc`,
	'zh-hans': `工作流程`,
	'zh-hant': `工作流程`,
	en: `Workflow`
};

export const loc_write: Record<Locale, string> = {
	ar: `اكتب`,
	de: `Schreib`,
	es: `Escribe`,
	fa: `بنویس`,
	fil: `Sumulat`,
	fr: `Écrire`,
	hi: `लिखना`,
	ht: `Ekri`,
	it: `Scrivi`,
	ja: `書く`,
	ko: `쓰기`,
	mww: `sau ntawv`,
	ps: `ولیکه`,
	pt: `Escreva`,
	'pt-pt': `Escrever`,
	ru: `Пиши`,
	sm: `Tusi`,
	so: `Qor`,
	th: `เขียน`,
	ur: `لکھو`,
	vi: `Viết`,
	'zh-hans': `写`,
	'zh-hant': `寫`,
	en: `Write`
};

export const loc_yearsAndMonthsFormat: Record<Locale, (years: unknown, months: unknown) => string> = {
	ar: (years, months) => `${years} ${months} أشهر`,
	de: (years, months) => `${years} Jahre und ${months} Monate`,
	es: (years, months) => `${years} años y ${months} meses`,
	fa: (years, months) => `${years} سال و ${months} ماه`,
	fil: (years, months) => `${years} taon at ${months} buwan`,
	fr: (years, months) => `${years} ans et ${months} mois`,
	hi: (years, months) => `${years} साल और ${months} महीने`,
	ht: (years, months) => `${years} ${months}`,
	it: (years, months) => `${years} anni e ${months} mesi`,
	ja: (years, months) => `${years}${months}`,
	ko: (years, months) => `${years} 년 ${months} 개월`,
	mww: (years, months) => `${years} xyoos ${months} lub hlis`,
	ps: (years, months) => `${years} کاله او ${months} میاشتې`,
	pt: (years, months) => `${years} anos e ${months} meses`,
	'pt-pt': (years, months) => `2 ${years} ${months} meses`,
	ru: (years, months) => `${years} года и ${months} месяца`,
	sm: (years, months) => `${years} tausaga ma ${months} masina`,
	so: (years, months) => `${years} sano iyo ${months} bilood`,
	th: (years, months) => `${years} ปี ${months} เดือน`,
	ur: (years, months) => `${years} سال اور ${months} ماہ`,
	vi: (years, months) => `${years} năm ${months} tháng`,
	'zh-hans': (years, months) => `${years}${months}`,
	'zh-hant': (years, months) => `${years}${months}`,
	en: (years, months) => `${years} years and ${months} months`
};

export const loc_yes: Record<Locale, string> = {
	ar: `نعم`,
	de: `Ja`,
	es: `Sí`,
	fa: `بله`,
	fil: `Oo`,
	fr: `Oui`,
	hi: `हाँ`,
	ht: `Wi`,
	it: `Sì`,
	ja: `はい`,
	ko: `네`,
	mww: `Yog lawm`,
	ps: `هو`,
	pt: `Sim`,
	'pt-pt': `Sim`,
	ru: `Да`,
	sm: `Ioe`,
	so: `Haa`,
	th: `ใช่`,
	ur: `جی ہاں`,
	vi: `Có`,
	'zh-hans': `是的`,
	'zh-hant': `是的`,
	en: `Yes`
};

export const loc_you: Record<Locale, string> = {
	ar: `أنت`,
	de: `Du`,
	es: `Tú`,
	fa: `تو`,
	fil: `Ikaw`,
	fr: `Toi`,
	hi: `आप`,
	ht: `Ou`,
	it: `Tu`,
	ja: `お前だ`,
	ko: `너`,
	mww: `Koj`,
	ps: `ته`,
	pt: `Você`,
	'pt-pt': `Tu`,
	ru: `Ты`,
	sm: `O oe`,
	so: `Adiga`,
	th: `คุณ`,
	ur: `تم`,
	vi: `Bạn`,
	'zh-hans': `你`,
	'zh-hant': `你`,
	en: `You`
};

export const loc_youAreSubscribed: Record<Locale, string> = {
	ar: `أنت مشترك`,
	de: `Sie sind abonniert`,
	es: `Estás suscrito`,
	fa: `شما مشترک هستید`,
	fil: `Ikaw ay naka-subscribe`,
	fr: `Vous êtes abonné`,
	hi: `आपने सदस्यता ली है`,
	ht: `Ou abònman`,
	it: `Sei iscritto`,
	ja: `あなたは購読しています`,
	ko: `구독하셨습니다`,
	mww: `Koj tau sau npe`,
	ps: `تاسو ګډون کړی یاست`,
	pt: `Você está inscrito`,
	'pt-pt': `Está subscrito`,
	ru: `Вы подписаны`,
	sm: `Ua e lesitala`,
	so: `Waad isdiiwaan gelisay`,
	th: `คุณสมัครสมาชิกแล้ว`,
	ur: `آپ سبسکرائب کر چکے ہیں`,
	vi: `Bạn đã đăng ký`,
	'zh-hans': `你已经订阅了`,
	'zh-hant': `你已經訂閱了`,
	en: `You are subscribed`
};

export const loc_youCanAskThingsFormat: Record<Locale, (chatPrompt1: unknown, chatPrompt2: unknown, chatPrompt3: unknown, cumulusAssistant: unknown) => TemplateResult> = {
	ar: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`يمكنك طرح أسئلة مثل "${chatPrompt1}"، "${chatPrompt2}"، "${chatPrompt3}"، و <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">المزيد</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> يعمل بالذكاء الاصطناعي، لذا هناك أخطاء محتملة. راجع المخرجات بعناية قبل الاستخدام.`,
	de: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Du kannst Dinge fragen wie "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" und <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Mehr</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> wird von KI angetrieben, daher sind Fehler möglich. Überprüfen Sie die Ergebnisse vor der Anwendung sorgfältig.`,
	es: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Puedes preguntar cosas como "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" y <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">más</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> funciona con IA, así que es posible que se cometan errores. Revisa cuidadosamente los resultados antes de usarlos.`,
	fa: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`می توانید سوالاتی مانند «${chatPrompt1}»، «${chatPrompt2}»، «${chatPrompt3}» و <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">بیشتر</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> با هوش مصنوعی کار می کند، بنابراین ممکن است اشتباه شود. قبل از استفاده، خروجی ها را با دقت بررسی کنید.`,
	fil: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Maaari kang magtanong ng mga bagay tulad ng "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", at <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">higit pa</button>.<br>Ang <a href="/docs/assistant">${cumulusAssistant}</a> ay pinapatakbo ng AI, kaya posible ang mga pagkakamali. Suriin nang mabuti ang output bago gamitin.`,
	fr: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Vous pouvez poser des questions comme « ${chatPrompt1} », « ${chatPrompt2} », « ${chatPrompt3} », et <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">plus</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> est alimenté par l’IA, donc des erreurs sont possibles. Examinez attentivement les résultats avant utilisation.`,
	hi: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`आप "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" जैसी चीजें पूछ सकते हैं, और <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">अधिक</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> एआई द्वारा संचालित है, इसलिए गलतियाँ संभव हैं। उपयोग करने से पहले आउटपुट की सावधानीपूर्वक समीक्षा करें।`,
	ht: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Ou ka mande bagay tankou "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", ak <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Plis</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> patrone pa AI, kidonk erè yo posib Revize pwodiksyon ak anpil atansyon anvan ou itilize.`,
	it: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Puoi chiedere cose come "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" e <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">di più</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> è alimentato dall'IA, quindi sono possibili errori. Rivedi attentamente i risultati prima di usarlo.`,
	ja: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`「${chatPrompt1}」「${chatPrompt2}」「${chatPrompt3}」などを尋ねることができます。 <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">もっと</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> はAIによって動いているため、ミスは起こり得ます。使用前に出力をよく確認してください。`,
	ko: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`"${chatPrompt1}", "${chatPrompt2}하기", "${chatPrompt3} 그리고 <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">더 보기</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> 는 AI로 구동되기 때문에 실수할 수 있습니다. 사용 전에 출력물을 꼼꼼히 검토하세요.`,
	mww: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Koj tuaj yeem nug tej yam xws li "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", thiab <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">ntau dua</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> yog powered los ntawm AI, yog li yuam kev ua tau. Xyuas cov zis ua tib zoo ua ntej siv.`,
	ps: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`تاسو کولی شئ داسې پوښتنې وکړئ لکه "${chatPrompt1}"، ${chatPrompt2}"، "${chatPrompt3} کړئ"، او <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">نور</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> د AI لخوا ځواکمن شوی، نو تېروتنې ممکن دی. د کارونې مخکې محصول په دقت سره وګوره.`,
	pt: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Você pode perguntar coisas como "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" e <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Mais</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> é movido por IA, então erros são possíveis. Revise cuidadosamente a produção antes de usar.`,
	'pt-pt': (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Pode perguntar coisas como "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" e <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">mais</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> é alimentado por IA, por isso erros são possíveis. Revise cuidadosamente os resultados antes de o usar.`,
	ru: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Вы можете спросить такие вещи, как «${chatPrompt1}», «${chatPrompt2}», «${chatPrompt3}» и <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Подробнее</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> работает на ИИ, поэтому возможны ошибки. Внимательно проверяйте выходные данные перед использованием.`,
	sm: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`E mafai ona e fesili atu i mea e pei o le "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", ma <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">sili atu</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> e fa'amalosia e AI, o lea e mafai ai ona faia ni mea sese. Iloilo ma le faaeteete le galuega faatino a o lei faaaogaina.`,
	so: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Waxaad weydiin kartaa waxyaabo sida "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", iyo <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">wax badan</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> waxaa ku shaqeeya AI, sidaas darteed khaladaad waa suurtagal. Si taxaddar leh u eeg natiijada ka hor intaadan isticmaalin.`,
	th: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`คุณสามารถถามสิ่งต่างๆ เช่น "สรุป${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" และ <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">เพิ่มเติม</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> ขับเคลื่อนโดย AI ดังนั้นจึงอาจเกิดข้อผิดพลาดได้ Review ผลลัพธ์อย่างรอบคอบก่อนใช้งาน`,
	ur: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`آپ ایسی باتیں پوچھ سکتے ہیں جیسے "${chatPrompt1}"، ${chatPrompt2} کریں"، "${chatPrompt3} کریں"، اور <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">مزید</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> AI سے چلتا ہے، اس لیے غلطیاں ہو سکتی ہیں۔ استعمال سے پہلے آؤٹ پٹ کو غور سے دیکھیں۔`,
	vi: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`Bạn có thể hỏi những thứ như "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" và <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Xem thêm</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> được hỗ trợ bởi AI, vì vậy có thể xảy ra sai sót. Review đầu ra cẩn thận trước khi sử dụng.`,
	'zh-hans': (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`你可以问诸如“${chatPrompt1}”、“${chatPrompt2}”、“${chatPrompt3}”等问题 <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">更多</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> 由 AI 驱动，因此出错是有可能的。使用前仔细检查输出。`,
	'zh-hant': (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`你可以問像是「${chatPrompt1}」、「${chatPrompt2}${chatPrompt3}」等問題<button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">更多</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> 是由 AI 驅動，因此出錯是有可能的。使用前請仔細檢查輸出。`,
	en: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant) => html`You can ask things like "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", and <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">more</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> is powered by AI, so mistakes are possible. Review output carefully before use.`
};

export const loc_youCompletedSurveyRecently: Record<Locale, string> = {
	ar: `لقد قدمت هذا النموذج مؤخرا.`,
	de: `Du hast dieses Formular kürzlich eingereicht.`,
	es: `Has enviado este formulario recientemente.`,
	fa: `شما این فرم را اخیرا ارسال کرده اید.`,
	fil: `Isinumite mo ang form na ito kamakailan.`,
	fr: `Vous avez soumis ce formulaire récemment.`,
	hi: `आपने यह फॉर्म हाल ही में सबमिट किया है।`,
	ht: `Ou te soumèt fòm sa a dènyèman.`,
	it: `Hai inviato questo modulo di recente.`,
	ja: `最近このフォームを提出されましたね。`,
	ko: `최근에 이 양식을 제출하셨습니다.`,
	mww: `Koj tau xa daim ntawv no tsis ntev los no.`,
	ps: `ته دا فورمه تازه وړاندې کړې ده.`,
	pt: `Você enviou este formulário recentemente.`,
	'pt-pt': `Submeteste este formulário recentemente.`,
	ru: `Вы недавно отправили эту форму.`,
	sm: `Na e auina mai lenei fomu talu ai nei.`,
	so: `Waxaad dhawaan soo gudbisay foomkan.`,
	th: `คุณเพิ่งส่งแบบฟอร์มนี้ไปเมื่อเร็วๆ นี้`,
	ur: `آپ نے یہ فارم حال ہی میں جمع کروایا ہے۔`,
	vi: `Bạn đã gửi biểu mẫu này gần đây.`,
	'zh-hans': `你最近提交了这份表格。`,
	'zh-hant': `你最近提交了這份表格。`,
	en: `You submitted this form recently.`
};

export const loc_youManageYourOwnCare: Record<Locale, string> = {
	ar: `أنت تدير رعايتك بنفسك.`,
	de: `Du kümmerst dich selbst um deine Pflege.`,
	es: `Tú gestionas tu propio cuidado.`,
	fa: `خودت مراقبتت را مدیریت می کنی.`,
	fil: `Ikaw ang namamahala sa iyong sariling pag-aalaga.`,
	fr: `Vous gérez vos propres soins.`,
	hi: `आप अपनी देखभाल का प्रबंधन स्वयं करते हैं।`,
	ht: `Ou jere pwòp swen ou.`,
	it: `Gestisci la tua cura.`,
	ja: `自分のケアは自分で管理してください。`,
	ko: `스스로 돌봄을 관리하세요.`,
	mww: `Koj tswj koj tus kheej kev saib xyuas.`,
	ps: `ته خپله پاملرنه کوې.`,
	pt: `Você gerencia seus próprios cuidados.`,
	'pt-pt': `Tu geres os teus próprios cuidados.`,
	ru: `Вы сами заботитесь о себе.`,
	sm: `E te pulea lau oe lava tausiga.`,
	so: `Adigu naftaada ayaad maamushaa.`,
	th: `คุณจัดการการดูแลของคุณเอง`,
	ur: `آپ اپنی دیکھ بھال خود سنبھالتے ہیں۔`,
	vi: `Bạn tự quản lý việc chăm sóc của mình.`,
	'zh-hans': `你自己管理照顾。`,
	'zh-hant': `你自己管理照顧。`,
	en: `You manage your own care.`
};

export const loc_yourLocation: Record<Locale, string> = {
	ar: `موقعك`,
	de: `Dein Standort`,
	es: `Tu ubicación`,
	fa: `موقعیت شما`,
	fil: `Email Address *`,
	fr: `Votre emplacement`,
	hi: `आपका स्थान`,
	ht: `Kote ou ye`,
	it: `La tua posizione`,
	ja: `あなたの位置`,
	ko: `당신의 위치`,
	mww: `Koj qhov chaw nyob`,
	ps: `ستاسو ځای`,
	pt: `Sua localização`,
	'pt-pt': `A sua localização`,
	ru: `Ваше местоположение`,
	sm: `Lou nofoaga`,
	so: `Goobtaada`,
	th: `ตําแหน่งของคุณ`,
	ur: `آپ کی جگہ`,
	vi: `Vị trí của bạn`,
	'zh-hans': `你的位置`,
	'zh-hant': `你的位置`,
	en: `Your location`
};

export const loc_yourOrganizations: Record<Locale, string> = {
	ar: `منظماتكم`,
	de: `Ihre Organisationen`,
	es: `Vuestras organizaciones`,
	fa: `سازمان های شما`,
	fil: `Ang iyong mga organisasyon`,
	fr: `Vos organisations`,
	hi: `आपके संगठन`,
	ht: `Òganizasyon ou yo`,
	it: `Le vostre organizzazioni`,
	ja: `あなたの組織`,
	ko: `여러분의 조직`,
	mww: `Koj cov koom haum`,
	ps: `ستاسو سازمانونه`,
	pt: `Suas organizações`,
	'pt-pt': `As vossas organizações`,
	ru: `Ваши организации`,
	sm: `Au fa'alapotopotoga`,
	so: `Ururadaada`,
	th: `องค์กรของคุณ`,
	ur: `آپ کی تنظیمیں`,
	vi: `Tổ chức của bạn`,
	'zh-hans': `你的组织`,
	'zh-hant': `你的組織`,
	en: `Your organizations`
};

export const loc_yourProfile: Record<Locale, string> = {
	ar: `ملفك الشخصي`,
	de: `Dein Profil`,
	es: `Tu perfil`,
	fa: `پروفایل شما`,
	fil: `Email Address *`,
	fr: `Votre profil`,
	hi: `आपकी प्रोफ़ाइल`,
	ht: `Pwofil ou`,
	it: `Il tuo profilo`,
	ja: `あなたのプロフィール`,
	ko: `당신의 프로필`,
	mww: `Koj qhov profile`,
	ps: `ستا پروفایل`,
	pt: `Seu perfil`,
	'pt-pt': `O teu perfil`,
	ru: `Ваш профиль`,
	sm: `Lau talaaga otooto`,
	so: `Profile-kaaga`,
	th: `โปรไฟล์ของคุณ`,
	ur: `آپ کی پروفائل`,
	vi: `Hồ sơ của bạn`,
	'zh-hans': `你的个人资料`,
	'zh-hant': `你的個人資料`,
	en: `Your profile`
};

export const loc_yourSessionExpired: Record<Locale, string> = {
	ar: `انتهت جلستك. سجل الدخول لمتابعة جلستك.`,
	de: `Deine Sitzung ist abgelaufen. Melden Sie sich an, um Ihre Sitzung fortzusetzen.`,
	es: `Tu sesión ha expirado. Inicia sesión para continuar tu sesión.`,
	fa: `جلسه ات منقضی شد. برای ادامه جلسه وارد شوید.`,
	fil: `Nag-expire na ang session mo. Mag-sign in upang ipagpatuloy ang iyong sesyon.`,
	fr: `Ta séance a expiré. Connectez-vous pour poursuivre votre séance.`,
	hi: `आपका सत्र समाप्त हो गया है. अपना सत्र जारी रखने के लिए साइन इन करें.`,
	ht: `Sesyon ou ekspire. Siyen pou w kontinye sesyon w la.`,
	it: `La tua sessione è terminata. Accedi per continuare la tua sessione.`,
	ja: `セッションは期限切れです。セッションを続けるにはサインインしてください。`,
	ko: `세션이 만료되었습니다. 세션을 계속하려면 로그인하세요.`,
	mww: `Koj qhov kev sib kho tas sij hawm. Kos npe rau hauv mus txuas ntxiv koj qhov kev sib kho.`,
	ps: `ستا غونډه پای ته ورسېده. د خپل سیشن د دوام لپاره ننوځئ.`,
	pt: `Sua sessão expirou. Faça login para continuar sua sessão de trabalho.`,
	'pt-pt': `A tua sessão expirou. Inicie sessão para continuar a sua sessão.`,
	ru: `Твоя сессия закончилась. Войдите в систему, чтобы продолжить сессию.`,
	sm: `Ua uma le aoga o lau sauniga. Saini i totonu e faaauau ai lau sauniga.`,
	so: `Fadhigaaga wuu dhacay. Isdiiwaangeli si aad u sii waddo fadhigaaga.`,
	th: `เซสชันของคุณหมดอายุ ลงชื่อเข้าใช้เพื่อดําเนินการต่อเซสชันของคุณ`,
	ur: `تمہارا سیشن ختم ہو گیا۔ اپنا سیشن جاری رکھنے کے لیے سائن ان کریں۔`,
	vi: `Phiên của bạn đã hết hạn. Đăng nhập để tiếp tục phiên của bạn.`,
	'zh-hans': `你的会话已过期。登录以继续您的会话。`,
	'zh-hant': `你的課程已經結束。登入以繼續您的課程。`,
	en: `Your session expired. Sign in to continue your session.`
};

export const loc_youSignedInWithFormat: Record<Locale, (provider: unknown) => string> = {
	ar: (provider) => `لقد سجلت الدخول عبر ${provider}`,
	de: (provider) => `Du hast dich mit ${provider} angemeldet`,
	es: (provider) => `Has iniciado sesión con ${provider}`,
	fa: (provider) => `شما با ${provider} وارد شدید.`,
	fil: (provider) => `Nag-sign in ka sa ${provider}`,
	fr: (provider) => `Vous vous êtes connecté avec ${provider}`,
	hi: (provider) => `आपने ${provider} साथ साइन इन किया है`,
	ht: (provider) => `Ou siyen ak ${provider}`,
	it: (provider) => `Hai effettuato l'accesso con ${provider}`,
	ja: (provider) => `${provider}でサインインしました`,
	ko: (provider) => `${provider}로 로그인하셨습니다`,
	mww: (provider) => `Koj tau kos npe nrog ${provider}`,
	ps: (provider) => `ته ${provider} سره ننوتې`,
	pt: (provider) => `Você entrou no ${provider}`,
	'pt-pt': (provider) => `Iniciaste sessão com ${provider}`,
	ru: (provider) => `Вы вошли в ${provider}`,
	sm: (provider) => `Na e saini i totonu ma ${provider}`,
	so: (provider) => `Waxaad ku soo gashay ${provider}`,
	th: (provider) => `คุณลงชื่อเข้าใช้ด้วย ${provider}`,
	ur: (provider) => `آپ ${provider} کے ساتھ سائن ان کیا`,
	vi: (provider) => `Bạn đã đăng nhập bằng ${provider}`,
	'zh-hans': (provider) => `你用${provider}登录了`,
	'zh-hant': (provider) => `你用 ${provider} 登入了`,
	en: (provider) => `You signed in with ${provider}`
};

export const loc_zipCode: Record<Locale, string> = {
	ar: `الرمز البريدي`,
	de: `Postleitzahl`,
	es: `Código postal`,
	fa: `کد پستی`,
	fil: `Email Address *`,
	fr: `Code postal`,
	hi: `ज़िप कोड`,
	ht: `Kòd postal`,
	it: `Codice postale`,
	ja: `郵便番号`,
	ko: `우편번호`,
	mww: `Tsib tug leb qhia thaj tsam yus nyob`,
	ps: `زیپ شفر`,
	pt: `CEP`,
	'pt-pt': `Código postal`,
	ru: `Почтовый индекс`,
	sm: `Numera o le pusa meli`,
	so: `Lanbarka furaha`,
	th: `รหัสไปรษณีย์`,
	ur: `زپ کوڈ`,
	vi: `Mã bưu chính`,
	'zh-hans': `邮政编码`,
	'zh-hant': `郵遞區號`,
	en: `Zip code`
};

export const loc_zipCodeExt: Record<Locale, TemplateResult> = {
	ar: html`<span class="sr-only">الرمز البريدي </span>الامتداد<span class="sr-only"></span>`,
	de: html`<span class="sr-only">Postleitzahl </span>Außer<span class="sr-only">Ension</span>`,
	es: html`<span class="sr-only">Código postal </span><span class="sr-only">Extensión</span>`,
	fa: html`<span class="sr-only">کد پستی </span>گسترش<span class="sr-only"></span>`,
	fil: html`<span class="sr-only">Email </span> Address *Ext<span class="sr-only">ension</span>`,
	fr: html`<span class="sr-only">Code postal </span><span class="sr-only">Extension de la direction</span>`,
	hi: html`<span class="sr-only">ज़िप कोड </span>विस्तार<span class="sr-only"></span>`,
	ht: html`<span class="sr-only">Kòd postal </span>Ext<span class="sr-only">ension</span>`,
	it: html`<span class="sr-only">Codice postale </span><span class="sr-only">Estensione</span>`,
	ja: html`<span class="sr-only">郵便番号 </span>外<span class="sr-only">延</span>`,
	ko: html`<span class="sr-only">우편번호 </span>익스텐<span class="sr-only">션</span>`,
	mww: html`<span class="sr-only">Tsib tug leb qhia thaj tsam yus nyob </span>Ext<span class="sr-only">ension</span>`,
	ps: html`<span class="sr-only">زیپ شفر </span>Ext<span class="sr-only">ension</span>`,
	pt: html`<span class="sr-only">CEP </span><span class="sr-only">Extensão</span>`,
	'pt-pt': html`<span class="sr-only">Código postal </span><span class="sr-only">Extensão</span>`,
	ru: html`<span class="sr-only">Почтовый индекс </span>Ext<span class="sr-only">ension</span>`,
	sm: html`<span class="sr-only">Numera o le pusa meli </span>Ext<span class="sr-only">ension</span>`,
	so: html`<span class="sr-only">Lanbarka furaha </span><span class="sr-only">Ballaarinta</span>`,
	th: html`<span class="sr-only">รหัสไปรษณีย์ </span>ขยาย<span class="sr-only"></span>`,
	ur: html`<span class="sr-only">زپ کوڈ </span>توسیع<span class="sr-only"></span>`,
	vi: html`<span class="sr-only">Mã bưu chính </span>Mở rộng<span class="sr-only"></span>`,
	'zh-hans': html`<span class="sr-only">邮政编码 </span>延伸<span class="sr-only"></span>`,
	'zh-hant': html`<span class="sr-only">郵遞區號 </span>延<span class="sr-only">展</span>`,
	en: html`<span class="sr-only">Zip code </span>Ext<span class="sr-only">ension</span>`
};

